import { GraphQLClient } from 'graphql-request';
import * as Dom from 'graphql-request/dist/types.dom';
import { gql } from 'graphql-request';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Date: any;
  DateString: any;
  DateTime: any;
  DateTimeISO: any;
  JSON: any;
  JSONObject: any;
  RubyTimestamp: any;
  Time: any;
};

export type AgentContactInput = {
  brokerage_names?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  customer_uuid: Scalars['String'];
  license_number?: InputMaybe<Scalars['String']>;
  mls: Scalars['String'];
  mls_id?: InputMaybe<Scalars['String']>;
};

export type AuthorizationType =
  /** any human that is marked as an agent */
  | 'AGENT_ACCESS'
  /** any human that is authenticated */
  | 'ANY_AUTHENTICATED'
  /** any human that is in an organization */
  | 'ANY_MEMBERSHIP'
  /** 3rd party contractors that do assessments for us */
  | 'ASSESSMENT_CONTRACTOR_MEMBERSHIP'
  /** belongs to the Day One Walk Partners - National org */
  | 'D1W_PARTNER_MEMBERSHIP'
  /** belongs to OD Homefield-HOC Contractors Organization */
  | 'HOC_CONTRACTOR_MEMBERSHIP'
  /** belongs to 24/7 InTouch (G Team) */
  | 'INTOUCH_CX_ORG_MEMBERSHIP'
  | 'LWOD_AGENT_ORG_MEMBERSHIP'
  /** allows any actor (without a login) to access this resource */
  | 'NO_AUTHENTICATION'
  /** belongs to an ODA reit with access to BwODA */
  | 'ODA_REIT_ORG_MEMBERSHIP'
  /** belongs to the ODHL organization */
  | 'ODHL_ORG_MEMBERSHIP'
  /** combination of OPENDOOR_INTERNAL_ACCESS, OSN_ORG_MEMBERSHIP, ODHL_ORG_MEMBERSHIP */
  | 'OPENDOOR_AND_JVS_INTERNAL_ACCESS'
  /** the web "has_internal_access" boolean */
  | 'OPENDOOR_INTERNAL_ACCESS'
  /** belongs to the OSN organization */
  | 'OSN_ORG_MEMBERSHIP'
  /** belongs to Utilities BPO Team Organization */
  | 'UTILITIES_CONTRACTOR_MEMBERSHIP';

export type Badge =
  | 'AVAILABLE_SOON'
  | 'IN_CONTRACT'
  | 'IS_EXCLUSIVE'
  | 'ON_THE_MARKET'
  | 'RECENTLY_SOLD'
  /** A property that is possibly still for sale but is unactionable at the moment */
  | 'TEMP_UNAVAILABLE'
  /** A home that is for sale but cannot be self-toured, must be bought with an agent via MLS */
  | 'TRADITIONAL'
  | 'UNKNOWN';

/** Types of brokerage assignments for listing products */
export type BrokerageAssignmentType =
  /** Brokerage is assigned to the listing */
  | 'ASSIGNED'
  /** Brokerage is proposed for the listing */
  | 'PROPOSED';

/**
 * A list of task types a customer may be required to complete in order to facilitate
 * their transaction, both OBO and non-OBO
 */
export type BuyClosingTaskType =
  | 'APPRAISAL'
  | 'BUY_DIRECT_EARNEST_MONEY'
  | 'BUY_DIRECT_FINAL_WALKTHROUGH'
  | 'BUY_DIRECT_INFO_TITLE_ESCROW'
  | 'BUY_DIRECT_REVIEW_DISCLOSURES'
  | 'BUY_DIRECT_SCHEDULE_INSPECTION'
  | 'BUY_DIRECT_SIGN_CONTRACT'
  | 'FEED_FILTERS'
  | 'INFORMATION_CONFIRMATION'
  | 'INSPECTIONS'
  | 'LOAN_APPLICATION'
  | 'LOAN_FINALIZATION'
  | 'MARKET_TRENDS'
  | 'NOT_SPECIFIED'
  | 'RESALE_CONTRACT'
  | 'UTILITIES';

export type BuyDirectContractStatus =
  | 'BACKUP'
  | 'BUY_IT_NOW'
  | 'HIGHEST_AND_BEST'
  | 'UNAVAILABLE';

/** A set of Document types that are of interest for a customer in Buy experience */
export type BuyDocumentType =
  | 'APPRAISAL'
  | 'DOCUMENT'
  | 'INSPECTION_REPORT'
  | 'MULTIPLE_DOCUMENTS'
  | 'OFFER_ADDENDUM'
  | 'PREAPPROVAL_LETTER'
  | 'PROGRAM_AGREEMENT'
  | 'PURCHASE_AGREEMENT';

/** Uploaded files in S3 can have one of three states */
export type BuyFileScanStatus =
  /** The file is safe to download/preview/share */
  | 'CLEAN'
  /** OLA will maintain a record of infected files, but they are auto-deleted in S3 to ensure security standards */
  | 'INFECTED'
  /** The file is currently being scanned */
  | 'IN_PROGRESS';

export type BuyerDataInput = {
  qual_move_timeline?: InputMaybe<QualMoveTimelineOption>;
};

/** Options for the scope of a cached object. */
export type CacheControlScope =
  /** Each caller will receive a unique cached version of this object. */
  | 'PRIVATE'
  /** Cached value will be shared between all callers. */
  | 'PUBLIC';

export type CancelExteriorAssessmentInput = {
  cancellationReason?: InputMaybe<CancellationReasonInput>;
  sellerInputUUID: Scalars['String'];
  visitId: Scalars['String'];
};

export type CancellationReasonInput = {
  additionalDetails?: InputMaybe<Scalars['String']>;
  structuredReasons?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** Possible options for getting prequalified for cash offers */
export type CashOfferEligibilityLender =
  | 'ODHB'
  | 'ODHL'
  | 'other';

export type ClosingTasksInput = {
  hoaFees?: InputMaybe<HoaFeesTaskInput>;
  hvacRoof?: InputMaybe<HvacRoofTaskInput>;
  lateCheckout?: InputMaybe<LateCheckoutTaskInput>;
  otherHomeInfo?: InputMaybe<OtherHomeInfoTaskInput>;
  serviceAccounts?: InputMaybe<ServiceAccountsTaskInput>;
  setCloseDate?: InputMaybe<SetCloseDateTaskInput>;
  setSignatories?: InputMaybe<SetSignatoriesTaskInput>;
};

export type CommissionType =
  | 'FLAT_CENTS'
  | 'RATE_BPS';

export type CompsInput = {
  compsAddressUuids?: InputMaybe<Array<Scalars['String']>>;
};

/** The completion state of a customer task */
export type CustomerTaskState =
  /** Task has been completed */
  | 'COMPLETE'
  /** Task has not been completed */
  | 'PENDING';

/** The type of task for mutation identification */
export type CustomerTaskType =
  | 'ACCESS_KEYS'
  | 'BOOK_INSPECTION'
  | 'CONFIRM_FINANCING'
  | 'FINALIZE_CLOSING'
  | 'MAKE_DEPOSIT'
  | 'RECEIVE_ACCESS_CODE'
  | 'REVIEW_OFFER'
  | 'SIGN_CONTRACT';

export type DetailsInput = {
  addressUuid: Scalars['String'];
};

export type DigitalCheckoutInput = {
  declaration: Scalars['String'];
  lockboxLocation: Scalars['String'];
  phoneNumber: Scalars['String'];
  photos?: InputMaybe<Array<PhotoInput>>;
};

export type DwellingType =
  | 'APARTMENT'
  | 'CHURCH'
  | 'COMMERCIAL'
  | 'COOP'
  | 'FARM'
  | 'HALF_DUPLEX'
  | 'HOTEL'
  | 'INDUSTRIAL'
  | 'MANUFACTURED'
  | 'MIXED'
  | 'MOBILE_HOME'
  | 'MULTI_FAMILY'
  | 'OFFICE'
  | 'OTHER'
  | 'RETAIL'
  | 'SINGLE_FAMILY'
  | 'SPECIAL_PURPOSE'
  | 'TOWNHOUSE'
  | 'UNKNOWN'
  | 'VACANT'
  | 'WAREHOUSE';

/** Types of seller experiences available in the platform */
export type ExperienceType =
  /** Agent-led offers experience (legacy typo - kept for backward compatibility) */
  | 'AGENT_LED_OFERS'
  /** Agent-led offers experience */
  | 'AGENT_LED_OFFERS'
  /** Direct to Customer (multi-product) */
  | 'DIRECT_TO_CUSTOMER'
  /** Sell direct via Agent referral */
  | 'SELL_DIRECT_AGENT'
  /** Core sell direct experience (cash offer) */
  | 'SELL_DIRECT_CORE'
  /** The multi-product experience available to the customer */
  | 'SELL_YOUR_WAY'
  /** Unknown or unrecognized experience type */
  | 'UNKNOWN';

export type FinancingSource =
  | 'AWAITING_MORTGAGE_PARTNER_APPROVAL'
  | 'CASH'
  | 'PRE_APPROVAL';

/**
 * GeoBoundary is used to build a geographic boundary for a property search
 *
 * This is a boundary defined by two points at opposite corners of a rectangle.
 * This is how Indextrious exposes their GeoBoundary type and while it's not
 * ideal to have to design the input shape around their type, it's necessary
 * to make this ergonmic for clients.
 *
 * Keep in mind, this prevents us from having more complex shapes like any arbitrary polygon.
 * By taking a northwest coordinate and a southeast coordinate, I'm guessing Indextrious figures out
 * how to determine the remaining points of the rectangular polygon and build the "box" it searches within
 */
export type GeoBoundaryInput = {
  /** Southeast coordinate of the boundary */
  bottomRight: GeoPoint;
  /** Northwest coordinate of the boundary */
  topLeft: GeoPoint;
};

/** GeoPoint is a coordinate pair used for geospatial queries and identifying a location */
export type GeoPoint = {
  /** 'They say your attitude determines your latitude' - Kanye West */
  lat: Scalars['Float'];
  /** Longitude is the angular distance of a place east or west of the meridian at Greenwich, England */
  lon: Scalars['Float'];
};

export type GetEngagementDetailsRequestInput = {
  propertyEngagementId: Scalars['String'];
  requestId?: InputMaybe<OdProtosCommon_RequestIdInput>;
  requestorId?: InputMaybe<OdProtosCommon_RequestorIdInput>;
};

export type GetMarketConfigByMarketInput = {
  market?: InputMaybe<OdProtosCommonMarket_Market>;
};

export type GetUserAvatarInput = {
  /** The user email to look up in Slack. */
  email: Scalars['String'];
};

/**
 * `Any` contains an arbitrary serialized protocol buffer message along with a
 * URL that describes the type of the serialized message.
 *
 * Protobuf library provides support to pack/unpack Any values in the form
 * of utility functions or additional generated methods of the Any type.
 *
 * Example 1: Pack and unpack a message in C++.
 *
 *     Foo foo = ...;
 *     Any any;
 *     any.PackFrom(foo);
 *     ...
 *     if (any.UnpackTo(&foo)) {
 *       ...
 *     }
 *
 * Example 2: Pack and unpack a message in Java.
 *
 *     Foo foo = ...;
 *     Any any = Any.pack(foo);
 *     ...
 *     if (any.is(Foo.class)) {
 *       foo = any.unpack(Foo.class);
 *     }
 *
 *  Example 3: Pack and unpack a message in Python.
 *
 *     foo = Foo(...)
 *     any = Any()
 *     any.Pack(foo)
 *     ...
 *     if any.Is(Foo.DESCRIPTOR):
 *       any.Unpack(foo)
 *       ...
 *
 *  Example 4: Pack and unpack a message in Go
 *
 *      foo := &pb.Foo{...}
 *      any, err := anypb.New(foo)
 *      if err != nil {
 *        ...
 *      }
 *      ...
 *      foo := &pb.Foo{}
 *      if err := any.UnmarshalTo(foo); err != nil {
 *        ...
 *      }
 *
 * The pack methods provided by protobuf library will by default use
 * 'type.googleapis.com/full.type.name' as the type URL and the unpack
 * methods only use the fully qualified type name after the last '/'
 * in the type URL, for example "foo.bar.com/x/y.z" will yield type
 * name "y.z".
 *
 *
 * JSON
 * ====
 * The JSON representation of an `Any` value uses the regular
 * representation of the deserialized, embedded message, with an
 * additional field `@type` which contains the type URL. Example:
 *
 *     package google.profile;
 *     message Person {
 *       string first_name = 1;
 *       string last_name = 2;
 *     }
 *
 *     {
 *       "@type": "type.googleapis.com/google.profile.Person",
 *       "firstName": <string>,
 *       "lastName": <string>
 *     }
 *
 * If the embedded message type is well-known and has a custom JSON
 * representation, that representation will be embedded adding a field
 * `value` which holds the custom JSON in addition to the `@type`
 * field. Example (for message [google.protobuf.Duration][]):
 *
 *     {
 *       "@type": "type.googleapis.com/google.protobuf.Duration",
 *       "value": "1.212s"
 *     }
 */
export type GoogleProtobuf_AnyInput = {
  /**
   * A URL/resource name that uniquely identifies the type of the serialized
   * protocol buffer message. This string must contain at least
   * one "/" character. The last segment of the URL's path must represent
   * the fully qualified name of the type (as in
   * `path/google.protobuf.Duration`). The name should be in a canonical form
   * (e.g., leading "." is not accepted).
   *
   * In practice, teams usually precompile into the binary all types that they
   * expect it to use in the context of Any. However, for URLs which use the
   * scheme `http`, `https`, or no scheme, one can optionally set up a type
   * server that maps type URLs to message definitions as follows:
   *
   * * If no scheme is provided, `https` is assumed.
   * * An HTTP GET on the URL must yield a [google.protobuf.Type][]
   *   value in binary format, or produce an error.
   * * Applications are allowed to cache lookup results based on the
   *   URL, or have them precompiled into a binary to avoid any
   *   lookup. Therefore, binary compatibility needs to be preserved
   *   on changes to types. (Use versioned type names to manage
   *   breaking changes.)
   *
   * Note: this functionality is not currently available in the official
   * protobuf release, and it is not used for type URLs beginning with
   * type.googleapis.com.
   *
   * Schemes other than `http`, `https` (or the empty scheme) might be
   * used with implementation specific semantics.
   */
  typeUrl?: InputMaybe<Scalars['String']>;
  /** Must be a valid serialized protocol buffer of the above specified type. */
  value?: InputMaybe<Scalars['String']>;
};

/**
 * Api is a light-weight descriptor for an API Interface.
 *
 * Interfaces are also described as "protocol buffer services" in some contexts,
 * such as by the "service" keyword in a .proto file, but they are different
 * from API Services, which represent a concrete implementation of an interface
 * as opposed to simply a description of methods and bindings. They are also
 * sometimes simply referred to as "APIs" in other contexts, such as the name of
 * this message itself. See https://cloud.google.com/apis/design/glossary for
 * detailed terminology.
 */
export type GoogleProtobuf_ApiInput = {
  /** The methods of this interface, in unspecified order. */
  methods?: InputMaybe<Array<GoogleProtobuf_MethodInput>>;
  /** Included interfaces. See [Mixin][]. */
  mixins?: InputMaybe<Array<GoogleProtobuf_MixinInput>>;
  /**
   * The fully qualified name of this interface, including package name
   * followed by the interface's simple name.
   */
  name?: InputMaybe<Scalars['String']>;
  /** Any metadata attached to the interface. */
  options?: InputMaybe<Array<GoogleProtobuf_OptionInput>>;
  /**
   * Source context for the protocol buffer service represented by this
   * message.
   */
  sourceContext?: InputMaybe<GoogleProtobuf_SourceContextInput>;
  /** The source syntax of the service. */
  syntax?: InputMaybe<GoogleProtobuf_Syntax>;
  /**
   * A version string for this interface. If specified, must have the form
   * `major-version.minor-version`, as in `1.10`. If the minor version is
   * omitted, it defaults to zero. If the entire version field is empty, the
   * major version is derived from the package name, as outlined below. If the
   * field is not empty, the version in the package name will be verified to be
   * consistent with what is provided here.
   *
   * The versioning schema uses [semantic
   * versioning](http://semver.org) where the major version number
   * indicates a breaking change and the minor version an additive,
   * non-breaking change. Both version numbers are signals to users
   * what to expect from different versions, and should be carefully
   * chosen based on the product plan.
   *
   * The major version is also reflected in the package name of the
   * interface, which must end in `v<major-version>`, as in
   * `google.feature.v1`. For major versions 0 and 1, the suffix can
   * be omitted. Zero major versions must only be used for
   * experimental, non-GA interfaces.
   */
  version?: InputMaybe<Scalars['String']>;
};

/**
 * Wrapper message for `bool`.
 *
 * The JSON representation for `BoolValue` is JSON `true` and `false`.
 */
export type GoogleProtobuf_BoolValueInput = {
  /** The bool value. */
  value?: InputMaybe<Scalars['Boolean']>;
};

/**
 * Wrapper message for `bytes`.
 *
 * The JSON representation for `BytesValue` is JSON string.
 */
export type GoogleProtobuf_BytesValueInput = {
  /** The bytes value. */
  value?: InputMaybe<Scalars['String']>;
};

/** Describes a message type. */
export type GoogleProtobuf_DescriptorProtoInput = {
  enumType?: InputMaybe<Array<GoogleProtobuf_EnumDescriptorProtoInput>>;
  extension?: InputMaybe<Array<GoogleProtobuf_FieldDescriptorProtoInput>>;
  extensionRange?: InputMaybe<Array<GoogleProtobuf_DescriptorProto_ExtensionRangeInput>>;
  field?: InputMaybe<Array<GoogleProtobuf_FieldDescriptorProtoInput>>;
  name?: InputMaybe<Scalars['String']>;
  nestedType?: InputMaybe<Array<GoogleProtobuf_DescriptorProtoInput>>;
  oneofDecl?: InputMaybe<Array<GoogleProtobuf_OneofDescriptorProtoInput>>;
  options?: InputMaybe<GoogleProtobuf_MessageOptionsInput>;
  /**
   * Reserved field names, which may not be used by fields in the same message.
   * A given name may only be reserved once.
   */
  reservedName?: InputMaybe<Array<Scalars['String']>>;
  reservedRange?: InputMaybe<Array<GoogleProtobuf_DescriptorProto_ReservedRangeInput>>;
};

export type GoogleProtobuf_DescriptorProto_ExtensionRangeInput = {
  /** Exclusive. */
  end?: InputMaybe<Scalars['Float']>;
  options?: InputMaybe<GoogleProtobuf_ExtensionRangeOptionsInput>;
  /** Inclusive. */
  start?: InputMaybe<Scalars['Float']>;
};

/**
 * Range of reserved tag numbers. Reserved tag numbers may not be used by
 * fields or extension ranges in the same message. Reserved ranges may
 * not overlap.
 */
export type GoogleProtobuf_DescriptorProto_ReservedRangeInput = {
  /** Exclusive. */
  end?: InputMaybe<Scalars['Float']>;
  /** Inclusive. */
  start?: InputMaybe<Scalars['Float']>;
};

/**
 * Wrapper message for `double`.
 *
 * The JSON representation for `DoubleValue` is JSON number.
 */
export type GoogleProtobuf_DoubleValueInput = {
  /** The double value. */
  value?: InputMaybe<Scalars['Float']>;
};

/**
 * A Duration represents a signed, fixed-length span of time represented
 * as a count of seconds and fractions of seconds at nanosecond
 * resolution. It is independent of any calendar and concepts like "day"
 * or "month". It is related to Timestamp in that the difference between
 * two Timestamp values is a Duration and it can be added or subtracted
 * from a Timestamp. Range is approximately +-10,000 years.
 *
 * # Examples
 *
 * Example 1: Compute Duration from two Timestamps in pseudo code.
 *
 *     Timestamp start = ...;
 *     Timestamp end = ...;
 *     Duration duration = ...;
 *
 *     duration.seconds = end.seconds - start.seconds;
 *     duration.nanos = end.nanos - start.nanos;
 *
 *     if (duration.seconds < 0 && duration.nanos > 0) {
 *       duration.seconds += 1;
 *       duration.nanos -= 1000000000;
 *     } else if (duration.seconds > 0 && duration.nanos < 0) {
 *       duration.seconds -= 1;
 *       duration.nanos += 1000000000;
 *     }
 *
 * Example 2: Compute Timestamp from Timestamp + Duration in pseudo code.
 *
 *     Timestamp start = ...;
 *     Duration duration = ...;
 *     Timestamp end = ...;
 *
 *     end.seconds = start.seconds + duration.seconds;
 *     end.nanos = start.nanos + duration.nanos;
 *
 *     if (end.nanos < 0) {
 *       end.seconds -= 1;
 *       end.nanos += 1000000000;
 *     } else if (end.nanos >= 1000000000) {
 *       end.seconds += 1;
 *       end.nanos -= 1000000000;
 *     }
 *
 * Example 3: Compute Duration from datetime.timedelta in Python.
 *
 *     td = datetime.timedelta(days=3, minutes=10)
 *     duration = Duration()
 *     duration.FromTimedelta(td)
 *
 * # JSON Mapping
 *
 * In JSON format, the Duration type is encoded as a string rather than an
 * object, where the string ends in the suffix "s" (indicating seconds) and
 * is preceded by the number of seconds, with nanoseconds expressed as
 * fractional seconds. For example, 3 seconds with 0 nanoseconds should be
 * encoded in JSON format as "3s", while 3 seconds and 1 nanosecond should
 * be expressed in JSON format as "3.000000001s", and 3 seconds and 1
 * microsecond should be expressed in JSON format as "3.000001s".
 */
export type GoogleProtobuf_DurationInput = {
  /**
   * Signed fractions of a second at nanosecond resolution of the span
   * of time. Durations less than one second are represented with a 0
   * `seconds` field and a positive or negative `nanos` field. For durations
   * of one second or more, a non-zero value for the `nanos` field must be
   * of the same sign as the `seconds` field. Must be from -999,999,999
   * to +999,999,999 inclusive.
   */
  nanos?: InputMaybe<Scalars['Float']>;
  /**
   * Signed seconds of the span of time. Must be from -315,576,000,000
   * to +315,576,000,000 inclusive. Note: these bounds are computed from:
   * 60 sec/min * 60 min/hr * 24 hr/day * 365.25 days/year * 10000 years
   */
  seconds?: InputMaybe<Scalars['Float']>;
};

/**
 * A generic empty message that you can re-use to avoid defining duplicated
 * empty messages in your APIs. A typical example is to use it as the request
 * or the response type of an API method. For instance:
 *
 *     service Foo {
 *       rpc Bar(google.protobuf.Empty) returns (google.protobuf.Empty);
 *     }
 *
 * The JSON representation for `Empty` is empty JSON object `{}`.
 */
export type GoogleProtobuf_EmptyInput = {
  _empty?: InputMaybe<Scalars['Boolean']>;
};

/** Describes an enum type. */
export type GoogleProtobuf_EnumDescriptorProtoInput = {
  name?: InputMaybe<Scalars['String']>;
  options?: InputMaybe<GoogleProtobuf_EnumOptionsInput>;
  /**
   * Reserved enum value names, which may not be reused. A given name may only
   * be reserved once.
   */
  reservedName?: InputMaybe<Array<Scalars['String']>>;
  /**
   * Range of reserved numeric values. Reserved numeric values may not be used
   * by enum values in the same enum declaration. Reserved ranges may not
   * overlap.
   */
  reservedRange?: InputMaybe<Array<GoogleProtobuf_EnumDescriptorProto_EnumReservedRangeInput>>;
  value?: InputMaybe<Array<GoogleProtobuf_EnumValueDescriptorProtoInput>>;
};

/**
 * Range of reserved numeric values. Reserved values may not be used by
 * entries in the same enum. Reserved ranges may not overlap.
 *
 * Note that this is distinct from DescriptorProto.ReservedRange in that it
 * is inclusive such that it can appropriately represent the entire int32
 * domain.
 */
export type GoogleProtobuf_EnumDescriptorProto_EnumReservedRangeInput = {
  /** Inclusive. */
  end?: InputMaybe<Scalars['Float']>;
  /** Inclusive. */
  start?: InputMaybe<Scalars['Float']>;
};

/** Enum type definition. */
export type GoogleProtobuf_EnumInput = {
  /** Enum value definitions. */
  enumvalue?: InputMaybe<Array<GoogleProtobuf_EnumValueInput>>;
  /** Enum type name. */
  name?: InputMaybe<Scalars['String']>;
  /** Protocol buffer options. */
  options?: InputMaybe<Array<GoogleProtobuf_OptionInput>>;
  /** The source context. */
  sourceContext?: InputMaybe<GoogleProtobuf_SourceContextInput>;
  /** The source syntax. */
  syntax?: InputMaybe<GoogleProtobuf_Syntax>;
};

export type GoogleProtobuf_EnumOptionsInput = {
  /**
   * Set this option to true to allow mapping different tag names to the same
   * value.
   */
  allowAlias?: InputMaybe<Scalars['Boolean']>;
  /**
   * Is this enum deprecated?
   * Depending on the target platform, this can emit Deprecated annotations
   * for the enum, or it will be completely ignored; in the very least, this
   * is a formalization for deprecating enums.
   */
  deprecated?: InputMaybe<Scalars['Boolean']>;
  /** The parser stores options it doesn't recognize here. See above. */
  uninterpretedOption?: InputMaybe<Array<GoogleProtobuf_UninterpretedOptionInput>>;
};

/** Describes a value within an enum. */
export type GoogleProtobuf_EnumValueDescriptorProtoInput = {
  name?: InputMaybe<Scalars['String']>;
  number?: InputMaybe<Scalars['Float']>;
  options?: InputMaybe<GoogleProtobuf_EnumValueOptionsInput>;
};

/** Enum value definition. */
export type GoogleProtobuf_EnumValueInput = {
  /** Enum value name. */
  name?: InputMaybe<Scalars['String']>;
  /** Enum value number. */
  number?: InputMaybe<Scalars['Float']>;
  /** Protocol buffer options. */
  options?: InputMaybe<Array<GoogleProtobuf_OptionInput>>;
};

export type GoogleProtobuf_EnumValueOptionsInput = {
  /**
   * Is this enum value deprecated?
   * Depending on the target platform, this can emit Deprecated annotations
   * for the enum value, or it will be completely ignored; in the very least,
   * this is a formalization for deprecating enum values.
   */
  deprecated?: InputMaybe<Scalars['Boolean']>;
  /** The parser stores options it doesn't recognize here. See above. */
  uninterpretedOption?: InputMaybe<Array<GoogleProtobuf_UninterpretedOptionInput>>;
};

export type GoogleProtobuf_ExtensionRangeOptionsInput = {
  /** The parser stores options it doesn't recognize here. See above. */
  uninterpretedOption?: InputMaybe<Array<GoogleProtobuf_UninterpretedOptionInput>>;
};

/** Describes a field within a message. */
export type GoogleProtobuf_FieldDescriptorProtoInput = {
  /**
   * For numeric types, contains the original text representation of the value.
   * For booleans, "true" or "false".
   * For strings, contains the default text contents (not escaped in any way).
   * For bytes, contains the C escaped value.  All bytes >= 128 are escaped.
   * TODO(kenton):  Base-64 encode?
   */
  defaultValue?: InputMaybe<Scalars['String']>;
  /**
   * For extensions, this is the name of the type being extended.  It is
   * resolved in the same manner as type_name.
   */
  extendee?: InputMaybe<Scalars['String']>;
  /**
   * JSON name of this field. The value is set by protocol compiler. If the
   * user has set a "json_name" option on this field, that option's value
   * will be used. Otherwise, it's deduced from the field's name by converting
   * it to camelCase.
   */
  jsonName?: InputMaybe<Scalars['String']>;
  label?: InputMaybe<GoogleProtobuf_FieldDescriptorProto_Label>;
  name?: InputMaybe<Scalars['String']>;
  number?: InputMaybe<Scalars['Float']>;
  /**
   * If set, gives the index of a oneof in the containing type's oneof_decl
   * list.  This field is a member of that oneof.
   */
  oneofIndex?: InputMaybe<Scalars['Float']>;
  options?: InputMaybe<GoogleProtobuf_FieldOptionsInput>;
  /**
   * If true, this is a proto3 "optional". When a proto3 field is optional, it
   * tracks presence regardless of field type.
   *
   * When proto3_optional is true, this field must be belong to a oneof to
   * signal to old proto3 clients that presence is tracked for this field. This
   * oneof is known as a "synthetic" oneof, and this field must be its sole
   * member (each proto3 optional field gets its own synthetic oneof). Synthetic
   * oneofs exist in the descriptor only, and do not generate any API. Synthetic
   * oneofs must be ordered after all "real" oneofs.
   *
   * For message fields, proto3_optional doesn't create any semantic change,
   * since non-repeated message fields always track presence. However it still
   * indicates the semantic detail of whether the user wrote "optional" or not.
   * This can be useful for round-tripping the .proto file. For consistency we
   * give message fields a synthetic oneof also, even though it is not required
   * to track presence. This is especially important because the parser can't
   * tell if a field is a message or an enum, so it must always create a
   * synthetic oneof.
   *
   * Proto2 optional fields do not set this flag, because they already indicate
   * optional with `LABEL_OPTIONAL`.
   */
  proto3Optional?: InputMaybe<Scalars['Boolean']>;
  /**
   * If type_name is set, this need not be set.  If both this and type_name
   * are set, this must be one of TYPE_ENUM, TYPE_MESSAGE or TYPE_GROUP.
   */
  type?: InputMaybe<GoogleProtobuf_FieldDescriptorProto_Type>;
  /**
   * For message and enum types, this is the name of the type.  If the name
   * starts with a '.', it is fully-qualified.  Otherwise, C++-like scoping
   * rules are used to find the type (i.e. first the nested types within this
   * message are searched, then within the parent, on up to the root
   * namespace).
   */
  typeName?: InputMaybe<Scalars['String']>;
};

export type GoogleProtobuf_FieldDescriptorProto_Label =
  /** 0 is reserved for errors */
  | 'LABEL_OPTIONAL'
  | 'LABEL_REPEATED'
  | 'LABEL_REQUIRED';

export type GoogleProtobuf_FieldDescriptorProto_Type =
  | 'TYPE_BOOL'
  /** New in version 2. */
  | 'TYPE_BYTES'
  /**
   * 0 is reserved for errors.
   * Order is weird for historical reasons.
   */
  | 'TYPE_DOUBLE'
  | 'TYPE_ENUM'
  | 'TYPE_FIXED32'
  | 'TYPE_FIXED64'
  | 'TYPE_FLOAT'
  /**
   * Tag-delimited aggregate.
   * Group type is deprecated and not supported in proto3. However, Proto3
   * implementations should still be able to parse the group wire format and
   * treat group fields as unknown fields.
   */
  | 'TYPE_GROUP'
  /**
   * Not ZigZag encoded.  Negative numbers take 10 bytes.  Use TYPE_SINT32 if
   * negative values are likely.
   */
  | 'TYPE_INT32'
  /**
   * Not ZigZag encoded.  Negative numbers take 10 bytes.  Use TYPE_SINT64 if
   * negative values are likely.
   */
  | 'TYPE_INT64'
  /** Length-delimited aggregate. */
  | 'TYPE_MESSAGE'
  | 'TYPE_SFIXED32'
  | 'TYPE_SFIXED64'
  /** Uses ZigZag encoding. */
  | 'TYPE_SINT32'
  /** Uses ZigZag encoding. */
  | 'TYPE_SINT64'
  | 'TYPE_STRING'
  | 'TYPE_UINT32'
  | 'TYPE_UINT64';

/** A single field of a message type. */
export type GoogleProtobuf_FieldInput = {
  /** The field cardinality. */
  cardinality?: InputMaybe<GoogleProtobuf_Field_Cardinality>;
  /** The string value of the default value of this field. Proto2 syntax only. */
  defaultValue?: InputMaybe<Scalars['String']>;
  /** The field JSON name. */
  jsonName?: InputMaybe<Scalars['String']>;
  /** The field type. */
  kind?: InputMaybe<GoogleProtobuf_Field_Kind>;
  /** The field name. */
  name?: InputMaybe<Scalars['String']>;
  /** The field number. */
  number?: InputMaybe<Scalars['Float']>;
  /**
   * The index of the field type in `Type.oneofs`, for message or enumeration
   * types. The first type has index 1; zero means the type is not in the list.
   */
  oneofIndex?: InputMaybe<Scalars['Float']>;
  /** The protocol buffer options. */
  options?: InputMaybe<Array<GoogleProtobuf_OptionInput>>;
  /** Whether to use alternative packed wire representation. */
  packed?: InputMaybe<Scalars['Boolean']>;
  /**
   * The field type URL, without the scheme, for message or enumeration
   * types. Example: `"type.googleapis.com/google.protobuf.Timestamp"`.
   */
  typeUrl?: InputMaybe<Scalars['String']>;
};

/**
 * `FieldMask` represents a set of symbolic field paths, for example:
 *
 *     paths: "f.a"
 *     paths: "f.b.d"
 *
 * Here `f` represents a field in some root message, `a` and `b`
 * fields in the message found in `f`, and `d` a field found in the
 * message in `f.b`.
 *
 * Field masks are used to specify a subset of fields that should be
 * returned by a get operation or modified by an update operation.
 * Field masks also have a custom JSON encoding (see below).
 *
 * # Field Masks in Projections
 *
 * When used in the context of a projection, a response message or
 * sub-message is filtered by the API to only contain those fields as
 * specified in the mask. For example, if the mask in the previous
 * example is applied to a response message as follows:
 *
 *     f {
 *       a : 22
 *       b {
 *         d : 1
 *         x : 2
 *       }
 *       y : 13
 *     }
 *     z: 8
 *
 * The result will not contain specific values for fields x,y and z
 * (their value will be set to the default, and omitted in proto text
 * output):
 *
 *
 *     f {
 *       a : 22
 *       b {
 *         d : 1
 *       }
 *     }
 *
 * A repeated field is not allowed except at the last position of a
 * paths string.
 *
 * If a FieldMask object is not present in a get operation, the
 * operation applies to all fields (as if a FieldMask of all fields
 * had been specified).
 *
 * Note that a field mask does not necessarily apply to the
 * top-level response message. In case of a REST get operation, the
 * field mask applies directly to the response, but in case of a REST
 * list operation, the mask instead applies to each individual message
 * in the returned resource list. In case of a REST custom method,
 * other definitions may be used. Where the mask applies will be
 * clearly documented together with its declaration in the API.  In
 * any case, the effect on the returned resource/resources is required
 * behavior for APIs.
 *
 * # Field Masks in Update Operations
 *
 * A field mask in update operations specifies which fields of the
 * targeted resource are going to be updated. The API is required
 * to only change the values of the fields as specified in the mask
 * and leave the others untouched. If a resource is passed in to
 * describe the updated values, the API ignores the values of all
 * fields not covered by the mask.
 *
 * If a repeated field is specified for an update operation, new values will
 * be appended to the existing repeated field in the target resource. Note that
 * a repeated field is only allowed in the last position of a `paths` string.
 *
 * If a sub-message is specified in the last position of the field mask for an
 * update operation, then new value will be merged into the existing sub-message
 * in the target resource.
 *
 * For example, given the target message:
 *
 *     f {
 *       b {
 *         d: 1
 *         x: 2
 *       }
 *       c: [1]
 *     }
 *
 * And an update message:
 *
 *     f {
 *       b {
 *         d: 10
 *       }
 *       c: [2]
 *     }
 *
 * then if the field mask is:
 *
 *  paths: ["f.b", "f.c"]
 *
 * then the result will be:
 *
 *     f {
 *       b {
 *         d: 10
 *         x: 2
 *       }
 *       c: [1, 2]
 *     }
 *
 * An implementation may provide options to override this default behavior for
 * repeated and message fields.
 *
 * In order to reset a field's value to the default, the field must
 * be in the mask and set to the default value in the provided resource.
 * Hence, in order to reset all fields of a resource, provide a default
 * instance of the resource and set all fields in the mask, or do
 * not provide a mask as described below.
 *
 * If a field mask is not present on update, the operation applies to
 * all fields (as if a field mask of all fields has been specified).
 * Note that in the presence of schema evolution, this may mean that
 * fields the client does not know and has therefore not filled into
 * the request will be reset to their default. If this is unwanted
 * behavior, a specific service may require a client to always specify
 * a field mask, producing an error if not.
 *
 * As with get operations, the location of the resource which
 * describes the updated values in the request message depends on the
 * operation kind. In any case, the effect of the field mask is
 * required to be honored by the API.
 *
 * ## Considerations for HTTP REST
 *
 * The HTTP kind of an update operation which uses a field mask must
 * be set to PATCH instead of PUT in order to satisfy HTTP semantics
 * (PUT must only be used for full updates).
 *
 * # JSON Encoding of Field Masks
 *
 * In JSON, a field mask is encoded as a single string where paths are
 * separated by a comma. Fields name in each path are converted
 * to/from lower-camel naming conventions.
 *
 * As an example, consider the following message declarations:
 *
 *     message Profile {
 *       User user = 1;
 *       Photo photo = 2;
 *     }
 *     message User {
 *       string display_name = 1;
 *       string address = 2;
 *     }
 *
 * In proto a field mask for `Profile` may look as such:
 *
 *     mask {
 *       paths: "user.display_name"
 *       paths: "photo"
 *     }
 *
 * In JSON, the same mask is represented as below:
 *
 *     {
 *       mask: "user.displayName,photo"
 *     }
 *
 * # Field Masks and Oneof Fields
 *
 * Field masks treat fields in oneofs just as regular fields. Consider the
 * following message:
 *
 *     message SampleMessage {
 *       oneof test_oneof {
 *         string name = 4;
 *         SubMessage sub_message = 9;
 *       }
 *     }
 *
 * The field mask can be:
 *
 *     mask {
 *       paths: "name"
 *     }
 *
 * Or:
 *
 *     mask {
 *       paths: "sub_message"
 *     }
 *
 * Note that oneof type names ("test_oneof" in this case) cannot be used in
 * paths.
 *
 * ## Field Mask Verification
 *
 * The implementation of any API method which has a FieldMask type field in the
 * request should verify the included field paths, and return an
 * `INVALID_ARGUMENT` error if any path is unmappable.
 */
export type GoogleProtobuf_FieldMaskInput = {
  /** The set of field mask paths. */
  paths?: InputMaybe<Array<Scalars['String']>>;
};

export type GoogleProtobuf_FieldOptionsInput = {
  /**
   * The ctype option instructs the C++ code generator to use a different
   * representation of the field than it normally would.  See the specific
   * options below.  This option is not yet implemented in the open source
   * release -- sorry, we'll try to include it in a future version!
   */
  ctype?: InputMaybe<GoogleProtobuf_FieldOptions_CType>;
  /**
   * Is this field deprecated?
   * Depending on the target platform, this can emit Deprecated annotations
   * for accessors, or it will be completely ignored; in the very least, this
   * is a formalization for deprecating fields.
   */
  deprecated?: InputMaybe<Scalars['Boolean']>;
  /**
   * The jstype option determines the JavaScript type used for values of the
   * field.  The option is permitted only for 64 bit integral and fixed types
   * (int64, uint64, sint64, fixed64, sfixed64).  A field with jstype JS_STRING
   * is represented as JavaScript string, which avoids loss of precision that
   * can happen when a large value is converted to a floating point JavaScript.
   * Specifying JS_NUMBER for the jstype causes the generated JavaScript code to
   * use the JavaScript "number" type.  The behavior of the default option
   * JS_NORMAL is implementation dependent.
   *
   * This option is an enum to permit additional types to be added, e.g.
   * goog.math.Integer.
   */
  jstype?: InputMaybe<GoogleProtobuf_FieldOptions_JsType>;
  /**
   * Should this field be parsed lazily?  Lazy applies only to message-type
   * fields.  It means that when the outer message is initially parsed, the
   * inner message's contents will not be parsed but instead stored in encoded
   * form.  The inner message will actually be parsed when it is first accessed.
   *
   * This is only a hint.  Implementations are free to choose whether to use
   * eager or lazy parsing regardless of the value of this option.  However,
   * setting this option true suggests that the protocol author believes that
   * using lazy parsing on this field is worth the additional bookkeeping
   * overhead typically needed to implement it.
   *
   * This option does not affect the public interface of any generated code;
   * all method signatures remain the same.  Furthermore, thread-safety of the
   * interface is not affected by this option; const methods remain safe to
   * call from multiple threads concurrently, while non-const methods continue
   * to require exclusive access.
   *
   *
   * Note that implementations may choose not to check required fields within
   * a lazy sub-message.  That is, calling IsInitialized() on the outer message
   * may return true even if the inner message has missing required fields.
   * This is necessary because otherwise the inner message would have to be
   * parsed in order to perform the check, defeating the purpose of lazy
   * parsing.  An implementation which chooses not to check required fields
   * must be consistent about it.  That is, for any particular sub-message, the
   * implementation must either *always* check its required fields, or *never*
   * check its required fields, regardless of whether or not the message has
   * been parsed.
   */
  lazy?: InputMaybe<Scalars['Boolean']>;
  /**
   * The packed option can be enabled for repeated primitive fields to enable
   * a more efficient representation on the wire. Rather than repeatedly
   * writing the tag and type for each element, the entire array is encoded as
   * a single length-delimited blob. In proto3, only explicit setting it to
   * false will avoid using packed encoding.
   */
  packed?: InputMaybe<Scalars['Boolean']>;
  /** The parser stores options it doesn't recognize here. See above. */
  uninterpretedOption?: InputMaybe<Array<GoogleProtobuf_UninterpretedOptionInput>>;
  /** For Google-internal migration only. Do not use. */
  weak?: InputMaybe<Scalars['Boolean']>;
};

export type GoogleProtobuf_FieldOptions_CType =
  | 'CORD'
  /** Default mode. */
  | 'STRING'
  | 'STRING_PIECE';

export type GoogleProtobuf_FieldOptions_JsType =
  /** Use the default type. */
  | 'JS_NORMAL'
  /** Use JavaScript numbers. */
  | 'JS_NUMBER'
  /** Use JavaScript strings. */
  | 'JS_STRING';

/** Whether a field is optional, required, or repeated. */
export type GoogleProtobuf_Field_Cardinality =
  /** For optional fields. */
  | 'CARDINALITY_OPTIONAL'
  /** For repeated fields. */
  | 'CARDINALITY_REPEATED'
  /** For required fields. Proto2 syntax only. */
  | 'CARDINALITY_REQUIRED'
  /** For fields with unknown cardinality. */
  | 'CARDINALITY_UNKNOWN';

/** Basic field types. */
export type GoogleProtobuf_Field_Kind =
  /** Field type bool. */
  | 'TYPE_BOOL'
  /** Field type bytes. */
  | 'TYPE_BYTES'
  /** Field type double. */
  | 'TYPE_DOUBLE'
  /** Field type enum. */
  | 'TYPE_ENUM'
  /** Field type fixed32. */
  | 'TYPE_FIXED32'
  /** Field type fixed64. */
  | 'TYPE_FIXED64'
  /** Field type float. */
  | 'TYPE_FLOAT'
  /** Field type group. Proto2 syntax only, and deprecated. */
  | 'TYPE_GROUP'
  /** Field type int32. */
  | 'TYPE_INT32'
  /** Field type int64. */
  | 'TYPE_INT64'
  /** Field type message. */
  | 'TYPE_MESSAGE'
  /** Field type sfixed32. */
  | 'TYPE_SFIXED32'
  /** Field type sfixed64. */
  | 'TYPE_SFIXED64'
  /** Field type sint32. */
  | 'TYPE_SINT32'
  /** Field type sint64. */
  | 'TYPE_SINT64'
  /** Field type string. */
  | 'TYPE_STRING'
  /** Field type uint32. */
  | 'TYPE_UINT32'
  /** Field type uint64. */
  | 'TYPE_UINT64'
  /** Field type unknown. */
  | 'TYPE_UNKNOWN';

/** Describes a complete .proto file. */
export type GoogleProtobuf_FileDescriptorProtoInput = {
  /** Names of files imported by this file. */
  dependency?: InputMaybe<Array<Scalars['String']>>;
  enumType?: InputMaybe<Array<GoogleProtobuf_EnumDescriptorProtoInput>>;
  extension?: InputMaybe<Array<GoogleProtobuf_FieldDescriptorProtoInput>>;
  /** All top-level definitions in this file. */
  messageType?: InputMaybe<Array<GoogleProtobuf_DescriptorProtoInput>>;
  /** file name, relative to root of source tree */
  name?: InputMaybe<Scalars['String']>;
  options?: InputMaybe<GoogleProtobuf_FileOptionsInput>;
  /** e.g. "foo", "foo.bar", etc. */
  package?: InputMaybe<Scalars['String']>;
  /** Indexes of the public imported files in the dependency list above. */
  publicDependency?: InputMaybe<Array<Scalars['Float']>>;
  service?: InputMaybe<Array<GoogleProtobuf_ServiceDescriptorProtoInput>>;
  /**
   * This field contains optional information about the original source code.
   * You may safely remove this entire field without harming runtime
   * functionality of the descriptors -- the information is needed only by
   * development tools.
   */
  sourceCodeInfo?: InputMaybe<GoogleProtobuf_SourceCodeInfoInput>;
  /**
   * The syntax of the proto file.
   * The supported values are "proto2" and "proto3".
   */
  syntax?: InputMaybe<Scalars['String']>;
  /**
   * Indexes of the weak imported files in the dependency list.
   * For Google-internal migration only. Do not use.
   */
  weakDependency?: InputMaybe<Array<Scalars['Float']>>;
};

/**
 * The protocol compiler can output a FileDescriptorSet containing the .proto
 * files it parses.
 */
export type GoogleProtobuf_FileDescriptorSetInput = {
  file?: InputMaybe<Array<GoogleProtobuf_FileDescriptorProtoInput>>;
};

export type GoogleProtobuf_FileOptionsInput = {
  /**
   * Enables the use of arenas for the proto messages in this file. This applies
   * only to generated classes for C++.
   */
  ccEnableArenas?: InputMaybe<Scalars['Boolean']>;
  /**
   * Should generic services be generated in each language?  "Generic" services
   * are not specific to any particular RPC system.  They are generated by the
   * main code generators in each language (without additional plugins).
   * Generic services were the only kind of service generation supported by
   * early versions of google.protobuf.
   *
   * Generic services are now considered deprecated in favor of using plugins
   * that generate code specific to your particular RPC system.  Therefore,
   * these default to false.  Old code which depends on generic services should
   * explicitly set them to true.
   */
  ccGenericServices?: InputMaybe<Scalars['Boolean']>;
  /** Namespace for generated classes; defaults to the package. */
  csharpNamespace?: InputMaybe<Scalars['String']>;
  /**
   * Is this file deprecated?
   * Depending on the target platform, this can emit Deprecated annotations
   * for everything in the file, or it will be completely ignored; in the very
   * least, this is a formalization for deprecating files.
   */
  deprecated?: InputMaybe<Scalars['Boolean']>;
  /**
   * Sets the Go package where structs generated from this .proto will be
   * placed. If omitted, the Go package will be derived from the following:
   *   - The basename of the package import path, if provided.
   *   - Otherwise, the package statement in the .proto file, if present.
   *   - Otherwise, the basename of the .proto file, without extension.
   */
  goPackage?: InputMaybe<Scalars['String']>;
  /** This option does nothing. */
  javaGenerateEqualsAndHash?: InputMaybe<Scalars['Boolean']>;
  javaGenericServices?: InputMaybe<Scalars['Boolean']>;
  /**
   * If enabled, then the Java code generator will generate a separate .java
   * file for each top-level message, enum, and service defined in the .proto
   * file.  Thus, these types will *not* be nested inside the wrapper class
   * named by java_outer_classname.  However, the wrapper class will still be
   * generated to contain the file's getDescriptor() method as well as any
   * top-level extensions defined in the file.
   */
  javaMultipleFiles?: InputMaybe<Scalars['Boolean']>;
  /**
   * Controls the name of the wrapper Java class generated for the .proto file.
   * That class will always contain the .proto file's getDescriptor() method as
   * well as any top-level extensions defined in the .proto file.
   * If java_multiple_files is disabled, then all the other classes from the
   * .proto file will be nested inside the single wrapper outer class.
   */
  javaOuterClassname?: InputMaybe<Scalars['String']>;
  /**
   * Sets the Java package where classes generated from this .proto will be
   * placed.  By default, the proto package is used, but this is often
   * inappropriate because proto packages do not normally start with backwards
   * domain names.
   */
  javaPackage?: InputMaybe<Scalars['String']>;
  /**
   * If set true, then the Java2 code generator will generate code that
   * throws an exception whenever an attempt is made to assign a non-UTF-8
   * byte sequence to a string field.
   * Message reflection will do the same.
   * However, an extension field still accepts non-UTF-8 byte sequences.
   * This option has no effect on when used with the lite runtime.
   */
  javaStringCheckUtf8?: InputMaybe<Scalars['Boolean']>;
  /**
   * Sets the objective c class prefix which is prepended to all objective c
   * generated classes from this .proto. There is no default.
   */
  objcClassPrefix?: InputMaybe<Scalars['String']>;
  optimizeFor?: InputMaybe<GoogleProtobuf_FileOptions_OptimizeMode>;
  /**
   * Sets the php class prefix which is prepended to all php generated classes
   * from this .proto. Default is empty.
   */
  phpClassPrefix?: InputMaybe<Scalars['String']>;
  phpGenericServices?: InputMaybe<Scalars['Boolean']>;
  /**
   * Use this option to change the namespace of php generated metadata classes.
   * Default is empty. When this option is empty, the proto file name will be
   * used for determining the namespace.
   */
  phpMetadataNamespace?: InputMaybe<Scalars['String']>;
  /**
   * Use this option to change the namespace of php generated classes. Default
   * is empty. When this option is empty, the package name will be used for
   * determining the namespace.
   */
  phpNamespace?: InputMaybe<Scalars['String']>;
  pyGenericServices?: InputMaybe<Scalars['Boolean']>;
  /**
   * Use this option to change the package of ruby generated classes. Default
   * is empty. When this option is not set, the package name will be used for
   * determining the ruby package.
   */
  rubyPackage?: InputMaybe<Scalars['String']>;
  /**
   * By default Swift generators will take the proto package and CamelCase it
   * replacing '.' with underscore and use that to prefix the types/symbols
   * defined. When this options is provided, they will use this value instead
   * to prefix the types/symbols defined.
   */
  swiftPrefix?: InputMaybe<Scalars['String']>;
  /**
   * The parser stores options it doesn't recognize here.
   * See the documentation for the "Options" section above.
   */
  uninterpretedOption?: InputMaybe<Array<GoogleProtobuf_UninterpretedOptionInput>>;
};

/** Generated classes can be optimized for speed or code size. */
export type GoogleProtobuf_FileOptions_OptimizeMode =
  /**
   * etc.
   *
   * Use ReflectionOps to implement these methods.
   */
  | 'CODE_SIZE'
  /** Generate code using MessageLite and the lite runtime. */
  | 'LITE_RUNTIME'
  /** Generate complete code for parsing, serialization, */
  | 'SPEED';

/**
 * Wrapper message for `float`.
 *
 * The JSON representation for `FloatValue` is JSON number.
 */
export type GoogleProtobuf_FloatValueInput = {
  /** The float value. */
  value?: InputMaybe<Scalars['Float']>;
};

/**
 * Describes the relationship between generated code and its original source
 * file. A GeneratedCodeInfo message is associated with only one generated
 * source file, but may contain references to different source .proto files.
 */
export type GoogleProtobuf_GeneratedCodeInfoInput = {
  /**
   * An Annotation connects some span of text in generated code to an element
   * of its generating .proto file.
   */
  annotation?: InputMaybe<Array<GoogleProtobuf_GeneratedCodeInfo_AnnotationInput>>;
};

export type GoogleProtobuf_GeneratedCodeInfo_AnnotationInput = {
  /**
   * Identifies the starting offset in bytes in the generated code
   * that relates to the identified object.
   */
  begin?: InputMaybe<Scalars['Float']>;
  /**
   * Identifies the ending offset in bytes in the generated code that
   * relates to the identified offset. The end offset should be one past
   * the last relevant byte (so the length of the text = end - begin).
   */
  end?: InputMaybe<Scalars['Float']>;
  /**
   * Identifies the element in the original source .proto file. This field
   * is formatted the same as SourceCodeInfo.Location.path.
   */
  path?: InputMaybe<Array<Scalars['Float']>>;
  /** Identifies the filesystem path to the original source .proto. */
  sourceFile?: InputMaybe<Scalars['String']>;
};

/**
 * Wrapper message for `int32`.
 *
 * The JSON representation for `Int32Value` is JSON number.
 */
export type GoogleProtobuf_Int32ValueInput = {
  /** The int32 value. */
  value?: InputMaybe<Scalars['Float']>;
};

/**
 * Wrapper message for `int64`.
 *
 * The JSON representation for `Int64Value` is JSON string.
 */
export type GoogleProtobuf_Int64ValueInput = {
  /** The int64 value. */
  value?: InputMaybe<Scalars['Float']>;
};

/**
 * `ListValue` is a wrapper around a repeated field of values.
 *
 * The JSON representation for `ListValue` is JSON array.
 */
export type GoogleProtobuf_ListValueInput = {
  /** Repeated field of dynamically typed values. */
  values?: InputMaybe<Array<GoogleProtobuf_ValueInput>>;
};

export type GoogleProtobuf_MessageOptionsInput = {
  /**
   * Is this message deprecated?
   * Depending on the target platform, this can emit Deprecated annotations
   * for the message, or it will be completely ignored; in the very least,
   * this is a formalization for deprecating messages.
   */
  deprecated?: InputMaybe<Scalars['Boolean']>;
  /**
   * Whether the message is an automatically generated map entry type for the
   * maps field.
   *
   * For maps fields:
   *     map<KeyType, ValueType> map_field = 1;
   * The parsed descriptor looks like:
   *     message MapFieldEntry {
   *         option map_entry = true;
   *         optional KeyType key = 1;
   *         optional ValueType value = 2;
   *     }
   *     repeated MapFieldEntry map_field = 1;
   *
   * Implementations may choose not to generate the map_entry=true message, but
   * use a native map in the target language to hold the keys and values.
   * The reflection APIs in such implementations still need to work as
   * if the field is a repeated message field.
   *
   * NOTE: Do not set the option in .proto files. Always use the maps syntax
   * instead. The option should only be implicitly set by the proto compiler
   * parser.
   */
  mapEntry?: InputMaybe<Scalars['Boolean']>;
  /**
   * Set true to use the old proto1 MessageSet wire format for extensions.
   * This is provided for backwards-compatibility with the MessageSet wire
   * format.  You should not use this for any other reason:  It's less
   * efficient, has fewer features, and is more complicated.
   *
   * The message must be defined exactly as follows:
   *   message Foo {
   *     option message_set_wire_format = true;
   *     extensions 4 to max;
   *   }
   * Note that the message cannot have any defined fields; MessageSets only
   * have extensions.
   *
   * All extensions of your type must be singular messages; e.g. they cannot
   * be int32s, enums, or repeated messages.
   *
   * Because this is an option, the above two restrictions are not enforced by
   * the protocol compiler.
   */
  messageSetWireFormat?: InputMaybe<Scalars['Boolean']>;
  /**
   * Disables the generation of the standard "descriptor()" accessor, which can
   * conflict with a field of the same name.  This is meant to make migration
   * from proto1 easier; new code should avoid fields named "descriptor".
   */
  noStandardDescriptorAccessor?: InputMaybe<Scalars['Boolean']>;
  /** The parser stores options it doesn't recognize here. See above. */
  uninterpretedOption?: InputMaybe<Array<GoogleProtobuf_UninterpretedOptionInput>>;
};

/** Describes a method of a service. */
export type GoogleProtobuf_MethodDescriptorProtoInput = {
  /** Identifies if client streams multiple client messages */
  clientStreaming?: InputMaybe<Scalars['Boolean']>;
  /**
   * Input and output type names.  These are resolved in the same way as
   * FieldDescriptorProto.type_name, but must refer to a message type.
   */
  inputType?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  options?: InputMaybe<GoogleProtobuf_MethodOptionsInput>;
  outputType?: InputMaybe<Scalars['String']>;
  /** Identifies if server streams multiple server messages */
  serverStreaming?: InputMaybe<Scalars['Boolean']>;
};

/** Method represents a method of an API interface. */
export type GoogleProtobuf_MethodInput = {
  /** The simple name of this method. */
  name?: InputMaybe<Scalars['String']>;
  /** Any metadata attached to the method. */
  options?: InputMaybe<Array<GoogleProtobuf_OptionInput>>;
  /** If true, the request is streamed. */
  requestStreaming?: InputMaybe<Scalars['Boolean']>;
  /** A URL of the input message type. */
  requestTypeUrl?: InputMaybe<Scalars['String']>;
  /** If true, the response is streamed. */
  responseStreaming?: InputMaybe<Scalars['Boolean']>;
  /** The URL of the output message type. */
  responseTypeUrl?: InputMaybe<Scalars['String']>;
  /** The source syntax of this method. */
  syntax?: InputMaybe<GoogleProtobuf_Syntax>;
};

export type GoogleProtobuf_MethodOptionsInput = {
  /**
   * Is this method deprecated?
   * Depending on the target platform, this can emit Deprecated annotations
   * for the method, or it will be completely ignored; in the very least,
   * this is a formalization for deprecating methods.
   */
  deprecated?: InputMaybe<Scalars['Boolean']>;
  idempotencyLevel?: InputMaybe<GoogleProtobuf_MethodOptions_IdempotencyLevel>;
  /** The parser stores options it doesn't recognize here. See above. */
  uninterpretedOption?: InputMaybe<Array<GoogleProtobuf_UninterpretedOptionInput>>;
};

/**
 * Is this method side-effect-free (or safe in HTTP parlance), or idempotent,
 * or neither? HTTP based RPC implementation may choose GET verb for safe
 * methods, and PUT verb for idempotent methods instead of the default POST.
 */
export type GoogleProtobuf_MethodOptions_IdempotencyLevel =
  | 'IDEMPOTENCY_UNKNOWN'
  /** idempotent, but may have side effects */
  | 'IDEMPOTENT'
  /** implies idempotent */
  | 'NO_SIDE_EFFECTS';

/**
 * Declares an API Interface to be included in this interface. The including
 * interface must redeclare all the methods from the included interface, but
 * documentation and options are inherited as follows:
 *
 * - If after comment and whitespace stripping, the documentation
 *   string of the redeclared method is empty, it will be inherited
 *   from the original method.
 *
 * - Each annotation belonging to the service config (http,
 *   visibility) which is not set in the redeclared method will be
 *   inherited.
 *
 * - If an http annotation is inherited, the path pattern will be
 *   modified as follows. Any version prefix will be replaced by the
 *   version of the including interface plus the [root][] path if
 *   specified.
 *
 * Example of a simple mixin:
 *
 *     package google.acl.v1;
 *     service AccessControl {
 *       // Get the underlying ACL object.
 *       rpc GetAcl(GetAclRequest) returns (Acl) {
 *         option (google.api.http).get = "/v1/{resource=**}:getAcl";
 *       }
 *     }
 *
 *     package google.storage.v2;
 *     service Storage {
 *       rpc GetAcl(GetAclRequest) returns (Acl);
 *
 *       // Get a data record.
 *       rpc GetData(GetDataRequest) returns (Data) {
 *         option (google.api.http).get = "/v2/{resource=**}";
 *       }
 *     }
 *
 * Example of a mixin configuration:
 *
 *     apis:
 *     - name: google.storage.v2.Storage
 *       mixins:
 *       - name: google.acl.v1.AccessControl
 *
 * The mixin construct implies that all methods in `AccessControl` are
 * also declared with same name and request/response types in
 * `Storage`. A documentation generator or annotation processor will
 * see the effective `Storage.GetAcl` method after inheriting
 * documentation and annotations as follows:
 *
 *     service Storage {
 *       // Get the underlying ACL object.
 *       rpc GetAcl(GetAclRequest) returns (Acl) {
 *         option (google.api.http).get = "/v2/{resource=**}:getAcl";
 *       }
 *       ...
 *     }
 *
 * Note how the version in the path pattern changed from `v1` to `v2`.
 *
 * If the `root` field in the mixin is specified, it should be a
 * relative path under which inherited HTTP paths are placed. Example:
 *
 *     apis:
 *     - name: google.storage.v2.Storage
 *       mixins:
 *       - name: google.acl.v1.AccessControl
 *         root: acls
 *
 * This implies the following inherited HTTP annotation:
 *
 *     service Storage {
 *       // Get the underlying ACL object.
 *       rpc GetAcl(GetAclRequest) returns (Acl) {
 *         option (google.api.http).get = "/v2/acls/{resource=**}:getAcl";
 *       }
 *       ...
 *     }
 */
export type GoogleProtobuf_MixinInput = {
  /** The fully qualified name of the interface which is included. */
  name?: InputMaybe<Scalars['String']>;
  /**
   * If non-empty specifies a path under which inherited HTTP paths
   * are rooted.
   */
  root?: InputMaybe<Scalars['String']>;
};

/**
 * `NullValue` is a singleton enumeration to represent the null value for the
 * `Value` type union.
 *
 *  The JSON representation for `NullValue` is JSON `null`.
 */
export type GoogleProtobuf_NullValue =
  /** Null value. */
  | 'NULL_VALUE';

/** Describes a oneof. */
export type GoogleProtobuf_OneofDescriptorProtoInput = {
  name?: InputMaybe<Scalars['String']>;
  options?: InputMaybe<GoogleProtobuf_OneofOptionsInput>;
};

export type GoogleProtobuf_OneofOptionsInput = {
  /** The parser stores options it doesn't recognize here. See above. */
  uninterpretedOption?: InputMaybe<Array<GoogleProtobuf_UninterpretedOptionInput>>;
};

/**
 * A protocol buffer option, which can be attached to a message, field,
 * enumeration, etc.
 */
export type GoogleProtobuf_OptionInput = {
  /**
   * The option's name. For protobuf built-in options (options defined in
   * descriptor.proto), this is the short name. For example, `"map_entry"`.
   * For custom options, it should be the fully-qualified name. For example,
   * `"google.api.http"`.
   */
  name?: InputMaybe<Scalars['String']>;
  /**
   * The option's value packed in an Any message. If the value is a primitive,
   * the corresponding wrapper type defined in google/protobuf/wrappers.proto
   * should be used. If the value is an enum, it should be stored as an int32
   * value using the google.protobuf.Int32Value type.
   */
  value?: InputMaybe<GoogleProtobuf_AnyInput>;
};

/** Describes a service. */
export type GoogleProtobuf_ServiceDescriptorProtoInput = {
  method?: InputMaybe<Array<GoogleProtobuf_MethodDescriptorProtoInput>>;
  name?: InputMaybe<Scalars['String']>;
  options?: InputMaybe<GoogleProtobuf_ServiceOptionsInput>;
};

export type GoogleProtobuf_ServiceOptionsInput = {
  /**
   * Is this service deprecated?
   * Depending on the target platform, this can emit Deprecated annotations
   * for the service, or it will be completely ignored; in the very least,
   * this is a formalization for deprecating services.
   */
  deprecated?: InputMaybe<Scalars['Boolean']>;
  /** The parser stores options it doesn't recognize here. See above. */
  uninterpretedOption?: InputMaybe<Array<GoogleProtobuf_UninterpretedOptionInput>>;
};

/**
 * Encapsulates information about the original source file from which a
 * FileDescriptorProto was generated.
 */
export type GoogleProtobuf_SourceCodeInfoInput = {
  /**
   * A Location identifies a piece of source code in a .proto file which
   * corresponds to a particular definition.  This information is intended
   * to be useful to IDEs, code indexers, documentation generators, and similar
   * tools.
   *
   * For example, say we have a file like:
   *   message Foo {
   *     optional string foo = 1;
   *   }
   * Let's look at just the field definition:
   *   optional string foo = 1;
   *   ^       ^^     ^^  ^  ^^^
   *   a       bc     de  f  ghi
   * We have the following locations:
   *   span   path               represents
   *   [a,i)  [ 4, 0, 2, 0 ]     The whole field definition.
   *   [a,b)  [ 4, 0, 2, 0, 4 ]  The label (optional).
   *   [c,d)  [ 4, 0, 2, 0, 5 ]  The type (string).
   *   [e,f)  [ 4, 0, 2, 0, 1 ]  The name (foo).
   *   [g,h)  [ 4, 0, 2, 0, 3 ]  The number (1).
   *
   * Notes:
   * - A location may refer to a repeated field itself (i.e. not to any
   *   particular index within it).  This is used whenever a set of elements are
   *   logically enclosed in a single code segment.  For example, an entire
   *   extend block (possibly containing multiple extension definitions) will
   *   have an outer location whose path refers to the "extensions" repeated
   *   field without an index.
   * - Multiple locations may have the same path.  This happens when a single
   *   logical declaration is spread out across multiple places.  The most
   *   obvious example is the "extend" block again -- there may be multiple
   *   extend blocks in the same scope, each of which will have the same path.
   * - A location's span is not always a subset of its parent's span.  For
   *   example, the "extendee" of an extension declaration appears at the
   *   beginning of the "extend" block and is shared by all extensions within
   *   the block.
   * - Just because a location's span is a subset of some other location's span
   *   does not mean that it is a descendant.  For example, a "group" defines
   *   both a type and a field in a single declaration.  Thus, the locations
   *   corresponding to the type and field and their components will overlap.
   * - Code which tries to interpret locations should probably be designed to
   *   ignore those that it doesn't understand, as more types of locations could
   *   be recorded in the future.
   */
  location?: InputMaybe<Array<GoogleProtobuf_SourceCodeInfo_LocationInput>>;
};

export type GoogleProtobuf_SourceCodeInfo_LocationInput = {
  /**
   * If this SourceCodeInfo represents a complete declaration, these are any
   * comments appearing before and after the declaration which appear to be
   * attached to the declaration.
   *
   * A series of line comments appearing on consecutive lines, with no other
   * tokens appearing on those lines, will be treated as a single comment.
   *
   * leading_detached_comments will keep paragraphs of comments that appear
   * before (but not connected to) the current element. Each paragraph,
   * separated by empty lines, will be one comment element in the repeated
   * field.
   *
   * Only the comment content is provided; comment markers (e.g. //) are
   * stripped out.  For block comments, leading whitespace and an asterisk
   * will be stripped from the beginning of each line other than the first.
   * Newlines are included in the output.
   *
   * Examples:
   *
   *   optional int32 foo = 1;  // Comment attached to foo.
   *   // Comment attached to bar.
   *   optional int32 bar = 2;
   *
   *   optional string baz = 3;
   *   // Comment attached to baz.
   *   // Another line attached to baz.
   *
   *   // Comment attached to qux.
   *   //
   *   // Another line attached to qux.
   *   optional double qux = 4;
   *
   *   // Detached comment for corge. This is not leading or trailing comments
   *   // to qux or corge because there are blank lines separating it from
   *   // both.
   *
   *   // Detached comment for corge paragraph 2.
   *
   *   optional string corge = 5;
   *   /* Block comment attached
   *    * to corge.  Leading asterisks
   *    * will be removed. *\/
   *   /* Block comment attached to
   *    * grault. *\/
   *   optional int32 grault = 6;
   *
   *   // ignored detached comments.
   */
  leadingComments?: InputMaybe<Scalars['String']>;
  leadingDetachedComments?: InputMaybe<Array<Scalars['String']>>;
  /**
   * Identifies which part of the FileDescriptorProto was defined at this
   * location.
   *
   * Each element is a field number or an index.  They form a path from
   * the root FileDescriptorProto to the place where the definition.  For
   * example, this path:
   *   [ 4, 3, 2, 7, 1 ]
   * refers to:
   *   file.message_type(3)  // 4, 3
   *       .field(7)         // 2, 7
   *       .name()           // 1
   * This is because FileDescriptorProto.message_type has field number 4:
   *   repeated DescriptorProto message_type = 4;
   * and DescriptorProto.field has field number 2:
   *   repeated FieldDescriptorProto field = 2;
   * and FieldDescriptorProto.name has field number 1:
   *   optional string name = 1;
   *
   * Thus, the above path gives the location of a field name.  If we removed
   * the last element:
   *   [ 4, 3, 2, 7 ]
   * this path refers to the whole field declaration (from the beginning
   * of the label to the terminating semicolon).
   */
  path?: InputMaybe<Array<Scalars['Float']>>;
  /**
   * Always has exactly three or four elements: start line, start column,
   * end line (optional, otherwise assumed same as start line), end column.
   * These are packed into a single field for efficiency.  Note that line
   * and column numbers are zero-based -- typically you will want to add
   * 1 to each before displaying to a user.
   */
  span?: InputMaybe<Array<Scalars['Float']>>;
  trailingComments?: InputMaybe<Scalars['String']>;
};

/**
 * `SourceContext` represents information about the source of a
 * protobuf element, like the file in which it is defined.
 */
export type GoogleProtobuf_SourceContextInput = {
  /**
   * The path-qualified name of the .proto file that contained the associated
   * protobuf element.  For example: `"google/protobuf/source_context.proto"`.
   */
  fileName?: InputMaybe<Scalars['String']>;
};

/**
 * Wrapper message for `string`.
 *
 * The JSON representation for `StringValue` is JSON string.
 */
export type GoogleProtobuf_StringValueInput = {
  /** The string value. */
  value?: InputMaybe<Scalars['String']>;
};

/**
 * `Struct` represents a structured data value, consisting of fields
 * which map to dynamically typed values. In some languages, `Struct`
 * might be supported by a native representation. For example, in
 * scripting languages like JS a struct is represented as an
 * object. The details of that representation are described together
 * with the proto support for the language.
 *
 * The JSON representation for `Struct` is JSON object.
 */
export type GoogleProtobuf_StructInput = {
  /** Unordered map of dynamically typed values. */
  fields?: InputMaybe<Array<GoogleProtobuf_Struct_FieldsEntryInput>>;
};

/** `GoogleProtobuf_Struct_FieldsEntryInput` represents the `fields` map in `google.protobuf.Struct`. */
export type GoogleProtobuf_Struct_FieldsEntryInput = {
  key?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<GoogleProtobuf_ValueInput>;
};

/** The syntax in which a protocol buffer element is defined. */
export type GoogleProtobuf_Syntax =
  /** Syntax `proto2`. */
  | 'SYNTAX_PROTO2'
  /** Syntax `proto3`. */
  | 'SYNTAX_PROTO3';

/**
 * A Timestamp represents a point in time independent of any time zone or local
 * calendar, encoded as a count of seconds and fractions of seconds at
 * nanosecond resolution. The count is relative to an epoch at UTC midnight on
 * January 1, 1970, in the proleptic Gregorian calendar which extends the
 * Gregorian calendar backwards to year one.
 *
 * All minutes are 60 seconds long. Leap seconds are "smeared" so that no leap
 * second table is needed for interpretation, using a [24-hour linear
 * smear](https://developers.google.com/time/smear).
 *
 * The range is from 0001-01-01T00:00:00Z to 9999-12-31T23:59:59.999999999Z. By
 * restricting to that range, we ensure that we can convert to and from [RFC
 * 3339](https://www.ietf.org/rfc/rfc3339.txt) date strings.
 *
 * # Examples
 *
 * Example 1: Compute Timestamp from POSIX `time()`.
 *
 *     Timestamp timestamp;
 *     timestamp.set_seconds(time(NULL));
 *     timestamp.set_nanos(0);
 *
 * Example 2: Compute Timestamp from POSIX `gettimeofday()`.
 *
 *     struct timeval tv;
 *     gettimeofday(&tv, NULL);
 *
 *     Timestamp timestamp;
 *     timestamp.set_seconds(tv.tv_sec);
 *     timestamp.set_nanos(tv.tv_usec * 1000);
 *
 * Example 3: Compute Timestamp from Win32 `GetSystemTimeAsFileTime()`.
 *
 *     FILETIME ft;
 *     GetSystemTimeAsFileTime(&ft);
 *     UINT64 ticks = (((UINT64)ft.dwHighDateTime) << 32) | ft.dwLowDateTime;
 *
 *     // A Windows tick is 100 nanoseconds. Windows epoch 1601-01-01T00:00:00Z
 *     // is 11644473600 seconds before Unix epoch 1970-01-01T00:00:00Z.
 *     Timestamp timestamp;
 *     timestamp.set_seconds((INT64) ((ticks / 10000000) - 11644473600LL));
 *     timestamp.set_nanos((INT32) ((ticks % 10000000) * 100));
 *
 * Example 4: Compute Timestamp from Java `System.currentTimeMillis()`.
 *
 *     long millis = System.currentTimeMillis();
 *
 *     Timestamp timestamp = Timestamp.newBuilder().setSeconds(millis / 1000)
 *         .setNanos((int) ((millis % 1000) * 1000000)).build();
 *
 *
 * Example 5: Compute Timestamp from Java `Instant.now()`.
 *
 *     Instant now = Instant.now();
 *
 *     Timestamp timestamp =
 *         Timestamp.newBuilder().setSeconds(now.getEpochSecond())
 *             .setNanos(now.getNano()).build();
 *
 *
 * Example 6: Compute Timestamp from current time in Python.
 *
 *     timestamp = Timestamp()
 *     timestamp.GetCurrentTime()
 *
 * # JSON Mapping
 *
 * In JSON format, the Timestamp type is encoded as a string in the
 * [RFC 3339](https://www.ietf.org/rfc/rfc3339.txt) format. That is, the
 * format is "{year}-{month}-{day}T{hour}:{min}:{sec}[.{frac_sec}]Z"
 * where {year} is always expressed using four digits while {month}, {day},
 * {hour}, {min}, and {sec} are zero-padded to two digits each. The fractional
 * seconds, which can go up to 9 digits (i.e. up to 1 nanosecond resolution),
 * are optional. The "Z" suffix indicates the timezone ("UTC"); the timezone
 * is required. A proto3 JSON serializer should always use UTC (as indicated by
 * "Z") when printing the Timestamp type and a proto3 JSON parser should be
 * able to accept both UTC and other timezones (as indicated by an offset).
 *
 * For example, "2017-01-15T01:30:15.01Z" encodes 15.01 seconds past
 * 01:30 UTC on January 15, 2017.
 *
 * In JavaScript, one can convert a Date object to this format using the
 * standard
 * [toISOString()](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/toISOString)
 * method. In Python, a standard `datetime.datetime` object can be converted
 * to this format using
 * [`strftime`](https://docs.python.org/2/library/time.html#time.strftime) with
 * the time format spec '%Y-%m-%dT%H:%M:%S.%fZ'. Likewise, in Java, one can use
 * the Joda Time's [`ISODateTimeFormat.dateTime()`](
 * http://www.joda.org/joda-time/apidocs/org/joda/time/format/ISODateTimeFormat.html#dateTime%2D%2D
 * ) to obtain a formatter capable of generating timestamps in this format.
 */
export type GoogleProtobuf_TimestampInput = {
  /**
   * Non-negative fractions of a second at nanosecond resolution. Negative
   * second values with fractions must still have non-negative nanos values
   * that count forward in time. Must be from 0 to 999,999,999
   * inclusive.
   */
  nanos?: InputMaybe<Scalars['Float']>;
  /**
   * Represents seconds of UTC time since Unix epoch
   * 1970-01-01T00:00:00Z. Must be from 0001-01-01T00:00:00Z to
   * 9999-12-31T23:59:59Z inclusive.
   */
  seconds?: InputMaybe<Scalars['Float']>;
};

/** A protocol buffer message type. */
export type GoogleProtobuf_TypeInput = {
  /** The list of fields. */
  fields?: InputMaybe<Array<GoogleProtobuf_FieldInput>>;
  /** The fully qualified message name. */
  name?: InputMaybe<Scalars['String']>;
  /** The list of types appearing in `oneof` definitions in this type. */
  oneofs?: InputMaybe<Array<Scalars['String']>>;
  /** The protocol buffer options. */
  options?: InputMaybe<Array<GoogleProtobuf_OptionInput>>;
  /** The source context. */
  sourceContext?: InputMaybe<GoogleProtobuf_SourceContextInput>;
  /** The source syntax. */
  syntax?: InputMaybe<GoogleProtobuf_Syntax>;
};

/**
 * Wrapper message for `uint32`.
 *
 * The JSON representation for `UInt32Value` is JSON number.
 */
export type GoogleProtobuf_UInt32ValueInput = {
  /** The uint32 value. */
  value?: InputMaybe<Scalars['Float']>;
};

/**
 * Wrapper message for `uint64`.
 *
 * The JSON representation for `UInt64Value` is JSON string.
 */
export type GoogleProtobuf_UInt64ValueInput = {
  /** The uint64 value. */
  value?: InputMaybe<Scalars['Float']>;
};

/**
 * A message representing a option the parser does not recognize. This only
 * appears in options protos created by the compiler::Parser class.
 * DescriptorPool resolves these when building Descriptor objects. Therefore,
 * options protos in descriptor objects (e.g. returned by Descriptor::options(),
 * or produced by Descriptor::CopyTo()) will never have UninterpretedOptions
 * in them.
 */
export type GoogleProtobuf_UninterpretedOptionInput = {
  aggregateValue?: InputMaybe<Scalars['String']>;
  doubleValue?: InputMaybe<Scalars['Float']>;
  /**
   * The value of the uninterpreted option, in whatever type the tokenizer
   * identified it as during parsing. Exactly one of these should be set.
   */
  identifierValue?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Array<GoogleProtobuf_UninterpretedOption_NamePartInput>>;
  negativeIntValue?: InputMaybe<Scalars['Float']>;
  positiveIntValue?: InputMaybe<Scalars['Float']>;
  stringValue?: InputMaybe<Scalars['String']>;
};

/**
 * The name of the uninterpreted option.  Each string represents a segment in
 * a dot-separated name.  is_extension is true iff a segment represents an
 * extension (denoted with parentheses in options specs in .proto files).
 * E.g.,{ ["foo", false], ["bar.baz", true], ["qux", false] } represents
 * "foo.(bar.baz).qux".
 */
export type GoogleProtobuf_UninterpretedOption_NamePartInput = {
  isExtension?: InputMaybe<Scalars['Boolean']>;
  namePart?: InputMaybe<Scalars['String']>;
};

/**
 * `Value` represents a dynamically typed value which can be either
 * null, a number, a string, a boolean, a recursive struct value, or a
 * list of values. A producer of value is expected to set one of these
 * variants. Absence of any variant indicates an error.
 *
 * The JSON representation for `Value` is JSON value.
 */
export type GoogleProtobuf_ValueInput = {
  /** The kind of value. */
  kind?: InputMaybe<GoogleProtobuf_Value_KindOneofInput>;
};

export type GoogleProtobuf_Value_KindOneofInput = {
  /** Represents a boolean value. */
  boolValue?: InputMaybe<Scalars['Boolean']>;
  /** Represents a repeated `Value`. */
  listValue?: InputMaybe<GoogleProtobuf_ListValueInput>;
  /** Represents a null value. */
  nullValue?: InputMaybe<GoogleProtobuf_NullValue>;
  /** Represents a double value. */
  numberValue?: InputMaybe<Scalars['Float']>;
  /** Represents a string value. */
  stringValue?: InputMaybe<Scalars['String']>;
  /** Represents a structured value. */
  structValue?: InputMaybe<GoogleProtobuf_StructInput>;
};

/**
 * The canonical error codes for gRPC APIs.
 *
 *
 * Sometimes multiple error codes may apply.  Services should return
 * the most specific error code that applies.  For example, prefer
 * `OUT_OF_RANGE` over `FAILED_PRECONDITION` if both codes apply.
 * Similarly prefer `NOT_FOUND` or `ALREADY_EXISTS` over `FAILED_PRECONDITION`.
 */
export type GoogleRpc_Code =
  /**
   * The operation was aborted, typically due to a concurrency issue such as
   * a sequencer check failure or transaction abort.
   *
   * See the guidelines above for deciding between `FAILED_PRECONDITION`,
   * `ABORTED`, and `UNAVAILABLE`.
   *
   * HTTP Mapping: 409 Conflict
   */
  | 'ABORTED'
  /**
   * The entity that a client attempted to create (e.g., file or directory)
   * already exists.
   *
   * HTTP Mapping: 409 Conflict
   */
  | 'ALREADY_EXISTS'
  /**
   * The operation was cancelled, typically by the caller.
   *
   * HTTP Mapping: 499 Client Closed Request
   */
  | 'CANCELLED'
  /**
   * Unrecoverable data loss or corruption.
   *
   * HTTP Mapping: 500 Internal Server Error
   */
  | 'DATA_LOSS'
  /**
   * The deadline expired before the operation could complete. For operations
   * that change the state of the system, this error may be returned
   * even if the operation has completed successfully.  For example, a
   * successful response from a server could have been delayed long
   * enough for the deadline to expire.
   *
   * HTTP Mapping: 504 Gateway Timeout
   */
  | 'DEADLINE_EXCEEDED'
  /**
   * The operation was rejected because the system is not in a state
   * required for the operation's execution.  For example, the directory
   * to be deleted is non-empty, an rmdir operation is applied to
   * a non-directory, etc.
   *
   * Service implementors can use the following guidelines to decide
   * between `FAILED_PRECONDITION`, `ABORTED`, and `UNAVAILABLE`:
   *  (a) Use `UNAVAILABLE` if the client can retry just the failing call.
   *  (b) Use `ABORTED` if the client should retry at a higher level
   *      (e.g., when a client-specified test-and-set fails, indicating the
   *      client should restart a read-modify-write sequence).
   *  (c) Use `FAILED_PRECONDITION` if the client should not retry until
   *      the system state has been explicitly fixed.  E.g., if an "rmdir"
   *      fails because the directory is non-empty, `FAILED_PRECONDITION`
   *      should be returned since the client should not retry unless
   *      the files are deleted from the directory.
   *
   * HTTP Mapping: 400 Bad Request
   */
  | 'FAILED_PRECONDITION'
  /**
   * Internal errors.  This means that some invariants expected by the
   * underlying system have been broken.  This error code is reserved
   * for serious errors.
   *
   * HTTP Mapping: 500 Internal Server Error
   */
  | 'INTERNAL'
  /**
   * The client specified an invalid argument.  Note that this differs
   * from `FAILED_PRECONDITION`.  `INVALID_ARGUMENT` indicates arguments
   * that are problematic regardless of the state of the system
   * (e.g., a malformed file name).
   *
   * HTTP Mapping: 400 Bad Request
   */
  | 'INVALID_ARGUMENT'
  /**
   * Some requested entity (e.g., file or directory) was not found.
   *
   * Note to server developers: if a request is denied for an entire class
   * of users, such as gradual feature rollout or undocumented whitelist,
   * `NOT_FOUND` may be used. If a request is denied for some users within
   * a class of users, such as user-based access control, `PERMISSION_DENIED`
   * must be used.
   *
   * HTTP Mapping: 404 Not Found
   */
  | 'NOT_FOUND'
  /**
   * Not an error; returned on success
   *
   * HTTP Mapping: 200 OK
   */
  | 'OK'
  /**
   * The operation was attempted past the valid range.  E.g., seeking or
   * reading past end-of-file.
   *
   * Unlike `INVALID_ARGUMENT`, this error indicates a problem that may
   * be fixed if the system state changes. For example, a 32-bit file
   * system will generate `INVALID_ARGUMENT` if asked to read at an
   * offset that is not in the range [0,2^32-1], but it will generate
   * `OUT_OF_RANGE` if asked to read from an offset past the current
   * file size.
   *
   * There is a fair bit of overlap between `FAILED_PRECONDITION` and
   * `OUT_OF_RANGE`.  We recommend using `OUT_OF_RANGE` (the more specific
   * error) when it applies so that callers who are iterating through
   * a space can easily look for an `OUT_OF_RANGE` error to detect when
   * they are done.
   *
   * HTTP Mapping: 400 Bad Request
   */
  | 'OUT_OF_RANGE'
  /**
   * The caller does not have permission to execute the specified
   * operation. `PERMISSION_DENIED` must not be used for rejections
   * caused by exhausting some resource (use `RESOURCE_EXHAUSTED`
   * instead for those errors). `PERMISSION_DENIED` must not be
   * used if the caller can not be identified (use `UNAUTHENTICATED`
   * instead for those errors). This error code does not imply the
   * request is valid or the requested entity exists or satisfies
   * other pre-conditions.
   *
   * HTTP Mapping: 403 Forbidden
   */
  | 'PERMISSION_DENIED'
  /**
   * Some resource has been exhausted, perhaps a per-user quota, or
   * perhaps the entire file system is out of space.
   *
   * HTTP Mapping: 429 Too Many Requests
   */
  | 'RESOURCE_EXHAUSTED'
  /**
   * The request does not have valid authentication credentials for the
   * operation.
   *
   * HTTP Mapping: 401 Unauthorized
   */
  | 'UNAUTHENTICATED'
  /**
   * The service is currently unavailable.  This is most likely a
   * transient condition, which can be corrected by retrying with
   * a backoff. Note that it is not always safe to retry
   * non-idempotent operations.
   *
   * See the guidelines above for deciding between `FAILED_PRECONDITION`,
   * `ABORTED`, and `UNAVAILABLE`.
   *
   * HTTP Mapping: 503 Service Unavailable
   */
  | 'UNAVAILABLE'
  /**
   * The operation is not implemented or is not supported/enabled in this
   * service.
   *
   * HTTP Mapping: 501 Not Implemented
   */
  | 'UNIMPLEMENTED'
  /**
   * Unknown error.  For example, this error may be returned when
   * a `Status` value received from another address space belongs to
   * an error space that is not known in this address space.  Also
   * errors raised by APIs that do not return enough error information
   * may be converted to this error.
   *
   * HTTP Mapping: 500 Internal Server Error
   */
  | 'UNKNOWN';

export type HoaAmenitiesInput = {
  clubhouse?: InputMaybe<Scalars['Boolean']>;
  dogPark?: InputMaybe<Scalars['Boolean']>;
  golf?: InputMaybe<Scalars['Boolean']>;
  gym?: InputMaybe<Scalars['Boolean']>;
  other?: InputMaybe<Scalars['Boolean']>;
  otherInfo?: InputMaybe<Scalars['String']>;
  park?: InputMaybe<Scalars['Boolean']>;
  pool?: InputMaybe<Scalars['Boolean']>;
  sauna?: InputMaybe<Scalars['Boolean']>;
  sportsCourts?: InputMaybe<Scalars['Boolean']>;
  tennisCourt?: InputMaybe<Scalars['Boolean']>;
  trails?: InputMaybe<Scalars['Boolean']>;
  trashRecycling?: InputMaybe<Scalars['Boolean']>;
};

export type HoaFeeInput = {
  amount?: InputMaybe<Scalars['Int']>;
  frequency?: InputMaybe<Scalars['String']>;
};

export type HoaFeesTaskInput = {
  hasHoa?: InputMaybe<Scalars['Boolean']>;
  hoaAmenities?: InputMaybe<HoaAmenitiesInput>;
  hoaAnswered?: InputMaybe<Scalars['Boolean']>;
  hoaFees?: InputMaybe<Array<InputMaybe<HoaFeeInput>>>;
  hoaName?: InputMaybe<Scalars['String']>;
};

export type HomeCompsInput = {
  compsAddressUuids?: InputMaybe<Array<Scalars['String']>>;
};

export type HomeDetailsInput = {
  addressUuid: Scalars['String'];
  sellerInputUuid?: InputMaybe<Scalars['String']>;
};

/**
 * Query and mutation resolvers for HTTP requests can choose to include an HttpResponseType.
 * This enum is simple since clients don't need to worry about raw HTTP response status codes
 * and can instead use something simpler.
 */
export type HttpResponseType =
  /** 3XXs, 4XXs, 5XXs */
  | 'FAILURE'
  /** 2XXs */
  | 'SUCCESS';

export type HvacRoofTaskInput = {
  damageClaimDetails?: InputMaybe<Scalars['String']>;
  filedClaim?: InputMaybe<Scalars['Boolean']>;
  hasPolybutenePiping?: InputMaybe<Scalars['Boolean']>;
  hasSeptic?: InputMaybe<Scalars['Boolean']>;
  hasSprinklerOrIrrigation?: InputMaybe<Scalars['Boolean']>;
  hasSumpPump?: InputMaybe<Scalars['Boolean']>;
  hasWellWaterSupply?: InputMaybe<Scalars['Boolean']>;
  hvacAge?: InputMaybe<Scalars['String']>;
  lastFoundationEvaluation?: InputMaybe<Scalars['String']>;
  receivedProceeds?: InputMaybe<Scalars['Boolean']>;
  roofAge?: InputMaybe<Scalars['String']>;
  roofStormDamage?: InputMaybe<Scalars['Boolean']>;
  sprinklerTimerType?: InputMaybe<SprinklerTimer>;
  workingSprinkler?: InputMaybe<Scalars['Boolean']>;
};

/** Input for initiating a customer task */
export type InitiateCustomerTaskInput = {
  /** The unique identifier for this resource instance */
  id: Scalars['String'];
  /** The type of task being initiated */
  taskType: CustomerTaskType;
};

/** From HDS: granite_slab, granite_tile, other_tile, corian, formica, quartz to enum values */
export type KitchenCountertop =
  | 'CORIAN'
  | 'FORMICA'
  | 'GRANITE_SLAB'
  | 'GRANITE_TILE'
  | 'OTHER_TILE'
  | 'QUARTZ'
  | 'UNKNOWN';

export type LateCheckoutTaskInput = {
  costPerDayCents?: InputMaybe<Scalars['Int']>;
  fixedCostCents?: InputMaybe<Scalars['Int']>;
  lateCheckoutDate?: InputMaybe<Scalars['String']>;
  numberOfDays?: InputMaybe<Scalars['Int']>;
  sellerInterested?: InputMaybe<Scalars['Boolean']>;
  totalCostCents?: InputMaybe<Scalars['Int']>;
};

export type LenderTourGateAnswerEnum =
  | 'all_cash'
  | 'not_yet'
  | 'qualified_or_approved';

export type ListingHistoryEventType =
  | 'CLOSE_PRICE_CHANGE'
  | 'FOR_SALE'
  | 'LIST_PRICE_CHANGE'
  | 'OFF_MARKET'
  | 'PENDING'
  | 'SOLD';

export type ListingHistoryState =
  | 'COMING_SOON'
  | 'FOR_SALE'
  | 'OFF_MARKET'
  | 'PRIVATELY_LISTED'
  | 'SALE_PENDING'
  | 'SOLD'
  | 'TEMP_OFF_MARKET'
  | 'UNKNOWN'
  | 'WITHDRAWN';

/** ListingState represents the current state of a property listing */
export type ListingState =
  | 'AVAILABLE_SOON'
  | 'IN_CONTRACT'
  | 'ON_THE_MARKET'
  | 'RECENTLY_SOLD'
  | 'UNKNOWN';

export type ListingTag =
  | 'BUY_DIRECT_ELIGIBLE'
  | 'BUY_DIRECT_MULTIPLE_OFFERS'
  | 'BUY_DIRECT_SALE_PENDING'
  | 'BUY_DIRECT_VERBAL_AGREEMENT';

export type MlsDisplayPermission =
  | 'FULL'
  | 'LIMITED_ADDRESS'
  | 'LIMITED_PHOTO'
  | 'NONE';

export type MailgunEmailInput = {
  email: Scalars['String'];
};

/** From HDS: entry_level, first_floor, second_floor, third_floor, basement to enum values */
export type MasterBedroomLocation =
  | 'BASEMENT'
  | 'FIRST_FLOOR'
  | 'SECOND_FLOOR'
  | 'THIRD_FLOOR'
  | 'UNKNOWN';

export type MinMaxFilter = {
  max?: InputMaybe<Scalars['Int']>;
  min?: InputMaybe<Scalars['Int']>;
};

export type MinMaxFloatFilter = {
  max?: InputMaybe<Scalars['Float']>;
  min?: InputMaybe<Scalars['Float']>;
};

/** See https://docs.aws.amazon.com/AWSJavaScriptSDK/v3/latest/clients/client-s3/enums/objectstorageclass.html */
export type ObjectStorageClass =
  | 'DEEP_ARCHIVE'
  | 'GLACIER'
  | 'GLACIER_IR'
  | 'INTELLIGENT_TIERING'
  | 'ONEZONE_IA'
  | 'OUTPOSTS'
  | 'REDUCED_REDUNDANCY'
  | 'STANDARD'
  | 'STANDARD_IA';

export type OccupantInfo = {
  email?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
};

export type OdProtosAbraV0Data_AssessmentReviewEscalation_EscalationType =
  | 'DEAL_BREAKERS'
  /** Specialty inspections */
  | 'ELECTRICAL'
  | 'FOUNDATION'
  | 'HIGH_PRELIMS_COST'
  | 'HIGH_REPAIR_COST'
  | 'HVAC'
  | 'LAND_SURVEYING'
  | 'LIVING_AREA_MEASUREMENT'
  | 'MANUAL'
  | 'MISSING_PRICE'
  | 'MISSING_QUANTITY'
  | 'MOLD_REMEDIATION'
  | 'NON_OD_ASSESSMENT'
  | 'ODOR_REMEDIATION'
  | 'OTHER_ELEMENTS'
  | 'PLUMBING'
  | 'POOL'
  | 'PREVIOUS_WALK'
  | 'RADON'
  | 'REPORTS_SUBMITTED'
  | 'REVIEW_OLD_SPECIALTY_INSPECTION'
  | 'ROOF'
  | 'SEPTIC'
  | 'STRUCTURAL'
  | 'TERMITE'
  | 'UNKNOWN_TYPE'
  | 'WELLS';

export type OdProtosAbraV0Data_AssessmentReviewEscalation_State =
  | 'OPEN'
  | 'RESOLVED'
  | 'UNKNOWN';

export type OdProtosAbraV0Data_AssessmentReviewState =
  | 'ASSESSMENT_REVIEW_STATE_COMPLETED'
  | 'ASSESSMENT_REVIEW_STATE_DISCREPANCIES_REVIEW_COMPLETED'
  | 'ASSESSMENT_REVIEW_STATE_PENDING'
  | 'ASSESSMENT_REVIEW_STATE_SKIPPED'
  | 'ASSESSMENT_REVIEW_STATE_SKIPPED_NOT_ELIGIBLE'
  | 'ASSESSMENT_REVIEW_STATE_UNSPECIFIED';

export type OdProtosAbraV0Data_AssessmentState =
  | 'ASSESSMENT_STATE_CANCELED'
  | 'ASSESSMENT_STATE_COMPLETED'
  | 'ASSESSMENT_STATE_SCHEDULED'
  | 'ASSESSMENT_STATE_UNKNOWN';

export type OdProtosAbraV0Data_Assessment_State =
  | 'SUBMITTED'
  | 'UNKNOWN'
  | 'UNSAFE';

/** Represents a component of an addendum */
export type OdProtosAbraV0Data_DecisionAddendumComponentInput = {
  /** The monetary amount associated with this component */
  amount?: InputMaybe<OdProtosCommon_MoneyInput>;
  /** The source category that contributed to this component */
  source?: InputMaybe<OdProtosAbraV0Data_DecisionAddendumSource>;
};

/**
 * Decision outcome indicating an addendum is required before proceeding
 * to closing, typically due to discovered issues or changed circumstances
 */
export type OdProtosAbraV0Data_DecisionAddendumRequiredInput = {
  /**
   * Breakdown of the adjustment by source category for transparency, communication
   * with sellers, etc. funds_adjustment = sum of each component amount in decomposition
   */
  decomposition?: InputMaybe<Array<OdProtosAbraV0Data_DecisionAddendumComponentInput>>;
  /** The total funds adjustment to be added as an addendum */
  fundsAdjustment?: InputMaybe<OdProtosCommon_MoneyInput>;
};

/**
 * Represents the source or category that contributed to a contract addendum
 * calculated after the diligence visit
 */
export type OdProtosAbraV0Data_DecisionAddendumSource =
  /** Use when addendum component is due to home detail changes that affect valuation */
  | 'PRICING'
  /** Use when addendum component is due to repair scope changes or discoveries */
  | 'REPAIR_SCOPES'
  /** Default/unknown source - should not be used in practice */
  | 'UNSPECIFIED';

/**
 * Decision outcome indicating the transaction can proceed to closing
 * without any additional requirements or adjustments
 */
export type OdProtosAbraV0Data_DecisionClearToCloseInput = {
  _empty?: InputMaybe<Scalars['Boolean']>;
};

/**
 * Decision outcome indicating the transaction should be withdrawn
 * due to issues discovered during the diligence visit
 */
export type OdProtosAbraV0Data_DecisionWithdrawInput = {
  /** Human-readable explanation for why the transaction is being withdrawn */
  reasoning?: InputMaybe<Scalars['String']>;
};

export type OdProtosAbraV0Data_InspectionType =
  | 'FLOOR_PLAN'
  | 'HOME_INSPECTION'
  | 'UNKNOWN';

export type OdProtosAbraV0Data_OnSiteContactInput = {
  email?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
};

export type OdProtosAbraV0Data_OrderStatus =
  | 'CANCELLED'
  | 'COMPLETED'
  | 'CREATED'
  | 'INITIALIZED'
  | 'ORDER_STATUS_UNKNOWN'
  | 'RESCHEDULE_REQUESTED'
  | 'SCHEDULED';

/**
 * Represents the outcome of a post-contract diligence review process,
 * capturing the decision made and when it was finalized
 */
export type OdProtosAbraV0Data_PostContractDiligenceReviewInput = {
  decision?: InputMaybe<OdProtosAbraV0Data_PostContractDiligenceReview_DecisionOneofInput>;
  /** Timestamp when the review decision was finalized */
  reviewedAt?: InputMaybe<Scalars['DateTime']>;
};

export type OdProtosAbraV0Data_PostContractDiligenceReview_DecisionOneofInput = {
  addendumRequired?: InputMaybe<OdProtosAbraV0Data_DecisionAddendumRequiredInput>;
  clearToClose?: InputMaybe<OdProtosAbraV0Data_DecisionClearToCloseInput>;
  withdraw?: InputMaybe<OdProtosAbraV0Data_DecisionWithdrawInput>;
};

/** Who completed an assessment phase. Top-level for reuse across events. */
export type OdProtosAbraV0Events_CompletedBy =
  /** Agent app-based task */
  | 'COMPLETED_BY_AGENT'
  /** Virtual assessment or seller app-based */
  | 'COMPLETED_BY_CUSTOMER'
  /** Visit-based assessment */
  | 'COMPLETED_BY_HPM'
  | 'COMPLETED_BY_UNSPECIFIED';

/** Next ID: 2 */
export type OdProtosAbraV0Services_AcquisitionWithdrawnRequestInput = {
  casaId?: InputMaybe<Scalars['String']>;
};

export type OdProtosAbraV0Services_CancelInspectionOrderRequestInput = {
  cancellationReason?: InputMaybe<Scalars['String']>;
  visitId?: InputMaybe<Scalars['String']>;
};

export type OdProtosAbraV0Services_CompleteAssessmentReviewRequestInput = {
  assessmentReviewId?: InputMaybe<Scalars['String']>;
};

export type OdProtosAbraV0Services_CompleteDiscrepancyReviewRequestInput = {
  assessmentReviewId?: InputMaybe<Scalars['String']>;
};

export type OdProtosAbraV0Services_CreateHomeAccessInformationRequestInput = {
  additionalInstructions?: InputMaybe<Scalars['String']>;
  addressToken?: InputMaybe<Scalars['String']>;
  customerId?: InputMaybe<Scalars['String']>;
  /** optional field. Will be present if gated_community = true */
  gateCode?: InputMaybe<Scalars['String']>;
  gateCodeNotes?: InputMaybe<Scalars['String']>;
  /** represents if the home is in a gated community */
  gatedCommunity?: InputMaybe<Scalars['Boolean']>;
  keypadAccess?: InputMaybe<Scalars['Boolean']>;
  /** optional field. Will be present if keypad_access = true */
  keypadCode?: InputMaybe<Scalars['String']>;
  lockboxAccess?: InputMaybe<Scalars['Boolean']>;
  /** optional field. Will be present if lockbox_access = true */
  lockboxCode?: InputMaybe<Scalars['String']>;
  /** represents the assessment visit_id */
  visitId?: InputMaybe<Scalars['String']>;
};

export type OdProtosAbraV0Services_CreateInspectionOrderRequestInput = {
  addressToken?: InputMaybe<Scalars['String']>;
  onSiteContact?: InputMaybe<OdProtosAbraV0Data_OnSiteContactInput>;
};

export type OdProtosAbraV0Services_CreatePostContractDiligenceReviewRequestInput = {
  addressToken?: InputMaybe<Scalars['String']>;
  flipToken?: InputMaybe<Scalars['String']>;
  offerUuid?: InputMaybe<Scalars['String']>;
  review?: InputMaybe<OdProtosAbraV0Data_PostContractDiligenceReviewInput>;
};

export type OdProtosAbraV0Services_ExpediteDeficienciesRequestInput = {
  orderId?: InputMaybe<Scalars['String']>;
};

export type OdProtosAbraV0Services_ExpediteLimitationsRequestInput = {
  orderId?: InputMaybe<Scalars['String']>;
};

export type OdProtosAbraV0Services_ExpediteReportProcessingRequestInput = {
  orderId?: InputMaybe<Scalars['String']>;
};

export type OdProtosAbraV0Services_GetAreaAssetsByHomeRequestInput = {
  addressId?: InputMaybe<Scalars['String']>;
  sizeModifiers?: InputMaybe<Array<OdProtosCabinetData_SizeModifierInput>>;
};

export type OdProtosAbraV0Services_GetAssessmentByAddressRequestInput = {
  addressToken?: InputMaybe<Scalars['String']>;
};

export type OdProtosAbraV0Services_GetAssessmentReviewRequestInput = {
  addressToken?: InputMaybe<Scalars['String']>;
};

export type OdProtosAbraV0Services_GetAvailableBookingTimesRequestInput = {
  inspectionOrderReference?: InputMaybe<Scalars['String']>;
};

export type OdProtosAbraV0Services_GetCompletedAssessmentStepsRequestInput = {
  /**
   * In the future we can add the different steps here.
   * So that the caller can specify which steps they are interested in.
   */
  addressId?: InputMaybe<Scalars['String']>;
};

export type OdProtosAbraV0Services_GetHomeRiskFactorsByHomeRequestInput = {
  addressId?: InputMaybe<Scalars['String']>;
};

export type OdProtosAbraV0Services_GetHumanReadableAssessmentRequestInput = {
  addressId?: InputMaybe<Scalars['String']>;
};

export type OdProtosAbraV0Services_GetIsHomeQualifiedForVirtualExteriorAssessmentRequestInput = {
  addressId?: InputMaybe<Scalars['String']>;
  isHomebuilderLead?: InputMaybe<Scalars['Boolean']>;
  preferredHomeDetailIds?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosAbraV0Services_GetLatestInspectionReportsRequestInput = {
  orderId?: InputMaybe<Scalars['String']>;
};

export type OdProtosAbraV0Services_GetOrderForAddressRequestInput = {
  addressToken?: InputMaybe<Scalars['String']>;
};

export type OdProtosAbraV0Services_GetOrderForVisitRequestInput = {
  visitId?: InputMaybe<Scalars['String']>;
};

export type OdProtosAbraV0Services_GetOrderLimitationsRequestInput = {
  orderId?: InputMaybe<Scalars['String']>;
};

export type OdProtosAbraV0Services_GetOrdersForAddressRequestInput = {
  addressToken?: InputMaybe<Scalars['String']>;
  statusesIn?: InputMaybe<Array<OdProtosAbraV0Data_OrderStatus>>;
};

export type OdProtosAbraV0Services_GetPostContractDiligenceAddendumRequestInput = {
  postContractDiligenceReviewId?: InputMaybe<Scalars['String']>;
};

export type OdProtosAbraV0Services_GetPostContractDiligenceReviewRequestInput = {
  offerUuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosAbraV0Services_GetRepairScopeSuggestionsRequestInput = {
  orderId?: InputMaybe<Scalars['String']>;
};

export type OdProtosAbraV0Services_GetRepairScopesByHomeRequestInput = {
  addressId?: InputMaybe<Scalars['String']>;
};

export type OdProtosAbraV0Services_IsAssessmentCompletedRequestInput = {
  addressId?: InputMaybe<Scalars['String']>;
  completionCutoffDate?: InputMaybe<Scalars['DateTime']>;
  /**
   * ignore_pending true means we return is completed true
   * even if there are oustanding parts of the assessment
   * e.g ignore_pending: true
   * Interior & Exterior submitted means completed
   * If an interior and an exterior are submitted it will return true
   * even if there is another interior that is not submitted
   */
  ignorePending?: InputMaybe<Scalars['Boolean']>;
};

export type OdProtosAbraV0Services_IsAssessmentReviewPerformedInAbraRequestInput = {
  offerUuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosAbraV0Services_RequestSpecialtyInspectionRequestInput = {
  addressId?: InputMaybe<Scalars['String']>;
  inspectionType?: InputMaybe<Scalars['String']>;
  visitSchedulingUrl?: InputMaybe<Scalars['String']>;
};

/** TODO: deprecate, use UpdateInspectionOrder instead */
export type OdProtosAbraV0Services_RescheduleInspectionOrderRequestInput = {
  bookingTime?: InputMaybe<Scalars['DateTime']>;
  inspectionOrderReference?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  /** updates only present fields */
  onSiteContact?: InputMaybe<OdProtosAbraV0Data_OnSiteContactInput>;
};

export type OdProtosAbraV0Services_ReviewAssessmentRequestInput = {
  addressId?: InputMaybe<Scalars['String']>;
  adminUrl?: InputMaybe<Scalars['String']>;
  ccOnSpecialtyInspection?: InputMaybe<Array<Scalars['String']>>;
  offerUuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosAbraV0Services_SelectBookingTimeRequestInput = {
  bookingTime?: InputMaybe<Scalars['DateTime']>;
  inspectionOrderReference?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  onSiteContact?: InputMaybe<OdProtosAbraV0Data_OnSiteContactInput>;
};

export type OdProtosAbraV0Services_TriggerAssessmentCompletionNotificationRequestInput = {
  addressToken?: InputMaybe<Scalars['String']>;
  scopingTaskType?: InputMaybe<Scalars['String']>;
};

export type OdProtosAbraV0Services_TriggerConditionScopingRequestInput = {
  addressId?: InputMaybe<Scalars['String']>;
  rubricReportId?: InputMaybe<Scalars['String']>;
  taskId?: InputMaybe<Scalars['String']>;
  visitId?: InputMaybe<Scalars['String']>;
};

export type OdProtosAbraV0Services_TriggerInspectifyReportsHandlingRequestInput = {
  addressId?: InputMaybe<Scalars['String']>;
  cubicasaReportId?: InputMaybe<Scalars['String']>;
  homeInspectionReportId?: InputMaybe<Scalars['String']>;
  /** Optional: if not provided new visit will be created */
  visitId?: InputMaybe<Scalars['String']>;
};

export type OdProtosAbraV0Services_UpdateInspectionOrderRequestInput = {
  bookingTime?: InputMaybe<Scalars['DateTime']>;
  inspectionOrderReference?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  /** updates only present fields */
  onSiteContact?: InputMaybe<OdProtosAbraV0Data_OnSiteContactInput>;
};

/** Next ID: 2 */
export type OdProtosAbraV0Services_WalkApprovedRequestInput = {
  casaId?: InputMaybe<Scalars['String']>;
};

/** Next ID: 6 */
export type OdProtosAbraV0Services_WalkProposedRequestInput = {
  casaId?: InputMaybe<Scalars['String']>;
  proposerHumanToken?: InputMaybe<Scalars['String']>;
  resolutionUrl?: InputMaybe<Scalars['String']>;
  walkDetails?: InputMaybe<Scalars['String']>;
  walkReason?: InputMaybe<Scalars['String']>;
};

/** Next ID: 3 */
export type OdProtosAbraV0Services_WalkRejectedRequestInput = {
  casaId?: InputMaybe<Scalars['String']>;
  isBudgetReviewNeeded?: InputMaybe<Scalars['Boolean']>;
};

/**
 * Type enumerates the kinds of offer types that can be accepted by a property
 * owner.
 */
export type OdProtosAcceptedOfferTypeData_Type =
  /**
   * The property is accepting backup offers, as it currently has a committed
   * buyer.
   */
  | 'BACKUP'
  /**
   * A qualified offer may buy the property instantly at a set "Buy it now"
   * price
   */
  | 'BUY_IT_NOW'
  /**
   * The property owner is collecting competing offers which it will examine on
   * a set deadline.
   */
  | 'HIGHEST_AND_BEST'
  /**
   * Offers to purchase the property at a price chosen by the buyer may be
   * submitted which will be considered by property owner and responded to
   */
  | 'NEGOTIABLE'
  | 'UNKNOWN_ACCEPTED_OFFER_TYPE';

export type OdProtosAccountingData_JournalEntryInput = {
  currency?: InputMaybe<Scalars['Float']>;
  line?: InputMaybe<OdProtosAccountingData_LineInput>;
  memoHeader?: InputMaybe<Scalars['String']>;
  postingDate?: InputMaybe<Scalars['DateTime']>;
  refNumber?: InputMaybe<Scalars['Float']>;
  reversalDate?: InputMaybe<Scalars['DateTime']>;
  subsidiary?: InputMaybe<Scalars['Float']>;
  unitsType?: InputMaybe<Scalars['Float']>;
};

export type OdProtosAccountingData_LineInput = {
  items?: InputMaybe<Array<OdProtosAccountingData_LineItemInput>>;
};

export type OdProtosAccountingData_LineItemInput = {
  account?: InputMaybe<Scalars['Float']>;
  accountingBucket?: InputMaybe<Scalars['Float']>;
  customer?: InputMaybe<Scalars['Float']>;
  debit?: InputMaybe<Scalars['String']>;
  department?: InputMaybe<Scalars['Float']>;
  fileNumber?: InputMaybe<Scalars['Float']>;
  inactiveToken?: InputMaybe<Scalars['Float']>;
  market?: InputMaybe<Scalars['Float']>;
  memoLine?: InputMaybe<Scalars['String']>;
  token?: InputMaybe<Scalars['Float']>;
  vendor?: InputMaybe<Scalars['Float']>;
};

export type OdProtosAccountingServices_CreateSynchronizationJobRequestInput = {
  source?: InputMaybe<Scalars['String']>;
};

export type OdProtosAccountingServices_PostJournalEntryRequestInput = {
  endpoint?: InputMaybe<Scalars['String']>;
  journalEntry?: InputMaybe<OdProtosAccountingData_JournalEntryInput>;
  trackingId?: InputMaybe<Scalars['String']>;
};

export type OdProtosAccountingServices_RetryNetsuitePostRequestInput = {
  trackingId?: InputMaybe<Scalars['String']>;
};

/** Next ID: 7 */
export type OdProtosAcquisitionServices_GetListedPriceCeilingRequestInput = {
  /** Address of the property to compute the listed price ceiling for. */
  addressToken?: InputMaybe<Scalars['String']>;
  /** Features overlays to use when computing the listed price ceiling. */
  featureOverlay?: InputMaybe<OdProtosAcquisitionServices_GetListedPriceCeilingRequest_FeatureOverlayInput>;
  /** Market that the property belongs to. */
  market?: InputMaybe<OdProtosCommonMarket_Market>;
  /** Time at which we want to evaluate the listed price ceiling. */
  timestamp?: InputMaybe<Scalars['DateTime']>;
  /** Whether to use the dynamic DOM rules. */
  useDom?: InputMaybe<Scalars['Boolean']>;
  /**
   * Valuation of the property post repairs. This is usually the OVM valuation
   * at offer time and an ensembled valuation at underwriting time.
   */
  valuationPostRepairs?: InputMaybe<OdProtosCommon_MoneyInput>;
};

/** Next ID: 5 */
export type OdProtosAcquisitionServices_GetListedPriceCeilingRequest_FeatureOverlayInput = {
  /** Latest list date. */
  listDate?: InputMaybe<OdProtosCommon_DateInput>;
  /** Latest list price. */
  listPrice?: InputMaybe<OdProtosCommon_MoneyInput>;
  /** Latest listing status. */
  listingStatus?: InputMaybe<Scalars['String']>;
  /** Date of latest status change */
  statusChangeDate?: InputMaybe<OdProtosCommon_DateInput>;
};

/** Next ID: 26 */
export type OdProtosAcquisitionServices_GetNetCashPresentationRequestInput = {
  addressToken?: InputMaybe<Scalars['String']>;
  /** Date, to the best of our knowledge, that the offer will be sent on */
  asOfDate?: InputMaybe<OdProtosCommon_DateInput>;
  /**
   * Additional credit line item that will impact fee (and consequently
   * margin). Expressed as a percentage of valuation
   */
  creditCustomOfferAdjustmentPercentage?: InputMaybe<Scalars['Float']>;
  /**
   * This is used to set fee based on experiment treatment
   * DEPRECATED: No longer used. The continuous net cash experiment has ended.
   */
  experimentFlags?: InputMaybe<OdProtosPricesAcquisitionData_FeeExperimentFlagsInput>;
  /** Overrides */
  feeOverrides?: InputMaybe<OdProtosPricesAcquisitionData_FeeOverridesInput>;
  /** A recent presentation that may be used in grandfathering logic. */
  grandfatheredPresentation?: InputMaybe<OdProtosAcquisitionServices_GrandfatheredPresentationInput>;
  /** True if the offer relevant to this request is part of Opendoor Exclusives */
  inExclusiveOffers?: InputMaybe<Scalars['Boolean']>;
  /** True if the offer is eligible for CashPlus/SellWithUpside */
  isSellWithUpsideEligible?: InputMaybe<Scalars['Boolean']>;
  /** An override for LGM */
  lgmOverride?: InputMaybe<OdProtosAcquisitionServices_LgmOverrideInput>;
  market?: InputMaybe<OdProtosCommonMarket_Market>;
  /** Homebuilder partner if any. Deprecated in favor of partner_referrals */
  partner?: InputMaybe<OdProtosPricesCommon_Partner>;
  /** The partners that referred this lead */
  partnerReferrals?: InputMaybe<Array<OdProtosPricesCommon_PartnerReferralInput>>;
  postRepairValuation?: InputMaybe<OdProtosCommon_MoneyInput>;
  postValuationAdjustmentLineItems?: InputMaybe<Array<OdProtosAcquisitionServices_GetNetCashPresentationRequest_PostValuationAdjustmentLineItemsEntryInput>>;
  /** The net cash in cents from the prelim offer NCP. May be used to calculate the RFO adjustment. */
  prelimOfferNetCashCents?: InputMaybe<OdProtosCommon_MoneyInput>;
  /** This is used as an input to calculate addendum */
  repairsCharge?: InputMaybe<OdProtosCommon_MoneyInput>;
  /** This is used as an input to calculate addendum */
  subsidySellerCx?: InputMaybe<OdProtosCommon_MoneyInput>;
  targetInternalFee?: InputMaybe<OdProtosCommon_MoneyInput>;
  /** This is used as an input to determining a cap on homebuilder partner subsidy */
  targetLeveredGrossMargin?: InputMaybe<OdProtosCommon_MoneyInput>;
};

/** `OdProtosAcquisitionServices_GetNetCashPresentationRequest_PostValuationAdjustmentLineItemsEntryInput` represents the `post_valuation_adjustment_line_items` map in `od_protos.acquisition.services.GetNetCashPresentationRequest`. */
export type OdProtosAcquisitionServices_GetNetCashPresentationRequest_PostValuationAdjustmentLineItemsEntryInput = {
  key?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<OdProtosCommon_MoneyInput>;
};

/** Next ID: 31 */
export type OdProtosAcquisitionServices_GetTargetNetCashRequestInput = {
  /**
   * The Abacus fee version to use, defaults to the latest version. This should
   * only be used in special circumstances as we always want to use the latest
   * version of fees in production. If we want to grandfather (i.e. freeze) an
   * earlier fee, then we should add a subsidy for the difference, e.g. see
   * GrandfatheredPresentation.
   */
  abacusVersion?: InputMaybe<Scalars['String']>;
  addressToken?: InputMaybe<Scalars['String']>;
  /** Date, to the best of our knowledge, that the offer will be sent on */
  asOfDate?: InputMaybe<OdProtosCommon_DateInput>;
  city?: InputMaybe<Scalars['String']>;
  county?: InputMaybe<Scalars['String']>;
  /** Coefficients for days to pend adjustments */
  daysToPendAdjustmentCoefficients?: InputMaybe<Array<OdProtosAcquisitionServices_GetTargetNetCashRequest_DaysToPendAdjustmentCoefficientsEntryInput>>;
  /** Type of Dwelling ('single_family', 'apartment', etc.) */
  dwellingTypeLabel?: InputMaybe<Scalars['String']>;
  enableNsc?: InputMaybe<Scalars['Boolean']>;
  /**
   * This is used to set fee based on experiment treatment
   * DEPRECATED: No longer used. The continuous net cash experiment has ended.
   */
  experimentFlags?: InputMaybe<OdProtosPricesAcquisitionData_FeeExperimentFlagsInput>;
  /** Whether or not the home is part of a Homeowners Association (HOA) */
  hasHoa?: InputMaybe<Scalars['Boolean']>;
  includeOfferBuffers?: InputMaybe<Scalars['Boolean']>;
  /** An override for LGM */
  lgmOverride?: InputMaybe<OdProtosAcquisitionServices_LgmOverrideInput>;
  market?: InputMaybe<OdProtosCommonMarket_Market>;
  /** Allow passing NSC from external system */
  nscOverrideCents?: InputMaybe<OdProtosCommon_MoneyInput>;
  /** The partners that referred this lead */
  partnerReferrals?: InputMaybe<Array<OdProtosPricesCommon_PartnerReferralInput>>;
  /** Whether or not the home has a private pool */
  pool?: InputMaybe<Scalars['Boolean']>;
  /** Line items used when calculating baseline net cash post inspection */
  postInspectionLineItems?: InputMaybe<OdProtosAcquisitionServices_PostInspectionLineItemsInput>;
  /** Valuation after repairs */
  postRepairValuation?: InputMaybe<OdProtosCommon_MoneyInput>;
  postValuationAdjustmentLineItems?: InputMaybe<Array<OdProtosAcquisitionServices_GetTargetNetCashRequest_PostValuationAdjustmentLineItemsEntryInput>>;
  sqFt?: InputMaybe<Scalars['Float']>;
  /** Address information for geo-based constants. */
  state?: InputMaybe<Scalars['String']>;
  /** Individual adjustments that affect val gain, to be summed into total valgain in Abacus */
  valGainAdjustmentLineItems?: InputMaybe<Array<OdProtosAcquisitionServices_GetTargetNetCashRequest_ValGainAdjustmentLineItemsEntryInput>>;
  /** Inputs necessary for Negative Selection Charge calculation. */
  valuationExpectedError?: InputMaybe<Scalars['Float']>;
  zip?: InputMaybe<Scalars['String']>;
};

/** `OdProtosAcquisitionServices_GetTargetNetCashRequest_DaysToPendAdjustmentCoefficientsEntryInput` represents the `days_to_pend_adjustment_coefficients` map in `od_protos.acquisition.services.GetTargetNetCashRequest`. */
export type OdProtosAcquisitionServices_GetTargetNetCashRequest_DaysToPendAdjustmentCoefficientsEntryInput = {
  key?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['Float']>;
};

/** `OdProtosAcquisitionServices_GetTargetNetCashRequest_PostValuationAdjustmentLineItemsEntryInput` represents the `post_valuation_adjustment_line_items` map in `od_protos.acquisition.services.GetTargetNetCashRequest`. */
export type OdProtosAcquisitionServices_GetTargetNetCashRequest_PostValuationAdjustmentLineItemsEntryInput = {
  key?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<OdProtosCommon_MoneyInput>;
};

/** `OdProtosAcquisitionServices_GetTargetNetCashRequest_ValGainAdjustmentLineItemsEntryInput` represents the `val_gain_adjustment_line_items` map in `od_protos.acquisition.services.GetTargetNetCashRequest`. */
export type OdProtosAcquisitionServices_GetTargetNetCashRequest_ValGainAdjustmentLineItemsEntryInput = {
  key?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<OdProtosCommon_MoneyInput>;
};

/** Next ID: 35 */
export type OdProtosAcquisitionServices_GetUnitEconomicsRequestInput = {
  abacusVersion?: InputMaybe<Scalars['String']>;
  addressToken?: InputMaybe<Scalars['String']>;
  /** Date, to the best of our knowledge, that the offer will be sent on */
  asOfDate?: InputMaybe<OdProtosCommon_DateInput>;
  city?: InputMaybe<Scalars['String']>;
  county?: InputMaybe<Scalars['String']>;
  /** Coefficients for days to pend adjustments */
  daysToPendAdjustmentCoefficients?: InputMaybe<Array<OdProtosAcquisitionServices_GetUnitEconomicsRequest_DaysToPendAdjustmentCoefficientsEntryInput>>;
  /** Type of Dwelling ('single_family', 'apartment', etc.) */
  dwellingTypeLabel?: InputMaybe<Scalars['String']>;
  enableNsc?: InputMaybe<Scalars['Boolean']>;
  /**
   * This is used to set fee based on experiment treatment
   * DEPRECATED: No longer used. The continuous net cash experiment has ended.
   */
  experimentFlags?: InputMaybe<OdProtosPricesAcquisitionData_FeeExperimentFlagsInput>;
  /** The list of credits and subsidies that were applied, e.g. rounding, flooring */
  feeAdjustmentLineItems?: InputMaybe<Array<OdProtosAcquisitionServices_LineItemInput>>;
  /** Whether or not the home is part of a Homeowners Association (HOA) */
  hasHoa?: InputMaybe<Scalars['Boolean']>;
  includeOfferBuffers?: InputMaybe<Scalars['Boolean']>;
  /** Internal fee cents */
  internalFeeCents?: InputMaybe<OdProtosCommon_MoneyInput>;
  /** An override for LGM */
  lgmOverride?: InputMaybe<OdProtosAcquisitionServices_LgmOverrideInput>;
  market?: InputMaybe<OdProtosCommonMarket_Market>;
  /** Allows the skipping of negative selection charge calculation */
  nscOverrideCents?: InputMaybe<OdProtosCommon_MoneyInput>;
  /** Whether or not the home has a private pool */
  pool?: InputMaybe<Scalars['Boolean']>;
  /** Line items used when calculating unit economics post inspection */
  postInspectionLineItems?: InputMaybe<OdProtosAcquisitionServices_PostInspectionLineItemsInput>;
  /** Valuation after repairs */
  postRepairValuation?: InputMaybe<OdProtosCommon_MoneyInput>;
  postValuationAdjustmentLineItems?: InputMaybe<Array<OdProtosAcquisitionServices_GetUnitEconomicsRequest_PostValuationAdjustmentLineItemsEntryInput>>;
  sqFt?: InputMaybe<Scalars['Float']>;
  /** Geo details about the property */
  state?: InputMaybe<Scalars['String']>;
  /** Individual adjustments that affect valgain, to be summed into total valgain in Abacus */
  valGainAdjustmentLineItems?: InputMaybe<Array<OdProtosAcquisitionServices_GetUnitEconomicsRequest_ValGainAdjustmentLineItemsEntryInput>>;
  /** Inputs necessary for Negative Selection Charge calculation */
  valuationExpectedError?: InputMaybe<Scalars['Float']>;
  zip?: InputMaybe<Scalars['String']>;
};

/** `OdProtosAcquisitionServices_GetUnitEconomicsRequest_DaysToPendAdjustmentCoefficientsEntryInput` represents the `days_to_pend_adjustment_coefficients` map in `od_protos.acquisition.services.GetUnitEconomicsRequest`. */
export type OdProtosAcquisitionServices_GetUnitEconomicsRequest_DaysToPendAdjustmentCoefficientsEntryInput = {
  key?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['Float']>;
};

/** `OdProtosAcquisitionServices_GetUnitEconomicsRequest_PostValuationAdjustmentLineItemsEntryInput` represents the `post_valuation_adjustment_line_items` map in `od_protos.acquisition.services.GetUnitEconomicsRequest`. */
export type OdProtosAcquisitionServices_GetUnitEconomicsRequest_PostValuationAdjustmentLineItemsEntryInput = {
  key?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<OdProtosCommon_MoneyInput>;
};

/** `OdProtosAcquisitionServices_GetUnitEconomicsRequest_ValGainAdjustmentLineItemsEntryInput` represents the `val_gain_adjustment_line_items` map in `od_protos.acquisition.services.GetUnitEconomicsRequest`. */
export type OdProtosAcquisitionServices_GetUnitEconomicsRequest_ValGainAdjustmentLineItemsEntryInput = {
  key?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<OdProtosCommon_MoneyInput>;
};

/** Next ID: 10 */
export type OdProtosAcquisitionServices_GrandfatheredPresentationInput = {
  /**
   * Additional charge that gets added to the purchase and sale agreement
   * This field is just like addendum in GetNetCashPresentationResponse below.
   */
  addendum?: InputMaybe<OdProtosCommon_MoneyInput>;
  /** When the original presentation was produced. */
  asOfDate?: InputMaybe<OdProtosCommon_DateInput>;
  /**
   * The fee we will show the customer (modulo co-broke)
   * This field is just like external_fee in GetNetCashPresentationResponse below.
   */
  externalFee?: InputMaybe<OdProtosCommon_MoneyInput>;
  /**
   * The price we show the customer (aka headline price).
   * This field is just like external_price in GetNetCashPresentationResponse below.
   */
  externalPrice?: InputMaybe<OdProtosCommon_MoneyInput>;
  /**
   * The list of credits and subsidies that were applied, e.g. rounding, flooring
   * This field is just like fee_adjustment_line_items in GetNetCashPresentationResponse below.
   */
  feeAdjustmentLineItems?: InputMaybe<Array<OdProtosAcquisitionServices_LineItemInput>>;
  internalFee?: InputMaybe<OdProtosCommon_MoneyInput>;
  /** Specifies how acquisition should handle this `GrandfatheredPresentation`. */
  policy?: InputMaybe<OdProtosAcquisitionServices_GrandfatheredPresentation_GrandfatheringPolicy>;
  postValuationAdjustmentLineItems?: InputMaybe<Array<OdProtosAcquisitionServices_GrandfatheredPresentation_PostValuationAdjustmentLineItemsEntryInput>>;
  valuationPostRepairs?: InputMaybe<OdProtosCommon_MoneyInput>;
};

export type OdProtosAcquisitionServices_GrandfatheredPresentation_GrandfatheringPolicy =
  /**
   * Get difference of post-UW net cash and prelim net cash. If difference > 0, take
   * some percentage (efo_inertia_percentage) of this increase as a fee on final offer.
   */
  | 'ENGAGEMENT_OPTIMIZED_FINAL_OFFER'
  /** Keep the same external price and fee from prelim offer at underwriting time. */
  | 'GUARANTEE_AT_PRELIM_OFFER'
  /**
   * Keep the same internal fee less post valuation adjustments (e.g. risk
   * based pricing, listed price ceiling, etc) from prelim offer at
   * underwriting time.
   */
  | 'OFFER_TO_UW_INTERNAL_FEE_LESS_POST_VAL_ADJUSTMENTS'
  /** Re-use the external_price and external_fee. Compute addendum like normal. */
  | 'PRESERVE_EXTERNAL_PRICE_AND_EXTERNAL_FEE_RECALCULATE_ADDENDUM'
  | 'UNKNOWN';

/** `OdProtosAcquisitionServices_GrandfatheredPresentation_PostValuationAdjustmentLineItemsEntryInput` represents the `post_valuation_adjustment_line_items` map in `od_protos.acquisition.services.GrandfatheredPresentation`. */
export type OdProtosAcquisitionServices_GrandfatheredPresentation_PostValuationAdjustmentLineItemsEntryInput = {
  key?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<OdProtosCommon_MoneyInput>;
};

/** Next ID: 3 */
export type OdProtosAcquisitionServices_LgmOverrideInput = {
  /**
   * Determines if we apply the override post-NCP adjustments (rounding, flooring, etc.).
   * Null by default, implying we'll apply pre-adjustments if unset.
   * DEPRECATED: This field is no longer used. Adjustments are now always applied.
   */
  applyPostAdjustments?: InputMaybe<Scalars['Boolean']>;
  /** An override for our target LGM */
  overrideBps?: InputMaybe<Scalars['Int']>;
};

/** Next ID: 4 */
export type OdProtosAcquisitionServices_LineItemInput = {
  account?: InputMaybe<Array<Scalars['String']>>;
  amount?: InputMaybe<OdProtosCommon_MoneyInput>;
  description?: InputMaybe<Scalars['String']>;
};

/** Next ID: 13 */
export type OdProtosAcquisitionServices_PostInspectionLineItemsInput = {
  costNitpickyRepairs?: InputMaybe<OdProtosCommon_MoneyInput>;
  /** "predicted" because a model determines this estimate */
  costPredictedBrn?: InputMaybe<OdProtosCommon_MoneyInput>;
  /** "predicted" because a model determines this estimate */
  costPredictedPostlistRepairs?: InputMaybe<OdProtosCommon_MoneyInput>;
  costPrelims?: InputMaybe<OdProtosCommon_MoneyInput>;
  /** Today, this is essentially postlist repairs + BRN */
  costScopedDeferredRepairs?: InputMaybe<OdProtosCommon_MoneyInput>;
  /**
   * TODO: We should begin using/reading prelist, postlist, and BRN rather than
   * cost_scoped_immediate_repairs and cost_scoped_deferred_repairs
   *
   * Today, this is essentially prelist repairs
   */
  costScopedImmediateRepairs?: InputMaybe<OdProtosCommon_MoneyInput>;
  /**
   * "scoped" because humans determine this estimate, though it will be ensembled with model
   * predictions in the future
   */
  costScopedPrelistRepairs?: InputMaybe<OdProtosCommon_MoneyInput>;
  costScopedRenovations?: InputMaybe<OdProtosCommon_MoneyInput>;
  scopedSellerRepairsCharge?: InputMaybe<OdProtosCommon_MoneyInput>;
  subsidySellerCx?: InputMaybe<OdProtosCommon_MoneyInput>;
};

/** Next ID: 3 */
export type OdProtosAcquisitionUnderwritingData_UnderwritingOutcomeInput = {
  outcome?: InputMaybe<OdProtosAcquisitionUnderwritingData_UnderwritingOutcome_OutcomeOneofInput>;
};

export type OdProtosAcquisitionUnderwritingData_UnderwritingOutcome_OutcomeOneofInput = {
  /** we can proceed to next steps */
  proceed?: InputMaybe<OdProtosAcquisitionUnderwritingData_UnderwritingOutcome_ProceedInput>;
  /** underwriting completed with an accepted walk */
  walk?: InputMaybe<OdProtosAcquisitionUnderwritingData_UnderwritingOutcome_WalkInput>;
};

export type OdProtosAcquisitionUnderwritingData_UnderwritingOutcome_ProceedInput = {
  eligibility?: InputMaybe<OdProtosAcquisitionUnderwritingData_UnderwritingOutcome_Proceed_EligibilityInput>;
};

export type OdProtosAcquisitionUnderwritingData_UnderwritingOutcome_Proceed_EligibilityInput = {
  listWithOpendoor?: InputMaybe<Scalars['Boolean']>;
  sellDirect?: InputMaybe<Scalars['Boolean']>;
  sellWithUpside?: InputMaybe<Scalars['Boolean']>;
};

export type OdProtosAcquisitionUnderwritingData_UnderwritingOutcome_WalkInput = {
  _empty?: InputMaybe<Scalars['Boolean']>;
};

/** Next ID: 5 */
export type OdProtosAcquisitionUnderwritingServices_CancelUnderwritingRequestInput = {
  idempotencyKey?: InputMaybe<Scalars['String']>;
  propertyEngagementId?: InputMaybe<Scalars['String']>;
  requestId?: InputMaybe<OdProtosCommon_RequestIdInput>;
  requestorId?: InputMaybe<OdProtosCommon_RequestorIdInput>;
};

export type OdProtosAcquisitionUnderwritingServices_CancelUnderwritingResponse_Error_Code =
  | 'INVALID_ARGUMENT'
  | 'UNKNOWN';

/** Next ID: 4 */
export type OdProtosAcquisitionUnderwritingServices_ComputeUnderwritingOutcomeRequestInput = {
  propertyEngagementId?: InputMaybe<Scalars['String']>;
  requestId?: InputMaybe<OdProtosCommon_RequestIdInput>;
  requestorId?: InputMaybe<OdProtosCommon_RequestorIdInput>;
};

export type OdProtosAcquisitionUnderwritingServices_ComputeUnderwritingOutcomeResponse_Error_Code =
  | 'INVALID_ARGUMENT'
  | 'UNKNOWN';

/** Next ID: 6 */
export type OdProtosAcquisitionUnderwritingServices_CreateUnderwritingWalkRequestInput = {
  idempotencyKey?: InputMaybe<Scalars['String']>;
  proposal?: InputMaybe<OdProtosPricingData_WalkProposalInput>;
  requestId?: InputMaybe<OdProtosCommon_RequestIdInput>;
  requestorId?: InputMaybe<OdProtosCommon_RequestorIdInput>;
  resolution?: InputMaybe<OdProtosPricingData_WalkResolutionInput>;
};

export type OdProtosAcquisitionUnderwritingServices_CreateUnderwritingWalkResponse_Error_Code =
  | 'INVALID_ARGUMENT'
  | 'UNKNOWN';

/** Next ID: 5 */
export type OdProtosAcquisitionUnderwritingServices_CreateWalkProposalRequestInput = {
  idempotencyKey?: InputMaybe<Scalars['String']>;
  requestId?: InputMaybe<OdProtosCommon_RequestIdInput>;
  requestorId?: InputMaybe<OdProtosCommon_RequestorIdInput>;
  walkProposal?: InputMaybe<OdProtosPricingData_WalkProposalInput>;
};

export type OdProtosAcquisitionUnderwritingServices_CreateWalkProposalResponse_Error_Code =
  | 'INVALID_ARGUMENT'
  | 'UNKNOWN';

export type OdProtosAcquisitionUnderwritingServices_CreateWalkResolutionDirectOverrideValuationRequestInput = {
  idempotencyKey?: InputMaybe<Scalars['String']>;
  overrideValuationCi50margin?: InputMaybe<Scalars['Float']>;
  overrideValuationPrice?: InputMaybe<OdProtosCommon_MoneyInput>;
  propertyEngagementId?: InputMaybe<Scalars['String']>;
  requestId?: InputMaybe<OdProtosCommon_RequestIdInput>;
  requestorId?: InputMaybe<OdProtosCommon_RequestorIdInput>;
  valuatorToken?: InputMaybe<Scalars['String']>;
};

export type OdProtosAcquisitionUnderwritingServices_CreateWalkResolutionDirectOverrideValuationResponse_Error_Code =
  | 'INVALID_ARGUMENT'
  | 'UNKNOWN';

/** Next ID: 5 */
export type OdProtosAcquisitionUnderwritingServices_CreateWalkResolutionRequestInput = {
  idempotencyKey?: InputMaybe<Scalars['String']>;
  requestId?: InputMaybe<OdProtosCommon_RequestIdInput>;
  requestorId?: InputMaybe<OdProtosCommon_RequestorIdInput>;
  walkResolution?: InputMaybe<OdProtosPricingData_WalkResolutionInput>;
};

export type OdProtosAcquisitionUnderwritingServices_CreateWalkResolutionResponse_Error_Code =
  | 'INVALID_ARGUMENT'
  | 'UNKNOWN';

/** Next ID: 5 */
export type OdProtosAcquisitionUnderwritingServices_CreateWalkResolutionTaskRequestInput = {
  idempotencyKey?: InputMaybe<Scalars['String']>;
  propertyEngagementId?: InputMaybe<Scalars['String']>;
  requestId?: InputMaybe<OdProtosCommon_RequestIdInput>;
  requestorId?: InputMaybe<OdProtosCommon_RequestorIdInput>;
};

export type OdProtosAcquisitionUnderwritingServices_CreateWalkResolutionTaskResponse_Error_Code =
  | 'INVALID_ARGUMENT'
  | 'UNKNOWN';

/** Next ID: 4 */
export type OdProtosAcquisitionUnderwritingServices_GetEngagementPricingsRequestInput = {
  propertyEngagementId?: InputMaybe<Scalars['String']>;
  requestId?: InputMaybe<OdProtosCommon_RequestIdInput>;
  requestorId?: InputMaybe<OdProtosCommon_RequestorIdInput>;
};

/** Next ID: 4 */
export type OdProtosAcquisitionUnderwritingServices_GetEngagementRequestInput = {
  propertyEngagementId?: InputMaybe<Scalars['String']>;
  requestId?: InputMaybe<OdProtosCommon_RequestIdInput>;
  requestorId?: InputMaybe<OdProtosCommon_RequestorIdInput>;
};

export type OdProtosAcquisitionUnderwritingServices_GetEngagementResponse_Error_Code =
  | 'INVALID_ARGUMENT'
  | 'UNKNOWN';

/** Next ID: 4 */
export type OdProtosAcquisitionUnderwritingServices_GetSubEngagementRequestInput = {
  propertyEngagementId?: InputMaybe<Scalars['String']>;
  requestId?: InputMaybe<OdProtosCommon_RequestIdInput>;
  requestorId?: InputMaybe<OdProtosCommon_RequestorIdInput>;
};

export type OdProtosAcquisitionUnderwritingServices_GetSubEngagementResponse_Error_Code =
  | 'INVALID_ARGUMENT'
  | 'UNKNOWN';

/** Next ID: 4 */
export type OdProtosAcquisitionUnderwritingServices_GetWalkProposalsRequestInput = {
  propertyEngagementId?: InputMaybe<Scalars['String']>;
  requestId?: InputMaybe<OdProtosCommon_RequestIdInput>;
  requestorId?: InputMaybe<OdProtosCommon_RequestorIdInput>;
};

/** Next ID: 5 */
export type OdProtosAcquisitionUnderwritingServices_RecordCamundaProcessInstanceCreationRequestInput = {
  camundaProcessInstance?: InputMaybe<OdProtosPricingData_CamundaProcessInstanceInput>;
  idempotencyKey?: InputMaybe<Scalars['String']>;
  requestId?: InputMaybe<OdProtosCommon_RequestIdInput>;
  requestorId?: InputMaybe<OdProtosCommon_RequestorIdInput>;
};

export type OdProtosAcquisitionUnderwritingServices_RecordCamundaProcessInstanceCreationResponse_Error_Code =
  | 'INVALID_ARGUMENT'
  | 'UNKNOWN';

/** Next ID: 5 */
export type OdProtosAcquisitionUnderwritingServices_RecordCamundaProcessInstanceFinishRequestInput = {
  idempotencyKey?: InputMaybe<Scalars['String']>;
  propertyEngagementId?: InputMaybe<Scalars['String']>;
  requestId?: InputMaybe<OdProtosCommon_RequestIdInput>;
  requestorId?: InputMaybe<OdProtosCommon_RequestorIdInput>;
};

export type OdProtosAcquisitionUnderwritingServices_RecordCamundaProcessInstanceFinishResponse_Error_Code =
  | 'INVALID_ARGUMENT'
  | 'UNKNOWN';

/** Next ID: 6 */
export type OdProtosAcquisitionUnderwritingServices_RecordEngagementCompletedRequestInput = {
  idempotencyKey?: InputMaybe<Scalars['String']>;
  outcome?: InputMaybe<OdProtosAcquisitionUnderwritingData_UnderwritingOutcomeInput>;
  propertyEngagementId?: InputMaybe<Scalars['String']>;
  requestId?: InputMaybe<OdProtosCommon_RequestIdInput>;
  requestorId?: InputMaybe<OdProtosCommon_RequestorIdInput>;
};

export type OdProtosAcquisitionUnderwritingServices_RecordEngagementCompletedResponse_Error_Code =
  | 'INVALID_ARGUMENT'
  | 'UNKNOWN';

/** Next ID: 7 */
export type OdProtosAcquisitionUnderwritingServices_RecordEngagementPricingRequestInput = {
  idempotencyKey?: InputMaybe<Scalars['String']>;
  propertyEngagementId?: InputMaybe<Scalars['String']>;
  requestId?: InputMaybe<OdProtosCommon_RequestIdInput>;
  requestorId?: InputMaybe<OdProtosCommon_RequestorIdInput>;
  source?: InputMaybe<Scalars['String']>;
  webUnitEconomicId?: InputMaybe<Scalars['String']>;
};

export type OdProtosAcquisitionUnderwritingServices_RecordEngagementPricingResponse_Error_Code =
  | 'INVALID_ARGUMENT'
  | 'UNKNOWN';

/** Next ID: 8 */
export type OdProtosAcquisitionUnderwritingServices_RecordNewEngagementRequestInput = {
  addressToken?: InputMaybe<Scalars['String']>;
  idempotencyKey?: InputMaybe<Scalars['String']>;
  /** Mock configurations, if present, will short-circuit the process */
  mockConfiguration?: InputMaybe<OdProtosPricingData_MockAcquisitionUnderwritingInput>;
  propertyEngagementGroupId?: InputMaybe<Scalars['String']>;
  propertyEngagementId?: InputMaybe<Scalars['String']>;
  requestId?: InputMaybe<OdProtosCommon_RequestIdInput>;
  requestorId?: InputMaybe<OdProtosCommon_RequestorIdInput>;
};

export type OdProtosAcquisitionUnderwritingServices_RecordNewEngagementResponse_Error_Code =
  | 'INVALID_ARGUMENT'
  | 'UNKNOWN';

/** Next ID: 14 */
export type OdProtosAcquisitionUnderwritingServices_RecordNewSubEngagementRequestInput = {
  idempotencyKey?: InputMaybe<Scalars['String']>;
  /** PE ID for the overaching UW property engagement (which is triggering this sub engagement) */
  parentPropertyEngagementId?: InputMaybe<Scalars['String']>;
  /**
   * Typically, you should not set this field and one will be idempotently generated by the server.
   * This field is left available for testing purposes (temporarily).
   */
  propertyEngagementId?: InputMaybe<Scalars['String']>;
  requestId?: InputMaybe<OdProtosCommon_RequestIdInput>;
  requestorId?: InputMaybe<OdProtosCommon_RequestorIdInput>;
  subEngagement?: InputMaybe<OdProtosAcquisitionUnderwritingServices_RecordNewSubEngagementRequest_SubEngagementOneofInput>;
};

export type OdProtosAcquisitionUnderwritingServices_RecordNewSubEngagementRequest_OverrideValuationArgsInput = {
  humanToken?: InputMaybe<Scalars['String']>;
};

export type OdProtosAcquisitionUnderwritingServices_RecordNewSubEngagementRequest_PreRenoValuationArgsInput = {
  humanToken?: InputMaybe<Scalars['String']>;
};

export type OdProtosAcquisitionUnderwritingServices_RecordNewSubEngagementRequest_SubEngagementOneofInput = {
  dataLabeling?: InputMaybe<GoogleProtobuf_EmptyInput>;
  ensembledValuation?: InputMaybe<GoogleProtobuf_EmptyInput>;
  overrideValuation?: InputMaybe<OdProtosAcquisitionUnderwritingServices_RecordNewSubEngagementRequest_OverrideValuationArgsInput>;
  postRenoValuation?: InputMaybe<GoogleProtobuf_EmptyInput>;
  preRenoValuation?: InputMaybe<OdProtosAcquisitionUnderwritingServices_RecordNewSubEngagementRequest_PreRenoValuationArgsInput>;
  repairBudgetReview?: InputMaybe<GoogleProtobuf_EmptyInput>;
  riskAssessment?: InputMaybe<GoogleProtobuf_EmptyInput>;
};

export type OdProtosAcquisitionUnderwritingServices_RecordNewSubEngagementResponse_Error_Code =
  | 'INVALID_ARGUMENT'
  | 'UNKNOWN';

/** Next ID: 5 */
export type OdProtosAcquisitionUnderwritingServices_RecordSubEngagementCompletedRequestInput = {
  idempotencyKey?: InputMaybe<Scalars['String']>;
  /** PE ID of the sub engagement */
  propertyEngagementId?: InputMaybe<Scalars['String']>;
  requestId?: InputMaybe<OdProtosCommon_RequestIdInput>;
  requestorId?: InputMaybe<OdProtosCommon_RequestorIdInput>;
};

export type OdProtosAcquisitionUnderwritingServices_RecordSubEngagementCompletedResponse_Error_Code =
  | 'INVALID_ARGUMENT'
  | 'UNKNOWN';

/** Next ID: 5 */
export type OdProtosAcquisitionUnderwritingServices_RecordSubEngagementStoppedRequestInput = {
  idempotencyKey?: InputMaybe<Scalars['String']>;
  /** PE ID of the sub engagement */
  propertyEngagementId?: InputMaybe<Scalars['String']>;
  requestId?: InputMaybe<OdProtosCommon_RequestIdInput>;
  requestorId?: InputMaybe<OdProtosCommon_RequestorIdInput>;
};

export type OdProtosAcquisitionUnderwritingServices_RecordSubEngagementStoppedResponse_Error_Code =
  | 'INVALID_ARGUMENT'
  | 'UNKNOWN';

/** Next ID: 5 */
export type OdProtosAcquisitionUnderwritingServices_TerminatePropertyEngagementRequestInput = {
  idempotencyKey?: InputMaybe<Scalars['String']>;
  propertyEngagementId?: InputMaybe<Scalars['String']>;
  requestId?: InputMaybe<OdProtosCommon_RequestIdInput>;
  requestorId?: InputMaybe<OdProtosCommon_RequestorIdInput>;
};

export type OdProtosAcquisitionUnderwritingServices_TerminatePropertyEngagementResponse_Error_Code =
  | 'INVALID_ARGUMENT'
  | 'NOT_FOUND'
  | 'UNKNOWN';

export type OdProtosAddressParserServices_AddressIdentifierInput = {
  /** String that will be parsed for address components. */
  text?: InputMaybe<Scalars['String']>;
};

export type OdProtosAddressParserServices_ParseRequestInput = {
  addressIdentifiers?: InputMaybe<Array<OdProtosAddressParserServices_AddressIdentifierInput>>;
};

export type OdProtosAdmiralData_AttributedEvent_UserAssociationReason =
  | 'CODELESS_UNLOCK'
  | 'CODE_HANDOUT'
  | 'UNKNOWN_ASSOCIATION_REASON';

export type OdProtosAdmiralData_AttributedEvent_UserType =
  | 'CUSTOMER'
  | 'EMPLOYEE'
  | 'SECURITY'
  | 'UNKNOWN_USER_TYPE'
  | 'VENDOR';

export type OdProtosAdmiralData_ConnectivityRating =
  | 'BAD'
  | 'GOOD'
  | 'UNKNOWN';

export type OdProtosAdmiralData_DeviceInstallFeedbackInput = {
  deviceNotInstalledReason?: InputMaybe<Scalars['String']>;
  installationSchemaDeviceId?: InputMaybe<Scalars['Float']>;
  trackingId?: InputMaybe<Scalars['String']>;
};

/** Structured input reasons that say why a device schema is non-default */
export type OdProtosAdmiralData_DeviceSchema_Reason =
  | 'ELEVATED_HOME_RISK';

export type OdProtosAdmiralData_DeviceTeardownFeedbackInput = {
  deviceNotTornDownReason?: InputMaybe<Scalars['String']>;
  installationSchemaDeviceId?: InputMaybe<Scalars['Float']>;
  tornDown?: InputMaybe<Scalars['Boolean']>;
};

export type OdProtosAdmiralData_EventKind =
  | 'CAMERA_MOTION_DETECTED'
  /**
   * Contact sensor events
   * (starting at 20 to leave room for more unlock events)
   */
  | 'CONTACT_SENSOR_BROKEN'
  | 'CONTACT_SENSOR_CLOSED'
  | 'CONTACT_SENSOR_LEFT_OPEN'
  | 'DEVICE_OFFLINE'
  | 'DEVICE_ONLINE'
  | 'DOOR_AUTO_LOCKED'
  /**
   * We get separate events for code usages from "door unlocked with code" events
   * so we'll distinguish the two with a different event kind
   */
  | 'DOOR_CODE_USAGE'
  | 'DOOR_JAMMED_WHILE_LOCKING'
  | 'DOOR_JAMMED_WHILE_UNLOCKING'
  | 'DOOR_LOCKED'
  /** Door lock events */
  | 'DOOR_LOCKED_MANUALLY'
  | 'DOOR_LOCKED_REMOTELY'
  | 'DOOR_UNLOCKED'
  | 'DOOR_UNLOCKED_MANUALLY'
  /** Door unlocks */
  | 'DOOR_UNLOCKED_REMOTELY'
  | 'DOOR_UNLOCKED_WITH_CODE'
  | 'DOOR_UNLOCK_EXCEEDED_ATTEMPTS'
  | 'EVENT_KIND_UNKNOWN'
  | 'HUB_OFFLINE'
  | 'HUB_ONLINE'
  | 'LOW_BATTERY_ALERT'
  /** Motion events */
  | 'MOTION_DETECTED'
  | 'MOTION_STOPPED'
  | 'TAMPER'
  | 'TEMPERATURE_ALERT'
  /** General device events */
  | 'TEMPERATURE_READING';

export type OdProtosAdmiralData_EventType =
  | 'BATTERY_EVENT'
  | 'CONTACT_SENSOR_EVENT'
  | 'DEVICE_CONNECTIVITY_EVENT'
  | 'DOOR_LOCK_EVENT'
  | 'DOOR_UNLOCK_EVENT'
  | 'EVENT_TYPE_UNKNOWN'
  | 'HUB_CONNECTIVITY_EVENT'
  | 'MOTION_EVENT'
  | 'TAMPER_EVENT'
  | 'TEMPERATURE_EVENT';

/** Structured input reasons that say why a device schema is non-default */
export type OdProtosAdmiralData_ExpectedDevice_Reason =
  | 'CAMERA_EXPERIMENT'
  | 'DEFAULT'
  | 'ELEVATED_HOME_RISK'
  | 'SIGNAGE_EXPERIMENT'
  | 'SMART_BULB_EXPERIMENT';

export type OdProtosAdmiralData_ExpectedDevice_Type =
  | 'CAMERA'
  | 'CONTACT_SENSOR'
  | 'DOOR_LOCK'
  | 'MOTION_SENSOR'
  | 'SECURITY_SIGNAGE'
  | 'SIREN'
  | 'SMART_BULB'
  | 'UNKNOWN';

export type OdProtosAdmiralData_HomeAccessMethod =
  | 'ACCESS_METHOD_DOOR_CODE'
  | 'ACCESS_METHOD_LOCKBOX'
  | 'ACCESS_METHOD_MARKET_CODE'
  | 'ACCESS_METHOD_REMOTE_UNLOCK'
  | 'ACCESS_METHOD_ROTATING_CODE'
  | 'ACCESS_METHOD_STATIC_CODE'
  | 'ACCESS_METHOD_VENDOR_CODE';

export type OdProtosAdmiralData_HomeAccessUserType =
  | 'CUSTOMER'
  | 'EMPLOYEE'
  | 'SECURITY'
  | 'UNKNOWN_USER_TYPE'
  | 'VENDOR';

/** Next ID: 4 */
export type OdProtosAdmiralData_HubParamsInput = {
  certificateId?: InputMaybe<Scalars['String']>;
  identifier?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

export type OdProtosAdmiralData_InstallationReportV2ParamsInput = {
  fleetUuid?: InputMaybe<Scalars['String']>;
  issueFilter?: InputMaybe<OdProtosAdmiralData_InstallationReportV2Params_IssueFilter>;
  troubleReportType?: InputMaybe<OdProtosAdmiralData_InstallationReportV2Params_TroubleReportType>;
};

export type OdProtosAdmiralData_InstallationReportV2Params_IssueFilter =
  /** Filters devices with battery issues or unknown battery status */
  | 'BATTERY'
  /** Filters any motion sensors that have a high temperature reading or unknown */
  | 'HIGH_TEMPERATURE'
  /** Filters locks that have been jammed */
  | 'LOCK_JAMMED'
  /** Filters any motion sensors that have a low temperature reading or unknown */
  | 'LOW_TEMPERATURE'
  /** Returns all results without a filter */
  | 'NO_FILTER'
  /** Filters devices with pairing issues or unknown pairing status */
  | 'PAIRING'
  /** Filters silent devices that have not reported status in a while */
  | 'SILENT';

/** (optional) TroubleReportType allows filtering reports based on specific issue types */
export type OdProtosAdmiralData_InstallationReportV2Params_TroubleReportType =
  | 'ANY'
  | 'HUB'
  | 'LOCK'
  | 'MOTION_SENSOR'
  | 'NONE'
  | 'SIREN'
  | 'UNKNOWN';

export type OdProtosAdmiralData_LockBoltAction =
  | 'LOCK'
  | 'UNKNOWN_LOCK_ACTION'
  | 'UNLOCK';

export type OdProtosAdmiralData_SirenActivationAction =
  | 'ACTIVATE'
  | 'DEACTIVATE'
  | 'UNKNOWN_SIREN_ACTION';

export type OdProtosAdmiralData_SmartRentDeviceStatusFromCache_InstallationStatus =
  | 'COMPLETE'
  | 'IN_PROGRESS'
  | 'UNKNOWN_STATUS';

export type OdProtosAdmiralData_SmartRentDeviceStatusFromCache_Type =
  | 'CAMERA'
  | 'CONTACT_SENSOR'
  | 'DOOR_LOCK'
  | 'MOTION_SENSOR'
  | 'SIREN'
  | 'SMART_BULB'
  | 'UNKNOWN';

export type OdProtosAdmiralData_SmartRentDeviceStatus_InstallationStatus =
  | 'COMPLETE'
  | 'IN_PROGRESS'
  | 'UNKNOWN_STATUS';

export type OdProtosAdmiralData_SmartRentDeviceStatus_Type =
  | 'CAMERA'
  | 'CONTACT_SENSOR'
  | 'DOOR_LOCK'
  | 'MOTION_SENSOR'
  | 'SIREN'
  | 'SMART_BULB'
  | 'UNKNOWN';

export type OdProtosAdmiralData_SmartRentDoorCodeType =
  | 'MARKET_CODE'
  | 'ROTATING_CODE'
  | 'STATIC_CODE'
  | 'UNKNOWN_CODE_TYPE';

/** SELECT DISTINCT upper(kind) FROM smartrent_events; */
export type OdProtosAdmiralData_SmartRentEvent_EventKindTypes =
  | 'KIND_MANUAL_UNLOCK'
  | 'KIND_MOTION'
  | 'KIND_UNSPECIFIED';

/** SELECT DISTINCT upper(trigger) FROM smartrent_events; */
export type OdProtosAdmiralData_SmartRentEvent_EventTriggerTypes =
  | 'TRIGGER_DEVICE_LOCK'
  | 'TRIGGER_DEVICE_MOTION_SENSOR'
  | 'TRIGGER_HUB_OFFLINE'
  | 'TRIGGER_HUB_ONLINE'
  | 'TRIGGER_UNSPECIFIED';

export type OdProtosAdmiralData_Timeframe =
  | 'LAST_HOUR'
  | 'LAST_NINETY_DAYS'
  | 'LAST_SEVEN_DAYS'
  | 'LAST_TWENTY_EIGHT_DAYS'
  | 'LAST_TWENTY_FOUR_HOURS'
  | 'MONTH_TO_DATE'
  | 'NONE';

export type OdProtosAdmiralServices_AssociateRingAccountToAddressRequestInput = {
  addressUuid?: InputMaybe<Scalars['String']>;
  ringAccountId?: InputMaybe<Scalars['Float']>;
};

export type OdProtosAdmiralServices_BackfillSessionEventRequestInput = {
  eventId?: InputMaybe<Scalars['Float']>;
  trigger?: InputMaybe<Scalars['String']>;
};

export type OdProtosAdmiralServices_BulkSetLockboxCodesRequestInput = {
  pairs?: InputMaybe<Array<OdProtosAdmiralServices_CodePairInput>>;
};

export type OdProtosAdmiralServices_CheckHubSchemaRequestInput = {
  addressId?: InputMaybe<Scalars['String']>;
  hubIdentifier?: InputMaybe<Scalars['String']>;
};

export type OdProtosAdmiralServices_ClientType =
  | 'CUSTOMER'
  | 'HOME_ACCESS'
  | 'HPM'
  | 'NON_ACCESS'
  | 'VENDOR';

export type OdProtosAdmiralServices_CodePairInput = {
  addressUuid?: InputMaybe<Scalars['String']>;
  code?: InputMaybe<Scalars['String']>;
};

export type OdProtosAdmiralServices_CompleteKnoxSetupRequestInput = {
  addressUuid?: InputMaybe<Scalars['String']>;
  hubIdentifier?: InputMaybe<Scalars['String']>;
  skipListingTypeChange?: InputMaybe<Scalars['Boolean']>;
};

/**
 * Creates or updates the link between an Address UUID and a hub identifier. A partial hub identifier, as long as it's
 * unique, is acceptable.
 */
export type OdProtosAdmiralServices_CreateInstallationV2RequestInput = {
  addressUuid?: InputMaybe<Scalars['String']>;
  hubIdentifier?: InputMaybe<Scalars['String']>;
};

export type OdProtosAdmiralServices_CreateSmartrentUnitRequestInput = {
  addressId?: InputMaybe<Scalars['String']>;
};

export type OdProtosAdmiralServices_DeactivateInstallationV2RequestInput = {
  addressUuid?: InputMaybe<Scalars['String']>;
  deleteReason?: InputMaybe<OdProtosAdmiralServices_DeleteReason>;
  hubIdentifier?: InputMaybe<Scalars['String']>;
};

export type OdProtosAdmiralServices_DeleteReason =
  | 'CLEANUP'
  | 'MANUALLY_DELETED'
  | 'TEAR_DOWN'
  | 'UNKNOWN';

export type OdProtosAdmiralServices_DeviceSchemaRequests_GetDeviceSchemaInput = {
  addressUuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosAdmiralServices_GetAfterVisitingHoursRequestInput = {
  addressUuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosAdmiralServices_GetAttributedEventsRequestInput = {
  addressUuid?: InputMaybe<Scalars['String']>;
  /** Get events where occurred_at < end_time descending */
  endTime?: InputMaybe<Scalars['DateTime']>;
  includeEventTypes?: InputMaybe<Array<OdProtosAdmiralData_EventType>>;
  paginationRequest?: InputMaybe<OdProtosCommonPagination_PaginationRequestInput>;
  /** Get events where occurred_at > start_time descending */
  startTime?: InputMaybe<Scalars['DateTime']>;
};

export type OdProtosAdmiralServices_GetCameraReviewRequestInput = {
  id?: InputMaybe<Scalars['Float']>;
};

/** Next ID: 4 */
export type OdProtosAdmiralServices_GetCustomerCodeRequestInput = {
  /** Required: UUID for the home you want to fetch a door code for */
  addressUuid?: InputMaybe<Scalars['String']>;
  /** Optional (but encouraged!): Client that request was sent from (buyer, scout, vendor portal) */
  client?: InputMaybe<Scalars['String']>;
  /**
   * Optional (but encouraged!): the token for the customer who is requesting the code.
   * Used for attribution. Ignored if blank.
   */
  customerToken?: InputMaybe<Scalars['String']>;
};

export type OdProtosAdmiralServices_GetDoorCodeForHubRequestInput = {
  alwaysFetchNewCode?: InputMaybe<Scalars['Boolean']>;
  handedOutToToken?: InputMaybe<Scalars['String']>;
  hubIdentifier?: InputMaybe<Scalars['String']>;
  trippyVisitId?: InputMaybe<Scalars['String']>;
};

export type OdProtosAdmiralServices_GetHomeAccessHistoryRequestInput = {
  addressUuid?: InputMaybe<Scalars['String']>;
  paginationRequest?: InputMaybe<OdProtosCommonPagination_OffsetPaginationRequestInput>;
  sort?: InputMaybe<OdProtosAdmiralServices_SortRequestInput>;
};

export type OdProtosAdmiralServices_GetHomeRiskAssessmentRequestInput = {
  addressUuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosAdmiralServices_GetLockboxCodeRequestInput = {
  addressUuid?: InputMaybe<Scalars['String']>;
  clientType?: InputMaybe<OdProtosAdmiralServices_ClientType>;
  handedOutToToken?: InputMaybe<Scalars['String']>;
};

export type OdProtosAdmiralServices_GetOrCreateDoorCodeForVendorRequestInput = {
  addressId?: InputMaybe<Scalars['String']>;
  /**
   * allow_expiration_extension: if an expiration_timestamp is provided
   * and an existing code is found the expires before the desired time,
   * extend the expiration time
   */
  allowExpirationExtension?: InputMaybe<Scalars['Boolean']>;
  /** expiration_timestamp: the time that this code will expire. */
  expirationTimestamp?: InputMaybe<Scalars['DateTime']>;
  organizationId?: InputMaybe<Scalars['String']>;
};

export type OdProtosAdmiralServices_GetSmartRentDeviceEventsRequestInput = {
  after?: InputMaybe<Scalars['DateTime']>;
  before?: InputMaybe<Scalars['DateTime']>;
  smartrentDeviceIds?: InputMaybe<Array<Scalars['Float']>>;
};

export type OdProtosAdmiralServices_GetSmartRentDeviceStatusesRequestInput = {
  addressUuid?: InputMaybe<Scalars['String']>;
};

/** Next ID: 2 */
export type OdProtosAdmiralServices_GetStaticCodeRequestInput = {
  /** Required: UUID for the home you want to fetch a door code for */
  addressUuid?: InputMaybe<Scalars['String']>;
  clientType?: InputMaybe<OdProtosAdmiralServices_ClientType>;
  handedOutToToken?: InputMaybe<Scalars['String']>;
};

export type OdProtosAdmiralServices_HubRequests_FindUniqueInput = {
  identifierPart?: InputMaybe<Scalars['String']>;
};

export type OdProtosAdmiralServices_HubRequests_GetByCertificateIdInput = {
  certificateId?: InputMaybe<Scalars['String']>;
};

export type OdProtosAdmiralServices_HubRequests_GetInput = {
  identifier?: InputMaybe<Scalars['String']>;
};

export type OdProtosAdmiralServices_HubRequests_ToggleHubWifiInput = {
  addressToken?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
};

export type OdProtosAdmiralServices_HubRequests_UpdateHubWifiPassphraseInput = {
  addressToken?: InputMaybe<Scalars['String']>;
  passphrase?: InputMaybe<Scalars['String']>;
};

export type OdProtosAdmiralServices_HubRequests_UpsertInput = {
  hub?: InputMaybe<OdProtosAdmiralData_HubParamsInput>;
};

export type OdProtosAdmiralServices_HubSchemaStatus_DeviceKind =
  | 'CRITICAL'
  | 'REQUIRED';

export type OdProtosAdmiralServices_InstallationReportV2Requests_GetInput = {
  paginationRequest?: InputMaybe<OdProtosCommonPagination_PaginationRequestInput>;
  params?: InputMaybe<OdProtosAdmiralData_InstallationReportV2ParamsInput>;
};

export type OdProtosAdmiralServices_InstallationRequests_GetInput = {
  addressUuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosAdmiralServices_InstallationRequests_ListByAddressUuidInput = {
  addressUuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosAdmiralServices_InstallationRequests_ListProtectionsInTimeRangeInput = {
  addressUuids?: InputMaybe<Array<Scalars['String']>>;
  endingAt?: InputMaybe<Scalars['DateTime']>;
  includeShadows?: InputMaybe<Scalars['Boolean']>;
  startingAt?: InputMaybe<Scalars['DateTime']>;
};

export type OdProtosAdmiralServices_InstallationRequests_ProtectionsForAddressInput = {
  addressUuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosAdmiralServices_ListCustomerHomeAccessesRequestInput = {
  customerId?: InputMaybe<Scalars['String']>;
  paginationRequest?: InputMaybe<OdProtosCommonPagination_PaginationRequestInput>;
};

export type OdProtosAdmiralServices_ListCustomerHomeAccessesResponse_AccessMethod =
  | 'DOOR_CODE'
  | 'REMOTE_UNLOCK';

export type OdProtosAdmiralServices_ListHomeRiskAssessmentsRequestInput = {
  addressUuids?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosAdmiralServices_ListRingAccountAssociationsRequestInput = {
  addressUuids?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosAdmiralServices_ListRingAccountsRequestInput = {
  markets?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosAdmiralServices_MergeCustomerAccessDataRequestInput = {
  mergedCustomerUuid?: InputMaybe<Scalars['String']>;
  mergedIntoCustomerUuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosAdmiralServices_PatrolResponseRequests_GetInput = {
  id?: InputMaybe<Scalars['Float']>;
};

export type OdProtosAdmiralServices_PatrolResponseRequests_ListByAddressInput = {
  addressUuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosAdmiralServices_PatrolResponseRequests_UpdateInput = {
  id?: InputMaybe<Scalars['Float']>;
  incidentReportId?: InputMaybe<Scalars['String']>;
  reportingError?: InputMaybe<Scalars['Boolean']>;
  reportingErrorReasons?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosAdmiralServices_ProvideDeviceInstallationFeedbackRequestInput = {
  feedback?: InputMaybe<Array<OdProtosAdmiralData_DeviceInstallFeedbackInput>>;
  userToken?: InputMaybe<Scalars['String']>;
};

export type OdProtosAdmiralServices_ProvideDeviceTeardownFeedbackRequestInput = {
  feedback?: InputMaybe<Array<OdProtosAdmiralData_DeviceTeardownFeedbackInput>>;
  userToken?: InputMaybe<Scalars['String']>;
};

export type OdProtosAdmiralServices_ProvideKnoxInstallationFeedbackRequestInput = {
  addressUuid?: InputMaybe<Scalars['String']>;
  connectivityRating?: InputMaybe<OdProtosAdmiralData_ConnectivityRating>;
  knoxNotInstalledReason?: InputMaybe<Scalars['String']>;
  userToken?: InputMaybe<Scalars['String']>;
  willInstallLater?: InputMaybe<Scalars['Boolean']>;
};

export type OdProtosAdmiralServices_RandomizeLockCodeRequestInput = {
  /** device_identifier accepts full or partial identifiers. Admiral does not expect callers to have full identifier. */
  deviceIdentifier?: InputMaybe<Scalars['String']>;
  slotNumber?: InputMaybe<Scalars['Float']>;
};

export type OdProtosAdmiralServices_ResolveCameraReviewRequestInput = {
  cameraReviewId?: InputMaybe<Scalars['Float']>;
  resolution?: InputMaybe<OdProtosAdmiralServices_ResolveCameraReviewRequest_ResolutionOneofInput>;
};

export type OdProtosAdmiralServices_ResolveCameraReviewRequest_ResolutionOneofInput = {
  falseAlarm?: InputMaybe<Scalars['Boolean']>;
  incidentReportId?: InputMaybe<Scalars['String']>;
};

export type OdProtosAdmiralServices_SearchRequestInput = {
  /** search allows partial/full hub identifier, partial/full addressUUID, and partial/full readable address. */
  search?: InputMaybe<Scalars['String']>;
};

export type OdProtosAdmiralServices_SetHomeToHighRiskRequestInput = {
  addressUuid?: InputMaybe<Scalars['String']>;
  incidentReportId?: InputMaybe<Scalars['String']>;
};

export type OdProtosAdmiralServices_SetLockboxCodeRequestInput = {
  addressUuid?: InputMaybe<Scalars['String']>;
  lockboxCode?: InputMaybe<Scalars['String']>;
};

export type OdProtosAdmiralServices_SmartrentUnitByAddressRequestInput = {
  addressId?: InputMaybe<Scalars['String']>;
};

export type OdProtosAdmiralServices_SortDirection =
  | 'ASC'
  | 'DESC';

export type OdProtosAdmiralServices_SortRequestInput = {
  direction?: InputMaybe<OdProtosAdmiralServices_SortDirection>;
};

/** Next ID: 7 */
export type OdProtosAdmiralServices_UnlockHomeRequestInput = {
  /** Optional (but encouraged!): Client that request was sent from (buyer, scout, vendor portal) */
  client?: InputMaybe<Scalars['String']>;
  /**
   * Optional (but encouraged!): the token for the customer who is requesting the codeless unlock.
   * Used for attribution and analytics tracking. Ignored if blank.
   */
  customerToken?: InputMaybe<Scalars['String']>;
  /**
   * Optional (but encouraged!): the token for the user who is requesting the codeless unlock.
   * This is meant for codeless unlock by internal users.
   * Used for attribution and analytics tracking. Ignored if blank.
   * Only needed if customer_token is blank.
   */
  humanToken?: InputMaybe<Scalars['String']>;
  /** Required: identifying information for home to unlock */
  identifier?: InputMaybe<OdProtosAdmiralServices_UnlockHomeRequest_IdentifierOneofInput>;
  /**
   * The home's listing slug, only required for unlock requests that will be proxied to knox.
   * if listing_slug is provided, hub_identifier MUST also be provided
   */
  listingSlug?: InputMaybe<Scalars['String']>;
};

export type OdProtosAdmiralServices_UnlockHomeRequest_IdentifierOneofInput = {
  /** UUID for the home you want to unlock */
  addressUuid?: InputMaybe<Scalars['String']>;
  /** identifier for the Hub to unlock */
  hubIdentifier?: InputMaybe<Scalars['String']>;
};

export type OdProtosAgentDataStore_AgentVerificationStatus =
  | 'AGENT_STATUS_DENIED'
  | 'AGENT_STATUS_FULLY_VERIFIED'
  | 'AGENT_STATUS_REQUIRES_VERIFICATION'
  | 'AGENT_STATUS_UNKNOWN'
  | 'AGENT_STATUS_VERIFIED';

export type OdProtosAgentDataStore_CreateAgentContactRequestInput = {
  brokerageNames?: InputMaybe<Array<Scalars['String']>>;
  contactId?: InputMaybe<Scalars['String']>;
  licenseNumber?: InputMaybe<Scalars['String']>;
  mls?: InputMaybe<OdProtosCommonMls_Mls>;
  mlsId?: InputMaybe<Scalars['String']>;
  sourceSystem?: InputMaybe<OdProtosAgentDataStore_CreateAgentContactRequest_SourceSystem>;
  verifiedPhoneNumber?: InputMaybe<Scalars['String']>;
};

export type OdProtosAgentDataStore_CreateAgentContactRequest_SourceSystem =
  | 'ADMIN'
  | 'APP'
  | 'NOMAD'
  | 'SHOWINGTIME'
  | 'UNKNOWN';

export type OdProtosAgentDataStore_GetAgentContactRequestInput = {
  identifier?: InputMaybe<OdProtosAgentDataStore_GetAgentContactRequest_IdentifierOneofInput>;
};

export type OdProtosAgentDataStore_GetAgentContactRequest_IdentifierOneofInput = {
  /** The ID of the contact from Custard. See protobuf/custard/v1/data/contact.proto */
  contactId?: InputMaybe<Scalars['String']>;
  /** The ID owned by this service for the agent_contact */
  id?: InputMaybe<Scalars['String']>;
};

/**
 * An MLSAgent represents a standardized version of the data being ingested from the different MLSs for agents
 *
 * Context: Different MLSs give us different versions of raw data which must be mapped into a standard form
 *
 * A MLSAgent is uniquely identified by the (mls_name, mls_id) tuple.
 *
 * Next ID: 15
 */
export type OdProtosAgentDataStore_MlsAgentInput = {
  /** Name of brokerage agent belongs to */
  brokerage?: InputMaybe<Scalars['String']>;
  /** Agents email */
  email?: InputMaybe<Scalars['String']>;
  /** First name of the agent */
  firstName?: InputMaybe<Scalars['String']>;
  /** Flag to represent if the agent is active */
  isActive?: InputMaybe<Scalars['Boolean']>;
  /** Last name of the agent */
  lastName?: InputMaybe<Scalars['String']>;
  /** License number for the agent. This does not need to match the MLS ID */
  licenseNumber?: InputMaybe<Scalars['String']>;
  /** Name of MLS for this agent. Required */
  mls?: InputMaybe<OdProtosCommonMls_Mls>;
  /** MLS_ID for this agent. Can contain letters and special characters. Required */
  mlsId?: InputMaybe<Scalars['String']>;
  /** Internal MLS_ID for this agent. Can contain letters and special characters. */
  mlsInternalId?: InputMaybe<Scalars['String']>;
  /** Mod timestamp for the agent. Required */
  modTimestamp?: InputMaybe<Scalars['DateTime']>;
  /** Agents primary phone number */
  primaryPhoneNumber?: InputMaybe<Scalars['String']>;
  /** Agents secondary phone number */
  secondaryPhoneNumber?: InputMaybe<Scalars['String']>;
  /** Timestamp representing when the agent was updated in the ADS database. */
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

/**
 * List of params on which MLS Agents can be searched on
 * This purposely does not include everything in the MLSAgent message as only certain fields are indexed
 * and expected to be searched on
 *
 * Next ID: 5
 */
export type OdProtosAgentDataStore_MlsAgentSearchParamsInput = {
  /** Name of the mls for which the agent is being searched for */
  mls?: InputMaybe<OdProtosCommonMls_Mls>;
  /**
   * Unique ID from the MLS which identifies the agent. Its usually semi private and different from the license
   * number which can be public on an agent's website. Required
   */
  mlsId?: InputMaybe<Scalars['String']>;
  /** Unique ID from the MLS which identifies the agent. It is usually private. Either mls_id or mls_internal_id is needed to search. If both are provided, it does 'And' on both. */
  mlsInternalId?: InputMaybe<Scalars['String']>;
};

export type OdProtosAgentDataStore_MlsAgentSearchRequestInput = {
  /** params being used to search for the MLS agent */
  mlsAgentSearchParams?: InputMaybe<OdProtosAgentDataStore_MlsAgentSearchParamsInput>;
};

export type OdProtosAgentDataStore_MlsAgentWriteRequestInput = {
  /** MLSAgent to be added to the records */
  mlsAgent?: InputMaybe<OdProtosAgentDataStore_MlsAgentInput>;
};

export type OdProtosAgentDataStore_MlsAgentsSearchRequestInput = {
  /** params being used to search for the MLS agents */
  mlsAgentSearchParams?: InputMaybe<Array<OdProtosAgentDataStore_MlsAgentSearchParamsInput>>;
};

export type OdProtosAgentDataStore_MergeAgentContactsRequestInput = {
  mergedContactId?: InputMaybe<Scalars['String']>;
  mergedIntoContactId?: InputMaybe<Scalars['String']>;
};

export type OdProtosAgentDataStore_UpdateAgentContactRequestInput = {
  brokerageNames?: InputMaybe<OdProtosAgentDataStore_UpdateAgentContactRequest_BrokerageNamesInput>;
  id?: InputMaybe<Scalars['String']>;
  licenseNumber?: InputMaybe<Scalars['String']>;
  /** Non-null fields will be updated. */
  mlsIdentifier?: InputMaybe<OdProtosAgentDataStore_UpdateAgentContactRequest_MlsIdentifierInput>;
};

export type OdProtosAgentDataStore_UpdateAgentContactRequest_BrokerageNamesInput = {
  brokerageNames?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosAgentDataStore_UpdateAgentContactRequest_MlsIdentifierInput = {
  mls?: InputMaybe<OdProtosCommonMls_Mls>;
  mlsId?: InputMaybe<Scalars['String']>;
};

export type OdProtosAgentDataStore_UpdateAgentVerificationStatusRequestInput = {
  agentVerificationStatus?: InputMaybe<OdProtosAgentDataStore_AgentVerificationStatus>;
  contactId?: InputMaybe<Scalars['String']>;
  humanIdentifier?: InputMaybe<Scalars['String']>;
};

export type OdProtosAgentsData_AgentFilterInput = {
  /**
   * Only Agents which have a state found in the states list will
   * be returned. If no states filter is provided, all Agents found
   * in the ACTIVE state will be returned
   */
  states?: InputMaybe<Array<OdProtosAgentsData_Agent_State>>;
};

export type OdProtosAgentsData_AgentLead_LeadType =
  | 'AGENT_LED_OFFERS_LISTING'
  | 'LIST_WITH_CERTAINTY_LISTING'
  | 'PARN_LISTING'
  | 'UNKNOWN_LEAD_TYPE';

export type OdProtosAgentsData_AgentLead_State =
  | 'AGENTS_PROPOSED'
  | 'ASSIGNED'
  | 'ASSIGNMENT_NOT_POSSIBLE'
  | 'BROKERAGE_ACCEPTED'
  | 'BROKERAGE_PROPOSED'
  | 'CANDIDATE_AGENTS_PROPOSED'
  | 'COMPLETED'
  | 'CREATED'
  | 'DELETED'
  | 'IN_PROGRESS'
  | 'MANUAL_ASSIGNMENT_REQUIRED'
  | 'SELECTING_AGENT'
  | 'SELECTING_BROKERAGE'
  | 'SELECT_AGENT_CANDIDATE'
  | 'UNKNOWN'
  | 'UNSERVICEABLE';

export type OdProtosAgentsData_Agent_ScheduleUnavailabilityInput = {
  endTime?: InputMaybe<Scalars['DateTime']>;
  startTime?: InputMaybe<Scalars['DateTime']>;
};

export type OdProtosAgentsData_Agent_State =
  | 'ACTIVE'
  | 'BLOCKED'
  | 'INACTIVE'
  | 'UNKNOWN';

/** Next ID: 4 */
export type OdProtosAgentsData_Agent_SupportedLeadInput = {
  market?: InputMaybe<Scalars['String']>;
  serviceRegion?: InputMaybe<OdProtosAgentsData_ServiceRegionInput>;
  type?: InputMaybe<OdProtosAgentsData_LeadType>;
};

export type OdProtosAgentsData_Agent_WeeklyScheduleSlotInput = {
  dayOfWeek?: InputMaybe<OdProtosCommon_DayOfWeek>;
  endTime?: InputMaybe<OdProtosAgentsData_TimeOfDayInput>;
  startTime?: InputMaybe<OdProtosAgentsData_TimeOfDayInput>;
};

export type OdProtosAgentsData_BrokerageInput = {
  agentAssignmentType?: InputMaybe<OdProtosAgentsData_Brokerage_AgentAssignmentType>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  opendoorManagingHumanId?: InputMaybe<Scalars['String']>;
  publicDisplayPhoneNumber?: InputMaybe<Scalars['String']>;
  publicDisplayPhotoCabinetId?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<OdProtosAgentsData_Brokerage_State>;
  supportedLeads?: InputMaybe<Array<OdProtosAgentsData_Brokerage_SupportedLeadInput>>;
  teamLeadAgentId?: InputMaybe<Scalars['String']>;
};

export type OdProtosAgentsData_Brokerage_AgentAssignmentType =
  | 'AUTOMATIC_AGENT_ASSIGNMENT'
  | 'MANUAL_AGENT_ASSIGNMENT'
  | 'UNKNOWN_AGENT_ASSIGNMENT';

export type OdProtosAgentsData_Brokerage_State =
  | 'ACTIVE'
  | 'INACTIVE'
  | 'UNKNOWN';

/** Next ID: 6 */
export type OdProtosAgentsData_Brokerage_SupportedLeadInput = {
  market?: InputMaybe<Scalars['String']>;
  serviceRegion?: InputMaybe<OdProtosAgentsData_ServiceRegionInput>;
  supportsSpanish?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<OdProtosAgentsData_LeadType>;
  weight?: InputMaybe<Scalars['Float']>;
};

/** NEXT ID: 20 */
export type OdProtosAgentsData_LeadType =
  | 'AGENT_LED_OFFERS_LISTING'
  | 'APPRAISAL_VISIT'
  | 'AVID'
  | 'EXCLUSIVES_MARKETPLACE_OPEN_HOUSE'
  | 'EXCLUSIVES_MARKETPLACE_SHOWING'
  | 'EXTRAORDINARY_EVENT_PAY'
  | 'FINAL_WALKTHROUGH'
  | 'FLIER_DELIVERY'
  | 'INSPECTION'
  | 'LIST_WITH_CERTAINTY_LISTING'
  | 'LOCK_CHECK'
  | 'OD_OWNED_HOME_AUDIT'
  | 'OPEN_HOUSE'
  | 'PARN_LISTING'
  | 'PHOTOGRAPHER_MEETING'
  | 'PICK_UP_AND_DELIVERY'
  | 'POST_MUTUAL_VISIT'
  | 'THREE_SIXTY_SCANS'
  | 'TOUR'
  | 'UNKNOWN';

export type OdProtosAgentsData_OfficeMlsIdsAction =
  | 'ADD'
  | 'REMOVE';

/** Next ID: 3 */
export type OdProtosAgentsData_ServiceRegionInput = {
  region?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<OdProtosAgentsData_ServiceRegion_Type>;
};

/** Next ID: 4 */
export type OdProtosAgentsData_ServiceRegion_Type =
  | 'GLOBAL'
  | 'MARKET'
  | 'UNKNOWN'
  | 'ZIP_CODE';

export type OdProtosAgentsData_TimeOfDayInput = {
  hour?: InputMaybe<Scalars['Float']>;
  minute?: InputMaybe<Scalars['Float']>;
};

export type OdProtosAgentsServices_AcceptLeadRequestInput = {
  agentCustomerId?: InputMaybe<Scalars['String']>;
  agentLeadId?: InputMaybe<Scalars['String']>;
};

export type OdProtosAgentsServices_ActivateAgentRequestInput = {
  agentId?: InputMaybe<Scalars['String']>;
};

export type OdProtosAgentsServices_AddBrokeragesMlsRequestInput = {
  brokerageId?: InputMaybe<Scalars['String']>;
  mlsName?: InputMaybe<Scalars['String']>;
  officeMlsIds?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosAgentsServices_AddScheduleUnavailabilityRequestInput = {
  agentId?: InputMaybe<Scalars['String']>;
  scheduleUnavailability?: InputMaybe<OdProtosAgentsData_Agent_ScheduleUnavailabilityInput>;
};

export type OdProtosAgentsServices_AddWeeklyScheduleSlotRequestInput = {
  agentId?: InputMaybe<Scalars['String']>;
  weeklyScheduleSlot?: InputMaybe<OdProtosAgentsData_Agent_WeeklyScheduleSlotInput>;
};

export type OdProtosAgentsServices_AdminAssignLeadRequestInput = {
  agentId?: InputMaybe<Scalars['String']>;
  agentLeadId?: InputMaybe<Scalars['String']>;
};

export type OdProtosAgentsServices_AssignLeadRequestInput = {
  agentId?: InputMaybe<Scalars['String']>;
  agentLeadId?: InputMaybe<Scalars['String']>;
};

export type OdProtosAgentsServices_CreateAgentRequestInput = {
  agentCustomerId?: InputMaybe<Scalars['String']>;
  brokerageId?: InputMaybe<Scalars['String']>;
};

export type OdProtosAgentsServices_CreateAgentWithoutBrokerageRequestInput = {
  agentCustomerId?: InputMaybe<Scalars['String']>;
};

export type OdProtosAgentsServices_CreateBrokerageRequestInput = {
  brokerage?: InputMaybe<OdProtosAgentsData_BrokerageInput>;
};

export type OdProtosAgentsServices_DeactivateAgentRequestInput = {
  agentId?: InputMaybe<Scalars['String']>;
};

export type OdProtosAgentsServices_GetAgentByIdRequestInput = {
  agentId?: InputMaybe<Scalars['String']>;
};

export type OdProtosAgentsServices_GetAgentRequestInput = {
  agentCustomerId?: InputMaybe<Scalars['String']>;
};

export type OdProtosAgentsServices_GetBrokerageAgentsRequestInput = {
  brokerageId?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<OdProtosAgentsData_AgentFilterInput>;
};

export type OdProtosAgentsServices_GetBrokerageRequestInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type OdProtosAgentsServices_ListBrokeragesRequestInput = {
  _empty?: InputMaybe<Scalars['Boolean']>;
};

export type OdProtosAgentsServices_RejectLeadRequestInput = {
  agentCustomerId?: InputMaybe<Scalars['String']>;
  agentLeadId?: InputMaybe<Scalars['String']>;
};

export type OdProtosAgentsServices_RemoveAgentSupportedLeadRequestInput = {
  agentId?: InputMaybe<Scalars['String']>;
  supportedLead?: InputMaybe<OdProtosAgentsData_Agent_SupportedLeadInput>;
};

export type OdProtosAgentsServices_RemoveBrokerageSupportedLeadRequestInput = {
  id?: InputMaybe<Scalars['String']>;
  supportedLead?: InputMaybe<OdProtosAgentsData_Brokerage_SupportedLeadInput>;
};

export type OdProtosAgentsServices_RemoveHeadshotRequestInput = {
  agentId?: InputMaybe<Scalars['String']>;
};

export type OdProtosAgentsServices_RemoveScheduleUnavailabilityRequestInput = {
  agentId?: InputMaybe<Scalars['String']>;
  scheduleUnavailability?: InputMaybe<OdProtosAgentsData_Agent_ScheduleUnavailabilityInput>;
};

export type OdProtosAgentsServices_RemoveWeeklyScheduleSlotRequestInput = {
  agentId?: InputMaybe<Scalars['String']>;
  weeklyScheduleSlot?: InputMaybe<OdProtosAgentsData_Agent_WeeklyScheduleSlotInput>;
};

export type OdProtosAgentsServices_SetAgentLicenseRequestInput = {
  agentId?: InputMaybe<Scalars['String']>;
  licenseNumber?: InputMaybe<Scalars['String']>;
  licenseState?: InputMaybe<OdProtosCommonState_State>;
};

export type OdProtosAgentsServices_SetAgentSupportedLeadRequestInput = {
  agentId?: InputMaybe<Scalars['String']>;
  supportedLead?: InputMaybe<OdProtosAgentsData_Agent_SupportedLeadInput>;
};

export type OdProtosAgentsServices_SetAgentSupportedLeadsInBulkRequestInput = {
  agentId?: InputMaybe<Scalars['String']>;
  supportedLeads?: InputMaybe<Array<OdProtosAgentsData_Agent_SupportedLeadInput>>;
};

export type OdProtosAgentsServices_SetBrokerageSupportedLeadRequestInput = {
  id?: InputMaybe<Scalars['String']>;
  supportedLead?: InputMaybe<OdProtosAgentsData_Brokerage_SupportedLeadInput>;
};

export type OdProtosAgentsServices_SetBrokerageSupportedLeadsInBulkRequestInput = {
  id?: InputMaybe<Scalars['String']>;
  supportedLeads?: InputMaybe<Array<OdProtosAgentsData_Brokerage_SupportedLeadInput>>;
};

export type OdProtosAgentsServices_SetHeadshotRequestInput = {
  agentId?: InputMaybe<Scalars['String']>;
  headshotUrl?: InputMaybe<Scalars['String']>;
};

export type OdProtosAgentsServices_UpdateAgentRequestInput = {
  agentCustomerId?: InputMaybe<Scalars['String']>;
  agentId?: InputMaybe<Scalars['String']>;
  headshotCabinetId?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
};

export type OdProtosAgentsServices_UpdateBrokerageRequestInput = {
  brokerage?: InputMaybe<OdProtosAgentsData_BrokerageInput>;
  updateMask?: InputMaybe<GoogleProtobuf_FieldMaskInput>;
};

export type OdProtosAgentsServices_UpdateBrokeragesMlsRequestInput = {
  id?: InputMaybe<Scalars['String']>;
  mlsName?: InputMaybe<Scalars['String']>;
  officeMlsIds?: InputMaybe<Array<Scalars['String']>>;
  officeMlsIdsAction?: InputMaybe<OdProtosAgentsData_OfficeMlsIdsAction>;
  updateMask?: InputMaybe<GoogleProtobuf_FieldMaskInput>;
};

export type OdProtosAthleteData_Bank =
  | 'JP_MORGAN'
  | 'NONE'
  | 'WELLS_FARGO';

export type OdProtosAthleteData_CreateTemplateApprovalInput = {
  bank?: InputMaybe<OdProtosAthleteData_Bank>;
  escrowAgency?: InputMaybe<Scalars['String']>;
  financier?: InputMaybe<Scalars['String']>;
  fromAccountId?: InputMaybe<Scalars['String']>;
  marketIdentifier?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  /** FINENG-375 - change osn_jpm to string true/false instead of bool */
  osnJpmStr?: InputMaybe<Scalars['String']>;
  /** uuid only present with other fields when modifying existing template */
  templateUuid?: InputMaybe<Scalars['String']>;
  toAccountId?: InputMaybe<Scalars['String']>;
  wireType?: InputMaybe<Scalars['String']>;
};

/**
 * EscrowTemplateLookup is used to find the unique template
 * identified by each of the three attributes,
 * where the template in turn identifies the payer/payee
 */
export type OdProtosAthleteData_EscrowTemplateLookupInput = {
  /** the name of the escrow agency executing the transaction */
  escrowAgencyName?: InputMaybe<Scalars['String']>;
  financierName?: InputMaybe<Scalars['String']>;
  /** snake case, from web/Market.rb */
  marketIdentifier?: InputMaybe<Scalars['String']>;
  scroogeEntityId?: InputMaybe<Scalars['String']>;
};

export type OdProtosAthleteData_TemplateAccountOrderingInput = {
  column?: InputMaybe<OdProtosAthleteData_TemplateAccountOrdering_Column>;
  isDescending?: InputMaybe<Scalars['Boolean']>;
};

export type OdProtosAthleteData_TemplateAccountOrdering_Column =
  | 'ACCOUNT_NUMBER'
  | 'COUNTRY'
  | 'NAME';

export type OdProtosAthleteData_TemplateOrderingInput = {
  column?: InputMaybe<OdProtosAthleteData_TemplateOrdering_Column>;
  isDescending?: InputMaybe<Scalars['Boolean']>;
};

export type OdProtosAthleteData_TemplateOrdering_Column =
  | 'BANK'
  | 'ESCROW_AGENCY_NAME'
  | 'FINANCIER_NAME'
  | 'MARKET_IDENTIFIER'
  | 'NAME'
  | 'OSN_JPM';

/** Wire represents a wire transfer */
export type OdProtosAthleteData_WireInput = {
  /** bank used to send the wire */
  bank?: InputMaybe<OdProtosAthleteData_Bank>;
  bankName?: InputMaybe<Scalars['String']>;
  /** when the wire was created */
  creationDatetime?: InputMaybe<Scalars['DateTime']>;
  /** non-unique external id (likely flip token) of the wire */
  externalId?: InputMaybe<Scalars['String']>;
  /** name of user who intiated wire */
  initiatorFullName?: InputMaybe<Scalars['String']>;
  /** arbitrary internal note */
  note?: InputMaybe<Scalars['String']>;
  /** the amount of the wire */
  paymentAmountCents?: InputMaybe<Scalars['Float']>;
  /** this is the id that will be shared with the bank */
  publicId?: InputMaybe<Scalars['String']>;
  /** arbitrary strings that indicate the reason / additional details for the wire */
  remittanceInfo?: InputMaybe<OdProtosAthleteData_Wire_RemittanceInfoInput>;
  /** remittance status of wire */
  status?: InputMaybe<OdProtosAthleteData_Wire_WireStatus>;
  /** Opendoor-understood wire type */
  type?: InputMaybe<OdProtosAthleteData_Wire_WireType>;
  /** uuid of the wire */
  uuid?: InputMaybe<Scalars['String']>;
  /** the date the wire will be transferred (have value) */
  valueDate?: InputMaybe<OdProtosCommon_DateInput>;
};

/**
 * RemittanceInfo are four text fields describing
 * to payee the intended purpose of the wire –
 * for each escrow wire they indicate which escrow account to fund
 */
export type OdProtosAthleteData_Wire_RemittanceInfoInput = {
  field1?: InputMaybe<Scalars['String']>;
  field2?: InputMaybe<Scalars['String']>;
  field3?: InputMaybe<Scalars['String']>;
  field4?: InputMaybe<Scalars['String']>;
};

/**
 * WireStatus represents the Wells-Fargo-indicated/JP Morgan status
 * of each initiated wire transfer
 */
export type OdProtosAthleteData_Wire_WireStatus =
  | 'ACCEPTED'
  /** Wells Fargo */
  | 'AWAITING_APPROVAL'
  | 'AWAITING_RATE'
  | 'AWAITING_REPAIR'
  | 'CANCELED'
  | 'COMPLETED'
  | 'FUTURE_VALUE_DATE'
  | 'INTERNAL_UNINITIALIZED'
  /** General */
  | 'MARK_FOR_DELETION'
  /** JP Morgan */
  | 'PENDING'
  | 'PENDING_CLIENT_REVIEW'
  | 'PENDING_COMPLIANCE_REVIEW'
  | 'PENDING_CREDIT_DECISION'
  | 'PROCESSING_BY_BANK'
  | 'QUEUED'
  | 'REJECTED'
  | 'REJECTED_BY_BANK'
  | 'SUCCESSFUL'
  | 'UNKNOWN'
  | 'UNSUCCESSFUL';

/**
 * WireType is used for validations per flip
 * to ensure that no more than one wire of each type
 * (save CORRECTION) is submitted for a home
 */
export type OdProtosAthleteData_Wire_WireType =
  | 'AMOUNT_DUE_FROM_BUYER'
  | 'CORRECTION'
  | 'EARNEST_DEPOSIT'
  | 'OPTION_FEE';

export type OdProtosAthleteServices_BulkConfirmTemplateApprovalRequestInput = {
  approve?: InputMaybe<Scalars['Boolean']>;
  uuids?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosAthleteServices_CreateTemplateAccountInput = {
  accountNumber?: InputMaybe<Scalars['String']>;
  agentCountry?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  routingNumber?: InputMaybe<Scalars['String']>;
};

export type OdProtosAthleteServices_CreateTemplateAccountsRequestInput = {
  templateAccounts?: InputMaybe<Array<OdProtosAthleteServices_CreateTemplateAccountInput>>;
};

export type OdProtosAthleteServices_CreateTemplateApprovalsRequestInput = {
  templateApprovals?: InputMaybe<Array<OdProtosAthleteData_CreateTemplateApprovalInput>>;
};

export type OdProtosAthleteServices_GetWiresForExternalIdRequestInput = {
  externalId?: InputMaybe<Scalars['String']>;
};

export type OdProtosAthleteServices_InitiateEscrowWireRequestInput = {
  templateLookup?: InputMaybe<OdProtosAthleteData_EscrowTemplateLookupInput>;
  wire?: InputMaybe<OdProtosAthleteData_WireInput>;
};

export type OdProtosAthleteServices_SearchTemplateAccountsRequestInput = {
  accountNumber?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  ordering?: InputMaybe<Array<OdProtosAthleteData_TemplateAccountOrderingInput>>;
  pagination?: InputMaybe<OdProtosCommonPagination_PaginationRequestInput>;
  templateAccountUuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosAthleteServices_SearchTemplatesRequestInput = {
  escrowAgencyName?: InputMaybe<Scalars['String']>;
  financierName?: InputMaybe<Scalars['String']>;
  marketIdentifier?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  ordering?: InputMaybe<Array<OdProtosAthleteData_TemplateOrderingInput>>;
  pagination?: InputMaybe<OdProtosCommonPagination_PaginationRequestInput>;
  templateUuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosAthleteServices_UpdateTemplateAccountRequestInput = {
  agentCountry?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  uuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosAthleteServices_VerifyTemplateRequestInput = {
  templateLookup?: InputMaybe<OdProtosAthleteData_EscrowTemplateLookupInput>;
};

export type OdProtosAuthAuthzData_Grant_Status =
  | 'ACTIVE'
  | 'INACTIVE';

export type OdProtosAuthAuthzData_ScopeInput = {
  description?: InputMaybe<Scalars['String']>;
  /**
   * Must be of the format `([a-z][a-z0-9\\-]+)(\\.([a-z][a-z0-9\\-])+)?`
   * use `.` to separate segments
   */
  id?: InputMaybe<Scalars['String']>;
};

export type OdProtosAuthAuthzServices_RoleConditionInput = {
  /** Must have at least one of these roles if non-empty. */
  authorizedRoles?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosAuthAuthzServices_UserAuthorizedBranches_RequestInput = {
  /** Required role conditions that must be satisfied */
  roleConditions?: InputMaybe<OdProtosAuthAuthzServices_RoleConditionInput>;
  /** Required scope. Must be present in the grant (or you must be a direct member of the branch) */
  scope?: InputMaybe<OdProtosAuthAuthzData_ScopeInput>;
  /** If you do not specify the user id, the currently authenticated user will be used. */
  userId?: InputMaybe<Scalars['String']>;
};

export type OdProtosAuthAuthzServices_UserAuthorized_RequestInput = {
  /** Branch in bender to check for */
  branchId?: InputMaybe<Scalars['String']>;
  /** Required role conditions that must be satisfied */
  roleConditions?: InputMaybe<OdProtosAuthAuthzServices_RoleConditionInput>;
  /** Required scope. Must be present in the grant (or you must be a direct member of the branch) */
  scope?: InputMaybe<OdProtosAuthAuthzData_ScopeInput>;
  /** If you do not specify the user id, the currently authenticated user will be used. */
  userId?: InputMaybe<Scalars['String']>;
};

export type OdProtosAuthzProxyReferenceServiceServices_MessageInput = {
  message?: InputMaybe<Scalars['String']>;
};

export type OdProtosBallparkData_Source =
  | 'BULK_OVM'
  | 'NATIONWIDE_VALUATIONS_ENSEMBLER'
  | 'REALTY_TRAC'
  | 'UNKNOWN_SOURCE';

/** Next ID: 2 */
export type OdProtosBallparkServices_GetHomeFeeRequestInput = {
  addressUuid?: InputMaybe<Scalars['String']>;
};

/** Next ID: 2 */
export type OdProtosBallparkServices_GetHomeFeesRequestInput = {
  addressUuids?: InputMaybe<Array<Scalars['String']>>;
};

/** Next ID: 5 */
export type OdProtosBallparkServices_GetHomeValueRequestInput = {
  addressUuid?: InputMaybe<Scalars['String']>;
};

/** Next ID: 3 */
export type OdProtosBallparkServices_GetHomeValuesRequestInput = {
  addressUuids?: InputMaybe<Array<Scalars['String']>>;
  market?: InputMaybe<OdProtosCommonMarket_Market>;
};

export type OdProtosBanditData_LaborCostInput = {
  totalCents?: InputMaybe<Scalars['Float']>;
};

export type OdProtosBanditData_MaterialCostInput = {
  quantity?: InputMaybe<Scalars['Float']>;
  unit?: InputMaybe<OdProtosBanditData_UnitType>;
  unitCents?: InputMaybe<Scalars['Float']>;
};

export type OdProtosBanditData_RepairScopeOrigin =
  | 'REPAIRSCOPEORIGIN_ASSESSMENT_REVIEW'
  | 'REPAIRSCOPEORIGIN_CONDITION_SCOPING'
  | 'REPAIRSCOPEORIGIN_CONDITION_SCOPING_AI'
  | 'REPAIRSCOPEORIGIN_CONDITION_SCOPING_AI_FEEDBACK'
  | 'REPAIRSCOPEORIGIN_CONDITION_SCOPING_AI_HIDDEN'
  /** manual */
  | 'REPAIRSCOPEORIGIN_CONDITION_SCOPING_M'
  | 'REPAIRSCOPEORIGIN_POST_CONTRACT_DILIGENCE_SCOPING'
  | 'REPAIRSCOPEORIGIN_UNSPECIFIED';

export type OdProtosBanditData_SourceReferenceInput = {
  id?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<OdProtosBanditData_SourceReference_SourceReferenceType>;
};

export type OdProtosBanditData_SourceReference_SourceReferenceType =
  | 'PROMPT'
  | 'PROMPT_GROUP'
  | 'SOURCE_REFERENCE_TYPE_UNSPECIFIED';

export type OdProtosBanditData_State =
  | 'APPROVED'
  | 'DELETED'
  | 'INVALID'
  | 'OPEN';

export type OdProtosBanditData_UnitType =
  | 'EACH'
  | 'LINEAR_FEET'
  | 'SQUARE_FEET';

export type OdProtosBanditServices_ChangeAddressRequestInput = {
  newAddressId?: InputMaybe<Scalars['String']>;
  oldAddressId?: InputMaybe<Scalars['String']>;
  taskIds?: InputMaybe<Array<Scalars['String']>>;
  visitIds?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosBanditServices_CreateRepairScopeRequestInput = {
  addressId?: InputMaybe<Scalars['String']>;
  areaId?: InputMaybe<Scalars['String']>;
  createdFromSource?: InputMaybe<Scalars['String']>;
  createdFromSourceReference?: InputMaybe<OdProtosBanditData_SourceReferenceInput>;
  defectId?: InputMaybe<Scalars['String']>;
  deferred?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<Scalars['String']>;
  featureId?: InputMaybe<Scalars['String']>;
  laborCost?: InputMaybe<OdProtosBanditData_LaborCostInput>;
  materialCost?: InputMaybe<OdProtosBanditData_MaterialCostInput>;
  origin?: InputMaybe<OdProtosBanditData_RepairScopeOrigin>;
  taskId?: InputMaybe<Scalars['String']>;
  visitId?: InputMaybe<Scalars['String']>;
};

export type OdProtosBanditServices_DeleteRepairScopeRequestInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type OdProtosBanditServices_DeleteRepairScopesRequestInput = {
  repairScopeIds?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosBanditServices_EnsureRepairScopePrelimsRequestInput = {
  addressId?: InputMaybe<Scalars['String']>;
};

export type OdProtosBanditServices_GetRepairScopesByHomeRequestInput = {
  addressId?: InputMaybe<Scalars['String']>;
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
  originIn?: InputMaybe<Array<OdProtosBanditData_RepairScopeOrigin>>;
};

export type OdProtosBanditServices_GetRepairScopesSnapshotsRequestInput = {
  addressId?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<OdProtosBanditServices_RepairScopeSnapshotFiltersInput>;
};

export type OdProtosBanditServices_GetRepairScopesTotalFiltersInput = {
  originIn?: InputMaybe<Array<OdProtosBanditData_RepairScopeOrigin>>;
  snapshotTime?: InputMaybe<Scalars['DateTime']>;
};

export type OdProtosBanditServices_GetRepairScopesTotalRequestInput = {
  addressId?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<OdProtosBanditServices_GetRepairScopesTotalFiltersInput>;
};

export type OdProtosBanditServices_IdentifierListRequestInput = {
  ids?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosBanditServices_IdentifierRequestInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type OdProtosBanditServices_ListAssessmentScopeCostsForAddressesRequestInput = {
  addressIds?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosBanditServices_RepairScopeSnapshotFiltersInput = {
  excludeDeletedSnapshots?: InputMaybe<Scalars['Boolean']>;
  originIn?: InputMaybe<Array<OdProtosBanditData_RepairScopeOrigin>>;
};

export type OdProtosBanditServices_RestoreDeletedRepairScopeRequestInput = {
  repairScopeId?: InputMaybe<Scalars['String']>;
};

/** The non null values will be updated */
export type OdProtosBanditServices_UpdateRepairScopeRequestInput = {
  areaId?: InputMaybe<Scalars['String']>;
  defectId?: InputMaybe<Scalars['String']>;
  deferred?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<Scalars['String']>;
  featureId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  laborCost?: InputMaybe<OdProtosBanditData_LaborCostInput>;
  materialCost?: InputMaybe<OdProtosBanditData_MaterialCostInput>;
  origin?: InputMaybe<OdProtosBanditData_RepairScopeOrigin>;
  updatedFromSource?: InputMaybe<Scalars['String']>;
};

/** An ID issues by an MLS. */
export type OdProtosBrokeragesData_MlsidInput = {
  id?: InputMaybe<Scalars['String']>;
  mls?: InputMaybe<OdProtosCommonMls_Mls>;
};

/** A real estate license issued by a state. */
export type OdProtosBrokeragesData_RealEstateLicenseInput = {
  number?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<OdProtosCommonState_State>;
};

/** initial map region to be displayed for a market, to be used inside MarketConfig */
export type OdProtosBuyConfig_InitialMapRegionInput = {
  latitude?: InputMaybe<Scalars['Float']>;
  latitudeDelta?: InputMaybe<Scalars['Float']>;
  longitude?: InputMaybe<Scalars['Float']>;
  longitudeDelta?: InputMaybe<Scalars['Float']>;
};

/**
 * Config keyed by Market.
 * PBDB Key: market
 */
export type OdProtosBuyConfig_MarketConfigInput = {
  /** flag for if market is active */
  active?: InputMaybe<Scalars['Boolean']>;
  /** number of days on market on average */
  averageDaysOnMarket?: InputMaybe<Scalars['Float']>;
  /** flag to turn on bwod for market */
  buyingExperience?: InputMaybe<Scalars['Boolean']>;
  /** contact email for non bwod markets */
  contactEmail?: InputMaybe<Scalars['String']>;
  /** contact email for bwod markets */
  contactEmailBx?: InputMaybe<Scalars['String']>;
  /** contact number for non bwod markets */
  contactPhoneNumber?: InputMaybe<Scalars['String']>;
  /** contact number for bwod markets */
  contactPhoneNumberBx?: InputMaybe<Scalars['String']>;
  /** flag for whether direct buy is on */
  directBuy?: InputMaybe<Scalars['Boolean']>;
  /** displayable name of the market (e.g "Phoenix"). */
  displayName?: InputMaybe<Scalars['String']>;
  /** displayable name of the state (e.g "Arizona") */
  displayState?: InputMaybe<Scalars['String']>;
  /** Deprecated: Feed filter defaults set during onboarding process */
  feedDefaults?: InputMaybe<OdProtosBuyConfig_PropertiesFilterInput>;
  /** flag for buyer incentive */
  hasBuyerIncentive?: InputMaybe<Scalars['Boolean']>;
  /** flag on whether to hide sale prices */
  hideSalePrices?: InputMaybe<Scalars['Boolean']>;
  /** path of homes in web */
  homesPath?: InputMaybe<Scalars['String']>;
  /** integer id of the market. */
  id?: InputMaybe<Scalars['Float']>;
  /** name of the market. This is also the identifier (e.g. "phoenix"). */
  identifier?: InputMaybe<Scalars['String']>;
  /** map region for the market */
  initialMapRegion?: InputMaybe<OdProtosBuyConfig_InitialMapRegionInput>;
  /** how wide of a map should we show */
  initialMapRegionLatitudeDelta?: InputMaybe<Scalars['Float']>;
  /** how tall of a map should we show */
  initialMapRegionLongitudeDelta?: InputMaybe<Scalars['Float']>;
  /** how tall of a map should we show (typo) */
  intitialMapRegionLongitudeDelta?: InputMaybe<Scalars['Float']>;
  /** market center latitude */
  marketCenterLatitude?: InputMaybe<Scalars['Float']>;
  /** market center longitude */
  marketCenterLongitude?: InputMaybe<Scalars['Float']>;
  /** primary MLS name for the market */
  mlsName?: InputMaybe<Scalars['String']>;
  /** all the MLS that are associated with this market */
  mlses?: InputMaybe<Array<OdProtosBuyConfig_MlsInput>>;
  /** name of the market (e.g "Phoenix"). */
  name?: InputMaybe<Scalars['String']>;
  /** flag to determine if open listings is active */
  openListingsActive?: InputMaybe<Scalars['Boolean']>;
  /** Ops region for market */
  opsRegion?: InputMaybe<Scalars['String']>;
  /** Fence ID of the region covered by this market. This is also the identifier (e.g. "phoenix"). */
  regionId?: InputMaybe<Scalars['String']>;
  /** secondary MLS name for the market (optional, not all markets have a secondary MLS) */
  secondaryMlsName?: InputMaybe<Scalars['String']>;
  /** Enable same-day tours/showings? */
  serviceSameDayShowings?: InputMaybe<Scalars['Boolean']>;
  /** Enable SMS verification? */
  serviceSmsVerification?: InputMaybe<Scalars['Boolean']>;
  /** appreviated name of the state (e.g "AZ"). */
  state?: InputMaybe<Scalars['String']>;
  /** full name of the state (e.g "Arizona") */
  stateName?: InputMaybe<Scalars['String']>;
  /** time zone for the market */
  timezone?: InputMaybe<Scalars['String']>;
  /** message for trade in incentive */
  tradeInIncentive?: InputMaybe<OdProtosBuyConfig_TradeInIncentiveInput>;
  /** flag for treatment */
  treatment?: InputMaybe<Scalars['Boolean']>;
};

/** MLS */
export type OdProtosBuyConfig_MlsInput = {
  name?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

/** Deprecated: User properties filter (used for feed) */
export type OdProtosBuyConfig_PropertiesFilterInput = {
  bathrooms?: InputMaybe<OdProtosBuyConfig_RangeInput>;
  bedrooms?: InputMaybe<OdProtosBuyConfig_RangeInput>;
  forFlippers?: InputMaybe<Scalars['Boolean']>;
  hasPool?: InputMaybe<Scalars['Boolean']>;
  includeHomebuilder?: InputMaybe<Scalars['Boolean']>;
  lotSqft?: InputMaybe<OdProtosBuyConfig_RangeInput>;
  maxMonthlyHoaFee?: InputMaybe<Scalars['Float']>;
  onlyFhaEligible?: InputMaybe<Scalars['Boolean']>;
  onlyInstantTours?: InputMaybe<Scalars['Boolean']>;
  onlyOpendoor?: InputMaybe<Scalars['Boolean']>;
  onlySingleStory?: InputMaybe<Scalars['Boolean']>;
  openHouses?: InputMaybe<Scalars['Boolean']>;
  poolType?: InputMaybe<Array<Scalars['String']>>;
  price?: InputMaybe<OdProtosBuyConfig_RangeInput>;
  propertyTypes?: InputMaybe<Array<Scalars['String']>>;
  sqft?: InputMaybe<OdProtosBuyConfig_RangeInput>;
  yearBuilt?: InputMaybe<OdProtosBuyConfig_RangeInput>;
  zips?: InputMaybe<Array<Scalars['String']>>;
  zoneIds?: InputMaybe<Array<Scalars['String']>>;
};

/** Integer range */
export type OdProtosBuyConfig_RangeInput = {
  max?: InputMaybe<Scalars['Float']>;
  min?: InputMaybe<Scalars['Float']>;
};

/** trade in incentive structure to be used inside Market Config */
export type OdProtosBuyConfig_TradeInIncentiveInput = {
  fixedAmountCents?: InputMaybe<Scalars['Float']>;
  percentage?: InputMaybe<Scalars['Float']>;
  type?: InputMaybe<Scalars['String']>;
};

/**
 * State represents the possible high-level states that a buy direct
 * channel's Originator can be in
 */
export type OdProtosBuydirectData_Channel_Originator_State =
  /** The property being sold by the Originator entity has a buyer committed to it */
  | 'COMMITTED_BUYER'
  /**
   * The property being sold by the Originator entity is pending commitment (it hasn't
   * been acquired yet or the selling has not been committed to)
   */
  | 'PENDING_COMMITMENT'
  /** The property being sold by the Originator entity is being prepared for listing */
  | 'PREPARING'
  /** The property being sold by the Originator entity is sellable */
  | 'SELLABLE'
  /** The property being sold by the Originator entity is no longer being sold */
  | 'TERMINATED'
  /** The State of the Originator entity is unknown */
  | 'UNKNOWN_ORIGINATOR_STATE';

/**
 * Originator type represents the possible types of entities that can be the
 * originator of a buy direct channel
 */
export type OdProtosBuydirectData_Channel_Originator_Type =
  /** The originator of the buy direct channel is Opendoor */
  | 'OPENDOOR'
  /** The originator of the buy direct channel is a third party seller */
  | 'THIRD_PARTY_SELLER'
  /** The originator of the buy direct channel is unknown */
  | 'UNKNOWN_ORIGINATOR_TYPE';

/**
 * State represents the possible high-level states that a buy direct channel
 * can be in during its lifecycle
 */
export type OdProtosBuydirectData_Channel_State =
  /**
   * The buy direct channel is currently inactive and the property is not
   * available through buy direct
   */
  | 'INACTIVE'
  /** The property is available to be purchased through the buy direct channel */
  | 'ON_THE_MARKET'
  /**
   * The BuyDirect Channel preparing to publish the property as being
   * available through buy direct
   */
  | 'PREPARING'
  /** The buy direct lifecycle for the property has terminated */
  | 'TERMINATED'
  /** The State of the BuyDirect Channel is unknown */
  | 'UNKNOWN_STATE'
  /**
   * The property is available to be seen through the buy direct channel,
   * however it is not available to be purchased yet
   */
  | 'VISIBLE';

/** TerminationReason indicates the reason a buy direct channel has terminated */
export type OdProtosBuydirectData_Channel_TerminationReason =
  /**
   * The channel has been terminated explicitly through a command as opposed
   * to naturally by the lifecycle of its parent
   */
  | 'EXPLICIT'
  /**
   * The channel has terminated because its parent (Resale) has been
   * canceled, meaning that Opendoor has terminated its intent to sell the
   * property at this time.
   */
  | 'RESALE_CANCELED'
  /**
   * The channel has terminated because its parent (Resale) has indicated
   * that the property was never acquired and hence does not need to be sold
   */
  | 'RESALE_NOT_ACQUIRED'
  /**
   * The channel has terminated because its parent (Resale) has indicated
   * that the property has been sold
   */
  | 'RESALE_SOLD'
  /** The channel has terminated for an unknown reason */
  | 'UNKNOWN_TERMINATION_REASON';

/**
 * ResaleState represents the possible high-level states that a buy direct
 * channel's Resale parent can be in
 */
export type OdProtosBuydirectData_Resale_ResaleState =
  /** The property being sold by the Resale entity has a buyer committed to it */
  | 'COMMITTED_BUYER'
  /**
   * The property being sold by the Resale entity is being prepared for
   * resale
   */
  | 'PREPARING'
  /**
   * The property being sold by the Resale entity is pre-inventory (it hasn't
   * been acquired yet)
   */
  | 'PRE_INVENTORY'
  /** The property being sold by the Resale entity is sellable */
  | 'SELLABLE'
  /** The property being sold by the Resale entity is no longer being sold */
  | 'TERMINATED'
  /** The State of the Resale entity is unknown */
  | 'UNKNOWN_RESALE_STATE';

/** Type is the enumeration of valid selling statuses */
export type OdProtosBuydirectData_SellingStatus_Type =
  /** The property will be available for sale soon */
  | 'AVAILABLE_SOON'
  /** The property is currently available for sale */
  | 'FOR_SALE'
  /**
   * The property is currently available for sale, but is under contract
   * with a buyer
   */
  | 'IN_CONTRACT'
  /** The property has been sold */
  | 'SOLD'
  /** The property is not available for sale */
  | 'UNAVAILABLE'
  /** Tnknown selling status */
  | 'UNKNOWN';

export type OdProtosBuydirectServices_GetBuyDirectChannelRequestInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type OdProtosBuydirectServices_GetMostRecentBuyDirectChannelByAddressIdRequestInput = {
  addressId?: InputMaybe<Scalars['String']>;
};

export type OdProtosBuyerData_Document_DocumentType =
  | 'ADDENDUM_COUNTER_SIGNATURE_DOCS'
  | 'ADDITIONAL_CLOSING_DOCS'
  | 'ADDITIONAL_DOCS'
  | 'CASH_OFFER_PROGRAM_AGREEMENT_DOCS'
  | 'CCPA_SCRUBBED_TYPE'
  | 'COMMISSION_INSTRUCTIONS_DOCS'
  | 'COUNTER_OFFER_DOCS'
  | 'DEED_DOCS'
  | 'DISCLOSURE_DOCS'
  | 'DOCUMENT_TYPE_UNKNOWN'
  | 'EARNEST_MONEY_RECEIPT_DOCS'
  | 'FINAL_SETTLEMENT_STATEMENTS_DOCS'
  | 'HOA_DEMAND_DOCS'
  | 'HOME_SALE_DOCS'
  | 'INSPECTION_REPORT_DOCS'
  | 'LAND_SURVEY_DOCS'
  | 'MORTGAGE_PREAPPROVAL_DOCS'
  | 'OBO_APPRAISAL_DOCS'
  | 'OBO_EARLY_OCCUPANCY_DOCS'
  | 'OBO_OPERATOR_APPRAISAL_DOCS'
  | 'PROOF_OF_FUNDS_DOCS'
  | 'PURCHASE_AGREEMENT_DOCS'
  | 'TAX_CERTIFICATE_DOCS'
  | 'TITLE_COMMITMENT_DOCS';

export type OdProtosBuyerData_Document_FileScanStatus =
  | 'CLEAN'
  | 'FILE_SCAN_STATUS_UNKNOWN'
  | 'INFECTED'
  | 'IN_PROGRESS';

export type OdProtosBuyerData_Offer_FundingSource =
  | 'CASH'
  | 'MORTGAGE'
  | 'UNKNOWN_FUNDING_SOURCE';

export type OdProtosBuyerData_Offer_OboStatus =
  | 'OBO_CLOSED_OPENDOOR_BOUGHT'
  | 'OBO_REASSIGNMENT_STARTED'
  | 'OBO_STATUS_UNKNOWN'
  | 'RESALE_CANCELED'
  | 'RESALE_CONTRACT_SENT'
  | 'RESALE_IN_CONTRACT'
  | 'TRANSACTION_COMPLETE_OPENDOOR_BOUGHT';

export type OdProtosBuyerData_Offer_State =
  | 'AWAITING_RESPONSE'
  | 'AWAITING_SIGNATURE'
  | 'CANCELED_BEFORE_SUBMITTING'
  | 'CANCELED_BY_BUYER'
  | 'CANCELED_ESCROW'
  | 'CLOSED_ESCROW'
  | 'COUNTERED'
  | 'DRAFT'
  | 'INCOMPLETE'
  | 'IN_CONTRACT'
  | 'IN_REVIEW'
  | 'READY_TO_SUBMIT'
  | 'REJECTED'
  | 'SUBMITTED_AS_BACKUP'
  | 'UNKNOWN';

export type OdProtosBuyerData_PricingRequest_ContactPreference =
  | 'CALL'
  | 'EMAIL'
  | 'TEXT'
  | 'UNKNOWN_CONTACT_PREFERENCE';

export type OdProtosBuyerData_Property_PoolType =
  | 'ABOVE_GROUND'
  | 'COMMUNITY'
  | 'NONE'
  | 'NO_POOL'
  | 'PRIVATE'
  | 'PRIVATE_SPA'
  | 'UNKNOWN_POOL_TYPE';

export type OdProtosBuyerData_Property_PropertyType =
  | 'APARTMENT'
  | 'COMMERCIAL'
  | 'HOME'
  | 'LAND'
  | 'MOBILE_HOME'
  | 'MULTI_FAMILY'
  | 'RENTAL'
  | 'TOWNHOME'
  | 'UNCLASSIFIED'
  | 'UNKNOWN_PROPERTY_TYPE';

export type OdProtosBuyerData_Rating_RatingContext =
  | 'ACCEPTED'
  | 'CANCELED'
  | 'CHECK_IN'
  | 'CLOSED'
  | 'MANUAL'
  | 'PRICING_REQUEST'
  | 'REJECTED'
  | 'TOUR_COMPLETED'
  /** Context enum used to identify review timeline */
  | 'UNKNOWN'
  | 'UNPAIR_REQUEST';

export type OdProtosBuyerData_ShowingRequest_InactiveReason =
  | 'ADMIN_REJECTED'
  | 'BUYER_CANCELED_AGENT'
  | 'BUYER_CANCELED_BEFORE'
  | 'BUYER_NO_SHOW'
  | 'BUYER_OPEN_HOUSE'
  | 'BUYER_TOURED_INDEPENDENTLY'
  | 'CANT_BE_SHOWN'
  | 'CANT_BE_SHOWN_WITH_TOUR'
  | 'NO_AGENT'
  | 'OFF_MARKET'
  | 'UNKNOWN'
  | 'UNRESPONSIVE_BUYER';

export type OdProtosBuyerData_ShowingRequest_VirtualPlatform =
  | 'FACETIME'
  | 'GOOGLE_DUO'
  | 'SKYPE'
  | 'UNKNOWN_VIRTUAL_PLATFORM'
  | 'WHATSAPP'
  | 'ZOOM';

export type OdProtosBuyerData_Task_TaskType =
  | 'APPRAISAL'
  | 'FEED_FILTERS'
  | 'INFORMATION_CONFIRMATION'
  | 'INSPECTIONS'
  | 'LOAN_APPLICATION'
  | 'LOAN_FINALIZATION'
  | 'MARKET_TRENDS'
  | 'RESALE_CONTRACT'
  | 'UNKNOWN_TASK_TYPE'
  | 'UTILITIES';

export type OdProtosBuyerData_Tour_RequestType =
  | 'FINAL_WALKTHROUGH'
  | 'INSPECTION'
  | 'OPEN_HOUSE'
  | 'SHOWING'
  | 'UNKNOWN_REQUEST_TYPE';

export type OdProtosBuyerData_Tour_State =
  | 'COMPLETED'
  | 'CONFIRMED'
  | 'EMPTY'
  | 'INACTIVE'
  | 'PENDING'
  | 'PROPERTY_CONFIRMED'
  | 'UNKNOWN_STATE';

export type OdProtosBuyerData_Tour_TourVibe =
  | 'DOOR_OPENER'
  | 'HANDS_ON'
  | 'UNKNOWN_TOUR_VIBE';

export type OdProtosBuyerData_User_CreditRating =
  | 'AVERAGE'
  | 'EXCELLENT'
  | 'GOOD'
  | 'LOW'
  | 'UNKNOWN_CREDIT_RATING';

/** DEPRECATED: Use SavedSearches in v2 buyer service */
export type OdProtosBuyerData_User_FeedPropertiesFilterInput = {
  hasPool?: InputMaybe<Scalars['Boolean']>;
  isFhaEligible?: InputMaybe<Scalars['Boolean']>;
  isSingleStory?: InputMaybe<Scalars['Boolean']>;
  maxLotSqft?: InputMaybe<Scalars['Int']>;
  maxMonthlyHoaFee?: InputMaybe<Scalars['Int']>;
  maxPrice?: InputMaybe<Scalars['Int']>;
  maxSqft?: InputMaybe<Scalars['Int']>;
  maxYearBuilt?: InputMaybe<Scalars['Int']>;
  minBathrooms?: InputMaybe<Scalars['Int']>;
  minBedrooms?: InputMaybe<Scalars['Int']>;
  minLotSqft?: InputMaybe<Scalars['Int']>;
  minPrice?: InputMaybe<Scalars['Int']>;
  minSqft?: InputMaybe<Scalars['Int']>;
  minYearBuilt?: InputMaybe<Scalars['Int']>;
  onlyHomebuilder?: InputMaybe<Scalars['Boolean']>;
  propertyTypes?: InputMaybe<Array<OdProtosBuyerData_Property_PropertyType>>;
  zones?: InputMaybe<Array<OdProtosBuyerData_ZoneInput>>;
};

/** DEPRECATED: Use FeedPropertiesFilter */
export type OdProtosBuyerData_User_PropertiesFilterInput = {
  hasPool?: InputMaybe<Scalars['Boolean']>;
  isFhaEligible?: InputMaybe<Scalars['Boolean']>;
  isSingleStory?: InputMaybe<Scalars['Boolean']>;
  maxLotSqft?: InputMaybe<Scalars['Float']>;
  maxMonthlyHoaFee?: InputMaybe<Scalars['Float']>;
  maxPrice?: InputMaybe<Scalars['Float']>;
  maxSqft?: InputMaybe<Scalars['Float']>;
  maxYearBuilt?: InputMaybe<Scalars['Float']>;
  minBathrooms?: InputMaybe<Scalars['Float']>;
  minBedrooms?: InputMaybe<Scalars['Float']>;
  minLotSqft?: InputMaybe<Scalars['Float']>;
  minPrice?: InputMaybe<Scalars['Float']>;
  minSqft?: InputMaybe<Scalars['Float']>;
  minYearBuilt?: InputMaybe<Scalars['Float']>;
  onlyHomebuilder?: InputMaybe<Scalars['Boolean']>;
  propertyTypes?: InputMaybe<Array<OdProtosBuyerData_Property_PropertyType>>;
  zones?: InputMaybe<Array<OdProtosBuyerData_ZoneInput>>;
};

export type OdProtosBuyerData_ZoneInput = {
  gdsId?: InputMaybe<Scalars['String']>;
};

export type OdProtosBuyerServicesBuyer_AgentRequests_GetAgentByIdInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type OdProtosBuyerServicesBuyer_AgentRequests_GetAgentByParamsIdInput = {
  paramsId?: InputMaybe<Scalars['String']>;
};

export type OdProtosBuyerServicesBuyer_AgentRequests_GetAgentProfileInfoByIdInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type OdProtosBuyerServicesBuyer_AgentRequests_GetAgentsByIdsInput = {
  ids?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosBuyerServicesBuyer_DocumentRequests_AddAppraisalDocumentByOfferIdInput = {
  amount?: InputMaybe<Scalars['Int']>;
  /** The name of the file, ex: pre_approval.pdf */
  name?: InputMaybe<Scalars['String']>;
  offerId?: InputMaybe<Scalars['String']>;
  s3Key?: InputMaybe<Scalars['String']>;
};

export type OdProtosBuyerServicesBuyer_DocumentRequests_AddPreApprovalDocumentByOfferIdInput = {
  /** The name of the file, ex: pre_approval.pdf */
  name?: InputMaybe<Scalars['String']>;
  offerId?: InputMaybe<Scalars['String']>;
  s3Key?: InputMaybe<Scalars['String']>;
};

export type OdProtosBuyerServicesBuyer_DocumentRequests_GetDocumentsByOfferIdInput = {
  offerId?: InputMaybe<Scalars['String']>;
};

export type OdProtosBuyerServicesBuyer_DocumentRequests_GetFileUploadUrlInput = {
  filename?: InputMaybe<Scalars['String']>;
};

export type OdProtosBuyerServicesBuyer_HelloSignDocumentRequests_GetHelloSignDocumentsByIdsInput = {
  ids?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosBuyerServicesBuyer_HelloSignDocumentRequests_GetHelloSignDocumentsForCurrentUserInput = {
  limit?: InputMaybe<Scalars['Float']>;
  sortKey?: InputMaybe<OdProtosBuyerServicesBuyer_HelloSignDocumentRequests_GetHelloSignDocumentsForCurrentUser_SortKey>;
  type?: InputMaybe<OdProtosBuyerServicesBuyer_HelloSignDocumentRequests_GetHelloSignDocumentsForCurrentUser_Type>;
};

export type OdProtosBuyerServicesBuyer_HelloSignDocumentRequests_GetHelloSignDocumentsForCurrentUser_SortKey =
  | 'SORT_KEY_CREATED_AT_DESC'
  | 'SORT_KEY_DEFAULT';

export type OdProtosBuyerServicesBuyer_HelloSignDocumentRequests_GetHelloSignDocumentsForCurrentUser_Type =
  | 'OBO_PROGRAM_AGREEMENT_LATEST_VERSION'
  | 'UNKNOWN_TYPE';

export type OdProtosBuyerServicesBuyer_MarketConfigRequests_GetMarketConfigByMarketInput = {
  market?: InputMaybe<OdProtosCommonMarket_Market>;
};

export type OdProtosBuyerServicesBuyer_MarketConfigRequests_GetPostalCodesByMarketInput = {
  market?: InputMaybe<OdProtosCommonMarket_Market>;
};

export type OdProtosBuyerServicesBuyer_OfferRequests_CancelOfferByIdInput = {
  cancelationDescription?: InputMaybe<Scalars['String']>;
  cancelationReason?: InputMaybe<OdProtosBuyerServicesBuyer_OfferRequests_CancelOfferById_CancelationReason>;
  id?: InputMaybe<Scalars['String']>;
};

export type OdProtosBuyerServicesBuyer_OfferRequests_CancelOfferById_CancelationReason =
  | 'BUYER_TEST'
  | 'CANT_DECIDE_PRICE'
  | 'CHOOSE_MY_AGENT'
  | 'NOT_GOOD_EXPERIENCE'
  | 'NO_LONGER_AVAILABLE'
  | 'NO_LONGER_INTERESTED'
  | 'OTHER'
  | 'TOO_MANY_COMPETING'
  | 'UNKNOWN_CANCELATION_REASON';

export type OdProtosBuyerServicesBuyer_OfferRequests_CreateOfferInput = {
  addressId?: InputMaybe<Scalars['String']>;
};

export type OdProtosBuyerServicesBuyer_OfferRequests_GetOfferByIdInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type OdProtosBuyerServicesBuyer_OfferRequests_GetOffersByHumanTokenInput = {
  humanToken?: InputMaybe<Scalars['String']>;
  offerFilters?: InputMaybe<OdProtosBuyerServicesBuyer_OfferRequests_GetOffersByHumanToken_OfferFilters>;
  paginationRequest?: InputMaybe<OdProtosCommonPagination_PaginationRequestInput>;
};

export type OdProtosBuyerServicesBuyer_OfferRequests_GetOffersByHumanToken_OfferFilters =
  | 'ACTIVE'
  | 'ALL'
  | 'INACTIVE';

export type OdProtosBuyerServicesBuyer_OfferRequests_GetOffersByIdsInput = {
  ids?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosBuyerServicesBuyer_OfferRequests_GetOffersForCurrentUserInput = {
  addressIds?: InputMaybe<Array<Scalars['String']>>;
  offerFilters?: InputMaybe<OdProtosBuyerServicesBuyer_OfferRequests_GetOffersForCurrentUser_OfferFilters>;
  paginationRequest?: InputMaybe<OdProtosCommonPagination_PaginationRequestInput>;
};

export type OdProtosBuyerServicesBuyer_OfferRequests_GetOffersForCurrentUser_OfferFilters =
  | 'ACTIVE'
  | 'ALL'
  | 'INACTIVE';

export type OdProtosBuyerServicesBuyer_OfferRequests_SubmitOfferInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type OdProtosBuyerServicesBuyer_OfferRequests_UpdateOfferAgentInput = {
  id?: InputMaybe<Scalars['String']>;
  ownAgent?: InputMaybe<Scalars['Boolean']>;
};

export type OdProtosBuyerServicesBuyer_OfferRequests_UpdateOfferDownPaymentInput = {
  id?: InputMaybe<Scalars['String']>;
  mortgageDownPaymentAmount?: InputMaybe<Scalars['Int']>;
  mortgageDownPaymentBps?: InputMaybe<Scalars['Float']>;
};

export type OdProtosBuyerServicesBuyer_OfferRequests_UpdateOfferFinancingInput = {
  fundingSource?: InputMaybe<OdProtosBuyerServicesBuyer_OfferRequests_UpdateOfferFinancing_FundingSource>;
  id?: InputMaybe<Scalars['String']>;
  loanContingencyDays?: InputMaybe<Scalars['Int']>;
  mortgagePreapproval?: InputMaybe<Scalars['Boolean']>;
  terms?: InputMaybe<Scalars['String']>;
};

export type OdProtosBuyerServicesBuyer_OfferRequests_UpdateOfferFinancing_FundingSource =
  | 'CASH'
  | 'MORTGAGE'
  | 'UNKNOWN_FUNDING_SOURCE';

export type OdProtosBuyerServicesBuyer_OfferRequests_UpdateOfferLenderInput = {
  id?: InputMaybe<Scalars['String']>;
  lenderCompanyName?: InputMaybe<Scalars['String']>;
  lenderEmail?: InputMaybe<Scalars['String']>;
  lenderName?: InputMaybe<Scalars['String']>;
  lenderPhone?: InputMaybe<Scalars['String']>;
};

export type OdProtosBuyerServicesBuyer_OfferRequests_UpdateOfferPriceInput = {
  id?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['Float']>;
  pricingAssistance?: InputMaybe<Scalars['Boolean']>;
};

export type OdProtosBuyerServicesBuyer_PartnerTourRequestRequests_CreatePartnerTourRequestInput = {
  addressId?: InputMaybe<Scalars['String']>;
  timeslot?: InputMaybe<OdProtosCommonBuyer_TimeslotInput>;
};

export type OdProtosBuyerServicesBuyer_PhoneVerificationRequests_CheckVerificationStatusForCurrentUserInput = {
  phoneNumber?: InputMaybe<Scalars['String']>;
};

export type OdProtosBuyerServicesBuyer_PhoneVerificationRequests_SendVerificationCodeInput = {
  phoneNumber?: InputMaybe<Scalars['String']>;
};

export type OdProtosBuyerServicesBuyer_PhoneVerificationRequests_VerifyPhoneInput = {
  phoneNumber?: InputMaybe<Scalars['String']>;
  verificationCode?: InputMaybe<Scalars['String']>;
};

export type OdProtosBuyerServicesBuyer_PricingRequestRequests_GetPricingRequestByIdInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type OdProtosBuyerServicesBuyer_PropertyPhotoRequests_GetPropertyPhotosByAddressIdInput = {
  addressId?: InputMaybe<Scalars['String']>;
};

export type OdProtosBuyerServicesBuyer_PropertyPhotoRequests_GetPropertyPhotosByAddressIdsInput = {
  addressIds?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosBuyerServicesBuyer_PropertyRequests_FavoritePropertyInput = {
  addressId?: InputMaybe<Scalars['String']>;
};

export type OdProtosBuyerServicesBuyer_PropertyRequests_GetAddressIdByPropertyIdInput = {
  propertyId?: InputMaybe<Scalars['String']>;
};

export type OdProtosBuyerServicesBuyer_PropertyRequests_GetFavoritePropertiesForCurrentUserInput = {
  paginationRequest?: InputMaybe<OdProtosCommonPagination_PaginationRequestInput>;
};

export type OdProtosBuyerServicesBuyer_PropertyRequests_GetFeedPropertiesForCurrentUserInput = {
  paginationRequest?: InputMaybe<OdProtosCommonPagination_OffsetPaginationRequestInput>;
  sortKey?: InputMaybe<OdProtosBuyerServicesBuyer_PropertyRequests_GetFeedPropertiesForCurrentUser_SortKey>;
};

export type OdProtosBuyerServicesBuyer_PropertyRequests_GetFeedPropertiesForCurrentUser_SortKey =
  | 'SORT_KEY_DEFAULT'
  | 'SORT_KEY_POPULAR_AT_DESC';

export type OdProtosBuyerServicesBuyer_PropertyRequests_GetHomebuilderDetailsByAddressIdInput = {
  addressId?: InputMaybe<Scalars['String']>;
};

export type OdProtosBuyerServicesBuyer_PropertyRequests_GetHomebuilderPropertiesByCommunityInput = {
  builderName?: InputMaybe<Scalars['String']>;
  communityId?: InputMaybe<Scalars['String']>;
};

export type OdProtosBuyerServicesBuyer_PropertyRequests_GetIsFavoritePropertyByAddressIdsInput = {
  addressIds?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosBuyerServicesBuyer_PropertyRequests_GetIsFavoritePropertyByIdsInput = {
  propertyIds?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosBuyerServicesBuyer_PropertyRequests_GetMlsListingAgentByAddressIdInput = {
  addressId?: InputMaybe<Scalars['String']>;
};

export type OdProtosBuyerServicesBuyer_PropertyRequests_GetOpenHousesForPropertiesInput = {
  addressIds?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosBuyerServicesBuyer_PropertyRequests_GetPropertiesByAddressIdsInput = {
  addressIds?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosBuyerServicesBuyer_PropertyRequests_GetPropertiesByGeometryInput = {
  /** If specified, filter criteria will be applied to limit the search results */
  filters?: InputMaybe<OdProtosBuyerServicesBuyer_PropertyRequests_PropertyFiltersInput>;
  paginationRequest?: InputMaybe<OdProtosCommonPagination_OffsetPaginationRequestInput>;
  /** GeoJSON shape (must be polygon or multipolygon) */
  shape?: InputMaybe<Scalars['String']>;
  sortKey?: InputMaybe<OdProtosBuyerServicesBuyer_PropertyRequests_SortKey>;
};

export type OdProtosBuyerServicesBuyer_PropertyRequests_GetPropertiesByIdsInput = {
  ids?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosBuyerServicesBuyer_PropertyRequests_GetPropertiesByTextQueryInput = {
  limit?: InputMaybe<Scalars['Float']>;
  location?: InputMaybe<OdProtosBuyerServicesBuyer_PropertyRequests_GetPropertiesByTextQuery_LocationInput>;
  queryString?: InputMaybe<Scalars['String']>;
};

export type OdProtosBuyerServicesBuyer_PropertyRequests_GetPropertiesByTextQuery_LocationInput = {
  latitude?: InputMaybe<Scalars['Float']>;
  longitude?: InputMaybe<Scalars['Float']>;
};

export type OdProtosBuyerServicesBuyer_PropertyRequests_GetPropertiesStatsByMarketInput = {
  market?: InputMaybe<OdProtosCommonMarket_Market>;
};

export type OdProtosBuyerServicesBuyer_PropertyRequests_GetPropertiesStatsForPropertiesFilterInput = {
  feedPropertiesFilter?: InputMaybe<OdProtosBuyerData_User_FeedPropertiesFilterInput>;
  /** DEPRECATED: Use feed_properties_filter */
  propertiesFilter?: InputMaybe<OdProtosBuyerData_User_PropertiesFilterInput>;
};

export type OdProtosBuyerServicesBuyer_PropertyRequests_GetPropertyByAddressIdInput = {
  addressId?: InputMaybe<Scalars['String']>;
};

export type OdProtosBuyerServicesBuyer_PropertyRequests_GetPropertyByIdInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type OdProtosBuyerServicesBuyer_PropertyRequests_GetPropertyByParamsIdInput = {
  paramsId?: InputMaybe<Scalars['String']>;
};

export type OdProtosBuyerServicesBuyer_PropertyRequests_GetPropertyCompsByAddressIdInput = {
  addressId?: InputMaybe<Scalars['String']>;
};

export type OdProtosBuyerServicesBuyer_PropertyRequests_GetPropertyMarkersByGeometryInput = {
  /** If specified, filter criteria will be applied to limit the search results */
  filters?: InputMaybe<OdProtosBuyerServicesBuyer_PropertyRequests_PropertyFiltersInput>;
  /** GeoJSON shape (must be polygon or multipolygon) */
  shape?: InputMaybe<Scalars['String']>;
  sortKey?: InputMaybe<OdProtosBuyerServicesBuyer_PropertyRequests_SortKey>;
};

export type OdProtosBuyerServicesBuyer_PropertyRequests_GetSimilarPropertiesByAddressIdInput = {
  addressId?: InputMaybe<Scalars['String']>;
};

/** Used for GetPropertiesByGeometry and GetPropertyMarkersByGeometry */
export type OdProtosBuyerServicesBuyer_PropertyRequests_MinMaxFilterInput = {
  max?: InputMaybe<Scalars['Float']>;
  min?: InputMaybe<Scalars['Float']>;
};

/** Used for GetPropertiesByGeometry and GetPropertyMarkersByGeometry */
export type OdProtosBuyerServicesBuyer_PropertyRequests_MinMaxFloatFilterInput = {
  max?: InputMaybe<Scalars['Float']>;
  min?: InputMaybe<Scalars['Float']>;
};

/** Used for GetPropertiesByGeometry and GetPropertyMarkersByGeometry */
export type OdProtosBuyerServicesBuyer_PropertyRequests_PropertyFiltersInput = {
  /** Only min value is used for bathrooms */
  bathroomsTotal?: InputMaybe<OdProtosBuyerServicesBuyer_PropertyRequests_MinMaxFloatFilterInput>;
  /** Only min value is used for bedrooms */
  bedrooms?: InputMaybe<OdProtosBuyerServicesBuyer_PropertyRequests_MinMaxFilterInput>;
  currentListPrice?: InputMaybe<OdProtosBuyerServicesBuyer_PropertyRequests_MinMaxFilterInput>;
  dwellingTypes?: InputMaybe<Array<OdProtosBuyerData_Property_PropertyType>>;
  hasPool?: InputMaybe<Scalars['Boolean']>;
  isFhaEligible?: InputMaybe<Scalars['Boolean']>;
  isOpendoorBackedOfferEligible?: InputMaybe<Scalars['Boolean']>;
  isOpendoorOwned?: InputMaybe<Scalars['Boolean']>;
  isSingleStory?: InputMaybe<Scalars['Boolean']>;
  lotSqFt?: InputMaybe<OdProtosBuyerServicesBuyer_PropertyRequests_MinMaxFilterInput>;
  /** Only max value is used for monthly hoa dues */
  monthlyHoaDues?: InputMaybe<OdProtosBuyerServicesBuyer_PropertyRequests_MinMaxFilterInput>;
  onlyHomebuilder?: InputMaybe<Scalars['Boolean']>;
  onlyInstantTourable?: InputMaybe<Scalars['Boolean']>;
  totalLivingSqFt?: InputMaybe<OdProtosBuyerServicesBuyer_PropertyRequests_MinMaxFilterInput>;
  yearBuilt?: InputMaybe<OdProtosBuyerServicesBuyer_PropertyRequests_MinMaxFilterInput>;
};

export type OdProtosBuyerServicesBuyer_PropertyRequests_RemoveFavoritePropertyInput = {
  addressId?: InputMaybe<Scalars['String']>;
};

/** Used for GetPropertiesByGeometry and GetPropertyMarkersByGeometry */
export type OdProtosBuyerServicesBuyer_PropertyRequests_SortKey =
  | 'SORT_KEY_CURRENT_LIST_PRICE_ASC'
  | 'SORT_KEY_CURRENT_LIST_PRICE_DESC'
  | 'SORT_KEY_DEFAULT'
  | 'SORT_KEY_LISTED_AT_ASC'
  | 'SORT_KEY_LISTED_AT_DESC'
  | 'SORT_KEY_TOTAL_LIVING_SQ_FT_ASC'
  | 'SORT_KEY_TOTAL_LIVING_SQ_FT_DESC';

export type OdProtosBuyerServicesBuyer_RatingRequests_GetRatingDetailsByIdInput = {
  /** BSON::ObjectId of the rating */
  id?: InputMaybe<Scalars['String']>;
};

export type OdProtosBuyerServicesBuyer_RatingRequests_GetRatingsByAgentIdInput = {
  /** BSON::ObjectId of the agent */
  agentId?: InputMaybe<Scalars['String']>;
  paginationRequest?: InputMaybe<OdProtosCommonPagination_PaginationRequestInput>;
};

export type OdProtosBuyerServicesBuyer_ShowingRequestRequests_CancelShowingRequestInput = {
  id?: InputMaybe<Scalars['String']>;
  inactiveReason?: InputMaybe<OdProtosBuyerData_ShowingRequest_InactiveReason>;
};

export type OdProtosBuyerServicesBuyer_ShowingRequestRequests_CreateShowingRequestInput = {
  addressId?: InputMaybe<Scalars['String']>;
  odPhoneVerified?: InputMaybe<Scalars['Boolean']>;
  openCallEligible?: InputMaybe<Scalars['Boolean']>;
  phone?: InputMaybe<Scalars['String']>;
  timeslots?: InputMaybe<Array<OdProtosCommonBuyer_TimeslotInput>>;
  tourId?: InputMaybe<Scalars['String']>;
  trialTour?: InputMaybe<Scalars['Boolean']>;
  virtual?: InputMaybe<Scalars['Boolean']>;
  virtualContact?: InputMaybe<Scalars['String']>;
  virtualPlatform?: InputMaybe<OdProtosBuyerData_ShowingRequest_VirtualPlatform>;
};

export type OdProtosBuyerServicesBuyer_ShowingRequestRequests_GetShowingRequestByIdInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type OdProtosBuyerServicesBuyer_ShowingRequestRequests_GetShowingRequestOperationalDataByAddressIdInput = {
  addressId?: InputMaybe<Scalars['String']>;
};

export type OdProtosBuyerServicesBuyer_ShowingRequestRequests_GetShowingRequestsByIdsInput = {
  ids?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosBuyerServicesBuyer_ShowingRequestRequests_GetShowingRequestsByTourIdsInput = {
  tourIds?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosBuyerServicesBuyer_ShowingRequestRequests_GetShowingRequestsForCurrentUserInput = {
  paginationRequest?: InputMaybe<OdProtosCommonPagination_PaginationRequestInput>;
  showingRequestFilter?: InputMaybe<OdProtosBuyerServicesBuyer_ShowingRequestRequests_GetShowingRequestsForCurrentUser_ShowingRequestFilter>;
};

export type OdProtosBuyerServicesBuyer_ShowingRequestRequests_GetShowingRequestsForCurrentUser_ShowingRequestFilter =
  | 'ACTIVE'
  | 'ALL'
  | 'INACTIVE';

export type OdProtosBuyerServicesBuyer_TaskRequests_GetTaskByIdInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type OdProtosBuyerServicesBuyer_TaskRequests_GetTasksByIdsInput = {
  ids?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosBuyerServicesBuyer_TaskRequests_GetTasksByOfferIdInput = {
  offerId?: InputMaybe<Scalars['String']>;
};

export type OdProtosBuyerServicesBuyer_TaskRequests_UpdateTaskStatusInput = {
  id?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<OdProtosBuyerServicesBuyer_TaskRequests_UpdateTaskStatus_Status>;
};

export type OdProtosBuyerServicesBuyer_TaskRequests_UpdateTaskStatus_Status =
  | 'CANCELED'
  | 'COMPLETED'
  | 'UNKNOWN_STATUS';

export type OdProtosBuyerServicesBuyer_TourRequests_CancelTourInput = {
  cancelationReason?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
};

export type OdProtosBuyerServicesBuyer_TourRequests_GetTourByIdInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type OdProtosBuyerServicesBuyer_TourRequests_GetTourDetailsByIdInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type OdProtosBuyerServicesBuyer_TourRequests_GetToursByIdsInput = {
  ids?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosBuyerServicesBuyer_TourRequests_GetToursForCurrentUserInput = {
  paginationRequest?: InputMaybe<OdProtosCommonPagination_PaginationRequestInput>;
  tourFilter?: InputMaybe<OdProtosBuyerServicesBuyer_TourRequests_GetToursForCurrentUser_TourFilter>;
};

export type OdProtosBuyerServicesBuyer_TourRequests_GetToursForCurrentUser_TourFilter =
  | 'ALL'
  | 'FUTURE'
  | 'NEEDS_FOLLOWUP'
  | 'PAST';

export type OdProtosBuyerServicesBuyer_TourRequests_UpdateTourTimeslotInput = {
  id?: InputMaybe<Scalars['String']>;
  timeslot?: InputMaybe<OdProtosCommonBuyer_TimeslotInput>;
};

export type OdProtosBuyerServicesBuyer_UserRequests_GetCurrentUserInput = {
  _empty?: InputMaybe<Scalars['Boolean']>;
};

export type OdProtosBuyerServicesBuyer_UserRequests_GetUserByHumanTokenInput = {
  humanToken?: InputMaybe<Scalars['String']>;
};

export type OdProtosBuyerServicesBuyer_UserRequests_GetUserByIdInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type OdProtosBuyerServicesBuyer_UserRequests_GetUsersByIdsInput = {
  ids?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosBuyerServicesBuyer_UserRequests_UpdateUserBuyingPowerInput = {
  annualHouseholdIncome?: InputMaybe<Scalars['Float']>;
  creditScoreIndicated?: InputMaybe<OdProtosBuyerData_User_CreditRating>;
  downPaymentAmount?: InputMaybe<Scalars['Float']>;
  monthlyDebt?: InputMaybe<Scalars['Float']>;
};

export type OdProtosBuyerServicesBuyer_UserRequests_UpdateUserContactInfoInput = {
  email?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
};

export type OdProtosBuyerServicesBuyer_UserRequests_UpdateUserFinancingInput = {
  attribution?: InputMaybe<OdProtosCommonBuyer_AttributionInput>;
  ownLender?: InputMaybe<Scalars['Boolean']>;
};

export type OdProtosBuyerServicesBuyer_UserRequests_UpdateUserHubBaseRouteInput = {
  hubBaseRoute?: InputMaybe<Scalars['String']>;
};

export type OdProtosBuyerServicesBuyer_UserRequests_UpdateUserLearnMoreRequestedInput = {
  learnMoreRequested?: InputMaybe<Scalars['Boolean']>;
};

export type OdProtosBuyerServicesBuyer_UserRequests_UpdateUserMarketIdentifierInput = {
  marketIdentifier?: InputMaybe<OdProtosCommonMarket_Market>;
};

export type OdProtosBuyerServicesBuyer_UserRequests_UpdateUserPropertiesFilterForCurrentUserInput = {
  feedPropertiesFilter?: InputMaybe<OdProtosBuyerData_User_FeedPropertiesFilterInput>;
  /** DEPRECATED: Use feed_properties_filter */
  propertiesFilter?: InputMaybe<OdProtosBuyerData_User_PropertiesFilterInput>;
};

export type OdProtosBuyerServicesBuyer_ViewingAppointmentRequests_GetViewingAppointmentByIdInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type OdProtosBuyerServicesBuyer_ViewingAppointmentRequests_GetViewingAppointmentsByIdsInput = {
  ids?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosBuyerServicesBuyer_VisitRequests_GetVisitByIdInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type OdProtosBuyerServicesBuyer_VisitRequests_GetVisitsByIdsInput = {
  ids?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosBuyerServicesBuyer_VisitRequests_GetVisitsForCurrentUserInput = {
  addressIds?: InputMaybe<Array<Scalars['String']>>;
  paginationRequest?: InputMaybe<OdProtosCommonPagination_PaginationRequestInput>;
};

export type OdProtosBuyerServicesBuyer_ZoneRequests_GetZoneSuggestionsByGdsZoneIdsInput = {
  forAutoFeedSetup?: InputMaybe<Scalars['Boolean']>;
  gdsZoneIds?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosBuyerServicesBuyer_ZoneRequests_GetZonesByTextQueryInput = {
  limit?: InputMaybe<Scalars['Float']>;
  queryString?: InputMaybe<Scalars['String']>;
};

export type OdProtosBuyerV2Data_PropertyType =
  | 'PROPERTY_TYPE_CONDO'
  | 'PROPERTY_TYPE_HOME'
  | 'PROPERTY_TYPE_TOWNHOME'
  | 'PROPERTY_TYPE_UNKNOWN';

export type OdProtosBuyerV2Data_Reaction =
  | 'REACTION_DISLIKE'
  | 'REACTION_LIKE'
  | 'REACTION_UNKNOWN';

export type OdProtosBuyerV2Data_ReactionSource =
  | 'REACTION_SOURCE_AVAILABLE_SOON_SIGNAGE_EMAIL_UPDATES'
  | 'REACTION_SOURCE_GALLERY'
  /** deprecated */
  | 'REACTION_SOURCE_SAVED_HOMES_FAVORITE'
  | 'REACTION_SOURCE_SELF_UNLOCK_GET_EMAIL_UPDATES'
  | 'REACTION_SOURCE_SELF_UNLOCK_SWIPE'
  | 'REACTION_SOURCE_UNKNOWN'
  /** deprecated in favor of more specific sources */
  | 'REACTION_SOURCE_WEB_PDP'
  | 'REACTION_SOURCE_WEB_PDP_ADD_TOUR_REQUEST_TO_CART'
  /** deprecated */
  | 'REACTION_SOURCE_WEB_PDP_BUYER_DRIVEN_SUPPLY_INTERESTED_IN_TOURING'
  /** deprecated */
  | 'REACTION_SOURCE_WEB_PDP_BUYER_DRIVEN_SUPPLY_START_AN_OFFER'
  | 'REACTION_SOURCE_WEB_PDP_EMAIL_UPDATES'
  | 'REACTION_SOURCE_WEB_PDP_FAVORITE'
  | 'REACTION_SOURCE_WEB_PDP_OFFER'
  | 'REACTION_SOURCE_WEB_PDP_SELF_TOUR'
  /** deprecated */
  | 'REACTION_SOURCE_WEB_PDP_SELLER_DISCLOSURE_REQUEST'
  | 'REACTION_SOURCE_WEB_PDP_TOUR_REQUEST';

/**
 * User-defined search criteria for the properties they're looking for. This is
 * used for the feed, and map.
 *
 * Boolean values should be named with an "Only" suffix so that false values
 * aren't ambiguous with "don't apply this filter" vs "exclude things matching
 * this" (which is never the case).
 *
 * Saved Search was formerly known as Property Filters in the now deprecated
 * version of the "buyer" service. This replaces the PropertyFilters and
 * FeedPropertyFilters defined in user.proto
 */
export type OdProtosBuyerV2Data_SavedSearchInput = {
  bathrooms?: InputMaybe<OdProtosCommon_FloatRangeInput>;
  bedrooms?: InputMaybe<OdProtosCommon_UInt32RangeInput>;
  fhaEligibleOnly?: InputMaybe<Scalars['Boolean']>;
  hasPoolOnly?: InputMaybe<Scalars['Boolean']>;
  /** The unique identifier for the SavedSearch */
  id?: InputMaybe<Scalars['String']>;
  lotSqft?: InputMaybe<OdProtosCommon_UInt32RangeInput>;
  maxMonthlyHoaFee?: InputMaybe<OdProtosCommon_MoneyInput>;
  /** The customer-facing name for the SavedSearch */
  name?: InputMaybe<Scalars['String']>;
  opendoorOwnedOnly?: InputMaybe<Scalars['Boolean']>;
  /** The reason that the SavedSearch was created */
  origin?: InputMaybe<OdProtosBuyerV2Data_SearchOrigin>;
  price?: InputMaybe<OdProtosCommon_MoneyRangeInput>;
  propertyTypes?: InputMaybe<Array<OdProtosBuyerV2Data_PropertyType>>;
  selfTourableOnly?: InputMaybe<Scalars['Boolean']>;
  singleStoryOnly?: InputMaybe<Scalars['Boolean']>;
  sqft?: InputMaybe<OdProtosCommon_UInt32RangeInput>;
  yearBuilt?: InputMaybe<OdProtosCommon_UInt32RangeInput>;
  zoneIds?: InputMaybe<Array<Scalars['String']>>;
};

/** SearchOrigin enumerates the entities who can create Buyer's saved searches. */
export type OdProtosBuyerV2Data_SearchOrigin =
  /** The Buyer directly created the SaveSearch */
  | 'SEARCH_ORIGIN_BUYER'
  /** The SavedSearch was created for the Buyer by their buying agent */
  | 'SEARCH_ORIGIN_BUYERS_AGENT'
  | 'SEARCH_ORIGIN_UNKNOWN';

export type OdProtosBuyerV2ServicesBuyer_AddSavedSearchRequestInput = {
  customerId?: InputMaybe<Scalars['String']>;
  savedSearch?: InputMaybe<OdProtosBuyerV2Data_SavedSearchInput>;
};

/**
 * Specify a time range to get the number of times a buyer liked a home
 * within that time range.
 */
export type OdProtosBuyerV2ServicesBuyer_AddressReactionCountsForTimeRangeRequestInput = {
  endTime?: InputMaybe<Scalars['DateTime']>;
  reactionType?: InputMaybe<OdProtosBuyerV2Data_Reaction>;
  startTime?: InputMaybe<Scalars['DateTime']>;
};

export type OdProtosBuyerV2ServicesBuyer_FindBuyersByPropertyReactionRequestInput = {
  addressId?: InputMaybe<Scalars['String']>;
  /** only return buyers whose reacted after this timestamp */
  reactedAfter?: InputMaybe<Scalars['DateTime']>;
  reaction?: InputMaybe<OdProtosBuyerV2Data_Reaction>;
};

export type OdProtosBuyerV2ServicesBuyer_FindBuyersBySavedSearchesRequestInput = {
  bathrooms?: InputMaybe<OdProtosCommon_FloatRangeInput>;
  bedrooms?: InputMaybe<OdProtosCommon_UInt32RangeInput>;
  /** must be > 0 */
  limit?: InputMaybe<Scalars['Float']>;
  lotSqft?: InputMaybe<OdProtosCommon_UInt32RangeInput>;
  price?: InputMaybe<OdProtosCommon_MoneyRangeInput>;
  /** required */
  propertyType?: InputMaybe<OdProtosBuyerV2Data_PropertyType>;
  sqft?: InputMaybe<OdProtosCommon_UInt32RangeInput>;
  yearBuilt?: InputMaybe<OdProtosCommon_UInt32RangeInput>;
  /** required */
  zoneIds?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosBuyerV2ServicesBuyer_GetBuyerRequestInput = {
  customerId?: InputMaybe<Scalars['String']>;
};

export type OdProtosBuyerV2ServicesBuyer_GetBuyersByAgentIdRequestInput = {
  agentId?: InputMaybe<Scalars['String']>;
};

export type OdProtosBuyerV2ServicesBuyer_GetBuyersWithAgentsRequestInput = {
  _empty?: InputMaybe<Scalars['Boolean']>;
};

export type OdProtosBuyerV2ServicesBuyer_GetPropertyReactionsByCustomerIdRequestInput = {
  customerId?: InputMaybe<Scalars['String']>;
  reaction?: InputMaybe<OdProtosBuyerV2Data_Reaction>;
};

export type OdProtosBuyerV2ServicesBuyer_OverrideBuyerTimestampsRequestInput = {
  /** the web customer id */
  customerId?: InputMaybe<Scalars['String']>;
  force?: InputMaybe<Scalars['Boolean']>;
  /** the timestamp the buyer was created in OLA */
  olaBuyerCreatedAt?: InputMaybe<Scalars['DateTime']>;
  /** the timestamp the filter was updated in OLA */
  olaPropertyFilterUpdatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type OdProtosBuyerV2ServicesBuyer_RemoveAgentIdRequestInput = {
  customerId?: InputMaybe<Scalars['String']>;
};

export type OdProtosBuyerV2ServicesBuyer_RemovePropertyReactionRequestInput = {
  addressId?: InputMaybe<Scalars['String']>;
  customerId?: InputMaybe<Scalars['String']>;
};

export type OdProtosBuyerV2ServicesBuyer_RemoveSavedSearchRequestInput = {
  customerId?: InputMaybe<Scalars['String']>;
  savedSearchId?: InputMaybe<Scalars['String']>;
};

export type OdProtosBuyerV2ServicesBuyer_SetAgentIdRequestInput = {
  agentId?: InputMaybe<Scalars['String']>;
  customerId?: InputMaybe<Scalars['String']>;
};

export type OdProtosBuyerV2ServicesBuyer_SetPropertyReactionRequestInput = {
  addressId?: InputMaybe<Scalars['String']>;
  customerId?: InputMaybe<Scalars['String']>;
  reaction?: InputMaybe<OdProtosBuyerV2Data_Reaction>;
  source?: InputMaybe<OdProtosBuyerV2Data_ReactionSource>;
};

export type OdProtosBuyerV2ServicesBuyer_SetSavedSearchRequestInput = {
  customerId?: InputMaybe<Scalars['String']>;
  savedSearch?: InputMaybe<OdProtosBuyerV2Data_SavedSearchInput>;
};

export type OdProtosBuyerV2ServicesBuyer_SetSelectedMarketRequestInput = {
  customerId?: InputMaybe<Scalars['String']>;
  market?: InputMaybe<OdProtosCommonMarket_Market>;
};

export type OdProtosBuyerV2ServicesBuyer_UpdateSavedSearchRequestInput = {
  customerId?: InputMaybe<Scalars['String']>;
  savedSearch?: InputMaybe<OdProtosBuyerV2Data_SavedSearchInput>;
};

export type OdProtosCabinetData_AssetInput = {
  attachments?: InputMaybe<Array<OdProtosCabinetData_AttachmentInput>>;
  /** true if the attachments have been loaded for this asset */
  attachmentsLoaded?: InputMaybe<Scalars['Boolean']>;
  fileLocation?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  imageData?: InputMaybe<OdProtosCabinetData_ImageDataInput>;
  mimeType?: InputMaybe<Scalars['String']>;
  /** The immutable name of this asset. May be empty. */
  name?: InputMaybe<Scalars['String']>;
  public?: InputMaybe<Scalars['Boolean']>;
  /** A public URL or a signed URL to access the asset (default validity: 7 days). */
  rawDownloadUrl?: InputMaybe<Scalars['String']>;
  /** The source service name */
  source?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<OdProtosCabinetData_Asset_Type>;
};

export type OdProtosCabinetData_Asset_Type =
  | 'AUDIO'
  | 'DOCUMENT'
  | 'IMAGE'
  /** Error if unknown. Must be specified when creating the asset */
  | 'UNKNOWN'
  | 'VIDEO';

export type OdProtosCabinetData_AttachmentInput = {
  assetId?: InputMaybe<Scalars['String']>;
  /**
   * The major of the attachment.
   * This may be an identifier of an object like "SellRequest#123" | "Address#123"
   */
  major?: InputMaybe<Scalars['String']>;
  /**
   * An additional categorization of the attachment
   * e.g. "seller" | "external" | "internal" etc.
   */
  minor?: InputMaybe<Scalars['String']>;
  /** The source of the attached object. i.e. the host system that owns the attachment */
  source?: InputMaybe<Scalars['String']>;
};

export type OdProtosCabinetData_ImageDataInput = {
  /** Only present if type is `IMAGE` */
  sizedDownloadUrls?: InputMaybe<Array<OdProtosCabinetData_SizedDownloadUrlInput>>;
};

/**
 * Sets the size modifier for photos.
 *
 * If both horizontal size and vertical size is unset, the raw image will be returned
 */
export type OdProtosCabinetData_SizeModifierInput = {
  /** Sets the horizontal size. If blank will be resized proportionally */
  horizontalSize?: InputMaybe<Scalars['Float']>;
  /** The name of the size modifier */
  name?: InputMaybe<Scalars['String']>;
  /** Sets the vertical size. If blank will be resized proportionally */
  verticalSize?: InputMaybe<Scalars['Float']>;
};

export type OdProtosCabinetData_SizedDownloadUrlInput = {
  downloadUrl?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** Attaches assets to an external entity. O(len(ids) * len(attached_to)). */
export type OdProtosCabinetService_AssetRequests_AttachInput = {
  /**
   * The assets to attach to the assets with the ids from `ids`. The
   * `asset_id` fields of the attachments are ignored.
   */
  attachedTo?: InputMaybe<Array<OdProtosCabinetData_AttachmentInput>>;
  /** The assets to attach each of the attachments to. */
  ids?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosCabinetService_AssetRequests_BulkCreateAssetsInput = {
  createAssets?: InputMaybe<Array<OdProtosCabinetService_AssetRequests_CreateAssetInput>>;
};

export type OdProtosCabinetService_AssetRequests_CreateAssetInput = {
  /**
   * The asset type to use.
   * The type you choose will affect the downloading and behaviour of what can be done with the asset
   */
  assetType?: InputMaybe<OdProtosCabinetData_Asset_Type>;
  attachTo?: InputMaybe<Array<OdProtosCabinetData_AttachmentInput>>;
  /** the path of the uploaded file (including prefix) */
  fullPath?: InputMaybe<Scalars['String']>;
  /**
   * For async requests, if a request is marked as high_priority=true
   * the asset will be processed in a faster queue
   */
  highPriority?: InputMaybe<Scalars['Boolean']>;
  /**
   * Optionaly set the UUID for this upload.
   * If not set, a UUID will be issued to you
   */
  id?: InputMaybe<Scalars['String']>;
  /** Returns the asset with sized images, works the same as 'GetAssets' */
  imageSizes?: InputMaybe<Array<OdProtosCabinetData_SizeModifierInput>>;
  /** The immutable name of this asset. May be empty. */
  name?: InputMaybe<Scalars['String']>;
  public?: InputMaybe<Scalars['Boolean']>;
  source?: InputMaybe<Scalars['String']>;
};

export type OdProtosCabinetService_AssetRequests_GetAssetsInput = {
  ids?: InputMaybe<Array<Scalars['String']>>;
  /** Add size modifiers for requesting images */
  imageSizes?: InputMaybe<Array<OdProtosCabinetData_SizeModifierInput>>;
  includeAttachments?: InputMaybe<Scalars['Boolean']>;
  preventAclSync?: InputMaybe<Scalars['Boolean']>;
};

export type OdProtosCabinetService_AssetRequests_GetUploadCredentialsInput = {
  _empty?: InputMaybe<Scalars['Boolean']>;
};

export type OdProtosCabinetService_AssetRequests_GetUploadUrlInput = {
  contentType?: InputMaybe<Scalars['String']>;
};

/** Replaces the underlying file that the asset points to */
export type OdProtosCabinetService_AssetRequests_ReplaceAssetInput = {
  fullPath?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
};

export type OdProtosCabinetService_AssetRequests_SearchInput = {
  attachedTo?: InputMaybe<Array<OdProtosCabinetData_AttachmentInput>>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  imageSizes?: InputMaybe<Array<OdProtosCabinetData_SizeModifierInput>>;
  includeAttachments?: InputMaybe<Scalars['Boolean']>;
  includeTypes?: InputMaybe<Array<OdProtosCabinetData_Asset_Type>>;
  pagination?: InputMaybe<OdProtosCommonPagination_PaginationRequestInput>;
};

/** Next ID: 32 */
export type OdProtosCasaData_AddressInput = {
  censusBlock?: InputMaybe<Scalars['String']>;
  censusTract?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  county?: InputMaybe<Scalars['String']>;
  countyFips?: InputMaybe<Scalars['String']>;
  geoAccuracy?: InputMaybe<OdProtosCasaData_GeoAccuracy>;
  isMissingUnitNumber?: InputMaybe<Scalars['Boolean']>;
  lastLine?: InputMaybe<Scalars['String']>;
  latitude?: InputMaybe<Scalars['Float']>;
  longitude?: InputMaybe<Scalars['Float']>;
  placeName?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  result?: InputMaybe<Array<OdProtosCasaData_Result>>;
  state?: InputMaybe<Scalars['String']>;
  street?: InputMaybe<Scalars['String']>;
  timeZone?: InputMaybe<Scalars['String']>;
  unitNumber?: InputMaybe<Scalars['String']>;
  unitType?: InputMaybe<Scalars['String']>;
  updatedToUuid?: InputMaybe<Scalars['String']>;
  /** UUID identifier for the address. Previously known as address_token. */
  uuid: Scalars['ID'];
  zipPlus4?: InputMaybe<Scalars['String']>;
};

export type OdProtosCasaData_GeoAccuracy =
  | 'GEO_APPROXIMATE'
  | 'GEO_ERROR'
  | 'GEO_ROOFTOP'
  | 'GEO_ROOFTOP_INTERPOLATED'
  | 'GEO_STREET_LEVEL'
  | 'GEO_UNKNOWN';

export type OdProtosCasaData_Result =
  /** The address has been detected as an upcoming area. */
  | 'ADDRESS_COMING_SOON'
  /** The address contains unnecessary sub-premise or other information. */
  | 'ADDRESS_EXTRANEOUS_INPUT'
  /** The address is invalid. */
  | 'ADDRESS_INVALID'
  /** The address has an invalid box number. */
  | 'ADDRESS_INVALID_BOX_NUMBER'
  /** The address has an invalid street number. */
  | 'ADDRESS_INVALID_PREMISE'
  /** The address street is invalid. */
  | 'ADDRESS_INVALID_STREET'
  /** The address has an invalid sub-premise (e.g. suite). */
  | 'ADDRESS_INVALID_SUB_PREMISE'
  /** The address is missing the box number. */
  | 'ADDRESS_MISSING_BOX_NUMBER'
  /** The address is missing a street number. */
  | 'ADDRESS_MISSING_PREMISE'
  /** The address is missing the sub-premise (e.g. suite). */
  | 'ADDRESS_MISSING_SUB_PREMISE'
  /**
   * The address is the "nil" address. This address is used globally as the alias
   * for all bad addresses. The definition of bad address will change over time,
   * but is currently used for completely invalid inputs, e.g. missing the postal
   * code and city/state/country information to locate, or has an obviously invalid
   * input such as a street name that looks like a UUID.
   */
  | 'ADDRESS_NIL'
  /** The address is not "real" (e.g. PO box, military address). */
  | 'ADDRESS_NOT_REAL'
  /** The address is not supported (e.g. overseas). */
  | 'ADDRESS_NOT_SUPPORTED'
  | 'ADDRESS_UNKNOWN'
  /** The address is unoccupied. */
  | 'ADDRESS_VACANT'
  /** The address is completely valid. */
  | 'ADDRESS_VALID'
  /** The address is valid at the street level. */
  | 'ADDRESS_VALID_STREET';

export type OdProtosCasaServices_CasaRequest_BulkManualCreateInput = {
  addresses?: InputMaybe<Array<OdProtosCasaData_AddressInput>>;
  /**
   * Usually Casa requires these to be non-null: street, city, state, postal_code
   * Set AllowIncompleteAddress=true to skip these checks. Used if you don't want Casa to error for any reason.
   */
  allowIncompleteAddress?: InputMaybe<Scalars['Boolean']>;
};

export type OdProtosCasaServices_CasaRequest_CreateAliasInput = {
  editorComments?: InputMaybe<Scalars['String']>;
  /** editor info is not used, will be discarded */
  editorEmail?: InputMaybe<Scalars['String']>;
  updatedToUuid?: InputMaybe<Scalars['String']>;
  uuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosCasaServices_CasaRequest_FindAliasInput = {
  uuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosCasaServices_CasaRequest_FindByFieldsInput = {
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  /** An alternative to specifying city, state, postal code. */
  lastLine?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  street?: InputMaybe<Scalars['String']>;
  unitNumber?: InputMaybe<Scalars['String']>;
  unitType?: InputMaybe<Scalars['String']>;
};

export type OdProtosCasaServices_CasaRequest_FindInput = {
  /** UUID identifier for the address. Previously known as address_token. */
  uuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosCasaServices_CasaRequest_FindReferencesInput = {
  uuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosCasaServices_CasaRequest_FindSignaturesInput = {
  uuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosCasaServices_CasaRequest_GetRestandardizeStateInput = {
  version?: InputMaybe<Scalars['String']>;
};

export type OdProtosCasaServices_CasaRequest_InvalidateSignatureInput = {
  signature?: InputMaybe<Scalars['String']>;
};

export type OdProtosCasaServices_CasaRequest_ListAliasInput = {
  uuid?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosCasaServices_CasaRequest_ListInput = {
  uuids?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosCasaServices_CasaRequest_ListUnitsInput = {
  limit?: InputMaybe<Scalars['Float']>;
  uuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosCasaServices_CasaRequest_ManualCreateInput = {
  address?: InputMaybe<OdProtosCasaData_AddressInput>;
  /**
   * Usually Casa requires these to be non-null: street, city, state, postal_code
   * Set AllowIncompleteAddress=true to skip these checks. Used if you don't want Casa to error for any reason.
   */
  allowIncompleteAddress?: InputMaybe<Scalars['Boolean']>;
};

export type OdProtosCasaServices_CasaRequest_RandomInput = {
  _empty?: InputMaybe<Scalars['Boolean']>;
};

export type OdProtosCasaServices_CasaRequest_RestandardizeInput = {
  skipUpdateEvent?: InputMaybe<Scalars['Boolean']>;
  uuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosCasaServices_CasaRequest_SetRestandardizeStateInput = {
  completed?: InputMaybe<Scalars['Boolean']>;
  uuid?: InputMaybe<Scalars['String']>;
  version?: InputMaybe<Scalars['String']>;
};

export type OdProtosCasaServices_CasaRequest_UuiDsInput = {
  afterUuid?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Float']>;
};

export type OdProtosCasaServices_CasaRequest_UpdateInput = {
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  county?: InputMaybe<Scalars['String']>;
  geoAccuracy?: InputMaybe<OdProtosCasaData_GeoAccuracy>;
  latitude?: InputMaybe<Scalars['Float']>;
  longitude?: InputMaybe<Scalars['Float']>;
  postalCode?: InputMaybe<Scalars['String']>;
  result?: InputMaybe<Array<OdProtosCasaData_Result>>;
  state?: InputMaybe<Scalars['String']>;
  street?: InputMaybe<Scalars['String']>;
  unitNumber?: InputMaybe<Scalars['String']>;
  unitType?: InputMaybe<Scalars['String']>;
  uuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosCasaServices_CasaRequest_UpdateSignatureInput = {
  signature?: InputMaybe<Scalars['String']>;
  updatedToUuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosCaseyV0Data_PermissionsInput = {
  owningBranchId?: InputMaybe<Scalars['String']>;
  /**
   * Empty here means all roles not no roles have access.
   * There is no way to restrict access to no roles.
   */
  rolesWithAccess?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosCaseyV0Data_SlaInput = {
  completedAt?: InputMaybe<Scalars['DateTime']>;
  deadline?: InputMaybe<Scalars['DateTime']>;
  type?: InputMaybe<OdProtosCaseyV0Data_Sla_SlaType>;
};

export type OdProtosCaseyV0Data_Sla_SlaType =
  | 'RESOLUTION';

export type OdProtosCaseyV0Data_SourceInput = {
  id?: InputMaybe<Scalars['String']>;
  /**
   * Use string instead of an enum because we could end up keying out task data on other data models,
   * and we wouldn't want to have to update Casey every time we introduce a new data model.
   * Use lower case, snake case representation of your model's name as the type,
   * e.g. address, offer, valuation, pricing_qa.
   */
  type?: InputMaybe<Scalars['String']>;
};

export type OdProtosCaseyV0Data_StartWorkRequestInput = {
  /** Human/Service starting the task */
  actor?: InputMaybe<OdProtosCaseyV0Data_WorkLog_ActorInput>;
  /** NOW() used if blank */
  startTime?: InputMaybe<Scalars['DateTime']>;
};

export type OdProtosCaseyV0Data_TaskInput = {
  /**
   * The time this task became active. If not set, defaults to time of creation.
   * Example1: we need to run a backfill, that involves deleting and recreating tasks,
   * so the rows will have a created_at time of now, but keep the original activated_at
   * time to refer to when the task was available to be worked on so that our metrics
   * (time to close/time to claim/etc) are still accurate.
   * Example2: a job creates tasks at midnight, but they are not intended to be able to
   * be worked on until 9am, so the activated_at time gets set to 9am, while the created_at
   * time is still midnight. This ensures that we don't have big lags between activated_at and
   * claimed due to the task not being workable until 9am, to maintain accurate metrics.
   */
  activatedAt?: InputMaybe<Scalars['DateTime']>;
  addressIds?: InputMaybe<Array<Scalars['String']>>;
  /**
   * Close code is used to identify why a task is CLOSED.
   * Example: happy path, duplicated task, etc.
   */
  closeCode?: InputMaybe<Scalars['String']>;
  contactIds?: InputMaybe<Array<Scalars['String']>>;
  description?: InputMaybe<Scalars['String']>;
  escalationLevel?: InputMaybe<Scalars['Float']>;
  /**
   * A snapshot of this task input and output when task is CLOSED.
   * for OPEN task: it should be empty.
   * for CLOSED task: it should be consistent with the most recent snapshot in the worklogs.
   */
  finalSnapshot?: InputMaybe<GoogleProtobuf_AnyInput>;
  id?: InputMaybe<Scalars['String']>;
  leadIds?: InputMaybe<Array<Scalars['String']>>;
  offerIds?: InputMaybe<Array<Scalars['String']>>;
  owner?: InputMaybe<OdProtosCaseyV0Data_Task_OwnerInput>;
  permissions?: InputMaybe<OdProtosCaseyV0Data_PermissionsInput>;
  regionIds?: InputMaybe<Array<Scalars['String']>>;
  slas?: InputMaybe<Array<OdProtosCaseyV0Data_SlaInput>>;
  snoozedUntil?: InputMaybe<Scalars['DateTime']>;
  sources?: InputMaybe<Array<OdProtosCaseyV0Data_SourceInput>>;
  status?: InputMaybe<OdProtosCaseyV0Data_Task_Status>;
  tags?: InputMaybe<Array<Scalars['String']>>;
  /**
   * Arbitrary task data.
   * Document the source proto in task_data.type_url
   */
  taskData?: InputMaybe<GoogleProtobuf_AnyInput>;
  taskType?: InputMaybe<Scalars['String']>;
  workLogs?: InputMaybe<Array<OdProtosCaseyV0Data_WorkLogInput>>;
};

export type OdProtosCaseyV0Data_TaskSearchFiltersInput = {
  addressIds?: InputMaybe<Array<Scalars['String']>>;
  contactIds?: InputMaybe<Array<Scalars['String']>>;
  /** Leave empty for including all tasks */
  excludeTasksByActor?: InputMaybe<OdProtosCaseyV0Data_WorkLog_ActorInput>;
  leadIds?: InputMaybe<Array<Scalars['String']>>;
  maxActivatedAt?: InputMaybe<Scalars['DateTime']>;
  maxEscalationLevel?: InputMaybe<Scalars['Int']>;
  minActivatedAt?: InputMaybe<Scalars['DateTime']>;
  minEscalationLevel?: InputMaybe<Scalars['Int']>;
  offerIds?: InputMaybe<Array<Scalars['String']>>;
  /** If true, results will show only tasks that have no owner */
  onlyNilOwner?: InputMaybe<Scalars['Boolean']>;
  /** If true, results will show only tasks that have an owner */
  onlyNotNilOwner?: InputMaybe<Scalars['Boolean']>;
  /** Leave empty for tasks owned by anyone */
  owner?: InputMaybe<OdProtosCaseyV0Data_Task_OwnerInput>;
  owningBranchIds?: InputMaybe<Array<Scalars['String']>>;
  regionIds?: InputMaybe<Array<Scalars['String']>>;
  sla?: InputMaybe<Array<OdProtosCaseyV0Data_TaskSearchFilters_SlaInput>>;
  /** Optional; if unspecified sorting behavior is undefined */
  sorting?: InputMaybe<OdProtosCaseyV0Data_TaskSearchFilters_SortingInput>;
  /**
   * Take the union of sources of the same type and intersection of sources of different types.
   * E.g. if we have the following sources specified:
   * [{id: "A", type: ADDRESS}, {id: "B", type: ADDRESS}, {id: "C", type: Contact}]
   * then we will look up tasks that has (address == "A" || address == "B") && (contact == "C").
   * Note: There cannot be more than 100 source IDs passed for the filter
   */
  sources?: InputMaybe<Array<OdProtosCaseyV0Data_SourceInput>>;
  /** Leave empty for all statuses */
  statuses?: InputMaybe<Array<OdProtosCaseyV0Data_Task_Status>>;
  /**
   * Input a name and value to filter on task data. If you omit the value,
   * you can filter for all tasks where the task_type matches the name.
   */
  taskData?: InputMaybe<GoogleProtobuf_AnyInput>;
  types?: InputMaybe<Array<Scalars['String']>>;
  workLog?: InputMaybe<OdProtosCaseyV0Data_TaskSearchFilters_WorkLogInput>;
};

export type OdProtosCaseyV0Data_TaskSearchFilters_SlaInput = {
  completedAt?: InputMaybe<OdProtosCaseyV0Data_TaskSearchFilters_TimeRestrictionInput>;
  deadlineAt?: InputMaybe<OdProtosCaseyV0Data_TaskSearchFilters_TimeRestrictionInput>;
  /** Deprecated don't use me!!! */
  dueRestrictions?: InputMaybe<OdProtosCaseyV0Data_TaskSearchFilters_Sla_DueRestrictionsOneofInput>;
  type?: InputMaybe<OdProtosCaseyV0Data_Sla_SlaType>;
};

/** DO NOT USE - deprecated */
export type OdProtosCaseyV0Data_TaskSearchFilters_Sla_Due =
  /** this will get converted to time restriction with dueAfter = time.now */
  | 'NOT_DUE'
  /** not valid - must set a restriction if you plan on filtering by SLA */
  | 'NO_FILTER'
  /** this will get converted to time restriction with dueOnOrBefore = time.now */
  | 'OVERDUE';

export type OdProtosCaseyV0Data_TaskSearchFilters_Sla_DueRestrictionsOneofInput = {
  due?: InputMaybe<OdProtosCaseyV0Data_TaskSearchFilters_Sla_Due>;
  timeRestriction?: InputMaybe<OdProtosCaseyV0Data_TaskSearchFilters_Sla_TimeRestrictionInput>;
};

/** DO NOT USE - deprecated */
export type OdProtosCaseyV0Data_TaskSearchFilters_Sla_TimeRestrictionInput = {
  /**
   * Must set either due_after or due_before
   * Tasks without the specified SLA will be excluded
   */
  dueAfter?: InputMaybe<Scalars['DateTime']>;
  dueAtOrBefore?: InputMaybe<Scalars['DateTime']>;
};

export type OdProtosCaseyV0Data_TaskSearchFilters_SortingInput = {
  /** Today we only have singular order by (i.e. no secondary order by column). */
  primarySortingRule?: InputMaybe<OdProtosCaseyV0Data_TaskSearchFilters_Sorting_RuleInput>;
};

export type OdProtosCaseyV0Data_TaskSearchFilters_Sorting_Direction =
  | 'ASCENDING'
  | 'DESCENDING'
  | 'INVALID_DIRECTION';

export type OdProtosCaseyV0Data_TaskSearchFilters_Sorting_Field =
  | 'INVALID_FIELD'
  /**
   * Tasks without RESOLUTION_SLAs will be sorted after tasks with RESOLUTION_SLAs regardless
   * of direection
   *
   * Sorting by RESOLUTION_SLA_RATIO sorts by what percentage of the time from activation to deadline has passed,
   * thus taking into account that tasks that originally had deadlines in the very near future may have worse
   * consequences for missing that deadline by a small amount than those that were long.
   * If this assumption is not true for your use case, this is not the sort for you!
   */
  | 'RESOLUTION_SLA'
  /**
   * Formula: (slas.deadline - current_time) / (slas.deadline - tasks.activated_at)
   * e.g. a task activated 10 hours ago, currently due in 1 hour,
   * is the same ratio as a task activated 10 days ago, currently due in 1 day
   * Overdue example
   * Task A is due 30 minutes ago, and activated 4 hours ago has a ratio ~ -0.14
   * Task B is due 30 minutes ago, and activated 40 hours ago has a ratio of ~ -0.013
   * Task A will sort before Task B since it has the lower ratio
   * (aka it's late by a larger % of the overall time it has been activated)
   */
  | 'RESOLUTION_SLA_RATIO';

export type OdProtosCaseyV0Data_TaskSearchFilters_Sorting_RuleInput = {
  direction?: InputMaybe<OdProtosCaseyV0Data_TaskSearchFilters_Sorting_Direction>;
  field?: InputMaybe<OdProtosCaseyV0Data_TaskSearchFilters_Sorting_Field>;
};

export type OdProtosCaseyV0Data_TaskSearchFilters_TimeRestrictionInput = {
  after?: InputMaybe<Scalars['DateTime']>;
  atOrBefore?: InputMaybe<Scalars['DateTime']>;
};

export type OdProtosCaseyV0Data_TaskSearchFilters_WorkLogInput = {
  inProgress?: InputMaybe<OdProtosCaseyV0Data_TaskSearchFilters_WorkLog_InProgress>;
};

export type OdProtosCaseyV0Data_TaskSearchFilters_WorkLog_InProgress =
  | 'NO_FILTER'
  | 'NO_WORK_IN_PROGRESS'
  | 'WORK_IN_PROGRESS';

export type OdProtosCaseyV0Data_Task_OwnerInput = {
  userId?: InputMaybe<Scalars['String']>;
};

export type OdProtosCaseyV0Data_Task_Status =
  | 'CLOSED'
  | 'OPEN';

export type OdProtosCaseyV0Data_WorkLogInput = {
  actor?: InputMaybe<OdProtosCaseyV0Data_WorkLog_ActorInput>;
  duration?: InputMaybe<GoogleProtobuf_DurationInput>;
  snapshot?: InputMaybe<GoogleProtobuf_AnyInput>;
  startTime?: InputMaybe<Scalars['DateTime']>;
  stopTime?: InputMaybe<Scalars['DateTime']>;
};

export type OdProtosCaseyV0Data_WorkLog_ActorInput = {
  userId?: InputMaybe<Scalars['String']>;
};

export type OdProtosCaseyV0Services_Assign_RequestInput = {
  newOwner?: InputMaybe<OdProtosCaseyV0Data_Task_OwnerInput>;
  taskId?: InputMaybe<Scalars['String']>;
};

export type OdProtosCaseyV0Services_CompleteSla_RequestInput = {
  /** NOW() used if blank */
  completedAt?: InputMaybe<Scalars['DateTime']>;
  slaType?: InputMaybe<OdProtosCaseyV0Data_Sla_SlaType>;
  taskId?: InputMaybe<Scalars['String']>;
};

export type OdProtosCaseyV0Services_Count_RequestInput = {
  filters?: InputMaybe<OdProtosCaseyV0Data_TaskSearchFiltersInput>;
  searchFilters?: InputMaybe<Array<OdProtosCaseyV0Data_TaskSearchFiltersInput>>;
};

export type OdProtosCaseyV0Services_Create_RequestInput = {
  /** If allow duplicates is true tasks with all the same attributes may be created multiple times */
  allowDuplicates?: InputMaybe<Scalars['Boolean']>;
  idempotencyKey?: InputMaybe<Scalars['String']>;
  /** we'll ignore your task.id tho. */
  task?: InputMaybe<OdProtosCaseyV0Data_TaskInput>;
};

export type OdProtosCaseyV0Services_Deescalate_RequestInput = {
  taskId?: InputMaybe<Scalars['String']>;
};

export type OdProtosCaseyV0Services_Escalate_RequestInput = {
  /** A snapshot of the task input and output. */
  snapshot?: InputMaybe<GoogleProtobuf_AnyInput>;
  taskId?: InputMaybe<Scalars['String']>;
};

export type OdProtosCaseyV0Services_FindTask_RequestInput = {
  filters?: InputMaybe<OdProtosCaseyV0Data_TaskSearchFiltersInput>;
  searchFilters?: InputMaybe<Array<OdProtosCaseyV0Data_TaskSearchFiltersInput>>;
};

export type OdProtosCaseyV0Services_GetTaskById_RequestInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type OdProtosCaseyV0Services_ListTasksByIds_RequestInput = {
  ids?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosCaseyV0Services_RelatedObjectInput = {
  objectId?: InputMaybe<Scalars['String']>;
  objectType?: InputMaybe<Scalars['String']>;
};

export type OdProtosCaseyV0Services_SearchAndStart_RequestInput = {
  filters?: InputMaybe<OdProtosCaseyV0Data_TaskSearchFiltersInput>;
  searchFilters?: InputMaybe<Array<OdProtosCaseyV0Data_TaskSearchFiltersInput>>;
  startWorkRequest?: InputMaybe<OdProtosCaseyV0Data_StartWorkRequestInput>;
};

export type OdProtosCaseyV0Services_Search_RequestInput = {
  filters?: InputMaybe<OdProtosCaseyV0Data_TaskSearchFiltersInput>;
  paginationRequest?: InputMaybe<OdProtosCommonPagination_PaginationRequestInput>;
  searchFilters?: InputMaybe<Array<OdProtosCaseyV0Data_TaskSearchFiltersInput>>;
};

export type OdProtosCaseyV0Services_SetSla_RequestInput = {
  newDeadline?: InputMaybe<Scalars['DateTime']>;
  slaType?: InputMaybe<OdProtosCaseyV0Data_Sla_SlaType>;
  taskId?: InputMaybe<Scalars['String']>;
};

export type OdProtosCaseyV0Services_SetStatus_RequestInput = {
  /** set this if you are going to set the task to CLOSED. */
  closeCode?: InputMaybe<Scalars['String']>;
  /**
   * set this if you want to set a new status
   * conditional on the current status matching
   */
  expectedCurrentStatus?: InputMaybe<OdProtosCaseyV0Services_SetStatus_Request_ExpectedCurrentStatusInput>;
  newStatus?: InputMaybe<OdProtosCaseyV0Data_Task_Status>;
  /** A snapshot of the task input and output. */
  snapshot?: InputMaybe<GoogleProtobuf_AnyInput>;
  taskId?: InputMaybe<Scalars['String']>;
};

export type OdProtosCaseyV0Services_SetStatus_Request_ExpectedCurrentStatusInput = {
  status?: InputMaybe<OdProtosCaseyV0Data_Task_Status>;
};

export type OdProtosCaseyV0Services_Snooze_RequestInput = {
  /** unsnoozed if blank */
  newSnoozedUntil?: InputMaybe<OdProtosCaseyV0Services_Task_TimeInput>;
  taskId?: InputMaybe<Scalars['String']>;
};

export type OdProtosCaseyV0Services_StartWork_RequestInput = {
  startWorkRequest?: InputMaybe<OdProtosCaseyV0Data_StartWorkRequestInput>;
  taskId?: InputMaybe<Scalars['String']>;
};

export type OdProtosCaseyV0Services_Task_TimeInput = {
  time?: InputMaybe<OdProtosCaseyV0Services_Task_Time_TimeOneofInput>;
};

export type OdProtosCaseyV0Services_Task_Time_TimeOneofInput = {
  exactTime?: InputMaybe<Scalars['DateTime']>;
};

export type OdProtosCaseyV0Services_UpdateFields_RequestInput = {
  sources?: InputMaybe<Array<OdProtosCaseyV0Data_SourceInput>>;
  /** usually for migrating from one task data type to another, do not use this in any usual cases or automated flows */
  taskData?: InputMaybe<GoogleProtobuf_AnyInput>;
  taskId?: InputMaybe<Scalars['String']>;
};

export type OdProtosCaseyV0Services_UpdateRelatedObjectReference_RequestInput = {
  fromObjectId?: InputMaybe<Scalars['String']>;
  objectType?: InputMaybe<Scalars['String']>;
  searchBy?: InputMaybe<OdProtosCaseyV0Services_UpdateRelatedObjectReference_Request_SearchByOneofInput>;
  toObjectId?: InputMaybe<Scalars['String']>;
};

export type OdProtosCaseyV0Services_UpdateRelatedObjectReference_Request_SearchByOneofInput = {
  relatedObject?: InputMaybe<OdProtosCaseyV0Services_RelatedObjectInput>;
  taskId?: InputMaybe<Scalars['String']>;
};

export type OdProtosCaseyV1Data_PermissionsInput = {
  owningBranchId?: InputMaybe<Scalars['String']>;
  /**
   * Empty here means all roles not no roles have access.
   * There is no way to restrict access to no roles.
   */
  rolesWithAccess?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosCaseyV1Data_SlaInput = {
  completedAt?: InputMaybe<Scalars['DateTime']>;
  deadline?: InputMaybe<Scalars['DateTime']>;
  type?: InputMaybe<OdProtosCaseyV1Data_Sla_SlaType>;
};

export type OdProtosCaseyV1Data_Sla_SlaType =
  | 'RESOLUTION';

export type OdProtosCaseyV1Data_SourceInput = {
  id?: InputMaybe<Scalars['String']>;
  /**
   * Use string instead of an enum because we could end up keying out task data on other data models,
   * and we wouldn't want to have to update Casey every time we introduce a new data model.
   * Use lower case, snake case representation of your model's name as the type,
   * e.g. address, offer, valuation, pricing_qa.
   */
  type?: InputMaybe<Scalars['String']>;
};

export type OdProtosCaseyV1Data_StartWorkRequestInput = {
  /** Human/Service starting the task */
  actor?: InputMaybe<OdProtosCaseyV1Data_WorkLog_ActorInput>;
  /** NOW() used if blank */
  startTime?: InputMaybe<Scalars['DateTime']>;
};

export type OdProtosCaseyV1Data_TaskInput = {
  /**
   * The time this task became active. If not set, defaults to time of creation.
   * Example1: we need to run a backfill, that involves deleting and recreating tasks,
   * so the rows will have a created_at time of now, but keep the original activated_at
   * time to refer to when the task was available to be worked on so that our metrics
   * (time to close/time to claim/etc) are still accurate.
   * Example2: a job creates tasks at midnight, but they are not intended to be able to
   * be worked on until 9am, so the activated_at time gets set to 9am, while the created_at
   * time is still midnight. This ensures that we don't have big lags between activated_at and
   * claimed due to the task not being workable until 9am, to maintain accurate metrics.
   */
  activatedAt?: InputMaybe<Scalars['DateTime']>;
  /** Hydrated fields for easy access and for graphql foreign entity reference (will be deprecated) */
  addressIds?: InputMaybe<Array<Scalars['String']>>;
  canceledAt?: InputMaybe<Scalars['DateTime']>;
  childTasks?: InputMaybe<Array<OdProtosCaseyV1Data_Task_TaskDependencyInput>>;
  /**
   * Close code is used to identify why a task is CLOSED.
   * Example: happy path, duplicated task, etc.
   */
  closeCode?: InputMaybe<Scalars['String']>;
  closingEvents?: InputMaybe<Array<Scalars['String']>>;
  completedAt?: InputMaybe<Scalars['DateTime']>;
  /** To understand how a task was completed (automatically or manually) */
  completionMethod?: InputMaybe<Scalars['String']>;
  contactIds?: InputMaybe<Array<Scalars['String']>>;
  description?: InputMaybe<Scalars['String']>;
  escalationLevel?: InputMaybe<Scalars['Float']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<OdProtosCaseyV1Data_Task_OwnerInput>;
  parentTasks?: InputMaybe<Array<OdProtosCaseyV1Data_Task_TaskDependencyInput>>;
  /** Used to determine who can see the task based on branch and role */
  permissions?: InputMaybe<OdProtosCaseyV1Data_PermissionsInput>;
  /** Fields used in v0 that are not deprecated */
  regionIds?: InputMaybe<Array<Scalars['String']>>;
  /** Used to determine who is responsible for the task and who can see it, ex: acq_tc, resale_cc, etc. */
  responsibilityRole?: InputMaybe<Scalars['String']>;
  slas?: InputMaybe<Array<OdProtosCaseyV1Data_SlaInput>>;
  snoozedUntil?: InputMaybe<Scalars['DateTime']>;
  sources?: InputMaybe<Array<OdProtosCaseyV1Data_SourceInput>>;
  status?: InputMaybe<OdProtosCaseyV1Data_Task_Status>;
  statusReason?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Array<Scalars['String']>>;
  /**
   * Arbitrary task data.
   * Document the source proto in task_data.type_url
   */
  taskData?: InputMaybe<GoogleProtobuf_AnyInput>;
  taskType?: InputMaybe<Scalars['String']>;
  visibilityRoles?: InputMaybe<Array<Scalars['String']>>;
  /**
   * Controls when the task becomes visible in search/list operations.
   * If set to a future time, the task will be hidden from SearchTasks, FindTask, Count, and Search APIs
   * until that time is reached. Tasks can still be retrieved by ID via GetTask and ListTasksByIds.
   * If NULL or not set, the task is immediately visible in all operations.
   */
  visibleAt?: InputMaybe<Scalars['DateTime']>;
  /** Backward reference to web task - will be deprecated once the web task migration is complete */
  webTaskId?: InputMaybe<Scalars['Float']>;
  workLogs?: InputMaybe<Array<OdProtosCaseyV1Data_WorkLogInput>>;
};

export type OdProtosCaseyV1Data_TaskSearchFiltersInput = {
  addressIds?: InputMaybe<Array<Scalars['String']>>;
  contactIds?: InputMaybe<Array<Scalars['String']>>;
  /** Leave empty for including all tasks */
  excludeTasksByActor?: InputMaybe<OdProtosCaseyV1Data_WorkLog_ActorInput>;
  maxActivatedAt?: InputMaybe<Scalars['DateTime']>;
  maxEscalationLevel?: InputMaybe<Scalars['Int']>;
  minActivatedAt?: InputMaybe<Scalars['DateTime']>;
  minEscalationLevel?: InputMaybe<Scalars['Int']>;
  /** If true, results will show only tasks that have no owner */
  onlyNilOwner?: InputMaybe<Scalars['Boolean']>;
  /** If true, results will show only tasks that have an owner */
  onlyNotNilOwner?: InputMaybe<Scalars['Boolean']>;
  /** Leave empty for tasks owned by anyone */
  owner?: InputMaybe<OdProtosCaseyV1Data_Task_OwnerInput>;
  owningBranchIds?: InputMaybe<Array<Scalars['String']>>;
  regionIds?: InputMaybe<Array<Scalars['String']>>;
  sla?: InputMaybe<Array<OdProtosCaseyV1Data_TaskSearchFilters_SlaInput>>;
  /** Optional; if unspecified sorting behavior is undefined */
  sorting?: InputMaybe<OdProtosCaseyV1Data_TaskSearchFilters_SortingInput>;
  /**
   * Take the union of sources of the same type and intersection of sources of different types.
   * E.g. if we have the following sources specified:
   * [{id: "A", type: ADDRESS}, {id: "B", type: ADDRESS}, {id: "C", type: Contact}]
   * then we will look up tasks that has (address == "A" || address == "B") && (contact == "C").
   * Note: There cannot be more than 100 source IDs passed for the filter
   */
  sources?: InputMaybe<Array<OdProtosCaseyV1Data_SourceInput>>;
  /** Leave empty for all statuses */
  statuses?: InputMaybe<Array<OdProtosCaseyV1Data_Task_Status>>;
  /**
   * Input a name and value to filter on task data. If you omit the value,
   * you can filter for all tasks where the task_type matches the name.
   */
  taskData?: InputMaybe<GoogleProtobuf_AnyInput>;
  types?: InputMaybe<Array<Scalars['String']>>;
  workLog?: InputMaybe<OdProtosCaseyV1Data_TaskSearchFilters_WorkLogInput>;
};

export type OdProtosCaseyV1Data_TaskSearchFilters_SlaInput = {
  completedAt?: InputMaybe<OdProtosCaseyV1Data_TaskSearchFilters_TimeRestrictionInput>;
  deadlineAt?: InputMaybe<OdProtosCaseyV1Data_TaskSearchFilters_TimeRestrictionInput>;
  type?: InputMaybe<OdProtosCaseyV1Data_Sla_SlaType>;
};

export type OdProtosCaseyV1Data_TaskSearchFilters_SortingInput = {
  /** Today we only have singular order by (i.e. no secondary order by column). */
  primarySortingRule?: InputMaybe<OdProtosCaseyV1Data_TaskSearchFilters_Sorting_RuleInput>;
};

export type OdProtosCaseyV1Data_TaskSearchFilters_Sorting_Direction =
  | 'ASCENDING'
  | 'DESCENDING'
  | 'INVALID_DIRECTION';

export type OdProtosCaseyV1Data_TaskSearchFilters_Sorting_Field =
  | 'INVALID_FIELD'
  /**
   * Tasks without RESOLUTION_SLAs will be sorted after tasks with RESOLUTION_SLAs regardless
   * of direection
   *
   * Sorting by RESOLUTION_SLA_RATIO sorts by what percentage of the time from activation to deadline has passed,
   * thus taking into account that tasks that originally had deadlines in the very near future may have worse
   * consequences for missing that deadline by a small amount than those that were long.
   * If this assumption is not true for your use case, this is not the sort for you!
   */
  | 'RESOLUTION_SLA'
  /**
   * Formula: (slas.deadline - current_time) / (slas.deadline - tasks.activated_at)
   * e.g. a task activated 10 hours ago, currently due in 1 hour,
   * is the same ratio as a task activated 10 days ago, currently due in 1 day
   * Overdue example
   * Task A is due 30 minutes ago, and activated 4 hours ago has a ratio ~ -0.14
   * Task B is due 30 minutes ago, and activated 40 hours ago has a ratio of ~ -0.013
   * Task A will sort before Task B since it has the lower ratio
   * (aka it's late by a larger % of the overall time it has been activated)
   */
  | 'RESOLUTION_SLA_RATIO';

export type OdProtosCaseyV1Data_TaskSearchFilters_Sorting_RuleInput = {
  direction?: InputMaybe<OdProtosCaseyV1Data_TaskSearchFilters_Sorting_Direction>;
  field?: InputMaybe<OdProtosCaseyV1Data_TaskSearchFilters_Sorting_Field>;
};

export type OdProtosCaseyV1Data_TaskSearchFilters_TimeRestrictionInput = {
  after?: InputMaybe<Scalars['DateTime']>;
  atOrBefore?: InputMaybe<Scalars['DateTime']>;
};

export type OdProtosCaseyV1Data_TaskSearchFilters_WorkLogInput = {
  inProgress?: InputMaybe<OdProtosCaseyV1Data_TaskSearchFilters_WorkLog_InProgress>;
};

export type OdProtosCaseyV1Data_TaskSearchFilters_WorkLog_InProgress =
  | 'NO_FILTER'
  | 'NO_WORK_IN_PROGRESS'
  | 'WORK_IN_PROGRESS';

export type OdProtosCaseyV1Data_Task_OwnerInput = {
  userId?: InputMaybe<Scalars['String']>;
};

export type OdProtosCaseyV1Data_Task_Status =
  | 'BLOCKED'
  | 'CANCELED'
  | 'CLOSED'
  | 'IN_PROGRESS'
  | 'OPEN'
  | 'PENDING';

export type OdProtosCaseyV1Data_Task_TaskDependencyInput = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<OdProtosCaseyV1Data_Task_Status>;
  taskType?: InputMaybe<Scalars['String']>;
};

export type OdProtosCaseyV1Data_WorkLogInput = {
  actor?: InputMaybe<OdProtosCaseyV1Data_WorkLog_ActorInput>;
  duration?: InputMaybe<GoogleProtobuf_DurationInput>;
  snapshot?: InputMaybe<GoogleProtobuf_AnyInput>;
  startTime?: InputMaybe<Scalars['DateTime']>;
  stopTime?: InputMaybe<Scalars['DateTime']>;
};

export type OdProtosCaseyV1Data_WorkLog_ActorInput = {
  userId?: InputMaybe<Scalars['String']>;
};

export type OdProtosCaseyV1Services_Assign_RequestInput = {
  newOwner?: InputMaybe<OdProtosCaseyV1Data_Task_OwnerInput>;
  taskId?: InputMaybe<Scalars['String']>;
};

export type OdProtosCaseyV1Services_CancelTask_RequestInput = {
  statusReason?: InputMaybe<Scalars['String']>;
  taskId?: InputMaybe<Scalars['String']>;
};

export type OdProtosCaseyV1Services_ClaimTask_RequestInput = {
  taskId?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type OdProtosCaseyV1Services_CompleteSla_RequestInput = {
  /** NOW() used if blank */
  completedAt?: InputMaybe<Scalars['DateTime']>;
  slaType?: InputMaybe<OdProtosCaseyV1Data_Sla_SlaType>;
  taskId?: InputMaybe<Scalars['String']>;
};

export type OdProtosCaseyV1Services_CompleteTask_RequestInput = {
  closeCode?: InputMaybe<Scalars['String']>;
  completionMethod?: InputMaybe<Scalars['String']>;
  taskId?: InputMaybe<Scalars['String']>;
};

export type OdProtosCaseyV1Services_Count_RequestInput = {
  searchFilters?: InputMaybe<Array<OdProtosCaseyV1Data_TaskSearchFiltersInput>>;
};

export type OdProtosCaseyV1Services_CreateBulkTasks_RequestInput = {
  /**
   * If allow duplicates is true, then tasks with all the same attributes will be allowed to be created multiple times.
   * If allow duplicates is false, then it'll throw an error if there are any duplicate tasks based on the attributes.
   */
  allowDuplicates?: InputMaybe<Scalars['Boolean']>;
  idempotencyKey?: InputMaybe<Scalars['String']>;
  tasks?: InputMaybe<Array<OdProtosCaseyV1Services_CreateBulkTasks_TaskInput>>;
};

export type OdProtosCaseyV1Services_CreateBulkTasks_TaskInput = {
  /** Event type to listen for auto closing from topic "tasks.closing_events" */
  closingEvents?: InputMaybe<Array<Scalars['String']>>;
  /**
   * To create a dependency on another task within the same bulk request. Value is the other task's task_type.
   * Cannot have circular dependency (will result in error).
   */
  dependsOn?: InputMaybe<Array<Scalars['String']>>;
  /** Description of the task. Will be used to display in the UI. */
  description?: InputMaybe<Scalars['String']>;
  /** Name of the task. Will be used to display in the UI. */
  name?: InputMaybe<Scalars['String']>;
  /** Owner of the task. This is optional and can be assigned later. */
  owner?: InputMaybe<OdProtosCaseyV1Data_Task_OwnerInput>;
  /** Permissions for the task. Will be used to determine who can view and complete the task based on branch and role. */
  permissions?: InputMaybe<OdProtosCaseyV1Data_PermissionsInput>;
  /** Optional, used to determine who is responsible for the task. Ex: acq_tc, resale_cc, etc. */
  responsibilityRole?: InputMaybe<Scalars['String']>;
  /** Due date for the task. */
  slas?: InputMaybe<Array<OdProtosCaseyV1Data_SlaInput>>;
  /** Optional, used to snooze the task until a certain time. It's used only at frontend side. No internal logic is attached to it. */
  snoozedUntil?: InputMaybe<Scalars['DateTime']>;
  /**
   * There can be multiple sources attached to a task. Ex: listing, offer, etc.
   * Will be used to enrich the task later and also to identify the tasks by transaction, customer etc.
   */
  sources?: InputMaybe<Array<OdProtosCaseyV1Data_SourceInput>>;
  tags?: InputMaybe<Array<Scalars['String']>>;
  /** Any additional data that needs to be attached to the task. */
  taskData?: InputMaybe<GoogleProtobuf_AnyInput>;
  /**
   * Identifier for the type of task. This is just an arbitrary string and is owned by the task producer.
   * Will be handy to have custom CTAs for different tasks or have custom filters to find tasks for specfic teams etc.
   */
  taskType?: InputMaybe<Scalars['String']>;
  /** Optional, used to determine who can see the task. Ex: acq_tc, resale_cc, etc. */
  visibilityRoles?: InputMaybe<Array<Scalars['String']>>;
  /** Optional, controls when the task becomes visible in search/list operations. */
  visibleAt?: InputMaybe<Scalars['DateTime']>;
  /** Optional, used to trace back the corresponding Web task if available */
  webTaskId?: InputMaybe<Scalars['Float']>;
};

export type OdProtosCaseyV1Services_CreateOrUpdateWebTask_RequestInput = {
  tasks?: InputMaybe<Array<OdProtosCaseyV1Services_CreateOrUpdateWebTask_TaskInput>>;
};

export type OdProtosCaseyV1Services_CreateOrUpdateWebTask_TaskInput = {
  activatedAt?: InputMaybe<Scalars['DateTime']>;
  canceledAt?: InputMaybe<Scalars['DateTime']>;
  closeCode?: InputMaybe<Scalars['String']>;
  closingEvents?: InputMaybe<Array<Scalars['String']>>;
  completedAt?: InputMaybe<Scalars['DateTime']>;
  completionMethod?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<OdProtosCaseyV1Data_Task_OwnerInput>;
  permissions?: InputMaybe<OdProtosCaseyV1Data_PermissionsInput>;
  responsibilityRole?: InputMaybe<Scalars['String']>;
  slas?: InputMaybe<Array<OdProtosCaseyV1Data_SlaInput>>;
  snoozedUntil?: InputMaybe<Scalars['DateTime']>;
  sources?: InputMaybe<Array<OdProtosCaseyV1Data_SourceInput>>;
  status?: InputMaybe<OdProtosCaseyV1Data_Task_Status>;
  tags?: InputMaybe<Array<Scalars['String']>>;
  taskData?: InputMaybe<GoogleProtobuf_AnyInput>;
  taskType?: InputMaybe<Scalars['String']>;
  visibilityRoles?: InputMaybe<Array<Scalars['String']>>;
  /** Optional, used to trace back the corresponding Web task if available */
  webTaskId?: InputMaybe<Scalars['Float']>;
};

export type OdProtosCaseyV1Services_Create_RequestInput = {
  /** If allow duplicates is true tasks with all the same attributes may be created multiple times */
  allowDuplicates?: InputMaybe<Scalars['Boolean']>;
  idempotencyKey?: InputMaybe<Scalars['String']>;
  /** we'll ignore your task.id tho. */
  task?: InputMaybe<OdProtosCaseyV1Data_TaskInput>;
};

export type OdProtosCaseyV1Services_Deescalate_RequestInput = {
  taskId?: InputMaybe<Scalars['String']>;
};

export type OdProtosCaseyV1Services_Escalate_RequestInput = {
  /** A snapshot of the task input and output. */
  snapshot?: InputMaybe<GoogleProtobuf_AnyInput>;
  taskId?: InputMaybe<Scalars['String']>;
};

export type OdProtosCaseyV1Services_FindTask_RequestInput = {
  searchFilters?: InputMaybe<Array<OdProtosCaseyV1Data_TaskSearchFiltersInput>>;
};

export type OdProtosCaseyV1Services_GetTask_RequestInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type OdProtosCaseyV1Services_ListTasksByIds_RequestInput = {
  ids?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosCaseyV1Services_RelatedObjectInput = {
  objectId?: InputMaybe<Scalars['String']>;
  objectType?: InputMaybe<Scalars['String']>;
};

export type OdProtosCaseyV1Services_SearchAndAssign_RequestInput = {
  /** new owner id to be assigned to the tasks */
  newOwner?: InputMaybe<Scalars['String']>;
  /**
   * Filters to find tasks to assign/re-assign. There must be at least one filter set.
   * If the owner filter is set, the new_owner will be updated only if the current owner matches.
   */
  searchFilters?: InputMaybe<OdProtosCaseyV1Data_TaskSearchFiltersInput>;
};

export type OdProtosCaseyV1Services_SearchAndStart_RequestInput = {
  searchFilters?: InputMaybe<Array<OdProtosCaseyV1Data_TaskSearchFiltersInput>>;
  startWorkRequest?: InputMaybe<OdProtosCaseyV1Data_StartWorkRequestInput>;
};

export type OdProtosCaseyV1Services_SearchTasks_RequestInput = {
  filters?: InputMaybe<OdProtosCaseyV1Data_TaskSearchFiltersInput>;
  paginationRequest?: InputMaybe<OdProtosCommonPagination_PaginationRequestInput>;
};

export type OdProtosCaseyV1Services_Search_RequestInput = {
  paginationRequest?: InputMaybe<OdProtosCommonPagination_PaginationRequestInput>;
  searchFilters?: InputMaybe<Array<OdProtosCaseyV1Data_TaskSearchFiltersInput>>;
};

export type OdProtosCaseyV1Services_SetSla_RequestInput = {
  newDeadline?: InputMaybe<Scalars['DateTime']>;
  slaType?: InputMaybe<OdProtosCaseyV1Data_Sla_SlaType>;
  taskId?: InputMaybe<Scalars['String']>;
};

export type OdProtosCaseyV1Services_SetStatus_RequestInput = {
  /** set this if you are going to set the task to CLOSED. */
  closeCode?: InputMaybe<Scalars['String']>;
  /**
   * set this if you want to set a new status
   * conditional on the current status matching
   */
  expectedCurrentStatus?: InputMaybe<OdProtosCaseyV1Services_SetStatus_Request_ExpectedCurrentStatusInput>;
  newStatus?: InputMaybe<OdProtosCaseyV1Data_Task_Status>;
  newStatusReason?: InputMaybe<Scalars['String']>;
  /** A snapshot of the task input and output. */
  snapshot?: InputMaybe<GoogleProtobuf_AnyInput>;
  taskId?: InputMaybe<Scalars['String']>;
};

export type OdProtosCaseyV1Services_SetStatus_Request_ExpectedCurrentStatusInput = {
  status?: InputMaybe<OdProtosCaseyV1Data_Task_Status>;
};

export type OdProtosCaseyV1Services_Snooze_RequestInput = {
  /** unsnoozed if blank */
  newSnoozedUntil?: InputMaybe<OdProtosCaseyV1Services_Task_TimeInput>;
  taskId?: InputMaybe<Scalars['String']>;
};

export type OdProtosCaseyV1Services_StartWork_RequestInput = {
  startWorkRequest?: InputMaybe<OdProtosCaseyV1Data_StartWorkRequestInput>;
  taskId?: InputMaybe<Scalars['String']>;
};

export type OdProtosCaseyV1Services_Task_TimeInput = {
  time?: InputMaybe<OdProtosCaseyV1Services_Task_Time_TimeOneofInput>;
};

export type OdProtosCaseyV1Services_Task_Time_TimeOneofInput = {
  exactTime?: InputMaybe<Scalars['DateTime']>;
};

export type OdProtosCaseyV1Services_UnclaimTask_RequestInput = {
  taskId?: InputMaybe<Scalars['String']>;
};

export type OdProtosCaseyV1Services_UpdateRelatedObjectReference_RequestInput = {
  fromObjectId?: InputMaybe<Scalars['String']>;
  objectType?: InputMaybe<Scalars['String']>;
  searchBy?: InputMaybe<OdProtosCaseyV1Services_UpdateRelatedObjectReference_Request_SearchByOneofInput>;
  toObjectId?: InputMaybe<Scalars['String']>;
};

export type OdProtosCaseyV1Services_UpdateRelatedObjectReference_Request_SearchByOneofInput = {
  relatedObject?: InputMaybe<OdProtosCaseyV1Services_RelatedObjectInput>;
  taskId?: InputMaybe<Scalars['String']>;
};

export type OdProtosCaseyV1Services_UpdateTaskDescriptionAndSla_RequestInput = {
  description?: InputMaybe<Scalars['String']>;
  newDeadline?: InputMaybe<Scalars['DateTime']>;
  slaType?: InputMaybe<OdProtosCaseyV1Data_Sla_SlaType>;
  taskId?: InputMaybe<Scalars['String']>;
};

export type OdProtosCaseyV1Services_UpdateWebTaskDependency_RequestInput = {
  taskDependencies?: InputMaybe<Array<OdProtosCaseyV1Services_UpdateWebTaskDependency_TaskDependencyInput>>;
};

export type OdProtosCaseyV1Services_UpdateWebTaskDependency_TaskDependencyInput = {
  parentWebTaskId?: InputMaybe<Scalars['Float']>;
  webTaskId?: InputMaybe<Scalars['Float']>;
};

export type OdProtosCommanderServices_GetOpenUserTasks_RequestInput = {
  /** Id of the process instance */
  processInstanceId?: InputMaybe<Scalars['String']>;
};

export type OdProtosCommanderServices_SubmitWorkflowData_RequestInput = {
  /**
   * Data submitted via the form
   * TODO: Explore support for nested objects and forms which has array of data.
   */
  formData?: InputMaybe<Array<OdProtosCommanderServices_SubmitWorkflowData_Request_FormDataEntryInput>>;
  /** Id of the process instance */
  processInstanceId?: InputMaybe<Scalars['String']>;
  /** Id of the associated user task */
  userTaskId?: InputMaybe<Scalars['String']>;
};

/** `OdProtosCommanderServices_SubmitWorkflowData_Request_FormDataEntryInput` represents the `form_data` map in `od_protos.commander.services.SubmitWorkflowData.Request`. */
export type OdProtosCommanderServices_SubmitWorkflowData_Request_FormDataEntryInput = {
  key?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

export type OdProtosCommonAssumptions_Unit =
  | 'BPS'
  | 'BPS_DIVIDED_BY_ONE_HUNDRED'
  | 'BPS_DIVIDED_BY_TEN_THOUSAND'
  | 'BPS_DIVIDED_BY_TEN_THOUSAND_PER_DIP'
  | 'CENTS'
  | 'CENTS_PER_DIP'
  | 'CENTS_PER_DOM'
  | 'CENTS_PER_HOME_PER_SQUARE_FOOT_PER_DIP'
  | 'DAYS'
  | 'DOLLARS'
  | 'UNSET';

/** Next ID: 5 */
export type OdProtosCommonBuyer_AttributionInput = {
  lastReferrer?: InputMaybe<Scalars['String']>;
  utmCampaign?: InputMaybe<Scalars['String']>;
  utmMedium?: InputMaybe<Scalars['String']>;
  utmSource?: InputMaybe<Scalars['String']>;
};

export type OdProtosCommonBuyer_TimeslotInput = {
  endsAt?: InputMaybe<Scalars['DateTime']>;
  startsAt?: InputMaybe<Scalars['DateTime']>;
};

export type OdProtosCommonData_AddressInput = {
  apn?: InputMaybe<Scalars['String']>;
  /**
   * Geo grouping determined by the US census
   * Bigger than a block, smaller than a census tract
   */
  blockGroupId?: InputMaybe<Scalars['String']>;
  blockId?: InputMaybe<Scalars['String']>;
  /**
   * Almost always empty. Some folks like to name everything
   * Designates a specific building within an address
   * Almost all addresses consist of a single building
   */
  building?: InputMaybe<Scalars['String']>;
  censusTractId?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  county?: InputMaybe<Scalars['String']>;
  lat?: InputMaybe<Scalars['Float']>;
  lng?: InputMaybe<Scalars['Float']>;
  postalCode?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<OdProtosCommonState_State>;
  street1?: InputMaybe<Scalars['String']>;
  subdivision?: InputMaybe<Scalars['String']>;
  /** The internal OD address token (Unique ID) */
  token?: InputMaybe<Scalars['String']>;
  /** A unit designates part of a building */
  unit?: InputMaybe<Scalars['String']>;
};

export type OdProtosCommonData_DwellingType =
  | 'APARTMENT'
  | 'CONDO'
  | 'LOFT'
  | 'MISCELLANEOUS'
  | 'OTHER'
  | 'PATIO'
  | 'SINGLE_FAMILY'
  | 'TOWNHOUSE'
  | 'VACANT';

export type OdProtosCommonData_PoolType =
  | 'BOTH_PRIVATE_COMMUNITY'
  | 'COMMUNITY'
  | 'NONE'
  | 'PRIVATE';

/** Health checks shouldn't require inputs, since clients are often naive (e.g. k8s readiness/liveness, pingdom) */
export type OdProtosCommonHealthServices_HealthRequestInput = {
  _empty?: InputMaybe<Scalars['Boolean']>;
};

/**
 * The names must be the uppercase versions of the market identifiers in web.
 * Update region.proto if any market is added/removed from here.
 */
export type OdProtosCommonMarket_Market =
  | 'ALABAMA_OTHER'
  | 'ALASKA_OTHER'
  | 'ALBUQUERQUE_NM'
  | 'ARIZONA_OTHER'
  | 'ARKANSAS_OTHER'
  | 'ASHEVILLE_NC'
  | 'ATLANTA'
  | 'AUSTIN'
  | 'BAKERSFIELD_CA'
  | 'BALTIMORE_MD'
  | 'BIRMINGHAM_AL'
  | 'BOISE'
  | 'BOSTON_MA'
  | 'CALIFORNIA_OTHER'
  | 'CENTRAL_CALIFORNIA_CA'
  | 'CHARLESTON_SC'
  | 'CHARLOTTE'
  | 'CHATTANOOGA'
  | 'CHICAGO_IL'
  | 'CINCINNATI_OH'
  | 'CINCINNATI_OK'
  | 'CLARKSVILLE_KY_TN'
  | 'CLEVELAND_OH'
  | 'COLORADO_OTHER'
  | 'COLORADO_SPRINGS_CO'
  | 'COLUMBIA_SC'
  | 'COLUMBUS_OH'
  | 'CONNECTICUT_OTHER'
  | 'CORPUS_CHRISTI_TX'
  | 'DALLAS'
  | 'DELAWARE_OTHER'
  | 'DENVER'
  | 'DETROIT_MI'
  | 'EAST_TEXAS'
  | 'EL_PASO'
  | 'FLORIDA_PANHANDLE'
  /** renamed to NORTHERN_COLORADO */
  | 'FORT_COLLINS_CO'
  | 'GEORGIA_OTHER'
  | 'GREENSBORO_NC'
  | 'GREENVILLE_SC'
  | 'HAWAII_OTHER'
  | 'HOUSTON'
  | 'HUNTSVILLE_AL'
  | 'IDAHO_OTHER'
  | 'ILLINOIS_OTHER'
  | 'INDIANAPOLIS_IN'
  | 'INDIANA_OTHER'
  | 'IOWA_OTHER'
  | 'JACKSONVILLE'
  | 'JOHNSON_CITY_TN'
  | 'KANSAS_CITY'
  | 'KANSAS_OTHER'
  | 'KENTUCKY_OTHER'
  | 'KILLEEN_TX'
  | 'KNOXVILLE_TN'
  | 'LAS_VEGAS'
  | 'LITTLE_ROCK_AR'
  | 'LOS_ANGELES'
  | 'LOUISIANA_OTHER'
  | 'LOUISVILLE_IN_KY'
  | 'MAINE_OTHER'
  | 'MARYLAND_OTHER'
  | 'MASSACHUSETTS_OTHER'
  /** Open Exchange only */
  | 'MEMPHIS_TN'
  | 'MIAMI_FL'
  | 'MICHIGAN_OTHER'
  | 'MILWAUKEE_WAUKESHA_WI'
  | 'MINNEAPOLIS'
  | 'MINNESOTA_OTHER'
  | 'MISSISSIPPI_OTHER'
  | 'MISSOURI_OTHER'
  | 'MONTANA_OTHER'
  | 'NASHVILLE'
  | 'NEBRASKA_OTHER'
  | 'NEVADA_OTHER'
  | 'NEW_HAMPSHIRE_OTHER'
  | 'NEW_MEXICO_OTHER'
  | 'NEW_ORLEANS_LA'
  | 'NEW_YORK_NEW_JERSEY'
  | 'NEW_YORK_OTHER'
  | 'NORTHERN_COLORADO'
  | 'NORTH_CAROLINA_OTHER'
  | 'NORTH_DAKOTA_OTHER'
  | 'OHIO_OTHER'
  | 'OKLAHOMA_CITY_OK'
  | 'OKLAHOMA_OTHER'
  | 'OMAHA_NE'
  | 'OREGON_OTHER'
  | 'ORLANDO'
  | 'PALM_BAY_FL'
  | 'PENNSYLVANIA_OTHER'
  | 'PHILADELPHIA_PA'
  | 'PHOENIX'
  | 'PITTSBURGH_PA'
  | 'PORTLAND'
  | 'PRESCOTT_AZ'
  | 'PROVIDENCE_RI'
  | 'PUERTO_RICO_OTHER'
  | 'RALEIGH'
  | 'RENO_NV'
  | 'RICHMOND_VA'
  | 'RIVERSIDE'
  | 'SACRAMENTO'
  | 'SALT_LAKE_CITY'
  | 'SAN_ANTONIO'
  | 'SAN_DIEGO_CA'
  | 'SAVANNAH_GA'
  | 'SEATTLE_WA'
  | 'SF_BAY_AREA'
  | 'SOUTHWEST_FL'
  | 'SOUTH_CAROLINA_OTHER'
  | 'SOUTH_DAKOTA_OTHER'
  | 'SOUTH_TEXAS'
  | 'SPRINGFIELD_MO'
  | 'ST_LOUIS'
  | 'TAMPA'
  | 'TENNESSEE_OTHER'
  | 'TUCSON'
  | 'TULSA_OK'
  | 'UNKNOWN'
  | 'UTAH_OTHER'
  | 'VERMONT_OTHER'
  | 'VIRGINIA_BEACH_VA'
  | 'VIRGINIA_OTHER'
  | 'WASHINGTON_DC'
  | 'WASHINGTON_OTHER'
  | 'WESTERN_MD'
  | 'WESTERN_NY'
  | 'WEST_TEXAS'
  | 'WEST_VIRGINIA_OTHER'
  | 'WICHITA_KS'
  | 'WISCONSIN_OTHER'
  | 'WYOMING_OTHER';

export type OdProtosCommonMarket_Region_Central =
  | 'ARKANSAS_OTHER'
  | 'AUSTIN'
  | 'CHICAGO_IL'
  | 'CORPUS_CHRISTI_TX'
  | 'DALLAS'
  | 'EAST_TEXAS'
  | 'EL_PASO'
  | 'HOUSTON'
  | 'INDIANA_OTHER'
  | 'IOWA_OTHER'
  | 'KANSAS_CITY'
  | 'KANSAS_OTHER'
  | 'KENTUCKY_OTHER'
  | 'KILLEEN_TX'
  | 'LITTLE_ROCK_AR'
  | 'LOUISIANA_OTHER'
  | 'MICHIGAN_OTHER'
  | 'MILWAUKEE_WAUKESHA_WI'
  | 'MINNESOTA_OTHER'
  | 'MISSISSIPPI_OTHER'
  | 'MISSOURI_OTHER'
  | 'NEBRASKA_OTHER'
  | 'NEW_ORLEANS_LA'
  | 'NORTH_DAKOTA_OTHER'
  | 'OKLAHOMA_CITY_OK'
  | 'OKLAHOMA_OTHER'
  | 'OMAHA_NE'
  | 'SAN_ANTONIO'
  | 'SOUTH_DAKOTA_OTHER'
  | 'SOUTH_TEXAS'
  | 'SPRINGFIELD_MO'
  | 'ST_LOUIS'
  | 'TULSA_OK'
  | 'WEST_TEXAS'
  | 'WICHITA_KS'
  | 'WISCONSIN_OTHER';

export type OdProtosCommonMarket_Region_East =
  | 'ALABAMA_OTHER'
  | 'ASHEVILLE_NC'
  | 'ATLANTA'
  | 'BALTIMORE_MD'
  | 'BIRMINGHAM_AL'
  | 'BOSTON_MA'
  | 'CHARLESTON_SC'
  | 'CHARLOTTE'
  | 'CHATTANOOGA'
  | 'CINCINNATI_OH'
  | 'CLARKSVILLE_KY_TN'
  | 'CLEVELAND_OH'
  | 'COLUMBIA_SC'
  | 'COLUMBUS_OH'
  | 'CONNECTICUT_OTHER'
  | 'DELAWARE_OTHER'
  | 'DETROIT_MI'
  | 'FLORIDA_PANHANDLE'
  | 'GEORGIA_OTHER'
  | 'GREENSBORO_NC'
  | 'GREENVILLE_SC'
  | 'HUNTSVILLE_AL'
  | 'ILLINOIS_OTHER'
  | 'INDIANAPOLIS_IN'
  | 'JACKSONVILLE'
  | 'JOHNSON_CITY_TN'
  | 'KNOXVILLE_TN'
  | 'LOUISVILLE_IN_KY'
  | 'MAINE_OTHER'
  | 'MARYLAND_OTHER'
  | 'MASSACHUSETTS_OTHER'
  | 'MEMPHIS_TN'
  | 'MIAMI_FL'
  | 'MINNEAPOLIS'
  | 'NASHVILLE'
  | 'NEW_HAMPSHIRE_OTHER'
  | 'NEW_YORK_NEW_JERSEY'
  | 'NEW_YORK_OTHER'
  | 'NORTH_CAROLINA_OTHER'
  | 'OHIO_OTHER'
  | 'ORLANDO'
  | 'PALM_BAY_FL'
  | 'PENNSYLVANIA_OTHER'
  | 'PHILADELPHIA_PA'
  | 'PITTSBURGH_PA'
  | 'PROVIDENCE_RI'
  | 'PUERTO_RICO_OTHER'
  | 'RALEIGH'
  | 'RICHMOND_VA'
  | 'SOUTHWEST_FL'
  | 'SOUTH_CAROLINA_OTHER'
  | 'TAMPA'
  | 'TENNESSEE_OTHER'
  | 'VERMONT_OTHER'
  | 'VIRGINIA_BEACH_VA'
  | 'VIRGINIA_OTHER'
  | 'WASHINGTON_DC'
  | 'WESTERN_MD'
  | 'WESTERN_NY'
  | 'WEST_VIRGINIA_OTHER';

export type OdProtosCommonMarket_Region_West =
  | 'ALASKA_OTHER'
  | 'ALBUQUERQUE_NM'
  | 'ARIZONA_OTHER'
  | 'BAKERSFIELD_CA'
  | 'BOISE'
  | 'CALIFORNIA_OTHER'
  | 'CENTRAL_CALIFORNIA_CA'
  | 'COLORADO_OTHER'
  | 'COLORADO_SPRINGS_CO'
  | 'DENVER'
  | 'HAWAII_OTHER'
  | 'IDAHO_OTHER'
  | 'LAS_VEGAS'
  | 'LOS_ANGELES'
  | 'MONTANA_OTHER'
  | 'NEVADA_OTHER'
  | 'NEW_MEXICO_OTHER'
  | 'NORTHERN_COLORADO'
  | 'OREGON_OTHER'
  | 'PHOENIX'
  | 'PORTLAND'
  | 'PRESCOTT_AZ'
  | 'RENO_NV'
  | 'RIVERSIDE'
  | 'SACRAMENTO'
  | 'SALT_LAKE_CITY'
  | 'SAN_DIEGO_CA'
  | 'SEATTLE_WA'
  | 'SF_BAY_AREA'
  | 'TUCSON'
  | 'UTAH_OTHER'
  | 'WASHINGTON_OTHER'
  | 'WYOMING_OTHER';

/**
 * Enumeration of Multiple Listing Services.
 * Comment format: Region Coverage - OD Markets
 */
export type OdProtosCommonMls_Mls =
  /** Aiken Association of REALTORS */
  | 'AARMLS'
  /** Austin - AUS (Austin, TX) */
  | 'ABORMLS'
  /** Aspen Glenwood MLS */
  | 'AGMLS'
  /** Alaska Multiple Listing Service */
  | 'AKMLS'
  /** Altitude MLS */
  | 'ALTITUDEMLS'
  /** Amarillo Association of REALTORS */
  | 'AMARILLOMLS'
  /** APEX MLS (Greater Louisville Association of REALTORS) */
  | 'APEXMLS'
  /** ArkansasONE MLS */
  | 'ARKONEMLS'
  /** Arizona Regional - PHX (Phoenix, AZ) */
  | 'ARMLS'
  /** Bagnell Dam Association of REALTORS */
  | 'BAGNELLMLS'
  /** Baldwin REALTORS */
  | 'BALDWINMLS'
  /** San Francisco, Northern Counties */
  | 'BAREIS'
  /** Brooklyn Board of REALTORS */
  | 'BBORMLS'
  /** BryanCollege Station Regional Multiple Listing Service */
  | 'BCSMLS'
  /** Miami FL */
  | 'BEACHESMLS'
  /** Beaumont Board of REALTORS */
  | 'BEBORMLS'
  /** Berkshire County Board of REALTORS */
  | 'BERKMLS'
  /** Black Hills Association of REALTORS */
  | 'BHARLMLS'
  /** Big Sky Country MLS (Gallatin Association of REALTORS) */
  | 'BIGSKYMLS'
  /** Billings Multiple Listing Service */
  | 'BILLINGSMLS'
  /** San Francisco, East/South Bay */
  | 'BRIDGEMLS'
  /** Washington DC, Arlington VA */
  | 'BRIGHTMLS'
  /** Charlottesville Area Association of REALTORS */
  | 'CAARMLS'
  /** California - LAX (Los Angeles, CA) */
  | 'CARETS'
  /** Cooperative Arkansas REALTORS MLS */
  | 'CARMLS'
  /** Capital Area Technology & REALTOR Services (Tallahassee Board of REALTORS) */
  | 'CATARS'
  /** Corpus Christi TX */
  | 'CBMLS'
  /** Columbia Board of REALTORS */
  | 'CBOR'
  /** Coastal Carolinas Association of REALTORS */
  | 'CCAR'
  /** Cape Cod & Islands Association of REALTORS */
  | 'CCIARMLS'
  /** Columbus, OH */
  | 'CCOR'
  /** Coeur d'Alene Multiple Listing Service */
  | 'CDAMLS'
  /** California Desert Association of REALTORS */
  | 'CDARMLS'
  /** Central Jersey - ? (NJ/NY) */
  | 'CENTRALJERSEYMLS'
  /** Central Georgia MLS */
  | 'CGMLS'
  /** Cheyenne Board of REALTORS */
  | 'CHEYENNEMLS'
  /** Charleston, SC */
  | 'CHSMLS'
  /** Cincinnati, OH */
  | 'CINCYMLS'
  /** CLASSIC MLS (Athens Area Association of REALTORS) */
  | 'CLASSICMLS'
  /** ? - CLT (Charlotte, SC) */
  | 'CMLS'
  /** Columbia SC */
  | 'CONSOLIDATEDMLS'
  /** Constellation MLS */
  | 'CONSTELLATION_ARMLS'
  /** Constellation MLS */
  | 'CONSTELLATION_BEACHESMLS'
  /** Constellation MLS */
  | 'CONSTELLATION_BRIGHTMLS'
  /** Constellation MLS */
  | 'CONSTELLATION_CMLS'
  /** Constellation MLS */
  | 'CONSTELLATION_CRMLS'
  /** Constellation MLS */
  | 'CONSTELLATION_FGCMLS'
  /** Constellation MLS */
  | 'CONSTELLATION_FMLS'
  /** Constellation MLS */
  | 'CONSTELLATION_GAMLS'
  /** Constellation MLS */
  | 'CONSTELLATION_HARMLS'
  /** Constellation MLS */
  | 'CONSTELLATION_MFRMLS'
  /** Constellation MLS */
  | 'CONSTELLATION_MI_REAL_SOURCE'
  /** Constellation MLS */
  | 'CONSTELLATION_MLSOK'
  /** Constellation MLS */
  | 'CONSTELLATION_MREDMLS'
  /** Constellation MLS */
  | 'CONSTELLATION_NORTHSTAR'
  /** Constellation MLS */
  | 'CONSTELLATION_ONEKEY'
  /** Constellation MLS */
  | 'CONSTELLATION_REALCOMP'
  /** Constellation MLS */
  | 'CONSTELLATION_REALTRACS'
  /** Constellation MLS */
  | 'CONSTELLATION_RECOLORADO'
  /** Constellation MLS */
  | 'CONSTELLATION_SDMLS'
  /** Constellation MLS */
  | 'CONSTELLATION_SEF'
  /** Contra Costa Association of REALTORS */
  | 'CONTRACOSTAMLS'
  /** Central Panhandle Association of REALTORS */
  | 'CPARMLS'
  /** Cedar Rapids Area Association of REALTORS */
  | 'CRAAR'
  /** Colorado Real Estate Network (CREN) */
  | 'CREN'
  /** California Regional - LAX (Los Angeles, CA), RIV (Riverside, CA) */
  | 'CRMLS'
  /** Kileen TX */
  | 'CTXMLS'
  /** Richmond, VA */
  | 'CVRMLS'
  /** Central Wisconsin Multiple Listing Service */
  | 'CWMLS'
  /** Central West Tennessee Association of REALTORS */
  | 'CWTARMLS'
  /** Dayton REALTORS */
  | 'DAYTONMLS'
  /** Daytona Beach Area Association of REALTORS */
  | 'DBAARMLS'
  /** Des Moines Area Association of REALTORS */
  | 'DMAARMLS'
  /** Emerald Coast Association of REALTORS */
  | 'ECAR'
  /** Elko County Association of REALTORS */
  | 'ELKOMLS'
  /** FargoMoorhead Area Association of REALTORS */
  | 'FMARMLS'
  /** ? - ATL (Atlanta, GA) */
  | 'FMLS'
  /** Fresno, CA */
  | 'FRESNOMLS'
  /** Birmingham, AL */
  | 'GALMLS'
  /** Georgia MLS - ATL (Atlanta, GA) */
  | 'GAMLS'
  /** Greater Antelope Valley Association of REALTORS */
  | 'GAVARMLS'
  /** Greater Baton Rouge Association of REALTORS */
  | 'GBRAR'
  /** Chattanooga TN */
  | 'GCAR'
  /** Gulf Coast MLS (Mobile Area Association of REALTORS) */
  | 'GCMLS'
  /** Bakersfield CA */
  | 'GEMLS'
  /** Greater El Paso Association of REALTORS */
  | 'GEPARMLS'
  /** Grand Forks Area Association of REALTORS */
  | 'GFAARMLS'
  /** Greater Fairbanks Board of REALTORS */
  | 'GFBORMLS'
  /** Golden Isles Association of REALTORS */
  | 'GIARMLS'
  /** Grand Island Board of REALTORS */
  | 'GIBORMLS'
  /** Grand Junction Area REALTOR Association */
  | 'GJARMLS'
  /** Louisville, KY */
  | 'GLARMLS'
  /** Global MLS */
  | 'GLOBALMLS'
  /** Greater Las Vegas - LAS (Las Vegas, NV) */
  | 'GLVAR'
  /** Greater Lehigh Valley REALTORS */
  | 'GLVRMLS'
  /** Greater McAllen Association of REALTORS */
  | 'GMAR'
  /** REALTORS of Greater MidNebraska */
  | 'GMNRBMLS'
  /** Greater Northwoods MLS */
  | 'GNMLS'
  /** Great Plains Regional MLS */
  | 'GPRMLS'
  /** Greenville + Anderson SC */
  | 'GREENVILLEMLS'
  /** Greenwich Association of REALTORS */
  | 'GREENWICHMLS'
  /** Greater Lansing Association of REALTORS */
  | 'GRLARMLS'
  /** Great North MLS */
  | 'GRNMLS'
  /** Central New York Information Services (Greater Syracuse Association of REALTORS) */
  | 'GSARMLS'
  /** Greater Scranton Board of REALTORS */
  | 'GSBOR'
  /** Great Smoky Mountains Association of REALTORS */
  | 'GSMARMLS'
  /** Garden State MLS (NJ/NY) */
  | 'GSMLS'
  /** Gulf South Real Estate Information Network */
  | 'GSREIN'
  /** Greater Tyler Association of REALTORS */
  | 'GTAR'
  /** Houston - HOU (Houston, TX) */
  | 'HARMLS'
  /** Hattiesburg Area Association of REALTORS */
  | 'HATARMLS'
  /** Huntington Board of REALTORS */
  | 'HBORMLS'
  /** High Country Association of REALTORS */
  | 'HCAR'
  /** Hudson County MLS (Liberty Board of REALTORS) */
  | 'HCMLS'
  /** HiCentral MLS (Honolulu Board of REALTORS) */
  | 'HICENTRALMLS'
  /** Highland Lakes Association of REALTORS */
  | 'HILAORMLS'
  /** Hive MLS */
  | 'HIVEMLS'
  /** Kansas City */
  | 'HMLMLS'
  /** Kansas City, HMLMLS was the original Kansas market and is no longer being ingested. It's left in for backwards compatibility */
  | 'HMLS'
  /** Hudson Valley Catskills Region Multiple List Service (Ulster County Board of REALTORS) */
  | 'HVMLS'
  /** Iowa City Area Association of REALTORS */
  | 'ICAAR'
  /** Iron County Board of REALTORS */
  | 'ICBOR'
  /** Chicago, IL */
  | 'ILMLSNI'
  /** Imagine MLS (Bluegrass REALTORS) */
  | 'IMAGINEMLS'
  /** Boise ID */
  | 'IMLS'
  /** Fort Collins CO */
  | 'IRES'
  /** IRES MLS */
  | 'IRESMLS'
  /** Indiana Regional MLS */
  | 'IRMLS'
  /** Knoxville + Morristown TN */
  | 'KAAR'
  /** Kanawha Valley Board of REALTORS */
  | 'KVBARMLS'
  /** Longview Area Association of REALTORS */
  | 'LAARMLS'
  /** Lynchburg Association of REALTORS */
  | 'LARMLS'
  /** Luzerne County Association of REALTORS */
  | 'LCARMLS'
  /** Lake Havasu Association of REALTORS */
  | 'LHARMLS'
  /** Lake of the Ozarks Board of REALTORS */
  | 'LOBRMLS'
  /** Longleaf Pine REALTORS */
  | 'LPRMLS'
  /** Lowcountry Regional MLS (BeaufortJasper County REALTORS) */
  | 'LRMLS'
  /** Lake Superior Area REALTORS */
  | 'LSARMLS'
  /** Lubbock Association of REALTORS */
  | 'LUBBOCKMLS'
  /** Memphis - ? (Memphis, TN) */
  | 'MAARMLS'
  /** Maine Listings */
  | 'MAINEMLS'
  /** St Louis MO */
  | 'MARIS'
  /** Maui MLS (REALTORS Association of Maui) */
  | 'MAUIMLS'
  /** Sacramento Metro - SAC (Sacramento, CA) */
  | 'METROLIST'
  /** Metro MLS */
  | 'METROMLS'
  /** Mid Florida - ORL (Orlando, FL), TPA (Tampa, FL) */
  | 'MFRMLS'
  /** Miami FL */
  | 'MIAMIRE'
  /** Indianapolis, IN */
  | 'MIBOR'
  /** MiRealSource */
  | 'MIREAL'
  /** California - LAX (Los Angeles, CA) */
  | 'MLSCLAW'
  /** Hawaii Information Service (MLS Hawaii) */
  | 'MLSHAWAII'
  /** San Francisco, South Bay */
  | 'MLSLISTINGS'
  /** Cleveland, OH */
  | 'MLSNOW'
  /** Oklahoma City OK */
  | 'MLSOK'
  /** Boston, MA */
  | 'MLSPIN'
  /** Southern Arizona - TUS (Tucson, AZ) */
  | 'MLSSAZ'
  /** MLS Technology */
  | 'MLSTECHNOLOGY'
  /** MLS United */
  | 'MLSU'
  /** Montgomery Area Association of REALTORS */
  | 'MOARMLS'
  /** MOREMLS (Monmouth Ocean Regional REALTORS) */
  | 'MOREMLS'
  /** Mount Rushmore Area Association of REALTORS */
  | 'MRAAR'
  /** Chicago, IL */
  | 'MREDMLS'
  /** Montana Regional MLS */
  | 'MRMLS'
  /** National */
  | 'MYSTATE'
  /** NoCoast MLS */
  | 'NCMLS'
  /** North Central West Virginia REIN */
  | 'NCWVREIN'
  /** Northeast Arkansas Board of REALTORS */
  | 'NEABOR'
  /** Northeast Florida - JAX (Jacksonville, FL) */
  | 'NEFMLS'
  /** Northeast Georgia Board of REALTORS */
  | 'NEGBORMLS'
  /** Northeast Iowa Regional Board of REALTORS */
  | 'NEIRBOR'
  /** Northeast Mississippi Board of REALTORS */
  | 'NEMISMLS'
  /** Northeast Oklahoma Board of REALTORS */
  | 'NEOKMLS'
  /** Northeast REALTORS of Louisiana */
  | 'NERLMLS'
  /** Northern Great Lakes REALTORS MLS */
  | 'NGLRMLS'
  /** Northwest Indiana REALTORS Association */
  | 'NIRAMLS'
  /** New Jersey MLS (NJ/NY) */
  | 'NJMLS'
  /** Northern Kentucky */
  | 'NKARMLS'
  /** New Mexico MLS */
  | 'NMMLS'
  /** Reno NV */
  | 'NNRMLS'
  /** Tulsa, OK */
  | 'NORES'
  /** Northwest Ohio Real Estate Information Service (NORIS) */
  | 'NORIS'
  /** Minnesota and Western Wisconsin - MSP (Minneapolis, MN) */
  | 'NORTHSTAR'
  /** North Texas - DFW (Dallas Ft Worth, TX) */
  | 'NTREIS'
  /** NorthWest Illinois Alliance of REALTORS */
  | 'NWILARMLS'
  /** Seattle, WA */
  | 'NWMLS'
  /** Northwestern Wisconsin Multiple Listing Service */
  | 'NWWMLS'
  /** NY State MLS */
  | 'NYSTATEMLS'
  /** Odessa Board of REALTORS */
  | 'ODESSAMLS'
  /** Oregon Data Share */
  | 'ODSHARE'
  /** Ozark Gateway Association of REALTORS */
  | 'OGARMLS'
  /** Hudson Valley, Long Island (NJ/NY) */
  | 'ONEKEY'
  /** Deprecated - MLS name is ONEKEY, see below */
  | 'ONEKEYMLS'
  /** Prescott AZ */
  | 'PAAR'
  /** Permian Basin Board of REALTORS */
  | 'PBBORMLS'
  /** Park City Board of REALTORS */
  | 'PCBOR'
  /** Pensacola Association of REALTORS */
  | 'PENSACOLAMLS'
  /** Pocono Mountains Association of REALTORS */
  | 'PMARMLS'
  /** Colorado Springs, CO */
  | 'PPMLS'
  /** PrimeMLS */
  | 'PRIMEMLS'
  /** Pacific Regional MLS */
  | 'PRMLS'
  /** Pueblo Association of REALTORS */
  | 'PUEBLOMLS'
  /** REALTOR Association of Acadiana */
  | 'RAAMLS'
  /** REALTORS Association of Citrus County */
  | 'RACITRUS'
  /** REALTORS Association of Indian River County */
  | 'RAIRC'
  /** REALTORS Association of Northeast Wisconsin */
  | 'RANWMLS'
  /** REALTOR Association of Southern Minnesota */
  | 'RASMMLS'
  /** River Counties Association of REALTORS */
  | 'RCARMLS'
  /** Detroit, MI */
  | 'REALCOMP'
  /** Mid-South - NAS (Nashville, TN) */
  | 'REALTRACS'
  /** Real Estate Board of New York (REBNY) */
  | 'REBNY'
  /** Colorado - DEN (Denver, CO) */
  | 'RECOLORADO'
  /** Real Estate Information Network (REIN) */
  | 'REIN'
  /** Real Estate Information Services (REALTOR Association of Southern Kentucky) */
  | 'REISKMLS'
  /** REsides */
  | 'RESIDES'
  /** REALTORS of Greater Augusta */
  | 'RGAMLS'
  /** Rio Grande Valley Multiple Listing Service (Harlingen Board of REALTORS) */
  | 'RGVMLS'
  /** ? - PDX (Portland, OR) */
  | 'RMLS'
  /** RMLS Alliance */
  | 'RMLSA'
  /** ROAM MLS */
  | 'ROAMMLS'
  /** Roanoke Valley Association of REALTORS */
  | 'RVARMLS'
  /** San Antonio - SAT (San Antonio, TX) */
  | 'SABORMLS'
  /** Santa Fe Association of REALTORS */
  | 'SAFARMLS'
  /** South Central Kansas MLS */
  | 'SCKMLS'
  /** South Central Wisconsin Multiple Listing Service */
  | 'SCWMLS'
  /** San Diego - ? (San Diego, CA) */
  | 'SDMLS'
  /** Southeast Alaska MLS */
  | 'SEAKMLS'
  /** San Francisco, Peninsula */
  | 'SFAR'
  /** Staten Island Multiple Listing Service */
  | 'SIMLS'
  /** REALTOR Association of the Sioux Empire */
  | 'SIOUXMLS'
  /** Louisville (Indiana side) */
  | 'SIRAMLS'
  /** South Jersey Shore Regional MLS */
  | 'SJSMLS'
  /** SmartMLS */
  | 'SMARTMLS'
  /** Savannah MultiList Corporation */
  | 'SMLMLS'
  /** Strategic MLS Alliance (Cullman Shoals Area) */
  | 'SMLSA'
  /** Snake River Regional MLS */
  | 'SNAKERMLS'
  /** Southern Missouri Regional MLS */
  | 'SOMOMLS'
  /** Space Coast MLS (Space Coast Association of REALTORS) */
  | 'SPACECOASTMLS'
  /** Greenville + Anderson SC */
  | 'SPTBGMLS'
  /** Spokane Association of REALTORS */
  | 'SRMLS'
  /** StateWide MLS */
  | 'STATEWIDEMLS'
  /** Sunflower Association of REALTORS */
  | 'SUNARMLS'
  /** southwest and Naples FL */
  | 'SWFLA'
  /** Albuquerque, NM */
  | 'SWMLS'
  /** Southwest Virginia Association of REALTORS */
  | 'SWVARMLS'
  /** Teton Board of REALTORS */
  | 'TETONMLS'
  /** Triangle Area of North Carolina - RDU (Raleigh, NC) */
  | 'TMLS'
  /** TennesseeVirginia Regional MLS */
  | 'TNVARMLS'
  /** Greensboro + Winston NC */
  | 'TRIADMLS'
  /** Upper Cumberland Association of REALTORS */
  | 'UCARMLS'
  | 'UNKNOWN'
  /** Upstate New York Real Estate Information Services (UNYREIS) */
  | 'UNYREIS'
  /** Utah - SLC (Salt Lake City, UT) */
  | 'UTAHRE'
  /** ValleyMLScom */
  | 'VALLEYMLS'
  /** West Alabama Multiple Listing Service */
  | 'WAMLS'
  /** Western Arizona REALTOR Data Exchange (WARDEX) */
  | 'WARDEX'
  /** Washington County Board of REALTORS */
  | 'WCBORMLS'
  /** Wisconsin Real Estate Exchange */
  | 'WIREX'
  /** Western Kentucky Regional MLS */
  | 'WKRMLS'
  /** White Mountain Association of REALTORS */
  | 'WMARMLS'
  /** Western New York Real Estate Information Services (WNYREIS) */
  | 'WNYREIS'
  /** West Penn MultiList */
  | 'WPML'
  /** Western Regional Information Systems & Technology (WRIST) */
  | 'WRIST'
  /** Western River Valley Board of REALTORS */
  | 'WRVBORMLS'
  /** Western Upstate Multiple Listing Service */
  | 'WUMLS'
  /** Willamette Valley MLS */
  | 'WVMLS'
  /** Water Wonderland Board of REALTORS */
  | 'WWBOR'
  /** Wyoming MLS */
  | 'WYMLS';

export type OdProtosCommonOptions_Format =
  | 'JSON'
  | 'PROTO';

/**
 * OffsetPaginationRequest
 *
 * More lightweight than the PaginationRequest
 * it only allows forward pagination
 */
export type OdProtosCommonPagination_OffsetPaginationRequestInput = {
  count?: InputMaybe<Scalars['Float']>;
  offset?: InputMaybe<Scalars['Float']>;
};

/**
 * Pagination request.
 *
 * To enable forward pagination, two arguments are required.
 * * first takes a non‐negative integer.
 * * after takes the cursor type as described in the cursor field section.
 * The server should use those two arguments to modify the edges returned by
 * the connection, returning edges after the after cursor, and returning at
 * most first edges.
 *
 * To enable backward pagination, two arguments are required.
 * * last takes a non‐negative integer.
 * * before takes the cursor type as described in the cursor field section.
 * The server should use those two arguments to modify the edges returned by
 * the connection, returning edges before the before cursor, and returning at
 * most last edges.
 */
export type OdProtosCommonPagination_PaginationRequestInput = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Float']>;
  last?: InputMaybe<Scalars['Float']>;
};

/** Tribool is a boolean (Yes/No) with a third state (Maybe). */
export type OdProtosCommonPagination_Tribool =
  | 'MAYBE'
  | 'NO'
  | 'YES';

/** Next ID: 9 */
export type OdProtosCommonSell_ListWithOpendoorRefreshStatus =
  | 'FAIL_ACTIVE_OFFER_ON_ADDRESS_LWOD'
  | 'FAIL_LEAD_NOT_FOUND_LWOD'
  | 'FAIL_LWOD_ERR_QUALIFY_LEAD'
  | 'FAIL_MERCH_MISSING_PRODUCT_LWOD'
  | 'FAIL_REFRESH_REQUESTED_TOO_SOON_LWOD'
  | 'NOT_ELIGIBLE_ALREADY_QUALIFIED'
  | 'NOT_ELIGIBLE_FOR_REFRESH'
  | 'REFRESH_SUCCESS'
  | 'UNKNOWN_REFRESH_STATUS';

/** Next ID: 34 */
export type OdProtosCommonSell_OfferRequest_Source =
  | 'AGENT_LED_OFFERS_REACTIVATE'
  | 'AGENT_LED_OFFER_AUTO_REFRESH'
  | 'AGENT_LED_OFFER_DROPOUT'
  /** AUTOMATED_AGENT_REENGAGEMENT_OFFER is used for agent refreshes triggered via the daily DAG */
  | 'AUTOMATED_AGENT_REENGAGEMENT_OFFER'
  /** AUTOMATED_MSRE_REFRESH_OFFER is used for auto offer refreshes for MSRE leads daily */
  | 'AUTOMATED_MSRE_REFRESH_OFFER'
  | 'AUTOMATED_REENGAGEMENT_OFFER'
  /** EMAIL_PROSPECTING is used for offer requests on leads from the EMAIL_PROSPECTING channel */
  | 'EMAIL_PROSPECTING'
  | 'EXCLUSIVE_OFFERS'
  /** FLYWHEEL is used for offer requests on leads from the FLYWHEEL channel */
  | 'FLYWHEEL'
  /** HOMEPAGE_RETURN_EXPERIENCE is used for offer refreshes that are triggered from the homepage */
  | 'HOMEPAGE_RETURN_EXPERIENCE'
  /** HOME_RESERVE is used for offers requests on leads from the HOME_RESERVE channel */
  | 'HOME_RESERVE'
  | 'INCOMPLETE_INITIAL_LEAD_FLOW'
  | 'INITIAL_LEAD_FLOW'
  | 'MOBILE_APP'
  | 'OFFER_REENGAGEMENT_CAMPAIGN'
  | 'OFFER_REVIEW'
  /** OUTBOUND_OFFERS_LISTED is used for 2020 Hackweek experiment of sending offers to listed homes */
  | 'OUTBOUND_OFFERS_LISTED'
  /** OUTBOUND_OFFERS_UNDERWRITTEN is used for outbound offers that should auto-start underwriting and skip assessments */
  | 'OUTBOUND_OFFERS_UNDERWRITTEN'
  | 'REFRESH_ADMIN'
  /** REFRESH_ASSESSMENT_COMPLETED is used when a customer completes a virtual assessment but their offer has expired */
  | 'REFRESH_ASSESSMENT_COMPLETED'
  | 'REFRESH_BROKERAGE_OFFER_DASHBOARD'
  | 'REFRESH_CORRECTED_SQ_FT_DATA'
  /** REFRESH_FROM_ENG is used for backfilling any refresh properties that expierenced a break in flow due to an error */
  | 'REFRESH_FROM_ENG'
  /** REFRESH_HOME_DETAILS is used for offer refreshes from the offer dashboard home details page */
  | 'REFRESH_HOME_DETAILS'
  | 'REFRESH_OFFER_DASHBOARD'
  /** REFRESH_PARTNER_CTA is used for offer requests that come from Opendoor partners */
  | 'REFRESH_PARTNER_CTA'
  /** REFRESH_PARTNER_REFERRAL is used for offers refreshed from the partnerships referral dashboard */
  | 'REFRESH_PARTNER_REFERRAL'
  | 'REFRESH_PREVIOUSLY_DENIED'
  | 'REFRESH_REENGAGEMENT_EMAILS'
  | 'REFRESH_SELLER_FEEDBACK'
  | 'REIT_BULK_REQUEST'
  /** Restore offer because of an LWOD Listing agreement being signed */
  | 'RESTORE_LWOD_LISTING_AGREEMENT_SIGNED'
  /** RETURN_TO_HUB_AUTO_REFRESH is used for offer refreshes automatically made when users return to the Hub */
  | 'RETURN_TO_HUB_AUTO_REFRESH'
  | 'UNKNOWN_OFFER_SOURCE';

export type OdProtosCommonSell_OpendoorWalkReason =
  | 'OPENDOOR_WALK_REASON_ADJACENT_TO_STABILIZATION'
  | 'OPENDOOR_WALK_REASON_OPENDOOR_ADDENDUM'
  | 'OPENDOOR_WALK_REASON_PRICING_UNCERTAINTY'
  | 'OPENDOOR_WALK_REASON_REPAIR_ASSESSMENT_INCOMPLETE'
  | 'OPENDOOR_WALK_REASON_REPAIR_SCOPE_OF_WORK_TOO_LARGE'
  | 'OPENDOOR_WALK_REASON_SEE_UNDERWRITING'
  | 'OPENDOOR_WALK_REASON_UNKNOWN';

/** Next ID: 17 */
export type OdProtosCommonSell_SellDirectOfferRefreshStatus =
  | 'FAIL_ACTIVE_OFFER_ON_ADDRESS'
  | 'FAIL_ACTIVE_OFFER_REQUEST_ON_ADDRESS'
  | 'FAIL_EXISTING_OFFER_NOT_FOUND'
  | 'FAIL_HOME_IS_NOW_LISTED'
  | 'FAIL_INSPECTION_IN_PROGRESS'
  | 'FAIL_LEAD_NOT_FOUND_SELL_DIRECT'
  | 'FAIL_LEAD_NOT_QUALIFIED'
  | 'FAIL_LISTING_DETAILS_NOT_FOUND'
  | 'FAIL_LWC_REFRESH_PERMISSION_DENIED'
  | 'FAIL_MERCH_DENIED_LEAD'
  | 'FAIL_OFFER_ALREADY_REFRESHED'
  | 'FAIL_OFFER_NOT_EXPIRED'
  | 'FAIL_OFFER_STATE_NOT_REFRESHABLE'
  | 'FAIL_REFRESH_REQUESTED_TOO_SOON'
  | 'FAIL_UPCOMING_CALENDLY_MEETING'
  | 'SUCCESS'
  | 'UNKNOWN';

export type OdProtosCommonSell_SellerWalkReason =
  | 'SELLER_WALK_REASON_CANNOT_FIND_NEW_HOME'
  | 'SELLER_WALK_REASON_CLOSE_OF_ESCROW_EXTENSION_DENIED'
  | 'SELLER_WALK_REASON_COMPETITION_OR_INVESTOR_OFFER'
  | 'SELLER_WALK_REASON_HOA_SOLAR_CITY_INSPECTION'
  | 'SELLER_WALK_REASON_HOME_IS_LISTED'
  | 'SELLER_WALK_REASON_LEGAL_ISSUES'
  | 'SELLER_WALK_REASON_NET_CASH'
  | 'SELLER_WALK_REASON_NOT_SELLING'
  | 'SELLER_WALK_REASON_OTHER_REASON'
  | 'SELLER_WALK_REASON_POST_INSPECTION_OPENDOOR_ASK'
  | 'SELLER_WALK_REASON_UNKNOWN';

export type OdProtosCommonSell_WalkInitiator =
  | 'WALK_INITIATOR_OPENDOOR'
  | 'WALK_INITIATOR_SELLER'
  | 'WALK_INITIATOR_UNKNOWN';

export type OdProtosCommonState_RecordingState_State =
  /** Arizona State */
  | 'AZ'
  /** California State */
  | 'CA'
  /** Idaho State */
  | 'ID'
  /** Nevada State */
  | 'NV'
  /** Oregon State */
  | 'OR'
  | 'UNKNOWN'
  /** Utah State */
  | 'UT';

/** Next ID: 66 */
export type OdProtosCommonState_State =
  /** Armed Forces Americas */
  | 'AA'
  /** Armed Forces Europe */
  | 'AE'
  /** Alaska State */
  | 'AK'
  /** Alabama State */
  | 'AL'
  /** Armed Forces Pacific */
  | 'AP'
  /** Arkansas State */
  | 'AR'
  /** American Samoa */
  | 'AS'
  /** Arizona State */
  | 'AZ'
  /** California State */
  | 'CA'
  /** Colorado State */
  | 'CO'
  /** Connecticut State */
  | 'CT'
  /** District of Columbia Federal district */
  | 'DC'
  /** Delaware State */
  | 'DE'
  /** Florida State */
  | 'FL'
  /** Georgia State */
  | 'GA'
  /** Guam */
  | 'GU'
  /** Hawaii State */
  | 'HI'
  /** Iowa State */
  | 'IA'
  /** Idaho State */
  | 'ID'
  /** Illinois State */
  | 'IL'
  /** Indiana State */
  | 'IN'
  /** Kansas State */
  | 'KS'
  /** Kentucky State (Commonwealth) */
  | 'KY'
  /** Louisiana State */
  | 'LA'
  /** Massachusetts State (Commonwealth) */
  | 'MA'
  /** Maryland State */
  | 'MD'
  /** Maine State */
  | 'ME'
  /** Michigan State */
  | 'MI'
  /** Minnesota State */
  | 'MN'
  /** Missouri State */
  | 'MO'
  /** Northern Mariana Islands (Commonwealth) */
  | 'MP'
  /** Mississippi State */
  | 'MS'
  /** Montana State */
  | 'MT'
  /** North Carolina */
  | 'NC'
  /** North Dakota State */
  | 'ND'
  /** Nebraska State */
  | 'NE'
  /** New Hampshire State */
  | 'NH'
  /** New Jersey State */
  | 'NJ'
  /** New Mexico State */
  | 'NM'
  /** Nevada State */
  | 'NV'
  /** New York State */
  | 'NY'
  /** Ohio State */
  | 'OH'
  /** Oklahoma State */
  | 'OK'
  /** Oregon State */
  | 'OR'
  /** Pennsylvania State (Commonwealth) */
  | 'PA'
  /** Puerto Rico (Commonwealth) */
  | 'PR'
  /** Rhode Island State */
  | 'RI'
  /** South Carolina State */
  | 'SC'
  /** South Dakota State */
  | 'SD'
  /** Tennessee State */
  | 'TN'
  /** Texas State */
  | 'TX'
  | 'UNKNOWN'
  /** Utah State */
  | 'UT'
  /** Virginia State (Commonwealth) */
  | 'VA'
  /** Virgin Islands */
  | 'VI'
  /** Vermont State */
  | 'VT'
  /** Washington State */
  | 'WA'
  /** Wisconsin	State */
  | 'WI'
  /** West Virginia State */
  | 'WV'
  /** Wyoming	State */
  | 'WY';

/**
 * Commonly used time zones. For a comprehensive list see:
 * https://en.wikipedia.org/wiki/List_of_tz_database_time_zones
 *
 * Next ID: 7
 */
export type OdProtosCommonTimezone_TimeZone =
  /** America/Chicago aka Central time. */
  | 'AMERICA_CHICAGO'
  /** America/Denver aka Mountain time. */
  | 'AMERICA_DENVER'
  /** America/Los_Angeles aka Pacific time */
  | 'AMERICA_LOS_ANGELES'
  /** America/New_York aka Eastern time. */
  | 'AMERICA_NEW_YORK'
  /**
   * America/Phoenix. Observed in most parts of Arizona, this time zone is
   * Mountain time without DST.
   */
  | 'AMERICA_PHOENIX'
  | 'UNKNOWN'
  /** Coordinated Universal Time */
  | 'UTC';

export type OdProtosCommon_Area_Unit =
  | 'SQUARE_INCH'
  | 'SQUARE_METER'
  | 'UNKNOWN';

export type OdProtosCommon_DateInput = {
  /**
   * Day of month. Must be from 1 to 31 and valid for the year and month, or 0
   * if specifying a year/month where the day is not significant.
   */
  day?: InputMaybe<Scalars['Float']>;
  /** Month of year. Must be from 1 to 12. */
  month?: InputMaybe<Scalars['Float']>;
  /**
   * Year of date. Must be from 1 to 9999, or 0 if specifying a date without
   * a year.
   */
  year?: InputMaybe<Scalars['Float']>;
};

export type OdProtosCommon_DayOfWeek =
  | 'FRIDAY'
  | 'MONDAY'
  | 'SATURDAY'
  | 'SUNDAY'
  | 'THURSDAY'
  | 'TUESDAY'
  | 'UNKNOWN'
  | 'WEDNESDAY';

/** An amount of time. */
export type OdProtosCommon_DurationInput = {
  unit?: InputMaybe<OdProtosCommon_Duration_Unit>;
  value?: InputMaybe<Scalars['Float']>;
};

export type OdProtosCommon_Duration_Unit =
  | 'DAY'
  | 'HOUR'
  | 'MINUTE'
  | 'MONTH'
  | 'SECOND'
  | 'UNKWOWN'
  | 'WEEK'
  | 'YEAR';

/** Next ID: 2 */
export type OdProtosCommon_EmailAddressInput = {
  /** Full e-mail address */
  value?: InputMaybe<Scalars['String']>;
};

export type OdProtosCommon_FloatRangeInput = {
  max?: InputMaybe<Scalars['Float']>;
  min?: InputMaybe<Scalars['Float']>;
};

/**
 * Represents a mailing address
 * NextID: 7
 */
export type OdProtosCommon_MailingAddressInput = {
  /** City, Suburb, etc */
  city?: InputMaybe<Scalars['String']>;
  /** Full name of the country */
  country?: InputMaybe<Scalars['String']>;
  /** Street number, Street name and direction */
  line1?: InputMaybe<Scalars['String']>;
  /** Unit/Apartment number, etc */
  line2?: InputMaybe<Scalars['String']>;
  /** State code (e.g. AZ) */
  state?: InputMaybe<Scalars['String']>;
  /** Zip/Postal code */
  zip?: InputMaybe<Scalars['String']>;
};

/** Next Id: 3 */
export type OdProtosCommon_MeasurementUnit =
  | 'EACH'
  | 'LINEAR_FT'
  | 'SQ_FT';

/** Next ID: 3 */
export type OdProtosCommon_MoneyInput = {
  /** defaults to USD */
  currencyCode?: InputMaybe<OdProtosCommon_Money_AlphabeticCurrencyCode>;
  /** value in lowest unit, e.g. this would be cents in USD */
  value?: InputMaybe<Scalars['Float']>;
};

export type OdProtosCommon_MoneyRangeInput = {
  max?: InputMaybe<OdProtosCommon_MoneyInput>;
  min?: InputMaybe<OdProtosCommon_MoneyInput>;
};

/**
 * defaults to USD;
 * sourced on 2017-04-27 from https://www.iso.org/iso-4217-currency-codes.html
 */
export type OdProtosCommon_Money_AlphabeticCurrencyCode =
  | 'AED'
  | 'AFN'
  | 'ALL'
  | 'AMD'
  | 'ANG'
  | 'AOA'
  | 'ARS'
  | 'AUD'
  | 'AWG'
  | 'AZN'
  | 'BAM'
  | 'BBD'
  | 'BDT'
  | 'BGN'
  | 'BHD'
  | 'BIF'
  | 'BMD'
  | 'BND'
  | 'BOB'
  | 'BOV'
  | 'BRL'
  | 'BSD'
  | 'BTN'
  | 'BWP'
  | 'BYN'
  | 'BZD'
  | 'CAD'
  | 'CDF'
  | 'CHE'
  | 'CHF'
  | 'CHW'
  | 'CLF'
  | 'CLP'
  | 'CNY'
  | 'COP'
  | 'COU'
  | 'CRC'
  | 'CUC'
  | 'CUP'
  | 'CVE'
  | 'CZK'
  | 'DJF'
  | 'DKK'
  | 'DOP'
  | 'DZD'
  | 'EGP'
  | 'ERN'
  | 'ETB'
  | 'EUR'
  | 'FJD'
  | 'FKP'
  | 'GBP'
  | 'GEL'
  | 'GHS'
  | 'GIP'
  | 'GMD'
  | 'GNF'
  | 'GTQ'
  | 'GYD'
  | 'HKD'
  | 'HNL'
  | 'HRK'
  | 'HTG'
  | 'HUF'
  | 'IDR'
  | 'ILS'
  | 'INR'
  | 'IQD'
  | 'IRR'
  | 'ISK'
  | 'JMD'
  | 'JOD'
  | 'JPY'
  | 'KES'
  | 'KGS'
  | 'KHR'
  | 'KMF'
  | 'KPW'
  | 'KRW'
  | 'KWD'
  | 'KYD'
  | 'KZT'
  | 'LAK'
  | 'LBP'
  | 'LKR'
  | 'LRD'
  | 'LSL'
  | 'LYD'
  | 'MAD'
  | 'MDL'
  | 'MGA'
  | 'MKD'
  | 'MMK'
  | 'MNT'
  | 'MOP'
  | 'MRO'
  | 'MUR'
  | 'MVR'
  | 'MWK'
  | 'MXN'
  | 'MXV'
  | 'MYR'
  | 'MZN'
  | 'NAD'
  | 'NGN'
  | 'NIO'
  | 'NOK'
  | 'NPR'
  | 'NZD'
  | 'OMR'
  | 'PAB'
  | 'PEN'
  | 'PGK'
  | 'PHP'
  | 'PKR'
  | 'PLN'
  | 'PYG'
  | 'QAR'
  | 'RON'
  | 'RSD'
  | 'RUB'
  | 'RWF'
  | 'SAR'
  | 'SBD'
  | 'SCR'
  | 'SDG'
  | 'SEK'
  | 'SGD'
  | 'SHP'
  | 'SLL'
  | 'SOS'
  | 'SRD'
  | 'SSP'
  | 'STD'
  | 'SVC'
  | 'SYP'
  | 'SZL'
  | 'THB'
  | 'TJS'
  | 'TMT'
  | 'TND'
  | 'TOP'
  | 'TRY'
  | 'TTD'
  | 'TWD'
  | 'TZS'
  | 'UAH'
  | 'UGX'
  | 'USD'
  | 'USN'
  | 'UYI'
  | 'UYU'
  | 'UZS'
  | 'VEF'
  | 'VND'
  | 'VUV'
  | 'WST'
  | 'XAF'
  | 'XAG'
  | 'XAU'
  | 'XBA'
  | 'XBB'
  | 'XBC'
  | 'XBD'
  | 'XCD'
  | 'XDR'
  | 'XOF'
  | 'XPD'
  | 'XPF'
  | 'XPT'
  | 'XSU'
  | 'XTS'
  | 'XUA'
  | 'XXX'
  | 'YER'
  | 'ZAR'
  | 'ZMW'
  | 'ZWL';

/** Next ID: 3 */
export type OdProtosCommon_NameInput = {
  /** Last name */
  familyName?: InputMaybe<Scalars['String']>;
  /** First name */
  givenName?: InputMaybe<Scalars['String']>;
};

/** Next ID: 2 */
export type OdProtosCommon_PhoneNumberInput = {
  /** Fully qualified phone number */
  value?: InputMaybe<Scalars['String']>;
};

/** Client-provided generated uuid for tracing the request. */
export type OdProtosCommon_RequestIdInput = {
  value?: InputMaybe<Scalars['String']>;
};

/** Registered client identifier */
export type OdProtosCommon_RequestorIdInput = {
  value?: InputMaybe<Scalars['String']>;
};

export type OdProtosCommon_SortDirection =
  | 'ASC'
  | 'DESC';

export type OdProtosCommon_TimeInput = {
  /** Hours of a time, where 0 is midnight, 12 is noon, and 13 is 1pm. */
  hours?: InputMaybe<Scalars['Float']>;
  /** Minutes of a time. */
  minutes?: InputMaybe<Scalars['Float']>;
};

export type OdProtosCommon_UInt32RangeInput = {
  max?: InputMaybe<Scalars['Float']>;
  min?: InputMaybe<Scalars['Float']>;
};

export type OdProtosCommunicationData_AddressInput = {
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  street?: InputMaybe<Scalars['String']>;
  unitNumber?: InputMaybe<Scalars['String']>;
  unitType?: InputMaybe<Scalars['String']>;
};

/**
 * unknown: an invalid state, indicating a system error
 * completed: call was handled successfully
 * canceled: call ended before completion (e.g. customer hangup, system error)
 * in_progress: call is ongoing
 * queued: the call has been queued, but has not started yet. this generally applies to outbound calls
 */
export type OdProtosCommunicationData_CallStatus =
  | 'CALL_STATUS_UNKNOWN'
  | 'CANCELED'
  | 'COMPLETED'
  | 'IN_PROGRESS'
  | 'QUEUED';

/**
 * Provides context around outgoing SMS messages. These are stored in Opencomm and used for analytics purposes.
 * To be included in mutation APIs (sends)
 */
export type OdProtosCommunicationData_CommunicationContextInput = {
  /** UUID of communication this message is replying to, if available */
  inReplyToUuid?: InputMaybe<Scalars['String']>;
  isAutomated?: InputMaybe<Scalars['Boolean']>;
  locale?: InputMaybe<OdProtosCommunicationData_Locale>;
  offerUuid?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Array<OdProtosCommunicationData_CommunicationTag>>;
  zendeskTicketUuid?: InputMaybe<Scalars['String']>;
};

/** see https://opendoor.atlassian.net/wiki/spaces/CO/pages/2053898320/Telephony+Strategy+Phone+numbers+categories */
export type OdProtosCommunicationData_CommunicationDirection =
  | 'DIRECTION_UNKNOWN'
  | 'INBOUND'
  | 'OUTBOUND';

export type OdProtosCommunicationData_CommunicationTag =
  | 'COMMUNICATION_TAG_UNSPECIFIED'
  | 'EP_TO_SUPPORT_CALL_TRANSFER'
  | 'FINAL_OFFER_CALL'
  | 'OFFER_REVIEW_CALL'
  | 'SPREAD_REDUCTION_CALL';

export type OdProtosCommunicationData_ContactNotMadeReason =
  | 'CONTACT_NOT_MADE_REASON_BUSY'
  | 'CONTACT_NOT_MADE_REASON_FAILED'
  | 'CONTACT_NOT_MADE_REASON_NO_ANSWER'
  | 'CONTACT_NOT_MADE_REASON_UNSPECIFIED'
  | 'CONTACT_NOT_MADE_REASON_VOICEMAIL';

export type OdProtosCommunicationData_DevicePlatform =
  | 'DEVICE_PLATFORM_ANDROID'
  | 'DEVICE_PLATFORM_IOS'
  | 'DEVICE_PLATFORM_UNSPECIFIED';

export type OdProtosCommunicationData_DeviceRegistrationState =
  | 'DEVICE_REGISTRATION_STATE_ACTIVE'
  | 'DEVICE_REGISTRATION_STATE_PENDING'
  | 'DEVICE_REGISTRATION_STATE_PENDING_DEACTIVATION'
  | 'DEVICE_REGISTRATION_STATE_UNSPECIFIED';

export type OdProtosCommunicationData_EmailStatusEventType =
  | 'BOUNCED'
  | 'CLICKED'
  | 'EMAIL_STATUS_EVENT_TYPE_UNKNOWN'
  | 'MARKED_SPAM'
  | 'OPENED';

export type OdProtosCommunicationData_Locale =
  | 'LOCALE_EN'
  | 'LOCALE_ES'
  | 'LOCALE_UNSPECIFIED';

/**
 * see https://opendoor.atlassian.net/wiki/spaces/CO/pages/2053898320/Telephony+Strategy+Phone+numbers+categories
 * next field index: 14
 */
export type OdProtosCommunicationData_PhoneNumberCategory =
  /** Access related */
  | 'ACCESS'
  | 'AI_AGENT'
  | 'BUY_DIRECT'
  | 'CHATBOT'
  /** Direct line to a specific person via Twilio Flex */
  | 'DIRECT'
  /** Direct line to a specific person via Mobile Phone */
  | 'DIRECT_MOBILE'
  | 'EXPERIMENTAL'
  | 'INFRASTRUCTURE'
  /** Quarantine is no longer a category but a flag on a phone number */
  | 'QUARANTINE'
  /**
   * Deprecated
   * Phone numbers pooled to anonymize the correspondents
   * https://opendoor.atlassian.net/wiki/spaces/CONSUMER/pages/2402222221/Agent+Relay+WIP
   */
  | 'RELAY_POOL'
  /** general support */
  | 'SUPPORT'
  | 'TESTING'
  | 'UNKNOWN'
  /** Visitor workflow */
  | 'VISITOR';

export type OdProtosCommunicationData_PhoneNumberSpecificationInput = {
  category?: InputMaybe<OdProtosCommunicationData_PhoneNumberCategory>;
  market?: InputMaybe<OdProtosCommonMarket_Market>;
};

/** Push notification states */
export type OdProtosCommunicationData_PushNotificationState =
  | 'PUSH_NOTIFICATION_STATE_ACCEPTED'
  | 'PUSH_NOTIFICATION_STATE_FAILED'
  | 'PUSH_NOTIFICATION_STATE_SENT'
  | 'PUSH_NOTIFICATION_STATE_UNSPECIFIED';

export type OdProtosCommunicationData_SendEmailOptionsInput = {
  /**
   * when non-zero, opencomm will prevent sending the same email (same recipients, same email content) within
   * the specified time window, in seconds
   */
  dedupeWindowSeconds?: InputMaybe<Scalars['Float']>;
  /**
   * Transactional emails are one-time notifications such as password resets and purchase confirmations
   * They maintain separate unsubscribe lists from things like marketing emails
   */
  transactional?: InputMaybe<Scalars['Boolean']>;
};

export type OdProtosCommunicationData_SendSmsOptionsInput = {
  /**
   * Opencomm will prevent sending the same SMS (same recipient, same content) within the specified time window, in seconds
   * By default, opencomm will dedupe within an hour window - set this value to override this behavior.
   * Set it to 0 to disable dedupe
   */
  dedupeWindowSeconds?: InputMaybe<Scalars['Float']>;
  shortenUrl?: InputMaybe<Scalars['Boolean']>;
};

export type OdProtosCommunicationData_SmsStatus =
  | 'FAILED'
  | 'PENDING'
  | 'SENT';

export type OdProtosCommunicationData_TranscriptRole =
  | 'TRANSCRIPT_ROLE_AGENT'
  | 'TRANSCRIPT_ROLE_CUSTOMER'
  | 'TRANSCRIPT_ROLE_UNSPECIFIED';

export type OdProtosCommunicationData_TranscriptionStatus =
  | 'TRANSCRIPTION_COMPLETED'
  | 'TRANSCRIPTION_FAILED'
  | 'TRANSCRIPTION_PROCESSING'
  | 'TRANSCRIPTION_STATUS_UNSPECIFIED';

/** Call analysis enums and messages */
export type OdProtosCommunicationData_UserSentiment =
  | 'USER_SENTIMENT_NEGATIVE'
  | 'USER_SENTIMENT_NEUTRAL'
  | 'USER_SENTIMENT_POSITIVE'
  | 'USER_SENTIMENT_UNSPECIFIED';

/**
 * unspecified: an invalid state, indicating some error
 * processing: voicemail is processing
 * completed: voicemail is processed and ready for use
 * canceled: voicemail experienced some error, no longer available
 */
export type OdProtosCommunicationData_VoicemailStatus =
  | 'VOICEMAIL_CANCELED'
  | 'VOICEMAIL_COMPLETED'
  | 'VOICEMAIL_PROCESSING'
  | 'VOICEMAIL_STATUS_UNSPECIFIED';

export type OdProtosCommunicationServices_ApplyCategoryConfigurationRequestInput = {
  applyToAll?: InputMaybe<Scalars['Boolean']>;
  numbersToUpdate?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosCommunicationServices_BlockIncomingPhoneNumberRequestInput = {
  incomingPhoneNumber?: InputMaybe<OdProtosCommon_PhoneNumberInput>;
  reason?: InputMaybe<Scalars['String']>;
};

export type OdProtosCommunicationServices_BuyAccessPhoneNumberRequestInput = {
  friendlyName?: InputMaybe<Scalars['String']>;
  market?: InputMaybe<OdProtosCommonMarket_Market>;
  /** Opencomm will determine it by category */
  messagingServiceSid?: InputMaybe<Scalars['String']>;
  phoneAreaCode?: InputMaybe<Scalars['String']>;
};

export type OdProtosCommunicationServices_BuyPhoneNumberForUserRequestInput = {
  friendlyName?: InputMaybe<Scalars['String']>;
  market?: InputMaybe<OdProtosCommonMarket_Market>;
  ownerId?: InputMaybe<Scalars['String']>;
  phoneAreaCode?: InputMaybe<Scalars['String']>;
  useMobilePhone?: InputMaybe<Scalars['Boolean']>;
};

export type OdProtosCommunicationServices_BuySupportPhoneNumberRequestInput = {
  friendlyName?: InputMaybe<Scalars['String']>;
  market?: InputMaybe<OdProtosCommonMarket_Market>;
  /** Opencomm will determine it by category */
  messagingServiceSid?: InputMaybe<Scalars['String']>;
  phoneAreaCode?: InputMaybe<Scalars['String']>;
};

export type OdProtosCommunicationServices_CreateProviderCallRequestInput = {
  /** Call configuration specific to the use case */
  callConfig?: InputMaybe<OdProtosCommunicationServices_CreateProviderCallRequest_CallConfigOneofInput>;
  communicationContext?: InputMaybe<OdProtosCommunicationData_CommunicationContextInput>;
  /** Phone number to call from (should be an Opendoor-owned AI_AGENT type number) */
  fromPhoneNumber?: InputMaybe<Scalars['String']>;
  /** Provider-specific configuration (required - selects provider) */
  providerConfig?: InputMaybe<OdProtosCommunicationServices_CreateProviderCallRequest_ProviderConfigOneofInput>;
  /** Phone number to call to (e.g. customer phone number) */
  toPhoneNumber?: InputMaybe<Scalars['String']>;
};

export type OdProtosCommunicationServices_CreateProviderCallRequest_CallConfigOneofInput = {
  offerReview?: InputMaybe<OdProtosCommunicationServices_OfferReviewCallConfigInput>;
  scheduleAssessment?: InputMaybe<OdProtosCommunicationServices_ScheduleAssessmentCallConfigInput>;
};

export type OdProtosCommunicationServices_CreateProviderCallRequest_ProviderConfigOneofInput = {
  retellAi?: InputMaybe<OdProtosCommunicationServices_RetellAiProviderConfigInput>;
};

export type OdProtosCommunicationServices_GetCallAnalysesByPhoneCallIdsRequestInput = {
  phoneCallIds?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosCommunicationServices_GetCommDataForCommIdsRequestInput = {
  communicationids?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosCommunicationServices_GetDeviceRegistrationsByUserEmailRequestInput = {
  userEmail?: InputMaybe<Scalars['String']>;
};

export type OdProtosCommunicationServices_GetEmailsForCustomerRequestInput = {
  customerId?: InputMaybe<Scalars['String']>;
  pagination?: InputMaybe<OdProtosCommonPagination_OffsetPaginationRequestInput>;
};

export type OdProtosCommunicationServices_GetOpendoorPhoneNumberByNumberRequestInput = {
  number?: InputMaybe<OdProtosCommon_PhoneNumberInput>;
};

export type OdProtosCommunicationServices_GetOpendoorPhoneNumbersForUserRequestInput = {
  ownerId?: InputMaybe<Scalars['String']>;
};

export type OdProtosCommunicationServices_GetPhoneCallsByIdsRequestInput = {
  ids?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosCommunicationServices_GetPhoneCallsForCustomerRequestInput = {
  customerId?: InputMaybe<Scalars['String']>;
  pagination?: InputMaybe<OdProtosCommonPagination_OffsetPaginationRequestInput>;
};

export type OdProtosCommunicationServices_GetPhoneCallsRequestInput = {
  identifier?: InputMaybe<OdProtosCommunicationServices_GetPhoneCallsRequest_IdentifierOneofInput>;
  pagination?: InputMaybe<OdProtosCommonPagination_OffsetPaginationRequestInput>;
};

export type OdProtosCommunicationServices_GetPhoneCallsRequest_IdentifierOneofInput = {
  customerId?: InputMaybe<Scalars['String']>;
  offerId?: InputMaybe<Scalars['String']>;
  operatorId?: InputMaybe<Scalars['String']>;
};

export type OdProtosCommunicationServices_GetSmsMessageRequestInput = {
  smsId?: InputMaybe<Scalars['String']>;
};

export type OdProtosCommunicationServices_GetSmsMessagesForCustomerRequestInput = {
  customerId?: InputMaybe<Scalars['String']>;
  pagination?: InputMaybe<OdProtosCommonPagination_OffsetPaginationRequestInput>;
};

export type OdProtosCommunicationServices_GetStructuredTranscriptsByCommunicationIdsRequestInput = {
  communicationIds?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosCommunicationServices_GetTranscriptsForPhoneCallsRequestInput = {
  endDate?: InputMaybe<Scalars['DateTime']>;
  /** Use to fetch all records in a given date range, use it without the identifier */
  fetchAll?: InputMaybe<Scalars['Boolean']>;
  identifier?: InputMaybe<OdProtosCommunicationServices_GetTranscriptsForPhoneCallsRequest_IdentifierOneofInput>;
  pagination?: InputMaybe<OdProtosCommonPagination_OffsetPaginationRequestInput>;
  startDate?: InputMaybe<Scalars['DateTime']>;
};

export type OdProtosCommunicationServices_GetTranscriptsForPhoneCallsRequest_CommunicationIdsInput = {
  communicationId?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosCommunicationServices_GetTranscriptsForPhoneCallsRequest_CustomerIdsInput = {
  customerId?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosCommunicationServices_GetTranscriptsForPhoneCallsRequest_IdentifierOneofInput = {
  communicationIds?: InputMaybe<OdProtosCommunicationServices_GetTranscriptsForPhoneCallsRequest_CommunicationIdsInput>;
  customerIds?: InputMaybe<OdProtosCommunicationServices_GetTranscriptsForPhoneCallsRequest_CustomerIdsInput>;
  offerIds?: InputMaybe<OdProtosCommunicationServices_GetTranscriptsForPhoneCallsRequest_OfferIdsInput>;
  operatorIds?: InputMaybe<OdProtosCommunicationServices_GetTranscriptsForPhoneCallsRequest_OperatorIdsInput>;
};

export type OdProtosCommunicationServices_GetTranscriptsForPhoneCallsRequest_OfferIdsInput = {
  offerId?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosCommunicationServices_GetTranscriptsForPhoneCallsRequest_OperatorIdsInput = {
  operatorId?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosCommunicationServices_GetVoicemailRequestInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type OdProtosCommunicationServices_GetVoicemailsRequestInput = {
  identifier?: InputMaybe<OdProtosCommunicationServices_GetVoicemailsRequest_IdentifierOneofInput>;
  pagination?: InputMaybe<OdProtosCommonPagination_OffsetPaginationRequestInput>;
};

export type OdProtosCommunicationServices_GetVoicemailsRequest_IdentifierOneofInput = {
  customerId?: InputMaybe<Scalars['String']>;
};

export type OdProtosCommunicationServices_InitiatePhoneCallRequestInput = {
  communicationContext?: InputMaybe<OdProtosCommunicationData_CommunicationContextInput>;
  /**
   * Phone number of Opendoor user initiating the call
   * This MUST be a "DIRECT" number for which the caller is the owner of the number
   */
  fromPhoneNumber?: InputMaybe<Scalars['String']>;
  /** Recipient (customer, vendor, ...) phone number */
  toPhoneNumber?: InputMaybe<Scalars['String']>;
};

export type OdProtosCommunicationServices_OfferReviewCallConfigInput = {
  customerName?: InputMaybe<Scalars['String']>;
  insights?: InputMaybe<Array<OdProtosCommunicationServices_OfferReviewCallConfig_InsightsEntryInput>>;
  propertyAddress?: InputMaybe<OdProtosCommunicationData_AddressInput>;
};

/** `OdProtosCommunicationServices_OfferReviewCallConfig_InsightsEntryInput` represents the `insights` map in `od_protos.communication.services.OfferReviewCallConfig`. */
export type OdProtosCommunicationServices_OfferReviewCallConfig_InsightsEntryInput = {
  key?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

export type OdProtosCommunicationServices_RecordIncomingEmailRequestInput = {
  attachments?: InputMaybe<Array<OdProtosCabinetData_AssetInput>>;
  content?: InputMaybe<Scalars['String']>;
  fromAddress?: InputMaybe<Scalars['String']>;
  subject?: InputMaybe<Scalars['String']>;
  toAddresses?: InputMaybe<Array<Scalars['String']>>;
  toBccAddresses?: InputMaybe<Array<Scalars['String']>>;
  toCcAddresses?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosCommunicationServices_RecordOutgoingEmailRequestInput = {
  attachments?: InputMaybe<Array<OdProtosCabinetData_AssetInput>>;
  content?: InputMaybe<Scalars['String']>;
  fromAddress?: InputMaybe<Scalars['String']>;
  senderId?: InputMaybe<Scalars['String']>;
  subject?: InputMaybe<Scalars['String']>;
  toAddresses?: InputMaybe<Array<Scalars['String']>>;
  toBccAddresses?: InputMaybe<Array<Scalars['String']>>;
  toCcAddresses?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosCommunicationServices_RegisterDeviceRequestInput = {
  appVersion?: InputMaybe<Scalars['String']>;
  applicationId?: InputMaybe<Scalars['String']>;
  deviceId?: InputMaybe<Scalars['String']>;
  platform?: InputMaybe<OdProtosCommunicationData_DevicePlatform>;
  userEmail?: InputMaybe<Scalars['String']>;
};

export type OdProtosCommunicationServices_ReleasePhoneNumberRequestInput = {
  number?: InputMaybe<OdProtosCommon_PhoneNumberInput>;
};

export type OdProtosCommunicationServices_RetellAiProviderConfigInput = {
  /** Optional agent configuration (e.g. for A/B testing) */
  overrideAgentId?: InputMaybe<Scalars['String']>;
  overrideAgentVersion?: InputMaybe<Scalars['String']>;
};

export type OdProtosCommunicationServices_ScheduleAssessmentCallConfigInput = {
  /**
   * Available time slots in format "YYYY-MM-DD morning" or "YYYY-MM-DD afternoon"
   * Example: ["2024-01-15 morning", "2024-01-15 afternoon", "2024-01-16 morning"]
   * Sorted chronologically with mornings before afternoons on the same day
   */
  availableTimeSlots?: InputMaybe<Array<Scalars['String']>>;
  customerName?: InputMaybe<Scalars['String']>;
  propertyAddress?: InputMaybe<OdProtosCommunicationData_AddressInput>;
};

export type OdProtosCommunicationServices_SendEmailRequestInput = {
  additionalHeaders?: InputMaybe<Array<OdProtosCommunicationServices_SendEmailRequest_AdditionalHeadersEntryInput>>;
  /**
   * optional - map of asset ids to attachment file names
   * if not provided, the "Name" of the asset will be used
   */
  attachmentAliases?: InputMaybe<Array<OdProtosCommunicationServices_SendEmailRequest_AttachmentAliasesEntryInput>>;
  attachments?: InputMaybe<Array<OdProtosCabinetData_AssetInput>>;
  content?: InputMaybe<Scalars['String']>;
  /**
   * from_address and any email recipients can be formatted either as email and name, e.g. "Support <support@opendoor.com>",
   * or just the email address, e.g. support@opendoor.com
   */
  fromAddress?: InputMaybe<Scalars['String']>;
  options?: InputMaybe<OdProtosCommunicationData_SendEmailOptionsInput>;
  /**
   * optional - if not provided, this will be inferred from the request context and then the from_address
   * if not inferrable, this will default to communication service token
   */
  senderId?: InputMaybe<Scalars['String']>;
  subject?: InputMaybe<Scalars['String']>;
  toAddresses?: InputMaybe<Array<Scalars['String']>>;
  toBccAddresses?: InputMaybe<Array<Scalars['String']>>;
  toCcAddresses?: InputMaybe<Array<Scalars['String']>>;
};

/** `OdProtosCommunicationServices_SendEmailRequest_AdditionalHeadersEntryInput` represents the `additional_headers` map in `od_protos.communication.services.SendEmailRequest`. */
export type OdProtosCommunicationServices_SendEmailRequest_AdditionalHeadersEntryInput = {
  key?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** `OdProtosCommunicationServices_SendEmailRequest_AttachmentAliasesEntryInput` represents the `attachment_aliases` map in `od_protos.communication.services.SendEmailRequest`. */
export type OdProtosCommunicationServices_SendEmailRequest_AttachmentAliasesEntryInput = {
  key?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

export type OdProtosCommunicationServices_SendPushNotificationRequestInput = {
  campaignId?: InputMaybe<Scalars['Float']>;
  dataFields?: InputMaybe<Array<OdProtosCommunicationServices_SendPushNotificationRequest_DataFieldsEntryInput>>;
  userEmails?: InputMaybe<Array<Scalars['String']>>;
};

/** `OdProtosCommunicationServices_SendPushNotificationRequest_DataFieldsEntryInput` represents the `data_fields` map in `od_protos.communication.services.SendPushNotificationRequest`. */
export type OdProtosCommunicationServices_SendPushNotificationRequest_DataFieldsEntryInput = {
  key?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** To */
export type OdProtosCommunicationServices_SendSmsRequestInput = {
  /** Sms attachments */
  assets?: InputMaybe<Array<OdProtosCabinetData_AssetInput>>;
  communicationContext?: InputMaybe<OdProtosCommunicationData_CommunicationContextInput>;
  content?: InputMaybe<Scalars['String']>;
  /**
   * If the from_phone_number or phone specification is not provided the service will throw an error
   * Optional: to_phone_number will be used if provided
   */
  fromPhoneNumber?: InputMaybe<Scalars['String']>;
  /** DEPRECATED: message service SID to use (pool of messaging numbers) */
  messagingServiceSid?: InputMaybe<Scalars['String']>;
  options?: InputMaybe<OdProtosCommunicationData_SendSmsOptionsInput>;
  /** Optional: the type of phone number to use (category and optionally market) */
  phoneNumberSpecification?: InputMaybe<OdProtosCommunicationData_PhoneNumberSpecificationInput>;
  /** human token of the sender, if not specified the user in the request context will be used if available */
  senderId?: InputMaybe<Scalars['String']>;
  /**
   * Optional: if to_phone_number is not provided, phone numbers from the customer will be tried
   * if to_phone_number is provided but fails, phone numbers from the customer will be tried
   */
  toCustomerId?: InputMaybe<Scalars['String']>;
  /**
   * At least one of to_phone_number or to_customer_id must be provided
   * Optional: to_phone_number will be used if provided
   */
  toPhoneNumber?: InputMaybe<Scalars['String']>;
};

export type OdProtosCommunicationServices_TrackPushOpenRequestInput = {
  messageId?: InputMaybe<Scalars['String']>;
  /** At least one of push_notification_id or message_id must be provided */
  pushNotificationId?: InputMaybe<Scalars['String']>;
};

export type OdProtosCommunicationServices_UnblockIncomingPhoneNumberRequestInput = {
  incomingPhoneNumber?: InputMaybe<OdProtosCommon_PhoneNumberInput>;
};

export type OdProtosCommunicationServices_UnregisterDeviceRequestInput = {
  deviceId?: InputMaybe<Scalars['String']>;
  userEmail?: InputMaybe<Scalars['String']>;
};

/**
 * Direction describes whether the communication is initiated by the Contact (OUTBOUND),
 * or initiated by another party to the Contact (INBOUND).
 *
 * Next ID: 3
 */
export type OdProtosCustardV1Data_ContactEvent_CommunicationEvent_Direction =
  | 'INBOUND'
  | 'INVALID'
  | 'OUTBOUND';

/**
 * Classifications for the type of phone number of the Contact.
 *
 * Next ID: 4
 */
export type OdProtosCustardV1Data_Phone_PhoneType =
  | 'HOME'
  | 'MOBILE'
  | 'OTHER'
  | 'WORK';

/** Don't use this. See below. */
export type OdProtosCustardV1Data_TrustLevel =
  | 'BLACKLISTED'
  | 'GRAYLISTED'
  | 'NEEDS_REVIEW'
  | 'UNKNOWN'
  | 'WHITELISTED';

/**
 * [To Be] DEPRECATED: Use OdProtosCustardV1Services_CustomerRequests_Get
 *
 * Next ID: 2
 */
export type OdProtosCustardV1Services_ContactRequests_GetInput = {
  id?: InputMaybe<Scalars['String']>;
};

/**
 * [To Be] DEPRECATED: Use OdProtosCustardV1Services_CustomerRequests_Update
 * for update agent status. Other roles cannot be set.
 *
 * Next ID: 3
 */
export type OdProtosCustardV1Services_ContactRequests_MarkRoleInput = {
  contactId?: InputMaybe<Scalars['String']>;
  roleToMark?: InputMaybe<OdProtosCustardV1Services_ContactRequests_Role>;
};

/**
 * The different roles that a Contact can be marked as.
 *
 * Next ID: 3
 */
export type OdProtosCustardV1Services_ContactRequests_Role =
  | 'AGENT'
  | 'CUSTOMER'
  | 'VENDOR';

/**
 * [To Be] DEPRECATED: Use OdProtosCustardV1Services_CustomerRequests_Update
 * for update agent status. Other roles cannot be set.
 *
 * Next ID: 3
 */
export type OdProtosCustardV1Services_ContactRequests_UnmarkRoleInput = {
  contactId?: InputMaybe<Scalars['String']>;
  roleToUnmark?: InputMaybe<OdProtosCustardV1Services_ContactRequests_Role>;
};

/** The status of a mortgage lead's pre-qualification or pre-approval */
export type OdProtosCustomerFinancingServiceData_ApplicationStatus =
  | 'APPROVED'
  | 'DENIED'
  | 'SUBMITTED'
  | 'UNKNOWN_STATUS';

/** Employment status for mortgage application */
export type OdProtosCustomerFinancingServiceData_EmploymentStatus =
  | 'EMPLOYED'
  | 'OTHER'
  | 'RETIRED'
  | 'SELF_EMPLOYED'
  | 'UNEMPLOYED'
  | 'UNKNOWN_EMPLOYMENT_STATUS';

/** The type of property for mortgage application */
export type OdProtosCustomerFinancingServiceData_PropertyType =
  | 'INVESTMENT_PROPERTY'
  | 'PRIMARY_RESIDENCE'
  | 'SECONDARY_RESIDENCE'
  | 'UNKNOWN_PROPERTY_TYPE';

/** Next ID: 6 */
export type OdProtosCustomerFinancingServiceServices_CustomerFinancingRequests_CreateAgentMortgageLeadInput = {
  additionalComments?: InputMaybe<Scalars['String']>;
  addressToken?: InputMaybe<Scalars['String']>;
  channel?: InputMaybe<Scalars['String']>;
  customerUuid?: InputMaybe<Scalars['String']>;
  leadType?: InputMaybe<Scalars['String']>;
  market?: InputMaybe<OdProtosCommonMarket_Market>;
};

/** Next ID: 2 */
export type OdProtosCustomerFinancingServiceServices_CustomerFinancingRequests_CreateCustomerMortgageLeadInput = {
  customerUuid?: InputMaybe<Scalars['String']>;
};

/** Next ID: 17 */
export type OdProtosCustomerFinancingServiceServices_CustomerFinancingRequests_CreateMortgageLeadInput = {
  addressToken?: InputMaybe<Scalars['String']>;
  channel?: InputMaybe<Scalars['String']>;
  currentAddress?: InputMaybe<Scalars['String']>;
  customerUuid?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  employmentStatus?: InputMaybe<OdProtosCustomerFinancingServiceData_EmploymentStatus>;
  firstName?: InputMaybe<Scalars['String']>;
  householdIncomeMax?: InputMaybe<Scalars['Float']>;
  householdIncomeMin?: InputMaybe<Scalars['Float']>;
  lastName?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  propertyType?: InputMaybe<OdProtosCustomerFinancingServiceData_PropertyType>;
  targetDownPayment?: InputMaybe<Scalars['Float']>;
  targetLocation?: InputMaybe<Scalars['String']>;
  targetMoveDate?: InputMaybe<Scalars['String']>;
  targetPrice?: InputMaybe<Scalars['Float']>;
};

export type OdProtosCustomerFinancingServiceServices_CustomerFinancingRequests_GetCurrentMortgageInterestRatesInput = {
  _empty?: InputMaybe<Scalars['Boolean']>;
};

export type OdProtosCustomerFinancingServiceServices_CustomerFinancingRequests_GetLatestMortgageLeadByCurrentUserInput = {
  _empty?: InputMaybe<Scalars['Boolean']>;
};

/** Next ID: 2 */
export type OdProtosCustomerFinancingServiceServices_CustomerFinancingRequests_GetLatestMortgageLeadByCustomerIdInput = {
  customerUuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosCustomerTosV1Services_Requests_GetTosStatusInput = {
  _empty?: InputMaybe<Scalars['Boolean']>;
};

export type OdProtosCustomerTosV1Services_Requests_TosAcceptedInput = {
  _empty?: InputMaybe<Scalars['Boolean']>;
};

export type OdProtosCustomerV1Data_Actor =
  | 'ACTOR_TYPE_UNSPECIFIED'
  | 'AUTOMATED'
  | 'CUSTOMER'
  | 'OPERATOR';

/**
 * Customer represents a customer's basic information
 *
 *
 * Next ID: 12
 */
export type OdProtosCustomerV1Data_CustomerInput = {
  ccpaSaleOfDataOptOut?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  firstName?: InputMaybe<Scalars['String']>;
  isAgent?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Scalars['String']>;
  /**
   * List of emails that this Customer has.
   * Primary email will not be included in this list.
   */
  otherEmails?: InputMaybe<Array<OdProtosCustomerV1Data_EmailInput>>;
  /**
   * List of phones that this Customer has.
   * Primary phone will not be included in this list.
   */
  otherPhoneNumbers?: InputMaybe<Array<OdProtosCustomerV1Data_PhoneInput>>;
  primaryEmail?: InputMaybe<OdProtosCustomerV1Data_EmailInput>;
  primaryPhoneNumber?: InputMaybe<OdProtosCustomerV1Data_PhoneInput>;
  uuid?: InputMaybe<Scalars['String']>;
};

/**
 * Email represents an email address of a customer and its corresponding
 * metadata with respect to that customer.
 *
 * Next ID: 2
 */
export type OdProtosCustomerV1Data_EmailInput = {
  /**
   * The e-mail address of this email object. This is also the primary identifier
   * of the email under the context of a specific customer.
   */
  address?: InputMaybe<OdProtosCommon_EmailAddressInput>;
};

export type OdProtosCustomerV1Data_FeedType =
  | 'FEED_TYPE_UNSPECIFIED'
  | 'MARKETING'
  | 'TRANSACTIONAL';

export type OdProtosCustomerV1Data_Medium =
  | 'CALL'
  | 'EMAIL'
  | 'MEDIUM_UNSPECIFIED'
  | 'SMS';

/**
 * Phone represents a phone number of a customer and its corresponding
 * metadata with respect to that customer.
 *
 * Next ID: 3
 */
export type OdProtosCustomerV1Data_PhoneInput = {
  /**
   * The phone number of this phone object. This is also the primary identifier
   * of the phone under the context of a specific customer.
   */
  number?: InputMaybe<OdProtosCommon_PhoneNumberInput>;
  /**
   * The type of phone number for the Contact.
   * e.g. home phone, mobile phone...
   */
  type?: InputMaybe<OdProtosCustomerV1Data_Phone_PhoneType>;
};

/**
 * Classifications for the type of phone number of the Contact.
 *
 * Next ID: 4
 */
export type OdProtosCustomerV1Data_Phone_PhoneType =
  | 'HOME'
  | 'MOBILE'
  | 'OTHER'
  | 'WORK';

export type OdProtosCustomerV1Data_SubscriptionStatus =
  /** This is when OD cannot resubscribe the customer (e.g. when the customer sends a STOP message) */
  | 'FORCE_UNSUBSCRIBED'
  | 'SUBSCRIBED'
  | 'SUBSCRIPTION_STATUS_UNSPECIFIED'
  | 'UNSUBSCRIBED';

/**
 * Create a new Customer
 *
 * Next ID: 2
 */
export type OdProtosCustomerV1Services_CustomerRequests_CreateInput = {
  newCustomer?: InputMaybe<OdProtosCustomerV1Data_CustomerInput>;
};

/** Get current sessions's customer */
export type OdProtosCustomerV1Services_CustomerRequests_GetCurrentCustomerInput = {
  _empty?: InputMaybe<Scalars['Boolean']>;
};

/**
 * Get Customer by a customer UUID
 *
 * Next ID: 2
 */
export type OdProtosCustomerV1Services_CustomerRequests_GetInput = {
  uuid?: InputMaybe<Scalars['String']>;
};

/**
 * Get the list of Customers by a list of customer UUIDs
 *
 * Next ID: 2
 */
export type OdProtosCustomerV1Services_CustomerRequests_GetListInput = {
  /** Limiting to a max of 100 customers */
  uuids?: InputMaybe<Array<Scalars['String']>>;
};

/**
 * Merge two existing customers that are duplicates.
 * Merges the info of the customer specified by merging_customer_uuid into the customer specified by keeping_customer_uuid.
 *
 * Next ID: 4
 */
export type OdProtosCustomerV1Services_CustomerRequests_MergeInput = {
  /** When dry_run is set to true, a preview merge result will be returned without actually performing the merge operation */
  dryRun?: InputMaybe<Scalars['Boolean']>;
  /** uuid specifies the keeping customer */
  keepingCustomerUuid?: InputMaybe<Scalars['String']>;
  /** uuid specifies the merging customer that will be deleted after the merge operation */
  mergingCustomerUuid?: InputMaybe<Scalars['String']>;
};

/**
 * Search for Customer(s) by specified filters
 *
 * When searching by email, and is_primary is not specified, returned customers are sorted in
 * the order of primary email matched, then non-primary email matched.
 * When searching by phone, returned customers are not sorted.
 *
 * Next ID: 6
 */
export type OdProtosCustomerV1Services_CustomerRequests_SearchInput = {
  customerSearchParams?: InputMaybe<OdProtosCustomerV1Services_CustomerRequests_Search_CustomerSearchParamsOneofInput>;
  /** limit cannot exceed 100. If limit is 0 then it will be set to the default of 100. */
  limit?: InputMaybe<Scalars['Float']>;
  onlyAgents?: InputMaybe<Scalars['Boolean']>;
};

export type OdProtosCustomerV1Services_CustomerRequests_Search_CustomerSearchParamsOneofInput = {
  emailParams?: InputMaybe<OdProtosCustomerV1Services_CustomerRequests_Search_EmailSearchParamsInput>;
  multiParams?: InputMaybe<OdProtosCustomerV1Services_CustomerRequests_Search_MultiSearchParamsInput>;
  phoneParams?: InputMaybe<OdProtosCustomerV1Services_CustomerRequests_Search_PhoneSearchParamsInput>;
};

/**
 * Email params to search for customers
 *
 * Next ID: 3
 */
export type OdProtosCustomerV1Services_CustomerRequests_Search_EmailSearchParamsInput = {
  email?: InputMaybe<Scalars['String']>;
  isPrimary?: InputMaybe<Scalars['Boolean']>;
};

/**
 * Params to search for a customer using multiple ways.
 * Will return customers in the order of:
 * 1. Primary email
 * 2. Email
 * 3. Phone number
 *
 * Next ID: 3
 */
export type OdProtosCustomerV1Services_CustomerRequests_Search_MultiSearchParamsInput = {
  email?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
};

/**
 * Phone params to search for customers
 *
 * Next ID: 2
 */
export type OdProtosCustomerV1Services_CustomerRequests_Search_PhoneSearchParamsInput = {
  phoneNumber?: InputMaybe<Scalars['String']>;
};

/**
 * Set Customer's primary phone number by either creating a new or updating an existing phone record
 *
 * Next ID: 2
 */
export type OdProtosCustomerV1Services_CustomerRequests_SetPrimaryPhoneNumberInput = {
  number?: InputMaybe<Scalars['String']>;
};

/**
 * UpdateCurrent will update an authenticated Customer's basic information.
 *
 * This endpoint will allow unauthenticated updating of customer information for "potential customers"
 * See implementation for definition of "potential customer"
 *
 * To use this endpoint without authentication information, provide customer_uuid of the customer to be updated
 * customer_uuid must match the authenticated customer if authentication information is present
 *
 *
 * Next ID: 6
 */
export type OdProtosCustomerV1Services_CustomerRequests_UpdateCurrentInput = {
  /**
   * UUID of the customer to be updated. This parameter MUST match the authenticated customer
   * if authentication information is present
   */
  customerUuid?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  isAgent?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Scalars['String']>;
  phones?: InputMaybe<Array<OdProtosCustomerV1Services_CustomerRequests_Update_Params_PhoneInput>>;
};

/**
 * Update will update a Customer's basic information.
 *
 * Next ID: 3
 */
export type OdProtosCustomerV1Services_CustomerRequests_UpdateInput = {
  /** params specifies a customer's parameters to update. */
  params?: InputMaybe<OdProtosCustomerV1Services_CustomerRequests_Update_ParamsInput>;
  /** uuid specifies the customer's UUID. */
  uuid?: InputMaybe<Scalars['String']>;
};

/**
 * Params specifies different parameters to update a Customer on.
 *
 * At least one parameter must be specified.
 *
 * Next ID: 6
 */
export type OdProtosCustomerV1Services_CustomerRequests_Update_ParamsInput = {
  emails?: InputMaybe<Array<OdProtosCustomerV1Services_CustomerRequests_Update_Params_EmailInput>>;
  firstName?: InputMaybe<Scalars['String']>;
  isAgent?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Scalars['String']>;
  phones?: InputMaybe<Array<OdProtosCustomerV1Services_CustomerRequests_Update_Params_PhoneInput>>;
};

/**
 * Email specifies the email to update/delete/create.
 *
 * Next ID: 3
 */
export type OdProtosCustomerV1Services_CustomerRequests_Update_Params_EmailInput = {
  new?: InputMaybe<OdProtosCustomerV1Services_CustomerRequests_Update_Params_Email_NewInput>;
  old?: InputMaybe<OdProtosCustomerV1Services_CustomerRequests_Update_Params_Email_OldInput>;
};

/**
 * New specifies the new email to update to.
 *
 * If nil is passed in, the customer's old email will be deleted.
 *
 * Next ID: 3
 */
export type OdProtosCustomerV1Services_CustomerRequests_Update_Params_Email_NewInput = {
  /**
   * The e-mail address of this email object. This is also the primary identifier
   * of the email under the context of a specific customer.
   */
  address?: InputMaybe<Scalars['String']>;
  /**
   * make_primary specifies whether or not to set the new email as primary. If a customer has
   * a different email set as primary, it will replace that primary with this new one.
   *
   * Setting make_primary to false will NOT unset an existing primary.
   */
  makePrimary?: InputMaybe<Scalars['Boolean']>;
};

/**
 * Old specifies the old email to update.
 *
 * If nil is passed in for the old email,
 * then a new email will be created based on
 * the new emails parameters.
 *
 * Next ID: 2
 */
export type OdProtosCustomerV1Services_CustomerRequests_Update_Params_Email_OldInput = {
  /**
   * The e-mail address of this email object. This is also the primary identifier
   * of the email under the context of a specific customer.
   */
  address?: InputMaybe<Scalars['String']>;
};

/**
 * Phone specifies the phone to update/delete/create.
 *
 * Next ID: 3
 */
export type OdProtosCustomerV1Services_CustomerRequests_Update_Params_PhoneInput = {
  new?: InputMaybe<OdProtosCustomerV1Services_CustomerRequests_Update_Params_Phone_NewInput>;
  old?: InputMaybe<OdProtosCustomerV1Services_CustomerRequests_Update_Params_Phone_OldInput>;
};

/**
 * New specifies the new phone to update to.
 *
 * If nil is passed in, the customer's old phone will be deleted.
 *
 * Next ID: 4
 */
export type OdProtosCustomerV1Services_CustomerRequests_Update_Params_Phone_NewInput = {
  /**
   * make_primary specifies whether or not to set the new phone as primary. If a customer has
   * a different phone set as primary, it will replace that primary with this new one.
   *
   * Setting make_primary to false will NOT unset an existing primary.
   */
  makePrimary?: InputMaybe<Scalars['Boolean']>;
  number?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<OdProtosCustomerV1Data_Phone_PhoneType>;
};

/**
 * Old specifies the old phone to update.
 *
 * The phone number and the phone type must match the customer's old phone
 * record exactly in order to find the right phone to update.
 *
 * If nil is passed in for the old phone,
 * then a new phone number will be created based on
 * the new phone parameters.
 *
 * Next ID: 3
 */
export type OdProtosCustomerV1Services_CustomerRequests_Update_Params_Phone_OldInput = {
  number?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<OdProtosCustomerV1Data_Phone_PhoneType>;
};

export type OdProtosCustomerV1Services_GetCommPreferenceRequestInput = {
  customerUuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosCustomerV1Services_GetSubscriptionsForFeedRequestInput = {
  customerUuid?: InputMaybe<Scalars['String']>;
  feedName?: InputMaybe<Scalars['String']>;
};

export type OdProtosCustomerV1Services_SubscribeToFeedRequestInput = {
  customerUuid?: InputMaybe<Scalars['String']>;
  feedName?: InputMaybe<Scalars['String']>;
  /**
   * The mediums to subscribe to. This is a repeated field to allow for multiple mediums to be subscribed to at once.
   * If a medium is not available for the feed, the endpoint will error out without subscribing to any mediums.
   * If a medium is already subscribed to, it will be ignored.
   * The list will be deduped.
   */
  mediumsToSubscribe?: InputMaybe<Array<OdProtosCustomerV1Data_Medium>>;
};

export type OdProtosCustomerV1Services_TriggerBackfillJobRequestInput = {
  jobName?: InputMaybe<OdProtosCustomerV1Services_TriggerBackfillJobRequest_AvailableJobs>;
};

export type OdProtosCustomerV1Services_TriggerBackfillJobRequest_AvailableJobs =
  | 'BACKFILL_COMM_PREFERENCES'
  | 'BACKFILL_DEFAULT_SUBSCRIPTIONS'
  | 'BACKFILL_UNSUBSCRIPTIONS'
  | 'UNSPECIFIED';

export type OdProtosCustomerV1Services_UnsubscribeFromFeedRequestInput = {
  customerUuid?: InputMaybe<Scalars['String']>;
  feedName?: InputMaybe<Scalars['String']>;
  /**
   * The mediums to unsubscribe from. This is a repeated field to allow for multiple mediums to be unsubscribed from at once.
   * If a medium is not available for the feed, the endpoint will error out without unsubscribing from any mediums.
   * If a medium is not subscribed to, it will be ignored.
   * The list will be deduped.
   */
  mediumsToUnsubscribe?: InputMaybe<Array<OdProtosCustomerV1Data_Medium>>;
};

export type OdProtosCustomerV1Services_UpsertCommPreferenceRequestInput = {
  /** If call_opt_out is not set, it will not be updated */
  callOptOut?: InputMaybe<Scalars['Boolean']>;
  customerUuid?: InputMaybe<Scalars['String']>;
  /** If email_opt_out is not set, it will not be updated */
  emailOptOut?: InputMaybe<Scalars['Boolean']>;
  /** If sms_opt_out is not set, it will not be updated */
  smsOptOut?: InputMaybe<Scalars['Boolean']>;
};

export type OdProtosDeadletterData_Status =
  | 'PENDING'
  | 'PROCESSED'
  | 'SKIPPED'
  | 'UNKNOWN';

export type OdProtosDeadletterServices_AttemptProcessRequestInput = {
  messageId?: InputMaybe<Scalars['String']>;
  topic?: InputMaybe<Scalars['String']>;
};

export type OdProtosDeadletterServices_AttemptProcessResponse_Error_Code =
  | 'INVALID_ARGUMENT'
  | 'UNKNOWN';

export type OdProtosDeadletterServices_ListDeadLettersRequestInput = {
  messageIds?: InputMaybe<Array<Scalars['String']>>;
  status?: InputMaybe<OdProtosDeadletterData_Status>;
  topic?: InputMaybe<Scalars['String']>;
};

export type OdProtosDeadletterServices_ListDeadLettersResponse_Error_Code =
  | 'INVALID_ARGUMENT'
  | 'UNKNOWN';

/**
 * Parameters for creating an organization
 * Next ID: 8
 */
export type OdProtosDirectoryData_Organization_CreateInput = {
  /** If provided, the organization will be associated with the provided address */
  addressUuid?: InputMaybe<Scalars['String']>;
  /** The primary email for contacting the organization **REQUIRED** */
  email?: InputMaybe<Scalars['String']>;
  /** The fax number, if any */
  fax?: InputMaybe<Scalars['String']>;
  /**
   * The legal name of the organization if different from the name.
   * If not set, the name will be used
   */
  legalName?: InputMaybe<Scalars['String']>;
  /** The name of the organization. This must be unique. **REQUIRED** */
  name?: InputMaybe<Scalars['String']>;
  /** If provided, this organization will be made a child organization of the parent */
  parentOrganizationUuid?: InputMaybe<Scalars['String']>;
  /** If provided, the corresponding user will be used as the primary organization contact */
  primaryContactToken?: InputMaybe<Scalars['String']>;
  /** The primary phone number for contacting the organization */
  primaryPhone?: InputMaybe<Scalars['String']>;
};

/**
 * Update parameters for an organization
 * Next ID: 9
 */
export type OdProtosDirectoryData_Organization_UpdateInput = {
  /** Change the address uuid of the organization. i.e. The office moved */
  addressUuid?: InputMaybe<Scalars['String']>;
  /** Change the primary email address associated with the organization */
  email?: InputMaybe<Scalars['String']>;
  /** Change the fax number associated with the organization */
  fax?: InputMaybe<Scalars['String']>;
  /** Change the legal name of the organization. */
  legalName?: InputMaybe<Scalars['String']>;
  /** Change the primary name of the organization. This must be unique wihtin the system */
  name?: InputMaybe<Scalars['String']>;
  /** Change the primary contact of the org */
  primaryContactToken?: InputMaybe<Scalars['String']>;
  /** Change the primary phone number associated with the organization */
  primaryPhone?: InputMaybe<Scalars['String']>;
  /** The uuid of the organization to update */
  uuid?: InputMaybe<Scalars['String']>;
};

/**
 * Parameters to change the password for a user
 * Next ID: 4
 */
export type OdProtosDirectoryData_User_ChangePasswordInput = {
  identifier?: InputMaybe<OdProtosDirectoryData_User_ChangePassword_IdentifierOneofInput>;
  password?: InputMaybe<Scalars['String']>;
  /** indicate if the password was randomly generated */
  randomlyGenerated?: InputMaybe<Scalars['Boolean']>;
};

export type OdProtosDirectoryData_User_ChangePassword_IdentifierOneofInput = {
  email?: InputMaybe<Scalars['String']>;
  token?: InputMaybe<Scalars['String']>;
};

/**
 * Required parameters to create a user
 * Next ID: 8
 */
export type OdProtosDirectoryData_User_CreateInput = {
  /** The current primary email for the user. **REQUIRED** */
  email?: InputMaybe<Scalars['String']>;
  fullName?: InputMaybe<Scalars['String']>;
  /** The password to use for the user. **REQUIRED** */
  password?: InputMaybe<Scalars['String']>;
  primaryPhone?: InputMaybe<Scalars['String']>;
  publicEmail?: InputMaybe<Scalars['String']>;
};

/**
 * Available parameters to update a user
 * Next ID: 6
 */
export type OdProtosDirectoryData_User_UpdateInput = {
  email?: InputMaybe<Scalars['String']>;
  fullName?: InputMaybe<Scalars['String']>;
  primaryPhone?: InputMaybe<Scalars['String']>;
  publicEmail?: InputMaybe<Scalars['String']>;
  token?: InputMaybe<Scalars['String']>;
};

/**
 * Parameters to validate a password for a user
 * Next ID: 3
 */
export type OdProtosDirectoryData_User_ValidatePasswordInput = {
  email?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
};

export type OdProtosDirectoryServices_BasicUuidRequestInput = {
  uuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosDirectoryServices_GetOrganizationById_RequestInput = {
  id?: InputMaybe<Scalars['String']>;
};

/**
 * Work with member roles.
 * Used to add/delete roles from a member
 * Next ID: 4
 */
export type OdProtosDirectoryServices_MemberRequests_EditMemberRolesInput = {
  organizationUuid?: InputMaybe<Scalars['String']>;
  /** The roles to operate on. */
  roleIdentifiers?: InputMaybe<Array<Scalars['String']>>;
  userToken?: InputMaybe<Scalars['String']>;
};

/**
 * Lists must be filtered by at least one dimension
 * Next ID: 3
 */
export type OdProtosDirectoryServices_MemberRequests_ListInput = {
  /** Specify the type of token to use to filter the list */
  identifierType?: InputMaybe<OdProtosDirectoryServices_MemberRequests_List_TokenType>;
  identifiers?: InputMaybe<Array<Scalars['String']>>;
};

/** The type of filtering to use */
export type OdProtosDirectoryServices_MemberRequests_List_TokenType =
  /** Filter using the tokens as member tokens */
  | 'MEMBER'
  /** Filter using the tokens as organization tokens */
  | 'ORGANIZATION'
  /** Filter using the tokens as role identifiers */
  | 'ROLE'
  /** Filter using the tokens as user tokens */
  | 'USER';

/** Request an index view of organizations */
export type OdProtosDirectoryServices_OrganizationRequests_IndexInput = {
  /** Filter by organization emails */
  emails?: InputMaybe<Array<Scalars['String']>>;
  /** Pagination parameters for the request */
  pagination?: InputMaybe<OdProtosDirectoryServices_PaginationRequestInput>;
  /** A query that will try to match against names and emails of the organization */
  query?: InputMaybe<Scalars['String']>;
  /** Filter by organization tokens */
  uuids?: InputMaybe<Array<Scalars['String']>>;
};

/**
 * When requesting results from a paginating endpoint
 * Specify the cursor to start pagination from. Leave this blank if pagination is just starting
 */
export type OdProtosDirectoryServices_PaginationRequestInput = {
  /** Max Count of records to return in the results */
  count?: InputMaybe<Scalars['Float']>;
  direction?: InputMaybe<OdProtosDirectoryServices_SortDirection>;
  /**
   * The cursor to start the page at.
   * Leave this blank to start at the start of the pagination stream
   */
  startCursor?: InputMaybe<Scalars['String']>;
};

export type OdProtosDirectoryServices_SortDirection =
  | 'ASC'
  | 'DESC';

export type OdProtosDirectoryServices_UserRequests_GetInput = {
  identifier?: InputMaybe<OdProtosDirectoryServices_UserRequests_Get_IdentifierOneofInput>;
};

export type OdProtosDirectoryServices_UserRequests_Get_IdentifierOneofInput = {
  email?: InputMaybe<Scalars['String']>;
  token?: InputMaybe<Scalars['String']>;
};

/** Request a paginated stream of users */
export type OdProtosDirectoryServices_UserRequests_IndexInput = {
  /** Filter by emails. Applies if set */
  emails?: InputMaybe<Array<Scalars['String']>>;
  /** Specify pagination */
  pagination?: InputMaybe<OdProtosDirectoryServices_PaginationRequestInput>;
  /** Search for users that match the query in name, email or primary phone number */
  query?: InputMaybe<Scalars['String']>;
  /** Filter by tokens. Applies if set */
  tokens?: InputMaybe<Array<Scalars['String']>>;
};

/**
 * InaccuracyCategory is an enum for the different types of inaccuracy categories
 * Ids are used
 */
export type OdProtosDiscloseData_InaccuracyCategory =
  | 'INACCURACY_CATEGORY_IRRELEVANTDATA'
  | 'INACCURACY_CATEGORY_UNKNOWN'
  | 'INACCURACY_CATEGORY_WRONGDATA';

/** Source is an enum for the different types of sources to aggregate disclosure data */
export type OdProtosDiscloseData_Source =
  | 'SOURCE_ADMIN'
  | 'SOURCE_ADMIN_ACTIVITY_TAB'
  | 'SOURCE_ADMIN_CLOSING_TAB'
  | 'SOURCE_ADMIN_INVENTORY_TAB'
  | 'SOURCE_ADMIN_LISTING_TAB'
  | 'SOURCE_ADMIN_RBR_TAB'
  | 'SOURCE_ADMIN_RENOVATION_TAB'
  | 'SOURCE_D1W'
  | 'SOURCE_EXTERIOR_ASSESSMENT'
  | 'SOURCE_FEMA_WEBSITE'
  | 'SOURCE_GOOGLE_MAPS'
  | 'SOURCE_NOTES'
  | 'SOURCE_QC_VISIT'
  | 'SOURCE_SELLER_INPUTS'
  | 'SOURCE_SEPTIC_SOT_IN_DISCO'
  | 'SOURCE_UNKNOWN'
  | 'SOURCE_VIRTUAL_ASSESSMENT'
  | 'SOURCE_WORK_ORDERS';

export type OdProtosDiscloseData_UpdateReportRequestInput = {
  id?: InputMaybe<Scalars['String']>;
  isFinal?: InputMaybe<Scalars['Boolean']>;
  rubric?: InputMaybe<OdProtosRubricV2Data_RubricInput>;
  source?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['String']>;
};

export type OdProtosDiscloseServices_CreateDisclosureRequestInput = {
  addressToken?: InputMaybe<Scalars['String']>;
  /** the disclosure_uuid get's generated in disclose and then request is made to rubric */
  disclosureUuid?: InputMaybe<Scalars['String']>;
  flipToken?: InputMaybe<Scalars['String']>;
};

/** Seller Disclosure Feedback */
export type OdProtosDiscloseServices_CreateSellerDisclosureFeedbackRequestInput = {
  accurateSourceIds?: InputMaybe<Array<OdProtosDiscloseData_Source>>;
  categoryId?: InputMaybe<Scalars['String']>;
  comment?: InputMaybe<Scalars['String']>;
  flipToken?: InputMaybe<Scalars['String']>;
  inaccuracyCategoryId?: InputMaybe<OdProtosDiscloseData_InaccuracyCategory>;
  questionId?: InputMaybe<Scalars['String']>;
  /** Source that is being marked as inaccurate */
  sourceId?: InputMaybe<OdProtosDiscloseData_Source>;
};

export type OdProtosDiscloseServices_DeleteSellerDisclosureFeedbackRequestInput = {
  deleteReason?: InputMaybe<Scalars['String']>;
  feedbackId?: InputMaybe<Scalars['Float']>;
};

export type OdProtosDiscloseServices_GetAirtableTemplatesByMarketRequestInput = {
  marketName?: InputMaybe<Scalars['String']>;
};

export type OdProtosDiscloseServices_GetDisclosureRequestInput = {
  addressToken?: InputMaybe<Scalars['String']>;
  flipToken?: InputMaybe<Scalars['String']>;
};

/**
 * Note: Not implementing pagintation for now
 * We don't expect to have a lot of feedbacks(max few hundreds) and size of feedbacks is small
 */
export type OdProtosDiscloseServices_GetSellerDisclosureFeedbacksRequestInput = {
  feedbackIds?: InputMaybe<Array<Scalars['Float']>>;
  flipToken?: InputMaybe<Scalars['String']>;
};

export type OdProtosDiscloseServices_GetSellerDisclosureTaskRequestInput = {
  _empty?: InputMaybe<Scalars['Boolean']>;
};

export type OdProtosDiscloseServices_GetSignedUrlRequestInput = {
  keyForS3?: InputMaybe<Scalars['String']>;
};

export type OdProtosDiscloseServices_IdentifierInput = {
  id?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Scalars['String']>;
};

export type OdProtosDiscloseServices_UpdateSellerDisclosureFeedbackRequestInput = {
  accurateSourceIds?: InputMaybe<Array<OdProtosDiscloseData_Source>>;
  comment?: InputMaybe<Scalars['String']>;
  feedbackId?: InputMaybe<Scalars['Float']>;
  inaccuracyCategoryId?: InputMaybe<OdProtosDiscloseData_InaccuracyCategory>;
};

export type OdProtosDiscloseServices_UploadDisclosuresFormRequestInput = {
  fileName?: InputMaybe<Scalars['String']>;
  pdfFile?: InputMaybe<Scalars['String']>;
};

export type OdProtosDistilleryData_JobResult_ValidationStatus =
  /**
   * Results for availability of a mandatory field with non-empty value.
   * 0 and 1 are mutually exclusive.
   *
   * for label "Available"
   */
  | 'AVAILABLE'
  /**
   * No validations configured for the field.
   *
   * for label "Captured"
   */
  | 'DEFAULT'
  /**
   * Confidence level of the field extraction is low.
   *
   * to grey out the labels
   */
  | 'LOW_CONFIDENCE'
  /** for label "Missing" */
  | 'MISSING'
  /**
   * Field is not expected in this document.
   *
   * for label "Unexpected"
   */
  | 'UNEXPECTED_FIELD'
  /**
   * Validation process encountered problems. Value is not verified.
   *
   * provide a label for this?
   */
  | 'UNKNOWN'
  /** for label "Mismatch" */
  | 'VALUE_MISMATCH'
  /**
   * Result for the correctness of the value of a field.
   * 3 and 4 are mutually exclusive.
   *
   * for label "Verified"
   */
  | 'VALUE_VERIFIED'
  /**
   * Result for the correctness of the data type of a field.
   * If this is not available, the field either has correct data type or
   * data type validation is not configured for the field
   *
   * for label "Not <data type label>"
   */
  | 'WRONG_DATA_TYPE';

export type OdProtosDistilleryData_RunFeedback_Type =
  | 'INCORRECT_VALUE'
  | 'MISSING_VALUE'
  | 'UNKNOWN';

export type OdProtosDistilleryData_WorkflowJob_Status =
  | 'ENQUEUED'
  | 'SUBMITTED'
  | 'UNKNOWN';

export type OdProtosDistilleryData_WorkflowRun_Status =
  | 'ENQUEUED'
  | 'EXTRACTED'
  | 'FAILED'
  | 'TRANSFORMED'
  | 'UNKNOWN'
  | 'VALIDATED';

export type OdProtosDistilleryData_Workflow_DocumentSource =
  | 'DMS'
  | 'FINPLAT'
  | 'UNKNOWN';

export type OdProtosDistilleryData_Workflow_Vendor =
  | 'EXTENDAPP'
  | 'UNKNOWN_VENDOR';

export type OdProtosDistilleryServices_DistilleryRequests_CreateWorkflowInput = {
  documentSource?: InputMaybe<OdProtosDistilleryData_Workflow_DocumentSource>;
  documentType?: InputMaybe<Scalars['String']>;
  documentableType?: InputMaybe<OdProtosDocumentManagementData_Documentable_Type>;
  market?: InputMaybe<OdProtosCommonMarket_Market>;
  sourceChannel?: InputMaybe<OdProtosDocumentManagementData_Document_SourceChannel>;
  state?: InputMaybe<OdProtosCommonState_State>;
  vendor?: InputMaybe<OdProtosDistilleryData_Workflow_Vendor>;
  vendorWorkflowId?: InputMaybe<Scalars['String']>;
};

export type OdProtosDistilleryServices_DistilleryRequests_FeedbackInput = {
  comment?: InputMaybe<Scalars['String']>;
  expectedValue?: InputMaybe<Scalars['String']>;
  extractedValue?: InputMaybe<Scalars['String']>;
  fieldId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<OdProtosDistilleryData_RunFeedback_Type>;
};

export type OdProtosDistilleryServices_DistilleryRequests_GetResultsInput = {
  by?: InputMaybe<OdProtosDistilleryServices_DistilleryRequests_GetResults_ByOneofInput>;
};

export type OdProtosDistilleryServices_DistilleryRequests_GetResults_ByOneofInput = {
  documentId?: InputMaybe<Scalars['String']>;
  jobId?: InputMaybe<Scalars['String']>;
};

export type OdProtosDistilleryServices_DistilleryRequests_GetRunFeedbacksInput = {
  workflowRunId?: InputMaybe<Scalars['String']>;
};

export type OdProtosDistilleryServices_DistilleryRequests_PauseWorkflowInput = {
  workflowId?: InputMaybe<Scalars['String']>;
};

export type OdProtosDistilleryServices_DistilleryRequests_ResumeWorkflowInput = {
  workflowId?: InputMaybe<Scalars['String']>;
};

export type OdProtosDistilleryServices_DistilleryRequests_SubmitJobInput = {
  params?: InputMaybe<OdProtosDistilleryServices_DistilleryRequests_SubmitJob_ParamsOneofInput>;
};

export type OdProtosDistilleryServices_DistilleryRequests_SubmitJob_DmsInput = {
  documentId?: InputMaybe<Scalars['String']>;
};

export type OdProtosDistilleryServices_DistilleryRequests_SubmitJob_DocumentUrlInput = {
  documentName?: InputMaybe<Scalars['String']>;
  documentSource?: InputMaybe<OdProtosDistilleryData_Workflow_DocumentSource>;
  /** URL of the document with public access for at least 15 minutes */
  url?: InputMaybe<Scalars['String']>;
  workflowIds?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosDistilleryServices_DistilleryRequests_SubmitJob_ParamsOneofInput = {
  dms?: InputMaybe<OdProtosDistilleryServices_DistilleryRequests_SubmitJob_DmsInput>;
  documentUrl?: InputMaybe<OdProtosDistilleryServices_DistilleryRequests_SubmitJob_DocumentUrlInput>;
};

export type OdProtosDistilleryServices_DistilleryRequests_SubmitRunFeedbacksInput = {
  feedbacks?: InputMaybe<Array<OdProtosDistilleryServices_DistilleryRequests_FeedbackInput>>;
  workflowRunId?: InputMaybe<Scalars['String']>;
};

export type OdProtosDistilleryServices_Transformation_RequestInput = {
  workflowRunId?: InputMaybe<Scalars['String']>;
};

export type OdProtosDistilleryServices_Validation_RequestInput = {
  workflowRunId?: InputMaybe<Scalars['String']>;
};

export type OdProtosDocumentManagementData_DocumentSource_Type =
  | 'CUSTARD_CUSTOMER'
  | 'HUMAN'
  | 'INSPECTION_REPORT'
  | 'MESSAGE_THREAD'
  | 'ORGANIZATION'
  | 'TASKS_HELLO_SIGN_TASK'
  | 'UNKNOWN';

export type OdProtosDocumentManagementData_DocumentStorageInput = {
  /**
   * Document storage ID. It could be a document s3 key in the case of web, or a
   * cabinet uuid.
   */
  id?: InputMaybe<Scalars['String']>;
  /** Where the document file is stored. */
  type?: InputMaybe<OdProtosDocumentManagementData_DocumentStorage_Type>;
};

export type OdProtosDocumentManagementData_DocumentStorage_Type =
  | 'CABINET'
  | 'UNKNOWN'
  | 'WEB';

export type OdProtosDocumentManagementData_DocumentTemplate_TransactionType =
  | 'ACQUISITION'
  | 'RESALE'
  | 'UNKNOWN_TRANSACTION';

export type OdProtosDocumentManagementData_DocumentTypeConfig_TransactionType =
  | 'ACQUISITION'
  | 'RESALE'
  | 'UNKNOWN_TRANSACTION';

export type OdProtosDocumentManagementData_DocumentTypeNote_TransactionType =
  | 'ACQUISITION'
  | 'RESALE'
  | 'UNKNOWN_TRANSACTION';

export type OdProtosDocumentManagementData_Document_SourceChannel =
  | 'BWOD_CHANNEL'
  | 'CLOSING_DASHBOARD_CHANNEL'
  | 'HELLO_SIGN_TASK_CHANNEL'
  | 'NOMAD_CHANNEL'
  | 'OFFER_PORTAL_CHANNEL'
  | 'RESALE_CLOSING_DASHBOARD_CHANNEL'
  | 'SETTLER_CHANNEL'
  | 'TOOLING_HUB_CHANNEL'
  | 'UNKNOWN_CHANNEL';

/** Next ID: 184 */
export type OdProtosDocumentManagementData_Document_Type =
  | 'ABAD'
  | 'ACQ_AGENT_REFERRAL_FORM'
  | 'ACQ_DEED'
  | 'ACQ_EMR'
  | 'ACQ_FINAL_SETTLEMENT_STATEMENT'
  | 'ACQ_HOA_DEMAND'
  | 'ACQ_HOA_GOVERNING_DOCS'
  | 'ACQ_HOA_RECEIPT'
  | 'ACQ_LAND_SURVEY'
  | 'ACQ_NATURAL_HAZARD_DISCLOSURE'
  | 'ACQ_OUTBOUND_ADDENDUM'
  | 'ACQ_T47_RESIDENTIAL_REAL_PROPERTY_AFFIDAVIT'
  | 'ACQ_TAX_CERTIFICATE'
  | 'ACQ_TITLE_COMMITMENT'
  | 'ACQ_UNSIGNED_DRAFT_SETTLEMENT_STATEMENT'
  | 'ADDENDUM'
  | 'AGENT_REFERRAL_W9'
  | 'AMENDMENT'
  | 'APPRAISAL_REPORT'
  | 'ASSESSMENT_REPORT'
  | 'AVID_BUYER'
  | 'AVID_SELLER'
  | 'BINDING_COUNTER_OFFER'
  | 'BINSR'
  | 'BRN_CREDIT_ADDENDUM'
  | 'BRN_RESPONSE'
  | 'BROKER_PRICE_OPINION'
  | 'BUYER_CLOSING_DOCS'
  | 'CANCEL_BINSR'
  | 'CASH_AGREEMENT'
  | 'CASH_PLUS_AGREEMENT'
  | 'CCR'
  | 'CHANGE_CLOSE_OF_ESCROW_ADDENDUM'
  | 'CHECKLIST_HOA_SOU'
  | 'CIC_RECEIPT'
  | 'CLOSING_STATEMENT_FOR_APPROVAL'
  | 'CLUE'
  | 'COMBINED'
  | 'COMBINED_FILE'
  | 'COMBINED_PURCHASE_AGREEMENT_AND_REPAIR_ADDENDUM'
  | 'COMMISSION_INSTRUCTIONS'
  | 'CONFIRMATION_OF_NO_HOA'
  | 'CONTINGENCY'
  | 'CONTINGENCY_REMOVAL'
  | 'COUNTER'
  | 'DEED'
  | 'EOI'
  | 'FINALIZE_BINSR'
  | 'FINAL_OFFER_PDF'
  | 'FINAL_REPAIR_ASK'
  | 'FINAL_SETTLEMENT_STATEMENT'
  | 'FIRPTA'
  | 'HOA'
  | 'HOA_ADDENDUM'
  | 'HOA_BUYER_APPROVAL'
  | 'HOA_CCRS'
  | 'HOA_CCR_AMENDMENT'
  | 'HOA_DEMAND'
  | 'HOA_DEMAND_SUB'
  | 'HOA_ESTOPPEL_LETTER_UPDATED'
  | 'HOA_PACKAGE'
  | 'HOA_STATUS_LETTER'
  | 'HOA_VIOLATION_RESOLUTION'
  | 'HOME_CONDITION_BRANDED'
  | 'HOME_CONDITION_UNBRANDED'
  | 'HOME_WARRANTY_INVOICE'
  | 'INITIAL_BINSR_REQUEST'
  | 'INITIAL_REPAIR_ASK'
  | 'INSPECTION_REPORT_ELECTRICAL'
  | 'INSPECTION_REPORT_FOUNDATION'
  | 'INSPECTION_REPORT_GENERAL'
  | 'INSPECTION_REPORT_HVAC'
  | 'INSPECTION_REPORT_OTHER'
  | 'INSPECTION_REPORT_PLUMBING'
  | 'INSPECTION_REPORT_POOL'
  | 'INSPECTION_REPORT_ROOF'
  | 'INSPECTION_REPORT_SHERLOCK'
  | 'INSPECTION_REPORT_TERMITE'
  | 'INSURANCE_CLAIM'
  | 'INVOICE'
  | 'LAND_SURVEY'
  | 'LATE_CHECKOUT_ADDENDUM'
  | 'LBP_ADDENDUM'
  | 'LEASED_FIXTURES'
  | 'LIEN_SEARCH'
  | 'LIGHTWEIGHT_PURCHASE_AGREEMENT'
  | 'LISTING_DISCLOSURE'
  | 'LISTING_PACKET'
  | 'LOSS_HISTORY_REPORT'
  | 'LWOD_OFFER_REVIEW'
  | 'MARKET_CONDITIONS_ADVISORY'
  | 'MEASUREMENT_REPORT'
  | 'MINERAL_OIL_GAS'
  | 'MISC'
  | 'NAME_CHANGE'
  | 'NON_BINDING_COUNTER_OFFER'
  | 'NON_REQUIRED_DOCS'
  | 'OD_ADDENDUM'
  | 'OD_GUARANTEE'
  | 'OD_SERVICES_ADDENDUM'
  | 'OUTBOUND_PURCHASE_AGREEMENT'
  | 'OWNERS_POLICY'
  | 'O_AND_E_RECEIPT'
  | 'PREPARED_DEED'
  | 'PREQUAL'
  | 'PROOF_OF_FUNDS'
  | 'PROPERTY_DISCLOSURE'
  | 'PROPOSED_AMENDMENT'
  | 'PTL'
  | 'PURCHASE_AGREEMENT'
  | 'PURCHASE_AGREEMENT_TERMINATION'
  | 'REALTOR_DISCLOSURE'
  | 'REIT_RESALE_PURCHASE_CONTRACT'
  | 'REJECTED_SETTLEMENT_STATEMENT'
  | 'RENOVATION_PROPOSAL'
  | 'REPAIR_ADDENDUM'
  | 'RESALE_ADDENDUM'
  | 'RESALE_EMR'
  | 'RESALE_FINAL_SETTLEMENT_STATEMENT'
  | 'RESALE_SIGNED_SELLER_CLOSING_DOCS'
  | 'RS_ADDENDUM'
  | 'RS_ADDENDUM_CONTINGENCY'
  | 'RS_ADDENDUM_HOA'
  | 'RS_ADDENDUM_LBP'
  | 'RS_ADDENDUM_MINERAL_OIL_GAS'
  | 'RS_ADDENDUM_TPF'
  | 'RS_AGENT_REFERRAL_FORM'
  | 'RS_AMENDMENT'
  | 'RS_BRN_CREDIT_ADDENDUM'
  | 'RS_BRN_FINAL'
  | 'RS_BRN_FINAL_CREDIT_ADDENDUM'
  | 'RS_BRN_INITIAL'
  | 'RS_BUYER_CLOSING_DOCS'
  | 'RS_BUYER_INSPECTION_FOUNDATION'
  | 'RS_BUYER_INSPECTION_GENERAL'
  | 'RS_BUYER_INSPECTION_HVAC'
  | 'RS_BUYER_INSPECTION_OTHER'
  | 'RS_BUYER_INSPECTION_ROOF'
  | 'RS_BUYER_INSPECTION_TERMITE'
  | 'RS_CANCEL_DOCUMENT'
  | 'RS_CIC_RECEIPT'
  | 'RS_COUNTER'
  | 'RS_CURE_NOTICE'
  | 'RS_DEED'
  | 'RS_FHA_LOAN_AMENDATORY'
  | 'RS_FINAL_SETTLEMENT_STATEMENT'
  | 'RS_HOA_DEMAND'
  | 'RS_HOA_DOCS'
  | 'RS_HOA_RECEIPT'
  | 'RS_HOME_WARRANTY_INVOICE'
  | 'RS_LAND_SURVEY'
  | 'RS_LOAN_STATUS_UPDATE'
  | 'RS_NATURAL_HAZARD_DISCLOSURE'
  | 'RS_PRE_CLOSE_WALKTHROUGH'
  | 'RS_REALTOR_DISCLOSURE_AGENCY'
  | 'RS_RECEIPT_EM'
  | 'RS_RECEIPT_OTHER'
  | 'RS_SELLER_SIGNED_CLOSING_DOCS'
  | 'RS_SURVEY'
  | 'RS_T47_RESIDENTIAL_REAL_PROPERTY_AFFIDAVIT'
  | 'RS_TAX_CERTIFICATE'
  | 'RS_TITLE_COMMITMENT'
  | 'RS_UNSIGNED_DRAFT_SETTLEMENT_STATEMENT'
  | 'RS_USER_MISC'
  | 'RS_VA_LOAN_AMENDATORY'
  | 'RS_W9'
  | 'SELLER_DISCLOSURES'
  | 'SEPTIC_PERMIT'
  | 'SHERLOCK_ASSESSMENT_REPORT'
  | 'SOLAR_INFORMATION'
  | 'SOLAR_MISC'
  | 'SOLAR_PAYOFF'
  | 'SOLAR_TRANSFER_AGREEMENT'
  | 'SPDS'
  | 'STATE_OR_COUNTY_DISCLOSURES'
  | 'SWU_ESTIMATED_NET_SHEET_PDF'
  | 'TAX_CERTIFICATE'
  | 'THIRD_PARTY_ADDENDUM'
  | 'TITLE_COMMITMENT'
  | 'TITLE_COMPANY_CHANGE'
  | 'TITLE_DISCLOSURE'
  | 'TRUTH_IN_SALE_OF_HOUSING_INSPECTION'
  | 'UCC_TERMINATION'
  | 'UNKNOWN_DOCUMENT';

export type OdProtosDocumentManagementData_DocumentableInput = {
  id?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<OdProtosDocumentManagementData_Documentable_Type>;
};

export type OdProtosDocumentManagementData_Documentable_Type =
  | 'BRN'
  | 'BROKERAGE_OFFER'
  | 'FLIP'
  | 'HOME_CONDITION_REPORT'
  | 'INSPECTION_REPORT'
  | 'INVOICE'
  | 'LISTING'
  | 'LISTING_OFFER'
  | 'MAINTENANCE_SCHEDULE'
  | 'OFFER'
  | 'UNKNOWN'
  | 'WORK_ORDER'
  | 'WORK_ORDER_ITEM';

export type OdProtosDocumentManagementServices_DocumentRequests_CreateTemplateInput = {
  region?: InputMaybe<Scalars['String']>;
  transactionType?: InputMaybe<OdProtosDocumentManagementData_DocumentTemplate_TransactionType>;
};

export type OdProtosDocumentManagementServices_DocumentRequests_DeleteInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type OdProtosDocumentManagementServices_DocumentRequests_DeleteTemplateDefinitionsInput = {
  templateDefinitionIds?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosDocumentManagementServices_DocumentRequests_GetDocumentTypeConfigInput = {
  documentTypeId?: InputMaybe<Scalars['String']>;
  transactionType?: InputMaybe<OdProtosDocumentManagementData_DocumentTypeConfig_TransactionType>;
};

export type OdProtosDocumentManagementServices_DocumentRequests_GetDocumentTypeNoteInput = {
  documentTypeId?: InputMaybe<Scalars['String']>;
  transactionType?: InputMaybe<OdProtosDocumentManagementData_DocumentTypeNote_TransactionType>;
};

export type OdProtosDocumentManagementServices_DocumentRequests_GetInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type OdProtosDocumentManagementServices_DocumentRequests_GetTemplateInput = {
  region?: InputMaybe<Scalars['String']>;
  transactionType?: InputMaybe<OdProtosDocumentManagementData_DocumentTemplate_TransactionType>;
};

export type OdProtosDocumentManagementServices_DocumentRequests_ListDocumentTypesInput = {
  _empty?: InputMaybe<Scalars['Boolean']>;
};

export type OdProtosDocumentManagementServices_DocumentRequests_ListInput = {
  documentType?: InputMaybe<OdProtosDocumentManagementData_Document_Type>;
  params?: InputMaybe<OdProtosDocumentManagementServices_DocumentRequests_List_ParamsOneofInput>;
};

/**
 * finds documents for listing offer and all related
 * listing offers up to and including this one
 */
export type OdProtosDocumentManagementServices_DocumentRequests_List_AllListingOfferDocumentsInput = {
  listingOfferId?: InputMaybe<Scalars['String']>;
};

export type OdProtosDocumentManagementServices_DocumentRequests_List_CurrentLeadDocumentsInput = {
  sellerLeadUuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosDocumentManagementServices_DocumentRequests_List_DocumentableInput = {
  documentable?: InputMaybe<OdProtosDocumentManagementData_DocumentableInput>;
};

export type OdProtosDocumentManagementServices_DocumentRequests_List_IdsInput = {
  ids?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosDocumentManagementServices_DocumentRequests_List_ParamsOneofInput = {
  currentLead?: InputMaybe<OdProtosDocumentManagementServices_DocumentRequests_List_CurrentLeadDocumentsInput>;
  documentable?: InputMaybe<OdProtosDocumentManagementServices_DocumentRequests_List_DocumentableInput>;
  ids?: InputMaybe<OdProtosDocumentManagementServices_DocumentRequests_List_IdsInput>;
  listingOffer?: InputMaybe<OdProtosDocumentManagementServices_DocumentRequests_List_AllListingOfferDocumentsInput>;
};

export type OdProtosDocumentManagementServices_DocumentRequests_ReviewInput = {
  id?: InputMaybe<Scalars['String']>;
  reason?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<OdProtosDocumentManagementServices_DocumentRequests_Review_ReviewStatus>;
  type?: InputMaybe<OdProtosDocumentManagementServices_DocumentRequests_Review_ReviewType>;
};

export type OdProtosDocumentManagementServices_DocumentRequests_Review_LogActivityInput = {
  activityNote?: InputMaybe<Scalars['String']>;
  activityType?: InputMaybe<Scalars['String']>;
  eventTime?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  reviewType?: InputMaybe<OdProtosDocumentManagementServices_DocumentRequests_Review_ReviewType>;
};

export type OdProtosDocumentManagementServices_DocumentRequests_Review_ReviewStatus =
  | 'APPROVED'
  | 'REJECTED';

export type OdProtosDocumentManagementServices_DocumentRequests_Review_ReviewType =
  | 'DUE_DILIGENCE'
  | 'TRANSACTION_COORDINATOR'
  | 'UNKNOWN';

export type OdProtosDocumentManagementServices_DocumentRequests_UpdateInput = {
  documentTypeId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  /** use document_type_id */
  type?: InputMaybe<OdProtosDocumentManagementData_Document_Type>;
};

export type OdProtosDocumentManagementServices_DocumentRequests_UploadInput = {
  params?: InputMaybe<OdProtosDocumentManagementServices_DocumentRequests_Upload_ParamsOneofInput>;
};

export type OdProtosDocumentManagementServices_DocumentRequests_Upload_DocumentInput = {
  documentTypeId?: InputMaybe<Scalars['String']>;
  documentable?: InputMaybe<OdProtosDocumentManagementData_DocumentableInput>;
  name?: InputMaybe<Scalars['String']>;
  propertyEngagementGroupId?: InputMaybe<Scalars['String']>;
  sourceChannel?: InputMaybe<OdProtosDocumentManagementData_Document_SourceChannel>;
  storage?: InputMaybe<OdProtosDocumentManagementData_DocumentStorageInput>;
  /** use document_type_id */
  type?: InputMaybe<OdProtosDocumentManagementData_Document_Type>;
};

export type OdProtosDocumentManagementServices_DocumentRequests_Upload_ParamsOneofInput = {
  document?: InputMaybe<OdProtosDocumentManagementServices_DocumentRequests_Upload_DocumentInput>;
};

export type OdProtosDocumentManagementServices_DocumentRequests_UpsertDocumentTypeConfigInput = {
  documentTypeId?: InputMaybe<Scalars['String']>;
  reviewFields?: InputMaybe<Array<OdProtosDocumentManagementServices_DocumentRequests_UpsertDocumentTypeConfig_ReviewFieldInput>>;
  transactionType?: InputMaybe<OdProtosDocumentManagementData_DocumentTypeConfig_TransactionType>;
};

export type OdProtosDocumentManagementServices_DocumentRequests_UpsertDocumentTypeConfig_ReviewFieldInput = {
  name?: InputMaybe<Scalars['String']>;
};

export type OdProtosDocumentManagementServices_DocumentRequests_UpsertDocumentTypeNoteInput = {
  documentTypeId?: InputMaybe<Scalars['String']>;
  note?: InputMaybe<Scalars['String']>;
  transactionType?: InputMaybe<OdProtosDocumentManagementData_DocumentTypeNote_TransactionType>;
};

export type OdProtosDocumentManagementServices_DocumentRequests_UpsertTemplateDefinitionsInput = {
  templateDefinitions?: InputMaybe<Array<OdProtosDocumentManagementServices_DocumentRequests_UpsertTemplateDefinitions_TemplateDefinitionInput>>;
  templateId?: InputMaybe<Scalars['String']>;
};

export type OdProtosDocumentManagementServices_DocumentRequests_UpsertTemplateDefinitions_TemplateDefinitionInput = {
  condition?: InputMaybe<Scalars['String']>;
  documentTypeId?: InputMaybe<Scalars['String']>;
  dueDiligenceContractSlaInDays?: InputMaybe<Scalars['Float']>;
  dueDiligenceDocUploadSlaInDays?: InputMaybe<Scalars['Float']>;
  dueDiligenceSlaInDays?: InputMaybe<Scalars['Float']>;
  id?: InputMaybe<Scalars['String']>;
  isOptional?: InputMaybe<Scalars['Boolean']>;
  requiresBuyerSignature?: InputMaybe<Scalars['Boolean']>;
  requiresDueDiligence?: InputMaybe<Scalars['Boolean']>;
  requiresEpsSignature?: InputMaybe<Scalars['Boolean']>;
  requiresNotarization?: InputMaybe<Scalars['Boolean']>;
  requiresReview?: InputMaybe<Scalars['Boolean']>;
  requiresSellerSignature?: InputMaybe<Scalars['Boolean']>;
  sortOrder?: InputMaybe<Scalars['Float']>;
  tcContractSlaInDays?: InputMaybe<Scalars['Float']>;
  tcDocUploadSlaInDays?: InputMaybe<Scalars['Float']>;
  tcSlaInDays?: InputMaybe<Scalars['Float']>;
};

export type OdProtosDocumentManagementServices_SyncWebDocReviewsToDms_DocumentReviewInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  docId?: InputMaybe<Scalars['String']>;
  reason?: InputMaybe<Scalars['String']>;
  reviewerId?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  webReviewId?: InputMaybe<Scalars['Float']>;
};

export type OdProtosDocumentManagementServices_SyncWebDocReviewsToDms_RequestInput = {
  bulkUpsert?: InputMaybe<Scalars['Boolean']>;
  documentReviews?: InputMaybe<Array<OdProtosDocumentManagementServices_SyncWebDocReviewsToDms_DocumentReviewInput>>;
};

export type OdProtosDocumentManagementServices_SyncWebDocsToDms_DocumentInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedById?: InputMaybe<Scalars['String']>;
  detectiveUuid?: InputMaybe<Scalars['String']>;
  documentType?: InputMaybe<OdProtosDocumentManagementData_Document_Type>;
  documentableId?: InputMaybe<Scalars['String']>;
  documentableType?: InputMaybe<Scalars['String']>;
  externalId?: InputMaybe<Scalars['String']>;
  externalSource?: InputMaybe<Scalars['String']>;
  homeworkId?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  parentId?: InputMaybe<Scalars['String']>;
  propertyEngagementGroupId?: InputMaybe<Scalars['String']>;
  s3ContentId?: InputMaybe<Scalars['String']>;
  signedOn?: InputMaybe<Scalars['DateTime']>;
  sourceChannel?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['String']>;
  sourceType?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  uuid?: InputMaybe<Scalars['String']>;
  visibilityMask?: InputMaybe<Scalars['String']>;
  webDocId?: InputMaybe<Scalars['Float']>;
};

export type OdProtosDocumentManagementServices_SyncWebDocsToDms_RequestInput = {
  bulkUpsert?: InputMaybe<Scalars['Boolean']>;
  documents?: InputMaybe<Array<OdProtosDocumentManagementServices_SyncWebDocsToDms_DocumentInput>>;
};

export type OdProtosElementsData_SyncType_Type =
  | 'CREATE'
  | 'DELETE'
  | 'UNKNOWN'
  | 'UPDATE';

/**
 * A utility context is a wrapper for general information required to manage any
 * utility.
 *
 * It can includes things like proof of ownership and home access information.
 *
 * NEXT ID: 35
 */
export type OdProtosElementsData_UtilityContextInput = {
  acqTitleContactEmail?: InputMaybe<Scalars['String']>;
  /** Acquisition Title Organization contact details */
  acqTitleContactName?: InputMaybe<Scalars['String']>;
  acqTitleContactPhone?: InputMaybe<Scalars['String']>;
  /** Url to the Acquisition warranty deed */
  acqWarrantyDeed?: InputMaybe<Scalars['String']>;
  /** Date the flip was acquired */
  acquisitionDate?: InputMaybe<Scalars['DateTime']>;
  /** Acquisition Title Organization name */
  acquisitionOrganizationName?: InputMaybe<Scalars['String']>;
  addressUuid?: InputMaybe<Scalars['String']>;
  /** Number of bathrooms in the Home. */
  bathrooms?: InputMaybe<Scalars['Float']>;
  /** Number of bedrooms in the Home. */
  bedrooms?: InputMaybe<Scalars['Float']>;
  closeOfEscrowDate?: InputMaybe<Scalars['DateTime']>;
  communityGateCode?: InputMaybe<Scalars['String']>;
  /** Context creation timestamp */
  createdAt?: InputMaybe<Scalars['DateTime']>;
  cxEmail?: InputMaybe<Scalars['String']>;
  /** Display Category represents Acq/Resale channels */
  displayCategory?: InputMaybe<Scalars['String']>;
  escrowNumber?: InputMaybe<Scalars['String']>;
  /** Url to the settlement doc */
  finalSettlementDoc?: InputMaybe<Scalars['String']>;
  /** Emails used for blocked escalation paths */
  hqlEmail?: InputMaybe<Scalars['String']>;
  /**
   * Uniqueness is enforced.
   * Flip token should follow the convention of 'flip:[TOKEN_HERE]'
   */
  identifier?: InputMaybe<Scalars['String']>;
  /** Last successful sync with an external tasking system */
  lastSyncedAt?: InputMaybe<Scalars['DateTime']>;
  lateCheckoutDate?: InputMaybe<Scalars['DateTime']>;
  lockboxCode?: InputMaybe<Scalars['String']>;
  /** Long form standard market name e.g. phoenix */
  market?: InputMaybe<Scalars['String']>;
  /** The meter number or a url to its picture */
  meterNumber?: InputMaybe<Scalars['String']>;
  /** All Utility Photo urls */
  photoUrls?: InputMaybe<Array<Scalars['String']>>;
  /** Url to the Resale settlement doc */
  resaleFinalSettlementDoc?: InputMaybe<Scalars['String']>;
  resaleTitleContactEmail?: InputMaybe<Scalars['String']>;
  resaleTitleContactName?: InputMaybe<Scalars['String']>;
  resaleTitleContactPhone?: InputMaybe<Scalars['String']>;
  /** Resale Title Organization and contact details */
  resaleTitleOrganizationName?: InputMaybe<Scalars['String']>;
  /** Url to the Resale warranty deed */
  resaleWarrantyDeed?: InputMaybe<Scalars['String']>;
  /** Special Flags like the lead type, offer type, if reserved home, etc. */
  specialFlags?: InputMaybe<Array<Scalars['String']>>;
  /** Total square footage of all livable area of the Home. */
  squareFootage?: InputMaybe<Scalars['Float']>;
  /** Context update timestamp */
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/**
 * A utility task contains instructions and state information for a utility
 * on/off/change task.
 *
 * E.g.
 * TURN_ON ELECTRIC due to ACQ_COE on 9/1
 * SCHEDULED for 9/3
 * Task completed 8/1
 *
 * Next ID: 24
 */
export type OdProtosElementsData_UtilityTaskInput = {
  accountNumber?: InputMaybe<Scalars['String']>;
  /**
   * An identifier to track tasks which were generated in the same batch
   * (for billing purposes)
   */
  batchUuid?: InputMaybe<Scalars['String']>;
  /** Additional context for why the task is blocked */
  blockedReason?: InputMaybe<Scalars['String']>;
  /** Task completion timestamp */
  completedAt?: InputMaybe<Scalars['DateTime']>;
  /** The vendor who serviced this utility type */
  contactedBy?: InputMaybe<Scalars['String']>;
  /**
   * Reference to a utility context.
   * Flip token should follow the convention of 'flip:[TOKEN_HERE]'
   */
  contextIdentifier?: InputMaybe<Scalars['String']>;
  /** Task creation timestamp */
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** Task deletion timestamp */
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  /** Date we want the activity to be scheduled */
  desiredActivityDate?: InputMaybe<Scalars['DateTime']>;
  /** To indicate if utility provider has been contacted for this task */
  isProviderContacted?: InputMaybe<Scalars['Boolean']>;
  /** If the task has a sync_scheduled_date, but is already synced immediately */
  isScheduledSyncCancelled?: InputMaybe<Scalars['Boolean']>;
  /** Last successful sync with an external tasking system */
  lastSyncedAt?: InputMaybe<Scalars['DateTime']>;
  note?: InputMaybe<Scalars['String']>;
  /** Utility provider, e.g. PG&E */
  provider?: InputMaybe<Scalars['String']>;
  reason?: InputMaybe<OdProtosElementsData_UtilityTask_Reason>;
  /** Date that the activity was actually scheduled */
  scheduledActivityDate?: InputMaybe<Scalars['DateTime']>;
  state?: InputMaybe<OdProtosElementsData_UtilityTask_TaskState>;
  /** Date we want the activity to be synced */
  syncScheduledDate?: InputMaybe<Scalars['DateTime']>;
  taskAction?: InputMaybe<OdProtosElementsData_UtilityTask_TaskAction>;
  /** Task update timestamp */
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  utilityType?: InputMaybe<OdProtosElementsData_UtilityTask_UtilityType>;
  uuid?: InputMaybe<Scalars['String']>;
  /** Whether the property has Sewer or Septic */
  wasteWaterType?: InputMaybe<Scalars['String']>;
};

/** Next ID: 8 */
export type OdProtosElementsData_UtilityTask_Reason =
  | 'ACQ_COE'
  | 'ACQ_COE_CHANGE'
  | 'EXPIRED'
  | 'LATE_CHECKOUT'
  | 'RESALE_COE'
  | 'RESALE_COE_CHANGE'
  | 'UNKNOWN_REASON'
  | 'WITHDRAWN';

/** Next ID: 6 */
export type OdProtosElementsData_UtilityTask_TaskAction =
  | 'HANDLE_WITHDRAWAL'
  | 'MODIFY_OFF'
  | 'MODIFY_ON'
  | 'TURN_OFF'
  | 'TURN_ON'
  | 'UNKNOWN_ACTION';

/** Next ID: 9 */
export type OdProtosElementsData_UtilityTask_TaskState =
  | 'BLOCKED'
  | 'CANCELED'
  | 'CLAIMED'
  | 'COMPLETED'
  | 'NOT_APPLICABLE'
  | 'PENDING_CX'
  | 'RE_OPENED'
  | 'UNCLAIMED'
  /**
   * UKNOWN_STATE is the default task state but should not be used in normal
   * circumstances.
   */
  | 'UNKNOWN_STATE';

/**
 * UtilityType is an enum that represents the possible types of utilities
 * or services that can be set up within a home.
 *
 * Next ID: 6
 */
export type OdProtosElementsData_UtilityTask_UtilityType =
  | 'ELECTRIC'
  | 'GAS'
  | 'SEWAGE'
  | 'TRASH'
  | 'UNKNOWN_TYPE'
  | 'WATER';

/**
 * Elements uses the context of existing tasks to apply a command.
 * A command can result in generating a new task or updating an existing task.
 *
 * NEXT ID: 9
 */
export type OdProtosElementsServices_CommandInput = {
  accountNumber?: InputMaybe<Scalars['String']>;
  /**
   * Reference to a utility context.
   * Flip token should follow the convention of 'flip:[TOKEN_HERE]'
   */
  contextIdentifier?: InputMaybe<Scalars['String']>;
  /** Date we want the activity to be scheduled. */
  desiredActivityDate?: InputMaybe<Scalars['DateTime']>;
  note?: InputMaybe<Scalars['String']>;
  provider?: InputMaybe<Scalars['String']>;
  reason?: InputMaybe<OdProtosElementsData_UtilityTask_Reason>;
  taskAction?: InputMaybe<OdProtosElementsData_UtilityTask_TaskAction>;
  utilityType?: InputMaybe<OdProtosElementsData_UtilityTask_UtilityType>;
};

export type OdProtosElementsServices_ElementsDebugRequest_SyncServiceAccountsInput = {
  _empty?: InputMaybe<Scalars['Boolean']>;
};

export type OdProtosElementsServices_ElementsDebugRequest_SyncTasksInput = {
  contextIdentifier?: InputMaybe<Scalars['String']>;
  /** This flag can be set to only resync unsynced tasks. */
  onlyUnsynced?: InputMaybe<Scalars['Boolean']>;
};

export type OdProtosElementsServices_ElementsRequest_CreateTaskInput = {
  task?: InputMaybe<OdProtosElementsData_UtilityTaskInput>;
};

export type OdProtosElementsServices_ElementsRequest_DeleteTaskInput = {
  taskUuid?: InputMaybe<Scalars['String']>;
};

/** Flip token identifier should follow the convention of 'flip:[TOKEN_HERE]' */
export type OdProtosElementsServices_ElementsRequest_GetContextInput = {
  identifier?: InputMaybe<Scalars['String']>;
};

export type OdProtosElementsServices_ElementsRequest_GetTaskInput = {
  taskUuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosElementsServices_ElementsRequest_GetUtilityContextAndTasksInput = {
  identifier?: InputMaybe<Scalars['String']>;
};

export type OdProtosElementsServices_ElementsRequest_MutateTaskInput = {
  taskMutate?: InputMaybe<OdProtosElementsServices_TaskMutateInput>;
};

export type OdProtosElementsServices_ElementsRequest_PushCommandsAndContextInput = {
  commands?: InputMaybe<Array<OdProtosElementsServices_CommandInput>>;
  context?: InputMaybe<OdProtosElementsData_UtilityContextInput>;
};

export type OdProtosElementsServices_ElementsRequest_SaveContextInput = {
  context?: InputMaybe<OdProtosElementsData_UtilityContextInput>;
};

export type OdProtosElementsServices_ElementsRequest_UpdateLastContextSyncInput = {
  identifier?: InputMaybe<Scalars['String']>;
};

export type OdProtosElementsServices_ElementsRequest_UpdateLastTaskSyncInput = {
  uuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosElementsServices_PublishToHomeDataStoreRequestInput = {
  flipToken?: InputMaybe<Scalars['String']>;
};

export type OdProtosElementsServices_SyncWattbuyWebNotesRequestInput = {
  flipToken?: InputMaybe<Scalars['String']>;
};

/** NEXT ID: 11 */
export type OdProtosElementsServices_TaskMutateInput = {
  accountNumber?: InputMaybe<Scalars['String']>;
  /** Task completion timestamp */
  completedAt?: InputMaybe<Scalars['DateTime']>;
  /** The vendor who serviced this utility type */
  contactedBy?: InputMaybe<Scalars['String']>;
  /** Indicates if utility provider has been contacted for this task */
  isProviderContacted?: InputMaybe<Scalars['Boolean']>;
  note?: InputMaybe<Scalars['String']>;
  /** Mutable fields */
  provider?: InputMaybe<Scalars['String']>;
  /** Date that the activity was actually scheduled. */
  scheduledActivityDate?: InputMaybe<Scalars['DateTime']>;
  state?: InputMaybe<OdProtosElementsData_UtilityTask_TaskState>;
  /** Task identifier */
  uuid?: InputMaybe<Scalars['String']>;
  /** Whether the property has Sewer or Septic */
  wasteWaterType?: InputMaybe<Scalars['String']>;
};

export type OdProtosElementsServices_TestCcpaAccessRequestInput = {
  customerUuid?: InputMaybe<Scalars['String']>;
};

/** Next ID: 8 */
export type OdProtosFenceData_RegionDetailInput = {
  archivedAt?: InputMaybe<Scalars['DateTime']>;
  /** From Directory */
  createdByToken?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  /** From Directory */
  editPermOrganizationUuids?: InputMaybe<Array<Scalars['String']>>;
  /**
   * Should only be populated with a Polygon or MultiPolygon GeoJSON object.
   * [To be implemented] - Will be usable after Polyfence rollout.
   */
  geojsonGeom?: InputMaybe<Scalars['String']>;
  /** [To be deprecated] Optional - Will no longer be used for actual logic after Polyfence rollout. Please use geojson_geom instead. */
  postalCodes?: InputMaybe<Array<Scalars['String']>>;
  state?: InputMaybe<OdProtosCommonState_State>;
};

/** Next ID: 6 */
export type OdProtosFenceData_RegionInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** Optional - may be empty if with_detail not set in request */
  details?: InputMaybe<OdProtosFenceData_RegionDetailInput>;
  identifier?: InputMaybe<Scalars['String']>;
  tagIdentifiers?: InputMaybe<Array<Scalars['String']>>;
  version?: InputMaybe<Scalars['Float']>;
};

/** Next ID: 3 */
export type OdProtosFenceServices_AddTagsToRegionRequestInput = {
  regionIdentifier?: InputMaybe<Scalars['String']>;
  tagIdentifiers?: InputMaybe<Array<Scalars['String']>>;
};

/**
 * Parameters for BulkGetIntersectingRegions RPC
 * Next ID: 5
 *
 * Required. The response will include all regions that intersect with this one
 * A region always intersects itself, but it may be excluded from the results
 * if it is not tagged correctly
 */
export type OdProtosFenceServices_BulkGetIntersectingRegionsRequestInput = {
  /** Fence Region identifier. */
  identifiers?: InputMaybe<Array<Scalars['String']>>;
  /** Filter the regions to return only those with ALL of these tags */
  tags?: InputMaybe<Array<Scalars['String']>>;
  /** Include the details field */
  withDetail?: InputMaybe<Scalars['Boolean']>;
};

/** Next ID: 5 */
export type OdProtosFenceServices_BulkGetRegionsFromAddressRequestInput = {
  addresses?: InputMaybe<Array<OdProtosFenceServices_BulkGetRegionsFromAddressRequest_AddressInput>>;
  tags?: InputMaybe<Array<Scalars['String']>>;
  withDetail?: InputMaybe<Scalars['Boolean']>;
  withGeom?: InputMaybe<Scalars['Boolean']>;
};

export type OdProtosFenceServices_BulkGetRegionsFromAddressRequest_AddressInput = {
  address?: InputMaybe<OdProtosFenceServices_BulkGetRegionsFromAddressRequest_Address_AddressOneofInput>;
};

export type OdProtosFenceServices_BulkGetRegionsFromAddressRequest_Address_AddressOneofInput = {
  addressUuid?: InputMaybe<Scalars['String']>;
  casaAddress?: InputMaybe<OdProtosCasaData_AddressInput>;
};

/** Next ID: 9 */
export type OdProtosFenceServices_CreateRegionRequestInput = {
  /** From Directory */
  createdByToken?: InputMaybe<Scalars['String']>;
  /** Optional - human readable description of region */
  description?: InputMaybe<Scalars['String']>;
  /**
   * Optional - Should only be populated with a Polygon or MultiPolygon GeoJSON object.
   * Will be usable after Polyfence rollout.
   */
  geojsonGeom?: InputMaybe<Scalars['String']>;
  identifier?: InputMaybe<Scalars['String']>;
  /** Optional - empty array is valid (means everyone can edit) */
  organizationUuid?: InputMaybe<Array<Scalars['String']>>;
  /**
   * [To be deprecated] Optional - Can be used with geojson_geom="" to request polygon generation.
   * This code path is for backwards compatibility and is strongly discouraged after Polyfence rollout.
   */
  postalCodes?: InputMaybe<Array<Scalars['String']>>;
  /** Optional */
  state?: InputMaybe<OdProtosCommonState_State>;
  /** Optional - empty array is valid */
  tagsIdentifiers?: InputMaybe<Array<Scalars['String']>>;
};

/** Next ID: 5 */
export type OdProtosFenceServices_CreateTagRequestInput = {
  /** From Directory */
  createdByToken?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  identifier?: InputMaybe<Scalars['String']>;
  noOverlap?: InputMaybe<Scalars['Boolean']>;
};

/**
 * Parameters for GetIntersectingRegions RPC
 * Next ID: 5
 *
 * Required. The response will include all regions that intersect with this one
 * A region always intersects itself, but it may be excluded from the results
 * if it is not tagged correctly
 */
export type OdProtosFenceServices_GetIntersectingRegionsRequestInput = {
  /** Fence Region identifier. */
  identifier?: InputMaybe<Scalars['String']>;
  /** Filter the regions to return only those with ALL of these tags */
  tags?: InputMaybe<Array<Scalars['String']>>;
  /** Include the details field */
  withDetail?: InputMaybe<Scalars['Boolean']>;
  withGeom?: InputMaybe<Scalars['Boolean']>;
};

/** Next ID: 2 */
export type OdProtosFenceServices_GetRegionHistoryRequestInput = {
  identifier?: InputMaybe<Scalars['String']>;
};

/** Next ID: 2 */
export type OdProtosFenceServices_GetRegionRequestInput = {
  identifier?: InputMaybe<Scalars['String']>;
};

/** Next ID: 6 */
export type OdProtosFenceServices_GetRegionsFromAddressRequestInput = {
  address?: InputMaybe<OdProtosFenceServices_GetRegionsFromAddressRequest_AddressOneofInput>;
  tags?: InputMaybe<Array<Scalars['String']>>;
  withDetail?: InputMaybe<Scalars['Boolean']>;
  withGeom?: InputMaybe<Scalars['Boolean']>;
};

export type OdProtosFenceServices_GetRegionsFromAddressRequest_AddressOneofInput = {
  addressUuid?: InputMaybe<Scalars['String']>;
  casaAddress?: InputMaybe<OdProtosCasaData_AddressInput>;
};

/** Next ID: 3 */
export type OdProtosFenceServices_GetRegionsFromPostalCodesRequestInput = {
  postalCodes?: InputMaybe<Array<Scalars['String']>>;
  tags?: InputMaybe<Array<Scalars['String']>>;
};

/** Next ID: 4 */
export type OdProtosFenceServices_GetRegionsFromTagsRequestInput = {
  /** Optional - will return all regions if empty */
  tagIdentifiers?: InputMaybe<Array<Scalars['String']>>;
  withDetail?: InputMaybe<Scalars['Boolean']>;
  withGeom?: InputMaybe<Scalars['Boolean']>;
};

/** Next ID: 2 */
export type OdProtosFenceServices_GetRegionsRequestInput = {
  identifiers?: InputMaybe<Array<Scalars['String']>>;
};

/** Next ID: 2 */
export type OdProtosFenceServices_GetTagRequestInput = {
  identifier?: InputMaybe<Scalars['String']>;
};

/** Next ID: 2 */
export type OdProtosFenceServices_GetTagsRequestInput = {
  /** Optional - return all tags if unset */
  identifiers?: InputMaybe<Array<Scalars['String']>>;
};

/** Next ID: 4 */
export type OdProtosFenceServices_UpdateRegionRequestInput = {
  region?: InputMaybe<OdProtosFenceData_RegionInput>;
  /**
   * Required: identifier, details.created_by_token
   * Won't update (set internally): version, created_at, details.archived_at
   */
  updateMask?: InputMaybe<GoogleProtobuf_FieldMaskInput>;
};

export type OdProtosFinanceData_AccountBalanceInput = {
  accountId?: InputMaybe<Scalars['String']>;
  amount?: InputMaybe<Scalars['String']>;
};

export type OdProtosFinanceData_AccountInput = {
  balance?: InputMaybe<Scalars['Float']>;
  bankName?: InputMaybe<Scalars['String']>;
  contributesToBorrowingBase?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  syncTime?: InputMaybe<Scalars['DateTime']>;
  type?: InputMaybe<Scalars['String']>;
};

export type OdProtosFinanceData_AccountsInput = {
  accounts?: InputMaybe<Array<OdProtosFinanceData_Accounts_AccountsEntryInput>>;
};

/** `OdProtosFinanceData_Accounts_AccountsEntryInput` represents the `accounts` map in `od_protos.finance.data.Accounts`. */
export type OdProtosFinanceData_Accounts_AccountsEntryInput = {
  key?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<OdProtosFinanceData_AccountInput>;
};

/** Acquisition // */
export type OdProtosFinanceData_AcquisitionInput = {
  actualCoeDate?: InputMaybe<Scalars['DateTime']>;
  expectedInitialCapEx?: InputMaybe<Scalars['Float']>;
  grossPurchasePrice?: InputMaybe<Scalars['Float']>;
  netPrice?: InputMaybe<Scalars['Float']>;
  scheduledCoeDate?: InputMaybe<Scalars['DateTime']>;
};

export type OdProtosFinanceData_BorrowingBaseInput = {
  concentrationLimits?: InputMaybe<Array<OdProtosFinanceData_ConcentrationLimitInput>>;
  state?: InputMaybe<OdProtosFinanceData_BorrowingBaseStateInput>;
};

export type OdProtosFinanceData_BorrowingBaseSnapshotInput = {
  borrowingBaseAmount?: InputMaybe<Scalars['Float']>;
  borrowingBaseAsOfDate?: InputMaybe<Scalars['DateTime']>;
  breachState?: InputMaybe<Scalars['String']>;
  cash?: InputMaybe<Scalars['Float']>;
  collateralization?: InputMaybe<Scalars['Float']>;
  concentrationLimitId?: InputMaybe<Scalars['String']>;
  facilityTransactions?: InputMaybe<Array<OdProtosFinanceData_TransactionInput>>;
  isInBreach?: InputMaybe<Scalars['Boolean']>;
  loanAmount?: InputMaybe<Scalars['Float']>;
  results?: InputMaybe<Array<OdProtosFinanceData_ConcentrationLimitResultInput>>;
};

export type OdProtosFinanceData_BorrowingBaseStateInput = {
  breachState?: InputMaybe<Scalars['String']>;
  initialSnapshot?: InputMaybe<OdProtosFinanceData_BorrowingBaseSnapshotInput>;
  isInBreach?: InputMaybe<Scalars['Boolean']>;
  latestSnapshot?: InputMaybe<OdProtosFinanceData_BorrowingBaseSnapshotInput>;
  maxSnapshot?: InputMaybe<OdProtosFinanceData_BorrowingBaseSnapshotInput>;
};

export type OdProtosFinanceData_ConcentrationLimitInput = {
  distinctTransactionBucketRule?: InputMaybe<OdProtosFinanceData_DistinctTransactionBucketInput>;
  id?: InputMaybe<Scalars['String']>;
  postProcessor?: InputMaybe<OdProtosFinanceData_PostProcessorInput>;
  transactionBucketRules?: InputMaybe<Array<OdProtosFinanceData_TransactionBucketRuleInput>>;
};

export type OdProtosFinanceData_ConcentrationLimitResultInput = {
  amount?: InputMaybe<Scalars['Float']>;
  concentrationLimitId?: InputMaybe<Scalars['String']>;
  results?: InputMaybe<Array<OdProtosFinanceData_TransactionBucketResultInput>>;
};

export type OdProtosFinanceData_DistinctThresholdsInput = {
  default?: InputMaybe<Scalars['Float']>;
  overrides?: InputMaybe<Array<OdProtosFinanceData_OverrideThresholdInput>>;
};

export type OdProtosFinanceData_DistinctTransactionBucketInput = {
  distinctThresholds?: InputMaybe<OdProtosFinanceData_DistinctThresholdsInput>;
  id?: InputMaybe<Scalars['String']>;
  partitionField?: InputMaybe<Scalars['String']>;
};

export type OdProtosFinanceData_EmailTemplateInput = {
  body?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  recipientGroupName?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type OdProtosFinanceData_FacilityInput = {
  accounts?: InputMaybe<OdProtosFinanceData_AccountsInput>;
  borrowingBase?: InputMaybe<OdProtosFinanceData_BorrowingBaseInput>;
  fundedTransactions?: InputMaybe<OdProtosFinanceData_FundedTransactionsInput>;
  id?: InputMaybe<Scalars['String']>;
  loanTerms?: InputMaybe<OdProtosFinanceData_LoanTermsInput>;
  marketConfig?: InputMaybe<OdProtosFinanceData_MarketsInput>;
  name?: InputMaybe<Scalars['String']>;
  owningEntity?: InputMaybe<Scalars['String']>;
  rateSchedule?: InputMaybe<OdProtosFinanceData_RateScheduleInput>;
  type?: InputMaybe<Scalars['String']>;
};

/** Financing // */
export type OdProtosFinanceData_FinancingInput = {
  facilityAllocations?: InputMaybe<Array<OdProtosFinanceData_Financing_FacilityAllocationsEntryInput>>;
};

/** `OdProtosFinanceData_Financing_FacilityAllocationsEntryInput` represents the `facility_allocations` map in `od_protos.finance.data.Financing`. */
export type OdProtosFinanceData_Financing_FacilityAllocationsEntryInput = {
  key?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type OdProtosFinanceData_FundedTransactionInput = {
  amount?: InputMaybe<Scalars['Float']>;
  transactionId?: InputMaybe<Scalars['String']>;
};

export type OdProtosFinanceData_FundedTransactionsInput = {
  transactions?: InputMaybe<Array<OdProtosFinanceData_FundedTransactions_TransactionsEntryInput>>;
};

/** `OdProtosFinanceData_FundedTransactions_TransactionsEntryInput` represents the `transactions` map in `od_protos.finance.data.FundedTransactions`. */
export type OdProtosFinanceData_FundedTransactions_TransactionsEntryInput = {
  key?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<OdProtosFinanceData_FundedTransactionInput>;
};

export type OdProtosFinanceData_LoanTermsInput = {
  amount?: InputMaybe<Scalars['Float']>;
};

export type OdProtosFinanceData_MarketInput = {
  category?: InputMaybe<Scalars['String']>;
  internalName?: InputMaybe<Scalars['String']>;
  launchDate?: InputMaybe<Scalars['DateTime']>;
  msa?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  zipCode?: InputMaybe<Scalars['String']>;
};

export type OdProtosFinanceData_MarketsInput = {
  markets?: InputMaybe<Array<OdProtosFinanceData_Markets_MarketsEntryInput>>;
};

/** `OdProtosFinanceData_Markets_MarketsEntryInput` represents the `markets` map in `od_protos.finance.data.Markets`. */
export type OdProtosFinanceData_Markets_MarketsEntryInput = {
  key?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<OdProtosFinanceData_MarketInput>;
};

export type OdProtosFinanceData_OverrideThresholdInput = {
  threshold?: InputMaybe<Scalars['Float']>;
  value?: InputMaybe<Scalars['String']>;
};

export type OdProtosFinanceData_PostProcessorInput = {
  count?: InputMaybe<Scalars['Float']>;
  id?: InputMaybe<Scalars['String']>;
  threshold?: InputMaybe<Scalars['Float']>;
  type?: InputMaybe<Scalars['String']>;
};

export type OdProtosFinanceData_PropertyAddressInput = {
  city?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  streetAddress?: InputMaybe<Scalars['String']>;
  token?: InputMaybe<Scalars['String']>;
  unit?: InputMaybe<Scalars['String']>;
  zipCode?: InputMaybe<Scalars['String']>;
};

export type OdProtosFinanceData_PropertyDetailInput = {
  address?: InputMaybe<OdProtosFinanceData_PropertyAddressInput>;
  numBathrooms?: InputMaybe<Scalars['Float']>;
  numBedrooms?: InputMaybe<Scalars['Float']>;
  propertyType?: InputMaybe<OdProtosFinanceData_PropertyDetail_PropertyType>;
  type?: InputMaybe<Scalars['String']>;
  yearBuilt?: InputMaybe<Scalars['Float']>;
};

export type OdProtosFinanceData_PropertyDetail_PropertyType =
  | 'CONDO'
  | 'MULTI_FAMILY'
  | 'PROPERTY_TYPE_UNSPECIFIED'
  | 'SINGLE_FAMILY'
  | 'TOWNHOUSE_OTHER';

/** Property // */
export type OdProtosFinanceData_PropertyInput = {
  detail?: InputMaybe<OdProtosFinanceData_PropertyDetailInput>;
  id?: InputMaybe<Scalars['String']>;
  syncTime?: InputMaybe<Scalars['DateTime']>;
};

export type OdProtosFinanceData_RateInput = {
  end?: InputMaybe<Scalars['Float']>;
  loanToCost?: InputMaybe<Scalars['Float']>;
  loanToValue?: InputMaybe<Scalars['Float']>;
  rateId?: InputMaybe<Scalars['String']>;
  resale?: InputMaybe<Scalars['Float']>;
  start?: InputMaybe<Scalars['Float']>;
};

export type OdProtosFinanceData_RateScheduleInput = {
  rateSchedule?: InputMaybe<Array<OdProtosFinanceData_RateInput>>;
};

/** Resale // */
export type OdProtosFinanceData_ResaleInput = {
  actualCoeDate?: InputMaybe<Scalars['DateTime']>;
  concentrationProceeds?: InputMaybe<OdProtosFinanceData_ResaleProceedsInput>;
  escrowProceeds?: InputMaybe<OdProtosFinanceData_ResaleProceedsInput>;
  scheduledCoeDate?: InputMaybe<Scalars['DateTime']>;
};

export type OdProtosFinanceData_ResaleProceedsInput = {
  date?: InputMaybe<Scalars['DateTime']>;
  money?: InputMaybe<Scalars['Float']>;
};

export type OdProtosFinanceData_TransactionBucketResultInput = {
  bbAmount?: InputMaybe<Scalars['Float']>;
  id?: InputMaybe<Scalars['String']>;
  maxLoanAmount?: InputMaybe<Scalars['Float']>;
  ruleId?: InputMaybe<Scalars['String']>;
  threshold?: InputMaybe<Scalars['Float']>;
  transactionIds?: InputMaybe<Array<Scalars['String']>>;
  withdrawalValue?: InputMaybe<Scalars['Float']>;
};

export type OdProtosFinanceData_TransactionBucketRuleInput = {
  conditionExpression?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  threshold?: InputMaybe<Scalars['Float']>;
};

/** Transaction // */
export type OdProtosFinanceData_TransactionInput = {
  acquisition?: InputMaybe<OdProtosFinanceData_AcquisitionInput>;
  financing?: InputMaybe<OdProtosFinanceData_FinancingInput>;
  id?: InputMaybe<Scalars['String']>;
  property?: InputMaybe<OdProtosFinanceData_PropertyInput>;
  resale?: InputMaybe<OdProtosFinanceData_ResaleInput>;
};

export type OdProtosFinanceServices_AuthorizeOauthRequestInput = {
  _empty?: InputMaybe<Scalars['Boolean']>;
};

/** BatchCreateOrUpdateTransactions // */
export type OdProtosFinanceServices_BatchCreateOrUpdateTransactionsRequestInput = {
  transactions?: InputMaybe<Array<OdProtosFinanceData_TransactionInput>>;
};

/** BatchDeleteTransactionFinancing // */
export type OdProtosFinanceServices_BatchDeleteTransactionFinancingRequestInput = {
  ids?: InputMaybe<Array<Scalars['String']>>;
};

/** BatchDeleteTransactions - NOT IMPLEMENTED // */
export type OdProtosFinanceServices_BatchDeleteTransactionsRequestInput = {
  ids?: InputMaybe<Array<Scalars['String']>>;
};

/** CreateConcentrationLimit // */
export type OdProtosFinanceServices_CreateConcentrationLimitRequestInput = {
  concentrationLimit?: InputMaybe<OdProtosFinanceData_ConcentrationLimitInput>;
  facilityId?: InputMaybe<Scalars['String']>;
};

export type OdProtosFinanceServices_CreateEmailTemplateRequestInput = {
  template?: InputMaybe<OdProtosFinanceData_EmailTemplateInput>;
};

/** CreateFacility // */
export type OdProtosFinanceServices_CreateFacilityAccountRequestInput = {
  account?: InputMaybe<OdProtosFinanceData_AccountInput>;
  facilityId?: InputMaybe<Scalars['String']>;
};

/** CreateFacility // */
export type OdProtosFinanceServices_CreateFacilityRequestInput = {
  facility?: InputMaybe<OdProtosFinanceData_FacilityInput>;
};

/** DeleteConcentrationLimit// */
export type OdProtosFinanceServices_DeleteConcentrationLimitRequestInput = {
  concentrationLimitId?: InputMaybe<Scalars['String']>;
  facilityId?: InputMaybe<Scalars['String']>;
};

/** DeleteFacility // */
export type OdProtosFinanceServices_DeleteFacilityAccountRequestInput = {
  accountId?: InputMaybe<Scalars['String']>;
  facilityId?: InputMaybe<Scalars['String']>;
};

/** DeleteFacilityMarkets // */
export type OdProtosFinanceServices_DeleteFacilityMarketsRequestInput = {
  facilityId?: InputMaybe<Scalars['String']>;
  zipCodes?: InputMaybe<Array<Scalars['String']>>;
};

/** GetFacility // */
export type OdProtosFinanceServices_GetFacilityRequestInput = {
  facilityId?: InputMaybe<Scalars['String']>;
};

/** GetTransaction // */
export type OdProtosFinanceServices_GetTransactionRequestInput = {
  id?: InputMaybe<Scalars['String']>;
};

/** Email Templates // */
export type OdProtosFinanceServices_ListEmailTemplatesRequestInput = {
  _empty?: InputMaybe<Scalars['Boolean']>;
};

/** ListFacilities // */
export type OdProtosFinanceServices_ListFacilitiesRequestInput = {
  pagination?: InputMaybe<OdProtosCommonPagination_PaginationRequestInput>;
};

/** ListFundedTransactions // */
export type OdProtosFinanceServices_ListFundedTransactionsRequestInput = {
  _empty?: InputMaybe<Scalars['Boolean']>;
};

/** SetAccountBalances // */
export type OdProtosFinanceServices_SetFacilityAccountBalancesRequestInput = {
  accountBalances?: InputMaybe<Array<OdProtosFinanceData_AccountBalanceInput>>;
  facilityId?: InputMaybe<Scalars['String']>;
};

export type OdProtosFinanceServices_SyncFacilityMarketsRequestInput = {
  _empty?: InputMaybe<Scalars['Boolean']>;
};

/** UpdateConcentrationLimit // */
export type OdProtosFinanceServices_UpdateConcentrationLimitRequestInput = {
  concentrationLimit?: InputMaybe<OdProtosFinanceData_ConcentrationLimitInput>;
  facilityId?: InputMaybe<Scalars['String']>;
};

/** UpdateFacility // */
export type OdProtosFinanceServices_UpdateFacilityAccountRequestInput = {
  account?: InputMaybe<OdProtosFinanceData_AccountInput>;
  facilityId?: InputMaybe<Scalars['String']>;
};

/** UpdateFacility // */
export type OdProtosFinanceServices_UpdateFacilityRequestInput = {
  facility?: InputMaybe<OdProtosFinanceData_FacilityInput>;
};

/** UpsertFacilityMarkets // */
export type OdProtosFinanceServices_UpsertFacilityMarketsRequestInput = {
  facilityId?: InputMaybe<Scalars['String']>;
  markets?: InputMaybe<Array<OdProtosFinanceData_MarketInput>>;
};

export type OdProtosFulfillmentData_MilestoneStatus =
  | 'CLOSE'
  | 'OPEN';

export type OdProtosFulfillmentServices_CreateClosingValidationByReasonInput = {
  fulfillmentId?: InputMaybe<Scalars['String']>;
  reason?: InputMaybe<Scalars['String']>;
};

export type OdProtosFulfillmentServices_CreateClosingValidationByValidationInput = {
  deedDocumentId?: InputMaybe<Scalars['String']>;
  deedRecordingDate?: InputMaybe<Scalars['DateTime']>;
  disbursementDate?: InputMaybe<Scalars['DateTime']>;
  finalSettlementStatementDocumentId?: InputMaybe<Scalars['String']>;
  fulfillmentId?: InputMaybe<Scalars['String']>;
  reason?: InputMaybe<Scalars['String']>;
  settlementDate?: InputMaybe<Scalars['DateTime']>;
};

export type OdProtosFulfillmentServices_CreateClosingValidationRequestInput = {
  by?: InputMaybe<OdProtosFulfillmentServices_CreateClosingValidationRequest_ByOneofInput>;
};

export type OdProtosFulfillmentServices_CreateClosingValidationRequest_ByOneofInput = {
  skipvalidation?: InputMaybe<OdProtosFulfillmentServices_CreateClosingValidationByReasonInput>;
  validate?: InputMaybe<OdProtosFulfillmentServices_CreateClosingValidationByValidationInput>;
};

export type OdProtosFulfillmentServices_GetClosingValidationById_RequestInput = {
  by?: InputMaybe<OdProtosFulfillmentServices_GetClosingValidationById_Request_ByOneofInput>;
};

export type OdProtosFulfillmentServices_GetClosingValidationById_Request_ByOneofInput = {
  closingValidationId?: InputMaybe<Scalars['String']>;
  fulfillmentId?: InputMaybe<Scalars['String']>;
};

export type OdProtosFulfillmentServices_GetFulfillmentById_RequestInput = {
  by?: InputMaybe<OdProtosFulfillmentServices_GetFulfillmentById_Request_ByOneofInput>;
};

export type OdProtosFulfillmentServices_GetFulfillmentById_Request_ByOneofInput = {
  fulfillmentId?: InputMaybe<Scalars['String']>;
  listingOfferUuid?: InputMaybe<Scalars['String']>;
  offerUuid?: InputMaybe<Scalars['String']>;
};

/** Next ID: 2 */
export type OdProtosFulfillmentServices_GetFulfillmentRequestInput = {
  fulfillmentId?: InputMaybe<Scalars['String']>;
};

export type OdProtosFulfillmentServices_GetFulfillmentWebStateRequestInput = {
  fulfillmentId?: InputMaybe<Scalars['String']>;
};

export type OdProtosFulfillmentServices_GetFulfillmentsSummaryForOperatorsRequestInput = {
  endTime?: InputMaybe<Scalars['DateTime']>;
  operatorTokens?: InputMaybe<Array<Scalars['String']>>;
  startTime?: InputMaybe<Scalars['DateTime']>;
};

export type OdProtosFulfillmentServices_GetTotalActiveVolumeForOperatorsRequestInput = {
  activeVolumeFilters?: InputMaybe<Array<OdProtosOperatorServices_ActiveVolumeFilterInput>>;
};

export type OdProtosFulfillmentServices_ReassignFulfillmentsRequestInput = {
  fulfillmentIds?: InputMaybe<Array<Scalars['String']>>;
  operatorTokens?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosFulfillmentServices_RefreshFulfillmentRequestInput = {
  propertyEngagementId?: InputMaybe<Scalars['String']>;
  propertyId?: InputMaybe<Scalars['String']>;
};

export type OdProtosFulfillmentServices_SearchFulfillmentRequestInput = {
  aggregations?: InputMaybe<Array<OdProtosIndextriousData_AggregationInput>>;
  filters?: InputMaybe<Array<OdProtosIndextriousData_FilterInput>>;
  page?: InputMaybe<OdProtosIndextriousData_PageParamsInput>;
  sortBy?: InputMaybe<Array<OdProtosIndextriousData_SortByInput>>;
};

export type OdProtosFulfillmentServices_UpdateFulfillmentRequestInput = {
  fulfillmentId?: InputMaybe<Scalars['String']>;
  fulfillmentStatus?: InputMaybe<Scalars['String']>;
  fulfillmentStatusReason?: InputMaybe<Scalars['String']>;
};

export type OdProtosGatekeeperServices_GetPermissionsForUserRequestInput = {
  _empty?: InputMaybe<Scalars['Boolean']>;
};

export type OdProtosGatekeeperServices_GetRequiredRolesForAllServicesEndpointsRequestInput = {
  _empty?: InputMaybe<Scalars['Boolean']>;
};

export type OdProtosGatekeeperServices_GetRequiredRolesForEndpointRequestInput = {
  /** Next ID: 3 */
  endpointName?: InputMaybe<Scalars['String']>;
  serviceName?: InputMaybe<Scalars['String']>;
};

export type OdProtosGatekeeperServices_GetRequiredRolesForPermissionsRequestInput = {
  permissions?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosGatekeeperServices_GetRequiredRolesForServiceEndpointsRequestInput = {
  /** Next ID: 2 */
  serviceName?: InputMaybe<Scalars['String']>;
};

export type OdProtosGatekeeperServices_GetServicePermissionsForRolesRequestInput = {
  serviceName?: InputMaybe<Scalars['String']>;
};

export type OdProtosGatekeeperServices_GetWebPermissionsForRolesRequestInput = {
  _empty?: InputMaybe<Scalars['Boolean']>;
};

/** Next ID: 39 */
export type OdProtosGeoDataStoreData_CoreLogicBuildingPermitInput = {
  addressCity?: InputMaybe<Scalars['String']>;
  addressPostalCode?: InputMaybe<Scalars['String']>;
  addressState?: InputMaybe<Scalars['String']>;
  addressStreet?: InputMaybe<Scalars['String']>;
  addressUnitNumber?: InputMaybe<Scalars['String']>;
  addressUnitType?: InputMaybe<Scalars['String']>;
  addressUuid?: InputMaybe<Scalars['String']>;
  apn?: InputMaybe<Scalars['String']>;
  buildingPermitNumber?: InputMaybe<Scalars['String']>;
  contractorBusinessName?: InputMaybe<Scalars['String']>;
  contractorCity?: InputMaybe<Scalars['String']>;
  contractorPostalCode?: InputMaybe<Scalars['String']>;
  contractorState?: InputMaybe<Scalars['String']>;
  contractorType?: InputMaybe<Scalars['Int']>;
  contractorUrl?: InputMaybe<Scalars['String']>;
  countyLandUseDescription?: InputMaybe<Scalars['String']>;
  fipsCode?: InputMaybe<Scalars['String']>;
  homeownerName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  landUseCode?: InputMaybe<Scalars['Int']>;
  mostRecentStatusAttained?: InputMaybe<Scalars['String']>;
  permitDescription?: InputMaybe<Scalars['String']>;
  permitEffectiveDate?: InputMaybe<OdProtosCommon_DateInput>;
  permitExpirationDate?: InputMaybe<OdProtosCommon_DateInput>;
  permitFilingFeesCents?: InputMaybe<Scalars['Float']>;
  permitJobValueCents?: InputMaybe<Scalars['Float']>;
  permitNumberOfUnits?: InputMaybe<Scalars['Float']>;
  permitProjectType1?: InputMaybe<Scalars['String']>;
  permitProjectType2?: InputMaybe<Scalars['String']>;
  permitProjectType3?: InputMaybe<Scalars['String']>;
  permitSquareFeet?: InputMaybe<Scalars['Float']>;
  permitStatus?: InputMaybe<Scalars['String']>;
  permitStories?: InputMaybe<Scalars['Float']>;
  permitSubtypeOfWork?: InputMaybe<Scalars['String']>;
  permitTypeOfWork?: InputMaybe<Scalars['String']>;
  projectName?: InputMaybe<Scalars['String']>;
  propertyIndicatorCode?: InputMaybe<Scalars['Int']>;
  stateLandUseDescription?: InputMaybe<Scalars['String']>;
};

export type OdProtosGeoDataStoreData_EducationLevel =
  | 'EDUCATIONLEVEL_ELEMENTARY'
  | 'EDUCATIONLEVEL_HIGH'
  | 'EDUCATIONLEVEL_MIDDLE'
  | 'EDUCATIONLEVEL_UNKNOWN';

/**
 * NOT FOR READ USAGE.
 * This is a proto DAS writing Precisely data to GDS ONLY.
 *
 * Next ID:
 */
export type OdProtosGeoDataStoreData_PreciselyDistrictInput = {
  /** wkt shape of the school district boundary */
  boundary?: InputMaybe<Scalars['String']>;
  /** Unique obj_id district identifier internal to precisely */
  id?: InputMaybe<Scalars['String']>;
  /** The name of the school district */
  name?: InputMaybe<Scalars['String']>;
  /** The identifier of the school district from NCES */
  ncesDistrictId?: InputMaybe<Scalars['String']>;
};

/**
 * NOT FOR READ USAGE.
 * This is a proto DAS writing Precisely data to GDS ONLY.
 *
 * Next ID: 15
 */
export type OdProtosGeoDataStoreData_PreciselySchoolInput = {
  /** wkt shape of the school boundary */
  boundary?: InputMaybe<Scalars['String']>;
  /** Unique obj_id district identifier internal to precisely */
  districtId?: InputMaybe<Scalars['String']>;
  /** Level of instruction provided by school (can be multiple) */
  educationLevel?: InputMaybe<Array<OdProtosGeoDataStoreData_EducationLevel>>;
  /** The grades offered at the school e.g. "PK-5" */
  gradesOffered?: InputMaybe<Scalars['String']>;
  /** The great school's overview url for this school */
  greatSchoolsUrl?: InputMaybe<Scalars['String']>;
  /** Unique obj_id school identifier internal to precisely */
  id?: InputMaybe<Scalars['String']>;
  /** The lat/lon of the school */
  latitude?: InputMaybe<Scalars['Float']>;
  longitude?: InputMaybe<Scalars['Float']>;
  /** The name of the school */
  name?: InputMaybe<Scalars['String']>;
  /** The identifier of the school district from NCES */
  ncesDistrictId?: InputMaybe<Scalars['String']>;
  /** The identifier of the school from NCES */
  ncesSchoolId?: InputMaybe<Scalars['String']>;
  /** The great schools rating of the school, out of 10 */
  rating?: InputMaybe<Scalars['Int']>;
  /** The type of school, e.g. public/private */
  schoolType?: InputMaybe<OdProtosGeoDataStoreData_PreciselySchool_SchoolType>;
  /** The school's website url */
  website?: InputMaybe<Scalars['String']>;
};

export type OdProtosGeoDataStoreData_PreciselySchool_SchoolType =
  | 'TYPE_PRIVATE'
  | 'TYPE_PUBLIC'
  | 'TYPE_UNKNOWN';

export type OdProtosGeoDataStoreData_Zone_Type =
  | 'CITY'
  | 'COUNTY'
  | 'MACRO_NEIGHBORHOOD'
  | 'NEIGHBORHOOD'
  | 'RESIDENTIAL_BOUNDARY'
  | 'STATE'
  | 'SUBNEIGHBORHOOD'
  | 'UNKNOWN'
  | 'ZIP_CODE';

export type OdProtosGeoDataStoreServices_BulkGetNicheSchoolsRequestInput = {
  /** The locations to query for schools. Capped at 200 */
  locations?: InputMaybe<Array<OdProtosGeoDataStoreServices_LocationInput>>;
  /**
   * Optional. The max number of schools to return for each location (the first N nearest schools).
   * Defaults to 25 if unset
   * Capped at 250, returns CodeInvalidArgument if request's limit is > 250
   */
  perLocationLimit?: InputMaybe<Scalars['Float']>;
};

export type OdProtosGeoDataStoreServices_BulkGetSchoolsRequestInput = {
  /** The locations to query for schools. Capped at 200 */
  locations?: InputMaybe<Array<OdProtosGeoDataStoreServices_LocationInput>>;
  /**
   * Optional. The max number of schools to return for each location (the first N nearest schools).
   * Defaults to 25 if unset
   * Capped at 250, returns CodeInvalidArgument if request's limit is > 250
   */
  perLocationLimit?: InputMaybe<Scalars['Float']>;
};

export type OdProtosGeoDataStoreServices_BulkGetZoneHierarchyRequestInput = {
  /** The locations to fetch zone hierarchies of. Capped at 20 */
  locations?: InputMaybe<Array<OdProtosGeoDataStoreServices_LocationInput>>;
  /** Optional: Option for modifying the returned geojson `shape` field */
  shapeGeoOption?: InputMaybe<OdProtosGeoDataStoreServices_ShapeGeoOption>;
  /** The zone types. */
  types?: InputMaybe<Array<OdProtosGeoDataStoreData_Zone_Type>>;
};

export type OdProtosGeoDataStoreServices_CheckFloodHazardRequestInput = {
  /** The latitude of the request (usually a home). */
  latitude?: InputMaybe<Scalars['Float']>;
  /** The longitude of the request (usually a home). */
  longitude?: InputMaybe<Scalars['Float']>;
  /** The zones to consider when checking flood hazard (default: A, A99, AE, AH, AO, V, VE). */
  zones?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosGeoDataStoreServices_GeoSortKey =
  | 'SORT_KEY_DEFAULT'
  | 'SORT_KEY_DISTANCE_ASC'
  | 'SORT_KEY_NAME_ASC';

export type OdProtosGeoDataStoreServices_GetCoreLogicBuildingPermitRequestInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type OdProtosGeoDataStoreServices_GetDisplayableZonesRequestInput = {
  /** Optional: Option for modifying the returned geojson `shape` field */
  shapeGeoOption?: InputMaybe<OdProtosGeoDataStoreServices_ShapeGeoOption>;
  /** Gets all zones matching requested UUIDs. */
  uuids?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosGeoDataStoreServices_GetNicheSchoolsRequestInput = {
  /** The latitude of the request (usually a home). */
  latitude?: InputMaybe<Scalars['Float']>;
  /**
   * Optional. The number of schools to return (the first N nearest schools).
   * Defaults to 25 if unset
   * Capped at 250, returns CodeInvalidArgument if request's limit is > 250
   */
  limit?: InputMaybe<Scalars['Float']>;
  /** The longitude of the request (usually a home). */
  longitude?: InputMaybe<Scalars['Float']>;
};

export type OdProtosGeoDataStoreServices_GetSchoolsRequestInput = {
  /** The latitude of the request (usually a home). */
  latitude?: InputMaybe<Scalars['Float']>;
  /**
   * Optional. The number of schools to return (the first N nearest schools).
   * Defaults to 25 if unset
   * Capped at 250, returns CodeInvalidArgument if request's limit is > 250
   */
  limit?: InputMaybe<Scalars['Float']>;
  /** The longitude of the request (usually a home). */
  longitude?: InputMaybe<Scalars['Float']>;
};

export type OdProtosGeoDataStoreServices_GetZoneHierarchyRequestInput = {
  /** The latitude of the request (usually a home). */
  latitude?: InputMaybe<Scalars['Float']>;
  /** The longitude of the request (usually a home). */
  longitude?: InputMaybe<Scalars['Float']>;
  /** Optional: Option for modifying the returned geojson `shape` field */
  shapeGeoOption?: InputMaybe<OdProtosGeoDataStoreServices_ShapeGeoOption>;
  /** The zone types. */
  types?: InputMaybe<Array<OdProtosGeoDataStoreData_Zone_Type>>;
};

export type OdProtosGeoDataStoreServices_GetZonesRequestInput = {
  /** Optional: Option for modifying the returned geojson `shape` field */
  shapeGeoOption?: InputMaybe<OdProtosGeoDataStoreServices_ShapeGeoOption>;
  /** Gets all zones matching requested UUIDs. */
  uuids?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosGeoDataStoreServices_GetZonesVersionIdRequestInput = {
  _empty?: InputMaybe<Scalars['Boolean']>;
};

export type OdProtosGeoDataStoreServices_ListCoreLogicBuildingPermitsRequestInput = {
  addressUuid?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Float']>;
};

export type OdProtosGeoDataStoreServices_LocationInput = {
  /** The latitude of the request (usually a home). */
  latitude?: InputMaybe<Scalars['Float']>;
  /** The longitude of the request (usually a home). */
  longitude?: InputMaybe<Scalars['Float']>;
};

export type OdProtosGeoDataStoreServices_SearchZonesByLocationRequestInput = {
  /** The latitude of the request (usually a home). */
  latitude?: InputMaybe<Scalars['Float']>;
  /**
   * Optional. The number of zones to return
   * Capped at 500, returns CodeInvalidArgument if request's limit is > 500
   * Defaults to 100 if unset
   */
  limit?: InputMaybe<Scalars['Float']>;
  /** The longitude of the request (usually a home). */
  longitude?: InputMaybe<Scalars['Float']>;
  /**
   * Optional: The distance to limit the search to.
   * Only Zones within this distance (in meters) will be returned
   * Capped at 160000 (~100 miles), returns CodeInvalidArgument if request's limit is > 160000
   */
  searchDistance?: InputMaybe<Scalars['Float']>;
  /** Optional: Option for modifying the returned geojson `shape` field */
  shapeGeoOption?: InputMaybe<OdProtosGeoDataStoreServices_ShapeGeoOption>;
  sortKey?: InputMaybe<OdProtosGeoDataStoreServices_GeoSortKey>;
  /** The zone types. */
  types?: InputMaybe<Array<OdProtosGeoDataStoreData_Zone_Type>>;
};

export type OdProtosGeoDataStoreServices_SearchZonesByPolygonRequestInput = {
  /**
   * Optional. The number of zones to return
   * Capped at 500, returns CodeInvalidArgument if request's limit is > 500
   * Defaults to 100 if unset
   */
  limit?: InputMaybe<Scalars['Float']>;
  /** GeoJSON polygon */
  polygon?: InputMaybe<Scalars['String']>;
  /**
   * Optional: The distance to limit the search to.
   * Only Zones within this distance (in meters) of the polygon border will be returned
   * Capped at 160000 (~100 miles), returns CodeInvalidArgument if request's limit is > 160000
   */
  searchDistance?: InputMaybe<Scalars['Float']>;
  /** Optional: Option for modifying the returned geojson `shape` field */
  shapeGeoOption?: InputMaybe<OdProtosGeoDataStoreServices_ShapeGeoOption>;
  sortKey?: InputMaybe<OdProtosGeoDataStoreServices_GeoSortKey>;
  /** The zone types. */
  types?: InputMaybe<Array<OdProtosGeoDataStoreData_Zone_Type>>;
};

export type OdProtosGeoDataStoreServices_SearchZonesByTextQueryRequestInput = {
  /** Optional: The latitude of the location used to order search results by nearest */
  latitude?: InputMaybe<Scalars['Float']>;
  /**
   * Optional. The number of zones to return
   * Capped at 500, returns CodeInvalidArgument if request's limit is > 500
   * Defaults to 100 if unset
   */
  limit?: InputMaybe<Scalars['Float']>;
  /** Optional: The longitude of the location used to order search results by nearest */
  longitude?: InputMaybe<Scalars['Float']>;
  /** The query string to search Zones by name with */
  queryString?: InputMaybe<Scalars['String']>;
  /** Optional: Option for modifying the returned geojson `shape` field */
  shapeGeoOption?: InputMaybe<OdProtosGeoDataStoreServices_ShapeGeoOption>;
  /** Optional: The states to limit results to */
  states?: InputMaybe<Array<OdProtosCommonState_State>>;
  /** The zone types. */
  types?: InputMaybe<Array<OdProtosGeoDataStoreData_Zone_Type>>;
};

/**
 * UNKNOWN/FULL_SIZE: Full shape is returned
 * EXCLUDE: Empty string is returned
 * SIMPLIFY: ST_Simplified shape is returned
 */
export type OdProtosGeoDataStoreServices_ShapeGeoOption =
  | 'EXCLUDE'
  | 'FULL_SIZE'
  | 'SIMPLIFY'
  | 'UNKNOWN';

export type OdProtosGeoDataStoreServices_WriteCoreLogicBuildingPermitsRequestInput = {
  permits?: InputMaybe<Array<OdProtosGeoDataStoreData_CoreLogicBuildingPermitInput>>;
};

export type OdProtosGeoDataStoreServices_WritePreciselyDistrictRequestInput = {
  district?: InputMaybe<OdProtosGeoDataStoreData_PreciselyDistrictInput>;
};

export type OdProtosGeoDataStoreServices_WritePreciselySchoolRequestInput = {
  school?: InputMaybe<OdProtosGeoDataStoreData_PreciselySchoolInput>;
};

/**
 * PodCount contains pod counts before and during test run.
 *
 * Next ID: 4
 */
export type OdProtosHedgehogData_PodCountInput = {
  preTestPodCount?: InputMaybe<Scalars['Int']>;
  serviceName?: InputMaybe<Scalars['String']>;
  testPodCount?: InputMaybe<Scalars['Int']>;
};

/**
 * Names of tests in hedgehog service
 * Next ID: 4
 */
export type OdProtosHedgehogData_TestName =
  | 'HUB_VIEW_VOLUME_TEST'
  | 'OFFER_CREATION_LOAD_TEST'
  | 'SELLER_INPUTS_LOAD_TEST'
  | 'UNKNOWN';

/**
 * states of tests in hedgehog service
 * Next ID: 5
 */
export type OdProtosHedgehogData_Test_TestState =
  | 'ABORTED'
  | 'COMPLETED'
  | 'PENDING'
  | 'RUNNING'
  | 'UNKNOWN';

/** Next ID: 1 */
export type OdProtosHedgehogServices_AbortAllRunningTestsRequestInput = {
  _empty?: InputMaybe<Scalars['Boolean']>;
};

/** Next ID: 2 */
export type OdProtosHedgehogServices_AbortTestRequestInput = {
  uuid?: InputMaybe<Scalars['String']>;
};

/** Next ID: 1 */
export type OdProtosHedgehogServices_GetAllRunningTestsRequestInput = {
  _empty?: InputMaybe<Scalars['Boolean']>;
};

/** Next ID: 1 */
export type OdProtosHedgehogServices_GetTestsRequestInput = {
  _empty?: InputMaybe<Scalars['Boolean']>;
};

/** Next ID: 10 */
export type OdProtosHedgehogServices_RunTestRequestInput = {
  podCounts?: InputMaybe<Array<OdProtosHedgehogData_PodCountInput>>;
  script?: InputMaybe<Scalars['String']>;
  testDataset?: InputMaybe<OdProtosHedgehogServices_RunTestRequest_TestDatasetOneofInput>;
  testDescription?: InputMaybe<Scalars['String']>;
  testName?: InputMaybe<OdProtosHedgehogServices_RunTestRequest_TestNameOneofInput>;
};

export type OdProtosHedgehogServices_RunTestRequest_TestDatasetOneofInput = {
  datasetFileContents?: InputMaybe<Scalars['String']>;
  sqlQuery?: InputMaybe<Scalars['String']>;
};

export type OdProtosHedgehogServices_RunTestRequest_TestNameOneofInput = {
  /** adhoc test name */
  adhocTestName?: InputMaybe<Scalars['String']>;
  /** saved test name */
  savedTestName?: InputMaybe<OdProtosHedgehogData_TestName>;
};

export type OdProtosHelloritoData_MergeFieldInput = {
  key?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

export type OdProtosHelloritoData_Signature_Status =
  | 'BOUNCED'
  | 'DECLINED'
  | 'PENDING'
  | 'SENT'
  | 'SIGNED';

export type OdProtosHelloritoServices_RecipientsInput = {
  ccs?: InputMaybe<Array<OdProtosHelloritoServices_Recipients_CcInput>>;
  signers?: InputMaybe<Array<OdProtosHelloritoServices_Recipients_SignerInput>>;
};

export type OdProtosHelloritoServices_Recipients_CcInput = {
  email?: InputMaybe<Scalars['String']>;
  fullName?: InputMaybe<Scalars['String']>;
};

export type OdProtosHelloritoServices_Recipients_SignerInput = {
  email?: InputMaybe<Scalars['String']>;
  fullName?: InputMaybe<Scalars['String']>;
  /**
   * Embedded signers will sign in an OD application.
   * Client is responsible for notifying signer, authenticating and authorizing them,
   * and presenting the contract using GetSignerView.
   */
  isEmbedded?: InputMaybe<Scalars['Boolean']>;
  role?: InputMaybe<Scalars['String']>;
};

export type OdProtosHelloritoServices_Request_CreateDraftInput = {
  fileUrl?: InputMaybe<Scalars['String']>;
  recipients?: InputMaybe<OdProtosHelloritoServices_RecipientsInput>;
  signingNotificationSubjectText?: InputMaybe<Scalars['String']>;
};

export type OdProtosHelloritoServices_Request_CreateInput = {
  mergeFields?: InputMaybe<Array<OdProtosHelloritoData_MergeFieldInput>>;
  recipients?: InputMaybe<OdProtosHelloritoServices_RecipientsInput>;
  signingNotificationSubjectText?: InputMaybe<Scalars['String']>;
  templateId?: InputMaybe<Scalars['String']>;
};

export type OdProtosHelloritoServices_Request_GetInput = {
  contractId?: InputMaybe<Scalars['String']>;
};

export type OdProtosHelloritoServices_Request_GetSenderViewInput = {
  draftId?: InputMaybe<Scalars['String']>;
  /** where the sender will be sent to after completion */
  returnUrl?: InputMaybe<Scalars['String']>;
};

export type OdProtosHelloritoServices_Request_GetSignerViewInput = {
  contractId?: InputMaybe<Scalars['String']>;
  /** where the signer will be sent to after completion */
  returnUrl?: InputMaybe<Scalars['String']>;
  signerEmail?: InputMaybe<Scalars['String']>;
};

export type OdProtosHelloritoServices_Request_GetVersionsInput = {
  contractVersionIds?: InputMaybe<Array<Scalars['String']>>;
};

/** Next index: 10 */
export type OdProtosHodorData_HoaContactInput = {
  addressUuid?: InputMaybe<Scalars['String']>;
  businessPhone?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  mobilePhone?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<OdProtosHodorData_HoaContact_HoaContactType>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type OdProtosHodorData_HoaContact_HoaContactType =
  | 'ATTORNEY'
  | 'MANAGING_AGENCY'
  | 'OWNERS_ASSOCIATION'
  | 'UNKNOWN';

export type OdProtosHodorData_HoaFeeInput = {
  addressUuid?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  endDate?: InputMaybe<Scalars['DateTime']>;
  frequency?: InputMaybe<OdProtosHodorData_HoaFee_FeeFrequency>;
  id?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  type?: InputMaybe<OdProtosHodorData_HoaFee_HoaFeeType>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type OdProtosHodorData_HoaFee_FeeFrequency =
  | 'ANNUALLY'
  | 'MONTHLY'
  | 'ONEOFF'
  | 'QUARTERLY'
  | 'SEMIANNUALLY'
  | 'UNKNOWN';

/** Type of association fee. */
export type OdProtosHodorData_HoaFee_HoaFeeType =
  | 'AMENTITY_FEE'
  | 'BUILDING_MAINTAINENCE_FEE'
  | 'COMMUNITY_MASTER_HOME_OWNER_FEE'
  | 'DISCLOSURE'
  | 'FEE_CAPITAL_IMPROVEMENTS_FEE'
  | 'HOMEOWNERS_ASSOCIATION'
  | 'HOME_OWNER_ASSESSMENTS_FEE'
  | 'HOME_OWNER_TRANSFER_FEE'
  | 'IMPROVEMENT'
  | 'INITIATION'
  | 'MASTER_ASSOCIATION_SPECIAL_ASSESSMENT'
  | 'MASTER_ASSOCIATION_TRANSFER'
  | 'MELLO_ROOS_COMMUNITY_FACILITIES_DISTRICT_FEE'
  | 'MOVE_IN'
  | 'NEW_ACCOUNT'
  | 'OTHER_FEE'
  | 'POA_FEE'
  | 'PREPAID'
  | 'RECREATION_FEE'
  | 'RESERVE'
  | 'RESORT_FEE'
  | 'SIDLID_COMMUNITY_FACILITIES_DISTRICT_FEE'
  | 'SPECIAL_ASSESSMENT'
  | 'SPECIAL_ASSESSMENT_UNDER_CONSIDERATION'
  | 'TENNIS_FEE'
  | 'TRANSFER'
  | 'TRANSFER_COMMON_ASSETS'
  | 'UNKNOWN_HOA_FEE_TYPE';

export type OdProtosHodorData_HoaRestrictionsInput = {
  ageRestriction?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  gateCommunityType?: InputMaybe<Scalars['String']>;
  hasAgeRestrictions?: InputMaybe<Scalars['Boolean']>;
  hasLeasingRestrictions?: InputMaybe<Scalars['Boolean']>;
  hasOccupancyRequirements?: InputMaybe<Scalars['Boolean']>;
  hoaCoversExteriorsAndRoofs?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
  institutionPurchaseLimit?: InputMaybe<Scalars['Float']>;
  institutionsAllowed?: InputMaybe<Scalars['Boolean']>;
  isAssociationMandatory?: InputMaybe<Scalars['Boolean']>;
  isSignageAllowed?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  utilitiesPaidByHoa?: InputMaybe<Scalars['Boolean']>;
};

/** HOA Types */
export type OdProtosHodorData_HomeownersAssociation_HoaType =
  | 'CONDO_OWNER_ASSOCIATION'
  | 'HOME_OWNER_ASSOCIATION'
  | 'LEGAL_AGENCY'
  | 'MANAGEMENT_AGENCY'
  | 'MASTER_ASSOCIATION'
  | 'PLANNED_UNIT_DEVELOPMENT'
  | 'SUB_HOME_OWNER_ASSOCIATION'
  | 'UNKNOWN_HOA_TYPE';

export type OdProtosHodorServices_AddPropertyToHoa_RequestInput = {
  hoaId?: InputMaybe<Scalars['String']>;
  isPrimary?: InputMaybe<Scalars['Boolean']>;
  propertyId?: InputMaybe<Scalars['String']>;
};

export type OdProtosHodorServices_CreateHoa_RequestInput = {
  billingAddressUuid?: InputMaybe<Scalars['String']>;
  mailingAddressUuid?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  restrictions?: InputMaybe<OdProtosHodorData_HoaRestrictionsInput>;
  type?: InputMaybe<OdProtosHodorData_HomeownersAssociation_HoaType>;
};

export type OdProtosHodorServices_GetHoaInfo_RequestInput = {
  hoaId?: InputMaybe<Scalars['String']>;
};

export type OdProtosHodorServices_GetHoasForProperty_RequestInput = {
  addressUuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosHodorServices_RemovePropertyFromHoa_RequestInput = {
  hoaId?: InputMaybe<Scalars['String']>;
  propertyId?: InputMaybe<Scalars['String']>;
};

export type OdProtosHodorServices_UpdateHoaContacts_RequestInput = {
  contactId?: InputMaybe<Scalars['String']>;
  contactRemovals?: InputMaybe<Array<Scalars['String']>>;
  contactUpserts?: InputMaybe<Array<OdProtosHodorData_HoaContactInput>>;
  hoaId?: InputMaybe<Scalars['String']>;
};

export type OdProtosHodorServices_UpdateHoaFees_RequestInput = {
  hoaId?: InputMaybe<Scalars['String']>;
  propertySpecificFeeRemovals?: InputMaybe<Array<Scalars['String']>>;
  propertySpecificFeeUpserts?: InputMaybe<Array<OdProtosHodorData_HoaFeeInput>>;
  standardFeeRemovals?: InputMaybe<Array<Scalars['String']>>;
  standardFeeUpserts?: InputMaybe<Array<OdProtosHodorData_HoaFeeInput>>;
};

export type OdProtosHodorServices_UpdateHoaIsArchived_RequestInput = {
  hoaId?: InputMaybe<Scalars['String']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
};

export type OdProtosHodorServices_UpdateHoaProperty_RequestInput = {
  accessCode?: InputMaybe<Scalars['String']>;
  guardContact?: InputMaybe<Scalars['String']>;
  hoaId?: InputMaybe<Scalars['String']>;
  propertyId?: InputMaybe<Scalars['String']>;
};

export type OdProtosHodorServices_UpdateHoaRestrictions_RequestInput = {
  hoaId?: InputMaybe<Scalars['String']>;
  restrictions?: InputMaybe<OdProtosHodorData_HoaRestrictionsInput>;
};

export type OdProtosHodorServices_UpdateHoa_RequestInput = {
  billingAddressUuid?: InputMaybe<Scalars['String']>;
  hoaId?: InputMaybe<Scalars['String']>;
  internalNote?: InputMaybe<Scalars['String']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  mailingAddressUuid?: InputMaybe<Scalars['String']>;
  managementAgencyUuid?: InputMaybe<Scalars['String']>;
  masterAssociationUuid?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<OdProtosHodorData_HomeownersAssociation_HoaType>;
};

export type OdProtosHodorServices_ValidateHoa_RequestInput = {
  hoaId?: InputMaybe<Scalars['String']>;
};

export type OdProtosHodorServices_ValidatePropertyHasNoHoa_RequestInput = {
  addressUuid?: InputMaybe<Scalars['String']>;
};

/**
 * Records service and user ID (human token rather than username or email which can change).
 * Particularly useful for finding patterns in home detail edits or tracking provenance
 */
export type OdProtosHomeDataStore_ActorInput = {
  systemId?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type OdProtosHomeDataStore_BatchGetHomeDetailRequestInput = {
  /** List of home detail IDs that would be queried over. */
  homeDetailIds?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosHomeDataStore_BatchRemovePrimaryAddressForHomeDetailRequestInput = {
  homeDetailIds?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosHomeDataStore_BatchResolveHomeDetailsRequestInput = {
  resolveHomeDetailsRequests?: InputMaybe<Array<OdProtosHomeDataStore_ResolveHomeDetailsRequestInput>>;
};

export type OdProtosHomeDataStore_BatchResolveProvidedHomeDetailsRequestInput = {
  /** provided_home_detail_requests is a list of homes and their details. Used to bulk resolve multiple homes in a single request */
  providedHomeDetailRequests?: InputMaybe<Array<OdProtosHomeDataStore_ResolveProvidedHomeDetailsRequestInput>>;
};

export type OdProtosHomeDataStore_BatchUnresolvedHomeDetailsRequestInput = {
  unresolvedHomeDetailsRequests?: InputMaybe<Array<OdProtosHomeDataStore_UnresolvedHomeDetailsRequestInput>>;
};

export type OdProtosHomeDataStore_BatchWriteHomeDetailsRequestInput = {
  /**
   * DEPRECATED. Actor information should be included in the home detail created_by field.
   * While teams are migrating, HDS will write this data into the home detail field.
   * Do not populate both actor and home_detail.created_by for any home detail being passed in.
   */
  actor?: InputMaybe<OdProtosHomeDataStore_ActorInput>;
  homeDetails?: InputMaybe<Array<OdProtosHomeDataStore_BatchWriteHomeDetailsRequest_HomeDetailWriteRequestInput>>;
};

export type OdProtosHomeDataStore_BatchWriteHomeDetailsRequest_HomeDetailWriteRequestInput = {
  homeDetail?: InputMaybe<OdProtosHomeDataStore_HomeDetailInput>;
};

export type OdProtosHomeDataStore_GetAllHomeDetailsBySourceRequestInput = {
  /** The maximum number of results to return. If not specified, defaults to 100. */
  limit?: InputMaybe<Scalars['Float']>;
  /** Maximum timestamp which we want to return home details for this home. Defaults to now. */
  ltTimestamp?: InputMaybe<Scalars['DateTime']>;
  /** Source of the home details we want to get. See `home_detail.proto` for explanation. */
  source?: InputMaybe<OdProtosHomeDataStore_HomeDetail_Source>;
  sourceId?: InputMaybe<Scalars['String']>;
  sourceName?: InputMaybe<Scalars['String']>;
};

export type OdProtosHomeDataStore_GetAllHomeDetailsRequestInput = {
  /** Address token of the home to get all details from. */
  addressToken?: InputMaybe<Scalars['String']>;
  /**
   * Timestamp as of which we want to resolve home details for this home. E.g. if we want to get the state of a home
   * in a particular date (without using any newer data) we should set this field.
   */
  endDate?: InputMaybe<Scalars['DateTime']>;
};

export type OdProtosHomeDataStore_GetHomeDetailRequestInput = {
  /**
   * Home Detail ID of a specific Home Detail. This would perform no resolution
   * and would return an immutable detail that was written before.
   */
  homeDetailId?: InputMaybe<Scalars['String']>;
};

/**
 * HomeDetail represents a view of a Home attributes. These details could come from one source (e.g. MLS) or be the
 * result of merging with multiple sources.
 *
 * A HomeDetail is uniquely identified by the (source, source_name, source_id, instance_updated_timestamp) tuple.
 *
 * Next ID: 214
 */
export type OdProtosHomeDataStore_HomeDetailInput = {
  /**
   * Square footage of all livable area above ground. Specifically this does not include any square footage from
   * finished basement.
   */
  aboveGradeSqFt?: InputMaybe<Scalars['Float']>;
  additions?: InputMaybe<Array<OdProtosHomeDataStore_HomeDetail_AdditionInput>>;
  /** Address UUID contains the casa identifier assigned to a specific home. */
  addressUuid?: InputMaybe<Scalars['String']>;
  /** Assessor's parcel number. Unique number assigned by each county Tax Assessor office. */
  apn?: InputMaybe<Scalars['String']>;
  architecturalStyle?: InputMaybe<Array<OdProtosHomeDataStore_HomeDetail_ArchitecturalStyle>>;
  attractors?: InputMaybe<OdProtosHomeDataStore_HomeDetail_AttractorsInput>;
  backYard?: InputMaybe<OdProtosHomeDataStore_HomeDetail_YardFeaturesInput>;
  /** no_yard, needs_work, partially_landscaped, fully_landscaped */
  backYardCondition?: InputMaybe<Scalars['String']>;
  /** Slope direction relative to the home. */
  backYardSlopeDirection?: InputMaybe<Scalars['String']>;
  /**
   * back yard slope severity
   * slight_slope, substantial_slope, severe_slope, none
   */
  backYardSlopeType?: InputMaybe<Scalars['String']>;
  basementFeatures?: InputMaybe<OdProtosHomeDataStore_HomeDetail_BasementFeaturesInput>;
  /** Square footage of finished basement area. */
  basementFinishedSqFt?: InputMaybe<Scalars['Float']>;
  /** Total square footage of the basement. It includes both finished and unfinished area square footage. */
  basementSqFt?: InputMaybe<Scalars['Float']>;
  /** Square footage of basement that is not considered as livable. */
  basementUnfinishedSqFt?: InputMaybe<Scalars['Float']>;
  /** needs_work, typical_use, great_condition */
  bathroomCondition?: InputMaybe<Scalars['String']>;
  /** repeated for each bathroom */
  bathroomFeatures?: InputMaybe<Array<OdProtosHomeDataStore_HomeDetail_BathroomFeaturesInput>>;
  /** Number of full bathrooms within the home (i.e. a bathroom with toilet, sink and shower/bathtub)/ */
  bathroomsFull?: InputMaybe<Scalars['Float']>;
  /** Number of bathrooms that do not contain a shower or bathtub. These are bathrooms with only a toilet and a sink. */
  bathroomsHalf?: InputMaybe<Scalars['Float']>;
  /** Number of bedrooms present in the Home. */
  bedrooms?: InputMaybe<Scalars['Float']>;
  /** city/urban block in which the property is located if applicable */
  block?: InputMaybe<Scalars['String']>;
  /** Name of the builder of this home. */
  builderName?: InputMaybe<Scalars['String']>;
  /** Number of carport spaces in this home. */
  carportSpaces?: InputMaybe<Scalars['Float']>;
  condition?: InputMaybe<OdProtosHomeDataStore_HomeDetail_ConditionInput>;
  /** Construction materials for a given home */
  constructionMaterials?: InputMaybe<Array<Scalars['String']>>;
  cookingRange?: InputMaybe<OdProtosHomeDataStore_HomeDetail_ApplianceInput>;
  coolingFeatures?: InputMaybe<Array<OdProtosHomeDataStore_HomeDetail_CoolingFeature>>;
  /**
   * Records system ID and user ID (human token) for creator of home detail.
   * Particularly useful for finding patterns in home detail edits or tracking provenance.
   */
  createdBy?: InputMaybe<OdProtosHomeDataStore_ActorInput>;
  detractors?: InputMaybe<OdProtosHomeDataStore_HomeDetail_DetractorsInput>;
  diningAreas?: InputMaybe<Array<OdProtosHomeDataStore_HomeDetail_DiningArea>>;
  dishwasher?: InputMaybe<OdProtosHomeDataStore_HomeDetail_ApplianceInput>;
  /**
   * driveway slope direction, relative to the home.
   * no_slope, downhill_slope, uphill_slope
   */
  drivewaySlopeDirection?: InputMaybe<Scalars['String']>;
  /**
   * driveway slope severity
   * slight_slope, substantial_slope, severe_slope, none
   */
  drivewaySlopeType?: InputMaybe<Scalars['String']>;
  /** Dwelling style of a home. (single_story, split-level) */
  dwellingStyle?: InputMaybe<Scalars['String']>;
  /**
   * Dwelling type contains the type of a home. Common values are: single_family, apartment, vacant, multi_family,
   * townhouse, etc. These values should come from DwellingTypeValues.
   */
  dwellingType?: InputMaybe<Scalars['String']>;
  /** Field to provide justification and context on internal Opendoor edits */
  editedFieldFeedback?: InputMaybe<Array<OdProtosHomeDataStore_HomeDetail_EditedFieldFeedbackInput>>;
  electricUtilityProviders?: InputMaybe<Array<OdProtosHomeDataStore_HomeDetail_UtilityProviderInput>>;
  /** aluminum, copper, unknown, other */
  electricalWireMaterial?: InputMaybe<Array<Scalars['String']>>;
  /** How you get into the home, either private entrance or some variation of shared. */
  entryType?: InputMaybe<Scalars['String']>;
  /** needs_work, average, like_new */
  exteriorFacadeCondition?: InputMaybe<Scalars['String']>;
  /** Number of stories of this home. */
  exteriorStories?: InputMaybe<Scalars['Float']>;
  facade?: InputMaybe<OdProtosHomeDataStore_HomeDetail_FacadeInput>;
  fenceFeatures?: InputMaybe<Array<OdProtosHomeDataStore_HomeDetail_FenceFeature>>;
  fireplaceFeatures?: InputMaybe<OdProtosHomeDataStore_HomeDetail_FireplaceFeaturesInput>;
  /** list of flooring materials used for a given home. */
  flooringMaterials?: InputMaybe<Array<Scalars['String']>>;
  /** basement, slab, pier_and_beam */
  foundationType?: InputMaybe<Scalars['String']>;
  frontYard?: InputMaybe<OdProtosHomeDataStore_HomeDetail_YardFeaturesInput>;
  /** no_yard, needs_work, partially_landscaped, fully_landscaped */
  frontYardCondition?: InputMaybe<Scalars['String']>;
  /** Number of parking spots in the home. */
  garageSpaces?: InputMaybe<Scalars['Float']>;
  garbageDisposal?: InputMaybe<OdProtosHomeDataStore_HomeDetail_ApplianceInput>;
  gasUtilityProviders?: InputMaybe<Array<OdProtosHomeDataStore_HomeDetail_UtilityProviderInput>>;
  /** Whether the home has a room addition. */
  hasAddition?: InputMaybe<Scalars['Boolean']>;
  /** whether the home has air conditioning */
  hasAirConditioning?: InputMaybe<Scalars['Boolean']>;
  /** Whether the home has asbestos in the walls. */
  hasAsbestosSiding?: InputMaybe<Scalars['Boolean']>;
  /** Whether the yard has a retaining wall */
  hasBackYardRetainingWall?: InputMaybe<Scalars['Boolean']>;
  /** Whether the house has a basement */
  hasBasement?: InputMaybe<Scalars['Boolean']>;
  /** Whether this home has a community/shared pool */
  hasCommunityPool?: InputMaybe<Scalars['Boolean']>;
  /** Whether home has access to a community/shared spa */
  hasCommunitySpa?: InputMaybe<Scalars['Boolean']>;
  hasCrawlspace?: InputMaybe<Scalars['Boolean']>;
  /** A room that could be used as a den/office/library */
  hasDen?: InputMaybe<Scalars['Boolean']>;
  hasExteriorBalcony?: InputMaybe<Scalars['Boolean']>;
  /** Whether the home has fire damage, now or in the past. */
  hasFireDamage?: InputMaybe<Scalars['Boolean']>;
  /** whether the home has a fireplace */
  hasFireplace?: InputMaybe<Scalars['Boolean']>;
  /** Whether the home has a garage converted into a room. */
  hasGarageConversion?: InputMaybe<Scalars['Boolean']>;
  /**
   * Whether or not the gated community has a guard or not.
   * 2/1/2021 - We are going to start buying homes that are in a guarded gated community this week.
   */
  hasGatedCommunityGuard?: InputMaybe<Scalars['Boolean']>;
  /** Whether the lot has been contaminated in the past (e.g., gas tank leak). */
  hasHistoryOfChemicalContamination?: InputMaybe<Scalars['Boolean']>;
  /** Whether horse features exist for a home */
  hasHorses?: InputMaybe<Scalars['Boolean']>;
  hasIncomeLimit?: InputMaybe<Scalars['Boolean']>;
  /** Whether the home has known foundation issues. */
  hasKnownFoundationIssues?: InputMaybe<Scalars['Boolean']>;
  hasLakeView?: InputMaybe<Scalars['Boolean']>;
  hasMountainView?: InputMaybe<Scalars['Boolean']>;
  hasNewRoof?: InputMaybe<Scalars['Boolean']>;
  hasNewWindows?: InputMaybe<Scalars['Boolean']>;
  /** whether the home has a nice backyard */
  hasNiceBackyard?: InputMaybe<Scalars['Boolean']>;
  /** whether the home has a nice curb appeal */
  hasNiceCurbAppeal?: InputMaybe<Scalars['Boolean']>;
  hasOceanView?: InputMaybe<Scalars['Boolean']>;
  hasOpenFloorPlan?: InputMaybe<Scalars['Boolean']>;
  hasPlantationShutters?: InputMaybe<Scalars['Boolean']>;
  /** Whether this home has a private pool or not. */
  hasPrivatePool?: InputMaybe<Scalars['Boolean']>;
  /** Whether home has a private spa */
  hasPrivateSpa?: InputMaybe<Scalars['Boolean']>;
  /** whether its a resort style home */
  hasResortStyle?: InputMaybe<Scalars['Boolean']>;
  /** Whether the home has a septic tank. */
  hasSeptic?: InputMaybe<Scalars['Boolean']>;
  /** Whether the home has or is in a sinkhole (cracked bedrock, source of foundation issues). */
  hasSinkhole?: InputMaybe<Scalars['Boolean']>;
  /** Whether the home has solar panels. */
  hasSolarPanels?: InputMaybe<Scalars['Boolean']>;
  /** Whether master bedroom is separated from rest of house */
  hasSplitMasterBedroom?: InputMaybe<Scalars['Boolean']>;
  /** whether the home has upgrades */
  hasUpgrades?: InputMaybe<Scalars['Boolean']>;
  /** Whether the house has a vaulted/raised ceiling */
  hasVaultedCeiling?: InputMaybe<Scalars['Boolean']>;
  hasWalkInCloset?: InputMaybe<Scalars['Boolean']>;
  /** Whether the home has/pumps its water from a well. */
  hasWellWater?: InputMaybe<Scalars['Boolean']>;
  heatingFeatures?: InputMaybe<Array<OdProtosHomeDataStore_HomeDetail_HeatingFeature>>;
  /**
   * First HOA associated with this home.
   *
   * Deprecated: Use field `hoas` instead.
   */
  hoa?: InputMaybe<OdProtosHomeDataStore_HomeDetail_HoaInput>;
  /** HOAs associated with this home. */
  hoas?: InputMaybe<Array<OdProtosHomeDataStore_HomeDetail_HoaInput>>;
  /** Unique identifier of this HomeDetail. It should be filled by Home Data Store. */
  homeDetailId: Scalars['ID'];
  hvacSystems?: InputMaybe<Array<OdProtosHomeDataStore_HomeDetail_HvacSystemInput>>;
  /**
   * Estimated name of subdivision based on location
   * Deprecated: Use dwellings geo_details table instead
   */
  imputedSubdivision?: InputMaybe<Scalars['String']>;
  /**
   * When we have multiple instances of the source, Instance_Updated_Timestamp contains when each instance becomes valid.
   * E.g MLS - instance_updated_timestamp may not be populated because there's only 1 listing. Default value will be set.
   * E.g Tax accessor - instance_updated_timestamp would be the tax year when the update became valid. (i.e TAX_YEAR_ASSESSED)
   * Moving forward this will be used to uniquely identify a home detail along with source information.
   * The timestamp resolution order for sorting would be instance_updated_timestamp > source_timestamp > timestamp
   */
  instanceUpdatedTimestamp?: InputMaybe<Scalars['DateTime']>;
  /** needs_work, typical_use, great_condition */
  interiorPaintCondition?: InputMaybe<Scalars['String']>;
  /** Number of interior stories of this home (differs from exterior_stories e.g. for mid/highrises & basements). */
  interiorStories?: InputMaybe<Scalars['Float']>;
  /** Must be null unless has_addition is true */
  isAdditionPermitted?: InputMaybe<Scalars['Boolean']>;
  /** Whether the home is in an elderly community. */
  isAgeRestrictedCommunity?: InputMaybe<Scalars['Boolean']>;
  /** Is the carport attached to the home? */
  isCarportAttached?: InputMaybe<Scalars['Boolean']>;
  /** Is the Garage attached to the home? */
  isGarageAttached?: InputMaybe<Scalars['Boolean']>;
  /** Whether the home is in a gated community. */
  isGatedCommunity?: InputMaybe<Scalars['Boolean']>;
  /** Whether the home is zoned for horses or other livestock. */
  isZonedForLivestock?: InputMaybe<Scalars['Boolean']>;
  /**
   * Primary appliance material (main kitchen)
   * stainless_steel, black, white, mixed
   */
  kitchenApplianceType?: InputMaybe<Scalars['String']>;
  /** needs_work, typical_use, great_condition */
  kitchenCondition?: InputMaybe<Scalars['String']>;
  /** granite_slab, granite_tile, other_tile, corian, formica, quartz */
  kitchenCountertop?: InputMaybe<Scalars['String']>;
  kitchenFeatures?: InputMaybe<OdProtosHomeDataStore_HomeDetail_KitchenFeaturesInput>;
  /** never, less_than_5_years_ago, 5_to_10_years_ago, more_than_10_years_ago */
  kitchenRemodel?: InputMaybe<Scalars['String']>;
  /** landscaping attributes of a home. Intended to replace repeated string field landscaping_features */
  landscaping?: InputMaybe<OdProtosHomeDataStore_HomeDetail_LandscapingFeaturesInput>;
  /** Landscaping features for a given home */
  landscapingFeatures?: InputMaybe<Array<Scalars['String']>>;
  /** Date when renovation was completed. */
  lastRenovatedDate?: InputMaybe<OdProtosCommon_DateInput>;
  laundryFeatures?: InputMaybe<OdProtosHomeDataStore_HomeDetail_LaundryFeaturesInput>;
  lotFeatures?: InputMaybe<OdProtosHomeDataStore_HomeDetail_LotFeaturesInput>;
  /** the individual lot number of the property as used in the Lot and Block survey system */
  lotNumber?: InputMaybe<Scalars['String']>;
  /** Square footage of the lot where the home sits. */
  lotSqFt?: InputMaybe<Scalars['Float']>;
  masterBathroomFeatures?: InputMaybe<Array<OdProtosHomeDataStore_HomeDetail_BathroomFeature>>;
  /** never, less_than_5_years_ago, 5_to_10_years_ago, more_than_10_years_ago */
  masterBathroomRemodel?: InputMaybe<Scalars['String']>;
  /** entry_level, first_floor, second_floor, third_floor, basement */
  masterBedroomFloor?: InputMaybe<Scalars['String']>;
  microwave?: InputMaybe<OdProtosHomeDataStore_HomeDetail_ApplianceInput>;
  nearCommunityPark?: InputMaybe<Scalars['Boolean']>;
  nearGolfCourse?: InputMaybe<Scalars['Boolean']>;
  nearestHighwayPrimary?: InputMaybe<OdProtosHomeDataStore_HomeDetail_RoadInput>;
  nearestHighwaySecondary?: InputMaybe<OdProtosHomeDataStore_HomeDetail_RoadInput>;
  nearestHighwayTertiary?: InputMaybe<OdProtosHomeDataStore_HomeDetail_RoadInput>;
  nearestMotorway?: InputMaybe<OdProtosHomeDataStore_HomeDetail_RoadInput>;
  nearestMotorwayLink?: InputMaybe<OdProtosHomeDataStore_HomeDetail_RoadInput>;
  nearestTrunk?: InputMaybe<OdProtosHomeDataStore_HomeDetail_RoadInput>;
  nearestTrunkLink?: InputMaybe<OdProtosHomeDataStore_HomeDetail_RoadInput>;
  /** # of fireplaces in the home */
  numFireplaces?: InputMaybe<Scalars['Float']>;
  /** Rooms that do not require additional features. Simply designates existence of a room. */
  otherRooms?: InputMaybe<Array<OdProtosHomeDataStore_HomeDetail_OtherRoom>>;
  outdoorSpaces?: InputMaybe<Array<OdProtosHomeDataStore_HomeDetail_OutdoorSpaceInput>>;
  /** ownership type, e.g. fee_simple, leasehold, condominium, timeshare, coop */
  ownership?: InputMaybe<Scalars['String']>;
  /** all_neutral, no_neutral, mix_mostly_neutral, mix_mostly_not_neutral */
  paintNeutral?: InputMaybe<Scalars['String']>;
  parkingFeatures?: InputMaybe<Array<OdProtosHomeDataStore_HomeDetail_ParkingFeature>>;
  /** Name of the buildable plan this home represents e.g. Hawthorne */
  planName?: InputMaybe<Scalars['String']>;
  /**
   * Number of available specs(lots) for this new construction plan
   * NOTE: New construction "homes" actually represent plans for a home.
   */
  planSpecCount?: InputMaybe<Scalars['Float']>;
  poolFeatures?: InputMaybe<Array<Scalars['String']>>;
  /** Flooring that covers the majority of the house */
  primaryFlooring?: InputMaybe<OdProtosHomeDataStore_HomeDetail_FlooringInput>;
  /** Primary Owner of this home as of timestamp. */
  primaryOwner?: InputMaybe<Scalars['String']>;
  /** Primary Owner type of this home. Common values are np, unknown, company, individual */
  primaryOwnerType?: InputMaybe<Scalars['String']>;
  refrigerator?: InputMaybe<OdProtosHomeDataStore_HomeDetail_ApplianceInput>;
  roof?: InputMaybe<OdProtosHomeDataStore_HomeDetail_RoofInput>;
  /** Roof materials of a home. */
  roofMaterials?: InputMaybe<Array<Scalars['String']>>;
  /** Map from room name to flooring */
  roomFloorings?: InputMaybe<Array<OdProtosHomeDataStore_HomeDetail_RoomFlooringsEntryInput>>;
  roomfeatureCarport?: InputMaybe<OdProtosHomeDataStore_HomeDetail_RoomFeaturesInput>;
  roomfeatureDeck?: InputMaybe<OdProtosHomeDataStore_HomeDetail_RoomFeaturesInput>;
  roomfeatureDen?: InputMaybe<OdProtosHomeDataStore_HomeDetail_RoomFeaturesInput>;
  /**
   * Top-level room field to be applied to rooms with specific and agreed upon locations.
   * There should be no ambiguity for a room location: e.g. master bedroom vs bedroom1, bedroom2
   * These fields are populated during Opendoor walkthroughs
   */
  roomfeatureDiningRoom?: InputMaybe<OdProtosHomeDataStore_HomeDetail_RoomFeaturesInput>;
  roomfeatureEntry?: InputMaybe<OdProtosHomeDataStore_HomeDetail_RoomFeaturesInput>;
  roomfeatureFamilyRoom?: InputMaybe<OdProtosHomeDataStore_HomeDetail_RoomFeaturesInput>;
  roomfeatureGarage?: InputMaybe<OdProtosHomeDataStore_HomeDetail_RoomFeaturesInput>;
  roomfeatureKitchen?: InputMaybe<OdProtosHomeDataStore_HomeDetail_RoomFeaturesInput>;
  roomfeatureLaundry?: InputMaybe<OdProtosHomeDataStore_HomeDetail_RoomFeaturesInput>;
  roomfeatureLivingRoom?: InputMaybe<OdProtosHomeDataStore_HomeDetail_RoomFeaturesInput>;
  roomfeatureLoft?: InputMaybe<OdProtosHomeDataStore_HomeDetail_RoomFeaturesInput>;
  roomfeatureMasterBathroom?: InputMaybe<OdProtosHomeDataStore_HomeDetail_RoomFeaturesInput>;
  roomfeatureMasterBedroom?: InputMaybe<OdProtosHomeDataStore_HomeDetail_RoomFeaturesInput>;
  roomfeatureMasterCloset?: InputMaybe<OdProtosHomeDataStore_HomeDetail_RoomFeaturesInput>;
  roomfeatureOffice?: InputMaybe<OdProtosHomeDataStore_HomeDetail_RoomFeaturesInput>;
  roomfeaturePorch?: InputMaybe<OdProtosHomeDataStore_HomeDetail_RoomFeaturesInput>;
  roomfeatureUnfinishedBasement?: InputMaybe<OdProtosHomeDataStore_HomeDetail_RoomFeaturesInput>;
  /**
   * Deprecated, use top-level fields for available rooms (e.g. family_room)
   * Remaining ambiguous rooms can continue to be listed here
   * Ex. bedroom (non-master), bathroom (non-master), hallway, closet, storage
   */
  rooms?: InputMaybe<Array<OdProtosHomeDataStore_HomeDetail_RoomInput>>;
  /** Name of elementary school district this address is in */
  schoolDistrictElementary?: InputMaybe<Scalars['String']>;
  /** Name of high school district this address is in */
  schoolDistrictHigh?: InputMaybe<Scalars['String']>;
  /** Name of individual elementary school this address attends */
  schoolElementary?: InputMaybe<Scalars['String']>;
  /** Name of individual high school this address attends */
  schoolHigh?: InputMaybe<Scalars['String']>;
  /** Name of individual middle / jr. high school this address attends */
  schoolMiddle?: InputMaybe<Scalars['String']>;
  /** Flooring that covers other parts of the house */
  secondaryFlooring?: InputMaybe<OdProtosHomeDataStore_HomeDetail_FlooringInput>;
  /**
   * Whether this home has a private pool or not.
   * Secondary Owner of this home as of timestamp.
   */
  secondaryOwner?: InputMaybe<Scalars['String']>;
  /** Secondary Owner type of this home. Common values are np, unknown, company, individual */
  secondaryOwnerType?: InputMaybe<Scalars['String']>;
  /** cast_iron, pvc, vinyl_abs, unknown, other */
  sewerPipeMaterial?: InputMaybe<Array<Scalars['String']>>;
  /** public, private, septic */
  sewerType?: InputMaybe<Scalars['String']>;
  sewerUtilityProviders?: InputMaybe<Array<OdProtosHomeDataStore_HomeDetail_UtilityProviderInput>>;
  /** Must be null unless has_solar_panels is true; options are leased, owned */
  solarPanelsOwnership?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<OdProtosHomeDataStore_HomeDetail_Source>;
  /**
   * Source ID refers to the ID associated to this Home Detail in the Source data source. This is very
   * useful for debugging purposes and together with address_id, timestamp, source and souce_name can uniquely
   * identify a HomeDetail.
   */
  sourceId?: InputMaybe<Scalars['String']>;
  /**
   * A more fine-grain description of the source. Not required to be set, but it is used for primary key of this home
   * detail. A common use case is the name of the MLS from where this detail came from, e.g. "armls".
   */
  sourceName?: InputMaybe<Scalars['String']>;
  /** Arbitrary source specific detail. There are no guarantees that this will be filled and should be used for experimental data that could be moved to the main proto. */
  sourceSpecificDetail?: InputMaybe<GoogleProtobuf_AnyInput>;
  /**
   * Source_Timestamp contains when a home detail has become valid from the source.
   * E.g MLS - source_timestamp is when the listing was listed (list_date)
   * E.g Tax accessor - source_timestamp maybe not filled in but if it was it'd be when the data was published to county tax (i.e. ASSR_LAST_UPDATED)
   */
  sourceTimestamp?: InputMaybe<Scalars['DateTime']>;
  /** Spa features for a home. */
  spaFeatures?: InputMaybe<Array<Scalars['String']>>;
  standaloneOven?: InputMaybe<OdProtosHomeDataStore_HomeDetail_ApplianceInput>;
  standaloneStovetop?: InputMaybe<OdProtosHomeDataStore_HomeDetail_ApplianceInput>;
  /** general, exterior, none */
  stormShelterType?: InputMaybe<Scalars['String']>;
  /** Name of subdivision. */
  subdivision?: InputMaybe<Scalars['String']>;
  /** ID of subdivision, unique for a given builder */
  subdivisionId?: InputMaybe<Scalars['String']>;
  /** Number of available new construction plans in subdivision */
  subdivisionPlanCount?: InputMaybe<Scalars['Float']>;
  /** cpvc, pvc, polybutylene, copper, galvanized, pex, unknown, other */
  supplyPipeMaterial?: InputMaybe<Array<Scalars['String']>>;
  /** the legal description for the property provided on the title commitment and included in tax records */
  taxLegalDescription?: InputMaybe<Scalars['String']>;
  /** calendar year for property tax */
  taxYear?: InputMaybe<Scalars['Float']>;
  /** annual property tax amount */
  taxes?: InputMaybe<Scalars['Float']>;
  /**
   * Timestamp contains when a home detail has been updated. This is a required field.
   * E.g MLS - timestamp is when the listing was updated (mod_timestamp)
   * E.g Tax accessor - timestamp is when the data was updated (i.e PUBLICATION_DATE)
   */
  timestamp?: InputMaybe<Scalars['DateTime']>;
  /** Square footage of all livable area including finished basement sqft. */
  totalLivingSqFt?: InputMaybe<Scalars['Float']>;
  /** Number of units in multi_family homes */
  units?: InputMaybe<Scalars['Float']>;
  /** Field if providers cannot be split into categories (limitation of data sources like MLS) */
  utilityProviders?: InputMaybe<Array<Scalars['String']>>;
  /** List of water heaters installed at the home */
  waterHeaters?: InputMaybe<Array<OdProtosHomeDataStore_HomeDetail_WaterHeaterInput>>;
  waterUtilityProviders?: InputMaybe<Array<OdProtosHomeDataStore_HomeDetail_UtilityProviderInput>>;
  yards?: InputMaybe<Array<OdProtosHomeDataStore_HomeDetail_YardInput>>;
  /** Year at which this home got built. */
  yearBuilt?: InputMaybe<Scalars['Float']>;
};

export type OdProtosHomeDataStore_HomeDetailWriteRequestInput = {
  /**
   * DEPRECATED. Actor information should be included in the home detail created_by field.
   * While teams are migrating, we will write this data into the home detail field.
   * Do not populate both actor and home_detail.created_by
   */
  actor?: InputMaybe<OdProtosHomeDataStore_ActorInput>;
  /** The home detail to be written. Address UUID, source information, and timestamp are required. */
  homeDetail?: InputMaybe<OdProtosHomeDataStore_HomeDetailInput>;
  /**
   * Require the home detail in the request to have a newer or equal timestamp to the existing home detail.
   * If there is no existing home detail for this source, or the existing home detail is older, write successfully.
   */
  validateGteTimestamp?: InputMaybe<Scalars['Boolean']>;
};

export type OdProtosHomeDataStore_HomeDetail_AdditionInput = {
  /** Does the addition have hvac */
  additionHvac?: InputMaybe<OdProtosHomeDataStore_HomeDetail_Addition_AdditionHvac>;
  /** the sqft of the addition */
  additionSqFt?: InputMaybe<Scalars['Float']>;
  /**
   * Type of addition.  possible values: attic_conversion, garage_conversion,
   * master_suite_addition, screen_porch, sun_room, other
   */
  additionType?: InputMaybe<Scalars['String']>;
  /**
   * Build quality of the addition relative to the original structure.
   * Possible values: inferior_to_original_structure, same_as_original_structure,
   * superior_to_original_structure.
   */
  buildQuality?: InputMaybe<Scalars['String']>;
  /**
   * True if the addition is permitted, false if it is known to be un-permitted,
   * null if unknown.
   */
  isPermitted?: InputMaybe<Scalars['Boolean']>;
  /** True if the addition is up to code, false if it not up to code. */
  isUpToCode?: InputMaybe<Scalars['Boolean']>;
};

export type OdProtosHomeDataStore_HomeDetail_Addition_AdditionHvac =
  | 'FULL_HVAC'
  | 'HEATED_ONLY'
  | 'HVAC_OTHER'
  | 'HVAC_UNKNOWN'
  | 'NO_HEATING_OR_COOLING';

export type OdProtosHomeDataStore_HomeDetail_ApplianceInput = {
  /** needs_work, typical_use, great_condition */
  condition?: InputMaybe<Scalars['String']>;
  /** gas, electric */
  energyType?: InputMaybe<Scalars['String']>;
  /** Designates the existence of the appliance. nil value == unknown. */
  hasAppliance?: InputMaybe<Scalars['Boolean']>;
  /** stainless_steel, black, white */
  materialType?: InputMaybe<Scalars['String']>;
};

export type OdProtosHomeDataStore_HomeDetail_ArchitecturalStyle =
  | 'ARCH_STYLE_A_FRAME'
  | 'ARCH_STYLE_CAPE_COD'
  | 'ARCH_STYLE_COLONIAL'
  | 'ARCH_STYLE_CONTEMPORARY'
  | 'ARCH_STYLE_MEDITERRANEAN'
  | 'ARCH_STYLE_RANCH'
  | 'ARCH_STYLE_SPLIT_LEVEL'
  | 'ARCH_STYLE_UNKNOWN';

/**
 * Attractors for a home. Oftentimes these are attributes of the home's surroundings that make it more attractive to buyers.
 * Float values should be between 0 and 1
 * 0 means the home does not have the attribute (e.g. it's not near a golf course at all)
 * 1 means the home is strongly correlated with the attribute (e.g. it's right on the golf course)
 * values between 0 and 1 represent the strength of the correlation (e.g. 0.5 if the home is somewhat near a golf course)
 */
export type OdProtosHomeDataStore_HomeDetail_AttractorsInput = {
  coveredPatio?: InputMaybe<Scalars['Float']>;
  coveredPorch?: InputMaybe<Scalars['Float']>;
  culDeSac?: InputMaybe<Scalars['Float']>;
  golfLot?: InputMaybe<Scalars['Float']>;
  lakeLot?: InputMaybe<Scalars['Float']>;
  otherAttractors?: InputMaybe<Scalars['Float']>;
  otherAttractorsReason?: InputMaybe<Scalars['String']>;
  parkGreenLot?: InputMaybe<Scalars['Float']>;
  views?: InputMaybe<Scalars['Float']>;
  yardLandscaping?: InputMaybe<Scalars['Float']>;
};

/** Basement features of a home. Common values are: finished, unfinished, crawl_space, egress, partially_finished etc */
export type OdProtosHomeDataStore_HomeDetail_BasementFeaturesInput = {
  /** is it a daylight basement */
  daylight?: InputMaybe<Scalars['Boolean']>;
  /** 10/24: Trying to avoid using repeated strings in general, extend this struct instead moving forward. */
  feature?: InputMaybe<Array<Scalars['String']>>;
  /** basement finish status */
  finishStatus?: InputMaybe<OdProtosHomeDataStore_HomeDetail_BasementFinishStatus>;
  /** whether the basement has HVAC */
  hasHvac?: InputMaybe<Scalars['Boolean']>;
};

export type OdProtosHomeDataStore_HomeDetail_BasementFinishStatus =
  | 'FINISH_STATUS_FINISHED'
  | 'FINISH_STATUS_PARTIALLY_FINISHED'
  | 'FINISH_STATUS_UNFINISHED'
  | 'FINISH_STATUS_UNKNOWN';

export type OdProtosHomeDataStore_HomeDetail_BathroomFeature =
  | 'BATHROOM_3_4_SHOWER_ONLY'
  | 'BATHROOM_3_4_TUB_ONLY'
  | 'BATHROOM_BIDET'
  | 'BATHROOM_DOUBLE_SINK'
  | 'BATHROOM_DUAL_BATHROOMS'
  | 'BATHROOM_FULL_BATH'
  | 'BATHROOM_GRANITE_COUNTERTOPS'
  | 'BATHROOM_HALF'
  | 'BATHROOM_JETTED_TUB'
  | 'BATHROOM_NONE'
  | 'BATHROOM_NO_MAIN_BATHROOM'
  | 'BATHROOM_OTHER'
  | 'BATHROOM_PRIVATE_TOILET'
  | 'BATHROOM_SAUNA'
  | 'BATHROOM_SEPARATE_SHOWER_TUB'
  | 'BATHROOM_SHOWER_TUB_COMBO'
  | 'BATHROOM_SKYLIGHTS'
  | 'BATHROOM_SOAKING_TUB'
  | 'BATHROOM_UNKNOWN'
  | 'BATHROOM_WALK_IN_CLOSETS';

export type OdProtosHomeDataStore_HomeDetail_BathroomFeaturesInput = {
  /** full_bath, three_quarter_bath, half_bath, quarter_bath */
  bathroomType?: InputMaybe<Scalars['String']>;
  doubleSink?: InputMaybe<Scalars['Boolean']>;
  graniteCountertops?: InputMaybe<Scalars['Boolean']>;
  /** deprecated as never filled, please use master_bathroom_features instead */
  isMasterBathroom?: InputMaybe<Scalars['Boolean']>;
  separateShowerTub?: InputMaybe<Scalars['Boolean']>;
  tileSurround?: InputMaybe<Scalars['Boolean']>;
  updatedTileFloors?: InputMaybe<Scalars['Boolean']>;
};

export type OdProtosHomeDataStore_HomeDetail_ConditionInput = {
  /** no_yard, needs_work, partially_landscaped, fully_landscaped */
  backYardCondition?: InputMaybe<Scalars['String']>;
  bathroom?: InputMaybe<Scalars['Float']>;
  /** needs_work, typical_use, great_condition */
  bathroomCondition?: InputMaybe<Scalars['String']>;
  exterior?: InputMaybe<Scalars['Float']>;
  /** needs_work, average, like_new */
  exteriorFacadeCondition?: InputMaybe<Scalars['String']>;
  /** flag to describe if home needs fixes/repairs */
  fixUpNeedsRepair?: InputMaybe<Scalars['Boolean']>;
  /** no_yard, needs_work, partially_landscaped, fully_landscaped */
  frontYardCondition?: InputMaybe<Scalars['String']>;
  interior?: InputMaybe<Scalars['Float']>;
  /** needs_work, typical_use, great_condition */
  interiorPaintCondition?: InputMaybe<Scalars['String']>;
  kitchen?: InputMaybe<Scalars['Float']>;
  /** needs_work, typical_use, great_condition */
  kitchenCondition?: InputMaybe<Scalars['String']>;
  /** Condition scores are a float between 0 and 1, where 0 is an unlivable disaster and 1 is brand new. */
  property?: InputMaybe<Scalars['Float']>;
};

/** Next Room Id: 20 */
export type OdProtosHomeDataStore_HomeDetail_CoolingFeature =
  | 'COOLING_AIR_CONDITION'
  | 'COOLING_ATTIC_FAN'
  | 'COOLING_CENTRAL'
  | 'COOLING_CENTRAL_ELECTRIC'
  | 'COOLING_CENTRAL_GAS'
  | 'COOLING_DUAL'
  | 'COOLING_ELECTRIC'
  | 'COOLING_ENERGY_STAR'
  | 'COOLING_EVAPORATIVE_COOLER'
  | 'COOLING_FAN'
  | 'COOLING_GAS'
  | 'COOLING_GEOTHERMAL'
  | 'COOLING_HEAT_PUMP'
  | 'COOLING_HIGH_EFFICIENCY'
  | 'COOLING_MINI_SPLIT'
  | 'COOLING_MUTLI_UNITS'
  | 'COOLING_NONE'
  | 'COOLING_OTHER'
  | 'COOLING_PROGRAMMABLE_THERMOSTAT'
  | 'COOLING_REFRIGERATION'
  | 'COOLING_UNKNOWN'
  | 'COOLING_WALL_UNIT'
  | 'COOLING_WHOLE_HOUSE_FAN'
  | 'COOLING_WINDOW_UNIT'
  | 'COOLING_ZONED';

/**
 * Detractors for a home. Oftentimes these are attributes of the home's surroundings that make it less attractive to buyers.
 * Float values should be between 0 and 1
 * 0 means the home does not have the attribute (e.g. it's not near a a busy road at all)
 * 1 means the home is strongly correlated with the attribute (e.g. it's right on a busy road)
 * values between 0 and 1 represent the strength of the correlation (e.g. 0.5 if the home is somewhat near a busy road)
 */
export type OdProtosHomeDataStore_HomeDetail_DetractorsInput = {
  busyRoadArterialConnector?: InputMaybe<Scalars['Float']>;
  busyRoadFreewayHighway?: InputMaybe<Scalars['Float']>;
  busyRoadMainWithSubdivision?: InputMaybe<Scalars['Float']>;
  neighborsCommercial?: InputMaybe<Scalars['Float']>;
  neighborsIndustrial?: InputMaybe<Scalars['Float']>;
  neighborsMultiFamily?: InputMaybe<Scalars['Float']>;
  neighborsSchool?: InputMaybe<Scalars['Float']>;
  otherDetractors?: InputMaybe<Scalars['Float']>;
  otherDetractorsReason?: InputMaybe<Scalars['String']>;
  powerHighVoltageTower?: InputMaybe<Scalars['Float']>;
  powerHighVoltageWire?: InputMaybe<Scalars['Float']>;
  powerLowVoltagePowerline?: InputMaybe<Scalars['Float']>;
  powerSubstation?: InputMaybe<Scalars['Float']>;
  railroad?: InputMaybe<Scalars['Float']>;
  slopedBackyard?: InputMaybe<Scalars['Float']>;
  slopedDriveway?: InputMaybe<Scalars['Float']>;
};

export type OdProtosHomeDataStore_HomeDetail_DiningArea =
  | 'DINING_BREAKFAST_AREA'
  | 'DINING_BREAKFAST_BAR'
  | 'DINING_EAT_IN_KITCHEN'
  | 'DINING_FAMILY_COMBO'
  | 'DINING_FORMAL'
  | 'DINING_FRONT_ROOM'
  | 'DINING_KITCHEN_COMBO'
  | 'DINING_LIVING_COMBO'
  | 'DINING_L_SHAPED'
  | 'DINING_NONE'
  | 'DINING_OTHER'
  | 'DINING_UNKNOWN';

export type OdProtosHomeDataStore_HomeDetail_DwellingTypeValues =
  | 'APARTMENT'
  | 'CHURCH'
  | 'COMMERCIAL'
  | 'COOP'
  | 'FARM'
  | 'HALF_DUPLEX'
  | 'HOTEL'
  | 'INDUSTRIAL'
  | 'MANUFACTURED'
  | 'MIXED'
  | 'MOBILE_HOME'
  | 'MULTI_FAMILY'
  | 'OFFICE'
  | 'OTHER'
  | 'RETAIL'
  | 'SINGLE_FAMILY'
  | 'SPECIAL_PURPOSE'
  | 'TENANCY_IN_COMMON'
  | 'TOWNHOUSE'
  | 'UNKNOWN_DWELLING_TYPE'
  | 'VACANT'
  | 'WAREHOUSE';

export type OdProtosHomeDataStore_HomeDetail_EditedFieldFeedbackInput = {
  /** structured sources, e.g. "mls", "floor_plan", "tax_data" */
  dataSource?: InputMaybe<Scalars['String']>;
  /** free form notes and justification for an edit */
  editContext?: InputMaybe<Scalars['String']>;
  /** structured reason codes for editing, e.g. "previous_edit_incorrect", "new_source_available" */
  editReasons?: InputMaybe<Array<Scalars['String']>>;
  /** home detail field that was edited */
  fieldKey?: InputMaybe<Scalars['String']>;
};

/** Facade / siding */
export type OdProtosHomeDataStore_HomeDetail_FacadeInput = {
  condition?: InputMaybe<Scalars['String']>;
  /** brick, composite, stucco, vinyl, wood, other */
  material?: InputMaybe<Array<Scalars['String']>>;
};

/** Fence structures and materials */
export type OdProtosHomeDataStore_HomeDetail_FenceFeature =
  | 'FENCE_ALUMINUM'
  | 'FENCE_BACK_YARD'
  | 'FENCE_BARBED_WIRE'
  | 'FENCE_BLOCK'
  | 'FENCE_BRICK'
  | 'FENCE_CHAIN_LINK'
  | 'FENCE_CROSS_FENCED'
  | 'FENCE_FRONT_YARD'
  | 'FENCE_FULLY_FENCED'
  | 'FENCE_METAL'
  | 'FENCE_NONE'
  | 'FENCE_OTHER'
  | 'FENCE_PARTIAL'
  | 'FENCE_PRIVACY'
  | 'FENCE_STONE'
  | 'FENCE_UNKNOWN'
  | 'FENCE_VINYL'
  | 'FENCE_WIRE'
  | 'FENCE_WOOD'
  | 'FENCE_WROUGHT_IRON';

export type OdProtosHomeDataStore_HomeDetail_FenceInput = {
  fenceMaterials?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosHomeDataStore_HomeDetail_FireplaceFeature =
  | 'FIREPLACE_BRICK'
  | 'FIREPLACE_DECORATIVE'
  | 'FIREPLACE_ELECTRIC'
  | 'FIREPLACE_FIREPIT'
  | 'FIREPLACE_FREE_STANDING'
  | 'FIREPLACE_GAS'
  | 'FIREPLACE_GAS_LOG'
  | 'FIREPLACE_GAS_STARTER'
  | 'FIREPLACE_INSERT'
  | 'FIREPLACE_NONE'
  | 'FIREPLACE_OTHER'
  | 'FIREPLACE_PELLET_STOVE'
  | 'FIREPLACE_TWO_WAY'
  | 'FIREPLACE_UNKNOWN'
  | 'FIREPLACE_WOOD'
  | 'FIREPLACE_WOOD_BURNING_STOVE';

export type OdProtosHomeDataStore_HomeDetail_FireplaceFeaturesInput = {
  features?: InputMaybe<Array<OdProtosHomeDataStore_HomeDetail_FireplaceFeature>>;
  locations?: InputMaybe<Array<OdProtosHomeDataStore_HomeDetail_Location>>;
};

export type OdProtosHomeDataStore_HomeDetail_FireplaceInput = {
  /** gas, electric, wood_burning */
  fireplaceType?: InputMaybe<Scalars['String']>;
};

export type OdProtosHomeDataStore_HomeDetail_FlooringInput = {
  /** heavily_worn, typical_use, great_condition */
  condition?: InputMaybe<Scalars['String']>;
  flooringMaterial?: InputMaybe<OdProtosHomeDataStore_HomeDetail_FlooringMaterial>;
  lengthFeet?: InputMaybe<Scalars['Float']>;
  /** tile, laminate, hardwood, carpet, other */
  material?: InputMaybe<Scalars['String']>;
  squareFeet?: InputMaybe<Scalars['Float']>;
  widthFeet?: InputMaybe<Scalars['Float']>;
};

export type OdProtosHomeDataStore_HomeDetail_FlooringMaterial =
  | 'FLOORING_BAMBOO'
  | 'FLOORING_BRICK'
  | 'FLOORING_CARPET'
  | 'FLOORING_CONCRETE'
  | 'FLOORING_CORK'
  | 'FLOORING_ENGINEERED_HARDWOOD'
  | 'FLOORING_ENGINEERED_WOOD'
  | 'FLOORING_GRANITE'
  | 'FLOORING_HARDWOOD'
  | 'FLOORING_LAMINATE'
  | 'FLOORING_LINOLEUM'
  | 'FLOORING_LUXURY_VINYL_PLANK'
  | 'FLOORING_MARBLE'
  | 'FLOORING_OTHER'
  | 'FLOORING_PAINTED'
  | 'FLOORING_PARQUET'
  | 'FLOORING_PAVERS'
  | 'FLOORING_SALTILLO_TILE'
  | 'FLOORING_SLATE'
  | 'FLOORING_STAMPED'
  | 'FLOORING_STONE'
  | 'FLOORING_TERRAZZO'
  | 'FLOORING_TILE'
  | 'FLOORING_TRAVERTINE'
  | 'FLOORING_UNKNOWN'
  | 'FLOORING_VINYL'
  | 'FLOORING_WOOD';

/** Next Room Id: 20 */
export type OdProtosHomeDataStore_HomeDetail_HeatingFeature =
  | 'HEATING_BASEBOARD'
  | 'HEATING_BOILER'
  | 'HEATING_CEILING'
  | 'HEATING_CENTRAL'
  | 'HEATING_ELECTRIC'
  | 'HEATING_FIREPLACE'
  | 'HEATING_FLOOR_FURNACE'
  | 'HEATING_GAS'
  | 'HEATING_GEOTHERMAL'
  | 'HEATING_HEAT_PUMP'
  | 'HEATING_HIGH_EFFICIENCY'
  | 'HEATING_HOT_WATER'
  | 'HEATING_MINI_SPLIT'
  | 'HEATING_NONE'
  | 'HEATING_OIL'
  | 'HEATING_OTHER'
  | 'HEATING_PROPANE'
  | 'HEATING_RADIANT'
  | 'HEATING_SOLAR'
  | 'HEATING_STEAM'
  | 'HEATING_UNKNOWN'
  | 'HEATING_WALL_FURNACE'
  | 'HEATING_WALL_UNIT'
  | 'HEATING_WOOD'
  | 'HEATING_ZONED';

/** Home Owner's Association data. */
export type OdProtosHomeDataStore_HomeDetail_HoaInput = {
  /** Managing agency name. */
  companyName?: InputMaybe<Scalars['String']>;
  contact?: InputMaybe<Array<OdProtosHomeDataStore_HomeDetail_Hoa_ContactInput>>;
  /** Fee to be paid to the HOA. Usually a recurring fee as specified by fee_frequency. */
  fee?: InputMaybe<OdProtosCommon_MoneyInput>;
  feeFrequency?: InputMaybe<Scalars['String']>;
  /** Optional maximum HOA fee. */
  feeMaximum?: InputMaybe<OdProtosCommon_MoneyInput>;
  /** Optional minimum HOA fee. */
  feeMinimum?: InputMaybe<OdProtosCommon_MoneyInput>;
  feeType?: InputMaybe<OdProtosHomeDataStore_HomeDetail_Hoa_HoaFeeType>;
  /** Whether the HOA has leasing restrictions. */
  hasLeasingRestriction?: InputMaybe<Scalars['Boolean']>;
  hoaType?: InputMaybe<OdProtosHomeDataStore_HomeDetail_Hoa_HoaType>;
  /** What is included with the HOA fees. */
  includes?: InputMaybe<Array<Scalars['String']>>;
  /** Law firm name. */
  lawFirmName?: InputMaybe<Scalars['String']>;
  /** Name of the HOA. */
  name?: InputMaybe<Scalars['String']>;
  /** Rules of the HOA. */
  rules?: InputMaybe<Scalars['String']>;
};

export type OdProtosHomeDataStore_HomeDetail_Hoa_ContactInput = {
  address?: InputMaybe<OdProtosHomeDataStore_HomeDetail_Hoa_Contact_AddressInput>;
  businessPhone?: InputMaybe<OdProtosCommon_PhoneNumberInput>;
  email?: InputMaybe<OdProtosCommon_EmailAddressInput>;
  mobilePhone?: InputMaybe<OdProtosCommon_PhoneNumberInput>;
  name?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<OdProtosHomeDataStore_HomeDetail_Hoa_Contact_Type>;
};

export type OdProtosHomeDataStore_HomeDetail_Hoa_Contact_AddressInput = {
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  street?: InputMaybe<Scalars['String']>;
  unitNumber?: InputMaybe<Scalars['String']>;
};

export type OdProtosHomeDataStore_HomeDetail_Hoa_Contact_Type =
  | 'ATTORNEY'
  | 'MANAGING_AGENCY'
  | 'OWNERS_ASSOCIATION'
  | 'UNKNOWN';

/** Type of association fee. */
export type OdProtosHomeDataStore_HomeDetail_Hoa_HoaFeeType =
  | 'AMENTITY_FEE'
  | 'BUILDING_MAINTAINENCE_FEE'
  | 'COMMUNITY_MASTER_HOME_OWNER_FEE'
  | 'FEE_CAPITAL_IMPROVEMENTS_FEE'
  | 'HOME_OWNER_ASSESSMENTS_FEE'
  | 'HOME_OWNER_TRANSFER_FEE'
  | 'MELLO_ROOS_COMMUNITY_FACILITIES_DISTRICT_FEE'
  | 'POA_FEE'
  | 'RECREATION_FEE'
  | 'RESORT_FEE'
  | 'TENNIS_FEE'
  | 'UNKNOWN_HOA_FEE_TYPE';

/** Owners association type. */
export type OdProtosHomeDataStore_HomeDetail_Hoa_HoaType =
  | 'CONDO_OWNER_ASSOCIATION'
  | 'HOME_OWNER_ASSOCIATION'
  | 'LEGAL_AGENCY'
  | 'MANAGEMENT_AGENCY'
  | 'PLANNED_UNIT_DEVELOPMENT'
  | 'UNKNOWN_HOA_TYPE';

export type OdProtosHomeDataStore_HomeDetail_HvacInput = {
  hvacLocation?: InputMaybe<OdProtosHomeDataStore_HomeDetail_HvacLocation>;
  hvacUnitType?: InputMaybe<OdProtosHomeDataStore_HomeDetail_HvacUnitType>;
  manufacturer?: InputMaybe<Scalars['String']>;
  model?: InputMaybe<Scalars['String']>;
  serialNumber?: InputMaybe<Scalars['String']>;
  yearManufactured?: InputMaybe<Scalars['Float']>;
};

export type OdProtosHomeDataStore_HomeDetail_HvacLocation =
  | 'INDOOR'
  | 'OUTDOOR'
  | 'UNKNOWN_LOCATION';

export type OdProtosHomeDataStore_HomeDetail_HvacSystemInput = {
  energyType?: InputMaybe<OdProtosHomeDataStore_HomeDetail_HvacSystem_HvacEnergyType>;
  /** List of HVACs installed at the home */
  hvacs?: InputMaybe<Array<OdProtosHomeDataStore_HomeDetail_HvacInput>>;
  systemType?: InputMaybe<OdProtosHomeDataStore_HomeDetail_HvacSystem_HvacSystemType>;
};

export type OdProtosHomeDataStore_HomeDetail_HvacSystem_HvacEnergyType =
  | 'ELECTRIC'
  | 'GAS'
  | 'UNKNOWN_ENERGY_TYPE';

export type OdProtosHomeDataStore_HomeDetail_HvacSystem_HvacSystemType =
  | 'PACKAGED'
  | 'SPLIT'
  | 'UNKNOWN_TYPE';

export type OdProtosHomeDataStore_HomeDetail_HvacUnitType =
  | 'AIR_HANDLING_UNIT'
  | 'CONDENSER'
  | 'FURNACE'
  | 'HEAT_PUMP'
  | 'UNKNOWN_UNIT_TYPE';

/** An inclusive range of integer values. */
export type OdProtosHomeDataStore_HomeDetail_IntegerRangeInput = {
  end?: InputMaybe<Scalars['Float']>;
  start?: InputMaybe<Scalars['Float']>;
};

export type OdProtosHomeDataStore_HomeDetail_KitchenFeaturesInput = {
  galley?: InputMaybe<Scalars['Boolean']>;
  hasBuiltInMicrowave?: InputMaybe<Scalars['Boolean']>;
  hasButlerPantry?: InputMaybe<Scalars['Boolean']>;
  hasCablePrewire?: InputMaybe<Scalars['Boolean']>;
  hasCeilingFan?: InputMaybe<Scalars['Boolean']>;
  hasCookingIsland?: InputMaybe<Scalars['Boolean']>;
  hasDoubleOven?: InputMaybe<Scalars['Boolean']>;
  hasExhaustFanOrHood?: InputMaybe<Scalars['Boolean']>;
  hasFoodPrepIsland?: InputMaybe<Scalars['Boolean']>;
  hasMultipleOvens?: InputMaybe<Scalars['Boolean']>;
  hasPantry?: InputMaybe<Scalars['Boolean']>;
  hasPlumbedGas?: InputMaybe<Scalars['Boolean']>;
  hasRecessedLighting?: InputMaybe<Scalars['Boolean']>;
  hasSkylight?: InputMaybe<Scalars['Boolean']>;
  hasVentMechanism?: InputMaybe<Scalars['Boolean']>;
  hasWalkInPantry?: InputMaybe<Scalars['Boolean']>;
  hasWallOven?: InputMaybe<Scalars['Boolean']>;
  hasWaterLineToFridge?: InputMaybe<Scalars['Boolean']>;
  hasWetBar?: InputMaybe<Scalars['Boolean']>;
  kitchenIsland?: InputMaybe<Scalars['Boolean']>;
  kitchenette?: InputMaybe<Scalars['Boolean']>;
  newCabinets?: InputMaybe<Scalars['Boolean']>;
  noAppliances?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<Scalars['Boolean']>;
  openFloorPlan?: InputMaybe<Scalars['Boolean']>;
  other?: InputMaybe<Scalars['Boolean']>;
  tileBacksplash?: InputMaybe<Scalars['Boolean']>;
};

export type OdProtosHomeDataStore_HomeDetail_LandscapingFeaturesInput = {
  decorativeLighting?: InputMaybe<Scalars['Boolean']>;
  dirt?: InputMaybe<Scalars['Boolean']>;
  fountain?: InputMaybe<Scalars['Boolean']>;
  fruitTrees?: InputMaybe<Scalars['Boolean']>;
  garden?: InputMaybe<Scalars['Boolean']>;
  grass?: InputMaybe<Scalars['Boolean']>;
  gravelStone?: InputMaybe<Scalars['Boolean']>;
  hasDesertYard?: InputMaybe<Scalars['Boolean']>;
  lowMaintenance?: InputMaybe<Scalars['Boolean']>;
  matureLandscaping?: InputMaybe<Scalars['Boolean']>;
  noLandscaping?: InputMaybe<Scalars['Boolean']>;
  shrubs?: InputMaybe<Scalars['Boolean']>;
  sprinklerSystem?: InputMaybe<Scalars['Boolean']>;
  syntheticGrass?: InputMaybe<Scalars['Boolean']>;
  trees?: InputMaybe<Scalars['Boolean']>;
};

export type OdProtosHomeDataStore_HomeDetail_LaundryFeature =
  | 'LAUNDRY_COMMUNITY_LAUNDRY'
  | 'LAUNDRY_DRYER_HOOKUP'
  | 'LAUNDRY_DRYER_INCLUDED'
  | 'LAUNDRY_NONE'
  | 'LAUNDRY_OTHER'
  | 'LAUNDRY_UNKNOWN'
  | 'LAUNDRY_WASHER_HOOKUP'
  | 'LAUNDRY_WASHER_INCLUDED';

export type OdProtosHomeDataStore_HomeDetail_LaundryFeaturesInput = {
  features?: InputMaybe<Array<OdProtosHomeDataStore_HomeDetail_LaundryFeature>>;
  location?: InputMaybe<OdProtosHomeDataStore_HomeDetail_Location>;
};

export type OdProtosHomeDataStore_HomeDetail_Location =
  | 'LOCATION_BASEMENT'
  | 'LOCATION_DEN'
  | 'LOCATION_DINING_ROOM'
  | 'LOCATION_EXTERIOR'
  | 'LOCATION_FAMILY_ROOM'
  | 'LOCATION_GARAGE'
  | 'LOCATION_GREAT_ROOM'
  | 'LOCATION_INTERIOR'
  | 'LOCATION_KITCHEN'
  | 'LOCATION_LAUNDRY_ROOM'
  | 'LOCATION_LIVING_ROOM'
  | 'LOCATION_MASTER_BEDROOM'
  | 'LOCATION_UNKNOWN'
  | 'LOCATION_UPSTAIRS';

/** Next LotFeature ID: 13; */
export type OdProtosHomeDataStore_HomeDetail_LotFeaturesInput = {
  isCleared?: InputMaybe<Scalars['Boolean']>;
  /** A lot abutting 2 intersecting streets where the interior angle of intersection does not exceed 135 degrees */
  isCornerLot?: InputMaybe<Scalars['Boolean']>;
  /** A lot on the end of a minor street with only one outlet and terminating in a vehicular turnaround */
  isCulDeSac?: InputMaybe<Scalars['Boolean']>;
  isFlagLot?: InputMaybe<Scalars['Boolean']>;
  isGreenbelt?: InputMaybe<Scalars['Boolean']>;
  isInteriorLot?: InputMaybe<Scalars['Boolean']>;
  isIrregularLot?: InputMaybe<Scalars['Boolean']>;
  isLandscaped?: InputMaybe<Scalars['Boolean']>;
  onGolfCourse?: InputMaybe<Scalars['Boolean']>;
  onWaterfront?: InputMaybe<Scalars['Boolean']>;
  other?: InputMaybe<Scalars['Boolean']>;
  /** Length of the plot outer boundaries */
  perimeterFeet?: InputMaybe<Scalars['Float']>;
};

export type OdProtosHomeDataStore_HomeDetail_OtherRoom =
  | 'OTHER_ROOM_DEN_OFFICE'
  | 'OTHER_ROOM_EXERCISE_ROOM'
  | 'OTHER_ROOM_FAMILY_ROOM'
  | 'OTHER_ROOM_FORMAL_DINING_ROOM'
  | 'OTHER_ROOM_FORMAL_LIVING_ROOM_SEPARATE'
  | 'OTHER_ROOM_FOYER'
  | 'OTHER_ROOM_GAME_ROOM'
  | 'OTHER_ROOM_GREAT_ROOM'
  | 'OTHER_ROOM_INTERIOR_LAUNDRY'
  | 'OTHER_ROOM_LAUNDRY_UTILITY_ROOM'
  | 'OTHER_ROOM_LIBRARY'
  | 'OTHER_ROOM_LOFT'
  | 'OTHER_ROOM_MEDIA_ROOM'
  | 'OTHER_ROOM_NONE'
  | 'OTHER_ROOM_OTHER'
  | 'OTHER_ROOM_SCREENED_PORCH'
  | 'OTHER_ROOM_SEP_GUEST_QUARTERS'
  | 'OTHER_ROOM_STORAGE'
  | 'OTHER_ROOM_SUN_ROOM'
  | 'OTHER_ROOM_UNKNOWN'
  | 'OTHER_ROOM_WINE_CELLAR'
  | 'OTHER_ROOM_WORKSHOP';

export type OdProtosHomeDataStore_HomeDetail_OutdoorSpaceInput = {
  /** True if the cover was built with a proper permit.  Nil if no cover exists. */
  isCoverPermitted?: InputMaybe<Scalars['Boolean']>;
  /** True if the patio has a cover. */
  isCovered?: InputMaybe<Scalars['Boolean']>;
  /** front, back, side */
  location?: InputMaybe<Scalars['String']>;
  /** patio, deck, porch, outdoor_kitchen, dock, other */
  type?: InputMaybe<Scalars['String']>;
};

/** Next Room Id: 45 */
export type OdProtosHomeDataStore_HomeDetail_ParkingFeature =
  | 'PARKING_ALLEY_ACCESS'
  | 'PARKING_ASSIGNED'
  | 'PARKING_ATTACHED_GARAGE'
  | 'PARKING_ATTACHED_GARAGE_CABINETS'
  | 'PARKING_CARPORT'
  | 'PARKING_CARPORT_ATTACHED'
  | 'PARKING_CARPORT_DETACHED'
  | 'PARKING_CIRCULAR_DRIVEWAY'
  | 'PARKING_COMMON'
  | 'PARKING_COMMUNITY'
  | 'PARKING_CONVERTED_GARAGE'
  | 'PARKING_COVERED'
  | 'PARKING_DETACHED_GARAGE'
  | 'PARKING_DIRECT_GARAGE_ACCESS'
  | 'PARKING_DRIVEWAY'
  | 'PARKING_ELECTRIC_CAR_CHARGING'
  | 'PARKING_EXTENDED_LENGTH_GARAGE'
  | 'PARKING_FEE'
  | 'PARKING_FRONT_ENTRY'
  | 'PARKING_GARAGE'
  | 'PARKING_GARAGE_DOOR_OPENER'
  | 'PARKING_GATED'
  | 'PARKING_GOLF_CART'
  | 'PARKING_HEATED_GARAGE'
  | 'PARKING_NONE'
  | 'PARKING_OFFSITE'
  | 'PARKING_OFF_STREET'
  | 'PARKING_OVERSIZED'
  | 'PARKING_PAVED_DRIVEWAY'
  | 'PARKING_PERMIT'
  | 'PARKING_PULL_THROUGH'
  | 'PARKING_REAR_ENTRY'
  | 'PARKING_RV'
  | 'PARKING_RV_GARAGE'
  | 'PARKING_SHARED_DRIVEWAY'
  | 'PARKING_SIDE_ENTRY'
  | 'PARKING_STORAGE'
  | 'PARKING_STREET'
  | 'PARKING_TANDEM'
  | 'PARKING_TEMP_CONTROLLED'
  | 'PARKING_UNASSIGNED'
  | 'PARKING_UNKNOWN'
  | 'PARKING_UNPAVED_DRIVEWAY'
  | 'PARKING_VALET'
  | 'PARKING_WORKSHOP';

/** Road represents segments of both Road and Links (onRamps) */
export type OdProtosHomeDataStore_HomeDetail_RoadInput = {
  adjacent?: InputMaybe<Scalars['Boolean']>;
  distanceM?: InputMaybe<Scalars['Float']>;
  /** name of the road, or some other signifier */
  label?: InputMaybe<Scalars['String']>;
  /** well-known text representation of the road */
  roadWkt?: InputMaybe<Scalars['String']>;
};

export type OdProtosHomeDataStore_HomeDetail_RoofInput = {
  /**
   * An estimation of the years we can expect the roof to require replacement,
   * represented as the range of years (e.g 2022 - 2024).
   */
  estimatedLifeExpiration?: InputMaybe<OdProtosHomeDataStore_HomeDetail_IntegerRangeInput>;
  hasEvidenceOfHailDamage?: InputMaybe<Scalars['Boolean']>;
  hasEvidenceOfLeakFromInterior?: InputMaybe<Scalars['Boolean']>;
  isRoofMaintainedByHoa?: InputMaybe<Scalars['Boolean']>;
  /**
   * asphalt_shingles, metal_shingles, wood_shingles, flat_rolled,
   * membrane_roofing, metal, shake, slate, tile, other, unknown
   */
  roofMaterials?: InputMaybe<Array<Scalars['String']>>;
  yearBuilt?: InputMaybe<Scalars['Float']>;
};

export type OdProtosHomeDataStore_HomeDetail_RoomFeaturesInput = {
  fireplaceFeatures?: InputMaybe<Array<OdProtosHomeDataStore_HomeDetail_FireplaceFeature>>;
  /** flooring material for whole room */
  flooringMaterial?: InputMaybe<OdProtosHomeDataStore_HomeDetail_FlooringMaterial>;
  /** Basement = floor -1, ground floor = floor 1. 0 should never be used. */
  interiorStory?: InputMaybe<Scalars['Float']>;
  lengthFeet?: InputMaybe<Scalars['Float']>;
  /** flooring material breakdown with included size */
  roomFloorings?: InputMaybe<Array<OdProtosHomeDataStore_HomeDetail_FlooringInput>>;
  squareFeet?: InputMaybe<Scalars['Float']>;
  widthFeet?: InputMaybe<Scalars['Float']>;
};

/** `OdProtosHomeDataStore_HomeDetail_RoomFlooringsEntryInput` represents the `room_floorings` map in `od_protos.home_data_store.HomeDetail`. */
export type OdProtosHomeDataStore_HomeDetail_RoomFlooringsEntryInput = {
  key?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<OdProtosHomeDataStore_HomeDetail_FlooringInput>;
};

/**
 * Deprecated, use top-level fields for available rooms.
 * Remaining ambiguous rooms can continue to be listed here
 * Ex. bedroom (non-master), bathroom (non-master), hallway, closet, storage
 * Next Room Id: 11
 */
export type OdProtosHomeDataStore_HomeDetail_RoomInput = {
  fireplaces?: InputMaybe<Array<OdProtosHomeDataStore_HomeDetail_FireplaceInput>>;
  /** heavily_worn, typical_use, great_condition */
  flooringCondition?: InputMaybe<Scalars['String']>;
  /** tile, laminate, hardwood, carpet, other */
  flooringMaterial?: InputMaybe<Scalars['String']>;
  lengthFeet?: InputMaybe<Scalars['Float']>;
  roomFloorings?: InputMaybe<Array<OdProtosHomeDataStore_HomeDetail_FlooringInput>>;
  /** currently only used for bathrooms, e.g. half_bath, full_bath */
  roomSubType?: InputMaybe<Scalars['String']>;
  /** bedroom, bathroom, living, kitchen, etc. */
  roomType?: InputMaybe<Scalars['String']>;
  squareFeet?: InputMaybe<Scalars['Float']>;
  /** first_floor, second_floor, third_floor, basement, sub_basement, other */
  story?: InputMaybe<Scalars['String']>;
  widthFeet?: InputMaybe<Scalars['Float']>;
};

/** Slope direction relative to the home. */
export type OdProtosHomeDataStore_HomeDetail_SlopeDirection =
  | 'SLOPEDIR_DOWNHILL'
  | 'SLOPEDIR_NONE'
  | 'SLOPEDIR_UNKNOWN'
  | 'SLOPEDIR_UPHILL';

export type OdProtosHomeDataStore_HomeDetail_SlopeType =
  | 'SLOPETYPE_NONE'
  | 'SLOPETYPE_SLIGHT'
  | 'SLOPETYPE_SUBSTANTIAL'
  | 'SLOPETYPE_UNKNOWN';

/**
 * Source encodes where does this data comes from. This is needed so that we can have resolution strategies that
 * depend on where data came from. Source is a coarse grained category of where the data came from. E.g. all MLS
 * data is grouped into the MLS source.
 *
 * If you plan to start writing to Home Data Store, please add yourself here and request a review from #data-infra.
 * Next Source ID: 30
 */
export type OdProtosHomeDataStore_HomeDetail_Source =
  /** Operator entered overrides through admin. Done by Opendoor employees. */
  | 'SOURCE_ADMIN_OVERRIDES'
  /** Sherlock assessments performed by Opendoor employees. This is written from web. */
  | 'SOURCE_ASSESSMENT'
  /** Derived data that combines ATTOM parcels details and census features */
  | 'SOURCE_ATTOM_AND_CENSUS_MTRAC'
  /** Data provided from Attom HOA data */
  | 'SOURCE_ATTOM_HOA_DATA'
  /** Derived data from ATTOM parcel dimensions */
  | 'SOURCE_ATTOM_PARCELS'
  /**
   * Parcel boundaries given to us by BSI, usually used to infer lot square footage. More documentation can be
   * found at https://github.com/opendoor-labs/dwellings/tree/master/docs/bsi and
   * https://www.boundarysolutions.com/.
   */
  | 'SOURCE_BSI_PARCEL'
  /**
   * Derived from the tax data provided by Corelogic. Corelogic provides tax data similar to RealtyTrac
   * but the data is expected to be more accurate
   */
  | 'SOURCE_CORELOGIC_TAX_DATA'
  /** Assessments and other field visits performed by Opendoor employees using Scout. */
  | 'SOURCE_FIELD_OPERATOR'
  /**
   * Figure Eight provides human tagged data about our homes. We use figure eight to determine kitchen countertops
   * among other things on homes in the markets we care about.
   * https://www.figure-eight.com/.
   */
  | 'SOURCE_FIGURE_EIGHT'
  /** Data provided from a floor plan scan */
  | 'SOURCE_FLOOR_PLAN'
  /** Homebuilder is any home builder corporation building brand new homes. For example: Lennar, Pulte. */
  | 'SOURCE_HOMEBUILDER'
  /** Data that is imputed from comps in the same postal code */
  | 'SOURCE_IMPUTED'
  /** Lakehouse arbitrated data */
  | 'SOURCE_LAKEHOUSE_ARBITRATED'
  /** Derived data from the Listing Remarks */
  | 'SOURCE_LISTING_REMARKS'
  /**
   * Parcel boundaries given by Maponics. Similar to BSI Parcel data.
   * https://www.pitneybowes.com/us/data/boundary-data/neighborhood-boundaries.html
   */
  | 'SOURCE_MAPONICS_PARCEL'
  /** Opendoor employees review discrepancies between seller answers and assessment data to identify correct values. */
  | 'SOURCE_MISSTATEMENT_RESOLUTION'
  /**
   * Multiple Listing Service. This contains data ingested by the Data Engineering team by connecting to different
   * MLS data feeds across different markets. This data is associated to when a home is in the market.
   */
  | 'SOURCE_MLS'
  /**
   * Maricopa County Assessor documents. Similar data as Realty Trac but of higher quality in the Phoenix area.
   * https://github.com/opendoor-labs/dwellings/tree/master/docs/monsoon.
   */
  | 'SOURCE_MONSOON'
  /**
   * Edits made by the ODA (Opendoor Direct Access – institutional buyers) ops team
   * during diligence in response to institutional bids.
   */
  | 'SOURCE_ODA_TOOLING'
  /**
   * Bulk labeling from internal users that use custom tools to label batches of homes at a time
   * At the time of adding this new source, this process is used to label guard gated communities, sink holes, entry types,
   * and similar features that might impact a home's eligibility in our buy box
   */
  | 'SOURCE_OPENDOOR_BULK_LABELING'
  /**
   * Opendoor edits made by internal tools and employees. Highest priority resolution. The tool used to make the
   * edit should be written as `source_name`.
   * Note: It will be necessary to create a separate "source" for other "Opendoor edits" in the future,
   * i.e. for Opendoor contract teams where the edits are lower priority.
   */
  | 'SOURCE_OPENDOOR_INTERNAL_EDIT'
  /** Data validated by an Opendoor employee */
  | 'SOURCE_OPENDOOR_INTERNAL_VALIDATION'
  /** GIS Values derived by Opendoor from Data provided by OpenStreetMap */
  | 'SOURCE_OSM'
  /** Data from photo labelling vendors via the service "dataingest" (i.e. HiveAI, RestB ...) */
  | 'SOURCE_PHOTO_LABELS'
  /** Condition scores from prelisting photos */
  | 'SOURCE_PRELISTING'
  /** PropCo (core OD flipping business) home details for resale listings. */
  | 'SOURCE_PROPCO_LISTING'
  /**
   * Realty Trac provides tax assessor records to us for the whole country. Documentation about this data source
   * can be found at https://github.com/opendoor-labs/dwellings/tree/master/docs/realty_trac.
   */
  | 'SOURCE_REALTY_TRAC'
  /**
   * A resolved source means that HDS resolved this home details by possibly merging multiple sources. It should
   * only be set by Home Data Store.
   */
  | 'SOURCE_RESOLVED'
  /**
   * Assessor documents manually scraped by the pricing team to get higher accuracy in some counties where
   * Realty Trac data quality is lacking.
   */
  | 'SOURCE_SCRAPED_COUNTY_TAX_ASSESSOR'
  /** Seller Inputs is that entered by a customer through our seller flow when requesting an offer. */
  | 'SOURCE_SELLER_INPUTS'
  /** Sherlock assessments performed by Opendoor employees. */
  | 'SOURCE_SHERLOCK'
  /**
   * Information from RepairScopes in Sherlock assessments performed by Opendoor employees.
   * This information may be transient. Consumers should verify that these values have not changed during renovation.
   */
  | 'SOURCE_SHERLOCK_REPAIR_SCOPES'
  /**
   * Default value, whenever we do not know the source of the data. HDS would not accept anything that has an
   * unspecified source.
   */
  | 'SOURCE_UNKNOWN'
  /** Edits made through the Valuation Tool (Pricing) when pricing associates make offers to a customer. */
  | 'SOURCE_VAL_TOOL'
  /** Virtual assessments performed by Opendoor employees */
  | 'SOURCE_VIRTUAL_ASSESSMENT'
  /** Opendoor edits done through https://wally.apps.opendoor.com/. This could come from anyone within Opendoor. */
  | 'SOURCE_WOLLIZ';

export type OdProtosHomeDataStore_HomeDetail_UtilityProviderInput = {
  providerName?: InputMaybe<Scalars['String']>;
};

export type OdProtosHomeDataStore_HomeDetail_WaterHeaterInput = {
  /**
   * An (inclusive) estimated range of the capacity of the water heater.
   * If an exact value is known, start and end will be equal.
   */
  capacityGallons?: InputMaybe<OdProtosHomeDataStore_HomeDetail_IntegerRangeInput>;
  energyType?: InputMaybe<OdProtosHomeDataStore_HomeDetail_WaterHeater_WaterHeaterEnergyType>;
  /** List of water heater features. */
  features?: InputMaybe<Array<Scalars['String']>>;
  /** Year when the water heater was installed. */
  yearInstalled?: InputMaybe<Scalars['Float']>;
};

export type OdProtosHomeDataStore_HomeDetail_WaterHeater_WaterHeaterEnergyType =
  | 'ELECTRIC'
  | 'GAS'
  | 'UNKNOWN_ENERGY_TYPE';

export type OdProtosHomeDataStore_HomeDetail_YardFeaturesInput = {
  fenceCompletionStatus?: InputMaybe<OdProtosHomeDataStore_HomeDetail_YardFeatures_FenceCompletionStatus>;
  fenceFeatures?: InputMaybe<Array<OdProtosHomeDataStore_HomeDetail_FenceFeature>>;
  /** Designates existence. False indicates the home has no yard in the specified position. */
  hasYard?: InputMaybe<Scalars['Boolean']>;
  landscaping?: InputMaybe<OdProtosHomeDataStore_HomeDetail_LandscapingFeaturesInput>;
  /** Slope direction relative to the home. */
  slopeDirection?: InputMaybe<OdProtosHomeDataStore_HomeDetail_SlopeDirection>;
  /** slope severity */
  slopeType?: InputMaybe<OdProtosHomeDataStore_HomeDetail_SlopeType>;
};

export type OdProtosHomeDataStore_HomeDetail_YardFeatures_FenceCompletionStatus =
  | 'FULL'
  | 'NO_FENCE'
  | 'PARTIAL'
  | 'UNSPECIFIED_STATUS';

/**
 * Deprecated, use yard features instead
 * Next Yard ID: 7;
 */
export type OdProtosHomeDataStore_HomeDetail_YardInput = {
  /** needs_work, typical_use, great_condition */
  condition?: InputMaybe<Scalars['String']>;
  fence?: InputMaybe<OdProtosHomeDataStore_HomeDetail_FenceInput>;
  /**
   * Designates existence. false value indicatest that the home
   * has no yard in the specified position.
   */
  hasYard?: InputMaybe<Scalars['Boolean']>;
  /** front, back */
  position?: InputMaybe<Scalars['String']>;
  /**
   * Slope direction relative to the home.
   * no_slope, downhill_slope, uphill_slope
   */
  slopeDirection?: InputMaybe<Scalars['String']>;
  /** slight_slope, substantial_slope, severe_slope, none */
  slopeType?: InputMaybe<Scalars['String']>;
};

export type OdProtosHomeDataStore_ListResolverLabelsRequestInput = {
  _empty?: InputMaybe<Scalars['Boolean']>;
};

/**
 * Seller inputs that do not exist on HomeDetail
 * Next ID: 15
 */
export type OdProtosHomeDataStore_PartnershipAdditionalHomeDetailsInput = {
  /** Can be unfinished, partially_finished, or finished */
  basementFinishing?: InputMaybe<Scalars['String']>;
  floodHistoryTriage?: InputMaybe<OdProtosSellReceptionData_Answers_FloodHistoryTriageInput>;
  hasFireDamage?: InputMaybe<Scalars['Boolean']>;
  /** Whether the house has leased solar panels AND the owner does not want to buy out the lease */
  hasLeasedSolarPanelsAndRejectBuyOut?: InputMaybe<Scalars['Boolean']>;
  /** Whether seller's estimate of the home's value is out of buybox */
  hasPriceEstimateTriage?: InputMaybe<Scalars['Boolean']>;
  /** Freetext additional information */
  otherInformation?: InputMaybe<Scalars['String']>;
};

export type OdProtosHomeDataStore_PreferredHomeDetailsUsage =
  /** Default behavior. Preferred home details are preferred above all else. */
  | 'PREFERRED_HOME_DETAILS_USAGE_DEFAULT'
  /**
   * Preferred home details will replace all other home details for the same source,
   * but the resolution strategy will still be applied, and could rank other home
   * details from other sources above the preferred home details.
   */
  | 'PREFERRED_HOME_DETAILS_USAGE_REPLACE_ALL_FROM_SOURCE';

export type OdProtosHomeDataStore_RemovePrimaryAddressForHomeDetailRequestInput = {
  homeDetailId?: InputMaybe<Scalars['String']>;
};

export type OdProtosHomeDataStore_ResolveHomeDetailsRequestInput = {
  /** Address from casa */
  address?: InputMaybe<OdProtosCasaData_AddressInput>;
  /** Address ID of the home we want to get details from. */
  addressToken?: InputMaybe<Scalars['String']>;
  /** Customer preassigned id for accessing the api. */
  clientId?: InputMaybe<Scalars['String']>;
  /**
   * Timestamp as of which we want to resolve home details for this home. E.g. if we want to get the state of a home
   * in a particular date (without using any newer data) we should set this field.
   */
  endDate?: InputMaybe<Scalars['DateTime']>;
  /**
   * List of home detail IDs with a higher preference that any others. Beginning of the list has higher preference than
   * the end. This should be used sparingly and it is meant for use-cases in which we want to apply overrides for
   * single requests.
   */
  preferredHomeDetailIds?: InputMaybe<Array<Scalars['String']>>;
  /**
   * Specify how the preferred_home_detail_ids should be used. The default is to use them
   * above all else, but we can also use them to replace all home details from a specific source.
   */
  preferredHomeDetailsUsage?: InputMaybe<OdProtosHomeDataStore_PreferredHomeDetailsUsage>;
  /** Specific resolution strategy desired. Default will be used if not given. */
  resolveStrategyLabel?: InputMaybe<Scalars['String']>;
};

export type OdProtosHomeDataStore_ResolveProvidedHomeDetailsRequestInput = {
  /** Address from casa. */
  address?: InputMaybe<OdProtosCasaData_AddressInput>;
  /** List of HomeDetails to be used for resolution. */
  providedHomeDetails?: InputMaybe<Array<OdProtosHomeDataStore_HomeDetailInput>>;
  /** Specific resolution strategy desired. Default will be used if not given. */
  resolveStrategyLabel?: InputMaybe<Scalars['String']>;
};

export type OdProtosHomeDataStore_SetPrimaryAddressForHomeDetailRequestInput = {
  /** The home detail ID we want to update. */
  homeDetailId?: InputMaybe<Scalars['String']>;
  /** New address UUID for the home detail. */
  primaryAddressUuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosHomeDataStore_UnresolvedHomeDetailsRequestInput = {
  /** Address token of the home to get unresolved home details from. */
  addressToken?: InputMaybe<Scalars['String']>;
  /**
   * Timestamp as of which we want to resolve home details for this home. E.g. if we want to get the state of a home
   * in a particular date (without using any newer data) we should set this field.
   */
  endDate?: InputMaybe<Scalars['DateTime']>;
};

export type OdProtosHomeInspectorData_DecisionEngineStatus =
  | 'DECISION_ENGINE_STATUS_APPROVED'
  | 'DECISION_ENGINE_STATUS_PENDING'
  | 'DECISION_ENGINE_STATUS_PROPAGATED'
  | 'DECISION_ENGINE_STATUS_REJECTED'
  | 'DECISION_ENGINE_STATUS_UNSPECIFIED'
  | 'DECISION_ENGINE_STATUS_VALIDATED';

export type OdProtosHomeInspectorData_RepairScopeSuggestion_Category =
  | 'CATEGORY_COSMETIC'
  | 'CATEGORY_FUNCTIONAL'
  | 'CATEGORY_PERSONALIZATION'
  | 'CATEGORY_SAFETY'
  | 'CATEGORY_STRUCTURAL'
  | 'CATEGORY_UNSPECIFIED';

export type OdProtosHomeInspectorData_RepairScopeSuggestion_ReviewStatus =
  | 'REVIEW_STATUS_ACCEPTED'
  | 'REVIEW_STATUS_PENDING'
  | 'REVIEW_STATUS_REVIEWED'
  | 'REVIEW_STATUS_SKIPPED'
  | 'REVIEW_STATUS_UNSPECIFIED';

export type OdProtosHomeInspectorData_RepairScopeSuggestion_Severity =
  | 'SEVERITY_MAJOR'
  | 'SEVERITY_MINOR'
  | 'SEVERITY_NON_ISSUE'
  | 'SEVERITY_NOT_APPLICABLE'
  | 'SEVERITY_UNSPECIFIED';

export type OdProtosHomeInspectorData_RepairStandardsActionInput = {
  prefillSelection?: InputMaybe<OdProtosHomeInspectorData_RepairStandardsAction_PrefillSelectionInput>;
  result?: InputMaybe<OdProtosHomeInspectorData_RepairStandardsAction_Result>;
};

export type OdProtosHomeInspectorData_RepairStandardsAction_PrefillSelectionInput = {
  prefillId?: InputMaybe<Scalars['String']>;
};

export type OdProtosHomeInspectorData_RepairStandardsAction_Result =
  | 'RESULT_CREATE'
  | 'RESULT_ESTIMATE_ONLY'
  | 'RESULT_IGNORE';

export type OdProtosHomeInspectorData_RepairStandardsRuleInput = {
  action?: InputMaybe<OdProtosHomeInspectorData_RepairStandardsActionInput>;
  assets?: InputMaybe<Array<Scalars['String']>>;
  criteria?: InputMaybe<Scalars['String']>;
  key?: InputMaybe<Scalars['String']>;
  marketActions?: InputMaybe<Array<OdProtosHomeInspectorData_RepairStandardsRule_MarketActionsEntryInput>>;
  mustNot?: InputMaybe<Scalars['String']>;
};

/** `OdProtosHomeInspectorData_RepairStandardsRule_MarketActionsEntryInput` represents the `market_actions` map in `od_protos.home_inspector.data.RepairStandardsRule`. */
export type OdProtosHomeInspectorData_RepairStandardsRule_MarketActionsEntryInput = {
  key?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<OdProtosHomeInspectorData_RepairStandardsActionInput>;
};

export type OdProtosHomeInspectorData_RepairStandardsRulesetInput = {
  rules?: InputMaybe<Array<OdProtosHomeInspectorData_RepairStandardsRuleInput>>;
  version?: InputMaybe<Scalars['String']>;
};

export type OdProtosHomeInspectorServices_AcceptRepairScopeSuggestionRequestInput = {
  notes?: InputMaybe<Scalars['String']>;
  repairScope?: InputMaybe<OdProtosBanditServices_CreateRepairScopeRequestInput>;
  repairScopeSuggestionId?: InputMaybe<Scalars['String']>;
  severityDowngrade?: InputMaybe<Scalars['Boolean']>;
};

/** Decision Engine messages */
export type OdProtosHomeInspectorServices_ApproveDecisionEngineRunRequestInput = {
  decisionEngineRunId?: InputMaybe<Scalars['String']>;
};

export type OdProtosHomeInspectorServices_AssessmentTaskCompletedRequestInput = {
  taskId?: InputMaybe<Scalars['String']>;
};

export type OdProtosHomeInspectorServices_ClearResultsRequestInput = {
  addressId?: InputMaybe<Scalars['String']>;
};

export type OdProtosHomeInspectorServices_ConditionScopingTaskCompletedRequestInput = {
  taskId?: InputMaybe<Scalars['String']>;
};

export type OdProtosHomeInspectorServices_ConditionScopingTaskCreatedRequestInput = {
  taskId?: InputMaybe<Scalars['String']>;
};

export type OdProtosHomeInspectorServices_CreateDecisionEngineRunsRequestInput = {
  repairScopeSuggestionIds?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosHomeInspectorServices_CreateFeatureQuestionRequestInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  featureName?: InputMaybe<Scalars['String']>;
  homeArea?: InputMaybe<Scalars['String']>;
  question?: InputMaybe<Scalars['String']>;
};

export type OdProtosHomeInspectorServices_CreatePromptConfigurationRequestInput = {
  jobType?: InputMaybe<Scalars['String']>;
  live?: InputMaybe<Scalars['Boolean']>;
  model?: InputMaybe<Scalars['String']>;
  prompt?: InputMaybe<Scalars['String']>;
  temperature?: InputMaybe<Scalars['Float']>;
  topK?: InputMaybe<Scalars['Float']>;
  topP?: InputMaybe<Scalars['Float']>;
};

export type OdProtosHomeInspectorServices_CreateRepairStandardsSnapshotRequestInput = {
  _empty?: InputMaybe<Scalars['Boolean']>;
};

export type OdProtosHomeInspectorServices_DevCreateNewConditionScopingTaskRequestInput = {
  addressId?: InputMaybe<Scalars['String']>;
  areas?: InputMaybe<Array<Scalars['String']>>;
  disabledStandards?: InputMaybe<Scalars['Boolean']>;
  faster?: InputMaybe<Scalars['Boolean']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};

export type OdProtosHomeInspectorServices_DryRunLlmRequestRequestInput = {
  addressId?: InputMaybe<Scalars['String']>;
  json?: InputMaybe<Scalars['Boolean']>;
  llmRequestId?: InputMaybe<Scalars['String']>;
  promptConfigurationId?: InputMaybe<Scalars['String']>;
  tag?: InputMaybe<Scalars['String']>;
};

export type OdProtosHomeInspectorServices_EnqueueHeroShotsRequestInput = {
  conditionScopingTaskId?: InputMaybe<Scalars['String']>;
};

export type OdProtosHomeInspectorServices_EstimateAreaRequestInput = {
  conditionScopingTaskId?: InputMaybe<Scalars['String']>;
  /** When true, skips area validation guardrails that check if livable area is within 10% of property area */
  skipAreaGuardrails?: InputMaybe<Scalars['Boolean']>;
};

export type OdProtosHomeInspectorServices_GenerateHeroShotsRequestInput = {
  /** optional list of specific areas */
  areas?: InputMaybe<Array<Scalars['String']>>;
  assessmentTaskId?: InputMaybe<Scalars['String']>;
};

export type OdProtosHomeInspectorServices_GenerateWebSocketTokenRequestInput = {
  addressId?: InputMaybe<Scalars['String']>;
};

export type OdProtosHomeInspectorServices_GetConditionScopingQuestionnaireRequestInput = {
  addressId?: InputMaybe<Scalars['String']>;
};

export type OdProtosHomeInspectorServices_GetRepairScopeSuggestionRequestInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type OdProtosHomeInspectorServices_ListDecisionEngineGroundTruthRunsRequestInput = {
  repairStandardsDefectId?: InputMaybe<Scalars['String']>;
};

export type OdProtosHomeInspectorServices_ListDecisionEngineRunsRequestInput = {
  repairScopeSuggestionIds?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosHomeInspectorServices_ListHeroShotsRequestInput = {
  addressId?: InputMaybe<Scalars['String']>;
};

export type OdProtosHomeInspectorServices_ListRepairScopeSuggestionsByIdsRequestInput = {
  ids?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosHomeInspectorServices_ListRepairScopeSuggestionsRequestInput = {
  addressId?: InputMaybe<Scalars['String']>;
  repairStandardsDefectId?: InputMaybe<Scalars['String']>;
  reviewStatus?: InputMaybe<OdProtosHomeInspectorData_RepairScopeSuggestion_ReviewStatus>;
};

export type OdProtosHomeInspectorServices_ListRepairStandardsDefectsRequestInput = {
  _empty?: InputMaybe<Scalars['Boolean']>;
};

export type OdProtosHomeInspectorServices_ProcessConditionScopingQuestionnaireRequestInput = {
  conditionScopingTaskId?: InputMaybe<Scalars['String']>;
};

export type OdProtosHomeInspectorServices_PropagateConditionScopingQuestionnaireRequestInput = {
  taskId?: InputMaybe<Scalars['String']>;
};

export type OdProtosHomeInspectorServices_PropagateRepairScopesRequestInput = {
  addressId?: InputMaybe<Scalars['String']>;
  conditionScopingTaskId?: InputMaybe<Scalars['String']>;
};

export type OdProtosHomeInspectorServices_RejectDecisionEngineRunRequestInput = {
  decisionEngineRunId?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
};

export type OdProtosHomeInspectorServices_RejectRepairScopeSuggestionRequestInput = {
  duplicateRepairScopeId?: InputMaybe<Scalars['String']>;
  incorrectPrefillFeedback?: InputMaybe<OdProtosHomeInspectorServices_RejectRepairScopeSuggestionRequest_IncorrectPrefillFeedbackInput>;
  incorrectPriceFeedback?: InputMaybe<OdProtosHomeInspectorServices_RejectRepairScopeSuggestionRequest_IncorrectPriceFeedbackInput>;
  notes?: InputMaybe<Scalars['String']>;
  rejectReason?: InputMaybe<OdProtosHomeInspectorServices_RejectRepairScopeSuggestionRequest_RejectReason>;
  repairScopeSuggestionId?: InputMaybe<Scalars['String']>;
};

export type OdProtosHomeInspectorServices_RejectRepairScopeSuggestionRequest_IncorrectPrefillFeedbackInput = {
  defectId?: InputMaybe<Scalars['String']>;
  prefillId?: InputMaybe<Scalars['String']>;
};

export type OdProtosHomeInspectorServices_RejectRepairScopeSuggestionRequest_IncorrectPriceFeedbackInput = {
  laborCost?: InputMaybe<OdProtosBanditData_LaborCostInput>;
  materialCost?: InputMaybe<OdProtosBanditData_MaterialCostInput>;
};

export type OdProtosHomeInspectorServices_RejectRepairScopeSuggestionRequest_RejectReason =
  | 'REJECT_REASON_APPROVED'
  | 'REJECT_REASON_DUPLICATE'
  | 'REJECT_REASON_INCORRECT_PREFILL'
  | 'REJECT_REASON_INCORRECT_PRICE'
  | 'REJECT_REASON_ISSUE_NOT_PRESENT'
  | 'REJECT_REASON_NEGLIGIBLE'
  | 'REJECT_REASON_NOT_APPLICABLE_TO_MARKET'
  | 'REJECT_REASON_NOT_DEFECT'
  | 'REJECT_REASON_UNSPECIFIED';

export type OdProtosHomeInspectorServices_TestRepairStandardsRulesetRequestInput = {
  repairScopeSuggestionId?: InputMaybe<Scalars['String']>;
  ruleset?: InputMaybe<OdProtosHomeInspectorData_RepairStandardsRulesetInput>;
};

/**
 * Config keyed by Market.
 * PBDB Key: market
 */
export type OdProtosHomeOperationsConfig_MarketConfigInput = {
  /**
   * Change orders above this dollar amount require approval from an area
   * construction manager
   */
  acmEscalationThresholdInDollars?: InputMaybe<Scalars['Float']>;
  /** Area construction manager Slack group */
  acmSlackGroup?: InputMaybe<Scalars['String']>;
  /** Slack channel for change order esclations */
  changeOrderEscalationSlackChannel?: InputMaybe<Scalars['String']>;
  /**
   * Change orders above this dollar amount require approval from a general
   * manager
   */
  gmEscalationThresholdInDollars?: InputMaybe<Scalars['Float']>;
  /** General manager Slack group */
  gmSlackGroup?: InputMaybe<Scalars['String']>;
  /** Home operations coordinator Slack group */
  hocSlackGroup?: InputMaybe<Scalars['String']>;
  /**
   * Used to qualify a home for low risk home treatment. The age of the home in years
   * must be this or less.
   */
  lowRiskHomeTreatmentHomeAgeInYears?: InputMaybe<Scalars['Float']>;
  /**
   * Used to qualify a home for low risk home treatment. The immediate or assessment
   * scope in dollars must be this amount or less.
   */
  lowRiskHomeTreatmentImmediateScopeInDollars?: InputMaybe<Scalars['Float']>;
  /**
   * Change orders above this dollar amount require approval from an area
   * construction manager (Renovation projects only)
   */
  renoAcmEscalationThresholdInDollars?: InputMaybe<Scalars['Float']>;
  /**
   * Change orders above this dollar amount require approval from a general
   * manager (Renovation projects only)
   */
  renoGmEscalationThresholdInDollars?: InputMaybe<Scalars['Float']>;
  /** Slack channel for unassigned line items */
  unassignedLineItemsSlackChannel?: InputMaybe<Scalars['String']>;
};

export type OdProtosHomeworkData_AlertThresholdEntity =
  | 'LINE_ITEM'
  | 'UNKNOWN';

export type OdProtosHomeworkData_ChangeOrder_State =
  | 'DRAFT'
  | 'FINALIZED'
  | 'INVALID'
  | 'READY_FOR_REVIEW';

export type OdProtosHomeworkData_LineItemFilterInput = {
  column?: InputMaybe<OdProtosHomeworkData_LineItemFilter_Column>;
  isNegated?: InputMaybe<Scalars['Boolean']>;
  operand?: InputMaybe<OdProtosHomeworkData_LineItemFilter_OperandInput>;
  operator?: InputMaybe<OdProtosHomeworkData_LineItemFilter_Operator>;
};

export type OdProtosHomeworkData_LineItemFilterSetInput = {
  /** filters are AND'd with each other */
  filters?: InputMaybe<Array<OdProtosHomeworkData_LineItemFilterInput>>;
};

export type OdProtosHomeworkData_LineItemFilter_Column =
  | 'CREATED_AT'
  | 'ID'
  | 'INVALID_COLUMN'
  | 'PROJECT_ID'
  | 'WORK_ORDER_ID';

export type OdProtosHomeworkData_LineItemFilter_OperandInput = {
  value?: InputMaybe<OdProtosHomeworkData_LineItemFilter_Operand_ValueOneofInput>;
};

export type OdProtosHomeworkData_LineItemFilter_Operand_StringListInput = {
  strings?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosHomeworkData_LineItemFilter_Operand_ValueOneofInput = {
  stringValue?: InputMaybe<Scalars['String']>;
  stringValueList?: InputMaybe<OdProtosHomeworkData_LineItemFilter_Operand_StringListInput>;
};

export type OdProtosHomeworkData_LineItemFilter_Operator =
  | 'EQUAL_TO'
  | 'GREATER_THAN'
  | 'GREATER_THAN_OR_EQUAL_TO'
  | 'IN'
  | 'INVALID_OPERATOR'
  | 'IS_NULL'
  | 'LESS_THAN'
  | 'LESS_THAN_OR_EQUAL_TO';

export type OdProtosHomeworkData_LineItemOrderingInput = {
  column?: InputMaybe<OdProtosHomeworkData_LineItemOrdering_Column>;
  isAscending?: InputMaybe<Scalars['Boolean']>;
};

export type OdProtosHomeworkData_LineItemOrdering_Column =
  | 'CREATED_AT'
  | 'INVALID';

export type OdProtosHomeworkData_LineItemScope_LaborCostInput = {
  totalCents?: InputMaybe<Scalars['Float']>;
  totalMinutes?: InputMaybe<Scalars['Float']>;
};

export type OdProtosHomeworkData_LineItemScope_MaterialCostInput = {
  quantity?: InputMaybe<Scalars['Float']>;
  unitCents?: InputMaybe<Scalars['Float']>;
  unitLabel?: InputMaybe<Scalars['String']>;
};

export type OdProtosHomeworkData_LineItem_AccountCategory =
  | 'BINSR'
  | 'RENOVATIONS'
  | 'REPAIRS';

export type OdProtosHomeworkData_LineItem_State =
  | 'DRAFT'
  | 'INVALID'
  | 'REWORK_REQUESTED'
  | 'SCOPE_ACCEPTED'
  | 'SCOPE_REJECTED'
  | 'WORK_CANCELED'
  | 'WORK_COMPLETED'
  | 'WORK_INVALIDATED'
  | 'WORK_VALIDATED';

export type OdProtosHomeworkData_MessageThreadStatus =
  | 'NO_ACTION_REQUIRED'
  | 'WAITING_ON_OPENDOOR_RESPONSE'
  | 'WAITING_ON_THIRD_PARTY_RESPONSE';

export type OdProtosHomeworkData_ProjectFilterInput = {
  column?: InputMaybe<OdProtosHomeworkData_ProjectFilter_Column>;
  isNegated?: InputMaybe<Scalars['Boolean']>;
  operand?: InputMaybe<OdProtosHomeworkData_ProjectFilter_OperandInput>;
  operator?: InputMaybe<OdProtosHomeworkData_ProjectFilter_Operator>;
};

export type OdProtosHomeworkData_ProjectFilterSetInput = {
  /** These filters are AND'd together */
  filters?: InputMaybe<Array<OdProtosHomeworkData_ProjectFilterInput>>;
};

export type OdProtosHomeworkData_ProjectFilter_Column =
  | 'ADDRESS_ID'
  | 'ID'
  | 'KIND'
  | 'MARKET'
  | 'SCHEDULED_START_AT'
  | 'STATE';

export type OdProtosHomeworkData_ProjectFilter_OperandInput = {
  value?: InputMaybe<OdProtosHomeworkData_ProjectFilter_Operand_ValueOneofInput>;
};

export type OdProtosHomeworkData_ProjectFilter_Operand_MarketListInput = {
  markets?: InputMaybe<Array<OdProtosCommonMarket_Market>>;
};

export type OdProtosHomeworkData_ProjectFilter_Operand_StringListInput = {
  strings?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosHomeworkData_ProjectFilter_Operand_ValueOneofInput = {
  kindValue?: InputMaybe<OdProtosHomeworkData_ProjectKind>;
  marketValue?: InputMaybe<OdProtosCommonMarket_Market>;
  marketValueList?: InputMaybe<OdProtosHomeworkData_ProjectFilter_Operand_MarketListInput>;
  stateValue?: InputMaybe<OdProtosHomeworkData_Project_State>;
  stringValue?: InputMaybe<Scalars['String']>;
  stringValueList?: InputMaybe<OdProtosHomeworkData_ProjectFilter_Operand_StringListInput>;
  timestamp?: InputMaybe<Scalars['DateTime']>;
};

export type OdProtosHomeworkData_ProjectFilter_Operator =
  | 'EQUAL_TO'
  | 'GREATER_THAN'
  | 'GREATER_THAN_OR_EQUAL_TO'
  | 'IN'
  | 'IS_NULL'
  | 'LESS_THAN'
  | 'LESS_THAN_OR_EQUAL_TO';

export type OdProtosHomeworkData_ProjectKind =
  | 'BRN'
  | 'LISTED'
  | 'NONE'
  /** When adding new values, also modify the db enum type. */
  | 'REIT_RENOVATION'
  | 'RENOVATION';

export type OdProtosHomeworkData_ProjectOrderingInput = {
  column?: InputMaybe<OdProtosHomeworkData_ProjectOrdering_Column>;
  isAscending?: InputMaybe<Scalars['Boolean']>;
};

export type OdProtosHomeworkData_ProjectOrdering_Column =
  | 'CREATED_AT'
  | 'SCHEDULED_START_ON'
  | 'SCHEDULED_STOP_ON';

export type OdProtosHomeworkData_Project_State =
  | 'CANCELED'
  | 'COMPLETED'
  | 'DRAFT'
  | 'INVALID'
  | 'IN_PROGRESS';

export type OdProtosHomeworkData_WorkOrderFilterInput = {
  column?: InputMaybe<OdProtosHomeworkData_WorkOrderFilter_Column>;
  isNegated?: InputMaybe<Scalars['Boolean']>;
  operand?: InputMaybe<OdProtosHomeworkData_WorkOrderFilter_OperandInput>;
  operator?: InputMaybe<OdProtosHomeworkData_WorkOrderFilter_Operator>;
};

export type OdProtosHomeworkData_WorkOrderFilterSetInput = {
  /** filters are AND'd with each other */
  filters?: InputMaybe<Array<OdProtosHomeworkData_WorkOrderFilterInput>>;
};

export type OdProtosHomeworkData_WorkOrderFilter_Column =
  | 'ADDRESS_ID'
  | 'ASSIGNED_TO_BRANCH_ID'
  | 'CREATED_AT'
  | 'ID'
  | 'KIND'
  | 'MANAGER_ID'
  | 'MARKET'
  | 'STATE'
  | 'VENDOR_COMPLETED_AT';

export type OdProtosHomeworkData_WorkOrderFilter_OperandInput = {
  value?: InputMaybe<OdProtosHomeworkData_WorkOrderFilter_Operand_ValueOneofInput>;
};

export type OdProtosHomeworkData_WorkOrderFilter_Operand_KindListInput = {
  kinds?: InputMaybe<Array<OdProtosHomeworkData_WorkOrder_Kind>>;
};

export type OdProtosHomeworkData_WorkOrderFilter_Operand_MarketListInput = {
  markets?: InputMaybe<Array<OdProtosCommonMarket_Market>>;
};

export type OdProtosHomeworkData_WorkOrderFilter_Operand_StateListInput = {
  states?: InputMaybe<Array<OdProtosHomeworkData_WorkOrder_State>>;
};

export type OdProtosHomeworkData_WorkOrderFilter_Operand_StringListInput = {
  strings?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosHomeworkData_WorkOrderFilter_Operand_ValueOneofInput = {
  kindValueList?: InputMaybe<OdProtosHomeworkData_WorkOrderFilter_Operand_KindListInput>;
  marketValue?: InputMaybe<OdProtosCommonMarket_Market>;
  marketValueList?: InputMaybe<OdProtosHomeworkData_WorkOrderFilter_Operand_MarketListInput>;
  stateValue?: InputMaybe<OdProtosHomeworkData_WorkOrder_State>;
  stateValueList?: InputMaybe<OdProtosHomeworkData_WorkOrderFilter_Operand_StateListInput>;
  stringValue?: InputMaybe<Scalars['String']>;
  stringValueList?: InputMaybe<OdProtosHomeworkData_WorkOrderFilter_Operand_StringListInput>;
  timestampValue?: InputMaybe<Scalars['DateTime']>;
};

export type OdProtosHomeworkData_WorkOrderFilter_Operator =
  | 'EQUAL_TO'
  | 'GREATER_THAN'
  | 'GREATER_THAN_OR_EQUAL_TO'
  | 'IN'
  | 'IS_NULL'
  | 'LESS_THAN'
  | 'LESS_THAN_OR_EQUAL_TO';

export type OdProtosHomeworkData_WorkOrderForTradePartnerIndex_ProgressState =
  | 'INVOICABLE'
  | 'INVOICE_APPROVED'
  | 'INVOICE_SUBMITTED'
  | 'IN_PROGRESS'
  | 'NEW'
  | 'NONE'
  | 'READY_TO_START'
  | 'REWORK_NEEDED'
  | 'WAITING_FOR_ALLOWED_START'
  | 'WAITING_FOR_QUALITY_CONTROL';

export type OdProtosHomeworkData_WorkOrderOrderingInput = {
  column?: InputMaybe<OdProtosHomeworkData_WorkOrderOrdering_Column>;
  isAscending?: InputMaybe<Scalars['Boolean']>;
};

export type OdProtosHomeworkData_WorkOrderOrdering_Column =
  | 'CREATED_AT';

export type OdProtosHomeworkData_WorkOrder_Kind =
  | 'FEEDBACK'
  | 'HOA_VIOLATION'
  /** Deprecated values */
  | 'HOLDING'
  | 'INCIDENT'
  | 'INSURED'
  | 'LENDER_REQUIRED'
  | 'LISTED'
  | 'LITE'
  | 'LWOD'
  | 'MAINTENANCE'
  | 'MARKETPLACE'
  | 'OTHER'
  | 'PRELIMINARY'
  | 'REIT_RENOVATION'
  | 'RENOVATION'
  | 'RESALE'
  | 'REWORK'
  | 'SOLD'
  | 'TEST';

/** When updating the Work Order State enum, also add it to the work_order_state enum in the db */
export type OdProtosHomeworkData_WorkOrder_State =
  | 'DRAFT'
  /**
   * This state means that the construction manager has finished
   * creating the work order and moved it from the DRAFT state
   */
  | 'FINALIZED'
  | 'INVALID'
  | 'REWORK_REQUESTED'
  | 'SCOPE_ACCEPTED'
  | 'SCOPE_REJECTED'
  | 'WORK_CANCELED'
  | 'WORK_COMMENCED'
  | 'WORK_COMPLETED'
  | 'WORK_INVALIDATED'
  | 'WORK_VALIDATED';

export type OdProtosHomeworkServices_AcceptWorkOrderRequestInput = {
  workOrderId?: InputMaybe<Scalars['String']>;
};

export type OdProtosHomeworkServices_AccountingBucketListInput = {
  accountingBuckets?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosHomeworkServices_AssignOnSiteWorkerRequestInput = {
  assignedOnSiteWorkerId?: InputMaybe<Scalars['String']>;
  lineItemId?: InputMaybe<Scalars['String']>;
};

export type OdProtosHomeworkServices_AsyncUploadPhotosRequestInput = {
  addressId?: InputMaybe<Scalars['String']>;
  photoType?: InputMaybe<OdProtosHomeworkServices_AsyncUploadPhotosRequest_PhotoType>;
};

export type OdProtosHomeworkServices_AsyncUploadPhotosRequest_PhotoType =
  | 'LINE_ITEM_AFTER_PHOTOS'
  | 'LINE_ITEM_BEFORE_PHOTOS'
  | 'UNSET';

export type OdProtosHomeworkServices_BrnRepairItemTokenRequestInput = {
  brnRepairItemToken?: InputMaybe<Scalars['String']>;
};

export type OdProtosHomeworkServices_ChangeAddressRequestInput = {
  newAddressId?: InputMaybe<Scalars['String']>;
  oldAddressId?: InputMaybe<Scalars['String']>;
  projectIds?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosHomeworkServices_CommenceWorkOrderRequestInput = {
  workOrderId?: InputMaybe<Scalars['String']>;
};

export type OdProtosHomeworkServices_CompleteLineItemRequestInput = {
  lineItemId?: InputMaybe<Scalars['String']>;
};

export type OdProtosHomeworkServices_CompleteReworkRequestInput = {
  reworkId?: InputMaybe<Scalars['String']>;
};

export type OdProtosHomeworkServices_CreateChangeOrderRequestInput = {
  /** The associated project [required] */
  projectId?: InputMaybe<Scalars['String']>;
};

export type OdProtosHomeworkServices_CreateLineItemRequestInput = {
  /**
   * Computed field, setting this field will only set account if it cannot be
   * computed
   */
  account?: InputMaybe<Scalars['String']>;
  areaId?: InputMaybe<Scalars['String']>;
  associatedWith?: InputMaybe<OdProtosHomeworkServices_CreateLineItemRequest_AssociatedWithOneofInput>;
  brnRepairItemToken?: InputMaybe<Scalars['String']>;
  /** Deprecated */
  changeOrderId?: InputMaybe<Scalars['String']>;
  defectId?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  featureId?: InputMaybe<Scalars['String']>;
  laborCost?: InputMaybe<OdProtosHomeworkData_LineItemScope_LaborCostInput>;
  materialCost?: InputMaybe<OdProtosHomeworkData_LineItemScope_MaterialCostInput>;
  prefillId?: InputMaybe<Scalars['String']>;
  /**
   * Computed field, setting this field will only set account if it cannot be
   * computed
   */
  repairIssue?: InputMaybe<Scalars['String']>;
  repairScopeToken?: InputMaybe<Scalars['String']>;
  requirementId?: InputMaybe<Scalars['String']>;
};

export type OdProtosHomeworkServices_CreateLineItemRequest_AssociatedWithOneofInput = {
  projectId?: InputMaybe<Scalars['String']>;
  workOrderId?: InputMaybe<Scalars['String']>;
};

export type OdProtosHomeworkServices_CreateLineItemScopeRequestInput = {
  cancelledAt?: InputMaybe<Scalars['DateTime']>;
  /** Optionally associate this scope with a change order */
  changeOrderId?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  laborCost?: InputMaybe<OdProtosHomeworkData_LineItemScope_LaborCostInput>;
  lineItemId?: InputMaybe<Scalars['String']>;
  /** Construction manager fields */
  managerAcceptedAt?: InputMaybe<Scalars['DateTime']>;
  materialCost?: InputMaybe<OdProtosHomeworkData_LineItemScope_MaterialCostInput>;
  reason?: InputMaybe<Scalars['String']>;
  skipExternalNotification?: InputMaybe<Scalars['Boolean']>;
  /** Vendor fields */
  vendorAcceptedAt?: InputMaybe<Scalars['DateTime']>;
};

export type OdProtosHomeworkServices_CreateProjectRequestInput = {
  /** Must be a casa address id */
  addressId?: InputMaybe<Scalars['String']>;
  budgetAmountCents?: InputMaybe<Scalars['Float']>;
  /** It is an error to create a project with a NONE project kind */
  kind?: InputMaybe<OdProtosHomeworkData_ProjectKind>;
  managedByBranchId?: InputMaybe<Scalars['String']>;
  managerContactUserToken?: InputMaybe<Scalars['String']>;
  ownedBy?: InputMaybe<OdProtosHomeworkServices_CreateProjectRequest_OwnedByOneofInput>;
  scheduledStartAt?: InputMaybe<Scalars['DateTime']>;
  scheduledStartOn?: InputMaybe<OdProtosCommon_DateInput>;
  scheduledStopAt?: InputMaybe<Scalars['DateTime']>;
  scheduledStopOn?: InputMaybe<OdProtosCommon_DateInput>;
};

export type OdProtosHomeworkServices_CreateProjectRequest_OwnedByOneofInput = {
  /** An branch of an organization owns it */
  branchId?: InputMaybe<Scalars['String']>;
  /** One person owns it */
  humanId?: InputMaybe<Scalars['String']>;
  organizationId?: InputMaybe<Scalars['String']>;
};

/**
 * Create a new project scope request. Homework enforces the rule that
 * signatures may only be supplied by the user they corrispond to. This is
 * pulled from the user token in the context of the request.
 */
export type OdProtosHomeworkServices_CreateProjectScopeRequestInput = {
  /** The budget in this scope */
  budgetAmountCents?: InputMaybe<Scalars['Float']>;
  /** The construction manager who accepted this project scope */
  managerAcceptedAt?: InputMaybe<Scalars['DateTime']>;
  /** The owner of the home who accepted this project scope */
  ownerAcceptedAt?: InputMaybe<Scalars['DateTime']>;
  /** The project that this scope is attached to */
  projectId?: InputMaybe<Scalars['String']>;
  scheduledStartAt?: InputMaybe<Scalars['DateTime']>;
  scheduledStartOn?: InputMaybe<OdProtosCommon_DateInput>;
  scheduledStopAt?: InputMaybe<Scalars['DateTime']>;
  scheduledStopOn?: InputMaybe<OdProtosCommon_DateInput>;
};

export type OdProtosHomeworkServices_CreateReworkRequestInput = {
  lineItemId?: InputMaybe<Scalars['String']>;
  reason?: InputMaybe<Scalars['String']>;
};

export type OdProtosHomeworkServices_CreateWorkOrderRequestInput = {
  accountingBuckets?: InputMaybe<Array<Scalars['String']>>;
  addressId?: InputMaybe<Scalars['String']>;
  assignedToBranchId?: InputMaybe<Scalars['String']>;
  budgetAmountCents?: InputMaybe<Scalars['Float']>;
  includeInHcr?: InputMaybe<Scalars['Boolean']>;
  /** Metadata */
  kind?: InputMaybe<OdProtosHomeworkData_WorkOrder_Kind>;
  managedByBranchId?: InputMaybe<Scalars['String']>;
  managerContactUserToken?: InputMaybe<Scalars['String']>;
  /** Use this field to mark the work order as finalized [optional] */
  managerFinalizedAt?: InputMaybe<Scalars['DateTime']>;
  managerId?: InputMaybe<Scalars['String']>;
  messageThreadId?: InputMaybe<Scalars['String']>;
  onSiteMessageThreadId?: InputMaybe<Scalars['String']>;
  projectId?: InputMaybe<Scalars['String']>;
  referenceNumber?: InputMaybe<Scalars['String']>;
  scheduledStartAt?: InputMaybe<Scalars['DateTime']>;
  scheduledStartOn?: InputMaybe<OdProtosCommon_DateInput>;
  /** deprecated */
  scheduledStopAt?: InputMaybe<Scalars['DateTime']>;
  scheduledStopOn?: InputMaybe<OdProtosCommon_DateInput>;
  vendorManagerId?: InputMaybe<Scalars['String']>;
};

export type OdProtosHomeworkServices_CreateWorkOrderScopeRequestInput = {
  budgetAmountCents?: InputMaybe<Scalars['Float']>;
  managerAcceptedAt?: InputMaybe<Scalars['DateTime']>;
  reason?: InputMaybe<Scalars['String']>;
  scheduledStartAt?: InputMaybe<Scalars['DateTime']>;
  scheduledStartOn?: InputMaybe<OdProtosCommon_DateInput>;
  scheduledStopAt?: InputMaybe<Scalars['DateTime']>;
  scheduledStopOn?: InputMaybe<OdProtosCommon_DateInput>;
  vendorAcceptedAt?: InputMaybe<Scalars['DateTime']>;
  workOrderId?: InputMaybe<Scalars['String']>;
};

export type OdProtosHomeworkServices_EnrollReitRenovationRequestInput = {
  address?: InputMaybe<OdProtosCasaServices_CasaRequest_FindByFieldsInput>;
  /** Notes to be added to the visit created during enrollment. */
  dayOneWalkVisitNotes?: InputMaybe<Scalars['String']>;
  initialBudgetCents?: InputMaybe<Scalars['Float']>;
  lockboxCode?: InputMaybe<Scalars['String']>;
  reitOrgId?: InputMaybe<Scalars['String']>;
  scheduledStartOn?: InputMaybe<OdProtosCommon_DateInput>;
  /**
   * Square footage of all livable area including finished basement sqft.
   * If REITs give us the square footage we should use the data they give us.
   */
  totalLivingSqFt?: InputMaybe<Scalars['Float']>;
};

export type OdProtosHomeworkServices_FinalizeAndAcceptWorkOrderRequestInput = {
  workOrderId?: InputMaybe<Scalars['String']>;
};

export type OdProtosHomeworkServices_FinalizeWorkOrderRequestInput = {
  workOrderId?: InputMaybe<Scalars['String']>;
};

export type OdProtosHomeworkServices_ForceDeleteWorkOrderRequestInput = {
  workOrderId?: InputMaybe<Scalars['String']>;
};

export type OdProtosHomeworkServices_ForceUpdateLineItemScopeRequestInput = {
  cancelledAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  laborCost?: InputMaybe<OdProtosHomeworkData_LineItemScope_LaborCostInput>;
  materialCost?: InputMaybe<OdProtosHomeworkData_LineItemScope_MaterialCostInput>;
  reason?: InputMaybe<Scalars['String']>;
};

export type OdProtosHomeworkServices_GetAlertThresholdRequestInput = {
  entity?: InputMaybe<OdProtosHomeworkData_AlertThresholdEntity>;
  marketIdentifier?: InputMaybe<OdProtosCommonMarket_Market>;
};

export type OdProtosHomeworkServices_GetWorkOrderByReferenceNumberRequestInput = {
  referenceNumber?: InputMaybe<Scalars['String']>;
};

export type OdProtosHomeworkServices_GetWorkOrderMessageThreadsRequestInput = {
  workOrderId?: InputMaybe<Scalars['String']>;
};

export type OdProtosHomeworkServices_IdentifierListRequestInput = {
  ids?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosHomeworkServices_IdentifierRequestInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type OdProtosHomeworkServices_LineItemAccountCategoryValueInput = {
  value?: InputMaybe<OdProtosHomeworkData_LineItem_AccountCategory>;
};

export type OdProtosHomeworkServices_ManagerApproveLineItemScopeRequestInput = {
  lineItemScopeId?: InputMaybe<Scalars['String']>;
};

export type OdProtosHomeworkServices_ManagerRejectLineItemScopeRequestInput = {
  lineItemScopeId?: InputMaybe<Scalars['String']>;
};

export type OdProtosHomeworkServices_MaybeFinalizeChangeOrdersRequestInput = {
  projectIds?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosHomeworkServices_PostToWorkOrderMessageThreadRequestInput = {
  content?: InputMaybe<Scalars['String']>;
  newStatus?: InputMaybe<OdProtosHomeworkData_MessageThreadStatus>;
  /** if false will use the regular message thread. */
  useOnsiteMessageThread?: InputMaybe<Scalars['Boolean']>;
  workOrderId?: InputMaybe<Scalars['String']>;
};

export type OdProtosHomeworkServices_ProposeLineItemCancellationRequestInput = {
  /** The time of the cancellation [required] */
  cancelledAt?: InputMaybe<Scalars['DateTime']>;
  /** The id of the line item to cancel [required] */
  id?: InputMaybe<Scalars['String']>;
  /** The time the manager accepted [optional] */
  managerAcceptedAt?: InputMaybe<Scalars['DateTime']>;
  /** The reason for the cancellation [required] */
  reason?: InputMaybe<Scalars['String']>;
  /** The time the vendor accepted [optional] */
  vendorAcceptedAt?: InputMaybe<Scalars['DateTime']>;
};

export type OdProtosHomeworkServices_ProposeLineItemRequestInput = {
  /**
   * Computed field, setting this field will only set account if it cannot be
   * computed
   */
  account?: InputMaybe<Scalars['String']>;
  accountType?: InputMaybe<OdProtosHomeworkData_LineItem_AccountCategory>;
  areaId?: InputMaybe<Scalars['String']>;
  associatedWith?: InputMaybe<OdProtosHomeworkServices_ProposeLineItemRequest_AssociatedWithOneofInput>;
  defectId?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  featureId?: InputMaybe<Scalars['String']>;
  laborCost?: InputMaybe<OdProtosHomeworkData_LineItemScope_LaborCostInput>;
  managerAcceptedAt?: InputMaybe<Scalars['DateTime']>;
  materialCost?: InputMaybe<OdProtosHomeworkData_LineItemScope_MaterialCostInput>;
  noBeforePhotoReason?: InputMaybe<Scalars['String']>;
  prefillId?: InputMaybe<Scalars['String']>;
  prefillPriceMismatchComment?: InputMaybe<Scalars['String']>;
  prefillPriceMismatchReason?: InputMaybe<Scalars['String']>;
  /**
   * Computed field, setting this field will only set account if it cannot be
   * computed
   */
  repairIssue?: InputMaybe<Scalars['String']>;
  repairScopeToken?: InputMaybe<Scalars['String']>;
  vendorAcceptedAt?: InputMaybe<Scalars['DateTime']>;
  workOrderId?: InputMaybe<Scalars['String']>;
};

export type OdProtosHomeworkServices_ProposeLineItemRequest_AssociatedWithOneofInput = {
  associatedWithProjectId?: InputMaybe<Scalars['String']>;
  associatedWithWorkOrderId?: InputMaybe<Scalars['String']>;
};

export type OdProtosHomeworkServices_ProposeLineItemScopeRequestInput = {
  /** Use ProposeLineItemCancellation instead */
  cancelledAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  laborCost?: InputMaybe<OdProtosHomeworkData_LineItemScope_LaborCostInput>;
  lineItemId?: InputMaybe<Scalars['String']>;
  managerAcceptedAt?: InputMaybe<Scalars['DateTime']>;
  materialCost?: InputMaybe<OdProtosHomeworkData_LineItemScope_MaterialCostInput>;
  reason?: InputMaybe<Scalars['String']>;
  vendorAcceptedAt?: InputMaybe<Scalars['DateTime']>;
};

export type OdProtosHomeworkServices_ProposeWorkOrderScopeRequestInput = {
  managerAcceptedAt?: InputMaybe<Scalars['DateTime']>;
  reason?: InputMaybe<Scalars['String']>;
  scheduledStartOn?: InputMaybe<OdProtosCommon_DateInput>;
  scheduledStopOn?: InputMaybe<OdProtosCommon_DateInput>;
  vendorAcceptedAt?: InputMaybe<Scalars['DateTime']>;
  workOrderId?: InputMaybe<Scalars['String']>;
};

export type OdProtosHomeworkServices_ReassignWorkOrderRequestInput = {
  assignedToBranchId?: InputMaybe<Scalars['String']>;
  workOrderId?: InputMaybe<Scalars['String']>;
};

export type OdProtosHomeworkServices_RejectWorkOrderRequestInput = {
  reason?: InputMaybe<Scalars['String']>;
  workOrderId?: InputMaybe<Scalars['String']>;
};

export type OdProtosHomeworkServices_SearchLineItemsRequestInput = {
  /** filter_sets are OR'd with each other */
  filterSets?: InputMaybe<Array<OdProtosHomeworkData_LineItemFilterSetInput>>;
  orderings?: InputMaybe<Array<OdProtosHomeworkData_LineItemOrderingInput>>;
  pagination?: InputMaybe<OdProtosCommonPagination_PaginationRequestInput>;
};

export type OdProtosHomeworkServices_SearchProjectsRequestInput = {
  /**
   * filter_sets are OR'd together (each one consists of a bunch of AND'd
   * filters, so the search can be pretty expressive).
   */
  filterSets?: InputMaybe<Array<OdProtosHomeworkData_ProjectFilterSetInput>>;
  orderings?: InputMaybe<Array<OdProtosHomeworkData_ProjectOrderingInput>>;
  pagination?: InputMaybe<OdProtosCommonPagination_PaginationRequestInput>;
};

export type OdProtosHomeworkServices_SearchWorkOrdersByStatesRequestInput = {
  /** Optional, no age limit if empty */
  earliestCreationTime?: InputMaybe<Scalars['DateTime']>;
  excludedStates?: InputMaybe<Array<OdProtosHomeworkData_WorkOrder_State>>;
  /** If true only expanded_work_orders are returned */
  expandWorkOrders?: InputMaybe<Scalars['Boolean']>;
  /** State filter, use one or the other */
  includedStates?: InputMaybe<Array<OdProtosHomeworkData_WorkOrder_State>>;
  pagination?: InputMaybe<OdProtosCommonPagination_OffsetPaginationRequestInput>;
};

export type OdProtosHomeworkServices_SearchWorkOrdersRequestInput = {
  /** assigned_field_user_ids are AND'd to all provided filters */
  assignedFieldUserIds?: InputMaybe<Array<Scalars['String']>>;
  /** If true only expanded_work_orders are returned */
  expandWorkOrders?: InputMaybe<Scalars['Boolean']>;
  /** filter_sets are OR'd with each other */
  filterSets?: InputMaybe<Array<OdProtosHomeworkData_WorkOrderFilterSetInput>>;
  /** manager_ids AND'd to all provided filters */
  managerIds?: InputMaybe<Array<Scalars['String']>>;
  orderings?: InputMaybe<Array<OdProtosHomeworkData_WorkOrderOrderingInput>>;
  pagination?: InputMaybe<OdProtosCommonPagination_PaginationRequestInput>;
  /** unclaimed AND'd to all provided filters */
  unclaimedWorkOrders?: InputMaybe<Scalars['Boolean']>;
};

export type OdProtosHomeworkServices_SignatureRequestInput = {
  decision?: InputMaybe<OdProtosHomeworkServices_SignatureRequest_DecisionOneofInput>;
};

export type OdProtosHomeworkServices_SignatureRequest_DecisionOneofInput = {
  acceptedAt?: InputMaybe<Scalars['DateTime']>;
  rejectedAt?: InputMaybe<Scalars['DateTime']>;
};

export type OdProtosHomeworkServices_SubmitChangeOrderRequestInput = {
  changeOrderId?: InputMaybe<Scalars['String']>;
  submittedAt?: InputMaybe<Scalars['DateTime']>;
};

export type OdProtosHomeworkServices_UnassignLineItemsCancelWorkOrderRequestInput = {
  projectId?: InputMaybe<Scalars['String']>;
  workOrderId?: InputMaybe<Scalars['String']>;
};

export type OdProtosHomeworkServices_UncompleteLineItemRequestInput = {
  lineItemId?: InputMaybe<Scalars['String']>;
};

export type OdProtosHomeworkServices_UncompleteReworkRequestInput = {
  reworkId?: InputMaybe<Scalars['String']>;
};

export type OdProtosHomeworkServices_UnenrollReitRenovationRequestInput = {
  projectId?: InputMaybe<Scalars['String']>;
};

export type OdProtosHomeworkServices_UpdateChangeOrderRequestInput = {
  /**
   * When the change order was finalized
   * an error will be returned if the change order
   * has already been finalized [optional]
   * Only a construction manager can finalize a change order
   */
  finalizedAt?: InputMaybe<Scalars['DateTime']>;
  /** The change order's id [required] */
  id?: InputMaybe<Scalars['String']>;
  /**
   * When the change order was submitted
   * an error will be returned if the change order
   * has already been submitted [optional]
   * Only a construction manager can submit a change order
   */
  submittedAt?: InputMaybe<Scalars['DateTime']>;
};

export type OdProtosHomeworkServices_UpdateLineItemRequestInput = {
  account?: InputMaybe<Scalars['String']>;
  accountCategory?: InputMaybe<OdProtosHomeworkServices_LineItemAccountCategoryValueInput>;
  areaId?: InputMaybe<Scalars['String']>;
  /** Vendor can update these fields */
  assignedOnSiteWorkerId?: InputMaybe<Scalars['String']>;
  associatedWith?: InputMaybe<OdProtosHomeworkServices_UpdateLineItemRequest_AssociatedWithOneofInput>;
  /** Deprecated */
  changeOrderId?: InputMaybe<Scalars['String']>;
  costToken?: InputMaybe<Scalars['String']>;
  defectId?: InputMaybe<Scalars['String']>;
  featureId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  invalidatedAt?: InputMaybe<Scalars['DateTime']>;
  noBeforePhotoReason?: InputMaybe<Scalars['String']>;
  prefillId?: InputMaybe<Scalars['String']>;
  prefillPriceMismatchComment?: InputMaybe<Scalars['String']>;
  prefillPriceMismatchReason?: InputMaybe<Scalars['String']>;
  repairIssue?: InputMaybe<Scalars['String']>;
  repairScopeToken?: InputMaybe<Scalars['String']>;
  requirementId?: InputMaybe<Scalars['String']>;
  unsetAssociatedWith?: InputMaybe<Scalars['Boolean']>;
  unsetBrnRepairItemToken?: InputMaybe<Scalars['Boolean']>;
  unsetInvalidatedAt?: InputMaybe<Scalars['Boolean']>;
  unsetValidatedAt?: InputMaybe<Scalars['Boolean']>;
  unsetVendorCompletedAt?: InputMaybe<Scalars['Boolean']>;
  /** Construction manager can update these fields */
  validatedAt?: InputMaybe<Scalars['DateTime']>;
  vendorCompletedAt?: InputMaybe<Scalars['DateTime']>;
};

export type OdProtosHomeworkServices_UpdateLineItemRequest_AssociatedWithOneofInput = {
  projectId?: InputMaybe<Scalars['String']>;
  workOrderId?: InputMaybe<Scalars['String']>;
};

export type OdProtosHomeworkServices_UpdateLineItemScopeRequestInput = {
  cancelledAt?: InputMaybe<Scalars['DateTime']>;
  /** Optionally associate this scope with a change order */
  changeOrderId?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  laborCost?: InputMaybe<OdProtosHomeworkData_LineItemScope_LaborCostInput>;
  /** Construction manager fields */
  managerSignatureRequest?: InputMaybe<OdProtosHomeworkServices_SignatureRequestInput>;
  materialCost?: InputMaybe<OdProtosHomeworkData_LineItemScope_MaterialCostInput>;
  reason?: InputMaybe<Scalars['String']>;
  /**
   * Vendor fields
   * We will allow the construction manager to set this field
   * temporarily
   */
  vendorSignatureRequest?: InputMaybe<OdProtosHomeworkServices_SignatureRequestInput>;
};

export type OdProtosHomeworkServices_UpdateProjectRequestInput = {
  addressId?: InputMaybe<Scalars['String']>;
  budgetAmountCents?: InputMaybe<Scalars['Float']>;
  cancelledAt?: InputMaybe<Scalars['DateTime']>;
  completedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  /** If kind = NONE (the default), no update is made */
  kind?: InputMaybe<OdProtosHomeworkData_ProjectKind>;
  lastMarkedSeenAt?: InputMaybe<Scalars['DateTime']>;
  managedByBranchId?: InputMaybe<Scalars['String']>;
  managerContactUserToken?: InputMaybe<Scalars['String']>;
  ownedBy?: InputMaybe<OdProtosHomeworkServices_UpdateProjectRequest_OwnedByOneofInput>;
  scheduledStartAt?: InputMaybe<Scalars['DateTime']>;
  scheduledStartOn?: InputMaybe<OdProtosCommon_DateInput>;
  scheduledStopAt?: InputMaybe<Scalars['DateTime']>;
  scheduledStopOn?: InputMaybe<OdProtosCommon_DateInput>;
  unsetCancelledAt?: InputMaybe<Scalars['Boolean']>;
};

export type OdProtosHomeworkServices_UpdateProjectRequest_OwnedByOneofInput = {
  /** An branch of an organization owns it */
  branchId?: InputMaybe<Scalars['String']>;
  /** One person owns it */
  humanId?: InputMaybe<Scalars['String']>;
  organizationId?: InputMaybe<Scalars['String']>;
};

export type OdProtosHomeworkServices_UpdateProjectScopeRequestInput = {
  /** The budget in this scope */
  budgetAmountCents?: InputMaybe<Scalars['Float']>;
  /** The id of the project scope to update */
  id?: InputMaybe<Scalars['String']>;
  /** The manager who accepted/rejected this project scope on behalf of Opendoor */
  managerSignatureRequest?: InputMaybe<OdProtosHomeworkServices_SignatureRequestInput>;
  /** The owner of the home who accepted/rejected this project scope */
  ownerSignatureRequest?: InputMaybe<OdProtosHomeworkServices_SignatureRequestInput>;
  scheduledStartAt?: InputMaybe<Scalars['DateTime']>;
  scheduledStartOn?: InputMaybe<OdProtosCommon_DateInput>;
  scheduledStopAt?: InputMaybe<Scalars['DateTime']>;
  scheduledStopOn?: InputMaybe<OdProtosCommon_DateInput>;
};

export type OdProtosHomeworkServices_UpdateReworkRequestInput = {
  id?: InputMaybe<Scalars['String']>;
  invalidatedAt?: InputMaybe<Scalars['DateTime']>;
  reason?: InputMaybe<Scalars['String']>;
  unsetInvalidatedAt?: InputMaybe<Scalars['Boolean']>;
  unsetValidatedAt?: InputMaybe<Scalars['Boolean']>;
  unsetVendorCompletedAt?: InputMaybe<Scalars['Boolean']>;
  /** Construction manager can update these fields */
  validatedAt?: InputMaybe<Scalars['DateTime']>;
  /** Vendor can update these fields */
  vendorCompletedAt?: InputMaybe<Scalars['DateTime']>;
};

export type OdProtosHomeworkServices_UpdateVendorManagerRequestInput = {
  unsetVendorManagerId?: InputMaybe<Scalars['Boolean']>;
  vendorManagerId?: InputMaybe<Scalars['String']>;
  workOrderId?: InputMaybe<Scalars['String']>;
};

export type OdProtosHomeworkServices_UpdateWorkOrderRequestInput = {
  accountingBuckets?: InputMaybe<OdProtosHomeworkServices_AccountingBucketListInput>;
  accountingClosedAt?: InputMaybe<Scalars['DateTime']>;
  /** Construction manager can update these fields */
  addressId?: InputMaybe<Scalars['String']>;
  assignedToBranchId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  includeInHcr?: InputMaybe<Scalars['Boolean']>;
  kind?: InputMaybe<OdProtosHomeworkServices_WorkOrderKindValueInput>;
  /** only construction manager can update this field */
  managerContactUserToken?: InputMaybe<Scalars['String']>;
  managerFinalizedAt?: InputMaybe<Scalars['DateTime']>;
  managerId?: InputMaybe<Scalars['String']>;
  messageThreadId?: InputMaybe<Scalars['String']>;
  onSiteMessageThreadId?: InputMaybe<Scalars['String']>;
  referenceNumber?: InputMaybe<Scalars['String']>;
  unsetManagerFinalizedAt?: InputMaybe<Scalars['Boolean']>;
  unsetManagerId?: InputMaybe<Scalars['Boolean']>;
  /** TODO: allow editing of project_id? */
  unsetVendorCommencedAt?: InputMaybe<Scalars['Boolean']>;
  unsetVendorManagerId?: InputMaybe<Scalars['Boolean']>;
  /** Vendor can update these fields */
  vendorCommencedAt?: InputMaybe<Scalars['DateTime']>;
  vendorManagerId?: InputMaybe<Scalars['String']>;
};

export type OdProtosHomeworkServices_UpdateWorkOrderScopeRequestInput = {
  budgetAmountCents?: InputMaybe<Scalars['Float']>;
  id?: InputMaybe<Scalars['String']>;
  /** Construction manager fields */
  managerSignatureRequest?: InputMaybe<OdProtosHomeworkServices_SignatureRequestInput>;
  reason?: InputMaybe<Scalars['String']>;
  scheduledStartAt?: InputMaybe<Scalars['DateTime']>;
  scheduledStartOn?: InputMaybe<OdProtosCommon_DateInput>;
  scheduledStopAt?: InputMaybe<Scalars['DateTime']>;
  scheduledStopOn?: InputMaybe<OdProtosCommon_DateInput>;
  /** Vendor fields */
  vendorSignatureRequest?: InputMaybe<OdProtosHomeworkServices_SignatureRequestInput>;
};

export type OdProtosHomeworkServices_WorkOrderKindValueInput = {
  value?: InputMaybe<OdProtosHomeworkData_WorkOrder_Kind>;
};

/** Only value aggregations are supported for now */
export type OdProtosIndextriousData_AggregationInput = {
  field?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  /**
   * By default, the terms aggregation returns the top 1000 terms with the most documents.
   * Use the size parameter to return more terms, up to the search.max_buckets limit (65536).
   */
  size?: InputMaybe<Scalars['Float']>;
  subAggregations?: InputMaybe<Array<OdProtosIndextriousData_AggregationInput>>;
  topHits?: InputMaybe<OdProtosIndextriousData_Aggregation_TopHitsInput>;
};

export type OdProtosIndextriousData_Aggregation_TopHitsInput = {
  size?: InputMaybe<Scalars['Float']>;
  sortBy?: InputMaybe<Array<OdProtosIndextriousData_SortByInput>>;
};

export type OdProtosIndextriousData_CashPlusStatus =
  | 'CASH_PLUS_STATUS_FALSE'
  | 'CASH_PLUS_STATUS_NOT_APPLICABLE'
  | 'CASH_PLUS_STATUS_TRUE'
  | 'CASH_PLUS_STATUS_UNKNOWN';

export type OdProtosIndextriousData_FilterInput = {
  value?: InputMaybe<OdProtosIndextriousData_Filter_ValueOneofInput>;
};

export type OdProtosIndextriousData_Filter_AndFilterInput = {
  filters?: InputMaybe<Array<OdProtosIndextriousData_FilterInput>>;
  /** Name of the filter. Useful for front end to identify the filter when it needs to be reset. */
  name?: InputMaybe<Scalars['String']>;
};

export type OdProtosIndextriousData_Filter_FieldExistsInput = {
  value?: InputMaybe<OdProtosIndextriousData_Filter_FieldExists_ValueOneofInput>;
};

export type OdProtosIndextriousData_Filter_FieldExists_ValueOneofInput = {
  field?: InputMaybe<Scalars['String']>;
  nestedField?: InputMaybe<Scalars['String']>;
};

export type OdProtosIndextriousData_Filter_FieldNotExistsInput = {
  value?: InputMaybe<OdProtosIndextriousData_Filter_FieldNotExists_ValueOneofInput>;
};

export type OdProtosIndextriousData_Filter_FieldNotExists_ValueOneofInput = {
  field?: InputMaybe<Scalars['String']>;
  nestedField?: InputMaybe<Scalars['String']>;
};

export type OdProtosIndextriousData_Filter_MultiFieldInput = {
  fields?: InputMaybe<Array<Scalars['String']>>;
  operand?: InputMaybe<OdProtosIndextriousData_Filter_OperandInput>;
  operator?: InputMaybe<OdProtosIndextriousData_Filter_Operator>;
};

/**
 * NotFilter is a special case of AndFilter with only one filter.
 * It is used to negate the filter.
 */
export type OdProtosIndextriousData_Filter_NotFilterInput = {
  filters?: InputMaybe<Array<OdProtosIndextriousData_FilterInput>>;
  /** Name of the filter. Useful for front end to identify the filter when it needs to be reset. */
  name?: InputMaybe<Scalars['String']>;
};

export type OdProtosIndextriousData_Filter_OperandInput = {
  value?: InputMaybe<OdProtosIndextriousData_Filter_Operand_ValueOneofInput>;
};

export type OdProtosIndextriousData_Filter_Operand_ArrayValueInput = {
  value?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosIndextriousData_Filter_Operand_GeoBoundingBoxValueInput = {
  bottomRight?: InputMaybe<OdProtosIndextriousData_GeoPointInput>;
  topLeft?: InputMaybe<OdProtosIndextriousData_GeoPointInput>;
};

export type OdProtosIndextriousData_Filter_Operand_GeoDistanceValueInput = {
  distance?: InputMaybe<Scalars['String']>;
  origin?: InputMaybe<OdProtosIndextriousData_GeoPointInput>;
};

export type OdProtosIndextriousData_Filter_Operand_GeoPolygonValueInput = {
  vertices?: InputMaybe<Array<OdProtosIndextriousData_GeoPointInput>>;
};

export type OdProtosIndextriousData_Filter_Operand_RangeValueInput = {
  gte?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  /** time_zone parameter is an UTC offset used to convert date values to UTC */
  timeZone?: InputMaybe<Scalars['String']>;
};

export type OdProtosIndextriousData_Filter_Operand_ValueOneofInput = {
  arrayValue?: InputMaybe<OdProtosIndextriousData_Filter_Operand_ArrayValueInput>;
  geoBoundingBoxValue?: InputMaybe<OdProtosIndextriousData_Filter_Operand_GeoBoundingBoxValueInput>;
  geoDistanceValue?: InputMaybe<OdProtosIndextriousData_Filter_Operand_GeoDistanceValueInput>;
  geoPolygonValue?: InputMaybe<OdProtosIndextriousData_Filter_Operand_GeoPolygonValueInput>;
  rangeValue?: InputMaybe<OdProtosIndextriousData_Filter_Operand_RangeValueInput>;
  stringValue?: InputMaybe<Scalars['String']>;
};

export type OdProtosIndextriousData_Filter_Operator =
  | 'EQUALS'
  /** GEO_BOUNDING_BOX is used to find documents with geo-points within a bounding box. */
  | 'GEO_BOUNDING_BOX'
  /** GEO_DISTANCE is used to find documents with geo-points within a certain distance of a central point. */
  | 'GEO_DISTANCE'
  /** GEO_POLYGON is used to find documents with geo-points within a polygon. */
  | 'GEO_POLYGON'
  | 'IN'
  | 'LIKE'
  | 'NOT_EQUALS'
  /**
   * PHRASE_PREFIX is used to match the beginning of a phrase. It also enforce the order of the words in the phrase.
   * For example, the phrase prefix query for "quick brown" will match documents with "quick brown fox" but not "brown fox quick".
   */
  | 'PHRASE_PREFIX'
  /**
   * PREFIX is used to match the beginning of a text. It does not enforce the order of the words in the text.
   * For example, the prefix query for "quick brown" will match documents with "quick brown fox" and "brown fox quick".
   */
  | 'PREFIX'
  | 'RANGE';

export type OdProtosIndextriousData_Filter_OrFilterInput = {
  filters?: InputMaybe<Array<OdProtosIndextriousData_FilterInput>>;
  /** Name of the filter. Useful for front end to identify the filter when it needs to be reset. */
  name?: InputMaybe<Scalars['String']>;
};

export type OdProtosIndextriousData_Filter_SingleFieldInput = {
  field?: InputMaybe<Scalars['String']>;
  operand?: InputMaybe<OdProtosIndextriousData_Filter_OperandInput>;
  operator?: InputMaybe<OdProtosIndextriousData_Filter_Operator>;
};

export type OdProtosIndextriousData_Filter_ValueOneofInput = {
  /**
   * To nest multiple 'and' filters within an 'or' filter
   * Note: By default all the *root* level filters are 'and' filters
   */
  and?: InputMaybe<OdProtosIndextriousData_Filter_AndFilterInput>;
  exists?: InputMaybe<OdProtosIndextriousData_Filter_FieldExistsInput>;
  multi?: InputMaybe<OdProtosIndextriousData_Filter_MultiFieldInput>;
  not?: InputMaybe<OdProtosIndextriousData_Filter_NotFilterInput>;
  notExists?: InputMaybe<OdProtosIndextriousData_Filter_FieldNotExistsInput>;
  or?: InputMaybe<OdProtosIndextriousData_Filter_OrFilterInput>;
  single?: InputMaybe<OdProtosIndextriousData_Filter_SingleFieldInput>;
};

export type OdProtosIndextriousData_GeoPointInput = {
  lat?: InputMaybe<Scalars['Float']>;
  lon?: InputMaybe<Scalars['Float']>;
};

export type OdProtosIndextriousData_Index =
  | 'ADDRESS'
  | 'BUYER_PROPERTY'
  | 'CUSTOMER'
  /** This field is deprecated. Use the 'document-reviews' index present as a child of the 'fulfillment' index instead. */
  | 'DOCUMENT'
  | 'FULFILLMENT'
  | 'HODOR'
  | 'HUMAN'
  | 'LISTING'
  | 'LISTING_OFFER'
  | 'LWCLISTING'
  | 'NOTE'
  | 'OPERATOR'
  | 'ORGANIZATION'
  | 'PROPERTY'
  | 'RENOVATION'
  | 'SELLER_LEAD'
  | 'SELL_DIRECT_OFFER'
  | 'SHOWING'
  | 'TASK'
  | 'TICKET'
  | 'TOUR_REQUEST'
  | 'TRADE_PARTNER_WORK_ORDER';

export type OdProtosIndextriousData_IndexRequestInput = {
  /** ID of the doc to index */
  id?: InputMaybe<Scalars['String']>;
  /** Index name of the doc to index */
  index?: InputMaybe<OdProtosIndextriousData_Index>;
  /** Set only if the index needs to be done synchronously. Should not be required for the most scenarios. */
  sync?: InputMaybe<Scalars['Boolean']>;
};

/** Listing data entry states */
export type OdProtosIndextriousData_ListingDataEntryState =
  | 'LISTING_DATA_ENTRY_COMPLETE'
  | 'LISTING_DATA_ENTRY_ESCALATED'
  | 'LISTING_DATA_ENTRY_INCOMPLETE';

/** listing photos state */
export type OdProtosIndextriousData_ListingPhotosState =
  | 'LISTING_PHOTOS_COMPLETED'
  | 'LISTING_PHOTOS_DELAYED'
  | 'LISTING_PHOTOS_PENDING'
  | 'LISTING_PHOTOS_SCHEDULED'
  | 'LISTING_PHOTOS_UNKNOWN';

/** listing price state */
export type OdProtosIndextriousData_ListingPriceState =
  | 'LISTING_PRICE_DELAYED'
  | 'LISTING_PRICE_PENDING'
  | 'LISTING_PRICE_RECEIVED'
  | 'LISTING_PRICE_UNKNOWN';

/** Listing Task states */
export type OdProtosIndextriousData_ListingTaskState =
  | 'TASK_CREATED'
  | 'TASK_SCHEDULED'
  | 'TASK_SENT'
  | 'TASK_UNKNOWN';

export type OdProtosIndextriousData_MigrateIndexRequestInput = {
  /**
   * If set to true, will auto promote the index after migration.
   * NOTE: if schema only is set to true, auto promotion won't happen.
   * It is done to reduce chances of any accidental index drops
   */
  autoPromote?: InputMaybe<Scalars['Boolean']>;
  index?: InputMaybe<OdProtosIndextriousData_Index>;
  /**
   * If set to true, will skip existing docs and migrate the scehma only.
   * Otherwise will migrate the schema and index existing docs with new schema.
   */
  schemaOnly?: InputMaybe<Scalars['Boolean']>;
};

export type OdProtosIndextriousData_MilestoneStatus =
  | 'CLOSE'
  | 'OPEN';

export type OdProtosIndextriousData_MlsTaskStatus =
  | 'COMPLETED_TASK_STATUS'
  | 'COMPLETED_WITH_ERROR_TASK_STATUS'
  | 'CONFIRMED_COMPLETED_TASK_STATUS'
  | 'DISCREPANCY_DETECTED_TASK_STATUS'
  | 'FATAL_TASK_STATUS'
  | 'MANUALLY_RESOLVED_TASK_STATUS'
  | 'PENDING_TASK_STATUS'
  | 'UNKNOWN_TASK_STATUS'
  | 'UNSUPPORTED_TASK_STATUS';

export type OdProtosIndextriousData_PageParamsInput = {
  /** 0 indexed page number */
  number?: InputMaybe<Scalars['Float']>;
  /** Number of items per page */
  size?: InputMaybe<Scalars['Float']>;
};

/** photo approval states */
export type OdProtosIndextriousData_PhotoReviewState =
  | 'PHOTO_REVIEW_ACCEPTED'
  | 'PHOTO_REVIEW_DELAYED'
  | 'PHOTO_REVIEW_INCOMPLETE'
  | 'PHOTO_REVIEW_REJECTED';

export type OdProtosIndextriousData_PromoteIndexRequestInput = {
  index?: InputMaybe<OdProtosIndextriousData_Index>;
};

export type OdProtosIndextriousData_RankingFunctionInput = {
  /** Boost mode is used to define how the computed score is combined with the score of the original query. Defaults to multiply. */
  boostMode?: InputMaybe<OdProtosIndextriousData_RankingFunction_BoostMode>;
  functions?: InputMaybe<Array<OdProtosIndextriousData_RankingFunction_FunctionInput>>;
  /** Score mode is used to aggregate the score of the functions. Defaults to multiply. */
  scoreMode?: InputMaybe<OdProtosIndextriousData_RankingFunction_Function_ScoreMode>;
};

export type OdProtosIndextriousData_RankingFunction_BoostMode =
  | 'AVG'
  | 'MAX'
  | 'MIN'
  /** default */
  | 'MULTIPLY'
  /** only function score is used, the query score is ignored */
  | 'REPLACE'
  | 'SUM';

export type OdProtosIndextriousData_RankingFunction_FunctionInput = {
  filter?: InputMaybe<OdProtosIndextriousData_FilterInput>;
  weight?: InputMaybe<Scalars['Float']>;
};

export type OdProtosIndextriousData_RankingFunction_Function_ScoreMode =
  | 'AVG'
  /** the first function that has a matching filter is applied */
  | 'FIRST'
  | 'MAX'
  | 'MIN'
  /** default */
  | 'MULTIPLY'
  | 'SUM';

export type OdProtosIndextriousData_ReIndexRequestInput = {
  filters?: InputMaybe<Array<OdProtosIndextriousData_FilterInput>>;
  /** Index name to re-index docs */
  index?: InputMaybe<OdProtosIndextriousData_Index>;
};

/** setup visit State */
export type OdProtosIndextriousData_SetupVisitState =
  | 'SETUP_VISIT_COMPLETED'
  | 'SETUP_VISIT_PENDING'
  | 'SETUP_VISIT_SCHEDULED'
  | 'SETUP_VISIT_UNKNOWN';

export type OdProtosIndextriousData_Sla_SlaType =
  | 'RESOLUTION';

export type OdProtosIndextriousData_SortByInput = {
  /** Needs to be set only for descending orders as default ordering is ascending */
  desc?: InputMaybe<Scalars['Boolean']>;
  field?: InputMaybe<Scalars['String']>;
  /** Specifies the order of items that are missing the above field. By default the order is LAST. */
  missing?: InputMaybe<OdProtosIndextriousData_SortBy_Missing>;
};

export type OdProtosIndextriousData_SortBy_Missing =
  | 'FIRST'
  | 'LAST';

export type OdProtosIndextriousServices_BackfillIndexRequestInput = {
  ids?: InputMaybe<OdProtosIndextriousServices_BackfillIndexRequest_IdsOneofInput>;
  index?: InputMaybe<OdProtosIndextriousData_Index>;
};

export type OdProtosIndextriousServices_BackfillIndexRequest_IdsAsStringListInput = {
  values?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosIndextriousServices_BackfillIndexRequest_IdsOneofInput = {
  idsFromFile?: InputMaybe<Scalars['String']>;
  stringIds?: InputMaybe<OdProtosIndextriousServices_BackfillIndexRequest_IdsAsStringListInput>;
};

export type OdProtosIndextriousServices_DeleteIndexRequestInput = {
  index?: InputMaybe<Scalars['String']>;
};

export type OdProtosIndextriousServices_FulfillmentSearchRequestInput = {
  aggregations?: InputMaybe<Array<OdProtosIndextriousData_AggregationInput>>;
  filters?: InputMaybe<Array<OdProtosIndextriousData_FilterInput>>;
  page?: InputMaybe<OdProtosIndextriousData_PageParamsInput>;
  /**
   * If custom ranking is needed, use this field to specify the filters and ranking functions.
   * This gets applied before any sort_by options that are specified.
   */
  ranking?: InputMaybe<OdProtosIndextriousData_RankingFunctionInput>;
  sortBy?: InputMaybe<Array<OdProtosIndextriousData_SortByInput>>;
};

export type OdProtosIndextriousServices_GetIndexSchemaRequestInput = {
  index?: InputMaybe<OdProtosIndextriousData_Index>;
};

export type OdProtosIndextriousServices_HodorSearchRequestInput = {
  aggregations?: InputMaybe<Array<OdProtosIndextriousData_AggregationInput>>;
  filters?: InputMaybe<Array<OdProtosIndextriousData_FilterInput>>;
  page?: InputMaybe<OdProtosIndextriousData_PageParamsInput>;
  /**
   * If custom ranking is needed, use this field to specify the filters and ranking functions.
   * This gets applied before any sort_by options that are specified.
   */
  ranking?: InputMaybe<OdProtosIndextriousData_RankingFunctionInput>;
  sortBy?: InputMaybe<Array<OdProtosIndextriousData_SortByInput>>;
};

export type OdProtosIndextriousServices_ListAliasesRequestInput = {
  _empty?: InputMaybe<Scalars['Boolean']>;
};

export type OdProtosIndextriousServices_ListIndexesRequestInput = {
  _empty?: InputMaybe<Scalars['Boolean']>;
};

export type OdProtosIndextriousServices_OperatorSearchRequestInput = {
  aggregations?: InputMaybe<Array<OdProtosIndextriousData_AggregationInput>>;
  filters?: InputMaybe<Array<OdProtosIndextriousData_FilterInput>>;
  page?: InputMaybe<OdProtosIndextriousData_PageParamsInput>;
  /**
   * If custom ranking is needed, use this field to specify the filters and ranking functions.
   * This gets applied before any sort_by options that are specified.
   */
  ranking?: InputMaybe<OdProtosIndextriousData_RankingFunctionInput>;
  sortBy?: InputMaybe<Array<OdProtosIndextriousData_SortByInput>>;
};

export type OdProtosIndextriousServices_PruneIndexRequestInput = {
  index?: InputMaybe<OdProtosIndextriousData_Index>;
};

export type OdProtosIndextriousServices_RenovationSearchRequestInput = {
  aggregations?: InputMaybe<Array<OdProtosIndextriousData_AggregationInput>>;
  filters?: InputMaybe<Array<OdProtosIndextriousData_FilterInput>>;
  page?: InputMaybe<OdProtosIndextriousData_PageParamsInput>;
  /**
   * If custom ranking is needed, use this field to specify the filters and ranking functions.
   * This gets applied before any sort_by options that are specified.
   */
  ranking?: InputMaybe<OdProtosIndextriousData_RankingFunctionInput>;
  sortBy?: InputMaybe<Array<OdProtosIndextriousData_SortByInput>>;
};

export type OdProtosIndextriousServices_SearchAddressesRequestInput = {
  aggregations?: InputMaybe<Array<OdProtosIndextriousData_AggregationInput>>;
  filters?: InputMaybe<Array<OdProtosIndextriousData_FilterInput>>;
  page?: InputMaybe<OdProtosIndextriousData_PageParamsInput>;
  ranking?: InputMaybe<OdProtosIndextriousData_RankingFunctionInput>;
  sortBy?: InputMaybe<Array<OdProtosIndextriousData_SortByInput>>;
};

export type OdProtosIndextriousServices_SearchIdsRequestInput = {
  filters?: InputMaybe<Array<OdProtosIndextriousData_FilterInput>>;
  indexes?: InputMaybe<Array<OdProtosIndextriousData_Index>>;
};

export type OdProtosIndextriousServices_SearchIndicesRequestInput = {
  aggregations?: InputMaybe<Array<OdProtosIndextriousData_AggregationInput>>;
  filters?: InputMaybe<Array<OdProtosIndextriousData_FilterInput>>;
  indexes?: InputMaybe<Array<OdProtosIndextriousData_Index>>;
  page?: InputMaybe<OdProtosIndextriousData_PageParamsInput>;
  /**
   * If custom ranking is needed, use this field to specify the filters and ranking functions.
   * This gets applied before any sort_by options that are specified.
   */
  ranking?: InputMaybe<OdProtosIndextriousData_RankingFunctionInput>;
  sortBy?: InputMaybe<Array<OdProtosIndextriousData_SortByInput>>;
};

export type OdProtosIndextriousServices_SearchTradePartnerWorkOrderRequestInput = {
  aggregations?: InputMaybe<Array<OdProtosIndextriousData_AggregationInput>>;
  filters?: InputMaybe<Array<OdProtosIndextriousData_FilterInput>>;
  page?: InputMaybe<OdProtosIndextriousData_PageParamsInput>;
  /**
   * If custom ranking is needed, use this field to specify the filters and ranking functions.
   * This gets applied before any sort_by options that are specified.
   */
  ranking?: InputMaybe<OdProtosIndextriousData_RankingFunctionInput>;
  sortBy?: InputMaybe<Array<OdProtosIndextriousData_SortByInput>>;
};

export type OdProtosIndextriousServices_SellDirectOfferSearchRequestInput = {
  aggregations?: InputMaybe<Array<OdProtosIndextriousData_AggregationInput>>;
  filters?: InputMaybe<Array<OdProtosIndextriousData_FilterInput>>;
  page?: InputMaybe<OdProtosIndextriousData_PageParamsInput>;
  /**
   * If custom ranking is needed, use this field to specify the filters and ranking functions.
   * This gets applied before any sort_by options that are specified.
   */
  ranking?: InputMaybe<OdProtosIndextriousData_RankingFunctionInput>;
  sortBy?: InputMaybe<Array<OdProtosIndextriousData_SortByInput>>;
};

export type OdProtosIndextriousServices_SwitchAliasRequestInput = {
  /** alias name to switch index for */
  alias?: InputMaybe<Scalars['String']>;
  /** new index name to alias */
  index?: InputMaybe<Scalars['String']>;
};

export type OdProtosIndextriousServices_TaskSearchRequestInput = {
  aggregations?: InputMaybe<Array<OdProtosIndextriousData_AggregationInput>>;
  filters?: InputMaybe<Array<OdProtosIndextriousData_FilterInput>>;
  page?: InputMaybe<OdProtosIndextriousData_PageParamsInput>;
  /**
   * If custom ranking is needed, use this field to specify the filters and ranking functions.
   * This gets applied before any sort_by options that are specified.
   */
  ranking?: InputMaybe<OdProtosIndextriousData_RankingFunctionInput>;
  sortBy?: InputMaybe<Array<OdProtosIndextriousData_SortByInput>>;
};

export type OdProtosIndextriousServices_TicketSearchRequestInput = {
  aggregations?: InputMaybe<Array<OdProtosIndextriousData_AggregationInput>>;
  filters?: InputMaybe<Array<OdProtosIndextriousData_FilterInput>>;
  page?: InputMaybe<OdProtosIndextriousData_PageParamsInput>;
  /**
   * If custom ranking is needed, use this field to specify the filters and ranking functions.
   * This gets applied before any sort_by options that are specified.
   */
  ranking?: InputMaybe<OdProtosIndextriousData_RankingFunctionInput>;
  sortBy?: InputMaybe<Array<OdProtosIndextriousData_SortByInput>>;
};

/**
 * UserIdentifier represents the identifier that the insight service uses
 * to determine the user.
 * Next ID: 3
 */
export type OdProtosInsightData_UserIdentifierInput = {
  userIdentifier?: InputMaybe<OdProtosInsightData_UserIdentifier_UserIdentifierOneofInput>;
};

export type OdProtosInsightData_UserIdentifier_UserIdentifierOneofInput = {
  anonymousId?: InputMaybe<Scalars['String']>;
  customerUuid?: InputMaybe<Scalars['String']>;
};

/** Next ID: 3 */
export type OdProtosInsightServices_InsightRequests_CheckUserAudiencesInput = {
  audiences?: InputMaybe<Array<Scalars['String']>>;
  user?: InputMaybe<OdProtosInsightData_UserIdentifierInput>;
};

/** Next ID: 4 */
export type OdProtosInsightServices_InsightRequests_ListAudienceMemberIDsInput = {
  audience?: InputMaybe<Scalars['String']>;
  /**
   * cursor should be null when getting the first page of results and it should contain
   * the returned cursor on subsequent requests.
   */
  cursor?: InputMaybe<Scalars['String']>;
  /** limit cannot be greater than 1000. If limit is 0 then it will be set to the default of 100. */
  limit?: InputMaybe<Scalars['Float']>;
};

/**
 * Identifier represents the identifier that the insight service uses
 * to determine what entity to select
 * Next ID: 4
 */
export type OdProtosInsightV2Data_IdentifierInput = {
  identifier?: InputMaybe<OdProtosInsightV2Data_Identifier_IdentifierOneofInput>;
};

export type OdProtosInsightV2Data_Identifier_CustomerInput = {
  identifier?: InputMaybe<OdProtosInsightV2Data_Identifier_Customer_IdentifierOneofInput>;
};

export type OdProtosInsightV2Data_Identifier_Customer_IdentifierOneofInput = {
  anonymousId?: InputMaybe<Scalars['String']>;
  customerUuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosInsightV2Data_Identifier_IdentifierOneofInput = {
  customerIdentifier?: InputMaybe<OdProtosInsightV2Data_Identifier_CustomerInput>;
  leadIdentifier?: InputMaybe<OdProtosInsightV2Data_Identifier_LeadInput>;
  propertyIdentifier?: InputMaybe<OdProtosInsightV2Data_Identifier_PropertyInput>;
};

export type OdProtosInsightV2Data_Identifier_LeadInput = {
  identifier?: InputMaybe<OdProtosInsightV2Data_Identifier_Lead_IdentifierOneofInput>;
};

export type OdProtosInsightV2Data_Identifier_Lead_IdentifierOneofInput = {
  leadId?: InputMaybe<Scalars['String']>;
  sellerInputId?: InputMaybe<Scalars['String']>;
  sellerLeadUuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosInsightV2Data_Identifier_PropertyInput = {
  identifier?: InputMaybe<OdProtosInsightV2Data_Identifier_Property_IdentifierOneofInput>;
};

export type OdProtosInsightV2Data_Identifier_Property_IdentifierOneofInput = {
  addressToken?: InputMaybe<Scalars['String']>;
};

/** Next ID: 4 */
export type OdProtosInsightV2Services_GetMapValueForKeyRequestInput = {
  identifier?: InputMaybe<OdProtosInsightV2Data_IdentifierInput>;
  key?: InputMaybe<Scalars['String']>;
  traitName?: InputMaybe<Scalars['String']>;
};

/** Next ID: 3 */
export type OdProtosInsightV2Services_GetTraitForIdentifierRequestInput = {
  identifier?: InputMaybe<OdProtosInsightV2Data_IdentifierInput>;
  traitName?: InputMaybe<Scalars['String']>;
};

/** Next ID: 3 */
export type OdProtosInsightV2Services_GetTraitsForIdentifierRequestInput = {
  identifier?: InputMaybe<OdProtosInsightV2Data_IdentifierInput>;
  traitNames?: InputMaybe<Array<Scalars['String']>>;
};

/** Next ID: 3 */
export type OdProtosInsightV2Services_ResetTraitForIdentifierRequestInput = {
  identifier?: InputMaybe<OdProtosInsightV2Data_IdentifierInput>;
  /** A nil trait_name will reset all traits */
  traitName?: InputMaybe<Scalars['String']>;
};

export type OdProtosInstitutionsData_Activity_Type =
  | 'BID_UPLOAD'
  | 'BULK_DOWNLOAD'
  | 'MLS_DOWNLOAD'
  | 'TAPE_DOWNLOAD'
  | 'UNKNOWN_TYPE';

export type OdProtosInstitutionsData_Alert_AlertType =
  | 'GUARDRAIL'
  | 'UNKNOWN_ALERT_TYPE';

export type OdProtosInstitutionsData_AuctionType =
  | 'AGENT_SOURCED'
  | 'BWODA'
  | 'DIRECT_SELLER'
  | 'HOME_BUILDER'
  | 'LISTED'
  | 'OD_EXCLUSIVES'
  | 'OD_SOURCED'
  | 'OUT_OF_BUYBOX'
  | 'OX_LISTING'
  | 'PRE_LIST'
  | 'UNKNOWN_TYPE'
  | 'WALK';

export type OdProtosInstitutionsData_BidAction =
  | 'BUYER_ACCEPTS'
  | 'BUYER_ACCEPTS_UPDATE'
  | 'BUYER_ADDITIONAL_DETAILS_UPDATE'
  | 'BUYER_COUNTERS'
  | 'BUYER_COUNTERS_HIGHEST_AND_BEST'
  | 'BUYER_SIGNS'
  | 'BUYER_WITHDRAWS'
  | 'OD_ACCEPTS'
  | 'OD_REJECTS'
  | 'OD_SENDS_CONTRACT'
  | 'PROCESS_INVENTORY_BID'
  | 'PROCESS_OBS_BID'
  | 'RECHECK_ELIGIBILITY'
  | 'REINSTATE_BID'
  | 'SELLER_ACCEPTS_INVENTORY_BID'
  | 'SELLER_ACCEPTS_INVENTORY_COUNTER'
  | 'SELLER_ACCEPTS_INVENTORY_HIGHEST_AND_BEST'
  | 'SELLER_ACCEPTS_OBS_BID'
  | 'SELLER_ACCEPTS_OBS_COUNTER'
  | 'SELLER_ACCEPTS_OBS_HIGHEST_AND_BEST'
  | 'SELLER_ACCEPTS_UPDATED_OFFER'
  | 'SELLER_COUNTERS'
  | 'SELLER_COUNTERS_COUNTER'
  | 'SELLER_COUNTERS_HIGHEST_AND_BEST'
  | 'SELLER_REJECTS'
  | 'SELLER_REJECTS_COUNTER'
  | 'SELLER_REJECTS_HIGHEST_AND_BEST'
  | 'SELLER_SENDS_ADDITIONAL_DETAILS'
  | 'SELLER_SENDS_CONTRACT'
  | 'SELLER_SIGNS'
  | 'SEND_PROPERTY_FLAGS'
  | 'TERMINATE_CONTRACT'
  | 'UNKNOWN_ACTION';

/**
 * The initial bid state is product specific:
 * (*) Resale - AWAITING_SELLER_OFFER_EVALUATION
 * (*) BwODA - AWAITING_OD_TO_SEND_CONTRACT
 * (*) OBS - AWAITING_OD_OFFER_EVALUATION
 */
export type OdProtosInstitutionsData_BidState =
  | 'AWAITING_ADDITIONAL_DETAILS_FROM_SELLER'
  | 'AWAITING_BUYER_ADDITIONAL_HOME_DETAIL_EVALUATION'
  | 'AWAITING_BUYER_COUNTER_EVALUATION'
  | 'AWAITING_BUYER_HIGHEST_AND_BEST_EVALUATION'
  | 'AWAITING_BUYER_OFFER_EVALUATION'
  | 'AWAITING_BUYER_REJECTION_EVALUATION'
  | 'AWAITING_BUYER_SIGNATURE'
  | 'AWAITING_OD_OFFER_EVALUATION'
  | 'AWAITING_OD_TO_SEND_CONTRACT'
  | 'AWAITING_SELLER_COUNTER_EVALUATION'
  | 'AWAITING_SELLER_HIGHEST_AND_BEST_EVALUATION'
  | 'AWAITING_SELLER_OFFER_EVALUATION'
  | 'AWAITING_SELLER_SIGNATURE'
  | 'AWAITING_SELLER_TO_SEND_CONTRACT'
  | 'AWAITING_SELLER_UPDATED_OFFER_EVALUATION'
  | 'BID_RECEIVED'
  | 'BUYER_WITHDRAWN'
  | 'CLEAR_TO_CLOSE'
  | 'CLOSED'
  | 'COUNTERED'
  | 'COUNTERED_HIGHEST_AND_BEST'
  | 'DRAFT'
  | 'IN_CONTRACT'
  | 'LATE_CHECKOUT'
  | 'LOST'
  | 'OD_REJECTED'
  /** The following bid states are deprecated and are not actively used anymore. */
  | 'PENDING'
  | 'PENDING_CLOSE'
  | 'SELLER_REJECTED'
  | 'TERMINATED'
  | 'UNKNOWN_STATE'
  | 'WON';

/** commission structure will differ from normal bwoda procedure if there is a referral */
export type OdProtosInstitutionsData_Bid_ReferralSourcedBy =
  | 'BUYER'
  | 'OPENDOOR'
  | 'UNKNOWN_REFERRAL_TYPE';

export type OdProtosInstitutionsData_Bid_SubmissionInfoInput = {
  escrowCompanyOrganizationId?: InputMaybe<Scalars['String']>;
  referralSourcedBy?: InputMaybe<OdProtosInstitutionsData_Bid_ReferralSourcedBy>;
  titleCompanyOrganizationId?: InputMaybe<Scalars['String']>;
};

/** go live dates for products */
export type OdProtosInstitutionsData_BrokerageRegion_LaunchDatesInput = {
  bwoda?: InputMaybe<OdProtosCommon_DateInput>;
  listed?: InputMaybe<OdProtosCommon_DateInput>;
  prelist?: InputMaybe<OdProtosCommon_DateInput>;
};

export type OdProtosInstitutionsData_BrokerageRegion_PreferencesInput = {
  /** e.g. Austin, TX */
  displayName?: InputMaybe<Scalars['String']>;
  /** composite of city and state e.g. austin_tx */
  identifier?: InputMaybe<Scalars['String']>;
  launchDates?: InputMaybe<OdProtosInstitutionsData_BrokerageRegion_LaunchDatesInput>;
  listingMlsList?: InputMaybe<Array<OdProtosInstitutionsData_MlsInput>>;
  /** managed by backend for now, TODO: update mls_list to be modified by UI */
  mlsList?: InputMaybe<Array<OdProtosCommonMls_Mls>>;
};

export type OdProtosInstitutionsData_Buybox_CriteriaInput = {
  allowPrivatePools?: InputMaybe<Scalars['Boolean']>;
  bathrooms?: InputMaybe<OdProtosInstitutionsData_Buybox_Criteria_FloatRangeInput>;
  bedrooms?: InputMaybe<OdProtosInstitutionsData_Buybox_Criteria_IntRangeInput>;
  dwellingTypes?: InputMaybe<Array<Scalars['String']>>;
  estimatedCurrentYieldPct?: InputMaybe<OdProtosInstitutionsData_Buybox_Criteria_FloatRangeInput>;
  guidancePrice?: InputMaybe<OdProtosInstitutionsData_Buybox_Criteria_IntRangeInput>;
  minYearBuilt?: InputMaybe<Scalars['Int']>;
  postalCodes?: InputMaybe<Array<Scalars['String']>>;
  sqFt?: InputMaybe<OdProtosInstitutionsData_Buybox_Criteria_IntRangeInput>;
};

export type OdProtosInstitutionsData_Buybox_Criteria_FloatRangeInput = {
  gte?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
};

/** use wrappers when a field is nullable */
export type OdProtosInstitutionsData_Buybox_Criteria_IntRangeInput = {
  gte?: InputMaybe<Scalars['Int']>;
  lte?: InputMaybe<Scalars['Int']>;
};

/**
 * The date preference manages a specific RelativeDate (for CH) or date field
 * for a bid.
 */
export type OdProtosInstitutionsData_DatePreferenceInput = {
  dayType?: InputMaybe<OdProtosInstitutionsData_DatePreference_DayType>;
  /** Date preference is this many days from an anchor. */
  days?: InputMaybe<Scalars['Float']>;
};

export type OdProtosInstitutionsData_DatePreference_DayType =
  /** Mon-Fri excluding national holidays. */
  | 'BUSINESS'
  | 'CALENDAR'
  /**
   * Same as calendar days but if the end date is not a business day, go to
   * the next business day
   */
  | 'CALENDAR_ENDING_ON_BUSINESS'
  | 'DAY_TYPE_UNKNOWN';

export type OdProtosInstitutionsData_DateRangeInput = {
  gte?: InputMaybe<OdProtosCommon_DateInput>;
  lt?: InputMaybe<OdProtosCommon_DateInput>;
};

export type OdProtosInstitutionsData_DecisionInput = {
  analystAction?: InputMaybe<Scalars['String']>;
  analystActionDescriptions?: InputMaybe<Scalars['String']>;
  analystActionReasons?: InputMaybe<Scalars['String']>;
  analystSignedOff?: InputMaybe<Scalars['Boolean']>;
  analystSuggestedCloseOfEscrow?: InputMaybe<Scalars['DateTime']>;
  analystSuggestedCounterAmountCents?: InputMaybe<Scalars['Float']>;
  analystSuggestedCounterCommissionPct?: InputMaybe<Scalars['Float']>;
  analystSuggestedDdEndDate?: InputMaybe<Scalars['DateTime']>;
  analystSuggestedEarnestMoneyDepositCents?: InputMaybe<Scalars['Float']>;
  analystSuggestedExpiresAt?: InputMaybe<Scalars['DateTime']>;
  analystSuggestedRejectionCode?: InputMaybe<Scalars['String']>;
  analystSuggestedRejectionDescription?: InputMaybe<Scalars['String']>;
  decisionableType?: InputMaybe<Scalars['String']>;
  decisionableUuid?: InputMaybe<Scalars['String']>;
  imsResponse?: InputMaybe<Scalars['String']>;
  isBackup?: InputMaybe<Scalars['Boolean']>;
  offerDecision?: InputMaybe<Scalars['String']>;
  offerDecisionDescriptions?: InputMaybe<Scalars['String']>;
  offerDecisionReasons?: InputMaybe<Scalars['String']>;
  uuid: Scalars['ID'];
};

export type OdProtosInstitutionsData_Event_Type =
  | 'BID_ASSIGNEE_UPDATED'
  | 'BID_CREATED'
  | 'BID_STATE_UPDATED'
  | 'BID_TAG_CREATED'
  | 'BID_TAG_DELETED'
  | 'BID_UPDATED'
  | 'BROKER_COMMENTS_UPDATED'
  | 'DOCUMENT_CREATED'
  | 'DOCUMENT_EXECUTED'
  | 'DOCUMENT_REVIEWS_CREATED'
  | 'DOCUMENT_REVIEWS_UPDATED'
  | 'DOCUMENT_SIGNED'
  | 'DOCUMENT_STATUS_UPDATED'
  | 'DOCUMENT_UPDATED'
  | 'DOCUMENT_VERSION_CREATED'
  | 'DOCUMENT_VERSION_UPDATED'
  | 'INSPECTION_STATE_UPDATED'
  | 'PARTICIPANT_CREATED'
  | 'PARTICIPANT_UPDATED'
  | 'SIGNATURE_REQUEST_CREATED'
  | 'SIGNATURE_REQUEST_UPDATED'
  | 'TERM_DATE_UPDATED'
  | 'TERM_UPDATED'
  | 'TRANSACTION_CREATED'
  | 'TRANSACTION_UPDATED'
  | 'UNKNOWN_EVENT_TYPE';

/** Next ID: 7 */
export type OdProtosInstitutionsData_ExternalPermission =
  | 'API_DOCUMENTATION_READ'
  | 'BUYBOX_READ'
  | 'BUYBOX_WRITE'
  | 'MLS_READ'
  | 'RENT_ESTIMATE_READ'
  | 'SETTINGS_READ'
  | 'SETTINGS_WRITE'
  | 'UNKNOWN_EXTERNAL_PERMISSION';

export type OdProtosInstitutionsData_HomebuilderLeadInput = {
  addedAt?: InputMaybe<OdProtosCommon_DateInput>;
  availableAt?: InputMaybe<OdProtosCommon_DateInput>;
  bathrooms?: InputMaybe<Scalars['Float']>;
  bedrooms?: InputMaybe<Scalars['Float']>;
  builderName?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  constructionStatus?: InputMaybe<Scalars['String']>;
  currentPriceUsd?: InputMaybe<Scalars['Int']>;
  garageSpaces?: InputMaybe<Scalars['Float']>;
  hasHoa?: InputMaybe<Scalars['Boolean']>;
  hasSeptic?: InputMaybe<Scalars['Boolean']>;
  hasSolarPanels?: InputMaybe<Scalars['Boolean']>;
  hoaMonthlyFeesCents?: InputMaybe<Scalars['Int']>;
  interiorSqFt?: InputMaybe<Scalars['Float']>;
  lot?: InputMaybe<Scalars['String']>;
  market?: InputMaybe<OdProtosCommonMarket_Market>;
  notes?: InputMaybe<Scalars['String']>;
  originalPriceUsd?: InputMaybe<Scalars['Float']>;
  plElevation?: InputMaybe<Scalars['String']>;
  planName?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  propertyType?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  street?: InputMaybe<Scalars['String']>;
  subdivisionProject?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<OdProtosCommon_DateInput>;
  yearBuilt?: InputMaybe<Scalars['Float']>;
};

/** Next ID: 7 */
export type OdProtosInstitutionsData_InspectionState =
  | 'AWAITING_INSPECTION'
  /** for when a reit has marked their inspection complete */
  | 'AWAITING_INSPECTION_COMPLETION'
  /** for when a reit has completed the inspection but we are waiting for them to either counter or release contingencies */
  | 'AWAITING_INSPECTION_RESULTS'
  | 'AWAITING_INSPECTION_SCHEDULED'
  | 'INSPECTION_CONTINGENCY_RELEASED'
  /** we are using AWAITING_INSPECTION instead */
  | 'INSPECTION_SCHEDULED'
  | 'POST_INSPECTION_NEGOTIATION'
  | 'UNKNOWN_INSPECTION_STATE';

/** Next ID: 18 */
export type OdProtosInstitutionsData_InternalPermission =
  | 'ADMIN'
  | 'ADVANCED_UI_FEATURES'
  | 'AGENT_OPERATOR_READ'
  | 'AGENT_OPERATOR_WRITE'
  | 'ELIGIBLE_PRODUCTS_READ'
  | 'ELIGIBLE_PRODUCTS_WRITE'
  | 'KEY_TERMS_READ'
  | 'KEY_TERMS_WRITE'
  | 'MANUAL_BID_UPLOAD_READ'
  | 'MANUAL_BID_UPLOAD_WRITE'
  | 'PARTICIPANTS_READ'
  | 'PARTICIPANTS_WRITE'
  | 'PIPELINE_READ'
  | 'PIPELINE_WRITE'
  | 'RESALE_READ'
  | 'RESALE_WRITE'
  | 'TASK_CONFIG_READ'
  | 'TASK_CONFIG_WRITE'
  | 'TASK_READ'
  | 'TASK_WRITE'
  | 'UNKNOWN_INTERNAL_PERMISSION';

export type OdProtosInstitutionsData_LeadEvent_LeadEventType =
  /** A Lead record is deleted */
  | 'DELETE'
  /** A Lead record is created */
  | 'INSERT'
  /** A Lead record is updated */
  | 'UPDATE';

export type OdProtosInstitutionsData_LeadType =
  | 'LEAD_TYPE_AGENT_SOURCED'
  | 'LEAD_TYPE_BWODA'
  | 'LEAD_TYPE_DIRECT_SELLER'
  | 'LEAD_TYPE_HOME_BUILDER'
  | 'LEAD_TYPE_LISTED'
  | 'LEAD_TYPE_ODLS_MANUAL'
  | 'LEAD_TYPE_OD_EXCLUSIVES'
  | 'LEAD_TYPE_OD_SOURCED'
  | 'LEAD_TYPE_OUT_OF_BUYBOX'
  | 'LEAD_TYPE_PRELIST'
  | 'LEAD_TYPE_UNSPECIFIED'
  | 'LEAD_TYPE_WALK';

export type OdProtosInstitutionsData_Lead_HomeDetails_HoaInput = {
  fee?: InputMaybe<OdProtosCommon_MoneyInput>;
  feeFrequency?: InputMaybe<Scalars['String']>;
  hasLeasingRestriction?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  rules?: InputMaybe<Scalars['String']>;
};

export type OdProtosInstitutionsData_Lead_LeadState =
  /**
   * Lead is actively receiving offers.
   * Terminal: No
   */
  | 'ACTIVE'
  /**
   * A sale has gone through and is now closed.
   * Terminal: Yes.
   */
  | 'CLOSED'
  /** Terminal: No. */
  | 'COMING_SOON'
  /**
   * Lead has expired and is no longer current.
   * Terminal: Yes
   */
  | 'EXPIRED'
  /**
   * Lead is not necessarily on MLS, typically associated with Exclusives.
   * Terminal: No
   */
  | 'PRIVATELY_LISTED'
  /** Terminal: No. */
  | 'SALE_PENDING'
  /** Terminal: No. */
  | 'TEMP_OFF_MARKET'
  | 'UNSPECIFIED_STATE'
  /**
   * Lead is not actively receiving offers.
   * Terminal: Yes
   */
  | 'WITHDRAWN';

export type OdProtosInstitutionsData_Lead_ListingAgentInput = {
  email?: InputMaybe<Scalars['String']>;
  mlsId?: InputMaybe<Scalars['String']>;
  mlsName?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<Scalars['String']>;
};

export type OdProtosInstitutionsData_Lead_NewBuildInfoInput = {
  builderName?: InputMaybe<Scalars['String']>;
  constructionStatus?: InputMaybe<Scalars['String']>;
  isNewBuild?: InputMaybe<Scalars['Boolean']>;
  lot?: InputMaybe<Scalars['String']>;
  plElevation?: InputMaybe<Scalars['String']>;
  planName?: InputMaybe<Scalars['String']>;
  subdivisionProject?: InputMaybe<Scalars['String']>;
};

export type OdProtosInstitutionsData_Lead_SellerInput = {
  email?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
};

export type OdProtosInstitutionsData_MarketSettingsInput = {
  market?: InputMaybe<OdProtosCommonMarket_Market>;
  sellableTypes?: InputMaybe<Array<OdProtosInstitutionsData_Sellable_Type>>;
};

/** These map to member roles in https://admin.opendoor.com/admin/organizations/23960 */
export type OdProtosInstitutionsData_MemberRole =
  /** Role for BPO LSS. */
  | 'BPO_LSS'
  /** Role for the Broker. */
  | 'BROKER'
  /** Role for the Transaction Coordinator. */
  | 'CUSTOMER_EXPERIENCE_PARTNER'
  | 'LICENSED_HOME_ADVISOR'
  /** Role for the Listing Coordinator. */
  | 'LISTING_COORDINATOR'
  | 'OBS_MANAGER'
  /** Role for the Portfolio Manager. */
  | 'PORTFOLIO_MANAGER'
  /** Role for the Pricing Analyst. */
  | 'PRICING_ANALYST'
  /** Role for the Pricing Lead. */
  | 'PRICING_LEAD'
  /** Temporary role that acts similar to CEP and handles inspection scheduling. */
  | 'TRANSACTION_SUPPORT_SPECIALIST'
  | 'UNKNOWN_MEMBER_ROLE';

export type OdProtosInstitutionsData_MlsInput = {
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  shortName?: InputMaybe<Scalars['String']>;
};

export type OdProtosInstitutionsData_MonetaryPreferenceInput = {
  preference?: InputMaybe<OdProtosInstitutionsData_MonetaryPreference_PreferenceOneofInput>;
};

export type OdProtosInstitutionsData_MonetaryPreference_PreferenceOneofInput = {
  amount?: InputMaybe<OdProtosCommon_MoneyInput>;
  /** 0-100 */
  percentage?: InputMaybe<Scalars['Float']>;
};

export type OdProtosInstitutionsData_NegotiationInput = {
  amountCents?: InputMaybe<OdProtosCommon_MoneyInput>;
  bidUuid?: InputMaybe<Scalars['String']>;
  commissionPct?: InputMaybe<Scalars['Float']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy?: InputMaybe<Scalars['String']>;
  /** Deprecated fields */
  deadline?: InputMaybe<OdProtosCommon_DateInput>;
  deadlineDate?: InputMaybe<Scalars['DateTime']>;
  decision?: InputMaybe<OdProtosInstitutionsData_DecisionInput>;
  isBuyerRequested?: InputMaybe<Scalars['Boolean']>;
  listingOfferId?: InputMaybe<Scalars['Float']>;
  offset?: InputMaybe<Scalars['Float']>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/**
 * We need to wrap the oneof inside Permission
 * because protobuf does not support repeated oneof
 */
export type OdProtosInstitutionsData_PermissionsInput = {
  externalPermissions?: InputMaybe<Array<OdProtosInstitutionsData_ExternalPermission>>;
  internalPermissions?: InputMaybe<Array<OdProtosInstitutionsData_InternalPermission>>;
};

/**
 * Reit settings are preferences for specific (or default) reit, brokerage_region, and
 * product type combinations. The final preferences applied to a bid are
 * computed based on the override levels.
 *
 * Override levels:
 *   (0) default reit + default brokerage region
 *   (1) default reit + specific brokerage region
 *   (2) default reit + specific brokerage region + specific product type
 *   (3) specific reit + default brokerage region
 *   (4) specific reit + specific brokerage region
 *   (5) specific reit + specific brokerage region + specific product type
 *
 * Next id: 11
 */
export type OdProtosInstitutionsData_ReitSettingsInput = {
  brokerageRegionId?: InputMaybe<Scalars['Float']>;
  id?: InputMaybe<Scalars['Float']>;
  preferences?: InputMaybe<OdProtosInstitutionsData_ReitSettings_PreferencesInput>;
  reitId?: InputMaybe<Scalars['Float']>;
  sellableType?: InputMaybe<OdProtosInstitutionsData_Sellable_Type>;
  state?: InputMaybe<OdProtosCommonState_State>;
};

/** Next id: 52 */
export type OdProtosInstitutionsData_ReitSettings_PreferencesInput = {
  appraisalContingencyDeadline?: InputMaybe<OdProtosInstitutionsData_DatePreferenceInput>;
  /** The number of days before a previously bid on lead is re-shown in feeds. */
  bidLifetimeDays?: InputMaybe<Scalars['Float']>;
  brokerContact?: InputMaybe<OdProtosInstitutionsReithouseDataCommon_ContactInput>;
  /** Contact information for the default broker and brokerage participants */
  brokerageContact?: InputMaybe<OdProtosInstitutionsReithouseDataCommon_ContactInput>;
  brokerageVendorId?: InputMaybe<Scalars['String']>;
  /** These participant preferences are human token only (for v1). */
  buyerAgent?: InputMaybe<OdProtosInstitutionsData_ReitSettings_Preferences_UserContactInput>;
  /** Contact information for the default buyer agent participant */
  buyerAgentContact?: InputMaybe<OdProtosInstitutionsReithouseDataCommon_ContactInput>;
  buyerCloser?: InputMaybe<OdProtosInstitutionsData_ReitSettings_Preferences_UserContactInput>;
  buyerCredit?: InputMaybe<OdProtosCommon_MoneyInput>;
  buyerInspector?: InputMaybe<OdProtosInstitutionsData_ReitSettings_Preferences_UserContactInput>;
  buyerPrincipal?: InputMaybe<OdProtosInstitutionsData_ReitSettings_Preferences_UserContactInput>;
  buyerReferralCommission?: InputMaybe<OdProtosInstitutionsData_MonetaryPreferenceInput>;
  buyerSignatory?: InputMaybe<OdProtosInstitutionsData_ReitSettings_Preferences_UserContactInput>;
  buyerUnderwriter?: InputMaybe<OdProtosInstitutionsData_ReitSettings_Preferences_UserContactInput>;
  /** Vendor branch ids used in transactions, editable through participants page for now */
  bwodaAgentVendorId?: InputMaybe<Scalars['String']>;
  closeOfEscrow?: InputMaybe<OdProtosInstitutionsData_DatePreferenceInput>;
  /**
   * The conveyances preference is added "as-is" to the transaction terms for
   * a bid.
   */
  conveyances?: InputMaybe<OdProtosInstitutionsReithouseData_ConveyancesInput>;
  /**
   * These freeform preferences are not stored on the bid or transaction,
   * instead are used as reference settings (similar to guardrail preferences).
   */
  customPreferences?: InputMaybe<Array<OdProtosInstitutionsData_ReitSettings_Preferences_CustomPreferenceInput>>;
  /** This is deprecated. Use inspection_contingency_deadline. */
  dueDiligence?: InputMaybe<OdProtosInstitutionsData_DatePreferenceInput>;
  earnestDeposit?: InputMaybe<OdProtosInstitutionsData_ReitSettings_Preferences_EarnestDepositInput>;
  earnestDepositDue?: InputMaybe<OdProtosInstitutionsData_DatePreferenceInput>;
  escrowCompanies?: InputMaybe<Array<OdProtosInstitutionsData_ReitSettings_Preferences_OrganizationContactInput>>;
  escrowCompany?: InputMaybe<OdProtosInstitutionsData_ReitSettings_Preferences_OrganizationContactInput>;
  escrowContact?: InputMaybe<OdProtosInstitutionsData_ReitSettings_Preferences_UserContactInput>;
  /**
   * @TODO Need to remove escrow_contacts and escrow_companies once we removed the escrow_companies
   * @TODO implementation in Institutions.
   * Note: Do not need to migrate escrow_companies data as it has the same data with the escrow_company
   */
  escrowContacts?: InputMaybe<Array<OdProtosInstitutionsData_ReitSettings_Preferences_UserContactInput>>;
  /** Operators will manually configure the escrows on the reit settings page. */
  escrowOrganizationUsers?: InputMaybe<Array<OdProtosInstitutionsData_ReitSettings_Preferences_OrganizationUserContactInput>>;
  financingType?: InputMaybe<OdProtosInstitutionsReithouseData_FinancingTypeInput>;
  inspectionContingencyDeadline?: InputMaybe<OdProtosInstitutionsData_DatePreferenceInput>;
  legalEntityName?: InputMaybe<Scalars['String']>;
  minimumInspectionContingencyDeadlineToCoe?: InputMaybe<OdProtosInstitutionsData_DatePreferenceInput>;
  /**
   * These "guardrail preferences" are not stored on the bid or transaction,
   * instead they are used to produce "guardrail alerts" on the detail view.
   */
  minimumInspectionDateToInspectionContingencyDeadline?: InputMaybe<OdProtosInstitutionsData_DatePreferenceInput>;
  obsAgentVendorId?: InputMaybe<Scalars['String']>;
  /** default commission percentages */
  odaCommission?: InputMaybe<OdProtosInstitutionsData_MonetaryPreferenceInput>;
  odaOperatorBranchId?: InputMaybe<Scalars['String']>;
  offerExpiration?: InputMaybe<OdProtosInstitutionsData_DatePreferenceInput>;
  opendoorReferralCommission?: InputMaybe<OdProtosInstitutionsData_MonetaryPreferenceInput>;
  optionMoney?: InputMaybe<OdProtosInstitutionsData_ReitSettings_Preferences_OptionMoneyInput>;
  oxFee?: InputMaybe<OdProtosInstitutionsData_MonetaryPreferenceInput>;
  oxListingCommission?: InputMaybe<OdProtosInstitutionsData_MonetaryPreferenceInput>;
  propertyFlags?: InputMaybe<OdProtosInstitutionsData_ReitSettings_Preferences_PropertyFlagsInput>;
  resolutionPeriodDeadline?: InputMaybe<OdProtosInstitutionsData_DatePreferenceInput>;
  sellerCredit?: InputMaybe<OdProtosInstitutionsData_MonetaryPreferenceInput>;
  /** This is deprecated. Use inspection_contingency_deadline. */
  terminationOptionPeriod?: InputMaybe<OdProtosInstitutionsData_DatePreferenceInput>;
  titleCompanies?: InputMaybe<Array<OdProtosInstitutionsData_ReitSettings_Preferences_OrganizationContactInput>>;
  titleCompany?: InputMaybe<OdProtosInstitutionsData_ReitSettings_Preferences_OrganizationContactInput>;
  transactionCoordinator?: InputMaybe<OdProtosInstitutionsData_ReitSettings_Preferences_UserContactInput>;
  /**
   * Overrides preferences (at the current level) for any bid on a property
   * that meets the year built condition (i.e. year_built >= 2019).
   */
  yearBuiltOverride?: InputMaybe<OdProtosInstitutionsData_YearBuiltOverrideInput>;
};

export type OdProtosInstitutionsData_ReitSettings_Preferences_CustomPreferenceInput = {
  applicableBidStates?: InputMaybe<Array<OdProtosInstitutionsData_BidState>>;
  message?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type OdProtosInstitutionsData_ReitSettings_Preferences_EarnestDepositInput = {
  nonrefundableAmount?: InputMaybe<OdProtosCommon_MoneyInput>;
  refundableAmount?: InputMaybe<OdProtosCommon_MoneyInput>;
};

export type OdProtosInstitutionsData_ReitSettings_Preferences_OptionMoneyInput = {
  buyerAmount?: InputMaybe<OdProtosCommon_MoneyInput>;
  opendoorAmount?: InputMaybe<OdProtosCommon_MoneyInput>;
};

export type OdProtosInstitutionsData_ReitSettings_Preferences_OrganizationContactInput = {
  organizationId?: InputMaybe<Scalars['String']>;
};

export type OdProtosInstitutionsData_ReitSettings_Preferences_OrganizationUserContactInput = {
  organizationId?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type OdProtosInstitutionsData_ReitSettings_Preferences_PropertyFlagsInput = {
  hoaRestrictions?: InputMaybe<OdProtosInstitutionsData_ReitSettings_Preferences_PropertyFlags_HoaRestrictionsInput>;
  homeCondition?: InputMaybe<OdProtosInstitutionsData_ReitSettings_Preferences_PropertyFlags_HomeConditionInput>;
  homeFeatures?: InputMaybe<OdProtosInstitutionsData_ReitSettings_Preferences_PropertyFlags_HomeFeaturesInput>;
  locationFeatures?: InputMaybe<OdProtosInstitutionsData_ReitSettings_Preferences_PropertyFlags_LocationFeaturesInput>;
  other?: InputMaybe<Scalars['String']>;
  parkingRequirements?: InputMaybe<OdProtosInstitutionsData_ReitSettings_Preferences_PropertyFlags_ParkingRequirementsInput>;
  tenantOccupancy?: InputMaybe<OdProtosInstitutionsData_ReitSettings_Preferences_PropertyFlags_TenantOccupancyInput>;
  titlePreference?: InputMaybe<Scalars['Boolean']>;
};

export type OdProtosInstitutionsData_ReitSettings_Preferences_PropertyFlags_HoaRestrictionsInput = {
  capacityThreshold?: InputMaybe<Scalars['Boolean']>;
  hoaRequirement?: InputMaybe<Scalars['Boolean']>;
  leaseRequirement?: InputMaybe<Scalars['Boolean']>;
};

export type OdProtosInstitutionsData_ReitSettings_Preferences_PropertyFlags_HomeConditionInput = {
  extensiveLandscapeRepair?: InputMaybe<Scalars['Boolean']>;
  foundationIssues?: InputMaybe<Scalars['Boolean']>;
  waterIntrusionDamage?: InputMaybe<Scalars['Boolean']>;
};

export type OdProtosInstitutionsData_ReitSettings_Preferences_PropertyFlags_HomeFeaturesInput = {
  oilTank?: InputMaybe<Scalars['Boolean']>;
  polybutylenePlumbing?: InputMaybe<Scalars['Boolean']>;
  septic?: InputMaybe<Scalars['Boolean']>;
  sharedDriveway?: InputMaybe<Scalars['Boolean']>;
  slopedLots?: InputMaybe<Scalars['Boolean']>;
  solarPanels?: InputMaybe<Scalars['Boolean']>;
  wellWater?: InputMaybe<Scalars['Boolean']>;
};

export type OdProtosInstitutionsData_ReitSettings_Preferences_PropertyFlags_LocationFeaturesInput = {
  busyStreet?: InputMaybe<Scalars['Boolean']>;
  commercialZone?: InputMaybe<Scalars['Boolean']>;
  floodZone?: InputMaybe<Scalars['Boolean']>;
  highCrimeZoneRating?: InputMaybe<Scalars['Boolean']>;
  highVoltageWiresPoles?: InputMaybe<Scalars['Boolean']>;
  lowSchoolZoneRating?: InputMaybe<Scalars['Boolean']>;
  openWater?: InputMaybe<Scalars['Boolean']>;
};

export type OdProtosInstitutionsData_ReitSettings_Preferences_PropertyFlags_ParkingRequirementsInput = {
  attachedGarage?: InputMaybe<Scalars['Boolean']>;
  carport?: InputMaybe<Scalars['Boolean']>;
  coveredParking?: InputMaybe<Scalars['Boolean']>;
  detachedGarage?: InputMaybe<Scalars['Boolean']>;
  pavedDriveway?: InputMaybe<Scalars['Boolean']>;
};

export type OdProtosInstitutionsData_ReitSettings_Preferences_PropertyFlags_TenantOccupancyInput = {
  occupancyInMonths?: InputMaybe<Scalars['Float']>;
  tenant?: InputMaybe<Scalars['Boolean']>;
};

export type OdProtosInstitutionsData_ReitSettings_Preferences_UserContactInput = {
  userId?: InputMaybe<Scalars['String']>;
};

export type OdProtosInstitutionsData_SellableInfoInput = {
  mls?: InputMaybe<OdProtosCommonMls_Mls>;
  /** TODO: migrate onto this field from type, then switch type to be Sellable.Type */
  sellableType?: InputMaybe<OdProtosInstitutionsData_Sellable_Type>;
  sourceType?: InputMaybe<OdProtosRealtyCommon_Source_Type>;
  /**
   * For prelist and inventory, token is the flip token.
   * For direct_seller, out of buybox, and walk, token is the lead token.
   * For bwoda, mls, token (id), and source_type come from the ODLS sell request's source.
   */
  token?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<OdProtosInstitutionsData_AuctionType>;
};

export type OdProtosInstitutionsData_Sellable_Type =
  | 'AGENT_SOURCED'
  | 'BWODA'
  | 'DIRECT_SELLER'
  | 'HOME_BUILDER'
  | 'LISTED'
  | 'OD_EXCLUSIVES'
  | 'OD_SOURCED'
  | 'OUT_OF_BUYBOX'
  | 'OX_LISTING'
  | 'PRE_LIST'
  | 'UNKNOWN_TYPE'
  | 'WALK';

export type OdProtosInstitutionsData_TimestampRangeInput = {
  /** Include results that have been greater than or equal to */
  gte?: InputMaybe<Scalars['DateTime']>;
  /** Include results that have been less than */
  lt?: InputMaybe<Scalars['DateTime']>;
};

export type OdProtosInstitutionsData_UserInput = {
  email?: InputMaybe<Scalars['String']>;
  fullName?: InputMaybe<Scalars['String']>;
  permissions?: InputMaybe<OdProtosInstitutionsData_PermissionsInput>;
  productionApiToken?: InputMaybe<Scalars['String']>;
  readmeUrl?: InputMaybe<Scalars['String']>;
  reitId?: InputMaybe<Scalars['Float']>;
  slackId?: InputMaybe<Scalars['String']>;
  stagingApiToken?: InputMaybe<Scalars['String']>;
  token?: InputMaybe<Scalars['String']>;
};

export type OdProtosInstitutionsData_YearBuiltOverrideInput = {
  gte?: InputMaybe<Scalars['Float']>;
  preferences?: InputMaybe<OdProtosInstitutionsData_ReitSettings_PreferencesInput>;
};

export type OdProtosInstitutionsExternal_BidStatus =
  | 'AWAITING_SIGNATURE'
  | 'CLEAR_TO_CLOSE'
  | 'CLOSED'
  | 'INSPECTION_PERIOD'
  | 'IN_NEGOTIATION'
  | 'LATE_CHECKOUT'
  | 'NEW_OFFER'
  | 'PENDING_CLOSE'
  | 'REJECTED'
  | 'TERMINATED'
  | 'UNKNOWN_BID_STATUS';

/** Tells us when to show this guardrail preference tooltip */
export type OdProtosInstitutionsExternal_GuardrailPreference_Type =
  | 'INSPECTION_CONTINGENCY'
  | 'INSPECTION_SCHEDULE'
  | 'UNKNOWN';

export type OdProtosInstitutionsExternal_NextAction_Type =
  /** deprecated */
  | 'CONFIRM_INSPECTION'
  | 'CONFIRM_INSPECTION_STATUS'
  | 'EVALUATE_DATE_COUNTER'
  | 'EVALUATE_PRICE_COUNTER'
  /** deprecated */
  | 'EVALUATE_TERMS'
  | 'EVALUATE_TERM_COUNTER'
  /** deprecated */
  | 'PROPOSE_INSPECTION'
  /** deprecated */
  | 'PROPOSE_POST_INSPECTION'
  | 'PROPOSE_POST_INSPECTION_NEGOTIATION'
  /** deprecated */
  | 'RELEASE_INSPECTION_CONTINGENCY'
  | 'SCHEDULE_INSPECTION'
  | 'SIGN_DOCUMENTS'
  | 'UNKNOWN_TYPE'
  /** deprecated */
  | 'UPLOAD_DOCUMENTS';

export type OdProtosInstitutionsExternal_NextAction_Urgency =
  | 'HIGH'
  | 'LOW'
  | 'UNKNOWN_URGENCY';

/** Requirement for a document. */
export type OdProtosInstitutionsReithouseDataBrokerage_DocumentRequirementInput = {
  /** Required document class. Implicit: The document must be uploaded. */
  documentDescriptorClass?: InputMaybe<OdProtosRealtyDocumentsData_DocumentDescriptor_Class>;
  transitionRequirements?: InputMaybe<Array<OdProtosInstitutionsReithouseDataBrokerage_DocumentRequirement_TransitionRequirementInput>>;
};

/** Rules for how the document transitions states/is archived */
export type OdProtosInstitutionsReithouseDataBrokerage_DocumentRequirement_TransitionRequirementInput = {
  isRequired?: InputMaybe<Scalars['Boolean']>;
  /** Requires an approved review */
  reviewedByBroker?: InputMaybe<Scalars['Boolean']>;
  /** Both parties must have signed before transition */
  signed?: InputMaybe<Scalars['Boolean']>;
  /** When to check for a required document. */
  when?: InputMaybe<OdProtosInstitutionsReithouseDataBrokerage_DocumentRequirement_TransitionRequirement_WhenOneofInput>;
};

export type OdProtosInstitutionsReithouseDataBrokerage_DocumentRequirement_TransitionRequirement_WhenOneofInput = {
  /** Before a transaction is archived. */
  beforeArchive?: InputMaybe<Scalars['Boolean']>;
  /** Before a transaction transitions to a state. */
  beforeTransitionToState?: InputMaybe<OdProtosInstitutionsReithouseData_Transaction_State>;
};

export type OdProtosInstitutionsReithouseDataBrokerage_DocumentReview_RejectionReason =
  | 'INCORRECT_INFORMATION'
  | 'INFORMATION_NOT_MATCHING'
  | 'MISSING_ADDENDA_AMENDMENT_AFFIDAVIT'
  | 'MISSING_BOX_CHECK'
  | 'MISSING_BROKER_AGENT_INFORMATION'
  | 'MISSING_CLOSING_DATE'
  | 'MISSING_COMMISSION_AMOUNT_NOTATION'
  | 'MISSING_DATE'
  | 'MISSING_DISCLOSURE'
  | 'MISSING_DOCUMENT'
  | 'MISSING_DUE_DILIGENCE_INSPECTION_PERIOD'
  | 'MISSING_ESCROW_GROUP'
  | 'MISSING_INITIALS'
  | 'MISSING_LIST_PURCHASE_PRICE'
  | 'MISSING_PAGE'
  | 'MISSING_PROPERTY_ADDRESS'
  | 'MISSING_PROPERTY_APN_ID_LEGAL_DESCRIPTION'
  | 'MISSING_PRO_RATA_SHARE_INFO'
  | 'MISSING_REFERRAL_AMOUNT_NOTATION'
  | 'MISSING_SIGNATURE'
  | 'OTHER'
  | 'UNKNOWN';

/** Result of document review. */
export type OdProtosInstitutionsReithouseDataBrokerage_DocumentReview_Result =
  | 'APPROVED'
  | 'NONE'
  | 'REJECTED';

export type OdProtosInstitutionsReithouseDataBrokerage_DocumentViolation_Type =
  | 'MISSING_TYPE'
  | 'NOT_REVIEWED_BY_BROKER'
  | 'NOT_SIGNED'
  | 'UNKNOWN';

export type OdProtosInstitutionsReithouseDataBrokerage_RuleInput = {
  type?: InputMaybe<OdProtosInstitutionsReithouseDataBrokerage_Rule_TypeOneofInput>;
};

export type OdProtosInstitutionsReithouseDataBrokerage_Rule_TypeOneofInput = {
  documentRequirement?: InputMaybe<OdProtosInstitutionsReithouseDataBrokerage_DocumentRequirementInput>;
};

/**
 * Brokerage-defined rule set for transactions.
 *
 * Note that transactions also have implicit rules. See Transaction documentation.
 */
export type OdProtosInstitutionsReithouseDataBrokerage_TransactionRuleSetInput = {
  /** Brokerage VendorBranch that owns these transaction requirements. */
  brokerageVendorBranchId?: InputMaybe<Scalars['String']>;
  /** Rules in this rule set. */
  rules?: InputMaybe<Array<OdProtosInstitutionsReithouseDataBrokerage_RuleInput>>;
};

/** The actor doing the thing */
export type OdProtosInstitutionsReithouseDataCommon_ActorInput = {
  /** Deprecated: Use user_id instead. */
  organizationId?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
};

/**
 * Contact records information
 * about a contact. Person, organization, customer etc.
 */
export type OdProtosInstitutionsReithouseDataCommon_ContactInput = {
  address?: InputMaybe<OdProtosCommonData_AddressInput>;
  customerId?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  legalName?: InputMaybe<Scalars['String']>;
  license?: InputMaybe<OdProtosBrokeragesData_RealEstateLicenseInput>;
  mlsId?: InputMaybe<OdProtosBrokeragesData_MlsidInput>;
  name?: InputMaybe<Scalars['String']>;
  organizationId?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  phoneNumbers?: InputMaybe<Array<OdProtosInstitutionsReithouseDataCommon_PhoneNumberInput>>;
  userId?: InputMaybe<Scalars['String']>;
  vendorBranchId?: InputMaybe<Scalars['String']>;
};

/** An ID issued by an MLS. */
export type OdProtosInstitutionsReithouseDataCommon_MlsidInput = {
  id?: InputMaybe<Scalars['String']>;
  mls?: InputMaybe<OdProtosCommonMls_Mls>;
};

export type OdProtosInstitutionsReithouseDataCommon_PhoneNumberInput = {
  description?: InputMaybe<Scalars['String']>;
  number?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<OdProtosInstitutionsReithouseDataCommon_PhoneNumber_Type>;
};

export type OdProtosInstitutionsReithouseDataCommon_PhoneNumber_Type =
  | 'FAX'
  | 'HOME'
  | 'MOBILE'
  | 'OTHER'
  | 'WORK';

/** A specific version of an ID. */
export type OdProtosInstitutionsReithouseDataCommon_VersionedIdInput = {
  id?: InputMaybe<Scalars['String']>;
  version?: InputMaybe<Scalars['Float']>;
};

/** Additional amount of earnest money and its due date (NC only) */
export type OdProtosInstitutionsReithouseData_AdditionalEarnestDepositInput = {
  amount?: InputMaybe<OdProtosCommon_MoneyInput>;
  due?: InputMaybe<OdProtosCommon_DateInput>;
};

/** Date an appraiser estimates the property value for the lender. */
export type OdProtosInstitutionsReithouseData_AppraisalDateInput = {
  date?: InputMaybe<OdProtosCommon_DateInput>;
};

export type OdProtosInstitutionsReithouseData_AssetInput = {
  location?: InputMaybe<OdProtosInstitutionsReithouseData_Asset_LocationOneofInput>;
};

export type OdProtosInstitutionsReithouseData_Asset_LocationOneofInput = {
  cabinetAssetId?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

/** Broker commission. */
export type OdProtosInstitutionsReithouseData_BrokerCommissionInput = {
  commission?: InputMaybe<OdProtosInstitutionsReithouseData_BrokerCommission_CommissionOneofInput>;
};

export type OdProtosInstitutionsReithouseData_BrokerCommission_CommissionOneofInput = {
  amount?: InputMaybe<OdProtosCommon_MoneyInput>;
  /** 0-100 */
  percentage?: InputMaybe<Scalars['Float']>;
};

export type OdProtosInstitutionsReithouseData_ClearinghouseSpecificInput = {
  /** hellorito template id */
  helloritoTemplateId?: InputMaybe<Scalars['String']>;
  /** List of CH terms that this document includes */
  includedChTerms?: InputMaybe<Array<OdProtosInstitutionsReithouseData_ClearinghouseSpecific_ClearinghouseTerm>>;
  /** whether document is needed in order to archive in Clearinghouse */
  isRequiredForChArchive?: InputMaybe<Scalars['Boolean']>;
  /** List of CH transaction states in which a document needs broker review. */
  needsBrokerReviewInChStates?: InputMaybe<Array<OdProtosInstitutionsReithouseData_ClearinghouseSpecific_ClearinghouseState>>;
  /** If set to NONE, document is not required in clearinghouse */
  requiredForChState?: InputMaybe<OdProtosInstitutionsReithouseData_ClearinghouseSpecific_ClearinghouseState>;
  /** List of fields needed to generate this document */
  templateFields?: InputMaybe<Array<OdProtosInstitutionsReithouseData_TemplateFieldDescriptorInput>>;
};

/**
 * these values needs to correspond to od_protos.institutions.reithouse.data.Transaction.State
 * in order for DocConfig and Reithouse to understand each other
 */
export type OdProtosInstitutionsReithouseData_ClearinghouseSpecific_ClearinghouseState =
  | 'CLOSED'
  | 'DISCARDED'
  | 'DRAFT'
  | 'IN_CONTRACT'
  | 'LATE_CHECKOUT'
  /** NONE indicates that no state is chosen */
  | 'NONE'
  | 'OPEN'
  | 'PRELIST'
  | 'REJECTED'
  | 'TERMINATED'
  | 'UNKNOWN_STATE';

/**
 * these values needs to correspond to od_protos.institutions.reithouse.data.TermType.Type
 * in order for DocConfig and Reithouse to understand each other
 */
export type OdProtosInstitutionsReithouseData_ClearinghouseSpecific_ClearinghouseTerm =
  | 'ADDITIONAL_EARNEST_DEPOSIT'
  | 'APPRAISAL_CONTINGENCY'
  | 'APPRAISAL_DATE'
  | 'BUYER_BROKER_COMMISSION'
  | 'CLOSE_OF_ESCROW_DATE'
  | 'CONTINGENCY'
  | 'CONTRACT_EXPIRATION'
  | 'CONVEYANCES'
  | 'EARNEST_DEPOSIT'
  | 'EARNEST_DEPOSIT_DUE'
  | 'FINANCING_CONTINGENCY'
  | 'FINANCING_TYPE'
  | 'FUNDING_RELATED_DELAYS'
  | 'INSPECTION_CONTINGENCY'
  | 'INSPECTION_SCHEDULE'
  | 'LAND_SURVEY_REQUIREMENT'
  | 'OPENDOOR_COMMISSION'
  | 'OX_FEE'
  | 'PRICE'
  | 'RENT_BACK'
  | 'REPAIR'
  | 'RESOLUTION_PERIOD_CONTINGENCY'
  | 'SELLER_BROKER_COMMISSION'
  | 'SELLER_CREDIT'
  | 'SELLER_DISCLOSURES_DUE'
  | 'TERMINATION_OPTION'
  | 'TEXT_TERM'
  | 'TITLE_POLICY_AMENDMENT'
  | 'TITLE_POLICY_FEE'
  | 'VACANCY_DATE';

/** CloseOfEscrowDate is the date when the ownership transfers from seller to buyer. */
export type OdProtosInstitutionsReithouseData_CloseOfEscrowDateInput = {
  date?: InputMaybe<OdProtosCommon_DateInput>;
  relativeDate?: InputMaybe<OdProtosInstitutionsReithouseData_RelativeDateInput>;
};

/**
 * Concession is money given to buyer or seller for a reason.
 * Often, a seller might give the buyer concession instead of agreeing to a repair ask.
 */
export type OdProtosInstitutionsReithouseData_ConcessionInput = {
  /** Deprecated but still used for backward compatibility */
  amount?: InputMaybe<OdProtosCommon_MoneyInput>;
  commission?: InputMaybe<OdProtosInstitutionsReithouseData_Concession_CommissionOneofInput>;
  reason?: InputMaybe<Scalars['String']>;
  recipient?: InputMaybe<OdProtosInstitutionsReithouseData_Party>;
};

export type OdProtosInstitutionsReithouseData_Concession_CommissionOneofInput = {
  commissionAmount?: InputMaybe<OdProtosCommon_MoneyInput>;
  /** 0-100 */
  percentage?: InputMaybe<Scalars['Float']>;
};

/** Contingency. */
export type OdProtosInstitutionsReithouseData_ContingencyInput = {
  contingencyType?: InputMaybe<OdProtosInstitutionsReithouseData_Contingency_ContingencyTypeInput>;
  releasedAt?: InputMaybe<Scalars['DateTime']>;
};

export type OdProtosInstitutionsReithouseData_Contingency_AppraisalInput = {
  /** the date by when appraisal needs to be done. anchor is contract binding date. */
  deadline?: InputMaybe<OdProtosInstitutionsReithouseData_RelativeDateInput>;
};

export type OdProtosInstitutionsReithouseData_Contingency_ContingencyTypeInput = {
  type?: InputMaybe<OdProtosInstitutionsReithouseData_Contingency_ContingencyType_TypeOneofInput>;
};

export type OdProtosInstitutionsReithouseData_Contingency_ContingencyType_TypeOneofInput = {
  appraisal?: InputMaybe<OdProtosInstitutionsReithouseData_Contingency_AppraisalInput>;
  financing?: InputMaybe<OdProtosInstitutionsReithouseData_Contingency_FinancingInput>;
  homeSale?: InputMaybe<OdProtosInstitutionsReithouseData_Contingency_HomeSaleInput>;
  inspection?: InputMaybe<OdProtosInstitutionsReithouseData_Contingency_InspectionInput>;
  resolutionPeriod?: InputMaybe<OdProtosInstitutionsReithouseData_Contingency_ResolutionPeriodInput>;
};

export type OdProtosInstitutionsReithouseData_Contingency_FinancingInput = {
  /** the date by when mortgage financing needs to be secured. */
  financingDeadline?: InputMaybe<OdProtosCommon_DateInput>;
};

export type OdProtosInstitutionsReithouseData_Contingency_HomeSaleInput = {
  /** the date by when another linked home transaction must be completed. */
  deadline?: InputMaybe<OdProtosInstitutionsReithouseData_RelativeDateInput>;
};

export type OdProtosInstitutionsReithouseData_Contingency_InspectionInput = {
  /** the date by when inspection needs to be done. anchor is contract binding date. */
  deadline?: InputMaybe<OdProtosInstitutionsReithouseData_RelativeDateInput>;
  inspectionDeadline?: InputMaybe<OdProtosCommon_DateInput>;
};

export type OdProtosInstitutionsReithouseData_Contingency_ResolutionPeriodInput = {
  /** the date by when resolution needs to be done. anchor is inspection contingency release date. */
  deadline?: InputMaybe<OdProtosInstitutionsReithouseData_RelativeDateInput>;
};

export type OdProtosInstitutionsReithouseData_ContractExpirationInput = {
  date?: InputMaybe<OdProtosCommon_DateInput>;
  /** anchor is contract sent date. */
  deadline?: InputMaybe<OdProtosInstitutionsReithouseData_RelativeDateInput>;
};

export type OdProtosInstitutionsReithouseData_ConveyancesInput = {
  /** List of items that will convey. */
  items?: InputMaybe<Array<OdProtosInstitutionsReithouseData_Conveyances_ItemInput>>;
};

export type OdProtosInstitutionsReithouseData_Conveyances_ItemInput = {
  description?: InputMaybe<Scalars['String']>;
  itemType?: InputMaybe<OdProtosInstitutionsReithouseData_Conveyances_ItemType>;
};

export type OdProtosInstitutionsReithouseData_Conveyances_ItemType =
  | 'DRYER'
  | 'MICROWAVE'
  | 'OTHER'
  | 'REFRIGERATOR'
  | 'STOVE_OVEN'
  | 'UNKNOWN'
  | 'WASHER';

/**
 * Represents a document used in real estate transactions
 * These documents have a class but also may be applicable at a federal, state or vendor level
 */
export type OdProtosInstitutionsReithouseData_DocumentDescriptorInput = {
  /**
   * ------------------------
   * Other Attributes:
   * ------------------------
   * Location of a blank version of the document
   */
  asset?: InputMaybe<OdProtosInstitutionsReithouseData_AssetInput>;
  /**
   * If not empty string, this document is only applicable when this vendor branch is involved
   * in the transaction
   */
  branchId?: InputMaybe<Scalars['String']>;
  /** If present, this document is only applicable for a house built after this year */
  builtAfterYear?: InputMaybe<Scalars['Float']>;
  /** If present, this document is only applicable for a house built before this year */
  builtBeforeYear?: InputMaybe<Scalars['Float']>;
  /** whether or not it makes sense to have multiple copies of this document per transaction */
  canHaveMultiple?: InputMaybe<Scalars['Boolean']>;
  class?: InputMaybe<OdProtosInstitutionsReithouseData_DocumentDescriptor_Class>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdByUserToken?: InputMaybe<Scalars['String']>;
  /** Human readable version of the class field. Can be used to display in UIs */
  displayClass?: InputMaybe<Scalars['String']>;
  /** If true this document is federally applicable */
  federal?: InputMaybe<Scalars['Boolean']>;
  /**
   * ------------------------
   * Qualifiers:
   * ------------------------
   * Next id: 22
   */
  id?: InputMaybe<Scalars['String']>;
  /** If true, this document is only applicable for property with a HOA */
  isForHoa?: InputMaybe<Scalars['Boolean']>;
  /**
   * ------------------------
   * Contents:
   * ------------------------
   * Local market name for this document
   */
  name?: InputMaybe<Scalars['String']>;
  /** List of parties for which a signature is required */
  requiredSignatures?: InputMaybe<OdProtosInstitutionsReithouseData_PartyListInput>;
  /** If present this document is applicable only in this state */
  state?: InputMaybe<OdProtosCommonState_State>;
  status?: InputMaybe<OdProtosInstitutionsReithouseData_DocumentDescriptor_Status>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  updatedByUserToken?: InputMaybe<Scalars['String']>;
  /**
   * If not empty string, this document is only applicable when this vendor is involved
   * in the transaction
   */
  vendorId?: InputMaybe<Scalars['String']>;
};

/**
 * The general description of the document
 * The realty document will have many sub-types represented by the `DocumentDescriptor`
 * Next ID: 65
 */
export type OdProtosInstitutionsReithouseData_DocumentDescriptor_Class =
  | 'ABAD'
  | 'ADDENDUM'
  | 'AGENCY_AGREEMENT'
  | 'AGENCY_DISCLOSURE'
  | 'AGREEMENT'
  | 'AMENDMENT'
  | 'APPRAISAL_REPORT'
  | 'ASSIGNMENT'
  | 'BILL_OF_SALE'
  | 'BUYER_PURCHASE_ADDENDUM'
  | 'CERTIFICATE_OF_OCCUPANCY'
  | 'CLOSING_DOCUMENTS'
  | 'COMISSION_INSTRUCTIONS'
  | 'COMPENSATION_AGREEMENT'
  | 'CONCIERGE_AGREEMENT'
  | 'CONCIERGE_INVOICE'
  | 'COUNTER_OFFER'
  | 'DEED'
  | 'DISCLOSURE'
  | 'EARNEST_MONEY_DEPOSIT_RECEIPT'
  | 'EARNEST_MONEY_RELEASE_FORM'
  | 'EXCLUSIVE_RIGHT_TO_SELL'
  | 'FINAL_REPAIR_ASK'
  | 'FINAL_SETTLEMENT_STATEMENT'
  | 'FINAL_WALKTHROUGH_VERIFICATION'
  | 'FIRPTA'
  | 'HOA_ADDENDUM'
  | 'HOA_DEMAND'
  | 'HOA_GOVERNING_DOCUMENTS'
  | 'HOA_QUESTIONNAIRE'
  | 'HOA_VIOLATION_RESOLUTION'
  | 'HOME_BUILDER_WARRANTY'
  | 'INSPECTION_REPORT'
  | 'LAND_SURVEY'
  | 'LCO_ADDENDUM'
  | 'LEAD_BASED_PAINT_DISCLOSURE'
  | 'LIEN_SEARCH'
  | 'LISTING_AGREEMENT'
  | 'LOAN_PAYOFF'
  | 'LOSS_HISTORY_REPORT'
  | 'MARKET_CONDITIONS_ADVISORY'
  | 'MISCELLANEOUS'
  | 'MLS_INPUT_FORM'
  | 'MLS_PRINTOUT'
  | 'MUD_DOCUMENT'
  | 'OPTION_FEE'
  | 'OPTION_MONEY_VERIFICATION'
  | 'OWNERS_POLICY'
  | 'PHOTO'
  | 'POWER_OF_ATTORNEY_AGREEMENT'
  | 'PRE_QUALIFICATION'
  | 'PRE_TERMINATION'
  | 'PURCHASE_AGREEMENT'
  | 'RECEIPT'
  | 'REFERRAL_AGREEMENT'
  | 'REFERRAL_W9'
  | 'REPAIR_CREDIT_ADDENDUM'
  | 'SELLER_PROPERTY_DISCLOSURE_STATEMENT'
  | 'T47'
  | 'TAX_CERTIFICATE'
  | 'TERMINATION'
  | 'TITLE_COMMITMENT'
  | 'TRANSFER_ADDENDUM'
  | 'UNKNOWN'
  | 'WIRE_INSTRUCTIONS';

/**
 * these values needs to correspond to od_protos.institutions.reithouse.data.Transaction.State
 * in order for DocConfig and Reithouse to understand each other
 */
export type OdProtosInstitutionsReithouseData_DocumentDescriptor_ClearinghouseState =
  | 'CLOSED'
  | 'DISCARDED'
  | 'DRAFT'
  | 'IN_CONTRACT'
  /** NONE indicates that no state is chosen */
  | 'NONE'
  | 'OPEN'
  | 'PRELIST'
  | 'REJECTED'
  | 'TERMINATED'
  | 'UNKNOWN_STATE';

export type OdProtosInstitutionsReithouseData_DocumentDescriptor_Status =
  | 'ACTIVE'
  | 'INACTIVE';

export type OdProtosInstitutionsReithouseData_DocumentError_Type =
  | 'MISSING_TYPE'
  | 'NOT_REVIEWED_BY_BROKER'
  | 'NOT_SIGNED';

/** Common signature requirement */
export type OdProtosInstitutionsReithouseData_Document_SignatureRequirement =
  /** No signature required (so even if it's missing, it's not an exception to the rules and no action required) */
  | 'NOT_REQUIRED'
  /** Signature required */
  | 'REQUIRED'
  /** Unknown */
  | 'UNKNOWN';

export type OdProtosInstitutionsReithouseData_Document_Version_Status =
  | 'ACCEPTED'
  | 'PROCESSED'
  | 'RECEIVED'
  | 'REJECTED';

/** Earnest deposit delivery period */
export type OdProtosInstitutionsReithouseData_EarnestDepositDueInput = {
  /** anchor is contract binding date. */
  dueDate?: InputMaybe<OdProtosInstitutionsReithouseData_RelativeDateInput>;
};

/** Earnest money deposit. */
export type OdProtosInstitutionsReithouseData_EarnestDepositInput = {
  /** total Earnest Money Deposit amount */
  amount?: InputMaybe<OdProtosCommon_MoneyInput>;
  /**
   * non-refundable Earnest Money Deposit amount. This field is optional.
   * total EMD amount = non-refundable EMD amount + refundable EMD amount
   */
  nonRefundableAmount?: InputMaybe<OdProtosCommon_MoneyInput>;
};

/** Link to outside resource */
export type OdProtosInstitutionsReithouseData_ExternalLinkInput = {
  /** External id associated with the link */
  id?: InputMaybe<Scalars['String']>;
  /** Name of link */
  name?: InputMaybe<Scalars['String']>;
  /** Link address */
  url?: InputMaybe<Scalars['String']>;
};

export type OdProtosInstitutionsReithouseData_FeeSplitInput = {
  buyer?: InputMaybe<OdProtosInstitutionsReithouseData_FeeSplit_SplitInput>;
  seller?: InputMaybe<OdProtosInstitutionsReithouseData_FeeSplit_SplitInput>;
};

export type OdProtosInstitutionsReithouseData_FeeSplit_SplitInput = {
  split?: InputMaybe<OdProtosInstitutionsReithouseData_FeeSplit_Split_SplitOneofInput>;
};

export type OdProtosInstitutionsReithouseData_FeeSplit_Split_SplitOneofInput = {
  amount?: InputMaybe<OdProtosCommon_MoneyInput>;
  percentage?: InputMaybe<Scalars['Float']>;
};

export type OdProtosInstitutionsReithouseData_FinancingTypeInput = {
  /** If other, this is the description of the financing type. */
  description?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<OdProtosInstitutionsReithouseData_FinancingType_Type>;
};

/** Type of financing. */
export type OdProtosInstitutionsReithouseData_FinancingType_Type =
  | 'CASH'
  | 'CONVENTIONAL'
  | 'FHA'
  | 'HARD_MONEY'
  | 'OTHER'
  | 'UNKNOWN'
  | 'VA';

/** Whether funding related delays is allowed */
export type OdProtosInstitutionsReithouseData_FundingRelatedDelaysInput = {
  isAllowed?: InputMaybe<Scalars['Boolean']>;
};

export type OdProtosInstitutionsReithouseData_GroupSpecificInput = {
  documentDescriptorId?: InputMaybe<Scalars['String']>;
  domain?: InputMaybe<OdProtosInstitutionsReithouseData_GroupSpecific_DomainOneofInput>;
  productType?: InputMaybe<OdProtosInstitutionsReithouseData_Transaction_Type>;
};

export type OdProtosInstitutionsReithouseData_GroupSpecific_DomainOneofInput = {
  clearinghouseSpecific?: InputMaybe<OdProtosInstitutionsReithouseData_ClearinghouseSpecificInput>;
};

export type OdProtosInstitutionsReithouseData_InspectionScheduleInput = {
  inspectionDate?: InputMaybe<OdProtosCommon_DateInput>;
  inspectionEndTime?: InputMaybe<OdProtosCommon_TimeInput>;
  inspectionStartTime?: InputMaybe<OdProtosCommon_TimeInput>;
};

/** Whether land survey is required and surrounding terms (TX only) */
export type OdProtosInstitutionsReithouseData_LandSurveyRequirementInput = {
  /** if required, this is when the survey is due. anchor is contract binding date. */
  dueDate?: InputMaybe<OdProtosInstitutionsReithouseData_RelativeDateInput>;
  /** if required, the land survey is due within this period after signing contract */
  dueWithinPeriod?: InputMaybe<OdProtosCommon_DurationInput>;
  isSurveyRequired?: InputMaybe<Scalars['Boolean']>;
  /** if required, this party pays for the land survey */
  payer?: InputMaybe<OdProtosInstitutionsReithouseData_Party>;
};

export type OdProtosInstitutionsReithouseData_OverrideFieldInput = {
  /**
   * name of the template field
   * must be one of data.Document user_overrideable_template_fields
   */
  name?: InputMaybe<Scalars['String']>;
  /**
   * value to use for this field
   * type must correspond with data.Document user_overrideable_template_fields
   */
  value?: InputMaybe<OdProtosInstitutionsReithouseData_OverrideField_ValueOneofInput>;
};

export type OdProtosInstitutionsReithouseData_OverrideField_ValueOneofInput = {
  boolVal?: InputMaybe<Scalars['Boolean']>;
  stringVal?: InputMaybe<Scalars['String']>;
};

export type OdProtosInstitutionsReithouseData_ParticipantError_Type =
  | 'EXPECTED_EXACTLY_ONE'
  | 'MISSING'
  | 'MISSING_FIELD';

/** Next ID: 19 */
export type OdProtosInstitutionsReithouseData_Participant_Role =
  | 'AGENT'
  | 'BROKER'
  | 'BROKERAGE'
  | 'COAGENT'
  | 'COVERING_COAGENT'
  | 'ESCROW_COMPANY'
  | 'ESCROW_CONTACT'
  /** Roles specifically designated for OX Listing Transactions. */
  | 'LISTING_COORDINATOR'
  | 'MORTGAGE_CONTACT'
  | 'OBSERVER'
  | 'PRINCIPAL'
  | 'PRINCIPAL_CLOSER'
  | 'PRINCIPAL_SIGNATORY'
  | 'TITLE_COMPANY'
  | 'TITLE_CONTACT'
  | 'TRANSACTION_COORDINATOR'
  /**
   * Temporary role needed by Homebase team. Unclear if there is future application
   * or if Homebase will even need to use it in the future.
   */
  | 'TRANSACTION_SUPPORT_SPECIALIST'
  | 'UNDERWRITER'
  | 'UNKNOWN_ROLE';

/**
 * A party in a real estate transaction. There is a BUYER and SELLER party.
 * There is also a NONE party, which is used to represent participants in neither party.
 */
export type OdProtosInstitutionsReithouseData_Party =
  | 'BUYER'
  | 'NONE'
  | 'SELLER';

/** List of parties */
export type OdProtosInstitutionsReithouseData_PartyListInput = {
  parties?: InputMaybe<Array<OdProtosInstitutionsReithouseData_PartyList_Party>>;
};

export type OdProtosInstitutionsReithouseData_PartyList_Party =
  | 'BUYER'
  | 'SELLER';

/** Price is the amount the buyer will pay the seller for ownership of the property. */
export type OdProtosInstitutionsReithouseData_PriceInput = {
  amount?: InputMaybe<OdProtosCommon_MoneyInput>;
};

export type OdProtosInstitutionsReithouseData_RelativeDateInput = {
  /**
   * the type of anchor determines how anchor_date is computed
   * this is dependent on term type
   */
  anchor?: InputMaybe<OdProtosInstitutionsReithouseData_RelativeDate_AnchorType>;
  /** if the concrete anchor date is available, this is the value. null otherwise */
  anchorDate?: InputMaybe<OdProtosCommon_DateInput>;
  /** if the concrete date is able to be calculated, this is the value. null otherwise */
  date?: InputMaybe<OdProtosCommon_DateInput>;
  dayType?: InputMaybe<OdProtosInstitutionsReithouseData_RelativeDate_DayType>;
  /** date value is this many days from anchor */
  deltaDays?: InputMaybe<Scalars['Float']>;
  /** if this is set, computed value is this instead of anchor + delta */
  overrideDate?: InputMaybe<OdProtosCommon_DateInput>;
};

export type OdProtosInstitutionsReithouseData_RelativeDate_AnchorType =
  | 'CONTRACT_EXECUTE'
  | 'CONTRACT_OFFER_SEND'
  | 'INSPECTION_CONTINGENCY_RELEASE'
  | 'NOW';

export type OdProtosInstitutionsReithouseData_RelativeDate_DayType =
  /** Mon-Fri excluding national holidays */
  | 'BUSINESS'
  | 'CALENDAR'
  /** Same as calendar days but if the end date is not a business day, go to the next business day */
  | 'CALENDAR_ENDING_ON_BUSINESS';

/** Terms on how seller need to rent back the property after closing. OD term is Late Checkout. */
export type OdProtosInstitutionsReithouseData_RentBackInput = {
  /** Total amount paid for rent back. */
  amount?: InputMaybe<OdProtosCommon_MoneyInput>;
  date?: InputMaybe<OdProtosCommon_DateInput>;
};

/** Repair ask from buyer to fix something. */
export type OdProtosInstitutionsReithouseData_RepairInput = {
  amount?: InputMaybe<OdProtosCommon_MoneyInput>;
  ask?: InputMaybe<Scalars['String']>;
};

export type OdProtosInstitutionsReithouseData_SellerCreditInput = {
  credit?: InputMaybe<OdProtosInstitutionsReithouseData_SellerCredit_CreditOneofInput>;
  reason?: InputMaybe<Scalars['String']>;
};

export type OdProtosInstitutionsReithouseData_SellerCredit_CreditOneofInput = {
  amount?: InputMaybe<OdProtosCommon_MoneyInput>;
  percentage?: InputMaybe<Scalars['Float']>;
};

/** When seller must send disclosures by (TX only) */
export type OdProtosInstitutionsReithouseData_SellerDisclosuresDueInput = {
  /** anchor is contract binding date. */
  dueDate?: InputMaybe<OdProtosInstitutionsReithouseData_RelativeDateInput>;
};

export type OdProtosInstitutionsReithouseData_SignatureRequest_Status =
  /** could not deliver to signer */
  | 'BOUNCED'
  /** signer refused to sign */
  | 'DECLINED'
  /** given a signing order, not this signer's turn yet */
  | 'PENDING_SEND'
  /** out for signature */
  | 'SENT'
  /** successfully signed */
  | 'SIGNED';

/** Represents a field used in a document template */
export type OdProtosInstitutionsReithouseData_TemplateFieldDescriptorInput = {
  name?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<OdProtosInstitutionsReithouseData_TemplateFieldDescriptor_Type>;
};

/** a template field can either be a boolean or a string */
export type OdProtosInstitutionsReithouseData_TemplateFieldDescriptor_Type =
  | 'BOOLEAN'
  | 'STRING';

export type OdProtosInstitutionsReithouseData_TermError_Type =
  | 'EXPIRED'
  | 'MISSING'
  | 'NOT_AGREED_UPON'
  | 'NO_DURATION_FOR_RELATIVE_DATE';

/** Wrapper to share TermType code */
export type OdProtosInstitutionsReithouseData_TermTypeInput = {
  type?: InputMaybe<OdProtosInstitutionsReithouseData_TermType_TypeOneofInput>;
};

/**
 * Used to identify a term type without the data
 * New types should be added to both at the same time!
 */
export type OdProtosInstitutionsReithouseData_TermType_Type =
  | 'ADDITIONAL_EARNEST_DEPOSIT'
  | 'APPRAISAL_CONTINGENCY'
  | 'APPRAISAL_DATE'
  | 'BUYER_BROKER_COMMISSION'
  | 'CLOSE_OF_ESCROW_DATE'
  | 'CONTINGENCY'
  | 'CONTRACT_EXPIRATION'
  | 'CONVEYANCES'
  | 'EARNEST_DEPOSIT'
  | 'EARNEST_DEPOSIT_DUE'
  | 'FINANCING_CONTINGENCY'
  | 'FUNDING_RELATED_DELAYS'
  | 'HOME_SALE_CONTINGENCY'
  | 'INSPECTION_CONTINGENCY'
  | 'INSPECTION_SCHEDULE'
  | 'LAND_SURVEY_REQUIREMENT'
  | 'OPENDOOR_COMMISSION'
  | 'OX_FEE'
  | 'PRICE'
  | 'REIMBURSEMENT'
  | 'RENT_BACK'
  | 'REPAIR'
  | 'RESOLUTION_PERIOD_CONTINGENCY'
  | 'SELLER_BROKER_COMMISSION'
  | 'SELLER_CREDIT'
  | 'SELLER_DISCLOSURES_DUE'
  | 'TERMINATION_OPTION'
  | 'TEXT_TERM'
  | 'TITLE_POLICY_AMENDMENT'
  | 'TITLE_POLICY_FEE'
  | 'VACANCY_DATE';

export type OdProtosInstitutionsReithouseData_TermType_TypeOneofInput = {
  additionalEarnestDeposit?: InputMaybe<OdProtosInstitutionsReithouseData_AdditionalEarnestDepositInput>;
  appraisalDate?: InputMaybe<OdProtosInstitutionsReithouseData_AppraisalDateInput>;
  brokerCommission?: InputMaybe<OdProtosInstitutionsReithouseData_BrokerCommissionInput>;
  buyerBrokerCommission?: InputMaybe<OdProtosInstitutionsReithouseData_BrokerCommissionInput>;
  closeOfEscrowDate?: InputMaybe<OdProtosInstitutionsReithouseData_CloseOfEscrowDateInput>;
  concession?: InputMaybe<OdProtosInstitutionsReithouseData_ConcessionInput>;
  contingency?: InputMaybe<OdProtosInstitutionsReithouseData_ContingencyInput>;
  contractExpiration?: InputMaybe<OdProtosInstitutionsReithouseData_ContractExpirationInput>;
  conveyances?: InputMaybe<OdProtosInstitutionsReithouseData_ConveyancesInput>;
  earnestDeposit?: InputMaybe<OdProtosInstitutionsReithouseData_EarnestDepositInput>;
  earnestDepositDue?: InputMaybe<OdProtosInstitutionsReithouseData_EarnestDepositDueInput>;
  fundingRelatedDelays?: InputMaybe<OdProtosInstitutionsReithouseData_FundingRelatedDelaysInput>;
  inspectionSchedule?: InputMaybe<OdProtosInstitutionsReithouseData_InspectionScheduleInput>;
  landSurveyRequirement?: InputMaybe<OdProtosInstitutionsReithouseData_LandSurveyRequirementInput>;
  opendoorCommission?: InputMaybe<OdProtosInstitutionsReithouseData_BrokerCommissionInput>;
  oxFee?: InputMaybe<OdProtosInstitutionsReithouseData_BrokerCommissionInput>;
  price?: InputMaybe<OdProtosInstitutionsReithouseData_PriceInput>;
  reimbursement?: InputMaybe<OdProtosInstitutionsReithouseData_SellerCreditInput>;
  rentBack?: InputMaybe<OdProtosInstitutionsReithouseData_RentBackInput>;
  repair?: InputMaybe<OdProtosInstitutionsReithouseData_RepairInput>;
  sellerBrokerCommission?: InputMaybe<OdProtosInstitutionsReithouseData_BrokerCommissionInput>;
  sellerCredit?: InputMaybe<OdProtosInstitutionsReithouseData_SellerCreditInput>;
  sellerDisclosuresDue?: InputMaybe<OdProtosInstitutionsReithouseData_SellerDisclosuresDueInput>;
  terminationOption?: InputMaybe<OdProtosInstitutionsReithouseData_TerminationOptionInput>;
  textTerm?: InputMaybe<OdProtosInstitutionsReithouseData_TextTermInput>;
  titlePolicyAmendment?: InputMaybe<OdProtosInstitutionsReithouseData_TitlePolicyAmendmentInput>;
  titlePolicyFee?: InputMaybe<OdProtosInstitutionsReithouseData_FeeSplitInput>;
  vacancyDate?: InputMaybe<OdProtosInstitutionsReithouseData_VacancyDateInput>;
};

export type OdProtosInstitutionsReithouseData_Term_Status =
  | 'ACCEPTED'
  | 'PROPOSED'
  | 'RATIFIED'
  | 'REJECTED'
  | 'REMOVED';

/**
 * Termination Option allows the buyer to pay an option fee so that
 * they can cancel the contract for any reason within the option period
 * (TX only)
 */
export type OdProtosInstitutionsReithouseData_TerminationOptionInput = {
  feeAmount?: InputMaybe<OdProtosCommon_MoneyInput>;
  /** if true, fee amount is credited back to buyer at closing */
  isCreditableTowardsClosing?: InputMaybe<Scalars['Boolean']>;
  optionPeriod?: InputMaybe<OdProtosCommon_DurationInput>;
};

/** TextTerm represents a manually entered term */
export type OdProtosInstitutionsReithouseData_TextTermInput = {
  body?: InputMaybe<Scalars['String']>;
};

/** Whether title policy will be amended from the standard version (TX only) */
export type OdProtosInstitutionsReithouseData_TitlePolicyAmendmentInput = {
  /** if yes, this party pays for the amendment */
  payer?: InputMaybe<OdProtosInstitutionsReithouseData_Party>;
  willBeAmended?: InputMaybe<Scalars['Boolean']>;
};

/** State of the transaction. */
export type OdProtosInstitutionsReithouseData_Transaction_State =
  | 'CLOSED'
  | 'DISCARDED'
  | 'DRAFT'
  | 'IN_CONTRACT'
  | 'LATE_CHECKOUT'
  | 'OPEN'
  | 'PRELIST'
  | 'REJECTED'
  | 'TERMINATED'
  | 'UNKNOWN_STATE';

/** Transaction type. */
export type OdProtosInstitutionsReithouseData_Transaction_Type =
  | 'AGENT_SOURCED'
  | 'BWODA'
  | 'DIRECT_SELLER'
  | 'HOME_BUILDER'
  | 'OD_EXCLUSIVES'
  | 'OD_SOURCED'
  | 'OUT_OF_BUYBOX'
  | 'OX_LISTING'
  | 'UNKNOWN_TYPE'
  | 'WALK';

/** Date when property should be vacant. */
export type OdProtosInstitutionsReithouseData_VacancyDateInput = {
  date?: InputMaybe<OdProtosCommon_DateInput>;
};

export type OdProtosInstitutionsReithouseServices_AcceptTermRequestInput = {
  id?: InputMaybe<Scalars['String']>;
  party?: InputMaybe<OdProtosInstitutionsReithouseData_Party>;
};

export type OdProtosInstitutionsReithouseServices_AddParticipantRequestInput = {
  contact?: InputMaybe<OdProtosInstitutionsReithouseDataCommon_ContactInput>;
  observerType?: InputMaybe<Scalars['String']>;
  party?: InputMaybe<OdProtosInstitutionsReithouseData_Party>;
  role?: InputMaybe<OdProtosInstitutionsReithouseData_Participant_Role>;
  transactionId?: InputMaybe<Scalars['String']>;
};

export type OdProtosInstitutionsReithouseServices_ArchiveTransactionRequestInput = {
  /**
   * If this flag is set to true, response will contain violations, if any,
   * but will not actually archive even if there are no violations
   */
  dryRun?: InputMaybe<Scalars['Boolean']>;
  /**
   * Whether or not you want to ignore the transaction's rules
   * when trying to transition state
   */
  overrideRules?: InputMaybe<Scalars['Boolean']>;
  /** What party you're archiving on behalf of (seller or buyer) */
  party?: InputMaybe<OdProtosInstitutionsReithouseData_Party>;
  /** Transaction to update. */
  transactionId?: InputMaybe<Scalars['String']>;
};

export type OdProtosInstitutionsReithouseServices_CounterTermRequestInput = {
  counteredTermId?: InputMaybe<Scalars['String']>;
  params?: InputMaybe<OdProtosInstitutionsReithouseServices_CreateTermParamsInput>;
};

export type OdProtosInstitutionsReithouseServices_CreateDocumentDescriptorRequestInput = {
  /** id and created/updated by fields are ignored and set by the server */
  documentDescriptor?: InputMaybe<OdProtosInstitutionsReithouseData_DocumentDescriptorInput>;
};

/** next: 8 */
export type OdProtosInstitutionsReithouseServices_CreateDocumentRequestInput = {
  /** A number to uniquely identify an amendment in a transaction */
  amendmentNumber?: InputMaybe<Scalars['Int']>;
  /** Signature requirement for buyer */
  buyerSignatureRequirement?: InputMaybe<OdProtosInstitutionsReithouseData_Document_SignatureRequirement>;
  /** Document descriptor id that describes this document. */
  documentDescriptorId?: InputMaybe<Scalars['String']>;
  /** Display name. */
  name?: InputMaybe<Scalars['String']>;
  /** Signature requirement for seller */
  sellerSignatureRequirement?: InputMaybe<OdProtosInstitutionsReithouseData_Document_SignatureRequirement>;
  /** Transaction this document is part of. */
  transactionId?: InputMaybe<Scalars['String']>;
};

export type OdProtosInstitutionsReithouseServices_CreateDocumentVersionRequestInput = {
  buyerSigned?: InputMaybe<Scalars['Boolean']>;
  cabinetAssetId?: InputMaybe<Scalars['String']>;
  documentId?: InputMaybe<Scalars['String']>;
  /** Date when document version was executed. */
  fullySignedDate?: InputMaybe<OdProtosCommon_DateInput>;
  sellerSigned?: InputMaybe<Scalars['Boolean']>;
};

export type OdProtosInstitutionsReithouseServices_CreateGroupSpecificRequestInput = {
  groupSpecific?: InputMaybe<OdProtosInstitutionsReithouseData_GroupSpecificInput>;
};

export type OdProtosInstitutionsReithouseServices_CreateHelloSignDraftRequestInput = {
  cabinetAssetId?: InputMaybe<Scalars['String']>;
  /** document to create a draft for */
  documentId?: InputMaybe<Scalars['String']>;
  /**
   * if true, ReitHouse will handling the signing process rather than HelloSign
   * backend might also ignore this in the some hardcoded cases
   */
  embeddedSign?: InputMaybe<Scalars['Boolean']>;
  signers?: InputMaybe<Array<OdProtosInstitutionsReithouseServices_CreateHelloSignDraftRequest_SignerInput>>;
};

export type OdProtosInstitutionsReithouseServices_CreateHelloSignDraftRequest_SignerInput = {
  /**
   * smaller numbers sign first. if multiple signers have the same number,
   * they are notified at the same time and there is no enforced signing order
   */
  order?: InputMaybe<Scalars['Float']>;
  /** participant who will be asked to sign */
  participantId?: InputMaybe<Scalars['String']>;
};

export type OdProtosInstitutionsReithouseServices_CreateTermParamsInput = {
  comment?: InputMaybe<Scalars['String']>;
  expiresAt?: InputMaybe<OdProtosCommon_DateInput>;
  includedInDocumentId?: InputMaybe<Scalars['String']>;
  party?: InputMaybe<OdProtosInstitutionsReithouseData_Party>;
  /** Type details at code/protobuf/institutions/reithouse/data/term.proto */
  termType?: InputMaybe<OdProtosInstitutionsReithouseData_TermTypeInput>;
};

export type OdProtosInstitutionsReithouseServices_CreateTermRequestInput = {
  params?: InputMaybe<OdProtosInstitutionsReithouseServices_CreateTermParamsInput>;
  transactionId?: InputMaybe<Scalars['String']>;
};

/** Next id: 23 */
export type OdProtosInstitutionsReithouseServices_CreateTransactionRequestInput = {
  /** Access instructions for the property. */
  accessInstructions?: InputMaybe<Scalars['String']>;
  /** Address of the home being transacted. */
  addressId?: InputMaybe<Scalars['String']>;
  businessType?: InputMaybe<Scalars['String']>;
  /** Buyer party specific data. */
  buyerParty?: InputMaybe<OdProtosInstitutionsReithouseServices_CreateTransactionRequest_PartySpecificInput>;
  /**
   * Date that the certificate of occupancy will be received.
   * Should only be used when is_new_build == True
   */
  certificateOfOccupancyDate?: InputMaybe<OdProtosCommon_DateInput>;
  /** Date of close of escrow of the transaction. */
  closeOfEscrowDate?: InputMaybe<OdProtosCommon_DateInput>;
  /** Links to related transaction pages */
  externalLinks?: InputMaybe<Array<OdProtosInstitutionsReithouseData_ExternalLinkInput>>;
  /** Home details of the home being transacted. */
  homeDetailId?: InputMaybe<Scalars['String']>;
  /** Set when the property is a new build. */
  isNewBuild?: InputMaybe<Scalars['Boolean']>;
  /**
   * Set when the transaction is a OX Listing transaction.
   *
   * The OX_Listing transaction type is used instead in transaction creation.
   */
  isOxListing?: InputMaybe<Scalars['Boolean']>;
  /** Set when the property is vacant. */
  isVacant?: InputMaybe<Scalars['Boolean']>;
  /** Set when the transaction is created from a lead. */
  leadId?: InputMaybe<Scalars['String']>;
  /** Related MLS listings. */
  mlsIds?: InputMaybe<Array<OdProtosInstitutionsReithouseDataCommon_MlsidInput>>;
  /** Display name. */
  name?: InputMaybe<Scalars['String']>;
  /** Related ODLS SellRequest. */
  odlsSellRequestId?: InputMaybe<Scalars['String']>;
  /** Related ODLS SellResponse. */
  odlsSellResponseId?: InputMaybe<Scalars['String']>;
  /** Participants to add to the transaction upon creation. */
  participants?: InputMaybe<Array<OdProtosInstitutionsReithouseServices_ParticipantParamsInput>>;
  productType?: InputMaybe<OdProtosInstitutionsReithouseData_Transaction_Type>;
  /** Purchase price of the home being transacted. */
  purchasePrice?: InputMaybe<OdProtosCommon_MoneyInput>;
  /** DEPRECATED. All transactions are in Institutions now. */
  rerouteToInstitutions?: InputMaybe<Scalars['Boolean']>;
  /** Seller party specific data. */
  sellerParty?: InputMaybe<OdProtosInstitutionsReithouseServices_CreateTransactionRequest_PartySpecificInput>;
  /** Business type of transaction. Required when creating a transaction. Replaced with product_type. */
  transactionType?: InputMaybe<Scalars['String']>;
};

/** Data specific to a party of the transaction. */
export type OdProtosInstitutionsReithouseServices_CreateTransactionRequest_PartySpecificInput = {
  /** Agent Team that owns this transaction. */
  agentVendorBranchId?: InputMaybe<Scalars['String']>;
  /** Brokerage that owns this transaction. */
  brokerageVendorBranchId?: InputMaybe<Scalars['String']>;
  /** Escrow Org for party */
  escrowOrgId?: InputMaybe<Scalars['String']>;
  /**
   * Brokerage's rule sets to use for this transaction.
   * If set, Documents will automatically be created based on the rule sets.
   */
  ruleSetId?: InputMaybe<OdProtosInstitutionsReithouseDataCommon_VersionedIdInput>;
  /** Title Org for party */
  titleOrgId?: InputMaybe<Scalars['String']>;
};

export type OdProtosInstitutionsReithouseServices_DeleteDocumentRequestInput = {
  /** Document to delete. */
  documentId?: InputMaybe<Scalars['String']>;
};

export type OdProtosInstitutionsReithouseServices_GenerateDocumentPacketRequestInput = {
  /** document to generate a version for */
  documentId?: InputMaybe<Scalars['String']>;
  /** if true, will return errors if any, but will not actually generate or send the contract */
  dryRun?: InputMaybe<Scalars['Boolean']>;
  /**
   * if true, ReitHouse will handle the signing process rather than HelloSign.
   * backend might also ignore this in the some hardcoded cases
   */
  embeddedSign?: InputMaybe<Scalars['Boolean']>;
  /**
   * if true, only generate document but DO NOT send to signers
   * this is only temporarily needed while we transition all signing to embedded signing and split up generate and send.
   * Steps to remove this:
   * 1. Change CH code to ignore this flag and always only generate without send
   * 2. Change Pact (or other client code) to not pass in this option in when making request
   * 3. Remove this from the proto
   */
  generateOnly?: InputMaybe<Scalars['Boolean']>;
  /**
   * Explicitly define values to fill into these fields.
   * Anything in this list will override the value that
   * Reithouse would have used for this field otherwise
   *
   * name must be one of data.Document user_overrideable_template_fields
   */
  overrideFields?: InputMaybe<Array<OdProtosInstitutionsReithouseData_OverrideFieldInput>>;
  /**
   * Can be used when there are multiple principal participants of a single party
   * The preselected participants will be the only ones in their party that will be asked to sign
   */
  preselectedParticipantIds?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosInstitutionsReithouseServices_GetDocumentStatusesRequestInput = {
  documentIds?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosInstitutionsReithouseServices_GetGroupSpecificDocumentDescriptorsRequestInput = {
  ids?: InputMaybe<Array<OdProtosInstitutionsReithouseServices_GetGroupSpecificDocumentDescriptorsRequest_GroupSpecificDocumentDescriptorIdInput>>;
};

export type OdProtosInstitutionsReithouseServices_GetGroupSpecificDocumentDescriptorsRequest_GroupSpecificDocumentDescriptorIdInput = {
  documentDescriptorId?: InputMaybe<Scalars['String']>;
  productType?: InputMaybe<OdProtosInstitutionsReithouseData_Transaction_Type>;
};

export type OdProtosInstitutionsReithouseServices_GetTransactionStatusesRequestInput = {
  transactionIds?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosInstitutionsReithouseServices_GroupSpecificSearchRequestInput = {
  filters?: InputMaybe<OdProtosInstitutionsReithouseServices_GroupSpecificSearchRequest_FiltersInput>;
  paginationRequest?: InputMaybe<OdProtosCommonPagination_PaginationRequestInput>;
  query?: InputMaybe<Scalars['String']>;
};

export type OdProtosInstitutionsReithouseServices_GroupSpecificSearchRequest_FiltersInput = {
  filterByProductTypes?: InputMaybe<Array<OdProtosInstitutionsReithouseData_Transaction_Type>>;
  filterByState?: InputMaybe<Array<OdProtosCommonState_State>>;
  filterByVendorId?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosInstitutionsReithouseServices_HelloSignSignatureUrlRequestInput = {
  helloSignSignatureId?: InputMaybe<Scalars['String']>;
};

export type OdProtosInstitutionsReithouseServices_IdentifierInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type OdProtosInstitutionsReithouseServices_IdentifierListInput = {
  ids?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosInstitutionsReithouseServices_ParticipantParamsInput = {
  contact?: InputMaybe<OdProtosInstitutionsReithouseDataCommon_ContactInput>;
  observerType?: InputMaybe<Scalars['String']>;
  party?: InputMaybe<OdProtosInstitutionsReithouseData_Party>;
  role?: InputMaybe<OdProtosInstitutionsReithouseData_Participant_Role>;
};

export type OdProtosInstitutionsReithouseServices_RejectTermRequestInput = {
  id?: InputMaybe<Scalars['String']>;
  party?: InputMaybe<OdProtosInstitutionsReithouseData_Party>;
};

export type OdProtosInstitutionsReithouseServices_ReleaseContingencyTermRequestInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type OdProtosInstitutionsReithouseServices_RemoveParticipantRequestInput = {
  participantId?: InputMaybe<Scalars['String']>;
};

export type OdProtosInstitutionsReithouseServices_RemoveTermRequestInput = {
  id?: InputMaybe<Scalars['String']>;
  party?: InputMaybe<OdProtosInstitutionsReithouseData_Party>;
};

export type OdProtosInstitutionsReithouseServices_RequestDocumentRequestInput = {
  documentId?: InputMaybe<Scalars['String']>;
  participantId?: InputMaybe<Scalars['String']>;
  party?: InputMaybe<OdProtosInstitutionsReithouseData_Party>;
  role?: InputMaybe<OdProtosInstitutionsReithouseData_Participant_Role>;
};

export type OdProtosInstitutionsReithouseServices_ReviewDocumentRequestInput = {
  brokerageVendorBranchId?: InputMaybe<Scalars['String']>;
  documentVersionId?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  party?: InputMaybe<OdProtosInstitutionsReithouseData_Party>;
  rejectionReasons?: InputMaybe<Array<OdProtosInstitutionsReithouseDataBrokerage_DocumentReview_RejectionReason>>;
  result?: InputMaybe<OdProtosInstitutionsReithouseDataBrokerage_DocumentReview_Result>;
};

export type OdProtosInstitutionsReithouseServices_ReviseTermParamsInput = {
  comment?: InputMaybe<Scalars['String']>;
  expiresAt?: InputMaybe<OdProtosCommon_DateInput>;
  party?: InputMaybe<OdProtosInstitutionsReithouseData_Party>;
  /** Type details at code/protobuf/institutions/reithouse/data/term.proto */
  termType?: InputMaybe<OdProtosInstitutionsReithouseData_TermTypeInput>;
};

export type OdProtosInstitutionsReithouseServices_ReviseTermRequestInput = {
  expiresAt?: InputMaybe<OdProtosCommon_DateInput>;
  id?: InputMaybe<Scalars['String']>;
  params?: InputMaybe<OdProtosInstitutionsReithouseServices_ReviseTermParamsInput>;
};

export type OdProtosInstitutionsReithouseServices_ScheduleFinalWalkthroughRequestInput = {
  /** Date of final walkthrough. */
  finalWalkthroughDate?: InputMaybe<OdProtosCommon_DateInput>;
  finalWalkthroughEndTime?: InputMaybe<OdProtosCommon_TimeInput>;
  /** Time of final walkthrough. */
  finalWalkthroughStartTime?: InputMaybe<OdProtosCommon_TimeInput>;
  /** Transaction to schedule final walkthrough. */
  transactionId?: InputMaybe<Scalars['String']>;
};

export type OdProtosInstitutionsReithouseServices_SearchTransactionsRequestInput = {
  actor?: InputMaybe<OdProtosInstitutionsReithouseDataCommon_ActorInput>;
  filters?: InputMaybe<OdProtosInstitutionsReithouseServices_SearchTransactionsRequest_FiltersInput>;
  orderBy?: InputMaybe<Array<OdProtosInstitutionsReithouseServices_SearchTransactionsRequest_OrderByOption>>;
  paginationRequest?: InputMaybe<OdProtosCommonPagination_PaginationRequestInput>;
  party?: InputMaybe<OdProtosInstitutionsReithouseData_Party>;
};

export type OdProtosInstitutionsReithouseServices_SearchTransactionsRequest_FiltersInput = {
  /** Filter for transactions needs broker review after a date. */
  afterBrokerReviewDueAt?: InputMaybe<OdProtosCommon_DateInput>;
  /** Filter for transactions after a close of escrow date. */
  afterCoeDate?: InputMaybe<OdProtosCommon_DateInput>;
  archivedState?: InputMaybe<OdProtosInstitutionsReithouseServices_SearchTransactionsRequest_Filters_ArchivedState>;
  /** Filter for transactions needs broker review before a date. */
  beforeBrokerReviewDueAt?: InputMaybe<OdProtosCommon_DateInput>;
  /** Filter for transactions before a close of escrow date. */
  beforeCoeDate?: InputMaybe<OdProtosCommon_DateInput>;
  documentReviewState?: InputMaybe<OdProtosInstitutionsReithouseServices_SearchTransactionsRequest_Filters_DocumentReviewState>;
  /** Filter for transactions across a variety of fields (ids, address ..). */
  fuzzyQuery?: InputMaybe<Scalars['String']>;
  /** Filter for transactions by ID */
  ids?: InputMaybe<Array<Scalars['String']>>;
  /** Filter for transactions has less than maximum number of overdue documents. */
  maxOverdueDocuments?: InputMaybe<Scalars['Int']>;
  /** Filter for transactions has less than maximum number of documents rejected by brokers. */
  maxRejectedDocuments?: InputMaybe<Scalars['Int']>;
  /** Filter for transactions has more than minimum number of overdue documents. */
  minOverdueDocuments?: InputMaybe<Scalars['Int']>;
  /** Filter for transactions has more than minimum number of documents rejected by brokers. */
  minRejectedDocuments?: InputMaybe<Scalars['Int']>;
  productTypes?: InputMaybe<Array<OdProtosInstitutionsReithouseData_Transaction_Type>>;
  /** Filter for transactions by the state of the property. */
  propertyStates?: InputMaybe<Array<OdProtosInstitutionsReithouseData_Transaction_State>>;
  /** Filter for transactions by title company. */
  titleName?: InputMaybe<Scalars['String']>;
  /** Filter for transactions by transaction types. Replace with product_types. */
  transactionTypes?: InputMaybe<Array<Scalars['String']>>;
  /** Filter for transactions by geographic US state. */
  usStates?: InputMaybe<Array<OdProtosCommonState_State>>;
};

/** Filter for archived transactions */
export type OdProtosInstitutionsReithouseServices_SearchTransactionsRequest_Filters_ArchivedState =
  | 'ALL_ARCHIVED_AND_UNARCHIVED'
  | 'ONLY_ARCHIVED'
  | 'ONLY_UNARCHIVED';

/** Filter for transactions that have documents that need review. */
export type OdProtosInstitutionsReithouseServices_SearchTransactionsRequest_Filters_DocumentReviewState =
  | 'ALL'
  | 'NEEDS_REVIEW'
  | 'REVIEWED';

export type OdProtosInstitutionsReithouseServices_SearchTransactionsRequest_OrderByOption =
  | 'ARCHIVED_ASC'
  | 'ARCHIVED_DESC'
  /** COE: Close of Escrow date */
  | 'COE_ASC'
  /** COE: Close of Escrow date */
  | 'COE_DESC'
  | 'NAME_ASC'
  | 'NAME_DESC'
  /** number of overdue documents */
  | 'OVERDUE_DOCUMENTS_ASC'
  /** number of overdue documents */
  | 'OVERDUE_DOCUMENTS_DESC'
  /** number of rejected document by brokers */
  | 'REJECTED_DOCUMENTS_ASC'
  /** number of rejected document by brokers */
  | 'REJECTED_DOCUMENTS_DESC'
  /** earliest broker review due by date */
  | 'REVIEW_DUE_ASC'
  /** earliest broker review due by date */
  | 'REVIEW_DUE_DESC'
  | 'STATE_ASC'
  | 'STATE_DESC';

export type OdProtosInstitutionsReithouseServices_SetTermDocumentIdRequestInput = {
  id?: InputMaybe<Scalars['String']>;
  includedInDocumentId?: InputMaybe<Scalars['String']>;
};

export type OdProtosInstitutionsReithouseServices_TransactionDocumentDescriptorsRequestInput = {
  /**
   * Filters document type included in the list if set
   * If not set, all document types are returned
   */
  includeClasses?: InputMaybe<Array<OdProtosInstitutionsReithouseData_DocumentDescriptor_Class>>;
  /**
   * Filters document status included in the list if set
   * If not set, only active document types are returned
   */
  includeStatuses?: InputMaybe<Array<OdProtosInstitutionsReithouseData_DocumentDescriptor_Status>>;
  transactionInfo?: InputMaybe<OdProtosInstitutionsReithouseServices_TransactionLookupInfoInput>;
};

/** Transaction messages */
export type OdProtosInstitutionsReithouseServices_TransactionIdInput = {
  transactionId?: InputMaybe<Scalars['String']>;
};

/**
 * Describe the transaction
 * The more information provided the better results can be given
 */
export type OdProtosInstitutionsReithouseServices_TransactionLookupInfoInput = {
  /** The address where the transaction is happening. (REQUIRED) */
  addressId?: InputMaybe<Scalars['String']>;
  branchIds?: InputMaybe<Array<Scalars['String']>>;
  /** The home detail id as provided by home data store */
  homeDetailId?: InputMaybe<Scalars['String']>;
  /** If provided, only transactions with the given product_type are returned */
  productType?: InputMaybe<OdProtosInstitutionsReithouseData_Transaction_Type>;
  /**
   * vendor_ids:
   *  The brokerage vendors involved
   *
   *  branch_ids:
   *  The vendor branches (used to represent different work flows) involved
   *
   *  Document descriptors that have vendor set to null apply to all vendors.
   *  Similarly, descriptors that have branch set to null apply to all branches.
   *  If the vendor is set but the branch is null, then the descriptor apply to
   *  all branches in that vendor.
   *
   *  Because of the above, it is recommended to always supply the vendor if the
   *  branch is supplied. This way, we can return descriptors that apply to:
   *
   *  * all vendors
   *  * all branches in the specified vendor(s)
   *  * the specified branch(es)
   *
   *  Only supplying the branch qualifier will result in missing the second subset
   *  of applicable document descriptors.
   */
  vendorIds?: InputMaybe<Array<Scalars['String']>>;
  /**
   * The year the home was built
   * year_built in home_detail supersedes this if available
   */
  yearBuilt?: InputMaybe<Scalars['Float']>;
};

export type OdProtosInstitutionsReithouseServices_TransitionTransactionRequestInput = {
  /**
   * If this flag is set to true, response will contain violations, if any,
   * but will not actually transition state even if there are no violations
   */
  dryRun?: InputMaybe<Scalars['Boolean']>;
  notes?: InputMaybe<Scalars['String']>;
  /**
   * Whether or not you want to ignore the transaction's rules
   * when trying to transition state
   */
  overrideRules?: InputMaybe<Scalars['Boolean']>;
  party?: InputMaybe<OdProtosInstitutionsReithouseData_Party>;
  reason?: InputMaybe<Scalars['String']>;
  /** Transaction to update. */
  transactionId?: InputMaybe<Scalars['String']>;
  /** State to transition to. */
  transitionToState?: InputMaybe<OdProtosInstitutionsReithouseData_Transaction_State>;
};

export type OdProtosInstitutionsReithouseServices_UnarchiveTransactionRequestInput = {
  party?: InputMaybe<OdProtosInstitutionsReithouseData_Party>;
  /** Transaction to update. */
  transactionId?: InputMaybe<Scalars['String']>;
};

export type OdProtosInstitutionsReithouseServices_UnreleaseContingencyTermRequestInput = {
  id?: InputMaybe<Scalars['String']>;
};

/**
 * Copied non-deprecated fields from data.DocumentDescriptor
 * This endpoint expects all fields to be set on request
 * and will clear any unset fields. It does NOT perform partial updates.
 */
export type OdProtosInstitutionsReithouseServices_UpdateDocumentDescriptorRequestInput = {
  asset?: InputMaybe<OdProtosInstitutionsReithouseData_AssetInput>;
  branchId?: InputMaybe<Scalars['String']>;
  builtAfterYear?: InputMaybe<Scalars['Float']>;
  /** qualifiers */
  builtBeforeYear?: InputMaybe<Scalars['Float']>;
  canHaveMultiple?: InputMaybe<Scalars['Boolean']>;
  class?: InputMaybe<OdProtosInstitutionsReithouseData_DocumentDescriptor_Class>;
  displayClass?: InputMaybe<Scalars['String']>;
  federal?: InputMaybe<Scalars['Boolean']>;
  /** Next id: 20 */
  id?: InputMaybe<Scalars['String']>;
  isForHoa?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  requiredSignatures?: InputMaybe<OdProtosInstitutionsReithouseData_PartyListInput>;
  state?: InputMaybe<OdProtosCommonState_State>;
  status?: InputMaybe<OdProtosInstitutionsReithouseData_DocumentDescriptor_Status>;
  vendorId?: InputMaybe<Scalars['String']>;
};

/** next: 10 */
export type OdProtosInstitutionsReithouseServices_UpdateDocumentRequestInput = {
  /** DocumentVersion to set as the active version. */
  activeDocumentVersionId?: InputMaybe<Scalars['String']>;
  /** A number to uniquely identify an amendment in a transaction */
  amendmentNumber?: InputMaybe<Scalars['Int']>;
  /** Signature requirement for buyer */
  buyerSignatureRequirement?: InputMaybe<OdProtosInstitutionsReithouseData_Document_SignatureRequirement>;
  /** DocumentVersion to set as the active version. */
  currentDocumentVersionId?: InputMaybe<Scalars['String']>;
  /** Class that describes this document. */
  documentDescriptorClass?: InputMaybe<OdProtosInstitutionsReithouseData_DocumentDescriptor_Class>;
  /** Updated document descriptor id that describes this document. */
  documentDescriptorId?: InputMaybe<Scalars['String']>;
  /** Document to update. */
  documentId?: InputMaybe<Scalars['String']>;
  /** Display name. */
  name?: InputMaybe<Scalars['String']>;
  /** Signature requirement for seller */
  sellerSignatureRequirement?: InputMaybe<OdProtosInstitutionsReithouseData_Document_SignatureRequirement>;
};

export type OdProtosInstitutionsReithouseServices_UpdateDocumentVersionRequestInput = {
  buyerSigned?: InputMaybe<Scalars['Boolean']>;
  cabinetAssetId?: InputMaybe<Scalars['String']>;
  /** Date when document version was executed. */
  fullySignedDate?: InputMaybe<OdProtosCommon_DateInput>;
  id?: InputMaybe<Scalars['String']>;
  sellerSigned?: InputMaybe<Scalars['Boolean']>;
};

export type OdProtosInstitutionsReithouseServices_UpdateGroupSpecificRequestInput = {
  /** required */
  documentDescriptorId?: InputMaybe<Scalars['String']>;
  domain?: InputMaybe<OdProtosInstitutionsReithouseServices_UpdateGroupSpecificRequest_DomainOneofInput>;
  /** required */
  productType?: InputMaybe<OdProtosInstitutionsReithouseData_Transaction_Type>;
};

export type OdProtosInstitutionsReithouseServices_UpdateGroupSpecificRequest_DomainOneofInput = {
  updateClearinghouseSpecific?: InputMaybe<OdProtosInstitutionsReithouseServices_UpdateGroupSpecificRequest_UpdateClearinghouseSpecificInput>;
};

export type OdProtosInstitutionsReithouseServices_UpdateGroupSpecificRequest_UpdateClearinghouseSpecificInput = {
  helloritoTemplateId?: InputMaybe<Scalars['String']>;
  includedChTerms?: InputMaybe<OdProtosInstitutionsReithouseServices_UpdateGroupSpecificRequest_UpdateClearinghouseSpecific_UpdateIncludedChTermsInput>;
  isRequiredForChArchive?: InputMaybe<Scalars['Boolean']>;
  needsBrokerReviewInChStates?: InputMaybe<OdProtosInstitutionsReithouseServices_UpdateGroupSpecificRequest_UpdateClearinghouseSpecific_UpdateNeedsBrokerReviewInChStatesInput>;
  /** for comments about what each field is, see data.ClearinghouseSpecific */
  requiredForChState?: InputMaybe<OdProtosInstitutionsReithouseData_ClearinghouseSpecific_ClearinghouseState>;
  templateFields?: InputMaybe<OdProtosInstitutionsReithouseServices_UpdateGroupSpecificRequest_UpdateClearinghouseSpecific_UpdateTemplateFieldsInput>;
};

export type OdProtosInstitutionsReithouseServices_UpdateGroupSpecificRequest_UpdateClearinghouseSpecific_UpdateIncludedChTermsInput = {
  includedChTerms?: InputMaybe<Array<OdProtosInstitutionsReithouseData_ClearinghouseSpecific_ClearinghouseTerm>>;
};

export type OdProtosInstitutionsReithouseServices_UpdateGroupSpecificRequest_UpdateClearinghouseSpecific_UpdateNeedsBrokerReviewInChStatesInput = {
  needsBrokerReviewInChStates?: InputMaybe<Array<OdProtosInstitutionsReithouseData_ClearinghouseSpecific_ClearinghouseState>>;
};

export type OdProtosInstitutionsReithouseServices_UpdateGroupSpecificRequest_UpdateClearinghouseSpecific_UpdateTemplateFieldsInput = {
  templateFields?: InputMaybe<Array<OdProtosInstitutionsReithouseData_TemplateFieldDescriptorInput>>;
};

export type OdProtosInstitutionsReithouseServices_UpdateParticipantRequestInput = {
  contact?: InputMaybe<OdProtosInstitutionsReithouseDataCommon_ContactInput>;
  observerType?: InputMaybe<Scalars['String']>;
  participantId?: InputMaybe<Scalars['String']>;
  party?: InputMaybe<OdProtosInstitutionsReithouseData_Party>;
  role?: InputMaybe<OdProtosInstitutionsReithouseData_Participant_Role>;
};

export type OdProtosInstitutionsReithouseServices_UpdateTransactionReasonRequestInput = {
  /** if a value for this field is not supplied, request will use the notes of prior transaction event */
  notes?: InputMaybe<Scalars['String']>;
  party?: InputMaybe<OdProtosInstitutionsReithouseData_Party>;
  reason?: InputMaybe<Scalars['String']>;
  transactionId?: InputMaybe<Scalars['String']>;
};

/** Next: 24 */
export type OdProtosInstitutionsReithouseServices_UpdateTransactionRequestInput = {
  /** Access instructions for the property. */
  accessInstructions?: InputMaybe<Scalars['String']>;
  /** Related MLS listings to add. */
  addMlsIds?: InputMaybe<Array<OdProtosInstitutionsReithouseDataCommon_MlsidInput>>;
  /** Address of the home being transacted. */
  addressId?: InputMaybe<Scalars['String']>;
  /** Binding date */
  bindingDate?: InputMaybe<OdProtosCommon_DateInput>;
  /** Buyer party specific data. */
  buyerParty?: InputMaybe<OdProtosInstitutionsReithouseServices_UpdateTransactionRequest_PartySpecificInput>;
  /** Date that the certificate of occupancy will be received. */
  certificateOfOccupancyDate?: InputMaybe<OdProtosCommon_DateInput>;
  /** Date of close of escrow of the transaction. */
  closeOfEscrowDate?: InputMaybe<OdProtosCommon_DateInput>;
  discoveryNotes?: InputMaybe<Scalars['String']>;
  /** Links to related transaction pages */
  externalLinks?: InputMaybe<Array<OdProtosInstitutionsReithouseData_ExternalLinkInput>>;
  highestAndBestDate?: InputMaybe<OdProtosCommon_DateInput>;
  /** Highest and best offer deadline. */
  highestAndBestDeadline?: InputMaybe<Scalars['DateTime']>;
  highestAndBestTime?: InputMaybe<OdProtosCommon_TimeInput>;
  /** Home details of the home being transacted. */
  homeDetailId?: InputMaybe<Scalars['String']>;
  /** Transaction to update. */
  id?: InputMaybe<Scalars['String']>;
  /** Set when the transaction is for a multioffer listing */
  isMultioffer?: InputMaybe<Scalars['Boolean']>;
  /** Set when the property is a new build. */
  isNewBuild?: InputMaybe<Scalars['Boolean']>;
  /** Set when the property is vacant. */
  isVacant?: InputMaybe<Scalars['Boolean']>;
  /** Display name. */
  name?: InputMaybe<Scalars['String']>;
  /** Related ODLS SellRequest. */
  odlsSellRequestId?: InputMaybe<Scalars['String']>;
  /** Related ODLS SellResponse. */
  odlsSellResponseId?: InputMaybe<Scalars['String']>;
  /** Purchase price of the home being transacted. */
  purchasePrice?: InputMaybe<OdProtosCommon_MoneyInput>;
  /** Related MLS listings to remove. */
  removeMlsIds?: InputMaybe<Array<OdProtosInstitutionsReithouseDataCommon_MlsidInput>>;
  sellerInterested?: InputMaybe<Scalars['Boolean']>;
  /** Seller party specific data. */
  sellerParty?: InputMaybe<OdProtosInstitutionsReithouseServices_UpdateTransactionRequest_PartySpecificInput>;
};

/** Data specific to a party of the transaction. */
export type OdProtosInstitutionsReithouseServices_UpdateTransactionRequest_PartySpecificInput = {
  /** Agent Team that owns this transaction. */
  agentVendorBranchId?: InputMaybe<Scalars['String']>;
  /** Brokerage that owns this transaction. */
  brokerageVendorBranchId?: InputMaybe<Scalars['String']>;
  /** Escrow Org for party */
  escrowOrgId?: InputMaybe<Scalars['String']>;
  /** Rule set to use for this transaction. */
  ruleSetId?: InputMaybe<OdProtosInstitutionsReithouseDataCommon_VersionedIdInput>;
  /** Title Org for party */
  titleOrgId?: InputMaybe<Scalars['String']>;
};

export type OdProtosInstitutionsServices_AddAgentOperatorEligibilityRequestInput = {
  agentOperatorId?: InputMaybe<Scalars['Float']>;
  allMarkets?: InputMaybe<Scalars['Boolean']>;
  allReits?: InputMaybe<Scalars['Boolean']>;
  allSellableTypes?: InputMaybe<Scalars['Boolean']>;
  brokerageRegionId?: InputMaybe<Scalars['Float']>;
  /** this field is only set for LCEP agent operators */
  coverageOnly?: InputMaybe<Scalars['Boolean']>;
  market?: InputMaybe<OdProtosCommonMarket_Market>;
  reitId?: InputMaybe<Scalars['Float']>;
  roles?: InputMaybe<Array<OdProtosInstitutionsData_MemberRole>>;
  sellableType?: InputMaybe<OdProtosInstitutionsData_Sellable_Type>;
};

export type OdProtosInstitutionsServices_BidElasticsearchRequestInput = {
  aggs?: InputMaybe<OdProtosInstitutionsServices_BidElasticsearchRequest_AggsInput>;
  filter?: InputMaybe<OdProtosInstitutionsServices_BidElasticsearchRequest_FilterInput>;
  paginationRequest?: InputMaybe<OdProtosCommonPagination_PaginationRequestInput>;
  sort?: InputMaybe<OdProtosInstitutionsServices_BidElasticsearchRequest_SortInput>;
};

/**
 * Placeholder for interacting with *aggs* from the Elasticsearch Search API.
 * https://www.elastic.co/guide/en/elasticsearch/reference/current/search-aggregations.html
 */
export type OdProtosInstitutionsServices_BidElasticsearchRequest_AggsInput = {
  _empty?: InputMaybe<Scalars['Boolean']>;
};

export type OdProtosInstitutionsServices_BidElasticsearchRequest_FilterInput = {
  addressTokens?: InputMaybe<Array<Scalars['String']>>;
  assigneeHumanTokens?: InputMaybe<Array<Scalars['String']>>;
  /** if no bid states are passed it, we default to only live bid states */
  bidStates?: InputMaybe<Array<OdProtosInstitutionsData_BidState>>;
  buyerIds?: InputMaybe<Array<Scalars['Float']>>;
  inspectionStates?: InputMaybe<Array<OdProtosInstitutionsData_InspectionState>>;
  markets?: InputMaybe<Array<OdProtosCommonMarket_Market>>;
  sellableTypes?: InputMaybe<Array<OdProtosInstitutionsData_Sellable_Type>>;
};

export type OdProtosInstitutionsServices_BidElasticsearchRequest_SortInput = {
  sortField?: InputMaybe<OdProtosInstitutionsServices_BidElasticsearchRequest_Sort_Field>;
  sortOrder?: InputMaybe<OdProtosInstitutionsServices_BidElasticsearchRequest_Sort_Order>;
};

export type OdProtosInstitutionsServices_BidElasticsearchRequest_Sort_Field =
  | 'ADDRESS'
  | 'BID_PRICE'
  | 'CEP'
  | 'EMD_DUE_DATE'
  | 'FIELD_UNKNOWN'
  | 'INSPECTION_CONTINGENCY_DATE'
  | 'INSPECTION_SCHEDULED_AT_DATE'
  | 'LISTING_STATUS'
  | 'OFFER_DATE'
  | 'OFFER_RECEIVED_AT'
  | 'PRIMARY_AGENT';

export type OdProtosInstitutionsServices_BidElasticsearchRequest_Sort_Order =
  | 'ASC'
  | 'DESC'
  | 'ORDER_UNKNOWN';

export type OdProtosInstitutionsServices_BidOmniSearchRequestInput = {
  search?: InputMaybe<Scalars['String']>;
};

/** Next id: 7 */
export type OdProtosInstitutionsServices_BidSearchRequestInput = {
  filters?: InputMaybe<OdProtosInstitutionsServices_BidSearchRequest_FiltersInput>;
  paginationRequest?: InputMaybe<OdProtosCommonPagination_PaginationRequestInput>;
};

export type OdProtosInstitutionsServices_BidSearchRequest_FiltersInput = {
  addressIds?: InputMaybe<Array<Scalars['String']>>;
  assigneeHumanTokens?: InputMaybe<Array<Scalars['String']>>;
  onlyEndedAuctions?: InputMaybe<Scalars['Boolean']>;
  /** if referral_source is not specified, search all referral options */
  referralSourcedBys?: InputMaybe<Array<OdProtosInstitutionsData_Bid_ReferralSourcedBy>>;
  sellableTypes?: InputMaybe<Array<OdProtosInstitutionsData_AuctionType>>;
  /** if no bid states are passed in, we default to only live bid states */
  states?: InputMaybe<Array<OdProtosInstitutionsData_BidState>>;
};

export type OdProtosInstitutionsServices_BulkGetSellableRequestInput = {
  sellableIds?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosInstitutionsServices_BulkUpdateTaskConfigsRequestInput = {
  reitMarketsToAdd?: InputMaybe<Array<OdProtosInstitutionsTasks_Conditions_ReitMarketInput>>;
  reitMarketsToRemove?: InputMaybe<Array<OdProtosInstitutionsTasks_Conditions_ReitMarketInput>>;
  taskConfigIds?: InputMaybe<Array<Scalars['Float']>>;
};

export type OdProtosInstitutionsServices_CopyAndUpdateTaskConfigRequestInput = {
  /** Updates for the new task config. */
  name?: InputMaybe<Scalars['String']>;
  preferences?: InputMaybe<OdProtosInstitutionsTasks_TaskConfig_PreferencesInput>;
  preferencesFieldMask?: InputMaybe<GoogleProtobuf_FieldMaskInput>;
  /**
   * Source task config id. The specific *reit_markets* that are "copied" to the
   * new task config are removed from the source task config's all_conditions and
   * added to its none_conditions.
   */
  sourceTaskConfigId?: InputMaybe<Scalars['Float']>;
  /**
   * Specific reit market selections for the new task config. For v1 these must
   * be a subset of reit markets in the source task config.
   */
  specificReitMarkets?: InputMaybe<Array<OdProtosInstitutionsTasks_Conditions_ReitMarketInput>>;
};

export type OdProtosInstitutionsServices_CreateAdminBidRequestInput = {
  bidAmountUsd?: InputMaybe<Scalars['Float']>;
  buyerId?: InputMaybe<Scalars['Float']>;
  commisionPct?: InputMaybe<Scalars['Float']>;
  /** The OX_Listing product type is used instead in bid creation. */
  isOxListing?: InputMaybe<Scalars['Boolean']>;
  leadId?: InputMaybe<Scalars['String']>;
  maxBidAmountUsd?: InputMaybe<Scalars['Float']>;
  reitId?: InputMaybe<Scalars['Float']>;
  sellableId?: InputMaybe<Scalars['String']>;
  submissionInfo?: InputMaybe<OdProtosInstitutionsData_Bid_SubmissionInfoInput>;
  transactionType?: InputMaybe<OdProtosInstitutionsReithouseData_Transaction_Type>;
};

export type OdProtosInstitutionsServices_CreateAgentOperatorRequestInput = {
  /** this field is only set for LCEP - left null for other agent operators */
  dailyCapacityLimit?: InputMaybe<Scalars['Int']>;
  dailyListingCapacityLimit?: InputMaybe<Scalars['Int']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  humanToken?: InputMaybe<Scalars['String']>;
  roles?: InputMaybe<Array<OdProtosInstitutionsData_MemberRole>>;
  totalCapacityLimit?: InputMaybe<Scalars['Float']>;
  totalListingCapacityLimit?: InputMaybe<Scalars['Int']>;
};

export type OdProtosInstitutionsServices_CreateBrokerageRegionRequestInput = {
  market?: InputMaybe<OdProtosCommonMarket_Market>;
  preferences?: InputMaybe<OdProtosInstitutionsData_BrokerageRegion_PreferencesInput>;
  state?: InputMaybe<OdProtosCommonState_State>;
};

export type OdProtosInstitutionsServices_CreateLeadFromSellRequestRequestInput = {
  sellRequestId?: InputMaybe<Scalars['String']>;
};

export type OdProtosInstitutionsServices_CreateLeadRequestInput = {
  addressId?: InputMaybe<Scalars['String']>;
  assessmentLink?: InputMaybe<Scalars['String']>;
  availableAt?: InputMaybe<OdProtosCommon_DateInput>;
  brokerageId?: InputMaybe<Scalars['String']>;
  brokerageName?: InputMaybe<Scalars['String']>;
  /** replaced by flat_cents and percentage fields */
  buyerCommission?: InputMaybe<Scalars['Float']>;
  buyerCommissionFlatCents?: InputMaybe<Scalars['Int']>;
  /** will be removed once we fully replace it with rate_bips in BE */
  buyerCommissionPercentage?: InputMaybe<Scalars['Float']>;
  buyerCommissionRateBips?: InputMaybe<Scalars['Int']>;
  closingTimeline?: InputMaybe<Scalars['Int']>;
  endsAt?: InputMaybe<OdProtosCommon_DateInput>;
  flipToken?: InputMaybe<Scalars['String']>;
  isNewBuild?: InputMaybe<Scalars['Boolean']>;
  leadType?: InputMaybe<OdProtosInstitutionsData_LeadType>;
  listPriceUsd?: InputMaybe<Scalars['Int']>;
  listingAgents?: InputMaybe<Array<OdProtosInstitutionsData_Lead_ListingAgentInput>>;
  newBuildInfo?: InputMaybe<OdProtosInstitutionsData_Lead_NewBuildInfoInput>;
  photoLink?: InputMaybe<Scalars['String']>;
  privateNotes?: InputMaybe<Scalars['String']>;
  publicNotes?: InputMaybe<Scalars['String']>;
  sellers?: InputMaybe<Array<OdProtosInstitutionsData_Lead_SellerInput>>;
  state?: InputMaybe<OdProtosInstitutionsData_Lead_LeadState>;
};

export type OdProtosInstitutionsServices_CreateNegotiationRequestInput = {
  /** Convenience gRPC request metadata that will be refactored */
  metadata?: InputMaybe<Scalars['String']>;
  negotiation?: InputMaybe<OdProtosInstitutionsData_NegotiationInput>;
};

export type OdProtosInstitutionsServices_CreateReitRequestInput = {
  /** Optional */
  buyerIds?: InputMaybe<Array<Scalars['Float']>>;
  human?: InputMaybe<OdProtosInstitutionsServices_CreateReitRequest_HumanInput>;
  isBroker?: InputMaybe<Scalars['Boolean']>;
  reit?: InputMaybe<OdProtosInstitutionsServices_CreateReitRequest_OrganizationInput>;
};

export type OdProtosInstitutionsServices_CreateReitRequest_HumanInput = {
  email?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
};

export type OdProtosInstitutionsServices_CreateReitRequest_OrganizationInput = {
  email?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  shortName?: InputMaybe<Scalars['String']>;
};

export type OdProtosInstitutionsServices_CreateTagRequestInput = {
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type OdProtosInstitutionsServices_CreateTaskConfigRequestInput = {
  caseyTaskType?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  preferences?: InputMaybe<OdProtosInstitutionsTasks_TaskConfig_PreferencesInput>;
};

export type OdProtosInstitutionsServices_DeleteAgentOperatorEligibilityRequestInput = {
  id?: InputMaybe<Scalars['Float']>;
};

export type OdProtosInstitutionsServices_DeleteAgentOperatorRequestInput = {
  id?: InputMaybe<Scalars['Float']>;
};

export type OdProtosInstitutionsServices_DeleteTaskConfigRequestInput = {
  taskConfigId?: InputMaybe<Scalars['Float']>;
};

export type OdProtosInstitutionsServices_ExternalRequest_DownloadBidsViewRequestInput = {
  filters?: InputMaybe<OdProtosInstitutionsServices_ExternalRequest_GetBidsViewRequest_FiltersInput>;
};

export type OdProtosInstitutionsServices_ExternalRequest_GetBidsSummaryRequestInput = {
  filters?: InputMaybe<OdProtosInstitutionsServices_ExternalRequest_GetBidsSummaryRequest_FiltersInput>;
};

export type OdProtosInstitutionsServices_ExternalRequest_GetBidsSummaryRequest_FiltersInput = {
  reitId?: InputMaybe<Scalars['Float']>;
};

export type OdProtosInstitutionsServices_ExternalRequest_GetBidsViewRequestInput = {
  filters?: InputMaybe<OdProtosInstitutionsServices_ExternalRequest_GetBidsViewRequest_FiltersInput>;
  offsetPaginationRequest?: InputMaybe<OdProtosCommonPagination_OffsetPaginationRequestInput>;
  sort?: InputMaybe<OdProtosInstitutionsServices_ExternalRequest_GetBidsViewRequest_SortInput>;
};

export type OdProtosInstitutionsServices_ExternalRequest_GetBidsViewRequest_FiltersInput = {
  bidStatuses?: InputMaybe<Array<OdProtosInstitutionsExternal_BidStatus>>;
  bidTokens?: InputMaybe<Array<Scalars['String']>>;
  bindingDate?: InputMaybe<OdProtosInstitutionsData_DateRangeInput>;
  closeOfEscrow?: InputMaybe<OdProtosInstitutionsData_DateRangeInput>;
  inspectionContingencyDeadline?: InputMaybe<OdProtosInstitutionsData_DateRangeInput>;
  inspectionDate?: InputMaybe<OdProtosInstitutionsData_DateRangeInput>;
  markets?: InputMaybe<Array<OdProtosCommonMarket_Market>>;
  mlses?: InputMaybe<Array<OdProtosCommonMls_Mls>>;
  nextActions?: InputMaybe<Array<OdProtosInstitutionsExternal_NextAction_Type>>;
  nextMilestones?: InputMaybe<Array<Scalars['String']>>;
  reitIds?: InputMaybe<Array<Scalars['Float']>>;
  sellableTypes?: InputMaybe<Array<OdProtosInstitutionsData_Sellable_Type>>;
  submittedByHumanTokens?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosInstitutionsServices_ExternalRequest_GetBidsViewRequest_SortInput = {
  direction?: InputMaybe<OdProtosInstitutionsServices_ExternalRequest_GetBidsViewRequest_Sort_Direction>;
  field?: InputMaybe<OdProtosInstitutionsServices_ExternalRequest_GetBidsViewRequest_Sort_Field>;
};

export type OdProtosInstitutionsServices_ExternalRequest_GetBidsViewRequest_Sort_Direction =
  | 'ASC'
  | 'DESC';

export type OdProtosInstitutionsServices_ExternalRequest_GetBidsViewRequest_Sort_Field =
  | 'ADDRESS'
  | 'MARKET'
  | 'NEXT_ACTIONS'
  | 'NEXT_MILESTONE'
  | 'PRODUCT_TYPE'
  | 'STATUS'
  | 'UPDATED_AT';

export type OdProtosInstitutionsServices_FindAddressRequestInput = {
  city?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<OdProtosCommonState_State>;
  street?: InputMaybe<Scalars['String']>;
  unitNumber?: InputMaybe<Scalars['String']>;
};

export type OdProtosInstitutionsServices_FindOrCreateAddressRequestInput = {
  city?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<OdProtosCommonState_State>;
  street?: InputMaybe<Scalars['String']>;
  unitNumber?: InputMaybe<Scalars['String']>;
};

export type OdProtosInstitutionsServices_GetActivitiesRequestInput = {
  filters?: InputMaybe<OdProtosInstitutionsServices_GetActivitiesRequest_FiltersInput>;
  paginationRequest?: InputMaybe<OdProtosCommonPagination_PaginationRequestInput>;
};

export type OdProtosInstitutionsServices_GetActivitiesRequest_FiltersInput = {
  activityTypes?: InputMaybe<Array<OdProtosInstitutionsData_Activity_Type>>;
  allUsers?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<OdProtosInstitutionsData_TimestampRangeInput>;
};

export type OdProtosInstitutionsServices_GetAgentOperatorAssignmentForListingRequestInput = {
  brokerageRegionId?: InputMaybe<Scalars['Float']>;
  excludedHumanTokens?: InputMaybe<Array<Scalars['String']>>;
  reitId?: InputMaybe<Scalars['Float']>;
  role?: InputMaybe<OdProtosInstitutionsData_MemberRole>;
};

export type OdProtosInstitutionsServices_GetAlertsForBidRequestInput = {
  alertType?: InputMaybe<OdProtosInstitutionsData_Alert_AlertType>;
  bidUuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosInstitutionsServices_GetAllAgentOperatorsRequestInput = {
  enabledOnly?: InputMaybe<Scalars['Boolean']>;
};

export type OdProtosInstitutionsServices_GetAllBrokerageRegionsRequestInput = {
  _empty?: InputMaybe<Scalars['Boolean']>;
};

export type OdProtosInstitutionsServices_GetAllTagsRequestInput = {
  _empty?: InputMaybe<Scalars['Boolean']>;
};

export type OdProtosInstitutionsServices_GetAuctionsWithBidsRequestInput = {
  flipTokens?: InputMaybe<Array<Scalars['String']>>;
  /** Convenience gRPC request metadata that will be refactored */
  metadata?: InputMaybe<Scalars['String']>;
};

/** Next id: 7 */
export type OdProtosInstitutionsServices_GetAuctionsWithLiveBidsRequestInput = {
  addressIds?: InputMaybe<Array<Scalars['String']>>;
  assigneeHumanTokens?: InputMaybe<Array<Scalars['String']>>;
  auctionTypes?: InputMaybe<Array<OdProtosInstitutionsData_AuctionType>>;
  /** if no bid states are passed it, we default to only live bid states */
  bidStates?: InputMaybe<Array<OdProtosInstitutionsData_BidState>>;
  metadata?: InputMaybe<Scalars['String']>;
  onlyEndedAuctions?: InputMaybe<Scalars['Boolean']>;
};

export type OdProtosInstitutionsServices_GetBidAssigneesRequestInput = {
  bidIds?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosInstitutionsServices_GetBidEventsRequestInput = {
  filters?: InputMaybe<OdProtosInstitutionsServices_GetBidEventsRequest_FiltersInput>;
};

export type OdProtosInstitutionsServices_GetBidEventsRequest_FiltersInput = {
  bidToken?: InputMaybe<Scalars['String']>;
  /** Optional */
  types?: InputMaybe<Array<OdProtosInstitutionsData_Event_Type>>;
};

export type OdProtosInstitutionsServices_GetBidRequestInput = {
  uuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosInstitutionsServices_GetBidsForSellableRequestInput = {
  auctionType?: InputMaybe<OdProtosInstitutionsData_AuctionType>;
  externalId?: InputMaybe<Scalars['String']>;
  /** Convenience gRPC request metadata that will be refactored */
  metadata?: InputMaybe<Scalars['String']>;
};

export type OdProtosInstitutionsServices_GetBidsRequestInput = {
  uuids?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosInstitutionsServices_GetBrokerageRegionsRequestInput = {
  identifiers?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosInstitutionsServices_GetCurrentUserRequestInput = {
  _empty?: InputMaybe<Scalars['Boolean']>;
};

export type OdProtosInstitutionsServices_GetDownloadableLeadsRequestInput = {
  leadIds?: InputMaybe<Array<Scalars['String']>>;
  reitId?: InputMaybe<Scalars['Float']>;
};

export type OdProtosInstitutionsServices_GetLatestAuctionDetailsRequestInput = {
  auctionType?: InputMaybe<OdProtosInstitutionsData_AuctionType>;
  externalId?: InputMaybe<Scalars['String']>;
  /** Convenience gRPC request metadata that will be refactored */
  metadata?: InputMaybe<Scalars['String']>;
};

export type OdProtosInstitutionsServices_GetLatestLeadUpdatedAtByMlsNameRequestInput = {
  mlsName?: InputMaybe<Scalars['String']>;
};

export type OdProtosInstitutionsServices_GetLeadBySellRequestIdRequestInput = {
  sellRequestId?: InputMaybe<Scalars['String']>;
};

export type OdProtosInstitutionsServices_GetLeadDetailRequestInput = {
  leadId?: InputMaybe<Scalars['String']>;
};

export type OdProtosInstitutionsServices_GetLeadHistoryRequestInput = {
  field?: InputMaybe<Scalars['String']>;
  leadId?: InputMaybe<Scalars['String']>;
};

export type OdProtosInstitutionsServices_GetLeadsRequestInput = {
  leadIds?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosInstitutionsServices_GetMarketSettingsForReitRequestInput = {
  reitId?: InputMaybe<Scalars['Float']>;
};

export type OdProtosInstitutionsServices_GetNotificationsRequestInput = {
  filters?: InputMaybe<OdProtosInstitutionsServices_GetNotificationsRequest_FiltersInput>;
  paginationRequest?: InputMaybe<OdProtosCommonPagination_PaginationRequestInput>;
};

export type OdProtosInstitutionsServices_GetNotificationsRequest_FiltersInput = {
  activityTypes?: InputMaybe<Array<OdProtosInstitutionsData_Activity_Type>>;
  unreadOnly?: InputMaybe<Scalars['Boolean']>;
};

export type OdProtosInstitutionsServices_GetOdaResolvedHomeDetailRequestInput = {
  /** Address Id of the home */
  addressToken?: InputMaybe<Scalars['String']>;
  /** Convenience gRPC request metadata that will be refactored */
  metadata?: InputMaybe<Scalars['String']>;
};

export type OdProtosInstitutionsServices_GetPermissionsForCurrentUserRequestInput = {
  _empty?: InputMaybe<Scalars['Boolean']>;
};

export type OdProtosInstitutionsServices_GetPipelineViewBidsRequestInput = {
  filter?: InputMaybe<OdProtosInstitutionsServices_GetPipelineViewBidsRequest_FilterInput>;
  offsetPaginationRequest?: InputMaybe<OdProtosCommonPagination_OffsetPaginationRequestInput>;
  paginationRequest?: InputMaybe<OdProtosCommonPagination_PaginationRequestInput>;
  sort?: InputMaybe<OdProtosInstitutionsServices_GetPipelineViewBidsRequest_SortInput>;
};

export type OdProtosInstitutionsServices_GetPipelineViewBidsRequest_FilterInput = {
  addressTokens?: InputMaybe<Array<Scalars['String']>>;
  assigneeHumanTokens?: InputMaybe<Array<Scalars['String']>>;
  /** if no bid states are passed it, we default to only live bid states */
  bidStates?: InputMaybe<Array<OdProtosInstitutionsData_BidState>>;
  bidTokens?: InputMaybe<Array<Scalars['String']>>;
  buyerReitIds?: InputMaybe<Array<Scalars['Float']>>;
  includeCoveringTransactions?: InputMaybe<Scalars['Boolean']>;
  inspectionStates?: InputMaybe<Array<OdProtosInstitutionsData_InspectionState>>;
  leadTypes?: InputMaybe<Array<OdProtosInstitutionsServices_GetPipelineViewBidsRequest_Filter_LeadType>>;
  markets?: InputMaybe<Array<OdProtosCommonMarket_Market>>;
  nextTaskDue?: InputMaybe<Scalars['DateTime']>;
  oxListingsFilter?: InputMaybe<OdProtosInstitutionsServices_GetPipelineViewBidsRequest_Filter_OxListingsFilter>;
  referralSourcedBys?: InputMaybe<Array<OdProtosInstitutionsData_Bid_ReferralSourcedBy>>;
  sellableTypes?: InputMaybe<Array<OdProtosInstitutionsData_Sellable_Type>>;
  tagIds?: InputMaybe<Array<Scalars['Float']>>;
};

export type OdProtosInstitutionsServices_GetPipelineViewBidsRequest_Filter_LeadType =
  | 'IS_VACANT'
  | 'NEW_BUILD'
  | 'REFERRAL_LISTING';

export type OdProtosInstitutionsServices_GetPipelineViewBidsRequest_Filter_OxListingsFilter =
  | 'EXCLUDE_OX_LISTINGS'
  | 'INCLUDE_ALL'
  | 'OX_LISTINGS_ONLY'
  | 'UNSPECIFIED';

export type OdProtosInstitutionsServices_GetPipelineViewBidsRequest_SortInput = {
  direction?: InputMaybe<OdProtosInstitutionsServices_GetPipelineViewBidsRequest_Sort_Direction>;
  field?: InputMaybe<OdProtosInstitutionsServices_GetPipelineViewBidsRequest_Sort_Field>;
};

export type OdProtosInstitutionsServices_GetPipelineViewBidsRequest_Sort_Direction =
  | 'ASC'
  | 'DESC';

export type OdProtosInstitutionsServices_GetPipelineViewBidsRequest_Sort_Field =
  | 'ADDRESS'
  | 'BID_STATE'
  | 'CLOSING_TEAM'
  | 'COE'
  | 'CURRENT_OFFER_AMOUNT'
  | 'CURRENT_OFFER_PERCENT_OF_LIST'
  | 'DD_END_DATE'
  | 'DOM'
  | 'FWT_DATE'
  | 'HB_DEADLINE'
  | 'INSPECTION_DATE'
  | 'IN_CONTRACT_AT'
  | 'LCEP'
  | 'LISTING_STATUS'
  | 'MAX_OFFER_AMOUNT'
  | 'NEXT_TASK_DUE'
  | 'OFFER_EXPIRATION_DATE'
  | 'OFFER_RECEIVED_AT'
  | 'RENT_BACK_DATE'
  | 'RESOLUTION_PERIOD'
  | 'TASK_COUNT'
  | 'UPDATED_AT';

export type OdProtosInstitutionsServices_GetPreferencesForBidRequestInput = {
  bidUuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosInstitutionsServices_GetReitForHumanRequestInput = {
  humanToken?: InputMaybe<Scalars['String']>;
};

export type OdProtosInstitutionsServices_GetReitRequestInput = {
  reitId?: InputMaybe<Scalars['Float']>;
};

export type OdProtosInstitutionsServices_GetReitSettingsRequestInput = {
  brokerageRegionId?: InputMaybe<Scalars['Float']>;
  reitId?: InputMaybe<Scalars['Float']>;
  sellableType?: InputMaybe<OdProtosInstitutionsData_Sellable_Type>;
};

export type OdProtosInstitutionsServices_GetReitsByIdRequestInput = {
  reitIds?: InputMaybe<Array<Scalars['Float']>>;
};

export type OdProtosInstitutionsServices_GetReitsRequestInput = {
  /** Convenience gRPC request metadata that will be refactored */
  metadata?: InputMaybe<Scalars['String']>;
};

export type OdProtosInstitutionsServices_GetRetradeDetailsRequestInput = {
  listingOfferId?: InputMaybe<Scalars['Float']>;
  /** Convenience gRPC request metadata that will be refactored */
  metadata?: InputMaybe<Scalars['String']>;
};

export type OdProtosInstitutionsServices_GetSellableRequestInput = {
  identifier?: InputMaybe<OdProtosInstitutionsServices_GetSellableRequest_IdentifierOneofInput>;
};

export type OdProtosInstitutionsServices_GetSellableRequest_IdentifierOneofInput = {
  addressId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  sellableInfo?: InputMaybe<OdProtosInstitutionsData_SellableInfoInput>;
};

export type OdProtosInstitutionsServices_GetSellableTypeEligibilitiesRequestInput = {
  reitId?: InputMaybe<Scalars['Float']>;
};

export type OdProtosInstitutionsServices_GetTaskConfigsByIdsRequestInput = {
  /**
   * Historically, tasks in Casey are have a different id in their sources.
   * TODO: Clean this up. Backfill TaskConfig.id in Casey? Deprecate Casey?
   */
  caseySourceIds?: InputMaybe<Array<Scalars['String']>>;
  taskConfigIds?: InputMaybe<Array<Scalars['Float']>>;
};

export type OdProtosInstitutionsServices_GetTaskConfigsRequestInput = {
  market?: InputMaybe<OdProtosCommonMarket_Market>;
  reitId?: InputMaybe<Scalars['Float']>;
  sellableType?: InputMaybe<OdProtosInstitutionsData_Sellable_Type>;
};

export type OdProtosInstitutionsServices_LeadsOmniSearchRequestInput = {
  search?: InputMaybe<Scalars['String']>;
};

export type OdProtosInstitutionsServices_MarkNotificationsAsReadRequestInput = {
  notificationIds?: InputMaybe<Array<Scalars['Float']>>;
};

export type OdProtosInstitutionsServices_PerformBidActionRequestInput = {
  bidAction?: InputMaybe<OdProtosInstitutionsData_BidAction>;
  bidUuid?: InputMaybe<Scalars['String']>;
  /** Any additional data in performing an action as json (i.e. negotiation information) */
  data?: InputMaybe<Scalars['String']>;
  /** Convenience gRPC request metadata that will be refactored */
  metadata?: InputMaybe<Scalars['String']>;
};

export type OdProtosInstitutionsServices_ProcessLeadsRequestInput = {
  homebuilderLeads?: InputMaybe<Array<OdProtosInstitutionsData_HomebuilderLeadInput>>;
};

export type OdProtosInstitutionsServices_RemoveAgentOperatorEligibilityRoleRequestInput = {
  id?: InputMaybe<Scalars['Float']>;
  role?: InputMaybe<OdProtosInstitutionsData_MemberRole>;
};

export type OdProtosInstitutionsServices_RemoveAgentOperatorRoleRequestInput = {
  id?: InputMaybe<Scalars['Float']>;
  role?: InputMaybe<OdProtosInstitutionsData_MemberRole>;
};

export type OdProtosInstitutionsServices_SearchUsersRequestInput = {
  query?: InputMaybe<Scalars['String']>;
};

export type OdProtosInstitutionsServices_SellableSearchRequestInput = {
  filters?: InputMaybe<OdProtosInstitutionsServices_SellableSearchRequest_FiltersInput>;
  paginationRequest?: InputMaybe<OdProtosCommonPagination_PaginationRequestInput>;
};

export type OdProtosInstitutionsServices_SellableSearchRequest_FiltersInput = {
  /**
   * if AuctionType is MlsListings and only a market is specified
   * we merge to prefer an MLS over another based on the historically more reliable mls
   */
  markets?: InputMaybe<Array<OdProtosCommonMarket_Market>>;
  /** specifying an MLS will result in only leads from that MLS returning */
  mls?: InputMaybe<Array<OdProtosCommonMls_Mls>>;
  sourceCreatedAt?: InputMaybe<OdProtosInstitutionsData_TimestampRangeInput>;
  states?: InputMaybe<Array<OdProtosRealtyOdlsData_SellRequest_State>>;
  types?: InputMaybe<Array<OdProtosInstitutionsData_Sellable_Type>>;
};

export type OdProtosInstitutionsServices_SendRemoveNomadTaskSlackMessageRequestInput = {
  bidToken?: InputMaybe<Scalars['String']>;
  caseyTaskId?: InputMaybe<Scalars['String']>;
  note?: InputMaybe<Scalars['String']>;
  reason?: InputMaybe<Scalars['String']>;
};

export type OdProtosInstitutionsServices_SetBrokerageRegionPreferencesRequestInput = {
  identifier?: InputMaybe<Scalars['String']>;
  preferences?: InputMaybe<OdProtosInstitutionsData_BrokerageRegion_PreferencesInput>;
  preferencesFieldMask?: InputMaybe<GoogleProtobuf_FieldMaskInput>;
};

/** Performs a full update of criteria - all desired fields must be specified */
export type OdProtosInstitutionsServices_SetBuyboxRequestInput = {
  criteria?: InputMaybe<OdProtosInstitutionsData_Buybox_CriteriaInput>;
  market?: InputMaybe<OdProtosCommonMarket_Market>;
  reitId?: InputMaybe<Scalars['Float']>;
};

export type OdProtosInstitutionsServices_SetReitSettingsRequestInput = {
  /**
   * Valid field mask items are all top level ReitSettingsPreferences.  An empty mask means that all fields will be updated.
   * This fieldmask option was removed as it was not compiling once the fieldmask plugin was acutally in use
   * It may be because it is a nested fieldmask ?
   * [(common.options.fieldmask) = "reit_settings.preferences"];
   */
  preferencesFieldMask?: InputMaybe<GoogleProtobuf_FieldMaskInput>;
  /** The id in ReitSettings takes precedence over the other search criteria. */
  reitSettings?: InputMaybe<OdProtosInstitutionsData_ReitSettingsInput>;
};

export type OdProtosInstitutionsServices_UpdateAgentOperatorRequestInput = {
  coverageDates?: InputMaybe<Array<OdProtosCommon_DateInput>>;
  /** these two fields are only set for LCEP - left null for other agent operators */
  dailyCapacityLimit?: InputMaybe<Scalars['Int']>;
  dailyListingCapacityLimit?: InputMaybe<Scalars['Int']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Float']>;
  roles?: InputMaybe<Array<OdProtosInstitutionsData_MemberRole>>;
  totalCapacityLimit?: InputMaybe<Scalars['Int']>;
  totalListingCapacityLimit?: InputMaybe<Scalars['Int']>;
};

export type OdProtosInstitutionsServices_UpdateAuctionDetailsRequestInput = {
  auctionUuid?: InputMaybe<Scalars['String']>;
  /** Convenience gRPC request metadata that will be refactored */
  metadata?: InputMaybe<Scalars['String']>;
  odaReviewer?: InputMaybe<OdProtosInstitutionsData_UserInput>;
};

export type OdProtosInstitutionsServices_UpdateBidBrokerageRequestInput = {
  bidUuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosInstitutionsServices_UpdateBidRequestInput = {
  amountCents?: InputMaybe<Scalars['Float']>;
  bidUuid?: InputMaybe<Scalars['String']>;
  commissionPct?: InputMaybe<Scalars['Float']>;
  /** Convenience gRPC request metadata that will be refactored */
  metadata?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<OdProtosInstitutionsData_BidState>;
  /** Optional tags to set on the Bid. If not set, the tags will not be updated. */
  tags?: InputMaybe<OdProtosInstitutionsServices_UpdateBidRequest_TagsInput>;
  updateArgs?: InputMaybe<Scalars['String']>;
  updatedBy?: InputMaybe<OdProtosInstitutionsData_UserInput>;
};

export type OdProtosInstitutionsServices_UpdateBidRequest_TagsInput = {
  ids?: InputMaybe<Array<Scalars['Float']>>;
};

export type OdProtosInstitutionsServices_UpdateDecisionRequestInput = {
  decision?: InputMaybe<OdProtosInstitutionsData_DecisionInput>;
  /** Convenience gRPC request metadata that will be refactored */
  metadata?: InputMaybe<Scalars['String']>;
};

export type OdProtosInstitutionsServices_UpdateLeadAddressRequestInput = {
  city?: InputMaybe<Scalars['String']>;
  county?: InputMaybe<Scalars['String']>;
  latitude?: InputMaybe<Scalars['Float']>;
  leadId?: InputMaybe<Scalars['String']>;
  longitude?: InputMaybe<Scalars['Float']>;
  postalCode?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  street?: InputMaybe<Scalars['String']>;
  unitNumber?: InputMaybe<Scalars['String']>;
};

export type OdProtosInstitutionsServices_UpdateLeadListingRequestInput = {
  assessmentLink?: InputMaybe<Scalars['String']>;
  availableAt?: InputMaybe<OdProtosCommon_DateInput>;
  brokerageId?: InputMaybe<Scalars['String']>;
  brokerageName?: InputMaybe<Scalars['String']>;
  /** replaced by flat_cents and percentage fields */
  buyerCommission?: InputMaybe<Scalars['Float']>;
  buyerCommissionFlatCents?: InputMaybe<Scalars['Int']>;
  /** will be removed once we fully replace it with rate_bips in BE */
  buyerCommissionPercentage?: InputMaybe<Scalars['Float']>;
  buyerCommissionRateBips?: InputMaybe<Scalars['Int']>;
  closingTimeline?: InputMaybe<Scalars['Int']>;
  currentListPriceUsd?: InputMaybe<Scalars['Int']>;
  endedAt?: InputMaybe<OdProtosCommon_DateInput>;
  endsAt?: InputMaybe<OdProtosCommon_DateInput>;
  flipToken?: InputMaybe<Scalars['String']>;
  isNewBuild?: InputMaybe<Scalars['Boolean']>;
  leadId?: InputMaybe<Scalars['String']>;
  listingAgents?: InputMaybe<Array<OdProtosInstitutionsData_Lead_ListingAgentInput>>;
  newBuildInfo?: InputMaybe<OdProtosInstitutionsData_Lead_NewBuildInfoInput>;
  originalListPriceUsd?: InputMaybe<Scalars['Int']>;
  photoLink?: InputMaybe<Scalars['String']>;
  privateNotes?: InputMaybe<Scalars['String']>;
  productType?: InputMaybe<Scalars['String']>;
  publicNotes?: InputMaybe<Scalars['String']>;
  sellers?: InputMaybe<Array<OdProtosInstitutionsData_Lead_SellerInput>>;
  state?: InputMaybe<OdProtosInstitutionsData_Lead_LeadState>;
};

export type OdProtosInstitutionsServices_UpdateLeadNewBuildInfoRequestInput = {
  id?: InputMaybe<Scalars['String']>;
  newBuildInfo?: InputMaybe<OdProtosInstitutionsData_Lead_NewBuildInfoInput>;
};

export type OdProtosInstitutionsServices_UpdateLeadPropertyRequestInput = {
  addressId?: InputMaybe<Scalars['String']>;
  apn?: InputMaybe<Scalars['String']>;
  bathrooms?: InputMaybe<Scalars['Float']>;
  bedrooms?: InputMaybe<Scalars['Int']>;
  carportSpaces?: InputMaybe<Scalars['Int']>;
  exteriorStories?: InputMaybe<Scalars['Int']>;
  garageSpaces?: InputMaybe<Scalars['Int']>;
  hasPrivatePool?: InputMaybe<Scalars['Boolean']>;
  hasSeptic?: InputMaybe<Scalars['Boolean']>;
  hasSolarPanels?: InputMaybe<Scalars['Boolean']>;
  hoas?: InputMaybe<Array<OdProtosInstitutionsData_Lead_HomeDetails_HoaInput>>;
  interiorSqFt?: InputMaybe<Scalars['Int']>;
  interiorStories?: InputMaybe<Scalars['Int']>;
  isAgeRestrictedCommunity?: InputMaybe<Scalars['Boolean']>;
  leadId?: InputMaybe<Scalars['String']>;
  lotSqFt?: InputMaybe<Scalars['Int']>;
  propertyType?: InputMaybe<Scalars['String']>;
  sewerType?: InputMaybe<Scalars['String']>;
  solarPanelsOwnership?: InputMaybe<Scalars['String']>;
  subdivision?: InputMaybe<Scalars['String']>;
  yearBuilt?: InputMaybe<Scalars['Int']>;
};

export type OdProtosInstitutionsServices_UpdateMarketSettingsForReitRequestInput = {
  marketSettingsToUpdate?: InputMaybe<Array<OdProtosInstitutionsData_MarketSettingsInput>>;
  reitId?: InputMaybe<Scalars['Float']>;
};

export type OdProtosInstitutionsServices_UpdateReitRequestInput = {
  reit?: InputMaybe<OdProtosInstitutionsServices_UpdateReitRequest_ReitInput>;
  reitFieldMask?: InputMaybe<GoogleProtobuf_FieldMaskInput>;
  reitId?: InputMaybe<Scalars['Float']>;
};

export type OdProtosInstitutionsServices_UpdateReitRequest_ReitInput = {
  apiBidSubmissionDisabled?: InputMaybe<Scalars['Boolean']>;
  bidLifetimeDays?: InputMaybe<Scalars['Float']>;
  buyerReitIds?: InputMaybe<Array<Scalars['Float']>>;
  isBroker?: InputMaybe<Scalars['Boolean']>;
  mlsReadEnabled?: InputMaybe<Scalars['Boolean']>;
  rentEstimateReadEnabled?: InputMaybe<Scalars['Boolean']>;
};

export type OdProtosInstitutionsServices_UpdateTagRequestInput = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Float']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
};

export type OdProtosInstitutionsServices_UpdateTaskConfigRequestInput = {
  name?: InputMaybe<Scalars['String']>;
  preferences?: InputMaybe<OdProtosInstitutionsTasks_TaskConfig_PreferencesInput>;
  preferencesFieldMask?: InputMaybe<GoogleProtobuf_FieldMaskInput>;
  taskConfigId?: InputMaybe<Scalars['Float']>;
};

export type OdProtosInstitutionsServices_UpdateTaskRequestInput = {
  isCompleted?: InputMaybe<Scalars['Boolean']>;
  /** Convenience gRPC request metadata that will be refactored */
  metadata?: InputMaybe<Scalars['String']>;
  taskUuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosInstitutionsTasksServices_CreateTaskRequestInput = {
  assigneeHumanToken?: InputMaybe<Scalars['String']>;
  bidToken?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  dueBy?: InputMaybe<Scalars['DateTime']>;
  /** required: name, description, task type */
  name?: InputMaybe<Scalars['String']>;
  priority?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<OdProtosInstitutionsTasks_Task_Status>;
  tags?: InputMaybe<Array<Scalars['String']>>;
  taskConfigId?: InputMaybe<Scalars['Int']>;
  taskType?: InputMaybe<Scalars['String']>;
};

export type OdProtosInstitutionsTasksServices_GetTasksRequestInput = {
  ids?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosInstitutionsTasksServices_SearchTasksRequestInput = {
  filters?: InputMaybe<OdProtosInstitutionsTasksServices_SearchTasksRequest_FiltersInput>;
};

export type OdProtosInstitutionsTasksServices_SearchTasksRequest_FiltersInput = {
  assigneeHumanTokens?: InputMaybe<Array<Scalars['String']>>;
  /** TODO add pagination */
  bidTokens?: InputMaybe<Array<Scalars['String']>>;
  statuses?: InputMaybe<Array<OdProtosInstitutionsTasks_Task_Status>>;
};

export type OdProtosInstitutionsTasksServices_UpdateTaskRequestInput = {
  assigneeHumanToken?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  dueBy?: InputMaybe<Scalars['DateTime']>;
  /** all fields are optional, and will be updated if set */
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  priority?: InputMaybe<Scalars['Int']>;
  snoozedUntil?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<OdProtosInstitutionsTasks_Task_Status>;
  tags?: InputMaybe<OdProtosInstitutionsTasksServices_UpdateTaskRequest_TagsInput>;
};

export type OdProtosInstitutionsTasksServices_UpdateTaskRequest_TagsInput = {
  tags?: InputMaybe<Array<Scalars['String']>>;
};

/** The Conditions specify parameters that control when bid tasks should exist. */
export type OdProtosInstitutionsTasks_ConditionsInput = {
  acceptedTerms?: InputMaybe<Array<OdProtosInstitutionsReithouseData_TermType_Type>>;
  bidStates?: InputMaybe<Array<OdProtosInstitutionsData_BidState>>;
  boolFilters?: InputMaybe<Array<OdProtosInstitutionsTasks_Conditions_BoolFilterInput>>;
  customClasses?: InputMaybe<Array<OdProtosInstitutionsTasks_Conditions_CustomClass>>;
  dateFilters?: InputMaybe<Array<OdProtosInstitutionsTasks_Conditions_DateFilterInput>>;
  documentsNotMeetingSigningRequirements?: InputMaybe<OdProtosInstitutionsTasks_Conditions_DocumentsInput>;
  documentsWithBrokerApprovalComment?: InputMaybe<OdProtosInstitutionsTasks_Conditions_DocumentsInput>;
  documentsWithBrokerRejection?: InputMaybe<OdProtosInstitutionsTasks_Conditions_DocumentsInput>;
  inspectionStates?: InputMaybe<Array<OdProtosInstitutionsData_InspectionState>>;
  intFilters?: InputMaybe<Array<OdProtosInstitutionsTasks_Conditions_IntFilterInput>>;
  partyTurnTerms?: InputMaybe<Array<OdProtosInstitutionsReithouseData_Party>>;
  /** This condition is met when all specified fields are present (non-null). */
  presentFields?: InputMaybe<Array<OdProtosInstitutionsTasks_FieldInput>>;
  proposedTerms?: InputMaybe<Array<OdProtosInstitutionsTasks_Conditions_ProposedTermInput>>;
  ratifiedTerms?: InputMaybe<Array<OdProtosInstitutionsReithouseData_TermType_Type>>;
  referralSourcedBys?: InputMaybe<Array<OdProtosInstitutionsData_Bid_ReferralSourcedBy>>;
  reitMarkets?: InputMaybe<Array<OdProtosInstitutionsTasks_Conditions_ReitMarketInput>>;
  rejectedTerms?: InputMaybe<Array<OdProtosInstitutionsReithouseData_TermType_Type>>;
  sellableTypes?: InputMaybe<Array<OdProtosInstitutionsData_Sellable_Type>>;
  sourceTypes?: InputMaybe<Array<OdProtosRealtyCommon_Source_Type>>;
  states?: InputMaybe<Array<OdProtosCommonState_State>>;
  timestampFilters?: InputMaybe<Array<OdProtosInstitutionsTasks_Conditions_TimestampFilterInput>>;
};

/** BollFilter is a boolean field compared against a value for equality. */
export type OdProtosInstitutionsTasks_Conditions_BoolFilterInput = {
  field?: InputMaybe<OdProtosInstitutionsTasks_Field_Bool>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type OdProtosInstitutionsTasks_Conditions_CustomClass =
  /** Guardrail terms set in reit preferences are not followed */
  | 'GUARDRAIL_TERM_MIN_DAY_VIOLATION'
  /** The seller agent contact email in PACT is not specified. */
  | 'SELLER_AGENT_CONTACT_EMAIL_MISSING'
  | 'UNKNOWN_CUSTOM_CLASS';

/**
 * DateFilter is an adjusted date compared against the current date.
 *
 * Examples:
 * (1) The equivalent filter for:
 *     (a) "within 1 day of the inspection scheduled date" or
 *     (b) "*start condition* 1 day before inspection schedule date" or
 *     (c) "inspection schedule date is in 1 day" is:
 *     CURRENT_DATE_ON_OR_AFTER Date.INSPECTION_SCHEDULED - 1 day
 * (2) The filter for "on or after binding date" is:
 *     CURRENT_DATE_ON_OR_AFTER Date.BINDING
 */
export type OdProtosInstitutionsTasks_Conditions_DateFilterInput = {
  dayType?: InputMaybe<OdProtosInstitutionsTasks_DayType>;
  deltaDays?: InputMaybe<Scalars['Float']>;
  field?: InputMaybe<OdProtosInstitutionsTasks_Field_Date>;
  operator?: InputMaybe<OdProtosInstitutionsTasks_Conditions_DateFilter_Operator>;
};

export type OdProtosInstitutionsTasks_Conditions_DateFilter_Operator =
  | 'CURRENT_DATE_ON_OR_AFTER'
  | 'CURRENT_DATE_ON_OR_BEFORE'
  | 'UNKNOWN_OPERATOR';

/**
 * Each document version that matches a Documents condition will create its
 * own separate task.
 *
 * Additionally, each document review that matches the condition will also
 * create its own separate task.
 */
export type OdProtosInstitutionsTasks_Conditions_DocumentsInput = {
  /** When the list is empty the criteria is applied to all valid values. */
  documentDescriptorIds?: InputMaybe<Array<Scalars['String']>>;
};

/** IntFilter is an int field compared against a value. */
export type OdProtosInstitutionsTasks_Conditions_IntFilterInput = {
  field?: InputMaybe<OdProtosInstitutionsTasks_Field_Int>;
  operator?: InputMaybe<OdProtosInstitutionsTasks_Conditions_IntFilter_Operator>;
  /** RHS value. */
  value?: InputMaybe<Scalars['Float']>;
};

export type OdProtosInstitutionsTasks_Conditions_IntFilter_Operator =
  | 'EQUAL_TO'
  | 'GREATER_THAN'
  | 'GREATER_THAN_OR_EQUAL_TO'
  | 'LESS_THAN'
  | 'LESS_THAN_OR_EQUAL_TO'
  | 'UNKNOWN_OPERATOR';

export type OdProtosInstitutionsTasks_Conditions_ProposedTermInput = {
  /** When NONE this condition will match either party. */
  party?: InputMaybe<OdProtosInstitutionsReithouseData_Party>;
  termType?: InputMaybe<OdProtosInstitutionsReithouseData_TermType_Type>;
};

/** These conditions are built in the UI using a kind of step-by-step wizard. */
export type OdProtosInstitutionsTasks_Conditions_ReitMarketInput = {
  market?: InputMaybe<OdProtosCommonMarket_Market>;
  /**
   * A reit and market combination specifying an inclusion or
   * for this task config.
   *
   * When null/unknown unspecified the criteria is applied to all valid
   * values. At least one parameter must be specified.
   */
  reitId?: InputMaybe<Scalars['Float']>;
};

/**
 * TimestampFilter is an adjusted timestamp field compared against the current
 * timestamp.
 *
 * Examples:
 * (1) The equivalent filters for:
 *     (a) "within 4 hours of the highest and best deadline" or
 *     (b) "*start condition* 4 hours before highest and best deadline" or:
 *     (c) "highest and best deadline is in 4 hours" is:
 *     Timestamp.HIGHEST_AND_BEST_DEADLINE - 4 hours is AFTER_NOW_TIMESTAMP
 * (2) The filter for "1 day after bid state entered at" is:
 *     CURRENT_TIMESTAMP_AFTER Timestamp.BID_STATE_ENTERED_AT + 1
 * (3) The filter for "before auction ended at" is:
 *     CURRENT_TIMESTAMP_BEFORE Timestamp.AUCTION_ENDED_AT
 */
export type OdProtosInstitutionsTasks_Conditions_TimestampFilterInput = {
  dayType?: InputMaybe<OdProtosInstitutionsTasks_DayType>;
  /** Duration is added to the field anchor for deadline computation. */
  deltaDuration?: InputMaybe<GoogleProtobuf_DurationInput>;
  field?: InputMaybe<OdProtosInstitutionsTasks_Field_Timestamp>;
  operator?: InputMaybe<OdProtosInstitutionsTasks_Conditions_TimestampFilter_Operator>;
};

export type OdProtosInstitutionsTasks_Conditions_TimestampFilter_Operator =
  | 'CURRENT_TIMESTAMP_AFTER'
  | 'CURRENT_TIMESTAMP_BEFORE'
  | 'UNKNOWN_OPERATOR';

export type OdProtosInstitutionsTasks_DayType =
  /** Mon-Fri excluding national holidays. */
  | 'BUSINESS'
  | 'CALENDAR'
  | 'DAY_TYPE_UNKNOWN';

export type OdProtosInstitutionsTasks_FieldInput = {
  field?: InputMaybe<OdProtosInstitutionsTasks_Field_FieldOneofInput>;
};

export type OdProtosInstitutionsTasks_Field_Bool =
  | 'IS_NEW_BUILD'
  | 'IS_VACANT'
  | 'UNKNOWN_BOOL_FIELD';

export type OdProtosInstitutionsTasks_Field_Date =
  | 'BINDING'
  | 'CERTIFICATE_OF_OCCUPANCY'
  | 'CLOSE_OF_ESCROW'
  | 'CONTINGENCY_DEADLINE'
  | 'EARNEST_MONEY_DUE_DATE'
  | 'INSPECTION_SCHEDULED'
  | 'RENT_BACK_DATE'
  | 'TIMESTAMP_AUCTION_ENDED_AT'
  /** The fields below are duplicated from Timestamp but with date logic for ops. */
  | 'TIMESTAMP_BID_STATE_ENTERED_AT'
  | 'TIMESTAMP_HIGHEST_AND_BEST_DEADLINE'
  | 'TIMESTAMP_TASK_ACTIVATED_AT'
  | 'UNKNOWN_DATE_FIELD'
  | 'VACANCY_DATE';

export type OdProtosInstitutionsTasks_Field_FieldOneofInput = {
  bool?: InputMaybe<OdProtosInstitutionsTasks_Field_Bool>;
  date?: InputMaybe<OdProtosInstitutionsTasks_Field_Date>;
  int?: InputMaybe<OdProtosInstitutionsTasks_Field_Int>;
  string?: InputMaybe<OdProtosInstitutionsTasks_Field_String>;
  timestamp?: InputMaybe<OdProtosInstitutionsTasks_Field_Timestamp>;
};

export type OdProtosInstitutionsTasks_Field_Int =
  | 'HOA_FEE'
  | 'UNKNOWN_INT_FIELD'
  | 'YEAR_BUILT';

export type OdProtosInstitutionsTasks_Field_String =
  | 'ACCESS_INSTRUCTIONS'
  | 'UNKNOWN_STRING_FIELD';

export type OdProtosInstitutionsTasks_Field_Timestamp =
  | 'AUCTION_ENDED_AT'
  | 'BID_STATE_ENTERED_AT'
  | 'HIGHEST_AND_BEST_DEADLINE'
  | 'TASK_ACTIVATED_AT'
  | 'UNKNOWN_TIMESTAMP_FIELD';

export type OdProtosInstitutionsTasks_TaskConfig_DeadlineInput = {
  anchor?: InputMaybe<OdProtosInstitutionsTasks_TaskConfig_Deadline_AnchorOneofInput>;
  dayType?: InputMaybe<OdProtosInstitutionsTasks_DayType>;
  /** Duration is added to the field anchor for deadline computation. */
  deltaDuration?: InputMaybe<GoogleProtobuf_DurationInput>;
  /** Overrides the time portion of this deadline using the property's timezone. */
  overrideTime?: InputMaybe<OdProtosCommon_TimeInput>;
};

export type OdProtosInstitutionsTasks_TaskConfig_Deadline_AnchorOneofInput = {
  anchorDate?: InputMaybe<OdProtosInstitutionsTasks_Field_Date>;
  anchorTimestamp?: InputMaybe<OdProtosInstitutionsTasks_Field_Timestamp>;
  customClass?: InputMaybe<OdProtosInstitutionsTasks_TaskConfig_Deadline_CustomClass>;
};

export type OdProtosInstitutionsTasks_TaskConfig_Deadline_CustomClass =
  | 'UNKNOWN_CUSTOM_CLASS';

export type OdProtosInstitutionsTasks_TaskConfig_PreferencesInput = {
  /** The conditions that, when met, will open (or reopen) a bid task. */
  allConditions?: InputMaybe<OdProtosInstitutionsTasks_ConditionsInput>;
  /** SLA parameters for this config. */
  deadline?: InputMaybe<OdProtosInstitutionsTasks_TaskConfig_DeadlineInput>;
  description?: InputMaybe<Scalars['String']>;
  /** Controls whether a bid task should be reopened when the conditions are subsequently met again */
  isOneTime?: InputMaybe<Scalars['Boolean']>;
  /** The task is assigned to a bid assignee human with the provided member role. */
  memberRole?: InputMaybe<OdProtosInstitutionsData_MemberRole>;
  noneConditions?: InputMaybe<OdProtosInstitutionsTasks_ConditionsInput>;
  /** Optional priority of the task. Historically we use 0, 1, 2 or 3' */
  priority?: InputMaybe<Scalars['Int']>;
  /**
   * Human readable (and maintained) tags for the task config and its spawned
   * tasks for display in frontends. These are immutable in spawned tasks.
   */
  tags?: InputMaybe<Array<OdProtosInstitutionsTasks_TaskConfig_Preferences_TagInput>>;
};

export type OdProtosInstitutionsTasks_TaskConfig_Preferences_TagInput = {
  name?: InputMaybe<Scalars['String']>;
};

export type OdProtosInstitutionsTasks_TaskConfig_State =
  /** This task config fully applied and is live for new and existing bids. */
  | 'ACTIVE'
  /** This task config is being applied by a backend migration. */
  | 'APPLYING'
  /**
   * This task config is no longer in use and all migrations have been
   * performed. If needed, it can be removed from the db at this point.
   */
  | 'DELETED'
  /** This task config is new or modified. */
  | 'PENDING'
  | 'UNKNOWN_STATE';

export type OdProtosInstitutionsTasks_Task_Status =
  | 'STATUS_CLOSED'
  | 'STATUS_OPEN'
  | 'STATUS_UNSPECIFIED';

export type OdProtosInventoryPrototypeData_BuyerOfferDetailsInput = {
  /** Next ID: 13 */
  financingType?: InputMaybe<OdProtosInventoryPrototypeData_BuyerOfferDetails_FinancingType>;
  isEscalated?: InputMaybe<Scalars['Boolean']>;
  isFinalOffer?: InputMaybe<Scalars['Boolean']>;
  messageThreadUuid?: InputMaybe<Scalars['String']>;
  netProceedsCents?: InputMaybe<OdProtosCommon_MoneyInput>;
  offerAmountCents?: InputMaybe<OdProtosCommon_MoneyInput>;
  offerId?: InputMaybe<Scalars['Float']>;
  offerValidFrom?: InputMaybe<OdProtosCommon_DateInput>;
  offerValidUntil?: InputMaybe<OdProtosCommon_DateInput>;
  state?: InputMaybe<OdProtosInventoryPrototypeData_BuyerOfferDetails_Lifecycle>;
  targetNetProceedsCents?: InputMaybe<OdProtosCommon_MoneyInput>;
  totalConcessionsCents?: InputMaybe<OdProtosCommon_MoneyInput>;
};

/** Next ID: 8 */
export type OdProtosInventoryPrototypeData_BuyerOfferDetails_FinancingType =
  | 'CASH'
  | 'CONVENTIONAL'
  | 'FHA'
  | 'FINANCING_REQUIRED'
  | 'TXVA'
  | 'UNKNOWN'
  | 'USDA'
  | 'VA';

/** Next ID: 5 */
export type OdProtosInventoryPrototypeData_BuyerOfferDetails_Lifecycle =
  | 'ACCEPTED'
  | 'EXPIRED'
  | 'OPEN'
  | 'REJECTED'
  | 'WITHDRAWN';

/** Next ID: 2 */
export type OdProtosInventoryPrototypeData_ChangeAddressTokenDetailsInput = {
  newAddressUuid?: InputMaybe<Scalars['String']>;
};

/** Next ID: 14 */
export type OdProtosInventoryPrototypeData_EventType =
  /** When the listing's address token changes. */
  | 'EVENT_ADDRESS_TOKEN_CHANGED'
  | 'EVENT_BUYER_OFFER_ENTERED'
  | 'EVENT_HOME_OUT_OF_INVENTORY'
  /** When the listing should be ingested into IMS. */
  | 'EVENT_HOME_READY_FOR_UNDERWRITING'
  | 'EVENT_LISTING_PHOTOS_UPLOADED'
  /** When the listing state is flipped back from canceled. */
  | 'EVENT_LISTING_REINSTATED'
  /** When a list price ensembled valuation is canceled. */
  | 'EVENT_LIST_PRICE_ENSEMBLED_VALUATION_CANCELED'
  /** When a list price ensembled valuation is completed. */
  | 'EVENT_LIST_PRICE_ENSEMBLED_VALUATION_COMPLETED'
  /** When a list price ensembled valuation is escalated. */
  | 'EVENT_LIST_PRICE_ENSEMBLED_VALUATION_ESCALATED'
  /** When the list price valuation is completed. */
  | 'EVENT_LIST_PRICE_VALUATION_COMPLETED'
  /** When a list price valuation task is requested. */
  | 'EVENT_LIST_PRICE_VALUATION_REQUESTED'
  | 'EVENT_MANUAL_TRIGGER'
  /** When the listing's portfolio changes. */
  | 'EVENT_ORGANIZATION_CHANGED'
  | 'EVENT_SNAPSHOT';

/** Next ID: 2 */
export type OdProtosInventoryPrototypeData_ListPriceEnsembledValuationCompletedDetailsInput = {
  ensembledValuationId?: InputMaybe<Scalars['Float']>;
};

/** Next ID: 2 */
export type OdProtosInventoryPrototypeData_ListPriceEnsembledValuationEscalatedDetailsInput = {
  ensembledValuationId?: InputMaybe<Scalars['Float']>;
};

/** Next ID: 2 */
export type OdProtosInventoryPrototypeData_ListPriceValuationCompletedDetailsInput = {
  valuationId?: InputMaybe<Scalars['Float']>;
};

/** Next ID: 2 */
export type OdProtosInventoryPrototypeData_ListPriceValuationRequestedDetailsInput = {
  ensembledValuationId?: InputMaybe<Scalars['Float']>;
};

/** Next ID: 2 */
export type OdProtosInventoryPrototypeData_ListingPhotosUploadedDetailsInput = {
  dwellingType?: InputMaybe<Scalars['String']>;
};

export type OdProtosInventoryPrototypeNetProceeds_BuyerOfferNetProceedsRequestInput = {
  brnCost?: InputMaybe<OdProtosCommon_MoneyInput>;
  brokerCommission?: InputMaybe<OdProtosCommon_MoneyInput>;
  concession?: InputMaybe<OdProtosCommon_MoneyInput>;
  daysPendToClose?: InputMaybe<Scalars['Float']>;
  /** For indifference price there are still days left till pend */
  daysToPend?: InputMaybe<Scalars['Float']>;
  /** Used for fetching data from financials service (e.g. financing costs). */
  flipToken?: InputMaybe<Scalars['String']>;
  /** Next ID: 17 */
  headlinePrice?: InputMaybe<OdProtosCommon_MoneyInput>;
  homeWarranty?: InputMaybe<OdProtosCommon_MoneyInput>;
  /** UUID of the listing that the offer belongs to. */
  listingUuid?: InputMaybe<Scalars['String']>;
  netReferralCommission?: InputMaybe<OdProtosCommon_MoneyInput>;
  offerId?: InputMaybe<Scalars['Float']>;
  /** Cost if Opendoor pays the title insurance. */
  titleCost?: InputMaybe<OdProtosCommon_MoneyInput>;
  /** Amount gained if the buyer uses OD title JV. */
  titleCredit?: InputMaybe<OdProtosCommon_MoneyInput>;
  unitHoldingCost?: InputMaybe<OdProtosCommon_MoneyInput>;
  /** If BwOD agent is used */
  usingBwodAgent?: InputMaybe<Scalars['Boolean']>;
  /** Whether the buyer offer has Opendoor Home Loan attached. */
  usingOdHomeLoan?: InputMaybe<Scalars['Boolean']>;
};

export type OdProtosInventoryPrototypeNetProceeds_PreListNetProceedsRequestInput = {
  acquisitionCloseDate?: InputMaybe<Scalars['DateTime']>;
  addressToken?: InputMaybe<Scalars['String']>;
  /** Next ID: 7 */
  flipToken?: InputMaybe<Scalars['String']>;
  market?: InputMaybe<OdProtosCommonMarket_Market>;
  offer?: InputMaybe<OdProtosInventoryPrototypeNetProceeds_PreListOfferInput>;
  uwAfterRenovationValuationCents?: InputMaybe<OdProtosCommon_MoneyInput>;
};

export type OdProtosInventoryPrototypeNetProceeds_PreListOfferInput = {
  brnCost?: InputMaybe<OdProtosCommon_MoneyInput>;
  brokerCommission?: InputMaybe<OdProtosCommon_MoneyInput>;
  concession?: InputMaybe<OdProtosCommon_MoneyInput>;
  daysPendToClose?: InputMaybe<Scalars['Float']>;
  /** Next ID: 13 */
  headlinePrice?: InputMaybe<OdProtosCommon_MoneyInput>;
  homeWarranty?: InputMaybe<OdProtosCommon_MoneyInput>;
  /** UUID of the listing that the offer belongs to. */
  listingUuid?: InputMaybe<Scalars['String']>;
  netReferralCommission?: InputMaybe<OdProtosCommon_MoneyInput>;
  offerDate?: InputMaybe<Scalars['DateTime']>;
  offerId?: InputMaybe<Scalars['Float']>;
  /** Cost if Opendoor pays the title insurance. */
  titleCost?: InputMaybe<OdProtosCommon_MoneyInput>;
  /** Amount gained if the buyer uses OD title JV. */
  titleCredit?: InputMaybe<OdProtosCommon_MoneyInput>;
};

export type OdProtosInventoryPrototypeServices_GetAgentFeedbacksRequestInput = {
  /**
   * Using oneof here in case we want to allow looking up by other identifiers
   * like address token in the future.
   */
  identifier?: InputMaybe<OdProtosInventoryPrototypeServices_GetAgentFeedbacksRequest_IdentifierOneofInput>;
};

export type OdProtosInventoryPrototypeServices_GetAgentFeedbacksRequest_IdentifierOneofInput = {
  flipToken?: InputMaybe<Scalars['String']>;
};

/** Next ID: 5 */
export type OdProtosInventoryPrototypeServices_InventoryManagementRequest_ConsiderBuyerOfferInput = {
  buyOfferDetails?: InputMaybe<OdProtosInventoryPrototypeData_BuyerOfferDetailsInput>;
  flipToken?: InputMaybe<Scalars['String']>;
  listing?: InputMaybe<OdProtosProjectionsDataFlip_ListingInput>;
  listingUuid?: InputMaybe<Scalars['String']>;
};

/** Next ID: 13 */
export type OdProtosInventoryPrototypeServices_InventoryManagementRequest_CreateEventInput = {
  addressUuid?: InputMaybe<Scalars['String']>;
  eventDetails?: InputMaybe<OdProtosInventoryPrototypeServices_InventoryManagementRequest_CreateEvent_EventDetailsOneofInput>;
  eventType?: InputMaybe<OdProtosInventoryPrototypeData_EventType>;
  listingUuid?: InputMaybe<Scalars['String']>;
  organizationToken?: InputMaybe<Scalars['String']>;
  /**
   * DEPRECATED
   * TODO(jiatu): Remove when we do not communicate with web_listing_id anymore.
   */
  webListingId?: InputMaybe<Scalars['Float']>;
};

export type OdProtosInventoryPrototypeServices_InventoryManagementRequest_CreateEvent_EventDetailsOneofInput = {
  buyOfferDetails?: InputMaybe<OdProtosInventoryPrototypeData_BuyerOfferDetailsInput>;
  changeAddressTokenDetails?: InputMaybe<OdProtosInventoryPrototypeData_ChangeAddressTokenDetailsInput>;
  listPriceEnsembledValuationCompletedDetails?: InputMaybe<OdProtosInventoryPrototypeData_ListPriceEnsembledValuationCompletedDetailsInput>;
  listPriceEnsembledValuationEscalatedDetails?: InputMaybe<OdProtosInventoryPrototypeData_ListPriceEnsembledValuationEscalatedDetailsInput>;
  listPriceValuationCompletedDetails?: InputMaybe<OdProtosInventoryPrototypeData_ListPriceValuationCompletedDetailsInput>;
  listPriceValuationRequestedDetails?: InputMaybe<OdProtosInventoryPrototypeData_ListPriceValuationRequestedDetailsInput>;
  listingPhotosUploadedDetails?: InputMaybe<OdProtosInventoryPrototypeData_ListingPhotosUploadedDetailsInput>;
};

/**
 * FlipInfo has all required property data from Web needed by Invoicer.
 * Invoicer currently does not make REST calls back to Web.
 * Next ID: 4
 */
export type OdProtosInvoicerData_FlipInfoInput = {
  /** Human readable address for the home */
  addressHumanReadable?: InputMaybe<Scalars['String']>;
  /** Current flip state for the flip token */
  flipState?: InputMaybe<Scalars['String']>;
  /** Flip token for the property */
  flipToken?: InputMaybe<Scalars['String']>;
  /** Market identifier for the home */
  marketIdentifier?: InputMaybe<Scalars['String']>;
  /** Set if an organization other than Opendoor owns the home. */
  owningOrganizationId?: InputMaybe<Scalars['String']>;
  propertyEngagementGroupId?: InputMaybe<Scalars['String']>;
  /** In relation to what service is this invoice. */
  serviceType?: InputMaybe<OdProtosInvoicerData_ServiceType>;
};

/**
 * Invoice describes an account receivable to vendor provider.
 * Next ID: 10
 */
export type OdProtosInvoicerData_InvoiceInput = {
  /** Free form map of custom invoice fields */
  customFields?: InputMaybe<Array<OdProtosInvoicerData_Invoice_CustomFieldsEntryInput>>;
  /** Invoice id within web */
  invoiceId?: InputMaybe<Scalars['Float']>;
  /**
   * Invoice token within web
   * For work orders this is the work order reference number
   */
  invoiceToken?: InputMaybe<Scalars['String']>;
  /** Type of the invoice */
  invoiceType?: InputMaybe<OdProtosInvoicerData_InvoiceType>;
  /** Line items of the invoice */
  items?: InputMaybe<Array<OdProtosInvoicerData_InvoiceItemInput>>;
  /** Organization token within web */
  organizationToken?: InputMaybe<Scalars['String']>;
  /** The purchase order number for the invoice */
  purchaseOrderNumber?: InputMaybe<Scalars['String']>;
  /** The email of the requester to send the JE prep to */
  requesterEmail?: InputMaybe<Scalars['String']>;
  /** Submission date of the invoice */
  submittedDate?: InputMaybe<OdProtosCommon_DateInput>;
  /** Vendor provided invoice number unique to the vendor branch */
  vendorInvoiceNumber?: InputMaybe<Scalars['String']>;
};

/**
 * InvoiceItem models an invoice line item
 * Next ID: 6
 */
export type OdProtosInvoicerData_InvoiceItemInput = {
  /** Account name pertaining to the invoice line item */
  account?: InputMaybe<Scalars['String']>;
  /** Date prescribed to the invoice line item */
  costIncurredDate?: InputMaybe<OdProtosCommon_DateInput>;
  /** Free form map of custom invoice item fields */
  customFields?: InputMaybe<Array<OdProtosInvoicerData_InvoiceItem_CustomFieldsEntryInput>>;
  /** Memo of the invoice line item */
  description?: InputMaybe<Scalars['String']>;
  /** Property information pertaining to the invoice line item */
  flipInfo?: InputMaybe<OdProtosInvoicerData_FlipInfoInput>;
  /** Quantity pertaining to the invoice line item */
  quantity?: InputMaybe<Scalars['Float']>;
  /** Cost in cents */
  unitCostCents?: InputMaybe<Scalars['Float']>;
};

/** `OdProtosInvoicerData_InvoiceItem_CustomFieldsEntryInput` represents the `custom_fields` map in `od_protos.invoicer.data.InvoiceItem`. */
export type OdProtosInvoicerData_InvoiceItem_CustomFieldsEntryInput = {
  key?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/**
 * InvoiceType represents the category of an invoice.
 * Next ID: 2
 */
export type OdProtosInvoicerData_InvoiceType =
  | 'MAINTENANCE'
  | 'WORK_ORDER';

/** `OdProtosInvoicerData_Invoice_CustomFieldsEntryInput` represents the `custom_fields` map in `od_protos.invoicer.data.Invoice`. */
export type OdProtosInvoicerData_Invoice_CustomFieldsEntryInput = {
  key?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

export type OdProtosInvoicerData_ServiceType =
  /** Renovation on a REIT owned home. */
  | 'REIT_RENO'
  | 'UNKNOWN';

export type OdProtosInvoicerServices_GenerateNetsuiteJeRequestInput = {
  /**
   * The input invoices for the JE request,
   * currently supports both maintenance and work order invoices
   */
  inputInvoices?: InputMaybe<Array<OdProtosInvoicerData_InvoiceInput>>;
};

export type OdProtosInvoicerServices_NotifyNoInvoicesForJeRequestInput = {
  /** Type of the invoice */
  invoiceType?: InputMaybe<OdProtosInvoicerData_InvoiceType>;
  /** The email of the requester to send the notification to */
  requesterEmail?: InputMaybe<Scalars['String']>;
};

export type OdProtosJourneyDataCategories_AgentConnectCategoryInput = {
  event?: InputMaybe<OdProtosJourneyDataCategories_AgentConnectCategory_EventOneofInput>;
};

/** Triggered whenever a customer is shown a denial page other than a partner referral */
export type OdProtosJourneyDataCategories_AgentConnectCategory_DeniedEventInput = {
  denialReason?: InputMaybe<Scalars['String']>;
  sellerInputUuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosJourneyDataCategories_AgentConnectCategory_EventOneofInput = {
  /** agent_connect_denied_event */
  deniedEvent?: InputMaybe<OdProtosJourneyDataCategories_AgentConnectCategory_DeniedEventInput>;
  /** agent_connect_handoff_event */
  handoffEvent?: InputMaybe<OdProtosJourneyDataCategories_AgentConnectCategory_HandoffEventInput>;
  /** agent_connect_view_event */
  viewEvent?: InputMaybe<OdProtosJourneyDataCategories_AgentConnectCategory_ViewEventInput>;
};

/** Triggered whenever a customer completes a handoff to a referral partner */
export type OdProtosJourneyDataCategories_AgentConnectCategory_HandoffEventInput = {
  buyerIntent?: InputMaybe<Scalars['Boolean']>;
  odEstimatedSalePriceCents?: InputMaybe<Scalars['Int']>;
  partner?: InputMaybe<OdProtosJourneyDataCategories_AgentConnectCategory_Partner>;
  sellerInputUuid?: InputMaybe<Scalars['String']>;
  sellerIntent?: InputMaybe<OdProtosJourneyDataCategories_AgentConnectCategory_SellerIntent>;
};

export type OdProtosJourneyDataCategories_AgentConnectCategory_Partner =
  | 'CLEVER'
  | 'JMG'
  | 'MSRE'
  | 'PARN'
  | 'REDFIN'
  | 'UNKNOWN_PARTNER';

export type OdProtosJourneyDataCategories_AgentConnectCategory_SellerIntent =
  | 'CASH'
  | 'CASH_PLUS'
  | 'LIST'
  | 'UNKNOWN';

/** Triggered whenever a Partner page is shown to refer in Agent Connect */
export type OdProtosJourneyDataCategories_AgentConnectCategory_ViewEventInput = {
  buyerIntent?: InputMaybe<Scalars['Boolean']>;
  odEstimatedSalePriceCents?: InputMaybe<Scalars['Int']>;
  partner?: InputMaybe<OdProtosJourneyDataCategories_AgentConnectCategory_Partner>;
  sellerInputUuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosJourneyDataCategories_AloCategoryInput = {
  /** Next ID: 4 */
  event?: InputMaybe<OdProtosJourneyDataCategories_AloCategory_EventOneofInput>;
};

export type OdProtosJourneyDataCategories_AloCategory_AloExperienceSlug =
  | 'ALO_POST_HANDOFF_V1'
  | 'UNKNOWN_SLUG';

/** Next ID: 10 */
export type OdProtosJourneyDataCategories_AloCategory_AloEligibilityDetailsInput = {
  isAfterLaunchDate?: InputMaybe<Scalars['Boolean']>;
  isEligibleMarket?: InputMaybe<Scalars['Boolean']>;
  isFirstOffer?: InputMaybe<Scalars['Boolean']>;
  isNotPreviouslyDeniedRefresh?: InputMaybe<Scalars['Boolean']>;
  isNotReit?: InputMaybe<Scalars['Boolean']>;
  isNotRestrictedPartnershipLead?: InputMaybe<Scalars['Boolean']>;
  isNotVolumeRestricted?: InputMaybe<Scalars['Boolean']>;
  isNotWorkingWithAgent?: InputMaybe<Scalars['Boolean']>;
  isValidOfferRequestSource?: InputMaybe<Scalars['Boolean']>;
};

/** Next ID: 4 */
export type OdProtosJourneyDataCategories_AloCategory_AloHandoffPageViewEventInput = {
  flipToken?: InputMaybe<Scalars['String']>;
  leadUuid?: InputMaybe<Scalars['String']>;
  offerUuid?: InputMaybe<Scalars['String']>;
  sellerLeadUuid?: InputMaybe<Scalars['String']>;
};

/** Next ID: 10 */
export type OdProtosJourneyDataCategories_AloCategory_AloHandoffSubmitEventInput = {
  addressReadable?: InputMaybe<Scalars['String']>;
  customerEmail?: InputMaybe<Scalars['String']>;
  customerName?: InputMaybe<Scalars['String']>;
  customerPhone?: InputMaybe<Scalars['String']>;
  flipToken?: InputMaybe<Scalars['String']>;
  leadUuid?: InputMaybe<Scalars['String']>;
  marketIdentifier?: InputMaybe<Scalars['String']>;
  offerUuid?: InputMaybe<Scalars['String']>;
  sellerLeadUuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosJourneyDataCategories_AloCategory_AloPageViewEventInput = {
  experienceSlug?: InputMaybe<OdProtosJourneyDataCategories_AloCategory_AloExperienceSlug>;
  flipToken?: InputMaybe<Scalars['String']>;
  leadUuid?: InputMaybe<Scalars['String']>;
  offerUuid?: InputMaybe<Scalars['String']>;
  sellerLeadUuid?: InputMaybe<Scalars['String']>;
};

/** Next ID: 10 */
export type OdProtosJourneyDataCategories_AloCategory_AloQualificationEventInput = {
  aloEligibilityDetails?: InputMaybe<OdProtosJourneyDataCategories_AloCategory_AloEligibilityDetailsInput>;
  eligibilityDetails?: InputMaybe<Array<OdProtosJourneyDataCategories_AloCategory_AloQualificationEvent_EligibilityDetailsEntryInput>>;
  flipToken?: InputMaybe<Scalars['String']>;
  leadUuid?: InputMaybe<Scalars['String']>;
  market?: InputMaybe<Scalars['String']>;
  offerRequestSource?: InputMaybe<Scalars['String']>;
  offerUuid?: InputMaybe<Scalars['String']>;
  qualificationDecision?: InputMaybe<OdProtosJourneyDataCategories_AloCategory_QualificationDecision>;
  sellerInputUuid?: InputMaybe<Scalars['String']>;
  sellerLeadUuid?: InputMaybe<Scalars['String']>;
};

/** `OdProtosJourneyDataCategories_AloCategory_AloQualificationEvent_EligibilityDetailsEntryInput` represents the `eligibility_details` map in `od_protos.journey.data.categories.AloCategory.AloQualificationEvent`. */
export type OdProtosJourneyDataCategories_AloCategory_AloQualificationEvent_EligibilityDetailsEntryInput = {
  key?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type OdProtosJourneyDataCategories_AloCategory_EventOneofInput = {
  /** alo_handoff_page_view_event */
  handoffPageViewEvent?: InputMaybe<OdProtosJourneyDataCategories_AloCategory_AloHandoffPageViewEventInput>;
  /** alo_handoff_submit_event */
  handoffSubmitEvent?: InputMaybe<OdProtosJourneyDataCategories_AloCategory_AloHandoffSubmitEventInput>;
  /** alo_page_view_event */
  pageViewEvent?: InputMaybe<OdProtosJourneyDataCategories_AloCategory_AloPageViewEventInput>;
  /** alo_qualification_event */
  qualificationEvent?: InputMaybe<OdProtosJourneyDataCategories_AloCategory_AloQualificationEventInput>;
};

export type OdProtosJourneyDataCategories_AloCategory_QualificationDecision =
  | 'ELIGIBLE'
  | 'INELIGIBLE'
  | 'UNKNOWN';

export type OdProtosJourneyDataCategories_AssessmentCategoryInput = {
  event?: InputMaybe<OdProtosJourneyDataCategories_AssessmentCategory_EventOneofInput>;
};

export type OdProtosJourneyDataCategories_AssessmentCategory_AssessmentFirstPhotoTakenInput = {
  offerUuid?: InputMaybe<Scalars['String']>;
  sellerLeadUuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosJourneyDataCategories_AssessmentCategory_AssessmentFirstQuestionAnsweredInput = {
  offerUuid?: InputMaybe<Scalars['String']>;
  sellerLeadUuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosJourneyDataCategories_AssessmentCategory_AssessmentFlowCompletedEventInput = {
  assessmentType?: InputMaybe<OdProtosJourneyDataCategories_AssessmentCategory_AssessmentType>;
  leadId?: InputMaybe<Scalars['String']>;
  offerUuid?: InputMaybe<Scalars['String']>;
  sellerLeadUuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosJourneyDataCategories_AssessmentCategory_AssessmentFlowStartEventInput = {
  assessmentType?: InputMaybe<OdProtosJourneyDataCategories_AssessmentCategory_AssessmentType>;
  leadId?: InputMaybe<Scalars['String']>;
  offerUuid?: InputMaybe<Scalars['String']>;
  sellerLeadUuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosJourneyDataCategories_AssessmentCategory_AssessmentRequestedEventInput = {
  offerUuid?: InputMaybe<Scalars['String']>;
  requestedDatetime?: InputMaybe<Scalars['DateTime']>;
  sellerLeadUuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosJourneyDataCategories_AssessmentCategory_AssessmentScheduleStartEventInput = {
  assessmentType?: InputMaybe<OdProtosJourneyDataCategories_AssessmentCategory_AssessmentType>;
  offerUuid?: InputMaybe<Scalars['String']>;
  sellerLeadUuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosJourneyDataCategories_AssessmentCategory_AssessmentSpaceCompletedInput = {
  allAreasCompleted?: InputMaybe<Scalars['Boolean']>;
  offerUuid?: InputMaybe<Scalars['String']>;
  sellerLeadUuid?: InputMaybe<Scalars['String']>;
  spaceTypeName?: InputMaybe<Scalars['String']>;
};

export type OdProtosJourneyDataCategories_AssessmentCategory_AssessmentType =
  | 'HA'
  | 'ORVA'
  | 'SSVA'
  | 'UNKNOWN_ASSESSMENT_TYPE'
  | 'VIRTUAL_INSPECTION';

export type OdProtosJourneyDataCategories_AssessmentCategory_EventOneofInput = {
  firstPhotoTaken?: InputMaybe<OdProtosJourneyDataCategories_AssessmentCategory_AssessmentFirstPhotoTakenInput>;
  firstQuestionAnswered?: InputMaybe<OdProtosJourneyDataCategories_AssessmentCategory_AssessmentFirstQuestionAnsweredInput>;
  flowCompleted?: InputMaybe<OdProtosJourneyDataCategories_AssessmentCategory_AssessmentFlowCompletedEventInput>;
  flowStart?: InputMaybe<OdProtosJourneyDataCategories_AssessmentCategory_AssessmentFlowStartEventInput>;
  /** assessment_requested_event */
  requested?: InputMaybe<OdProtosJourneyDataCategories_AssessmentCategory_AssessmentRequestedEventInput>;
  scheduleStart?: InputMaybe<OdProtosJourneyDataCategories_AssessmentCategory_AssessmentScheduleStartEventInput>;
  spaceCompleted?: InputMaybe<OdProtosJourneyDataCategories_AssessmentCategory_AssessmentSpaceCompletedInput>;
};

export type OdProtosJourneyDataCategories_AuthenticationCategoryInput = {
  event?: InputMaybe<OdProtosJourneyDataCategories_AuthenticationCategory_EventOneofInput>;
};

export type OdProtosJourneyDataCategories_AuthenticationCategory_AuthMethod =
  | 'EMAIL_PASSWORD'
  | 'FACEBOOK'
  | 'GOOGLE'
  | 'LITE'
  | 'METHOD_UNSPECIFIED'
  | 'SESSION_ALREADY_EXISTS';

export type OdProtosJourneyDataCategories_AuthenticationCategory_AuthSource =
  | 'KEY_APP'
  | 'SOURCE_UNSPECIFIED';

export type OdProtosJourneyDataCategories_AuthenticationCategory_EventOneofInput = {
  /** authentication_login_event */
  login?: InputMaybe<OdProtosJourneyDataCategories_AuthenticationCategory_LoginEventInput>;
  /** authentication_login_failure_event */
  loginFailure?: InputMaybe<OdProtosJourneyDataCategories_AuthenticationCategory_LoginFailureEventInput>;
  /** authentication_registration_event */
  registration?: InputMaybe<OdProtosJourneyDataCategories_AuthenticationCategory_RegistrationEventInput>;
  /** authentication_registration_failure_event */
  registrationFailure?: InputMaybe<OdProtosJourneyDataCategories_AuthenticationCategory_RegistrationFailureEventInput>;
};

export type OdProtosJourneyDataCategories_AuthenticationCategory_LoginEventInput = {
  authMethod?: InputMaybe<OdProtosJourneyDataCategories_AuthenticationCategory_AuthMethod>;
  authSource?: InputMaybe<OdProtosJourneyDataCategories_AuthenticationCategory_AuthSource>;
};

export type OdProtosJourneyDataCategories_AuthenticationCategory_LoginFailureEventInput = {
  authMethod?: InputMaybe<OdProtosJourneyDataCategories_AuthenticationCategory_AuthMethod>;
  authSource?: InputMaybe<OdProtosJourneyDataCategories_AuthenticationCategory_AuthSource>;
};

export type OdProtosJourneyDataCategories_AuthenticationCategory_RegistrationEventInput = {
  authMethod?: InputMaybe<OdProtosJourneyDataCategories_AuthenticationCategory_AuthMethod>;
  authSource?: InputMaybe<OdProtosJourneyDataCategories_AuthenticationCategory_AuthSource>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
};

export type OdProtosJourneyDataCategories_AuthenticationCategory_RegistrationFailureEventInput = {
  authMethod?: InputMaybe<OdProtosJourneyDataCategories_AuthenticationCategory_AuthMethod>;
  authSource?: InputMaybe<OdProtosJourneyDataCategories_AuthenticationCategory_AuthSource>;
};

export type OdProtosJourneyDataCategories_ChatCategoryInput = {
  event?: InputMaybe<OdProtosJourneyDataCategories_ChatCategory_EventOneofInput>;
};

export type OdProtosJourneyDataCategories_ChatCategory_EventOneofInput = {
  interaction?: InputMaybe<OdProtosJourneyDataCategories_ChatCategory_InteractionEventInput>;
};

export type OdProtosJourneyDataCategories_ChatCategory_InteractionEventInput = {
  category?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  interactionId?: InputMaybe<Scalars['String']>;
  interactionType?: InputMaybe<OdProtosJourneyDataCategories_ChatCategory_InteractionEvent_InteractionType>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  rawUserInput?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<OdProtosJourneyDataCategories_ChatCategory_InteractionEvent_Source>;
};

/** Next ID: 2 */
export type OdProtosJourneyDataCategories_ChatCategory_InteractionEvent_InteractionType =
  | 'SMS'
  | 'UNKNOWN_INTERACTION_TYPE';

/** Next ID: 4 */
export type OdProtosJourneyDataCategories_ChatCategory_InteractionEvent_Source =
  | 'CHAT_UI'
  | 'CUSTOMER_INITIATED'
  | 'OPENDOOR_INITIATED'
  | 'UNKNOWN_SOURCE';

/** Next ID: 3 */
export type OdProtosJourneyDataCategories_CommunicationCategoryInput = {
  event?: InputMaybe<OdProtosJourneyDataCategories_CommunicationCategory_EventOneofInput>;
};

export type OdProtosJourneyDataCategories_CommunicationCategory_EventOneofInput = {
  smsReceived?: InputMaybe<OdProtosJourneyDataCategories_CommunicationCategory_SmsReceivedEventInput>;
  smsSent?: InputMaybe<OdProtosJourneyDataCategories_CommunicationCategory_SmsSentEventInput>;
  subscriptionUpdated?: InputMaybe<OdProtosJourneyDataCategories_CommunicationCategory_SubscriptionUpdatedEventInput>;
};

/** when a customer receives an sms from opendoor */
export type OdProtosJourneyDataCategories_CommunicationCategory_SmsReceivedEventInput = {
  content?: InputMaybe<Scalars['String']>;
  conversationId?: InputMaybe<Scalars['String']>;
  fromPhoneNumber?: InputMaybe<Scalars['String']>;
  messageSid?: InputMaybe<Scalars['String']>;
  toPhoneNumber?: InputMaybe<Scalars['String']>;
};

/** when a customer sends an sms to opendoor */
export type OdProtosJourneyDataCategories_CommunicationCategory_SmsSentEventInput = {
  content?: InputMaybe<Scalars['String']>;
  conversationId?: InputMaybe<Scalars['String']>;
  fromPhoneNumber?: InputMaybe<Scalars['String']>;
  messageSid?: InputMaybe<Scalars['String']>;
  phoneNumberCategory?: InputMaybe<Scalars['String']>;
  toPhoneNumber?: InputMaybe<Scalars['String']>;
};

/** when a customer changes their subscriptions to communication channels */
export type OdProtosJourneyDataCategories_CommunicationCategory_SubscriptionUpdatedEventInput = {
  actor?: InputMaybe<OdProtosCustomerV1Data_Actor>;
  /**
   * map of feed name to whether the customer is subscribed to that feed
   * format: medium.feed_name -> is_subscribed
   */
  subscriptions?: InputMaybe<Array<OdProtosJourneyDataCategories_CommunicationCategory_SubscriptionUpdatedEvent_SubscriptionsEntryInput>>;
};

/** `OdProtosJourneyDataCategories_CommunicationCategory_SubscriptionUpdatedEvent_SubscriptionsEntryInput` represents the `subscriptions` map in `od_protos.journey.data.categories.CommunicationCategory.SubscriptionUpdatedEvent`. */
export type OdProtosJourneyDataCategories_CommunicationCategory_SubscriptionUpdatedEvent_SubscriptionsEntryInput = {
  key?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type OdProtosJourneyDataCategories_ExperimentationCategoryInput = {
  event?: InputMaybe<OdProtosJourneyDataCategories_ExperimentationCategory_EventOneofInput>;
};

export type OdProtosJourneyDataCategories_ExperimentationCategory_AssignmentEventInput = {
  experimentName?: InputMaybe<Scalars['String']>;
  variant?: InputMaybe<Scalars['String']>;
};

export type OdProtosJourneyDataCategories_ExperimentationCategory_EventOneofInput = {
  /** experimentation_assignment_event */
  assignment?: InputMaybe<OdProtosJourneyDataCategories_ExperimentationCategory_AssignmentEventInput>;
  /** experimentation_impression_event */
  impression?: InputMaybe<OdProtosJourneyDataCategories_ExperimentationCategory_ImpressionEventInput>;
  /** experimentation_lead_assignment_event */
  leadAssignment?: InputMaybe<OdProtosJourneyDataCategories_ExperimentationCategory_LeadAssignmentEventInput>;
  /** experimentation_lead_impression_event */
  leadImpression?: InputMaybe<OdProtosJourneyDataCategories_ExperimentationCategory_LeadImpressionEventInput>;
};

export type OdProtosJourneyDataCategories_ExperimentationCategory_ImpressionEventInput = {
  experimentName?: InputMaybe<Scalars['String']>;
  variant?: InputMaybe<Scalars['String']>;
};

export type OdProtosJourneyDataCategories_ExperimentationCategory_LeadAssignmentEventInput = {
  experimentName?: InputMaybe<Scalars['String']>;
  sellerLeadUuid?: InputMaybe<Scalars['String']>;
  variant?: InputMaybe<Scalars['String']>;
};

export type OdProtosJourneyDataCategories_ExperimentationCategory_LeadImpressionEventInput = {
  experimentName?: InputMaybe<Scalars['String']>;
  sellerLeadUuid?: InputMaybe<Scalars['String']>;
  variant?: InputMaybe<Scalars['String']>;
};

export type OdProtosJourneyDataCategories_HomeGuideCategoryInput = {
  event?: InputMaybe<OdProtosJourneyDataCategories_HomeGuideCategory_EventOneofInput>;
};

export type OdProtosJourneyDataCategories_HomeGuideCategory_EventOneofInput = {
  qualification?: InputMaybe<OdProtosJourneyDataCategories_HomeGuideCategory_QualificationEventInput>;
  valuation?: InputMaybe<OdProtosJourneyDataCategories_HomeGuideCategory_ValuationEventInput>;
};

export type OdProtosJourneyDataCategories_HomeGuideCategory_QualificationEventInput = {
  qualificationDecision?: InputMaybe<OdProtosJourneyDataCategories_HomeGuideCategory_QualificationEvent_QualificationDecision>;
  sellerInputId?: InputMaybe<Scalars['String']>;
};

export type OdProtosJourneyDataCategories_HomeGuideCategory_QualificationEvent_QualificationDecision =
  | 'PRODUCT_DENIED'
  | 'PRODUCT_QUALIFIED'
  | 'PRODUCT_UNDENIED'
  | 'UNKNOWN';

/** Next ID: 6 */
export type OdProtosJourneyDataCategories_HomeGuideCategory_ValuationEventInput = {
  addressToken?: InputMaybe<Scalars['String']>;
  compsAddressUuids?: InputMaybe<Array<Scalars['String']>>;
  sellerInputUuid?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<OdProtosJourneyDataCategories_HomeGuideCategory_ValuationEvent_ValuationSource>;
  valuationCents?: InputMaybe<Scalars['Float']>;
};

/** Next ID: 3 */
export type OdProtosJourneyDataCategories_HomeGuideCategory_ValuationEvent_ValuationSource =
  | 'BALLPARK'
  | 'UNKNOWN_SOURCE'
  | 'VALUATION_API';

export type OdProtosJourneyDataCategories_LanguageCategoryInput = {
  event?: InputMaybe<OdProtosJourneyDataCategories_LanguageCategory_EventOneofInput>;
};

export type OdProtosJourneyDataCategories_LanguageCategory_EventOneofInput = {
  selectEvent?: InputMaybe<OdProtosJourneyDataCategories_LanguageCategory_SelectEventInput>;
};

export type OdProtosJourneyDataCategories_LanguageCategory_Language =
  | 'ENGLISH'
  | 'LANGUAGE_UNSPECIFIED'
  | 'SPANISH';

export type OdProtosJourneyDataCategories_LanguageCategory_SelectEventInput = {
  language?: InputMaybe<OdProtosJourneyDataCategories_LanguageCategory_Language>;
};

export type OdProtosJourneyDataCategories_MarketplacePropertyCategoryInput = {
  event?: InputMaybe<OdProtosJourneyDataCategories_MarketplacePropertyCategory_EventOneofInput>;
};

export type OdProtosJourneyDataCategories_MarketplacePropertyCategory_DetailPageViewEventInput = {
  addressUuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosJourneyDataCategories_MarketplacePropertyCategory_EventOneofInput = {
  detailPageView?: InputMaybe<OdProtosJourneyDataCategories_MarketplacePropertyCategory_DetailPageViewEventInput>;
  offerStart?: InputMaybe<OdProtosJourneyDataCategories_MarketplacePropertyCategory_OfferStartEventInput>;
  reaction?: InputMaybe<OdProtosJourneyDataCategories_MarketplacePropertyCategory_ReactionEventInput>;
  share?: InputMaybe<OdProtosJourneyDataCategories_MarketplacePropertyCategory_ShareEventInput>;
  similarHomesClick?: InputMaybe<OdProtosJourneyDataCategories_MarketplacePropertyCategory_SimilarHomesClickEventInput>;
  tourBookingStart?: InputMaybe<OdProtosJourneyDataCategories_MarketplacePropertyCategory_TourBookingStartEventInput>;
};

export type OdProtosJourneyDataCategories_MarketplacePropertyCategory_OfferStartEventInput = {
  addressUuid?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Scalars['String']>;
};

export type OdProtosJourneyDataCategories_MarketplacePropertyCategory_ReactionEventInput = {
  addressUuid?: InputMaybe<Scalars['String']>;
  reaction?: InputMaybe<OdProtosJourneyDataCategories_MarketplacePropertyCategory_ReactionEventReaction>;
  source?: InputMaybe<Scalars['String']>;
};

export type OdProtosJourneyDataCategories_MarketplacePropertyCategory_ReactionEventReaction =
  | 'REACTION_ADD_DISLIKE'
  | 'REACTION_ADD_LIKE'
  | 'REACTION_REMOVE_DISLIKE'
  | 'REACTION_REMOVE_LIKE'
  | 'REACTION_UNSPECIFIED';

export type OdProtosJourneyDataCategories_MarketplacePropertyCategory_ShareEventInput = {
  addressUuid?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Scalars['String']>;
};

export type OdProtosJourneyDataCategories_MarketplacePropertyCategory_SimilarHomesClickEventInput = {
  addressUuid?: InputMaybe<Scalars['String']>;
  clickedAddressUuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosJourneyDataCategories_MarketplacePropertyCategory_TourBookingStartEventInput = {
  addressUuid?: InputMaybe<Scalars['String']>;
  placement?: InputMaybe<Scalars['String']>;
};

export type OdProtosJourneyDataCategories_PlatformCategoryInput = {
  /** Next ID: 29 */
  event?: InputMaybe<OdProtosJourneyDataCategories_PlatformCategory_EventOneofInput>;
};

export type OdProtosJourneyDataCategories_PlatformCategory_AccordionClickEventInput = {
  /** Name of the individual accordion in the accordion list */
  accordionName?: InputMaybe<Scalars['String']>;
  /**
   * Canonical identifier of the accordion list
   * Convention: {app_name}-{accordion_list_name}
   * accordion_list_name should be unique within the app
   */
  targetName?: InputMaybe<Scalars['String']>;
};

export type OdProtosJourneyDataCategories_PlatformCategory_AccordionViewEventInput = {
  /**
   * Canonical identifier of the accordion list
   * Convention: {app_name}-{accordion_list_name}
   * accordion_list_name should be unique within the app
   */
  targetName?: InputMaybe<Scalars['String']>;
};

export type OdProtosJourneyDataCategories_PlatformCategory_AppBackgroundedEventInput = {
  /** App build number (e.g., "456") */
  build?: InputMaybe<Scalars['String']>;
  /** App version (e.g., "1.2.3") */
  version?: InputMaybe<Scalars['String']>;
};

export type OdProtosJourneyDataCategories_PlatformCategory_AppDownloadLinkEventInput = {
  devicePlatform?: InputMaybe<OdProtosJourneyDataCategories_PlatformCategory_DevicePlatform>;
  linkMethod?: InputMaybe<OdProtosJourneyDataCategories_PlatformCategory_LinkMethod>;
};

export type OdProtosJourneyDataCategories_PlatformCategory_AppForegroundedEventInput = {
  /** App build number (e.g., "456") */
  build?: InputMaybe<Scalars['String']>;
  /** Whether app transitioned from background (always true for this event) */
  fromBackground?: InputMaybe<Scalars['Boolean']>;
  /** App version (e.g., "1.2.3") */
  version?: InputMaybe<Scalars['String']>;
};

/** App lifecycle events for mobile apps */
export type OdProtosJourneyDataCategories_PlatformCategory_AppLaunchedEventInput = {
  /** App build number (e.g., "456") */
  build?: InputMaybe<Scalars['String']>;
  /** Whether app transitioned from background to foreground (vs cold start) */
  fromBackground?: InputMaybe<Scalars['Boolean']>;
  /** Bundle ID of referring application if launched from another app */
  referringApplication?: InputMaybe<Scalars['String']>;
  /** Deep link URL if app was launched via URL */
  url?: InputMaybe<Scalars['String']>;
  /** App version (e.g., "1.2.3") */
  version?: InputMaybe<Scalars['String']>;
};

export type OdProtosJourneyDataCategories_PlatformCategory_BoxViewEventInput = {
  /**
   * Canonical identifier of the box
   * Convention: {app_name}-{box_name}
   * box_name should be unique within the app
   */
  targetName?: InputMaybe<Scalars['String']>;
};

export type OdProtosJourneyDataCategories_PlatformCategory_ButtonClickEventInput = {
  /**
   * Canonical identifier of the button
   * Convention: {app_name}-{button_name}
   * button_name should be unique within the app
   */
  targetName?: InputMaybe<Scalars['String']>;
};

export type OdProtosJourneyDataCategories_PlatformCategory_ButtonViewEventInput = {
  /**
   * Canonical identifier of the button
   * Convention: {app_name}-{button_name}
   * button_name should be unique within the app
   */
  targetName?: InputMaybe<Scalars['String']>;
};

export type OdProtosJourneyDataCategories_PlatformCategory_CardViewEventInput = {
  /**
   * Canonical identifier of the card
   * Convention: {app_name}-{card_name}
   * card_name should be unique within the app
   */
  targetName?: InputMaybe<Scalars['String']>;
};

export type OdProtosJourneyDataCategories_PlatformCategory_CheckboxClickEventInput = {
  /** Name of the individual checkbox in the checkbox group */
  optionName?: InputMaybe<Scalars['String']>;
  /**
   * Canonical identifier of the checkbox group
   * Convention: {app_name}-{checkbox_name}
   * checkbox_name should be unique within the app
   */
  targetName?: InputMaybe<Scalars['String']>;
};

export type OdProtosJourneyDataCategories_PlatformCategory_CheckboxViewEventInput = {
  /**
   * Canonical identifier of the checkbox group
   * Convention: {app_name}-{checkbox_name}
   * checkbox_name should be unique within the app
   */
  targetName?: InputMaybe<Scalars['String']>;
};

export type OdProtosJourneyDataCategories_PlatformCategory_CustomerOneTimeExperienceEventInput = {
  experienceName?: InputMaybe<Scalars['String']>;
};

export type OdProtosJourneyDataCategories_PlatformCategory_CustomerUnsubscribeEventInput = {
  feedName?: InputMaybe<Scalars['String']>;
};

export type OdProtosJourneyDataCategories_PlatformCategory_DevicePlatform =
  | 'ANDROID'
  | 'DEVICE_PLATFORM_UNSPECIFIED'
  | 'IOS';

export type OdProtosJourneyDataCategories_PlatformCategory_EventOneofInput = {
  accordionClickEvent?: InputMaybe<OdProtosJourneyDataCategories_PlatformCategory_AccordionClickEventInput>;
  accordionViewEvent?: InputMaybe<OdProtosJourneyDataCategories_PlatformCategory_AccordionViewEventInput>;
  appBackgroundedEvent?: InputMaybe<OdProtosJourneyDataCategories_PlatformCategory_AppBackgroundedEventInput>;
  appDownloadLinkEvent?: InputMaybe<OdProtosJourneyDataCategories_PlatformCategory_AppDownloadLinkEventInput>;
  appForegroundedEvent?: InputMaybe<OdProtosJourneyDataCategories_PlatformCategory_AppForegroundedEventInput>;
  appLaunchedEvent?: InputMaybe<OdProtosJourneyDataCategories_PlatformCategory_AppLaunchedEventInput>;
  boxViewEvent?: InputMaybe<OdProtosJourneyDataCategories_PlatformCategory_BoxViewEventInput>;
  buttonClickEvent?: InputMaybe<OdProtosJourneyDataCategories_PlatformCategory_ButtonClickEventInput>;
  buttonViewEvent?: InputMaybe<OdProtosJourneyDataCategories_PlatformCategory_ButtonViewEventInput>;
  cardViewEvent?: InputMaybe<OdProtosJourneyDataCategories_PlatformCategory_CardViewEventInput>;
  checkboxClickEvent?: InputMaybe<OdProtosJourneyDataCategories_PlatformCategory_CheckboxClickEventInput>;
  checkboxViewEvent?: InputMaybe<OdProtosJourneyDataCategories_PlatformCategory_CheckboxViewEventInput>;
  customerOneTimeExperienceEvent?: InputMaybe<OdProtosJourneyDataCategories_PlatformCategory_CustomerOneTimeExperienceEventInput>;
  customerUnsubscribeEvent?: InputMaybe<OdProtosJourneyDataCategories_PlatformCategory_CustomerUnsubscribeEventInput>;
  imageViewEvent?: InputMaybe<OdProtosJourneyDataCategories_PlatformCategory_ImageViewEventInput>;
  initialPageViewEvent?: InputMaybe<OdProtosJourneyDataCategories_PlatformCategory_InitialPageViewEventInput>;
  inputViewEvent?: InputMaybe<OdProtosJourneyDataCategories_PlatformCategory_InputViewEventInput>;
  leadOneTimeExperienceEvent?: InputMaybe<OdProtosJourneyDataCategories_PlatformCategory_LeadOneTimeExperienceEventInput>;
  linkClickEvent?: InputMaybe<OdProtosJourneyDataCategories_PlatformCategory_LinkClickEventInput>;
  linkViewEvent?: InputMaybe<OdProtosJourneyDataCategories_PlatformCategory_LinkViewEventInput>;
  pageLoadedEvent?: InputMaybe<OdProtosJourneyDataCategories_PlatformCategory_PageLoadedEventInput>;
  pageViewEvent?: InputMaybe<OdProtosJourneyDataCategories_PlatformCategory_PageViewEventInput>;
  radioClickEvent?: InputMaybe<OdProtosJourneyDataCategories_PlatformCategory_RadioClickEventInput>;
  radioViewEvent?: InputMaybe<OdProtosJourneyDataCategories_PlatformCategory_RadioViewEventInput>;
  screenViewEvent?: InputMaybe<OdProtosJourneyDataCategories_PlatformCategory_ScreenViewEventInput>;
  sessionEndEvent?: InputMaybe<OdProtosJourneyDataCategories_PlatformCategory_SessionEndEventInput>;
  sessionStartEvent?: InputMaybe<OdProtosJourneyDataCategories_PlatformCategory_SessionStartEventInput>;
  textViewEvent?: InputMaybe<OdProtosJourneyDataCategories_PlatformCategory_TextViewEventInput>;
};

export type OdProtosJourneyDataCategories_PlatformCategory_ImageViewEventInput = {
  /**
   * Canonical identifier of the image
   * Convention: {app_name}-{image_name}
   * image_name should be unique within the app
   */
  targetName?: InputMaybe<Scalars['String']>;
};

/** temporary initial page_view event */
export type OdProtosJourneyDataCategories_PlatformCategory_InitialPageViewEventInput = {
  _empty?: InputMaybe<Scalars['Boolean']>;
};

export type OdProtosJourneyDataCategories_PlatformCategory_InputViewEventInput = {
  /**
   * Canonical identifier of the input
   * Convention: {app_name}-{input_name}
   * input_name should be unique within the app
   */
  targetName?: InputMaybe<Scalars['String']>;
};

export type OdProtosJourneyDataCategories_PlatformCategory_LeadOneTimeExperienceEventInput = {
  experienceName?: InputMaybe<Scalars['String']>;
  leadId?: InputMaybe<Scalars['String']>;
  sellerLeadUuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosJourneyDataCategories_PlatformCategory_LinkClickEventInput = {
  /**
   * Canonical identifier of the link
   * Convention: {app_name}-{link_name}
   * link_name should be unique within the app
   */
  targetName?: InputMaybe<Scalars['String']>;
};

export type OdProtosJourneyDataCategories_PlatformCategory_LinkMethod =
  | 'CLICK'
  | 'LINK_METHOD_UNSPECIFIED'
  | 'QR_SCAN';

export type OdProtosJourneyDataCategories_PlatformCategory_LinkViewEventInput = {
  /**
   * Canonical identifier of the link
   * Convention: {app_name}-{link_name}
   * link_name should be unique within the app
   */
  targetName?: InputMaybe<Scalars['String']>;
};

/** Used for measuring page performance, e.g. load time. */
export type OdProtosJourneyDataCategories_PlatformCategory_PageLoadedEventInput = {
  loadTimeMs?: InputMaybe<Scalars['Int']>;
  routerPath?: InputMaybe<Scalars['String']>;
};

/**
 * website_source field contains the page's url, etc.
 * No other event-specific data needed for now.
 */
export type OdProtosJourneyDataCategories_PlatformCategory_PageViewEventInput = {
  _empty?: InputMaybe<Scalars['Boolean']>;
};

export type OdProtosJourneyDataCategories_PlatformCategory_RadioClickEventInput = {
  /** Name of the individual radio in the radio group */
  optionName?: InputMaybe<Scalars['String']>;
  /**
   * Canonical identifier of the radio group
   * Convention: {app_name}-{radio_name}
   * radio_name should be unique within the app
   */
  targetName?: InputMaybe<Scalars['String']>;
};

export type OdProtosJourneyDataCategories_PlatformCategory_RadioViewEventInput = {
  /**
   * Canonical identifier of the radio group
   * Convention: {app_name}-{radio_name}
   * radio_name should be unique within the app
   */
  targetName?: InputMaybe<Scalars['String']>;
};

/**
 * mobile_source field contains the screen's focusRouteName, etc.
 * No other event-specfic data needed for now.
 */
export type OdProtosJourneyDataCategories_PlatformCategory_ScreenViewEventInput = {
  _empty?: InputMaybe<Scalars['Boolean']>;
};

export type OdProtosJourneyDataCategories_PlatformCategory_SessionEndEventInput = {
  _empty?: InputMaybe<Scalars['Boolean']>;
};

export type OdProtosJourneyDataCategories_PlatformCategory_SessionStartEventInput = {
  _empty?: InputMaybe<Scalars['Boolean']>;
};

export type OdProtosJourneyDataCategories_PlatformCategory_TextViewEventInput = {
  /**
   * Canonical identifier of the text
   * Convention: {app_name}-{text_name}
   * text_name should be unique within the app
   */
  targetName?: InputMaybe<Scalars['String']>;
};

export type OdProtosJourneyDataCategories_RetailWebUnlockCategoryInput = {
  event?: InputMaybe<OdProtosJourneyDataCategories_RetailWebUnlockCategory_EventOneofInput>;
};

export type OdProtosJourneyDataCategories_RetailWebUnlockCategory_ContactUsEventInput = {
  target?: InputMaybe<Scalars['String']>;
};

export type OdProtosJourneyDataCategories_RetailWebUnlockCategory_EventOneofInput = {
  contactUsEvent?: InputMaybe<OdProtosJourneyDataCategories_RetailWebUnlockCategory_ContactUsEventInput>;
  generalErrorEvent?: InputMaybe<OdProtosJourneyDataCategories_RetailWebUnlockCategory_GeneralErrorEventInput>;
  idVerificationEvent?: InputMaybe<OdProtosJourneyDataCategories_RetailWebUnlockCategory_IdVerificationEventInput>;
  idVerificationSubmissionEvent?: InputMaybe<OdProtosJourneyDataCategories_RetailWebUnlockCategory_IdVerificationSubmissionEventInput>;
  locationPermissionEvent?: InputMaybe<OdProtosJourneyDataCategories_RetailWebUnlockCategory_LocationPermissionEventInput>;
  propertyStatusEvent?: InputMaybe<OdProtosJourneyDataCategories_RetailWebUnlockCategory_PropertyStatusEventInput>;
  unlockAttemptEvent?: InputMaybe<OdProtosJourneyDataCategories_RetailWebUnlockCategory_UnlockAttemptEventInput>;
  viewEvent?: InputMaybe<OdProtosJourneyDataCategories_RetailWebUnlockCategory_ViewEventInput>;
};

export type OdProtosJourneyDataCategories_RetailWebUnlockCategory_GeneralErrorEventInput = {
  addressUuid?: InputMaybe<Scalars['String']>;
  error?: InputMaybe<Scalars['String']>;
  listingId?: InputMaybe<Scalars['String']>;
};

export type OdProtosJourneyDataCategories_RetailWebUnlockCategory_IdVerificationActions =
  | 'ALLOW_CAMERA'
  | 'DISALLOW_CAMERA'
  | 'SCAN_BACK'
  | 'SCAN_FRONT'
  | 'UNKNOWN_IDV_ACTION';

export type OdProtosJourneyDataCategories_RetailWebUnlockCategory_IdVerificationEventInput = {
  action?: InputMaybe<OdProtosJourneyDataCategories_RetailWebUnlockCategory_IdVerificationActions>;
};

export type OdProtosJourneyDataCategories_RetailWebUnlockCategory_IdVerificationFailureFlavor =
  | 'EXPIRED_ID'
  | 'MITEK_ERROR'
  | 'OD_SERVERSIDE_ERROR'
  | 'UNDERAGE_ID'
  | 'UNKNOWN_IDV_FAILURE';

export type OdProtosJourneyDataCategories_RetailWebUnlockCategory_IdVerificationSubmissionEventInput = {
  failureReason?: InputMaybe<OdProtosJourneyDataCategories_RetailWebUnlockCategory_IdVerificationFailureFlavor>;
  success?: InputMaybe<Scalars['Boolean']>;
};

export type OdProtosJourneyDataCategories_RetailWebUnlockCategory_ListingValidationFailureFlavor =
  | 'AFTER_HOURS_TOURING'
  | 'HOME_SOLD'
  | 'HOME_UNDER_CONTRACT'
  | 'PPM'
  | 'TEMPORARILY_OFF_MARKET'
  | 'TRADITIONAL_LISTING'
  | 'UNKNOWN_LISTING_FAILURE';

export type OdProtosJourneyDataCategories_RetailWebUnlockCategory_LocationPermissionEventInput = {
  locationPermission?: InputMaybe<Scalars['Boolean']>;
};

export type OdProtosJourneyDataCategories_RetailWebUnlockCategory_PropertyStatusEventInput = {
  addressUuid?: InputMaybe<Scalars['String']>;
  listingId?: InputMaybe<Scalars['String']>;
  tourUnavailableReason?: InputMaybe<OdProtosJourneyDataCategories_RetailWebUnlockCategory_ListingValidationFailureFlavor>;
};

export type OdProtosJourneyDataCategories_RetailWebUnlockCategory_StepType =
  | 'GENERAL_ERROR'
  | 'ID_VERIFICATION_STEPS'
  | 'ONBOARDING_STEPS'
  | 'PROPERTY_CONFIRMATION_STEPS'
  | 'UNKNOWN_STEP'
  | 'UNLOCK_HOME_STEPS';

export type OdProtosJourneyDataCategories_RetailWebUnlockCategory_UnlockAttemptEventInput = {
  addressUuid?: InputMaybe<Scalars['String']>;
  failureReason?: InputMaybe<OdProtosJourneyDataCategories_RetailWebUnlockCategory_UnlockFailureFlavor>;
  listingId?: InputMaybe<Scalars['String']>;
  success?: InputMaybe<Scalars['Boolean']>;
};

export type OdProtosJourneyDataCategories_RetailWebUnlockCategory_UnlockFailureFlavor =
  | 'CODE_UNLOCK'
  | 'FAILED_UNLOCK'
  | 'NEED_MORE_INFO'
  | 'UNKNOWN_UNLOCK_FAILURE';

export type OdProtosJourneyDataCategories_RetailWebUnlockCategory_ViewEventInput = {
  /** address_id is not set in start of the flow, so we allow it to be null */
  addressUuid?: InputMaybe<Scalars['String']>;
  /** listing_id is not set in start of the flow, so we allow it to be null */
  listingId?: InputMaybe<Scalars['String']>;
  step?: InputMaybe<Scalars['String']>;
  stepType?: InputMaybe<OdProtosJourneyDataCategories_RetailWebUnlockCategory_StepType>;
};

export type OdProtosJourneyDataCategories_SellCategoryInput = {
  /** Next ID: 11 */
  event?: InputMaybe<OdProtosJourneyDataCategories_SellCategory_EventOneofInput>;
};

/** Next ID: 13 */
export type OdProtosJourneyDataCategories_SellCategory_AddressEntryEventInput = {
  campaign?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  latitude?: InputMaybe<Scalars['Float']>;
  longitude?: InputMaybe<Scalars['Float']>;
  market?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  receptionChannel?: InputMaybe<OdProtosSellReceptionData_SellerInput_Channel>;
  sellerInputId?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  /**
   * Fields match IAddressInputAddress
   * https://github.com/opendoor-labs/code/blob/c393c8d0061e9a8ce32c63621d3ec1ded9fa55ca/js/packages/cinderblocks/src/growth/AddressInput/AddressInput.tsx#L19
   */
  street1?: InputMaybe<Scalars['String']>;
  unit?: InputMaybe<Scalars['String']>;
};

/** Next ID: 11 */
export type OdProtosJourneyDataCategories_SellCategory_AddressEntryV2EventInput = {
  campaign?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  latitude?: InputMaybe<Scalars['Float']>;
  longitude?: InputMaybe<Scalars['Float']>;
  market?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  sourcePage?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  street1?: InputMaybe<Scalars['String']>;
  unit?: InputMaybe<Scalars['String']>;
};

/** Next ID: 4 */
export type OdProtosJourneyDataCategories_SellCategory_ApiOfferRequestEventInput = {
  email?: InputMaybe<Scalars['String']>;
  partnerIdentifier?: InputMaybe<Scalars['String']>;
  sellerInputId?: InputMaybe<Scalars['String']>;
};

/** Next ID: 7 */
export type OdProtosJourneyDataCategories_SellCategory_ApiReferralHandoverEventInput = {
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  partnerIdentifier?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  sellerInputId?: InputMaybe<Scalars['String']>;
};

/** Track the s3w intent for each lead at FO */
export type OdProtosJourneyDataCategories_SellCategory_CustomerProductIntentAtFinalOfferInput = {
  intent?: InputMaybe<OdProtosJourneyDataCategories_SellCategory_ProductIntentType>;
  leadId?: InputMaybe<Scalars['String']>;
  offerUuid?: InputMaybe<Scalars['String']>;
  sellerLeadUuid?: InputMaybe<Scalars['String']>;
};

/** Track the s3w intent for each lead after FO */
export type OdProtosJourneyDataCategories_SellCategory_CustomerProductIntentPostFinalOfferInput = {
  intent?: InputMaybe<OdProtosJourneyDataCategories_SellCategory_ProductIntentType>;
  leadId?: InputMaybe<Scalars['String']>;
  offerUuid?: InputMaybe<Scalars['String']>;
  sellerLeadUuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosJourneyDataCategories_SellCategory_EventOneofInput = {
  /**
   * Growth team-owned events
   *
   * sell_address_entry_event
   */
  addressEntry?: InputMaybe<OdProtosJourneyDataCategories_SellCategory_AddressEntryEventInput>;
  /** sell_address_entry_v2_event */
  addressEntryV2?: InputMaybe<OdProtosJourneyDataCategories_SellCategory_AddressEntryV2EventInput>;
  /** sell_api_offer_request_event */
  apiOfferRequest?: InputMaybe<OdProtosJourneyDataCategories_SellCategory_ApiOfferRequestEventInput>;
  /** sell_api_referral_handover_event */
  apiReferralHandover?: InputMaybe<OdProtosJourneyDataCategories_SellCategory_ApiReferralHandoverEventInput>;
  customerProductIntentAtFinalOffer?: InputMaybe<OdProtosJourneyDataCategories_SellCategory_CustomerProductIntentAtFinalOfferInput>;
  customerProductIntentPostFinalOffer?: InputMaybe<OdProtosJourneyDataCategories_SellCategory_CustomerProductIntentPostFinalOfferInput>;
  /** sell_experience_viewed_event */
  experienceViewed?: InputMaybe<OdProtosJourneyDataCategories_SellCategory_ExperienceViewedEventInput>;
  /** sell_onboarding_start_event */
  onboardingStart?: InputMaybe<OdProtosJourneyDataCategories_SellCategory_OnboardingStartEventInput>;
  /** Seller team-owned events */
  ssvaTaskComplete?: InputMaybe<OdProtosJourneyDataCategories_SellCategory_SsvaTaskCompleteEventInput>;
};

/** Triggered when a seller views a sell experience page */
export type OdProtosJourneyDataCategories_SellCategory_ExperienceViewedEventInput = {
  /** Optional: specific page design slug for tracking */
  experienceSlug?: InputMaybe<Scalars['String']>;
  experienceType?: InputMaybe<OdProtosSellSellerData_SellerExperience>;
  isFirstOffer?: InputMaybe<Scalars['Boolean']>;
  offerState?: InputMaybe<OdProtosSellSellerData_Offer_State>;
  offerUuid?: InputMaybe<Scalars['String']>;
  sellerLeadUuid?: InputMaybe<Scalars['String']>;
};

/** Next ID: 11 */
export type OdProtosJourneyDataCategories_SellCategory_OnboardingStartEventInput = {
  city?: InputMaybe<Scalars['String']>;
  latitude?: InputMaybe<Scalars['Float']>;
  longitude?: InputMaybe<Scalars['Float']>;
  market?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  receptionChannel?: InputMaybe<OdProtosSellReceptionData_SellerInput_Channel>;
  sellerInputUuid?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  street1?: InputMaybe<Scalars['String']>;
  unit?: InputMaybe<Scalars['String']>;
};

export type OdProtosJourneyDataCategories_SellCategory_ProductIntentType =
  | 'LIST'
  | 'MARKETPLACE'
  | 'SELL_DIRECT'
  | 'UNKNOWN_TYPE';

export type OdProtosJourneyDataCategories_SellCategory_SsvaTaskCompleteEventInput = {
  leadId?: InputMaybe<Scalars['String']>;
  offerId?: InputMaybe<Scalars['String']>;
  offerUuid?: InputMaybe<Scalars['String']>;
  sellerLeadUuid?: InputMaybe<Scalars['String']>;
  ssvaTaskName?: InputMaybe<OdProtosJourneyDataCategories_SellCategory_SsvaTaskType>;
};

export type OdProtosJourneyDataCategories_SellCategory_SsvaTaskType =
  | 'QUESTIONNAIRE_TASK'
  | 'SELLER_DISCLOSURE_DOCUMENT_TASK'
  | 'UNKNOWN_SSVA_TASK_TYPE'
  | 'UPLOAD_BACKYARD_RECORDING_TASK'
  | 'UPLOAD_FRONTYARD_RECORDING_TASK'
  | 'UPLOAD_INTERIOR_RECORDING_TASK'
  | 'UPLOAD_WHOLE_HOME_RECORDING_TASK';

export type OdProtosJourneyDataCategories_SellDirectCategoryInput = {
  event?: InputMaybe<OdProtosJourneyDataCategories_SellDirectCategory_EventOneofInput>;
};

export type OdProtosJourneyDataCategories_SellDirectCategory_EventOneofInput = {
  finalOfferCreated?: InputMaybe<OdProtosJourneyDataCategories_SellDirectCategory_FinalOfferCreatedEventInput>;
  offerCreated?: InputMaybe<OdProtosJourneyDataCategories_SellDirectCategory_OfferCreatedEventInput>;
  offerFallthrough?: InputMaybe<OdProtosJourneyDataCategories_SellDirectCategory_OfferFallthroughEventInput>;
  offerView?: InputMaybe<OdProtosJourneyDataCategories_SellDirectCategory_OfferViewEventInput>;
  /** sell_direct_qualification_event */
  qualification?: InputMaybe<OdProtosJourneyDataCategories_SellDirectCategory_QualificationEventInput>;
  signComplete?: InputMaybe<OdProtosJourneyDataCategories_SellDirectCategory_SignCompleteEventInput>;
  signQuestionsSubmit?: InputMaybe<OdProtosJourneyDataCategories_SellDirectCategory_SignQuestionsSubmitEventInput>;
  signStart?: InputMaybe<OdProtosJourneyDataCategories_SellDirectCategory_SignStartEventInput>;
};

export type OdProtosJourneyDataCategories_SellDirectCategory_FallthroughType =
  | 'EXPIRATION'
  | 'OD_WALK'
  | 'SELLER_WALK'
  | 'UNKNOWN_FALLTHROUGH_TYPE';

export type OdProtosJourneyDataCategories_SellDirectCategory_FinalOfferCreatedEventInput = {
  finalizedFeePct?: InputMaybe<Scalars['Float']>;
  headlinePrice?: InputMaybe<Scalars['Float']>;
  leadId?: InputMaybe<Scalars['String']>;
  offerId?: InputMaybe<Scalars['String']>;
  offerUuid?: InputMaybe<Scalars['String']>;
  ovmExpectedError?: InputMaybe<Scalars['Float']>;
  sellerLeadUuid?: InputMaybe<Scalars['String']>;
  underwritingId?: InputMaybe<Scalars['String']>;
};

export type OdProtosJourneyDataCategories_SellDirectCategory_OfferCreatedEventInput = {
  headlineFeePct?: InputMaybe<Scalars['Float']>;
  headlineOffer?: InputMaybe<Scalars['Float']>;
  internalFeePct?: InputMaybe<Scalars['Float']>;
  leadId?: InputMaybe<Scalars['String']>;
  offerCreationSource?: InputMaybe<OdProtosCommonSell_OfferRequest_Source>;
  offerId?: InputMaybe<Scalars['String']>;
  offerIsRefresh?: InputMaybe<Scalars['Boolean']>;
  offerRefreshIndex?: InputMaybe<Scalars['Int']>;
  offerUuid?: InputMaybe<Scalars['String']>;
  opendoorInitiated?: InputMaybe<Scalars['Boolean']>;
  ovmExpectedError?: InputMaybe<Scalars['Float']>;
  sellerInputId?: InputMaybe<Scalars['String']>;
  sellerLeadUuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosJourneyDataCategories_SellDirectCategory_OfferFallthroughEventInput = {
  fallthroughType?: InputMaybe<OdProtosJourneyDataCategories_SellDirectCategory_FallthroughType>;
  leadId?: InputMaybe<Scalars['String']>;
  offerId?: InputMaybe<Scalars['String']>;
  offerUuid?: InputMaybe<Scalars['String']>;
  sellerLeadUuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosJourneyDataCategories_SellDirectCategory_OfferViewEventInput = {
  isFirstOffer?: InputMaybe<Scalars['Boolean']>;
  leadId?: InputMaybe<Scalars['String']>;
  /** This is populated with a UUID, not a numeric ID as the name suggests */
  offerId?: InputMaybe<Scalars['String']>;
  offerState?: InputMaybe<OdProtosSellSellerData_Offer_State>;
  offerUuid?: InputMaybe<Scalars['String']>;
  sellerLeadUuid?: InputMaybe<Scalars['String']>;
};

/**
 * sell_direct_qualification_event
 * Triggered whenever qualification for the Sell Direct product changes
 */
export type OdProtosJourneyDataCategories_SellDirectCategory_QualificationEventInput = {
  denialReason?: InputMaybe<Scalars['String']>;
  qualificationChannel?: InputMaybe<OdProtosSellReceptionData_SellerInput_Channel>;
  qualificationDecision?: InputMaybe<OdProtosJourneyDataCategories_SellDirectCategory_QualificationEvent_QualificationDecision>;
  sellerInputId?: InputMaybe<Scalars['String']>;
};

export type OdProtosJourneyDataCategories_SellDirectCategory_QualificationEvent_QualificationDecision =
  | 'PRODUCT_DENIED'
  | 'PRODUCT_QUALIFIED'
  | 'PRODUCT_UNDENIED'
  | 'UNKNOWN';

export type OdProtosJourneyDataCategories_SellDirectCategory_SignCompleteEventInput = {
  headlinePrice?: InputMaybe<Scalars['Float']>;
  leadId?: InputMaybe<Scalars['String']>;
  offerId?: InputMaybe<Scalars['String']>;
  offerUuid?: InputMaybe<Scalars['String']>;
  sellerLeadUuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosJourneyDataCategories_SellDirectCategory_SignQuestionsSubmitEventInput = {
  leadId?: InputMaybe<Scalars['String']>;
  offerId?: InputMaybe<Scalars['String']>;
  offerUuid?: InputMaybe<Scalars['String']>;
  sellerLeadUuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosJourneyDataCategories_SellDirectCategory_SignStartEventInput = {
  leadId?: InputMaybe<Scalars['String']>;
  offerId?: InputMaybe<Scalars['String']>;
  offerUuid?: InputMaybe<Scalars['String']>;
  sellerLeadUuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosJourneyDataCategories_SellEaCategoryInput = {
  event?: InputMaybe<OdProtosJourneyDataCategories_SellEaCategory_EventOneofInput>;
};

export type OdProtosJourneyDataCategories_SellEaCategory_CompleteEventInput = {
  eaType?: InputMaybe<OdProtosJourneyDataCategories_SellEaCategory_EaType>;
  leadId?: InputMaybe<Scalars['String']>;
  offerId?: InputMaybe<Scalars['String']>;
  offerUuid?: InputMaybe<Scalars['String']>;
  sellerLeadUuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosJourneyDataCategories_SellEaCategory_EaType =
  | 'EXTERIOR_ASSESSMENT'
  | 'EXTERIOR_VIRTUAL_ASSESSMENT'
  /** exterior + interior of home */
  | 'HOME_ASSESSMENT'
  | 'UNKNOWN_EA_TYPE';

export type OdProtosJourneyDataCategories_SellEaCategory_EventOneofInput = {
  complete?: InputMaybe<OdProtosJourneyDataCategories_SellEaCategory_CompleteEventInput>;
  schedule?: InputMaybe<OdProtosJourneyDataCategories_SellEaCategory_ScheduleEventInput>;
};

export type OdProtosJourneyDataCategories_SellEaCategory_ScheduleEventInput = {
  eaType?: InputMaybe<OdProtosJourneyDataCategories_SellEaCategory_EaType>;
  leadId?: InputMaybe<Scalars['String']>;
  offerId?: InputMaybe<Scalars['String']>;
  offerUuid?: InputMaybe<Scalars['String']>;
  scheduledDatetime?: InputMaybe<Scalars['DateTime']>;
  sellerLeadUuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosJourneyDataCategories_SellFinalOfferCallCategoryInput = {
  event?: InputMaybe<OdProtosJourneyDataCategories_SellFinalOfferCallCategory_EventOneofInput>;
};

export type OdProtosJourneyDataCategories_SellFinalOfferCallCategory_EventOneofInput = {
  canceled?: InputMaybe<OdProtosJourneyDataCategories_SellFinalOfferCallCategory_FinalOfferCallCanceledEventInput>;
  proposed?: InputMaybe<OdProtosJourneyDataCategories_SellFinalOfferCallCategory_FinalOfferCallProposedEventInput>;
  rescheduled?: InputMaybe<OdProtosJourneyDataCategories_SellFinalOfferCallCategory_FinalOfferCallRescheduledEventInput>;
  scheduled?: InputMaybe<OdProtosJourneyDataCategories_SellFinalOfferCallCategory_FinalOfferCallScheduledEventInput>;
};

export type OdProtosJourneyDataCategories_SellFinalOfferCallCategory_FinalOfferCallCanceledEventInput = {
  offerUuid?: InputMaybe<Scalars['String']>;
  sellerLeadUuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosJourneyDataCategories_SellFinalOfferCallCategory_FinalOfferCallProposedEventInput = {
  offerUuid?: InputMaybe<Scalars['String']>;
  sellerLeadUuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosJourneyDataCategories_SellFinalOfferCallCategory_FinalOfferCallRescheduledEventInput = {
  offerUuid?: InputMaybe<Scalars['String']>;
  scheduledDatetime?: InputMaybe<Scalars['DateTime']>;
  sellerLeadUuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosJourneyDataCategories_SellFinalOfferCallCategory_FinalOfferCallScheduledEventInput = {
  offerUuid?: InputMaybe<Scalars['String']>;
  scheduledDatetime?: InputMaybe<Scalars['DateTime']>;
  sellerLeadUuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosJourneyDataCategories_SellListCategoryInput = {
  event?: InputMaybe<OdProtosJourneyDataCategories_SellListCategory_EventOneofInput>;
};

export type OdProtosJourneyDataCategories_SellListCategory_AgreementSignCompleteEventInput = {
  lwcProductId?: InputMaybe<Scalars['String']>;
  sellDirectLeadToken?: InputMaybe<Scalars['String']>;
  sellerLeadUuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosJourneyDataCategories_SellListCategory_EventOneofInput = {
  /**
   * Field 3 (intent_update) was removed - IntentUpdateEvent is no longer published
   *
   * sell_list_agreement_sign_complete_event
   */
  agreementSignComplete?: InputMaybe<OdProtosJourneyDataCategories_SellListCategory_AgreementSignCompleteEventInput>;
  /** sell_list_offer_view_event */
  offerView?: InputMaybe<OdProtosJourneyDataCategories_SellListCategory_OfferViewEventInput>;
  /** sell_list_qualification_event */
  qualification?: InputMaybe<OdProtosJourneyDataCategories_SellListCategory_QualificationEventInput>;
};

/** Triggered when an LwC-enrolled lead views the offer dashboard */
export type OdProtosJourneyDataCategories_SellListCategory_OfferViewEventInput = {
  isFirstOffer?: InputMaybe<Scalars['Boolean']>;
  listingRangeMax?: InputMaybe<OdProtosCommon_MoneyInput>;
  listingRangeMin?: InputMaybe<OdProtosCommon_MoneyInput>;
  offerUuid?: InputMaybe<Scalars['String']>;
  recommendedProduct?: InputMaybe<Scalars['String']>;
  sellDirectLeadToken?: InputMaybe<Scalars['String']>;
  /** This is populated with a UUID, not a numeric ID as the name suggests */
  sellDirectOfferId?: InputMaybe<Scalars['String']>;
  sellerLeadUuid?: InputMaybe<Scalars['String']>;
};

/** Triggered when a Sell Direct lead's LwC qualification status changes */
export type OdProtosJourneyDataCategories_SellListCategory_QualificationEventInput = {
  lwcProductId?: InputMaybe<Scalars['String']>;
  qualificationDecision?: InputMaybe<OdProtosJourneyDataCategories_SellListCategory_QualificationEvent_QualificationDecision>;
  sellDirectLeadToken?: InputMaybe<Scalars['String']>;
  sellerLeadUuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosJourneyDataCategories_SellListCategory_QualificationEvent_QualificationDecision =
  | 'PRODUCT_DENIED'
  | 'PRODUCT_QUALIFIED'
  | 'PRODUCT_UNDENIED'
  | 'UNKNOWN';

export type OdProtosJourneyDataCategories_SellOrvaCategoryInput = {
  event?: InputMaybe<OdProtosJourneyDataCategories_SellOrvaCategory_EventOneofInput>;
};

export type OdProtosJourneyDataCategories_SellOrvaCategory_CancelEventInput = {
  cancellationReason?: InputMaybe<OdProtosJourneyDataCategories_SellOrvaCategory_OrvaCancellationReason>;
  cancellationSource?: InputMaybe<Scalars['String']>;
  leadId?: InputMaybe<Scalars['String']>;
  offerId?: InputMaybe<Scalars['String']>;
  offerUuid?: InputMaybe<Scalars['String']>;
  sellerLeadUuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosJourneyDataCategories_SellOrvaCategory_EventOneofInput = {
  cancel?: InputMaybe<OdProtosJourneyDataCategories_SellOrvaCategory_CancelEventInput>;
  reschedule?: InputMaybe<OdProtosJourneyDataCategories_SellOrvaCategory_RescheduleEventInput>;
  schedule?: InputMaybe<OdProtosJourneyDataCategories_SellOrvaCategory_ScheduleEventInput>;
};

export type OdProtosJourneyDataCategories_SellOrvaCategory_OrvaCancellationReason =
  | 'CANCELLATION_REASON_UNKNOWN'
  | 'CEP_CANNOT_MAKE_IT'
  | 'CUSTOMER_CANNOT_MAKE_IT';

export type OdProtosJourneyDataCategories_SellOrvaCategory_RescheduleEventInput = {
  leadId?: InputMaybe<Scalars['String']>;
  offerId?: InputMaybe<Scalars['String']>;
  offerUuid?: InputMaybe<Scalars['String']>;
  sellerLeadUuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosJourneyDataCategories_SellOrvaCategory_ScheduleEventInput = {
  agentScheduled?: InputMaybe<Scalars['String']>;
  leadId?: InputMaybe<Scalars['String']>;
  offerId?: InputMaybe<Scalars['String']>;
  offerUuid?: InputMaybe<Scalars['String']>;
  scheduledDatetime?: InputMaybe<Scalars['DateTime']>;
  sellerLeadUuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosJourneyDataCategories_SellOfferReviewCategoryInput = {
  event?: InputMaybe<OdProtosJourneyDataCategories_SellOfferReviewCategory_EventOneofInput>;
};

export type OdProtosJourneyDataCategories_SellOfferReviewCategory_EventOneofInput = {
  canceled?: InputMaybe<OdProtosJourneyDataCategories_SellOfferReviewCategory_OfferReviewCanceledEventInput>;
  completed?: InputMaybe<OdProtosJourneyDataCategories_SellOfferReviewCategory_OfferReviewCompletedEventInput>;
  rescheduled?: InputMaybe<OdProtosJourneyDataCategories_SellOfferReviewCategory_OfferReviewRescheduledEventInput>;
  scheduled?: InputMaybe<OdProtosJourneyDataCategories_SellOfferReviewCategory_OfferReviewScheduledEventInput>;
};

export type OdProtosJourneyDataCategories_SellOfferReviewCategory_OrOutcome =
  | 'AGENT_CUSTOMER_HANDED_OFF_TO_AEP'
  | 'CALL_NOT_COMPLETE_RESCHEDULE_OR'
  | 'CALL_NOT_COMPLETE_SENT_SSVA'
  | 'CAN_COMPLETE_OR'
  | 'DID_NOT_CONVERT'
  | 'NO_SHOW'
  | 'OPENDOOR_CANNOT_PURCHASE_OOBB'
  | 'UNKNOWN_OR_OUTCOME';

export type OdProtosJourneyDataCategories_SellOfferReviewCategory_OrType =
  | 'OR'
  | 'ORVA'
  | 'UNKNOWN_OR_TYPE';

export type OdProtosJourneyDataCategories_SellOfferReviewCategory_OfferReviewCanceledEventInput = {
  leadId?: InputMaybe<Scalars['String']>;
  offerUuid?: InputMaybe<Scalars['String']>;
  orType?: InputMaybe<OdProtosJourneyDataCategories_SellOfferReviewCategory_OrType>;
  reason?: InputMaybe<Scalars['String']>;
  sellerLeadUuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosJourneyDataCategories_SellOfferReviewCategory_OfferReviewCompletedEventInput = {
  leadId?: InputMaybe<Scalars['String']>;
  offerUuid?: InputMaybe<Scalars['String']>;
  orType?: InputMaybe<OdProtosJourneyDataCategories_SellOfferReviewCategory_OrType>;
  origin?: InputMaybe<OdProtosJourneyDataCategories_SellOfferReviewCategory_Origin>;
  outcome?: InputMaybe<OdProtosJourneyDataCategories_SellOfferReviewCategory_OrOutcome>;
  sellerLeadUuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosJourneyDataCategories_SellOfferReviewCategory_OfferReviewRescheduledEventInput = {
  leadId?: InputMaybe<Scalars['String']>;
  offerUuid?: InputMaybe<Scalars['String']>;
  orType?: InputMaybe<OdProtosJourneyDataCategories_SellOfferReviewCategory_OrType>;
  scheduledDatetime?: InputMaybe<Scalars['DateTime']>;
  sellerLeadUuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosJourneyDataCategories_SellOfferReviewCategory_OfferReviewScheduledEventInput = {
  leadId?: InputMaybe<Scalars['String']>;
  offerUuid?: InputMaybe<Scalars['String']>;
  orType?: InputMaybe<OdProtosJourneyDataCategories_SellOfferReviewCategory_OrType>;
  scheduledDatetime?: InputMaybe<Scalars['DateTime']>;
  sellerLeadUuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosJourneyDataCategories_SellOfferReviewCategory_Origin =
  | 'CUSTOMER_OUTREACH'
  | 'CUSTOMER_SCHEDULED'
  | 'PROACTIVE_OUTREACH'
  | 'UNKNOWN_ORIGIN';

export type OdProtosJourneyDataCategories_SellOnboardingCategoryInput = {
  event?: InputMaybe<OdProtosJourneyDataCategories_SellOnboardingCategory_EventOneofInput>;
};

export type OdProtosJourneyDataCategories_SellOnboardingCategory_EventOneofInput = {
  /** sell_onboarding_questions_submit_event */
  questionsSubmit?: InputMaybe<OdProtosJourneyDataCategories_SellOnboardingCategory_QuestionsSubmitEventInput>;
};

export type OdProtosJourneyDataCategories_SellOnboardingCategory_QuestionsSubmitEventInput = {
  answers?: InputMaybe<OdProtosSellReceptionData_AnswersInput>;
  sellerInputId?: InputMaybe<Scalars['String']>;
};

export type OdProtosJourneyDataCategories_SellVaCategoryInput = {
  event?: InputMaybe<OdProtosJourneyDataCategories_SellVaCategory_EventOneofInput>;
};

export type OdProtosJourneyDataCategories_SellVaCategory_CompleteEventInput = {
  leadId?: InputMaybe<Scalars['String']>;
  offerId?: InputMaybe<Scalars['String']>;
  offerUuid?: InputMaybe<Scalars['String']>;
  sellerLeadUuid?: InputMaybe<Scalars['String']>;
  vaType?: InputMaybe<OdProtosJourneyDataCategories_SellVaCategory_VaType>;
};

export type OdProtosJourneyDataCategories_SellVaCategory_EventOneofInput = {
  complete?: InputMaybe<OdProtosJourneyDataCategories_SellVaCategory_CompleteEventInput>;
  flowStart?: InputMaybe<OdProtosJourneyDataCategories_SellVaCategory_FlowStartEventInput>;
  occupancy?: InputMaybe<OdProtosJourneyDataCategories_SellVaCategory_OccupancyEventInput>;
  start?: InputMaybe<OdProtosJourneyDataCategories_SellVaCategory_StartEventInput>;
};

export type OdProtosJourneyDataCategories_SellVaCategory_FlowStartEventInput = {
  leadId?: InputMaybe<Scalars['String']>;
  /** This is populated with a UUID, not a numeric ID as the name suggests */
  offerId?: InputMaybe<Scalars['String']>;
  offerUuid?: InputMaybe<Scalars['String']>;
  sellerLeadUuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosJourneyDataCategories_SellVaCategory_OccupancyEventInput = {
  leadId?: InputMaybe<Scalars['String']>;
  occupancy?: InputMaybe<OdProtosWebData_OccupancyAtVa>;
  offerUuid?: InputMaybe<Scalars['String']>;
  sellerLeadUuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosJourneyDataCategories_SellVaCategory_StartEventInput = {
  leadId?: InputMaybe<Scalars['String']>;
  /** This is populated with a UUID, not a numeric ID as the name suggests */
  offerId?: InputMaybe<Scalars['String']>;
  offerUuid?: InputMaybe<Scalars['String']>;
  sellerLeadUuid?: InputMaybe<Scalars['String']>;
  vaType?: InputMaybe<OdProtosJourneyDataCategories_SellVaCategory_VaType>;
};

export type OdProtosJourneyDataCategories_SellVaCategory_VaType =
  | 'ORVA'
  | 'SSVA'
  | 'UNKNOWN_VA_TYPE';

export type OdProtosJourneyDataCategories_SellWithUpsideCategoryInput = {
  event?: InputMaybe<OdProtosJourneyDataCategories_SellWithUpsideCategory_EventOneofInput>;
};

export type OdProtosJourneyDataCategories_SellWithUpsideCategory_EstimatedSalesPriceChangeEventInput = {
  changeCents?: InputMaybe<Scalars['Float']>;
  newEstimatedSalesPriceCents?: InputMaybe<Scalars['Float']>;
  offerUuid?: InputMaybe<Scalars['String']>;
  oldEstimatedSalesPriceCents?: InputMaybe<Scalars['Float']>;
  opendoorEstimatedSalesPriceCents?: InputMaybe<Scalars['Float']>;
  sellerLeadUuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosJourneyDataCategories_SellWithUpsideCategory_EventOneofInput = {
  estimatedSalesPriceChange?: InputMaybe<OdProtosJourneyDataCategories_SellWithUpsideCategory_EstimatedSalesPriceChangeEventInput>;
  /** sell_with_upside_qualification_event */
  qualification?: InputMaybe<OdProtosJourneyDataCategories_SellWithUpsideCategory_QualificationEventInput>;
  upfrontCashChange?: InputMaybe<OdProtosJourneyDataCategories_SellWithUpsideCategory_UpfrontCashChangeEventInput>;
};

export type OdProtosJourneyDataCategories_SellWithUpsideCategory_QualificationEventInput = {
  addressUuid?: InputMaybe<Scalars['String']>;
  denialReason?: InputMaybe<Scalars['String']>;
  offerUuid?: InputMaybe<Scalars['String']>;
  qualificationDecision?: InputMaybe<OdProtosJourneyDataCategories_SellWithUpsideCategory_QualificationEvent_QualificationDecision>;
  sellerLeadUuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosJourneyDataCategories_SellWithUpsideCategory_QualificationEvent_QualificationDecision =
  | 'PRODUCT_DENIED'
  | 'PRODUCT_QUALIFIED'
  | 'PRODUCT_UNDENIED'
  | 'UNKNOWN';

export type OdProtosJourneyDataCategories_SellWithUpsideCategory_UpfrontCashChangeEventInput = {
  changeCents?: InputMaybe<Scalars['Float']>;
  newUpfrontCashCents?: InputMaybe<Scalars['Float']>;
  offerUuid?: InputMaybe<Scalars['String']>;
  oldUpfrontCashCents?: InputMaybe<Scalars['Float']>;
  sellerLeadUuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosJourneyDataOptions_CdpOptions_FieldPlacement =
  /** Extra context is used to provide additional metadata. Should only be used in Sources. */
  | 'EXTRA_CONTEXT'
  /** PROP is the default and it is used for properties describing the event. */
  | 'PROP'
  /** Standardized fields have their name and placement hard-coded and do not rely on reflection. */
  | 'STANDARDIZED'
  /** Trait's describe the customer and are relevant beyond a single event (e.g. name, email). */
  | 'TRAIT';

export type OdProtosJourneyDataOptions_CdpOptions_MessageOptions_Format =
  /** JSON_OBJECT nests the message's content using the JSON field names. Maps cannot be used within nested objects. */
  | 'JSON_OBJECT'
  | 'NOT_SPECIFIED';

/**
 * Context for Ad Clicks
 * Next ID: 4
 */
export type OdProtosJourneyData_AdClickContextInput = {
  /** facbook ad click */
  fbclid?: InputMaybe<Scalars['String']>;
  /** google ad click */
  gclid?: InputMaybe<Scalars['String']>;
  /** tiktok ad click */
  ttclid?: InputMaybe<Scalars['String']>;
};

/**
 * Context for Ad analytics
 * Next ID: 8
 */
export type OdProtosJourneyData_AnalyticsContextInput = {
  /** Facebook _fbp cookie */
  fbBrowserId?: InputMaybe<Scalars['String']>;
  /** Facebook _fbc cookie */
  fbClickId?: InputMaybe<Scalars['String']>;
  gaClientId?: InputMaybe<Scalars['String']>;
  /** Google Analytics session ID */
  gaSessionId?: InputMaybe<Scalars['String']>;
  /** Nextdoor ndclid cookie */
  nextdoorClickId?: InputMaybe<Scalars['String']>;
  /** Reddit _rdt_uuid cookie */
  redditBrowserId?: InputMaybe<Scalars['String']>;
  /** TikTok _ttp cookie */
  tiktokBrowserId?: InputMaybe<Scalars['String']>;
};

/** Next ID: 4 */
export type OdProtosJourneyData_BackendSourceInput = {
  clientIp?: InputMaybe<Scalars['String']>;
  /**
   * client's user_agent and IP if the event originates from FE and routed by a BE service
   * should be nil if the event originates from BE
   */
  clientUserAgent?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** Next ID: 2 */
export type OdProtosJourneyData_BackfillSourceInput = {
  eventOrigin?: InputMaybe<OdProtosJourneyData_BackfillSource_EventOrigin>;
};

export type OdProtosJourneyData_BackfillSource_EventOrigin =
  | 'SNOWFLAKE'
  | 'UNSPECIFIED';

/**
 * Context for tracking parameter fields
 * Next ID: 13
 */
export type OdProtosJourneyData_CampaignContextInput = {
  utmAdgid?: InputMaybe<Scalars['String']>;
  utmCampaign?: InputMaybe<Scalars['String']>;
  utmCat?: InputMaybe<Scalars['String']>;
  utmContent?: InputMaybe<Scalars['String']>;
  utmCta?: InputMaybe<Scalars['String']>;
  utmExternalid?: InputMaybe<Scalars['String']>;
  utmGeo?: InputMaybe<Scalars['String']>;
  utmMedium?: InputMaybe<Scalars['String']>;
  utmNtwk?: InputMaybe<Scalars['String']>;
  utmSource?: InputMaybe<Scalars['String']>;
  utmSubsite?: InputMaybe<Scalars['String']>;
  utmTerm?: InputMaybe<Scalars['String']>;
};

/**
 * Context for customer related fields
 * Next ID: 6
 */
export type OdProtosJourneyData_CustomerContextInput = {
  customerUuid?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  primaryEmail?: InputMaybe<Scalars['String']>;
  primaryPhone?: InputMaybe<Scalars['String']>;
};

/** Next ID: 15 */
export type OdProtosJourneyData_EdgeSourceInput = {
  /** where the event is coming from (mostly useful for debugging page view events) */
  eventOrigin?: InputMaybe<OdProtosJourneyData_EdgeSource_EventOrigin>;
  /** request.url.host */
  host?: InputMaybe<Scalars['String']>;
  ip?: InputMaybe<Scalars['String']>;
  language?: InputMaybe<Array<Scalars['String']>>;
  market?: InputMaybe<Scalars['String']>;
  /** request.url.pathname */
  pathname?: InputMaybe<Scalars['String']>;
  /** the url.pathname passed to the underlying internal service */
  proxyPath?: InputMaybe<Scalars['String']>;
  /** the url.searchParams passed to the underlying internal service */
  proxyQueryMap?: InputMaybe<Array<OdProtosJourneyData_EdgeSource_ProxyQueryMapEntryInput>>;
  /** request.url.search ({ 'x': '5', 'y': '3', 'z': 'a,b' }) */
  queryMap?: InputMaybe<Array<OdProtosJourneyData_EdgeSource_QueryMapEntryInput>>;
  referrer?: InputMaybe<Scalars['String']>;
  secPurpose?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
  userAgent?: InputMaybe<Scalars['String']>;
};

export type OdProtosJourneyData_EdgeSource_EventOrigin =
  | 'SERVER';

/** `OdProtosJourneyData_EdgeSource_ProxyQueryMapEntryInput` represents the `proxy_query_map` map in `od_protos.journey.data.EdgeSource`. */
export type OdProtosJourneyData_EdgeSource_ProxyQueryMapEntryInput = {
  key?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** `OdProtosJourneyData_EdgeSource_QueryMapEntryInput` represents the `query_map` map in `od_protos.journey.data.EdgeSource`. */
export type OdProtosJourneyData_EdgeSource_QueryMapEntryInput = {
  key?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Next ID: 36 */
export type OdProtosJourneyData_EventWrapperInput = {
  analyticsContext?: InputMaybe<OdProtosJourneyData_AnalyticsContextInput>;
  /** Must have at least one of these identifiers set */
  anonymousId?: InputMaybe<Scalars['String']>;
  campaignContext?: InputMaybe<OdProtosJourneyData_CampaignContextInput>;
  /** product or capability */
  category?: InputMaybe<OdProtosJourneyData_EventWrapper_CategoryOneofInput>;
  customerUuid?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<OdProtosJourneyData_EventWrapper_SourceOneofInput>;
  timestamp?: InputMaybe<Scalars['DateTime']>;
};

export type OdProtosJourneyData_EventWrapper_CategoryOneofInput = {
  agentConnect?: InputMaybe<OdProtosJourneyDataCategories_AgentConnectCategoryInput>;
  alo?: InputMaybe<OdProtosJourneyDataCategories_AloCategoryInput>;
  assessment?: InputMaybe<OdProtosJourneyDataCategories_AssessmentCategoryInput>;
  authentication?: InputMaybe<OdProtosJourneyDataCategories_AuthenticationCategoryInput>;
  chat?: InputMaybe<OdProtosJourneyDataCategories_ChatCategoryInput>;
  communication?: InputMaybe<OdProtosJourneyDataCategories_CommunicationCategoryInput>;
  experimentation?: InputMaybe<OdProtosJourneyDataCategories_ExperimentationCategoryInput>;
  homeGuide?: InputMaybe<OdProtosJourneyDataCategories_HomeGuideCategoryInput>;
  language?: InputMaybe<OdProtosJourneyDataCategories_LanguageCategoryInput>;
  marketplaceProperty?: InputMaybe<OdProtosJourneyDataCategories_MarketplacePropertyCategoryInput>;
  platform?: InputMaybe<OdProtosJourneyDataCategories_PlatformCategoryInput>;
  retailWebUnlock?: InputMaybe<OdProtosJourneyDataCategories_RetailWebUnlockCategoryInput>;
  sell?: InputMaybe<OdProtosJourneyDataCategories_SellCategoryInput>;
  sellDirect?: InputMaybe<OdProtosJourneyDataCategories_SellDirectCategoryInput>;
  sellEa?: InputMaybe<OdProtosJourneyDataCategories_SellEaCategoryInput>;
  sellFinalOfferCall?: InputMaybe<OdProtosJourneyDataCategories_SellFinalOfferCallCategoryInput>;
  sellList?: InputMaybe<OdProtosJourneyDataCategories_SellListCategoryInput>;
  sellOfferReview?: InputMaybe<OdProtosJourneyDataCategories_SellOfferReviewCategoryInput>;
  sellOnboarding?: InputMaybe<OdProtosJourneyDataCategories_SellOnboardingCategoryInput>;
  sellOrva?: InputMaybe<OdProtosJourneyDataCategories_SellOrvaCategoryInput>;
  sellVa?: InputMaybe<OdProtosJourneyDataCategories_SellVaCategoryInput>;
  sellWithUpside?: InputMaybe<OdProtosJourneyDataCategories_SellWithUpsideCategoryInput>;
};

export type OdProtosJourneyData_EventWrapper_SourceOneofInput = {
  backendSource?: InputMaybe<OdProtosJourneyData_BackendSourceInput>;
  backfillSource?: InputMaybe<OdProtosJourneyData_BackfillSourceInput>;
  edgeSource?: InputMaybe<OdProtosJourneyData_EdgeSourceInput>;
  mobileSource?: InputMaybe<OdProtosJourneyData_MobileSourceInput>;
  websiteSource?: InputMaybe<OdProtosJourneyData_WebsiteSourceInput>;
};

/**
 * Context for Exclusive Offers
 * Next ID: 8
 */
export type OdProtosJourneyData_ExclusiveOffersContextInput = {
  allPhotoCount?: InputMaybe<Scalars['Int']>;
  internalPhotoCount?: InputMaybe<Scalars['Int']>;
  mlsPhotoCount?: InputMaybe<Scalars['Int']>;
  offerBlurPricing?: InputMaybe<Scalars['Boolean']>;
  offerRangeMax?: InputMaybe<Scalars['Float']>;
  offerRangeMin?: InputMaybe<Scalars['Float']>;
  potentialBuyerCount?: InputMaybe<Scalars['Int']>;
};

export type OdProtosJourneyData_FailedEventsQueryParamsInput = {
  eventNameParams?: InputMaybe<OdProtosJourneyData_FailedEventsQueryParams_EventNameQueryParamsInput>;
  idParams?: InputMaybe<OdProtosJourneyData_FailedEventsQueryParams_IdQueryParamsInput>;
  timestampParams?: InputMaybe<OdProtosJourneyData_FailedEventsQueryParams_TimestampQueryParamsInput>;
};

export type OdProtosJourneyData_FailedEventsQueryParams_EventNameQueryParamsInput = {
  eventName?: InputMaybe<Scalars['String']>;
};

export type OdProtosJourneyData_FailedEventsQueryParams_IdQueryParamsInput = {
  end?: InputMaybe<Scalars['Float']>;
  start?: InputMaybe<Scalars['Float']>;
};

export type OdProtosJourneyData_FailedEventsQueryParams_TimestampQueryParamsInput = {
  end?: InputMaybe<Scalars['DateTime']>;
  start?: InputMaybe<Scalars['DateTime']>;
};

export type OdProtosJourneyData_InternalEventWrapper_Destination =
  | 'ALL'
  | 'AMPLITUDE'
  | 'SEGMENT_IDENTIFY'
  | 'SEGMENT_TRACK'
  | 'UNKNOWN';

/**
 * Context for lead fields
 * Next ID: 4
 */
export type OdProtosJourneyData_LeadContextInput = {
  sellerInputUuid?: InputMaybe<Scalars['String']>;
  sellerLeadMarket?: InputMaybe<Scalars['String']>;
  sellerLeadUuid?: InputMaybe<Scalars['String']>;
};

/** Next ID: 22 */
export type OdProtosJourneyData_MobileSourceInput = {
  adTrackingEnabled?: InputMaybe<Scalars['Boolean']>;
  advertisingId?: InputMaybe<Scalars['String']>;
  appBuild?: InputMaybe<Scalars['String']>;
  /** App info */
  appName?: InputMaybe<Scalars['String']>;
  appNamespace?: InputMaybe<Scalars['String']>;
  appVersion?: InputMaybe<Scalars['String']>;
  /** Network info */
  carrier?: InputMaybe<Scalars['String']>;
  /** Device info */
  deviceId?: InputMaybe<Scalars['String']>;
  deviceManufacturer?: InputMaybe<Scalars['String']>;
  deviceModel?: InputMaybe<Scalars['String']>;
  deviceName?: InputMaybe<Scalars['String']>;
  deviceType?: InputMaybe<Scalars['String']>;
  /** where the event is coming from (mostly useful for debugging page view events) */
  eventOrigin?: InputMaybe<OdProtosJourneyData_MobileSource_EventOrigin>;
  /** Route info */
  focusRouteName?: InputMaybe<Scalars['String']>;
  ip?: InputMaybe<Scalars['String']>;
  notificationPermissionStatus?: InputMaybe<Scalars['String']>;
  /** OS info */
  osName?: InputMaybe<Scalars['String']>;
  osVersion?: InputMaybe<Scalars['String']>;
  /**
   * Screen info
   * using context.screen.XXX to keep consistency with WebsiteSource's convention
   */
  screenDensity?: InputMaybe<Scalars['Int']>;
  /** In pixels */
  screenHeight?: InputMaybe<Scalars['Int']>;
  /** In pixels */
  screenWidth?: InputMaybe<Scalars['Int']>;
  userAgent?: InputMaybe<Scalars['String']>;
};

export type OdProtosJourneyData_MobileSource_EventOrigin =
  | 'APP';

/**
 * Context for Sell Direct
 * Next ID: 7
 */
export type OdProtosJourneyData_SellDirectContextInput = {
  dwellingType?: InputMaybe<Scalars['String']>;
  offerDenialReason?: InputMaybe<Scalars['String']>;
  offerHeadlinePrice?: InputMaybe<Scalars['Float']>;
  offerId?: InputMaybe<Scalars['String']>;
  offerRequestSource?: InputMaybe<OdProtosCommonSell_OfferRequest_Source>;
  offerState?: InputMaybe<Scalars['String']>;
};

/** Next ID: 2 */
export type OdProtosJourneyData_SellDirectConversionEventInput = {
  conversionEvent?: InputMaybe<OdProtosWebDataSellDirect_SellDirectEventType>;
};

/** Next ID: 49 */
export type OdProtosJourneyData_UserEventInput = {
  adClickContext?: InputMaybe<OdProtosJourneyData_AdClickContextInput>;
  analyticsContext?: InputMaybe<OdProtosJourneyData_AnalyticsContextInput>;
  anonymousId?: InputMaybe<Scalars['String']>;
  campaignContext?: InputMaybe<OdProtosJourneyData_CampaignContextInput>;
  customerContext?: InputMaybe<OdProtosJourneyData_CustomerContextInput>;
  /**
   * Next ID: same as Next ID of parent message
   * NOTE: Please keep events ordered by index in each group
   */
  event?: InputMaybe<OdProtosJourneyData_UserEvent_EventOneofInput>;
  exclusiveOffersContext?: InputMaybe<OdProtosJourneyData_ExclusiveOffersContextInput>;
  humanId?: InputMaybe<Scalars['String']>;
  leadContext?: InputMaybe<OdProtosJourneyData_LeadContextInput>;
  sellDirectContext?: InputMaybe<OdProtosJourneyData_SellDirectContextInput>;
  /** Next ID: same as Next ID of parent message */
  source?: InputMaybe<OdProtosJourneyData_UserEvent_SourceOneofInput>;
  timestamp?: InputMaybe<Scalars['DateTime']>;
  uuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosJourneyData_UserEvent_EventOneofInput = {
  /** conversion events */
  sellDirectConversionEvent?: InputMaybe<OdProtosJourneyData_SellDirectConversionEventInput>;
};

export type OdProtosJourneyData_UserEvent_SourceOneofInput = {
  backendSource?: InputMaybe<OdProtosJourneyData_BackendSourceInput>;
  mobileSource?: InputMaybe<OdProtosJourneyData_MobileSourceInput>;
  websiteSource?: InputMaybe<OdProtosJourneyData_WebsiteSourceInput>;
};

/** Next ID: 14 */
export type OdProtosJourneyData_WebsiteSourceInput = {
  /** where the event is coming from (mostly useful for debugging page view events) */
  eventOrigin?: InputMaybe<OdProtosJourneyData_WebsiteSource_EventOrigin>;
  /** request.url.host */
  host?: InputMaybe<Scalars['String']>;
  /** ip is overwritten on HTTP requests with a website source. */
  ip?: InputMaybe<Scalars['String']>;
  /** this will be overwritten on HTTP requests */
  isWebview?: InputMaybe<Scalars['Boolean']>;
  language?: InputMaybe<Array<Scalars['String']>>;
  /** request.url.pathname */
  pathname?: InputMaybe<Scalars['String']>;
  /** the url.pathname passed to the underlying internal service */
  proxyPath?: InputMaybe<Scalars['String']>;
  /** the url.searchParams passed to the underlying internal service */
  proxyQueryMap?: InputMaybe<Array<OdProtosJourneyData_WebsiteSource_ProxyQueryMapEntryInput>>;
  /** request.url.search ({ 'x': '5', 'y': '3', 'z': 'a,b' }) */
  queryMap?: InputMaybe<Array<OdProtosJourneyData_WebsiteSource_QueryMapEntryInput>>;
  referrer?: InputMaybe<Scalars['String']>;
  screen?: InputMaybe<OdProtosJourneyData_WebsiteSource_ScreenInput>;
  url?: InputMaybe<Scalars['String']>;
  userAgent?: InputMaybe<Scalars['String']>;
};

export type OdProtosJourneyData_WebsiteSource_EventOrigin =
  | 'CLIENT'
  | 'SERVER'
  | 'UNSPECIFIED';

/** `OdProtosJourneyData_WebsiteSource_ProxyQueryMapEntryInput` represents the `proxy_query_map` map in `od_protos.journey.data.WebsiteSource`. */
export type OdProtosJourneyData_WebsiteSource_ProxyQueryMapEntryInput = {
  key?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** `OdProtosJourneyData_WebsiteSource_QueryMapEntryInput` represents the `query_map` map in `od_protos.journey.data.WebsiteSource`. */
export type OdProtosJourneyData_WebsiteSource_QueryMapEntryInput = {
  key?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

export type OdProtosJourneyData_WebsiteSource_ScreenInput = {
  density?: InputMaybe<Scalars['Float']>;
  height?: InputMaybe<Scalars['Float']>;
  width?: InputMaybe<Scalars['Float']>;
};

export type OdProtosJourneyServices_ApproveStagedEventsRequestInput = {
  tag?: InputMaybe<Scalars['String']>;
};

export type OdProtosJourneyServices_ModifyFailedEventsRequestInput = {
  modifier?: InputMaybe<Scalars['String']>;
  queryParams?: InputMaybe<OdProtosJourneyData_FailedEventsQueryParamsInput>;
};

export type OdProtosJourneyServices_SendEventRequestInput = {
  event?: InputMaybe<OdProtosJourneyData_EventWrapperInput>;
};

export type OdProtosJourneyServices_SendUserEventRequestInput = {
  userEvent?: InputMaybe<OdProtosJourneyData_UserEventInput>;
};

export type OdProtosJourneyTesting_EnumTest =
  | 'ENUMTEST_NONE'
  | 'ENUMTEST_ONE'
  | 'ENUMTEST_TWO';

/** The different types of inputs a MarketDataEntry Question can support */
export type OdProtosListerineData_InputType =
  | 'DROPDOWN'
  | 'INPUT_TYPE_UNKNOWN'
  | 'MULTI_LINE_TEXT'
  | 'MULTI_SELECT'
  | 'RADIO_GROUP'
  | 'SINGLE_LINE_TEXT';

/** Listing data entry states */
export type OdProtosListerineData_ListingDataEntryState =
  | 'LISTING_DATA_ENTRY_COMPLETE'
  | 'LISTING_DATA_ENTRY_ESCALATED'
  | 'LISTING_DATA_ENTRY_INCOMPLETE';

/** listing fields state */
export type OdProtosListerineData_ListingFieldsState =
  | 'LISTING_FIELDS_COMPLETED'
  | 'LISTING_FIELDS_PENDING'
  | 'LISTING_FIELDS_UNKNOWN';

export type OdProtosListerineData_ListingPhotosRoute =
  | 'PHOTO_BRACKETING'
  | 'PHOTO_VENDOR';

/** listing photos state */
export type OdProtosListerineData_ListingPhotosState =
  | 'LISTING_PHOTOS_COMPLETED'
  | 'LISTING_PHOTOS_DELAYED'
  | 'LISTING_PHOTOS_PENDING'
  | 'LISTING_PHOTOS_SCHEDULED'
  | 'LISTING_PHOTOS_UNKNOWN';

/** listing price state */
export type OdProtosListerineData_ListingPriceState =
  | 'LISTING_PRICE_DELAYED'
  | 'LISTING_PRICE_PENDING'
  | 'LISTING_PRICE_RECEIVED'
  | 'LISTING_PRICE_UNKNOWN';

export type OdProtosListerineData_ListingTaskStatus =
  | 'TASK_CREATED'
  | 'TASK_SCHEDULED'
  | 'TASK_SENT'
  | 'TASK_UNKNOWN';

/** Market data entry states */
export type OdProtosListerineData_MarketDataEntryState =
  | 'MARKET_DATA_ENTRY_COMPLETE'
  | 'MARKET_DATA_ENTRY_ESCALATED'
  | 'MARKET_DATA_ENTRY_INCOMPLETE';

/** photo approval states */
export type OdProtosListerineData_PhotoReviewState =
  | 'PHOTO_REVIEW_ACCEPTED'
  | 'PHOTO_REVIEW_DELAYED'
  | 'PHOTO_REVIEW_INCOMPLETE'
  | 'PHOTO_REVIEW_REJECTED';

/** renovation state */
export type OdProtosListerineData_RenoState =
  | 'RENO_STATE_COMPLETED'
  | 'RENO_STATE_PENDING'
  | 'RENO_STATE_UNKNOWN';

/** setup visit State */
export type OdProtosListerineData_SetupVisitState =
  | 'SETUP_VISIT_COMPLETED'
  | 'SETUP_VISIT_PENDING'
  | 'SETUP_VISIT_SCHEDULED'
  | 'SETUP_VISIT_UNKNOWN';

export type OdProtosListerineServices_AddOpenHouseInfoForActiveListingsRequestInput = {
  listingUuids?: InputMaybe<Array<Scalars['String']>>;
  market?: InputMaybe<Scalars['String']>;
};

export type OdProtosListerineServices_ChangeAddressRequestInput = {
  flipToken?: InputMaybe<Scalars['String']>;
  newAddressId?: InputMaybe<Scalars['String']>;
  oldAddressId?: InputMaybe<Scalars['String']>;
};

/** request to create listing task */
export type OdProtosListerineServices_CreateListingTaskRequestInput = {
  addressToken?: InputMaybe<Scalars['String']>;
  externalListing?: InputMaybe<Scalars['Boolean']>;
  flipId?: InputMaybe<Scalars['String']>;
  flipState?: InputMaybe<Scalars['String']>;
  flipToken?: InputMaybe<Scalars['String']>;
  listingDataEntryMarketSuffix?: InputMaybe<Scalars['String']>;
  listingId?: InputMaybe<Scalars['String']>;
  listingUuid?: InputMaybe<Scalars['String']>;
  market?: InputMaybe<Scalars['String']>;
  sourceType?: InputMaybe<OdProtosScroogeData_Allocation_Source_SourceType>;
};

/** empty request for get all listing tasks */
export type OdProtosListerineServices_GetActiveListingTasksRequestInput = {
  _empty?: InputMaybe<Scalars['Boolean']>;
};

export type OdProtosListerineServices_GetActiveListingTasksV2RequestInput = {
  pagination?: InputMaybe<OdProtosCommonPagination_PaginationRequestInput>;
};

export type OdProtosListerineServices_GetDynamicDataEntryConfigForAddressRequestInput = {
  addressToken?: InputMaybe<Scalars['String']>;
  market?: InputMaybe<Scalars['String']>;
};

/** request to query listing task by web's listing_uuid or listerine's specific guid */
export type OdProtosListerineServices_GetListingTaskRequestInput = {
  /** This is listerine's ID for the listing task */
  listingTaskId?: InputMaybe<Scalars['String']>;
  listingUuid?: InputMaybe<Scalars['String']>;
};

/** request to query multiple listing tasks by id */
export type OdProtosListerineServices_GetListingTasksRequestInput = {
  listingTaskIds?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosListerineServices_GetMarketDataEntryConfigByListingTaskIdRequestInput = {
  listingTaskId?: InputMaybe<Scalars['String']>;
};

export type OdProtosListerineServices_GetMarketDataEntryConfigRequestInput = {
  market?: InputMaybe<Scalars['String']>;
};

export type OdProtosListerineServices_GetPhotoReviewRejectReasonsRequestInput = {
  /** This metadata is optional. */
  metadata?: InputMaybe<Scalars['String']>;
};

export type OdProtosListerineServices_IsRelistPossibleRequestInput = {
  listingUuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosListerineServices_ManuallyResolveListingTaskRequestInput = {
  listDate?: InputMaybe<Scalars['String']>;
  listingTaskId?: InputMaybe<Scalars['String']>;
  listingUuid?: InputMaybe<Scalars['String']>;
  mlsId?: InputMaybe<Scalars['String']>;
  mlsName?: InputMaybe<Scalars['String']>;
};

export type OdProtosListerineServices_MarkExceptionCaseyTaskCompleteRequestInput = {
  caseyTaskId?: InputMaybe<Scalars['String']>;
  delayReason?: InputMaybe<Scalars['String']>;
};

export type OdProtosListerineServices_RelistOnMlsRequestInput = {
  listingUuid?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['Float']>;
};

/** next id : 5 */
export type OdProtosListerineServices_ToggleFrozenRequestInput = {
  freezeReason?: InputMaybe<Scalars['String']>;
  isFrozen?: InputMaybe<Scalars['Boolean']>;
  listingTaskId?: InputMaybe<Scalars['String']>;
  listingUuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosListerineServices_TriggerDataEntryTasksRequestInput = {
  /** address_ids skips any checks. */
  addressIds?: InputMaybe<Array<Scalars['String']>>;
  visits?: InputMaybe<Array<OdProtosListerineServices_VisitInput>>;
};

export type OdProtosListerineServices_TriggerMlsPublishRequestInput = {
  listingUuid?: InputMaybe<Scalars['String']>;
};

/** request to update the external listing flag for the listing task under listing_uuid */
export type OdProtosListerineServices_UpdateExternalListingFlagRequestInput = {
  isExternalListing?: InputMaybe<Scalars['Boolean']>;
  listingUuid?: InputMaybe<Scalars['String']>;
};

/** request to update flip state */
export type OdProtosListerineServices_UpdateFlipStateRequestInput = {
  flipState?: InputMaybe<Scalars['String']>;
  listingUuid?: InputMaybe<Scalars['String']>;
};

/** request to update listing photos state */
export type OdProtosListerineServices_UpdateListingPhotosStateRequestInput = {
  listingUuid?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<OdProtosListerineData_ListingPhotosState>;
};

/** request to update listing price and listing price state */
export type OdProtosListerineServices_UpdateListingPriceStateRequestInput = {
  listingPrice?: InputMaybe<Scalars['Float']>;
  listingUuid?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<OdProtosListerineData_ListingPriceState>;
};

export type OdProtosListerineServices_UpdateMarketDataEntryRequestInput = {
  caseyTaskId?: InputMaybe<Scalars['String']>;
  escalationReason?: InputMaybe<Scalars['String']>;
  /**
   * The answers to a MarketDataEntry form. Listerine expects a json blob with a mapping of
   * Question.field_name -> answer.
   */
  formData?: InputMaybe<Scalars['String']>;
  listingTaskId?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<OdProtosListerineData_MarketDataEntryState>;
  updatedState?: InputMaybe<OdProtosListerineData_ListingDataEntryState>;
};

/** TODO deprecate */
export type OdProtosListerineServices_UpdateMarketDataEntryStateRequestInput = {
  /**
   * The answers to a MarketDataEntry form. Listerine expects a json blob with a mapping of
   * Question.field_name -> answer.
   */
  formData?: InputMaybe<Scalars['String']>;
  listingTaskId?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<OdProtosListerineData_MarketDataEntryState>;
};

/**
 * Update the state of photo review for a particular listing task. from_web should only be set to true if the
 * approval came from web.
 */
export type OdProtosListerineServices_UpdatePhotoReviewStateRequestInput = {
  caseyTaskId?: InputMaybe<Scalars['String']>;
  fromWeb?: InputMaybe<Scalars['Boolean']>;
  listingTaskId?: InputMaybe<Scalars['String']>;
  listingUuid?: InputMaybe<Scalars['String']>;
  /** This is the long form text reason for rejection */
  rejectReason?: InputMaybe<Scalars['String']>;
  /** This is one of the enumerated rejection types returned from GetPhotoReviewRejectReasons */
  rejectReasonBucket?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<OdProtosListerineData_PhotoReviewState>;
};

/** request to update setup visit state */
export type OdProtosListerineServices_UpdateSetupVisitStateRequestInput = {
  listingUuid?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<OdProtosListerineData_SetupVisitState>;
};

/** Visit and Address needed for DE task creation */
export type OdProtosListerineServices_VisitInput = {
  addressId?: InputMaybe<Scalars['String']>;
  visitId?: InputMaybe<Scalars['String']>;
};

export type OdProtosListingsData_Actor =
  | 'AGENT'
  | 'CEP'
  | 'SYSTEM'
  | 'UNKNOWN_ACTOR';

export type OdProtosListingsData_AloUnenrollmentReason =
  | 'ALO_UNENROLLMENT_REASON_MANUAL'
  | 'ALO_UNENROLLMENT_REASON_UNSPECIFIED';

export type OdProtosListingsData_ExperiencePartnerSupportRequestType =
  | 'SUPPORT_REQUEST_TYPE_FINAL_OFFER_DISCUSSIOON_WITH_SELLER'
  | 'SUPPORT_REQUEST_TYPE_OFFER_EXPLORATION'
  | 'SUPPORT_REQUEST_TYPE_REPAIR_ASKS'
  | 'SUPPORT_REQUEST_TYPE_SELLER_AGENT_INTRODUCTION'
  | 'SUPPORT_REQUEST_TYPE_SELLER_CONTACT'
  | 'UNKNOWN_SUPPORT_REQUEST_TYPE';

export type OdProtosListingsData_KeyTimestampPairInput = {
  key?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['DateTime']>;
};

export type OdProtosListingsData_ListingInput = {
  addressId?: InputMaybe<Scalars['String']>;
  agent?: InputMaybe<OdProtosListingsData_Listing_AgentInput>;
  agentCommissionRate?: InputMaybe<Scalars['Float']>;
  brokerageId?: InputMaybe<Scalars['String']>;
  contractPrice?: InputMaybe<Scalars['Float']>;
  customerId?: InputMaybe<Scalars['String']>;
  estimatedListPrice?: InputMaybe<OdProtosCommon_MoneyInput>;
  estimatedSalePrice?: InputMaybe<OdProtosCommon_MoneyInput>;
  grossCommission?: InputMaybe<Scalars['Float']>;
  id?: InputMaybe<Scalars['String']>;
  listingPrice?: InputMaybe<Scalars['Float']>;
  marketId?: InputMaybe<Scalars['String']>;
  soldPrice?: InputMaybe<Scalars['Float']>;
  source?: InputMaybe<OdProtosListingsData_Listing_SourceInput>;
  state?: InputMaybe<OdProtosListingsData_Listing_State>;
  timestamps?: InputMaybe<Array<OdProtosListingsData_Listing_TimestampInput>>;
};

export type OdProtosListingsData_Listing_AgentInput = {
  id?: InputMaybe<Scalars['String']>;
  leadId?: InputMaybe<Scalars['String']>;
};

export type OdProtosListingsData_Listing_SourceInput = {
  id?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<OdProtosListingsData_Listing_Source_Type>;
};

export type OdProtosListingsData_Listing_Source_Type =
  | 'LIST_WITH_CERTAINTY'
  | 'PARN'
  | 'UNKNOWN';

export type OdProtosListingsData_Listing_State =
  | 'AGENT_ASSIGNMENT'
  | 'CANCELED'
  | 'IN_CONTRACT'
  | 'LEAD_TERMINATED'
  | 'LISTING_ACTIVE'
  | 'LISTING_AGREEMENT_SIGNED'
  | 'LISTING_TERMINATED'
  | 'NOT_LISTED'
  | 'OWNER_LIST_DECISION'
  | 'SOLD'
  | 'UNKNOWN';

export type OdProtosListingsData_Listing_TimestampInput = {
  state?: InputMaybe<OdProtosListingsData_Listing_State>;
  timestamp?: InputMaybe<Scalars['DateTime']>;
};

/** The LwcProductFilter is used to filter LwcProduct list results */
export type OdProtosListingsData_LwcProductFilterInput = {
  /**
   * Only LwcProducts which have a state found in the states list will
   * be returned. If no states filter is provided, all LwcProducts found
   * in an "active" states (i.e. not CREATED or DELETED) will be returned.
   */
  states?: InputMaybe<Array<OdProtosListingsData_LwcProduct_State>>;
};

/** Next ID: 31 */
export type OdProtosListingsData_LwcProduct_State =
  | 'CLOSED'
  | 'CREATED'
  | 'LISTING_AGREEMENT_SIGNED'
  /** Terminal */
  | 'NOT_ELIGIBLE'
  | 'UNKNOWN';

export type OdProtosListingsData_NoteType =
  | 'AGENT_NOTE'
  | 'CEP_NOTE'
  | 'LEAD_PASS_BACK_NOTE'
  | 'UNKNOWN_NOTE';

/** Next ID: 4 */
export type OdProtosListingsData_ParnDidNotCloseReason =
  | 'NO_ACCEPTABLE_OFFERS'
  | 'OTHER'
  | 'PLANS_CHANGED'
  | 'UNKNOWN_REASON_DID_NOT_CLOSE';

/** Next ID: 5 */
export type OdProtosListingsData_ParnDidNotConvertReason =
  | 'NOT_INTERESTED'
  | 'PARN_COMPETITOR'
  | 'PARN_NON_RESPONSIVE'
  | 'PARN_NOT_BUYING_OR_SELLING'
  | 'UNKNOWN_REASON_DID_NOT_CONVERT';

export type OdProtosListingsData_ParnKeyTimestampPairInput = {
  key?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['DateTime']>;
};

/** Next ID: 14 */
export type OdProtosListingsData_Parn_State =
  | 'CREATED'
  | 'DID_NOT_CLOSE_NO_ACCEPTABLE_OFFERS'
  | 'DID_NOT_CLOSE_OTHER'
  | 'DID_NOT_CLOSE_PLANS_CHANGED'
  | 'DID_NOT_CONVERT_COMPETITOR'
  | 'DID_NOT_CONVERT_NON_RESPONSIVE'
  | 'DID_NOT_CONVERT_NOT_BUYING_SELLING'
  | 'DID_NOT_CONVERT_NOT_INTERESTED'
  | 'FIRST_CONTACT_ATTEMPTED'
  | 'FIRST_CONTACT_MADE'
  | 'LISTING_INITIATED'
  | 'SELECTED_PARN'
  /** Terminal */
  | 'SOLD'
  | 'UNKNOWN';

export type OdProtosListingsData_SelectedProduct =
  | 'SELECTED_PRODUCT_LIST_WITH_CERTAINTY'
  | 'SELECTED_PRODUCT_OPENDOOR_DIRECT'
  | 'SELECTED_PRODUCT_SELL_WITH_UPSIDE'
  | 'SELECTED_PRODUCT_UNKNOWN';

export type OdProtosListingsServices_CheckEligibilityRequestInput = {
  addressId?: InputMaybe<Scalars['String']>;
  sellerInputId?: InputMaybe<Scalars['String']>;
};

export type OdProtosListingsServices_CreateListingRequestInput = {
  listing?: InputMaybe<OdProtosListingsData_ListingInput>;
};

export type OdProtosListingsServices_CreateLwcProductRequestInput = {
  addressId?: InputMaybe<Scalars['String']>;
  hasInitialLeadFlowOfferRequest?: InputMaybe<Scalars['Boolean']>;
  isFirstOffer?: InputMaybe<Scalars['Boolean']>;
  isNotPreviouslyDeniedRefresh?: InputMaybe<Scalars['Boolean']>;
  latestSellDirectOfferUuid?: InputMaybe<Scalars['String']>;
  marketId?: InputMaybe<Scalars['String']>;
  sellDirectLeadToken?: InputMaybe<Scalars['String']>;
  skipEligibilityCheck?: InputMaybe<Scalars['Boolean']>;
};

export type OdProtosListingsServices_CreateParnRequestInput = {
  addressId?: InputMaybe<Scalars['String']>;
  sellDirectLeadToken?: InputMaybe<Scalars['String']>;
  zipCode?: InputMaybe<Scalars['String']>;
};

export type OdProtosListingsServices_FirstContactAttemptedForParnRequestInput = {
  firstContactAttemptedAt?: InputMaybe<Scalars['DateTime']>;
  parnId?: InputMaybe<Scalars['String']>;
};

export type OdProtosListingsServices_FirstContactMadeForParnRequestInput = {
  firstContactMadeAt?: InputMaybe<Scalars['DateTime']>;
  parnId?: InputMaybe<Scalars['String']>;
};

export type OdProtosListingsServices_GetListingBySourceRequestInput = {
  sourceId?: InputMaybe<Scalars['String']>;
};

export type OdProtosListingsServices_GetListingDetailByAgentLeadIdRequestInput = {
  agentLeadId?: InputMaybe<Scalars['String']>;
};

export type OdProtosListingsServices_GetListingDetailsByAgentRequestInput = {
  agentCustomerId?: InputMaybe<Scalars['String']>;
};

/** Endpoints with page-based pagination */
export type OdProtosListingsServices_GetListingDetailsByAgentV2RequestInput = {
  agentCustomerId?: InputMaybe<Scalars['String']>;
  /** 0-indexed page number (0 for first page) */
  pageNumber?: InputMaybe<Scalars['Float']>;
  pageSize?: InputMaybe<Scalars['Float']>;
  /** Searches across customer name and property address */
  searchQuery?: InputMaybe<Scalars['String']>;
  sellingStageFilter?: InputMaybe<Scalars['String']>;
  sourceFilter?: InputMaybe<Scalars['String']>;
};

export type OdProtosListingsServices_GetListingDetailsByBrokerageRequestInput = {
  agentCustomerId?: InputMaybe<Scalars['String']>;
};

export type OdProtosListingsServices_GetListingDetailsByBrokerageV2RequestInput = {
  agentCustomerId?: InputMaybe<Scalars['String']>;
  agentFilter?: InputMaybe<Scalars['String']>;
  /** 0-indexed page number (0 for first page) */
  pageNumber?: InputMaybe<Scalars['Float']>;
  pageSize?: InputMaybe<Scalars['Float']>;
  /** Searches across customer name and property address */
  searchQuery?: InputMaybe<Scalars['String']>;
  sellingStageFilter?: InputMaybe<Scalars['String']>;
  sourceFilter?: InputMaybe<Scalars['String']>;
};

export type OdProtosListingsServices_GetListingPricingInformationRequestInput = {
  lwcProductId?: InputMaybe<Scalars['String']>;
};

export type OdProtosListingsServices_GetListingRequestInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type OdProtosListingsServices_GetLwcDetailsBySellDirectLeadRequestInput = {
  sellDirectLeadToken?: InputMaybe<Scalars['String']>;
};

export type OdProtosListingsServices_GetLwcDetailsBySellerInputUuidRequestInput = {
  sellerInputUuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosListingsServices_GetLwcDetailsBySellerLeadUuidRequestInput = {
  sellerLeadUuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosListingsServices_GetLwcDetailsForBrokerageRequestInput = {
  /**
   * I can see us having a brokerage_id, agent_id fields in the future
   * to enable getting LWC Details for a brokerage via different IDs
   */
  agentCustomerId?: InputMaybe<Scalars['String']>;
};

export type OdProtosListingsServices_GetLwcDetailsRequestInput = {
  /** If we start using this for CEPs, add new fields instead of using oneof */
  agentCustomerId?: InputMaybe<Scalars['String']>;
};

export type OdProtosListingsServices_GetLwcProductViewBySellDirectLeadRequestInput = {
  sellDirectLeadToken?: InputMaybe<Scalars['String']>;
};

export type OdProtosListingsServices_GetLwcProductViewBySellerLeadUuidRequestInput = {
  sellerLeadUuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosListingsServices_GetOpenExperiencePartnerSupportRequestRequestInput = {
  lwcProductId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<OdProtosListingsData_ExperiencePartnerSupportRequestType>;
};

export type OdProtosListingsServices_GetParnDetailsRequestInput = {
  agentCustomerId?: InputMaybe<Scalars['String']>;
};

export type OdProtosListingsServices_GetRepairNarrativeRequestInput = {
  addressId?: InputMaybe<Scalars['String']>;
};

/**
 * Request/Response objects for GetSellDirectDetails
 * Next ID: 3
 */
export type OdProtosListingsServices_GetSellDirectDetailsRequestInput = {
  lwcProductId?: InputMaybe<Scalars['String']>;
  sellDirectLeadToken?: InputMaybe<Scalars['String']>;
};

export type OdProtosListingsServices_InitiateListingLeadBySellerLeadTokenRequestInput = {
  /**
   * When true, skips the ODLO experiment check and routes to regional brokerages.
   * Set to true for operator-initiated manual handoffs via tessellation.
   */
  bypassOdloExperimentCheck?: InputMaybe<Scalars['Boolean']>;
  sellerLeadToken?: InputMaybe<Scalars['String']>;
};

export type OdProtosListingsServices_InitiateListingLeadRequestInput = {
  lwcProductId?: InputMaybe<Scalars['String']>;
};

export type OdProtosListingsServices_ListLwcDetailsRequestInput = {
  filter?: InputMaybe<OdProtosListingsData_LwcProductFilterInput>;
};

export type OdProtosListingsServices_ListingAgreementSignedRequestInput = {
  listingAgreementSignedAt?: InputMaybe<Scalars['DateTime']>;
  lwcProductId?: InputMaybe<Scalars['String']>;
};

export type OdProtosListingsServices_MarkNotEligibleRequestInput = {
  lwcProductId?: InputMaybe<Scalars['String']>;
};

export type OdProtosListingsServices_ParnDidNotCloseRequestInput = {
  parnId?: InputMaybe<Scalars['String']>;
  reason?: InputMaybe<OdProtosListingsData_ParnDidNotCloseReason>;
};

export type OdProtosListingsServices_ParnDidNotConvertRequestInput = {
  parnId?: InputMaybe<Scalars['String']>;
  reason?: InputMaybe<OdProtosListingsData_ParnDidNotConvertReason>;
};

export type OdProtosListingsServices_ReactivateLeadRequestInput = {
  lwcProductId?: InputMaybe<Scalars['String']>;
};

export type OdProtosListingsServices_RequestExperiencePartnerSupportRequestInput = {
  lwcProductId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<OdProtosListingsData_ExperiencePartnerSupportRequestType>;
};

export type OdProtosListingsServices_SelectedParnRequestInput = {
  listingAgreementSignedAt?: InputMaybe<Scalars['DateTime']>;
  parnId?: InputMaybe<Scalars['String']>;
};

export type OdProtosListingsServices_SetAloQualificationRequestInput = {
  /** Reason for unenrollment (only relevant when is_qualified=false) */
  aloUnenrollmentReason?: InputMaybe<OdProtosListingsData_AloUnenrollmentReason>;
  isQualified?: InputMaybe<Scalars['Boolean']>;
  sellDirectLeadToken?: InputMaybe<Scalars['String']>;
};

export type OdProtosListingsServices_SetAgentNoteForParnRequestInput = {
  note?: InputMaybe<Scalars['String']>;
  parnId?: InputMaybe<Scalars['String']>;
};

export type OdProtosListingsServices_SetDetailsRequestInput = {
  admin?: InputMaybe<Scalars['Boolean']>;
  agentCommissionRate?: InputMaybe<Scalars['Float']>;
  contractPrice?: InputMaybe<Scalars['Float']>;
  estimatedListPrice?: InputMaybe<OdProtosCommon_MoneyInput>;
  estimatedSalePrice?: InputMaybe<OdProtosCommon_MoneyInput>;
  grossCommission?: InputMaybe<Scalars['Float']>;
  id?: InputMaybe<Scalars['String']>;
  listingPrice?: InputMaybe<Scalars['Float']>;
  nextState?: InputMaybe<OdProtosListingsData_Listing_State>;
  soldPrice?: InputMaybe<Scalars['Float']>;
  timestampOverrides?: InputMaybe<Array<OdProtosListingsServices_SetDetailsRequest_TimestampOverrideInput>>;
  updateMask?: InputMaybe<GoogleProtobuf_FieldMaskInput>;
};

export type OdProtosListingsServices_SetDetailsRequest_TimestampOverrideInput = {
  state?: InputMaybe<OdProtosListingsData_Listing_State>;
  timestamp?: InputMaybe<Scalars['DateTime']>;
};

export type OdProtosListingsServices_SetNoteRequestInput = {
  lwcProductId?: InputMaybe<Scalars['String']>;
  note?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<OdProtosListingsData_NoteType>;
};

export type OdProtosListingsServices_SetParnTimestampsRequestInput = {
  keyTimestampPairs?: InputMaybe<Array<OdProtosListingsData_ParnKeyTimestampPairInput>>;
  parnId?: InputMaybe<Scalars['String']>;
};

export type OdProtosListingsServices_SetTimestampsRequestInput = {
  keyTimestampPairs?: InputMaybe<Array<OdProtosListingsData_KeyTimestampPairInput>>;
  lwcProductId?: InputMaybe<Scalars['String']>;
};

/**
 * A market is a non-overlapping region that Opendoor operates in. Markets are the highest-level
 * division of Opendoor operations.
 *
 * Data in this message is intended to be very high-level and only provide config that *almost all*
 * services need. If your service has a requirement for Market-keyed config, please define a new
 * service/product-specific message and register it as a new type in PBDB.
 *
 * PBDB Key: Fence Region ID
 * Next ID: 6
 */
export type OdProtosMarketConfig_MarketInput = {
  /** Customer facing name (e.g. "Phoenix"). */
  displayName?: InputMaybe<Scalars['String']>;
  /** Directory ID of the organization that oversees this market. */
  orgId?: InputMaybe<Scalars['String']>;
  /** Fence ID of the region covered by this market. This is also the identifier (e.g. "phoenix"). */
  regionId?: InputMaybe<Scalars['String']>;
  /** Used mainly for naming market-specific things like Slack channels (e.g. "phx"). */
  shorthandIdentifier?: InputMaybe<Scalars['String']>;
  /** Timezone of the market (e.g. "America/Los_Angeles") */
  timezone?: InputMaybe<Scalars['String']>;
};

export type OdProtosMdfModelsAcquisition_BrnSpendRequestInput = {
  /** [Required] The address token of the home */
  addressToken?: InputMaybe<Scalars['String']>;
  /** [Optional] Overrides market name for address token */
  marketName?: InputMaybe<Scalars['String']>;
};

export type OdProtosMdfModelsAcquisition_PostlistRepairSpendRequestInput = {
  /** [Required] The address token of the home */
  addressToken?: InputMaybe<Scalars['String']>;
  /** [Optional] Overrides market name for address token */
  marketName?: InputMaybe<Scalars['String']>;
};

export type OdProtosMdfModelsAcquisition_PrelistRepairScopeRequestInput = {
  aboveGradeSqFt?: InputMaybe<Scalars['Int']>;
  /** [Required] The address token of the home */
  addressToken?: InputMaybe<Scalars['String']>;
  basementFinishedSqFt?: InputMaybe<Scalars['Int']>;
  dwellingType?: InputMaybe<Scalars['String']>;
  hasHoa?: InputMaybe<Scalars['Boolean']>;
  hasPrivatePool?: InputMaybe<Scalars['Boolean']>;
  /** [Required] The internal fee charged for this home */
  internalFee?: InputMaybe<Scalars['Float']>;
  /** [Required] Whether the home is is_listed */
  isListed?: InputMaybe<Scalars['Boolean']>;
  lotSqFt?: InputMaybe<Scalars['Int']>;
  propertyConditionScore?: InputMaybe<Scalars['Float']>;
  yearBuilt?: InputMaybe<Scalars['Int']>;
};

export type OdProtosMdfModelsAcquisition_RestbCalibrationScoreRequestInput = {
  addressToken?: InputMaybe<Scalars['String']>;
  bathroomSellerAnswer?: InputMaybe<Scalars['String']>;
  exteriorSellerAnswer?: InputMaybe<Scalars['String']>;
  kitchenSellerAnswer?: InputMaybe<Scalars['String']>;
  livingRoomSellerAnswer?: InputMaybe<Scalars['String']>;
  offerValuationUsd?: InputMaybe<Scalars['Float']>;
};

export type OdProtosMdfModelsResale_IndifferencePriceTargetModelRequestInput = {
  flipToken?: InputMaybe<Scalars['String']>;
};

export type OdProtosMdfModelsResale_InitialMarkupFeaturesRequestInput = {
  addressToken?: InputMaybe<Scalars['String']>;
};

export type OdProtosMdfModelsResale_ResalePricingRecommendationsRequestInput = {
  addressToken?: InputMaybe<Scalars['String']>;
};

/** These are the new formats that should be used going forward */
export type OdProtosMdfModelsResale_ResaleProbabilityContractModelRequestInput = {
  flipToken?: InputMaybe<Scalars['String']>;
};

export type OdProtosMdfModelsResale_ResaleTargetPriceModelRequestInput = {
  flipToken?: InputMaybe<Scalars['String']>;
};

export type OdProtosMdfModelsSpread_DaysToPendBiasRequestInput = {
  /** [Required] The address token of the home */
  addressToken?: InputMaybe<Scalars['String']>;
  /** [Optional] Dwelling type, defaults to value from HDS */
  dwellingType?: InputMaybe<Scalars['String']>;
  /** [Optional] Whether the home has a hoa, defaults to value from HDS */
  hasHoa?: InputMaybe<Scalars['Boolean']>;
  /** [Optional] Whether the home is in a age restricted community, defaults to value from HDS */
  isAgeRestrictedCommunity?: InputMaybe<Scalars['Boolean']>;
  /** [Optional] Whether the home is in a gated community, defaults to value from HDS */
  isGatedCommunity?: InputMaybe<Scalars['Boolean']>;
  /** [Required] Valuation of the home in USD */
  postRepairValuationUsd?: InputMaybe<Scalars['Float']>;
  /** [Optional] Year build, defaults to value from HDS */
  yearBuilt?: InputMaybe<Scalars['Int']>;
};

export type OdProtosMdfModelsSpread_ForecastedSpreadDailyChangeRequestInput = {
  /** [Required] The address token of the home. */
  addressToken?: InputMaybe<Scalars['String']>;
  /** [Required] The date range end. Format expected is YYYY-MM-DD */
  dateEnd?: InputMaybe<Scalars['String']>;
  /** [Required] The date range start. Format expected is YYYY-MM-DD */
  dateStart?: InputMaybe<Scalars['String']>;
  /** [Required] Valuation of the home in USD */
  valuationUsd?: InputMaybe<Scalars['Float']>;
};

export type OdProtosMdfModelsSpread_MultivariatePrelistValGainAdjustmentRequestInput = {
  /** [Required] The address token of the home */
  addressToken?: InputMaybe<Scalars['String']>;
  /** [Optional] Dwelling type, defaults to value from HDS */
  dwellingType?: InputMaybe<Scalars['String']>;
  /** [Optional] Whether the home is in a guarded, gated community, defaults to value from HDS */
  hasGatedCommunityGuard?: InputMaybe<Scalars['Boolean']>;
  /** [Optional] Whether the home has a hoa, defaults to value from HDS */
  hasHoa?: InputMaybe<Scalars['Boolean']>;
  /** [Optional] Whether the home has a private pool, defaults to value from HDS */
  hasPrivatePool?: InputMaybe<Scalars['Boolean']>;
  /** [Optional] Whether the home is in a age restricted community, defaults to value from HDS */
  isAgeRestrictedCommunity?: InputMaybe<Scalars['Boolean']>;
  /** [Optional] Whether the home is in a gated community, defaults to value from HDS */
  isGatedCommunity?: InputMaybe<Scalars['Boolean']>;
  /** [Required] Valuation of the home in USD */
  postRepairValuationUsd?: InputMaybe<Scalars['Float']>;
  /** [Optional] The [1-6] RestB property condition score, defaults to denormalized value from HDS */
  propertyRestbConditionScore?: InputMaybe<Scalars['Float']>;
  /** [Optional] Year build, defaults to value from HDS */
  yearBuilt?: InputMaybe<Scalars['Int']>;
};

/** Protos for the post-list val gain adjustments model */
export type OdProtosMdfModelsSpread_MultivariateValGainAdjustmentRequestInput = {
  /** [Required] The address token of the home */
  addressToken?: InputMaybe<Scalars['String']>;
  /** [Optional] Dwelling type, defaults to value from HDS */
  dwellingType?: InputMaybe<Scalars['String']>;
  /** [Optional] Whether the home is in a guarded, gated community, defaults to value from HDS */
  hasGatedCommunityGuard?: InputMaybe<Scalars['Boolean']>;
  /** [Optional] Whether the home has a hoa, defaults to value from HDS */
  hasHoa?: InputMaybe<Scalars['Boolean']>;
  /** [Optional] Whether the home has a private pool, defaults to value from HDS */
  hasPrivatePool?: InputMaybe<Scalars['Boolean']>;
  /** [Optional] Whether the home is in a age restricted community, defaults to value from HDS */
  isAgeRestrictedCommunity?: InputMaybe<Scalars['Boolean']>;
  /** [Optional] Whether the home is in a gated community, defaults to value from HDS */
  isGatedCommunity?: InputMaybe<Scalars['Boolean']>;
  /** [Required] Valuation of the home in USD */
  postRepairValuationUsd?: InputMaybe<Scalars['Float']>;
  /** [Optional] The [1-6] RestB property condition score, defaults to denormalized value from HDS */
  propertyRestbConditionScore?: InputMaybe<Scalars['Float']>;
  /** [Optional] Year build, defaults to value from HDS */
  yearBuilt?: InputMaybe<Scalars['Int']>;
};

export type OdProtosMdfModelsSpread_NegativeSelectionChargeRequestInput = {
  /** [Required] The address token of the home. */
  addressToken?: InputMaybe<Scalars['String']>;
  /** [Required] OVM Expected Error */
  expectedError?: InputMaybe<Scalars['Float']>;
};

export type OdProtosMdfModelsValuation_NationwideValuationsEnsemblerModelRequestInput = {
  /**
   * Home features
   *
   * [Optional] Above ground finished sq ft of the home
   */
  aboveGradeSqFt?: InputMaybe<Scalars['Int']>;
  addressToken?: InputMaybe<Scalars['String']>;
  /** [Optional] Basement finished sq ft of the home */
  basementFinishedSqFt?: InputMaybe<Scalars['Int']>;
  /** [Optional] Basement unfinished sq ft of the home */
  basementUnfinishedSqFt?: InputMaybe<Scalars['Int']>;
  /** [Optional] Bathrooms full */
  bathroomsFull?: InputMaybe<Scalars['Int']>;
  /** [Optional] Bathrooms half */
  bathroomsHalf?: InputMaybe<Scalars['Int']>;
  /** [Optional] Bedrooms */
  bedrooms?: InputMaybe<Scalars['Int']>;
  /** [Optional] HDS-formatted dwelling type of the home */
  dwellingType?: InputMaybe<Scalars['String']>;
  /** [Optional] Size of the home lot */
  lotSqFt?: InputMaybe<Scalars['Int']>;
  /** [Optional] Year home was built */
  yearBuilt?: InputMaybe<Scalars['Int']>;
};

export type OdProtosMdfModelsValuation_QuantariumDebiasedValuationRequestInput = {
  addressToken?: InputMaybe<Scalars['String']>;
};

export type OdProtosMdfModelsValuation_QuantariumEnsemblerModelRequestInput = {
  /** [Optional] Above grade square footage of the home */
  aboveGradeSqFt?: InputMaybe<Scalars['Int']>;
  /** [Required] The address token of the home */
  addressToken?: InputMaybe<Scalars['String']>;
  /** [Optional] Basement finished sq ft of the home */
  basementFinishedSqFt?: InputMaybe<Scalars['Int']>;
  /** [Optional] Basement unfinished sq ft of the home */
  basementUnfinishedSqFt?: InputMaybe<Scalars['Int']>;
  /** [Optional] RestB formatted (1-6) bathroom condition score */
  bathroomConditionScore?: InputMaybe<Scalars['Float']>;
  /** [Optional] Bathrooms full */
  bathroomsFull?: InputMaybe<Scalars['Int']>;
  /** [Optional] Bathrooms half */
  bathroomsHalf?: InputMaybe<Scalars['Int']>;
  /** [Optional] Bedrooms */
  bedrooms?: InputMaybe<Scalars['Int']>;
  /** [Optional] Garport spaces */
  carportSpaces?: InputMaybe<Scalars['Int']>;
  /** [Optional] HDS-formatted dwelling type of the home */
  dwellingType?: InputMaybe<Scalars['String']>;
  /** [Optional] RestB formatted (1-6) exterior condition score */
  exteriorConditionScore?: InputMaybe<Scalars['Float']>;
  /** [Optional] Exterior stories */
  exteriorStories?: InputMaybe<Scalars['Int']>;
  /** [Optional] Garage spaces */
  garageSpaces?: InputMaybe<Scalars['Int']>;
  /** [Optional] Whether the home has a basement */
  hasBasement?: InputMaybe<Scalars['Boolean']>;
  /** [Optional] Whether the home's basement has a daylight */
  hasBasementDaylight?: InputMaybe<Scalars['Boolean']>;
  /** [Optional] Whether the home is part of a gated community */
  hasGatedCommunityGuard?: InputMaybe<Scalars['Boolean']>;
  /** [Optional] Whether the home is part of a HOA */
  hasHoa?: InputMaybe<Scalars['Boolean']>;
  /** [Optional] Whether the home has a new roof */
  hasNewRoof?: InputMaybe<Scalars['Boolean']>;
  /** [Optional] Whether the home has new windows */
  hasNewWindows?: InputMaybe<Scalars['Boolean']>;
  /** [Optional] Whether the home has a nice backyard */
  hasNiceBackyard?: InputMaybe<Scalars['Boolean']>;
  /** [Optional] Whether the home has a private pool */
  hasPrivatePool?: InputMaybe<Scalars['Boolean']>;
  /** [Optional] Whether the home has solar */
  hasSolar?: InputMaybe<Scalars['Boolean']>;
  /** [Optional] Whether the home has upgrades */
  hasUpgrades?: InputMaybe<Scalars['Boolean']>;
  /** [Optional] RestB formatted (1-6) interior condition score */
  interiorConditionScore?: InputMaybe<Scalars['Float']>;
  /** [Optional] Whether the home is in an age restricted community */
  isAgeRestrictedCommunity?: InputMaybe<Scalars['Boolean']>;
  /** [Optional] Kitchen appliance type */
  kitchenApplianceType?: InputMaybe<Scalars['String']>;
  /** [Optional] RestB formatted (1-6) kitchen condition score */
  kitchenConditionScore?: InputMaybe<Scalars['Float']>;
  /** [Optional] Kitchen countertop type */
  kitchenCountertop?: InputMaybe<Scalars['String']>;
  /** [Optional] Size of the home lot */
  lotSqFt?: InputMaybe<Scalars['Int']>;
  /** [Required] OVM Expected Error in decimal formats */
  ovmExpectedError?: InputMaybe<Scalars['Float']>;
  /** [Required] OVM Valuation in USD */
  ovmValuation?: InputMaybe<Scalars['Float']>;
  /** [Optional] RestB formatted (1-6) property condition score */
  propertyConditionScore?: InputMaybe<Scalars['Float']>;
  /** [Optional] Year home was built */
  yearBuilt?: InputMaybe<Scalars['Int']>;
};

export type OdProtosMdfModelsValuation_QuantariumValuationRequestInput = {
  addressToken?: InputMaybe<Scalars['String']>;
};

export type OdProtosMdfModelsValuation_RealtyTracValuationRequestInput = {
  addressToken?: InputMaybe<Scalars['String']>;
};

export type OdProtosMdfModelsValuation_ValuationsEnsemblerModelRequestInput = {
  /**
   * Home features
   *
   * [Optional] Above ground finished sq ft of the home
   */
  aboveGradeSqFt?: InputMaybe<Scalars['Int']>;
  /** [Required] The address token of the home */
  addressToken?: InputMaybe<Scalars['String']>;
  /** [Optional] Basement finished sq ft of the home */
  basementFinishedSqFt?: InputMaybe<Scalars['Int']>;
  /** [Optional] Basement unfinished sq ft of the home */
  basementUnfinishedSqFt?: InputMaybe<Scalars['Int']>;
  /** [Optional] RestB formatted (1-6) bathroom condition score */
  bathroomConditionScore?: InputMaybe<Scalars['Float']>;
  /** [Optional] Bathrooms full */
  bathroomsFull?: InputMaybe<Scalars['Int']>;
  /** [Optional] Bathrooms half */
  bathroomsHalf?: InputMaybe<Scalars['Int']>;
  /** [Optional] Bedrooms */
  bedrooms?: InputMaybe<Scalars['Int']>;
  /** [Optional] Garport spaces */
  carportSpaces?: InputMaybe<Scalars['Int']>;
  /** [Optional] HDS-formatted dwelling type of the home */
  dwellingType?: InputMaybe<Scalars['String']>;
  /** [Optional] RestB formatted (1-6) exterior condition score */
  exteriorConditionScore?: InputMaybe<Scalars['Float']>;
  /** [Optional] Garage spaces */
  garageSpaces?: InputMaybe<Scalars['Int']>;
  /** [Optional] RestB formatted (1-6) interior condition score */
  interiorConditionScore?: InputMaybe<Scalars['Float']>;
  /** [Optional] Whether the home is in an age restricted community */
  isAgeRestrictedCommunity?: InputMaybe<Scalars['Boolean']>;
  /** [Optional] RestB formatted (1-6) kitchen condition score */
  kitchenConditionScore?: InputMaybe<Scalars['Float']>;
  /** [Optional] Size of the home lot */
  lotSqFt?: InputMaybe<Scalars['Int']>;
  /** [Required] Ensemble methodology, must be one of ("prelim_offer", "underwriting" or "list_price") */
  methodology?: InputMaybe<Scalars['String']>;
  /**
   * Valuation metadata
   *
   * [Required] OVM Expected Error in decimal formats
   */
  ovmExpectedError?: InputMaybe<Scalars['Float']>;
  /** [Required] OVM Uncertainty percentile (taken directly from signals output) */
  ovmUncertaintyPercentileInDistribution?: InputMaybe<Scalars['Float']>;
  /**
   * Child valuations
   *
   * [Required] OVM Valuation in USD (not cents!)
   */
  ovmValuation?: InputMaybe<Scalars['Int']>;
  /** [Optional] Valuation from first PA in Ensemble, in USD (not cents!) */
  pa1Valuation?: InputMaybe<Scalars['Int']>;
  /** [Optional] Valuation from 2nd PA in Ensemble, in USD (not cents!) */
  pa2Valuation?: InputMaybe<Scalars['Int']>;
  /** [Optional] Valuation from 3rd PA in Ensemble, in USD (not cents!) */
  pa3Valuation?: InputMaybe<Scalars['Int']>;
  /** [Optional] Valuation from 4th PA in Ensemble, in USD (not cents!) */
  pa4Valuation?: InputMaybe<Scalars['Int']>;
  /** [Optional] Quantarium confidence score */
  quantariumConfidenceScore?: InputMaybe<Scalars['Float']>;
  /** [Optional] Quantarium Valuation in USD (not cents!) */
  quantariumValuation?: InputMaybe<Scalars['Int']>;
  /** [Optional] Year home was built */
  yearBuilt?: InputMaybe<Scalars['Int']>;
};

/** NEXT ID: 27 */
export type OdProtosMdfServices_ModelRequestInput = {
  modelRequest?: InputMaybe<OdProtosMdfServices_ModelRequest_ModelRequestOneofInput>;
};

export type OdProtosMdfServices_ModelRequest_ModelRequestOneofInput = {
  brnSpendRequest?: InputMaybe<OdProtosMdfModelsAcquisition_BrnSpendRequestInput>;
  daysToPendBiasRequest?: InputMaybe<OdProtosMdfModelsSpread_DaysToPendBiasRequestInput>;
  forecastedSpreadDailyChangeRequest?: InputMaybe<OdProtosMdfModelsSpread_ForecastedSpreadDailyChangeRequestInput>;
  indifferencePriceTargetModelRequest?: InputMaybe<OdProtosMdfModelsResale_IndifferencePriceTargetModelRequestInput>;
  initialMarkupFeaturesRequest?: InputMaybe<OdProtosMdfModelsResale_InitialMarkupFeaturesRequestInput>;
  multivariatePrelistValGainAdjustmentRequest?: InputMaybe<OdProtosMdfModelsSpread_MultivariatePrelistValGainAdjustmentRequestInput>;
  /** ----------- SPREAD ----------- */
  multivariateValGainAdjustmentRequest?: InputMaybe<OdProtosMdfModelsSpread_MultivariateValGainAdjustmentRequestInput>;
  nationwideValuationsEnsemblerRequest?: InputMaybe<OdProtosMdfModelsValuation_NationwideValuationsEnsemblerModelRequestInput>;
  negativeSelectionChargeRequest?: InputMaybe<OdProtosMdfModelsSpread_NegativeSelectionChargeRequestInput>;
  postlistRepairSpendRequest?: InputMaybe<OdProtosMdfModelsAcquisition_PostlistRepairSpendRequestInput>;
  /** -------- ACQUISITION --------- */
  prelistRepairScopeRequest?: InputMaybe<OdProtosMdfModelsAcquisition_PrelistRepairScopeRequestInput>;
  quantariumDebiasedValuationRequest?: InputMaybe<OdProtosMdfModelsValuation_QuantariumDebiasedValuationRequestInput>;
  /** ----------- VALUATION ----------- */
  quantariumEnsemblerModelRequest?: InputMaybe<OdProtosMdfModelsValuation_QuantariumEnsemblerModelRequestInput>;
  quantariumValuationRequest?: InputMaybe<OdProtosMdfModelsValuation_QuantariumValuationRequestInput>;
  realtytracValuationRequest?: InputMaybe<OdProtosMdfModelsValuation_RealtyTracValuationRequestInput>;
  resalePricingRecommendationsRequest?: InputMaybe<OdProtosMdfModelsResale_ResalePricingRecommendationsRequestInput>;
  /** ----------- RESALE ----------- */
  resaleProbabilityContractModelRequest?: InputMaybe<OdProtosMdfModelsResale_ResaleProbabilityContractModelRequestInput>;
  resaleTargetPriceModelRequest?: InputMaybe<OdProtosMdfModelsResale_ResaleTargetPriceModelRequestInput>;
  restbCalibrationScoreRequest?: InputMaybe<OdProtosMdfModelsAcquisition_RestbCalibrationScoreRequestInput>;
  valuationsEnsemblerRequest?: InputMaybe<OdProtosMdfModelsValuation_ValuationsEnsemblerModelRequestInput>;
};

export type OdProtosMdfServices_ScoringRequestInput = {
  modelEndpoint?: InputMaybe<Scalars['String']>;
  modelRequests?: InputMaybe<Array<OdProtosMdfServices_ModelRequestInput>>;
  requestId?: InputMaybe<Scalars['String']>;
};

/**
 * AddressContext represents the location of the eligibility check. At least
 * one of the fields must be provided, but prefer to provide more if possible.
 * Latitude and longitude cannot be the only fields provided.
 * Only the address_id is directly passed to the CheckEligibility data fields
 * from the AddressContext.
 * Next ID: 6
 */
export type OdProtosMerchandisingData_AddressContextInput = {
  /**
   * Address identifier. This will be used to look up the postal code and
   * market fields if not specified.
   */
  addressId?: InputMaybe<Scalars['String']>;
  /** Latitude of the address. Cannot be the only field provided. */
  latitude?: InputMaybe<Scalars['Float']>;
  /** Longitude of the address. Cannot be the only field provided. */
  longitude?: InputMaybe<Scalars['Float']>;
  /**
   * Active market region. Provide this field only if the address lies within
   * an *active* market.
   */
  market?: InputMaybe<OdProtosCommonMarket_Market>;
  /** Postal code of address. Useful as a shortcut for some services. */
  postalCode?: InputMaybe<Scalars['String']>;
};

/** Next ID: 2 */
export type OdProtosMerchandisingData_BoolWrapperInput = {
  bool?: InputMaybe<Scalars['Boolean']>;
};

/**
 * CustomerContext represents customer information to be used with CheckEligibility
 * calls
 */
export type OdProtosMerchandisingData_CustomerContextInput = {
  email?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/**
 * Set of services that Merchandising can fetch fields from.
 * Next ID: 16
 */
export type OdProtosMerchandisingData_DataSource =
  | 'BALLPARK'
  | 'CASA'
  | 'DWELLINGS'
  | 'FENCE'
  | 'GDS'
  | 'HDS'
  | 'LISTING'
  | 'ODLS'
  | 'OFFER_OUTLIER'
  | 'OSTIARY'
  | 'PARTNERSHIP'
  | 'RECEPTION'
  | 'SELLER_DASHBOARD_METRICS'
  | 'TOGGLE'
  | 'UNKNOWN_SOURCE'
  | 'WEB';

/**
 * DataSources represents the sources a CheckEligibility request can use to fetch data.
 * Next ID: 7
 */
export type OdProtosMerchandisingData_DataSourcesInput = {
  experimentEntityId?: InputMaybe<Scalars['String']>;
  homeDataStoreId?: InputMaybe<Scalars['String']>;
  /** Optional fields to limit calls to external datasources in a CheckEligibility request. */
  input?: InputMaybe<OdProtosMerchandisingData_DataSources_InputOneofInput>;
  sellerInput?: InputMaybe<OdProtosMerchandisingData_DataSources_SellerInputInput>;
};

export type OdProtosMerchandisingData_DataSources_DataSourceListInput = {
  dataSources?: InputMaybe<Array<OdProtosMerchandisingData_DataSource>>;
};

export type OdProtosMerchandisingData_DataSources_InputOneofInput = {
  /** Do not make any calls to external datasources. */
  excludeAll?: InputMaybe<Scalars['Boolean']>;
  /** Call out to all datasources except those in this list. */
  excluded?: InputMaybe<OdProtosMerchandisingData_DataSources_DataSourceListInput>;
  /** Call out to only the datasources in this list. */
  included?: InputMaybe<OdProtosMerchandisingData_DataSources_DataSourceListInput>;
};

export type OdProtosMerchandisingData_DataSources_SellerInputInput = {
  id?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<OdProtosMerchandisingData_DataSources_SellerInput_Type>;
};

export type OdProtosMerchandisingData_DataSources_SellerInput_Type =
  | 'PARTNERSHIP'
  | 'RECEPTION'
  | 'UNKNOWN_TYPE';

/**
 * Fields is a set of data inputs used by Merchandising to check eligibilities.
 * Rules in RuleSets can reference fields by their name and when evaluating
 * the rule expression, the value that will be used will be provided by
 * this Protobuf message in the gRPC request. If a field is left unset,
 * it will be interpreted as having a NULL value.
 *
 * Field must have one of the following types:
 * BoolWrapper
 * Int64Wrapper
 * DoubleWrapper
 * StringWrapper
 * TimestampWrapper
 * StringListWrapper
 *
 * The wrapper types exist to distinguish fields between the Unknown state and the
 * Null state. Both states represent a missing value, but the intention is different.
 * An Unknown state is where the caller, or a data source, does not know the value
 * of a field, while the Null state is where value is known to be missing.
 *
 * If Merchandising finds an Unknown value, it will attempt to fill that value in by
 * loading data from its data sources. If Merchandising finds a Null value, it will
 * not attempt to fill the value in and leave the value as null.
 *
 * Callers should prefer to use the Unknown state to allow Merchandising to fetch data,
 * however callers may want to use Null if:
 * They do not want Merchandising to call a particular data source that provides
 * the missing field.
 * They intentionally want the value of the field to be missing and not be used
 * in the evaluation of rules.
 *
 * To use a Unknown value, leave the field unset in the Fields message.
 *
 * // All fields are implicitly unknown.
 * fields := &pb.Fields{}
 * // Explicitly set field to unknown state.
 * fields.LotSqFt = nil
 *
 * To use a Null value, set the field to an empty wrapper.
 *
 * // Set field to null state.
 * fields.LotSqFt = &pb.Int64Wrapper{}
 *
 * To use a non-missing value, set the field to a populated wrapper.
 *
 * // Set field to a populated state.
 * fields.LotSqFt = &pb.Int64Wrapper{Int64: &wrappers.Int64Value{Value: 2000}}
 *
 * Next ID: 90
 */
export type OdProtosMerchandisingData_FieldsInput = {
  activeOrganicGrowth?: InputMaybe<OdProtosMerchandisingData_BoolWrapperInput>;
  activelyLookingToBuy?: InputMaybe<OdProtosMerchandisingData_BoolWrapperInput>;
  addressEntryProduct?: InputMaybe<OdProtosMerchandisingData_StringWrapperInput>;
  addressId?: InputMaybe<OdProtosMerchandisingData_StringWrapperInput>;
  addressUuid?: InputMaybe<OdProtosMerchandisingData_StringWrapperInput>;
  ageRestrictedCommunity?: InputMaybe<OdProtosMerchandisingData_BoolWrapperInput>;
  agentRelation?: InputMaybe<OdProtosMerchandisingData_BoolWrapperInput>;
  asbestosSiding?: InputMaybe<OdProtosMerchandisingData_BoolWrapperInput>;
  bathrooms?: InputMaybe<OdProtosMerchandisingData_Int64WrapperInput>;
  bedrooms?: InputMaybe<OdProtosMerchandisingData_Int64WrapperInput>;
  belowMarketRateOwnership?: InputMaybe<OdProtosMerchandisingData_BoolWrapperInput>;
  brokerageUuid?: InputMaybe<OdProtosMerchandisingData_StringWrapperInput>;
  buyWithOpendoorEnabled?: InputMaybe<OdProtosMerchandisingData_BoolWrapperInput>;
  cesspool?: InputMaybe<OdProtosMerchandisingData_BoolWrapperInput>;
  distressedSale?: InputMaybe<OdProtosMerchandisingData_BoolWrapperInput>;
  dwellingType?: InputMaybe<OdProtosMerchandisingData_StringWrapperInput>;
  expectedError?: InputMaybe<OdProtosMerchandisingData_Float64WrapperInput>;
  expectedLgmCents?: InputMaybe<OdProtosMerchandisingData_Int64WrapperInput>;
  /**
   * Optimizely feature flag names. Flags in this list are assumed enabled; flags not in the list are assumed disabled.
   * If this field is provided, Optimizely will not be called to check on the status of the flags.
   */
  featureFlags?: InputMaybe<OdProtosMerchandisingData_StringListWrapperInput>;
  fireDamage?: InputMaybe<OdProtosMerchandisingData_BoolWrapperInput>;
  flipStatus?: InputMaybe<OdProtosMerchandisingData_StringWrapperInput>;
  floodHistory?: InputMaybe<OdProtosMerchandisingData_BoolWrapperInput>;
  floodProximity?: InputMaybe<OdProtosMerchandisingData_Int64WrapperInput>;
  floodZone?: InputMaybe<OdProtosMerchandisingData_BoolWrapperInput>;
  floodZoneCode?: InputMaybe<OdProtosMerchandisingData_StringWrapperInput>;
  foundationIssues?: InputMaybe<OdProtosMerchandisingData_BoolWrapperInput>;
  gatedCommunity?: InputMaybe<OdProtosMerchandisingData_BoolWrapperInput>;
  gatedCommunityHasGuard?: InputMaybe<OdProtosMerchandisingData_BoolWrapperInput>;
  hasCompAddressUuids?: InputMaybe<OdProtosMerchandisingData_BoolWrapperInput>;
  hasHistoricalMarketMetrics?: InputMaybe<OdProtosMerchandisingData_BoolWrapperInput>;
  /**
   * has_legacy_flip can be used when constricting the
   * sell direct buybox. For example, when constraining
   * valuation cents you can continue to allows addresses
   * which have a legacy flip to be considered eligible
   * despite falling outside the new buybox.
   */
  hasLegacyFlip?: InputMaybe<OdProtosMerchandisingData_BoolWrapperInput>;
  hasValuationCents?: InputMaybe<OdProtosMerchandisingData_BoolWrapperInput>;
  hoaNames?: InputMaybe<OdProtosMerchandisingData_StringListWrapperInput>;
  homeEstimateCents?: InputMaybe<OdProtosMerchandisingData_Int64WrapperInput>;
  inAgentLedOffersExperience?: InputMaybe<OdProtosMerchandisingData_BoolWrapperInput>;
  inCovidWhitelist?: InputMaybe<OdProtosMerchandisingData_BoolWrapperInput>;
  internalFeePct?: InputMaybe<OdProtosMerchandisingData_Float64WrapperInput>;
  /** use internal_fee to include risk_adjustment (NSC) */
  internalFeeWithoutRiskAdjustmentPct?: InputMaybe<OdProtosMerchandisingData_Float64WrapperInput>;
  isOfferOutlier?: InputMaybe<OdProtosMerchandisingData_BoolWrapperInput>;
  isQualifiedForAlo?: InputMaybe<OdProtosMerchandisingData_BoolWrapperInput>;
  leadChannel?: InputMaybe<OdProtosMerchandisingData_StringWrapperInput>;
  leadState?: InputMaybe<OdProtosMerchandisingData_StringWrapperInput>;
  leasedSolarPanels?: InputMaybe<OdProtosMerchandisingData_BoolWrapperInput>;
  listPriceCents?: InputMaybe<OdProtosMerchandisingData_Int64WrapperInput>;
  livestock?: InputMaybe<OdProtosMerchandisingData_BoolWrapperInput>;
  lotSqFt?: InputMaybe<OdProtosMerchandisingData_Int64WrapperInput>;
  mlsListingStatus?: InputMaybe<OdProtosMerchandisingData_StringWrapperInput>;
  mobileManufacturedHome?: InputMaybe<OdProtosMerchandisingData_BoolWrapperInput>;
  mostRecentZillowReferralDays?: InputMaybe<OdProtosMerchandisingData_Int64WrapperInput>;
  newConstruction?: InputMaybe<OdProtosMerchandisingData_BoolWrapperInput>;
  offerRequestCount?: InputMaybe<OdProtosMerchandisingData_Int64WrapperInput>;
  offerRequestSource?: InputMaybe<OdProtosMerchandisingData_StringWrapperInput>;
  opendoorDirectDenialReason?: InputMaybe<OdProtosMerchandisingData_StringWrapperInput>;
  /** partnership_type is deprecated - use referral_types instead. */
  partnershipType?: InputMaybe<OdProtosMerchandisingData_StringWrapperInput>;
  polybutylenePiping?: InputMaybe<OdProtosMerchandisingData_BoolWrapperInput>;
  postalCode?: InputMaybe<OdProtosMerchandisingData_StringWrapperInput>;
  potentialTradeIn?: InputMaybe<OdProtosMerchandisingData_BoolWrapperInput>;
  price?: InputMaybe<OdProtosMerchandisingData_Int64WrapperInput>;
  priceEstimateTriage?: InputMaybe<OdProtosMerchandisingData_BoolWrapperInput>;
  privatePool?: InputMaybe<OdProtosMerchandisingData_BoolWrapperInput>;
  referralIdentifiers?: InputMaybe<OdProtosMerchandisingData_StringListWrapperInput>;
  referralTypes?: InputMaybe<OdProtosMerchandisingData_StringListWrapperInput>;
  rentControlledTenantOccupied?: InputMaybe<OdProtosMerchandisingData_BoolWrapperInput>;
  riskProhibitedRegion?: InputMaybe<OdProtosMerchandisingData_BoolWrapperInput>;
  saleTimeline?: InputMaybe<OdProtosMerchandisingData_StringWrapperInput>;
  septic?: InputMaybe<OdProtosMerchandisingData_BoolWrapperInput>;
  seriousSeller?: InputMaybe<OdProtosMerchandisingData_BoolWrapperInput>;
  sharedEntrance?: InputMaybe<OdProtosMerchandisingData_BoolWrapperInput>;
  sharedLot?: InputMaybe<OdProtosMerchandisingData_BoolWrapperInput>;
  sinkholes?: InputMaybe<OdProtosMerchandisingData_BoolWrapperInput>;
  timeshare?: InputMaybe<OdProtosMerchandisingData_BoolWrapperInput>;
  totalLivingSqFt?: InputMaybe<OdProtosMerchandisingData_Int64WrapperInput>;
  undergroundOilTank?: InputMaybe<OdProtosMerchandisingData_BoolWrapperInput>;
  uniqueOwnershipStructure?: InputMaybe<OdProtosMerchandisingData_BoolWrapperInput>;
  unpermittedAddition?: InputMaybe<OdProtosMerchandisingData_BoolWrapperInput>;
  valuationCents?: InputMaybe<OdProtosMerchandisingData_Int64WrapperInput>;
  valuationCentsForPartnerships?: InputMaybe<OdProtosMerchandisingData_Int64WrapperInput>;
  wellWater?: InputMaybe<OdProtosMerchandisingData_BoolWrapperInput>;
  workingWithAgent?: InputMaybe<OdProtosMerchandisingData_BoolWrapperInput>;
  workingWithHomeBuilder?: InputMaybe<OdProtosMerchandisingData_BoolWrapperInput>;
  yearBuilt?: InputMaybe<OdProtosMerchandisingData_Int64WrapperInput>;
};

/** Next ID: 2 */
export type OdProtosMerchandisingData_Float64WrapperInput = {
  float64?: InputMaybe<Scalars['Float']>;
};

/** Next ID: 2 */
export type OdProtosMerchandisingData_Int64WrapperInput = {
  int64?: InputMaybe<Scalars['Float']>;
};

export type OdProtosMerchandisingData_NullValue =
  | 'NULL_VALUE';

/** Next ID: 4 */
export type OdProtosMerchandisingData_Result_Status =
  /** The rule's condition was not satisfied. */
  | 'FAILED'
  /** The rule's condition could not be evaluated due to missing data. */
  | 'MISSING'
  /** The rule's condition was satisfied. */
  | 'PASSED'
  | 'UNKNOWN_STATUS';

/** Next ID: 3 */
export type OdProtosMerchandisingData_RuleInput = {
  exprJson?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type OdProtosMerchandisingData_RuleSetVersion_State =
  /** The proposed version has been approved and is now live. */
  | 'APPROVED'
  /** The proposed version has been closed without approval. */
  | 'CLOSED'
  /** This version has been proposed, but is not yet live. */
  | 'PROPOSED'
  | 'UNKNOWN_STATE';

/** Next ID: 2 */
export type OdProtosMerchandisingData_StringListWrapperInput = {
  stringList?: InputMaybe<Array<Scalars['String']>>;
};

/** Next ID: 2 */
export type OdProtosMerchandisingData_StringWrapperInput = {
  string?: InputMaybe<Scalars['String']>;
};

export type OdProtosMerchandisingData_Value_Kind =
  | 'BOOL'
  | 'FLOAT64'
  | 'INT64'
  | 'NULL'
  | 'STRING'
  | 'STRING_LIST'
  | 'TIMESTAMP'
  | 'UNKNOWN_TYPE';

/** Next ID: 2 */
export type OdProtosMerchandisingServices_ApproveRulesRequestInput = {
  ruleSetVersionId?: InputMaybe<Scalars['String']>;
};

/** Next ID: 2 */
export type OdProtosMerchandisingServices_BulkCreateRuleSetsRequestInput = {
  requests?: InputMaybe<Array<OdProtosMerchandisingServices_CreateRuleSetRequestInput>>;
};

/** Next ID: 6 */
export type OdProtosMerchandisingServices_CheckEligibilityRequestInput = {
  address?: InputMaybe<OdProtosMerchandisingData_AddressContextInput>;
  customer?: InputMaybe<OdProtosMerchandisingData_CustomerContextInput>;
  dataFields?: InputMaybe<OdProtosMerchandisingData_FieldsInput>;
  dataSources?: InputMaybe<OdProtosMerchandisingData_DataSourcesInput>;
  experiences?: InputMaybe<Array<Scalars['String']>>;
};

/** Next ID: 2 */
export type OdProtosMerchandisingServices_CloseRulesRequestInput = {
  ruleSetVersionId?: InputMaybe<Scalars['String']>;
};

/** Next ID: 6 */
export type OdProtosMerchandisingServices_CreateRuleSetRequestInput = {
  /**
   * Whether the rule set is active or not. If this field is not set, defaults
   * to true.
   */
  active?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<Scalars['String']>;
  experience?: InputMaybe<Scalars['String']>;
  market?: InputMaybe<OdProtosCommonMarket_Market>;
  /** If set, the similar market's active rule set will be copied and used as the new market's inital ruleset. */
  marketToCopy?: InputMaybe<OdProtosCommonMarket_Market>;
};

export type OdProtosMerchandisingServices_DeleteRuleSetRequestInput = {
  ruleSetId?: InputMaybe<Scalars['String']>;
};

/** Next ID: 3 */
export type OdProtosMerchandisingServices_FindRuleSetsRequestInput = {
  experiences?: InputMaybe<Array<Scalars['String']>>;
  markets?: InputMaybe<Array<OdProtosCommonMarket_Market>>;
};

export type OdProtosMerchandisingServices_GetProposedEditsRequestInput = {
  _empty?: InputMaybe<Scalars['Boolean']>;
};

/** Next ID: 2 */
export type OdProtosMerchandisingServices_GetRuleSetRequestInput = {
  ruleSetId?: InputMaybe<Scalars['String']>;
};

/** Next ID: 3 */
export type OdProtosMerchandisingServices_ListRuleSetVersionsRequestInput = {
  input?: InputMaybe<OdProtosMerchandisingServices_ListRuleSetVersionsRequest_InputOneofInput>;
};

export type OdProtosMerchandisingServices_ListRuleSetVersionsRequest_IdentifiersInput = {
  ids?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosMerchandisingServices_ListRuleSetVersionsRequest_InputOneofInput = {
  ruleSetId?: InputMaybe<Scalars['String']>;
  ruleSetVersionIds?: InputMaybe<OdProtosMerchandisingServices_ListRuleSetVersionsRequest_IdentifiersInput>;
};

/** Next ID: 4 */
export type OdProtosMerchandisingServices_ListRuleSetsRequestInput = {
  input?: InputMaybe<OdProtosMerchandisingServices_ListRuleSetsRequest_InputOneofInput>;
};

export type OdProtosMerchandisingServices_ListRuleSetsRequest_IdentifiersInput = {
  ids?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosMerchandisingServices_ListRuleSetsRequest_InputOneofInput = {
  markets?: InputMaybe<OdProtosMerchandisingServices_ListRuleSetsRequest_MarketsInput>;
  ruleSetIds?: InputMaybe<OdProtosMerchandisingServices_ListRuleSetsRequest_IdentifiersInput>;
};

export type OdProtosMerchandisingServices_ListRuleSetsRequest_MarketsInput = {
  markets?: InputMaybe<Array<OdProtosCommonMarket_Market>>;
};

/** Next ID: 4 */
export type OdProtosMerchandisingServices_ProposeRulesRequestInput = {
  includedRuleSetVersionIds?: InputMaybe<Array<Scalars['String']>>;
  ruleSetId?: InputMaybe<Scalars['String']>;
  rules?: InputMaybe<Array<OdProtosMerchandisingData_RuleInput>>;
};

/** Next ID: 5 */
export type OdProtosMerchandisingServices_ScheduleBacktestRequestInput = {
  /**
   * Specify a list of particular addresses to target.
   * TODO: Support this functionality.
   */
  backtests?: InputMaybe<Array<OdProtosMerchandisingServices_ScheduleBacktestRequest_BacktestInput>>;
  experience?: InputMaybe<Scalars['String']>;
  market?: InputMaybe<OdProtosCommonMarket_Market>;
  proposedrulesetversionuuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosMerchandisingServices_ScheduleBacktestRequest_BacktestInput = {
  addresstoken?: InputMaybe<Scalars['String']>;
};

/** Next ID: 4 */
export type OdProtosMerchandisingServices_UpdateRuleSetRequestInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<Scalars['String']>;
  ruleSetId?: InputMaybe<Scalars['String']>;
};

/** Next ID: 3 */
export type OdProtosMerchandisingServices_UpdateRuleSetRulesRequestInput = {
  includedRuleSetVersionIds?: InputMaybe<Array<Scalars['String']>>;
  ruleSetId?: InputMaybe<Scalars['String']>;
  rules?: InputMaybe<Array<OdProtosMerchandisingData_RuleInput>>;
};

/** Next ID: 2 */
export type OdProtosMerchandisingServices_ValidateRulesRequestInput = {
  rules?: InputMaybe<Array<OdProtosMerchandisingData_RuleInput>>;
};

export type OdProtosMergeServices_MergeAddressRequestInput = {
  fromId?: InputMaybe<Scalars['String']>;
  toId?: InputMaybe<Scalars['String']>;
};

export type OdProtosMergeServices_MergeCustomerRequestInput = {
  fromId?: InputMaybe<Scalars['String']>;
  toId?: InputMaybe<Scalars['String']>;
};

export type OdProtosMolassesData_AddOpenHouseInfoInput = {
  listingUuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosMolassesData_CloseOfEscrowDateUpdateInput = {
  listingUuid?: InputMaybe<Scalars['String']>;
  newDate?: InputMaybe<Scalars['String']>;
};

export type OdProtosMolassesData_FhaEligibleUpdateInput = {
  fhaEligibleDate?: InputMaybe<Scalars['String']>;
  listingUuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosMolassesData_Level =
  | 'ERROR_LEVEL'
  | 'INFO_LEVEL'
  | 'UNKNOWN_LEVEL'
  | 'WARN_LEVEL';

export type OdProtosMolassesData_ListerineCreateListingBlobInput = {
  addressToken?: InputMaybe<Scalars['String']>;
  fetchedData?: InputMaybe<Scalars['String']>;
  formData?: InputMaybe<Scalars['String']>;
  hdsId?: InputMaybe<Scalars['String']>;
  hpmD1wVisit?: InputMaybe<Scalars['String']>;
  hpmSetupVisit?: InputMaybe<Scalars['String']>;
  isTraditionalListing?: InputMaybe<Scalars['Boolean']>;
  listingTaskId?: InputMaybe<Scalars['String']>;
  listingUuid?: InputMaybe<Scalars['String']>;
};

/** ListingStatus enumerates the different possible MLS statuses a listing can be in. */
export type OdProtosMolassesData_ListingStatus =
  | 'ACTIVE_LISTING_STATUS'
  | 'CANCELED_LISTING_STATUS'
  | 'CLOSED_LISTING_STATUS'
  | 'COMING_SOON_LISTING_STATUS'
  | 'CONTINGENT_LISTING_STATUS'
  | 'EXPIRED_LISTING_STATUS'
  | 'PENDING_LISTING_STATUS'
  | 'PUT_ON_MARKET_LISTING_STATUS'
  | 'TEMPORARILY_OFF_MARKET_LISTING_STATUS'
  | 'UNKNOWN_LISTING_STATUS'
  | 'WITHDRAWN_LISTING_STATUS';

/**
 * ListingStatusFields is an object that contains any metadata that we also want to manually specify
 * when performing a particular request (e.g. specifying an estimated COE date when updating a
 * listing status.)
 *
 * Fetching this data is by default managed by the Molasses service itself, but this object allows
 * us to manually specify/override any parameters that we want to use when performing the request.
 */
export type OdProtosMolassesData_ListingStatusFieldsInput = {
  /** TODO(evan): Fill this out as it becomes necessary. */
  optionExpirationDate?: InputMaybe<Scalars['String']>;
};

export type OdProtosMolassesData_ListingStatusUpdateInput = {
  isTraditionalListing?: InputMaybe<Scalars['Boolean']>;
  listingUuid?: InputMaybe<Scalars['String']>;
  newStatus?: InputMaybe<OdProtosMolassesData_ListingStatus>;
  overrides?: InputMaybe<OdProtosMolassesData_ListingStatusFieldsInput>;
};

export type OdProtosMolassesData_MlsTaskStatus =
  /**
   * COMPLETED represents a task that ran to completion and has passed any post-submission
   * checks/validations verifying that it completed properly.
   */
  | 'COMPLETED_TASK_STATUS'
  /**
   * COMPLETED_WITH_ERROR represents a task that has run to completion, with an error.
   * It will retry unless the max retries have been reached (then it is fatal).
   */
  | 'COMPLETED_WITH_ERROR_TASK_STATUS'
  /**
   * CONFIRMED_COMPLETED represents a task that successfully completed and its consequences were verified
   * after the task was completed
   */
  | 'CONFIRMED_COMPLETED_TASK_STATUS'
  /**
   * DISCREPANCY_DETECTED_TASK_STATUS represents a task that successfully completed and its consequences (price)
   * do not match or could not be confirmed after the task was completed
   */
  | 'DISCREPANCY_DETECTED_TASK_STATUS'
  /**
   * FATAL represents a task that has failed permanently, either because we reached the
   * maximum number of retries or we ran into some sort of unrecoverable error.
   */
  | 'FATAL_TASK_STATUS'
  /** MANUALLY_RESOLVED represents a task that was manually resolved by an Operator outside of Molasses */
  | 'MANUALLY_RESOLVED_TASK_STATUS'
  /**
   * PENDING represents a task that has been readied for execution and may be picked up by a
   * worker, but has not yet run to completion.
   */
  | 'PENDING_TASK_STATUS'
  | 'UNKNOWN_TASK_STATUS'
  /**
   * UNSUPPORTED represents a task update for an unsupported (mls, TaskType)
   * pair.
   */
  | 'UNSUPPORTED_TASK_STATUS';

export type OdProtosMolassesData_MlsTaskType =
  | 'ADD_OPEN_HOUSE_INFO_TASK_TYPE'
  | 'CLOSE_OF_ESCROW_DATE_UPDATE_TASK_TYPE'
  | 'CREATE_LISTING_TASK_TYPE'
  | 'FHA_ELIGIBLE_UPDATE_TASK_TYPE'
  | 'LISTING_STATUS_UPDATE_TASK_TYPE'
  | 'PRICE_UPDATE_TASK_TYPE'
  | 'UNKNOWN_TASK_TYPE'
  | 'UPLOAD_DISCLOSURE_DOCS_TASK_TYPE';

export type OdProtosMolassesData_PriceUpdateInput = {
  listingUuid?: InputMaybe<Scalars['String']>;
  newPriceCents?: InputMaybe<Scalars['Float']>;
};

export type OdProtosMolassesData_UploadDisclosureDocsInput = {
  /** 4: content_url */
  documentId?: InputMaybe<Scalars['String']>;
  filename?: InputMaybe<Scalars['String']>;
  listingUuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosMolassesServices_MlsTaskRequest_GetInput = {
  taskUuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosMolassesServices_MlsTaskRequest_GetLatestListingCreateInput = {
  ignoreNotFoundErrors?: InputMaybe<Scalars['Boolean']>;
  listingUuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosMolassesServices_MlsTaskRequest_ListInput = {
  /** UUIDs for all tasks to be returned. If none are specified, returns all tasks. */
  taskUuids?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosMolassesServices_MlsTaskRequest_RerunInput = {
  taskUuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosMolassesServices_MlsTaskRequest_SearchInput = {
  listingUuid?: InputMaybe<Array<Scalars['String']>>;
  /** pagination is required */
  pagination?: InputMaybe<OdProtosCommonPagination_PaginationRequestInput>;
  taskStatus?: InputMaybe<Array<OdProtosMolassesData_MlsTaskStatus>>;
  /**
   * It searches by the union of filters. If the individual filter is provided
   * it searches for entries that have one of the provided values.
   */
  taskType?: InputMaybe<Array<OdProtosMolassesData_MlsTaskType>>;
};

export type OdProtosMolassesServices_MlsTaskRequest_SetToManuallyResolvedInput = {
  taskUuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosMolassesServices_MolassesRequest_AddOpenHouseInfoInput = {
  updateRequest?: InputMaybe<OdProtosMolassesData_AddOpenHouseInfoInput>;
};

export type OdProtosMolassesServices_MolassesRequest_CloseOfEscrowDateUpdateInput = {
  updateRequest?: InputMaybe<OdProtosMolassesData_CloseOfEscrowDateUpdateInput>;
};

export type OdProtosMolassesServices_MolassesRequest_FhaEligibleUpdateInput = {
  updateRequest?: InputMaybe<OdProtosMolassesData_FhaEligibleUpdateInput>;
};

export type OdProtosMolassesServices_MolassesRequest_ListMlsNamesInput = {
  _empty?: InputMaybe<Scalars['Boolean']>;
};

export type OdProtosMolassesServices_MolassesRequest_ListUsernamesInput = {
  mlsName?: InputMaybe<Scalars['String']>;
};

export type OdProtosMolassesServices_MolassesRequest_ListingCreateInput = {
  updateRequest?: InputMaybe<OdProtosMolassesData_ListerineCreateListingBlobInput>;
};

export type OdProtosMolassesServices_MolassesRequest_ListingStatusUpdateInput = {
  updateRequest?: InputMaybe<OdProtosMolassesData_ListingStatusUpdateInput>;
};

export type OdProtosMolassesServices_MolassesRequest_PriceUpdateInput = {
  updateRequest?: InputMaybe<OdProtosMolassesData_PriceUpdateInput>;
};

export type OdProtosMolassesServices_MolassesRequest_UpdateMlsCredentialsInput = {
  mlsName?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  username?: InputMaybe<Scalars['String']>;
};

export type OdProtosMolassesServices_MolassesRequest_UploadDisclosureDocsInput = {
  updateRequest?: InputMaybe<OdProtosMolassesData_UploadDisclosureDocsInput>;
};

export type OdProtosMolassesServices_SupportedRequest_IsSupportedInput = {
  checkSupported?: InputMaybe<OdProtosMolassesServices_SupportedUpdateInput>;
};

export type OdProtosMolassesServices_SupportedRequest_UpdateInput = {
  supportedRequest?: InputMaybe<OdProtosMolassesServices_SupportedUpdateInput>;
};

/** Represents a possible update to the MLS and its support */
export type OdProtosMolassesServices_SupportedUpdateInput = {
  /** Desired state of this update type, ignored for IsSupported checks */
  isActive?: InputMaybe<Scalars['Boolean']>;
  /** Optional listing_status, only applicable for that task type */
  listingStatus?: InputMaybe<OdProtosMolassesData_ListingStatus>;
  /** MlsName of the supported update */
  mlsName?: InputMaybe<Scalars['String']>;
  /** TaskType of the active request */
  taskType?: InputMaybe<OdProtosMolassesData_MlsTaskType>;
};

/** Next ID: 3 */
export type OdProtosMortgageData_CreditRangeInput = {
  max?: InputMaybe<Scalars['Float']>;
  min?: InputMaybe<Scalars['Float']>;
};

export type OdProtosNotesData_NoteContextInput = {
  category?: InputMaybe<Scalars['String']>;
  contextIdentifiers?: InputMaybe<Array<Scalars['String']>>;
  contextType?: InputMaybe<OdProtosNotesTypes_ContextType>;
};

export type OdProtosNotesData_NoteItemOrderingInput = {
  column?: InputMaybe<OdProtosNotesData_NoteItemOrdering_Column>;
  isAscending?: InputMaybe<Scalars['Boolean']>;
};

export type OdProtosNotesData_NoteItemOrdering_Column =
  | 'CREATED_AT';

export type OdProtosNotesData_NoteSearchFiltersInput = {
  /** ignore, if empty. If more then one, then combines with AND */
  tags?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosNotesServices_CreateNote_RequestInput = {
  /** Main text of the note. */
  body?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Scalars['String']>;
  checkbackDate?: InputMaybe<Scalars['DateTime']>;
  contextIdentifier?: InputMaybe<Scalars['String']>;
  /** Type of note */
  contextType?: InputMaybe<OdProtosNotesTypes_ContextType>;
  /** Token of the creating user. */
  createdByToken?: InputMaybe<Scalars['String']>;
  /** Deprecated */
  tags?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosNotesServices_CreateNotes_NoteInput = {
  /** Main text of the note. */
  body?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Scalars['String']>;
  checkbackDate?: InputMaybe<Scalars['DateTime']>;
  contextIdentifier?: InputMaybe<Scalars['String']>;
  /** Type of note */
  contextType?: InputMaybe<OdProtosNotesTypes_ContextType>;
  /** Token of the creating user. */
  createdByToken?: InputMaybe<Scalars['String']>;
};

export type OdProtosNotesServices_CreateNotes_RequestInput = {
  notes?: InputMaybe<Array<OdProtosNotesServices_CreateNotes_NoteInput>>;
};

export type OdProtosNotesServices_CreateOrUpdateNoteFromWebBulk_NoteInput = {
  /** Main text of the note. */
  body?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Scalars['String']>;
  checkbackDate?: InputMaybe<Scalars['DateTime']>;
  contextIdentifier?: InputMaybe<Scalars['String']>;
  /** Type of note */
  contextType?: InputMaybe<OdProtosNotesTypes_ContextType>;
  /** Creation timestamp of note. */
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** Token of the creating user. */
  createdByToken?: InputMaybe<Scalars['String']>;
  /** Last modified timestamp of note. */
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** uuid of the note in web */
  uuid?: InputMaybe<Scalars['String']>;
  /** Note Id is an identifier for notes in web */
  webNoteId?: InputMaybe<Scalars['Float']>;
};

export type OdProtosNotesServices_CreateOrUpdateNoteFromWebBulk_RequestInput = {
  notes?: InputMaybe<Array<OdProtosNotesServices_CreateOrUpdateNoteFromWebBulk_NoteInput>>;
};

export type OdProtosNotesServices_DeleteCustomerNoteForCcpa_RequestInput = {
  contextIdentifier?: InputMaybe<Scalars['String']>;
};

export type OdProtosNotesServices_DeleteNoteWeb_RequestInput = {
  webNoteId?: InputMaybe<Scalars['Float']>;
};

export type OdProtosNotesServices_DeleteNote_RequestInput = {
  contextType?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
};

export type OdProtosNotesServices_GetLatestNote_RequestInput = {
  noteContexts?: InputMaybe<Array<OdProtosNotesData_NoteContextInput>>;
};

export type OdProtosNotesServices_GetNoteById_RequestInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type OdProtosNotesServices_MigrateWebNotes_RequestInput = {
  batchSize?: InputMaybe<Scalars['Float']>;
  lastMigrationTime?: InputMaybe<Scalars['DateTime']>;
  notableTypes?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosNotesServices_NoteUpdateInput = {
  /** Using wrapper to handle optional fields */
  body?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Scalars['String']>;
  checkbackDate?: InputMaybe<Scalars['DateTime']>;
  contextIdentifier?: InputMaybe<Scalars['String']>;
  contextType?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
};

export type OdProtosNotesServices_SearchNotes_RequestInput = {
  body?: InputMaybe<Scalars['String']>;
  /** If provided restrict to notes with this category */
  category?: InputMaybe<Scalars['String']>;
  contextIdentifier?: InputMaybe<Scalars['String']>;
  contextIdentifiers?: InputMaybe<Array<Scalars['String']>>;
  /** Context type and identifier must be specified. */
  contextType?: InputMaybe<OdProtosNotesTypes_ContextType>;
  createdByTokens?: InputMaybe<Array<Scalars['String']>>;
  /** Deprecated */
  filters?: InputMaybe<OdProtosNotesData_NoteSearchFiltersInput>;
  orderings?: InputMaybe<Array<OdProtosNotesData_NoteItemOrderingInput>>;
  pagination?: InputMaybe<OdProtosCommonPagination_PaginationRequestInput>;
};

export type OdProtosNotesServices_UpdateNoteV1_RequestInput = {
  note?: InputMaybe<OdProtosNotesServices_NoteUpdateInput>;
};

export type OdProtosNotesServices_UpdateNote_RequestInput = {
  body?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Scalars['String']>;
  checkbackDate?: InputMaybe<Scalars['DateTime']>;
  contextType?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
};

export type OdProtosNotesServices_UpdateNotes_RequestInput = {
  notes?: InputMaybe<Array<OdProtosNotesServices_NoteUpdateInput>>;
};

/**
 * All notes have are associated with some external context.
 * Type and identifier specify this context.
 *
 * DO NOT change existing enum names as it will break past notes!
 * DO add to this enum for a new note association! No further service changes are
 * required.
 */
export type OdProtosNotesTypes_ContextType =
  | 'ADDRESS'
  | 'BRN'
  | 'BROKER_TRANSACTION_DOCUMENT_REVIEW'
  | 'BROKER_TRANSACTION_REVIEW'
  | 'BUY_OFFER'
  | 'CASEY_TASK'
  | 'CONSTRUCTION_WORK_ORDER'
  | 'CONTACT'
  | 'DOCUMENT'
  | 'EXCLUSIVE_LISTING_INFO'
  | 'FULFILLMENT'
  | 'LISTING'
  | 'LWOD_LEAD'
  | 'MESSAGE_THREAD'
  | 'OFFER'
  | 'OPENDOOR_BACKED_OFFER'
  | 'OPENDOOR_BACKED_ORDER'
  | 'PRICING_QA'
  | 'RENOVATION'
  | 'REPAIR_BUDGET_REVIEW'
  | 'TRANSACTION'
  | 'UNKNOWN'
  | 'VISIT'
  | 'VISIT_ITEM'
  | 'WEB_FLIP';

export type OdProtosNotificationsData_Notification_NotificationType =
  | 'CUSTOMER_MESSAGE'
  | 'HOME_REASSIGNMENT'
  | 'INVALID_TYPE'
  | 'PROJECT_NOTE'
  | 'REPAIR_SCOPES_READY_FOR_REVIEW'
  | 'VISIT_ASSIGN'
  | 'VISIT_CANCEL'
  | 'VISIT_CREATE'
  | 'VISIT_REJECT'
  | 'VISIT_REMINDER'
  | 'VISIT_SCHEDULE_CHANGE'
  | 'WORK_ORDER_MESSAGE';

export type OdProtosNotificationsData_Notification_Platform =
  | 'INVALID_PLATFORM'
  | 'MAESTRO'
  | 'SCOUT';

export type OdProtosNotificationsServices_AssociatedWithInput = {
  associatedWithId?: InputMaybe<Scalars['String']>;
  associatedWithType?: InputMaybe<Scalars['String']>;
};

/** Next ID: 4 */
export type OdProtosNotificationsServices_BackfillNotificationRequestInput = {
  createRequest?: InputMaybe<OdProtosNotificationsServices_CreateNotificationRequestInput>;
  createdAtOverwrite?: InputMaybe<Scalars['DateTime']>;
  markAsSeen?: InputMaybe<Scalars['Boolean']>;
};

/** Next ID: 2 */
export type OdProtosNotificationsServices_BackfillNotificationsRequestInput = {
  backfillNotificationRequests?: InputMaybe<Array<OdProtosNotificationsServices_BackfillNotificationRequestInput>>;
};

/** Next ID: 4 */
export type OdProtosNotificationsServices_CountNotificationsRequestInput = {
  associatedWith?: InputMaybe<OdProtosNotificationsServices_AssociatedWithInput>;
  hideSeenNotifications?: InputMaybe<Scalars['Boolean']>;
  market?: InputMaybe<Scalars['String']>;
  markets?: InputMaybe<Array<Scalars['String']>>;
  maxDate?: InputMaybe<Scalars['DateTime']>;
  minDate?: InputMaybe<Scalars['DateTime']>;
  platform?: InputMaybe<OdProtosNotificationsData_Notification_Platform>;
  types?: InputMaybe<Array<OdProtosNotificationsData_Notification_NotificationType>>;
};

/** Next ID: 5 */
export type OdProtosNotificationsServices_CountUnseenNotificationsForMarketsRequestInput = {
  createdAtInterval?: InputMaybe<OdProtosNotificationsServices_IntervalInput>;
  markets?: InputMaybe<Array<Scalars['String']>>;
  platform?: InputMaybe<OdProtosNotificationsData_Notification_Platform>;
};

/** Next ID: 5 */
export type OdProtosNotificationsServices_CountUnseenNotificationsForUserRequestInput = {
  createdAtInterval?: InputMaybe<OdProtosNotificationsServices_IntervalInput>;
  platform?: InputMaybe<OdProtosNotificationsData_Notification_Platform>;
  userToken?: InputMaybe<Scalars['String']>;
};

/** Next ID: 10 */
export type OdProtosNotificationsServices_CreateNotificationRequestInput = {
  assignedUserToken?: InputMaybe<Scalars['String']>;
  associatedWith?: InputMaybe<OdProtosNotificationsServices_CreateNotificationRequest_AssociatedWithOneofInput>;
  market?: InputMaybe<Scalars['String']>;
  platform?: InputMaybe<OdProtosNotificationsData_Notification_Platform>;
  subtitle?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<OdProtosNotificationsData_Notification_NotificationType>;
};

export type OdProtosNotificationsServices_CreateNotificationRequest_AssociatedWithOneofInput = {
  addressId?: InputMaybe<Scalars['String']>;
  projectId?: InputMaybe<Scalars['String']>;
  visitId?: InputMaybe<Scalars['String']>;
  workOrderId?: InputMaybe<Scalars['String']>;
};

/** Next ID: 2 */
export type OdProtosNotificationsServices_GetNotificationsByIdRequestInput = {
  notificationIds?: InputMaybe<Array<Scalars['String']>>;
};

/** Next ID: 3 */
export type OdProtosNotificationsServices_GetNotificationsForWorkOrderRequestInput = {
  platform?: InputMaybe<OdProtosNotificationsData_Notification_Platform>;
  workOrderId?: InputMaybe<Scalars['String']>;
};

export type OdProtosNotificationsServices_IntervalInput = {
  endTime?: InputMaybe<Scalars['DateTime']>;
  startTime?: InputMaybe<Scalars['DateTime']>;
};

/** Next ID: 5 */
export type OdProtosNotificationsServices_ListNotificationsForAssociatedWithIdsRequestInput = {
  addressIds?: InputMaybe<Array<Scalars['String']>>;
  notificationType?: InputMaybe<OdProtosNotificationsData_Notification_NotificationType>;
  platform?: InputMaybe<OdProtosNotificationsData_Notification_Platform>;
  workOrderIds?: InputMaybe<Array<Scalars['String']>>;
};

/** Next ID: 2 */
export type OdProtosNotificationsServices_MarkNotificationSeenRequestInput = {
  notificationId?: InputMaybe<Scalars['String']>;
};

/** Next ID: 2 */
export type OdProtosNotificationsServices_MarkNotificationUnseenRequestInput = {
  notificationId?: InputMaybe<Scalars['String']>;
};

/** Next ID: 5 */
export type OdProtosNotificationsServices_SearchNotificationsRequestInput = {
  associatedWith?: InputMaybe<OdProtosNotificationsServices_AssociatedWithInput>;
  hideSeenNotifications?: InputMaybe<Scalars['Boolean']>;
  market?: InputMaybe<Scalars['String']>;
  markets?: InputMaybe<Array<Scalars['String']>>;
  maxDate?: InputMaybe<Scalars['DateTime']>;
  minDate?: InputMaybe<Scalars['DateTime']>;
  pagination?: InputMaybe<OdProtosCommonPagination_OffsetPaginationRequestInput>;
  platform?: InputMaybe<OdProtosNotificationsData_Notification_Platform>;
  types?: InputMaybe<Array<OdProtosNotificationsData_Notification_NotificationType>>;
};

export type OdProtosOperatorData_BrokerageLicenseFilterInput = {
  licenseStates?: InputMaybe<Array<OdProtosCommonState_State>>;
  operatorTokens?: InputMaybe<Array<Scalars['String']>>;
  validOn?: InputMaybe<Scalars['DateTime']>;
};

export type OdProtosOperatorData_BrokerageLicenseInput = {
  licenseNumber?: InputMaybe<Scalars['String']>;
  licenseState?: InputMaybe<OdProtosCommonState_State>;
  operatorToken?: InputMaybe<Scalars['String']>;
  uuid?: InputMaybe<Scalars['String']>;
  validTill?: InputMaybe<Scalars['DateTime']>;
};

/** Deprecated: use coverage pods */
export type OdProtosOperatorData_CoverageCircleInput = {
  /**
   * The keys and values are Operator Human token
   * the operator from the key is covered by the operator from the value
   * e.g: the map:
   * {
   *   "X" : "Y",
   *   "Y" : "Z",
   *   "Z" : "X".
   * }
   * represents the coverage circle
   * X -> Y -> Z -> X
   *
   * If X is unavailable the responsibility for their work goes to Y
   * If Y is unavailable the responsibility for their work goes to Z
   * If Z is unavailable the responsibility for their work goes to X (closing the circle)
   * The map has to represent a closed circle, the list of keys and values are the same and are unique
   * map<from_operator_token, to_operator_token>
   */
  coverageMap?: InputMaybe<Array<OdProtosOperatorData_CoverageCircle_CoverageMapEntryInput>>;
};

/** `OdProtosOperatorData_CoverageCircle_CoverageMapEntryInput` represents the `coverage_map` map in `od_protos.operator.data.CoverageCircle`. */
export type OdProtosOperatorData_CoverageCircle_CoverageMapEntryInput = {
  key?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

export type OdProtosOperatorData_CoverageResponsibilityGrainType =
  | 'RESPONSIBILITY_GRAIN_CUSTOMER'
  | 'RESPONSIBILITY_GRAIN_TRANSACTION'
  | 'RESPONSIBILITY_GRAIN_UNSPECIFIED';

export type OdProtosOperatorData_FilterInput = {
  /** Filter out operators who no longer work with Opendoor */
  excludeDeactivated?: InputMaybe<Scalars['Boolean']>;
  /**
   * Get operators with given tokens, or get all operators
   * in the reporting hierarchy of given manager taoken
   */
  operatorFilter?: InputMaybe<OdProtosOperatorData_Filter_OperatorFilterOneofInput>;
};

export type OdProtosOperatorData_Filter_HumanTokensInput = {
  values?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosOperatorData_Filter_OperatorFilterOneofInput = {
  managerToken?: InputMaybe<Scalars['String']>;
  operatorTokens?: InputMaybe<OdProtosOperatorData_Filter_HumanTokensInput>;
};

export type OdProtosOperatorData_SkillFilterInput = {
  operatorTokens?: InputMaybe<Array<Scalars['String']>>;
  skillNames?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosOperatorData_SkillInput = {
  details?: InputMaybe<Scalars['String']>;
  operatorToken?: InputMaybe<Scalars['String']>;
  skillName?: InputMaybe<Scalars['String']>;
  uuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosOperatorData_TemplateConfigurationInput = {
  capacityCount?: InputMaybe<Scalars['Float']>;
  category?: InputMaybe<OdProtosOperatorData_WorkCategory>;
  id?: InputMaybe<Scalars['String']>;
  marketRestrictions?: InputMaybe<Array<OdProtosCommonMarket_Market>>;
  regionRestrictions?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosOperatorData_TemplateInput = {
  configurations?: InputMaybe<Array<OdProtosOperatorData_TemplateConfigurationInput>>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  level?: InputMaybe<Scalars['Float']>;
  name?: InputMaybe<Scalars['String']>;
};

export type OdProtosOperatorData_WorkAssignmentAttributesInput = {
  /** Location, reference to valid casa address */
  addressToken?: InputMaybe<Scalars['String']>;
  /** Current operator token, to exclude in case of reassignments */
  currentOperatorToken?: InputMaybe<Scalars['String']>;
  /** Date by which work must be done */
  dueDate?: InputMaybe<Scalars['DateTime']>;
  /** Real estate license needed */
  licensesRequired?: InputMaybe<Array<Scalars['String']>>;
  /** Skills / specializations needed */
  skillsRequired?: InputMaybe<Array<Scalars['String']>>;
  /** Strict due date availability */
  strictDueDateAvailibility?: InputMaybe<Scalars['Boolean']>;
  /** Type of work */
  workCategory?: InputMaybe<OdProtosOperatorData_WorkCategory>;
};

export type OdProtosOperatorData_WorkAssignmentConfigInput = {
  allowOverutilization?: InputMaybe<Scalars['Boolean']>;
  capacityCount?: InputMaybe<Scalars['Float']>;
  category?: InputMaybe<OdProtosOperatorData_WorkCategory>;
  humanToken?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  level?: InputMaybe<Scalars['Float']>;
  marketRestrictions?: InputMaybe<Array<OdProtosCommonMarket_Market>>;
  regionRestrictions?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosOperatorData_WorkCategory =
  | 'ACQ_TC'
  | 'FVA_ALA_ASSESSMENT'
  | 'FVA_ASSESSMENT'
  | 'IVA_ASSESSMENT'
  | 'RESALE_TC'
  | 'UNKNOWN';

export type OdProtosOperatorServices_ActiveVolumeFilterInput = {
  category?: InputMaybe<OdProtosOperatorData_WorkCategory>;
  configId?: InputMaybe<Scalars['String']>;
  humanToken?: InputMaybe<Scalars['String']>;
  markets?: InputMaybe<Array<OdProtosCommonMarket_Market>>;
};

export type OdProtosOperatorServices_AssignTemplateRequestInput = {
  humanToken?: InputMaybe<Scalars['String']>;
  templateId?: InputMaybe<Scalars['String']>;
};

export type OdProtosOperatorServices_CreateCoveragePodRequestInput = {
  name?: InputMaybe<Scalars['String']>;
  /** Human tokens */
  operatorTokens?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosOperatorServices_DeleteBrokerageLicensesRequestInput = {
  licenseUuids?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosOperatorServices_DeleteCoveragePodRequestInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type OdProtosOperatorServices_DeleteOperatorSkillsRequestInput = {
  skillUuids?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosOperatorServices_DeleteOperatorWorkAssignmentConfigsRequestInput = {
  workAssignmentConfigIds?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosOperatorServices_DeleteTemplatesRequestInput = {
  templateUuids?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosOperatorServices_GetActiveVolumeForOperatorsRequestInput = {
  activeVolumeFilters?: InputMaybe<Array<OdProtosOperatorServices_ActiveVolumeFilterInput>>;
  dueDates?: InputMaybe<Array<Scalars['DateTime']>>;
};

export type OdProtosOperatorServices_GetAvailableOperatorsInTimeWindowRequestInput = {
  endTime?: InputMaybe<Scalars['DateTime']>;
  operatorHumanTokens?: InputMaybe<Array<Scalars['String']>>;
  sharedCalendarId?: InputMaybe<Scalars['String']>;
  startTime?: InputMaybe<Scalars['DateTime']>;
  useGoogleCalendar?: InputMaybe<Scalars['Boolean']>;
};

export type OdProtosOperatorServices_GetBestCandidateBulkRequestInput = {
  /** optional, only when above is true - use shared (team) calendar instead of operator's primary calendar */
  sharedCalendarId?: InputMaybe<Scalars['String']>;
  /** optional - tiebreaker strategy for selecting among candidates with equal utilization */
  tiebreakerStrategy?: InputMaybe<OdProtosOperatorServices_TiebreakerStrategy>;
  /** optional - use google calendar instead of web availability details */
  useGoogleCalendar?: InputMaybe<Scalars['Boolean']>;
  /** The type of work, market restrictions, (and skills, licenses if needed) for each work unit */
  workUnits?: InputMaybe<Array<OdProtosOperatorData_WorkAssignmentAttributesInput>>;
};

export type OdProtosOperatorServices_GetBestCandidateForWorkRequestInput = {
  /** The type of work, market restrictions, (and skills, licenses if needed) */
  attributes?: InputMaybe<OdProtosOperatorData_WorkAssignmentAttributesInput>;
  /** optional, only when above is true - use shared (team) calendar instead of operator's primary calendar */
  sharedCalendarId?: InputMaybe<Scalars['String']>;
  /** optional - tiebreaker strategy for selecting among candidates with equal utilization. */
  tiebreakerStrategy?: InputMaybe<OdProtosOperatorServices_TiebreakerStrategy>;
  /** optional - use google calendar instead of web availability details */
  useGoogleCalendar?: InputMaybe<Scalars['Boolean']>;
};

export type OdProtosOperatorServices_GetBrokerageLicensesRequestInput = {
  filter?: InputMaybe<OdProtosOperatorData_BrokerageLicenseFilterInput>;
};

export type OdProtosOperatorServices_GetCandidatesForWorkRequestInput = {
  attributes?: InputMaybe<OdProtosOperatorData_WorkAssignmentAttributesInput>;
  sharedCalendarId?: InputMaybe<Scalars['String']>;
  useGoogleCalendar?: InputMaybe<Scalars['Boolean']>;
};

export type OdProtosOperatorServices_GetCoveringOperatorRequestInput = {
  operatorHumanToken?: InputMaybe<Scalars['String']>;
};

export type OdProtosOperatorServices_GetOperatorByUserTokenRequestInput = {
  userToken?: InputMaybe<Scalars['String']>;
};

export type OdProtosOperatorServices_GetOperatorCoverageResponsibilitiesRequestInput = {
  operatorToken?: InputMaybe<Scalars['String']>;
};

export type OdProtosOperatorServices_GetOperatorRequestInput = {
  uuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosOperatorServices_GetOperatorSkillsRequestInput = {
  filter?: InputMaybe<OdProtosOperatorData_SkillFilterInput>;
};

export type OdProtosOperatorServices_GetOperatorUnavailabilitiesRequestInput = {
  endTime?: InputMaybe<Scalars['DateTime']>;
  operatorHumanTokens?: InputMaybe<Array<Scalars['String']>>;
  sharedCalendarId?: InputMaybe<Scalars['String']>;
  startTime?: InputMaybe<Scalars['DateTime']>;
  useGoogleCalendar?: InputMaybe<Scalars['Boolean']>;
};

export type OdProtosOperatorServices_GetOperatorWorkAssignmentConfigsRequestInput = {
  filter?: InputMaybe<OdProtosOperatorServices_WorkAssignmentConfigFilterInput>;
};

export type OdProtosOperatorServices_GetOperatorsCoveredByOperatorRequestInput = {
  operatorHumanToken?: InputMaybe<Scalars['String']>;
};

export type OdProtosOperatorServices_GetOperatorsRequestInput = {
  filter?: InputMaybe<OdProtosOperatorData_FilterInput>;
};

/** Next ID: 2 */
export type OdProtosOperatorServices_GetRoleMembersRequestInput = {
  name?: InputMaybe<Scalars['String']>;
};

export type OdProtosOperatorServices_GetTemplatesRequestInput = {
  filter?: InputMaybe<OdProtosOperatorServices_TemplateFilterInput>;
};

/** Next ID: 2 */
export type OdProtosOperatorServices_GetUserRolesRequestInput = {
  userToken?: InputMaybe<Scalars['String']>;
};

export type OdProtosOperatorServices_HolidayCalendarRequestInput = {
  /** Please refrain using start time past 2022-01-01. Calendar API has holidays starting from 2022 */
  starttime?: InputMaybe<Scalars['DateTime']>;
};

export type OdProtosOperatorServices_ListCoveragePodsRequestInput = {
  pagination?: InputMaybe<OdProtosCommonPagination_OffsetPaginationRequestInput>;
};

export type OdProtosOperatorServices_RefreshOperatorDataRequestInput = {
  operatorfilter?: InputMaybe<OdProtosOperatorServices_RefreshOperatorDataRequest_OperatorFilterOneofInput>;
};

export type OdProtosOperatorServices_RefreshOperatorDataRequest_OperatorEmailsInput = {
  values?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosOperatorServices_RefreshOperatorDataRequest_OperatorFilterOneofInput = {
  operatorEmails?: InputMaybe<OdProtosOperatorServices_RefreshOperatorDataRequest_OperatorEmailsInput>;
  operatorTokens?: InputMaybe<OdProtosOperatorServices_RefreshOperatorDataRequest_OperatorTokensInput>;
};

export type OdProtosOperatorServices_RefreshOperatorDataRequest_OperatorTokensInput = {
  values?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosOperatorServices_SetBrokerageLicensesRequestInput = {
  licenses?: InputMaybe<Array<OdProtosOperatorData_BrokerageLicenseInput>>;
};

export type OdProtosOperatorServices_SetCoverageCirclesRequestInput = {
  /**
   * If any operator from an existing circle is modified, the full circle must be provided
   * To remove an operator from a circle, set the operator's covering operator to ""
   * E.g To go from X -> Y -> Z -> X to X -> Z -> X you must pass in the coverage circle coverage map of
   * "X": "Z"
   * "Y": ""
   * "Z: "X"
   */
  modifiedCoverageCircles?: InputMaybe<Array<OdProtosOperatorData_CoverageCircleInput>>;
};

export type OdProtosOperatorServices_SetOperatorSkillsRequestInput = {
  skills?: InputMaybe<Array<OdProtosOperatorData_SkillInput>>;
};

export type OdProtosOperatorServices_SetOperatorWorkAssignmentConfigsRequestInput = {
  configs?: InputMaybe<Array<OdProtosOperatorData_WorkAssignmentConfigInput>>;
};

export type OdProtosOperatorServices_SetTemplatesRequestInput = {
  templates?: InputMaybe<Array<OdProtosOperatorData_TemplateInput>>;
};

export type OdProtosOperatorServices_TemplateFilterInput = {
  categories?: InputMaybe<Array<OdProtosOperatorData_WorkCategory>>;
  level?: InputMaybe<Scalars['Float']>;
  markets?: InputMaybe<Array<OdProtosCommonMarket_Market>>;
  regions?: InputMaybe<Array<Scalars['String']>>;
};

/**
 * TiebreakerStrategy defines how the allocator resolves cases where
 * multiple operators have equal utilization.
 */
export type OdProtosOperatorServices_TiebreakerStrategy =
  /**
   * Randomly selects among tied operators with probability proportional
   * to their capacity.
   */
  | 'TIEBREAKER_STRATEGY_CAPACITY_WEIGHTED_RANDOM'
  | 'TIEBREAKER_STRATEGY_UNSPECIFIED';

export type OdProtosOperatorServices_UpdateCoveragePodRequestInput = {
  id?: InputMaybe<Scalars['String']>;
  /** null if not updated */
  name?: InputMaybe<Scalars['String']>;
  /** null if not updated */
  newOperatorTokens?: InputMaybe<OdProtosOperatorServices_UpdateCoveragePodRequest_OperatorTokensInput>;
};

/** Human tokens */
export type OdProtosOperatorServices_UpdateCoveragePodRequest_OperatorTokensInput = {
  values?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosOperatorServices_WorkAssignmentConfigFilterInput = {
  /** Filter out configurations of operators who no longer work with Opendoor */
  excludeDeactivatedOperatorConfigs?: InputMaybe<Scalars['Boolean']>;
  /** Market restrictions */
  markets?: InputMaybe<Array<OdProtosCommonMarket_Market>>;
  /**
   * all configurations of operators in list, or all operators
   * in reporting hierarchy of given manager
   */
  operatorFilter?: InputMaybe<OdProtosOperatorServices_WorkAssignmentConfigFilter_OperatorFilterOneofInput>;
  /** Region restrictions - region identifiers from Fence */
  regions?: InputMaybe<Array<Scalars['String']>>;
  /** Type of work */
  workCategories?: InputMaybe<Array<OdProtosOperatorData_WorkCategory>>;
};

export type OdProtosOperatorServices_WorkAssignmentConfigFilter_HumanTokensInput = {
  values?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosOperatorServices_WorkAssignmentConfigFilter_OperatorFilterOneofInput = {
  humanTokens?: InputMaybe<OdProtosOperatorServices_WorkAssignmentConfigFilter_HumanTokensInput>;
  managerToken?: InputMaybe<Scalars['String']>;
};

/** Next ID: 5 */
export type OdProtosOstiaryServices_CheckRiskProhibitedRegionRequestInput = {
  latitude?: InputMaybe<Scalars['Float']>;
  longitude?: InputMaybe<Scalars['Float']>;
  requestId?: InputMaybe<OdProtosCommon_RequestIdInput>;
  requestorId?: InputMaybe<OdProtosCommon_RequestorIdInput>;
};

export type OdProtosOstiaryServices_CheckRiskProhibitedRegionResponse_Error_Code =
  | 'INVALID_ARGUMENT'
  | 'UNKNOWN';

export type OdProtosOutreachData_OrvaSchedulingOutcomeType =
  | 'LEFT_VM_OR_TEXT'
  | 'NOT_ELIGIBLE'
  | 'NOT_INTERESTED'
  | 'NO_ANSWER'
  | 'ORVA_COMPLETED'
  | 'ORVA_SCHEDULED'
  | 'SKIPPED'
  | 'UNKNOWN'
  | 'VERBALLY_AGREED_TO_SSVA';

export type OdProtosOutreachServices_GetNextOutreachRequestInput = {
  bucketId?: InputMaybe<Scalars['String']>;
};

export type OdProtosOutreachServices_GetOutcomesCountSinceRequestInput = {
  bucketId?: InputMaybe<Scalars['String']>;
  since?: InputMaybe<Scalars['String']>;
};

export type OdProtosOutreachServices_PaginatedUserOutreachesRequestInput = {
  paginationRequest?: InputMaybe<OdProtosCommonPagination_PaginationRequestInput>;
};

export type OdProtosOutreachServices_RecordOutreachOutcomeRequestInput = {
  outcomeType?: InputMaybe<OdProtosOutreachServices_RecordOutreachOutcomeRequest_OutcomeTypeOneofInput>;
  outreachId?: InputMaybe<Scalars['String']>;
};

export type OdProtosOutreachServices_RecordOutreachOutcomeRequest_OutcomeTypeOneofInput = {
  orvaSchedulingOutcomeType?: InputMaybe<OdProtosOutreachData_OrvaSchedulingOutcomeType>;
};

export type OdProtosOxOxCommsData_AddressInput = {
  city?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<OdProtosCommonState_State>;
  street1?: InputMaybe<Scalars['String']>;
  street2?: InputMaybe<Scalars['String']>;
};

export type OdProtosOxOxCommsData_Communication_CommunicationType =
  | 'PHONE_CALL'
  | 'SMS_MESSAGE'
  | 'UNKNOWN_COMMUNICATION_TYPE';

export type OdProtosOxOxCommsData_Communication_Direction =
  | 'INBOUND'
  | 'OUTBOUND'
  | 'UNKNOWN_DIRECTION';

export type OdProtosOxOxCommsData_ContactInput = {
  address?: InputMaybe<OdProtosOxOxCommsData_AddressInput>;
  association?: InputMaybe<OdProtosOxOxCommsData_Contact_Association>;
  company?: InputMaybe<Scalars['String']>;
  emailAddresses?: InputMaybe<Array<OdProtosOxOxCommsData_EmailAddressInput>>;
  firstName?: InputMaybe<Scalars['String']>;
  gongUserId?: InputMaybe<Scalars['String']>;
  /** not using a foreign key to Directory here because we are decoupling from Web */
  humanToken?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  jobTitle?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  mlsIds?: InputMaybe<Array<OdProtosBrokeragesData_MlsidInput>>;
  needsReview?: InputMaybe<Scalars['Boolean']>;
  phoneNumbers?: InputMaybe<Array<OdProtosOxOxCommsData_PhoneNumberInput>>;
  realEstateLicenses?: InputMaybe<Array<OdProtosBrokeragesData_RealEstateLicenseInput>>;
  slackId?: InputMaybe<Scalars['String']>;
  voicemailGreetingRecordingId?: InputMaybe<Scalars['String']>;
};

/** which party does this Contact represent? */
export type OdProtosOxOxCommsData_Contact_Association =
  /** OX employee */
  | 'EMPLOYEE'
  /** non-OX Opendoor employee */
  | 'OPENDOOR'
  /** REIT partner */
  | 'PARTNER'
  /** any 3rd party involved in a transaction */
  | 'THIRD_PARTY'
  | 'UNKNOWN_ASSOCIATION';

export type OdProtosOxOxCommsData_EmailAddressInput = {
  address?: InputMaybe<Scalars['String']>;
  brokerageRegionIds?: InputMaybe<Array<Scalars['Float']>>;
  contactId?: InputMaybe<Scalars['String']>;
  emailAddressType?: InputMaybe<OdProtosOxOxCommsData_EmailAddress_EmailAddressType>;
  id?: InputMaybe<Scalars['String']>;
};

export type OdProtosOxOxCommsData_EmailAddress_EmailAddressType =
  | 'PERSONAL'
  | 'UNKNOWN_EMAIL_ADDRESS_TYPE'
  | 'WORK';

export type OdProtosOxOxCommsData_PhoneCall_Status =
  /** caller received a busy signal */
  | 'BUSY'
  /** call was answered and has ended normally */
  | 'COMPLETED'
  /** call could not be completed as dialed, most likely because the phone number was non-existent */
  | 'FAILED'
  /** call has been initiated but is not yet in progress */
  | 'INITIATED'
  /** call was answered and is currently in progress */
  | 'IN_PROGRESS'
  /** there was no answer or the call was rejected */
  | 'NO_ANSWER'
  /** call is ready and waiting in line before dialing */
  | 'QUEUED'
  /** call is currently ringing */
  | 'RINGING'
  | 'UNKNOWN_STATUS';

export type OdProtosOxOxCommsData_PhoneNumberInput = {
  brokerageRegionIds?: InputMaybe<Array<Scalars['Float']>>;
  contactId?: InputMaybe<Scalars['String']>;
  /** formatted in US format, e.g. (415) 555-2671 */
  formattedNumber?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  /** must always be in E.164 format, e.g. +14155552671 */
  number?: InputMaybe<Scalars['String']>;
  numberExtension?: InputMaybe<Scalars['String']>;
  phoneType?: InputMaybe<OdProtosOxOxCommsData_PhoneNumber_PhoneNumberType>;
};

export type OdProtosOxOxCommsData_PhoneNumber_PhoneNumberType =
  /** market number provided by Twilio */
  | 'MARKET'
  | 'PERSONAL'
  | 'UNKNOWN_PHONE_NUMBER_TYPE'
  | 'WORK';

export type OdProtosOxOxCommsData_SmsMessage_Status =
  /** Twilio has received your API request to immediately send an outbound message */
  | 'ACCEPTED'
  /** the message was scheduled to be sent at a later time but was canceled. */
  | 'CANCELED'
  /** Twilio has received confirmation of outbound message delivery from the upstream carrier, and, where available, the destination handset */
  | 'DELIVERED'
  /** the outbound message failed to send */
  | 'FAILED'
  /** the message was created but sending is not yet in progress */
  | 'INITIATED'
  /** the Twilio API request to send a message was successful and the message is queued to be sent out */
  | 'QUEUED'
  /** the message was received */
  | 'RECEIVED'
  /** the inbound message was received by Twilio and is currently being processed */
  | 'RECEIVING'
  /** the message has been scheduled to be sent at a later time */
  | 'SCHEDULED'
  /** Twilio is dispatching the outbound message to the nearest upstream carrier in the network */
  | 'SENDING'
  /** the nearest upstream carrier accepted the outbound message */
  | 'SENT'
  /** Twilio received a delivery receipt indicating that the outbound message was not delivered */
  | 'UNDELIVERED'
  | 'UNKNOWN_STATUS';

export type OdProtosOxOxCommsServices_CreateContactRequestInput = {
  /** authorize transfer of phone numbers/email addresses from another contact to this one */
  authorizeTransfers?: InputMaybe<Scalars['Boolean']>;
  contact?: InputMaybe<OdProtosOxOxCommsData_ContactInput>;
};

export type OdProtosOxOxCommsServices_DeleteContactRequestInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type OdProtosOxOxCommsServices_GetCommunicationsForContactRequestInput = {
  contactId?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<OdProtosOxOxCommsServices_GetCommunicationsForContactRequest_FiltersInput>;
  paginationRequest?: InputMaybe<OdProtosCommonPagination_PaginationRequestInput>;
};

export type OdProtosOxOxCommsServices_GetCommunicationsForContactRequest_FiltersInput = {
  /** choose SMS or phone call. If not set, all types are returned */
  communicationType?: InputMaybe<OdProtosOxOxCommsData_Communication_CommunicationType>;
  /** if set, only communications between the currently viewed contact and the participant are returned */
  participantContactId?: InputMaybe<Scalars['String']>;
};

export type OdProtosOxOxCommsServices_GetCommunicationsRequestInput = {
  ids?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosOxOxCommsServices_GetContactByEmailAddressRequestInput = {
  emailAddress?: InputMaybe<Scalars['String']>;
};

export type OdProtosOxOxCommsServices_GetContactRequestInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type OdProtosOxOxCommsServices_GetContactsRequestInput = {
  ids?: InputMaybe<Array<Scalars['String']>>;
};

/** returns all contacts that have communicated with the participant */
export type OdProtosOxOxCommsServices_GetParticipantContactsRequestInput = {
  participantContactId?: InputMaybe<Scalars['String']>;
};

export type OdProtosOxOxCommsServices_GetRecordingsRequestInput = {
  ids?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosOxOxCommsServices_MakePhoneCallRequestInput = {
  /** this will be the PhoneCall id */
  id?: InputMaybe<Scalars['String']>;
  recipientPhoneNumberId?: InputMaybe<Scalars['String']>;
  /** must be a display (aka market) number */
  senderPhoneNumberId?: InputMaybe<Scalars['String']>;
};

export type OdProtosOxOxCommsServices_RecordVoicemailGreetingRequestInput = {
  /** the contact to record a new voicemail greeting for */
  contactId?: InputMaybe<Scalars['String']>;
  /** this will be the id of the PhoneCall used to record the greeting */
  id?: InputMaybe<Scalars['String']>;
};

export type OdProtosOxOxCommsServices_SearchContactsRequestInput = {
  paginationRequest?: InputMaybe<OdProtosCommonPagination_PaginationRequestInput>;
  searchText?: InputMaybe<Scalars['String']>;
};

export type OdProtosOxOxCommsServices_SendSmsMessageRequestInput = {
  body?: InputMaybe<Scalars['String']>;
  /** this will be the SmsMessage id */
  id?: InputMaybe<Scalars['String']>;
  recipientPhoneNumberId?: InputMaybe<Scalars['String']>;
  /** must be a display (aka market) number */
  senderPhoneNumberId?: InputMaybe<Scalars['String']>;
};

export type OdProtosOxOxCommsServices_UpdateContactRequestInput = {
  /** authorize transfer of phone numbers/email addresses from another contact to this one */
  authorizeTransfers?: InputMaybe<Scalars['Boolean']>;
  contact?: InputMaybe<OdProtosOxOxCommsData_ContactInput>;
  fieldMask?: InputMaybe<GoogleProtobuf_FieldMaskInput>;
  /** merge this contact into the updated contact */
  mergeInContactId?: InputMaybe<Scalars['String']>;
};

/** This will move to a common ox location in the future */
export type OdProtosOxOxUsersData_OxNameInput = {
  value?: InputMaybe<Scalars['String']>;
};

/** Permissions */
export type OdProtosOxOxUsersData_Permissions =
  | 'ADMIN'
  | 'ADVANCED_UI_FEATURES'
  | 'AGENT_OPERATOR_READ'
  | 'AGENT_OPERATOR_WRITE'
  | 'API_DOCUMENTATION_READ'
  | 'BUYBOX_READ'
  | 'BUYBOX_WRITE'
  | 'ELIGIBLE_PRODUCTS_READ'
  | 'ELIGIBLE_PRODUCTS_WRITE'
  | 'KEY_TERMS_READ'
  | 'KEY_TERMS_WRITE'
  | 'MANUAL_BID_UPLOAD_READ'
  | 'MANUAL_BID_UPLOAD_WRITE'
  | 'MLS_READ'
  | 'PARTICIPANTS_READ'
  | 'PARTICIPANTS_WRITE'
  | 'PIPELINE_READ'
  | 'PIPELINE_WRITE'
  | 'RESALE_READ'
  | 'RESALE_WRITE'
  | 'SETTINGS_READ'
  | 'SETTINGS_WRITE'
  | 'TASK_CONFIG_READ'
  | 'TASK_CONFIG_WRITE'
  | 'TASK_READ'
  | 'TASK_WRITE'
  | 'UNKNOWN_PERMISSION';

export type OdProtosOxOxUsersServices_AddMemberRequestInput = {
  organizationId?: InputMaybe<Scalars['String']>;
  roleTypes?: InputMaybe<Array<Scalars['String']>>;
  userId?: InputMaybe<OdProtosOxOxUsersData_OxNameInput>;
};

export type OdProtosOxOxUsersServices_AddOrganizationRoleRequestInput = {
  organizationId?: InputMaybe<Scalars['String']>;
  roleName?: InputMaybe<Scalars['String']>;
  roleType?: InputMaybe<Scalars['String']>;
};

export type OdProtosOxOxUsersServices_CreateOrganizationRequestInput = {
  email?: InputMaybe<Scalars['String']>;
  emailDomains?: InputMaybe<Array<Scalars['String']>>;
  name?: InputMaybe<Scalars['String']>;
  primaryContactEmail?: InputMaybe<Scalars['String']>;
  primaryContactFirstName?: InputMaybe<Scalars['String']>;
  primaryContactLastName?: InputMaybe<Scalars['String']>;
};

export type OdProtosOxOxUsersServices_CreateUserRequestInput = {
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
};

export type OdProtosOxOxUsersServices_GetOrganizationByIdRequestInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type OdProtosOxOxUsersServices_GetOrganizationsByEmailRequestInput = {
  email?: InputMaybe<Scalars['String']>;
};

export type OdProtosOxOxUsersServices_GetUserByEmailRequestInput = {
  email?: InputMaybe<Scalars['String']>;
};

export type OdProtosOxOxUsersServices_GetUserByIdRequestInput = {
  userId?: InputMaybe<OdProtosOxOxUsersData_OxNameInput>;
};

export type OdProtosOxOxUsersServices_GetUserEventsRequestInput = {
  userId?: InputMaybe<OdProtosOxOxUsersData_OxNameInput>;
};

export type OdProtosOxOxUsersServices_RemoveMemberRequestInput = {
  organizationId?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<OdProtosOxOxUsersData_OxNameInput>;
};

export type OdProtosOxOxUsersServices_RemoveOrganizationRoleRequestInput = {
  organizationId?: InputMaybe<Scalars['String']>;
  roleType?: InputMaybe<Scalars['String']>;
};

export type OdProtosOxOxUsersServices_UpdateMemberRolesRequestInput = {
  organizationId?: InputMaybe<Scalars['String']>;
  roleTypes?: InputMaybe<Array<Scalars['String']>>;
  userId?: InputMaybe<OdProtosOxOxUsersData_OxNameInput>;
};

export type OdProtosOxOxUsersServices_UpdateOrganizationRequestInput = {
  id?: InputMaybe<Scalars['String']>;
  updates?: InputMaybe<OdProtosOxOxUsersServices_UpdateOrganizationRequest_UpdatesInput>;
};

export type OdProtosOxOxUsersServices_UpdateOrganizationRequest_UpdatesInput = {
  email?: InputMaybe<Scalars['String']>;
  emailDomains?: InputMaybe<Array<Scalars['String']>>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  primaryContactId?: InputMaybe<OdProtosOxOxUsersData_OxNameInput>;
};

export type OdProtosOxOxUsersServices_UpdateOrganizationRoleRequestInput = {
  roleId?: InputMaybe<Scalars['String']>;
  updates?: InputMaybe<OdProtosOxOxUsersServices_UpdateOrganizationRoleRequest_UpdatesInput>;
};

export type OdProtosOxOxUsersServices_UpdateOrganizationRoleRequest_UpdatesInput = {
  permissions?: InputMaybe<Array<OdProtosOxOxUsersData_Permissions>>;
  roleName?: InputMaybe<Scalars['String']>;
  roleType?: InputMaybe<Scalars['String']>;
};

export type OdProtosOxOxUsersServices_UpdateUserRequestInput = {
  id?: InputMaybe<OdProtosOxOxUsersData_OxNameInput>;
  updates?: InputMaybe<OdProtosOxOxUsersServices_UpdateUserRequest_UpdatesInput>;
};

export type OdProtosOxOxUsersServices_UpdateUserRequest_UpdatesInput = {
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Scalars['String']>;
};

/**
 * The billing type determines when final payment eligibility is reported and payouts are made
 * Next ID: 3
 */
export type OdProtosPartnershipData_BillingType =
  /** Billed via a monthly invoicing process */
  | 'INVOICE'
  /** Billed on as part of transaction closing process */
  | 'PER_TRANSACTION'
  | 'UNKNOWN_BILLING_TYPE';

/** Delivery parameters for a future offer */
export type OdProtosPartnershipData_CommunicationDetailsInput = {
  /**
   * Specifies the time the offer should be delivered to the customer.
   * Specified in milliseconds of UTC time since Unix epoch.
   */
  offerDeliveryTime?: InputMaybe<Scalars['Float']>;
};

/**
 * References contact information for a customer or partner.
 * Next ID: 5
 */
export type OdProtosPartnershipData_CustomerDetailsInput = {
  email?: InputMaybe<Scalars['String']>;
  fullName?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/**
 * DirectoryOrg defines the fields and children orgs needed to create an org in the Directory service.
 * It also included metadata tracked by the partnership service
 *
 * Next ID: 5
 */
export type OdProtosPartnershipData_DirectoryOrgInput = {
  /** Immediate children of this organization */
  children?: InputMaybe<Array<OdProtosPartnershipData_DirectoryOrgInput>>;
  /** Required to create an org in the Directory service */
  email?: InputMaybe<Scalars['String']>;
  /** Metadata that is provided for the leaf nodes of the organization hierarchy */
  metadata?: InputMaybe<OdProtosPartnershipData_MetadataInput>;
  /** Relevant name at the given partner organization hierarchy level */
  name?: InputMaybe<Scalars['String']>;
};

/** Next ID: 2 */
export type OdProtosPartnershipData_DocumentType =
  | 'INVOICE_DOCUMENT_TYPE'
  | 'UNKNOWN_DOCUMENT_TYPE';

/** Next ID: 2 */
export type OdProtosPartnershipData_InboundBuyerReferral_Source =
  | 'PARTNER_LISTING_LINK'
  | 'PARTNER_PRELISTED_LINK'
  | 'UNKNOWN';

/** Next ID: 2 */
export type OdProtosPartnershipData_LoyaltyEvent_EventType =
  /** Used for an event associated with an offer close */
  | 'OFFER_CLOSE'
  | 'UNKNOWN_EVENT_TYPE';

/** Next ID: 3 */
export type OdProtosPartnershipData_LoyaltyEvent_Source =
  /** Used for an event associated with an acquisition offer */
  | 'ACQUISITION_OFFER'
  /** Used for an event associated with a resale offer */
  | 'RESALE_OFFER'
  | 'UNKNOWN_EVENT_SOURCE';

/**
 * Metadata contains various additional details about a DirectoryOrg that the partnership service tracks
 *
 * Next ID: 5
 */
export type OdProtosPartnershipData_MetadataInput = {
  city?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  street?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
};

/**
 * Possible sources of an offer request
 * Next ID: 4
 */
export type OdProtosPartnershipData_Offer_Source =
  | 'CUSTOMER'
  | 'PARTNER'
  | 'SYSTEM'
  | 'UNKNOWN_OFFER_SOURCE';

/**
 * Specifies the current state of an outbound buyer referral tour request
 * Next ID: 6
 */
export type OdProtosPartnershipData_OutboundBuyerReferralTourRequest_State =
  | 'CANCELED'
  | 'COMPLETE'
  | 'NO_SHOW'
  | 'REQUESTED'
  | 'SCHEDULED'
  | 'UNKNOWN_STATE';

/**
 * Specifies the current state of an outbound buyer referral
 * Next ID: 6
 */
export type OdProtosPartnershipData_OutboundBuyerReferral_State =
  | 'CLOSED'
  | 'INTERESTED'
  | 'IN_CONTRACT'
  | 'NOT_MOVING_FORWARD'
  | 'TOURING'
  | 'UNKNOWN_STATE';

/** Next ID: 9 */
export type OdProtosPartnershipData_PartnerBranchInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  displayName?: InputMaybe<Scalars['String']>;
  internalOrganizationId?: InputMaybe<Scalars['String']>;
  partnerIdentifier?: InputMaybe<Scalars['String']>;
  regionIdentifier?: InputMaybe<Scalars['String']>;
  salesAssociateEmails?: InputMaybe<Array<Scalars['String']>>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** Next ID: 7 */
export type OdProtosPartnershipData_PartnerBranchMemberInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  partnerBranchUuid?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  userId?: InputMaybe<Scalars['String']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/**
 * Seller input that is coming from an external partner.
 * Next ID: 10
 */
export type OdProtosPartnershipData_PartnerSellerInputInput = {
  /** Details about the home that are not included in protobuf/home-data-store/home_detail.proto */
  additionalHomeDetails?: InputMaybe<OdProtosHomeDataStore_PartnershipAdditionalHomeDetailsInput>;
  /** Casa address of the property */
  casaAddress?: InputMaybe<OdProtosCasaData_AddressInput>;
  /** Specifies some communication parameters */
  communicationDetails?: InputMaybe<OdProtosPartnershipData_CommunicationDetailsInput>;
  /** Details about the home */
  homeDetails?: InputMaybe<OdProtosHomeDataStore_HomeDetailInput>;
  /** Specifies details of seller */
  inputSellerDetails?: InputMaybe<OdProtosPartnershipData_SellerDetailsInput>;
  /** Identifier of the partner */
  partnerIdentifier?: InputMaybe<Scalars['String']>;
  /** Contact information for referring party */
  referrerDetails?: InputMaybe<OdProtosPartnershipData_CustomerDetailsInput>;
  /**
   * Contact information for seller
   * Being deprecated in favor of CustomerDetails embedded in
   * input_seller_details field.
   */
  sellerDetails?: InputMaybe<OdProtosPartnershipData_CustomerDetailsInput>;
  /** Specifies the source of the referral for this seller input */
  source?: InputMaybe<OdProtosPartnershipData_Referral_Source>;
};

/** Next ID: 10 */
export type OdProtosPartnershipData_PartnerUserInput = {
  /** Email -- Their existing email with their company */
  email?: InputMaybe<Scalars['String']>;
  /** First Name */
  firstName?: InputMaybe<Scalars['String']>;
  /** The directory user token if one exists */
  id?: InputMaybe<Scalars['String']>;
  /** Last Name */
  lastName?: InputMaybe<Scalars['String']>;
  /** identifer of partner user is associated with ("" for independent user) */
  partnerIdentifier?: InputMaybe<Scalars['String']>;
  /** Phone number */
  phoneNumber?: InputMaybe<Scalars['String']>;
  /** The region identifier for the market that this user operates in */
  regionIdentifier?: InputMaybe<Scalars['String']>;
  /** Roles to assign to Membership */
  roles?: InputMaybe<Array<Scalars['String']>>;
};

/**
 * References the relationship between an Opendoor and the partner.
 * Next ID: 15
 */
export type OdProtosPartnershipData_PartnershipType =
  | 'AGENT_BROKERAGE'
  | 'AGENT_TECH_INTEGRATION'
  | 'CORPORATE_BENEFITS'
  | 'CREDIT_AND_DEBT'
  | 'HOME_BUILDER'
  | 'INDEPENDENT_DEVELOPER'
  | 'LENDER'
  | 'MARKETING'
  | 'MLS'
  | 'ONLINE_REAL_ESTATE'
  /** used as a catch-all partnership type */
  | 'OTHERS'
  | 'REAL_ESTATE_AGENCY'
  | 'REIT'
  /** used internally only for creating test partners */
  | 'TEST_PARTNER'
  | 'UNKNOWN';

/**
 * The payable conditions determine which conditions must be met in order for the referral to be payable to the partner.
 * Next ID: 9
 */
export type OdProtosPartnershipData_PayableConditions =
  | 'CHECK_FOR_ASSOCIATED_AGENT'
  | 'CHECK_FOR_ASSOCIATED_API_PARTNER'
  | 'CHECK_FOR_ASSOCIATED_ORE'
  | 'CUSTOMER_MATCH'
  | 'EMAIL_MATCH'
  | 'HANDOVER_BEFORE_OFFER_VIEWED'
  | 'REFERRAL_INITIATED_AT_HANDOVER'
  | 'TWO_WEEK_ELIGIBILITY_LOCK'
  | 'UNKNOWN_PAYABLE_CONDITION';

/**
 * A payable conversion event that we might pay partners for
 * Next ID: 7
 */
export type OdProtosPartnershipData_PayableEvent =
  | 'ACQ_CLOSED_WITH_RESALE'
  | 'AGENT_ACCESS_BONUS'
  | 'CLOSED_SALE'
  | 'OFFER_VIEWED'
  | 'QUALIFIED_LEAD'
  | 'RESALE_CLOSED_SALE'
  | 'UNKNOWN_EVENT';

/**
 * A payment agreement models a payment contract terms established with a given partner
 * Next ID: 26
 */
export type OdProtosPartnershipData_PaymentAgreementInput = {
  activatedAt?: InputMaybe<Scalars['DateTime']>;
  activatedBy?: InputMaybe<Scalars['String']>;
  archivedAt?: InputMaybe<Scalars['DateTime']>;
  archivedBy?: InputMaybe<Scalars['String']>;
  attributionType?: InputMaybe<OdProtosPartnershipData_Referral_AttributionType>;
  billingType?: InputMaybe<OdProtosPartnershipData_BillingType>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  partnerIdentifier?: InputMaybe<Scalars['String']>;
  payableConditions?: InputMaybe<Array<OdProtosPartnershipData_PayableConditions>>;
  payableEvent?: InputMaybe<OdProtosPartnershipData_PayableEvent>;
  paymentAgreementTiers?: InputMaybe<Array<OdProtosPartnershipData_PaymentAgreementTierInput>>;
  paymentType?: InputMaybe<OdProtosPartnershipData_PaymentType>;
  product?: InputMaybe<OdProtosSellCommon_Product>;
  sendCommissionInstruction?: InputMaybe<Scalars['Boolean']>;
  state?: InputMaybe<OdProtosPartnershipData_PaymentAgreement_State>;
  termConversionWindowDays?: InputMaybe<Scalars['Float']>;
  termPayOnDetachedLead?: InputMaybe<Scalars['Boolean']>;
  termPreviousRequestDays?: InputMaybe<Scalars['Float']>;
  termUniqueLeadType?: InputMaybe<OdProtosPartnershipData_UniqueLeadType>;
  tierType?: InputMaybe<OdProtosPartnershipData_TierType>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/**
 * A payment agreement tier includes the payout details for a given payment agreement
 * Next ID: 11
 */
export type OdProtosPartnershipData_PaymentAgreementTierInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  minimumPoints?: InputMaybe<Scalars['Float']>;
  paymentAgreementUuid?: InputMaybe<Scalars['String']>;
  paymentFlatRate?: InputMaybe<Scalars['Float']>;
  paymentPercentageBasis?: InputMaybe<Scalars['Float']>;
  points?: InputMaybe<Scalars['Float']>;
  tierCondition?: InputMaybe<OdProtosPartnershipData_TierCondition>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** Next ID: 4 */
export type OdProtosPartnershipData_PaymentAgreement_State =
  | 'ACTIVE'
  | 'ARCHIVED'
  | 'DRAFT'
  | 'UNKNOWN';

/**
 * Reason why a referral payment is or is not payable
 * Next ID: 22
 */
export type OdProtosPartnershipData_PaymentEligibilityReason =
  | 'AGENT_ATTRIBUTION_AFTER_FINAL_OFFER'
  | 'ALL_CHECKS_PASSED'
  | 'ALREADY_PAID'
  | 'CUSTOMER_MATCH_FAILED'
  | 'DETACHED_LEAD'
  | 'ELA_TAKEBACK'
  | 'EMAIL_MATCH_FAILED'
  | 'INELIGIBLE_ASSOCIATED_AGENT'
  | 'IS_HOMEOWNER'
  | 'IS_LISTED'
  | 'OD_DIRECT_PYMT_INELIGIBLE_IN_SELL_WITH_UPSIDE'
  | 'OFFER_NOT_VIEWED'
  | 'OFFER_WITHDRAWN'
  | 'OUTSIDE_CONVERSION_WINDOW'
  | 'OVERRIDDEN'
  | 'PREVIOUS_OFFER_REQUEST'
  | 'RECENT_DELISTED_ADDRESS'
  | 'REFERRAL_HANDOVER_NOT_BEFORE_VIEW'
  | 'REFERRAL_NOT_ACCEPTED'
  | 'UNENROLLED_SELL_WITH_UPSIDE'
  | 'UNKNOWN_REASON';

/**
 * The payment type determines how a referral payment value should be calculated
 * Next ID: 6
 */
export type OdProtosPartnershipData_PaymentType =
  /** For SwU, we pay a flat fee and percentage of cash advance */
  | 'COMBINED_FLAT_AND_PERCENT_OF_SWU'
  /** Flat fee paid on a given lead's conversion event */
  | 'FLAT'
  /** In the case of closed_sale, we pay 1-1.5% of headline price */
  | 'PERCENT_OF_HEADLINE'
  /** In the case of SwU offer closed, we pay on percentage of cash advance */
  | 'PERCENT_OF_HEADLINE_OR_SWU_ADVANCE'
  /** In the case of resale closed, we pay on percentage of closed listing offer */
  | 'PERCENT_OF_RESALE_PRICE'
  | 'UNKNOWN_PAYMENT_TYPE';

/**
 * Acceptance status of a referral invitation by the invitee
 *
 * Next ID: 3
 */
export type OdProtosPartnershipData_ReferralInvitationAcceptanceStatus =
  | 'ACCEPTED'
  | 'DECLINED'
  | 'PENDING';

/** Next ID: 4 */
export type OdProtosPartnershipData_ReferralPayment_Source =
  /** The default source used on records created by default process */
  | 'DEFAULT'
  /** Used on records created from initial backfill of payment data into partnership db */
  | 'INITIAL_BACKFILL'
  /** Used on records the are modified manually by eng or ops */
  | 'MANUAL_OVERRIDE'
  | 'UNKNOWN_SOURCE';

/** Next ID: 4 */
export type OdProtosPartnershipData_ReferralPayment_State =
  /** Used once a payable (conversion) event has occured */
  | 'CONVERTED'
  /** Used after referral_payment record is created, for most payable events this state is transitory */
  | 'PROJECTED'
  /** Transitions to reported state after a billing report is generated or a transaction closes, depending on billing type */
  | 'REPORTED'
  | 'UNKNOWN_STATE';

/**
 * Attributes contains additional information regarding a referral. Intended to store
 * details and fields that might be subject to change.
 *
 * Next ID: 15
 */
export type OdProtosPartnershipData_Referral_AttributesInput = {
  /** Whether agent is attributed to referral prior to final offer */
  agentAttributedByFinalOffer?: InputMaybe<Scalars['Boolean']>;
  /** Real estate license, used for agent referrals */
  agentRealEstateLicenseNumber?: InputMaybe<Scalars['String']>;
  /** Real estate license state, used for agent referrals */
  agentRealEstateLicenseState?: InputMaybe<Scalars['String']>;
  /** Brokerage address, used for agent referrals */
  brokerageAddress?: InputMaybe<Scalars['String']>;
  /** Brokerage name, used for agent referrals */
  brokerageName?: InputMaybe<Scalars['String']>;
  /** Time an attempt to update the ELA action was made */
  elaActionUpdated?: InputMaybe<Scalars['DateTime']>;
  /** Time an ELA assignment was passed back to the partner */
  elaPassbackDate?: InputMaybe<Scalars['DateTime']>;
  /** Token of the external listing associated with the referral */
  elaResaleFlipToken?: InputMaybe<Scalars['String']>;
  /** Time an ELA assignment was taken back from the partner */
  elaTakebackDate?: InputMaybe<Scalars['DateTime']>;
  /** Tracks whether the referral is eligible for a agent referral payment. Not intended to track referral payments generally. */
  eligibleForAgentReferralPayment?: InputMaybe<Scalars['Boolean']>;
  /** Time the offer was requested using the partner API */
  offerRequestedAt?: InputMaybe<Scalars['String']>;
  /** Used to store the name of the other_builder partner when provided by the customer. */
  otherBuilderName?: InputMaybe<Scalars['String']>;
  /** Tracks whether the referral has been handed over from a partner's site for the purposes of payment eligibility */
  referralHandoverOccurredAt?: InputMaybe<Scalars['String']>;
  /** Used to store a sales associate email provided by a customer when the sales associate does not yet have a human record */
  unknownSalesAssociateEmail?: InputMaybe<Scalars['String']>;
  /** Array of webhook sent at timestamps */
  webhooksSentAt?: InputMaybe<Array<OdProtosPartnershipData_Referral_Attributes_WebhookSentAtInput>>;
};

/** Next ID: 3 */
export type OdProtosPartnershipData_Referral_Attributes_WebhookSentAtInput = {
  eventName?: InputMaybe<Scalars['String']>;
  webhookSentAt?: InputMaybe<Scalars['String']>;
};

/**
 * Exact attribution for this referral, i.e. referral type.
 *
 * Next ID: 3
 */
export type OdProtosPartnershipData_Referral_AttributionType =
  | 'REFERRAL'
  /** can add other attribution types in the future like NO_ATTRIBUTION or REPRESENTATION_NO_REFERRAL */
  | 'REPRESENTATION'
  | 'UNKNOWN_ATTRIBUTION';

/** Next ID: 6 */
export type OdProtosPartnershipData_Referral_SellerRelation =
  /** The seller is a client of the referrer */
  | 'CLIENT'
  /** The seller is a prospective client of the referrer */
  | 'POTENTIAL_CLIENT'
  /** The seller is not represented by referrer. Is only being referred */
  | 'REFEREE'
  /** the seller is being referred by invitation to Opendoor by the referrer. */
  | 'REFERRAL_BY_INVITATION'
  /** The referring party is representing themselves */
  | 'SELF'
  | 'UNKNOWN_RELATION';

/** Next ID: 10 */
export type OdProtosPartnershipData_Referral_Source =
  | 'ADMIN_OVERRIDE'
  | 'DETACHED_LEAD'
  | 'PARTNER_API'
  | 'REFERRAL_DASHBOARD'
  | 'REFERRAL_LINK'
  | 'SCRIPT'
  | 'SELLER_DISCLOSURES'
  | 'SELLER_FLOW'
  | 'TRACKING_KEYWORD'
  | 'UNKNOWN';

/** Next ID: 4 */
export type OdProtosPartnershipData_Report_State =
  /** The report is failed to be generated */
  | 'FAILED'
  /** The report is still in process of generating */
  | 'IN_PROGRESS'
  /** The report has successfully been generated and ready for download */
  | 'READY_TO_DOWNLOAD'
  | 'UNKNOWN';

/** Next ID: 13 */
export type OdProtosPartnershipData_ReportingSearchFiltersInput = {
  /** Search for leads with this casa address uuid */
  addressId?: InputMaybe<Scalars['String']>;
  /** This will be used to build the search_after field in the next query */
  after?: InputMaybe<Scalars['String']>;
  /** The direcion of the sort oder: 'asc' or 'desc' */
  direction?: InputMaybe<OdProtosPartnershipData_ReportingSearchFilters_Direction>;
  /** Search for leads created before the end_date */
  endDate?: InputMaybe<Scalars['DateTime']>;
  /** The field to order the results by */
  orderBy?: InputMaybe<OdProtosPartnershipData_ReportingSearchFilters_OrderBy>;
  /** Search for leads that match any of these markets */
  regionIdentifiers?: InputMaybe<Array<Scalars['String']>>;
  /** Search for leads with referrals that have a referrer with this user id */
  salesReferrerUserId?: InputMaybe<Scalars['String']>;
  /** The text search query to fuzzy match against address, customer, and sales referrer */
  searchQuery?: InputMaybe<Scalars['String']>;
  /** Will be passed as the `size` parameter in the elastic search query */
  size?: InputMaybe<Scalars['Float']>;
  /** Search for leads created after the start_date */
  startDate?: InputMaybe<Scalars['DateTime']>;
  /** Search for leads that match any of these lead states */
  states?: InputMaybe<Array<Scalars['String']>>;
  /** Search for leads that have been updated at any time since updated_since */
  updatedSince?: InputMaybe<Scalars['DateTime']>;
};

/**
 * The options for sort direction
 * Next ID: 2
 */
export type OdProtosPartnershipData_ReportingSearchFilters_Direction =
  | 'ASC'
  | 'DESC';

/**
 * The options for ordering sorted results
 * Next ID: 6
 */
export type OdProtosPartnershipData_ReportingSearchFilters_OrderBy =
  | 'CUSTOMER_NAME'
  | 'LEAD_CREATED'
  | 'OFFER_SENT'
  | 'PARTNER_DISPLAY_NAME'
  | 'REGION_IDENTIFIER'
  | 'SALES_REFERRER';

/**
 * Seller details for a given transaction.
 * Can represent one of a number of parties defined by relation fields.
 * Next ID: 4
 */
export type OdProtosPartnershipData_SellerDetailsInput = {
  agentRelationToSeller?: InputMaybe<OdProtosPartnershipData_SellerDetails_AgentRelationToSeller>;
  customerContactDetails?: InputMaybe<OdProtosPartnershipData_CustomerDetailsInput>;
  sellerRelationToOwner?: InputMaybe<OdProtosPartnershipData_SellerDetails_SellerRelationToOwner>;
};

export type OdProtosPartnershipData_SellerDetails_AgentRelationToSeller =
  | 'AGENT_SELF'
  | 'CLIENT'
  | 'POTENTIAL_CLIENT'
  | 'REFEREE'
  | 'UNKNOWN_AGENT_RELATION';

export type OdProtosPartnershipData_SellerDetails_SellerRelationToOwner =
  | 'AGENT'
  | 'SELLER_SELF'
  | 'UNKNOWN_SELLER_RELATION';

/**
 * The tier condition is the condition that be met in order for the referral to be eligible for that payment agreement tier.
 * Next ID: 7
 */
export type OdProtosPartnershipData_TierCondition =
  | 'AGENT_REPRESENTED'
  | 'AGENT_UNREPRESENTED'
  | 'ELA_ASSIGNED'
  | 'ELA_UNASSIGNED'
  | 'ENROLLED_SELL_WITH_UPSIDE'
  | 'NOT_ENROLLED_SELL_WITH_UPSIDE'
  | 'NO_CONDITION';

/**
 * The tier type determines the type of payment agreement tier and how to evaluate which active payment_agreement_tier to use
 * Next ID: 7
 */
export type OdProtosPartnershipData_TierType =
  | 'AGENT_ACCESS_TIER'
  /** tier depends on whether the buyer is represented */
  | 'BUYER_REPRESENTATION_TIER'
  /** tier depends on whether there is an active partner ELA attached to the referral */
  | 'ELA_TIER'
  /** tier depends on which market the partner is in */
  | 'MARKET_TIER'
  | 'NO_TIER_TYPE'
  /** tier depends on how many closed offers the partner has */
  | 'OFFER_CLOSED_COUNT_TIER'
  /** tier depends on whether enrolled in SwU */
  | 'SWU_TIER';

/**
 * States for underwriting
 * Next ID: 6
 */
export type OdProtosPartnershipData_Underwriting_State =
  | 'APPROVED'
  | 'COMPLETED'
  | 'DRAFT'
  | 'ESCALATED'
  | 'UNKNOWN_STATE'
  | 'WALKED';

/**
 * The unique lead type determines which duplicate payment rule is used in the eligibility process
 * Next ID: 2
 */
export type OdProtosPartnershipData_UniqueLeadType =
  | 'ADDRESS'
  | 'NONE';

/** Next ID: 2 */
export type OdProtosPartnershipServices_AcceptReferralInvitationRequestInput = {
  invitationId?: InputMaybe<Scalars['String']>;
};

/** Next ID: 2 */
export type OdProtosPartnershipServices_ActivatePaymentAgreementRequestInput = {
  uuid?: InputMaybe<Scalars['String']>;
};

/** Next ID: 2 */
export type OdProtosPartnershipServices_ActivatePaymentAgreementTierRequestInput = {
  uuid?: InputMaybe<Scalars['String']>;
};

/** Next ID: 2 */
export type OdProtosPartnershipServices_ArchivePaymentAgreementRequestInput = {
  uuid?: InputMaybe<Scalars['String']>;
};

/** Next ID: 2 */
export type OdProtosPartnershipServices_AuthenticatePartnerByTokenRequestInput = {
  /** Auth token that uniquely identifies a partner */
  token?: InputMaybe<Scalars['String']>;
};

/** Next ID: 2 */
export type OdProtosPartnershipServices_BulkCreatePartnerUsersRequestInput = {
  /** List of all partner users */
  partnerUsers?: InputMaybe<Array<OdProtosPartnershipData_PartnerUserInput>>;
};

/** Next ID: 2 */
export type OdProtosPartnershipServices_BulkGetReferralsForSellerInputsRequestInput = {
  sellerInputs?: InputMaybe<Array<OdProtosPartnershipServices_GetReferralsForSellerInputRequestInput>>;
};

/** Next ID: 4 */
export type OdProtosPartnershipServices_CheckProductsEligibilityRequestInput = {
  /** Casa Address ID */
  addressId?: InputMaybe<Scalars['String']>;
  /** optional -- only needed if checking product eligibility for an external partner */
  partnerIdentifier?: InputMaybe<Scalars['String']>;
  /** Products for which to check eligibility */
  products?: InputMaybe<Array<OdProtosSellCommon_Product>>;
};

/** Next ID: 4 */
export type OdProtosPartnershipServices_ClaimInboundBuyerReferralsForListingOfferRequestInput = {
  customerIds?: InputMaybe<Array<Scalars['String']>>;
  listingOfferId?: InputMaybe<Scalars['String']>;
};

/** Next ID: 18 */
export type OdProtosPartnershipServices_CreateOrUpdateReferralForSellerInputRequestInput = {
  /** Optional -- the attributes data on the referral */
  attributes?: InputMaybe<OdProtosPartnershipData_Referral_AttributesInput>;
  /** Mask of attributes fields to update. An empty mask means to update all fields. */
  attributesMask?: InputMaybe<GoogleProtobuf_FieldMaskInput>;
  attributionType?: InputMaybe<OdProtosPartnershipData_Referral_AttributionType>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** Optional -- Identifier for an external object in a partner's system */
  externalTrackingId?: InputMaybe<Scalars['String']>;
  leadToken?: InputMaybe<Scalars['String']>;
  /** Optional -- Organization from Directory for this referral */
  organizationId?: InputMaybe<Scalars['String']>;
  /** Unique identifier for the partnership associated with this referral */
  partnerIdentifier?: InputMaybe<Scalars['String']>;
  /** Referral type for the partnership */
  partnershipType?: InputMaybe<OdProtosPartnershipData_PartnershipType>;
  /** Fence region identifier for the address on the seller input */
  regionIdentifier?: InputMaybe<Scalars['String']>;
  /**
   * Seller input of the initial related referral for detached lead,
   * e.g. when a referred customer starts a new lead via the core flow.
   */
  rootSellerInputId?: InputMaybe<Scalars['String']>;
  /** Seller Input ID for the customer being referred */
  sellerInputId?: InputMaybe<Scalars['String']>;
  /** Optional -- Relation the seller has to the referrer */
  sellerRelation?: InputMaybe<OdProtosPartnershipData_Referral_SellerRelation>;
  /** Optional -- Source the referral came from */
  source?: InputMaybe<OdProtosPartnershipData_Referral_Source>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /**
   * Optional -- User email for this referral. Will be used to fetch a user from Directory. If none is found, this field
   * if ignored.
   */
  userEmail?: InputMaybe<Scalars['String']>;
  /** Optional -- User from Directory for this referral */
  userId?: InputMaybe<Scalars['String']>;
};

/** Next ID: 2 */
export type OdProtosPartnershipServices_CreatePartnerAuthTokenRequestInput = {
  partnerIdentifier?: InputMaybe<Scalars['String']>;
};

/** Next ID: 3 */
export type OdProtosPartnershipServices_CreatePartnerOrgHierarchyRequestInput = {
  /** List of children for the root organization */
  orgs?: InputMaybe<Array<OdProtosPartnershipData_DirectoryOrgInput>>;
  /** Root node partner identifier */
  rootPartnerIdentifier?: InputMaybe<Scalars['String']>;
};

/** Next ID: 9 */
export type OdProtosPartnershipServices_CreatePartnerRequestInput = {
  /** Display name of the partner being created */
  displayName?: InputMaybe<Scalars['String']>;
  /** Unique identifier for the partner being created */
  identifier?: InputMaybe<Scalars['String']>;
  /** Opendoor landing page for partner */
  landingPage?: InputMaybe<Scalars['String']>;
  /** Associated organization from Directory to be updated */
  organizationId?: InputMaybe<Scalars['String']>;
  /** Specifies the type of partnership this partner has with Opendoor */
  partnershipType?: InputMaybe<OdProtosPartnershipData_PartnershipType>;
  /** URL-safe string for partner */
  slug?: InputMaybe<Scalars['String']>;
  /** Marketing tracking keyword associated with a partner */
  trackingKeyword?: InputMaybe<Scalars['String']>;
  /** URL for the partner's webhook endpoint */
  webhookUrl?: InputMaybe<Scalars['String']>;
};

/** Next ID: 2 */
export type OdProtosPartnershipServices_CreatePartnerUserRequestInput = {
  /** The partner user to create */
  partnerUser?: InputMaybe<OdProtosPartnershipData_PartnerUserInput>;
};

/** Next ID: 2 */
export type OdProtosPartnershipServices_CreatePaymentAgreementRequestInput = {
  paymentAgreement?: InputMaybe<OdProtosPartnershipData_PaymentAgreementInput>;
};

/** Next ID: 2 */
export type OdProtosPartnershipServices_CreatePaymentAgreementTierRequestInput = {
  paymentAgreementTier?: InputMaybe<OdProtosPartnershipData_PaymentAgreementTierInput>;
};

/** Next ID: 14 */
export type OdProtosPartnershipServices_CreateReferralForSellerInputRequestInput = {
  /** The UUID of the address eligibility log to associate to this referral */
  addressEligibilityLogUuid?: InputMaybe<Scalars['String']>;
  /** Optional -- address ID of the referral address */
  addressId?: InputMaybe<Scalars['String']>;
  /** Optional -- Identifier for an external object in a partner's system */
  externalTrackingId?: InputMaybe<Scalars['String']>;
  leadToken?: InputMaybe<Scalars['String']>;
  /** Optional -- Organization from Directory for this referral */
  organizationId?: InputMaybe<Scalars['String']>;
  /** Unique identifier for the partnership associated with this referral */
  partnerIdentifier?: InputMaybe<Scalars['String']>;
  /** Referral type for the partnership */
  partnershipType?: InputMaybe<OdProtosPartnershipData_PartnershipType>;
  /** Fence region identifier for the address on the seller input */
  regionIdentifier?: InputMaybe<Scalars['String']>;
  /** Seller Input ID for the customer being referred */
  sellerInputId?: InputMaybe<Scalars['String']>;
  /** Optional -- Relation the seller has to the referrer */
  sellerRelation?: InputMaybe<OdProtosPartnershipData_Referral_SellerRelation>;
  /** Optional -- Source the referral came from */
  source?: InputMaybe<OdProtosPartnershipData_Referral_Source>;
  /** Optional -- User from Directory for this referral */
  userId?: InputMaybe<Scalars['String']>;
};

/** Next ID: 12 */
export type OdProtosPartnershipServices_CreateReferralRequestInput = {
  /** Optional -- Identifier for an external object in a partner's system */
  externalTrackingId?: InputMaybe<Scalars['String']>;
  leadToken?: InputMaybe<Scalars['String']>;
  /** Optional -- Organization from Directory for this referral */
  organizationId?: InputMaybe<Scalars['String']>;
  /** Unique identifier for the partnership associated with this referral */
  partnerIdentifier?: InputMaybe<Scalars['String']>;
  /** Type of the partnership this referral is coming from */
  partnershipType?: InputMaybe<OdProtosPartnershipData_PartnershipType>;
  /** Fence region identifier for the address on the seller input */
  regionIdentifier?: InputMaybe<Scalars['String']>;
  /** Seller Input ID for the customer being referred */
  sellerInputId?: InputMaybe<Scalars['String']>;
  /** Optional -- Relation the seller has to the referrer */
  sellerRelation?: InputMaybe<OdProtosPartnershipData_Referral_SellerRelation>;
  /** The source this referral is created from */
  source?: InputMaybe<OdProtosPartnershipData_Referral_Source>;
  /** Optional -- User from Directory for this referral */
  userId?: InputMaybe<Scalars['String']>;
};

/** Next ID: 6 */
export type OdProtosPartnershipServices_CreateReferralsFromTrackingKeywordsRequestInput = {
  /** Collection of tracking keywords */
  keywords?: InputMaybe<Array<Scalars['String']>>;
  leadToken?: InputMaybe<Scalars['String']>;
  /** Partner referral ID. */
  partnerReferralId?: InputMaybe<Scalars['String']>;
  /** Region identifier of the referral to create */
  regionIdentifier?: InputMaybe<Scalars['String']>;
  /** ID of the seller input */
  sellerInputId?: InputMaybe<Scalars['String']>;
};

/** Next ID: 5 */
export type OdProtosPartnershipServices_CreateReportRequestInput = {
  documentType?: InputMaybe<OdProtosPartnershipData_DocumentType>;
  endDate?: InputMaybe<Scalars['DateTime']>;
  partnerIdentifier?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
};

/** Next ID: 2 */
export type OdProtosPartnershipServices_CreateSellRequestRequestInput = {
  partnerSellerInput?: InputMaybe<OdProtosPartnershipData_PartnerSellerInputInput>;
};

/** Next ID: 7 */
export type OdProtosPartnershipServices_CreateSellRequestResponse_SellRequestError =
  | 'ERROR_CONTACT_INFO'
  | 'ERROR_HOME_ADDRESS'
  | 'ERROR_HOME_DETAILS'
  | 'ERROR_MISSING_MARKET'
  | 'ERROR_MISSING_PARTNER'
  | 'ERROR_NULL'
  | 'ERROR_REFERRAL';

/** Next ID: 2 */
export type OdProtosPartnershipServices_CreateSellerInputRequestInput = {
  partnerSellerInput?: InputMaybe<OdProtosPartnershipData_PartnerSellerInputInput>;
};

/** Next ID: 7 */
export type OdProtosPartnershipServices_CreateSellerInputResponse_SellerInputError =
  | 'ERROR_CONTACT_INFO'
  | 'ERROR_HOME_ADDRESS'
  | 'ERROR_HOME_DETAILS'
  | 'ERROR_MISSING_MARKET'
  | 'ERROR_MISSING_PARTNER'
  | 'ERROR_NULL'
  | 'ERROR_REFERRAL';

/** Next ID: 2 */
export type OdProtosPartnershipServices_DeactivatePartnerAuthTokenRequestInput = {
  token?: InputMaybe<Scalars['String']>;
};

/** Next ID: 2 */
export type OdProtosPartnershipServices_DeclineReferralInvitationRequestInput = {
  invitationId?: InputMaybe<Scalars['String']>;
};

/** Next ID: 3 */
export type OdProtosPartnershipServices_DeletePartnerWebhookUrlRequestInput = {
  /** Identifier of the partner to update */
  identifier?: InputMaybe<Scalars['String']>;
};

/** Next ID: 4 */
export type OdProtosPartnershipServices_DeleteReferralForSellerInputRequestInput = {
  leadToken?: InputMaybe<Scalars['String']>;
  /** Referral type for the partnership */
  partnershipType?: InputMaybe<OdProtosPartnershipData_PartnershipType>;
  /** Seller Input ID for the customer being referred */
  sellerInputId?: InputMaybe<Scalars['String']>;
};

/** Next ID: 3 */
export type OdProtosPartnershipServices_DeleteReferralLinkRequestInput = {
  partnerIdentifier?: InputMaybe<Scalars['String']>;
  userEmail?: InputMaybe<Scalars['String']>;
};

/** Next ID: 2 */
export type OdProtosPartnershipServices_GenerateDownloadableReportRequestInput = {
  searchFilters?: InputMaybe<OdProtosPartnershipData_ReportingSearchFiltersInput>;
};

/** Next ID: 3 */
export type OdProtosPartnershipServices_GenerateReferralLinkRequestInput = {
  email?: InputMaybe<Scalars['String']>;
  partnerIdentifier?: InputMaybe<Scalars['String']>;
};

/** Next ID: 5 */
export type OdProtosPartnershipServices_GetActivePaymentAgreementRequestInput = {
  attributionType?: InputMaybe<OdProtosPartnershipData_Referral_AttributionType>;
  partnerIdentifier?: InputMaybe<Scalars['String']>;
  payableEvent?: InputMaybe<OdProtosPartnershipData_PayableEvent>;
  product?: InputMaybe<OdProtosSellCommon_Product>;
};

/** Next ID: 2 */
export type OdProtosPartnershipServices_GetAgentReferralPaymentsBySellerInputIdRequestInput = {
  sellerInputId?: InputMaybe<Scalars['String']>;
};

/** Next ID: 2 */
export type OdProtosPartnershipServices_GetDownloadableReportRequestInput = {
  reportRunId?: InputMaybe<Scalars['String']>;
};

/** Next ID: 4 */
export type OdProtosPartnershipServices_GetEmbeddableReportsRequestInput = {
  endDate?: InputMaybe<Scalars['DateTime']>;
  /** Contains query parameters for param_market_name, which will be appended to an embeddable URL */
  marketNameQueryParameters?: InputMaybe<Array<Scalars['String']>>;
  startDate?: InputMaybe<Scalars['DateTime']>;
};

/** Next ID: 3 */
export type OdProtosPartnershipServices_GetExistingReferralsForTrackingIdRequestInput = {
  /** Tracking Identifier for partner's referral */
  externalTrackingId?: InputMaybe<Scalars['String']>;
  /** Unique identifier for the partnership associated with this referral */
  partnerIdentifier?: InputMaybe<Scalars['String']>;
};

/** Next ID: 2 */
export type OdProtosPartnershipServices_GetInboundBuyerReferralsForListingOfferRequestInput = {
  listingOfferId?: InputMaybe<Scalars['String']>;
};

/** Next ID: 4 */
export type OdProtosPartnershipServices_GetLeadStatusStringMappingRequestInput = {
  denialReason?: InputMaybe<OdProtosSellCommon_DenialReason>;
  leadState?: InputMaybe<OdProtosSellSellerData_ProductOffering_State>;
  offerState?: InputMaybe<OdProtosSellSellerData_Offer_State>;
};

/** Next ID: 2 */
export type OdProtosPartnershipServices_GetLoyaltyEventRequestInput = {
  /** The id of an event external to the system, e.g. ListingOffer uuid or OpendoorDirectOffer uuid */
  foreignEventUuid?: InputMaybe<Scalars['String']>;
};

/** Next ID: 3 */
export type OdProtosPartnershipServices_GetLoyaltyPointsAndPayoutByCustomerRequestInput = {
  /** The Custard customer uuid */
  customerUuid?: InputMaybe<Scalars['String']>;
  /** The id of an event external to the system, e.g. ListingOffer uuid or OpendoorDirectOffer uuid */
  foreignEventUuid?: InputMaybe<Scalars['String']>;
};

/** Next ID: 2 */
export type OdProtosPartnershipServices_GetOutboundBuyerReferralRequestInput = {
  uuid: Scalars['ID'];
};

/** Next ID: 2 */
export type OdProtosPartnershipServices_GetOutboundBuyerReferralsRequestInput = {
  input?: InputMaybe<OdProtosPartnershipServices_GetOutboundBuyerReferralsRequest_InputOneofInput>;
};

export type OdProtosPartnershipServices_GetOutboundBuyerReferralsRequest_InputOneofInput = {
  partnerIdentifier?: InputMaybe<Scalars['String']>;
  salesRepresentativeId?: InputMaybe<Scalars['String']>;
};

/** Next ID: 2 */
export type OdProtosPartnershipServices_GetPartnerAuthTokensRequestInput = {
  partnerIdentifier?: InputMaybe<Scalars['String']>;
};

/** Next ID: 2 */
export type OdProtosPartnershipServices_GetPartnerBranchByUserRequestInput = {
  userId?: InputMaybe<Scalars['String']>;
};

/** Next ID: 2 */
export type OdProtosPartnershipServices_GetPartnerBranchRequestInput = {
  uuid?: InputMaybe<Scalars['String']>;
};

/** Next ID: 2 */
export type OdProtosPartnershipServices_GetPartnerBranchesByPartnerRequestInput = {
  partnerIdentifier?: InputMaybe<Scalars['String']>;
};

/** Next ID: 2 */
export type OdProtosPartnershipServices_GetPartnerByTrackingKeywordRequestInput = {
  /** tracking keyword of the requested parter */
  trackingKeyword?: InputMaybe<Scalars['String']>;
};

/** Next ID: 2 */
export type OdProtosPartnershipServices_GetPartnerRequestInput = {
  /** Identifier of the requested parter */
  identifier?: InputMaybe<Scalars['String']>;
};

/** Next ID: 2 */
export type OdProtosPartnershipServices_GetPartnersByOrgIDsRequestInput = {
  /** Identifiers of the organizations */
  organizationIds?: InputMaybe<Array<Scalars['String']>>;
};

/** Next ID: 2 */
export type OdProtosPartnershipServices_GetPaymentAgreementRequestInput = {
  uuid?: InputMaybe<Scalars['String']>;
};

/** Next ID: 2 */
export type OdProtosPartnershipServices_GetPaymentAgreementsForPartnerRequestInput = {
  partnerIdentifier?: InputMaybe<Scalars['String']>;
};

/** Next ID: 2 */
export type OdProtosPartnershipServices_GetReferralInvitationEligibilityRequestInput = {
  sellerInputId?: InputMaybe<Scalars['String']>;
};

/** Next ID: 2 */
export type OdProtosPartnershipServices_GetReferralInvitationRequestInput = {
  sellerInputId?: InputMaybe<Scalars['String']>;
};

/** Next ID: 6 */
export type OdProtosPartnershipServices_GetReferralLinkRequestInput = {
  partnerIdentifier?: InputMaybe<Scalars['String']>;
  userData?: InputMaybe<OdProtosPartnershipServices_GetReferralLinkRequest_UserDataOneofInput>;
  /** TODO: deprecate after removed from FE */
  userId?: InputMaybe<Scalars['String']>;
};

export type OdProtosPartnershipServices_GetReferralLinkRequest_UserDataOneofInput = {
  /** If slug is passed in, the link will be returned if it exists, but a link will not be created otherwise. */
  slug?: InputMaybe<Scalars['String']>;
  /** If user_email is passed in, the link will be returned if it exists, but a link will not be created otherwise. */
  userEmail?: InputMaybe<Scalars['String']>;
  /** If user_id is passed in and a referral link does not exist, a referral link will be created. */
  userToken?: InputMaybe<Scalars['String']>;
};

/** Next ID: 2 */
export type OdProtosPartnershipServices_GetReferralPaymentRequestInput = {
  uuid?: InputMaybe<Scalars['String']>;
};

/** Next ID: 2 */
export type OdProtosPartnershipServices_GetReferralPaymentsByFlipTokenRequestInput = {
  flipToken?: InputMaybe<Scalars['String']>;
};

/** Next ID: 2 */
export type OdProtosPartnershipServices_GetReferralRequestInput = {
  /** ID of the requested referral */
  uuid?: InputMaybe<Scalars['String']>;
};

/** Next ID: 4 */
export type OdProtosPartnershipServices_GetReferralsByAddressRequestInput = {
  addressId?: InputMaybe<Scalars['String']>;
  customerEmail?: InputMaybe<Scalars['String']>;
  customerPhone?: InputMaybe<Scalars['String']>;
};

/** Next ID: 2 */
export type OdProtosPartnershipServices_GetReferralsByTrackingIdRequestInput = {
  /** external tracking id from partner */
  trackingId?: InputMaybe<Scalars['String']>;
};

/** Next ID: 2 */
export type OdProtosPartnershipServices_GetReferralsForReferrerRequestInput = {
  /** ID of the referrer from Directory */
  userId?: InputMaybe<Scalars['String']>;
};

/** Next ID: 3 */
export type OdProtosPartnershipServices_GetReferralsForSellerInputRequestInput = {
  leadToken?: InputMaybe<Scalars['String']>;
  /** ID of the seller input */
  sellerInputId?: InputMaybe<Scalars['String']>;
};

/** Next ID: 2 */
export type OdProtosPartnershipServices_GetReportRequestInput = {
  uuid?: InputMaybe<Scalars['String']>;
};

/** Next ID: 1 */
export type OdProtosPartnershipServices_GetReportableIndexFieldsRequestInput = {
  _empty?: InputMaybe<Scalars['Boolean']>;
};

/** Next ID: 6 */
export type OdProtosPartnershipServices_GetSellerLeadsRequestInput = {
  /**
   * Cursor that points to the last seller lead
   * from the previous response
   */
  cursor?: InputMaybe<Scalars['String']>;
  /** To get leads created before the end_date */
  endDate?: InputMaybe<Scalars['DateTime']>;
  /** Max number of leads to return */
  limit?: InputMaybe<Scalars['Float']>;
  partnerIdentifier?: InputMaybe<Scalars['String']>;
  /** To get leads created after the start_date */
  startDate?: InputMaybe<Scalars['DateTime']>;
};

/** Next ID: 2 */
export type OdProtosPartnershipServices_GetUserNotificationPreferencesRequestInput = {
  userId?: InputMaybe<Scalars['String']>;
};

/** Next ID: 10 */
export type OdProtosPartnershipServices_HandleReferralHandoffRequestInput = {
  agentRealEstateLicenseNumber?: InputMaybe<Scalars['String']>;
  agentRealEstateLicenseState?: InputMaybe<Scalars['String']>;
  brokerageAddress?: InputMaybe<Scalars['String']>;
  brokerageName?: InputMaybe<Scalars['String']>;
  customerEmail?: InputMaybe<Scalars['String']>;
  customerFirstName?: InputMaybe<Scalars['String']>;
  customerLastName?: InputMaybe<Scalars['String']>;
  customerPhoneNumber?: InputMaybe<Scalars['String']>;
  sellerInputId?: InputMaybe<Scalars['String']>;
};

/** Next ID: 2 */
export type OdProtosPartnershipServices_ListPartnersByTypesRequestInput = {
  partnershipTypes?: InputMaybe<Array<OdProtosPartnershipData_PartnershipType>>;
};

/** Next ID: 2 */
export type OdProtosPartnershipServices_ListPartnersRequestInput = {
  partnershipType?: InputMaybe<OdProtosPartnershipData_PartnershipType>;
};

/** Next ID: 3 */
export type OdProtosPartnershipServices_NotificationPreferenceInput = {
  categoryKey?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
};

/** Next ID: 4 */
export type OdProtosPartnershipServices_OverrideReferralPaymentRequestInput = {
  notes?: InputMaybe<Scalars['String']>;
  payable?: InputMaybe<Scalars['Boolean']>;
  uuid?: InputMaybe<Scalars['String']>;
};

/**
 * Next ID: 11
 *
 * Params after AttributionType are unnecessary if opting to represent.
 */
export type OdProtosPartnershipServices_ReferOrRepresentCustomerRequestInput = {
  agentRealEstateLicenseNumber?: InputMaybe<Scalars['String']>;
  agentRealEstateLicenseState?: InputMaybe<Scalars['String']>;
  attributionType?: InputMaybe<OdProtosPartnershipData_Referral_AttributionType>;
  brokerageAddress?: InputMaybe<Scalars['String']>;
  brokerageName?: InputMaybe<Scalars['String']>;
  customerEmail?: InputMaybe<Scalars['String']>;
  customerFirstName?: InputMaybe<Scalars['String']>;
  customerLastName?: InputMaybe<Scalars['String']>;
  customerPhoneNumber?: InputMaybe<Scalars['String']>;
  referralId?: InputMaybe<Scalars['String']>;
};

/** Next ID: 2 */
export type OdProtosPartnershipServices_RemovePaymentAgreementTierRequestInput = {
  uuid?: InputMaybe<Scalars['String']>;
};

/** Next ID: 2 */
export type OdProtosPartnershipServices_ResetReferralAttributionTypeRequestInput = {
  /** ID of the referral */
  uuid?: InputMaybe<Scalars['String']>;
};

/** Next ID: 21 */
export type OdProtosPartnershipServices_SearchSellerLeadsIndexRequestInput = {
  /** Search for leads with this casa address uuid */
  addressId?: InputMaybe<Scalars['String']>;
  /** This will be used to build the search_after field in the next query */
  after?: InputMaybe<Scalars['String']>;
  /** The direcion of the sort oder: 'asc' or 'desc' */
  direction?: InputMaybe<OdProtosPartnershipServices_SearchSellerLeadsIndexRequest_Direction>;
  /** Search for leads created before the end_date */
  endDate?: InputMaybe<Scalars['DateTime']>;
  /** Deprecated in favor for partner_states */
  flipStates?: InputMaybe<Array<Scalars['String']>>;
  /** The field to order the results by */
  orderBy?: InputMaybe<OdProtosPartnershipServices_SearchSellerLeadsIndexRequest_OrderBy>;
  /** Search for leads that match any of these partner display names */
  partnerIdentifiers?: InputMaybe<Array<Scalars['String']>>;
  /** Search for leads that match any of these partnership types */
  partnershipTypes?: InputMaybe<Array<OdProtosPartnershipData_PartnershipType>>;
  /** Search for leads that have a payable referral payment */
  payable?: InputMaybe<Scalars['Boolean']>;
  /** Search for leads that match any of these markets */
  regionIdentifiers?: InputMaybe<Array<Scalars['String']>>;
  /** Search for leads with these root seller input ids */
  rootSellerInputIds?: InputMaybe<Array<Scalars['String']>>;
  /** Search for leads with referrals that have a referrer with this user id */
  salesReferrerUserId?: InputMaybe<Scalars['String']>;
  /** The text search query to fuzzy match against address, customer, and sales referrer */
  searchQuery?: InputMaybe<Scalars['String']>;
  /** Search for leads with these seller input ids */
  sellerInputIds?: InputMaybe<Array<Scalars['String']>>;
  /** Search for leads with these seller lead ids */
  sellerLeadIds?: InputMaybe<Array<Scalars['String']>>;
  /** Will be passed as the `size` parameter in the elastic search query */
  size?: InputMaybe<Scalars['Float']>;
  /** Search for leads created after the start_date */
  startDate?: InputMaybe<Scalars['DateTime']>;
  /** Search for leads that match any of these lead states */
  states?: InputMaybe<Array<Scalars['String']>>;
  /** Search for leads that have been updated at any time since updated_since */
  updatedSince?: InputMaybe<Scalars['DateTime']>;
};

/**
 * The options for sort direction
 * Next ID: 2
 */
export type OdProtosPartnershipServices_SearchSellerLeadsIndexRequest_Direction =
  | 'ASC'
  | 'DESC';

/**
 * The options for ordering sorted results
 * Next ID: 6
 */
export type OdProtosPartnershipServices_SearchSellerLeadsIndexRequest_OrderBy =
  | 'CUSTOMER_NAME'
  | 'LEAD_CREATED'
  | 'OFFER_SENT'
  | 'PARTNER_DISPLAY_NAME'
  | 'REGION_IDENTIFIER'
  | 'SALES_REFERRER';

/** Next ID: 3 */
export type OdProtosPartnershipServices_SendLoginLiteLinkEmailForSellerInputRequestInput = {
  isRefresh?: InputMaybe<Scalars['Boolean']>;
  sellerInputId?: InputMaybe<Scalars['String']>;
};

/** Next ID: 4 */
export type OdProtosPartnershipServices_SendPartnershipLeadNotificationsRequestInput = {
  offerCreatedAt?: InputMaybe<Scalars['DateTime']>;
  sellerLeadUuid?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<OdProtosPartnershipServices_SendPartnershipLeadNotificationsRequest_State>;
};

/** Next ID: 2 */
export type OdProtosPartnershipServices_SendPartnershipLeadNotificationsRequest_State =
  | 'OFFER_SENT'
  | 'UNKNOWN';

/** Next ID: 4 */
export type OdProtosPartnershipServices_SetReferralLinkRequestInput = {
  partnerIdentifier?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
  userEmail?: InputMaybe<Scalars['String']>;
};

/** Next ID: 4 */
export type OdProtosPartnershipServices_UpdateLoyaltyEventRequestInput = {
  /** Optional: The customer uuid */
  customerUuid?: InputMaybe<Scalars['String']>;
  /** The id of an event external to the system, e.g. ListingOffer uuid or OpendoorDirectOffer uuid */
  foreignEventUuid?: InputMaybe<Scalars['String']>;
  /** Optional: The number of loyalty points being earned for this event */
  points?: InputMaybe<Scalars['Float']>;
};

/** Next ID: 4 */
export type OdProtosPartnershipServices_UpdateOutboundBuyerReferralRequestInput = {
  salesRepresentativeId?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<OdProtosPartnershipData_OutboundBuyerReferral_State>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** Next ID: 4 */
export type OdProtosPartnershipServices_UpdateOutboundBuyerReferralTourRequestRequestInput = {
  scheduledTime?: InputMaybe<Scalars['DateTime']>;
  state?: InputMaybe<OdProtosPartnershipData_OutboundBuyerReferralTourRequest_State>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** Next ID: 4 */
export type OdProtosPartnershipServices_UpdatePartnerBranchMemberByPartnerAndRegionRequestInput = {
  partnerIdentifier?: InputMaybe<Scalars['String']>;
  regionIdentifier?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
};

/** Next ID: 2 */
export type OdProtosPartnershipServices_UpdatePartnerBranchMemberRequestInput = {
  partnerBranchMember?: InputMaybe<OdProtosPartnershipData_PartnerBranchMemberInput>;
};

/** Next ID: 3 */
export type OdProtosPartnershipServices_UpdatePartnerBranchRequestInput = {
  partnerBranch?: InputMaybe<OdProtosPartnershipData_PartnerBranchInput>;
  updateMask?: InputMaybe<GoogleProtobuf_FieldMaskInput>;
};

/** Next ID: 7 */
export type OdProtosPartnershipServices_UpdatePartnerRequestInput = {
  /** Optional -- updated display name */
  displayName?: InputMaybe<Scalars['String']>;
  /** Identifier of the partner to update */
  identifier?: InputMaybe<Scalars['String']>;
  /** Optional -- updated landing page */
  landingPage?: InputMaybe<Scalars['String']>;
  /** Optional -- updated slug */
  slug?: InputMaybe<Scalars['String']>;
  /** Optional -- updated tracking keyword */
  trackingKeyword?: InputMaybe<Scalars['String']>;
  /** Optional -- URL for the partner's webhook endpoint */
  webhookUrl?: InputMaybe<Scalars['String']>;
};

/** Next ID: 17 */
export type OdProtosPartnershipServices_UpdatePaymentAgreementRequestInput = {
  attributionType?: InputMaybe<OdProtosPartnershipData_Referral_AttributionType>;
  billingType?: InputMaybe<OdProtosPartnershipData_BillingType>;
  notes?: InputMaybe<Scalars['String']>;
  partnerIdentifier?: InputMaybe<Scalars['String']>;
  payableConditions?: InputMaybe<Array<OdProtosPartnershipData_PayableConditions>>;
  payableEvent?: InputMaybe<OdProtosPartnershipData_PayableEvent>;
  paymentType?: InputMaybe<OdProtosPartnershipData_PaymentType>;
  product?: InputMaybe<OdProtosSellCommon_Product>;
  sendCommissionInstruction?: InputMaybe<Scalars['Boolean']>;
  termConversionWindowDays?: InputMaybe<Scalars['Int']>;
  termPayOnDetachedLead?: InputMaybe<Scalars['Boolean']>;
  termPreviousRequestDays?: InputMaybe<Scalars['Int']>;
  termUniqueLeadTypeWrapper?: InputMaybe<OdProtosPartnershipServices_UpdatePaymentAgreementRequest_TermUniqueLeadTypeWrapperInput>;
  tierTypeWrapper?: InputMaybe<OdProtosPartnershipServices_UpdatePaymentAgreementRequest_TermTierTypeWrapperInput>;
  uuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosPartnershipServices_UpdatePaymentAgreementRequest_TermTierTypeWrapperInput = {
  tierType?: InputMaybe<OdProtosPartnershipData_TierType>;
};

export type OdProtosPartnershipServices_UpdatePaymentAgreementRequest_TermUniqueLeadTypeWrapperInput = {
  termUniqueLeadType?: InputMaybe<OdProtosPartnershipData_UniqueLeadType>;
};

/** Next ID: 7 */
export type OdProtosPartnershipServices_UpdatePaymentAgreementTierRequestInput = {
  minimumPoints?: InputMaybe<Scalars['Float']>;
  paymentFlatRate?: InputMaybe<Scalars['Float']>;
  paymentPercentageBasis?: InputMaybe<Scalars['Float']>;
  points?: InputMaybe<Scalars['Float']>;
  tierCondition?: InputMaybe<OdProtosPartnershipData_TierCondition>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** Next ID: 2 */
export type OdProtosPartnershipServices_UpdateReferralPaymentsForFlipTokenRequestInput = {
  flipToken?: InputMaybe<Scalars['String']>;
};

/** Next ID: 6 */
export type OdProtosPartnershipServices_UpdateReferralRequestInput = {
  /** Optional -- updated organization ID for the referral */
  organizationId?: InputMaybe<Scalars['String']>;
  /** Optional -- updated user ID for the referral */
  userId?: InputMaybe<Scalars['String']>;
  /** ID of the referral to update */
  uuid?: InputMaybe<Scalars['String']>;
};

/** Next ID: 4 */
export type OdProtosPartnershipServices_UpdateReferralSellerRelationForSellerInputRequestInput = {
  /** Referral type for the partnership */
  partnershipType?: InputMaybe<OdProtosPartnershipData_PartnershipType>;
  /** Seller Input ID for the customer being referred */
  sellerInputId?: InputMaybe<Scalars['String']>;
  /** The seller's relation to the referrer */
  sellerRelation?: InputMaybe<OdProtosPartnershipData_Referral_SellerRelation>;
};

/** Next ID: 6 */
export type OdProtosPartnershipServices_UpdateReferralUserForSellerInputRequestInput = {
  leadToken?: InputMaybe<Scalars['String']>;
  /** Referral type for the partnership */
  partnershipType?: InputMaybe<OdProtosPartnershipData_PartnershipType>;
  /** Seller Input ID for the customer being referred */
  sellerInputId?: InputMaybe<Scalars['String']>;
  /** Referrer details for seller input */
  userData?: InputMaybe<OdProtosPartnershipServices_UpdateReferralUserForSellerInputRequest_UserDataOneofInput>;
};

export type OdProtosPartnershipServices_UpdateReferralUserForSellerInputRequest_UserDataOneofInput = {
  userEmail?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
};

/** Next ID: 4 */
export type OdProtosPartnershipServices_UpdateSellRequestRequestInput = {
  communicationDetails?: InputMaybe<OdProtosPartnershipData_CommunicationDetailsInput>;
  referrerDetails?: InputMaybe<OdProtosPartnershipData_CustomerDetailsInput>;
  sellerInputId?: InputMaybe<Scalars['String']>;
};

/** Next ID: 3 */
export type OdProtosPartnershipServices_UpdateUserNotificationPreferencesRequestInput = {
  notificationPreferences?: InputMaybe<Array<OdProtosPartnershipServices_NotificationPreferenceInput>>;
  userId?: InputMaybe<Scalars['String']>;
};

/** Next ID: 2 */
export type OdProtosPartnershipServices_ValidateEmailRequestInput = {
  email?: InputMaybe<Scalars['String']>;
};

/**
 * An expression oneof.
 *
 * Expressions in PBDB are a subset of PostgreSQL 10 expressions:
 *
 * 1. Identifier: A property of an entry, either 'key', 'value', or 'last_version_created_at'.
 *                The 'value' identifier represents a PostgreSQL JSONB type that is the canonical
 *                JSON mapping of a Protocol Buffer as defined in
 *                'https://developers.google.com/protocol-buffers/docs/proto3#json'.
 *                You may access fields using PostgreSQL JSONB operators and functions such as
 *                "->>", "#>>", "jsonb_extract_path", etc.
 * 2. Value:      A value, such as a string or a number.
 * 3. Function:   A function call, the name of the PostgreSQL operator or function and the arguments
 *                to apply to it.
 *
 * *Examples*
 *
 * Let's see some examples, using some pseudo-protobuf code. Suppose we have this User message:
 *   message User {
 *     string name = 1;
 *     int32 age = 2;
 *   }
 *
 * Expressions for a user's name and age:
 *   Fn("->>", Id("value"), Val("name"))
 *   Fn("->>", Id("value"), Val("age"))
 *
 * Boolean expression for whether a user has the name "Jason":
 *   Fn("=",
 *     Fn("->>", Id("value"), Val("name")),
 *     Value("Jason")
 *   )
 *
 * Boolean expression for whether a user is at least 18 years old:
 *   Fn(">=",
 *     Fn("->>", Id("value"), Val("age")),
 *     Val(18)
 *   )
 *
 * Boolean expression that is the AND of the above.
 *   Fn("AND", [
 *     Fn("=",
 *       Fn("->>", Id("value"), Val("name")),
 *       Value("Jason")
 *     ),
 *     Fn(">=",
 *       Fn("->>", Id("value"), Val("age")),
 *       Val(18)
 *     )
 *   ])
 */
export type OdProtosPbdbData_ExprInput = {
  type?: InputMaybe<OdProtosPbdbData_Expr_TypeOneofInput>;
};

/**
 * A function expression is a function (or operator) and its arguments.
 *
 * The supported set of functions with their names and arities:
 *
 * Logical:
 *   "NOT" / 1
 * 	 "AND" / 0+
 * 	 "OR" / 0+
 *
 * Null:
 * 	 "IS NULL" / 1
 * 	 "IS NOT NULL" / 1
 *
 * Comparison:
 * 	 "=" / 2
 * 	 "!=" / 2
 * 	 "<" / 2
 * 	 ">" / 2
 * 	 "<=" / 2
 * 	 ">=" / 2
 * 	 "LIKE" / 2
 * 	 "NOT LIKE" / 2
 *
 * Array:
 * 	 "IN" / 1+
 * 	 "NOT IN" / 1+
 *
 * JSON/JSONB:
 * 	 "->" / 2
 * 	 "->>" / 2
 * 	 "#>" / 2
 * 	 "#>>" / 2
 *
 * String:
 * 	 "lower" / 1
 * 	 "upper" / 2
 *
 * Casts:
 *   "CAST AS x" / 1, where x is one of:
 *     bigint,
 *   	 boolean,
 *   	 bytea,
 *   	 date,
 *   	 double precision,
 *   	 integer,
 *   	 interval,
 *   	 json,
 *   	 jsonb,
 *   	 real,
 *   	 text,
 *   	 time,
 *   	 timetz,
 *   	 timestamp,
 *   	 timestamptz,
 */
export type OdProtosPbdbData_Expr_FunctionInput = {
  /** Arguments on the operation. */
  args?: InputMaybe<Array<OdProtosPbdbData_ExprInput>>;
  /** Name of function or operator. */
  fn?: InputMaybe<Scalars['String']>;
};

export type OdProtosPbdbData_Expr_TypeOneofInput = {
  function?: InputMaybe<OdProtosPbdbData_Expr_FunctionInput>;
  /** An identifier, either 'key', 'value', or 'last_version_created_at'. */
  identifier?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<OdProtosPbdbData_Expr_ValueInput>;
};

/** A value expression. */
export type OdProtosPbdbData_Expr_ValueInput = {
  type?: InputMaybe<OdProtosPbdbData_Expr_Value_TypeOneofInput>;
};

export type OdProtosPbdbData_Expr_Value_TypeOneofInput = {
  bool?: InputMaybe<Scalars['Boolean']>;
  bytes?: InputMaybe<Scalars['String']>;
  double?: InputMaybe<Scalars['Float']>;
  duration?: InputMaybe<GoogleProtobuf_DurationInput>;
  float?: InputMaybe<Scalars['Float']>;
  int32?: InputMaybe<Scalars['Float']>;
  int64?: InputMaybe<Scalars['Float']>;
  string?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['DateTime']>;
  uint32?: InputMaybe<Scalars['Float']>;
  uint64?: InputMaybe<Scalars['Float']>;
};

/** A sort expression is an expression and a direction. */
export type OdProtosPbdbData_SortExprInput = {
  direction?: InputMaybe<OdProtosPbdbData_SortExpr_Direction>;
  expr?: InputMaybe<OdProtosPbdbData_ExprInput>;
};

export type OdProtosPbdbData_SortExpr_Direction =
  | 'ASC'
  | 'DESC';

/**
 * Enumeration of types of PBDB entries.
 * You should add a new identifier here when registering a new PBDB entry type.
 */
export type OdProtosPbdbData_Type =
  /**
   * Config for a buy market.
   * * Key: market identifier
   * * Value: od_protos.buy.config.MarketConfig
   */
  | 'BUY_MARKET_CONFIG'
  /**
   * EXAMPLE is an example type. Please follow this format.
   * * Key: any string
   * * Value: od_protos.example.config.ExampleData
   */
  | 'EXAMPLE'
  /**
   * Config for market operations.
   * * Key: market identifier
   * * Value: od_protos.home_operations.config.MarketConfig
   */
  | 'HOME_OPERATIONS_MARKET_CONFIG'
  /**
   * A market is a non-overlapping region that Opendoor operates in. Markets are the highest-level
   * division of Opendoor operations.
   * * Key: Fence Region ID
   * * Value: od_protos.market.config.Market
   */
  | 'MARKET'
  /**
   * Config for a Sell market.
   * * Key: Fence Region ID
   * * Value: od_protos.sell.config.MarketConfig
   */
  | 'SELL_MARKET_CONFIG'
  | 'UNSET';

export type OdProtosPbdbServices_ListRequestInput = {
  /** An expression to filter on. Must evaluate to a boolean. */
  filterExpr?: InputMaybe<OdProtosPbdbData_ExprInput>;
  /** Required. Defines the requested page of the list. */
  pagination?: InputMaybe<OdProtosCommonPagination_PaginationRequestInput>;
  /** Expressions to sort on. */
  sortExprs?: InputMaybe<Array<OdProtosPbdbData_SortExprInput>>;
  /** The type of entries to list. */
  type?: InputMaybe<OdProtosPbdbData_Type>;
};

export type OdProtosPbdbServices_NotARealCommandRequestInput = {
  brokerageTransactionRules?: InputMaybe<OdProtosInstitutionsReithouseDataBrokerage_TransactionRuleSetInput>;
  buyMarketConfig?: InputMaybe<OdProtosBuyConfig_MarketConfigInput>;
  homeOperationsMarketConfig?: InputMaybe<OdProtosHomeOperationsConfig_MarketConfigInput>;
  market?: InputMaybe<OdProtosMarketConfig_MarketInput>;
  sellMarketConfig?: InputMaybe<OdProtosSellConfig_MarketConfigInput>;
};

export type OdProtosPbdbServices_ReadRequestInput = {
  /** The key of the entry to read. */
  key?: InputMaybe<Scalars['String']>;
  /** The type of the entry to read. */
  type?: InputMaybe<OdProtosPbdbData_Type>;
  /**
   * Used to read a specific version of an entry.
   * * If == 0 (default), reads the latest version of an entry.
   * * If > 0, reads a specific version of an entry.
   */
  version?: InputMaybe<Scalars['Float']>;
};

export type OdProtosPbdbServices_WriteRequestInput = {
  /** The key of the entry to write. */
  key?: InputMaybe<Scalars['String']>;
  /**
   * Used to prevent multiple clients from overwriting each other.
   * Returns FAILED_PRECONDITION if a condition wasn't satisfied.
   * * If == nil (default), unconditionally writes the entry.
   * * If == 0, conditionally writes the entry if this entry doesn't exist yet.
   * * If > 0, conditionally writes the entry if last_version_condition matches
   *   the current version.
   */
  lastVersionCondition?: InputMaybe<Scalars['Int']>;
  /** The type of the entry to write. */
  type?: InputMaybe<OdProtosPbdbData_Type>;
  /** The value of the entry. The value is subject to the type's validation rules. */
  value?: InputMaybe<Scalars['String']>;
};

/** Describes a specific kind of edit for an Item */
export type OdProtosPictionaryBracketeerData_EditInput = {
  /**
   * This is implemented as a oneof instead of an enum to allow future edit modes to have
   * specialized parameters
   */
  spec?: InputMaybe<OdProtosPictionaryBracketeerData_Edit_SpecOneofInput>;
};

export type OdProtosPictionaryBracketeerData_EditJob_State =
  /** Accepted but not yet submitted to 3rd party editor */
  | 'CREATED'
  /** 3rd party notified us of a problem */
  | 'ERROR'
  /** Request was created, but not accepted by 3rd party */
  | 'FAILURE'
  /** Processing of successful job outputs is complete and all assets available in Cabinet */
  | 'FINISHED'
  /** Request accepted by 3rd party editor */
  | 'PENDING'
  /** 3rd party notified us of job completion, but we're still processing results */
  | 'SUCCESS'
  | 'UNKNOWN';

/** Basic HDR bracketing is a pre-set package of edits */
export type OdProtosPictionaryBracketeerData_Edit_BracketingInput = {
  _empty?: InputMaybe<Scalars['Boolean']>;
};

export type OdProtosPictionaryBracketeerData_Edit_SpecOneofInput = {
  /** Standard HDR bracketing service */
  bracketingSpec?: InputMaybe<OdProtosPictionaryBracketeerData_Edit_BracketingInput>;
};

/** A line item in an edit job */
export type OdProtosPictionaryBracketeerData_ItemInput = {
  /** List of requested services */
  edits?: InputMaybe<Array<OdProtosPictionaryBracketeerData_EditInput>>;
  /** URLs where input images may be retrieved (must be accessible to public) */
  inputUrls?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosPictionaryData_ErrorInput = {
  /** maps to go/lib/errors.Code */
  code?: InputMaybe<Scalars['Float']>;
  /** Human-readable error message */
  message?: InputMaybe<Scalars['String']>;
};

/** Optionally used to enrich drop folder events with additional data */
export type OdProtosPictionaryGdriveData_DropFolder_MetaInput = {
  addressUuid?: InputMaybe<Scalars['String']>;
  /** Arbitrary other data may be attached. Maximum size may be limited. */
  blob?: InputMaybe<Scalars['String']>;
  flipToken?: InputMaybe<Scalars['String']>;
  listingUuid?: InputMaybe<Scalars['String']>;
};

/**
 * Uniquely identifies a drop folder and its purpose. This value serves to de-duplicate requests.
 * For example, if a drop folder is for accepting new listing photos, the namespace could be
 * "add_listing_photos" and the ID could be set to the listing_uuid of the associated listing.
 * You may also choose to use obfuscated namespaces so long as they are unique.
 */
export type OdProtosPictionaryGdriveData_DropFolder_SubjectInput = {
  id?: InputMaybe<Scalars['String']>;
  namespace?: InputMaybe<Scalars['String']>;
};

export type OdProtosPictionaryServices_AlbumConsumedReqInput = {
  albumId?: InputMaybe<Scalars['String']>;
  client?: InputMaybe<Scalars['String']>;
  /** if error is unset we assume the operation succeeded */
  error?: InputMaybe<OdProtosPictionaryData_ErrorInput>;
  workshopId?: InputMaybe<Scalars['String']>;
};

export type OdProtosPictionaryServices_DeleteDropFolderReqInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type OdProtosPictionaryServices_DeleteWorkshopReqInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type OdProtosPictionaryServices_EditPhotosReqInput = {
  /**
   * Optional user-provided value which is used to compute a kafka partition key. The job ID is used
   * when not set. You would only need to set this value if you wanted to preserve event order
   * across more than one job.
   */
  eventKey?: InputMaybe<Scalars['String']>;
  /** A list of edit request items */
  items?: InputMaybe<Array<OdProtosPictionaryBracketeerData_ItemInput>>;
  /** Human-readable name for this job (visible to 3P services) */
  name?: InputMaybe<Scalars['String']>;
};

export type OdProtosPictionaryServices_GetDropFolderReqInput = {
  identifier?: InputMaybe<OdProtosPictionaryServices_GetDropFolderReq_IdentifierOneofInput>;
};

export type OdProtosPictionaryServices_GetDropFolderReq_IdentifierOneofInput = {
  addressUuid?: InputMaybe<Scalars['String']>;
  dropFolderId?: InputMaybe<Scalars['String']>;
  flipToken?: InputMaybe<Scalars['String']>;
  listingUuid?: InputMaybe<Scalars['String']>;
  subject?: InputMaybe<OdProtosPictionaryGdriveData_DropFolder_SubjectInput>;
};

export type OdProtosPictionaryServices_GetEditJobsReqInput = {
  jobIds?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosPictionaryServices_GetOrCreateDropFolderReqInput = {
  /** If the drop folder does not exist one will be created in Google Drive with this name */
  folderName?: InputMaybe<Scalars['String']>;
  /** Metadata will be updated, if given (when drop folder does not exist yet) */
  meta?: InputMaybe<OdProtosPictionaryGdriveData_DropFolder_MetaInput>;
  subject?: InputMaybe<OdProtosPictionaryGdriveData_DropFolder_SubjectInput>;
};

export type OdProtosPictionaryServices_GetWorkshopReqInput = {
  identifier?: InputMaybe<OdProtosPictionaryServices_GetWorkshopReq_IdentifierOneofInput>;
};

export type OdProtosPictionaryServices_GetWorkshopReq_IdentifierOneofInput = {
  addressUuid?: InputMaybe<Scalars['String']>;
  flipToken?: InputMaybe<Scalars['String']>;
  listingUuid?: InputMaybe<Scalars['String']>;
  workshopId?: InputMaybe<Scalars['String']>;
};

export type OdProtosPictionaryServices_SetDropFolderMetaReqInput = {
  identifier?: InputMaybe<OdProtosPictionaryServices_SetDropFolderMetaReq_IdentifierOneofInput>;
  meta?: InputMaybe<OdProtosPictionaryGdriveData_DropFolder_MetaInput>;
};

export type OdProtosPictionaryServices_SetDropFolderMetaReq_IdentifierOneofInput = {
  id?: InputMaybe<Scalars['String']>;
  subject?: InputMaybe<OdProtosPictionaryGdriveData_DropFolder_SubjectInput>;
};

export type OdProtosPictionaryServices_UploadAssetsReqInput = {
  assetIds?: InputMaybe<Array<Scalars['String']>>;
  dropFolderId?: InputMaybe<Scalars['String']>;
};

export type OdProtosPricesAcquisitionData_ContinuousNetCashExperimentTreatmentInput = {
  subsidyBps?: InputMaybe<Scalars['Float']>;
  treatmentArm?: InputMaybe<Scalars['String']>;
};

export type OdProtosPricesAcquisitionData_FeeExperimentFlagsInput = {
  continuousNetCashExperimentTreatment?: InputMaybe<OdProtosPricesAcquisitionData_ContinuousNetCashExperimentTreatmentInput>;
};

export type OdProtosPricesAcquisitionData_FeeOverridesInput = {
  applyFeeBandExperiment?: InputMaybe<Scalars['Boolean']>;
  applyHeadlinePriceExperiment?: InputMaybe<Scalars['Boolean']>;
  /**
   * If set, the headline discount on the home will be set such that
   * headline fee / headline price == flat_headline_fee_percentage.
   */
  flatHeadlineFeePercentage?: InputMaybe<Scalars['Float']>;
  ignoreFeeFloors?: InputMaybe<Scalars['Boolean']>;
  /**
   * Whether to ignore partner fee policy violations. These violations usually result in a fee
   * calculation error. A list of these violations can be found at o/homebuilder-grandfather.
   */
  ignorePartnerPolicyViolation?: InputMaybe<Scalars['Boolean']>;
  minExternalFeePercentage?: InputMaybe<Scalars['Float']>;
};

export type OdProtosPricesCommon_OnlineRealEstatePartner =
  | 'ORE_NONE'
  | 'ORE_UNKNOWN'
  | 'REDFIN';

/**
 * Next ID: 61
 * NOTE: WHEN UPDATING THIS ENUM YOU MUST BUMP PROTOS FOR PRICES, WEB, AND GENIE.
 * In the past, we have forgotten to bump protos for Genie, causing it to crash when it receives a partner it doesn't recognize.
 *
 * NOTE: IN PRACTICE, THIS IS USED JUST FOR HOMEBUILDER PARTNERS. Soon to be deprecated in favor of PartnerReferral type above.
 */
export type OdProtosPricesCommon_Partner =
  | 'AMERICAN_WEST'
  | 'ASHTON_WOODS'
  | 'BEAZER_HOMES'
  | 'BLOOMFIELD_HOMES'
  | 'BROOKFIELD_RESIDENTIAL_PROPERTIES'
  | 'CALATLANTIC'
  | 'CAVENDAR'
  | 'CENTEX'
  | 'CENTURY_COMMUNITIES'
  | 'CHAFIN'
  | 'CITY_VENTURES'
  | 'CLARITY'
  | 'DAN_RYAN'
  | 'DAVID_WEEKLEY'
  | 'DEERBROOKE'
  | 'DEL_WEBB'
  | 'DORN'
  | 'DREAM_FINDERS_HOMES'
  | 'DREES'
  | 'DRHORTON'
  /** TODO: Remove this when web is no longer using it. */
  | 'DR_HORTON'
  | 'EMPIRE_COMMUNITIES'
  | 'EPCON_COMMUNITIES_FRANCHISING'
  | 'FRONTDOOR'
  | 'GEHAN_HOMES'
  | 'GOODALL'
  | 'JDRE'
  | 'JMC_HOMES'
  | 'JOHN_HOUSTON_CUSTOM_HOMES'
  | 'JOHN_WIELAND_HOMES'
  | 'KB_HOME'
  | 'LENNAR'
  | 'LILLIAN'
  | 'MARACAY'
  | 'MARONDA'
  | 'MATTAMY'
  | 'MERITAGE'
  | 'MEYERRANCH'
  | 'MI_HOMES'
  | 'NONE'
  | 'OTHER_BUILDER'
  | 'PAHLISCH'
  | 'PARDEE'
  | 'PERRY_HOMES'
  | 'PROVIDENCE_HOMES'
  | 'PULTE'
  | 'RICHMOND_AMERICAN'
  | 'RIVERSIDE'
  | 'RYAN'
  | 'SHEA_HOMES_TRILOGY'
  | 'SMITHDOUGLAS'
  | 'STONE_BRIDGE'
  | 'TAYLOR_MORRISON'
  | 'TOLL_BROTHERS'
  | 'TOUCHSTONE'
  | 'TRENDMAKER_HOMES'
  | 'TRIPOINTE'
  | 'TRUE_HOMES_USA'
  | 'UNKNOWN'
  | 'WADE_JURNEY_HOMES'
  | 'WOODSIDE';

/**
 * PartnerReferral defines all the data about the referral and the associated partner that we need for pricing, mainly fees.
 *
 * Next ID: 5
 */
export type OdProtosPricesCommon_PartnerReferralInput = {
  attributionType?: InputMaybe<OdProtosPricesCommon_PartnerReferral_AttributionType>;
  partnerIdentifier?: InputMaybe<Scalars['String']>;
  partnershipType?: InputMaybe<OdProtosPricesCommon_PartnerReferral_PartnershipType>;
  referralId?: InputMaybe<Scalars['String']>;
};

/** Next ID: 3 */
export type OdProtosPricesCommon_PartnerReferral_AttributionType =
  | 'REFERRAL'
  | 'REPRESENTATION'
  | 'UNKNOWN_ATTRIBUTION';

/** Next ID: 5 */
export type OdProtosPricesCommon_PartnerReferral_PartnershipType =
  | 'HOMEBUILDER'
  /** Pricing does not need to know about most partnership types. */
  | 'OTHER'
  | 'REAL_ESTATE_AGENCY'
  | 'REIT'
  | 'UNKNOWN';

export type OdProtosPricesDataFinancials_AcquisitionChannel =
  | 'AGENT_ACQUISITION'
  | 'DIRECT_ACQUISITION'
  | 'HOME_BUILDER_NON_PARTNER'
  | 'HOME_BUILDER_PARTNER'
  | 'REIT_ACQUISITION'
  | 'TRADE_IN'
  | 'UNSET_ACQUISITION_CHANNEL';

/**
 * Next ID: 12
 * Deprecated IDs: 1, 6
 */
export type OdProtosPricesDataFinancials_CohortInput = {
  /** If empty, assumed to be all channels. */
  acquisitionChannels?: InputMaybe<Array<OdProtosPricesDataFinancials_AcquisitionChannel>>;
  cohortType?: InputMaybe<OdProtosPricesDataFinancials_CohortType>;
  endDate?: InputMaybe<OdProtosCommon_DateInput>;
  /** If empty, flips from all markets will be returned. */
  markets?: InputMaybe<Array<OdProtosCommonMarket_Market>>;
  offerAutomationType?: InputMaybe<OdProtosPricesDataFinancials_OfferAutomationType>;
  /** >= lower_bound (where offer_price is positive) */
  offerPriceLowerBound?: InputMaybe<Scalars['Float']>;
  /** < upper_bound (where offer_price is positive) */
  offerPriceUpperBound?: InputMaybe<Scalars['Float']>;
  /** If empty, assumed to be all channels. */
  resaleChannels?: InputMaybe<Array<OdProtosPricesDataFinancials_ResaleChannel>>;
  /**
   * start_date and end_date define the cohort's date range. This date range is
   * inclusive of start_date and end_date and is defined in UTC. It includes all the flips that
   * were of type `cohort_type` during the time period.
   */
  startDate?: InputMaybe<OdProtosCommon_DateInput>;
};

/** Next ID: 7 */
export type OdProtosPricesDataFinancials_CohortType =
  | 'ACQUISITION_COE'
  | 'ACQUISITION_CONTRACT'
  | 'ACQUISITION_CR'
  | 'LISTED'
  | 'RESALE_COE'
  | 'RESALE_CONTRACT'
  | 'UNSET_COHORT_TYPE'
  | 'UNSOLD';

export type OdProtosPricesDataFinancials_ContractState =
  | 'CONTRACT_STATE_IN_CONTRACT'
  | 'CONTRACT_STATE_LISTED'
  | 'CONTRACT_STATE_PRE_LISTING'
  | 'CONTRACT_STATE_RESALE_CONTINGENCY_RELEASED'
  | 'CONTRACT_STATE_RESALE_IN_CONTRACT'
  | 'CONTRACT_STATE_SOLD'
  | 'CONTRACT_STATE_SOLD_AND_CLOSED_BY_ACCOUNTING'
  | 'CONTRACT_STATE_UW';

export type OdProtosPricesDataFinancials_GetFinancialsRequestInput = {
  cohort?: InputMaybe<OdProtosPricesDataFinancials_CohortInput>;
  /**
   * Note: Only one of tokens or cohort should be set. A `oneof` proto declaration can't be used
   * here because it does not support `repeated` fields.
   */
  tokens?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosPricesDataFinancials_OfferAutomationType =
  | 'ALL_OFFERS'
  | 'AUTOMATED_OFFERS'
  | 'VAL_LEAD_OFFERS';

/** Deprecated IDs: 4 */
export type OdProtosPricesDataFinancials_ResaleChannel =
  | 'AGENT_RESALE'
  | 'DIRECT_RESALE'
  | 'REIT'
  | 'UNKNOWN'
  | 'UNSET_RESALE_CHANNEL';

export type OdProtosPricingDataPropertyEngagements_AcquisitionDataLabeling_State =
  | 'UNKNOWN';

export type OdProtosPricingDataPropertyEngagements_AcquisitionRepairBudgetReview_State =
  | 'UNKNOWN';

export type OdProtosPricingDataPropertyEngagements_AcquisitionRiskAssessment_State =
  | 'COMPLETED'
  | 'ESCALATED'
  | 'MANUAL_COMPLETED'
  | 'MANUAL_REQUESTED'
  | 'REQUESTED'
  | 'REUSED'
  | 'SKIPPED'
  | 'UNKNOWN';

/**
 * Note: AUS does not accurately populate this state on its events. The LifecycleState
 * on PE events is more relevant
 */
export type OdProtosPricingDataPropertyEngagements_AcquisitionUnderwriting_State =
  | 'ACTIVE'
  | 'COMPLETED'
  | 'FAILED'
  | 'OD_SELECT'
  | 'RESOLVING_WALK'
  | 'UNKNOWN';

export type OdProtosPricingDataPropertyEngagements_AcquisitionValuation_EventExtensions_Domain_Completed_ValuationType =
  | 'UNKNOWN'
  | 'WEB_ENSEMBLED_VALUATION'
  | 'WEB_SINGLE_VALUATION';

export type OdProtosPricingDataPropertyEngagements_AcquisitionValuation_State =
  | 'UNKNOWN';

export type OdProtosPricingDataPropertyEngagements_SellWithUpsidePricing_State =
  | 'ACTIVE'
  | 'COMPLETED'
  | 'UNKNOWN';

/** Next ID: 7 */
export type OdProtosPricingData_CamundaFlowNodeInstanceInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  endedAt?: InputMaybe<Scalars['DateTime']>;
  flowNodeName?: InputMaybe<Scalars['String']>;
  incident?: InputMaybe<OdProtosPricingData_CamundaIncidentInput>;
  key?: InputMaybe<Scalars['Float']>;
  /** ACTIVE, COMPLETED, TERMINATED */
  state?: InputMaybe<Scalars['String']>;
};

/** Next ID: 6 */
export type OdProtosPricingData_CamundaIncidentInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  incidentType?: InputMaybe<Scalars['String']>;
  key?: InputMaybe<Scalars['Float']>;
  message?: InputMaybe<Scalars['String']>;
  /** ACTIVE, MIGRATED, RESOLVED, PENDING */
  state?: InputMaybe<Scalars['String']>;
};

/**
 * Captures data relevant to a single instance of the Camunda process
 * Next ID: 10
 */
export type OdProtosPricingData_CamundaProcessInstanceInput = {
  /** When the camunda process instance was created */
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** The flow node instances of the process instance which would represent the current state of the process instance */
  flowNodeInstances?: InputMaybe<Array<OdProtosPricingData_CamundaFlowNodeInstanceInput>>;
  /** The process instance key */
  processInstanceKey?: InputMaybe<Scalars['Float']>;
  /** The process name */
  processName?: InputMaybe<Scalars['String']>;
  /** The Property Engagement ID */
  propertyEngagementId?: InputMaybe<Scalars['String']>;
  /** The process instance state */
  state?: InputMaybe<Scalars['String']>;
  /** When the camunda process instance was last updated */
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** The variables stored in the process instance */
  variables?: InputMaybe<GoogleProtobuf_StructInput>;
  /** The Camunda model version */
  version?: InputMaybe<Scalars['Float']>;
};

export type OdProtosPricingData_EnsembledRepairLineItem_RepairType =
  | 'PRELIST'
  | 'UNKNOWN';

/** Configurations for mocking the underwriting workflow */
export type OdProtosPricingData_MockAcquisitionUnderwritingInput = {
  dataLabeling?: InputMaybe<OdProtosPricingData_MockAcquisitionUnderwriting_MockDataLabelingInput>;
  defaultHumanToken?: InputMaybe<Scalars['String']>;
  repairBudgetReview?: InputMaybe<OdProtosPricingData_MockAcquisitionUnderwriting_MockRepairBudgetReviewInput>;
  riskAssessment?: InputMaybe<OdProtosPricingData_MockAcquisitionUnderwriting_MockRiskAssessmentInput>;
  valuation?: InputMaybe<OdProtosPricingData_MockAcquisitionUnderwriting_MockValuationInput>;
};

/**
 * Do not add fields to this message
 * Instead, create a new PE-specific message for the scenario
 * and add the fields there.
 */
export type OdProtosPricingData_MockAcquisitionUnderwriting_HappyPathInput = {
  _empty?: InputMaybe<Scalars['Boolean']>;
};

export type OdProtosPricingData_MockAcquisitionUnderwriting_MockDataLabelingInput = {
  config?: InputMaybe<OdProtosPricingData_MockAcquisitionUnderwriting_MockDataLabeling_ConfigOneofInput>;
};

export type OdProtosPricingData_MockAcquisitionUnderwriting_MockDataLabeling_ConfigOneofInput = {
  happyPath?: InputMaybe<OdProtosPricingData_MockAcquisitionUnderwriting_HappyPathInput>;
};

export type OdProtosPricingData_MockAcquisitionUnderwriting_MockRepairBudgetReviewInput = {
  config?: InputMaybe<OdProtosPricingData_MockAcquisitionUnderwriting_MockRepairBudgetReview_ConfigOneofInput>;
};

export type OdProtosPricingData_MockAcquisitionUnderwriting_MockRepairBudgetReview_ConfigOneofInput = {
  happyPath?: InputMaybe<OdProtosPricingData_MockAcquisitionUnderwriting_HappyPathInput>;
  proposeWalk?: InputMaybe<OdProtosPricingData_MockAcquisitionUnderwriting_MockRepairBudgetReview_ProposeWalkInput>;
};

export type OdProtosPricingData_MockAcquisitionUnderwriting_MockRepairBudgetReview_ProposeWalkInput = {
  humanToken?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  primaryReason?: InputMaybe<Scalars['String']>;
  resolutionOutcome?: InputMaybe<OdProtosPricingData_WalkResolutionOutcome>;
  secondaryReason?: InputMaybe<Scalars['String']>;
};

export type OdProtosPricingData_MockAcquisitionUnderwriting_MockRiskAssessmentInput = {
  config?: InputMaybe<OdProtosPricingData_MockAcquisitionUnderwriting_MockRiskAssessment_ConfigOneofInput>;
};

export type OdProtosPricingData_MockAcquisitionUnderwriting_MockRiskAssessment_ConfigOneofInput = {
  happyPath?: InputMaybe<OdProtosPricingData_MockAcquisitionUnderwriting_MockRiskAssessment_HappyPathInput>;
  proposeWalk?: InputMaybe<OdProtosPricingData_MockAcquisitionUnderwriting_MockRiskAssessment_ProposeWalkInput>;
  skipRiskAssessment?: InputMaybe<OdProtosPricingData_MockAcquisitionUnderwriting_MockRiskAssessment_SkipInput>;
};

export type OdProtosPricingData_MockAcquisitionUnderwriting_MockRiskAssessment_HappyPathInput = {
  humanToken?: InputMaybe<Scalars['String']>;
};

export type OdProtosPricingData_MockAcquisitionUnderwriting_MockRiskAssessment_ProposeWalkInput = {
  humanToken?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
};

export type OdProtosPricingData_MockAcquisitionUnderwriting_MockRiskAssessment_SkipInput = {
  _empty?: InputMaybe<Scalars['Boolean']>;
};

export type OdProtosPricingData_MockAcquisitionUnderwriting_MockValuationInput = {
  config?: InputMaybe<OdProtosPricingData_MockAcquisitionUnderwriting_MockValuation_ConfigOneofInput>;
  finalPrv?: InputMaybe<OdProtosCommon_MoneyInput>;
};

export type OdProtosPricingData_MockAcquisitionUnderwriting_MockValuation_ConfigOneofInput = {
  happyPath?: InputMaybe<OdProtosPricingData_MockAcquisitionUnderwriting_HappyPathInput>;
  proposeWalk?: InputMaybe<OdProtosPricingData_MockAcquisitionUnderwriting_MockValuation_ProposeWalkInput>;
};

export type OdProtosPricingData_MockAcquisitionUnderwriting_MockValuation_ProposeWalkInput = {
  humanToken?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  primaryReason?: InputMaybe<Scalars['String']>;
  secondaryReason?: InputMaybe<Scalars['String']>;
};

export type OdProtosPricingData_UnderwritingSubEngagement =
  | 'DATA_LABELING'
  | 'ENSEMBLED_VALUATION'
  /** optional valuation that overrides the EV after a rejected walk proposal */
  | 'OVERRIDE_VALUATION'
  /** part of OD Select workflow */
  | 'POST_RENO_VALUATION'
  /** part of OD Select workflow */
  | 'PRE_RENO_VALUATION'
  | 'REPAIR_BUDGET_REVIEW'
  | 'RISK_ASSESSMENT'
  | 'UNKNOWN';

/** Next ID: 9 */
export type OdProtosPricingData_WalkProposalInput = {
  addressToken?: InputMaybe<Scalars['String']>;
  /** The primary reason for the walk proposal */
  primaryReason?: InputMaybe<Scalars['String']>;
  /** Parent PE ID for the sub-engagement that is the source of this walk proposal */
  propertyEngagementId?: InputMaybe<Scalars['String']>;
  /** additional details about the walk proposal */
  proposalDetails?: InputMaybe<GoogleProtobuf_StructInput>;
  /** The Human token of user who proposed the walk */
  proposedByToken?: InputMaybe<Scalars['String']>;
  /** The source of the proposal. These are the only valid sources for initiating a walk proposal */
  proposedFromPeType?: InputMaybe<OdProtosPricingData_UnderwritingSubEngagement>;
  /** PE ID for the sub-engagement */
  sourcePropertyEngagementId?: InputMaybe<Scalars['String']>;
  /** If the walk proposal was proposed from a valuation PE, it's ID will be set here. */
  valuationId?: InputMaybe<Scalars['Float']>;
};

/** Next ID: 11 */
export type OdProtosPricingData_WalkResolutionInput = {
  /** If the walk proposal was accepted, the ID of the accepted walk proposal */
  acceptedWalkProposalId?: InputMaybe<Scalars['String']>;
  /** direct override valuation EE proxy */
  directOverrideValuationCi50margin?: InputMaybe<Scalars['Float']>;
  /** direct override valuation price */
  directOverrideValuationPrice?: InputMaybe<OdProtosCommon_MoneyInput>;
  propertyEngagementId?: InputMaybe<Scalars['String']>;
  /** instructions stemming from the decision made on the walk proposal */
  resolutionCxInstructions?: InputMaybe<Scalars['String']>;
  /** notes about the decision made on the walk proposal */
  resolutionNote?: InputMaybe<Scalars['String']>;
  /** the decision made on the walk proposal */
  resolutionOutcome?: InputMaybe<OdProtosPricingData_WalkResolutionOutcome>;
  /** The type of walk resolution */
  resolutionType?: InputMaybe<OdProtosPricingData_WalkResolutionType>;
  /** when the walk proposal was resolved */
  resolvedAt?: InputMaybe<Scalars['DateTime']>;
  /** The Human token of the user who resolved the proposal */
  resolvedByToken?: InputMaybe<Scalars['String']>;
};

export type OdProtosPricingData_WalkResolutionOutcome =
  | 'ACCEPTED'
  | 'REJECTED'
  | 'REJECTED_WITH_DIRECT_OVERRIDE'
  | 'REJECTED_WITH_VALUATION_OVERRIDE'
  | 'UNKNOWN_OUTCOME';

export type OdProtosPricingData_WalkResolutionType =
  | 'HOMES'
  | 'PRICING'
  | 'UNKNOWN_RESOLUTION_TYPE';

export type OdProtosPricingsData_AgentCommissionInput = {
  flatRate?: InputMaybe<OdProtosCommon_MoneyInput>;
  /**
   * Percentage of the projected resale sales price
   * (or agent_projected_resale_sales_price if available)
   *
   * e.g., 0.06 for 6%
   */
  percentage?: InputMaybe<Scalars['Float']>;
};

export type OdProtosPricingsData_AgentProjectedSalesPriceInput = {
  amount?: InputMaybe<OdProtosCommon_MoneyInput>;
  /** If true, will ignore modification guardrails (e.g., 110% of projected sales price) */
  force?: InputMaybe<Scalars['Boolean']>;
};

export type OdProtosPricingsData_ComponentInput = {
  /** amount = round(scalar * sum(components)) */
  amount?: InputMaybe<OdProtosCommon_MoneyInput>;
  /**
   * the key must match the contained component name
   * e.g., { k : { name: k, ... }, ... }
   */
  components?: InputMaybe<Array<OdProtosPricingsData_Component_ComponentsEntryInput>>;
  name?: InputMaybe<Scalars['String']>;
  scalar?: InputMaybe<Scalars['Float']>;
};

/** `OdProtosPricingsData_Component_ComponentsEntryInput` represents the `components` map in `od_protos.pricings.data.Component`. */
export type OdProtosPricingsData_Component_ComponentsEntryInput = {
  key?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<OdProtosPricingsData_ComponentInput>;
};

export type OdProtosPricingsData_MetadataInput = {
  addressToken?: InputMaybe<Scalars['String']>;
  /**
   * metainfo is not used by the service
   * but it will be associated with created records
   * so callers may lookup in non-prod (e.g., snowflake) contexts
   *  e.g., select * from pricings where metadata:metainfo:foo = 'bar';
   */
  metainfo?: InputMaybe<GoogleProtobuf_StructInput>;
  propertyEngagementGroupId?: InputMaybe<Scalars['String']>;
  propertyEngagementId?: InputMaybe<Scalars['String']>;
};

export type OdProtosPricingsData_ModificationInput = {
  kind?: InputMaybe<OdProtosPricingsData_Modification_KindOneofInput>;
};

export type OdProtosPricingsData_Modification_KindOneofInput = {
  agentProjectedSalesPrice?: InputMaybe<OdProtosPricingsData_AgentProjectedSalesPriceInput>;
  buyerAgentCommission?: InputMaybe<OdProtosPricingsData_AgentCommissionInput>;
  prelistRepairsSubsidy?: InputMaybe<OdProtosPricingsData_PrelistRepairsSubsidyInput>;
  salesPriceSubsidy?: InputMaybe<OdProtosPricingsData_SalesPriceSubsidyInput>;
  sellerAgentCommission?: InputMaybe<OdProtosPricingsData_AgentCommissionInput>;
  sellerDesiredAdvance?: InputMaybe<OdProtosPricingsData_SellerDesiredAdvanceInput>;
  sellerProjectedSalesPrice?: InputMaybe<OdProtosPricingsData_SellerProjectedSalesPriceInput>;
};

export type OdProtosPricingsData_MutationInput = {
  operation?: InputMaybe<OdProtosPricingsData_Mutation_OperationOneofInput>;
};

export type OdProtosPricingsData_Mutation_OperationOneofInput = {
  /**
   * Add a new instance of the given modification.
   * Some modifications may only be allowed at most once or may conflict with other modifications.
   * In such cases, the server will return an error.
   */
  add?: InputMaybe<OdProtosPricingsData_ModificationInput>;
  /**
   * Remove an existing instance of the given modification.
   * The server will return an error if the modification does not exist.
   */
  remove?: InputMaybe<OdProtosPricingsData_ModificationInput>;
  /**
   * Update an existing instance of the given modification.
   * The server will return an error if the modification does not exist or if the update is
   * not allowed.
   */
  update?: InputMaybe<OdProtosPricingsData_ModificationInput>;
  /**
   * Update an existing instance of the given modification, or add it if it does not exist.
   * May not be compatible with all modifications.
   * Will return an error if multiple modifications of the same type are present and cannot be uniqely identified
   */
  upsert?: InputMaybe<OdProtosPricingsData_ModificationInput>;
};

export type OdProtosPricingsData_PrelistRepairsSubsidyInput = {
  amount?: InputMaybe<OdProtosCommon_MoneyInput>;
};

export type OdProtosPricingsData_SalesPriceSubsidyInput = {
  amount?: InputMaybe<OdProtosCommon_MoneyInput>;
  /** If true, will ignore modification guardrails (e.g., 20% of UW PRV) */
  force?: InputMaybe<Scalars['Boolean']>;
};

export type OdProtosPricingsData_SellerDesiredAdvanceInput = {
  desiredCashAdvance?: InputMaybe<OdProtosCommon_MoneyInput>;
};

export type OdProtosPricingsData_SellerProjectedSalesPriceInput = {
  sellerProjectedSalesPrice?: InputMaybe<OdProtosCommon_MoneyInput>;
};

export type OdProtosPricingsServicesPricingsGraphql_DeriveNewPricingRequestInput = {
  /**
   * Typically, you want to derive from a 'leaf' pricing (e.g., some 'latest' pricing)
   * When `allow_non_leaf_derivation = false` (default), we return an error if the source pricing is not a leaf
   * That is, if any derivations have been made _from_ the source pricing, we return an error
   */
  allowNonLeafDerivation?: InputMaybe<Scalars['Boolean']>;
  emitUpdateEvent?: InputMaybe<Scalars['Boolean']>;
  idempotencyKey?: InputMaybe<Scalars['String']>;
  mutations?: InputMaybe<Array<OdProtosPricingsData_MutationInput>>;
  sourcePricingUuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosPricingsServicesPricingsGraphql_GetSellWithUpsidePricingOptionsRequestInput = {
  /** This is the base pricing that will be used to produce options */
  basePricingUuid?: InputMaybe<Scalars['String']>;
  requestId?: InputMaybe<OdProtosCommon_RequestIdInput>;
  requestorId?: InputMaybe<OdProtosCommon_RequestorIdInput>;
  /** Optional: Seller estimated sales price */
  sellerEstimatedSalesPrice?: InputMaybe<OdProtosCommon_MoneyInput>;
};

export type OdProtosPricingsServicesPricingsGraphql_ListPricingsExpandedRequestInput = {
  pricingUuids?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosPricingsServicesPricingsGraphql_ListPricingsRequestInput = {
  pricingUuids?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosPricingsServicesPricingsGraphql_SubmitPostDiligenceVisitPricingUpdateRequestInput = {
  /** the casey task ID is a good option for this */
  idempotencyKey?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<OdProtosPricingsData_MetadataInput>;
  offerUuid?: InputMaybe<Scalars['String']>;
  operatorDecision?: InputMaybe<OdProtosPricingsServicesPricingsGraphql_SubmitPostDiligenceVisitPricingUpdateRequest_OperatorDecisionOneofInput>;
};

export type OdProtosPricingsServicesPricingsGraphql_SubmitPostDiligenceVisitPricingUpdateRequest_OperatorDecisionOneofInput = {
  addendum?: InputMaybe<OdProtosCommon_MoneyInput>;
  proceed?: InputMaybe<GoogleProtobuf_EmptyInput>;
  withdraw?: InputMaybe<OdProtosPricingsServicesPricingsGraphql_WithdrawDecisionInput>;
};

export type OdProtosPricingsServicesPricingsGraphql_WithdrawDecisionInput = {
  reasoning?: InputMaybe<Scalars['String']>;
};

/** Next ID: 9 */
export type OdProtosPricingsServicesPricings_CreateListWithOpendoorPricingRequestInput = {
  /** from partnership.data.Partner.identifier */
  agentReferralPartnerId?: InputMaybe<Scalars['String']>;
  economics?: InputMaybe<OdProtosPricingsServicesPricings_CreateListWithOpendoorPricingRequest_EconomicsOneofInput>;
  idempotencyKey?: InputMaybe<Scalars['String']>;
  /**
   * Hack: if we need additional partner fields, begin generalizing this request.
   * e.g., call GetReferralsForSellerInputRequest and parse partners that way.
   */
  isMsre?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<OdProtosPricingsData_MetadataInput>;
  requestId?: InputMaybe<OdProtosCommon_RequestIdInput>;
  requestorId?: InputMaybe<OdProtosCommon_RequestorIdInput>;
};

export type OdProtosPricingsServicesPricings_CreateListWithOpendoorPricingRequest_EconomicsOneofInput = {
  /**
   * This is the minimum data we need to compute an lwod pricing.
   * I've created this to demonstrate what we need, but we may want to replace this with some
   * new identifier. e.g., a valuation ID + repairs ensemble ID + ... something else w/ val gain + pvals.
   * Or maybe we decide it's just the first two IDs are necessary in which case we can query for flip level val gain.
   * Maybe pvals are not necessary here. All TBD.
   */
  rawEconomics?: InputMaybe<OdProtosPricingsServicesPricings_CreateListWithOpendoorPricingRequest_RawEconomicsInput>;
  underwritingId?: InputMaybe<Scalars['Float']>;
};

/**
 * This is the minimum data we need to compute an lwod pricing,
 * which is what we normally get from the SD offer.
 * Hopefully this will go away after we develop a better abstraction
 */
export type OdProtosPricingsServicesPricings_CreateListWithOpendoorPricingRequest_RawEconomicsInput = {
  /** required */
  postRepairValuation?: InputMaybe<OdProtosCommon_MoneyInput>;
  /** defaults to 0 if unset */
  postValuationAdjustments?: InputMaybe<OdProtosCommon_MoneyInput>;
  /** defaults to 0 if unset */
  prelistRepairsCost?: InputMaybe<OdProtosCommon_MoneyInput>;
  /** defaults to 0 if unset */
  projectedValGain?: InputMaybe<OdProtosCommon_MoneyInput>;
};

export type OdProtosPricingsServicesPricings_CreateListWithOpendoorPricingResponse_Error_Code =
  | 'INVALID_ARGUMENT'
  | 'NOT_FOUND'
  | 'UNKNOWN';

/** Next ID: 5 */
export type OdProtosPricingsServicesPricings_CreateSellDirectPricingRequestInput = {
  idempotencyKey?: InputMaybe<Scalars['String']>;
  inputs?: InputMaybe<OdProtosPricingsServicesPricings_CreateSellDirectPricingRequest_SdInputsInput>;
  metadata?: InputMaybe<OdProtosPricingsData_MetadataInput>;
  requestId?: InputMaybe<OdProtosCommon_RequestIdInput>;
  requestorId?: InputMaybe<OdProtosCommon_RequestorIdInput>;
};

export type OdProtosPricingsServicesPricings_CreateSellDirectPricingRequest_SdInputsInput = {
  city?: InputMaybe<Scalars['String']>;
  closingCosts?: InputMaybe<OdProtosPricingsData_ComponentInput>;
  costPrelistRepairs?: InputMaybe<OdProtosPricingsData_ComponentInput>;
  costRenovation?: InputMaybe<OdProtosPricingsData_ComponentInput>;
  county?: InputMaybe<Scalars['String']>;
  dwellingType?: InputMaybe<Scalars['String']>;
  hasHoa?: InputMaybe<Scalars['Boolean']>;
  hasPool?: InputMaybe<Scalars['Boolean']>;
  market?: InputMaybe<OdProtosCommonMarket_Market>;
  negativeSelectionCharge?: InputMaybe<OdProtosCommon_MoneyInput>;
  overrideTargetGrossMarginBps?: InputMaybe<Scalars['Float']>;
  postRepairValuation?: InputMaybe<OdProtosCommon_MoneyInput>;
  postValuationAdjustments?: InputMaybe<OdProtosPricingsData_ComponentInput>;
  projectedBrn?: InputMaybe<OdProtosPricingsData_ComponentInput>;
  projectedPostlistRepairs?: InputMaybe<OdProtosPricingsData_ComponentInput>;
  sqft?: InputMaybe<Scalars['Float']>;
  state?: InputMaybe<Scalars['String']>;
  valGainAdjustments?: InputMaybe<OdProtosPricingsData_ComponentInput>;
};

export type OdProtosPricingsServicesPricings_CreateSellDirectPricingResponse_Error_Code =
  | 'INVALID_ARGUMENT'
  | 'UNKNOWN';

/** Next ID: 10 */
export type OdProtosPricingsServicesPricings_CreateSellWithUpsidePricingRequestInput = {
  /**
   * When neither is set, no agent relationship is established, meaning it is an
   * Opendoor Led Offer (ODLO).
   */
  agentRelationship?: InputMaybe<OdProtosPricingsServicesPricings_CreateSellWithUpsidePricingRequest_AgentRelationshipOneofInput>;
  idempotencyKey?: InputMaybe<Scalars['String']>;
  /**
   * Hack: if we need additional partner fields, begin generalizing this request.
   * e.g., call GetReferralsForSellerInputRequest and parse partners that way.
   */
  isMsre?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<OdProtosPricingsData_MetadataInput>;
  newOfferPresentationExperiment?: InputMaybe<Scalars['Boolean']>;
  requestId?: InputMaybe<OdProtosCommon_RequestIdInput>;
  requestorId?: InputMaybe<OdProtosCommon_RequestorIdInput>;
  underwritingId?: InputMaybe<Scalars['Float']>;
};

export type OdProtosPricingsServicesPricings_CreateSellWithUpsidePricingRequest_AgentRelationshipOneofInput = {
  /**
   * Agent Acq
   * from partnership.data.Partner.identifier
   */
  agentReferralPartnerId?: InputMaybe<Scalars['String']>;
  /**
   * Agent Led Offer (ALO)
   * Temporarily may have OD brokerage set for ODLO
   * from agents.data.Brokerage.id
   */
  brokerageId?: InputMaybe<Scalars['String']>;
};

export type OdProtosPricingsServicesPricings_CreateSellWithUpsidePricingResponse_Error_Code =
  | 'INVALID_ARGUMENT'
  | 'NOT_FOUND'
  | 'UNKNOWN';

export type OdProtosPricingsServicesPricings_DeriveNewPricingRequestInput = {
  /**
   * Typically, you want to derive from a 'leaf' pricing (e.g., some 'latest' pricing)
   * When `allow_non_leaf_derivation = false` (default), we return an error if the source pricing is not a leaf
   * That is, if any derivations have been made _from_ the source pricing, we return an error
   */
  allowNonLeafDerivation?: InputMaybe<Scalars['Boolean']>;
  emitUpdateEvent?: InputMaybe<Scalars['Boolean']>;
  idempotencyKey?: InputMaybe<Scalars['String']>;
  mutations?: InputMaybe<Array<OdProtosPricingsData_MutationInput>>;
  requestId?: InputMaybe<OdProtosCommon_RequestIdInput>;
  requestorId?: InputMaybe<OdProtosCommon_RequestorIdInput>;
  sourcePricingUuid?: InputMaybe<Scalars['String']>;
  /** the user token who is requesting the new derived pricing */
  userToken?: InputMaybe<Scalars['String']>;
};

export type OdProtosPricingsServicesPricings_DeriveNewPricingResponse_Error_Code =
  | 'INVALID_ARGUMENT'
  /** See DeriveNewPricingRequest.allow_non_leaf_derivation for context. */
  | 'NON_LEAF_PRICING'
  | 'NOT_FOUND'
  | 'UNKNOWN';

export type OdProtosPricingsServicesPricings_GetPricingRequestInput = {
  pricingUuid?: InputMaybe<Scalars['String']>;
  requestId?: InputMaybe<OdProtosCommon_RequestIdInput>;
  requestorId?: InputMaybe<OdProtosCommon_RequestorIdInput>;
};

export type OdProtosPricingsServicesPricings_GetPricingResponse_Error_Code =
  | 'INVALID_ARGUMENT'
  | 'NOT_FOUND'
  | 'UNKNOWN';

export type OdProtosPricingsServicesPricings_GetUnitEconomicsRequestInput = {
  identifier?: InputMaybe<OdProtosPricingsServicesPricings_GetUnitEconomicsRequest_IdentifierOneofInput>;
  requestId?: InputMaybe<OdProtosCommon_RequestIdInput>;
  requestorId?: InputMaybe<OdProtosCommon_RequestorIdInput>;
};

export type OdProtosPricingsServicesPricings_GetUnitEconomicsRequest_IdentifierOneofInput = {
  /** All records in Pricings have a unique pricing_uuid */
  pricingUuid?: InputMaybe<Scalars['String']>;
  /** Historical web records have this unit_economics_id */
  unitEconomicsId?: InputMaybe<Scalars['Float']>;
};

export type OdProtosPricingsServicesPricings_GetUnitEconomicsResponse_Error_Code =
  | 'INVALID_ARGUMENT'
  | 'NOT_FOUND'
  | 'UNKNOWN';

export type OdProtosPricingsServicesPricings_SubmitPostDiligenceVisitRepairScopeUpdateRequestInput = {
  idempotencyKey?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<OdProtosPricingsData_MetadataInput>;
  offerUuid?: InputMaybe<Scalars['String']>;
  requestId?: InputMaybe<OdProtosCommon_RequestIdInput>;
  requestorId?: InputMaybe<OdProtosCommon_RequestorIdInput>;
  /**
   * delta between original scope and revised scope
   *
   * In the future we might need more specificity to update economics?
   * common.Money revised_prelist_repair_estimate = 7;
   * common.Money revised_postlist_repair_estimate = 8;
   * common.Money revised_brn_estimate = 9;
   */
  scopeDifference?: InputMaybe<OdProtosCommon_MoneyInput>;
};

export type OdProtosPricingsServicesPricings_SubmitPostDiligenceVisitRepairScopeUpdateResponse_Error_Code =
  | 'INVALID_ARGUMENT'
  | 'UNKNOWN';

export type OdProtosPricingsServicesPricings_UpsertUnitEconomicsRequestInput = {
  idempotencyKey?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<OdProtosPricingsData_MetadataInput>;
  /** Callers may specify a uuid. If not specified, one will be generated. */
  pricingUuid?: InputMaybe<Scalars['String']>;
  requestId?: InputMaybe<OdProtosCommon_RequestIdInput>;
  requestorId?: InputMaybe<OdProtosCommon_RequestorIdInput>;
  unitEconomicsJson?: InputMaybe<Scalars['String']>;
};

export type OdProtosPricingsServicesPricings_UpsertUnitEconomicsResponse_Error_Code =
  | 'INVALID_ARGUMENT'
  | 'UNKNOWN';

export type OdProtosProjectionsDataFlip_ListingInput = {
  /** acquisition close date in "YYYY-MM-DD" format */
  acquisitionCloseDateIso8601?: InputMaybe<Scalars['String']>;
  /** the address token of the property */
  addressToken?: InputMaybe<Scalars['String']>;
  /** after renovation valuation in cents */
  afterRenovationValuation?: InputMaybe<OdProtosCommon_MoneyInput>;
  /** current list price in cents */
  currentListPrice?: InputMaybe<OdProtosCommon_MoneyInput>;
  /** we need flip token to retrieve RestB score */
  flipToken?: InputMaybe<Scalars['String']>;
  /** initial list price in cents */
  initialListPrice?: InputMaybe<OdProtosCommon_MoneyInput>;
  /** whether the home is an Opendoor home or not */
  isOpendoor?: InputMaybe<Scalars['Boolean']>;
  /** when the last price change occurred */
  lastPriceChangeDatetime?: InputMaybe<Scalars['DateTime']>;
  /** list date in "YYYY-MM-DD" format */
  listDateIso8601?: InputMaybe<Scalars['String']>;
  /** list valuation in cents */
  listValuation?: InputMaybe<OdProtosCommon_MoneyInput>;
  /** market area of the flip */
  market?: InputMaybe<OdProtosCommonMarket_Market>;
  /** list date in "YYYY-MM-DD" format */
  postListConditionDateIso8601?: InputMaybe<Scalars['String']>;
};

export type OdProtosProjectionsServices_BulkProjectionPostListRequestInput = {
  listings?: InputMaybe<Array<OdProtosProjectionsDataFlip_ListingInput>>;
};

export type OdProtosProjectionsServices_InitialMarkupLineItemSource =
  | 'OVERLAY'
  | 'PCF_MODEL'
  | 'UNKNOWN_SOURCE';

export type OdProtosProjectionsServices_InitialMarkupRecommendationRequestInput = {
  /** the address token of the property */
  addressToken?: InputMaybe<Scalars['String']>;
  /** Flip token, for RestB pre-list fetching */
  flipToken?: InputMaybe<Scalars['String']>;
  /** ILP valuation in cents */
  initialListPriceValuation?: InputMaybe<OdProtosCommon_MoneyInput>;
  /** market area of the flip */
  market?: InputMaybe<OdProtosCommonMarket_Market>;
};

export type OdProtosProjectionsServices_ProjectionPostListRequestInput = {
  listing?: InputMaybe<OdProtosProjectionsDataFlip_ListingInput>;
};

export type OdProtosPropertyDataStoreServices_AddressAutocompleteRequestInput = {
  /** If true, suggestions will include properties with invalid addresses */
  allowInvalidAddresses?: InputMaybe<Scalars['Boolean']>;
  /** If specified, properties matching these listing states are excluded from suggestions */
  excludeListingStates?: InputMaybe<Array<OdProtosRealtyOdlsData_SellRequest_State>>;
  /**
   * If specified, results will include the full Property of the suggestion
   * To maximize performance, set this to false
   */
  fetchProperties?: InputMaybe<Scalars['Boolean']>;
  /**
   * Configures the level of fuzziness applied to the suggestion query
   * For strict prefix matching, use FUZZINESS_NONE
   */
  fuzziness?: InputMaybe<OdProtosPropertyDataStoreServices_Fuzziness>;
  /** If specified, only properties matching these listing states are suggested */
  includeListingStates?: InputMaybe<Array<OdProtosRealtyOdlsData_SellRequest_State>>;
  /** Optional. If specified, results will include matching suggestions closer to this point first */
  latitude?: InputMaybe<Scalars['Float']>;
  /** The max number of suggestions to return. Capped at 50. Defaults to 5. */
  limit?: InputMaybe<Scalars['Float']>;
  longitude?: InputMaybe<Scalars['Float']>;
  queryString?: InputMaybe<Scalars['String']>;
};

export type OdProtosPropertyDataStoreServices_BulkRefreshPropertyRequestInput = {
  addressIds?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosPropertyDataStoreServices_BwodFilterInput = {
  marketIdentifiers?: InputMaybe<Array<OdProtosCommonMarket_Market>>;
};

export type OdProtosPropertyDataStoreServices_Fuzziness =
  | 'FUZZINESS_AUTO'
  | 'FUZZINESS_NONE'
  | 'FUZZINESS_UNKNOWN';

export type OdProtosPropertyDataStoreServices_GetPropertiesByAddressIdRequestInput = {
  /** Maximum of 1000 ids per request enforced */
  addressIds?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosPropertyDataStoreServices_GetPropertyByAddressIdRequestInput = {
  addressId?: InputMaybe<Scalars['String']>;
};

export type OdProtosPropertyDataStoreServices_MinMaxFilterInput = {
  max?: InputMaybe<Scalars['Float']>;
  min?: InputMaybe<Scalars['Float']>;
};

export type OdProtosPropertyDataStoreServices_MinMaxFloatFilterInput = {
  max?: InputMaybe<Scalars['Float']>;
  min?: InputMaybe<Scalars['Float']>;
};

export type OdProtosPropertyDataStoreServices_PaginationRequestInput = {
  from?: InputMaybe<Scalars['Float']>;
  size?: InputMaybe<Scalars['Float']>;
};

/** Next ID: 43 */
export type OdProtosPropertyDataStoreServices_PropertyFiltersInput = {
  /** Optionally filters the results to properties within some range of above grade sq footage */
  aboveGradeSqFt?: InputMaybe<OdProtosPropertyDataStoreServices_MinMaxFilterInput>;
  /** Optionally filters the results to properties within some range of basement sq footage */
  basementSqFt?: InputMaybe<OdProtosPropertyDataStoreServices_MinMaxFilterInput>;
  /**
   * Optionally filters the results to properties having some range of bathrooms
   * Note: current convention is to count half baths as 0.5; so 2 full 2 half house = 3.0 total
   */
  bathroomsTotal?: InputMaybe<OdProtosPropertyDataStoreServices_MinMaxFloatFilterInput>;
  /** Optionally filters the results to properties having some range of bedrooms */
  bedrooms?: InputMaybe<OdProtosPropertyDataStoreServices_MinMaxFilterInput>;
  /** If bwod markets are defined in filter, only properties that are currently eligible for BwOD Offers (and in those markets) are returned */
  bwodOfferable?: InputMaybe<OdProtosPropertyDataStoreServices_BwodFilterInput>;
  /** If bwod markets are defined in filter, only properties that are currently eligible for BwOD Tours (and in those markets) are returned */
  bwodTourable?: InputMaybe<OdProtosPropertyDataStoreServices_BwodFilterInput>;
  /** Optionally filters results to properties in a specific city (case-insensitive) */
  city?: InputMaybe<Scalars['String']>;
  /** Optionally filters the results to properties within some range of current list price */
  currentListPrice?: InputMaybe<OdProtosPropertyDataStoreServices_MinMaxFilterInput>;
  /** If empty, properties of any dwelling type are returned. If specified, only those properties matching these dwelling types are returned */
  dwellingTypes?: InputMaybe<Array<Scalars['String']>>;
  /** Any address ids specified in exclude_address_ids are filtered out of search results */
  excludeAddressIds?: InputMaybe<Array<Scalars['String']>>;
  /** If specified, properties matching these states are excluded */
  excludeListingStates?: InputMaybe<Array<OdProtosRealtyOdlsData_SellRequest_State>>;
  /** Include properties that have indexed_at >= gte_indexed_at */
  gteIndexedAt?: InputMaybe<Scalars['DateTime']>;
  /** Include properties that have listed_at >= gte_listed_at */
  gteListedAt?: InputMaybe<Scalars['DateTime']>;
  /** Include properties that have pending_at >= gte_pending_at */
  gtePendingAt?: InputMaybe<Scalars['DateTime']>;
  /** Include properties that have sold_at >= gte_sold_at */
  gteSoldAt?: InputMaybe<Scalars['DateTime']>;
  /**
   * If true, only properties with photos are returned. If false, only properties without photos are returned
   * Does NOT indicate whether those photos are downloaded in Cabinet, only that they are known to exist on the sell request
   */
  hasPhotos?: InputMaybe<Scalars['Boolean']>;
  /** If true, only properties with pool are returned. If false, only properties with no pool are returned */
  hasPool?: InputMaybe<Scalars['Boolean']>;
  /** Set to false to exclude all properties with a takedown request. If true, only taken-down properties are returned */
  hasTakedown?: InputMaybe<Scalars['Boolean']>;
  isDisplayable?: InputMaybe<Scalars['Boolean']>;
  /** If true, only properties that are currently eligible to be purchased with an FHA loan are returned */
  isFhaEligible?: InputMaybe<Scalars['Boolean']>;
  /** If true, only new construction properties are returned. If false, new construction properties are excluded */
  isNewConstruction?: InputMaybe<Scalars['Boolean']>;
  /** Optionally filters the results to only Opendoor-owned properties */
  isOpendoorOwned?: InputMaybe<Scalars['Boolean']>;
  /** If empty, properties with any current listing state are returned. If specified, only those properties matching these states are returned */
  listingStates?: InputMaybe<Array<OdProtosRealtyOdlsData_SellRequest_State>>;
  /** Optionally filters the results to properties within some range of lot size */
  lotSqFt?: InputMaybe<OdProtosPropertyDataStoreServices_MinMaxFilterInput>;
  /** Include properties that have indexed_at < lt_indexed_at */
  ltIndexedAt?: InputMaybe<Scalars['DateTime']>;
  /** Include properties that have listed_at < lt_listed_at */
  ltListedAt?: InputMaybe<Scalars['DateTime']>;
  /** Include properties that have been pending_at < lt_pending_at */
  ltPendingAt?: InputMaybe<Scalars['DateTime']>;
  /** Include properties that have sold_at < lt_sold_at */
  ltSoldAt?: InputMaybe<Scalars['DateTime']>;
  /** Optionally filters the results to properties within some range of monthly HOA dues */
  monthlyHoaDues?: InputMaybe<OdProtosPropertyDataStoreServices_MinMaxFilterInput>;
  /**
   * If empty, all properties, regardless of photo status are returned.
   * If specified, only those properties with photos known to already be available in Cabinet *or*
   *   those created in ODLS before (now - threshold) are returned.
   * That way, we don't indefinitely exclude Properties that will *never* have photos from search results
   * Set to -1 to return properties without cabinet photos downloaded
   */
  photoThresholdSeconds?: InputMaybe<Scalars['Float']>;
  /** If true, only currently-popular (based on page views) properties are returned */
  popular?: InputMaybe<Scalars['Boolean']>;
  /** Optionally filters results to properties in specific postal/zip codes */
  postalCodes?: InputMaybe<Array<Scalars['String']>>;
  /** If true, only properties that are available for self-touring are returned. If false, only those properties without self-touring are returned */
  selfTourAvailable?: InputMaybe<Scalars['Boolean']>;
  /** Optionally filters the results to properties within some range of sold price price */
  soldPrice?: InputMaybe<OdProtosPropertyDataStoreServices_MinMaxFilterInput>;
  /** Optionally filters results to properties in a specific state (2-letter code, case-insensitive) */
  state?: InputMaybe<Scalars['String']>;
  /**
   * Optionally filters the results to properties with some range of stories
   * Uses interior stories where available, otherwise falls back on exterior stories
   */
  stories?: InputMaybe<OdProtosPropertyDataStoreServices_MinMaxFilterInput>;
  /** Optionally filters the results to only properties with a matching subdivision value */
  subdivision?: InputMaybe<Scalars['String']>;
  /** Optionally filters the results to properties within some range of total sq footage */
  totalLivingSqFt?: InputMaybe<OdProtosPropertyDataStoreServices_MinMaxFilterInput>;
  /** Optionally filters the results to properties built within some range of years */
  yearBuilt?: InputMaybe<OdProtosPropertyDataStoreServices_MinMaxFilterInput>;
  /** If specified, only those properties within the specified GDS zones are returned */
  zoneIds?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosPropertyDataStoreServices_RefreshPropertyRequestInput = {
  addressId?: InputMaybe<Scalars['String']>;
};

export type OdProtosPropertyDataStoreServices_SearchPropertiesByFieldsRequestInput = {
  filters?: InputMaybe<OdProtosPropertyDataStoreServices_PropertyFiltersInput>;
  paginationRequest?: InputMaybe<OdProtosPropertyDataStoreServices_PaginationRequestInput>;
  sortKey?: InputMaybe<OdProtosPropertyDataStoreServices_SearchPropertiesRequest_SortKey>;
};

export type OdProtosPropertyDataStoreServices_SearchPropertiesByQueryRequestInput = {
  /** If specified, filter criteria will be applied to limit the search results */
  filters?: InputMaybe<OdProtosPropertyDataStoreServices_PropertyFiltersInput>;
  /** If specified, results will include results closer to this point first */
  latitude?: InputMaybe<Scalars['Float']>;
  longitude?: InputMaybe<Scalars['Float']>;
  paginationRequest?: InputMaybe<OdProtosPropertyDataStoreServices_PaginationRequestInput>;
  queryString?: InputMaybe<Scalars['String']>;
};

export type OdProtosPropertyDataStoreServices_SearchPropertiesRequestInput = {
  /** If specified, filter criteria will be applied to limit the search results */
  filters?: InputMaybe<OdProtosPropertyDataStoreServices_PropertyFiltersInput>;
  paginationRequest?: InputMaybe<OdProtosPropertyDataStoreServices_PaginationRequestInput>;
  /** GeoJSON shape (must be polygon or multipolygon) */
  shape?: InputMaybe<Scalars['String']>;
  sortKey?: InputMaybe<OdProtosPropertyDataStoreServices_SearchPropertiesRequest_SortKey>;
};

export type OdProtosPropertyDataStoreServices_SearchPropertiesRequest_SortKey =
  | 'SORT_KEY_CURRENT_LIST_PRICE_ASC'
  | 'SORT_KEY_CURRENT_LIST_PRICE_DESC'
  | 'SORT_KEY_DEFAULT'
  | 'SORT_KEY_INDEXED_AT_ASC'
  | 'SORT_KEY_INDEXED_AT_DESC'
  | 'SORT_KEY_LISTED_AT_ASC'
  | 'SORT_KEY_LISTED_AT_DESC'
  | 'SORT_KEY_NONE'
  | 'SORT_KEY_TOTAL_LIVING_SQ_FT_ASC'
  | 'SORT_KEY_TOTAL_LIVING_SQ_FT_DESC';

/**
 * ActorType describes an entity that can be associated with a given lifecycle
 * domain object (PE / PT etc).
 */
export type OdProtosPropertyLifecycleDataActors_ActorType =
  | 'CONTACT_CUSTOMER'
  | 'UNKNOWN';

export type OdProtosPropertyLifecycleDataDip_DipBucketInput = {
  fromDurationDays?: InputMaybe<Scalars['Float']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  riskLevel?: InputMaybe<Scalars['Float']>;
  stageId?: InputMaybe<Scalars['String']>;
  toDurationDays?: InputMaybe<Scalars['Float']>;
  /** Only populated in response (for obvious reasons) */
  value?: InputMaybe<Scalars['Float']>;
};

export type OdProtosPropertyLifecycleDataPropertyEngagements_Assessment_State =
  | 'CANCELED'
  | 'COMPLETED'
  | 'SCHEDULED'
  | 'UNKNOWN'
  | 'WAITING_FOR_CUSTOMER';

export type OdProtosPropertyLifecycleDataPropertyEngagements_BuyerRepairNegotiation_State =
  | 'ACCEPTED'
  | 'ADDENDUM_OUT'
  | 'CANCELED'
  | 'CREDIT_ONLY_ACCEPTED'
  | 'DRAFT'
  | 'ESTIMATING'
  | 'ESTIMATION_COMPLETE'
  | 'RENEGOTIATING'
  | 'UNKNOWN'
  | 'WORK_COMPLETED'
  | 'WORK_IN_PROGRESS'
  | 'ZERO_WORK_COMPLETED';

export type OdProtosPropertyLifecycleDataPropertyEngagements_BwodLead_State =
  | 'OFFERED'
  | 'UNKNOWN';

export type OdProtosPropertyLifecycleDataPropertyEngagements_DebtFinancing_State =
  | 'FUNDED'
  | 'IN_PROGRESS'
  | 'UNKNOWN';

export type OdProtosPropertyLifecycleDataPropertyEngagements_DigitalCheckout_State =
  | 'APPROVED'
  | 'CANCELED'
  | 'DRAFT'
  | 'SUBMITTED'
  | 'UNKNOWN';

export type OdProtosPropertyLifecycleDataPropertyEngagements_DirectLead_State =
  | 'CREATED'
  | 'DENIED'
  | 'PRELIM_OFFER_SENT'
  | 'QUALIFIED'
  | 'UNKNOWN';

export type OdProtosPropertyLifecycleDataPropertyEngagements_DirectOffer_State =
  /** Terminated Success */
  | 'CLOSED'
  /**
   * Deprecated: New offers will not enter these states
   * Old offers may be in these states
   */
  | 'CREATED'
  /** Terminated Failure */
  | 'CUSTOMER_WITHDRAWN'
  | 'ENTERED_CONTRACT'
  /** Terminated Failure */
  | 'EXPIRED'
  | 'FINAL_OFFER_SENT'
  /** Will stay in FINAL_OFFER_SENT until we enter contract */
  | 'FINAL_OFFER_VIEWED'
  /**
   * We are in LATE_CHECKOUT when we own the home, but we don't have
   * possession yet due to late checkout
   */
  | 'LATE_CHECKOUT'
  /** Terminated Failure */
  | 'OPENDOOR_WITHDRAWN'
  /** This PE will start once the prelim offer is sent */
  | 'PRELIM_OFFER_SENT'
  /** Replaced by ENTERED_CONTRACT */
  | 'RELEASED_CONTINGENCIES'
  | 'UNKNOWN'
  /** Replaced by CUSTOMER_WITHDRAWN and OPENDOOR_WITHDRAWN */
  | 'WITHDRAWN';

export type OdProtosPropertyLifecycleDataPropertyEngagements_ExclusiveListing_State =
  | 'AWAITING_SELLER_COMMITMENT'
  | 'EXPIRED'
  | 'IN_CONTRACT'
  | 'LISTED'
  | 'SETUP_STARTED'
  | 'SOLD'
  | 'UNKNOWN';

export type OdProtosPropertyLifecycleDataPropertyEngagements_ExternalListing_State =
  | 'ACTIVE'
  | 'ATTORNEY_REVIEW'
  | 'CANCELED'
  | 'CONTINGENCY_RELEASED'
  | 'INACTIVE'
  | 'IN_CONTRACT'
  | 'SOLD'
  | 'UNKNOWN';

export type OdProtosPropertyLifecycleDataPropertyEngagements_HomeAccessMonitoring_State =
  | 'ACCESS_AVAILABLE'
  | 'ACCESS_MONITORING_AVAILABLE'
  | 'COMPLETED'
  | 'MONITORING_AVAILABLE'
  | 'REQUESTED'
  | 'UNKNOWN';

export type OdProtosPropertyLifecycleDataPropertyEngagements_InventoryListing_State =
  | 'ACTIVE'
  | 'ATTORNEY_REVIEW'
  | 'CANCELED'
  | 'CONTINGENCY_RELEASED'
  | 'DRAFT'
  | 'IN_CONTRACT'
  | 'SOLD'
  | 'UNKNOWN'
  | 'UPCOMING';

export type OdProtosPropertyLifecycleDataPropertyEngagements_InventoryMaintenance_State =
  | 'ACTIVE'
  | 'INACTIVE'
  | 'UNKNOWN';

export type OdProtosPropertyLifecycleDataPropertyEngagements_InventoryReno_State =
  | 'CANCELED'
  | 'COMPLETED'
  | 'DRAFT'
  | 'IN_PROGRESS'
  | 'UNKNOWN';

export type OdProtosPropertyLifecycleDataPropertyEngagements_Inventory_State =
  | 'ACQUIRING'
  | 'NOT_ACQUIRED'
  | 'ON_THE_MARKET'
  | 'PREP_FOR_RESALE'
  | 'RESERVED'
  | 'SELLABLE'
  | 'SELLING'
  /** OWNERSHIP_EXCEPTION = 9; */
  | 'SOLD'
  | 'UNKNOWN';

export type OdProtosPropertyLifecycleDataPropertyEngagements_LenderRequiredRepairs_State =
  | 'ADDENDUM_ACCEPTED'
  | 'ADDENDUM_CREATED'
  | 'CANCELED'
  | 'CREATED'
  | 'DRAFT'
  | 'ESTIMATED'
  | 'UNKNOWN'
  | 'WORK_ORDERS_COMPLETE'
  | 'WORK_ORDERS_CREATED';

export type OdProtosPropertyLifecycleDataPropertyEngagements_MaintenanceSchedule_Metadata_MaintenanceKind =
  | 'CLEANING'
  | 'HVAC'
  | 'LANDSCAPING'
  | 'OTHER'
  | 'POOL'
  | 'SNOW'
  | 'UNKNOWN';

export type OdProtosPropertyLifecycleDataPropertyEngagements_MaintenanceSchedule_State =
  | 'ACTIVE'
  | 'CANCELED'
  | 'FINISHED'
  | 'REQUESTED'
  | 'SCHEDULED'
  | 'UNKNOWN';

export type OdProtosPropertyLifecycleDataPropertyEngagements_OboBuyerOffer_State =
  | 'ACTIVE'
  | 'AWAITING_SIGNATURE'
  | 'BUYER_WALKED'
  | 'CANCELED'
  | 'CLOSED'
  | 'CONTINGENCIES_RELEASED'
  | 'CONTRACT_FELL_THROUGH'
  | 'IN_CONTRACT'
  | 'UNKNOWN';

export type OdProtosPropertyLifecycleDataPropertyEngagements_OboBwodOffer_State =
  | 'ACQ_WITHDRAWN'
  | 'CANCELED'
  | 'CONTINGENCIES_RELEASED'
  | 'IN_CONTRACT'
  | 'LISTED'
  | 'PRE_RENOVATION'
  | 'RESALE_CONTINGENCIES_RELEASED'
  | 'RESALE_IN_CONTRACT'
  | 'SOLD'
  | 'UNKNOWN';

export type OdProtosPropertyLifecycleDataPropertyEngagements_ReitReno_State =
  /** Terminal sad */
  | 'CANCELED'
  /** Terminal happy */
  | 'COMPLETED'
  | 'IN_PROGRESS'
  | 'PLANNED'
  | 'UNKNOWN';

export type OdProtosPropertyLifecycleDataPropertyEngagements_RenoPrep_State =
  | 'CANCELED'
  | 'COMPLETED'
  | 'REQUESTED'
  | 'UNKNOWN';

export type OdProtosPropertyLifecycleDataPropertyEngagements_RenoProjectExecution_State =
  /** Terminal sad */
  | 'CANCELED'
  /** Terminal happy */
  | 'COMPLETED'
  | 'IN_PROGRESS'
  | 'PLANNED'
  | 'UNKNOWN';

export type OdProtosPropertyLifecycleDataPropertyEngagements_RenoRepairScoping_State =
  | 'CANCELED'
  | 'COMPLETED'
  | 'REQUESTED'
  | 'STARTED'
  | 'UNKNOWN';

/** Kind is analgous to listing offer channel. */
export type OdProtosPropertyLifecycleDataPropertyEngagements_ResaleBuyerOffer_Metadata_Kind =
  /** Opendoor is the brokerage */
  | 'BROKERAGE'
  /** Buy Direct */
  | 'DIRECT'
  /** Exclusive Listing */
  | 'EXCLUSIVE'
  /** Exclusive Third Party (3P) */
  | 'EXCLUSIVE_THIRD_PARTY'
  /** External Listing */
  | 'EXTERNAL'
  | 'REIT'
  | 'UNKNOWN';

export type OdProtosPropertyLifecycleDataPropertyEngagements_ResaleBuyerOffer_State =
  | 'ACTIVE'
  | 'ATTORNEY_REVIEW'
  | 'AWAITING_SIGNATURE'
  | 'BACKUP'
  | 'BUYER_WALKED'
  /** This state is terminal (sad). */
  | 'CANCELED'
  /** This state is terminal (happy). */
  | 'CLOSED'
  | 'CONTINGENCIES_RELEASED'
  | 'CONTRACT_FELLTHROUGH'
  | 'COUNTERED'
  | 'IN_CONTRACT'
  | 'IN_NEGOTIATION'
  /** This state is terminal (sad). */
  | 'REJECTED'
  | 'UNKNOWN';

export type OdProtosPropertyLifecycleDataPropertyEngagements_ResaleListing_State =
  | 'ACTIVE'
  | 'ATTORNEY_REVIEW'
  | 'CANCELED'
  | 'CONTINGENCY_RELEASED'
  | 'INACTIVE'
  | 'IN_CONTRACT'
  | 'SOLD'
  | 'UNKNOWN';

/** The list of supported property engagement types */
export type OdProtosPropertyLifecycleDataPropertyEngagements_Type =
  | 'ACQUISITION_DATA_LABELING'
  | 'ACQUISITION_REPAIR_BUDGET_REVIEW'
  | 'ACQUISITION_RISK_ASSESSMENT'
  | 'ACQUISITION_UNDERWRITING'
  | 'ACQUISITION_VALUATION'
  | 'ASSESSSMENT'
  | 'BUYER_REPAIR_NEGOTIATION'
  | 'BWOD_LEAD'
  | 'DEBT_FINANCING'
  | 'DIGITAL_CHECKOUT'
  | 'DIRECT_LEAD'
  | 'DIRECT_OFFER'
  | 'EXCLUSIVE_LISTING'
  | 'EXTERNAL_LISTING'
  | 'HOME_ACCESS_MONITORING'
  | 'INVENTORY'
  | 'INVENTORY_LISTING'
  | 'INVENTORY_MAINTENANCE'
  | 'INVENTORY_RENO'
  | 'LENDER_REQUIRED_REPAIRS'
  | 'MAINTENANCE_SCHEDULE'
  | 'OBO_BUYER_OFFER'
  | 'OBO_BWOD_OFFER'
  | 'REIT_RENO'
  | 'RENO_PREP'
  | 'RENO_PROJECT_EXECUTION'
  | 'RENO_REPAIR_SCOPING'
  | 'RESALE_BUYER_OFFER'
  | 'RESALE_BUY_DIRECT'
  | 'RESALE_INVENTORY'
  | 'RESALE_LISTING'
  /** register all PE types here */
  | 'SELL_WITH_UPSIDE_PRICING'
  | 'THIRD_PARTY_MARKETPLACE_LISTING'
  | 'UNKNOWN';

/**
 * LifecycleState describes the lifecycle state of a property engagement or
 * property task from the perspective of the property lifecycle domain.
 *
 * Domain-specific PE/PT states are tracked separately and are defined
 * on a per-PE/PT basis
 */
export type OdProtosPropertyLifecycleData_LifecycleState =
  /**
   * The PE/PT is active. When a PE/PT is ACTIVE, its domain state is used to
   * reflect its state specific to the type of PE/PT
   */
  | 'ACTIVE'
  /** The PE/PT is in a paused state */
  | 'PAUSED'
  /**
   * The PLD has requested that the implementing domain create a PE/PT,
   * however an event confirming its creation hasn't been received yet
   */
  | 'REQUESTED'
  /** The PE/PT has terminated with a failure */
  | 'TERMINATED_FAILURE'
  /** The PE/PT has terminated successfully */
  | 'TERMINATED_SUCCESS'
  | 'UNKNOWN';

/**
 * The LifecycleState enum provides is used to notify the property lifecycle
 * domain how a property engagement's lifecycle state has changed from within
 * a domain event.
 */
export type OdProtosPropertyLifecycleEvents_PropertyLifecycleInputMessage_PropertyEngagementEvent_LifecycleState =
  /** The property engagement is active */
  | 'ACTIVE'
  /** The property engagement has terminated with a failed outcome */
  | 'TERMINATED_FAILURE'
  /** The property engagement has terminated with a successful outcome */
  | 'TERMINATED_SUCCESS'
  /**
   * The property engagement's lifecycle state is unchanged by this
   * domain event
   */
  | 'UNKNOWN';

/**
 * The LifecycleState enum provides is used to notify the property lifecycle
 * domain how a property engagement's lifecycle state has changed from within
 * a domain event.
 */
export type OdProtosPropertyLifecycleEvents_PropertyLifecycleMessage_PropertyEngagementEvent_LifecycleState =
  /** The property engagement is active */
  | 'ACTIVE'
  /** The property engagement has terminated with a failed outcome */
  | 'TERMINATED_FAILURE'
  /** The property engagement has terminated with a successful outcome */
  | 'TERMINATED_SUCCESS'
  /**
   * The property engagement's lifecycle state is unchanged by this
   * domain event
   */
  | 'UNKNOWN';

export type OdProtosPropertyLifecycleServicesDip_GetDipMetrics_FiltersInput = {
  markets?: InputMaybe<Array<OdProtosCommonMarket_Market>>;
  postalCodes?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosPropertyLifecycleServicesDip_GetDipMetrics_RequestInput = {
  filters?: InputMaybe<OdProtosPropertyLifecycleServicesDip_GetDipMetrics_FiltersInput>;
};

export type OdProtosPropertyLifecycleServicesDip_GetDipProperties_FiltersInput = {
  /** List of client-defined buckets. Each has a specific associated stage ID from the server. */
  buckets?: InputMaybe<Array<OdProtosPropertyLifecycleDataDip_DipBucketInput>>;
  markets?: InputMaybe<Array<OdProtosCommonMarket_Market>>;
  postalCodes?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosPropertyLifecycleServicesDip_GetDipProperties_PaginationInput = {
  limit?: InputMaybe<Scalars['Float']>;
  offset?: InputMaybe<Scalars['Float']>;
};

export type OdProtosPropertyLifecycleServicesDip_GetDipProperties_RequestInput = {
  filters?: InputMaybe<OdProtosPropertyLifecycleServicesDip_GetDipProperties_FiltersInput>;
  pagination?: InputMaybe<OdProtosPropertyLifecycleServicesDip_GetDipProperties_PaginationInput>;
};

export type OdProtosPropertyLifecycleServices_ApplyBpmnMigration_RequestInput = {
  _empty?: InputMaybe<Scalars['Boolean']>;
};

export type OdProtosPropertyLifecycleServices_DeletePropertyEngagement_RequestInput = {
  propertyEngagementId?: InputMaybe<Scalars['String']>;
};

export type OdProtosPropertyLifecycleServices_DipAggregationType =
  | 'AVERAGE'
  | 'UNKNOWN';

export type OdProtosPropertyLifecycleServices_EnqueueBackfill_RequestInput = {
  backfillAllFlips?: InputMaybe<Scalars['Boolean']>;
  backfillAllYears?: InputMaybe<Scalars['Boolean']>;
  /** if set it will run the PE metadata backfill */
  backfillPeMetadata?: InputMaybe<Scalars['Boolean']>;
  backfillPeMetadataLimit?: InputMaybe<Scalars['Float']>;
  backfillPeMetadataOffset?: InputMaybe<Scalars['Float']>;
  /** if set will run only state mismatch data fix and COE date mismatch */
  dataFix?: InputMaybe<Scalars['Boolean']>;
  /** if set will run only the incremental PE backfill */
  incremental?: InputMaybe<Scalars['Boolean']>;
  /** if set will run only the inventory PE backfill */
  inventory?: InputMaybe<Scalars['Boolean']>;
  /** if set it will run the inventory listing backfill */
  inventoryListing?: InputMaybe<Scalars['Boolean']>;
  /** if set it will run the inventory reno backfill */
  inventoryReno?: InputMaybe<Scalars['Boolean']>;
  /** if set it will run the maintenance schedule backfill */
  maintenanceSchedule?: InputMaybe<Scalars['Boolean']>;
  tier?: InputMaybe<Scalars['Float']>;
  year?: InputMaybe<Scalars['Float']>;
};

export type OdProtosPropertyLifecycleServices_GetDipMetrics_RequestInput = {
  aggregationType?: InputMaybe<OdProtosPropertyLifecycleServices_DipAggregationType>;
};

export type OdProtosPropertyLifecycleServices_GetPropertyEngagementEventLog_RequestInput = {
  propertyEngagementId?: InputMaybe<Scalars['String']>;
};

export type OdProtosPropertyLifecycleServices_GetPropertyEngagementsV1_RequestInput = {
  /** by is the primary filter */
  by?: InputMaybe<OdProtosPropertyLifecycleServices_GetPropertyEngagementsV1_Request_ByOneofInput>;
  /**
   * fetch_events: if set the service will populate all events for the
   * PE's in the response
   */
  fetchEvents?: InputMaybe<Scalars['Boolean']>;
  /** Each filter is AND'd together, for example, returned PEs must be one of the PE types, one of the states given, etc. */
  filter?: InputMaybe<Array<OdProtosPropertyLifecycleServices_GetPropertyEngagementsV1_Request_FilterInput>>;
  paginationRequest?: InputMaybe<OdProtosPropertyLifecycleServices_PaginationRequestInput>;
};

export type OdProtosPropertyLifecycleServices_GetPropertyEngagementsV1_Request_ByOneofInput = {
  customerId?: InputMaybe<Scalars['String']>;
  propertyEngagementGroupIds?: InputMaybe<OdProtosPropertyLifecycleServices_PropertyEngagementGroupIDsInput>;
  propertyEngagementIds?: InputMaybe<OdProtosPropertyLifecycleServices_GetPropertyEngagementsV1_Request_PropertyEngagementIDsInput>;
  propertyId?: InputMaybe<Scalars['String']>;
};

export type OdProtosPropertyLifecycleServices_GetPropertyEngagementsV1_Request_FilterInput = {
  by?: InputMaybe<OdProtosPropertyLifecycleServices_GetPropertyEngagementsV1_Request_Filter_ByOneofInput>;
};

export type OdProtosPropertyLifecycleServices_GetPropertyEngagementsV1_Request_Filter_ByOneofInput = {
  lifecycleStates?: InputMaybe<OdProtosPropertyLifecycleServices_LifecycleStatesInput>;
  /**
   * When min_completed_at is set it filters out all
   * PEs completed before that date.
   * Note that uncompleted PEs will not be filtered out.
   */
  minCompletedAt?: InputMaybe<Scalars['DateTime']>;
  propertyEngagementTypes?: InputMaybe<OdProtosPropertyLifecycleServices_PropertyEngagementTypesInput>;
};

export type OdProtosPropertyLifecycleServices_GetPropertyEngagementsV1_Request_PropertyEngagementIDsInput = {
  ids?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosPropertyLifecycleServices_GetPropertyEngagements_RequestInput = {
  by?: InputMaybe<OdProtosPropertyLifecycleServices_GetPropertyEngagements_Request_ByOneofInput>;
};

export type OdProtosPropertyLifecycleServices_GetPropertyEngagements_Request_ByOneofInput = {
  customerId?: InputMaybe<Scalars['String']>;
  propertyEngagementIds?: InputMaybe<OdProtosPropertyLifecycleServices_GetPropertyEngagements_Request_PropertyEngagementIDsInput>;
  propertyId?: InputMaybe<Scalars['String']>;
};

export type OdProtosPropertyLifecycleServices_GetPropertyEngagements_Request_PropertyEngagementIDsInput = {
  ids?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosPropertyLifecycleServices_GetPropertyEventLog_RequestInput = {
  by?: InputMaybe<OdProtosPropertyLifecycleServices_GetPropertyEventLog_Request_ByOneofInput>;
};

export type OdProtosPropertyLifecycleServices_GetPropertyEventLog_Request_ByOneofInput = {
  addressToken?: InputMaybe<Scalars['String']>;
  propertyId?: InputMaybe<Scalars['String']>;
};

export type OdProtosPropertyLifecycleServices_GetProperty_RequestInput = {
  /**
   * Property can be referenced either by the PLD property ID or
   * the address token currently mapped to the property
   */
  by?: InputMaybe<OdProtosPropertyLifecycleServices_GetProperty_Request_ByOneofInput>;
};

export type OdProtosPropertyLifecycleServices_GetProperty_Request_ByOneofInput = {
  addressToken?: InputMaybe<Scalars['String']>;
  propertyId?: InputMaybe<Scalars['String']>;
};

export type OdProtosPropertyLifecycleServices_LifecycleStatesInput = {
  allowedLifecycleStates?: InputMaybe<Array<OdProtosPropertyLifecycleData_LifecycleState>>;
};

export type OdProtosPropertyLifecycleServices_PaginationRequestInput = {
  /**
   * after is the cursor value at which point we should start
   * leave blank to start in the beginning
   */
  after?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Float']>;
};

export type OdProtosPropertyLifecycleServices_PropertyEngagementGroupIDsInput = {
  propertyEngagementGroupIds?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosPropertyLifecycleServices_PropertyEngagementTypesInput = {
  types?: InputMaybe<Array<OdProtosPropertyLifecycleDataPropertyEngagements_Type>>;
};

export type OdProtosQacServices_CheckForServiceRequestInput = {
  envId?: InputMaybe<Scalars['String']>;
  /** The k8s service name (in staging) of the service */
  stagingName?: InputMaybe<Scalars['String']>;
};

export type OdProtosQacServices_CreateEnvRequestInput = {
  /** Arbitrary name, usually branch or PR */
  name?: InputMaybe<Scalars['String']>;
  /** Email of the user who created the environment */
  userEmail?: InputMaybe<Scalars['String']>;
};

export type OdProtosQacServices_DeleteEnvRequestInput = {
  envId?: InputMaybe<Scalars['String']>;
};

export type OdProtosQacServices_GetEnvRequestInput = {
  envId?: InputMaybe<Scalars['String']>;
};

export type OdProtosQacServices_GithubSpecInput = {
  branch?: InputMaybe<Scalars['String']>;
  cloneDb?: InputMaybe<Scalars['Boolean']>;
  /** Typically you will just set one or the other of these, although setting both is supported. */
  imageTag?: InputMaybe<Scalars['String']>;
  /** substitute for repo/path */
  name?: InputMaybe<Scalars['String']>;
  path?: InputMaybe<Scalars['String']>;
  /** Used to redeploy on pushes. If set, ignore image_tag and branch. */
  prUrl?: InputMaybe<Scalars['String']>;
  repo?: InputMaybe<Scalars['String']>;
};

export type OdProtosQacServices_GooseMockInput = {
  /** E.g., prices.acquisition.testing.TestFeeService. See goose README */
  gooseModule?: InputMaybe<Scalars['String']>;
  /** The k8s service name (in staging) of the service being mocked */
  stagingName?: InputMaybe<Scalars['String']>;
};

export type OdProtosQacServices_GooseMocksInput = {
  /** Github branch of Goose mocks (if not master). Will be deprecated once PR pipelines are setup */
  branch?: InputMaybe<Scalars['String']>;
  grpc?: InputMaybe<Array<OdProtosQacServices_GooseMockInput>>;
  /** Not supported yet */
  http?: InputMaybe<Array<OdProtosQacServices_GooseMockInput>>;
  /** Goose Docker image tag. Will be deprecated once PR pipelines for building images is setup */
  imageTag?: InputMaybe<Scalars['String']>;
  /** Used to redeploy on pushes. If set, ignore image_tag and branch. */
  prUrl?: InputMaybe<Scalars['String']>;
};

export type OdProtosQacServices_HandlePullRequestEventRequestInput = {
  action?: InputMaybe<Scalars['String']>;
  prUrl?: InputMaybe<Scalars['String']>;
};

export type OdProtosQacServices_ListEnvsRequestInput = {
  _empty?: InputMaybe<Scalars['Boolean']>;
};

export type OdProtosQacServices_PostponeEnvCleanupRequestInput = {
  envId?: InputMaybe<Scalars['String']>;
};

export type OdProtosQacServices_RedeployServicesRequestInput = {
  /** Image tag for each path returned by ServicesForPr, or in service_branches */
  imageTags?: InputMaybe<Array<OdProtosQacServices_RedeployServicesRequest_ImageTagsEntryInput>>;
  /** If given, QAC redeploys all envs with services using this PR */
  prUrl?: InputMaybe<Scalars['String']>;
  /** Redeploys all envs with services running on the given branches */
  serviceBranches?: InputMaybe<Array<OdProtosQacServices_ServiceBranchInput>>;
};

/** `OdProtosQacServices_RedeployServicesRequest_ImageTagsEntryInput` represents the `image_tags` map in `od_protos.qac.services.RedeployServicesRequest`. */
export type OdProtosQacServices_RedeployServicesRequest_ImageTagsEntryInput = {
  key?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

export type OdProtosQacServices_ServiceBranchInput = {
  branch?: InputMaybe<Scalars['String']>;
  path?: InputMaybe<Scalars['String']>;
  repo?: InputMaybe<Scalars['String']>;
};

export type OdProtosQacServices_ServiceSpecInput = {
  spec?: InputMaybe<OdProtosQacServices_ServiceSpec_SpecOneofInput>;
};

export type OdProtosQacServices_ServiceSpec_SpecOneofInput = {
  github?: InputMaybe<OdProtosQacServices_GithubSpecInput>;
  /** See py/projects/goose */
  goose?: InputMaybe<OdProtosQacServices_GooseMocksInput>;
};

export type OdProtosQacServices_ServicesForPrRequestInput = {
  prUrl?: InputMaybe<Scalars['String']>;
};

export type OdProtosQacServices_SetBuildUrlRequestInput = {
  buildUrl?: InputMaybe<Scalars['String']>;
  prUrl?: InputMaybe<Scalars['String']>;
};

export type OdProtosQacServices_SetServicesRequestInput = {
  envId?: InputMaybe<Scalars['String']>;
  services?: InputMaybe<Array<OdProtosQacServices_ServiceSpecInput>>;
};

/** The actor doing the thing */
export type OdProtosRealtyCommon_ActorInput = {
  userId?: InputMaybe<Scalars['String']>;
};

export type OdProtosRealtyCommon_AgentInformationInput = {
  contact?: InputMaybe<OdProtosRealtyCommon_ContactInput>;
  license?: InputMaybe<OdProtosBrokeragesData_RealEstateLicenseInput>;
  mlsId?: InputMaybe<OdProtosBrokeragesData_MlsidInput>;
  officeMlsId?: InputMaybe<Scalars['String']>;
  officeName?: InputMaybe<Scalars['String']>;
};

export type OdProtosRealtyCommon_CoeTermInput = {
  date?: InputMaybe<Scalars['String']>;
};

export type OdProtosRealtyCommon_CommissionBreakdownInput = {
  buyer?: InputMaybe<OdProtosRealtyCommon_CommissionInput>;
  seller?: InputMaybe<OdProtosRealtyCommon_CommissionInput>;
};

export type OdProtosRealtyCommon_CommissionInput = {
  type?: InputMaybe<OdProtosRealtyCommon_Commission_TypeOneofInput>;
};

export type OdProtosRealtyCommon_Commission_TypeOneofInput = {
  flatCents?: InputMaybe<Scalars['Float']>;
  /** `1 bip = 1%/100` = 1/10000 */
  rateBips?: InputMaybe<Scalars['Float']>;
};

/**
 * Contact records information
 * about a contact. Person, organization, customer etc.
 */
export type OdProtosRealtyCommon_ContactInput = {
  address?: InputMaybe<OdProtosCommonData_AddressInput>;
  customerId?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  legalName?: InputMaybe<Scalars['String']>;
  license?: InputMaybe<OdProtosBrokeragesData_RealEstateLicenseInput>;
  mlsId?: InputMaybe<OdProtosBrokeragesData_MlsidInput>;
  name?: InputMaybe<Scalars['String']>;
  organizationId?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  phoneNumbers?: InputMaybe<Array<OdProtosRealtyCommon_PhoneNumberInput>>;
  userId?: InputMaybe<Scalars['String']>;
  vendorBranchId?: InputMaybe<Scalars['String']>;
};

export type OdProtosRealtyCommon_CreditTermInput = {
  beneficiary?: InputMaybe<Scalars['String']>;
  creditCents?: InputMaybe<Scalars['Float']>;
  creditReason?: InputMaybe<Scalars['String']>;
  responsibleParty?: InputMaybe<OdProtosRealtyCommon_PartyType>;
};

/**
 * Any disclosures that need to be made by either party.
 * Includes leans, easements, seller disclosures, or covenants.
 */
export type OdProtosRealtyCommon_DisclosureInput = {
  description?: InputMaybe<Scalars['String']>;
  documentId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  identifier?: InputMaybe<OdProtosRealtyCommon_Disclosure_IdentifierOneofInput>;
  kind?: InputMaybe<OdProtosRealtyCommon_Disclosure_Kind>;
};

export type OdProtosRealtyCommon_Disclosure_IdentifierOneofInput = {
  buyOfferId?: InputMaybe<Scalars['String']>;
  negotiationId?: InputMaybe<Scalars['String']>;
  sellRequestId?: InputMaybe<Scalars['String']>;
};

export type OdProtosRealtyCommon_Disclosure_Kind =
  | 'COVENANT_DISCLOSURE'
  | 'EASEMENT_DISCLOSURE'
  | 'FINANCING_DISCLOSURE'
  | 'LEAN_DISCLOSURE'
  | 'OTHER_DISCLOSURE'
  | 'SELLER_DISCLOSURE';

export type OdProtosRealtyCommon_FeeTermInput = {
  beneficiary?: InputMaybe<Scalars['String']>;
  feeCents?: InputMaybe<Scalars['Float']>;
  responsibleParty?: InputMaybe<OdProtosRealtyCommon_PartyType>;
};

export type OdProtosRealtyCommon_FinancingTermInput = {
  type?: InputMaybe<OdProtosRealtyCommon_FinancingTerm_FinancingType>;
};

export type OdProtosRealtyCommon_FinancingTerm_FinancingType =
  | 'ALL_CASH'
  | 'CONVENTIONAL_LOAN'
  | 'FHA_LOAN'
  | 'TX_VA_LOAN'
  | 'UNKNOWN_FINANCING'
  | 'USDA_LOAN'
  | 'VA_LOAN';

export type OdProtosRealtyCommon_OptionPeriodTermInput = {
  _empty?: InputMaybe<Scalars['Boolean']>;
};

export type OdProtosRealtyCommon_OtherTermInput = {
  description?: InputMaybe<Scalars['String']>;
};

export type OdProtosRealtyCommon_PartyType =
  | 'BUYER'
  | 'SELLER'
  | 'UNKNOWN';

export type OdProtosRealtyCommon_PhoneNumberInput = {
  description?: InputMaybe<Scalars['String']>;
  number?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<OdProtosRealtyCommon_PhoneNumber_Type>;
};

export type OdProtosRealtyCommon_PhoneNumber_Type =
  | 'FAX'
  | 'HOME'
  | 'MOBILE'
  | 'OTHER'
  | 'WORK';

export type OdProtosRealtyCommon_PriceTermInput = {
  priceCents?: InputMaybe<Scalars['Float']>;
};

export type OdProtosRealtyCommon_RepairTermInput = {
  requiredRepairDescription?: InputMaybe<Scalars['String']>;
  responsibleParty?: InputMaybe<OdProtosRealtyCommon_PartyType>;
};

export type OdProtosRealtyCommon_SourceInput = {
  /** Optional. The private/system ID from the source. For example, the MLS resource ID. */
  externalId?: InputMaybe<Scalars['String']>;
  /** Required. The public/known ID from the source. For example, the MLS number. */
  id?: InputMaybe<Scalars['String']>;
  /** Used when type is `MLS`. */
  mls?: InputMaybe<OdProtosCommonMls_Mls>;
  /** Required. The type of the source information for grouping/sorting later. */
  type?: InputMaybe<OdProtosRealtyCommon_Source_Type>;
};

export type OdProtosRealtyCommon_Source_Type =
  /** From a homebuilder. */
  | 'HOMEBUILDER'
  /** From a listing agent and off MLS. */
  | 'LISTING_AGENT'
  /** From an MLS. If set, please also set the mls field. */
  | 'MLS'
  /** From Opendoor, when they are selling (e.g. resale). */
  | 'PROP_CO'
  /** From a direct seller who entered their address on the Opendoor seller flow. */
  | 'SELLER_CO'
  | 'UNKNOWN_TYPE';

/**
 * A contractual term that can become part of the contract if both parties agree to it.
 *
 * Terms are immutable--the details may never be modified.
 * In SellRequests and BuyOffers, terms may be freely added and deleted.
 * In Negotiations, terms may be proposed but not deleted. If a term should be removed, both
 * parties must REJECT the term.
 */
export type OdProtosRealtyCommon_TermInput = {
  id?: InputMaybe<Scalars['String']>;
  proposedAt?: InputMaybe<Scalars['DateTime']>;
  proposerParty?: InputMaybe<OdProtosRealtyCommon_PartyType>;
  proposerUserToken?: InputMaybe<Scalars['String']>;
  termOneof?: InputMaybe<OdProtosRealtyCommon_TermOneofInput>;
};

/** Wrapper around term oneof. */
export type OdProtosRealtyCommon_TermOneofInput = {
  type?: InputMaybe<OdProtosRealtyCommon_TermOneof_TypeOneofInput>;
};

export type OdProtosRealtyCommon_TermOneof_TypeOneofInput = {
  coe?: InputMaybe<OdProtosRealtyCommon_CoeTermInput>;
  credit?: InputMaybe<OdProtosRealtyCommon_CreditTermInput>;
  fee?: InputMaybe<OdProtosRealtyCommon_FeeTermInput>;
  financing?: InputMaybe<OdProtosRealtyCommon_FinancingTermInput>;
  optionPeriod?: InputMaybe<OdProtosRealtyCommon_OptionPeriodTermInput>;
  other?: InputMaybe<OdProtosRealtyCommon_OtherTermInput>;
  price?: InputMaybe<OdProtosRealtyCommon_PriceTermInput>;
  repair?: InputMaybe<OdProtosRealtyCommon_RepairTermInput>;
};

/**
 * these values needs to correspond to od_protos.realty.clearinghouse.data.Transaction.State
 * in order for Proforma and Clearinghouse to understand each other
 */
export type OdProtosRealtyDocumentsData_ClearinghouseSpecific_ClearinghouseState =
  | 'CLOSED'
  | 'DISCARDED'
  | 'DRAFT'
  | 'IN_CONTRACT'
  | 'LATE_CHECKOUT'
  /** NONE indicates that no state is chosen */
  | 'NONE'
  | 'OPEN'
  | 'REJECTED'
  | 'TERMINATED'
  | 'UNKNOWN_STATE';

/**
 * these values needs to correspond to od_protos.realty.clearinghouse.data.TermType.Type
 * in order for Proforma and Clearinghouse to understand each other
 */
export type OdProtosRealtyDocumentsData_ClearinghouseSpecific_ClearinghouseTerm =
  | 'ADDITIONAL_EARNEST_DEPOSIT'
  | 'APPRAISAL_DATE'
  | 'BUYER_BROKER_COMMISSION'
  | 'CLOSE_OF_ESCROW_DATE'
  | 'CONTINGENCY'
  | 'CONTRACT_EXPIRATION'
  | 'EARNEST_DEPOSIT'
  | 'EARNEST_DEPOSIT_DUE'
  | 'FINANCING_CONTINGENCY'
  | 'FUNDING_RELATED_DELAYS'
  | 'INSPECTION_CONTINGENCY'
  | 'LAND_SURVEY_REQUIREMENT'
  | 'OPENDOOR_COMMISSION'
  | 'PRICE'
  | 'RENT_BACK'
  | 'REPAIR'
  | 'RESOLUTION_PERIOD_CONTINGENCY'
  | 'SELLER_BROKER_COMMISSION'
  | 'SELLER_CREDIT'
  | 'SELLER_DISCLOSURES_DUE'
  | 'TERMINATION_OPTION'
  | 'TEXT_TERM'
  | 'TITLE_POLICY_AMENDMENT'
  | 'TITLE_POLICY_FEE';

/**
 * The general description of the document
 * The realty document will have many sub-types represented by the `DocumentDescriptor`
 * NEXT ID: 65
 */
export type OdProtosRealtyDocumentsData_DocumentDescriptor_Class =
  | 'ABAD'
  | 'ADDENDUM'
  | 'AGENCY_AGREEMENT'
  | 'AGENCY_DISCLOSURE'
  | 'AGREEMENT'
  | 'AMENDMENT'
  | 'APPRAISAL_REPORT'
  | 'ASSIGNMENT'
  | 'BILL_OF_SALE'
  | 'BUYER_PURCHASE_ADDENDUM'
  | 'CERTIFICATE_OF_OCCUPANCY'
  | 'CLOSING_DOCUMENTS'
  | 'COMISSION_INSTRUCTIONS'
  | 'COMPENSATION_AGREEMENT'
  | 'CONCIERGE_AGREEMENT'
  | 'CONCIERGE_INVOICE'
  | 'COUNTER_OFFER'
  | 'DEED'
  | 'DISCLOSURE'
  | 'EARNEST_MONEY_DEPOSIT_RECEIPT'
  | 'EARNEST_MONEY_RELEASE_FORM'
  | 'EXCLUSIVE_RIGHT_TO_SELL'
  | 'FINAL_REPAIR_ASK'
  | 'FINAL_SETTLEMENT_STATEMENT'
  | 'FINAL_WALKTHROUGH_VERIFICATION'
  | 'FIRPTA'
  | 'HOA_ADDENDUM'
  | 'HOA_DEMAND'
  | 'HOA_GOVERNING_DOCUMENTS'
  | 'HOA_QUESTIONNAIRE'
  | 'HOA_VIOLATION_RESOLUTION'
  | 'HOME_BUILDER_WARRANTY'
  | 'INSPECTION_REPORT'
  | 'LAND_SURVEY'
  | 'LCO_ADDENDUM'
  | 'LEAD_BASED_PAINT_DISCLOSURE'
  | 'LIEN_SEARCH'
  | 'LISTING_AGREEMENT'
  | 'LOAN_PAYOFF'
  | 'LOSS_HISTORY_REPORT'
  | 'MARKET_CONDITIONS_ADVISORY'
  | 'MISCELLANEOUS'
  | 'MLS_INPUT_FORM'
  | 'MLS_PRINTOUT'
  | 'MUD_DOCUMENT'
  | 'OPTION_FEE'
  | 'OPTION_MONEY_VERIFICATION'
  | 'OWNERS_POLICY'
  | 'PHOTO'
  | 'POWER_OF_ATTORNEY_AGREEMENT'
  | 'PRE_QUALIFICATION'
  | 'PRE_TERMINATION'
  | 'PURCHASE_AGREEMENT'
  | 'RECEIPT'
  | 'REFERRAL_AGREEMENT'
  | 'REFERRAL_W9'
  | 'REPAIR_CREDIT_ADDENDUM'
  | 'SELLER_PROPERTY_DISCLOSURE_STATEMENT'
  | 'T47'
  | 'TAX_CERTIFICATE'
  | 'TERMINATION'
  | 'TITLE_COMMITMENT'
  | 'TRANSFER_ADDENDUM'
  | 'UNKNOWN'
  | 'WIRE_INSTRUCTIONS';

/**
 * these values needs to correspond to od_protos.realty.clearinghouse.data.Transaction.State
 * in order for Proforma and Clearinghouse to understand each other
 */
export type OdProtosRealtyDocumentsData_DocumentDescriptor_ClearinghouseState =
  | 'CLOSED'
  | 'DISCARDED'
  | 'DRAFT'
  | 'IN_CONTRACT'
  /** NONE indicates that no state is chosen */
  | 'NONE'
  | 'OPEN'
  | 'REJECTED'
  | 'TERMINATED'
  | 'UNKNOWN_STATE';

export type OdProtosRealtyDocumentsData_DocumentDescriptor_Status =
  | 'ACTIVE'
  | 'INACTIVE';

export type OdProtosRealtyDocumentsData_PartyList_Party =
  | 'BUYER'
  | 'SELLER';

/** a template field can either be a boolean or a string */
export type OdProtosRealtyDocumentsData_TemplateFieldDescriptor_Type =
  | 'BOOLEAN'
  | 'STRING';

/** Represents an openhouse for a home. */
export type OdProtosRealtyOdlsData_OpenHouseInput = {
  /** Whether the open house is active. */
  active?: InputMaybe<Scalars['Boolean']>;
  contact?: InputMaybe<OdProtosRealtyCommon_ContactInput>;
  /** Create timestamp. Generated by the service. */
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** End timestamp in UTC. */
  endTime?: InputMaybe<Scalars['DateTime']>;
  /** The ID of the open house on the external system. */
  externalId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  sellRequestId?: InputMaybe<Scalars['String']>;
  /** Start timestamp in UTC. */
  startTime?: InputMaybe<Scalars['DateTime']>;
  /** The type of open house (i.e. public vs private). */
  type?: InputMaybe<OdProtosRealtyOdlsData_OpenHouse_Type>;
  /** Update timestamp. Generated by the service. */
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type OdProtosRealtyOdlsData_OpenHouse_Type =
  /** The open house is scheduled for a private showing. */
  | 'TYPE_PRIVATE'
  /** The open house is open to the public. */
  | 'TYPE_PUBLIC'
  | 'TYPE_UNKNOWN';

/**
 * Blobbly data on the sell request. The core functionality of Clearinghouse
 * does not need this data, but ODLS does pass this data on to buyers.
 * Next ID: 57
 */
export type OdProtosRealtyOdlsData_SellBlobInput = {
  /**
   * The raw address fields from the sell request source. May be used for display
   * purposes when the Casa address quality is bad.
   */
  address?: InputMaybe<OdProtosRealtyOdlsData_SellBlob_AddressInput>;
  /** List of non-photo assets. */
  assets?: InputMaybe<Array<OdProtosRealtyOdlsData_SellBlob_AssetInput>>;
  /** Only completed after a sale */
  buyerAgentInformation?: InputMaybe<OdProtosRealtyCommon_AgentInformationInput>;
  buyerConcessionsCents?: InputMaybe<Scalars['Float']>;
  cDom?: InputMaybe<Scalars['Float']>;
  /** Assume this to be in local time w.r.t. the home location */
  closedTimestamp?: InputMaybe<Scalars['DateTime']>;
  commissionBreakdown?: InputMaybe<OdProtosRealtyCommon_CommissionBreakdownInput>;
  /** Price fields */
  currentListPriceCents?: InputMaybe<Scalars['Float']>;
  currentLowPriceCents?: InputMaybe<Scalars['Float']>;
  /** Free-form text description of this sell request. */
  description?: InputMaybe<Scalars['String']>;
  disclosures?: InputMaybe<Array<OdProtosRealtyCommon_DisclosureInput>>;
  /** An opaque string for contact information required for public display. */
  displayContactInformation?: InputMaybe<Scalars['String']>;
  dom?: InputMaybe<Scalars['Float']>;
  entryTimestamp?: InputMaybe<Scalars['DateTime']>;
  /** Estimated date this sell request will be listed on the MLS. */
  estimatedMlsListDate?: InputMaybe<OdProtosCommon_DateInput>;
  /** Estimated date scheduled tour will be available. */
  estimatedScheduledTourAvailableDate?: InputMaybe<OdProtosCommon_DateInput>;
  /** Estimated date self tour will be available. */
  estimatedSelfTourAvailable?: InputMaybe<OdProtosCommon_DateInput>;
  /** Whether this sell request is currently eligible for an FHA loan. */
  fhaLoanEligible?: InputMaybe<Scalars['Boolean']>;
  /** When this sell request will be eligible for an FHA loan. */
  fhaLoanEligibleOn?: InputMaybe<OdProtosCommon_DateInput>;
  hasDocuments?: InputMaybe<Scalars['Boolean']>;
  /** HomeDataStore IDs pointing to immutable home detail data. */
  homeDetailId?: InputMaybe<Scalars['String']>;
  /** Optional. When the seller hopes the transaction will close by. This is an estimate. */
  hopefulCloseBy?: InputMaybe<Scalars['DateTime']>;
  /** Timestamps provided by the source for when various events happened. */
  listPriceChangedAt?: InputMaybe<Scalars['DateTime']>;
  /** Assume this to be in local time w.r.t. the home location */
  listTimestamp?: InputMaybe<Scalars['DateTime']>;
  listingAgentInformation?: InputMaybe<OdProtosRealtyCommon_AgentInformationInput>;
  mlsListingInformation?: InputMaybe<OdProtosRealtyOdlsData_SellBlob_MlsListingInformationInput>;
  modificationTimestamp?: InputMaybe<Scalars['DateTime']>;
  /**
   * Optional. When the seller requires the transaction to close by. This if often used when the
   * seller has a contingent purchase agreement.
   */
  mustCloseBy?: InputMaybe<Scalars['DateTime']>;
  newConstruction?: InputMaybe<Scalars['Boolean']>;
  occupancy?: InputMaybe<OdProtosRealtyOdlsData_SellBlob_Occupancy>;
  /** When true, signifies that a Listing can be unlocked remotely without a code. */
  odCodelessUnlock?: InputMaybe<Scalars['Boolean']>;
  /**
   * Matches Web's listing.published field.
   * For context, see https://opendoor.slack.com/archives/GUS9FUQ8Y/p1583947707054400
   */
  odPublished?: InputMaybe<Scalars['Boolean']>;
  /** The slug used for constructing Opendoor listing URLs. */
  odSlug?: InputMaybe<Scalars['String']>;
  offerCount?: InputMaybe<Scalars['Int']>;
  originalListPriceCents?: InputMaybe<Scalars['Float']>;
  permissions?: InputMaybe<OdProtosRealtyOdlsData_SellBlob_PermissionsInput>;
  /** Cabinet ID pointing to photos. */
  photoIds?: InputMaybe<Array<Scalars['String']>>;
  /** List of metadata that must align with `photo_ids`. */
  photoMetadata?: InputMaybe<Array<OdProtosRealtyOdlsData_SellBlob_PhotoMetadataInput>>;
  photoModificationTimestamp?: InputMaybe<Scalars['DateTime']>;
  /** See DATAS-540 */
  possibleShortSale?: InputMaybe<Scalars['Boolean']>;
  privateRemarks?: InputMaybe<Scalars['String']>;
  publicRemarks?: InputMaybe<Scalars['String']>;
  /** Assume this to be in local time w.r.t. the home location */
  salePendingTimestamp?: InputMaybe<Scalars['DateTime']>;
  /** Traditional scheduled tour is available with an agent. */
  scheduledTourAvailable?: InputMaybe<Scalars['Boolean']>;
  /**
   * Self tour at buyer's convenience.
   * TODO: Self tour times are currently not available on this API.
   */
  selfTourAvailable?: InputMaybe<Scalars['Boolean']>;
  sellerConcessionsCents?: InputMaybe<Scalars['Float']>;
  /** Data specific to the seller. Contact the seller to get the descriptor for this data. */
  sellerSpecificData?: InputMaybe<GoogleProtobuf_AnyInput>;
  showingInstructions?: InputMaybe<Array<Scalars['String']>>;
  soldPriceCents?: InputMaybe<Scalars['Float']>;
  specialListingConditions?: InputMaybe<OdProtosRealtyOdlsData_SellBlob_SpecialListingConditionsInput>;
  stateChangeTimestamp?: InputMaybe<Scalars['DateTime']>;
  subdivision?: InputMaybe<Scalars['String']>;
  /** Assume this to be in local time w.r.t. the home location */
  tempOffMarketTimestamp?: InputMaybe<Scalars['DateTime']>;
  /** Initial proposed terms of the transaction. */
  terms?: InputMaybe<Array<OdProtosRealtyCommon_TermInput>>;
  viewCount?: InputMaybe<Scalars['Int']>;
  virtualTourLinks?: InputMaybe<Array<Scalars['String']>>;
  visitCount?: InputMaybe<Scalars['Int']>;
  /** Assume this to be in local time w.r.t. the home location */
  withdrawnTimestamp?: InputMaybe<Scalars['DateTime']>;
  zoning?: InputMaybe<Scalars['String']>;
};

export type OdProtosRealtyOdlsData_SellBlob_AddressInput = {
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  latitude?: InputMaybe<Scalars['Float']>;
  longitude?: InputMaybe<Scalars['Float']>;
  postalCode?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  street?: InputMaybe<Scalars['String']>;
  unitNumber?: InputMaybe<Scalars['String']>;
};

export type OdProtosRealtyOdlsData_SellBlob_AssetInput = {
  /** The short text given to summarize the object. */
  caption?: InputMaybe<Scalars['String']>;
  /** The type of asset at the URL or HTML. */
  category?: InputMaybe<OdProtosRealtyOdlsData_SellBlob_Asset_Category>;
  /** The full robust description of the object. */
  description?: InputMaybe<Scalars['String']>;
  /** The JavaScript or other method to embed a video, image, virtual tour or other media. */
  html?: InputMaybe<Scalars['String']>;
  /** The transactional timestamp automatically recorded by the system representing when the media record was last modified. */
  modificationTimestamp?: InputMaybe<Scalars['DateTime']>;
  /** The display permission for this asset. */
  permission?: InputMaybe<Array<OdProtosRealtyOdlsData_SellBlob_Permission>>;
  /** The URI to the media file referenced by this record. */
  url?: InputMaybe<Scalars['String']>;
};

/** https://ddwiki.reso.org/display/DDW17/MediaCategory+Lookups */
export type OdProtosRealtyOdlsData_SellBlob_Asset_Category =
  | 'AGENT_PHOTO'
  | 'BRANDED_VIRTUAL_TOUR'
  | 'DOCUMENT'
  | 'FLOOR_PLAN'
  | 'OFFICE_LOGO'
  | 'OFFICE_PHOTO'
  | 'PHOTO'
  | 'UNBRANDED_VIRTUAL_TOUR'
  | 'UNKNOWN'
  | 'VIDEO';

export type OdProtosRealtyOdlsData_SellBlob_MlsListingInformationInput = {
  listingNumber?: InputMaybe<Scalars['String']>;
  mls?: InputMaybe<OdProtosCommonMls_Mls>;
};

export type OdProtosRealtyOdlsData_SellBlob_Occupancy =
  | 'OCCUPANCY_OWNER_OCCUPIED'
  | 'OCCUPANCY_TENANT_OCCUPIED'
  | 'OCCUPANCY_UNKNOWN'
  | 'OCCUPANCY_UNOCCUPIED';

/** Display permissions. According to RESO spec there's also IDX, VOW, agent-only, office-only, and firm-only. */
export type OdProtosRealtyOdlsData_SellBlob_Permission =
  | 'PRIVATE'
  | 'PUBLIC';

export type OdProtosRealtyOdlsData_SellBlob_PermissionsInput = {
  /**
   * Permit Automated Valuation Model on this sell request
   *
   * AVM stands for “Automated Valuation Model.” It is a program that automatically analyzes
   * various data points to produce an estimate on the current value of a home or property.
   */
  allowAvm?: InputMaybe<Scalars['Boolean']>;
  allowCommentsAndReviews?: InputMaybe<Scalars['Boolean']>;
  allowPublishToInternet?: InputMaybe<Scalars['Boolean']>;
  allowShowings?: InputMaybe<Scalars['Boolean']>;
  hideDisplayAddress?: InputMaybe<Scalars['Boolean']>;
  showSinglePhotoOnly?: InputMaybe<Scalars['Boolean']>;
};

export type OdProtosRealtyOdlsData_SellBlob_PhotoMetadataInput = {
  /** The short text given to summarize the object. Commonly used as the short description displayed under a photo. */
  caption?: InputMaybe<Scalars['String']>;
  /** The full robust description of the photo. */
  description?: InputMaybe<Scalars['String']>;
  /** The height of the image expressed in pixels. */
  height?: InputMaybe<Scalars['Float']>;
  /**
   * When set to true, the media record in question is the preferred photo.
   * This will typically mean the photo to be shown when only one of the photos is to be displayed.
   */
  isPreferred?: InputMaybe<Scalars['Boolean']>;
  /** The transactional timestamp automatically recorded by the system representing when the photo was last modified. */
  modificationTimestamp?: InputMaybe<Scalars['DateTime']>;
  /** The original URL of where the photo was downloaded from. */
  originalUrl?: InputMaybe<Scalars['String']>;
  /** The display permission for this photo. */
  permission?: InputMaybe<Array<OdProtosRealtyOdlsData_SellBlob_Permission>>;
  /** The width of the image expressed in pixels. */
  width?: InputMaybe<Scalars['Float']>;
};

export type OdProtosRealtyOdlsData_SellBlob_SpecialListingConditionsInput = {
  asIs?: InputMaybe<Scalars['Boolean']>;
  courtApprovalRequired?: InputMaybe<Scalars['Boolean']>;
  ownerAgent?: InputMaybe<Scalars['Boolean']>;
  ownerOccupiedRequirement?: InputMaybe<Scalars['Boolean']>;
  preForeclosure?: InputMaybe<Scalars['Boolean']>;
  probateSale?: InputMaybe<Scalars['Boolean']>;
  reo?: InputMaybe<Scalars['Boolean']>;
  shortSale?: InputMaybe<Scalars['Boolean']>;
};

/** Describes the distribution channels for this sell request */
export type OdProtosRealtyOdlsData_SellRequest_ChannelInput = {
  type?: InputMaybe<OdProtosRealtyOdlsData_SellRequest_Channel_TypeOneofInput>;
};

export type OdProtosRealtyOdlsData_SellRequest_ChannelType =
  | 'EXCLUSIVES'
  | 'INSTITUTIONAL_BUYER'
  | 'PUBLIC'
  | 'UNKNOWN_CHANNEL_TYPE';

/** Present this sell request to partner agents */
export type OdProtosRealtyOdlsData_SellRequest_Channel_AgentRepresentationChannelInput = {
  _empty?: InputMaybe<Scalars['Boolean']>;
};

/** Present this sell request to partners with early access */
export type OdProtosRealtyOdlsData_SellRequest_Channel_EarlyAccessChannelInput = {
  _empty?: InputMaybe<Scalars['Boolean']>;
};

/** Present this sell request to buyers on the Opendoor Exclusives platform */
export type OdProtosRealtyOdlsData_SellRequest_Channel_ExclusivesChannelInput = {
  _empty?: InputMaybe<Scalars['Boolean']>;
};

/** Present this sell request to institutional buyers */
export type OdProtosRealtyOdlsData_SellRequest_Channel_InstitutionalBuyerChannelInput = {
  _empty?: InputMaybe<Scalars['Boolean']>;
};

/** Present this sell request to the public */
export type OdProtosRealtyOdlsData_SellRequest_Channel_PublicChannelInput = {
  _empty?: InputMaybe<Scalars['Boolean']>;
};

export type OdProtosRealtyOdlsData_SellRequest_Channel_TypeOneofInput = {
  agentRepresentation?: InputMaybe<OdProtosRealtyOdlsData_SellRequest_Channel_AgentRepresentationChannelInput>;
  earlyAccess?: InputMaybe<OdProtosRealtyOdlsData_SellRequest_Channel_EarlyAccessChannelInput>;
  exclusives?: InputMaybe<OdProtosRealtyOdlsData_SellRequest_Channel_ExclusivesChannelInput>;
  institutional?: InputMaybe<OdProtosRealtyOdlsData_SellRequest_Channel_InstitutionalBuyerChannelInput>;
  public?: InputMaybe<OdProtosRealtyOdlsData_SellRequest_Channel_PublicChannelInput>;
};

export type OdProtosRealtyOdlsData_SellRequest_PropertyType =
  | 'COMMERCIAL_LEASE'
  | 'COMMERCIAL_SALE'
  | 'LAND_SALE'
  | 'RESIDENTIAL_LEASE'
  | 'RESIDENTIAL_SALE'
  | 'UNKNOWN_PROPERTY_TYPE';

/**
 * Sell request states define the actions that can be performed on the sell request.
 *
 * Terminal: Sell request cannot receive new buy offers and will not change state under normal
 *   circumstances.
 */
export type OdProtosRealtyOdlsData_SellRequest_State =
  /**
   * The seller is actively receiving offers.
   * Terminal: No
   */
  | 'SELL_REQUEST_ACTIVE'
  /**
   * A sale has gone through and is now closed.
   * Terminal: Yes.
   */
  | 'SELL_REQUEST_CLOSED'
  /**
   * The sell request is coming soon.
   * Terminal: No.
   */
  | 'SELL_REQUEST_COMING_SOON'
  /**
   * The sell request has expired and is no longer current. This state is set automatically when
   * the sell request expires.
   * Terminal: Yes
   */
  | 'SELL_REQUEST_EXPIRED'
  /**
   * The sell request is listed privately (aka not on the MLS) (e.g. listed only on exclusives).
   * Terminal: No.
   */
  | 'SELL_REQUEST_PRIVATELY_LISTED'
  /**
   * A sale is pending.
   * Terminal: No.
   */
  | 'SELL_REQUEST_SALE_PENDING'
  /**
   * The sell request is temporarily off the market.
   * Terminal: No.
   */
  | 'SELL_REQUEST_TEMP_OFF_MARKET'
  | 'SELL_REQUEST_UNKNOWN'
  /**
   * The seller is not actively receiving offers.
   * Terminal: Yes
   */
  | 'SELL_REQUEST_WITHDRAWN';

export type OdProtosRealtyOdlsServices_BulkSellRequestGetBySourceRequestInput = {
  actor?: InputMaybe<OdProtosRealtyCommon_ActorInput>;
  channelType?: InputMaybe<OdProtosRealtyOdlsData_SellRequest_ChannelType>;
  displayPermissions?: InputMaybe<OdProtosRealtyOdlsServices_SellRequestDisplayPermissionsInput>;
  sources?: InputMaybe<Array<OdProtosRealtyCommon_SourceInput>>;
};

export type OdProtosRealtyOdlsServices_HasMlsListingsRequestInput = {
  addressId?: InputMaybe<Scalars['String']>;
};

export type OdProtosRealtyOdlsServices_OpenHouseSearchRequestInput = {
  /** Optional. Filter OpenHouses based on its active field. */
  active?: InputMaybe<Scalars['Boolean']>;
  actor?: InputMaybe<OdProtosRealtyCommon_ActorInput>;
  /** Find openhouses scheduled to start after timestamp. */
  gteTimestamp?: InputMaybe<Scalars['DateTime']>;
  /** Find openhouses scheduled to start before timestamp. */
  ltTimestamp?: InputMaybe<Scalars['DateTime']>;
  paginationRequest?: InputMaybe<OdProtosCommonPagination_PaginationRequestInput>;
  /** Get open houses for these sell requests. */
  sellRequestIds?: InputMaybe<Array<Scalars['String']>>;
  /** Return open houses by type. */
  type?: InputMaybe<OdProtosRealtyOdlsData_OpenHouse_Type>;
};

export type OdProtosRealtyOdlsServices_SellRequestDisplayPermissionsInput = {
  /**
   * Include everything you want to be returned, e.g. `PUBLIC` _and_ `PRIVATE`.
   * It is directly matched against the asset permission list.
   * Defaults to `PUBLIC` only.
   */
  assetPermissions?: InputMaybe<Array<OdProtosRealtyOdlsData_SellBlob_Permission>>;
};

export type OdProtosRealtyOdlsServices_SellRequestGetBySourceRequestInput = {
  actor?: InputMaybe<OdProtosRealtyCommon_ActorInput>;
  channelType?: InputMaybe<OdProtosRealtyOdlsData_SellRequest_ChannelType>;
  displayPermissions?: InputMaybe<OdProtosRealtyOdlsServices_SellRequestDisplayPermissionsInput>;
  source?: InputMaybe<OdProtosRealtyCommon_SourceInput>;
};

export type OdProtosRealtyOdlsServices_SellRequestGetCurrentListForAddressRequestInput = {
  actor?: InputMaybe<OdProtosRealtyCommon_ActorInput>;
  addressId?: InputMaybe<Scalars['String']>;
  channelType?: InputMaybe<OdProtosRealtyOdlsData_SellRequest_ChannelType>;
  displayPermissions?: InputMaybe<OdProtosRealtyOdlsServices_SellRequestDisplayPermissionsInput>;
  propertyType?: InputMaybe<OdProtosRealtyOdlsData_SellRequest_PropertyType>;
};

/** Searches for sell requests that match the given filters */
export type OdProtosRealtyOdlsServices_SellRequestSearchRequestInput = {
  actor?: InputMaybe<OdProtosRealtyCommon_ActorInput>;
  displayPermissions?: InputMaybe<OdProtosRealtyOdlsServices_SellRequestDisplayPermissionsInput>;
  filters?: InputMaybe<OdProtosRealtyOdlsServices_SellRequestSearchRequest_FiltersInput>;
  paginationRequest?: InputMaybe<OdProtosCommonPagination_PaginationRequestInput>;
  sortKey?: InputMaybe<OdProtosRealtyOdlsServices_SellRequestSearchRequest_SortKey>;
};

export type OdProtosRealtyOdlsServices_SellRequestSearchRequest_FiltersInput = {
  /** Filter by address IDs. */
  addressIds?: InputMaybe<Array<Scalars['String']>>;
  /** Required. Filter by channel type (only one channel type at a time is supported). */
  channelType?: InputMaybe<OdProtosRealtyOdlsData_SellRequest_ChannelType>;
  /**
   * Filter results to exclude those states that appear here
   * If a state appears in both include and exclude, exclude will take precedence (i.e. it will not appear)
   */
  excludeStates?: InputMaybe<Array<OdProtosRealtyOdlsData_SellRequest_State>>;
  /**
   * Include results that have been updated_at >= gte_updated_at
   * This is an inclusive bound
   * [updated_at_min, updated_at_max)
   */
  gteUpdatedAt?: InputMaybe<Scalars['DateTime']>;
  /**
   * Filter results to those including these states
   * If a state appears in both include and exclude, exclude will take precedence (i.e. it will not appear)
   */
  includeStates?: InputMaybe<Array<OdProtosRealtyOdlsData_SellRequest_State>>;
  /**
   * Include results that have been updated_at < lt_updated_at
   * This is an exclusive bound
   * [updated_at_min, updated_at_max)
   */
  ltUpdatedAt?: InputMaybe<Scalars['DateTime']>;
  /** Required. Filter by property type (only one property type at a time is supported). */
  propertyType?: InputMaybe<OdProtosRealtyOdlsData_SellRequest_PropertyType>;
  /** Filter results to only include items from a source */
  sources?: InputMaybe<Array<OdProtosRealtyCommon_SourceInput>>;
};

export type OdProtosRealtyOdlsServices_SellRequestSearchRequest_SortKey =
  /** Sort by address and earliest listed first. */
  | 'SORT_KEY_ADDRESS_LISTED_ASC'
  /** Sort by address and most recently listed first. */
  | 'SORT_KEY_ADDRESS_LISTED_DESC'
  /** Sort by earliest created at first. */
  | 'SORT_KEY_CREATED_AT_ASC'
  /** Sort by most recently created at first. */
  | 'SORT_KEY_CREATED_AT_DESC'
  | 'SORT_KEY_DEFAULT'
  /** Sort by earliest updated at first. */
  | 'SORT_KEY_UPDATED_AT_ASC'
  /** Sort by most recently updated at first. */
  | 'SORT_KEY_UPDATED_AT_DESC';

export type OdProtosRealtyOdlsServices_SellerRequest_AddNewChannelInput = {
  actor?: InputMaybe<OdProtosRealtyCommon_ActorInput>;
  /**
   * New channel to add to the sell request
   * Will raise an error if already added
   */
  channel?: InputMaybe<OdProtosRealtyOdlsData_SellRequest_ChannelInput>;
  /** ID of sell request to update. */
  id?: InputMaybe<Scalars['String']>;
};

export type OdProtosRealtyOdlsServices_SellerRequest_BulkSellRequestChangeEventsBySellRequestIdInput = {
  actor?: InputMaybe<OdProtosRealtyCommon_ActorInput>;
  sellRequestIds?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosRealtyOdlsServices_SellerRequest_BulkSellRequestHistoryLatestBySellRequestIdInput = {
  actor?: InputMaybe<OdProtosRealtyCommon_ActorInput>;
  lteTimestamp?: InputMaybe<Scalars['DateTime']>;
  sellRequestIds?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosRealtyOdlsServices_SellerRequest_GetPreferredSellRequestByAddressIdInput = {
  addressId?: InputMaybe<Scalars['String']>;
};

export type OdProtosRealtyOdlsServices_SellerRequest_GetPreferredSellRequestsByAddressIDsInput = {
  /** Max 100 address IDs! */
  addressIds?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosRealtyOdlsServices_SellerRequest_OpenHouseCreateInput = {
  /** Whether the open house is available. */
  active?: InputMaybe<Scalars['Boolean']>;
  actor?: InputMaybe<OdProtosRealtyCommon_ActorInput>;
  contact?: InputMaybe<OdProtosRealtyCommon_ContactInput>;
  /** End timestamp in UTC. */
  endTime?: InputMaybe<Scalars['DateTime']>;
  /** The stable ID from the sell request "source", used for de-duplicating open houses. */
  externalId?: InputMaybe<Scalars['String']>;
  /** Set individual fields. */
  openHouse?: InputMaybe<OdProtosRealtyOdlsData_OpenHouseInput>;
  sellRequestId?: InputMaybe<Scalars['String']>;
  /** Start timestamp in UTC. */
  startTime?: InputMaybe<Scalars['DateTime']>;
  type?: InputMaybe<OdProtosRealtyOdlsData_OpenHouse_Type>;
};

export type OdProtosRealtyOdlsServices_SellerRequest_OpenHouseGetByExternalIdInput = {
  actor?: InputMaybe<OdProtosRealtyCommon_ActorInput>;
  externalId?: InputMaybe<Scalars['String']>;
  sellRequestId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<OdProtosRealtyOdlsData_OpenHouse_Type>;
};

export type OdProtosRealtyOdlsServices_SellerRequest_OpenHouseGetInput = {
  actor?: InputMaybe<OdProtosRealtyCommon_ActorInput>;
  id?: InputMaybe<Scalars['String']>;
};

export type OdProtosRealtyOdlsServices_SellerRequest_OpenHouseListInput = {
  actor?: InputMaybe<OdProtosRealtyCommon_ActorInput>;
  ids?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosRealtyOdlsServices_SellerRequest_OpenHouseUpdateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  actor?: InputMaybe<OdProtosRealtyCommon_ActorInput>;
  contact?: InputMaybe<OdProtosRealtyCommon_ContactInput>;
  /** End timestamp in UTC. */
  endTime?: InputMaybe<Scalars['DateTime']>;
  /** The stable ID from the sell request "source", used for de-duplicating open houses. */
  externalId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  /** Set individual fields. Does not alter any fields missing below. */
  openHouse?: InputMaybe<OdProtosRealtyOdlsData_OpenHouseInput>;
  /** Start timestamp in UTC. */
  startTime?: InputMaybe<Scalars['DateTime']>;
};

export type OdProtosRealtyOdlsServices_SellerRequest_OpenHouseUpdatedInput = {
  gtUpdatedAt?: InputMaybe<Scalars['DateTime']>;
  paginationRequest?: InputMaybe<OdProtosCommonPagination_PaginationRequestInput>;
  type?: InputMaybe<OdProtosRealtyOdlsData_OpenHouse_Type>;
};

export type OdProtosRealtyOdlsServices_SellerRequest_SellRequestChangeEventsBySellRequestIdInput = {
  actor?: InputMaybe<OdProtosRealtyCommon_ActorInput>;
  sellRequestId?: InputMaybe<Scalars['String']>;
};

/**
 * Create a new sell request.
 * A sell request may be rejected if there is an existing sell request already in the system.
 */
export type OdProtosRealtyOdlsServices_SellerRequest_SellRequestCreateInput = {
  actor?: InputMaybe<OdProtosRealtyCommon_ActorInput>;
  addressId?: InputMaybe<Scalars['String']>;
  channelType?: InputMaybe<OdProtosRealtyOdlsData_SellRequest_ChannelType>;
  channels?: InputMaybe<Array<OdProtosRealtyOdlsData_SellRequest_ChannelInput>>;
  expiresAfter?: InputMaybe<Scalars['DateTime']>;
  homeDetailId?: InputMaybe<Scalars['String']>;
  /**
   * Required. The organization that owns this sell request.
   * Only users in this organization may update this sell request.
   */
  organizationId?: InputMaybe<Scalars['String']>;
  primaryContact?: InputMaybe<OdProtosRealtyCommon_ContactInput>;
  propertyType?: InputMaybe<OdProtosRealtyOdlsData_SellRequest_PropertyType>;
  sellBlob?: InputMaybe<OdProtosRealtyOdlsData_SellBlobInput>;
  source?: InputMaybe<OdProtosRealtyCommon_SourceInput>;
  state?: InputMaybe<OdProtosRealtyOdlsData_SellRequest_State>;
  timestamp?: InputMaybe<Scalars['DateTime']>;
};

export type OdProtosRealtyOdlsServices_SellerRequest_SellRequestGetInput = {
  actor?: InputMaybe<OdProtosRealtyCommon_ActorInput>;
  displayPermissions?: InputMaybe<OdProtosRealtyOdlsServices_SellRequestDisplayPermissionsInput>;
  id?: InputMaybe<Scalars['String']>;
};

export type OdProtosRealtyOdlsServices_SellerRequest_SellRequestHistoryBySellRequestIdInput = {
  actor?: InputMaybe<OdProtosRealtyCommon_ActorInput>;
  displayPermissions?: InputMaybe<OdProtosRealtyOdlsServices_SellRequestDisplayPermissionsInput>;
  gteTimestamp?: InputMaybe<Scalars['DateTime']>;
  /** for pagination */
  limit?: InputMaybe<Scalars['Float']>;
  ltTimestamp?: InputMaybe<Scalars['DateTime']>;
  sellRequestId?: InputMaybe<Scalars['String']>;
};

export type OdProtosRealtyOdlsServices_SellerRequest_SellRequestHistoryDeleteInput = {
  actor?: InputMaybe<OdProtosRealtyCommon_ActorInput>;
  sellRequestId?: InputMaybe<Scalars['String']>;
  sellRequestTimestamp?: InputMaybe<Scalars['DateTime']>;
};

export type OdProtosRealtyOdlsServices_SellerRequest_SellRequestHistoryGetInput = {
  actor?: InputMaybe<OdProtosRealtyCommon_ActorInput>;
  displayPermissions?: InputMaybe<OdProtosRealtyOdlsServices_SellRequestDisplayPermissionsInput>;
  sellRequestId?: InputMaybe<Scalars['String']>;
  sellRequestTimestamp?: InputMaybe<Scalars['DateTime']>;
};

export type OdProtosRealtyOdlsServices_SellerRequest_SellRequestHistoryLatestBySellRequestIdInput = {
  actor?: InputMaybe<OdProtosRealtyCommon_ActorInput>;
  lteTimestamp?: InputMaybe<Scalars['DateTime']>;
  sellRequestId?: InputMaybe<Scalars['String']>;
};

/** Write to the Sell Request History table */
export type OdProtosRealtyOdlsServices_SellerRequest_SellRequestHistoryWriteInput = {
  actor?: InputMaybe<OdProtosRealtyCommon_ActorInput>;
  addressId?: InputMaybe<Scalars['String']>;
  channelType?: InputMaybe<OdProtosRealtyOdlsData_SellRequest_ChannelType>;
  expiresAfter?: InputMaybe<Scalars['DateTime']>;
  homeDetailId?: InputMaybe<Scalars['String']>;
  organizationId?: InputMaybe<Scalars['String']>;
  primaryContact?: InputMaybe<OdProtosRealtyCommon_ContactInput>;
  propertyType?: InputMaybe<OdProtosRealtyOdlsData_SellRequest_PropertyType>;
  sellBlob?: InputMaybe<OdProtosRealtyOdlsData_SellBlobInput>;
  /**
   * The sell_request_id and sell_request_timestamp will constitute the primary keys of the Sell Requests History
   * table and will therefore be used to upsert data into the table. A corresponding sell request with the given
   * sell request id must exist in order to write the history record.
   */
  sellRequestId?: InputMaybe<Scalars['String']>;
  sellRequestTimestamp?: InputMaybe<Scalars['DateTime']>;
  source?: InputMaybe<OdProtosRealtyCommon_SourceInput>;
  state?: InputMaybe<OdProtosRealtyOdlsData_SellRequest_State>;
};

export type OdProtosRealtyOdlsServices_SellerRequest_SellRequestListInput = {
  actor?: InputMaybe<OdProtosRealtyCommon_ActorInput>;
  displayPermissions?: InputMaybe<OdProtosRealtyOdlsServices_SellRequestDisplayPermissionsInput>;
  ids?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosRealtyOdlsServices_SellerRequest_SellRequestResolveInput = {
  /** The id of the sell request that you want to find the master of */
  id?: InputMaybe<Scalars['String']>;
  /** provide a list of mls ids */
  mlsId?: InputMaybe<OdProtosRealtyOdlsData_SellBlob_MlsListingInformationInput>;
};

/** Updates to a sell request. */
export type OdProtosRealtyOdlsServices_SellerRequest_SellRequestUpdateInput = {
  actor?: InputMaybe<OdProtosRealtyCommon_ActorInput>;
  addressId?: InputMaybe<Scalars['String']>;
  expiresAfter?: InputMaybe<Scalars['DateTime']>;
  homeDetailId?: InputMaybe<Scalars['String']>;
  /** ID of sell request to update. */
  id?: InputMaybe<Scalars['String']>;
  propertyType?: InputMaybe<OdProtosRealtyOdlsData_SellRequest_PropertyType>;
  sellBlob?: InputMaybe<OdProtosRealtyOdlsData_SellBlobInput>;
  source?: InputMaybe<OdProtosRealtyCommon_SourceInput>;
  state?: InputMaybe<OdProtosRealtyOdlsData_SellRequest_State>;
  timestamp?: InputMaybe<Scalars['DateTime']>;
};

/** Creates or updates a sell request based on source ID. */
export type OdProtosRealtyOdlsServices_SellerRequest_SellRequestWriteInput = {
  actor?: InputMaybe<OdProtosRealtyCommon_ActorInput>;
  addressId?: InputMaybe<Scalars['String']>;
  channelType?: InputMaybe<OdProtosRealtyOdlsData_SellRequest_ChannelType>;
  expiresAfter?: InputMaybe<Scalars['DateTime']>;
  homeDetailId?: InputMaybe<Scalars['String']>;
  organizationId?: InputMaybe<Scalars['String']>;
  primaryContact?: InputMaybe<OdProtosRealtyCommon_ContactInput>;
  propertyType?: InputMaybe<OdProtosRealtyOdlsData_SellRequest_PropertyType>;
  sellBlob?: InputMaybe<OdProtosRealtyOdlsData_SellBlobInput>;
  sellRequestTimestamp?: InputMaybe<Scalars['DateTime']>;
  source?: InputMaybe<OdProtosRealtyCommon_SourceInput>;
  state?: InputMaybe<OdProtosRealtyOdlsData_SellRequest_State>;
};

/** Params for getting multiple seller inputs. */
export type OdProtosReceptionServices_BulkGetSellerInputsRequestInput = {
  options?: InputMaybe<OdProtosReceptionServices_SellerInputRequestOptionsInput>;
  /** External identifiers for the seller inputs. */
  uuids?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosReceptionServices_CalendlyCalendarRequestInput = {
  fromSellerFlow?: InputMaybe<Scalars['Boolean']>;
  /** External identifier for the seller input. */
  uuid?: InputMaybe<Scalars['String']>;
};

/**
 * Params for creating a seller input.
 * Next ID: 12
 */
export type OdProtosReceptionServices_CreateSellerInputRequestInput = {
  /**
   * Address used to create the seller input can be either a set of params provided
   * by Google Maps autocomplete / manual seller inputs, or an already verified
   * address uuid from Casa (in the case of home profiles).
   */
  address?: InputMaybe<OdProtosReceptionServices_SellerAddressInput>;
  /** Address entry tracking and other data for analytics */
  analyticsMetadata?: InputMaybe<OdProtosSellReceptionData_SellerInput_AnalyticsMetadataInput>;
  /**
   * The channel the seller came in from, used to determine the overall experience
   * the seller will go through.
   */
  channel?: InputMaybe<OdProtosSellReceptionData_SellerInput_Channel>;
  /** if true, bypass global acquisition pause due to COVID-19 */
  covid19Whitelist?: InputMaybe<Scalars['Boolean']>;
  /** Experiment entity ID to be used with Optimizely */
  experimentEntityId?: InputMaybe<Scalars['String']>;
  /**
   * Whether or not the user should end up on the trade-in dashboard
   * when they're finished.
   */
  isTradeInDashboard?: InputMaybe<Scalars['Boolean']>;
  /**
   * if this is passed in, we will check if this seller_input has finished the flow and can be redirected to Offer dash.
   * if it can, we will return the same seller_input_uuid
   */
  oldSellerInputUuid?: InputMaybe<Scalars['String']>;
  /** Partner referral tracking. */
  partnerReferralId?: InputMaybe<Scalars['String']>;
  /** Assign the sellerInput to the specific sellerFlow */
  sellerFlowNameOverride?: InputMaybe<Scalars['String']>;
  /** Assign the sellerInput to the specific sellerFlow */
  sellerFlowUuidOverride?: InputMaybe<Scalars['String']>;
  /** Cookie based tracking keywords to associate with the seller input. */
  trackingData?: InputMaybe<Array<OdProtosReceptionServices_CreateSellerInputRequest_TrackingDataInput>>;
};

/** Cookie based tracking keywords to associate with the seller input. */
export type OdProtosReceptionServices_CreateSellerInputRequest_TrackingDataInput = {
  /** Tracking keyword (e.g. p_publicprofile). */
  keyword?: InputMaybe<Scalars['String']>;
  /** Time of tracking (i.e. when the keyword was added to the user's cookies). */
  trackedAt?: InputMaybe<Scalars['DateTime']>;
};

/** Params for denying a seller input. */
export type OdProtosReceptionServices_DenySellerInputRequestInput = {
  /** Denial reason to deny the seller input for. */
  denialReason?: InputMaybe<OdProtosSellCommon_DenialReason>;
  /** Product for which to deny the seller input */
  product?: InputMaybe<OdProtosSellCommon_Product>;
  /** External identifier for the seller input to deny. */
  uuid?: InputMaybe<Scalars['String']>;
};

/** Params for getting the latest seller input from customer and address. */
export type OdProtosReceptionServices_GetLatestSellerInputFromCustomerAndAddressRequestInput = {
  addressUuid?: InputMaybe<Scalars['String']>;
  customerUuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosReceptionServices_GetOfferedProductsRequestInput = {
  /**
   * Address used to create the seller input can be either a set of params provided
   * by Google Maps autocomplete / manual seller inputs, or an already verified
   * address uuid from Casa (in the case of home profiles).
   */
  address?: InputMaybe<OdProtosReceptionServices_SellerAddressInput>;
  /** The channel the seller will come through, used to determine eligibility for some products */
  channel?: InputMaybe<OdProtosSellReceptionData_SellerInput_Channel>;
  /** Products for which we are requesting a denial check */
  products?: InputMaybe<Array<OdProtosSellCommon_Product>>;
};

export type OdProtosReceptionServices_GetQualificationStatusRequestInput = {
  /** Seller input uuid */
  sellerInputUuid?: InputMaybe<Scalars['String']>;
};

/** Params for getting a seller input. */
export type OdProtosReceptionServices_GetSellerInputRequestInput = {
  /** External identifier for the seller input. */
  uuid?: InputMaybe<Scalars['String']>;
};

/** Params for getting seller inputs by address token. */
export type OdProtosReceptionServices_GetSellerInputsFromAddressUuidRequestInput = {
  /** Address token used to find seller inputs */
  addressUuid?: InputMaybe<Scalars['String']>;
  /** Limits the number of results to this amount */
  limit?: InputMaybe<Scalars['Float']>;
  /** How much to offset the query by */
  offset?: InputMaybe<Scalars['Float']>;
};

/** Params for getting seller inputs by email. */
export type OdProtosReceptionServices_GetSellerInputsFromEmailRequestInput = {
  /** Customer email used to find seller inputs */
  email?: InputMaybe<Scalars['String']>;
  /** Limits the number of results to this amount */
  limit?: InputMaybe<Scalars['Float']>;
  /** How much to offset the query by */
  offset?: InputMaybe<Scalars['Float']>;
};

/**
 * Params for modifying a seller address. Modification results in the address
 * needing to be verified again.
 */
export type OdProtosReceptionServices_ModifySellerAddressRequestInput = {
  /** New address params to be used. */
  address?: InputMaybe<OdProtosReceptionServices_SellerAddressInput>;
  /** Identifier for the seller input to be modified. */
  uuid?: InputMaybe<Scalars['String']>;
};

/** Params for refreshing home details */
export type OdProtosReceptionServices_RefreshHomeDetailsRequestInput = {
  /** The uuid of the seller input for which we want a refreshed set of home details */
  uuid?: InputMaybe<Scalars['String']>;
};

/** Params for requesting a listed offer / verifying a listing. */
export type OdProtosReceptionServices_RequestListedOfferRequestInput = {
  /** Optional override for the realtor email. */
  realtorEmail?: InputMaybe<Scalars['String']>;
  /** Optional override for the realtor name. */
  realtorName?: InputMaybe<Scalars['String']>;
  /** Identifier for the listed seller input. */
  uuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosReceptionServices_SaveSellerInputProgressRequestInput = {
  /** Email address */
  email?: InputMaybe<Scalars['String']>;
  /** External identifier for the seller input. */
  uuid?: InputMaybe<Scalars['String']>;
};

/** Address inputs for creating or updating a seller input. */
export type OdProtosReceptionServices_SellerAddressInput = {
  /** City of the address. */
  city?: InputMaybe<Scalars['String']>;
  /** Five digit postal code. */
  postalCode?: InputMaybe<Scalars['String']>;
  /** Two letter state abbreviation. */
  state?: InputMaybe<Scalars['String']>;
  /** Street name and number (e.g. 123 Main St). */
  street?: InputMaybe<Scalars['String']>;
  /** Unit number if applicable (e.g. 10), otherwise empty. */
  unit?: InputMaybe<Scalars['String']>;
  /**
   * Optional Casa address identifier if the address is already known. If uuid is
   * provided, other address fields are not required. If uuid is not provided,
   * other address fields are required.
   */
  uuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosReceptionServices_SellerInputRequestOptionsInput = {
  excludeAnswerPrefills?: InputMaybe<Scalars['Boolean']>;
  excludeAnswers?: InputMaybe<Scalars['Boolean']>;
  excludeHomeDetails?: InputMaybe<Scalars['Boolean']>;
};

/** Params for undenying a seller input. */
export type OdProtosReceptionServices_UndenySellerInputRequestInput = {
  /** Product for which to undeny the seller input */
  product?: InputMaybe<OdProtosSellCommon_Product>;
  /** External identifier for the seller input to undeny. */
  uuid?: InputMaybe<Scalars['String']>;
};

/**
 * Next ID: 11
 * Params for updating seller input answers.
 */
export type OdProtosReceptionServices_UpdateSellerInputRequestInput = {
  /**
   * JSON changed answers that should be updated.
   * Example: "{ \\"home.bedrooms\\": 3 }"
   */
  answers?: InputMaybe<Scalars['String']>;
  /** Sets a new channel, commonly used for listed homes. */
  channel?: InputMaybe<OdProtosSellReceptionData_SellerInput_Channel>;
  /** If true, will always perform the external eligibility check */
  forceExternalEligibilityCheck?: InputMaybe<Scalars['Boolean']>;
  /** If the home is listed or not */
  isListed?: InputMaybe<Scalars['Boolean']>;
  isOrvaAutoscheduleShown?: InputMaybe<Scalars['Boolean']>;
  /** if true, the MtM (Monitor the Market) dashboard has been visited */
  mtmVisited?: InputMaybe<Scalars['Boolean']>;
  /** Last page the seller completed in the seller flow. */
  sellerFlowLastCompletedSlug?: InputMaybe<Scalars['String']>;
  sellerFlowName?: InputMaybe<Scalars['String']>;
  sellerFlowUuid?: InputMaybe<Scalars['String']>;
  /** External identifier for the seller input. */
  uuid?: InputMaybe<Scalars['String']>;
};

/**
 * Params for verifying a seller address. Verification triggers address based
 * buybox and auto denial logic.
 */
export type OdProtosReceptionServices_VerifySellerAddressRequestInput = {
  /** Identifier for the seller input to be verified. */
  uuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosRefurbyData_ApResolutionTaskDataInput = {
  invoiceToken?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  referenceLinks?: InputMaybe<Array<Scalars['String']>>;
  workOrderId?: InputMaybe<Scalars['String']>;
};

export type OdProtosRefurbyData_MessageThreadStatus =
  | 'NO_ACTION_REQUIRED'
  | 'WAITING_ON_OPENDOOR_RESPONSE'
  | 'WAITING_ON_THIRD_PARTY_RESPONSE';

export type OdProtosRefurbyServices_CloseApResolutionTaskRequestInput = {
  taskId?: InputMaybe<Scalars['String']>;
};

export type OdProtosRefurbyServices_CompleteVisitRequestInput = {
  completedAt?: InputMaybe<Scalars['DateTime']>;
  projectId?: InputMaybe<Scalars['String']>;
  submitChangeOrder?: InputMaybe<Scalars['Boolean']>;
  visitId?: InputMaybe<Scalars['String']>;
};

export type OdProtosRefurbyServices_CreateApResolutionTaskRequestInput = {
  addressId?: InputMaybe<Scalars['String']>;
  taskData?: InputMaybe<OdProtosRefurbyData_ApResolutionTaskDataInput>;
};

export type OdProtosRefurbyServices_IdRequestInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type OdProtosRefurbyServices_PostToWorkOrderMessageThreadRequestInput = {
  authorId?: InputMaybe<Scalars['String']>;
  content?: InputMaybe<Scalars['String']>;
  newStatus?: InputMaybe<OdProtosRefurbyData_MessageThreadStatus>;
  workOrderId?: InputMaybe<Scalars['String']>;
};

export type OdProtosRenaissance_FeatureFetchBatchRequestInput = {
  /** UUID of the address of the home for which we want features for. */
  addressTokens?: InputMaybe<Array<Scalars['String']>>;
  /**
   * Date at which we want features to be fetched. E.g. the previous list price of a home might be different at
   * different time periods.
   */
  asofDates?: InputMaybe<Array<Scalars['DateTime']>>;
  /** Comps can be optional. */
  includeComps?: InputMaybe<Scalars['Boolean']>;
  /** The market of the request, in string form */
  market?: InputMaybe<Scalars['String']>;
  /** Overlay map of column_name -> value */
  overlaysDicts?: InputMaybe<Array<OdProtosRenaissance_OverlaysDictInput>>;
};

export type OdProtosRenaissance_FeatureFetchRequestInput = {
  /** UUID of the address of the home for which we want features for. */
  addressToken?: InputMaybe<Scalars['String']>;
  /**
   * Date at which we want features to be fetched. E.g. the previous list price of a home might be different at
   * different time periods.
   */
  asofDate?: InputMaybe<Scalars['DateTime']>;
  /** Comps can be optional. */
  includeComps?: InputMaybe<Scalars['Boolean']>;
  /** The market of the request, in string form */
  market?: InputMaybe<Scalars['String']>;
  /** Overlay map of column_name -> value */
  overlaysDict?: InputMaybe<OdProtosRenaissance_OverlaysDictInput>;
};

export type OdProtosRenaissance_OverlaysDictInput = {
  /** Overlay map of column_name -> value */
  overlaysDict?: InputMaybe<Array<OdProtosRenaissance_OverlaysDict_OverlaysDictEntryInput>>;
};

/** `OdProtosRenaissance_OverlaysDict_OverlaysDictEntryInput` represents the `overlays_dict` map in `od_protos.renaissance.OverlaysDict`. */
export type OdProtosRenaissance_OverlaysDict_OverlaysDictEntryInput = {
  key?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

export type OdProtosRenovationRepairScopingData_State =
  | 'CANCELED'
  | 'REQUESTED'
  | 'SCOPING_COMPLETED'
  | 'SCOPING_STARTED'
  | 'UNKNOWN';

export type OdProtosRenovationRepairScopingServices_BulkGetOrCreateRenoRepairScopingsRequestInput = {
  requests?: InputMaybe<Array<OdProtosRenovationRepairScopingServices_GetOrCreateRenoRepairScopingRequestInput>>;
};

export type OdProtosRenovationRepairScopingServices_GetOrCreateRenoRepairScopingRequestInput = {
  enrollmentId?: InputMaybe<Scalars['String']>;
  flipToken?: InputMaybe<Scalars['String']>;
};

export type OdProtosRenovationRepairScopingServices_GetRenoRepairScopingRequestInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type OdProtosRenovationRepairScopingServices_RequestRenoRepairScopingRequestInput = {
  addressId?: InputMaybe<Scalars['String']>;
};

export type OdProtosRenovationRepairScopingServices_SearchRenoRepairScopingRequestInput = {
  addressId?: InputMaybe<Scalars['String']>;
};

export type OdProtosRentinalServices_CancelSearchRequestInput = {
  token?: InputMaybe<Scalars['String']>;
};

export type OdProtosRentinalServices_EmptyRequestInput = {
  _empty?: InputMaybe<Scalars['Boolean']>;
};

export type OdProtosRentinalServices_ListSearchResultsRequestInput = {
  token?: InputMaybe<Scalars['String']>;
};

export type OdProtosRentinalServices_ListSearchRunsRequestInput = {
  after?: InputMaybe<Scalars['DateTime']>;
};

/** AcceptedOfferType represents the type of offer that Opendoor is accepting for a given home. */
export type OdProtosResaleInventoryData_AcceptedOfferTypeInput = {
  /** The deadline for submitting offers of the given accepted offer type. */
  deadline?: InputMaybe<Scalars['DateTime']>;
  offerType?: InputMaybe<OdProtosResaleInventoryData_AcceptedOfferType_OfferType>;
};

export type OdProtosResaleInventoryData_AcceptedOfferType_OfferType =
  /** Opendoor is accepting backup offers, as it currently has a committed buyer. */
  | 'BACKUP'
  /** “Buy It Now” means thsat if the offer qualifies then it will be automatically accepted/advanced at the "Buy It Now" price. */
  | 'BUY_IT_NOW'
  /** Opendoor is collecting competing offers which it will examine on a deadline. */
  | 'HIGHEST_AND_BEST'
  /** Offers to purchase the house at various prices may be submitted which will be considered by Opendoor and responded to. */
  | 'NEGOTIABLE'
  | 'UNKNOWN_ACCEPTED_OFFER_TYPE';

export type OdProtosResaleInventoryData_AcceptedOfferTypesInput = {
  acceptedOfferTypes?: InputMaybe<Array<OdProtosResaleInventoryData_AcceptedOfferTypeInput>>;
};

/** ActiveChannel represents details about a channel that is currently active for a resale. */
export type OdProtosResaleInventoryData_ActiveChannelInput = {
  channelType?: InputMaybe<OdProtosResaleInventoryData_ChannelType>;
  id?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<OdProtosResaleInventoryData_ChannelState>;
};

export type OdProtosResaleInventoryData_ActiveChannelsInput = {
  activeChannels?: InputMaybe<Array<OdProtosResaleInventoryData_ActiveChannelInput>>;
};

/** ChannelType represents the state of the channel */
export type OdProtosResaleInventoryData_ChannelState =
  /** The channel is pending activation, but has not yet been confirmed by the channel itself. */
  | 'ACTIVATION_PENDING'
  /** The channel is confirmed to be active by the channel. */
  | 'ACTIVE'
  /** The channel is terminated */
  | 'TERMINATED'
  /**
   * The channel termination is pending, but has not yet been confirmed. Once confirmed,
   * the channel will be terminated (aka removed from active channels).
   */
  | 'TERMINATION_PENDING'
  | 'UNKNOWN_CHANNEL_STATE';

/** ChannelType represents the type of channel that a home is being resold on. */
export type OdProtosResaleInventoryData_ChannelType =
  | 'BUY_DIRECT'
  | 'EXTERNAL_LISTING'
  | 'MLS'
  | 'UNKNOWN_CHANNEL_TYPE';

export type OdProtosResaleInventoryData_ResaleInput = {
  /** The list of offer types (and deadlines) that Opendoor is currently accepting for the property being sold */
  acceptedOfferTypes?: InputMaybe<OdProtosResaleInventoryData_AcceptedOfferTypesInput>;
  /** Flag that indicates if the property has its access blocked for customers */
  accessBlocked?: InputMaybe<Scalars['Boolean']>;
  /** The list of resale channels currently being managed by the Resale entity */
  activeChannels?: InputMaybe<OdProtosResaleInventoryData_ActiveChannelsInput>;
  addressId?: InputMaybe<Scalars['String']>;
  /**
   * The factor that the headline price will be adjusted by to calculate the
   * buy direect price.
   */
  buyDirectAdjustmentFactor?: InputMaybe<Scalars['Float']>;
  /** Flag that indicates if the property is eligible for exclusives */
  exclusivesEligible?: InputMaybe<Scalars['Boolean']>;
  /** If the field is populated, it represents the time the exclusives window expired */
  exclusivesWindowExpiredAt?: InputMaybe<Scalars['DateTime']>;
  /** The date when the property is expected to have access unblocked */
  expectedAccessUnblockedDate?: InputMaybe<OdProtosCommon_DateInput>;
  /** The date when the property is expected to become available to purchase (aka state = sellable) */
  expectedSellableDate?: InputMaybe<OdProtosCommon_DateInput>;
  /** The current headline (i.e. base) price that Opendoor wishes to receive when selling the property */
  headlinePrice?: InputMaybe<OdProtosCommon_MoneyInput>;
  /** The timestamp when the highest and best deadline is set to */
  highestAndBestDeadline?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  /** Flag indicating if the property is in a gated community */
  inGatedCommunity?: InputMaybe<Scalars['Boolean']>;
  /**
   * Flag that indicates if the property is currently exclusively listed,
   * as in it's currently listed on our gallery, but not on the MLS.
   */
  isExclusive?: InputMaybe<Scalars['Boolean']>;
  /**
   * Flag that indicates if the property being sold is currently listed
   * publicly
   */
  isPubliclyListed?: InputMaybe<Scalars['Boolean']>;
  /** The market_identifier indicating which market the property is in */
  marketIdentifier?: InputMaybe<OdProtosCommonMarket_Market>;
  /** The time at which photos have been marked as ready to be published */
  photosReadyTime?: InputMaybe<Scalars['DateTime']>;
  /** Flag that indicates if a door is unable to have a remote unlock setup or it is currently disabled/non-working */
  remoteUnlockDoorDisabled?: InputMaybe<Scalars['Boolean']>;
  /** Indicates if renovation has been completed */
  renovationCompleted?: InputMaybe<Scalars['Boolean']>;
  /**
   * Flag indicating if the property is self-tourable
   * This will be true if the property is not in a gated community and has a remote unlockable door
   */
  selfTourable?: InputMaybe<Scalars['Boolean']>;
  state?: InputMaybe<OdProtosResaleInventoryData_Resale_State>;
  /** The collection of most recent times that resale entered a state */
  stateEnterTimes?: InputMaybe<Array<OdProtosResaleInventoryData_Resale_StateEnterTimeInput>>;
  /** The reason a resale entity was terminated */
  terminationReason?: InputMaybe<OdProtosResaleInventoryData_Resale_TerminationReason>;
};

export type OdProtosResaleInventoryData_Resale_State =
  /** Opendoor has a buyer committed to purchase the property. */
  | 'COMMITTED_BUYER'
  /**
   * Opendoor owns the property, has access to it, and is preparing to sell it.
   * Resale will start related sub-processes (pricing, photos, remote access setup) at appropriate times.
   */
  | 'PREPARING'
  /**
   * The Resale lifecycle has been created, however it is in a holding state because we
   * haven't actually acquired the property yet.
   */
  | 'PRE_INVENTORY'
  /** The property may now be sold, and all Resale preparation has been completed. Any active channels may expose the property as for sale. */
  | 'SELLABLE'
  /** The Resale lifecycle has been terminated, typically because the property has been sold. */
  | 'TERMINATED'
  | 'UNKNOWN_STATE';

/** StateEnterTime tracks the time a Resale entity entered a particular state */
export type OdProtosResaleInventoryData_Resale_StateEnterTimeInput = {
  state?: InputMaybe<OdProtosResaleInventoryData_Resale_State>;
  timestamp?: InputMaybe<Scalars['DateTime']>;
};

/** TerminationReason indicates the reason a Resale entity was terminated */
export type OdProtosResaleInventoryData_Resale_TerminationReason =
  /** Home did not get acquired to be sold */
  | 'NOT_ACQUIRED'
  /** Resale was canceled */
  | 'SALE_CANCELED'
  /** Home has been sold */
  | 'SOLD'
  | 'UNKNOWN_TERMINATION_REASON';

export type OdProtosResaleInventoryServices_AddActiveChannelRequestInput = {
  channelType?: InputMaybe<OdProtosResaleInventoryData_ChannelType>;
  resaleId?: InputMaybe<Scalars['String']>;
};

export type OdProtosResaleInventoryServices_CommitBuyerRequestInput = {
  resaleId?: InputMaybe<Scalars['String']>;
};

export type OdProtosResaleInventoryServices_CreateResaleRequestInput = {
  resale?: InputMaybe<OdProtosResaleInventoryData_ResaleInput>;
};

export type OdProtosResaleInventoryServices_GetResaleRequestInput = {
  resaleId?: InputMaybe<Scalars['String']>;
};

export type OdProtosResaleInventoryServices_HomeInInventoryRequestInput = {
  resaleId?: InputMaybe<Scalars['String']>;
};

export type OdProtosResaleInventoryServices_PhotosReadyRequestInput = {
  photosReadyTime?: InputMaybe<Scalars['DateTime']>;
  resaleId?: InputMaybe<Scalars['String']>;
};

export type OdProtosResaleInventoryServices_RemoveActiveChannelRequestInput = {
  channelType?: InputMaybe<OdProtosResaleInventoryData_ChannelType>;
  resaleId?: InputMaybe<Scalars['String']>;
};

export type OdProtosResaleInventoryServices_RenovationCompletedRequestInput = {
  resaleId?: InputMaybe<Scalars['String']>;
};

export type OdProtosResaleInventoryServices_RevertResaleSoldRequestInput = {
  isExternalListing?: InputMaybe<Scalars['Boolean']>;
  resaleId?: InputMaybe<Scalars['String']>;
};

export type OdProtosResaleInventoryServices_SetAccessBlockedRequestInput = {
  accessBlocked?: InputMaybe<Scalars['Boolean']>;
  expectedAccessUnblockedDate?: InputMaybe<OdProtosCommon_DateInput>;
  resaleId?: InputMaybe<Scalars['String']>;
};

export type OdProtosResaleInventoryServices_SetExpectedAccessUnblockedDateRequestInput = {
  expectedAccessUnblockedDate?: InputMaybe<OdProtosCommon_DateInput>;
  resaleId?: InputMaybe<Scalars['String']>;
};

export type OdProtosResaleInventoryServices_SetExpectedSellableDateRequestInput = {
  expectedSellableDate?: InputMaybe<OdProtosCommon_DateInput>;
  resaleId?: InputMaybe<Scalars['String']>;
};

export type OdProtosResaleInventoryServices_SetHeadlinePriceRequestInput = {
  headlinePrice?: InputMaybe<OdProtosCommon_MoneyInput>;
  resaleId?: InputMaybe<Scalars['String']>;
};

export type OdProtosResaleInventoryServices_SetHighestAndBestDeadlineRequestInput = {
  highestAndBestDeadline?: InputMaybe<Scalars['DateTime']>;
  resaleId?: InputMaybe<Scalars['String']>;
};

export type OdProtosResaleInventoryServices_SetInGatedCommunityRequestInput = {
  inGatedCommunity?: InputMaybe<Scalars['Boolean']>;
  resaleId?: InputMaybe<Scalars['String']>;
};

export type OdProtosResaleInventoryServices_SetRemoteUnlockDoorDisabledRequestInput = {
  remoteUnlockDoorDisabled?: InputMaybe<Scalars['Boolean']>;
  resaleId?: InputMaybe<Scalars['String']>;
};

export type OdProtosResaleInventoryServices_TerminateRequestInput = {
  reason?: InputMaybe<OdProtosResaleInventoryData_Resale_TerminationReason>;
  resaleId?: InputMaybe<Scalars['String']>;
};

export type OdProtosResaleInventoryServices_UncommitBuyerRequestInput = {
  resaleId?: InputMaybe<Scalars['String']>;
};

export type OdProtosResaleInventoryServices_UnsetHighestAndBestDeadlineRequestInput = {
  resaleId?: InputMaybe<Scalars['String']>;
};

/**
 * UpdateActiveChannelRequest enable active channel details to be set for a
 * specific Resale ID and ChannelType. Based on the Resale ID/ChannelType,
 * the channel state and ID can be set.
 *
 * This endpoint was created for migration/data repair use cases
 */
export type OdProtosResaleInventoryServices_UpdateActiveChannelRequestInput = {
  channelId?: InputMaybe<Scalars['String']>;
  channelState?: InputMaybe<OdProtosResaleInventoryData_ChannelState>;
  channelType?: InputMaybe<OdProtosResaleInventoryData_ChannelType>;
  resaleId?: InputMaybe<Scalars['String']>;
};

export type OdProtosResaleInventoryServices_UpdateBuyDirectAdjustmentFactorRequestInput = {
  buyDirectAdjustmentFactor?: InputMaybe<Scalars['Float']>;
  resaleId?: InputMaybe<Scalars['String']>;
};

export type OdProtosRiskAssessmentData_BimodalCompsRiskInput = {
  _empty?: InputMaybe<Scalars['Boolean']>;
};

export type OdProtosRiskAssessmentData_CommercialNeighborsRiskInput = {
  option?: InputMaybe<OdProtosRiskAssessmentData_CommercialNeighborsRisk_OptionOneofInput>;
};

export type OdProtosRiskAssessmentData_CommercialNeighborsRisk_OptionOneofInput = {
  commercial?: InputMaybe<GoogleProtobuf_EmptyInput>;
  industrial?: InputMaybe<GoogleProtobuf_EmptyInput>;
  school?: InputMaybe<GoogleProtobuf_EmptyInput>;
};

export type OdProtosRiskAssessmentData_CrampedKitchenRiskInput = {
  _empty?: InputMaybe<Scalars['Boolean']>;
};

export type OdProtosRiskAssessmentData_MultiFamilyNeighborsRiskInput = {
  _empty?: InputMaybe<Scalars['Boolean']>;
};

export type OdProtosRiskAssessmentData_NewConstructionRiskInput = {
  _empty?: InputMaybe<Scalars['Boolean']>;
};

export type OdProtosRiskAssessmentData_NonConformingCurbAppealRiskInput = {
  _empty?: InputMaybe<Scalars['Boolean']>;
};

export type OdProtosRiskAssessmentData_OutlierCompsRiskInput = {
  _empty?: InputMaybe<Scalars['Boolean']>;
};

export type OdProtosRiskAssessmentData_PowerlineRiskInput = {
  option?: InputMaybe<OdProtosRiskAssessmentData_PowerlineRisk_OptionOneofInput>;
};

export type OdProtosRiskAssessmentData_PowerlineRisk_OptionOneofInput = {
  highVoltagePowerlineTower?: InputMaybe<GoogleProtobuf_EmptyInput>;
  highVoltagePowerlineWire?: InputMaybe<GoogleProtobuf_EmptyInput>;
  lowVoltagePowerlinePole?: InputMaybe<GoogleProtobuf_EmptyInput>;
  lowVoltagePowerlineWire?: InputMaybe<GoogleProtobuf_EmptyInput>;
  powerlineStation?: InputMaybe<GoogleProtobuf_EmptyInput>;
};

/**
 * Representation of standardized camunda variables that most
 * jobworkers will have available
 */
export type OdProtosRiskAssessmentData_PropertyEngagementMetadataInput = {
  addressToken?: InputMaybe<Scalars['String']>;
  instanceKey?: InputMaybe<Scalars['String']>;
  jobKey?: InputMaybe<Scalars['String']>;
  propertyEngagementGroupId?: InputMaybe<Scalars['String']>;
  propertyEngagementId?: InputMaybe<Scalars['String']>;
  /** camunda job worker specific details */
  stepName?: InputMaybe<Scalars['String']>;
};

export type OdProtosRiskAssessmentData_RecentDelistingRiskInput = {
  _empty?: InputMaybe<Scalars['Boolean']>;
};

export type OdProtosRiskAssessmentData_ResolutionStatus =
  | 'APPROVED'
  | 'REJECTED'
  | 'UNKNOWN';

/** A Risk is a specific risk factor */
export type OdProtosRiskAssessmentData_RiskInput = {
  /** The risk factor */
  factor?: InputMaybe<OdProtosRiskAssessmentData_Risk_FactorOneofInput>;
  /** Additional risk factor notes */
  notes?: InputMaybe<Scalars['String']>;
  /** The risk factor score */
  score?: InputMaybe<Scalars['Float']>;
};

export type OdProtosRiskAssessmentData_Risk_FactorOneofInput = {
  bimodalComps?: InputMaybe<OdProtosRiskAssessmentData_BimodalCompsRiskInput>;
  commercialNeighbors?: InputMaybe<OdProtosRiskAssessmentData_CommercialNeighborsRiskInput>;
  crampedKitchen?: InputMaybe<OdProtosRiskAssessmentData_CrampedKitchenRiskInput>;
  multiFamilyNeighbors?: InputMaybe<OdProtosRiskAssessmentData_MultiFamilyNeighborsRiskInput>;
  newConstruction?: InputMaybe<OdProtosRiskAssessmentData_NewConstructionRiskInput>;
  nonConformingCurbAppeal?: InputMaybe<OdProtosRiskAssessmentData_NonConformingCurbAppealRiskInput>;
  outlierComps?: InputMaybe<OdProtosRiskAssessmentData_OutlierCompsRiskInput>;
  powerline?: InputMaybe<OdProtosRiskAssessmentData_PowerlineRiskInput>;
  recentDelisting?: InputMaybe<OdProtosRiskAssessmentData_RecentDelistingRiskInput>;
  road?: InputMaybe<OdProtosRiskAssessmentData_RoadRiskInput>;
  slopedBackyard?: InputMaybe<OdProtosRiskAssessmentData_SlopedBackyardRiskInput>;
  slopedDriveway?: InputMaybe<OdProtosRiskAssessmentData_SlopedDrivewayRiskInput>;
  smallMaster?: InputMaybe<OdProtosRiskAssessmentData_SmallMasterRiskInput>;
  sunkenSpaces?: InputMaybe<OdProtosRiskAssessmentData_SunkenSpacesRiskInput>;
  trainTrack?: InputMaybe<OdProtosRiskAssessmentData_TrainTrackRiskInput>;
  underRenovated?: InputMaybe<OdProtosRiskAssessmentData_UnderRenovatedRiskInput>;
  unsightlyNeighbor?: InputMaybe<OdProtosRiskAssessmentData_UnsightlyNeighborRiskInput>;
  unusualAdjustments?: InputMaybe<OdProtosRiskAssessmentData_UnusualAdjustmentsRiskInput>;
};

export type OdProtosRiskAssessmentData_RoadRiskInput = {
  option?: InputMaybe<OdProtosRiskAssessmentData_RoadRisk_OptionOneofInput>;
};

export type OdProtosRiskAssessmentData_RoadRisk_OptionOneofInput = {
  arterialRoad?: InputMaybe<GoogleProtobuf_EmptyInput>;
  connectorRoad?: InputMaybe<GoogleProtobuf_EmptyInput>;
  freewayHighway?: InputMaybe<GoogleProtobuf_EmptyInput>;
  mainStreetWithinSubdivision?: InputMaybe<GoogleProtobuf_EmptyInput>;
};

export type OdProtosRiskAssessmentData_SlopedBackyardRiskInput = {
  _empty?: InputMaybe<Scalars['Boolean']>;
};

export type OdProtosRiskAssessmentData_SlopedDrivewayRiskInput = {
  _empty?: InputMaybe<Scalars['Boolean']>;
};

export type OdProtosRiskAssessmentData_SmallMasterRiskInput = {
  _empty?: InputMaybe<Scalars['Boolean']>;
};

export type OdProtosRiskAssessmentData_SunkenSpacesRiskInput = {
  _empty?: InputMaybe<Scalars['Boolean']>;
};

export type OdProtosRiskAssessmentData_TrainTrackRiskInput = {
  _empty?: InputMaybe<Scalars['Boolean']>;
};

export type OdProtosRiskAssessmentData_UnderRenovatedRiskInput = {
  _empty?: InputMaybe<Scalars['Boolean']>;
};

export type OdProtosRiskAssessmentData_UnsightlyNeighborRiskInput = {
  _empty?: InputMaybe<Scalars['Boolean']>;
};

export type OdProtosRiskAssessmentData_UnusualAdjustmentsRiskInput = {
  option?: InputMaybe<OdProtosRiskAssessmentData_UnusualAdjustmentsRisk_OptionOneofInput>;
};

export type OdProtosRiskAssessmentData_UnusualAdjustmentsRisk_OptionOneofInput = {
  golfLot?: InputMaybe<GoogleProtobuf_EmptyInput>;
  waterView?: InputMaybe<GoogleProtobuf_EmptyInput>;
};

export type OdProtosRiskAssessmentServices_CreateCaseyTaskForTestingErrorCode_Code =
  | 'UNKNOWN';

export type OdProtosRiskAssessmentServices_CreateCaseyTaskForTestingRequestInput = {
  requestId?: InputMaybe<OdProtosCommon_RequestIdInput>;
  requestorId?: InputMaybe<OdProtosCommon_RequestorIdInput>;
};

export type OdProtosRiskAssessmentServices_CreateRiskAssessmentErrorCode_Code =
  | 'DUPLICATE'
  | 'INCORRECT_RISK_SCORE'
  | 'INVALID_ARGUMENT'
  | 'OTHER'
  | 'UNKNOWN';

/** Next ID: 18 */
export type OdProtosRiskAssessmentServices_CreateRiskAssessmentRequestInput = {
  addressToken?: InputMaybe<Scalars['String']>;
  createdByToken?: InputMaybe<Scalars['String']>;
  historical?: InputMaybe<Scalars['Boolean']>;
  idempotencyKey?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  propertyEngagementId?: InputMaybe<Scalars['String']>;
  requestId?: InputMaybe<OdProtosCommon_RequestIdInput>;
  requestorId?: InputMaybe<OdProtosCommon_RequestorIdInput>;
  risks?: InputMaybe<Array<OdProtosRiskAssessmentData_RiskInput>>;
  score?: InputMaybe<Scalars['Float']>;
  shouldWalk?: InputMaybe<Scalars['Boolean']>;
  skipValuationOnWalk?: InputMaybe<Scalars['Boolean']>;
  walkOverrideNotes?: InputMaybe<Scalars['String']>;
  walkPreventionNotes?: InputMaybe<Scalars['String']>;
  walkRecOverridden?: InputMaybe<Scalars['Boolean']>;
  webValuationId?: InputMaybe<Scalars['String']>;
};

export type OdProtosRiskAssessmentServices_GetReusableRiskAssessmentErrorCode_Code =
  | 'NOT_FOUND'
  | 'UNKNOWN';

export type OdProtosRiskAssessmentServices_GetReusableRiskAssessmentRequestInput = {
  addressToken?: InputMaybe<Scalars['String']>;
  asOf?: InputMaybe<Scalars['DateTime']>;
  propertyEngagementGroupId?: InputMaybe<Scalars['String']>;
  requestId?: InputMaybe<OdProtosCommon_RequestIdInput>;
  requestorId?: InputMaybe<OdProtosCommon_RequestorIdInput>;
};

export type OdProtosRiskAssessmentServices_GetRiskAssessmentErrorCode_Code =
  | 'INVALID_ARGUMENT'
  | 'NOT_FOUND'
  | 'UNKNOWN';

export type OdProtosRiskAssessmentServices_GetRiskAssessmentRequestInput = {
  requestId?: InputMaybe<OdProtosCommon_RequestIdInput>;
  requestorId?: InputMaybe<OdProtosCommon_RequestorIdInput>;
  riskAssessmentId?: InputMaybe<Scalars['String']>;
};

export type OdProtosRiskAssessmentServices_LogSkipDecisionErrorCode_Code =
  | 'UNKNOWN';

export type OdProtosRiskAssessmentServices_LogSkipDecisionRequestInput = {
  addressToken?: InputMaybe<Scalars['String']>;
  /** Experiment name for deciding to go against general routing */
  experimentName?: InputMaybe<Scalars['String']>;
  propertyEngagementId?: InputMaybe<Scalars['String']>;
  requestId?: InputMaybe<OdProtosCommon_RequestIdInput>;
  requestorId?: InputMaybe<OdProtosCommon_RequestorIdInput>;
  /** Did we decide to generally skip or qc */
  routingDecision?: InputMaybe<OdProtosRiskAssessmentServices_SkipDecisionRoutingCode_Code>;
  /** Did we end up skipping QC or not */
  skipped?: InputMaybe<Scalars['Boolean']>;
};

export type OdProtosRiskAssessmentServices_RecordRiskAssessmentReuseErrorCode_Code =
  | 'UNKNOWN';

export type OdProtosRiskAssessmentServices_RecordRiskAssessmentReuseRequestInput = {
  /** Fill with Risk Assessment Property Engagement ID */
  idempotencyKey?: InputMaybe<Scalars['String']>;
  propertyEngagementId?: InputMaybe<Scalars['String']>;
  requestId?: InputMaybe<OdProtosCommon_RequestIdInput>;
  requestorId?: InputMaybe<OdProtosCommon_RequestorIdInput>;
  riskAssessmentUuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosRiskAssessmentServices_SkipDecisionRequestInput = {
  /** Fill with Risk Assessment Property Engagement ID */
  idempotencyKey?: InputMaybe<Scalars['String']>;
  propertyEngagementMetadata?: InputMaybe<OdProtosRiskAssessmentData_PropertyEngagementMetadataInput>;
  requestId?: InputMaybe<OdProtosCommon_RequestIdInput>;
  requestorId?: InputMaybe<OdProtosCommon_RequestorIdInput>;
};

export type OdProtosRiskAssessmentServices_SkipDecisionRoutingCode_Code =
  | 'QC'
  | 'SKIP'
  | 'UNKNOWN';

export type OdProtosRiskAssessmentServices_StartManualRiskAssessmentErrorCode_Code =
  | 'ALREADY_IN_PROGRESS'
  | 'DEPENDENCY_FAILURE'
  | 'INVALID_ARGUMENT'
  | 'UNKNOWN';

export type OdProtosRiskAssessmentServices_StartManualRiskAssessmentRequestInput = {
  addressToken?: InputMaybe<Scalars['String']>;
  idempotencyKey?: InputMaybe<Scalars['String']>;
  requestId?: InputMaybe<OdProtosCommon_RequestIdInput>;
  requestorId?: InputMaybe<OdProtosCommon_RequestorIdInput>;
  workflowTaskDetail?: InputMaybe<Scalars['String']>;
};

export type OdProtosRiskAssessmentServices_TerminatePropertyEngagementErrorCode_Code =
  | 'UNKNOWN';

export type OdProtosRiskAssessmentServices_TerminatePropertyEngagementRequestInput = {
  /** Fill with Risk Assessment Property Engagement ID */
  idempotencyKey?: InputMaybe<Scalars['String']>;
  propertyEngagementId?: InputMaybe<Scalars['String']>;
  requestId?: InputMaybe<OdProtosCommon_RequestIdInput>;
  requestorId?: InputMaybe<OdProtosCommon_RequestorIdInput>;
};

export type OdProtosRollCallData_EnrollmentFilterInput = {
  column?: InputMaybe<OdProtosRollCallData_EnrollmentFilter_Column>;
  isNegated?: InputMaybe<Scalars['Boolean']>;
  operand?: InputMaybe<OdProtosRollCallData_EnrollmentFilter_OperandInput>;
  operator?: InputMaybe<OdProtosRollCallData_EnrollmentFilter_Operator>;
};

export type OdProtosRollCallData_EnrollmentFilterSetInput = {
  /** filters are AND'd with each other */
  filters?: InputMaybe<Array<OdProtosRollCallData_EnrollmentFilterInput>>;
};

export type OdProtosRollCallData_EnrollmentFilter_Column =
  | 'ADDRESS_ID'
  | 'ADDRESS_LABEL'
  | 'ADDRESS_TSV'
  /** Active */
  | 'CANCELLED_AT'
  | 'DEFAULT_FIELD_USER_ID'
  | 'MARKET_FENCE_ID'
  /** Deprecated :  Protobuf 3 requires the first value to be 0 */
  | 'SERVICE'
  | 'VENDOR_BRANCH_ID';

export type OdProtosRollCallData_EnrollmentFilter_OperandInput = {
  value?: InputMaybe<OdProtosRollCallData_EnrollmentFilter_Operand_ValueOneofInput>;
};

export type OdProtosRollCallData_EnrollmentFilter_Operand_StringListInput = {
  strings?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosRollCallData_EnrollmentFilter_Operand_ValueOneofInput = {
  /** Deprecated */
  serviceValue?: InputMaybe<OdProtosRollCallData_Enrollment_Service>;
  stringValue?: InputMaybe<Scalars['String']>;
  stringValueList?: InputMaybe<OdProtosRollCallData_EnrollmentFilter_Operand_StringListInput>;
  timestampValue?: InputMaybe<Scalars['DateTime']>;
};

export type OdProtosRollCallData_EnrollmentFilter_Operator =
  | 'EQUAL_TO'
  | 'GREATER_THAN'
  | 'GREATER_THAN_OR_EQUAL_TO'
  | 'ILIKE'
  | 'IN'
  | 'IS_NULL'
  | 'LESS_THAN'
  | 'LESS_THAN_OR_EQUAL_TO'
  | 'LIKE'
  | 'TEXT_SEARCH';

export type OdProtosRollCallData_EnrollmentOrderingInput = {
  column?: InputMaybe<OdProtosRollCallData_EnrollmentOrdering_Column>;
  isAscending?: InputMaybe<Scalars['Boolean']>;
};

export type OdProtosRollCallData_EnrollmentOrdering_Column =
  | 'CANCELLED_AT'
  | 'CREATED_AT';

/** Deprecated */
export type OdProtosRollCallData_Enrollment_Service =
  | 'HOMEOPS_STANDARD'
  | 'INVALID'
  | 'PROPERTY_MANAGEMENT';

export type OdProtosRollCallServices_ChangeAddressRequestInput = {
  ids?: InputMaybe<Array<Scalars['String']>>;
  newAddressId?: InputMaybe<Scalars['String']>;
  oldAddressId?: InputMaybe<Scalars['String']>;
};

export type OdProtosRollCallServices_CreateEnrollmentRequestInput = {
  addressId?: InputMaybe<Scalars['String']>;
  defaultFieldUserId?: InputMaybe<Scalars['String']>;
  /** Deprecated */
  enrolleeOrganizationId?: InputMaybe<Scalars['String']>;
  enrolleeUserId?: InputMaybe<Scalars['String']>;
  marketFenceId?: InputMaybe<Scalars['String']>;
  occupantEmail?: InputMaybe<Scalars['String']>;
  occupantName?: InputMaybe<Scalars['String']>;
  occupantPhone?: InputMaybe<Scalars['String']>;
  reminderPhone?: InputMaybe<Scalars['String']>;
  service?: InputMaybe<OdProtosRollCallData_Enrollment_Service>;
  vendorBranchId?: InputMaybe<Scalars['String']>;
};

export type OdProtosRollCallServices_GetFieldUsersRequestInput = {
  marketFenceIds?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosRollCallServices_IdentifierListRequestInput = {
  ids?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosRollCallServices_IdentifierRequestInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type OdProtosRollCallServices_SearchEnrollmentsRequestInput = {
  /** filter_sets are OR'd with each other */
  filterSets?: InputMaybe<Array<OdProtosRollCallData_EnrollmentFilterSetInput>>;
  orderings?: InputMaybe<Array<OdProtosRollCallData_EnrollmentOrderingInput>>;
  pagination?: InputMaybe<OdProtosCommonPagination_PaginationRequestInput>;
};

export type OdProtosRollCallServices_UpdateEnrollmentRequestInput = {
  defaultFieldUserId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isOdSelectEnrollmentRequest?: InputMaybe<Scalars['Boolean']>;
  occupantEmail?: InputMaybe<Scalars['String']>;
  occupantName?: InputMaybe<Scalars['String']>;
  occupantPhone?: InputMaybe<Scalars['String']>;
  reminderPhone?: InputMaybe<Scalars['String']>;
};

export type OdProtosRubricData_OptionBehavior_Action =
  | 'CREATE_ISSUE'
  | 'EMIT_MESSAGE'
  | 'NONE'
  | 'REQUIRE_COMMENT'
  | 'REQUIRE_COMMENT_AND_PHOTO'
  | 'REQUIRE_PHOTOS';

export type OdProtosRubricData_Prompt_AnswerTypeValidation =
  | 'FLOAT'
  | 'INT'
  | 'NONE'
  | 'STRING';

export type OdProtosRubricData_Prompt_Type =
  | 'ASSET_COLLECTION'
  | 'FREEFORM'
  | 'KNOX_IDENTIFIER'
  | 'MULTIPLE_SELECT'
  | 'SINGLE_SELECT'
  | 'UNKNOWN';

export type OdProtosRubricServices_ChangeAddressRequestInput = {
  newAddressId?: InputMaybe<Scalars['String']>;
  oldAddressId?: InputMaybe<Scalars['String']>;
  taskIds?: InputMaybe<Array<Scalars['String']>>;
  visitIds?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosRubricV2Data_AllowedFollowUpPromptGroupInput = {
  /**
   * some prompts have followup prompts.
   * this list contains all followup prompts this
   * prompt group allows.
   */
  allowedFollowupPrompts?: InputMaybe<Array<OdProtosRubricV2Data_PromptInput>>;
  /** id identifies the prompt group. There can be multiple occasions of this id. */
  id?: InputMaybe<Scalars['String']>;
  /** key is a unique identifier */
  key?: InputMaybe<Scalars['String']>;
  prompts?: InputMaybe<Array<OdProtosRubricV2Data_PromptInput>>;
  required?: InputMaybe<Scalars['Boolean']>;
  tags?: InputMaybe<Array<Scalars['String']>>;
  title?: InputMaybe<Scalars['String']>;
};

export type OdProtosRubricV2Data_CorrelatedPromptResponseInput = {
  response?: InputMaybe<OdProtosRubricV2Data_CorrelatedPromptResponse_ResponseOneofInput>;
  rubricId?: InputMaybe<Scalars['String']>;
};

export type OdProtosRubricV2Data_CorrelatedPromptResponse_ResponseOneofInput = {
  audios?: InputMaybe<OdProtosRubricV2Data_UploadedAudiosInput>;
  photos?: InputMaybe<OdProtosRubricV2Data_UploadedPhotosInput>;
  selectedOptions?: InputMaybe<OdProtosRubricV2Data_SelectedOptionsInput>;
  text?: InputMaybe<Scalars['String']>;
  videos?: InputMaybe<OdProtosRubricV2Data_UploadedVideosInput>;
};

export type OdProtosRubricV2Data_EventInput = {
  assetIds?: InputMaybe<Array<Scalars['String']>>;
  id?: InputMaybe<Scalars['String']>;
  occurredAt?: InputMaybe<Scalars['DateTime']>;
  promptCorrelationKey?: InputMaybe<Scalars['String']>;
  promptGroupCorrelationKey?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

export type OdProtosRubricV2Data_ExternalActionTriggerInput = {
  actionName?: InputMaybe<Scalars['String']>;
  triggeringAnswers?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosRubricV2Data_FollowUpPromptGroupInput = {
  /**
   * if any of these answers are not selected
   * the followup prompt group will be added
   */
  expectedAnswers?: InputMaybe<Array<Scalars['String']>>;
  promptGroupId?: InputMaybe<Scalars['String']>;
  /** empty if the followup prompt group doesn't exist yet */
  promptGroupKey?: InputMaybe<Scalars['String']>;
  /**
   * if any of these answers are selected
   * the followup prompt group will be added
   */
  triggeringAnswers?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosRubricV2Data_FollowUpPromptInput = {
  /**
   * if any of these answers are not selected
   * the followup prompt will be added
   */
  expectedAnswers?: InputMaybe<Array<Scalars['String']>>;
  promptId?: InputMaybe<Scalars['String']>;
  /** empty if the followup prompt doesn't exist yet */
  promptKey?: InputMaybe<Scalars['String']>;
  /**
   * if any of these answers are selected
   * the followup prompt will be added
   */
  triggeringAnswers?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosRubricV2Data_OptionBehaviorInput = {
  action?: InputMaybe<OdProtosRubricV2Data_OptionBehavior_Action>;
  assetIds?: InputMaybe<Array<Scalars['String']>>;
  comment?: InputMaybe<Scalars['String']>;
};

export type OdProtosRubricV2Data_OptionBehavior_Action =
  | 'NONE'
  | 'REQUIRE_COMMENT'
  | 'REQUIRE_COMMENT_AND_PHOTO'
  /** Add if needed PROMPT_GROUP_ADDITION = 4; */
  | 'REQUIRE_COMMENT_AND_VIDEO'
  | 'REQUIRE_PHOTOS'
  | 'REQUIRE_VIDEOS';

export type OdProtosRubricV2Data_OptionInput = {
  description?: InputMaybe<Scalars['String']>;
  displayText?: InputMaybe<Scalars['String']>;
  optionBehavior?: InputMaybe<OdProtosRubricV2Data_OptionBehaviorInput>;
  value?: InputMaybe<Scalars['String']>;
};

export type OdProtosRubricV2Data_PreviousVisitDataInput = {
  comments?: InputMaybe<Array<Scalars['String']>>;
  correlatedPromptResponses?: InputMaybe<Array<OdProtosRubricV2Data_CorrelatedPromptResponseInput>>;
  photoUrls?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosRubricV2Data_PromptBehaviorInput = {
  behavior?: InputMaybe<OdProtosRubricV2Data_PromptBehavior_BehaviorOneofInput>;
};

export type OdProtosRubricV2Data_PromptBehavior_BehaviorOneofInput = {
  externalActionTrigger?: InputMaybe<OdProtosRubricV2Data_ExternalActionTriggerInput>;
  followUpPrompt?: InputMaybe<OdProtosRubricV2Data_FollowUpPromptInput>;
  followUpPromptGroup?: InputMaybe<OdProtosRubricV2Data_FollowUpPromptGroupInput>;
  /**
   * prompt_group_addition has not been properly implemented
   * it might get deprecated
   */
  promptGroupAddition?: InputMaybe<OdProtosRubricV2Data_PromptGroupAdditionInput>;
  textValidation?: InputMaybe<OdProtosRubricV2Data_TextValidationInput>;
};

export type OdProtosRubricV2Data_PromptGroupAdditionInput = {
  condition?: InputMaybe<OdProtosRubricV2Data_PromptGroupAddition_Condition>;
  /** the prompt group needs to be part of the cloneable_prompt_groups on the rubric */
  promptGroupId?: InputMaybe<Scalars['String']>;
};

export type OdProtosRubricV2Data_PromptGroupAddition_Condition =
  | 'NONE'
  /** Add if needed ONCE = 2; */
  | 'ONE_PER_NUMBER';

export type OdProtosRubricV2Data_PromptGroupInput = {
  /**
   * some prompts have followup prompt groups.
   * this list contains all followup prompt groups this
   * prompt group allows.
   */
  allowedFollowupPromptGroups?: InputMaybe<Array<OdProtosRubricV2Data_AllowedFollowUpPromptGroupInput>>;
  /**
   * some prompts have followup prompts.
   * this list contains all followup prompts this
   * prompt group allows.
   */
  allowedFollowupPrompts?: InputMaybe<Array<OdProtosRubricV2Data_PromptInput>>;
  /** correlation_key is used to correlate this prompt group with other related prompt groups in different rubrics */
  correlationKey?: InputMaybe<Scalars['String']>;
  /** id identifies the prompt group. There can be multiple occasions of this id. */
  id?: InputMaybe<Scalars['String']>;
  /** key is a unique identifier */
  key?: InputMaybe<Scalars['String']>;
  prompts?: InputMaybe<Array<OdProtosRubricV2Data_PromptInput>>;
  required?: InputMaybe<Scalars['Boolean']>;
  tags?: InputMaybe<Array<Scalars['String']>>;
  title?: InputMaybe<Scalars['String']>;
};

export type OdProtosRubricV2Data_PromptInput = {
  assetIds?: InputMaybe<Array<Scalars['String']>>;
  /** correlation_key is used to correlate this prompt with other related prompts in different rubrics */
  correlationKey?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  displayText?: InputMaybe<Scalars['String']>;
  /** id identifies the prompt. There can be multiple occasions of this id. */
  id?: InputMaybe<Scalars['String']>;
  /** key is a unique identifier */
  key?: InputMaybe<Scalars['String']>;
  options?: InputMaybe<Array<OdProtosRubricV2Data_OptionInput>>;
  previousVisit?: InputMaybe<OdProtosRubricV2Data_PreviousVisitDataInput>;
  /** prompt_behaviors are executed in order if the previous succeeds */
  promptBehaviors?: InputMaybe<Array<OdProtosRubricV2Data_PromptBehaviorInput>>;
  readOnly?: InputMaybe<Scalars['Boolean']>;
  required?: InputMaybe<Scalars['Boolean']>;
  response?: InputMaybe<OdProtosRubricV2Data_Prompt_ResponseOneofInput>;
  tags?: InputMaybe<Array<Scalars['String']>>;
  type?: InputMaybe<OdProtosRubricV2Data_Prompt_Type>;
};

export type OdProtosRubricV2Data_Prompt_ResponseOneofInput = {
  audios?: InputMaybe<OdProtosRubricV2Data_UploadedAudiosInput>;
  photos?: InputMaybe<OdProtosRubricV2Data_UploadedPhotosInput>;
  selectedOptions?: InputMaybe<OdProtosRubricV2Data_SelectedOptionsInput>;
  text?: InputMaybe<Scalars['String']>;
  videos?: InputMaybe<OdProtosRubricV2Data_UploadedVideosInput>;
};

export type OdProtosRubricV2Data_Prompt_Type =
  | 'AUDIO_INPUT'
  | 'FREEFORM'
  | 'MULTIPLE_SELECT'
  | 'PHOTO_INPUT'
  | 'SINGLE_SELECT'
  | 'TEXT_BOX'
  | 'UNKNOWN'
  | 'VIDEO_INPUT'
  | 'YEAR_SELECT';

export type OdProtosRubricV2Data_RegexValidationInput = {
  /** explanation of the regex in plain english. To be shown if the regex doesn't match */
  explanation?: InputMaybe<Scalars['String']>;
  regex?: InputMaybe<Scalars['String']>;
};

export type OdProtosRubricV2Data_RubricInput = {
  cloneablePromptGroups?: InputMaybe<Array<OdProtosRubricV2Data_PromptGroupInput>>;
  description?: InputMaybe<Scalars['String']>;
  events?: InputMaybe<Array<OdProtosRubricV2Data_EventInput>>;
  /** id identifies the rubric. There can be multiple occasions of this id. */
  id: Scalars['ID'];
  /** key is a unique identifier */
  key?: InputMaybe<Scalars['String']>;
  promptGroups?: InputMaybe<Array<OdProtosRubricV2Data_PromptGroupInput>>;
  title?: InputMaybe<Scalars['String']>;
};

export type OdProtosRubricV2Data_SelectedOptionsInput = {
  values?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosRubricV2Data_TextValidationInput = {
  answerTypeValidation?: InputMaybe<OdProtosRubricV2Data_TextValidation_AnswerTypeValidation>;
  /** If the answer is a number we make sure it's >= lower bound */
  lowerBoundValidation?: InputMaybe<Scalars['Float']>;
  regexValidation?: InputMaybe<OdProtosRubricV2Data_RegexValidationInput>;
  /** If the answer is a number we make sure it's <= upper bound */
  upperBoundValidation?: InputMaybe<Scalars['Float']>;
};

export type OdProtosRubricV2Data_TextValidation_AnswerTypeValidation =
  /** a number */
  | 'FLOAT'
  /** an integer */
  | 'INT'
  /** no type validation */
  | 'NONE'
  /** a year or "unknown" */
  | 'YEAR';

export type OdProtosRubricV2Data_UploadedAudiosInput = {
  assetIds?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosRubricV2Data_UploadedPhotosInput = {
  assetIds?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosRubricV2Data_UploadedVideosInput = {
  assetIds?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosRubricV2Services_AddPromptGroupsRequestInput = {
  promptGroupIds?: InputMaybe<Array<Scalars['String']>>;
  reportId?: InputMaybe<Scalars['String']>;
};

export type OdProtosRubricV2Services_AnswerOptionBehaviorRequestInput = {
  assetIds?: InputMaybe<Array<Scalars['String']>>;
  comment?: InputMaybe<Scalars['String']>;
  optionValue?: InputMaybe<Scalars['String']>;
  promptKey?: InputMaybe<Scalars['String']>;
  reportId?: InputMaybe<Scalars['String']>;
};

export type OdProtosRubricV2Services_AnswerPromptRequestInput = {
  promptKey?: InputMaybe<Scalars['String']>;
  reportId?: InputMaybe<Scalars['String']>;
  response?: InputMaybe<OdProtosRubricV2Services_AnswerPromptRequest_ResponseOneofInput>;
};

export type OdProtosRubricV2Services_AnswerPromptRequest_ResponseOneofInput = {
  audios?: InputMaybe<OdProtosRubricV2Data_UploadedAudiosInput>;
  photos?: InputMaybe<OdProtosRubricV2Data_UploadedPhotosInput>;
  selectedOptions?: InputMaybe<OdProtosRubricV2Data_SelectedOptionsInput>;
  text?: InputMaybe<Scalars['String']>;
  videos?: InputMaybe<OdProtosRubricV2Data_UploadedVideosInput>;
};

export type OdProtosRubricV2Services_BackfillQuestionsAndAnswersRequestInput = {
  /** Provide either limit and offset or report ids */
  limit?: InputMaybe<Scalars['Float']>;
  offset?: InputMaybe<Scalars['Float']>;
  reportIds?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosRubricV2Services_CompleteReportAndTaskRequestInput = {
  taskId?: InputMaybe<Scalars['String']>;
};

export type OdProtosRubricV2Services_CreateReportForVisitRequestInput = {
  visitId?: InputMaybe<Scalars['String']>;
};

export type OdProtosRubricV2Services_CreateTaskWithRubricRequestInput = {
  originatingRubricId?: InputMaybe<Scalars['String']>;
  taskRequest?: InputMaybe<OdProtosCaseyV0Services_Create_RequestInput>;
};

export type OdProtosRubricV2Services_CreateVisitTypeRubricAssociationRequestInput = {
  rubricId?: InputMaybe<Scalars['String']>;
  visitTypeId?: InputMaybe<Scalars['String']>;
};

export type OdProtosRubricV2Services_GetPromptDiscrepancyStatisticsRequestInput = {
  addressIds?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosRubricV2Services_IdentifierInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type OdProtosRubricV2Services_MockAgentFullAssessmentForAddressRequestInput = {
  addressToken?: InputMaybe<Scalars['String']>;
  agentHumanToken?: InputMaybe<Scalars['String']>;
};

export type OdProtosRubricV2Services_MockIpwForReportRequestInput = {
  visitId?: InputMaybe<Scalars['String']>;
};

export type OdProtosRubricV2Services_QuestionFilterInput = {
  /** A filter which must match against the answers for the question. */
  answerFilter?: InputMaybe<OdProtosRubricV2Services_QuestionFilter_ExprInput>;
  /** If specified, the question must have the given dwh tag */
  questionDwhTag?: InputMaybe<Scalars['String']>;
};

export type OdProtosRubricV2Services_QuestionFilter_AndInput = {
  exprs?: InputMaybe<Array<OdProtosRubricV2Services_QuestionFilter_ExprInput>>;
};

export type OdProtosRubricV2Services_QuestionFilter_AnswerPredicateInput = {
  /**
   * A list of answer values to compare against the answers in the
   * database.
   */
  answers?: InputMaybe<Array<Scalars['String']>>;
  /**
   * Indicates if this predicate requires that the questions
   * answers are a subset or a superset of the provided answers.
   * Only matters for multi-select.
   */
  setOp?: InputMaybe<OdProtosRubricV2Services_QuestionFilter_SetRelation>;
};

/**
 * We wrap the predicate in a oneof so we can gracefully extend the interface with
 * boolean combinators if needed in the future.
 */
export type OdProtosRubricV2Services_QuestionFilter_ExprInput = {
  expr?: InputMaybe<OdProtosRubricV2Services_QuestionFilter_Expr_ExprOneofInput>;
};

export type OdProtosRubricV2Services_QuestionFilter_Expr_ExprOneofInput = {
  and?: InputMaybe<OdProtosRubricV2Services_QuestionFilter_AndInput>;
  or?: InputMaybe<OdProtosRubricV2Services_QuestionFilter_OrInput>;
  pred?: InputMaybe<OdProtosRubricV2Services_QuestionFilter_AnswerPredicateInput>;
};

export type OdProtosRubricV2Services_QuestionFilter_OrInput = {
  exprs?: InputMaybe<Array<OdProtosRubricV2Services_QuestionFilter_ExprInput>>;
};

export type OdProtosRubricV2Services_QuestionFilter_SetRelation =
  | 'SUBSET'
  | 'SUPERSET';

export type OdProtosRubricV2Services_RemovePromptGroupRequestInput = {
  promptGroupKey?: InputMaybe<Scalars['String']>;
  reportId?: InputMaybe<Scalars['String']>;
};

export type OdProtosRubricV2Services_RepeatedIdentifierInput = {
  ids?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosRubricV2Services_ReplaceVisitRubricContentRequestInput = {
  rubricId?: InputMaybe<Scalars['String']>;
  visitIds?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosRubricV2Services_SearchReportQuestionsRequestInput = {
  /** If specified, only restrict the search to reports attached to the given address. */
  addressIds?: InputMaybe<Array<Scalars['String']>>;
  /** If specified, restrict the search to reports submitted in the last `lookback_seconds` */
  lookbackSeconds?: InputMaybe<Scalars['Float']>;
  /**
   * If specified, a filter to apply to the questions asked in the reports. At least one
   * question must match the filter in order for the report it is attached to to match.
   */
  questionFilter?: InputMaybe<OdProtosRubricV2Services_SearchReportQuestionsRequest_ExprInput>;
};

export type OdProtosRubricV2Services_SearchReportQuestionsRequest_AndInput = {
  exprs?: InputMaybe<Array<OdProtosRubricV2Services_SearchReportQuestionsRequest_ExprInput>>;
};

/**
 * We wrap the filter in a oneof struct so that we can gracefully extend the interface
 * with boolean combinators (and, or) in the future if needed. They are not yet needed,
 * so we haven't implemented them.
 */
export type OdProtosRubricV2Services_SearchReportQuestionsRequest_ExprInput = {
  expr?: InputMaybe<OdProtosRubricV2Services_SearchReportQuestionsRequest_Expr_ExprOneofInput>;
};

export type OdProtosRubricV2Services_SearchReportQuestionsRequest_Expr_ExprOneofInput = {
  and?: InputMaybe<OdProtosRubricV2Services_SearchReportQuestionsRequest_AndInput>;
  filter?: InputMaybe<OdProtosRubricV2Services_QuestionFilterInput>;
  or?: InputMaybe<OdProtosRubricV2Services_SearchReportQuestionsRequest_OrInput>;
};

export type OdProtosRubricV2Services_SearchReportQuestionsRequest_OrInput = {
  exprs?: InputMaybe<Array<OdProtosRubricV2Services_SearchReportQuestionsRequest_ExprInput>>;
};

export type OdProtosRubricV2Services_UpdateReportRequestInput = {
  id?: InputMaybe<Scalars['String']>;
  isFinal?: InputMaybe<Scalars['Boolean']>;
  rubric?: InputMaybe<OdProtosRubricV2Data_RubricInput>;
};

/**
 * Indicates when the next follow-up action should be taken for a card.
 * Used to schedule follow-up activities (e.g. today, tomorrow, after tomorrow).
 */
export type OdProtosSalesCrmData_ActionFor =
  | 'ACTION_FOR_AFTER_TOMORROW'
  | 'ACTION_FOR_TODAY'
  | 'ACTION_FOR_TOMORROW'
  | 'ACTION_FOR_UNSPECIFIED';

/** AssignedHSA represents either a human or a virtual agent assigned to a card. */
export type OdProtosSalesCrmData_AssignedHsaInput = {
  type?: InputMaybe<OdProtosSalesCrmData_AssignedHsa_TypeOneofInput>;
};

/** A human assigned to the card. */
export type OdProtosSalesCrmData_AssignedHsa_HumanInput = {
  _empty?: InputMaybe<Scalars['Boolean']>;
};

export type OdProtosSalesCrmData_AssignedHsa_TypeOneofInput = {
  human?: InputMaybe<OdProtosSalesCrmData_AssignedHsa_HumanInput>;
  virtualAgent?: InputMaybe<OdProtosSalesCrmData_AssignedHsa_VirtualAgentInput>;
};

/** A virtual agent assigned to the card. */
export type OdProtosSalesCrmData_AssignedHsa_VirtualAgentInput = {
  name?: InputMaybe<Scalars['String']>;
  version?: InputMaybe<Scalars['String']>;
};

export type OdProtosSalesCrmData_CallOutcome =
  | 'CALL_OUTCOME_ASSESSMENT_SCHEDULED'
  | 'CALL_OUTCOME_BUSY'
  | 'CALL_OUTCOME_FAILED'
  | 'CALL_OUTCOME_MEETING_BOOKED'
  | 'CALL_OUTCOME_NO_ANSWER'
  | 'CALL_OUTCOME_SCHEDULING_FAILED'
  | 'CALL_OUTCOME_SPOKE_TO_CUSTOMER'
  | 'CALL_OUTCOME_UNSPECIFIED'
  | 'CALL_OUTCOME_VOICEMAIL';

/** A message for aggregating filters. */
export type OdProtosSalesCrmData_CardFiltersInput = {
  /**
   * Assignee human ID is a field that allows to filter cards by the assigned
   * human ID.
   */
  assigneeHumanId?: InputMaybe<Scalars['String']>;
  /** Filter by card flavor */
  flavor?: InputMaybe<OdProtosSalesCrmData_Flavor>;
  /**
   * Follow up timing is a field that allows to filter cards by the time when
   * a follow up action should be taken.
   */
  followUpTiming?: InputMaybe<OdProtosSalesCrmData_ActionFor>;
  /** Filter by whether the offer has been refreshed */
  isOfferRefreshed?: InputMaybe<Scalars['Boolean']>;
  stage?: InputMaybe<OdProtosSalesCrmData_Stage>;
  /** Filter by card type */
  type?: InputMaybe<OdProtosSalesCrmData_CardType>;
};

/** Card should contain all data visible on a single card in the Prospect View. */
export type OdProtosSalesCrmData_CardInput = {
  /** The assigned HSA to the card */
  assignedHsa?: InputMaybe<OdProtosSalesCrmData_AssignedHsaInput>;
  /** The human ID assigned to this card. */
  assigneeHumanId?: InputMaybe<Scalars['String']>;
  /** The time card was created */
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** Precise follow up action date and time */
  expectedActionAt?: InputMaybe<Scalars['DateTime']>;
  /** The experiment */
  experiment?: InputMaybe<OdProtosSalesCrmData_Card_ExperimentOneofInput>;
  /** The flavor of the card (ALO, Non-ALO, D2C) */
  flavor?: InputMaybe<OdProtosSalesCrmData_Flavor>;
  /**
   * Follow up timing is a field that allows to filter cards by the time when
   * a follow up action should be taken.
   */
  followUpTiming?: InputMaybe<OdProtosSalesCrmData_ActionFor>;
  /** Whether the offer has been refreshed */
  isOfferRefreshed?: InputMaybe<Scalars['Boolean']>;
  /** I.e. ALO, Overdue */
  labels?: InputMaybe<Array<Scalars['String']>>;
  /**
   * This is a language code used to register this card in the onboarding process.
   * The format is two-letter ISO 639-1 code, e.g. "en", "es", "fr".
   */
  languageCode?: InputMaybe<Scalars['String']>;
  /** The Lead Token that that belongs to the card. */
  leadToken?: InputMaybe<Scalars['String']>;
  /** Number of times the card was moved to no-contact stage */
  noContactAttempts?: InputMaybe<Scalars['Float']>;
  /** A stage of the card. */
  stage?: InputMaybe<OdProtosSalesCrmData_Stage>;
  /** I.e. Contact made - not interested. */
  tags?: InputMaybe<Array<Scalars['String']>>;
  /**
   * A task sequence state of the card.
   * E.g. `Day 5` or `Day 3`.
   */
  taskSequenceState?: InputMaybe<Scalars['String']>;
  /** The type of the card (prospect or lead) */
  type?: InputMaybe<OdProtosSalesCrmData_CardType>;
  /** The time card was updated */
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

/** CardType represents the type of a card. */
export type OdProtosSalesCrmData_CardType =
  | 'CARD_TYPE_LEAD'
  | 'CARD_TYPE_PROSPECT'
  | 'CARD_TYPE_UNSPECIFIED';

export type OdProtosSalesCrmData_Card_ExperimentOneofInput = {
  higherOffer?: InputMaybe<OdProtosSalesCrmData_ExperimentHigherOfferInput>;
  odlo?: InputMaybe<OdProtosSalesCrmData_ExperimentOdloInput>;
  odloHigherOffer?: InputMaybe<OdProtosSalesCrmData_ExperimentOdloHigherOfferInput>;
};

/** CommunicationType defines the types of communication channels */
export type OdProtosSalesCrmData_CommunicationType =
  | 'COMMUNICATION_TYPE_SMS'
  | 'COMMUNICATION_TYPE_UNSPECIFIED';

/** DistributionConfig defines the complete distribution configuration. */
export type OdProtosSalesCrmData_DistributionConfigInput = {
  /**
   * List of distribution rules (percentages must sum to 100)
   * Used as fallback when no score rule matches, or when score data is not available.
   */
  rules?: InputMaybe<Array<OdProtosSalesCrmData_DistributionRuleInput>>;
  /**
   * ScoreRules are evaluated first, in order. If a score rule matches, its distribution is used.
   * Optional - if not provided, percentage-based rules are used exclusively.
   */
  scoreRules?: InputMaybe<Array<OdProtosSalesCrmData_ScoreRuleInput>>;
};

/**
 * DistributionRule defines a single rule for distributing cards to HSAs.
 * Each rule assigns a percentage of cards to either a group or a specific agent.
 */
export type OdProtosSalesCrmData_DistributionRuleInput = {
  /**
   * Percentage of cards this rule should handle (0-100)
   * All rule percentages must sum to 100
   */
  percentage?: InputMaybe<Scalars['Float']>;
  /** The target for this distribution rule (either a group or specific agent) */
  target?: InputMaybe<OdProtosSalesCrmData_DistributionRule_TargetOneofInput>;
};

export type OdProtosSalesCrmData_DistributionRule_TargetOneofInput = {
  /** Specific agent's human ID */
  agentId?: InputMaybe<Scalars['String']>;
  /** HSA group to distribute evenly among all HSAs in this group */
  group?: InputMaybe<OdProtosSalesCrmData_HsaGroup>;
};

/** ExpectedOutcome represents the expected outcome for a card */
export type OdProtosSalesCrmData_ExpectedOutcome =
  | 'EXPECTED_OUTCOME_ASSESSMENT_SCHEDULED'
  | 'EXPECTED_OUTCOME_OFFER_REVIEW'
  | 'EXPECTED_OUTCOME_UNSPECIFIED';

/** A list of available experiments */
export type OdProtosSalesCrmData_Experiment =
  /** Higher Offer. */
  | 'EXPERIMENT_HIGHER_OFFER'
  /** ALO but without agents. */
  | 'EXPERIMENT_ODLO'
  /** ODLO Higher Offer. */
  | 'EXPERIMENT_ODLO_HIGHER_OFFER'
  | 'EXPERIMENT_UNSPECIFIED';

/** A message for aggregating experiment card filters. */
export type OdProtosSalesCrmData_ExperimentCardFiltersInput = {
  /**
   * Assignee human ID is a field that allows to filter cards by the assigned
   * human ID.
   */
  assigneeHumanId?: InputMaybe<Scalars['String']>;
  /**
   * Experiment cards to fetch.
   * No experiment specified means all cards from all experiments will be returned.
   */
  experiment?: InputMaybe<Array<OdProtosSalesCrmData_Experiment>>;
  /** Filter by card flavor */
  flavor?: InputMaybe<OdProtosSalesCrmData_Flavor>;
  /** Filter by whether the offer has been refreshed */
  isOfferRefreshed?: InputMaybe<Scalars['Boolean']>;
  stage?: InputMaybe<OdProtosSalesCrmData_Stage>;
  /** Filter by tags. */
  tags?: InputMaybe<Array<Scalars['String']>>;
  /** Filter by card type */
  type?: InputMaybe<OdProtosSalesCrmData_CardType>;
};

/**
 * Higher Offer
 * ODLO Experiment: treatment_higher_offer
 */
export type OdProtosSalesCrmData_ExperimentHigherOfferInput = {
  selectedAssessmentTime?: InputMaybe<Scalars['DateTime']>;
};

/**
 * ALO but without agents and with Higher Offer
 * ODLO Experiment: treatment_higher_offer_odlo
 */
export type OdProtosSalesCrmData_ExperimentOdloHigherOfferInput = {
  selectedAssessmentTime?: InputMaybe<Scalars['DateTime']>;
};

/**
 * ALO but without agents (ODLO)
 * ODLO Experiment: treatment
 */
export type OdProtosSalesCrmData_ExperimentOdloInput = {
  _empty?: InputMaybe<Scalars['Boolean']>;
};

/** Flavor represents the flavor of a card. */
export type OdProtosSalesCrmData_Flavor =
  /** Agent-Led Offer */
  | 'FLAVOR_ALO'
  /** Direct to Consumer */
  | 'FLAVOR_D2C'
  /** Direct to Consumer - Button Clicked */
  | 'FLAVOR_D2C_BUTTON_CLICKED'
  /** Non Agent-Led Offer */
  | 'FLAVOR_NON_ALO'
  | 'FLAVOR_UNSPECIFIED';

/** HSAGroup defines the available groups for HSAs. */
export type OdProtosSalesCrmData_HsaGroup =
  | 'HSA_GROUP_AI'
  | 'HSA_GROUP_DEFAULT'
  | 'HSA_GROUP_MEXICO_TEAM'
  | 'HSA_GROUP_UNSPECIFIED';

/** HSAVirtualAgentConfig holds the configuration for a virtual sales agent */
export type OdProtosSalesCrmData_HsaVirtualAgentConfigInput = {
  /** Name of the virtual agent */
  name?: InputMaybe<Scalars['String']>;
  /** Phone number for the virtual agent */
  phoneNumber?: InputMaybe<Scalars['String']>;
  /** RetellAI configuration */
  retellConfig?: InputMaybe<OdProtosSalesCrmData_RetellAiConfigInput>;
  /** Sequence configuration */
  sequence?: InputMaybe<OdProtosSalesCrmData_SequenceConfigInput>;
  /** Testing configuration (optional) */
  testing?: InputMaybe<OdProtosSalesCrmData_VirtualAgentTestingConfigInput>;
  /** Version of the virtual agent */
  version?: InputMaybe<Scalars['String']>;
};

/** LLMAction represents the action determined by the LLM. */
export type OdProtosSalesCrmData_LlmAction =
  | 'LLM_ACTION_CONFIRM'
  | 'LLM_ACTION_ESCALATE_TO_HUMAN'
  | 'LLM_ACTION_NO_ACTION'
  | 'LLM_ACTION_SEND_CALENDLY_LINK'
  | 'LLM_ACTION_SEND_SMS'
  | 'LLM_ACTION_UNSPECIFIED';

/** LLMIntent represents the detected intent for event that triggered the LLM processing. */
export type OdProtosSalesCrmData_LlmIntent =
  | 'LLM_INTENT_ASK_QUESTION'
  | 'LLM_INTENT_CANCEL_TOUR'
  | 'LLM_INTENT_CONFIRM_TOUR'
  | 'LLM_INTENT_NOT_INTERESTED'
  | 'LLM_INTENT_OTHER'
  | 'LLM_INTENT_RESCHEDULE_TOUR'
  | 'LLM_INTENT_SCHEDULE_TOUR'
  | 'LLM_INTENT_UNSPECIFIED';

/** LLMInteractionStatus represents the processing status of an interaction. */
export type OdProtosSalesCrmData_LlmInteractionStatus =
  | 'LLM_INTERACTION_STATUS_FAILED'
  | 'LLM_INTERACTION_STATUS_PENDING'
  | 'LLM_INTERACTION_STATUS_PROCESSED'
  | 'LLM_INTERACTION_STATUS_UNSPECIFIED';

/** LLMPromptConfigurationType defines the types of prompt configurations. */
export type OdProtosSalesCrmData_LlmPromptConfigurationType =
  | 'LLM_PROMPT_CONFIGURATION_TYPE_SMS'
  | 'LLM_PROMPT_CONFIGURATION_TYPE_UNSPECIFIED';

/** LLMPromptConfigurationVariables describes variables used in prompt templates */
export type OdProtosSalesCrmData_LlmPromptConfigurationVariablesInput = {
  appointmentDetails?: InputMaybe<Scalars['String']>;
  availabilityTimeSlots?: InputMaybe<Array<Scalars['String']>>;
  cardStage?: InputMaybe<OdProtosSalesCrmData_Stage>;
  currentTime?: InputMaybe<Scalars['DateTime']>;
  smsCommunicationHistory?: InputMaybe<Array<OdProtosSalesCrmData_SmsCommunicationInput>>;
};

export type OdProtosSalesCrmData_PhoneCallFiltersInput = {
  agents?: InputMaybe<Array<OdProtosSalesCrmData_VirtualAgentFilterInput>>;
  callIds?: InputMaybe<Array<Scalars['String']>>;
  maxDate?: InputMaybe<Scalars['DateTime']>;
  minDate?: InputMaybe<Scalars['DateTime']>;
  outcomes?: InputMaybe<Array<OdProtosSalesCrmData_CallOutcome>>;
};

export type OdProtosSalesCrmData_PhoneCallSortInput = {
  desc?: InputMaybe<Scalars['Boolean']>;
  field?: InputMaybe<OdProtosSalesCrmData_PhoneCallSort_Field>;
};

export type OdProtosSalesCrmData_PhoneCallSort_Field =
  | 'CALLED_AT'
  | 'DURATION';

/** RetellAIConfig holds the configuration for RetellAI provider */
export type OdProtosSalesCrmData_RetellAiConfigInput = {
  /** RetellAI agent ID */
  agentId?: InputMaybe<Scalars['String']>;
  /** RetellAI agent version */
  agentVersion?: InputMaybe<Scalars['String']>;
};

export type OdProtosSalesCrmData_SmsCommunicationDirection =
  | 'SMS_COMMUNICATION_DIRECTION_INBOUND'
  | 'SMS_COMMUNICATION_DIRECTION_OUTBOUND'
  | 'SMS_COMMUNICATION_DIRECTION_UNSPECIFIED';

export type OdProtosSalesCrmData_SmsCommunicationInput = {
  content?: InputMaybe<Scalars['String']>;
  direction?: InputMaybe<OdProtosSalesCrmData_SmsCommunicationDirection>;
  timestamp?: InputMaybe<Scalars['DateTime']>;
};

/** ScoreRule filters cards by propensity score, then distributes by percentage. */
export type OdProtosSalesCrmData_ScoreRuleInput = {
  /**
   * Distribution defines how to distribute cards that match this score range.
   * Percentages must sum to 100.
   */
  distribution?: InputMaybe<Array<OdProtosSalesCrmData_DistributionRuleInput>>;
  /**
   * MaxScore is the maximum propensity score (exclusive) for this rule to match.
   * Use 0 or check the actual value to distinguish from "not set".
   */
  maxScore?: InputMaybe<Scalars['Float']>;
  /**
   * MinScore is the minimum propensity score (inclusive) for this rule to match.
   * Use 0 or check the actual value to distinguish from "not set".
   */
  minScore?: InputMaybe<Scalars['Float']>;
  /**
   * ScoreType specifies whether to use "score" (TRUE_SELLER_PREDICTION_SCORE)
   * or "percentile" (TRUE_SELLER_PERCENTILE). Defaults to SCORE_TYPE_SCORE for backward compatibility.
   */
  scoreType?: InputMaybe<OdProtosSalesCrmData_ScoreType>;
};

/** ScoreType defines the type of score used for routing. */
export type OdProtosSalesCrmData_ScoreType =
  /** Uses TRUE_SELLER_PERCENTILE for routing */
  | 'SCORE_TYPE_PERCENTILE'
  /** Uses TRUE_SELLER_PREDICTION_SCORE for routing */
  | 'SCORE_TYPE_SCORE'
  | 'SCORE_TYPE_UNSPECIFIED';

/** SequenceAction defines an action within a sequence day */
export type OdProtosSalesCrmData_SequenceActionInput = {
  action?: InputMaybe<OdProtosSalesCrmData_SequenceAction_ActionOneofInput>;
  /** Delay in minutes before executing this action */
  delayInMinutes?: InputMaybe<Scalars['Float']>;
};

/** SequenceActionType defines the type of action in a sequence */
export type OdProtosSalesCrmData_SequenceActionType =
  | 'SEQUENCE_ACTION_TYPE_CALL'
  | 'SEQUENCE_ACTION_TYPE_SMS'
  | 'SEQUENCE_ACTION_TYPE_UNSPECIFIED';

export type OdProtosSalesCrmData_SequenceAction_ActionOneofInput = {
  phoneCall?: InputMaybe<OdProtosSalesCrmData_SequenceAction_PhoneCallInput>;
  sms?: InputMaybe<OdProtosSalesCrmData_SequenceAction_SmsInput>;
};

export type OdProtosSalesCrmData_SequenceAction_PhoneCallInput = {
  _empty?: InputMaybe<Scalars['Boolean']>;
};

export type OdProtosSalesCrmData_SequenceAction_SmsInput = {
  /** SMS template */
  template?: InputMaybe<Scalars['String']>;
};

/** SequenceConfig defines the complete sequence configuration */
export type OdProtosSalesCrmData_SequenceConfigInput = {
  /** List of sequence days */
  days?: InputMaybe<Array<OdProtosSalesCrmData_SequenceDayInput>>;
  /** Version of the sequence configuration */
  version?: InputMaybe<Scalars['Float']>;
};

/** SequenceDay defines the actions for a specific day in the sequence */
export type OdProtosSalesCrmData_SequenceDayInput = {
  /** List of actions for this day */
  actions?: InputMaybe<Array<OdProtosSalesCrmData_SequenceActionInput>>;
  /** Business days to wait before next stage */
  nextStageInDays?: InputMaybe<Scalars['Float']>;
  /** Stage of the sequence (e.g., "1", "3", "5") */
  stage?: InputMaybe<Scalars['String']>;
};

/** Stage is a stage of a card in Sales CRM. */
export type OdProtosSalesCrmData_Stage =
  | 'STAGE_CONTACT_MADE'
  | 'STAGE_HANDOFF_COMPLETE'
  | 'STAGE_NEW_LEAD'
  | 'STAGE_NOT_INTERESTED'
  | 'STAGE_NO_CONTACT'
  | 'STAGE_UNSPECIFIED';

export type OdProtosSalesCrmData_TextConversationDirection =
  | 'TEXT_CONVERSATION_DIRECTION_INBOUND'
  | 'TEXT_CONVERSATION_DIRECTION_OUTBOUND'
  | 'TEXT_CONVERSATION_DIRECTION_UNSPECIFIED';

export type OdProtosSalesCrmData_TextConversationFiltersInput = {
  agents?: InputMaybe<Array<OdProtosSalesCrmData_VirtualAgentFilterInput>>;
  direction?: InputMaybe<OdProtosSalesCrmData_TextConversationDirection>;
  maxDate?: InputMaybe<Scalars['DateTime']>;
  minDate?: InputMaybe<Scalars['DateTime']>;
};

export type OdProtosSalesCrmData_TextConversationSortInput = {
  desc?: InputMaybe<Scalars['Boolean']>;
  field?: InputMaybe<OdProtosSalesCrmData_TextConversationSort_Field>;
};

export type OdProtosSalesCrmData_TextConversationSort_Field =
  | 'FIELD_UNSPECIFIED'
  | 'LAST_ACTIVITY';

/** TranscriptAnchor describes where the comment is placed in transcript text */
export type OdProtosSalesCrmData_TranscriptAnchorInput = {
  endCharOffset?: InputMaybe<Scalars['Float']>;
  endSegmentId?: InputMaybe<Scalars['String']>;
  endWordIndex?: InputMaybe<Scalars['Float']>;
  startCharOffset?: InputMaybe<Scalars['Float']>;
  startSegmentId?: InputMaybe<Scalars['String']>;
  startWordIndex?: InputMaybe<Scalars['Float']>;
};

export type OdProtosSalesCrmData_VirtualAgentFilterInput = {
  name?: InputMaybe<Scalars['String']>;
  /** Optional - if empty, matches any version */
  version?: InputMaybe<Scalars['String']>;
};

/** VirtualAgentTestingConfig holds testing configuration for overriding phone numbers */
export type OdProtosSalesCrmData_VirtualAgentTestingConfigInput = {
  /** Disable business hours and business days checks (optional) */
  disableBusinessHoursCheck?: InputMaybe<Scalars['Boolean']>;
  /** Override customer phone number for calls (optional) */
  overwriteCustomerPhoneNumberForCalls?: InputMaybe<Scalars['String']>;
  /** Override customer phone number for SMS (optional) */
  overwriteCustomerPhoneNumberForSms?: InputMaybe<Scalars['String']>;
  /** Override customer timezone (optional) */
  overwriteCustomerTimezone?: InputMaybe<Scalars['String']>;
};

/** Request to assign a card to a virtual agent */
export type OdProtosSalesCrmServices_AssignCardToVirtualAgentRequestInput = {
  /** Required. The human ID of the virtual agent to assign the card to */
  humanId?: InputMaybe<Scalars['String']>;
  /** Required. The lead token of the card to assign */
  leadToken?: InputMaybe<Scalars['String']>;
};

/** CreateCommentReplyRequest is used to create a reply to an existing comment. */
export type OdProtosSalesCrmServices_CreateCommentReplyRequestInput = {
  /** Required. Reply content. */
  content?: InputMaybe<Scalars['String']>;
  /** Required. Parent comment ID to reply to. */
  parentCommentId?: InputMaybe<Scalars['String']>;
};

/** CreateCommentRequest is used to create a root comment with anchor. */
export type OdProtosSalesCrmServices_CreateCommentRequestInput = {
  /** Required. Comment anchor, defining the exact location of the comment */
  anchor?: InputMaybe<OdProtosSalesCrmServices_CreateCommentRequest_AnchorOneofInput>;
  /** Required. Comment content. */
  content?: InputMaybe<Scalars['String']>;
  /** Required. The ID of the resource that the comment is attributed to. */
  resourceId?: InputMaybe<Scalars['String']>;
};

export type OdProtosSalesCrmServices_CreateCommentRequest_AnchorOneofInput = {
  transcriptAnchor?: InputMaybe<OdProtosSalesCrmData_TranscriptAnchorInput>;
};

/** CreateHSARequest is used to create a new HSA. */
export type OdProtosSalesCrmServices_CreateHsaRequestInput = {
  /** Optional. Virtual agent configuration for the HSA. */
  config?: InputMaybe<OdProtosSalesCrmData_HsaVirtualAgentConfigInput>;
  /** Required. The group the HSA belongs to. */
  group?: InputMaybe<OdProtosSalesCrmData_HsaGroup>;
  /** Required. The human ID of the HSA. */
  humanId?: InputMaybe<Scalars['String']>;
};

/** CreateLLMPromptConfigurationRequest is used to create a new LLM prompt configuration. */
export type OdProtosSalesCrmServices_CreateLlmPromptConfigurationRequestInput = {
  /** Optional. Template for context injection. */
  contextTemplate?: InputMaybe<Scalars['String']>;
  /** Optional. Maximum tokens for response. */
  maxTokens?: InputMaybe<Scalars['Float']>;
  /** Optional. Minimum intent confidence threshold. */
  minIntentConfidence?: InputMaybe<Scalars['Float']>;
  /** Required. LLM model name. */
  modelName?: InputMaybe<Scalars['String']>;
  /** Optional. Human-readable name. */
  name?: InputMaybe<Scalars['String']>;
  /** Required. LLM prompt configuration type */
  promptType?: InputMaybe<OdProtosSalesCrmData_LlmPromptConfigurationType>;
  /** Required. The system prompt text. */
  systemPrompt?: InputMaybe<Scalars['String']>;
  /** Optional. Temperature setting (0.0-1.0). */
  temperature?: InputMaybe<Scalars['Float']>;
  /** Optional. Version string. */
  version?: InputMaybe<Scalars['String']>;
};

/** DeleteCommentRequest is used to soft delete a comment or reply. */
export type OdProtosSalesCrmServices_DeleteCommentRequestInput = {
  /** Required. Comment ID to delete. */
  id?: InputMaybe<Scalars['String']>;
};

/** DeleteLLMPromptConfigurationRequest is used to delete a configuration. */
export type OdProtosSalesCrmServices_DeleteLlmPromptConfigurationRequestInput = {
  /** Required. The ID of the configuration to delete. */
  id?: InputMaybe<Scalars['String']>;
};

/** EditHSARequest is used to edit an existing HSA. */
export type OdProtosSalesCrmServices_EditHsaRequestInput = {
  /** A virtual agent config. */
  config?: InputMaybe<OdProtosSalesCrmData_HsaVirtualAgentConfigInput>;
  /** Optional. New group for the HSA (if HSA_GROUP_UNSPECIFIED, group won't be updated). */
  group?: InputMaybe<OdProtosSalesCrmData_HsaGroup>;
  /** Required. The human ID of the HSA to edit. */
  humanId?: InputMaybe<Scalars['String']>;
};

/** GetAllHSAsRequest is used to retrieve all active HSAs. */
export type OdProtosSalesCrmServices_GetAllHsAsRequestInput = {
  _empty?: InputMaybe<Scalars['Boolean']>;
};

/**
 * GetAssignedHumanIDsRequest is used to retrieve a list of human IDs
 * that are assigned to at least one card.
 */
export type OdProtosSalesCrmServices_GetAssignedHumanIDsRequestInput = {
  _empty?: InputMaybe<Scalars['Boolean']>;
};

/** Request to get all version history for an outcome type and optional flavor */
export type OdProtosSalesCrmServices_GetAssignmentConfigHistoryRequestInput = {
  /**
   * Optional. The card flavor to filter history for.
   * If FLAVOR_UNSPECIFIED, returns history for the fallback config.
   */
  flavor?: InputMaybe<OdProtosSalesCrmData_Flavor>;
  outcomeType?: InputMaybe<OdProtosSalesCrmData_ExpectedOutcome>;
};

/** GetCardRequest is used to retrieve a single card by its lead token. */
export type OdProtosSalesCrmServices_GetCardRequestInput = {
  /** Required. The token of the lead to retrieve. */
  leadToken?: InputMaybe<Scalars['String']>;
};

/**
 * GetCardsRequest is used to retrieve a list of cards based on the provided
 * filters.
 */
export type OdProtosSalesCrmServices_GetCardsRequestInput = {
  /** Card filters to apply. */
  filters?: InputMaybe<OdProtosSalesCrmData_CardFiltersInput>;
  /**
   * Limit the number of results returned.
   * If not set, defaults to 20.
   */
  limit?: InputMaybe<Scalars['Float']>;
  /** Optional. If set, the next page of results will be returned. */
  nextPageToken?: InputMaybe<Scalars['String']>;
};

/** GetCommentsRequest is used to retrieve comments. */
export type OdProtosSalesCrmServices_GetCommentsRequestInput = {
  /** Required. The ID of the resource that the comment is attributed to */
  resourceId?: InputMaybe<Scalars['String']>;
};

/**
 * GetExperimentCardsRequest is used to retrieve a list of experiment cards
 * based on the provided filters.
 */
export type OdProtosSalesCrmServices_GetExperimentCardsRequestInput = {
  /** Card filters to apply. */
  filters?: InputMaybe<OdProtosSalesCrmData_ExperimentCardFiltersInput>;
  /**
   * Limit the number of results returned.
   * If not set, defaults to 20.
   */
  limit?: InputMaybe<Scalars['Float']>;
  /** Optional. If set, the next page of results will be returned. */
  nextPageToken?: InputMaybe<Scalars['String']>;
};

/** GetHSARequest is used to retrieve a single HSA by human ID. */
export type OdProtosSalesCrmServices_GetHsaRequestInput = {
  /** Required. The human ID of the HSA to retrieve. */
  humanId?: InputMaybe<Scalars['String']>;
};

/** GetLLMPromptConfigurationRequest is used to retrieve a configuration by ID. */
export type OdProtosSalesCrmServices_GetLlmPromptConfigurationRequestInput = {
  /** Required. The ID of the configuration. */
  id?: InputMaybe<Scalars['String']>;
};

/** GetLLMRequestsByExternalIDsRequest is used to get LLM analysis data by SMS UUIDs. */
export type OdProtosSalesCrmServices_GetLlmRequestsByExternalIDsRequestInput = {
  communicationType?: InputMaybe<OdProtosSalesCrmData_CommunicationType>;
  externalIds?: InputMaybe<Array<Scalars['String']>>;
};

/** GetPhoneCallDetailsRequest is used to retrieve detailed information for a single phone call. */
export type OdProtosSalesCrmServices_GetPhoneCallDetailsRequestInput = {
  callId?: InputMaybe<Scalars['String']>;
};

/** GetPhoneCallsRequest is used to retrieve a paginated list of phone calls. */
export type OdProtosSalesCrmServices_GetPhoneCallsRequestInput = {
  filters?: InputMaybe<OdProtosSalesCrmData_PhoneCallFiltersInput>;
  pagination?: InputMaybe<OdProtosCommonPagination_OffsetPaginationRequestInput>;
  sort?: InputMaybe<OdProtosSalesCrmData_PhoneCallSortInput>;
};

/** GetTextConversationsRequest is used to retrieve a paginated list of text conversations. */
export type OdProtosSalesCrmServices_GetTextConversationsRequestInput = {
  filters?: InputMaybe<OdProtosSalesCrmData_TextConversationFiltersInput>;
  pagination?: InputMaybe<OdProtosCommonPagination_OffsetPaginationRequestInput>;
  sort?: InputMaybe<OdProtosSalesCrmData_TextConversationSortInput>;
};

/** GetVirtualAgentTextPromptRequest is used to get prompt configuration. */
export type OdProtosSalesCrmServices_GetVirtualAgentTextPromptRequestInput = {
  _empty?: InputMaybe<Scalars['Boolean']>;
};

/** GetVirtualAgentTextPromptVariablesRequest is used to get prompt configuration variables for particular lead token */
export type OdProtosSalesCrmServices_GetVirtualAgentTextPromptVariablesRequestInput = {
  leadToken?: InputMaybe<Scalars['String']>;
};

/** GetVirtualAgentsRequest is used to retrieve a list of virtual agents. */
export type OdProtosSalesCrmServices_GetVirtualAgentsRequestInput = {
  _empty?: InputMaybe<Scalars['Boolean']>;
};

/** ListLLMPromptConfigurationsRequest is used to list all configurations. */
export type OdProtosSalesCrmServices_ListLlmPromptConfigurationsRequestInput = {
  _empty?: InputMaybe<Scalars['Boolean']>;
};

/** RestoreHSARequest is used to restore a soft-deleted HSA. */
export type OdProtosSalesCrmServices_RestoreHsaRequestInput = {
  /** Required. The human ID of the HSA to restore. */
  humanId?: InputMaybe<Scalars['String']>;
};

/** Request to rollback to a specific configuration version */
export type OdProtosSalesCrmServices_RollbackAssignmentConfigRequestInput = {
  /**
   * Optional. The card flavor for the config to rollback.
   * If FLAVOR_UNSPECIFIED, rolls back the fallback config.
   */
  flavor?: InputMaybe<OdProtosSalesCrmData_Flavor>;
  /** The outcome type to rollback */
  outcomeType?: InputMaybe<OdProtosSalesCrmData_ExpectedOutcome>;
  /** The version to rollback to */
  targetVersion?: InputMaybe<Scalars['Float']>;
};

/** SoftDeleteHSARequest is used to soft delete an HSA. */
export type OdProtosSalesCrmServices_SoftDeleteHsaRequestInput = {
  /** Required. The human ID of the HSA to delete. */
  humanId?: InputMaybe<Scalars['String']>;
};

/** TestVirtualAgentPromptRequest is used to test a prompt with custom variables. */
export type OdProtosSalesCrmServices_TestVirtualAgentPromptRequestInput = {
  promptConfigId?: InputMaybe<Scalars['String']>;
  promptConfigurationVariables?: InputMaybe<OdProtosSalesCrmData_LlmPromptConfigurationVariablesInput>;
  systemPromptOverride?: InputMaybe<Scalars['String']>;
  userPromptOverride?: InputMaybe<Scalars['String']>;
};

/** Request to update an assignment configuration */
export type OdProtosSalesCrmServices_UpdateAssignmentConfigRequestInput = {
  /** The distribution configuration */
  config?: InputMaybe<OdProtosSalesCrmData_DistributionConfigInput>;
  /**
   * Optional. The card flavor for more granular assignment control.
   * If FLAVOR_UNSPECIFIED, creates a fallback config that applies to all cards of the outcome type.
   */
  flavor?: InputMaybe<OdProtosSalesCrmData_Flavor>;
  /** The outcome type this config applies to */
  outcomeType?: InputMaybe<OdProtosSalesCrmData_ExpectedOutcome>;
};

/** UpdateCardRequest is used to update a card with the provided lead token. */
export type OdProtosSalesCrmServices_UpdateCardRequestInput = {
  /**
   * Precise follow up action date and time.
   * It has higher priority than follow_up_in_days if both are set.
   */
  expectedActionAt?: InputMaybe<Scalars['DateTime']>;
  /**
   * Optional. A field that allows to set the number of days after when
   * a new action should be taken.
   */
  followUpInDays?: InputMaybe<Scalars['Float']>;
  /** Required. The token of the lead that will be updated. */
  leadToken?: InputMaybe<Scalars['String']>;
  /** Optional. A new stage that the lead will be moved to. */
  stage?: InputMaybe<OdProtosSalesCrmData_Stage>;
  /**
   * Optional. I.e. Contact made - not interested. This field will fully
   * overwrite the existing tags if any.
   */
  tags?: InputMaybe<Array<Scalars['String']>>;
  /** Optional. A field that allows to set the task sequence state. */
  taskSequenceState?: InputMaybe<Scalars['String']>;
};

/** UpdateCommentRequest is used to update an existing comment or reply. */
export type OdProtosSalesCrmServices_UpdateCommentRequestInput = {
  /** Required. New comment content. */
  content?: InputMaybe<Scalars['String']>;
  /** Required. Comment ID to update. */
  id?: InputMaybe<Scalars['String']>;
};

/** UpdateLLMPromptConfigurationRequest is used to update a configuration. */
export type OdProtosSalesCrmServices_UpdateLlmPromptConfigurationRequestInput = {
  /** Optional. New context template. */
  contextTemplate?: InputMaybe<Scalars['String']>;
  /** Required. The ID of the configuration to update. */
  id?: InputMaybe<Scalars['String']>;
  /** Optional. New max tokens setting. */
  maxTokens?: InputMaybe<Scalars['Float']>;
  /** Optional. New min intent confidence. */
  minIntentConfidence?: InputMaybe<Scalars['Float']>;
  /** Optional. New model name. */
  modelName?: InputMaybe<Scalars['String']>;
  /** Optional. New name. */
  name?: InputMaybe<Scalars['String']>;
  /** Optional. New system prompt text. */
  systemPrompt?: InputMaybe<Scalars['String']>;
  /** Optional. New temperature setting. */
  temperature?: InputMaybe<Scalars['Float']>;
  /** Optional. New version. */
  version?: InputMaybe<Scalars['String']>;
};

/** UpsertCardResponse is used to return the upserted card. */
export type OdProtosSalesCrmServices_UpsertCardRequestInput = {
  /** Required. The card to upsert. */
  card?: InputMaybe<OdProtosSalesCrmData_CardInput>;
};

/** Next ID: 7 */
export type OdProtosScroogeData_AllocationLoanDataInput = {
  /** The current advance amount for the home */
  advanceAmountCents?: InputMaybe<Scalars['Float']>;
  /** When the allocation funds should be advanced */
  advanceDate?: InputMaybe<Scalars['DateTime']>;
  /** The BPO value of the home */
  bpoValueCents?: InputMaybe<Scalars['Float']>;
  /** Deprecated: use source. */
  flipToken?: InputMaybe<Scalars['String']>;
  /** When the allocation funds should be released */
  releaseDate?: InputMaybe<Scalars['DateTime']>;
  /** The transaction that requires an allocation. */
  source?: InputMaybe<OdProtosScroogeData_Allocation_SourceInput>;
};

export type OdProtosScroogeData_Allocation_SourceInput = {
  id?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<OdProtosScroogeData_Allocation_Source_SourceType>;
};

export type OdProtosScroogeData_Allocation_Source_SourceType =
  | 'OPENDOOR_BACKED_OFFER'
  | 'SELL_DIRECT'
  | 'UNKNOWN_TYPE';

/** Indicates the state of the allocation */
export type OdProtosScroogeData_Allocation_State =
  | 'ALLOCATED_ACQUIRED'
  | 'ALLOCATED_ADVANCED'
  | 'ALLOCATED_IN_CONTRACT'
  | 'ALLOCATED_SOLD'
  | 'DEALLOCATED_RELEASED'
  | 'DEALLOCATED_WITHDRAWN'
  | 'UNKNOWN';

/**
 * Represents the flip data needed to make an automatic allocation of an owner entity to a home
 * Next ID: 20
 */
export type OdProtosScroogeData_AutomaticAllocationFlipDataInput = {
  /** The lot size of the home in acreage */
  acreage?: InputMaybe<Scalars['Float']>;
  /** The identifier of the user that requested the allocation */
  allocatingUserDirectoryToken?: InputMaybe<Scalars['String']>;
  /** The proxy for BPO value of the home */
  bpoValueProxyCents?: InputMaybe<Scalars['Float']>;
  /** The Casa-resolved uuid of the home */
  casaAddressUuid?: InputMaybe<Scalars['String']>;
  /**
   * The flip token for the home to be allocated
   * Deprecated: use source.
   */
  flipToken?: InputMaybe<Scalars['String']>;
  /** Flag that indicates whether the home has a solar lien */
  hasSolarLien?: InputMaybe<Scalars['Boolean']>;
  /** Flag that indicates whether the home has unpermitted additions */
  hasUnpermittedAdditions?: InputMaybe<Scalars['Boolean']>;
  /** The headline price of the home */
  headlinePriceCents?: InputMaybe<Scalars['Float']>;
  /** Flag that indicates whether the home is in a flood zone */
  inFloodZone?: InputMaybe<Scalars['Boolean']>;
  /** Flag that indicates whether the home is distressed or real estate owned */
  isDistressedOrReo?: InputMaybe<Scalars['Boolean']>;
  /** The number of bathrooms of the home */
  numBathroomsCents?: InputMaybe<Scalars['Float']>;
  /** The number of bedrooms of the home */
  numBedrooms?: InputMaybe<Scalars['Float']>;
  /** The postal code of the home */
  postalCode?: InputMaybe<Scalars['String']>;
  /** Number of pre possession days, relevant for Opendoor Backed Offers only */
  prePossessionDays?: InputMaybe<Scalars['Float']>;
  /** The property type of the home */
  propertyType?: InputMaybe<Scalars['String']>;
  /** The region ID the home is located in */
  regionId?: InputMaybe<Scalars['Float']>;
  /** The transaction that requires an allocation. */
  source?: InputMaybe<OdProtosScroogeData_Allocation_SourceInput>;
  /** The US state of the home */
  usState?: InputMaybe<Scalars['String']>;
  /** The year the home was built */
  yearBuilt?: InputMaybe<Scalars['Float']>;
};

export type OdProtosScroogeData_EntityMaxCumulativeBpoValueInput = {
  maxDollars?: InputMaybe<Scalars['Float']>;
};

export type OdProtosScroogeData_EntityMaxCumulativeHomesInput = {
  maxCount?: InputMaybe<Scalars['Float']>;
};

export type OdProtosScroogeData_EntityMaxOutstandingLoanInput = {
  maxDollars?: InputMaybe<Scalars['Float']>;
};

/** Represents an entity ruleset */
export type OdProtosScroogeData_EntityRulesetInput = {
  /** Timestamps for when the rule was created and last updated */
  createdAt?: InputMaybe<Scalars['DateTime']>;
  entityMaxCumulativeBpoValue?: InputMaybe<OdProtosScroogeData_EntityMaxCumulativeBpoValueInput>;
  entityMaxCumulativeHomes?: InputMaybe<OdProtosScroogeData_EntityMaxCumulativeHomesInput>;
  entityMaxOutstandingLoan?: InputMaybe<OdProtosScroogeData_EntityMaxOutstandingLoanInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type OdProtosScroogeData_FacilityDeclineHomeInRegionsInput = {
  regionIds?: InputMaybe<Array<Scalars['Float']>>;
};

export type OdProtosScroogeData_FacilityMaxDollarsInAnyRegionInput = {
  maxDollars?: InputMaybe<Scalars['Float']>;
};

export type OdProtosScroogeData_FacilityMaxDollarsInNewRegionsInput = {
  maxDollars?: InputMaybe<Scalars['Float']>;
};

export type OdProtosScroogeData_FacilityMaxDollarsInRegionsInput = {
  regionToMaxDollarsMap?: InputMaybe<Array<OdProtosScroogeData_FacilityMaxDollarsInRegions_RegionToMaxDollarsMapEntryInput>>;
};

/** `OdProtosScroogeData_FacilityMaxDollarsInRegions_RegionToMaxDollarsMapEntryInput` represents the `region_to_max_dollars_map` map in `od_protos.scrooge.data.FacilityMaxDollarsInRegions`. */
export type OdProtosScroogeData_FacilityMaxDollarsInRegions_RegionToMaxDollarsMapEntryInput = {
  key?: InputMaybe<Scalars['Float']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type OdProtosScroogeData_FacilityMaxDollarsInStatesInput = {
  stateToMaxDollarsMap?: InputMaybe<Array<OdProtosScroogeData_FacilityMaxDollarsInStates_StateToMaxDollarsMapEntryInput>>;
};

/** `OdProtosScroogeData_FacilityMaxDollarsInStates_StateToMaxDollarsMapEntryInput` represents the `state_to_max_dollars_map` map in `od_protos.scrooge.data.FacilityMaxDollarsInStates`. */
export type OdProtosScroogeData_FacilityMaxDollarsInStates_StateToMaxDollarsMapEntryInput = {
  key?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type OdProtosScroogeData_FacilityMaxHomesWithSolarLienInput = {
  maxCount?: InputMaybe<Scalars['Float']>;
};

export type OdProtosScroogeData_FacilityMaxOutstandingLoanInput = {
  maxDollars?: InputMaybe<Scalars['Float']>;
};

export type OdProtosScroogeData_FacilityMaxPctHomesBuiltBeforeYearInput = {
  maxPct?: InputMaybe<Scalars['Float']>;
  year?: InputMaybe<Scalars['Float']>;
};

export type OdProtosScroogeData_FacilityMaxPctHomesInAnyRegionInput = {
  maxPct?: InputMaybe<Scalars['Float']>;
};

export type OdProtosScroogeData_FacilityMaxPctHomesInRegionsWithinHeadlinePriceRangeInput = {
  headlinePriceCentsRange?: InputMaybe<OdProtosScroogeData_UInt32RangeInput>;
  maxPct?: InputMaybe<Scalars['Float']>;
  regionIds?: InputMaybe<Array<Scalars['Float']>>;
};

export type OdProtosScroogeData_FacilityMaxPctHomesInStatesInput = {
  stateToMaxPctMap?: InputMaybe<Array<OdProtosScroogeData_FacilityMaxPctHomesInStates_StateToMaxPctMapEntryInput>>;
};

/** `OdProtosScroogeData_FacilityMaxPctHomesInStates_StateToMaxPctMapEntryInput` represents the `state_to_max_pct_map` map in `od_protos.scrooge.data.FacilityMaxPctHomesInStates`. */
export type OdProtosScroogeData_FacilityMaxPctHomesInStates_StateToMaxPctMapEntryInput = {
  key?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type OdProtosScroogeData_FacilityMaxPctHomesOfPropertyTypesInput = {
  propertyTypeToMaxPctMap?: InputMaybe<Array<OdProtosScroogeData_FacilityMaxPctHomesOfPropertyTypes_PropertyTypeToMaxPctMapEntryInput>>;
};

/** `OdProtosScroogeData_FacilityMaxPctHomesOfPropertyTypes_PropertyTypeToMaxPctMapEntryInput` represents the `property_type_to_max_pct_map` map in `od_protos.scrooge.data.FacilityMaxPctHomesOfPropertyTypes`. */
export type OdProtosScroogeData_FacilityMaxPctHomesOfPropertyTypes_PropertyTypeToMaxPctMapEntryInput = {
  key?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type OdProtosScroogeData_FacilityMaxPctHomesWithGtXHeadlinePriceInput = {
  headlinePriceCents?: InputMaybe<Scalars['Float']>;
  maxPct?: InputMaybe<Scalars['Float']>;
};

export type OdProtosScroogeData_FacilityMaxPctHomesWithLtXBathInput = {
  maxPct?: InputMaybe<Scalars['Float']>;
  numBathroomsCents?: InputMaybe<Scalars['Float']>;
};

export type OdProtosScroogeData_FacilityMaxPctHomesWithLtXBedInput = {
  maxPct?: InputMaybe<Scalars['Float']>;
  numBedrooms?: InputMaybe<Scalars['Float']>;
};

export type OdProtosScroogeData_FacilityMaxPrePossessionDaysInput = {
  maxPrePossessionDays?: InputMaybe<Scalars['Float']>;
};

export type OdProtosScroogeData_FacilityOboDisallowedInput = {
  yes?: InputMaybe<Scalars['Boolean']>;
};

/**
 * Represents a facility ruleset
 * Next ID: 27
 */
export type OdProtosScroogeData_FacilityRulesetInput = {
  /** Timestamps for when the rule was created and last updated */
  createdAt?: InputMaybe<Scalars['DateTime']>;
  facilityDeclineHomeInRegions?: InputMaybe<OdProtosScroogeData_FacilityDeclineHomeInRegionsInput>;
  facilityMaxDollarsInAnyRegion?: InputMaybe<OdProtosScroogeData_FacilityMaxDollarsInAnyRegionInput>;
  facilityMaxDollarsInNewRegions?: InputMaybe<OdProtosScroogeData_FacilityMaxDollarsInNewRegionsInput>;
  facilityMaxDollarsInRegions?: InputMaybe<OdProtosScroogeData_FacilityMaxDollarsInRegionsInput>;
  facilityMaxDollarsInStates?: InputMaybe<OdProtosScroogeData_FacilityMaxDollarsInStatesInput>;
  facilityMaxHomesWithSolarLien?: InputMaybe<OdProtosScroogeData_FacilityMaxHomesWithSolarLienInput>;
  facilityMaxOutstandingLoan?: InputMaybe<OdProtosScroogeData_FacilityMaxOutstandingLoanInput>;
  facilityMaxPctHomesBuiltBeforeYear?: InputMaybe<OdProtosScroogeData_FacilityMaxPctHomesBuiltBeforeYearInput>;
  facilityMaxPctHomesInAnyRegion?: InputMaybe<OdProtosScroogeData_FacilityMaxPctHomesInAnyRegionInput>;
  facilityMaxPctHomesInRegionsWithinHeadlinePriceRange?: InputMaybe<OdProtosScroogeData_FacilityMaxPctHomesInRegionsWithinHeadlinePriceRangeInput>;
  facilityMaxPctHomesInStates?: InputMaybe<OdProtosScroogeData_FacilityMaxPctHomesInStatesInput>;
  facilityMaxPctHomesOfPropertyTypes?: InputMaybe<OdProtosScroogeData_FacilityMaxPctHomesOfPropertyTypesInput>;
  facilityMaxPctHomesWithGtXHeadlinePrice?: InputMaybe<OdProtosScroogeData_FacilityMaxPctHomesWithGtXHeadlinePriceInput>;
  facilityMaxPctHomesWithLtXBath?: InputMaybe<OdProtosScroogeData_FacilityMaxPctHomesWithLtXBathInput>;
  facilityMaxPctHomesWithLtXBed?: InputMaybe<OdProtosScroogeData_FacilityMaxPctHomesWithLtXBedInput>;
  facilityMaxPrePossessionDays?: InputMaybe<OdProtosScroogeData_FacilityMaxPrePossessionDaysInput>;
  facilityOboDisallowed?: InputMaybe<OdProtosScroogeData_FacilityOboDisallowedInput>;
  homeHasNoUnpermittedAdditions?: InputMaybe<OdProtosScroogeData_HomeHasNoUnpermittedAdditionsInput>;
  homeMaxAcreage?: InputMaybe<OdProtosScroogeData_HomeMaxAcreageInput>;
  /** New rules should be added below in order for backwards compatibility */
  homeMaxHeadlinePrice?: InputMaybe<OdProtosScroogeData_HomeMaxHeadlinePriceInput>;
  homeMinHeadlinePrice?: InputMaybe<OdProtosScroogeData_HomeMinHeadlinePriceInput>;
  homeNotDistressedOrReo?: InputMaybe<OdProtosScroogeData_HomeNotDistressedOrReoInput>;
  homeNotInFloodZone?: InputMaybe<OdProtosScroogeData_HomeNotInFloodZoneInput>;
  homeNotInPostalCodes?: InputMaybe<OdProtosScroogeData_HomeNotInPostalCodesInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type OdProtosScroogeData_HomeHasNoUnpermittedAdditionsInput = {
  yes?: InputMaybe<Scalars['Boolean']>;
};

export type OdProtosScroogeData_HomeMaxAcreageInput = {
  maxAcreage?: InputMaybe<Scalars['Float']>;
};

export type OdProtosScroogeData_HomeMaxHeadlinePriceInput = {
  maxDollars?: InputMaybe<Scalars['Float']>;
};

export type OdProtosScroogeData_HomeMinHeadlinePriceInput = {
  minDollars?: InputMaybe<Scalars['Float']>;
};

export type OdProtosScroogeData_HomeNotDistressedOrReoInput = {
  yes?: InputMaybe<Scalars['Boolean']>;
};

/**
 * IMPORTANT:
 * Source of truth for these rules: https://docs.google.com/document/d/1a2aZv2tbW_YXU7vd-wqyhOflHJnqlFTg_VVLTrjVVW8/edit
 * Please update that Google doc if you make changes in this file
 */
export type OdProtosScroogeData_HomeNotInFloodZoneInput = {
  yes?: InputMaybe<Scalars['Boolean']>;
};

export type OdProtosScroogeData_HomeNotInPostalCodesInput = {
  postalCodes?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosScroogeData_ManualAllocationInput = {
  allocatingUserDirectoryToken?: InputMaybe<Scalars['String']>;
  entityUuid?: InputMaybe<Scalars['String']>;
  facilityUuid?: InputMaybe<Scalars['String']>;
  isMisallocation?: InputMaybe<Scalars['Boolean']>;
  source?: InputMaybe<OdProtosScroogeData_Allocation_SourceInput>;
};

/**
 * Set of all facility and entity rules.
 * Next ID: 27
 */
export type OdProtosScroogeData_RuleType =
  | 'ENTITY_MAX_CUMULATIVE_BPO_VALUE'
  | 'ENTITY_MAX_CUMULATIVE_HOMES'
  /** Entity rules */
  | 'ENTITY_MAX_OUTSTANDING_LOAN'
  | 'FACILITY_DECLINE_HOME_IN_REGIONS'
  /** Internal facility rules */
  | 'FACILITY_MAX_CUMULATIVE_HOMES_INTERNAL'
  | 'FACILITY_MAX_DOLLARS_IN_ANY_REGION'
  | 'FACILITY_MAX_DOLLARS_IN_NEW_REGIONS'
  | 'FACILITY_MAX_DOLLARS_IN_REGIONS'
  | 'FACILITY_MAX_DOLLARS_IN_STATES'
  | 'FACILITY_MAX_HOMES_WITH_SOLAR_LIEN'
  | 'FACILITY_MAX_OUTSTANDING_LOAN'
  | 'FACILITY_MAX_PCT_HOMES_BUILT_BEFORE_YEAR'
  | 'FACILITY_MAX_PCT_HOMES_IN_ANY_REGION'
  | 'FACILITY_MAX_PCT_HOMES_IN_REGIONS_WITHIN_HEADLINE_PRICE_RANGE'
  | 'FACILITY_MAX_PCT_HOMES_IN_STATES'
  | 'FACILITY_MAX_PCT_HOMES_OF_PROPERTY_TYPES'
  | 'FACILITY_MAX_PCT_HOMES_WITH_GT_X_HEADLINE_PRICE'
  | 'FACILITY_MAX_PCT_HOMES_WITH_LT_X_BATH'
  | 'FACILITY_MAX_PCT_HOMES_WITH_LT_X_BED'
  | 'FACILITY_OBO_DISALLOWED'
  | 'HOME_HAS_NO_UNPERMITTED_ADDITIONS'
  | 'HOME_MAX_ACREAGE'
  | 'HOME_MAX_HEADLINE_PRICE'
  | 'HOME_MIN_HEADLINE_PRICE'
  /** Facility rules */
  | 'HOME_NOT_IN_FLOOD_ZONE'
  | 'HOME_NOT_IN_POSTAL_CODES'
  | 'RULE_TYPE_UNKNOWN';

export type OdProtosScroogeData_UInt32RangeInput = {
  max?: InputMaybe<Scalars['Float']>;
  min?: InputMaybe<Scalars['Float']>;
};

export type OdProtosScroogeServices_AllocationTestRequestInput = {
  entityUuid?: InputMaybe<Array<Scalars['String']>>;
  /**
   * Optional values to only test the provided faciilities/entities. If not provided
   * all active facilities/entities will be tested.
   */
  facilityUuid?: InputMaybe<Array<Scalars['String']>>;
  flipData?: InputMaybe<Array<OdProtosScroogeData_AutomaticAllocationFlipDataInput>>;
};

export type OdProtosScroogeServices_AutomaticAllocationRequestInput = {
  flipData?: InputMaybe<OdProtosScroogeData_AutomaticAllocationFlipDataInput>;
  /**
   * The allocation engine is bypassed when an override entity and facility uuid
   * are both specified.
   */
  overrideEntityUuid?: InputMaybe<Scalars['String']>;
  overrideFacilityUuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosScroogeServices_BatchCreateAllocationLoanDataRequestInput = {
  allocations?: InputMaybe<Array<OdProtosScroogeServices_CreateAllocationLoanDataRequestInput>>;
};

/** Next ID: 3 */
export type OdProtosScroogeServices_CreateAllocationLoanDataRequestInput = {
  allocationLoanData?: InputMaybe<OdProtosScroogeData_AllocationLoanDataInput>;
  source?: InputMaybe<OdProtosScroogeData_Allocation_SourceInput>;
};

export type OdProtosScroogeServices_CreateEntityRequestInput = {
  email?: InputMaybe<Scalars['String']>;
  facilityUuid?: InputMaybe<Scalars['String']>;
  fax?: InputMaybe<Scalars['String']>;
  legalName?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
};

export type OdProtosScroogeServices_CreateFacilityRequestInput = {
  isInTitlingTrust?: InputMaybe<Scalars['Boolean']>;
  legalName?: InputMaybe<Scalars['String']>;
  loanToCostPct?: InputMaybe<Scalars['Float']>;
  loanToValuePct?: InputMaybe<Scalars['Float']>;
  name?: InputMaybe<Scalars['String']>;
};

export type OdProtosScroogeServices_FacilityAllocationPctRowInput = {
  allocationPct?: InputMaybe<Scalars['Float']>;
  facilityUuid?: InputMaybe<Scalars['String']>;
};

/** GetAllActiveFacilitiesRequest does not take arguments */
export type OdProtosScroogeServices_GetAllActiveFacilitiesRequestInput = {
  _empty?: InputMaybe<Scalars['Boolean']>;
};

/** GetAllFacilitiesEntitiesRequest does not take arguments */
export type OdProtosScroogeServices_GetAllFacilitiesEntitiesRequestInput = {
  _empty?: InputMaybe<Scalars['Boolean']>;
};

export type OdProtosScroogeServices_GetAllocationLoanDataRequestInput = {
  facilityId?: InputMaybe<Scalars['String']>;
};

/** Next ID: 3 */
export type OdProtosScroogeServices_GetCurrentAllocationRequestInput = {
  /** Deprecated: use source. */
  flipToken?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<OdProtosScroogeData_Allocation_SourceInput>;
};

export type OdProtosScroogeServices_GetEntitiesForFacilityRequestInput = {
  facilityUuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosScroogeServices_GetEntityByIdRequestInput = {
  uuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosScroogeServices_GetEntityRulesetRequestInput = {
  entityUuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosScroogeServices_GetFacilityByIdRequestInput = {
  uuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosScroogeServices_GetFacilityRulesetRequestInput = {
  facilityUuid?: InputMaybe<Scalars['String']>;
};

/** Next ID: 8 */
export type OdProtosScroogeServices_ManualAllocationRequestInput = {
  allocatingUserDirectoryToken?: InputMaybe<Scalars['String']>;
  entityUuid?: InputMaybe<Scalars['String']>;
  facilityUuid?: InputMaybe<Scalars['String']>;
  /** Deprecated: use source. */
  flipToken?: InputMaybe<Scalars['String']>;
  isMisallocation?: InputMaybe<Scalars['Boolean']>;
  manualAllocations?: InputMaybe<Array<OdProtosScroogeData_ManualAllocationInput>>;
  source?: InputMaybe<OdProtosScroogeData_Allocation_SourceInput>;
};

/** Next ID: 4 */
export type OdProtosScroogeServices_UpdateAllocationStateRequestInput = {
  /** Deprecated: use source. */
  flipToken?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<OdProtosScroogeData_Allocation_SourceInput>;
  state?: InputMaybe<OdProtosScroogeData_Allocation_State>;
};

export type OdProtosScroogeServices_UpdateEntityRequestInput = {
  email?: InputMaybe<Scalars['String']>;
  facilityUuid?: InputMaybe<Scalars['String']>;
  fax?: InputMaybe<Scalars['String']>;
  legalName?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  uuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosScroogeServices_UpdateEntityRulesetRequestInput = {
  entityRules?: InputMaybe<OdProtosScroogeData_EntityRulesetInput>;
  entityUuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosScroogeServices_UpdateFacilityAllocationPctsRequestInput = {
  facilityAllocationPcts?: InputMaybe<Array<OdProtosScroogeServices_FacilityAllocationPctRowInput>>;
};

export type OdProtosScroogeServices_UpdateFacilityRequestInput = {
  isInTitlingTrust?: InputMaybe<Scalars['Boolean']>;
  legalName?: InputMaybe<Scalars['String']>;
  loanToCostPct?: InputMaybe<Scalars['Float']>;
  loanToValuePct?: InputMaybe<Scalars['Float']>;
  name?: InputMaybe<Scalars['String']>;
  uuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosScroogeServices_UpdateFacilityRulesetRequestInput = {
  facilityRules?: InputMaybe<OdProtosScroogeData_FacilityRulesetInput>;
  facilityUuid?: InputMaybe<Scalars['String']>;
};

/** Next ID: 5 */
export type OdProtosScroogeServices_UpdateFlipProjectionDatesRequestInput = {
  acquisitionDate?: InputMaybe<Scalars['DateTime']>;
  /** Deprecated: use source. */
  flipToken?: InputMaybe<Scalars['String']>;
  resaleDate?: InputMaybe<Scalars['DateTime']>;
  source?: InputMaybe<OdProtosScroogeData_Allocation_SourceInput>;
};

/**
 * Denial reason if the customer was denied for a product.
 * Next ID: 75
 */
export type OdProtosSellCommon_DenialReason =
  /** already an active offer for this address */
  | 'ACTIVE_OFFER'
  /** home is not in a region serviced by Opendoor */
  | 'ADDRESS'
  /** this address has been explicitly denied */
  | 'ADDRESS_OVERRIDE'
  /** customer is an agent representative of the homeowner */
  | 'AGENT_RELATION'
  /** home is in an age restricted community */
  | 'AGE_RESTRICTED_COMMUNITY'
  /** seasonal age restriction for certain market */
  | 'AGE_RESTRICTED_SEASONAL'
  /** home has asbestos siding */
  | 'ASBESTOS_SIDING'
  /** home was built before 1960 */
  | 'BEFORE_1960'
  /** San Francisco-specific program for low-middle income buyers */
  | 'BELOW_MARKET_RATE_OWNERSHIP'
  /** buyers are currently unavailable to make an offer on the home */
  | 'BUYER_UNAVAILABLE'
  /** Boston and NY/NJ only, for homes with a cesspool */
  | 'CESSPOOL'
  /** pause all acq offers for COVID-19 */
  | 'COVID_19'
  /** they were also denied for opendoor_direct, so they're not eligible for this other product */
  | 'DENIED_FOR_OPENDOOR_DIRECT'
  /** they were also denied for sell_with_upside, so they're not eligible for this other product */
  | 'DENIED_FOR_SELL_WITH_UPSIDE'
  /** dependent ruleset evaluation is incompatible with this product */
  | 'DEPENDENT_RULESET'
  /** duplicate lead on address */
  | 'DUPLICATE_LEAD'
  /** home type is not within the set of types purchased by Opendoor */
  | 'DWELLING_TYPE'
  /** expected levered gross margin (LGM) does not meet experience criteria */
  | 'EXPECTED_LGM'
  /** fees on offer are too high */
  | 'FEES_TOO_HIGH'
  /** home has previous or current fire damage */
  | 'FIRE_DAMAGE'
  /** home has a history of flooding */
  | 'FLOOD_HISTORY'
  /** home is in a flood zone. */
  | 'FLOOD_ZONE'
  /** home has known foundation issues */
  | 'FOUNDATION'
  /** home is in a gated community */
  | 'GATED_COMMUNITY'
  /** home is in a guard-gated community */
  | 'GUARD_GATED_COMMUNITY'
  /** home is in an ineligible HOA - requires rental history, SSN, etc. */
  | 'INELIGIBLE_HOA'
  /** home is in contract or in contingencies released with Opendoor */
  | 'IN_CONTRACT_WITH_OPENDOOR'
  /** home does not have adequate comps */
  | 'LACK_OF_ADEQUATE_COMPS'
  /** home has leased solar panels */
  | 'LEASED_SOLAR_PANELS'
  /** Opendoor has listed the home for sale */
  | 'LISTED_BY_OPENDOOR'
  /** livestock on property */
  | 'LIVESTOCK'
  /** home's lot sq ft is too large */
  | 'LOT_SQ_FT'
  /** For use with partner API, controls display of OD offers in partner's website UI */
  | 'MLS_LISTING_STATUS'
  /** mobile or manufactured home */
  | 'MOBILE_MANUFACTURED_HOME'
  /** home dwelling type is not in buybox */
  | 'NON_BUYBOX_DWELLING_TYPE'
  /** seller is not serious yet */
  | 'NON_SERIOUS_SELLER'
  | 'NOT_IN_AUTODENIAL_LISTING_EXP'
  /** seller is not in the lwod experiment */
  | 'NOT_IN_LWOD_PILOT'
  /** Not in the Sell w/ Upside experiment */
  | 'NOT_IN_SELL_WITH_UPSIDE_PILOT'
  | 'NOT_IN_SIDE_BY_SIDE_EXP'
  /** home is not denied */
  | 'NO_DENIAL'
  /** Deprecated, used only for the ShouldDenyBasedOnFlipStatus web GRPC endpoint */
  | 'OFFER_IN_PROGRESS'
  /** home has been deemed an outlier at pre-offer time */
  | 'OFFER_OUTLIER'
  /** other unspecified reason */
  | 'OTHER_DENIAL'
  /**
   * denial code used externally to present that we are missing a
   * particular piece of information necessary to value a home.
   * For backwards compatibility this denial_reason does not
   * have a more reasonable name like OTHER_DENIAL_VALUATION
   */
  | 'OTHER_DENIAL_DETAIL'
  /**
   * denial code used externally to present that we have some uncategorized
   * reason for denying a given address for a given product.
   */
  | 'OTHER_DENIAL_GENERAL'
  /** home has high risk factors */
  | 'OTHER_HIGH_RISK'
  /** Opendoor owns the home */
  | 'OWNED_BY_OPENDOOR'
  /** seller is working with a partner, could be homebuilder or other */
  | 'PARTNERSHIP'
  /** home has polybutylene piping */
  | 'POLYBUTYLENE_PIPING'
  /** already an active offer request for this address, still preparing offer */
  | 'PREPARING_OFFER'
  /** private pool */
  | 'PRIVATE_POOL'
  /** they're qualified for list with opendoor, which is incompatible with this product */
  | 'QUALIFIED_FOR_LWOD'
  /** they're qualified for opendoor direct, which is incompatible with this product */
  | 'QUALIFIED_FOR_OPENDOOR_DIRECT'
  /** lead will be passed to external brokerage */
  | 'RESERVED_FOR_EXTERNAL_BROKER'
  /** the home is in a region that Pricing has deemed too risky */
  | 'RISK_PROHIBITED_REGION'
  /** sale timeline is not compatible with the experience */
  | 'SALE_TIMELINE'
  /** rejected seller triage documentation */
  | 'SELLER_TRIAGE'
  /** home has a septic system */
  | 'SEPTIC'
  /** home has a shared entrance with neighbors */
  | 'SHARED_ENTRANCE'
  /** home has a shared lot with neighbors */
  | 'SHARED_LOT'
  /** home is tenant occupied (has lease) */
  | 'TENANT_OCCUPIED'
  /** seller is a trade-in customer */
  | 'TRADE_IN'
  /** opendoor cannot value the home. */
  | 'UNABLE_TO_VALUE'
  /** NY/NJ specific - homes commonly have underground oil tanks that can be costly */
  | 'UNDERGROUND_OIL_TANK'
  /** tenants in common, co-op programs */
  | 'UNIQUE_OWNERSHIP_STRUCTURE'
  /** home has unpermitted additions */
  | 'UNPERMITTED_ADDITION'
  /** home's value is outside of buybox range */
  | 'VALUATION_TOO_HIGH'
  /** home's value is outside of buybox range */
  | 'VALUATION_TOO_LOW'
  /** valuation is significantly lower than list price */
  | 'VALUATION_TOO_LOW_LISTED'
  /** home has a private well as the primary water source */
  | 'WELL_WATER'
  /** customer is working with a homebuilder partner */
  | 'WORKING_WITH_HOMEBUILDER'
  /** home was built too long ago */
  | 'YEAR_BUILT';

/**
 * The marketing channel the seller came in from.
 * Next ID: 4
 */
export type OdProtosSellCommon_MarketingChannel =
  /** From our mobile application. */
  | 'APP'
  /** From the main website opendoor.com. */
  | 'DEFAULT'
  /** From our home value report emails. */
  | 'HOME_VALUE'
  | 'UNKNOWN_CHANNEL';

/**
 * Partner home builders that refers sellers to us.
 * Next ID: 22
 */
export type OdProtosSellCommon_Partnership =
  | 'CALATLANTIC'
  | 'CENTURY_COMMUNITIES'
  | 'CHAFIN'
  | 'DAVID_WEEKLEY'
  | 'DR_HORTON'
  | 'FRONTDOOR'
  | 'GOODALL'
  | 'KB_HOME'
  | 'LENNAR'
  | 'MATTAMY'
  | 'MERITAGE'
  | 'MI_HOMES'
  | 'NONE'
  | 'OTHER_BUILDER'
  | 'PARDEE'
  | 'PULTE'
  | 'RYAN'
  | 'SHEA_HOMES_TRILOGY'
  | 'SMITHDOUGLAS'
  | 'TAYLOR_MORRISON'
  | 'TOLL_BROTHERS'
  | 'UNKNOWN'
  | 'WOODSIDE';

/**
 * A Product that we can offer to the seller.
 * Next ID: 13
 */
export type OdProtosSellCommon_Product =
  /** Refer to an agent to help them sell their home */
  | 'AGENT_REFERRAL'
  /** Buy a home from Opendoor */
  | 'BUY_WITH_OPENDOOR'
  /** Buy a home through an external listing agent */
  | 'EXTERNAL_LISTING_AGENT'
  /** Home insights dashboard */
  | 'HOME_INSIGHTS'
  /** List your home and get an Opendoor cash offer as a fallback */
  | 'LIST_WITH_CERTAINTY'
  /** List your home with Opendoor */
  | 'LIST_WITH_OPENDOOR'
  /** No product selected - used to reset/clear product selection */
  | 'NO_PRODUCT'
  /** Make a cash offer on any listed home, using Opendoor cash */
  | 'OPENDOOR_BACKED_OFFERS'
  /** Sell directly to Opendoor */
  | 'OPENDOOR_DIRECT'
  /** Sell to a REIT (Real Estate Investment Trust) */
  | 'REIT'
  /** Sell your home on Exclusives */
  | 'SELL_WITH_EXCLUSIVES'
  /** Sell directly with upside */
  | 'SELL_WITH_UPSIDE'
  /** Product with an unknown name. This should rarely happen */
  | 'UNKNOWN_PRODUCT';

/**
 * Segments that classify types of sellers
 * Next ID: 5
 */
export type OdProtosSellCommon_Segment =
  | 'BUYER'
  | 'HOMEBUILDER'
  | 'HOMEOWNER'
  | 'STAYING_IN_MARKET'
  | 'WORKING_WITH_AGENT';

/**
 * SelfServiceVirtualAssessmentExperimentGroup determines what experiment group the seller is in with regards to the Self Service
 * Virtual Assessment Experiment, where the seller has the option to upload a set of recordings of their home
 * in order to finalize their headline price. Depending on what group the seller falls into will determine
 * the user experience in terms of how they're presented with this option.
 * Next ID: 6
 */
export type OdProtosSellCommon_SelfServiceVirtualAssessmentExperimentGroup =
  /** Agent is presented the self-serve virtual assessment option with a heavier bias towards self-service. */
  | 'AGENT_ASSERTIVE'
  /** Agent is in the control group of the experiment */
  | 'AGENT_CONTROL'
  /**
   * Seller is presented with a heavier bias towards the self service option, and must explicitly opt out
   * of that experience.
   */
  | 'ASSERTIVE'
  /**
   * Seller is presented with both uploading the self service and scheduling a virtual assessment call with no
   * bias towards either option.
   */
  | 'BALANCED'
  /** Seller is in the control group of the experiment */
  | 'CONTROL'
  /** Seller is not in the experiment. */
  | 'NOT_IN_EXPERIMENT';

/**
 * The timeline the seller has when looking to sell their home.
 * Next ID: 6
 */
export type OdProtosSellCommon_Timeline =
  | 'ASAP'
  | 'JUST_BROWSING'
  | 'UNKNOWN_TIMELINE'
  /** 2 - 4 weeks */
  | 'WEEKS_2_4'
  /** 4 - 6 weeks */
  | 'WEEKS_4_6'
  /** 6+ weeks */
  | 'WEEKS_6_PLUS';

/**
 * Config keyed by Market (as a Fence Region).
 * PBDB Key: Fence Region ID
 * Next ID: 16
 */
export type OdProtosSellConfig_MarketConfigInput = {
  /** calendly link for agent team */
  agentCalendlyCalendar?: InputMaybe<Scalars['String']>;
  /** Brokerages ID of the brokerage used in this market. */
  brokerageId?: InputMaybe<Scalars['String']>;
  /** default calendly link */
  calendlyCalendar?: InputMaybe<Scalars['String']>;
  /** calendly link for seller to schedule immediate offer review, usually when offer is ready */
  calendlyCalendarImmediate?: InputMaybe<Scalars['String']>;
  /** calendly link for cep pilot team */
  cepPilotCalendlyCalendar?: InputMaybe<Scalars['String']>;
  /** calendly link for cep pilot team for immediate offer review, usually when offer is ready */
  cepPilotCalendlyCalendarImmediate?: InputMaybe<Scalars['String']>;
  /** CEP region the market belongs to (CEP regionalization) */
  cepRegion?: InputMaybe<Scalars['String']>;
  /** calendly link for home reserves pilot team */
  homeReservesCepCalendlyCalendar?: InputMaybe<Scalars['String']>;
  /** calendly link for lwod cep pilot team */
  lwodCepCalendlyCalendar?: InputMaybe<Scalars['String']>;
  /** Directory ID of the organization that manages this market. */
  orgId?: InputMaybe<Scalars['String']>;
  /** calendly link for partnership licensed team */
  partnershipLicensedCalendlyCalendar?: InputMaybe<Scalars['String']>;
  /** Fence ID of the region covered by this market. This is also the identifier (e.g. "phoenix"). */
  regionId?: InputMaybe<Scalars['String']>;
  /** calendly link for trade-in specific lead */
  tradeInCalendlyCalendar?: InputMaybe<Scalars['String']>;
  /** calendly link for trade-in specific lead for immediate offer review, usually when offer is ready */
  tradeInCalendlyCalendarImmediate?: InputMaybe<Scalars['String']>;
};

export type OdProtosSellOpsTasks_OfferReviewData_PreviousCallOutcome =
  /** follow up will be a virtual assessment call */
  | 'INCOMPLETE_VIRTUAL_ASSESSMENT'
  /** follow up will be with CEP */
  | 'NO_SHOW'
  /** no follow up */
  | 'ORVA_COMPLETE'
  /** follow up will be with CEP */
  | 'SELLER_NOT_READY'
  /** deprecating in favor of SELLER_NOT_READY. Do not use for new integrations. */
  | 'SELLER_NOT_READY_FOR_LISTING_APPOINTMENT'
  /** follow up will be with listing agent */
  | 'SELLER_NOT_READY_LISTING_AGENT_FOLLOW_UP'
  | 'UNKNOWN';

/**
 * Answers collected from the seller as part of the seller flow.
 * Next ID: 159
 */
export type OdProtosSellReceptionData_AnswersInput = {
  aboveGradeSqFt?: InputMaybe<Scalars['Float']>;
  aboveGradeSqFtOverrideReason?: InputMaybe<Scalars['String']>;
  /** Seller related answers */
  activelyLooking?: InputMaybe<Scalars['String']>;
  /** Home related answers */
  addition?: InputMaybe<Scalars['String']>;
  agent?: InputMaybe<Scalars['String']>;
  agentLedOfferEmail?: InputMaybe<Scalars['String']>;
  agentLedOfferFullName?: InputMaybe<Scalars['String']>;
  agentLedOfferPhoneNumber?: InputMaybe<Scalars['String']>;
  agentStatus?: InputMaybe<Scalars['String']>;
  agentType?: InputMaybe<Scalars['String']>;
  appSmsOptIn?: InputMaybe<Scalars['Boolean']>;
  backYardCondition?: InputMaybe<Scalars['String']>;
  backYardSlope?: InputMaybe<Scalars['String']>;
  backYardSlopeRetainingWall?: InputMaybe<Scalars['Boolean']>;
  backYardSlopeType?: InputMaybe<Scalars['String']>;
  basement?: InputMaybe<Scalars['String']>;
  basementFinishedSqFt?: InputMaybe<Scalars['Float']>;
  basementSqFt?: InputMaybe<Scalars['Float']>;
  basementSqFtOverrideReason?: InputMaybe<Scalars['String']>;
  basementSqFtTriage?: InputMaybe<Scalars['String']>;
  /** Deprecated. Use master_bathroom */
  bathroomCondition?: InputMaybe<Scalars['String']>;
  bathroomFeatures?: InputMaybe<OdProtosSellReceptionData_Answers_BathroomFeaturesInput>;
  bathroomRemodel?: InputMaybe<Scalars['String']>;
  bathroomSellerScore?: InputMaybe<Scalars['String']>;
  bathrooms?: InputMaybe<Scalars['Float']>;
  bathroomsFull?: InputMaybe<Scalars['Float']>;
  bathroomsHalf?: InputMaybe<Scalars['Float']>;
  bathroomsOverrideReason?: InputMaybe<Scalars['String']>;
  bedrooms?: InputMaybe<Scalars['Float']>;
  bedroomsOverrideReason?: InputMaybe<Scalars['String']>;
  bedroomsTriage?: InputMaybe<Scalars['String']>;
  brokerage?: InputMaybe<Scalars['String']>;
  /** deprecated */
  buyerZones?: InputMaybe<Array<OdProtosSellReceptionData_Answers_BuyerZoneInput>>;
  buyingNextHome?: InputMaybe<Scalars['Boolean']>;
  buyingNextHomeStatus?: InputMaybe<Scalars['String']>;
  buyingPower?: InputMaybe<OdProtosSellReceptionData_Answers_BuyingPowerInput>;
  buyingStage?: InputMaybe<Scalars['String']>;
  buyingTimeline?: InputMaybe<Scalars['String']>;
  carportSpaces?: InputMaybe<Scalars['Float']>;
  chatQuestions?: InputMaybe<Scalars['String']>;
  chatbotPhotoRequest?: InputMaybe<OdProtosSellReceptionData_Answers_ChatbotPhotoRequestInput>;
  currentlyInSellingProcess?: InputMaybe<Scalars['String']>;
  dwellingType?: InputMaybe<Scalars['String']>;
  eligibilityCriteria?: InputMaybe<OdProtosSellReceptionData_Answers_EligibilityCriteriaInput>;
  email?: InputMaybe<Scalars['String']>;
  entryTypes?: InputMaybe<OdProtosSellReceptionData_Answers_EntryTypesInput>;
  exclusivesCashOfferSentiment?: InputMaybe<Scalars['String']>;
  exclusivesCustomerPhoneNumber?: InputMaybe<Scalars['String']>;
  exclusivesHomesTouredAmount?: InputMaybe<Scalars['String']>;
  exclusivesInitialSellerOptionsInterest?: InputMaybe<OdProtosSellReceptionData_Answers_ExclusivesInitialSellerOptionsInterestInput>;
  exclusivesPrequalificationStatus?: InputMaybe<Scalars['String']>;
  exclusivesShareWithSeriousBuyers?: InputMaybe<Scalars['Boolean']>;
  exclusivesTasksForPotentiallyHigherOffer?: InputMaybe<OdProtosSellReceptionData_Answers_ExclusivesTasksForPotentiallyHigherOfferInput>;
  exclusivesThreeMonthTimeline?: InputMaybe<Scalars['Boolean']>;
  exploringFinancing?: InputMaybe<Scalars['String']>;
  exteriorAttributes?: InputMaybe<OdProtosSellReceptionData_Answers_ExteriorAttributesInput>;
  exteriorFacade?: InputMaybe<Scalars['String']>;
  exteriorSellerScore?: InputMaybe<Scalars['String']>;
  exteriorStories?: InputMaybe<Scalars['Float']>;
  /** Not used since April 2019 */
  financingReferral?: InputMaybe<Scalars['String']>;
  financingReferralOpendoorMortgage?: InputMaybe<Scalars['String']>;
  financingReferralTrustedLender?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  floodHistoryTriage?: InputMaybe<OdProtosSellReceptionData_Answers_FloodHistoryTriageInput>;
  floodZoneTriage?: InputMaybe<Scalars['String']>;
  flooringAllFloorTypes?: InputMaybe<OdProtosSellReceptionData_Answers_FloorTypesInput>;
  flooringCarpetCondition?: InputMaybe<Scalars['String']>;
  flooringCarpetRooms?: InputMaybe<OdProtosSellReceptionData_Answers_RoomsInput>;
  flooringFollowUpLiving?: InputMaybe<Scalars['String']>;
  flooringFollowUpMasterBedroom?: InputMaybe<Scalars['String']>;
  flooringHardwoodCondition?: InputMaybe<Scalars['String']>;
  flooringHardwoodRooms?: InputMaybe<OdProtosSellReceptionData_Answers_RoomsInput>;
  flooringLaminateCondition?: InputMaybe<Scalars['String']>;
  flooringLaminateRooms?: InputMaybe<OdProtosSellReceptionData_Answers_RoomsInput>;
  flooringMaterials?: InputMaybe<Array<Scalars['String']>>;
  flooringOtherRooms?: InputMaybe<OdProtosSellReceptionData_Answers_RoomsInput>;
  flooringPrimaryFloorCondition?: InputMaybe<Scalars['String']>;
  flooringPrimaryFloorType?: InputMaybe<Scalars['String']>;
  flooringSecondaryFloorCondition?: InputMaybe<Scalars['String']>;
  flooringSecondaryFloorType?: InputMaybe<Scalars['String']>;
  flooringTileCondition?: InputMaybe<Scalars['String']>;
  flooringTileRooms?: InputMaybe<OdProtosSellReceptionData_Answers_RoomsInput>;
  foundationIssue?: InputMaybe<Scalars['String']>;
  fullName?: InputMaybe<Scalars['String']>;
  garageSpaces?: InputMaybe<Scalars['Float']>;
  hasUpgrades?: InputMaybe<Scalars['Boolean']>;
  hoa?: InputMaybe<Scalars['Boolean']>;
  hoaFees?: InputMaybe<Scalars['Float']>;
  hoaTypes?: InputMaybe<OdProtosSellReceptionData_Answers_HoaTypesInput>;
  homeBuilder?: InputMaybe<Scalars['String']>;
  homeBuilderCommunity?: InputMaybe<Scalars['String']>;
  homeBuilderEmail?: InputMaybe<Scalars['String']>;
  homeBuilderOther?: InputMaybe<Scalars['String']>;
  homeBuyingProcess?: InputMaybe<Scalars['String']>;
  homeBuyingProcessOther?: InputMaybe<Scalars['String']>;
  homeGuideRegistered?: InputMaybe<Scalars['Boolean']>;
  initialFinancingStatus?: InputMaybe<Scalars['String']>;
  interiorAttributes?: InputMaybe<OdProtosSellReceptionData_Answers_InteriorAttributesInput>;
  interiorPaintCondition?: InputMaybe<Scalars['String']>;
  interiorPaintNeutral?: InputMaybe<Scalars['String']>;
  kitchenApplianceType?: InputMaybe<Scalars['String']>;
  kitchenCondition?: InputMaybe<Scalars['String']>;
  kitchenCounterType?: InputMaybe<Scalars['String']>;
  kitchenFeatures?: InputMaybe<OdProtosSellReceptionData_Answers_KitchenFeaturesInput>;
  kitchenRemodel?: InputMaybe<Scalars['String']>;
  /** Seller Score */
  kitchenSellerScore?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  leasedSolarPanelsTriage?: InputMaybe<Scalars['String']>;
  /** Customer-provided listing status when ODLS shows the home is listed */
  listed?: InputMaybe<Scalars['Boolean']>;
  /** Agent info related answers */
  listingAgentEmail?: InputMaybe<Scalars['String']>;
  listingAgentFullName?: InputMaybe<Scalars['String']>;
  livingRoomSellerScore?: InputMaybe<Scalars['String']>;
  lotOwnership?: InputMaybe<Scalars['String']>;
  masterBathroomCondition?: InputMaybe<Scalars['String']>;
  masterBedroomFloor?: InputMaybe<Scalars['Float']>;
  mlsAgentId?: InputMaybe<Scalars['String']>;
  mortgageAbad?: InputMaybe<Scalars['String']>;
  moveInReady?: InputMaybe<Scalars['String']>;
  movingAway?: InputMaybe<Scalars['String']>;
  optedIntoExclusiveOffers?: InputMaybe<Scalars['Boolean']>;
  otherInformation?: InputMaybe<Scalars['String']>;
  otherSellingWays?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  photosUploaded?: InputMaybe<Array<OdProtosSellReceptionData_Answers_PhotoInput>>;
  poolType?: InputMaybe<Scalars['String']>;
  priceEstimateCents?: InputMaybe<Scalars['Float']>;
  priceEstimateRange?: InputMaybe<OdProtosSellReceptionData_Answers_PriceEstimateRangeInput>;
  priceEstimateTriage?: InputMaybe<Scalars['String']>;
  propertyCondition?: InputMaybe<Scalars['String']>;
  realtorEmailOverride?: InputMaybe<Scalars['Boolean']>;
  realtorNameOverride?: InputMaybe<Scalars['Boolean']>;
  referralSource?: InputMaybe<Scalars['String']>;
  referralSourceOther?: InputMaybe<Scalars['String']>;
  referralSourceRadio?: InputMaybe<Scalars['String']>;
  relationToOwner?: InputMaybe<Scalars['String']>;
  relationToOwnerOther?: InputMaybe<Scalars['String']>;
  saleTimeline?: InputMaybe<Scalars['String']>;
  scheduleOfferReview?: InputMaybe<Scalars['String']>;
  selfServiceVirtualAssessmentChoice?: InputMaybe<Scalars['String']>;
  sellingReason?: InputMaybe<OdProtosSellReceptionData_Answers_SellingReasonInput>;
  sellingReasonOther?: InputMaybe<Scalars['String']>;
  sellingTimelineFlexibility?: InputMaybe<Scalars['String']>;
  setupBuyerFeed?: InputMaybe<OdProtosSellReceptionData_Answers_SetupBuyerFeedInput>;
  sharedEntrance?: InputMaybe<Scalars['Boolean']>;
  showingPreference?: InputMaybe<Scalars['String']>;
  signedListingAgreement?: InputMaybe<Scalars['Boolean']>;
  solarPanelsOwnershipType?: InputMaybe<Scalars['String']>;
  /** Deprecated. Use above_grade_sq_ft */
  sqFt?: InputMaybe<Scalars['Float']>;
  sqFtTriage?: InputMaybe<Scalars['String']>;
  userVerifiedAddress?: InputMaybe<Scalars['Boolean']>;
  verificationPrimaryOwner?: InputMaybe<Scalars['String']>;
  willingnessForTours?: InputMaybe<Scalars['String']>;
  workingWithHomeBuilder?: InputMaybe<Scalars['Boolean']>;
  yearBuilt?: InputMaybe<Scalars['Float']>;
};

/** Next ID: 6 */
export type OdProtosSellReceptionData_Answers_BathroomFeaturesInput = {
  doubleSink?: InputMaybe<Scalars['Boolean']>;
  graniteCountertops?: InputMaybe<Scalars['Boolean']>;
  separateShowerTub?: InputMaybe<Scalars['Boolean']>;
  tileSurround?: InputMaybe<Scalars['Boolean']>;
  updatedTileFloors?: InputMaybe<Scalars['Boolean']>;
};

/** Next ID: 11 */
export type OdProtosSellReceptionData_Answers_BuyerZoneInput = {
  breadcrumbPath?: InputMaybe<Scalars['String']>;
  displayName?: InputMaybe<Scalars['String']>;
  displayablePropertiesCount?: InputMaybe<Scalars['Float']>;
  gdsId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isNearby?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  parentName?: InputMaybe<Scalars['String']>;
  parents?: InputMaybe<Array<OdProtosSellReceptionData_Answers_BuyerZone_ZoneParentInput>>;
  value?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['Boolean']>;
};

export type OdProtosSellReceptionData_Answers_BuyerZone_ZoneParentInput = {
  breadcrumbPath?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type OdProtosSellReceptionData_Answers_BuyingPowerInput = {
  /** annual income in cents. */
  annualHouseholdIncome?: InputMaybe<Scalars['Float']>;
  /** credit score range. */
  creditScoreIndicated?: InputMaybe<OdProtosMortgageData_CreditRangeInput>;
  /** down payment in cents. */
  downPaymentAmount?: InputMaybe<Scalars['Float']>;
  /** monthly debt/expenses in cents. */
  monthlyDebt?: InputMaybe<Scalars['Float']>;
};

/** Next ID: 3 */
export type OdProtosSellReceptionData_Answers_ChatbotPhotoRequestInput = {
  status?: InputMaybe<Scalars['String']>;
  variant?: InputMaybe<Scalars['String']>;
};

/** Next ID: 20 */
export type OdProtosSellReceptionData_Answers_EligibilityCriteriaInput = {
  ageRestrictedCommunity?: InputMaybe<Scalars['Boolean']>;
  asbestosSiding?: InputMaybe<Scalars['Boolean']>;
  belowMarketRateOwnership?: InputMaybe<Scalars['Boolean']>;
  cesspool?: InputMaybe<Scalars['Boolean']>;
  fireDamage?: InputMaybe<Scalars['Boolean']>;
  gatedCommunity?: InputMaybe<Scalars['Boolean']>;
  historyOfChemicalContamination?: InputMaybe<Scalars['Boolean']>;
  knownFoundationIssues?: InputMaybe<Scalars['Boolean']>;
  leasedSolarPanels?: InputMaybe<Scalars['Boolean']>;
  livestock?: InputMaybe<Scalars['Boolean']>;
  mobileManufacturedHome?: InputMaybe<Scalars['Boolean']>;
  ownedSolarPanels?: InputMaybe<Scalars['Boolean']>;
  permittedAddition?: InputMaybe<Scalars['Boolean']>;
  /** Not used since Oct 2018 */
  polybutylenePiping?: InputMaybe<Scalars['Boolean']>;
  rentControlledTenantOccupied?: InputMaybe<Scalars['Boolean']>;
  septic?: InputMaybe<Scalars['Boolean']>;
  undergroundOilTank?: InputMaybe<Scalars['Boolean']>;
  uniqueOwnershipStructure?: InputMaybe<Scalars['Boolean']>;
  unpermittedAddition?: InputMaybe<Scalars['Boolean']>;
  wellWater?: InputMaybe<Scalars['Boolean']>;
};

/** Next ID: 4 */
export type OdProtosSellReceptionData_Answers_EntryTypesInput = {
  directEntry?: InputMaybe<Scalars['Boolean']>;
  sharedEntranceCondo?: InputMaybe<Scalars['Boolean']>;
};

/** Next ID: 4 */
export type OdProtosSellReceptionData_Answers_ExclusivesInitialSellerOptionsInterestInput = {
  exclusives?: InputMaybe<Scalars['Boolean']>;
  sellDirect?: InputMaybe<Scalars['Boolean']>;
  traditionalListing?: InputMaybe<Scalars['Boolean']>;
};

/** Next ID: 5 */
export type OdProtosSellReceptionData_Answers_ExclusivesTasksForPotentiallyHigherOfferInput = {
  forSaleSign?: InputMaybe<Scalars['Boolean']>;
  haveAnOpenHouse?: InputMaybe<Scalars['Boolean']>;
  listHomeTraditionally?: InputMaybe<Scalars['Boolean']>;
  makeRepairs?: InputMaybe<Scalars['Boolean']>;
};

/** Next ID: 11 */
export type OdProtosSellReceptionData_Answers_ExteriorAttributesInput = {
  deck?: InputMaybe<Scalars['Boolean']>;
  dock?: InputMaybe<Scalars['Boolean']>;
  hasNewRoof?: InputMaybe<Scalars['Boolean']>;
  hasNewWindows?: InputMaybe<Scalars['Boolean']>;
  hasNiceBackyard?: InputMaybe<Scalars['Boolean']>;
  patio?: InputMaybe<Scalars['Boolean']>;
  porch?: InputMaybe<Scalars['Boolean']>;
  sprinkler?: InputMaybe<Scalars['Boolean']>;
  upgradedPool?: InputMaybe<Scalars['Boolean']>;
  vinylSiding?: InputMaybe<Scalars['Boolean']>;
};

export type OdProtosSellReceptionData_Answers_FeedPropertyTypesInput = {
  apartment?: InputMaybe<Scalars['Boolean']>;
  home?: InputMaybe<Scalars['Boolean']>;
  multiFamily?: InputMaybe<Scalars['Boolean']>;
  townhome?: InputMaybe<Scalars['Boolean']>;
};

/** Next ID: 6 */
export type OdProtosSellReceptionData_Answers_FloodHistoryTriageInput = {
  harvey?: InputMaybe<Scalars['Boolean']>;
  memorialDay?: InputMaybe<Scalars['Boolean']>;
  notSure?: InputMaybe<Scalars['Boolean']>;
  other?: InputMaybe<Scalars['Boolean']>;
  taxDay?: InputMaybe<Scalars['Boolean']>;
};

/** Next ID: 6 */
export type OdProtosSellReceptionData_Answers_FloorTypesInput = {
  carpet?: InputMaybe<Scalars['Boolean']>;
  hardwood?: InputMaybe<Scalars['Boolean']>;
  laminate?: InputMaybe<Scalars['Boolean']>;
  other?: InputMaybe<Scalars['Boolean']>;
  tile?: InputMaybe<Scalars['Boolean']>;
};

/** Next ID: 4 */
export type OdProtosSellReceptionData_Answers_HoaTypesInput = {
  ageRestrictedCommunity?: InputMaybe<Scalars['Boolean']>;
  gatedCommunity?: InputMaybe<Scalars['Boolean']>;
  guardedGatedCommunity?: InputMaybe<Scalars['String']>;
  sharedEntranceCondo?: InputMaybe<Scalars['Boolean']>;
};

/** Next ID: 9 */
export type OdProtosSellReceptionData_Answers_InteriorAttributesInput = {
  basementWindows?: InputMaybe<Scalars['Boolean']>;
  finishedLoft?: InputMaybe<Scalars['Boolean']>;
  hasFireplace?: InputMaybe<Scalars['Boolean']>;
  hasOpenFloorPlan?: InputMaybe<Scalars['Boolean']>;
  hasWalkInCloset?: InputMaybe<Scalars['Boolean']>;
  kitchenIsland?: InputMaybe<Scalars['Boolean']>;
  laundry?: InputMaybe<Scalars['Boolean']>;
  sunroom?: InputMaybe<Scalars['Boolean']>;
};

/** Next ID: 4 */
export type OdProtosSellReceptionData_Answers_KitchenFeaturesInput = {
  kitchenIsland?: InputMaybe<Scalars['Boolean']>;
  newCabinets?: InputMaybe<Scalars['Boolean']>;
  tileBacksplash?: InputMaybe<Scalars['Boolean']>;
};

/** Next ID: 5 */
export type OdProtosSellReceptionData_Answers_PhotoInput = {
  filename?: InputMaybe<Scalars['String']>;
  key?: InputMaybe<Scalars['String']>;
  mimetype?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

/** Next ID: 3 */
export type OdProtosSellReceptionData_Answers_PriceEstimateRangeInput = {
  maxPrice?: InputMaybe<Scalars['String']>;
  minPrice?: InputMaybe<Scalars['String']>;
};

/** Next ID: 7 */
export type OdProtosSellReceptionData_Answers_RoomsInput = {
  dining?: InputMaybe<Scalars['Boolean']>;
  kitchen?: InputMaybe<Scalars['Boolean']>;
  living?: InputMaybe<Scalars['Boolean']>;
  masterBathroom?: InputMaybe<Scalars['Boolean']>;
  masterBedroom?: InputMaybe<Scalars['Boolean']>;
  other?: InputMaybe<Scalars['Boolean']>;
};

/** Next ID: 8 */
export type OdProtosSellReceptionData_Answers_SellingReasonInput = {
  downsizing?: InputMaybe<Scalars['Boolean']>;
  investmentProperty?: InputMaybe<Scalars['Boolean']>;
  needCash?: InputMaybe<Scalars['Boolean']>;
  other?: InputMaybe<Scalars['Boolean']>;
  relocating?: InputMaybe<Scalars['Boolean']>;
  retiring?: InputMaybe<Scalars['Boolean']>;
  upgrading?: InputMaybe<Scalars['Boolean']>;
};

/** Next ID: 7 */
export type OdProtosSellReceptionData_Answers_SetupBuyerFeedInput = {
  maxPrice?: InputMaybe<Scalars['Float']>;
  minBathrooms?: InputMaybe<Scalars['Float']>;
  minBedrooms?: InputMaybe<Scalars['Float']>;
  minPrice?: InputMaybe<Scalars['Float']>;
  propertyTypes?: InputMaybe<OdProtosSellReceptionData_Answers_FeedPropertyTypesInput>;
  zones?: InputMaybe<Array<OdProtosSellReceptionData_Answers_BuyerZoneInput>>;
};

export type OdProtosSellReceptionData_SellerInput_AddressVerifiedStatus =
  /** seller has implicitly confirmed their address, able to change their address */
  | 'AUTO_VERIFIED'
  /** seller has explicitly confirmed their address or moved to a state where their address cannot be changed */
  | 'CONFIRMED_VERIFIED'
  /** default for new seller inputs */
  | 'NOT_VERIFIED';

/** Next ID: 2 */
export type OdProtosSellReceptionData_SellerInput_AnalyticsMetadataInput = {
  addressEntry?: InputMaybe<OdProtosSellReceptionData_SellerInput_AnalyticsMetadata_AddressEntryInput>;
};

export type OdProtosSellReceptionData_SellerInput_AnalyticsMetadata_AddressEntryInput = {
  product?: InputMaybe<OdProtosSellReceptionData_SellerInput_AnalyticsMetadata_Product>;
  url?: InputMaybe<Scalars['String']>;
};

/** Next ID: 4 */
export type OdProtosSellReceptionData_SellerInput_AnalyticsMetadata_Product =
  | 'OPENDOOR_COMPLETE'
  | 'OPENDOOR_EXCLUSIVES'
  | 'SELL_DIRECT'
  | 'UNKNOWN';

/**
 * The channel the seller came in from, used to determine the overall experience
 * the seller will go through.
 * Next ID: 21
 */
export type OdProtosSellReceptionData_SellerInput_Channel =
  /** AGENT_REQUEST is used for agent requested leads. */
  | 'AGENT_REQUEST'
  /** AGENT_REQUEST_LISTED is used for agent requested leads on listed homes. */
  | 'AGENT_REQUEST_LISTED'
  /** APP is used for leads from the mobile app. */
  | 'APP'
  /** BUY_SELL_FLOW is used for the combined buy and sell flow launched by Buyer in 2021 */
  | 'BUY_SELL_FLOW'
  /**
   * CAKE_LANDING_PAGE is for leads starting from the /tradeins landing page,
   * intended to reach the new customer dashboard.
   */
  | 'CAKE_LANDING_PAGE'
  /** CCPA_OPT_OUT is used for leads that have opted out of CCPA */
  | 'CCPA_OPT_OUT'
  /** DEFAULT is the standard channel for incoming leads. */
  | 'DEFAULT'
  /** EMAIL_PROSPECTING is used for leads from the cold email prospecting experiment. */
  | 'EMAIL_PROSPECTING'
  /** EXCLUSIVE_OFFER is used for exclusive offers program */
  | 'EXCLUSIVE_OFFERS'
  /**
   * FLYWHEEL is used for leads from the address entry in the app before a
   * buyer unlocks a home, as derived from project Flywheel
   */
  | 'FLYWHEEL'
  /** HOME_RESERVE is used for Home reserve landing page */
  | 'HOME_RESERVE'
  /** HOME_VALUE is used for leads from the /home-value landing page. */
  | 'HOME_VALUE'
  /** OPENDOOR_BACKED_OFFER is used for bwod obo program */
  | 'OPENDOOR_BACKED_OFFER'
  /** OUTBOUND_OFFERS_LISTED is used for 2020 Hackweek experiment of sending offers to listed homes */
  | 'OUTBOUND_OFFERS_LISTED'
  /** OUTBOUND_OFFERS_UNDERWRITTEN is used for outbound offers that will be underwritten and sent out as final offers */
  | 'OUTBOUND_OFFERS_UNDERWRITTEN'
  /** PARTNER_API is used for seller inputs created via the partner API */
  | 'PARTNER_API'
  /** REIT_BULK_REQUEST is used for bulk acquisition requests from REITs */
  | 'REIT_BULK_REQUEST'
  | 'REIT_BULK_REQUEST_LISTED'
  /** SELLER_REQUEST_LISTED is used for seller requested leads on listed homes. */
  | 'SELLER_REQUEST_LISTED'
  /** TRADE_IN is used for leads from the /trade-in landing page. */
  | 'TRADE_IN'
  /** DO NOT USE, this represents an unset enum value. */
  | 'UNSET_CHANNEL';

export type OdProtosSellSellerData_AcquisitionState =
  | 'ACQUISITION_STATE_DENIED'
  | 'ACQUISITION_STATE_OTHER_WALK'
  | 'ACQUISITION_STATE_QUALIFIED'
  | 'ACQUISITION_STATE_UNDERWRITING_WALK'
  | 'ACQUISITION_STATE_UNKNOWN';

export type OdProtosSellSellerData_AddOn_AddOnType =
  | 'BWOD'
  | 'HOME_RESERVE'
  | 'UNKNOWN_ADD_ON';

export type OdProtosSellSellerData_AgentReferralDetails_AgentBio_Gender =
  | 'FEMALE'
  | 'MALE'
  | 'NON_BINARY'
  | 'UNKNOWN_GENDER';

export type OdProtosSellSellerData_HomeReserveMetadata_HomeReserveAttributionSource =
  /** The seller became eligible for Home Reserve by an operator submitting offer review notes */
  | 'OFFER_REVIEW_DISPOSITION'
  /** The seller became eligible for Home Reserve by answering questions in the seller flow */
  | 'SELLER_FLOW'
  | 'UNKNOWN';

/**
 * LeadId represents a lead input, currently including a lead id (seller_uuid) or a lead source (e.g. reception type and seller_input_uuid).
 * Next ID: 3
 */
export type OdProtosSellSellerData_LeadIdInput = {
  lead?: InputMaybe<OdProtosSellSellerData_LeadId_LeadOneofInput>;
};

export type OdProtosSellSellerData_LeadId_LeadOneofInput = {
  leadId?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<OdProtosSellSellerData_Lead_SourceInput>;
};

/**
 * A qualified sell lead.
 * Next ID: 27
 */
export type OdProtosSellSellerData_LeadInput = {
  /** The address of the lead. */
  addressId?: InputMaybe<Scalars['String']>;
  /**
   * JSON answers that the seller provided (e.g. home details, sale timeline).
   * Example: "{ \\"home.bedrooms\\": 3, \\"seller.email\\": \\"test@test.com\\" }"
   */
  answersJson?: InputMaybe<Scalars['String']>;
  /** The user token of the broker representing the brokerage. Optional. */
  brokerId?: InputMaybe<Scalars['String']>;
  /** The brokerage that is representing the transaction. */
  brokerageId?: InputMaybe<Scalars['String']>;
  /** Channel that the lead belongs to */
  channel?: InputMaybe<OdProtosSellReceptionData_SellerInput_Channel>;
  /** User token of the assigned closing manager. */
  closingManagerId?: InputMaybe<Scalars['String']>;
  /** The time the lead was created */
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** The customer who originated the lead. */
  customerId?: InputMaybe<Scalars['String']>;
  customerUuid?: InputMaybe<Scalars['String']>;
  /** Timestamp of decision_call for customers receiving both lwod and od_direct offer. */
  decisionCallAt?: InputMaybe<Scalars['DateTime']>;
  /** Experiment entity ID to be used with Optimizely and other experiments. */
  experimentEntityId?: InputMaybe<Scalars['String']>;
  /** User token of the assigned home adviser. */
  homeAdviserId?: InputMaybe<Scalars['String']>;
  /** Home details record referencing the seller's answers. */
  homeDetailId?: InputMaybe<Scalars['String']>;
  /** Primary identifier for a lead. */
  id?: InputMaybe<Scalars['String']>;
  /** The time of the offer review if the customer opted for one. */
  offerReview?: InputMaybe<OdProtosSellSellerData_OfferReviewInput>;
  /** Policies attached to this lead. */
  policy?: InputMaybe<OdProtosSellSellerData_PolicyInput>;
  /** All the product offerings associated with the lead. */
  productOfferings?: InputMaybe<Array<OdProtosSellSellerData_ProductOfferingInput>>;
  /** Records when a refresh was requested for this lead */
  refreshRequestedAt?: InputMaybe<Scalars['DateTime']>;
  /** Name of the market region the home is in. */
  region?: InputMaybe<Scalars['String']>;
  /** The product that the seller has selected */
  selectedProduct?: InputMaybe<OdProtosSellCommon_Product>;
  /** Identifier for the sell request in ODLS. */
  sellRequestId?: InputMaybe<Scalars['String']>;
  /** Information provided by the seller. */
  sellerDetails?: InputMaybe<OdProtosSellSellerData_SellerDetailsInput>;
  source?: InputMaybe<OdProtosSellSellerData_Lead_SourceInput>;
  /**
   * List of users who are participants of the lead. This will initially
   * be empty. When an offer is accepted we will prompt the customer to
   * create an account or log in at which point we can associate the first
   * participant to the lead. Thereafter participants can invite others
   * to join (e.g. spouses, other legal owners).
   */
  userIds?: InputMaybe<Array<Scalars['String']>>;
};

/** Which system generated the lead. */
export type OdProtosSellSellerData_Lead_SourceInput = {
  id?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<OdProtosSellSellerData_Lead_Source_Type>;
};

export type OdProtosSellSellerData_Lead_Source_Type =
  | 'PARTNERSHIP'
  | 'RECEPTION'
  | 'UNKNOWN_TYPE';

/** Next ID: 5 */
export type OdProtosSellSellerData_LoanDetailsInput = {
  estimatedBalanceCents?: InputMaybe<Scalars['Float']>;
  interestRatePercent?: InputMaybe<Scalars['Float']>;
  loanType?: InputMaybe<Scalars['String']>;
  originationDate?: InputMaybe<Scalars['DateTime']>;
};

/** Next ID: 34 */
export type OdProtosSellSellerData_OfferRequest_Source =
  | 'AGENT_LED_OFFERS_REACTIVATE'
  | 'AGENT_LED_OFFER_AUTO_REFRESH'
  | 'AGENT_LED_OFFER_DROPOUT'
  /** AUTOMATED_AGENT_REENGAGEMENT_OFFER is used for agent refreshes triggered via the daily DAG */
  | 'AUTOMATED_AGENT_REENGAGEMENT_OFFER'
  /** AUTOMATED_MSRE_REFRESH_OFFER is used for auto offer refreshes for MSRE leads daily */
  | 'AUTOMATED_MSRE_REFRESH_OFFER'
  | 'AUTOMATED_REENGAGEMENT_OFFER'
  /** EMAIL_PROSPECTING is used for offer requests on leads from the EMAIL_PROSPECTING channel */
  | 'EMAIL_PROSPECTING'
  | 'EXCLUSIVE_OFFERS'
  /** FLYWHEEL is used for offer requests on leads from the FLYWHEEL channel */
  | 'FLYWHEEL'
  /** HOMEPAGE_RETURN_EXPERIENCE is used for offer refreshes that are triggered from the homepage */
  | 'HOMEPAGE_RETURN_EXPERIENCE'
  /** HOME_RESERVE is used for offers requests on leads from the HOME_RESERVE channel */
  | 'HOME_RESERVE'
  | 'INCOMPLETE_INITIAL_LEAD_FLOW'
  | 'INITIAL_LEAD_FLOW'
  | 'MOBILE_APP'
  | 'OFFER_REENGAGEMENT_CAMPAIGN'
  | 'OFFER_REVIEW'
  /** OUTBOUND_OFFERS_LISTED is used for 2020 Hackweek experiment of sending offers to listed homes */
  | 'OUTBOUND_OFFERS_LISTED'
  /** OUTBOUND_OFFERS_UNDERWRITTEN is used for outbound offers that should auto-start underwriting and skip assessments */
  | 'OUTBOUND_OFFERS_UNDERWRITTEN'
  | 'REFRESH_ADMIN'
  /** REFRESH_ASSESSMENT_COMPLETED is used when a customer completes a virtual assessment but their offer has expired */
  | 'REFRESH_ASSESSMENT_COMPLETED'
  | 'REFRESH_BROKERAGE_OFFER_DASHBOARD'
  | 'REFRESH_CORRECTED_SQ_FT_DATA'
  /** REFRESH_FROM_ENG is used for backfilling any refresh properties that expierenced a break in flow due to an error */
  | 'REFRESH_FROM_ENG'
  /** REFRESH_HOME_DETAILS is used for offer refreshes from the offer dashboard home details page */
  | 'REFRESH_HOME_DETAILS'
  | 'REFRESH_OFFER_DASHBOARD'
  /** REFRESH_PARTNER_CTA is used for offer requests that come from Opendoor partners */
  | 'REFRESH_PARTNER_CTA'
  /** REFRESH_PARTNER_REFERRAL is used for offers refreshed from the partnerships referral dashboard */
  | 'REFRESH_PARTNER_REFERRAL'
  | 'REFRESH_PREVIOUSLY_DENIED'
  | 'REFRESH_REENGAGEMENT_EMAILS'
  | 'REFRESH_SELLER_FEEDBACK'
  | 'REIT_BULK_REQUEST'
  /** Restore offer because of an LWOD Listing agreement being signed */
  | 'RESTORE_LWOD_LISTING_AGREEMENT_SIGNED'
  /** RETURN_TO_HUB_AUTO_REFRESH is used for offer refreshes automatically made when users return to the Hub */
  | 'RETURN_TO_HUB_AUTO_REFRESH'
  | 'UNKNOWN_OFFER_SOURCE';

/**
 * OfferReview is a scheduled offer review session between the customer and a HA.
 * Next ID: 6
 */
export type OdProtosSellSellerData_OfferReviewInput = {
  /** Calendly's invitee identifier for the scheduled event. */
  calendlyInviteeUuid?: InputMaybe<Scalars['String']>;
  endTime?: InputMaybe<Scalars['DateTime']>;
  /** Identifier for the offer review. */
  id?: InputMaybe<Scalars['String']>;
  /** The time that the offer review is scheduled to start and end. */
  startTime?: InputMaybe<Scalars['DateTime']>;
};

export type OdProtosSellSellerData_Offer_Source_Type =
  | 'AGENT_REFERRAL'
  | 'CLEARINGHOUSE'
  | 'LASER'
  | 'UNKOWN_TYPE'
  | 'WEB_BROKERAGE_OFFER'
  | 'WEB_OFFER';

/**
 * State represents a state machine for offers.
 * Next ID: 10
 */
export type OdProtosSellSellerData_Offer_State =
  /**
   * Accepted means the seller has accepted the offer and is ready
   * to proceed. This is not legally binding.
   */
  | 'ACCEPTED'
  /**
   * Closed means the transaction has been successfully completed. In the
   * case of a direct sale, this means they have sold their home.
   */
  | 'CLOSED'
  /**
   * Contingencies released means all contingencies have been released on
   * the transaction.
   */
  | 'CONTINGENCIES_RELEASED'
  /**
   * Expired means the seller did not take action before the expiry of
   * the offer, and the offer is now invalid.
   */
  | 'EXPIRED'
  /**
   * In contract means the seller has signed the purchase agreement and
   * we now have a contractual relationship with the seller.
   */
  | 'IN_CONTRACT'
  /**
   * Received means we have received an offer from a buyer, but
   * have yet to notify the seller of the offer.
   */
  | 'RECEIVED'
  /** Rejected means the seller has rejected the offer. */
  | 'REJECTED'
  /**
   * Sent means we have notified the seller of the offer, and are
   * waiting on their response.
   */
  | 'SENT'
  /** This is an unknown or invalid state. */
  | 'UNKNOWN_STATE'
  /** Withdrawn means the seller has withdrawn from the transaction. */
  | 'WITHDRAWN';

/**
 * Policy contains simple data fields which govern what actions should
 * be taken for the lead.
 *
 * Next ID: 9
 */
export type OdProtosSellSellerData_PolicyInput = {
  /**
   * Experiment flags
   *
   * 100% rollout of CEP CX role (Feb 2020)
   */
  expAug2019CepPilot?: InputMaybe<Scalars['Boolean']>;
  /** Whether the lead is qualified for marketplace or not. */
  marketplace?: InputMaybe<Scalars['Boolean']>;
  /** Opendoor direct offer will be an automated offer. */
  opendoorDirectAutomatedOffer?: InputMaybe<Scalars['Boolean']>;
  /** Whether we can show comps as part of the offer or not. */
  showComps?: InputMaybe<Scalars['Boolean']>;
};

/**
 * ProductOffering represents a product that we can offer to the seller.
 * Next ID: 9
 */
export type OdProtosSellSellerData_ProductOfferingInput = {
  denialNotes?: InputMaybe<Scalars['String']>;
  /** Following fields are only set if denied. */
  denialReason?: InputMaybe<OdProtosSellCommon_DenialReason>;
  /** The time that lead was denied for this product (auto or manual denial) */
  deniedAt?: InputMaybe<Scalars['DateTime']>;
  /** User token of the actor who denied the product. */
  deniedBy?: InputMaybe<Scalars['String']>;
  /** The time that lead was initially qualified for this product */
  initialQualifiedAt?: InputMaybe<Scalars['DateTime']>;
  /** The interest level of a seller towards a specific product */
  interestLevel?: InputMaybe<OdProtosSellSellerData_ProductOffering_InterestLevel>;
  /** Reason that opendoor walked from the product */
  opendoorWalkReason?: InputMaybe<OdProtosCommonSell_OpendoorWalkReason>;
  product?: InputMaybe<OdProtosSellCommon_Product>;
  /** Reason that the seller walked from the product */
  sellerWalkReason?: InputMaybe<OdProtosCommonSell_SellerWalkReason>;
  state?: InputMaybe<OdProtosSellSellerData_ProductOffering_State>;
};

/** InterestLevel represents the interest level of a seller towards a product */
export type OdProtosSellSellerData_ProductOffering_InterestLevel =
  | 'INTERESTED'
  | 'NOT_INTERESTED'
  | 'UNKNOWN_INTEREST_LEVEL';

export type OdProtosSellSellerData_ProductOffering_State =
  | 'DENIED'
  | 'QUALIFIED'
  | 'UNKNOWN_STATE'
  | 'WITHDRAWN';

/**
 * SellerDetails contains information provided to us from the seller or
 * set by the source service (e.g. Reception or Partnership). Data specified
 * here may be updated if it is updated in the source service.
 *
 * Next ID: 22
 */
export type OdProtosSellSellerData_SellerDetailsInput = {
  /** Whether or not the customer answered that they are actively looking to buy */
  activelyLooking?: InputMaybe<Scalars['Boolean']>;
  /** True if the customer is an agent representing the home seller. */
  agent?: InputMaybe<Scalars['Boolean']>;
  /**
   * Following 4 fields are inputs to calculating buying power using the mortgage service,
   * so types are kept consistent with those in prequalification answers.
   * Seller's annual income in cents.
   */
  annualIncomeCents?: InputMaybe<Scalars['Float']>;
  /** The channel the seller came through */
  channel?: InputMaybe<OdProtosSellCommon_MarketingChannel>;
  /** Seller's credit score range. */
  creditScoreRange?: InputMaybe<OdProtosMortgageData_CreditRangeInput>;
  /** Seller's down payment in cents for their next home. */
  downPaymentCents?: InputMaybe<Scalars['Float']>;
  /** Determines if customer is eligible for an assumable loan from Roam */
  eligibleForRoamAssumableLoan?: InputMaybe<Scalars['Boolean']>;
  /** Seller's goal price. */
  goalPriceCents?: InputMaybe<Scalars['Float']>;
  /** Whether or not the customer has visited the new dynamic moving hub */
  hasVisitedHub?: InputMaybe<Scalars['Boolean']>;
  /** Whether or not the user is in the new trade-in dashboard experience. */
  isTradeInDashboard?: InputMaybe<Scalars['Boolean']>;
  /** Whether the home is currently listed or not. */
  listed?: InputMaybe<Scalars['Boolean']>;
  /** Seller's monthly debt/expenses in cents. */
  monthlyDebtsCents?: InputMaybe<Scalars['Float']>;
  /** Whether or not the customer has visited the offer dashboard. */
  offerDashboardVisited?: InputMaybe<Scalars['Boolean']>;
  /** Specifies the time the offer should be delivered to the customer. */
  offerDeliveryTime?: InputMaybe<Scalars['DateTime']>;
  /** The home builder partnership the seller came in through, if any. */
  partnership?: InputMaybe<OdProtosSellCommon_Partnership>;
  /** Photos submitted by the seller as a list of cabinet ids. */
  photoIds?: InputMaybe<Array<Scalars['String']>>;
  /** Seller's own estimate of the value of their home. */
  priceEstimateCents?: InputMaybe<Scalars['Float']>;
  /**
   * Customer UUID for the representative of the partner
   * organization that referred the lead to Opendoor.
   */
  referrerContactId?: InputMaybe<Scalars['String']>;
  /** Specifies loan details from Roam */
  roamAssumableLoanDetails?: InputMaybe<OdProtosSellSellerData_LoanDetailsInput>;
  /** Seller's sale timeline. */
  timeline?: InputMaybe<OdProtosSellCommon_Timeline>;
  /** Whether the home is a potential trade in or not. */
  tradeIn?: InputMaybe<Scalars['Boolean']>;
  /** Whether the home is a potential trade in bundle (sell + buy + finance). */
  tradeInBundle?: InputMaybe<Scalars['Boolean']>;
};

export type OdProtosSellSellerData_SellerExperience =
  | 'SELLER_EXPERIENCE_AGENT_ACQUISITION'
  | 'SELLER_EXPERIENCE_AGENT_LED_OFFERS'
  | 'SELLER_EXPERIENCE_DENIED'
  | 'SELLER_EXPERIENCE_DIRECT_TO_CONSUMER'
  | 'SELLER_EXPERIENCE_UNKNOWN';

export type OdProtosSellSellerData_TradeInSpecificData_Interest =
  | 'INTERESTED'
  | 'NOT_INTERESTED'
  | 'UNSET';

/** RecordedFeature is the feature of the home being recorded. */
export type OdProtosSellSellerData_VirtualAssessmentRecording_RecordedFeature =
  | 'BACKYARD'
  | 'FRONTYARD'
  | 'KITCHEN'
  | 'LIVING_ROOM'
  | 'MASTER_BEDROOM_AND_BATHROOM'
  | 'SELLER_DISCLOSURE_DOCUMENT'
  | 'UNKNOWN'
  | 'UTILITIES'
  | 'WHOLE_HOME';

export type OdProtosSellSellerEvents_SellerLeadEvent_AcquisitionUnderwritingDecisionDetermined_Decision =
  | 'PROCEED'
  | 'UNKNOWN_DECISION'
  | 'WALK';

export type OdProtosSellSellerServices_AreAllOffersReadyResponse_Ready =
  /** We have all the offers we expect. */
  | 'ALL_OFFERS_ARE_READY'
  /** We expect to receive offers, but haven't received all of them. */
  | 'NOT_ALL_OFFERS_ARE_READY'
  /** We don't expect any offers because there are no qualified products. */
  | 'NO_QUALIFIED_PRODUCTS'
  | 'UNKNOWN';

/** Next ID: 2 */
export type OdProtosSellSellerServices_ClearCustomerAssociationRequestInput = {
  sellerLeadUuid?: InputMaybe<Scalars['String']>;
};

/** Next ID: 2 */
export type OdProtosSellSellerServices_CreateLeadRequestInput = {
  lead?: InputMaybe<OdProtosSellSellerData_LeadInput>;
};

/** Next ID: 2 */
export type OdProtosSellSellerServices_CustomerIdsInput = {
  customerIds?: InputMaybe<Array<Scalars['String']>>;
};

/** Next ID: 2 */
export type OdProtosSellSellerServices_DenyLeadRequestInput = {
  denialNotes?: InputMaybe<Scalars['String']>;
  denialReason?: InputMaybe<OdProtosSellCommon_DenialReason>;
  deniedBy?: InputMaybe<Scalars['String']>;
  leadId?: InputMaybe<Scalars['String']>;
  product?: InputMaybe<OdProtosSellCommon_Product>;
};

/** Next: 6 */
export type OdProtosSellSellerServices_Experience =
  | 'AGENT_LED_OFERS'
  /** Also known as OpenDoor Led Offers (ODLO) */
  | 'DIRECT_TO_CONSUMER'
  | 'SELL_DIRECT_AGENT'
  | 'SELL_DIRECT_CORE'
  | 'SELL_YOUR_WAY'
  | 'UNKNOWN_EXPERIENCE';

/** Next ID: 1 */
export type OdProtosSellSellerServices_GetAcquisitionStateRequestInput = {
  sellerLeadUuid?: InputMaybe<Scalars['String']>;
};

/** Next ID: 2 */
export type OdProtosSellSellerServices_GetHomeDetailsRequestInput = {
  leadUuid?: InputMaybe<Scalars['String']>;
};

/** Next ID: 2 */
export type OdProtosSellSellerServices_GetInitialOfferRequestSourceRequestInput = {
  sellerLeadUuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosSellSellerServices_GetLatestLeadByAddressRequestInput = {
  addressUuid?: InputMaybe<Scalars['String']>;
};

/** Next ID: 3 */
export type OdProtosSellSellerServices_GetLatestLeadRequestInput = {
  addressUuid?: InputMaybe<Scalars['String']>;
  customerUuid?: InputMaybe<Scalars['String']>;
};

/** Next ID: 2 */
export type OdProtosSellSellerServices_GetLeadBySourceRequestInput = {
  source?: InputMaybe<OdProtosSellSellerData_Lead_SourceInput>;
};

/** Next ID: 3 */
export type OdProtosSellSellerServices_GetLeadRequestInput = {
  lead?: InputMaybe<OdProtosSellSellerServices_GetLeadRequest_LeadOneofInput>;
};

export type OdProtosSellSellerServices_GetLeadRequest_LeadOneofInput = {
  leadId?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<OdProtosSellSellerData_Lead_SourceInput>;
};

/** Next: 2 */
export type OdProtosSellSellerServices_GetProductsExperiencesRequestInput = {
  sellerLeadUuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosSellSellerServices_GetSelectedSellerProductRequestInput = {
  sellerLeadUuid?: InputMaybe<Scalars['String']>;
};

/** Next ID: 2 */
export type OdProtosSellSellerServices_GetSellerDetailsHistoryRequestInput = {
  sellerLeadUuid?: InputMaybe<Scalars['String']>;
};

/** Next ID: 2 */
export type OdProtosSellSellerServices_LeadIdsInput = {
  leadIds?: InputMaybe<Array<Scalars['String']>>;
};

/** Next ID: 2 */
export type OdProtosSellSellerServices_ListLeadsByAddressRequestInput = {
  addressUuid?: InputMaybe<Scalars['String']>;
};

/** Next ID: 2 */
export type OdProtosSellSellerServices_ListLeadsBySourceIdRequestInput = {
  sourceIds?: InputMaybe<Array<Scalars['String']>>;
};

/** Next ID: 2 */
export type OdProtosSellSellerServices_ListLeadsOnUniqueAddressesRequestInput = {
  /** Response will be limited to latest 20 leads */
  customerUuid?: InputMaybe<Scalars['String']>;
};

/** Next ID: 3 */
export type OdProtosSellSellerServices_ListLeadsRequestInput = {
  identifiers?: InputMaybe<OdProtosSellSellerServices_ListLeadsRequest_IdentifiersOneofInput>;
  leadIds?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosSellSellerServices_ListLeadsRequest_IdentifiersOneofInput = {
  /** Response will be limited to latest 200 leads */
  customerIds?: InputMaybe<OdProtosSellSellerServices_CustomerIdsInput>;
  leadUuids?: InputMaybe<OdProtosSellSellerServices_LeadIdsInput>;
};

/** Next ID: 4 */
export type OdProtosSellSellerServices_OfferViewedRequestInput = {
  /**
   * Setting lead_id instead of offer_id will send a viewed event for all qualified products.
   * Also while we still track REIT/Agent Referral offers, it'll set those offers to viewed
   * for qualified products.
   */
  leadId?: InputMaybe<Scalars['String']>;
  offerId?: InputMaybe<Scalars['String']>;
  /** The time the offer was viewed. If blank, the current time will be used */
  viewedAt?: InputMaybe<Scalars['DateTime']>;
};

/** Next ID: 3 */
export type OdProtosSellSellerServices_QualifyLeadRequestInput = {
  leadId?: InputMaybe<Scalars['String']>;
  product?: InputMaybe<OdProtosSellCommon_Product>;
};

/** Next ID: 4 */
export type OdProtosSellSellerServices_RefreshOffersRequestInput = {
  leadIds?: InputMaybe<Array<OdProtosSellSellerData_LeadIdInput>>;
  offerRequestSource?: InputMaybe<OdProtosSellSellerData_OfferRequest_Source>;
  offerRequestSourceCommon?: InputMaybe<OdProtosCommonSell_OfferRequest_Source>;
};

/** Next ID: 3 */
export type OdProtosSellSellerServices_RefreshOffersSingleLeadRequestInput = {
  leadId?: InputMaybe<OdProtosSellSellerData_LeadIdInput>;
  offerRequestSource?: InputMaybe<OdProtosCommonSell_OfferRequest_Source>;
};

/** Next: 3 */
export type OdProtosSellSellerServices_SelectProductRequestInput = {
  product?: InputMaybe<OdProtosSellCommon_Product>;
  sellerLeadUuid?: InputMaybe<Scalars['String']>;
};

/** Next ID: 4 */
export type OdProtosSellSellerServices_SetSellerDetailsRequestInput = {
  leadId?: InputMaybe<Scalars['String']>;
  sellerDetails?: InputMaybe<OdProtosSellSellerData_SellerDetailsInput>;
  updatedByToken?: InputMaybe<Scalars['String']>;
};

export type OdProtosSellSellerServices_SubmitAgentLedOfferDataRequestInput = {
  email?: InputMaybe<Scalars['String']>;
  fullName?: InputMaybe<Scalars['String']>;
  leadUuid?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
};

/** Next ID: 8 */
export type OdProtosSellSellerServices_UpdateLeadRequestInput = {
  addressId?: InputMaybe<Scalars['String']>;
  /**
   * JSON changed answers that should be updated.
   * Example: "{ \\"home.bedrooms\\": 3 }"
   */
  answers?: InputMaybe<Scalars['String']>;
  channel?: InputMaybe<OdProtosSellReceptionData_SellerInput_Channel>;
  customerUuid?: InputMaybe<Scalars['String']>;
  homeDetailId?: InputMaybe<Scalars['String']>;
  lead?: InputMaybe<OdProtosSellSellerServices_UpdateLeadRequest_LeadOneofInput>;
};

export type OdProtosSellSellerServices_UpdateLeadRequest_LeadOneofInput = {
  leadId?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<OdProtosSellSellerData_Lead_SourceInput>;
};

/** Next ID: 10 */
export type OdProtosSellSellerServices_UpdateSellerDetailsRequestInput = {
  annualIncomeCents?: InputMaybe<Scalars['Float']>;
  creditScoreRange?: InputMaybe<OdProtosMortgageData_CreditRangeInput>;
  downPaymentCents?: InputMaybe<Scalars['Float']>;
  goalPriceCents?: InputMaybe<Scalars['Float']>;
  hasVisitedHub?: InputMaybe<Scalars['Boolean']>;
  leadId?: InputMaybe<Scalars['String']>;
  monthlyDebtsCents?: InputMaybe<Scalars['Float']>;
  offerDashboardVisited?: InputMaybe<Scalars['Boolean']>;
  updatedByToken?: InputMaybe<Scalars['String']>;
};

/** Next ID: 6 */
export type OdProtosSellSellerServices_WithdrawFromProductRequestInput = {
  product?: InputMaybe<OdProtosSellCommon_Product>;
  sellerLeadUuid?: InputMaybe<Scalars['String']>;
  withdrawalDetails?: InputMaybe<Scalars['String']>;
  withdrawalReason?: InputMaybe<OdProtosSellSellerServices_WithdrawFromProductRequest_WithdrawalReasonOneofInput>;
};

export type OdProtosSellSellerServices_WithdrawFromProductRequest_WithdrawalReasonOneofInput = {
  opendoorWalkReason?: InputMaybe<OdProtosCommonSell_OpendoorWalkReason>;
  sellerWalkReason?: InputMaybe<OdProtosCommonSell_SellerWalkReason>;
};

/** Next ID: 7 */
export type OdProtosSellWebEvents_LeadEvent_PricingRoutingEventCreated_Strategy =
  | 'AD_HOC_REFRESH'
  | 'AUTOMATED'
  | 'CONSISTENT_VALUATIONS'
  | 'FORCE_AUTOMATED'
  | 'OUTLIER_VALUATIONS'
  | 'REPEAT'
  | 'UNKNOWN_STRATEGY';

/**
 * any filters we want to query by, beyond the required zip + market
 * Next ID: 3
 */
export type OdProtosSellerDashboardMetricsData_HistoricalMarketMetricsFiltersInput = {
  bathrooms?: InputMaybe<Scalars['String']>;
  bedrooms?: InputMaybe<Scalars['String']>;
};

/** Next ID: 3 */
export type OdProtosSellerDashboardMetricsServices_GetChangedListingsRequestInput = {
  /** required argument. if we cannot find data for that zip, we fall back to market */
  marketIdentifier?: InputMaybe<Scalars['String']>;
  /** zip of the neighborhood for which you want listings change data */
  zip?: InputMaybe<Scalars['String']>;
};

/** Next ID: 5 */
export type OdProtosSellerDashboardMetricsServices_GetClosedListingsRequestInput = {
  /** whether or not to only query for homes bought by opendoor */
  boughtByOpendoor?: InputMaybe<Scalars['Boolean']>;
  /** required argument. if we cannot find data for that zip, we fall back to market */
  marketIdentifier?: InputMaybe<Scalars['String']>;
  /** number of listings bought by opendoor; if this is specified, opendoor listings will be pushed to the front of results */
  numBoughtByOpendoor?: InputMaybe<Scalars['Float']>;
  /** how many closed listings to return */
  numListings?: InputMaybe<Scalars['Float']>;
  /** zip of the neighborhood for which you want new listings data */
  zip?: InputMaybe<Scalars['String']>;
};

/** Next ID: 3 */
export type OdProtosSellerDashboardMetricsServices_GetHistoricalHomeValuesRequestInput = {
  /** today's ballpark home valuation */
  currentHomeValuationCents?: InputMaybe<Scalars['Float']>;
  /** time frame of home values desired */
  monthsOfData?: InputMaybe<Scalars['Float']>;
  postalCode?: InputMaybe<Scalars['Float']>;
};

/** Next ID: 4 */
export type OdProtosSellerDashboardMetricsServices_GetHistoricalMarketMetricsRequestInput = {
  filters?: InputMaybe<OdProtosSellerDashboardMetricsData_HistoricalMarketMetricsFiltersInput>;
  numWeeks?: InputMaybe<Scalars['Float']>;
  zip?: InputMaybe<Scalars['String']>;
};

/** Next ID: 4 */
export type OdProtosSellerDashboardMetricsServices_GetHistoricalOffersRequestInput = {
  /** address token */
  addressUuid?: InputMaybe<Scalars['String']>;
  /** customer unique identifier */
  customerUuid?: InputMaybe<Scalars['String']>;
  /** months of data */
  monthsOfData?: InputMaybe<Scalars['Float']>;
};

/** Next ID: 2 */
export type OdProtosSellerDashboardMetricsServices_GetHomeEquityEstimateRequestInput = {
  addressToken?: InputMaybe<Scalars['String']>;
};

/** Next ID: 4 */
export type OdProtosSellerDashboardMetricsServices_GetHomeValuationRequestInput = {
  addressToken?: InputMaybe<Scalars['String']>;
  homeDetailId?: InputMaybe<Scalars['String']>;
  market?: InputMaybe<Scalars['String']>;
};

/** Next ID: 3 */
export type OdProtosSellerDashboardMetricsServices_GetListingsMetricsRequestInput = {
  /** required argument. if we cannot find data for that zip, we fall back to city */
  city?: InputMaybe<Scalars['String']>;
  /** Postal code of the neighborhood for which you want new listings data */
  postalCode?: InputMaybe<Scalars['String']>;
};

/** Next ID: 4 */
export type OdProtosSellerDashboardMetricsServices_GetMarketHomePriceAppreciationIncrementEnum =
  | 'DAILY'
  | 'MONTHLY'
  | 'TWICE_MONTHLY';

/** Next ID: 5 */
export type OdProtosSellerDashboardMetricsServices_GetMarketHomePriceAppreciationRequestInput = {
  endDate?: InputMaybe<OdProtosCommon_DateInput>;
  increment?: InputMaybe<OdProtosSellerDashboardMetricsServices_GetMarketHomePriceAppreciationIncrementEnum>;
  marketIdentifier?: InputMaybe<Array<Scalars['String']>>;
  startDate?: InputMaybe<OdProtosCommon_DateInput>;
};

/** Next ID: 2 */
export type OdProtosSellerDashboardMetricsServices_GetMarketMetricsRequestInput = {
  marketIdentifier?: InputMaybe<Scalars['String']>;
};

/** Next ID: 2 */
export type OdProtosSellerDashboardMetricsServices_GetMlsPhotosRequestInput = {
  addressToken?: InputMaybe<Scalars['String']>;
};

/** Next ID: 6 */
export type OdProtosSellerDashboardMetricsServices_GetNewListingsRequestInput = {
  /** whether or not to only query for homes listed by opendoor */
  listedByOpendoor?: InputMaybe<Scalars['Boolean']>;
  /** required argument. if we cannot find data for that zip, we fall back to market */
  marketIdentifier?: InputMaybe<Scalars['String']>;
  numListedByOpendoor?: InputMaybe<Scalars['Float']>;
  /** how many listings to return */
  numListings?: InputMaybe<Scalars['Float']>;
  /** zip of the neighborhood for which you want new listings data */
  zip?: InputMaybe<Scalars['String']>;
};

/** Next ID: 2 */
export type OdProtosSellerDashboardMetricsServices_GetNonOwnerOccupiedAddressesRequestInput = {
  addressToken?: InputMaybe<Scalars['String']>;
};

/** Next ID: 3 */
export type OdProtosSellerDashboardMetricsServices_GetOffMarketListingsRequestInput = {
  /** required argument. if we cannot find data for that zip, we fall back to market */
  marketIdentifier?: InputMaybe<Scalars['String']>;
  /** zip of the neighborhood for which you want off market listings data */
  zip?: InputMaybe<Scalars['String']>;
};

/** Next ID: 2 */
export type OdProtosSellerDashboardMetricsServices_GetSalePricePredictionRequestInput = {
  /** address token for */
  addressToken?: InputMaybe<Scalars['String']>;
};

/** Next ID: 3 */
export type OdProtosServiceRegistry_DbSyncTransform_ObfuscateColumns_ObfuscateColumn_Type =
  /**
   * TODO: Deterministically generate fakes from actual values so that
   * columns are comparable.
   *
   * Generates fake emails
   */
  | 'EMAIL'
  /** SHA256 of column contents */
  | 'HASH'
  /** Set column to NULL */
  | 'NULL'
  /** Generates fake phone numbers */
  | 'PHONE'
  | 'UNKNOWN';

/** Next ID: 2 */
export type OdProtosServiceRegistry_GetOrganizationRequestInput = {
  key?: InputMaybe<Scalars['String']>;
};

/** Next ID: 2 */
export type OdProtosServiceRegistry_GetServiceRequestInput = {
  key?: InputMaybe<Scalars['String']>;
};

/** Next ID: 2 */
export type OdProtosServiceRegistry_GetTeamRequestInput = {
  key?: InputMaybe<Scalars['String']>;
};

/** Next ID: 1 */
export type OdProtosServiceRegistry_ListOrganizationsRequestInput = {
  _empty?: InputMaybe<Scalars['Boolean']>;
};

/** Next ID: 1 */
export type OdProtosServiceRegistry_ListServicesRequestInput = {
  _empty?: InputMaybe<Scalars['Boolean']>;
};

/** Next ID: 1 */
export type OdProtosServiceRegistry_ListTeamsRequestInput = {
  _empty?: InputMaybe<Scalars['Boolean']>;
};

export type OdProtosServiceRegistry_Service_Type =
  | 'LIBRARY'
  | 'SERVICE'
  | 'UNKNOWN';

/**
 * UtilityType is an enum that represents the possible types of utilities
 * or services that can be set up within a home.
 *
 * Next ID: 6
 */
export type OdProtosServicehubData_UtilityTask_UtilityType =
  | 'ELECTRIC'
  | 'GAS'
  | 'SEWAGE'
  | 'TRASH'
  | 'UNKNOWN_TYPE'
  | 'WATER';

export type OdProtosServicehubServices_SfSyncRequest_GetUtilityStatusesByAddressInput = {
  city?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  street?: InputMaybe<Scalars['String']>;
};

export type OdProtosServicehubServices_SfSyncRequest_GetUtilityStatusesByFlipTokenInput = {
  flipToken?: InputMaybe<Scalars['String']>;
};

/** Next ID: 2 */
export type OdProtosServicehubServices_SyncCommunication_RequestInput = {
  /** ID of the communication */
  comradsId?: InputMaybe<Scalars['String']>;
};

/** Next ID: 2 */
export type OdProtosServicehubServices_SyncCustardContact_RequestInput = {
  /** ID of the Contact */
  contactId?: InputMaybe<Scalars['String']>;
};

/** Next ID: 2 */
export type OdProtosServicehubServices_SyncElementsUtilityContext_RequestInput = {
  /** ID of the context */
  contextId?: InputMaybe<Scalars['String']>;
};

/** Next ID: 2 */
export type OdProtosServicehubServices_SyncElementsUtilityTask_RequestInput = {
  /** ID of the task */
  taskId?: InputMaybe<Scalars['String']>;
};

/** Next ID: 2 */
export type OdProtosServicehubServices_SyncProperty_RequestInput = {
  /** AddressToken of the property */
  addressToken?: InputMaybe<Scalars['String']>;
};

/** Next ID: 2 */
export type OdProtosServicehubServices_SyncWebLeadRoles_RequestInput = {
  /** ID of the lead */
  leadId?: InputMaybe<Scalars['String']>;
  rolesToSync?: InputMaybe<Array<OdProtosServicehubServices_SyncWebLeadRoles_Role>>;
};

/**
 * These roles only have meaning as they relate to web's view of participants.
 * We maintain no guarantees how they will map to roles maintained within servicehub
 */
export type OdProtosServicehubServices_SyncWebLeadRoles_Role =
  | 'ACQ_AE'
  | 'INVALID_ROLE';

/** Next ID: 2 */
export type OdProtosServicehubServices_SyncWebLead_RequestInput = {
  /** ID of the Lead */
  leadId?: InputMaybe<Scalars['String']>;
};

/** Next ID: 2 */
export type OdProtosServicehubServices_SyncWebNote_RequestInput = {
  /** ID of the note */
  noteId?: InputMaybe<Scalars['String']>;
};

/** Next ID: 2 */
export type OdProtosServicehubServices_SyncWebOffer_RequestInput = {
  /** Web ID of the Offer */
  offerId?: InputMaybe<Scalars['String']>;
};

/**
 * Represents an Agent (either Buyers or Sellers)
 * Next ID: 3
 */
export type OdProtosSettlerData_AgentInput = {
  /** Commission rate as a percentage (e.g. 70 not 0.7) */
  commissionPercent?: InputMaybe<Scalars['Float']>;
  /** Contact details of the Agent */
  individual?: InputMaybe<OdProtosSettlerData_IndividualInput>;
};

/** List of the supported coordinator types */
export type OdProtosSettlerData_Coordinator_Type =
  | 'CLOSER'
  | 'PRECLOSER'
  | 'UNKNOWN';

/**
 * Represents a corporation that is transacting on a property
 * Next ID: 6
 */
export type OdProtosSettlerData_CorporationInput = {
  /** Contact details for this Corporation */
  contactEmail?: InputMaybe<Scalars['String']>;
  contactPhone?: InputMaybe<Scalars['String']>;
  /** Corporation identifier: Web uses customer uuid to represent institutional participants */
  customerUuid?: InputMaybe<Scalars['String']>;
  isOpendoor?: InputMaybe<Scalars['Boolean']>;
  /** Mailing Address */
  mailingAddress?: InputMaybe<OdProtosCommon_MailingAddressInput>;
  /** Name of the corporation */
  name?: InputMaybe<Scalars['String']>;
  /** Corporation identifier: Clearinghouse uses organization uuids to represent institutional participants */
  organizationUuid?: InputMaybe<Scalars['String']>;
};

/**
 * Legal document associated with a transaction.
 *
 * Next ID: 4
 */
export type OdProtosSettlerData_DocumentInput = {
  /**
   * Where the document originated from. Contains metadata about the originators
   * document.
   */
  source?: InputMaybe<OdProtosSettlerData_DocumentSourceInput>;
  /** Where the document is stored. */
  storage?: InputMaybe<OdProtosSettlerData_DocumentStorageInput>;
  /** The type of the document. */
  type?: InputMaybe<OdProtosSettlerData_Document_Type>;
  /**
   * UUID identifier for the document. This identifier may be used to filter which
   * documents are synced with our title partners if we think the same document
   * has already been synced.
   */
  uuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosSettlerData_DocumentSourceInput = {
  /** Originators document ID. For example, Resware's DocumentID, or Web's document_uuid. */
  id?: InputMaybe<Scalars['String']>;
  /** The document source type is where the document originated from. */
  type?: InputMaybe<OdProtosSettlerData_DocumentSource_Type>;
};

export type OdProtosSettlerData_DocumentSource_Type =
  | 'CLEARINGHOUSE'
  | 'OLA'
  | 'REITHOUSE'
  | 'RESWARE'
  | 'SPRUCE'
  | 'UNKNOWN'
  | 'WEB';

export type OdProtosSettlerData_DocumentStorageInput = {
  /**
   * Document storage ID. It could be a document s3 key in the case of web, or a
   * cabinet uuid.
   */
  id?: InputMaybe<Scalars['String']>;
  /** Where the document file is stored. */
  type?: InputMaybe<OdProtosSettlerData_DocumentStorage_Type>;
};

export type OdProtosSettlerData_DocumentStorage_Type =
  | 'CABINET'
  | 'UNKNOWN'
  | 'WEB';

/**
 * List of all possible document types that Settler needs for title and escrow.
 *
 * Next ID: 56
 */
export type OdProtosSettlerData_Document_Type =
  /** Affiliated business arrangement disclosure */
  | 'ABAD'
  | 'ADDENDUM'
  | 'ADDENDUM_RESALE'
  | 'AGENT_REFERRAL_FORM'
  | 'AGENT_REFERRAL_W9'
  | 'AGREED_SETTLEMENT_STATEMENT'
  | 'BRN_CREDIT_ADDENDUM'
  | 'BUYER_BORROWER_CLOSING_DOCS_UNSIGNED_MERGED'
  | 'BUYER_CLOSING_DOCS'
  | 'CANCELLATION'
  | 'CCR'
  | 'CHECKLIST_HOA_SOU'
  | 'CIC_RECEIPT'
  | 'CLOSING_STATEMENT_FOR_APPROVAL'
  | 'COMBINED_PURCHASE_AGREEMENT_AND_REPAIR_ADDENDUM'
  | 'COMMISSION_INSTRUCTIONS'
  | 'COUNTER_OFFER'
  | 'DEED'
  | 'EARNEST_MONEY_RECEIPT'
  | 'FINAL_REPAIR_ASK'
  | 'FINAL_SETTLEMENT_STATEMENT'
  /** Homeowner's association addendum */
  | 'HOA_ADDENDUM'
  | 'HOA_BUYER_APPROVAL'
  | 'HOA_CCRS'
  | 'HOA_DEMAND'
  | 'HOA_DEMAND_SUB'
  | 'HOA_ESTOPPEL_LETTER_UPDATED'
  /** List of HOA Fees, etc */
  | 'HOA_PACKAGE'
  | 'HOA_STATUS_LETTER'
  | 'HOA_VIOLATION_RESOLUTION'
  /** Same thing as Closing Statement but on an official govt doc */
  | 'HUD'
  | 'INSPECTION_REPORT'
  | 'LAND_SURVEY'
  /** Lead based paint addendum */
  | 'LBP_ADDENDUM'
  | 'LCO_ADDENDUM'
  | 'LIEN_SEARCH'
  | 'MARKED_COMMITMENT'
  /** https://opendoor.atlassian.net/browse/TITLE-52 */
  | 'NATURAL_HAZARD_DISCLOSURE'
  /** Never synced to Web */
  | 'OD_FINAL_FEES'
  | 'OPENDOOR_ADDENDUM'
  /** ENGBUGS-15350 - Outbound addednum is a repair ask on aquisition */
  | 'OUTBOUND_ADDENDUM'
  | 'OWNERS_POLICY'
  | 'PRELIM_EXECUTED_CLOSING_DOCS'
  | 'PREPARED_DEED'
  | 'PURCHASE_CONTRACT'
  | 'RESALE_COMMISSION_INSTRUCTIONS'
  | 'SELLER_CLOSING_DOCS_UNSIGNED_MERGED'
  | 'SELLER_SIGNED_CLOSING_DOCS'
  | 'SOLAR_INFORMATION'
  | 'T47_RESIDENTIAL_REAL_PROPERTY_AFFIDAVIT'
  | 'TAX_CERTIFICATE'
  | 'TITLE_COMMITMENT'
  | 'TRANSFER_ADDENDUM'
  /** https://docs.google.com/document/d/1FyN-FsXLhWgqjd4uwj2K2c1Q_Nfhj13o_b_KFa5Ef_M/edit */
  | 'TRIAL_LISTING_AGREEMENT'
  | 'UCC_TERMINATION'
  | 'UNKNOWN';

export type OdProtosSettlerData_File_PartnerType =
  | 'EMAIL'
  | 'RESWARE'
  | 'UNKNOWN';

/** Indicates the state of the file in Escrow */
export type OdProtosSettlerData_File_State =
  | 'CANCELED'
  | 'CLOSED'
  | 'INITIAL'
  | 'OPENED';

/**
 * Represents an individual who is transacting with one of our properties
 * Next ID: 7
 */
export type OdProtosSettlerData_IndividualInput = {
  /** Contact details for this individual */
  contactEmail?: InputMaybe<Scalars['String']>;
  contactPhone?: InputMaybe<Scalars['String']>;
  /**
   * Pre and post close mailing addresses. Post close address is optional, and
   * will default to the pre close address if unset.
   */
  mailingAddress?: InputMaybe<OdProtosCommon_MailingAddressInput>;
  /** First and last name of the Individual */
  name?: InputMaybe<OdProtosCommon_NameInput>;
  postCloseMailingAddress?: InputMaybe<OdProtosCommon_MailingAddressInput>;
  preferredLanguageAlpha2?: InputMaybe<Scalars['String']>;
};

/**
 * Represents multiple individuals who act as a single entity
 * (e.g. married couple who both have their names on the deed)
 * Next ID: 4
 */
export type OdProtosSettlerData_IndividualPartnershipInput = {
  /** Contact details for this Partnership */
  contactEmail?: InputMaybe<Scalars['String']>;
  contactPhone?: InputMaybe<Scalars['String']>;
  /** List of individuals in this partnership */
  individuals?: InputMaybe<Array<OdProtosSettlerData_IndividualInput>>;
};

/**
 * Loans associated with a file
 * Next ID: 3
 */
export type OdProtosSettlerData_LoanInput = {
  loanAmountCents?: InputMaybe<Scalars['Float']>;
  /** Some unique identifier for a loan */
  loanNumber?: InputMaybe<Scalars['String']>;
};

/**
 * Milestone for a particular file. There are typically many milestones that are
 * updated over time as a particular file nears its close of escrow date.
 *
 * Next ID: 5
 */
export type OdProtosSettlerData_MilestoneInput = {
  /** File UUID that is the parent of this milestone. */
  fileUuid?: InputMaybe<Scalars['String']>;
  /**
   * MilestoneStatusLog is a list of statuses and dates, which represent the
   * progress made on a particular milestone.
   */
  log?: InputMaybe<Array<OdProtosSettlerData_MilestoneStatusLogInput>>;
  type?: InputMaybe<OdProtosSettlerData_Milestone_MilestoneType>;
};

export type OdProtosSettlerData_MilestoneStatusLogInput = {
  date?: InputMaybe<Scalars['DateTime']>;
  /**
   * A JSON representation of the metadata associated with a milestone. in  the future,
   * we should have this typed and deprecated this field, but for now we can transmit it as a
   * string.
   */
  jsonmetadata?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<OdProtosSettlerData_MilestoneStatusLog_MilestoneStatus>;
};

/**
 * List of all the possible milestone statuses
 *
 * Next ID: 6
 */
export type OdProtosSettlerData_MilestoneStatusLog_MilestoneStatus =
  | 'CURATIVE'
  | 'EXPIRED'
  | 'RECEIVED'
  | 'REQUESTED'
  | 'SENT'
  | 'UNKNOWN';

/**
 * List of all the possible milestone types
 *
 * Next ID: 13
 */
export type OdProtosSettlerData_Milestone_MilestoneType =
  | 'AGENT_COMMISSION_INSTRUCTIONS_SENT'
  | 'BALANCED_WITH_LENDER'
  /** When the buyer information is recevied in a Resale */
  | 'BUYER_INFORMATION'
  | 'BUYER_SELLER_DOCS_SENT'
  | 'CLEAR_TITLE'
  | 'COE_DATE_CHANGED'
  | 'CONGRATS_EMAIL_SENT'
  | 'EARNEST_MONEY_RECEIPT'
  | 'FILE_STATUS_UPDATED'
  | 'FUNDED'
  | 'HOA_PACKAGE'
  | 'PAYOFF'
  | 'PRELIMINARY_DOCS_UPLOADED'
  | 'PRELIMINARY_SETTLEMENT_STATEMENT_PREPARED'
  | 'PRELIM_TITLE_COMMITMENT'
  /** When the seller information is received in an Aquisition */
  | 'SELLER_INFORMATION'
  | 'SIGNING_APPOINTMENT_CONFIRMED'
  | 'SIGNING_APPOINTMENT_SCHEDULED'
  | 'TITLE_SEARCH'
  | 'UNKNOWN';

/**
 * ReswareHuman associates a resware employee ID
 * Next ID: 3
 */
export type OdProtosSettlerData_ReswareHumanInput = {
  reswareEmployeeIds?: InputMaybe<Array<Scalars['String']>>;
  userToken?: InputMaybe<Scalars['String']>;
};

/**
 * Represents someone who has been assigned a role on the file
 * E.g. Precloser (a.k.a Escrow Assistant)
 * Next ID: 5
 */
export type OdProtosSettlerData_RoleAssignmentInput = {
  email?: InputMaybe<Scalars['String']>;
  /** The employee_id in external title software. */
  externalEmployeeId?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  roleType?: InputMaybe<OdProtosSettlerData_RoleAssignment_Type>;
};

/** Next ID: 4 */
export type OdProtosSettlerData_RoleAssignment_Type =
  /** Closing Coordinator does back office functions */
  | 'CLOSING_COORDINATOR'
  /** Closing Manager is the customer's point of contact at Opendoor */
  | 'CLOSING_MANAGER'
  | 'PRECLOSER'
  | 'UNKNOWN';

/**
 * Status of a sync
 * NextID: 3
 */
export type OdProtosSettlerData_SyncStatus =
  /** Indicates that something failed (either sync or async) */
  | 'FAILURE'
  /**
   * Indicates that something has been queued up successfully and is
   * being asynchronously processed
   */
  | 'PENDING'
  /** Indicates that something was successful (either sync or async) */
  | 'SUCCESS'
  /** Indicates that a document was successfully emailed (not over API) */
  | 'UNCONFIRMED';

export type OdProtosSettlerEvents_RecordsTitleEscrowLifecycleEvent_TitleEscrowLifecycleEvent_EventSource =
  | 'SETTLER'
  | 'UNKNOWN'
  | 'WEB';

export type OdProtosSettlerEvents_RecordsTitleEscrowLifecycleEvent_TitleEscrowLifecycleEvent_Transaction_TransactionType =
  | 'ACQ'
  | 'BUYER'
  | 'CLEARINGHOUSE'
  | 'RSL'
  | 'UNKNOWN';

/**
 * Request for AddDocuments method
 * Next ID: 3
 */
export type OdProtosSettlerServices_AddDocumentsRequestInput = {
  documents?: InputMaybe<Array<OdProtosSettlerData_DocumentInput>>;
  fileUuid?: InputMaybe<Scalars['String']>;
};

/**
 * Request for CancelFile method
 * Next ID: 2
 */
export type OdProtosSettlerServices_CancelFileRequestInput = {
  uuid?: InputMaybe<Scalars['String']>;
};

/**
 * Request for CloseFile method
 * Next ID: 11
 */
export type OdProtosSettlerServices_CloseFileRequestInput = {
  fileUuid?: InputMaybe<Scalars['String']>;
};

/**
 * Request for CreateFile method
 * Next ID: 34
 */
export type OdProtosSettlerServices_CreateFileRequestInput = {
  /** Specifies partnership channel for the acquisition lead */
  acquisitionPartnership?: InputMaybe<Scalars['String']>;
  /** Address uuid for the relevant property */
  addressUuid?: InputMaybe<Scalars['String']>;
  /** The Buyer in this file */
  buyer?: InputMaybe<OdProtosSettlerServices_CreateFileRequest_BuyerOneofInput>;
  /** Buyers agent information */
  buyersAgent?: InputMaybe<OdProtosSettlerData_AgentInput>;
  /**
   * File number in the client. Intended for use by humans when referring
   * to this File. In Web this is the Flip Token
   */
  clientFileNumber?: InputMaybe<Scalars['String']>;
  closeOfEscrowDate?: InputMaybe<Scalars['DateTime']>;
  /**
   * consumer_reference and consumer_service_reference will uniquely identify this file
   * in the service that calls Settler. This allows us to make CreateFile
   * idempotent
   */
  consumerReference?: InputMaybe<Scalars['String']>;
  consumerServiceReference?: InputMaybe<Scalars['String']>;
  /**
   * List of various documents required to create a new file with our title
   * partner. The purchase contract document is required, other document types
   * are optional and can be later added with the AddDocument method.
   */
  documents?: InputMaybe<Array<OdProtosSettlerData_DocumentInput>>;
  /** The contact for the Escrow organization */
  escrowOrganizationContactUserToken?: InputMaybe<Scalars['String']>;
  /** The organization providing Escrow services */
  escrowOrganizationUuid?: InputMaybe<Scalars['String']>;
  /**
   * Optional identifiers if we have already created a title file with an external
   * title partner. If these fields are populated, Settler will simply create a
   * new internal record, but won't attempt to create a file externally.
   */
  externalFileId?: InputMaybe<Scalars['String']>;
  externalFileNumber?: InputMaybe<Scalars['String']>;
  /** Specifies if the property was acquired */
  isAcquired?: InputMaybe<Scalars['Boolean']>;
  /** Specifies if the transaction is a mainstay (True) or opendoor (False) transaction */
  isMainstayTransaction?: InputMaybe<Scalars['Boolean']>;
  /** Unified Lender object to replace org objects above. */
  lenderUuid?: InputMaybe<Scalars['String']>;
  /** If channel = exclusive, we will use a different product type. */
  listingOfferChannel?: InputMaybe<Scalars['String']>;
  /** Any relevant Loans taken by the Buyer. Optional. */
  loans?: InputMaybe<Array<OdProtosSettlerData_LoanInput>>;
  /**
   * APN (assessor's parcel number) for this property.
   * Required by 3rd Party Title/Escrow Software
   */
  propertyApn?: InputMaybe<Scalars['String']>;
  /** The contact for the brokerage that is asking Escrow to open a file */
  requestingOrganizationContactUserToken?: InputMaybe<Scalars['String']>;
  /** The organization that is requesting Escrow open a file */
  requestingOrganizationUuid?: InputMaybe<Scalars['String']>;
  /** External employees that should be assigned to this File. Optional. */
  roleAssignments?: InputMaybe<Array<OdProtosSettlerData_RoleAssignmentInput>>;
  /** The price the property will sell for */
  salesPriceCents?: InputMaybe<Scalars['Float']>;
  /** The Seller in this file */
  seller?: InputMaybe<OdProtosSettlerServices_CreateFileRequest_SellerOneofInput>;
  /** Sellers agent information */
  sellersAgent?: InputMaybe<OdProtosSettlerData_AgentInput>;
};

export type OdProtosSettlerServices_CreateFileRequest_BuyerOneofInput = {
  buyerCorporation?: InputMaybe<OdProtosSettlerData_CorporationInput>;
  buyerIndividual?: InputMaybe<OdProtosSettlerData_IndividualInput>;
  buyerPartnership?: InputMaybe<OdProtosSettlerData_IndividualPartnershipInput>;
};

export type OdProtosSettlerServices_CreateFileRequest_SellerOneofInput = {
  sellerCorporation?: InputMaybe<OdProtosSettlerData_CorporationInput>;
  sellerIndividual?: InputMaybe<OdProtosSettlerData_IndividualInput>;
  sellerPartnership?: InputMaybe<OdProtosSettlerData_IndividualPartnershipInput>;
};

export type OdProtosSettlerServices_CreateMilestoneRequestInput = {
  milestone?: InputMaybe<OdProtosSettlerData_MilestoneInput>;
};

export type OdProtosSettlerServices_GetCoordinatorsRequestInput = {
  fileUuid?: InputMaybe<Scalars['String']>;
};

/**
 * Request for GetFile method
 * Next ID: 2
 */
export type OdProtosSettlerServices_GetFileRequestInput = {
  uuid?: InputMaybe<Scalars['String']>;
};

/**
 * Request for GetMilestones rpc
 * Next ID: 2
 */
export type OdProtosSettlerServices_GetMilestonesRequestInput = {
  fileUuid?: InputMaybe<Scalars['String']>;
};

/**
 * Title members that can handle a particular region
 * and a particular type of offer
 *
 * Next ID: 3
 */
export type OdProtosSettlerServices_GetTitleMembersRequestInput = {
  addressUuid?: InputMaybe<Scalars['String']>;
  titleMemberFilter?: InputMaybe<OdProtosSettlerServices_GetTitleMembersRequest_TitleMemberFilter>;
};

/** Next ID: 3 */
export type OdProtosSettlerServices_GetTitleMembersRequest_TitleMemberFilter =
  | 'ACQUISITION'
  | 'RESALE'
  | 'UNKNOWN';

export type OdProtosSettlerServices_ListCoordinatorsForFilesRequestInput = {
  params?: InputMaybe<OdProtosSettlerServices_ListCoordinatorsForFilesRequest_ParamsOneofInput>;
};

export type OdProtosSettlerServices_ListCoordinatorsForFilesRequest_ParamsOneofInput = {
  search?: InputMaybe<OdProtosSettlerServices_ListCoordinatorsForFilesRequest_SearchInput>;
};

export type OdProtosSettlerServices_ListCoordinatorsForFilesRequest_SearchInput = {
  fileCreatedAtFrom?: InputMaybe<Scalars['DateTime']>;
  fileCreatedAtTo?: InputMaybe<Scalars['DateTime']>;
};

/**
 * Request for ListDocumentsSyncs rpc
 * Next ID: 2
 */
export type OdProtosSettlerServices_ListDocumentSyncsRequestInput = {
  fileUuid?: InputMaybe<Scalars['String']>;
};

/**
 * Request for ListDocuments rpc
 * Next ID: 2
 */
export type OdProtosSettlerServices_ListDocumentsRequestInput = {
  fileUuid?: InputMaybe<Scalars['String']>;
};

/**
 * Request for ListFiles method
 * Next ID: 2
 */
export type OdProtosSettlerServices_ListFilesRequestInput = {
  externalfilenumbers?: InputMaybe<Array<Scalars['String']>>;
  uuids?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosSettlerServices_ListReswareHumansRequestInput = {
  reswareEmployeeIds?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosSettlerServices_UpdateFileParticipantsRequestInput = {
  /** The Buyer in this file */
  buyer?: InputMaybe<OdProtosSettlerServices_UpdateFileParticipantsRequest_BuyerOneofInput>;
  /** Buyers agent information */
  buyersAgent?: InputMaybe<OdProtosSettlerData_AgentInput>;
  fileUuid?: InputMaybe<Scalars['String']>;
  /** The Seller in this file */
  seller?: InputMaybe<OdProtosSettlerServices_UpdateFileParticipantsRequest_SellerOneofInput>;
  /** Sellers agent information */
  sellersAgent?: InputMaybe<OdProtosSettlerData_AgentInput>;
};

export type OdProtosSettlerServices_UpdateFileParticipantsRequest_BuyerOneofInput = {
  buyerCorporation?: InputMaybe<OdProtosSettlerData_CorporationInput>;
  buyerIndividual?: InputMaybe<OdProtosSettlerData_IndividualInput>;
  buyerPartnership?: InputMaybe<OdProtosSettlerData_IndividualPartnershipInput>;
};

export type OdProtosSettlerServices_UpdateFileParticipantsRequest_SellerOneofInput = {
  sellerCorporation?: InputMaybe<OdProtosSettlerData_CorporationInput>;
  sellerIndividual?: InputMaybe<OdProtosSettlerData_IndividualInput>;
  sellerPartnership?: InputMaybe<OdProtosSettlerData_IndividualPartnershipInput>;
};

/**
 * Request for UpdateFile method
 * Next ID: 3
 */
export type OdProtosSettlerServices_UpdateFileRequestInput = {
  externalFileNumber?: InputMaybe<Scalars['String']>;
  uuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosSettlerServices_UpdateFileTitlePrecloserRequestInput = {
  /** The contact for the Escrow organization */
  escrowOrganizationContactUserToken?: InputMaybe<Scalars['String']>;
  /** The role assignment information for the new contact */
  roleAssignment?: InputMaybe<OdProtosSettlerData_RoleAssignmentInput>;
  uuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosSettlerServices_UpdateReswareHumanRequestInput = {
  reswareHuman?: InputMaybe<OdProtosSettlerData_ReswareHumanInput>;
};

export type OdProtosSignalsData_BackYardConditionMessage_BackYardCondition =
  | 'FULLY_LANDSCAPED'
  | 'NEEDS_WORK'
  | 'NO_YARD'
  | 'PARTIALLY_LANDSCAPED'
  | 'UNKNOWN';

/** comps specified to be used in NNOVM */
export type OdProtosSignalsData_CompInput = {
  /** comps address token */
  addressToken?: InputMaybe<Scalars['String']>;
  /**
   * sometimes Surveyor has multiple comps per address token
   * this serves to uniquely identify a comp within the request when filled in
   */
  compNumber?: InputMaybe<Scalars['Int']>;
  fListingStatus?: InputMaybe<Scalars['String']>;
  listPrice?: InputMaybe<Scalars['Float']>;
  overlay?: InputMaybe<OdProtosSignalsData_OverlayInput>;
};

export type OdProtosSignalsData_ConditionMessage_Condition =
  | 'GREAT_CONDITION'
  | 'NEEDS_WORK'
  | 'TYPICAL_USE'
  | 'UNKNOWN';

/** Fractional home condition score */
export type OdProtosSignalsData_ConditionScoreInput = {
  score?: InputMaybe<Scalars['Float']>;
};

export type OdProtosSignalsData_DwellingTypeMessage_DwellingType =
  | 'APARTMENT'
  | 'HALF_DUPLEX'
  | 'MANUFACTURED_HOME'
  | 'MOBILE_HOME'
  | 'PATIO'
  | 'SINGLE_FAMILY'
  | 'TOWNHOUSE'
  | 'UNKNOWN';

export type OdProtosSignalsData_FloorConditionMessage_FloorCondition =
  | 'GREAT_CONDITION'
  | 'HEAVILY_WORN'
  | 'TYPICAL_USE'
  | 'UNKNOWN';

export type OdProtosSignalsData_FloorTypeMessage_FloorType =
  | 'CARPET'
  | 'HARDWOOD'
  | 'LAMINATE'
  | 'LINOLEUM'
  | 'OTHER'
  | 'TILE'
  | 'UNKNOWN'
  | 'VINYL'
  | 'VINYL_PLANK';

export type OdProtosSignalsData_KitchenApplianceTypeMessage_KitchenApplianceType =
  | 'BLACK'
  | 'MIXED'
  | 'OTHER'
  | 'STAINLESS_STEEL'
  | 'UNKNOWN'
  | 'WHITE';

export type OdProtosSignalsData_KitchenCounterTopMessage_KitchenCounterTop =
  | 'CORIAN'
  | 'FORMICA'
  | 'GRANITE'
  | 'GRANITE_SLAB'
  | 'GRANITE_TILE'
  | 'MARBLE'
  | 'OTHER'
  | 'OTHER_TILE'
  | 'QUARTZ'
  | 'TILE'
  | 'UNKNOWN';

/** acceptable model name for nnovm */
export type OdProtosSignalsData_ModelName =
  | 'HYBRIDOVM'
  | 'LIGHTNING'
  | 'UNKNOWN';

/**
 * home detail overlay fields and value options copied from
 * https://github.com/opendoor-labs/signals/blob/01689bbb/signals/api/constants.py#L3
 * and https://github.com/opendoor-labs/renaissance/blob/42d304b4/renaissance/nn_ovm/model_serving/constants.py#L6
 * but ignore some that don't get interpreated in renaissance.
 */
export type OdProtosSignalsData_OverlayInput = {
  aboveGradeSqFt?: InputMaybe<Scalars['Float']>;
  backYardCondition?: InputMaybe<OdProtosSignalsData_BackYardConditionMessage_BackYardCondition>;
  backYardRetainingWall?: InputMaybe<Scalars['String']>;
  backYardSlope?: InputMaybe<Scalars['String']>;
  backYardSlopeType?: InputMaybe<Scalars['String']>;
  basementFinishedSqFt?: InputMaybe<Scalars['Float']>;
  basementUnfinishedSqFt?: InputMaybe<Scalars['Float']>;
  bathroomCondition?: InputMaybe<OdProtosSignalsData_ConditionMessage_Condition>;
  bathroomConditionScore?: InputMaybe<OdProtosSignalsData_ConditionScoreInput>;
  bathroomsFull?: InputMaybe<Scalars['Int']>;
  bathroomsHalf?: InputMaybe<Scalars['Int']>;
  bedrooms?: InputMaybe<Scalars['Int']>;
  busyRoadTypeArterialConnectorStrength?: InputMaybe<Scalars['Float']>;
  carportSpaces?: InputMaybe<Scalars['Int']>;
  dwellingType?: InputMaybe<OdProtosSignalsData_DwellingTypeMessage_DwellingType>;
  exteriorConditionScore?: InputMaybe<OdProtosSignalsData_ConditionScoreInput>;
  exteriorStories?: InputMaybe<Scalars['Int']>;
  floorCondition?: InputMaybe<OdProtosSignalsData_FloorConditionMessage_FloorCondition>;
  garageSpaces?: InputMaybe<Scalars['Int']>;
  hasRenovation?: InputMaybe<Scalars['Boolean']>;
  interiorConditionScore?: InputMaybe<OdProtosSignalsData_ConditionScoreInput>;
  isAgeRestrictedCommunity?: InputMaybe<Scalars['Boolean']>;
  isGatedCommunity?: InputMaybe<Scalars['Boolean']>;
  kitchenApplianceType?: InputMaybe<OdProtosSignalsData_KitchenApplianceTypeMessage_KitchenApplianceType>;
  kitchenCondition?: InputMaybe<OdProtosSignalsData_ConditionMessage_Condition>;
  kitchenConditionScore?: InputMaybe<OdProtosSignalsData_ConditionScoreInput>;
  kitchenCountertop?: InputMaybe<OdProtosSignalsData_KitchenCounterTopMessage_KitchenCounterTop>;
  lotSqFt?: InputMaybe<Scalars['Float']>;
  paintCondition?: InputMaybe<OdProtosSignalsData_ConditionMessage_Condition>;
  pool?: InputMaybe<Scalars['Boolean']>;
  primaryFloorCondition?: InputMaybe<OdProtosSignalsData_FloorConditionMessage_FloorCondition>;
  primaryFloorType?: InputMaybe<OdProtosSignalsData_FloorTypeMessage_FloorType>;
  propertyConditionScore?: InputMaybe<OdProtosSignalsData_ConditionScoreInput>;
  renovationAmount?: InputMaybe<Scalars['Int']>;
  secondaryFloorCondition?: InputMaybe<OdProtosSignalsData_FloorConditionMessage_FloorCondition>;
  secondaryFloorType?: InputMaybe<OdProtosSignalsData_FloorTypeMessage_FloorType>;
  slopedBackYardStrength?: InputMaybe<Scalars['Float']>;
  sqFtDiscrepancy?: InputMaybe<Scalars['Float']>;
  totalFinishedSqFt?: InputMaybe<Scalars['Float']>;
  viewsStrength?: InputMaybe<Scalars['Float']>;
  yearBuilt?: InputMaybe<Scalars['Int']>;
};

export type OdProtosSignalsData_RequestIdInput = {
  value?: InputMaybe<Scalars['String']>;
};

export type OdProtosSignalsData_RequestorIdInput = {
  value?: InputMaybe<Scalars['String']>;
};

export type OdProtosSignalsData_SubjectInput = {
  addressToken?: InputMaybe<Scalars['String']>;
  overlay?: InputMaybe<OdProtosSignalsData_OverlayInput>;
};

export type OdProtosSignalsServices_FeatureCategory_Category =
  | 'ABOVE_GRADE_SQFT'
  | 'AS_IS_SALE'
  | 'BASEMENT_FIN_SQFT'
  | 'BASEMENT_UNFIN_SQFT'
  | 'BATHROOMS'
  | 'BEDROOMS'
  | 'CARPORT_SPACES'
  | 'CONSTRUCTION_BRICK'
  | 'CUL_DE_SAC'
  | 'DRIVEWAY_TYPE'
  | 'DWELLING_STYLE'
  | 'DWELLING_TYPE'
  | 'FLOORING'
  | 'GARAGE_SPACES'
  | 'GRANITE'
  | 'HAS_FIREPLACE'
  | 'HAS_PREV_DELISTING'
  | 'HAS_RESORT_STYLE'
  | 'HAS_SPA'
  | 'HAS_UPGRADES'
  | 'HOA'
  | 'INTERIOR_NEEDS_REPAIR'
  | 'IS_BUSY_ROAD'
  | 'IS_CASH_ONLY'
  | 'IS_GOLF_LOT'
  | 'IS_LAKE_LOT'
  | 'IS_PARK_LOT'
  | 'IS_RECENT_BUILD'
  | 'KITCHEN_ISLAND'
  | 'LOT_SQFT'
  | 'MOTIVATED_SELLER'
  | 'NEARBY_ROADS'
  | 'NEW_CONSTRUCTION'
  | 'NICE_BACKYARD'
  | 'NICE_CURB_APPEAL'
  | 'POOL'
  | 'PREV_DELISTED_DOM_MONTH_WEIGHTED'
  | 'RESTB_SCORES'
  | 'SELLER_CONCESSIONS'
  | 'SLC_AGE_RESTRICTED'
  | 'SLC_AGE_RESTRICTED_DEPRECATED'
  | 'SLC_AUCTION'
  | 'SLC_COURT_APPROVAL_REQ'
  | 'SLC_EXCLUSIONS'
  | 'SLC_GATED_COMMUNITY'
  | 'SLC_HUD_OWNED'
  | 'SLC_LENDER_APPROVED_SHORT_SALE'
  | 'SLC_LENDER_OWNED_REO'
  | 'SLC_OWNER_AGENT'
  | 'SLC_OWNER_OCCUPANCY_REQ'
  | 'SLC_PREV_APPROVED_SHORT_SALE'
  | 'SLC_PRE_FORECLOSURE'
  | 'SLC_PROBATE_ESTATE'
  | 'SLC_RELO_CORP_APPROVAL_REQ'
  | 'SLC_SHORT_SALE_APPROVAL_REQ'
  | 'SLC_SPECIAL_SALE'
  | 'SPECIAL_LISTING'
  | 'STAINLESS_STEEL'
  | 'STORIES'
  | 'TOTAL_FINISHED_SQFTBAD_INTERIOR_QUALITY'
  | 'UNKNOWN'
  | 'YEAR_BUILT';

export type OdProtosSignalsServices_FetchCompsAvailabilityRequestInput = {
  /**
   * The Asof date. For a historical valuation, comps beyond this date is not usable; for regular valuations,
   * it's the time when the request is made
   */
  asofDate?: InputMaybe<Scalars['DateTime']>;
  /** Comps with their address tokens and home detail overlay */
  comps?: InputMaybe<Array<OdProtosSignalsData_CompInput>>;
  /** suggest a specific OVM version to use, default is current production if none specified */
  featureFlags?: InputMaybe<Array<Scalars['String']>>;
  market?: InputMaybe<OdProtosCommonMarket_Market>;
  requestId?: InputMaybe<OdProtosSignalsData_RequestIdInput>;
  requestorId?: InputMaybe<OdProtosSignalsData_RequestorIdInput>;
  /** Subject address token and home details overlay */
  subject?: InputMaybe<OdProtosSignalsData_SubjectInput>;
};

export type OdProtosSignalsServices_FetchHpiRequestInput = {
  addressToken?: InputMaybe<Scalars['String']>;
  /** Whether allow the timeseries to be partial (allow missing certain time point value). */
  allowPartial?: InputMaybe<Scalars['Boolean']>;
  /** end as timestamp */
  end?: InputMaybe<Scalars['Float']>;
  /** end date of hpi series */
  endDate?: InputMaybe<OdProtosCommon_DateInput>;
  /** Whether to return the full timeseries or just the value at [start, end]. */
  fullTimeseries?: InputMaybe<Scalars['Boolean']>;
  postalCode?: InputMaybe<Scalars['String']>;
  /** metadata */
  requestId?: InputMaybe<OdProtosSignalsData_RequestIdInput>;
  requestorId?: InputMaybe<OdProtosSignalsData_RequestorIdInput>;
  /** start as timestamp */
  start?: InputMaybe<Scalars['Float']>;
  /** start date of hpi series */
  startDate?: InputMaybe<OdProtosCommon_DateInput>;
};

export type OdProtosSignalsServices_FetchHybridOvmLineItemAdjustmentsRequestInput = {
  /**
   * The Asof date. For a historical valuation, comps beyond this date is not usable; for regular valuations,
   * it's the time when the request is made
   */
  asofDate?: InputMaybe<Scalars['DateTime']>;
  /** Comps with their address tokens and home detail overlay */
  manualOverrideComps?: InputMaybe<Array<OdProtosSignalsData_CompInput>>;
  market?: InputMaybe<OdProtosCommonMarket_Market>;
  /** This is for logging purpose, use "HybridOVM" */
  model?: InputMaybe<OdProtosSignalsData_ModelName>;
  requestId?: InputMaybe<OdProtosSignalsData_RequestIdInput>;
  requestorId?: InputMaybe<OdProtosSignalsData_RequestorIdInput>;
  subject?: InputMaybe<OdProtosSignalsData_SubjectInput>;
};

export type OdProtosSignalsServices_InputCategory_Category =
  | 'NON_SURVEYOR_INPUT'
  | 'SURVEYOR_INPUT'
  | 'UNKNOWN';

export type OdProtosSignalsServices_UnusableReasonCategoryMessage_UnusableReasonCategory =
  | 'COMP_NOT_IN_SERVING_TABLE_OR_IN_DIFFERENT_MLS_FROM_SUBJECT'
  | 'HOME_DETAILS_FILTERED'
  | 'OTHER'
  | 'SPECIAL_SALE'
  | 'STALE_LISTING_IN_OVM'
  | 'UNKNOWN'
  | 'UNUSABLE_LISTING_STATUS';

export type OdProtosSupportData_AgentVerificationStatus =
  | 'AGENT_VERIFICATION_DENIED'
  | 'AGENT_VERIFICATION_FULLY_VERIFIED'
  | 'AGENT_VERIFICATION_REQUIRES_VERIFICATION'
  | 'AGENT_VERIFICATION_UNKNOWN'
  | 'AGENT_VERIFICATION_VERIFIED';

export type OdProtosSupportData_AssessmentFailureInformationInput = {
  reasonForCancellation?: InputMaybe<Scalars['String']>;
};

export type OdProtosSupportData_AssociatedRecordInput = {
  id?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

export type OdProtosSupportData_BrokerRejectionOfDocumentInformationInput = {
  documentRejectionReason?: InputMaybe<Scalars['String']>;
  documentType?: InputMaybe<OdProtosSupportData_DocumentType>;
};

export type OdProtosSupportData_ContractChangeInformationInput = {
  currentUgm?: InputMaybe<Scalars['Float']>;
  feeCostCents?: InputMaybe<Scalars['Float']>;
  impliedUgm?: InputMaybe<Scalars['Float']>;
  internalFeeCostCents?: InputMaybe<Scalars['Float']>;
  maximumSubsidyCents?: InputMaybe<Scalars['Int']>;
  partnershipTypes?: InputMaybe<Array<OdProtosSupportData_PartnershipType>>;
  purchaseAgreementCompletedDate?: InputMaybe<Scalars['DateTime']>;
  requestSubsidyTypes?: InputMaybe<Array<OdProtosWebData_SubsidyType>>;
  subsidyAmountCents?: InputMaybe<Scalars['Float']>;
  totalRepairCostCents?: InputMaybe<Scalars['Int']>;
};

export type OdProtosSupportData_CustomerType =
  | 'CUSTOMER_TYPE_AGENT'
  | 'CUSTOMER_TYPE_APPRAISER'
  | 'CUSTOMER_TYPE_DIRECT_CUSTOMER'
  | 'CUSTOMER_TYPE_INSPECTOR';

export type OdProtosSupportData_DocumentType =
  | 'ABAD'
  | 'CLOSING_DOCS'
  | 'EARNEST_MONEY_RECEIPT'
  | 'FINAL_SETTLEMENT_STATEMENT'
  | 'OD_ADDENDUM'
  | 'PURCHASE_AGREEMENT'
  | 'TAX_CERTIFICATE'
  | 'TITLE_COMMITMENT';

export type OdProtosSupportData_EscalationType =
  | 'FINAL_OFFER_STATUS'
  | 'OTHER_ESCALATION_REASON'
  | 'REPAIR_LINE_ITEM_REVIEW'
  /** deprecated in favor of REPAIR_LINE_ITEM_REVIEW */
  | 'REPAIR_REVIEW'
  | 'SECURITY_DEPOSIT_HOLDBACK';

export type OdProtosSupportData_HoldbackReason =
  | 'DEBRIS_DAMAGE'
  | 'HOLDBACK_OTHER'
  | 'HOME_DAMAGE'
  | 'LCO_OVERSTAY';

export type OdProtosSupportData_HomeInspectionRequestType =
  | 'ACCESS_INSTRUCTIONS_UPDATE'
  | 'DEBRIS_REVIEW'
  | 'DIGITAL_CHECKOUT_LOCKBOX_DROP_OFF'
  | 'INSTALL_EXCLUSIVES_COMING_SOON_SIGNAGE'
  | 'IN_PERSON_ASSESSMENT_OCCUPIED'
  | 'IN_PERSON_ASSESSMENT_VACANT'
  | 'ONE_DAY_RESCHEDULE_REQUEST'
  | 'OTHER'
  | 'SPECIFIC_ASSESSMENT';

/** Represents additional information needed for a Home Issues (Acquisition) ticket */
export type OdProtosSupportData_HomeIssuesAcquisitionInformationInput = {
  homeInspectionRequest?: InputMaybe<OdProtosSupportData_HomeInspectionRequestType>;
};

export type OdProtosSupportData_IdentityEscalationInformationInput = {
  buyerNameInContract?: InputMaybe<Scalars['String']>;
  customerPhone?: InputMaybe<Scalars['String']>;
  customerType?: InputMaybe<OdProtosSupportData_CustomerType>;
  frmmsQuestionsAsked?: InputMaybe<Scalars['Boolean']>;
  informationSaved?: InputMaybe<Scalars['Boolean']>;
  mlsMarketName?: InputMaybe<Scalars['String']>;
  sellerTransactionId?: InputMaybe<Scalars['String']>;
  vendorCompany?: InputMaybe<Scalars['String']>;
  vendorType?: InputMaybe<OdProtosSupportData_VendorType>;
};

/** Represents additional information needed for an In Person VA Request (Acquisition) ticket */
export type OdProtosSupportData_InPersonVaRequestAcquisitionInformationInput = {
  isOccupied?: InputMaybe<Scalars['Boolean']>;
};

/** Represents additional information needed for a Market Ops Escalations ticket */
export type OdProtosSupportData_MarketOpsEscalationsInformationInput = {
  escalationType?: InputMaybe<OdProtosSupportData_EscalationType>;
  holdbackReason?: InputMaybe<OdProtosSupportData_HoldbackReason>;
  repairReviewType?: InputMaybe<OdProtosSupportData_RepairReviewType>;
};

/** TODO: Replace TransactionIdentifier with OriginatingRecordIdentifier */
export type OdProtosSupportData_OriginatingRecordIdentifierInput = {
  id?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

export type OdProtosSupportData_PartnershipType =
  | 'AGENT'
  | 'HOMEBUILDER'
  | 'NO_PARTNERSHIP';

export type OdProtosSupportData_RepairReviewType =
  | 'ADDITION'
  | 'COST_ADJUSTMENT'
  | 'REMOVAL';

export type OdProtosSupportData_SellerType =
  | 'SELLER_TYPE_AGENT'
  | 'SELLER_TYPE_DIRECT_CUSTOMER';

export type OdProtosSupportData_SolarCompanyFinancingStatus =
  | 'FINANCED'
  | 'LEASED'
  | 'OWNED';

/** Represents additional information needed for a Solar Escalation Ticket */
export type OdProtosSupportData_SolarTicketInformationInput = {
  financingStatus?: InputMaybe<OdProtosSupportData_SolarCompanyFinancingStatus>;
  solarCompanyContactInformation?: InputMaybe<Scalars['String']>;
};

/** next id: 52 */
export type OdProtosSupportData_TicketForm =
  | 'ACCESS_REQUESTS'
  | 'ACQUISITION_TC_COMMS'
  | 'ACQUISITION_TE_TRANSACTION_COORDINATION'
  | 'AEP_MANAGER_ESCALATIONS'
  | 'AEP_MANAGER_OWNED_COE_CHANGE_REQUEST'
  | 'AEP_MANAGER_OWNED_CONTRACT_CANCELLATION_REQUEST'
  | 'AEP_MANAGER_OWNED_OTHER_APPROVAL_REQUEST'
  | 'AEP_MANAGER_OWNED_SUBSIDY_CHANGE_REQUEST'
  | 'AGENT_BILLING'
  | 'AGENT_OPS_AGENT'
  | 'AGENT_OPS_CUSTOMER'
  | 'AGENT_RECRUITING_AND_ONBOARDING'
  | 'ALA_DECLARATION_ESCALATION'
  | 'ASSESSMENT_FAILURE'
  | 'BRN_BUDGET_REVIEW'
  | 'BRN_EXECUTION'
  | 'BROKER_REJECTION_OF_DOCUMENT'
  | 'CEP_EMAIL'
  | 'CEP_MANAGER_OWNED_COE_CHANGE_REQUEST'
  | 'CEP_MANAGER_OWNED_OTHER_APPROVAL_REQUEST'
  | 'CEP_MANAGER_OWNED_SUBSIDY_CHANGE_REQUEST'
  | 'CEP_MANAGER_TO_XA_MANAGER_ESCALATIONS'
  | 'CONTRACT_CANCELLATION_REQUEST'
  | 'EXTERNAL_LISTINGS'
  | 'GENERAL_SUPPORT_TICKET'
  | 'HOA'
  | 'HOA_APPLICATIONS'
  | 'HOA_ASSESSMENTS'
  | 'HOA_DEMAND'
  | 'HOA_GENERAL_SUPPORT'
  | 'HOA_LITIGATIONS'
  | 'HOA_OTHERMISC'
  | 'HOA_REQUEST_NON_VIOLATION'
  | 'HOA_VIOLATIONS'
  | 'HOC_SUPPORT_EMAIL'
  | 'HOME_ISSUES_ACQUISITION'
  | 'HOME_ISSUES_RESALE'
  | 'HOME_MAINTENANCE'
  | 'HQI_FEEDBACK'
  | 'IDENTITY_ESCALATION_ACCOUNT_MERGE'
  | 'IDENTITY_ESCALATION_AGENT'
  | 'IDENTITY_ESCALATION_DIRECT_CUSTOMER'
  | 'IDENTITY_ESCALATION_SELLER'
  | 'IDENTITY_ESCALATION_VENDOR'
  | 'IN_PERSON_VA_REQUEST_ACQUISITION'
  | 'MARKET_OPS_ESCALATIONS'
  | 'REPAIR_ADJUSTMENT_REQUEST'
  | 'RESALE_EP_EMAIL'
  | 'RESALE_TE_TRANSACTION_COORDINATION'
  | 'SEPTIC_INSPECTION_REVIEW'
  | 'SOLAR_ESCALATION_ACQUISITION'
  | 'SOLAR_ESCALATION_RESALE'
  | 'SOLAR_TRANSACTION_COORDINATION'
  | 'UNKNOWN_FORM'
  | 'VISITOR_CAMPAIGN'
  | 'XA_MANAGER_TO_CEP_MANAGER_ESCALATIONS'
  | 'XA_TO_ACQ_EP_ESCALATION'
  | 'XA_TO_RESALE_EP_ESCALATION';

export type OdProtosSupportData_TicketPriority =
  | 'HIGH'
  | 'LOW'
  | 'NORMAL'
  | 'UNKNOWN_PRIORITY'
  | 'URGENT';

export type OdProtosSupportData_TicketStatus =
  | 'CLOSED'
  | 'HOLD'
  | 'NEW'
  | 'OPEN'
  | 'PENDING'
  | 'SOLVED'
  | 'UNKNOWN';

export type OdProtosSupportData_TransactionIdentifierInput = {
  id?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<OdProtosSupportData_TransactionIdentifier_Type>;
};

export type OdProtosSupportData_TransactionIdentifier_Type =
  | 'LISTING_OFFER'
  | 'OFFER';

export type OdProtosSupportData_VendorType =
  | 'VENDOR_TYPE_APPRAISER'
  | 'VENDOR_TYPE_INSPECTOR';

export type OdProtosSupportServices_AddCommentToTicketRequestInput = {
  assetIds?: InputMaybe<Array<Scalars['String']>>;
  author?: InputMaybe<OdProtosSupportServices_AddCommentToTicketRequest_AuthorOneofInput>;
  comment?: InputMaybe<Scalars['String']>;
  identifier?: InputMaybe<OdProtosSupportServices_AddCommentToTicketRequest_IdentifierOneofInput>;
  public?: InputMaybe<Scalars['Boolean']>;
};

export type OdProtosSupportServices_AddCommentToTicketRequest_AuthorOneofInput = {
  customerId?: InputMaybe<Scalars['String']>;
  userToken?: InputMaybe<Scalars['String']>;
};

export type OdProtosSupportServices_AddCommentToTicketRequest_IdentifierOneofInput = {
  id?: InputMaybe<Scalars['String']>;
  zendeskTicketId?: InputMaybe<Scalars['Float']>;
};

export type OdProtosSupportServices_AssignTicketRequestInput = {
  identifier?: InputMaybe<OdProtosSupportServices_AssignTicketRequest_IdentifierOneofInput>;
  ticketId?: InputMaybe<Scalars['String']>;
  userToken?: InputMaybe<Scalars['String']>;
};

export type OdProtosSupportServices_AssignTicketRequest_IdentifierOneofInput = {
  id?: InputMaybe<Scalars['String']>;
  zendeskTicketId?: InputMaybe<Scalars['Float']>;
};

export type OdProtosSupportServices_AssociateRecordToTicketRequestInput = {
  /**
   * This comment will be pushed to Zendesk after the
   * object is associated with the ticket
   */
  comment?: InputMaybe<Scalars['String']>;
  identifier?: InputMaybe<OdProtosSupportServices_AssociateRecordToTicketRequest_IdentifierOneofInput>;
  record?: InputMaybe<OdProtosSupportData_AssociatedRecordInput>;
  ticketId?: InputMaybe<Scalars['String']>;
};

export type OdProtosSupportServices_AssociateRecordToTicketRequest_IdentifierOneofInput = {
  id?: InputMaybe<Scalars['String']>;
  zendeskTicketId?: InputMaybe<Scalars['Float']>;
};

/** next id: 27 */
export type OdProtosSupportServices_CreateTicketRequestInput = {
  /**
   * Optional: Adds tags to the ticket. Some tickets have default tags
   * this will append to that default tag list.
   */
  addTags?: InputMaybe<Array<Scalars['String']>>;
  additionalTicketFields?: InputMaybe<OdProtosSupportServices_CreateTicketRequest_AdditionalTicketFieldsOneofInput>;
  addressId?: InputMaybe<Scalars['String']>;
  assigneeToken?: InputMaybe<Scalars['String']>;
  attachmentAssets?: InputMaybe<Array<OdProtosCabinetData_AssetInput>>;
  description?: InputMaybe<Scalars['String']>;
  forceInitialCommentPublic?: InputMaybe<Scalars['Boolean']>;
  form?: InputMaybe<OdProtosSupportData_TicketForm>;
  /** when non-empty, this will override the "description" field with an HTML-formatted ticket comment */
  htmlDescription?: InputMaybe<Scalars['String']>;
  originatingRecord?: InputMaybe<OdProtosSupportData_OriginatingRecordIdentifierInput>;
  priority?: InputMaybe<OdProtosSupportData_TicketPriority>;
  requester?: InputMaybe<OdProtosSupportServices_CreateTicketRequest_RequesterOneofInput>;
  status?: InputMaybe<OdProtosSupportData_TicketStatus>;
  /** Optional: This overrides the default subject for all ticket forms */
  subject?: InputMaybe<Scalars['String']>;
  /** only use external email addresses here - opendoor addresses will be ignored */
  ticketCcEmailAddresses?: InputMaybe<Array<Scalars['String']>>;
  type?: InputMaybe<Scalars['String']>;
};

export type OdProtosSupportServices_CreateTicketRequest_AdditionalTicketFieldsOneofInput = {
  assessmentFailureFields?: InputMaybe<OdProtosSupportData_AssessmentFailureInformationInput>;
  brokerRejectionOfDocumentFields?: InputMaybe<OdProtosSupportData_BrokerRejectionOfDocumentInformationInput>;
  contractChangeFields?: InputMaybe<OdProtosSupportData_ContractChangeInformationInput>;
  homeIssuesAcquisitionFields?: InputMaybe<OdProtosSupportData_HomeIssuesAcquisitionInformationInput>;
  identityEscalationFields?: InputMaybe<OdProtosSupportData_IdentityEscalationInformationInput>;
  inPersonVaRequestAcquisitionFields?: InputMaybe<OdProtosSupportData_InPersonVaRequestAcquisitionInformationInput>;
  marketOpsEscalationsFields?: InputMaybe<OdProtosSupportData_MarketOpsEscalationsInformationInput>;
  solarTicketFields?: InputMaybe<OdProtosSupportData_SolarTicketInformationInput>;
};

export type OdProtosSupportServices_CreateTicketRequest_RequesterOneofInput = {
  customerId?: InputMaybe<Scalars['String']>;
  requesterEmail?: InputMaybe<Scalars['String']>;
  userToken?: InputMaybe<Scalars['String']>;
};

export type OdProtosSupportServices_DisassociateRecordFromTicketRequestInput = {
  /**
   * This comment will be pushed to Zendesk after the
   * object is disassociated with the ticket
   */
  comment?: InputMaybe<Scalars['String']>;
  identifier?: InputMaybe<OdProtosSupportServices_DisassociateRecordFromTicketRequest_IdentifierOneofInput>;
  record?: InputMaybe<OdProtosSupportData_AssociatedRecordInput>;
  ticketId?: InputMaybe<Scalars['String']>;
};

export type OdProtosSupportServices_DisassociateRecordFromTicketRequest_IdentifierOneofInput = {
  id?: InputMaybe<Scalars['String']>;
  zendeskTicketId?: InputMaybe<Scalars['Float']>;
};

export type OdProtosSupportServices_GetTicketRequestInput = {
  ticketId?: InputMaybe<Scalars['String']>;
};

export type OdProtosSupportServices_PageParamsInput = {
  offset?: InputMaybe<Scalars['Float']>;
  /** max page size is 1000 */
  size?: InputMaybe<Scalars['Float']>;
};

/**
 * These fields are AND'd when searching.
 * Pagination is currently not currently needed since there are only
 * a handful of tasks per transaction, home, customer, and even assignee.
 */
export type OdProtosSupportServices_SearchTicketsRequestInput = {
  addressId?: InputMaybe<Scalars['String']>;
  assigneeUserToken?: InputMaybe<Scalars['String']>;
  associatedRecord?: InputMaybe<OdProtosSupportData_AssociatedRecordInput>;
  customerId?: InputMaybe<Scalars['String']>;
  originatingRecord?: InputMaybe<OdProtosSupportData_OriginatingRecordIdentifierInput>;
  page?: InputMaybe<OdProtosSupportServices_PageParamsInput>;
  sortBy?: InputMaybe<OdProtosSupportServices_SortByInput>;
  ticketForm?: InputMaybe<OdProtosSupportData_TicketForm>;
  ticketPriority?: InputMaybe<OdProtosSupportData_TicketPriority>;
  ticketStatus?: InputMaybe<OdProtosSupportData_TicketStatus>;
  /** deprecating in favor of using originating_record which allows us to query on more than offer and listing offer types */
  transactionId?: InputMaybe<OdProtosSupportData_TransactionIdentifierInput>;
};

export type OdProtosSupportServices_SetTicketStatusRequestInput = {
  ticketId?: InputMaybe<Scalars['String']>;
  ticketStatus?: InputMaybe<OdProtosSupportData_TicketStatus>;
};

export type OdProtosSupportServices_SortByFields =
  | 'CREATED_AT'
  | 'PRIORITY'
  | 'STATUS';

export type OdProtosSupportServices_SortByInput = {
  /** Descending order if true. Default is ascending */
  desc?: InputMaybe<Scalars['Boolean']>;
  /** defaults to sorting by created_at */
  field?: InputMaybe<OdProtosSupportServices_SortByFields>;
};

export type OdProtosSupportServices_UpdateOriginatingRecordForTicketRequestInput = {
  originatingRecord?: InputMaybe<OdProtosSupportData_OriginatingRecordIdentifierInput>;
  ticketIdentifier?: InputMaybe<OdProtosSupportServices_UpdateOriginatingRecordForTicketRequest_TicketIdentifierOneofInput>;
};

export type OdProtosSupportServices_UpdateOriginatingRecordForTicketRequest_TicketIdentifierOneofInput = {
  /** TODO: build functionality for ticket UUID support */
  zendeskTicketId?: InputMaybe<Scalars['Float']>;
};

export type OdProtosTangoData_ActionType =
  | 'CANCEL_APPOINTMENTS_ACTION'
  | 'HPM_VISIT_ACTION'
  | 'HQI_FEEDBACK_ACTION'
  | 'INVESTIGATE_ACTION'
  | 'PROTECT_ACTION'
  | 'SERVICE_REQUEST_ACTION'
  | 'UNKNOWN_ACTION'
  | 'WORK_ORDER_ACTION';

export type OdProtosTangoData_AreasDamagedInput = {
  list?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosTangoData_CustomerInput = {
  uuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosTangoData_CustomersInput = {
  list?: InputMaybe<Array<OdProtosTangoData_CustomerInput>>;
};

export type OdProtosTangoData_IncidentReportUpdateInput = {
  description?: InputMaybe<Scalars['String']>;
  patrolDispatched?: InputMaybe<Scalars['Boolean']>;
  reporterContact?: InputMaybe<Scalars['String']>;
  reporterEmail?: InputMaybe<Scalars['String']>;
  reporterName?: InputMaybe<Scalars['String']>;
  reporterPhoneNumber?: InputMaybe<Scalars['String']>;
  reporterRole?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Scalars['String']>;
  submitterId?: InputMaybe<Scalars['String']>;
  token?: InputMaybe<Scalars['String']>;
};

/**
 * Used to perform partial updates of investigations
 *
 * Null values will not be updated
 */
export type OdProtosTangoData_InvestigationUpdateInput = {
  addedToSecurityRoute?: InputMaybe<Scalars['Boolean']>;
  areasDamaged?: InputMaybe<OdProtosTangoData_AreasDamagedInput>;
  attributedCustomers?: InputMaybe<OdProtosTangoData_CustomersInput>;
  estimatedCostCents?: InputMaybe<Scalars['Float']>;
  modeOfEntry?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  occurred?: InputMaybe<OdProtosTangoData_OccurredInput>;
  reportedHardwareIssues?: InputMaybe<OdProtosTangoData_ReportedHardwareIssuesInput>;
  securityRouteDurationDays?: InputMaybe<Scalars['Float']>;
  securityRouteStart?: InputMaybe<OdProtosTangoData_SecurityRouteStartInput>;
  tags?: InputMaybe<OdProtosTangoData_TagsInput>;
  tier?: InputMaybe<OdProtosTangoData_TierInput>;
  token?: InputMaybe<Scalars['String']>;
};

/** An object which represents an incident report to be created */
export type OdProtosTangoData_NewIncidentReportInput = {
  /** Any descriptive information which might be useful during investigation */
  description?: InputMaybe<Scalars['String']>;
  /** Which flip the incident occurred at */
  flipToken?: InputMaybe<Scalars['String']>;
  /** If a patrol was dispatched due to this report */
  patrolDispatched?: InputMaybe<Scalars['Boolean']>;
  /** How to contact the reporter */
  reporterContact?: InputMaybe<Scalars['String']>;
  /** The reporter's email address */
  reporterEmail?: InputMaybe<Scalars['String']>;
  /** Who reported the incident */
  reporterName?: InputMaybe<Scalars['String']>;
  /** The reporter's phone number */
  reporterPhoneNumber?: InputMaybe<Scalars['String']>;
  /** What role the reporter has in relation to Opendoor */
  reporterRole?: InputMaybe<Scalars['String']>;
  /** A string tag indicating the kind of source for the report */
  source?: InputMaybe<Scalars['String']>;
  /** Which human is submitting the report */
  submitterId?: InputMaybe<Scalars['String']>;
  /** A set of tags representing what kind of incident(s) occurred */
  tags?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosTangoData_OccurredInput = {
  value?: InputMaybe<Scalars['DateTime']>;
};

export type OdProtosTangoData_ReportedHardwareIssuesInput = {
  list?: InputMaybe<Array<Scalars['String']>>;
};

/** Information about what caused the current home access restriction */
export type OdProtosTangoData_RestrictionCauseInput = {
  /** If the cause was an incident, the corresponding incident report token */
  incidentReportToken?: InputMaybe<Scalars['String']>;
  /** If the cause was an operator, this is their human token */
  operatorToken?: InputMaybe<Scalars['String']>;
  /** A stringly-typed reason for the restriction */
  trigger?: InputMaybe<OdProtosTangoData_RestrictionTrigger>;
};

/** An enumeration which describes the currently allowed access to the home */
export type OdProtosTangoData_RestrictionLevel =
  /** No special restrictions */
  | 'NO_RESTRICTION'
  /** Property Protection Mode, more stringent checks required to tour */
  | 'PROTECTED'
  /** Restricted Home Access mode, no customers allowed to tour */
  | 'RESTRICTED'
  /** Unknown/uninitialized value */
  | 'UNKNOWN_RESTRICTION';

export type OdProtosTangoData_RestrictionTrigger =
  /** This state was set during a backfill */
  | 'BACKFILL_TRIGGER'
  /** This restriction was triggered by a filed incident */
  | 'INCIDENT_TRIGGER'
  /** An operator set this state */
  | 'OPERATOR_TRIGGER'
  /** It is unknown what triggered this restriction */
  | 'UNKNOWN_TRIGGER';

export type OdProtosTangoData_SecurityRouteStartInput = {
  value?: InputMaybe<Scalars['DateTime']>;
};

export type OdProtosTangoData_TagsInput = {
  list?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosTangoData_TierInput = {
  value?: InputMaybe<Scalars['Float']>;
};

export type OdProtosTangoServices_ClearHomeAccessRestrictionRequestInput = {
  addressUuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosTangoServices_GetHomeAccessRestrictionRequestInput = {
  addressUuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosTangoServices_GetIncidentReportInvestigationRequestInput = {
  /** The incident report token for the related investigation */
  token?: InputMaybe<Scalars['String']>;
};

export type OdProtosTangoServices_GetIncidentReportRequestInput = {
  includeInvestigation?: InputMaybe<Scalars['Boolean']>;
  /** The incident report token for the incident to retrieve */
  token?: InputMaybe<Scalars['String']>;
};

export type OdProtosTangoServices_ListActionsByIncidentReportRequestInput = {
  /** The incident report token for the incident actions to retrieve */
  token?: InputMaybe<Scalars['String']>;
};

export type OdProtosTangoServices_ListIncidentReportsByAddressRequestInput = {
  /** The address to retrieve incident reports for */
  addressUuid?: InputMaybe<Scalars['String']>;
  includeInvestigations?: InputMaybe<Scalars['Boolean']>;
};

export type OdProtosTangoServices_ListIncidentReportsByCustomerRequestInput = {
  after?: InputMaybe<Scalars['DateTime']>;
  customerUuid?: InputMaybe<Scalars['String']>;
  includeInvestigations?: InputMaybe<Scalars['Boolean']>;
};

export type OdProtosTangoServices_ListIncidentReportsByFlipRequestInput = {
  /** The flip token to retrieve incident reports for */
  flipToken?: InputMaybe<Scalars['String']>;
  includeInvestigations?: InputMaybe<Scalars['Boolean']>;
};

export type OdProtosTangoServices_ListIncidentReportsRequestInput = {
  includeInvestigations?: InputMaybe<Scalars['Boolean']>;
  /** The tokens to retrieve incident reports for */
  tokens?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosTangoServices_ReportIncidentRequestInput = {
  includeActions?: InputMaybe<Scalars['Boolean']>;
  includeInvestigation?: InputMaybe<Scalars['Boolean']>;
  report?: InputMaybe<OdProtosTangoData_NewIncidentReportInput>;
};

export type OdProtosTangoServices_RestrictHomeAccessRequestInput = {
  addressUuid?: InputMaybe<Scalars['String']>;
  cause?: InputMaybe<OdProtosTangoData_RestrictionCauseInput>;
  restriction?: InputMaybe<OdProtosTangoData_RestrictionLevel>;
};

export type OdProtosTangoServices_UpdateIncidentReportRequestInput = {
  includeInvestigation?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<OdProtosTangoData_IncidentReportUpdateInput>;
};

export type OdProtosTangoServices_UpdateInvestigationRequestInput = {
  update?: InputMaybe<OdProtosTangoData_InvestigationUpdateInput>;
};

export type OdProtosTestingBasic_SimpleRequestInput = {
  boolValue?: InputMaybe<Scalars['Boolean']>;
  enum?: InputMaybe<OdProtosTestingBasic_SimpleRequest_Enum>;
  list?: InputMaybe<Array<Scalars['String']>>;
  listNested?: InputMaybe<Array<OdProtosTestingBasic_SimpleRequest_NestedInput>>;
  nested?: InputMaybe<OdProtosTestingBasic_SimpleRequest_NestedInput>;
  string?: InputMaybe<Scalars['String']>;
  struct?: InputMaybe<GoogleProtobuf_StructInput>;
  timestamp?: InputMaybe<Scalars['DateTime']>;
};

export type OdProtosTestingBasic_SimpleRequest_Enum =
  | 'DEFAULT'
  | 'FIRST';

export type OdProtosTestingBasic_SimpleRequest_NestedInput = {
  string?: InputMaybe<Scalars['String']>;
};

/** State indicates the current state of a ThirdPartyMarketplaceListing */
export type OdProtosThirdPartyMarketplaceListingData_State =
  /** The seller has a buyer committed to purchase the property. */
  | 'COMMITTED_BUYER'
  /**
   * The ThirdPartyMarketplaceListing lifecycle has been created and the
   * seller is enrolled in the program, however it is in a holding state
   * because we haven't received confirmation that the seller wants to
   * proceed yet.
   */
  | 'PENDING_COMMITMENT'
  /**
   * The seller has confirmed that they want to proceed with the
   * ThirdPartyMarketplaceListing program, and the property is now being
   * prepared for sale.
   */
  | 'PREPARING'
  /**
   * The property may now be sold, and all ThirdPartyMarketplaceListing
   * preparation has been completed. Any active channels may expose the
   * property as for sale.
   */
  | 'SELLABLE'
  /**
   * The ThirdPartyMarketplaceListing lifecycle has been terminated,
   * typically because the property has been sold.
   */
  | 'TERMINATED'
  | 'UNKNOWN_STATE';

/**
 * TerminationReason indicates the reason a ThirdPartyMarketplaceListing
 * entity was terminated
 */
export type OdProtosThirdPartyMarketplaceListingData_TerminationReason =
  /** The ThirdPartyMarketplaceListing was canceled by the seller */
  | 'SALE_CANCELED'
  /** Home has been sold */
  | 'SOLD'
  | 'UNKNOWN_TERMINATION_REASON';

/** Next ID: 6 */
export type OdProtosTodoData_ItemInput = {
  /** When the item was first created. */
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** The long form contents of the todo item. */
  description?: InputMaybe<Scalars['String']>;
  /** Primary identifier for the item. */
  id?: InputMaybe<Scalars['String']>;
  /** The short form title for the item. */
  title?: InputMaybe<Scalars['String']>;
  /** When the item was last updated. */
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

/** Next ID: 2 */
export type OdProtosTodoServices_CreateItemRequestInput = {
  item?: InputMaybe<OdProtosTodoData_ItemInput>;
};

/** Next ID: 2 */
export type OdProtosTodoServices_DeleteItemRequestInput = {
  itemId?: InputMaybe<Scalars['String']>;
};

/** Next ID: 2 */
export type OdProtosTodoServices_GetItemRequestInput = {
  itemId?: InputMaybe<Scalars['String']>;
};

/** Next ID: 2 */
export type OdProtosTodoServices_ListItemsRequestInput = {
  itemIds?: InputMaybe<Array<Scalars['String']>>;
};

/** Next ID: 2 */
export type OdProtosTodoServices_UpdateItemRequestInput = {
  item?: InputMaybe<OdProtosTodoData_ItemInput>;
};

export type OdProtosTrippyData_CancellationReasonInput = {
  additionalDetails?: InputMaybe<Scalars['String']>;
  structuredReasons?: InputMaybe<Array<Scalars['String']>>;
};

/** Next ID: 3 */
export type OdProtosTrippyData_VisitOrderingInput = {
  column?: InputMaybe<OdProtosTrippyData_VisitOrdering_Column>;
  isDescending?: InputMaybe<Scalars['Boolean']>;
};

/** Next ID: 13 */
export type OdProtosTrippyData_VisitOrdering_Column =
  | 'ADDRESS_ID'
  | 'ASSIGNED_ORGANIZATION_ID'
  | 'ASSIGNED_USER_TOKEN'
  | 'CANCELLED_AT'
  | 'CHECK_IN_AT'
  | 'CHECK_OUT_AT'
  | 'CREATED_AT'
  | 'DUE_BY'
  | 'SCHEDULE_START_AT'
  | 'SCHEDULE_STOP_AT'
  | 'UPDATED_AT'
  | 'VISIT_TYPE_ID';

export type OdProtosTrippyServices_BackfillEnrollmentsRequestInput = {
  domainId?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Float']>;
  offset?: InputMaybe<Scalars['Float']>;
};

export type OdProtosTrippyServices_CancelVisitRequestInput = {
  cancellationReason?: InputMaybe<OdProtosTrippyData_CancellationReasonInput>;
  cancellationSource?: InputMaybe<Scalars['String']>;
  visitId?: InputMaybe<Scalars['String']>;
};

export type OdProtosTrippyServices_ChangeAddressRequestInput = {
  enrollmentIds?: InputMaybe<Array<Scalars['String']>>;
  newAddressId?: InputMaybe<Scalars['String']>;
  oldAddressId?: InputMaybe<Scalars['String']>;
};

export type OdProtosTrippyServices_CheckIntoVisitRequestInput = {
  checkInTime?: InputMaybe<Scalars['DateTime']>;
  visitId?: InputMaybe<Scalars['String']>;
};

export type OdProtosTrippyServices_CheckOutFromVisitRequestInput = {
  checkOutTime?: InputMaybe<Scalars['DateTime']>;
  visitId?: InputMaybe<Scalars['String']>;
};

export type OdProtosTrippyServices_CreateDomainRequestInput = {
  /** Name of the domain */
  name?: InputMaybe<Scalars['String']>;
  /** ID of the organization who will own this entity */
  organizationId?: InputMaybe<Scalars['String']>;
  /** RFC 4122 compliant UUID to enforce idempotence */
  requestToken?: InputMaybe<Scalars['String']>;
};

/** Next ID: 23 */
export type OdProtosTrippyServices_CreateVisitRequestInput = {
  /** required */
  addressId?: InputMaybe<Scalars['String']>;
  /** Deprecated */
  assignedOrganizationId?: InputMaybe<Scalars['String']>;
  /** Leave blank to use new assigned_organization_token field */
  assignedOrganizationToken?: InputMaybe<Scalars['String']>;
  /** Must have at least one: assigned_user_token or assigned_organization_token */
  assignedUserToken?: InputMaybe<Scalars['String']>;
  cancelledAt?: InputMaybe<Scalars['DateTime']>;
  checkInAt?: InputMaybe<Scalars['DateTime']>;
  checkOutAt?: InputMaybe<Scalars['DateTime']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdByOrganizationId?: InputMaybe<Scalars['String']>;
  dueBy?: InputMaybe<Scalars['DateTime']>;
  /** optional */
  enrollmentId?: InputMaybe<Scalars['String']>;
  followupTime?: InputMaybe<Scalars['DateTime']>;
  isScheduleSlotBased?: InputMaybe<Scalars['Boolean']>;
  notes?: InputMaybe<Scalars['String']>;
  /** RFC 4122 compliant UUID to enforce idempotence */
  requestToken?: InputMaybe<Scalars['String']>;
  /** required */
  scheduledStartAt?: InputMaybe<Scalars['DateTime']>;
  scheduledStopAt?: InputMaybe<Scalars['DateTime']>;
  upcomingTime?: InputMaybe<Scalars['DateTime']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** required */
  visitTypeId?: InputMaybe<Scalars['String']>;
};

export type OdProtosTrippyServices_CreateVisitTypeRequestInput = {
  /** ID of the domain this entity will belong to */
  domainId?: InputMaybe<Scalars['String']>;
  /** Label for the visit type */
  label?: InputMaybe<Scalars['String']>;
  /** Unique identifier for this request to enforce idempotence */
  requestToken?: InputMaybe<Scalars['String']>;
};

export type OdProtosTrippyServices_GetDomainsRequestInput = {
  /** ID of the domain */
  ids?: InputMaybe<Array<Scalars['String']>>;
  /** Name of the domain */
  names?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosTrippyServices_GetVisitTypesRequestInput = {
  /** ID of the domain to filter by */
  domainId?: InputMaybe<Scalars['String']>;
  /** label of the visit type to filter by */
  label?: InputMaybe<Scalars['String']>;
  /** ID of the visit type */
  visitTypeIds?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosTrippyServices_GetVisitsRequestInput = {
  assignedUserToken?: InputMaybe<Scalars['String']>;
  visitIds?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosTrippyServices_IdentifierRequestInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type OdProtosTrippyServices_RejectVisitRequestInput = {
  id?: InputMaybe<Scalars['String']>;
  reason?: InputMaybe<Scalars['String']>;
};

/** Next ID: 21 */
export type OdProtosTrippyServices_SearchVisitsRequestInput = {
  addressIds?: InputMaybe<Array<Scalars['String']>>;
  assignedOrganizationIds?: InputMaybe<Array<Scalars['String']>>;
  assignedUserTokens?: InputMaybe<Array<Scalars['String']>>;
  cancelledAt?: InputMaybe<OdProtosTrippyServices_TimestampParamInput>;
  checkInAt?: InputMaybe<OdProtosTrippyServices_TimestampParamInput>;
  checkOutAt?: InputMaybe<OdProtosTrippyServices_TimestampParamInput>;
  createdAtRange?: InputMaybe<OdProtosTrippyServices_TimestampRangeInput>;
  createdByOrganizationIds?: InputMaybe<Array<Scalars['String']>>;
  createdByUserTokens?: InputMaybe<Array<Scalars['String']>>;
  /**
   * domain_ids filters out visits that have a visit type that belongs to one of the
   * specified domains. It will be ignored if visit_type_ids is set.
   */
  domainIds?: InputMaybe<Array<Scalars['String']>>;
  dueBy?: InputMaybe<OdProtosTrippyServices_TimestampParamInput>;
  enrollmentIds?: InputMaybe<Array<Scalars['String']>>;
  markets?: InputMaybe<Array<OdProtosCommonMarket_Market>>;
  ordering?: InputMaybe<Array<OdProtosTrippyData_VisitOrderingInput>>;
  pagination?: InputMaybe<OdProtosCommonPagination_PaginationRequestInput>;
  scheduledStartAtRange?: InputMaybe<OdProtosTrippyServices_TimestampRangeInput>;
  /** Optional timestamp fields that can be unset have TimestampParams */
  scheduledStopAt?: InputMaybe<OdProtosTrippyServices_TimestampParamInput>;
  updatedAtRange?: InputMaybe<OdProtosTrippyServices_TimestampRangeInput>;
  visitIds?: InputMaybe<Array<Scalars['String']>>;
  visitTypeIds?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosTrippyServices_TimestampParamInput = {
  params?: InputMaybe<OdProtosTrippyServices_TimestampParam_ParamsOneofInput>;
};

export type OdProtosTrippyServices_TimestampParam_ParamsOneofInput = {
  timeRange?: InputMaybe<OdProtosTrippyServices_TimestampRangeInput>;
  /** Filter visits solely by whether this time field is set (to anything) or not */
  unset?: InputMaybe<Scalars['Boolean']>;
};

export type OdProtosTrippyServices_TimestampRangeInput = {
  end?: InputMaybe<Scalars['DateTime']>;
  /** If start and end are both null, this will not apply any filtering and will return both set and unset values. */
  start?: InputMaybe<Scalars['DateTime']>;
};

/** Next ID: 15 */
export type OdProtosTrippyServices_UpdateVisitRequestInput = {
  assignedOrganizationId?: InputMaybe<Scalars['String']>;
  assignedUserToken?: InputMaybe<Scalars['String']>;
  cancellationReason?: InputMaybe<OdProtosTrippyData_CancellationReasonInput>;
  cancellationSource?: InputMaybe<Scalars['String']>;
  cancelledAt?: InputMaybe<Scalars['DateTime']>;
  dueBy?: InputMaybe<Scalars['DateTime']>;
  followupTime?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  rejectReason?: InputMaybe<Scalars['String']>;
  rejectedAt?: InputMaybe<Scalars['DateTime']>;
  scheduledStartAt?: InputMaybe<Scalars['DateTime']>;
  scheduledStopAt?: InputMaybe<Scalars['DateTime']>;
  upcomingTime?: InputMaybe<Scalars['DateTime']>;
};

export type OdProtosTrustData_CreateIdentityReviewInput = {
  customerUuid?: InputMaybe<Scalars['String']>;
  identityReviewType?: InputMaybe<Array<OdProtosTrustData_IdentityReviewType>>;
};

export type OdProtosTrustData_FalsePositive =
  | 'NEEDS_FURTHER_REVIEW'
  | 'NO'
  | 'YES';

export type OdProtosTrustData_HomeAccessStatus =
  | 'ALLOW'
  | 'DENY'
  | 'NEEDS_REVIEW'
  | 'REQUIRES_VERIFICATION'
  | 'UNDEFINED'
  | 'UNRESTRICTED';

export type OdProtosTrustData_IdVerificationAttempt_IdType =
  | 'DRIVERS_LICENSE'
  | 'STATE_ID'
  | 'UNKNOWN_ID_TYPE';

export type OdProtosTrustData_IdVerificationAttempt_Result =
  /** The service provider was unable to process the ID, likely because of image quality */
  | 'COULD_NOT_PROCESS'
  /** The ID was expired */
  | 'FAILED_EXPIRED'
  /** e.g. the front was a passport and the back was from a driver's license */
  | 'FAILED_INCONSISTENT'
  /** The ID has been used for verification too many times */
  | 'FAILED_RETRY_THRESHOLD'
  /** The ID belongs to a minor */
  | 'FAILED_UNDERAGE'
  /** Opendoor doesn't support that type of ID */
  | 'FAILED_UNSUPPORTED_ID_TYPE'
  /** The service provider processed the ID and it failed verification */
  | 'FAILED_VERIFICATION'
  /** The service provider processed the ID and the ID was verified */
  | 'ID_VERIFIED'
  | 'UNKNOWN_RESULT';

/** The status of our request to a 3rd party to verify an ID */
export type OdProtosTrustData_IdVerificationAttempt_Status =
  | 'API_ERROR'
  | 'ATTEMPTED'
  | 'COMPLETE'
  | 'TIMED_OUT'
  | 'UNKNOWN_STATUS';

export type OdProtosTrustData_IdentityReviewTask_IdentityReviewType =
  | 'ACCESS_CHANGE_REVIEW'
  | 'DEVICE_OVERLAP_REVIEW'
  | 'DEVICE_SCORE_REVIEW'
  | 'DUPLICATE_PHONE_REVIEW'
  | 'EMAIL_FIRST_SEEN_REVIEW'
  | 'IDV_REVIEW'
  | 'IP_ADDRESS_AT_UNLOCK_REVIEW'
  | 'REPORT_FRAUD_REVIEW'
  | 'REQUIRES_VERIFICATION_REVIEW'
  | 'SELLER_REVIEW'
  | 'SHOWING_TIME_CUSTOMER_REVIEW'
  | 'SMS_UNSUBSCRIBE_REVIEW'
  | 'UNKNOWN';

export type OdProtosTrustData_IdentityReviewType =
  | 'ACCESS_CHANGE_REVIEW'
  | 'DEVICE_OVERLAP_REVIEW'
  | 'DEVICE_SCORE_REVIEW'
  | 'DUPLICATE_PHONE_REVIEW'
  | 'EMAIL_FIRST_SEEN_REVIEW'
  | 'IDV_REVIEW'
  | 'IP_ADDRESS_AT_UNLOCK_REVIEW'
  | 'REPORT_FRAUD_REVIEW'
  | 'REQUIRES_VERIFICATION_REVIEW'
  | 'SELLER_REVIEW'
  | 'SHOWING_TIME_CUSTOMER_REVIEW'
  | 'SMS_UNSUBSCRIBE_REVIEW'
  | 'UNKNOWN';

export type OdProtosTrustData_ReviewStatus =
  | 'REQUESTED'
  | 'REVIEW_CANCELLED_BY_SYSTEM'
  | 'REVIEW_COMPLETED'
  | 'UNDER_REVIEW';

/** Reason buckets */
export type OdProtosTrustData_RiskAssessmentResult_Reason =
  | 'BLOCK_FIXED_IP_ORG'
  | 'BLOCK_NON_US_TRUE_IP_GEO'
  | 'CROSS_MARKET_UNLOCKS'
  | 'CROSS_MARKET_UNLOCKS_BY_AGENT'
  | 'DENIED_AGENT'
  | 'DENY_DEVICE_ID'
  | 'DUPLICATE_PHONE_NUMBER_ALREADY_DENIED'
  | 'EKATA_DIR_BUYER_COMMERCIAL_ADDRESS'
  | 'EKATA_HIGH_IDENTITY_CHECK_SCORE'
  | 'EKATA_INVALID_EMAIL_ADDRESS'
  | 'EKATA_INVALID_PHONE_NUMBER'
  | 'EKATA_TRUSTED'
  | 'EMAIL_WITH_BAD_IDENTITY_SCORE'
  | 'EXCEEDED_OFFER_REQUESTS'
  | 'FAILED_ID_VERIFICATION'
  | 'FULLY_VERIFIED_AGENT'
  | 'HAS_ANONYMOUS_PREPAID_PHONE_TYPE'
  | 'HAS_BLACKLISTED_CARRIER'
  | 'HAS_HIGH_RISKSCORE'
  | 'HAS_HIGH_RISK_EMAIL_DOMAIN'
  | 'HAS_INVALID_PHONE_NUMBER'
  | 'HAS_OLD_PROFILE'
  | 'HAS_REPEATED_VISITS_TO_SAME_HOME'
  | 'HAS_RISKY_PHONE_TYPE'
  | 'IDV_RETRY_THRESHOLD'
  | 'INVALID_NAME'
  | 'MANUAL_VERIFICATION'
  | 'NO_PHONE_NUMBER'
  | 'OFF_HOUR_UNLOCK_REQUEST'
  | 'OPENDOOR_INTERNAL_USER'
  | 'PASSED_ID_VERIFICATION'
  | 'PASSED_RISKASSESSMENT'
  | 'RECENT_EMAIL_WITH_BAD_IDENTITY_SCORE'
  | 'REQUIRES_VERIFICATION_AGENT'
  | 'SAME_MARKET_UNLOCK_WITHIN_SHORT_PERIOD'
  | 'TRUE_IP_ROUTING_TYPE'
  | 'TRUST_CHANGED_VIA_SMS'
  | 'UNKNOWN_REASON'
  | 'UNVERIFIED_AGENT'
  | 'VERIFIED_AGENT'
  | 'VISITED_SPREAD_PRICED_HOMES';

export type OdProtosTrustData_RiskAssessmentResult_RuleSet =
  | 'BUYER'
  | 'SELLER';

/** Result of user risk assessment */
export type OdProtosTrustData_RiskAssessmentResult_TrustLevel =
  | 'ALLOW'
  | 'BLACKLISTED'
  | 'DENY'
  | 'GRAYLISTED'
  | 'NEEDS_REVIEW'
  | 'PASSED'
  | 'REQUIRES_VERIFICATION'
  | 'UNKNOWN'
  | 'UNRESTRICTED';

export type OdProtosTrustData_UpdateIdentityReviewInput = {
  falsePositive?: InputMaybe<OdProtosTrustData_FalsePositive>;
  homeAccessStatusAfterReview?: InputMaybe<OdProtosTrustData_HomeAccessStatus>;
  id?: InputMaybe<Scalars['Float']>;
  investigatorNotes?: InputMaybe<Scalars['String']>;
  reviewStatus?: InputMaybe<OdProtosTrustData_ReviewStatus>;
};

export type OdProtosTrustServices_AddOffHourUnlockEventRequestInput = {
  /** The customer to set this trust level to. */
  customerId?: InputMaybe<Scalars['String']>;
};

export type OdProtosTrustServices_AddTrustEventRequestInput = {
  /** The customer to set this trust level to. */
  customerId?: InputMaybe<Scalars['String']>;
  eventType?: InputMaybe<OdProtosTrustServices_AddTrustEventRequest_EventType>;
  /** The reason of this change. */
  reason?: InputMaybe<Scalars['String']>;
  /** Optional: The human who is manually setting this trust level. */
  settingHumanId?: InputMaybe<Scalars['String']>;
  /** The new trust level to set for the given customer. */
  trustLevel?: InputMaybe<OdProtosTrustData_RiskAssessmentResult_TrustLevel>;
};

export type OdProtosTrustServices_AddTrustEventRequest_EventType =
  | 'MANUAL_EVALUATION'
  | 'OFF_HOUR_UNLOCK_ATTEMPT'
  | 'SMS_EVENT';

export type OdProtosTrustServices_AssessCustomerRiskRequestInput = {
  assessmentPurpose?: InputMaybe<OdProtosTrustServices_AssessCustomerRiskRequest_AssessmentPurpose>;
  /**
   * The token of the customer who we associate with the phone number.
   * This field is required.
   * Note that this is commonly the Customer.UUID, not the Customer.Token
   */
  customerToken?: InputMaybe<Scalars['String']>;
};

/**
 * Optional: for indicating specific evaluation situations; if not provided,
 * it will default to running the buyer ruleSet in CRA
 */
export type OdProtosTrustServices_AssessCustomerRiskRequest_AssessmentPurpose =
  | 'BUYER'
  | 'SELLER';

export type OdProtosTrustServices_CreateIdentityReviewRequestInput = {
  identityReviewRequest?: InputMaybe<OdProtosTrustData_CreateIdentityReviewInput>;
};

export type OdProtosTrustServices_GetBypassIdVerificationRequestInput = {
  contactId?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
};

export type OdProtosTrustServices_GetEkataRequestInput = {
  customerToken?: InputMaybe<Scalars['String']>;
};

export type OdProtosTrustServices_GetIdVerificationAttemptsRequestInput = {
  contactId?: InputMaybe<Scalars['String']>;
};

export type OdProtosTrustServices_GetIdentityReviewRequestInput = {
  id?: InputMaybe<Scalars['Float']>;
};

/** Next ID: 3 */
export type OdProtosTrustServices_GetPhoneNumberTelesignReportRequestInput = {
  /**
   * The token of the customer who we associate with the phone number. This field
   * is optional, but should be provided if available.
   */
  customerToken?: InputMaybe<Scalars['String']>;
  /** The phone number for whose owner we want to identify. This field is required */
  phoneNumber?: InputMaybe<Scalars['String']>;
};

export type OdProtosTrustServices_GetRelatedCustomersWithDeviceOverlapRequestInput = {
  customerToken?: InputMaybe<Scalars['String']>;
};

export type OdProtosTrustServices_GetSuccessfulIdVerificationRequestInput = {
  contactId?: InputMaybe<Scalars['String']>;
};

export type OdProtosTrustServices_GetThreatMetrixRequestInput = {
  customerToken?: InputMaybe<Scalars['String']>;
};

/** Next ID: 3 */
export type OdProtosTrustServices_IdentifyPhoneNumberRequestInput = {
  /**
   * The token of the customer who we associate with the phone number. This field
   * is optional, but should be provided if available.
   */
  customerToken?: InputMaybe<Scalars['String']>;
  /** The phone number for whose owner we want to identify. This field is required */
  phoneNumber?: InputMaybe<Scalars['String']>;
};

export type OdProtosTrustServices_MergeCustomerTrustRelatedEventsRequestInput = {
  mergedCustomerUuid?: InputMaybe<Scalars['String']>;
  mergedIntoCustomerUuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosTrustServices_ProfileDeviceRequestInput = {
  attributes?: InputMaybe<OdProtosTrustServices_ProfileDeviceRequest_AttributesInput>;
  /** This is an ID associated to a ThreatMetrix profiling event. */
  sessionId?: InputMaybe<Scalars['String']>;
  /** This is also known as the human's token */
  userId?: InputMaybe<Scalars['String']>;
};

/**
 * Metadata about the human to which the session_id is associated.
 * These will be used as a snapshot of the provided user's info.
 */
export type OdProtosTrustServices_ProfileDeviceRequest_AttributesInput = {
  emailAddress?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
};

export type OdProtosTrustServices_SetManualTrustLevelRequestInput = {
  /** The customer to set this trust level to. */
  customerId?: InputMaybe<Scalars['String']>;
  /** The reason of this change. */
  reason?: InputMaybe<Scalars['String']>;
  /** The human who is manually setting this trust level. */
  settingHumanId?: InputMaybe<Scalars['String']>;
  /** The new trust level to set for the given customer. */
  trustLevel?: InputMaybe<OdProtosTrustData_RiskAssessmentResult_TrustLevel>;
};

export type OdProtosTrustServices_UpdateIdentityReviewRequestInput = {
  updateIdentityReview?: InputMaybe<OdProtosTrustData_UpdateIdentityReviewInput>;
};

/** Attempts to determine if the phone number and email address belong to this customer */
export type OdProtosTrustServices_VerifyCustomerContactRequestInput = {
  customerUuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosTrustServices_VerifyIdRequestInput = {
  contactId?: InputMaybe<Scalars['String']>;
  idBackPdf417?: InputMaybe<Scalars['String']>;
  idFrontBase64?: InputMaybe<Scalars['String']>;
};

export type OdProtosValidataData_ConfidenceAttributeName =
  | 'ABOVE_GRADE_SQ_FT'
  /** UNEXPECTED UNALLOWED */
  | 'ATTRIBUTE_NAME_UNKNOWN';

export type OdProtosValidataData_ConfidenceLevel =
  | 'HIGH'
  | 'LOW'
  | 'MEDIUM'
  | 'UNKNOWN';

export type OdProtosValidataData_ConfidenceReason =
  | 'CONFIDENCE_REASON_CONFLICITING_INTERNAL_EDITS'
  | 'CONFIDENCE_REASON_CONFLICTING_DATA'
  | 'CONFIDENCE_REASON_CONFLICTING_DEPENDENCY_CONDITION'
  | 'CONFIDENCE_REASON_CONFLICTING_FLOOR_PLAN_SCAN'
  | 'CONFIDENCE_REASON_COULD_NOT_VERIFY'
  /**
   * Medium confidence reasons
   * (start at 20 to make room for more low conf. reasons)
   */
  | 'CONFIDENCE_REASON_EXTERNAL_SOURCES_AGREE'
  | 'CONFIDENCE_REASON_HPM_INPUT'
  /**
   * High confidence reasons
   * (start at 40 to make room for more medium conf. reasons)
   */
  | 'CONFIDENCE_REASON_INTERNALLY_VERIFIED'
  /** Low confidence reasons */
  | 'CONFIDENCE_REASON_NO_DATA'
  | 'CONFIDENCE_REASON_ONLY_IMPUTED'
  | 'CONFIDENCE_REASON_ONLY_SELLER_INPUTS'
  | 'CONFIDENCE_REASON_OUT_OF_RANGE'
  | 'CONFIDENCE_REASON_UNKNOWN';

export type OdProtosValidataData_ConfidenceThresholdsInput = {
  attribute?: InputMaybe<OdProtosValidataData_ConfidenceAttributeName>;
  threshold?: InputMaybe<OdProtosValidataData_ConfidenceThresholds_ThresholdOneofInput>;
};

export type OdProtosValidataData_ConfidenceThresholds_ThresholdOneofInput = {
  absoluteValueThreshold?: InputMaybe<Scalars['Float']>;
  percentageThreshold?: InputMaybe<Scalars['Float']>;
};

export type OdProtosValidataData_FloorPlanAssetInputInput = {
  assetType?: InputMaybe<OdProtosValidataData_FloorPlanAssetType>;
  externalUrl?: InputMaybe<Scalars['String']>;
  fileName?: InputMaybe<Scalars['String']>;
};

export type OdProtosValidataData_FloorPlanAssetType =
  | 'FLOOR_PLAN_ASSET_TYPE_GLA'
  | 'FLOOR_PLAN_ASSET_TYPE_JSON'
  | 'FLOOR_PLAN_ASSET_TYPE_LISTING_NO_DIMENSIONS'
  | 'FLOOR_PLAN_ASSET_TYPE_LISTING_WITH_DIMENSIONS'
  | 'FLOOR_PLAN_ASSET_TYPE_UNKNOWN';

export type OdProtosValidataData_FloorPlanFileType =
  | 'FLOOR_PLAN_FILE_TYPE_JPEG'
  | 'FLOOR_PLAN_FILE_TYPE_JSON'
  | 'FLOOR_PLAN_FILE_TYPE_PDF'
  | 'FLOOR_PLAN_FILE_TYPE_PNG'
  | 'FLOOR_PLAN_FILE_TYPE_SVG'
  | 'FLOOR_PLAN_FILE_TYPE_UNKNOWN';

export type OdProtosValidataData_HomeDataAssetFeedbackInput = {
  addressToken?: InputMaybe<Scalars['String']>;
  assessmentId?: InputMaybe<Scalars['String']>;
  assetId?: InputMaybe<Scalars['String']>;
  assetType?: InputMaybe<Scalars['String']>;
  feedbacks?: InputMaybe<Array<Scalars['String']>>;
  feedbacksCreatedBy?: InputMaybe<Scalars['String']>;
};

export type OdProtosValidataData_OptOutType =
  /** "all" means this home is opting out of floor plan scans at any point */
  | 'OPT_OUT_TYPE_ALL'
  /** "none" is way of opting in */
  | 'OPT_OUT_TYPE_NONE'
  /**
   * "pre-acquisition" means we'll opt out of floor plan scans while a seller still
   * occupies the home, but we will do a scan once acquired
   */
  | 'OPT_OUT_TYPE_PRE_ACQUISITION'
  | 'OPT_OUT_TYPE_UNKNOWN';

export type OdProtosValidataData_ScanEligibility =
  | 'SCAN_ELIGIBILITY_POST_ACQUISITION'
  | 'SCAN_ELIGIBILITY_PRE_ACQUISITION'
  | 'SCAN_ELIGIBILITY_UNKNOWN';

export type OdProtosValidataData_TaskType =
  | 'REVIEW_FLOOR_PLAN'
  | 'UNKNOWN_TASK_TYPE'
  /** Renamed from VALIDATE_DATA */
  | 'VERIFY_DATA'
  | 'VERIFY_DATA_ESCALATION'
  | 'VERIFY_DATA_MANUAL';

export type OdProtosValidataData_VerificationResultInput = {
  attribute?: InputMaybe<Scalars['String']>;
  completedAt?: InputMaybe<Scalars['DateTime']>;
  finalValue?: InputMaybe<Scalars['String']>;
  initialValue?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  reason?: InputMaybe<Scalars['String']>;
  verified?: InputMaybe<Scalars['Boolean']>;
};

export type OdProtosValidataServices_BatchGetConfidenceSignalsByFieldsRequestInput = {
  addressTokens?: InputMaybe<Array<Scalars['String']>>;
  /** Optional threshold config on a per attribute basis */
  thresholdConfig?: InputMaybe<Array<OdProtosValidataData_ConfidenceThresholdsInput>>;
};

/** CompleteDataQualityTask */
export type OdProtosValidataServices_CompleteDataQualityTaskRequestInput = {
  id?: InputMaybe<Scalars['String']>;
  taskNotes?: InputMaybe<Scalars['String']>;
  verificationResults?: InputMaybe<Array<OdProtosValidataData_VerificationResultInput>>;
};

export type OdProtosValidataServices_CreateAssetFeedbackRequestInput = {
  feedbacks?: InputMaybe<OdProtosValidataData_HomeDataAssetFeedbackInput>;
};

/** CreateDataQualityTask */
export type OdProtosValidataServices_CreateDataQualityTaskRequestInput = {
  addressToken?: InputMaybe<Scalars['String']>;
  attributes?: InputMaybe<Array<Scalars['String']>>;
  /** To Do: Maybe Deprecate after Cutover */
  caseyTaskId?: InputMaybe<Scalars['String']>;
  floorPlanScanId?: InputMaybe<Scalars['String']>;
  /** Related Object Ids, optional, if included will create related_object records in casey */
  leadId?: InputMaybe<Scalars['String']>;
  taskType?: InputMaybe<OdProtosValidataData_TaskType>;
};

/** Delete DataQualitytask */
export type OdProtosValidataServices_DeleteDataQualityTaskRequestInput = {
  caseyTaskId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
};

export type OdProtosValidataServices_GetConfidenceSignalsByFieldsRequestInput = {
  addressToken?: InputMaybe<Scalars['String']>;
  /** Optional threshold config on a per attribute basis */
  thresholdConfig?: InputMaybe<Array<OdProtosValidataData_ConfidenceThresholdsInput>>;
};

export type OdProtosValidataServices_GetCubicasaQuickEditLinkRequestInput = {
  cubicasaModelId?: InputMaybe<Scalars['String']>;
};

/** Get DataQualityTask */
export type OdProtosValidataServices_GetDataQualityTaskRequestInput = {
  /** To Do: Deprecate after Cutover */
  caseyTaskId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
};

export type OdProtosValidataServices_GetFloorPlanEligibilityRequestInput = {
  addressToken?: InputMaybe<Scalars['String']>;
  /**
   * Calculate eligibility regardless of user opt-out. This is useful
   * when powering UIs that allow opting in/out of floor plan scans,
   * so you can know what the eligiblity would be if the user opted-in
   */
  ignoreOptOut?: InputMaybe<Scalars['Boolean']>;
};

export type OdProtosValidataServices_GetFloorPlanScanUploadOverdueRequestInput = {
  humanToken?: InputMaybe<Scalars['String']>;
};

export type OdProtosValidataServices_GetGoToScanUrlRequestInput = {
  addressToken?: InputMaybe<Scalars['String']>;
};

export type OdProtosValidataServices_GetLatestAttributeVerificationsRequestInput = {
  addressTokens?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosValidataServices_ListAssetFeedbackRequestInput = {
  addressToken?: InputMaybe<Scalars['String']>;
  assetType?: InputMaybe<Scalars['String']>;
};

export type OdProtosValidataServices_ListFloorPlanOptOutsRequestInput = {
  addressTokens?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosValidataServices_MarkFloorPlanScanCompleteRequestInput = {
  id?: InputMaybe<Scalars['Float']>;
  scanCompletedBy?: InputMaybe<Scalars['String']>;
  scanVisitId?: InputMaybe<Scalars['String']>;
};

export type OdProtosValidataServices_MarkFloorPlanScanStartedRequestInput = {
  id?: InputMaybe<Scalars['Float']>;
};

export type OdProtosValidataServices_ProcessCompletedCubicasaOrderRequestInput = {
  cubicasaOrderId?: InputMaybe<Scalars['String']>;
};

export type OdProtosValidataServices_ProcessCompletedCubicasaTicketRequestInput = {
  addressToken?: InputMaybe<Scalars['String']>;
  cubicasaModelId?: InputMaybe<Scalars['String']>;
  cubicasaTicketId?: InputMaybe<Scalars['String']>;
};

export type OdProtosValidataServices_ProcessCreatedCubicasaOrderRequestInput = {
  cubicasaOrderId?: InputMaybe<Scalars['String']>;
};

export type OdProtosValidataServices_ProcessCreatedCubicasaTicketRequestInput = {
  addressToken?: InputMaybe<Scalars['String']>;
  cubicasaTicketId?: InputMaybe<Scalars['String']>;
  event?: InputMaybe<Scalars['String']>;
};

export type OdProtosValidataServices_RejectFloorPlanScanRequestInput = {
  id?: InputMaybe<Scalars['Float']>;
  rejectNotes?: InputMaybe<Scalars['String']>;
  rejectReason?: InputMaybe<Scalars['String']>;
  rejectedBy?: InputMaybe<Scalars['String']>;
};

export type OdProtosValidataServices_RequestFloorPlanScanRequestInput = {
  addressToken?: InputMaybe<Scalars['String']>;
  requestReason?: InputMaybe<Scalars['String']>;
  requestedBy?: InputMaybe<Scalars['String']>;
};

export type OdProtosValidataServices_SearchFloorPlanAssetsRequestInput = {
  addressTokens?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosValidataServices_SearchFloorPlanDetailsRequestInput = {
  addressTokens?: InputMaybe<Array<Scalars['String']>>;
  floorPlanScanIds?: InputMaybe<Array<Scalars['Float']>>;
};

export type OdProtosValidataServices_SearchFloorPlanScansRequestInput = {
  addressTokens?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosValidataServices_SetFloorPlanOptOutRequestInput = {
  addressToken?: InputMaybe<Scalars['String']>;
  createdBy?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<OdProtosValidataData_OptOutType>;
};

/** StartDataQualityTask */
export type OdProtosValidataServices_StartDataQualityTaskRequestInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type OdProtosValidataServices_SubmitFloorPlanAssetsRequestInput = {
  addressToken?: InputMaybe<Scalars['String']>;
  floorPlanAssetInputs?: InputMaybe<Array<OdProtosValidataData_FloorPlanAssetInputInput>>;
  visitId?: InputMaybe<Scalars['String']>;
};

export type OdProtosValidataServices_UpdateAssetFeedbackRequestInput = {
  feedbacks?: InputMaybe<Array<Scalars['String']>>;
  id?: InputMaybe<Scalars['Float']>;
};

export type OdProtosValuationsDataMergedcomps_ListingStatus =
  | 'ACTIVE'
  | 'CANCELED'
  | 'CLOSED'
  | 'COMING_SOON'
  | 'EXPIRED'
  | 'INCOMPLETE'
  | 'PENDING'
  | 'TEMP_OFF_MARKET'
  | 'UNKNOWN_LISTING_STATUS';

export type OdProtosValuationsServicesValuationsGraphql_ListValuationsRequestInput = {
  valuationIds?: InputMaybe<Array<Scalars['Float']>>;
};

export type OdProtosValuationsServicesValuations_GetMergedCompsForValuationRequestInput = {
  requestId?: InputMaybe<OdProtosCommon_RequestIdInput>;
  requestorId?: InputMaybe<OdProtosCommon_RequestorIdInput>;
  valuationKind?: InputMaybe<OdProtosValuationsServicesValuations_GetMergedCompsForValuationRequest_ValuationKindOneofInput>;
};

export type OdProtosValuationsServicesValuations_GetMergedCompsForValuationRequest_ValuationKindOneofInput = {
  ensembledValuationId?: InputMaybe<Scalars['Float']>;
  valuationId?: InputMaybe<Scalars['Float']>;
};

export type OdProtosValuationsServicesValuations_GetMergedCompsForValuationResponse_Error_Code =
  | 'INVALID_ARGUMENT'
  | 'NOT_FOUND'
  | 'UNKNOWN'
  | 'VALUATION_INCOMPLETE';

export type OdProtosValuationsServicesValuations_GetValuationRequestInput = {
  requestId?: InputMaybe<OdProtosCommon_RequestIdInput>;
  requestorId?: InputMaybe<OdProtosCommon_RequestorIdInput>;
  valuationId?: InputMaybe<Scalars['Float']>;
};

export type OdProtosValuationsServicesValuations_GetValuationResponse_Error_Code =
  | 'NOT_FOUND'
  | 'UNKNOWN';

/**
 * ExperimentVariant is used to assign a user to a given experiment bucket.
 * Next ID: 3
 */
export type OdProtosVariantData_ExperimentVariantInput = {
  experimentId?: InputMaybe<Scalars['String']>;
  variantKey?: InputMaybe<Scalars['String']>;
};

/**
 * FeatureFlagVariant is used to assign a user to a given feature flag bucket.
 * Next ID: 3
 */
export type OdProtosVariantData_FeatureFlagVariantInput = {
  featureFlagId?: InputMaybe<Scalars['String']>;
  variantKey?: InputMaybe<Scalars['String']>;
};

/**
 * Grain is used to identify the entity that will be bucketed and supports multiple identifiers.
 * Next ID: 4
 */
export type OdProtosVariantData_GrainInput = {
  grain?: InputMaybe<OdProtosVariantData_Grain_GrainOneofInput>;
  /** Deprecated: use grain instead */
  id?: InputMaybe<OdProtosVariantData_Grain_IdOneofInput>;
};

export type OdProtosVariantData_Grain_CustomerGrainInput = {
  primaryId?: InputMaybe<OdProtosVariantData_Grain_CustomerGrain_PrimaryIdOneofInput>;
  temporaryId?: InputMaybe<OdProtosVariantData_Grain_CustomerGrain_TemporaryIdOneofInput>;
};

export type OdProtosVariantData_Grain_CustomerGrain_PrimaryIdOneofInput = {
  customerUuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosVariantData_Grain_CustomerGrain_TemporaryIdOneofInput = {
  anonymousId?: InputMaybe<Scalars['String']>;
};

export type OdProtosVariantData_Grain_GrainOneofInput = {
  customer?: InputMaybe<OdProtosVariantData_Grain_CustomerGrainInput>;
  operator?: InputMaybe<OdProtosVariantData_Grain_OperatorGrainInput>;
  property?: InputMaybe<OdProtosVariantData_Grain_PropertyGrainInput>;
};

export type OdProtosVariantData_Grain_IdOneofInput = {
  anonymousId?: InputMaybe<Scalars['String']>;
  customerUuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosVariantData_Grain_OperatorGrainInput = {
  primaryId?: InputMaybe<OdProtosVariantData_Grain_OperatorGrain_PrimaryIdOneofInput>;
};

export type OdProtosVariantData_Grain_OperatorGrain_PrimaryIdOneofInput = {
  humanToken?: InputMaybe<Scalars['String']>;
};

export type OdProtosVariantData_Grain_PropertyGrainInput = {
  primaryId?: InputMaybe<OdProtosVariantData_Grain_PropertyGrain_PrimaryIdOneofInput>;
  temporaryId?: InputMaybe<OdProtosVariantData_Grain_PropertyGrain_TemporaryIdOneofInput>;
};

export type OdProtosVariantData_Grain_PropertyGrain_PrimaryIdOneofInput = {
  addressToken?: InputMaybe<Scalars['String']>;
};

export type OdProtosVariantData_Grain_PropertyGrain_TemporaryIdOneofInput = {
  propertyEngagementId?: InputMaybe<Scalars['String']>;
};

/** Next ID: 4 */
export type OdProtosVariantServices_AddUserToVariantsRequestInput = {
  /** the experiment variants the grain should be bucketed into */
  experiments?: InputMaybe<Array<OdProtosVariantData_ExperimentVariantInput>>;
  /** the feature flag variants the grain should be bucketed into */
  featureFlags?: InputMaybe<Array<OdProtosVariantData_FeatureFlagVariantInput>>;
  /** grain is the identifier for the entity that will be bucketed into a variant. */
  grain?: InputMaybe<OdProtosVariantData_GrainInput>;
};

/** Next ID: 4 */
export type OdProtosVariantServices_GetFeatureFlagsRequestInput = {
  /** grain is the identifier for the entity that will be bucketed into a variant. */
  grain?: InputMaybe<OdProtosVariantData_GrainInput>;
  /** keys are the identifiers of the feature flags. */
  keys?: InputMaybe<Array<Scalars['String']>>;
  /** props is for any additional data that is needed for determining which variant to bucket the entity in. */
  props?: InputMaybe<GoogleProtobuf_StructInput>;
};

/** Next ID: 5 */
export type OdProtosVariantServices_GetVariantRequestInput = {
  /** Set auto_impression to true if you want an impression automatically set. */
  autoImpression?: InputMaybe<Scalars['Boolean']>;
  /** grain is the identifier for the entity that will be bucketed into a variant. */
  grain?: InputMaybe<OdProtosVariantData_GrainInput>;
  /** key is the identifier of an experiment or feature flag. */
  key?: InputMaybe<Scalars['String']>;
  /** props is for any additional data that is needed for determining which variant to bucket the entity in. */
  props?: InputMaybe<GoogleProtobuf_StructInput>;
};

/** Next ID: 4 */
export type OdProtosVariantServices_GetVariantsRequestInput = {
  /** grain is the identifier for the entity that will be bucketed into a variant. */
  grain?: InputMaybe<OdProtosVariantData_GrainInput>;
  /** keys are the identifiers of experiments and/or feature flags. */
  keys?: InputMaybe<Array<Scalars['String']>>;
  /** props is for any additional data that is needed for determining which variant to bucket the entity in. */
  props?: InputMaybe<GoogleProtobuf_StructInput>;
};

/** Next ID: 4 */
export type OdProtosVariantServices_SetImpressionRequestInput = {
  /** grain is the identifier for the entity that will have an impression set. */
  grain?: InputMaybe<OdProtosVariantData_GrainInput>;
  /** key is the identifier of the experiment that the impression is for. */
  key?: InputMaybe<Scalars['String']>;
  /** variant_value is the variant the entity was exposed to. */
  variantValue?: InputMaybe<Scalars['String']>;
};

/**
 * Assignment Event is used to track the assignment of a variant for an entity.
 * Next ID: 4
 */
export type OdProtosVariantV2Data_AssignmentEventInput = {
  /** grain is the identifier for the entity that received an assignment. */
  grain?: InputMaybe<OdProtosVariantV2Data_GrainInput>;
  /** key is the identifier of the flag that the assignment is for. */
  key?: InputMaybe<Scalars['String']>;
  /** variant is the variant the entity was assigned. */
  variant?: InputMaybe<Scalars['String']>;
};

/**
 * ForceExperimentVariant is used to force a user to be assigned a specific variant for an experiment.
 * Next ID: 3
 */
export type OdProtosVariantV2Data_ForceExperimentVariantInput = {
  experimentId?: InputMaybe<Scalars['String']>;
  variant?: InputMaybe<Scalars['String']>;
};

/**
 * ForceFeatureFlagVariant is used to force a user to be assigned a specific variant for a feature flag.
 * Next ID: 3
 */
export type OdProtosVariantV2Data_ForceFeatureFlagVariantInput = {
  featureFlagId?: InputMaybe<Scalars['String']>;
  variant?: InputMaybe<Scalars['String']>;
};

/**
 * Grain is used to identify the entity that will be bucketed and supports multiple identifiers.
 * Next ID: 5
 */
export type OdProtosVariantV2Data_GrainInput = {
  grain?: InputMaybe<OdProtosVariantV2Data_Grain_GrainOneofInput>;
};

export type OdProtosVariantV2Data_Grain_CustomerGrainInput = {
  customerUuid?: InputMaybe<Scalars['String']>;
  temporaryId?: InputMaybe<OdProtosVariantV2Data_Grain_CustomerGrain_TemporaryIdOneofInput>;
};

export type OdProtosVariantV2Data_Grain_CustomerGrain_TemporaryIdOneofInput = {
  anonymousId?: InputMaybe<Scalars['String']>;
};

export type OdProtosVariantV2Data_Grain_GrainOneofInput = {
  customer?: InputMaybe<OdProtosVariantV2Data_Grain_CustomerGrainInput>;
  lead?: InputMaybe<OdProtosVariantV2Data_Grain_LeadGrainInput>;
  operator?: InputMaybe<OdProtosVariantV2Data_Grain_OperatorGrainInput>;
  property?: InputMaybe<OdProtosVariantV2Data_Grain_PropertyGrainInput>;
};

export type OdProtosVariantV2Data_Grain_LeadGrainInput = {
  customer?: InputMaybe<OdProtosVariantV2Data_Grain_CustomerGrainInput>;
  sellerLeadUuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosVariantV2Data_Grain_OperatorGrainInput = {
  humanToken?: InputMaybe<Scalars['String']>;
};

export type OdProtosVariantV2Data_Grain_PropertyGrainInput = {
  addressToken?: InputMaybe<Scalars['String']>;
  temporaryId?: InputMaybe<OdProtosVariantV2Data_Grain_PropertyGrain_TemporaryIdOneofInput>;
};

export type OdProtosVariantV2Data_Grain_PropertyGrain_TemporaryIdOneofInput = {
  propertyEngagementId?: InputMaybe<Scalars['String']>;
};

/** Next ID: 5 */
export type OdProtosVariantV2Services_AssignExperimentVariantRequestInput = {
  /** Set auto_impression to true if you want an impression automatically tracked. */
  autoImpression?: InputMaybe<Scalars['Boolean']>;
  /** grain is the identifier for the entity that a variant is being requested for. */
  grain?: InputMaybe<OdProtosVariantV2Data_GrainInput>;
  /** key is the identifier of an experiment. */
  key?: InputMaybe<Scalars['String']>;
  /** props is for any additional data that is needed for determining eligibility for the experiment. */
  props?: InputMaybe<GoogleProtobuf_StructInput>;
};

/** Next ID: 4 */
export type OdProtosVariantV2Services_AssignFeatureFlagVariantsRequestInput = {
  /** grain is the identifier for the entity that variants are being requested for. */
  grain?: InputMaybe<OdProtosVariantV2Data_GrainInput>;
  /** keys are the identifiers of the feature flags. */
  keys?: InputMaybe<Array<Scalars['String']>>;
  /** props is for any additional data that is needed for determining eligibility for the feature. */
  props?: InputMaybe<GoogleProtobuf_StructInput>;
};

/** Next ID: 4 */
export type OdProtosVariantV2Services_ForceVariantAssignmentsForTestsRequestInput = {
  /** the experiment variants the grain should be bucketed into */
  experiments?: InputMaybe<Array<OdProtosVariantV2Data_ForceExperimentVariantInput>>;
  /** the feature flag variants the grain should be bucketed into */
  featureFlags?: InputMaybe<Array<OdProtosVariantV2Data_ForceFeatureFlagVariantInput>>;
  /** grain is the identifier for the entity that will be assigned the variant. */
  grain?: InputMaybe<OdProtosVariantV2Data_GrainInput>;
};

/** Next ID: 3 */
export type OdProtosVariantV2Services_GetExperimentImpressionsRequestInput = {
  /** grain is the identifier for the entity that received the impressions. */
  grain?: InputMaybe<OdProtosVariantV2Data_GrainInput>;
  /** keys are the identifiers of experiments. */
  keys?: InputMaybe<Array<Scalars['String']>>;
};

/** Next ID: 3 */
export type OdProtosVariantV2Services_GetExperimentVariantsRequestInput = {
  /** grain is the identifier for the entity that the variants were assigned to. */
  grain?: InputMaybe<OdProtosVariantV2Data_GrainInput>;
  /** keys are the identifiers of experiments. */
  keys?: InputMaybe<Array<Scalars['String']>>;
};

/** Next ID: 4 */
export type OdProtosVariantV2Services_TrackExperimentImpressionRequestInput = {
  /** grain is the identifier for the entity that was impressed. */
  grain?: InputMaybe<OdProtosVariantV2Data_GrainInput>;
  /**
   * if this flag is true and this experiment already has an impression, then do not send another one
   * if this flag is false always send an impression
   */
  isIdempotent?: InputMaybe<Scalars['Boolean']>;
  /** key is the identifier of an experiment. */
  key?: InputMaybe<Scalars['String']>;
  /** variant is the experience that was impressed. */
  variant?: InputMaybe<Scalars['String']>;
};

/** Next ID: 2 */
export type OdProtosVariantV2Services_TrackLocalAssignmentsRequestInput = {
  /** Batch of assignment events, maximum batch size of 1000. */
  assignments?: InputMaybe<Array<OdProtosVariantV2Data_AssignmentEventInput>>;
};

/** CapabilitiesValue is a wrapper value for input purposes */
export type OdProtosVendorsData_CapabilitiesValueInput = {
  capabilities?: InputMaybe<Array<OdProtosVendorsData_CapabilityInput>>;
};

/** Next ID: 6 */
export type OdProtosVendorsData_CapabilityInput = {
  capabilityType?: InputMaybe<OdProtosVendorsData_CapabilityType>;
  configuration?: InputMaybe<OdProtosVendorsData_Capability_ConfigurationOneofInput>;
  inspect?: InputMaybe<Scalars['Boolean']>;
  install?: InputMaybe<Scalars['Boolean']>;
  maintenance?: InputMaybe<Scalars['Boolean']>;
  repair?: InputMaybe<Scalars['Boolean']>;
};

/**
 * Next ID: 72
 * NOTE: When you update this, please also create a migration to update dwh_capabilities_view
 */
export type OdProtosVendorsData_CapabilityType =
  | 'AGENT'
  | 'APPLIANCE'
  | 'BATHTUB_RESURFACING'
  | 'BRN_AND_LRR'
  | 'BROKER'
  | 'CABINETS'
  | 'CARPET_CLEANING'
  | 'CHIMNEY'
  | 'CLEANING'
  | 'CLEANING_MAINTENANCE'
  | 'CONCRETE_FLATWORK'
  | 'COUNTERTOP'
  | 'COUNTERTOP_RESURFACING'
  | 'CRAWL_SPACE'
  | 'DATA_LABELING'
  | 'DAY_ONE_WALK'
  | 'DISPATCH'
  | 'ELECTRICAL'
  | 'ENGINEERING'
  | 'FENCING'
  | 'FIREPLACE'
  | 'FLOORING'
  | 'FLOOR_REFINISHING'
  | 'FOUNDATION'
  | 'GARAGE_DOOR'
  | 'GAS_LINE_SERVICE'
  | 'GENERAL_CONTRACTOR'
  | 'GENERAL_INSPECTOR'
  | 'GLASS_WINDOW'
  | 'GUTTERS'
  | 'HANDYMAN'
  | 'HARDSCAPE_LANDSCAPE'
  | 'HOME_ASSESSMENT'
  | 'HVAC'
  | 'IRRIGATION'
  | 'JUNK_REMOVAL'
  | 'LANDSCAPING_MAINTENANCE'
  | 'LAND_SURVEYING'
  | 'LIVING_AREA_MEASUREMENT'
  | 'LOCKSMITH'
  | 'MASONRY'
  | 'MOLD_REMEDIATION'
  | 'ODOR_REMEDIATION'
  | 'OD_SELECT'
  | 'OIL_TANK_SERVICES'
  | 'PAINTING'
  | 'PESTS'
  | 'PHOTOGRAPHY'
  | 'PLUMBING'
  | 'POOL'
  | 'POOL_REPAIR'
  | 'PRESSURE_WASHING'
  | 'RADON_TESTING'
  | 'RENO_VALUATIONS'
  | 'RESTORATION'
  | 'ROOF'
  | 'SECURITY'
  | 'SEPTIC'
  | 'SEWER_INSPECTIONS_AND_REPAIRS'
  | 'SIDING'
  | 'SNOW'
  | 'STRUCTURAL'
  | 'TREE_SERVICES'
  | 'VALUATIONS'
  | 'WELLS'
  | 'WILDLIFE';

export type OdProtosVendorsData_Capability_ConfigurationOneofInput = {
  d1wConfiguration?: InputMaybe<OdProtosVendorsData_D1WConfigurationInput>;
};

/**
 * Next ID: 2
 * NOTE: When you update this, please also create a migration to update dwh_compliance_view
 */
export type OdProtosVendorsData_ComplianceStatus =
  | 'COMPLIANT'
  | 'NOT_COMPLIANT';

/** Next ID: 2 */
export type OdProtosVendorsData_ComplianceStatusValueInput = {
  status?: InputMaybe<OdProtosVendorsData_ComplianceStatus>;
};

export type OdProtosVendorsData_D1WConfigurationInput = {
  maxD1wsPerDay?: InputMaybe<Scalars['Float']>;
  maxD1wsPerWeek?: InputMaybe<Scalars['Float']>;
};

export type OdProtosVendorsData_Persona =
  | 'PARTNER'
  | 'PREFERRED'
  | 'RESERVE'
  | 'ROOKIE'
  | 'STRATEGIC'
  | 'UNSET';

export type OdProtosVendorsData_PersonaValueInput = {
  value?: InputMaybe<OdProtosVendorsData_Persona>;
};

/**
 * Next ID: 3
 * NOTE: When you update this, please also create a migration to update dwh_branches_view
 */
export type OdProtosVendorsData_Status =
  | 'ACTIVE'
  | 'DISABLED'
  | 'PENDING';

/** Next ID: 2 */
export type OdProtosVendorsData_StatusValueInput = {
  value?: InputMaybe<OdProtosVendorsData_Status>;
};

export type OdProtosVendorsData_VendorBranchCreateInput = {
  capabilities?: InputMaybe<Array<OdProtosVendorsData_CapabilityInput>>;
  /** fence_id is the service area of a VendorBranch */
  fenceId?: InputMaybe<Scalars['String']>;
  maxConcurrentWorkOrders?: InputMaybe<Scalars['Float']>;
  name?: InputMaybe<Scalars['String']>;
  organizationId?: InputMaybe<Scalars['String']>;
  persona?: InputMaybe<OdProtosVendorsData_Persona>;
  status?: InputMaybe<OdProtosVendorsData_Status>;
  vendorId?: InputMaybe<Scalars['String']>;
};

export type OdProtosVendorsData_VendorBranchUpdateInput = {
  /** if the field is set all capabilities are replaced by the given capabilities */
  capabilities?: InputMaybe<OdProtosVendorsData_CapabilitiesValueInput>;
  d1wConfiguration?: InputMaybe<OdProtosVendorsData_D1WConfigurationInput>;
  /** fence_id is the service area of a VendorBranch */
  fenceId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  maxConcurrentWorkOrders?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  organizationId?: InputMaybe<Scalars['String']>;
  persona?: InputMaybe<OdProtosVendorsData_PersonaValueInput>;
  status?: InputMaybe<OdProtosVendorsData_StatusValueInput>;
};

/** Next ID: 8 */
export type OdProtosVendorsData_VendorComplianceInput = {
  asOf?: InputMaybe<Scalars['DateTime']>;
  autoInsuranceExpires?: InputMaybe<Scalars['String']>;
  complianceStatus?: InputMaybe<OdProtosVendorsData_ComplianceStatus>;
  generalLiabilityInsuranceExpires?: InputMaybe<Scalars['String']>;
  netvendorId?: InputMaybe<Scalars['String']>;
  workersCompExempt?: InputMaybe<Scalars['Boolean']>;
  workersCompExpires?: InputMaybe<Scalars['String']>;
};

/** Next ID: 4 */
export type OdProtosVendorsData_VendorCreateInput = {
  name?: InputMaybe<Scalars['String']>;
  netvendorId?: InputMaybe<Scalars['String']>;
};

/** Next ID: 9 */
export type OdProtosVendorsData_VendorFeedbackInput = {
  associatedObjectId?: InputMaybe<Scalars['String']>;
  associatedObjectType?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdByUserToken?: InputMaybe<Scalars['String']>;
  /** JSON representing feedback */
  feedback?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  source?: InputMaybe<Scalars['String']>;
  vendorId?: InputMaybe<Scalars['String']>;
};

/** Next ID: 5 */
export type OdProtosVendorsData_VendorUpdateInput = {
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  netvendorId?: InputMaybe<Scalars['String']>;
};

export type OdProtosVendorsServices_AvgTradePartnerFeedbackV1RequestInput = {
  vendorId?: InputMaybe<Scalars['String']>;
};

/** Next ID: 2 */
export type OdProtosVendorsServices_CreateFeedbackForVendorRequestInput = {
  feedback?: InputMaybe<OdProtosVendorsData_VendorFeedbackInput>;
};

/** Next ID: 8 */
export type OdProtosVendorsServices_CreateInvoiceForWorkOrderRequestInput = {
  comment?: InputMaybe<Scalars['String']>;
  homeAddress?: InputMaybe<OdProtosVendorsServices_CreateInvoiceForWorkOrderRequest_AddressInput>;
  lineItems?: InputMaybe<Array<OdProtosVendorsServices_CreateInvoiceForWorkOrderRequest_LineItemInput>>;
  totalCost?: InputMaybe<Scalars['String']>;
  vendorAddress?: InputMaybe<OdProtosVendorsServices_CreateInvoiceForWorkOrderRequest_AddressInput>;
  vendorName?: InputMaybe<Scalars['String']>;
  vendorPhone?: InputMaybe<Scalars['String']>;
  workOrderId?: InputMaybe<Scalars['String']>;
};

export type OdProtosVendorsServices_CreateInvoiceForWorkOrderRequest_AddressInput = {
  city?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  street?: InputMaybe<Scalars['String']>;
};

export type OdProtosVendorsServices_CreateInvoiceForWorkOrderRequest_LineItemInput = {
  description?: InputMaybe<Scalars['String']>;
};

/** Next ID: 2 */
export type OdProtosVendorsServices_CreateOrUpdateVendorComplianceRequestInput = {
  vendorCompliance?: InputMaybe<OdProtosVendorsData_VendorComplianceInput>;
};

/** Next ID: 2 */
export type OdProtosVendorsServices_CreateVendorBranchRequestInput = {
  vendorBranch?: InputMaybe<OdProtosVendorsData_VendorBranchCreateInput>;
};

/** Next ID: 2 */
export type OdProtosVendorsServices_CreateVendorRequestInput = {
  vendor?: InputMaybe<OdProtosVendorsData_VendorCreateInput>;
};

/** Next ID: 3 */
export type OdProtosVendorsServices_GetVendorByExternalIdRequestInput = {
  externalId?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Scalars['String']>;
};

/** Next ID: 2 */
export type OdProtosVendorsServices_IdentifierListRequestInput = {
  ids?: InputMaybe<Array<Scalars['String']>>;
};

/** Next ID: 2 */
export type OdProtosVendorsServices_IdentifierRequestInput = {
  id?: InputMaybe<Scalars['String']>;
};

/** Next ID: 2 */
export type OdProtosVendorsServices_ListExternalIdsRequestInput = {
  source?: InputMaybe<Scalars['String']>;
};

/** Next ID: 1 */
export type OdProtosVendorsServices_SayHelloBenderRequestInput = {
  _empty?: InputMaybe<Scalars['Boolean']>;
};

/** If a variable is not set it won't be used to filter */
export type OdProtosVendorsServices_SearchVendorBranchesPaginatedRequestInput = {
  /**
   * capabilities are filtered as UNIONed
   * I.E. Show me POOL and HVAC vendors
   */
  capabilities?: InputMaybe<Array<OdProtosVendorsData_CapabilityInput>>;
  compliance?: InputMaybe<OdProtosVendorsData_ComplianceStatusValueInput>;
  location?: InputMaybe<OdProtosVendorsServices_SearchVendorBranchesPaginatedRequest_LocationOneofInput>;
  pagination?: InputMaybe<OdProtosCommonPagination_PaginationRequestInput>;
  postalCodes?: InputMaybe<Array<Scalars['String']>>;
  searchString?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<OdProtosVendorsData_StatusValueInput>;
  vendorIds?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosVendorsServices_SearchVendorBranchesPaginatedRequest_LocationOneofInput = {
  addressUuid?: InputMaybe<Scalars['String']>;
  casaAddress?: InputMaybe<OdProtosCasaData_AddressInput>;
  regionIds?: InputMaybe<OdProtosVendorsServices_IdentifierListRequestInput>;
};

export type OdProtosVendorsServices_SearchVendorMatchesRequestInput = {
  addressId?: InputMaybe<Scalars['String']>;
  capability?: InputMaybe<OdProtosVendorsData_CapabilityInput>;
  filterBrnVendors?: InputMaybe<Scalars['Boolean']>;
  /** limit: how many results should be returned */
  limit?: InputMaybe<Scalars['Float']>;
  workOrderKind?: InputMaybe<OdProtosHomeworkData_WorkOrder_Kind>;
};

/** Next ID: 2 */
export type OdProtosVendorsServices_UpdateVendorBranchRequestInput = {
  vendorBranch?: InputMaybe<OdProtosVendorsData_VendorBranchUpdateInput>;
};

/** Next ID: 2 */
export type OdProtosVendorsServices_UpdateVendorRequestInput = {
  vendor?: InputMaybe<OdProtosVendorsData_VendorUpdateInput>;
};

export type OdProtosVisitanteServices_BackfillAppointmentRequestInput = {
  addressToken?: InputMaybe<Scalars['String']>;
  appointmentId?: InputMaybe<Scalars['String']>;
  attendee?: InputMaybe<Scalars['String']>;
  endAt?: InputMaybe<Scalars['DateTime']>;
  startAt?: InputMaybe<Scalars['DateTime']>;
  visitTypeId?: InputMaybe<Scalars['String']>;
};

export type OdProtosVisitanteServices_BackfillFeedbackCreatedRequestInput = {
  addressToken?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  feedbackId?: InputMaybe<Scalars['String']>;
  isTraditional?: InputMaybe<Scalars['Boolean']>;
};

export type OdProtosWatsonData_AiContextInput = {
  enabled?: InputMaybe<Scalars['Boolean']>;
  exclusion?: InputMaybe<Scalars['String']>;
  inclusion?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['String']>;
  repairStandardsDefectIds?: InputMaybe<Array<Scalars['String']>>;
  scope?: InputMaybe<Scalars['String']>;
  summaryItem?: InputMaybe<Scalars['String']>;
};

export type OdProtosWatsonData_Cache =
  | 'COOCCURRANCE'
  | 'PREFILL'
  | 'UNKNOWN';

export type OdProtosWatsonData_NewDefectInput = {
  label?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

export type OdProtosWatsonData_NewFeatureInput = {
  label?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Next Id: 8 */
export type OdProtosWatsonData_PrefillDefinitionForUpsertInput = {
  aiContext?: InputMaybe<OdProtosWatsonData_AiContextInput>;
  issueTaxonomy?: InputMaybe<Scalars['String']>;
  longDescription?: InputMaybe<Scalars['String']>;
  prefillId?: InputMaybe<Scalars['String']>;
  pricingUnit?: InputMaybe<OdProtosCommon_MeasurementUnit>;
  shortDescription?: InputMaybe<Scalars['String']>;
  updatedByEmail?: InputMaybe<Scalars['String']>;
};

/** Next Id: 6 */
export type OdProtosWatsonData_PrefillMarketConfigForUpsertInput = {
  isVisible?: InputMaybe<Scalars['Boolean']>;
  marketIdentifier?: InputMaybe<OdProtosCommonMarket_Market>;
  prefillId?: InputMaybe<Scalars['String']>;
  pricePerUnitUsdCents?: InputMaybe<Scalars['Float']>;
  updatedByEmail?: InputMaybe<Scalars['String']>;
};

export type OdProtosWatsonData_Question_QuestionType =
  | 'DIMENSION_AREA'
  | 'FLOORING_MATERIAL_AND_DIMENSIONS'
  | 'MEASUREMENT'
  | 'MULTI_SELCT'
  | 'NUMERIC'
  | 'SINGLE_SELECT'
  | 'TWO_STEPS_SELECT';

/** Next Id: 3 */
export type OdProtosWatsonData_RepairScopePrefill_State =
  | 'ACTIVE'
  | 'DELETED'
  | 'HIDDEN'
  | 'UNDEFINED';

export type OdProtosWatsonServices_CategoricalDataRequests_GetInput = {
  _empty?: InputMaybe<Scalars['Boolean']>;
};

export type OdProtosWatsonServices_DefectsRequests_InsertInput = {
  defect?: InputMaybe<OdProtosWatsonData_NewDefectInput>;
};

export type OdProtosWatsonServices_FeaturesRequests_InsertInput = {
  feature?: InputMaybe<OdProtosWatsonData_NewFeatureInput>;
};

export type OdProtosWatsonServices_IdentifierRequests_GetInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type OdProtosWatsonServices_IdentifierRequests_ListInput = {
  ids?: InputMaybe<Array<Scalars['String']>>;
};

/** Next Id: 3 */
export type OdProtosWatsonServices_MostFrequentDefectsByFeaturesRequests_GetInput = {
  casaId?: InputMaybe<Scalars['String']>;
};

/** Next Id: 2 */
export type OdProtosWatsonServices_MostFrequentFeaturesByAreasRequests_GetInput = {
  casaId?: InputMaybe<Scalars['String']>;
};

export type OdProtosWatsonServices_PermissionCheckRequests_PrefillWriteAccessFromContextInput = {
  _empty?: InputMaybe<Scalars['Boolean']>;
};

/** Next Id: 2 */
export type OdProtosWatsonServices_RebuildCacheRequests_GetInput = {
  cache?: InputMaybe<OdProtosWatsonData_Cache>;
};

export type OdProtosWatsonServices_RegionalCategoricalDataRequests_GetInput = {
  marketIdentifier?: InputMaybe<OdProtosCommonMarket_Market>;
};

/** Next Id: 3 */
export type OdProtosWatsonServices_RepairRiskFactorRequests_GetInput = {
  casaId?: InputMaybe<Scalars['String']>;
  /** Deprecated. This field will be ignored */
  price?: InputMaybe<Scalars['Float']>;
};

/** Next Id: 3 */
export type OdProtosWatsonServices_RepairScopePrefillRequests_CopyPrefillMarketConfigsInput = {
  destinationMarketIdentifier?: InputMaybe<Scalars['String']>;
  originMarketIdentifier?: InputMaybe<Scalars['String']>;
};

/** Next Id: 4 */
export type OdProtosWatsonServices_RepairScopePrefillRequests_GetByTaxonomyInput = {
  includeHidden?: InputMaybe<Scalars['Boolean']>;
  market?: InputMaybe<OdProtosCommonMarket_Market>;
  taxonomy?: InputMaybe<Scalars['String']>;
};

/** Next Id: 2 */
export type OdProtosWatsonServices_RepairScopePrefillRequests_GetDefinitionsInput = {
  pagination?: InputMaybe<OdProtosCommonPagination_PaginationRequestInput>;
};

/** Next Id: 3 */
export type OdProtosWatsonServices_RepairScopePrefillRequests_GetFromAddressInput = {
  casaId?: InputMaybe<Scalars['String']>;
  includeHidden?: InputMaybe<Scalars['Boolean']>;
};

/** Next Id: 3 */
export type OdProtosWatsonServices_RepairScopePrefillRequests_GetFromMarketInput = {
  includeHidden?: InputMaybe<Scalars['Boolean']>;
  marketIdentifier?: InputMaybe<OdProtosCommonMarket_Market>;
};

/** Next Id: 2 */
export type OdProtosWatsonServices_RepairScopePrefillRequests_GetInput = {
  prefillId?: InputMaybe<Scalars['String']>;
};

/** Next Id: 2 */
export type OdProtosWatsonServices_RepairScopePrefillRequests_GetMarketConfigsInput = {
  market?: InputMaybe<OdProtosCommonMarket_Market>;
};

/** Next Id: 4 */
export type OdProtosWatsonServices_RepairScopePrefillRequests_GetMostFrequentInput = {
  includeHidden?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Float']>;
  marketIdentifier?: InputMaybe<OdProtosCommonMarket_Market>;
};

/** Next Id: 2 */
export type OdProtosWatsonServices_RepairScopePrefillRequests_ListInput = {
  /** prefill market definition IDs */
  ids?: InputMaybe<Array<Scalars['String']>>;
};

/** Next Id: 2 */
export type OdProtosWatsonServices_RepairScopePrefillRequests_UpsertPrefillDefinitionInput = {
  repairScopePrefillDefinition?: InputMaybe<OdProtosWatsonData_PrefillDefinitionForUpsertInput>;
};

/** Next Id: 2 */
export type OdProtosWatsonServices_RepairScopePrefillRequests_UpsertPrefillMarketConfigInput = {
  repairScopePrefillMarketConfig?: InputMaybe<OdProtosWatsonData_PrefillMarketConfigForUpsertInput>;
};

/** TODO: Define enum in web/data or web/customer_ops then deprecate this. */
export type OdProtosWebDataEvents_EventType =
  | 'AGENT_REFERRAL_CREATED'
  | 'AGENT_REFERRAL_OFFER_SMS_SENT'
  | 'AGENT_REFERRAL_UPDATED'
  | 'ANALYTICS'
  | 'ASSOCIATION'
  | 'ASSOCIATION_CHANGED'
  | 'ATTRIBUTE_CHANGED'
  | 'BLACKLIST_UNLOCK_ATTEMPT'
  | 'BUYER_ATTENTION_WORTHY_SIGNAL'
  | 'BUYER_LEAD_FROM_SELLER'
  | 'BUYER_SIGNUP'
  | 'CENTRALIZED_SHOWING_SERVICE_FEEDBACK'
  | 'CODELESS_UNLOCK_FAILED_ATTEMPT'
  | 'CODE_MISSING_UNLOCK_ATTEMPT'
  | 'COMBINED_DECISION_CALL_OUTCOME'
  | 'CONVERSATION_REASSIGNED'
  | 'COVID_SAFETY_WINDOW_UNLOCK_ATTEMPT'
  | 'CUSTOMER_DATA'
  | 'DELIGHTED_SMS_SURVEY_REQUEST'
  | 'DELIGHTED_SURVEY_REQUEST'
  | 'DELIGHTED_SURVEY_RESPONSE'
  | 'DEVICE_INSTALL'
  | 'EMAIL'
  | 'EXTERNAL_INTEREST'
  | 'GRAYLIST_UNLOCK_ATTEMPT'
  | 'HOMEBUILDER_OR_OUTCOME'
  | 'HOME_FEEDBACK_LEFT'
  | 'HOME_ISSUE_REPORTED'
  | 'ID_VERIFICATION'
  | 'INITIAL_UNLOCK_ATTEMPT'
  | 'INSUFFICIENT_VERSION_UNLOCK_ATTEMPT'
  | 'LISTING_INTEREST'
  | 'LISTING_NOT_FOUND_UNLOCK_ATTEMPT'
  | 'LISTING_OFFER_NOTIFICATION'
  | 'LISTING_OFFER_SUBMITTED'
  | 'LISTING_RESERVATION'
  | 'LWOD_OFFER_SENT'
  | 'LWOD_OR_OUTCOME'
  | 'MERGE'
  | 'NEEDS_ATTENTION_FOLLOWUP_TIME'
  | 'NEEDS_ATTENTION_RESOLVED'
  | 'NOTE'
  | 'OFFER_ON_INTERESTED_HOME'
  | 'OFFER_SENT'
  | 'OPEN_LISTINGS_OFFER_STATE'
  | 'OPEN_LISTINGS_TOUR_COMPLETED'
  | 'OR_VA_OUTCOME'
  | 'OUTREACH_OUTCOME'
  | 'OUTSIDE_VISITING_HOURS_UNLOCK_ATTEMPT'
  | 'OUT_OF_OFFICE_REPLY'
  | 'PARTICIPANT_CHANGED'
  | 'PHONE_CALL'
  | 'POST_FRMS_UNTRUSTED_UNLOCK_NOT_SENT'
  | 'PPM_UNLOCK_ATTEMPT'
  | 'PUSH_NOTIFICATION'
  | 'REPEAT_VISIT'
  | 'REQUEST_FOR_LWOD_AGENT'
  | 'SCHEDULE_TOUR_REQUEST'
  | 'SELF_TOUR_FEEDBACK'
  | 'SHOWINGTIME_FEEDBACK'
  | 'SMS'
  | 'SMS_OPT_OUT_NOTIFICATION'
  | 'SOLD_UNLOCK_ATTEMPT'
  | 'SYSTEM'
  | 'TOM_UNLOCK_ATTEMPT'
  | 'TRIAGE_SMS_RESPONSE_PHOTO_UPLOAD'
  | 'TRUST'
  | 'UNDER_COVID_LOCKDOWN'
  | 'UNKNOWN'
  | 'UNKNOWN_ERROR'
  | 'UNLOCK'
  | 'VISIT_EXPERIENCE_FEEDBACK_APPRECIATION'
  | 'VISIT_EXPERIENCE_FEEDBACK_REQUEST'
  | 'VISIT_EXPERIENCE_FEEDBACK_RESPONSE'
  | 'VISIT_EXPERIENCE_SCORE_REQUEST'
  | 'VISIT_EXPERIENCE_SCORE_RESPONSE'
  | 'VOICEMAIL'
  | 'WEB_CHAT';

export type OdProtosWebDataSellDirect_GetContractInfoRequestInput = {
  offerUuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebDataSellDirect_GetServiceProviderInfoRequestInput = {
  offerUuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebDataSellDirect_HoaInfo_Fee_Frequency =
  | 'ANNUALLY'
  | 'MONTHLY'
  | 'ONE_OFF'
  | 'QUARTERLY'
  | 'SEMI_ANNUALLY'
  | 'UNKNOWN';

export type OdProtosWebDataSellDirect_OfferReview_CallType =
  | 'PHONE'
  | 'UNKNOWN_CALL_TYPE'
  | 'VIDEO';

export type OdProtosWebDataSellDirect_OfferReview_CancelReason =
  | 'CUSTOMER_CANNOT_MAKE_IT'
  | 'OPENDOOR_CANNOT_MAKE_IT'
  | 'UNKNOWN_CANCEL_REASON';

export type OdProtosWebDataSellDirect_OfferReview_Outcome =
  | 'AGENT_CUSTOMER_HANDED_OFF_TO_AEP'
  | 'CALL_NOT_COMPLETE_RESCHEDULE_OR'
  | 'CALL_NOT_COMPLETE_SENT_SSVA'
  | 'CAN_COMPLETE_OR'
  | 'DID_NOT_CONVERT'
  | 'NO_SHOW'
  | 'OPENDOOR_CANNOT_PURCHASE_OOBB'
  | 'UNKNOWN';

/**
 * Sell Direct offer price types
 * Next ID: 2
 */
export type OdProtosWebDataSellDirect_PriceType =
  /** final close of escrow fee */
  | 'CLOSE_OF_ESCROW_FEE'
  /** proposed close of escrow fee */
  | 'REQUESTED_CLOSE_OF_ESCROW_FEE'
  | 'UNKNOWN_PRICE_TYPE';

/**
 * Next ID: 8
 * SoT for key events throughout a customer's sell direct experience
 */
export type OdProtosWebDataSellDirect_SellDirectEventType =
  /** The customer's final offer has been sent. Occurs after underwriting has been completed. */
  | 'FINAL_OFFER_SENT'
  /** The customer has viewed their final offer. Correlates with the "accepted" offer state. */
  | 'FINAL_OFFER_VIEWED'
  /** The customer has completed the transaction with Opendoor. Correlates with the "closed" offer state. */
  | 'OFFER_CLOSED'
  /** The customer has signed the purchase agreement. Correlates with the "contingency_released" offer state. */
  | 'OFFER_CONTINGENCY_RELEASED'
  /** The customer did not sign the purchase agreement in the allotted time. Correlates with the "expired" offer state. */
  | 'OFFER_EXPIRED'
  /** The transaction has been canceled by Opendoor or the customer after the contract has been signed. Correlates with the "withdrawn" offer state. */
  | 'OFFER_WITHDRAWN'
  /** The customer's preliminary offer has been sent. Correlates with the "sent" offer state. */
  | 'PRELIM_OFFER_SENT'
  | 'UNKNOWN';

/** Addendum types are defined in web/config/addendum_types.yml.erb */
export type OdProtosWebData_AddendumType =
  | 'APPLIANCES_ADDENDUM'
  | 'CHANGE_ASSESSMENT_ASK_DUE'
  | 'CLOSE_OF_ESCROW'
  | 'CREDIT_TO_SELLER'
  | 'CREDIT_TO_SELLER_CENTS'
  | 'LCO_TERMINATION_ADDENDUM'
  | 'OPTION_EXPIRATION_DATE'
  | 'OTHER'
  | 'SELLER_AGENT_DISCLOSURE'
  | 'SELLER_COMPLETED_REPAIR_CREDIT'
  | 'SELLER_CONTINGENCY_RETURN_CREDIT'
  | 'SELLER_CREDIT_TO_BUYER'
  | 'SELLER_NAME_CHANGE'
  | 'TRADE_IN_INCENTIVE_CREDIT';

export type OdProtosWebData_AvailabityCalendarType =
  | 'ASSESSMENT_VISIT'
  | 'DILIGENCE_VISIT'
  | 'UNKNOWN_VISIT';

export type OdProtosWebData_CoeChangeReason =
  | 'HOA'
  | 'OD_FWT_MISS'
  | 'OD_INSP_AVAILABILITY'
  | 'OD_NEGOTIATING_REPAIRS'
  | 'OD_OTHER'
  | 'OD_REPAIRS_NOT_READY'
  | 'SELLER_CHANGE_IN_PLANS'
  | 'SELLER_HANDLING_REPAIRS'
  | 'SELLER_INFORMATION_SHEET'
  | 'SELLER_MOVING_ISSUE'
  | 'SELLER_NEXT_HOME'
  | 'SELLER_OTHER'
  | 'SELLER_UNREALISTIC_COE'
  | 'SELLER_UNRESPONSIVE'
  | 'SOLAR_TRANSFER'
  | 'TITLE_CLOSING_APPT'
  | 'TITLE_COMMITMENT'
  | 'TITLE_FUNDING'
  | 'TITLE_HOA'
  | 'TITLE_MORTGAGE_PAYOFF'
  | 'TITLE_OTHER'
  | 'TITLE_SURVEY'
  | 'TITLE_UNRESPONSIVE';

export type OdProtosWebData_CoeChangeRequestInput = {
  changeReason?: InputMaybe<OdProtosWebData_CoeChangeReason>;
  newCoeDate?: InputMaybe<OdProtosCommon_DateInput>;
};

export type OdProtosWebData_CancellationRequestInput = {
  primaryReason?: InputMaybe<OdProtosWebData_PrimaryCancellationReason>;
  secondaryReason?: InputMaybe<OdProtosWebData_CancellationRequest_SecondaryReasonOneofInput>;
};

export type OdProtosWebData_CancellationRequest_SecondaryReasonOneofInput = {
  opendoorWalkReason?: InputMaybe<OdProtosWebData_OpendoorWalkSecondaryCancellationReason>;
  sellerInitiatedReason?: InputMaybe<OdProtosWebData_SellerInitiatedSecondaryCancellationReason>;
};

export type OdProtosWebData_CommunicationType =
  /** coming soon: phone comm types */
  | 'EMAIL_CONVERSATION';

export type OdProtosWebData_Customer_TrustLevel =
  | 'ALLOW'
  | 'DENY'
  | 'NEEDS_REVIEW'
  | 'REQUIRES_VERIFICATION'
  | 'UNRESTRICTED';

export type OdProtosWebData_DiligenceVisitStep_DiligenceVisitState =
  | 'COMPLETED'
  | 'IN_REVIEW'
  | 'NOT_SCHEDULED'
  | 'SCHEDULED'
  | 'UNKNOWN_STATE';

export type OdProtosWebData_DiligenceVisitType =
  | 'DILIGENCE_VISIT_TYPE_INSPECTIFY'
  | 'DILIGENCE_VISIT_TYPE_OPENDOOR'
  | 'DILIGENCE_VISIT_TYPE_UNKNOWN';

/** Next ID: 7 */
export type OdProtosWebData_DocumentSource_Type =
  | 'CUSTARD_CUSTOMER'
  | 'HUMAN'
  | 'INSPECTION_REPORT'
  | 'MESSAGE_THREAD'
  | 'ORGANIZATION'
  | 'TASKS_HELLO_SIGN_TASK'
  | 'UNKNOWN';

export type OdProtosWebData_DocumentType =
  | 'ACQ_OUTBOUND_ADDENDUM'
  | 'ADDENDUM'
  | 'CHANGE_CLOSE_OF_ESCROW_ADDENDUM'
  | 'COMBINED_PURCHASE_AGREEMENT_AND_REPAIR_ADDENDUM'
  | 'LATE_CHECKOUT_ADDENDUM'
  | 'REPAIR_ADDENDUM';

/** Next ID: 8 */
export type OdProtosWebData_Document_SourceChannel =
  | 'BWOD_CHANNEL'
  | 'CLOSING_DASHBOARD_CHANNEL'
  | 'HELLO_SIGN_TASK_CHANNEL'
  | 'NOMAD_CHANNEL'
  | 'OFFER_PORTAL_CHANNEL'
  | 'RESALE_CLOSING_DASHBOARD_CHANNEL'
  | 'SETTLER_CHANNEL'
  | 'TOOLING_HUB_CHANNEL'
  | 'UNKNOWN_CHANNEL';

/** Next ID: 184 */
export type OdProtosWebData_Document_Type =
  | 'ABAD'
  | 'ACQ_AGENT_REFERRAL_FORM'
  | 'ACQ_DEED'
  | 'ACQ_EMR'
  | 'ACQ_FINAL_SETTLEMENT_STATEMENT'
  | 'ACQ_HOA_DEMAND'
  | 'ACQ_HOA_GOVERNING_DOCS'
  | 'ACQ_HOA_RECEIPT'
  | 'ACQ_LAND_SURVEY'
  | 'ACQ_NATURAL_HAZARD_DISCLOSURE'
  | 'ACQ_OUTBOUND_ADDENDUM'
  | 'ACQ_T47_RESIDENTIAL_REAL_PROPERTY_AFFIDAVIT'
  | 'ACQ_TAX_CERTIFICATE'
  | 'ACQ_TITLE_COMMITMENT'
  | 'ACQ_UNSIGNED_DRAFT_SETTLEMENT_STATEMENT'
  | 'ADDENDUM'
  | 'AGENT_REFERRAL_W9'
  | 'AMENDMENT'
  | 'APPRAISAL_REPORT'
  | 'ASSESSMENT_REPORT'
  | 'AVID_BUYER'
  | 'AVID_SELLER'
  | 'BINDING_COUNTER_OFFER'
  | 'BINSR'
  | 'BRN_CREDIT_ADDENDUM'
  | 'BRN_RESPONSE'
  | 'BROKER_PRICE_OPINION'
  | 'BUYER_CLOSING_DOCS'
  | 'CANCEL_BINSR'
  | 'CASH_AGREEMENT'
  | 'CASH_PLUS_AGREEMENT'
  | 'CCR'
  | 'CHANGE_CLOSE_OF_ESCROW_ADDENDUM'
  | 'CHECKLIST_HOA_SOU'
  | 'CIC_RECEIPT'
  | 'CLOSING_STATEMENT_FOR_APPROVAL'
  | 'CLUE'
  | 'COMBINED'
  | 'COMBINED_FILE'
  | 'COMBINED_PURCHASE_AGREEMENT_AND_REPAIR_ADDENDUM'
  | 'COMMISSION_INSTRUCTIONS'
  | 'CONFIRMATION_OF_NO_HOA'
  | 'CONTINGENCY'
  | 'CONTINGENCY_REMOVAL'
  | 'COUNTER'
  | 'DEED'
  | 'EOI'
  | 'FINALIZE_BINSR'
  | 'FINAL_OFFER_PDF'
  | 'FINAL_REPAIR_ASK'
  | 'FINAL_SETTLEMENT_STATEMENT'
  | 'FIRPTA'
  | 'HOA'
  | 'HOA_ADDENDUM'
  | 'HOA_BUYER_APPROVAL'
  | 'HOA_CCRS'
  | 'HOA_CCR_AMENDMENT'
  | 'HOA_DEMAND'
  | 'HOA_DEMAND_SUB'
  | 'HOA_ESTOPPEL_LETTER_UPDATED'
  | 'HOA_PACKAGE'
  | 'HOA_STATUS_LETTER'
  | 'HOA_VIOLATION_RESOLUTION'
  | 'HOME_CONDITION_BRANDED'
  | 'HOME_CONDITION_UNBRANDED'
  | 'HOME_WARRANTY_INVOICE'
  | 'INITIAL_BINSR_REQUEST'
  | 'INITIAL_REPAIR_ASK'
  | 'INSPECTION_REPORT_ELECTRICAL'
  | 'INSPECTION_REPORT_FOUNDATION'
  | 'INSPECTION_REPORT_GENERAL'
  | 'INSPECTION_REPORT_HVAC'
  | 'INSPECTION_REPORT_OTHER'
  | 'INSPECTION_REPORT_PLUMBING'
  | 'INSPECTION_REPORT_POOL'
  | 'INSPECTION_REPORT_ROOF'
  | 'INSPECTION_REPORT_SHERLOCK'
  | 'INSPECTION_REPORT_TERMITE'
  | 'INSURANCE_CLAIM'
  | 'INVOICE'
  | 'LAND_SURVEY'
  | 'LATE_CHECKOUT_ADDENDUM'
  | 'LBP_ADDENDUM'
  | 'LEASED_FIXTURES'
  | 'LIEN_SEARCH'
  | 'LIGHTWEIGHT_PURCHASE_AGREEMENT'
  | 'LISTING_DISCLOSURE'
  | 'LISTING_PACKET'
  | 'LOSS_HISTORY_REPORT'
  | 'LWOD_OFFER_REVIEW'
  | 'MARKET_CONDITIONS_ADVISORY'
  | 'MEASUREMENT_REPORT'
  | 'MINERAL_OIL_GAS'
  | 'MISC'
  | 'NAME_CHANGE'
  | 'NON_BINDING_COUNTER_OFFER'
  | 'NON_REQUIRED_DOCS'
  | 'OD_ADDENDUM'
  | 'OD_GUARANTEE'
  | 'OD_SERVICES_ADDENDUM'
  | 'OUTBOUND_PURCHASE_AGREEMENT'
  | 'OWNERS_POLICY'
  /** NOTE, DIFFERENT THAN THE RUBY NAME CAUSE &'s DON'T TRANSLATE WELL */
  | 'O_AND_E_RECEIPT'
  | 'PREPARED_DEED'
  | 'PREQUAL'
  | 'PROOF_OF_FUNDS'
  | 'PROPERTY_DISCLOSURE'
  | 'PROPOSED_AMENDMENT'
  | 'PTL'
  | 'PURCHASE_AGREEMENT'
  | 'PURCHASE_AGREEMENT_TERMINATION'
  | 'REALTOR_DISCLOSURE'
  | 'REIT_RESALE_PURCHASE_CONTRACT'
  | 'REJECTED_SETTLEMENT_STATEMENT'
  | 'RENOVATION_PROPOSAL'
  | 'REPAIR_ADDENDUM'
  | 'RESALE_ADDENDUM'
  | 'RESALE_EMR'
  | 'RESALE_FINAL_SETTLEMENT_STATEMENT'
  | 'RESALE_SIGNED_SELLER_CLOSING_DOCS'
  | 'RS_ADDENDUM'
  | 'RS_ADDENDUM_CONTINGENCY'
  | 'RS_ADDENDUM_HOA'
  | 'RS_ADDENDUM_LBP'
  | 'RS_ADDENDUM_MINERAL_OIL_GAS'
  | 'RS_ADDENDUM_TPF'
  | 'RS_AGENT_REFERRAL_FORM'
  | 'RS_AMENDMENT'
  | 'RS_BRN_CREDIT_ADDENDUM'
  | 'RS_BRN_FINAL'
  | 'RS_BRN_FINAL_CREDIT_ADDENDUM'
  | 'RS_BRN_INITIAL'
  | 'RS_BUYER_CLOSING_DOCS'
  | 'RS_BUYER_INSPECTION_FOUNDATION'
  | 'RS_BUYER_INSPECTION_GENERAL'
  | 'RS_BUYER_INSPECTION_HVAC'
  | 'RS_BUYER_INSPECTION_OTHER'
  | 'RS_BUYER_INSPECTION_ROOF'
  | 'RS_BUYER_INSPECTION_TERMITE'
  | 'RS_CANCEL_DOCUMENT'
  | 'RS_CIC_RECEIPT'
  | 'RS_COUNTER'
  | 'RS_CURE_NOTICE'
  | 'RS_DEED'
  | 'RS_FHA_LOAN_AMENDATORY'
  | 'RS_FINAL_SETTLEMENT_STATEMENT'
  | 'RS_HOA_DEMAND'
  | 'RS_HOA_DOCS'
  | 'RS_HOA_RECEIPT'
  | 'RS_HOME_WARRANTY_INVOICE'
  | 'RS_LAND_SURVEY'
  | 'RS_LOAN_STATUS_UPDATE'
  | 'RS_NATURAL_HAZARD_DISCLOSURE'
  | 'RS_PRE_CLOSE_WALKTHROUGH'
  | 'RS_REALTOR_DISCLOSURE_AGENCY'
  | 'RS_RECEIPT_EM'
  | 'RS_RECEIPT_OTHER'
  | 'RS_SELLER_SIGNED_CLOSING_DOCS'
  | 'RS_SURVEY'
  | 'RS_T47_RESIDENTIAL_REAL_PROPERTY_AFFIDAVIT'
  | 'RS_TAX_CERTIFICATE'
  | 'RS_TITLE_COMMITMENT'
  | 'RS_UNSIGNED_DRAFT_SETTLEMENT_STATEMENT'
  | 'RS_USER_MISC'
  | 'RS_VA_LOAN_AMENDATORY'
  | 'RS_W9'
  | 'SELLER_DISCLOSURES'
  | 'SEPTIC_PERMIT'
  | 'SHERLOCK_ASSESSMENT_REPORT'
  | 'SOLAR_INFORMATION'
  | 'SOLAR_MISC'
  | 'SOLAR_PAYOFF'
  | 'SOLAR_TRANSFER_AGREEMENT'
  | 'SPDS'
  | 'STATE_OR_COUNTY_DISCLOSURES'
  | 'SWU_ESTIMATED_NET_SHEET_PDF'
  | 'TAX_CERTIFICATE'
  | 'THIRD_PARTY_ADDENDUM'
  | 'TITLE_COMMITMENT'
  | 'TITLE_COMPANY_CHANGE'
  | 'TITLE_DISCLOSURE'
  | 'TRUTH_IN_SALE_OF_HOUSING_INSPECTION'
  | 'UCC_TERMINATION'
  | 'UNKNOWN_DOCUMENT';

/** Next ID: 3 */
export type OdProtosWebData_DocumentableInput = {
  id?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<OdProtosWebData_Documentable_Type>;
};

/** Next ID: 13 */
export type OdProtosWebData_Documentable_Type =
  | 'BRN'
  | 'BROKERAGE_OFFER'
  | 'CONSTRUCTION_WORK_ORDER'
  | 'FLIP'
  | 'HOME_CONDITION_REPORT'
  | 'INSPECTION_REPORT'
  | 'INVOICE'
  | 'LISTING'
  | 'LISTING_OFFER'
  | 'MAINTENANCE_SCHEDULE'
  | 'OFFER'
  | 'UNKNOWN'
  | 'WORK_ORDER'
  | 'WORK_ORDER_ITEM';

export type OdProtosWebData_EnsembledValuation_Methodology =
  | 'LIST_PRICE'
  | 'UNDERWRITING'
  | 'UNKNOWN_METHODOLOGY';

export type OdProtosWebData_EnsembledValuation_Status =
  | 'CANCELED'
  | 'COMPLETED'
  | 'DRAFT'
  | 'ESCALATED'
  | 'IN_PROGRESS'
  | 'UNKNOWN_STATUS';

/** Next ID: 8 */
export type OdProtosWebData_ExperimentsEnum =
  | 'GUARANTEE_AT_PRELIM_OFFER'
  | 'LWC_WITH_ALA'
  | 'MSRE_OFFER_LOCK'
  | 'NO_VIRTUAL_ASSESSMENT'
  | 'OFFER_CALENDAR'
  | 'SELLER_LOW_OFFER_CONFIDENCE'
  | 'SELL_THREE_WAYS_MVP_EXPERIENCE'
  | 'SELL_YOUR_WAY_INCLUDE_CASH_PLUS'
  | 'UNKNOWN_EXPERIMENT';

/** Next ID: 4 */
export type OdProtosWebData_ExteriorAssessmentCustomerNotification_NotificationType =
  | 'ALL'
  | 'ARRIVAL_NOTIFICATION'
  | 'PREVIOUS_DAY_NOTIFICATION'
  | 'SCAN_EXPLAINER';

/** Next ID: 2 */
export type OdProtosWebData_ExteriorAssessmentCustomerNotification_Status =
  | 'FAILED'
  | 'SENT';

export type OdProtosWebData_ExternalListingWeeklyFeedback_State =
  | 'DRAFT'
  | 'SUBMITTED'
  | 'UNKNOWN_STATE';

/** Next ID: 2 */
export type OdProtosWebData_FeatureFlagEnum =
  | 'UNEXPIRE_OFFER_WITH_VALID_UNDERWRITING'
  | 'UNKNOWN_FEATURE_FLAG';

export type OdProtosWebData_FileUploadTask_FileType =
  | 'DOCUMENT'
  | 'UNKNOWN_FILE_TYPE'
  | 'VIDEO';

/**
 * The order of these states matters as HighWaterMark in web uses
 * the indices in `at_or_above_mark`? If you have to insert a state in
 * the middle, you may have to rewrite the initializer code for the STATES
 * member of Flips in web, as it currently uses the protobuf values for
 * ordering so any new states will end up at the end.
 */
export type OdProtosWebData_FlipState =
  | 'ACQ_ACCEPTED_LWOD'
  | 'ACQ_ACCEPTED_OTHER'
  | 'ACQ_EXPIRED'
  | 'ACQ_WITHDRAWN'
  | 'CONTINGENCIES_RELEASED'
  | 'DENIED'
  | 'EARLY_ACCESS'
  | 'IN_CONTRACT'
  | 'IN_RENOVATION'
  | 'LATE_CHECKOUT'
  | 'LISTED'
  | 'OFFERED'
  | 'OFFER_REQUESTED'
  | 'PRE_LISTING'
  | 'PRE_RENOVATION'
  | 'REFERRED_TO_MARKETPLACE'
  | 'RESALE_CONTINGENCIES_RELEASED'
  | 'RESALE_IN_CONTRACT'
  | 'RESALE_SOLD_BROKERAGE'
  | 'SOLD'
  | 'THIRD_PARTY_RESALE_CONTINGENCIES_RELEASED'
  /** The 3p states will precede the 1p states for purposes of Web HighWaterMark ordering */
  | 'THIRD_PARTY_RESALE_IN_CONTRACT'
  | 'THIRD_PARTY_SOLD'
  | 'THIRD_PARTY_SOLD_BACKED_OFFER'
  | 'UNDEFINED'
  | 'UNQUALIFIED';

/** Next ID: 3 */
export type OdProtosWebData_GetAllowedToReengageParamsInput = {
  addressToken?: InputMaybe<Scalars['String']>;
  /** last customer interaction date */
  customerInteractionDate?: InputMaybe<Scalars['DateTime']>;
};

export type OdProtosWebData_InspectionStep_InspectionStepState =
  | 'COMPLETED'
  | 'NOT_SCHEDULED'
  | 'SCHEDULED'
  | 'UNKNOWN_STATE';

export type OdProtosWebData_InspectionStep_InspectionType =
  /** Exterior assessment */
  | 'EA'
  /** Home assessment */
  | 'HA'
  | 'UNKNOWN_INSPECTION_TYPE';

export type OdProtosWebData_Inspection_Kind =
  | 'ACQUIRE_INITIAL_INSPECTION'
  | 'AFTER_RENOVATION_INSPECTION'
  | 'BRN_INSPECTION'
  | 'OTHER'
  | 'QUALITY_CONTROL'
  | 'SELF_QUALITY_CONTROL'
  | 'TRAINING_INITIAL_INSPECTION'
  | 'UKNOWN';

export type OdProtosWebData_Inspection_State =
  | 'ACTIVE'
  | 'CANCELED'
  | 'COMPLETED'
  | 'DRAFT'
  | 'SUBMITTED_FOR_REVIEW'
  | 'UNKNOWN';

export type OdProtosWebData_Invoice_State =
  | 'APPROVED'
  | 'DENIED'
  | 'DRAFT'
  | 'NOT_KNOWN'
  | 'REQUEST_APPROVED'
  | 'SUBMITTED';

/**
 * Request object used by ListLeadsRequest.
 * Next ID: 5
 */
export type OdProtosWebData_LeadIdentifierInput = {
  /** the lead is duplicated out of GetLeadRequest for reuse. */
  lead?: InputMaybe<OdProtosWebData_LeadIdentifier_LeadOneofInput>;
};

export type OdProtosWebData_LeadIdentifier_LeadOneofInput = {
  params?: InputMaybe<OdProtosWebData_LeadQueryParamsInput>;
  sellerLeadUuid?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<OdProtosWebData_LeadSourceInput>;
  token?: InputMaybe<Scalars['String']>;
};

/**
 * LeadParams represents parameters to query a lead by (e.g. address token and customer uuid).
 * Next ID: 3
 */
export type OdProtosWebData_LeadQueryParamsInput = {
  addressToken?: InputMaybe<Scalars['String']>;
  customerUuid?: InputMaybe<Scalars['String']>;
};

/**
 * Which system generated the lead.
 * Next ID: 3
 */
export type OdProtosWebData_LeadSourceInput = {
  id?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<OdProtosWebData_LeadSource_Type>;
};

export type OdProtosWebData_LeadSource_Type =
  | 'PARTNERSHIP'
  | 'RECEPTION'
  | 'UNKNOWN_TYPE';

export type OdProtosWebData_Lead_SellYourWayProduct =
  | 'LIST_WITH_CERTAINTY'
  | 'SELL_DIRECT'
  | 'UNKNOWN';

export type OdProtosWebData_LenderInput = {
  contactEmail?: InputMaybe<Scalars['String']>;
  contactName?: InputMaybe<Scalars['String']>;
  contactPhone?: InputMaybe<Scalars['String']>;
  organizationName?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<OdProtosWebData_Lender_LenderType>;
};

export type OdProtosWebData_Lender_LenderType =
  | 'NON_PARTNER'
  | 'OPENDOOR_HOME_LOANS'
  | 'TRUSTED_LENDER'
  | 'UNKNOWN';

export type OdProtosWebData_ListingOfferBrn_FollowHomesProcessCode =
  | 'ACTIVE_ISSUES'
  | 'BUYER_CIRCUMSTANCE'
  | 'BUYER_PREFERENCE'
  | 'COST_DIFFERENCE'
  | 'CREDIT_MAX'
  | 'HIGH_COST_BRN_CREDIT'
  | 'LENDER_REQUIRED_REPAIRS'
  | 'MAJOR_SYSTEMS_STRUCTURAL'
  | 'NEGOTIATION'
  | 'REPAIRS_IN_CONTRACT'
  | 'UNKNOWN';

export type OdProtosWebData_ListingOfferDetails_FinancingStatus =
  | 'CASH'
  | 'CONVENTIONAL'
  | 'DONT_KNOW'
  | 'FHA_LOAN'
  | 'MORTGAGE_PARTNER'
  | 'TX_VA_LOAN'
  | 'USDA_LOAN'
  | 'VA_LOAN';

export type OdProtosWebData_ListingOfferDetails_OfferedByType =
  | 'DIRECT_BUYER'
  | 'MLS_AGENT'
  | 'NON_MLS_AGENT'
  | 'OFFERED_BY_UNKNOWN';

export type OdProtosWebData_ListingOfferDetails_StateTransition =
  | 'ACTIVATE_BACKUP'
  | 'BUYER_WALK'
  | 'CANCEL'
  | 'CLOSE'
  | 'CONTRACT_FALL_THROUGH'
  | 'ENTER_CONTRACT'
  | 'MAKE_BACKUP'
  | 'NEGOTIATE'
  | 'REJECT'
  | 'RELEASE_CONTINGENCY'
  | 'REVERSE_CLOSE'
  | 'SEND_CONTRACT'
  | 'TO_ATTORNEY_REVIEW'
  | 'UNKNOWN'
  | 'WAIT_FOR_SIGNATURE';

export type OdProtosWebData_ListingOfferParticipantType =
  | 'ADDITIONAL_PARTICIPANT'
  | 'AGENT_TC_PARTICIPANT'
  | 'BUYER_2_PARTICIPANT'
  | 'BUYER_PARTICIPANT'
  | 'CONTACT_PARTICIPANT'
  | 'UNKNOWN_PARTICIPANT';

export type OdProtosWebData_ListingOffer_Channel =
  | 'BROKERAGE'
  /** Deprecated */
  | 'BROKERAGE_REFERRAL'
  | 'DIRECT'
  | 'EXCLUSIVE'
  | 'EXCLUSIVE_THIRD_PARTY'
  | 'EXTERNAL'
  | 'OPENDOOR_BACKED_OFFER_RESALE'
  | 'REIT';

/**
 * Next ID: 10
 * Got the values from: https://github.com/opendoor-labs/web/blob/e24581102256fde2c4e9eea679e574477f123db6/app/models/listing_offer.rb#L67
 */
export type OdProtosWebData_ListingOffer_Source =
  | 'APP'
  | 'BUY_DIRECT'
  | 'BUY_WITH_OPENDOOR'
  | 'EXCLUSIVE_SOURCE'
  | 'EXTERNAL_AGENT'
  | 'MANUAL'
  | 'OPEN_LISTINGS'
  | 'PORTAL'
  | 'REIT_BID'
  | 'UNKNOWN';

export type OdProtosWebData_LowOfferConfidenceVariant =
  | 'CONTROL'
  | 'INELIGIBLE'
  | 'TREATMENT'
  | 'UNKNOWN_VARIANT';

export type OdProtosWebData_MaintenanceRequest_FrequencyKind =
  | 'DAY'
  | 'MONTH'
  | 'ONE_OFF'
  | 'WEEK';

export type OdProtosWebData_MaintenanceRequest_Kind =
  | 'CLEANING'
  | 'HVAC'
  | 'LANDSCAPING'
  | 'NONE'
  | 'OTHER'
  | 'POOL'
  | 'SNOW';

export type OdProtosWebData_MaintenanceRequest_State =
  | 'APPROVED'
  | 'CANCELED'
  | 'DENIED'
  | 'INVALID'
  | 'INVOICED'
  | 'MISSED'
  | 'NEEDS_REVIEW'
  | 'PENDING';

/** Next ID: 2 */
export type OdProtosWebData_OrvaCancellationReason =
  | 'CEP_CANNOT_MAKE_IT'
  | 'CUSTOMER_CANNOT_MAKE_IT';

/** Next ID: 5 */
export type OdProtosWebData_OrvaState =
  | 'ORVA_ATTEMPTED'
  | 'ORVA_COMPLETED'
  | 'ORVA_EXPIRED'
  | 'ORVA_NOT_STARTED'
  | 'ORVA_SCHEDULED';

export type OdProtosWebData_OrvaStep_OrvaState =
  | 'COMPLETED'
  | 'NOT_SCHEDULED'
  | 'SCHEDULED'
  | 'UNKNOWN_STATE';

export type OdProtosWebData_OrvaStep_OrvaSubtype =
  | 'DEFAULT'
  | 'UNKNOWN_ORVA_SUBTYPE'
  | 'WITH_EVA';

/** Next ID: 5 */
export type OdProtosWebData_OccupancyAtVa =
  | 'LIVE_FAR_AWAY'
  | 'OTHER_OCCUPANCY'
  | 'OWNER_OCCUPIED'
  | 'TENANT_OCCUPIED'
  | 'UNKNOWN_OCCUPANCY';

/** Next ID: 2 */
export type OdProtosWebData_OfferIdentifiersInput = {
  identifiers?: InputMaybe<Array<Scalars['String']>>;
};

/**
 * OfferQueryParams represents parameters to query offers by (e.g. address token and customer uuid).
 * Next ID: 3
 */
export type OdProtosWebData_OfferQueryParamsInput = {
  addressToken?: InputMaybe<Scalars['String']>;
  customerUuid?: InputMaybe<Scalars['String']>;
  /**
   * Using the human token will only retrieve a limited amount of offers (20) for performance reasons
   * You probably want to use a combination of Lead fetching/Offer fetching in order to grab every single offer for a given human
   */
  humanToken?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebData_OfferReviewStep_OfferReviewState =
  | 'COMPLETED'
  | 'NOT_SCHEDULED'
  | 'SCHEDULED'
  | 'UNKNOWN_STATE';

export type OdProtosWebData_OfferReviewStep_OfferReviewType =
  | 'DEFAULT'
  | 'UNKNOWN_TYPE'
  | 'WITH_VIRTUAL_WALKTHROUGH'
  | 'WITH_VIRTUAL_WALKTHROUGH_AND_EVA';

/** Next ID: 16 */
export type OdProtosWebData_Offer_State =
  | 'ACCEPTED'
  | 'ACCEPTED_OFFER'
  | 'CLOSED'
  | 'CONTINGENCY_RELEASED'
  | 'DRAFT'
  | 'EXPIRED'
  /** final offer is ready, but not yet released to the seller */
  | 'FINAL_OFFER_UNRELEASED'
  | 'IN_CONTRACT'
  | 'READY_TO_SEND'
  | 'REQUESTED_TO_LIST'
  | 'SEND_IN_PROGRESS'
  | 'SENT'
  /** States all defined in web/app/models/offer.rb */
  | 'UNKNOWN'
  | 'VIEWING'
  | 'WAITING_FOR_LIST_WITH_CERTAINTY'
  | 'WAITING_FOR_OTHER_OFFERS'
  | 'WITHDRAWN';

/** Deprecated: Use od_protos.common.sell.OpendoorWalkReason */
export type OdProtosWebData_OpendoorWalkSecondaryCancellationReason =
  | 'ADJACENT_TO_STABILIZATION'
  | 'OPENDOOR_ADDENDUM'
  | 'PRICING_UNCERTAINTY'
  | 'REPAIR_ASSESSMENT_INCOMPLETE'
  | 'REPAIR_SCOPE_OF_WORK_TOO_LARGE'
  | 'SEE_UNDERWRITING';

/** Next ID: 7 */
export type OdProtosWebData_ParticipantInput = {
  /** Time the participant was created at */
  createdAt?: InputMaybe<Scalars['DateTime']>;
  email?: InputMaybe<Scalars['String']>;
  fullName?: InputMaybe<Scalars['String']>;
  humanId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  roles?: InputMaybe<Array<OdProtosWebData_ParticipantRole>>;
};

/** List of known participant roles in web, from web/app/models/concerns/participant_roles.rb */
export type OdProtosWebData_ParticipantRole =
  | 'ACQ_AE'
  | 'ACQ_AGENT'
  | 'ACQ_CX'
  | 'ACQ_EM'
  | 'ACQ_SDR'
  | 'ACQ_TC'
  | 'BROKER'
  | 'CONSISTENT_VALUATIONS'
  | 'ESTIMATOR'
  | 'FINANCE_TC'
  | 'HOLDING_SUPPORT'
  | 'HPM'
  | 'INITIATOR'
  | 'OUTLIER_VALUATIONS'
  | 'PORTFOLIO_MANAGER'
  | 'RENO_MANAGER'
  | 'RESALE_ACX'
  | 'RESALE_AGENT'
  | 'RESALE_CC'
  | 'RESALE_CX_SALES'
  | 'RESALE_CX_SALES_ASSOCIATE'
  | 'RESALE_CX_VISITOR'
  | 'RESALE_TC'
  | 'ROLE_UNKNOWN'
  | 'SECURITY_SUPPORT'
  | 'SELLER_PARTICIPANT'
  | 'SIGNATORY'
  | 'SOFT_RESALE_ACX'
  | 'SYSTEM'
  | 'TC_SUPPORT'
  | 'UNDERWRITER'
  | 'UTILITY_SUPPORT'
  | 'VALUATIONS'
  | 'VENDOR_DRIVER';

/** Next ID: 2 */
export type OdProtosWebData_ParticipantRolesForAccessInput = {
  participantRolesForAccess?: InputMaybe<Array<OdProtosWebData_ParticipantRole>>;
};

export type OdProtosWebData_ParticipantsInput = {
  participants?: InputMaybe<Array<OdProtosWebData_ParticipantInput>>;
};

export type OdProtosWebData_PostDiligenceAddendumType =
  | 'POST_DILIGENCE_ADDENDUM_TYPE_CREDIT_TO_BUYER'
  | 'POST_DILIGENCE_ADDENDUM_TYPE_CREDIT_TO_SELLER'
  | 'POST_DILIGENCE_ADDENDUM_TYPE_UNKNOWN';

/** Deprecated: Use od_protos.common.sell.WalkInitiator */
export type OdProtosWebData_PrimaryCancellationReason =
  | 'OPENDOOR_WALK'
  | 'SELLER_INITIATED';

/** Next ID: 5 */
export type OdProtosWebData_Reaction =
  | 'OKAY'
  | 'SATISFIED'
  | 'UNSATISFIED'
  | 'VERY_SATISFIED'
  | 'VERY_UNSATISFIED';

/**
 * The enum here should match with the following defined in Web
 * https://github.com/opendoor-labs/web/blob/4ec863aaf36a82b0c9df10b4de196020d142c7c6/app/models/virtual_assessment_recording.rb#L8
 * Next ID: 10
 */
export type OdProtosWebData_RecordedFeature =
  | 'BACKYARD'
  | 'FRONTYARD'
  | 'INTERIOR'
  | 'KITCHEN'
  | 'LIVING_ROOM'
  | 'MASTER_BEDROOM_AND_BATHROOM'
  | 'SELLER_DISCLOSURE_DOCUMENT'
  | 'UNKNOWN_RECORDED_FEATURE'
  | 'UTILITIES'
  | 'WHOLE_HOME';

/** From https://github.com/opendoor-labs/web/blob/0d7f7ed424/app/models/renovation.rb#L11-L17 */
export type OdProtosWebData_Renovation_State =
  /** "canceled" */
  | 'CANCELED'
  /** "completed" */
  | 'COMPLETED'
  /** "draft" */
  | 'DRAFT'
  /** "in_progress" */
  | 'IN_PROGRESS'
  /** "setup_completed" */
  | 'SETUP_COMPLETED'
  /** Does not correspond to any state web/models/renovation.rb */
  | 'UNKNOWN';

export type OdProtosWebData_RepairAdjustmentInput = {
  assetIds?: InputMaybe<Array<Scalars['String']>>;
  description?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebData_ResaleConcessionInput = {
  costCents?: InputMaybe<Scalars['Float']>;
  description?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<OdProtosWebData_ResaleConcession_ConcessionType>;
};

export type OdProtosWebData_ResaleConcession_ConcessionType =
  | 'APPRAISAL'
  | 'BUYER_AGENT_CONCESSIONS'
  | 'BUYER_BROKERAGE_PAYMENT'
  | 'CLOSING_COSTS'
  | 'COE_EXTENSION_EXPENSES'
  | 'DIRECT_BUYER_INCENTIVE'
  | 'EXCLUSIVES_BBC_INCENTIVE'
  | 'MORTGAGE_INCENTIVE'
  | 'OPENDOOR_PAID_IN_THIRD_PARTY_TRANSACTION'
  | 'OTHER'
  | 'RATE_LOCK_FEE'
  | 'REINSPECTION_COSTS';

export type OdProtosWebData_ResaleState =
  | 'RESALE_STATE_LISTED'
  | 'RESALE_STATE_NOT_LISTED'
  | 'RESALE_STATE_SOLD'
  | 'RESALE_STATE_UNKNOWN';

/** Next ID: 3 */
export type OdProtosWebData_SsvaState =
  | 'SSVA_COMPLETED'
  | 'SSVA_IN_PROGRESS'
  | 'SSVA_NOT_STARTED';

export type OdProtosWebData_SsvaStep_SsvaState =
  | 'COMPLETED'
  | 'IN_PROGRESS'
  | 'NOT_STARTED'
  | 'UNKNOWN_STATE';

export type OdProtosWebData_SsvaStep_SsvaSubtype =
  | 'DEFAULT'
  | 'DISCLOSURE'
  | 'UNKNOWN_SSVA_SUBTYPE'
  | 'WHOLE_HOME';

export type OdProtosWebData_ScheduleAssessmentInputInput = {
  notes?: InputMaybe<Scalars['String']>;
  offerUuid?: InputMaybe<Scalars['String']>;
  /** required */
  selectedAssessmentTime?: InputMaybe<Scalars['DateTime']>;
  /** Scheduling can be done with either seller_input_uuid or offer_uuid */
  sellerInputUuid?: InputMaybe<Scalars['String']>;
  /** Optional seller contact information */
  sellerName?: InputMaybe<Scalars['String']>;
  sellerPhoneNumber?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebData_ScheduleExteriorAssessmentInputInput = {
  notes?: InputMaybe<Scalars['String']>;
  offerUuid?: InputMaybe<Scalars['String']>;
  /** required */
  selectedInspectionTime?: InputMaybe<Scalars['DateTime']>;
  /** Scheduling can be done with either seller_input_uuid or offer_uuid */
  sellerInputUuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebData_SellWithUpsideState =
  | 'SWU_ACCEPTED'
  | 'SWU_ACQUISITION_PROCEEDS_PAID'
  | 'SWU_CREATED'
  | 'SWU_DECLINED'
  | 'SWU_ELIGIBLE'
  | 'SWU_NOT_ELIGIBLE'
  | 'SWU_RESALE_PROCEEDS_PAID'
  | 'SWU_UNKNOWN'
  | 'SWU_WITHDRAWN';

/** Next ID: 2 */
export type OdProtosWebData_SellerDisclosureState =
  | 'SELLER_DISCLOSURE_COMPLETE'
  | 'SELLER_DISCLOSURE_NEEDED';

/** Deprecated: Use od_protos.common.sell.SellerWalkReason */
export type OdProtosWebData_SellerInitiatedSecondaryCancellationReason =
  | 'CANNOT_FIND_NEW_HOME'
  | 'CLOSE_OF_ESCROW_EXTENSION_DENIED'
  | 'COMPETITION_OR_INVESTOR_OFFER'
  | 'HOA_SOLAR_CITY_INSPECTION'
  | 'HOME_IS_LISTED'
  | 'LEGAL_ISSUES'
  | 'NET_CASH'
  | 'NOT_SELLING'
  | 'OTHER_REASON'
  | 'POST_INSPECTION_OPENDOOR_ASK';

export type OdProtosWebData_SpecialFlagType =
  | 'DANGER'
  | 'DEFAULT'
  | 'INFO'
  | 'SUCCESS'
  | 'WARNING';

export type OdProtosWebData_StructuredTouchpointKind =
  | 'DECISION_CALL'
  | 'FINAL_OFFER_2024_REVIEW'
  | 'FINAL_OFFER_REVIEW'
  | 'OFFER_REVIEW'
  | 'OPTIONS_REVIEW_AND_VIRTUAL_ASSESSMENT'
  | 'RESALE_FEEDBACK_FORM';

export type OdProtosWebData_SubsidyRequestInput = {
  amountCents?: InputMaybe<Scalars['Float']>;
  type?: InputMaybe<OdProtosWebData_SubsidyType>;
};

export type OdProtosWebData_SubsidyType =
  | 'AGENT'
  | 'COMPETITOR_MATCH'
  | 'CX_SUBSIDY'
  | 'EMPLOYEE_SUBSIDY'
  | 'HOME_BUILDER'
  | 'NEW_PARTNERSHIP'
  | 'OPENDOOR_EXCLUSIVES_HIGHER_OFFER_GUARANTEE_INCENTIVE'
  | 'OPENDOOR_EXCLUSIVES_SIGNAGE_INCENTIVE'
  | 'REPAIR_ADJUSTMENT'
  | 'VAL_CREDIT_SUBSIDY';

export type OdProtosWebData_TouchpointableInput = {
  id?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<OdProtosWebData_Touchpointable_Type>;
};

export type OdProtosWebData_Touchpointable_Type =
  | 'ADDRESS'
  | 'LEAD'
  | 'OFFER';

/** Next ID: 3 */
export type OdProtosWebData_TradeInIncentiveType =
  | 'FIXED_AMOUNT'
  | 'PERCENTAGE'
  | 'UNKNOWN';

/** Next ID: 3 */
export type OdProtosWebData_Transaction_OpendoorTransactionType =
  | 'ACQUISITION'
  | 'RESALE'
  | 'UNKNOWN_TRANSACTION_TYPE';

/** Next ID: 8 */
export type OdProtosWebData_Transaction_State =
  | 'CLOSED'
  | 'DISCARDED'
  | 'DRAFT'
  | 'IN_CONTRACT'
  | 'OPEN'
  | 'REJECTED'
  | 'TERMINATED'
  | 'UNKNOWN_STATE';

export type OdProtosWebData_Transaction_TransactionSource_Web_Type =
  | 'LISTING_OFFER'
  | 'OFFER'
  | 'UNKNOWN';

/** Next ID: 6 */
export type OdProtosWebData_Underwriting_State =
  | 'APPROVED'
  | 'COMPLETED'
  | 'DRAFT'
  | 'ESCALATED'
  /** States defined in web/app/models/underwriting.rb */
  | 'UNKNOWN'
  | 'WALKED';

export type OdProtosWebData_Valuation_Methodology =
  | 'DESK'
  | 'LIGHT_WITH_COMPS'
  | 'LIST_PRICE'
  | 'LIST_PRICE_OVERRIDE'
  | 'LIST_PRICE_REVIEW'
  | 'LIST_PRICE_SHADOW'
  | 'ODSELECT_POST_RENO'
  | 'ODSELECT_PRE_RENO'
  | 'OVM_DEBUG'
  /** OVM valuation with CubiCasa home details for post-DV pricing review */
  | 'POST_DV'
  | 'UNDERWRITING'
  | 'UNDERWRITING_ESCALATION'
  | 'UNDERWRITING_SHADOW'
  | 'UNKNOWN_METHODOLOGY'
  | 'VALUATION_REPORT'
  | 'WALK_OVERRIDE';

export type OdProtosWebData_Valuation_Status =
  | 'CANCELED'
  | 'COMPLETED'
  | 'IN_PROGRESS'
  | 'UNKNOWN_STATUS';

/** Next ID: 5 */
export type OdProtosWebData_VirtualAssessmentRecordingInput = {
  fileName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  preSignedRecordingUrl?: InputMaybe<Scalars['String']>;
  recordedFeature?: InputMaybe<OdProtosWebData_RecordedFeature>;
  s3Directory?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebData_VirtualAssessmentStep_VirtualAssessmentType =
  | 'ORVA'
  | 'SSVA'
  | 'UNKNOWN_VIRTUAL_ASSESSMENT_TYPE'
  /** Either VA type is valid */
  | 'VA';

/**
 * Defines who is responsible for doing the Virtual Assessment.
 * Next ID: 3
 */
export type OdProtosWebData_VirtualAssessment_Actor =
  | 'CUSTOMER'
  /** LWC Partner Agent refers to the partner agent assigned to LWC leads */
  | 'LWC_PARTNER_AGENT'
  | 'UNKNOWN_ACTOR';

export type OdProtosWebData_VirtualAssessment_AssessmentType =
  | 'ORVA'
  | 'SSVA'
  | 'UNKNOWN';

export type OdProtosWebEvents_HelloSignContractEvent_Signature_Status =
  | 'AWAITING_SIGNATURE'
  | 'DECLINED'
  | 'SIGNED'
  | 'UNKNOWN';

export type OdProtosWebEvents_ListingEvent_PreviousState =
  | 'ACTIVE'
  | 'ATTORNEY_REVIEW'
  | 'CANCELED'
  | 'CONTINGENCY_RELEASED'
  | 'DRAFT'
  | 'IN_CONTRACT'
  | 'SOLD'
  | 'UNKNOWN';

export type OdProtosWebServicesAddendum_AddendumsForOfferRequestInput = {
  offerId?: InputMaybe<Scalars['Float']>;
  offerUuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesAddendum_CreateAddendumRequestInput = {
  addendumText?: InputMaybe<Scalars['String']>;
  addendumType?: InputMaybe<OdProtosWebData_AddendumType>;
  documentType?: InputMaybe<OdProtosWebData_DocumentType>;
  offerId?: InputMaybe<Scalars['String']>;
  reason?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesAddendum_CreateCreditToBuyerCombinedAmountAddendumRequestInput = {
  additionalCreditAmountCents?: InputMaybe<Scalars['Float']>;
  offerUuid?: InputMaybe<Scalars['String']>;
  send?: InputMaybe<Scalars['Boolean']>;
};

export type OdProtosWebServicesAddendum_CreatePostDiligenceAddendumRequestInput = {
  addendumText?: InputMaybe<Scalars['String']>;
  addendumType?: InputMaybe<OdProtosWebData_PostDiligenceAddendumType>;
  creditAmountCents?: InputMaybe<Scalars['Float']>;
  offerUuid?: InputMaybe<Scalars['String']>;
  send?: InputMaybe<Scalars['Boolean']>;
};

export type OdProtosWebServicesAddendum_SendPostDiligenceAddendumRequestInput = {
  addendumId?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesAgentReferral_CustomerOptionPreference =
  | 'CUSTOMER_OPTION_PREFERENCE_CASH'
  | 'CUSTOMER_OPTION_PREFERENCE_CASH_PLUS'
  | 'CUSTOMER_OPTION_PREFERENCE_LIST'
  | 'CUSTOMER_OPTION_PREFERENCE_UNSPECIFIED';

/** Next ID: 12 */
export type OdProtosWebServicesAgentReferral_ReferToCleverRealEstateRequestInput = {
  answerBathroomCondition?: InputMaybe<Scalars['String']>;
  answerExteriorCondition?: InputMaybe<Scalars['String']>;
  answerKitchenCondition?: InputMaybe<Scalars['String']>;
  answerLivingRoomCondition?: InputMaybe<Scalars['String']>;
  answerSaleTimeline?: InputMaybe<Scalars['String']>;
  customerOptionPreference?: InputMaybe<OdProtosWebServicesAgentReferral_CustomerOptionPreference>;
  email?: InputMaybe<Scalars['String']>;
  fullName?: InputMaybe<Scalars['String']>;
  partnerIdentifier?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  sellerInputUuid?: InputMaybe<Scalars['String']>;
};

/** Next ID: 6 */
export type OdProtosWebServicesAgentReferral_ReferToJasonMitchellGroupRequestInput = {
  email?: InputMaybe<Scalars['String']>;
  fullName?: InputMaybe<Scalars['String']>;
  partnerIdentifier?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  sellerInputUuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesAgentReferral_ReferToMarkSpainRequestInput = {
  email?: InputMaybe<Scalars['String']>;
  fullName?: InputMaybe<Scalars['String']>;
  partnerIdentifier?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  sellerInputUuid?: InputMaybe<Scalars['String']>;
};

/** Next ID: 5 */
export type OdProtosWebServicesAgentReferral_ReferToParnRequestInput = {
  email?: InputMaybe<Scalars['String']>;
  fullName?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  sellerInputUuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesAgentReferral_ReferToRedfinRequestInput = {
  email?: InputMaybe<Scalars['String']>;
  fullName?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  sellerInputUuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesAssessment_ExteriorAssessmentCustomerNotificationRequests_GetCustomerSmsMessageForPhoneNumbersRequestInput = {
  customerPhoneNumber?: InputMaybe<Scalars['String']>;
  eaCustomerNotificationCreatedAt?: InputMaybe<Scalars['DateTime']>;
  opendoorPhoneNumber?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesAssessment_ExteriorAssessmentCustomerNotificationRequests_GetLatestInput = {
  notificationType?: InputMaybe<OdProtosWebData_ExteriorAssessmentCustomerNotification_NotificationType>;
  visitId?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesAssessment_ExteriorAssessmentCustomerNotificationRequests_SendNotificationInput = {
  notificationType?: InputMaybe<OdProtosWebData_ExteriorAssessmentCustomerNotification_NotificationType>;
  visitId?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesAssessment_GetAllAssessmentSlotsRequestInput = {
  addressId?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesAssessment_GetLatestVirtualAssessmentRequestInput = {
  addressId?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesAssessment_GetVirtualAssessmentQuestionsRequestInput = {
  virtualAssessmentId?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesAssessment_ScheduleAssessmentRequestInput = {
  /** required */
  input?: InputMaybe<OdProtosWebData_ScheduleAssessmentInputInput>;
};

export type OdProtosWebServicesAssessment_UpdateAssessmentRequestInput = {
  notes?: InputMaybe<Scalars['String']>;
  selectedAssessmentTime?: InputMaybe<Scalars['DateTime']>;
  sellerLeadUuid?: InputMaybe<Scalars['String']>;
  sellerName?: InputMaybe<Scalars['String']>;
  sellerPhoneNumber?: InputMaybe<Scalars['String']>;
  visitId?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesBap_CreateAuctionForElaFlipRequestInput = {
  flipToken?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesBap_CreateCounterOfferRequestInput = {
  counterOfferBrokerCommissionPercentage?: InputMaybe<Scalars['Float']>;
  counterOfferPriceUsd?: InputMaybe<Scalars['Float']>;
  countererEmail?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Float']>;
};

export type OdProtosWebServicesBap_EscalatePrelistRequestInput = {
  escalatableId?: InputMaybe<Scalars['Float']>;
  escalationNote?: InputMaybe<Scalars['String']>;
  odaUgm?: InputMaybe<Scalars['Float']>;
};

export type OdProtosWebServicesBap_EscalateRequestInput = {
  listingOfferId?: InputMaybe<Scalars['Float']>;
};

export type OdProtosWebServicesBap_GetActiveFlipsWithOffersRequestInput = {
  _empty?: InputMaybe<Scalars['Boolean']>;
};

export type OdProtosWebServicesBap_GetWebBapFlipRequestInput = {
  flipToken?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesBap_GetWebBapListingOffersRequestInput = {
  flipToken?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesBap_UpdateIsFinalOfferRequestInput = {
  isFinalOffer?: InputMaybe<Scalars['Boolean']>;
  listingOfferId?: InputMaybe<Scalars['Float']>;
};

export type OdProtosWebServicesBap_UpsertBidReviewerNoteRequestInput = {
  body?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<OdProtosCommon_DateInput>;
  createdByEmail?: InputMaybe<Scalars['String']>;
  flipToken?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Float']>;
  listingOfferId?: InputMaybe<Scalars['Float']>;
  noteType?: InputMaybe<Scalars['String']>;
  productType?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<OdProtosCommon_DateInput>;
};

export type OdProtosWebServicesBap_UpsertOfferDecisionNoteRequestInput = {
  body?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<OdProtosCommon_DateInput>;
  createdByEmail?: InputMaybe<Scalars['String']>;
  flipToken?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Float']>;
  listingOfferId?: InputMaybe<Scalars['Float']>;
  noteType?: InputMaybe<Scalars['String']>;
  productType?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<OdProtosCommon_DateInput>;
};

export type OdProtosWebServicesBrokerageRegion_GetBrokerageRegionForFlipRequestInput = {
  flipToken?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesBudgetReview_AreReadyForReviewByAddressRequestInput = {
  addressTokens?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosWebServicesBudgetReview_AssessmentStatusRequestInput = {
  addressToken?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesBudgetReview_CompleteRepairBudgetReviewRequestInput = {
  offerUuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesBudgetReview_GetBudgetReviewForOfferRequestInput = {
  offerId?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesBudgetReview_SendSellerRepairDetailsRequestInput = {
  offerId?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesBudgetReview_UpdateRepairScopeRequestInput = {
  customerFacingDescription?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
};

/** Next ID: 3 */
export type OdProtosWebServicesBuyDirect_Requests_CancelBuyDirectOfferInput = {
  listingOfferId?: InputMaybe<Scalars['String']>;
  listingOfferUuid?: InputMaybe<Scalars['String']>;
};

/** Next ID: 12 */
export type OdProtosWebServicesBuyDirect_Requests_CreateBuyDirectOfferInput = {
  addOns?: InputMaybe<Array<OdProtosWebServicesBuyDirect_Requests_CreateBuyDirectOffer_AddOn>>;
  buyer?: InputMaybe<OdProtosWebServicesBuyDirect_Requests_CreateBuyDirectOffer_CustomerInput>;
  closeOfEscrow?: InputMaybe<OdProtosCommon_DateInput>;
  coBuyer?: InputMaybe<OdProtosWebServicesBuyDirect_Requests_CreateBuyDirectOffer_CustomerInput>;
  downPaymentCents?: InputMaybe<Scalars['Float']>;
  financingType?: InputMaybe<OdProtosWebData_ListingOfferDetails_FinancingStatus>;
  listing?: InputMaybe<OdProtosWebServicesBuyDirect_Requests_CreateBuyDirectOffer_ListingOneofInput>;
  preApprovalLetter?: InputMaybe<OdProtosWebServicesBuyDirect_Requests_CreateBuyDirectOffer_DocumentInput>;
  requestedHeroesHomeCredit?: InputMaybe<Scalars['Boolean']>;
  tradeInAddress?: InputMaybe<Scalars['String']>;
};

/** Next ID: 7 */
export type OdProtosWebServicesBuyDirect_Requests_CreateBuyDirectOffer_AddOn =
  /** Replaced by EARLY_MOVEIN */
  | 'EARLY_CHECKOUT'
  | 'EARLY_MOVEIN'
  | 'MOVING_SERVICES'
  | 'NONE'
  | 'OSN_TITLE_ESCROW'
  | 'POWERWALL'
  /** Deprecated: Warranty is available to buyers by default and no longer needs to be selected. */
  | 'WARRANTY';

/** Next ID: 4 */
export type OdProtosWebServicesBuyDirect_Requests_CreateBuyDirectOffer_CustomerInput = {
  email?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
};

/** Next ID: 3 */
export type OdProtosWebServicesBuyDirect_Requests_CreateBuyDirectOffer_DocumentInput = {
  name?: InputMaybe<Scalars['String']>;
  s3Path?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesBuyDirect_Requests_CreateBuyDirectOffer_ListingOneofInput = {
  /** Finds the latest listing for the address. */
  addressToken?: InputMaybe<Scalars['String']>;
  listingId?: InputMaybe<Scalars['String']>;
};

/** Next ID: 3 */
export type OdProtosWebServicesBuyDirect_Requests_NotifyAepOfContingentBuyerInput = {
  listing?: InputMaybe<OdProtosWebServicesBuyDirect_Requests_NotifyAepOfContingentBuyer_ListingOneofInput>;
};

export type OdProtosWebServicesBuyDirect_Requests_NotifyAepOfContingentBuyer_ListingOneofInput = {
  /** Finds the latest listing for the address. */
  addressToken?: InputMaybe<Scalars['String']>;
  listingId?: InputMaybe<Scalars['String']>;
};

/** Next ID: 2 */
export type OdProtosWebServicesBuyDirect_Requests_RequestContractInput = {
  listingOfferUuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesBuyDirect_Responses_CancelBuyDirectOffer_Status =
  | 'FAILURE'
  | 'SUCCESS';

export type OdProtosWebServicesBuyDirect_Responses_NotifyAepOfContingentBuyer_Status =
  | 'FAILURE'
  | 'SUCCESS';

export type OdProtosWebServicesBuyDirect_Responses_RequestContract_Status =
  | 'FAILURE'
  | 'SUCCESS';

export type OdProtosWebServicesCalendly_GetAvailabilityRequestInput = {
  market?: InputMaybe<OdProtosCommonMarket_Market>;
  slug?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesCalendly_GetCalendlyEventRequestInput = {
  calendlyEventId?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesCalendly_GetCalendlyEventsByIdsRequestInput = {
  ids?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosWebServicesCalendly_TrackCalendlySchedulingAvailabilityRequestInput = {
  customerUuid?: InputMaybe<Scalars['String']>;
  market?: InputMaybe<OdProtosCommonMarket_Market>;
  slug?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesCheckout_ApproveDigitalCheckoutRequestInput = {
  offerUuid?: InputMaybe<Scalars['String']>;
  overridePhotoRequirement?: InputMaybe<Scalars['Boolean']>;
};

export type OdProtosWebServicesCheckout_DeleteDigitalCheckoutPhotoRequestInput = {
  digitalCheckoutPhotoId?: InputMaybe<Scalars['Float']>;
};

export type OdProtosWebServicesCheckout_DigitalCheckoutForOfferRequestInput = {
  offerId?: InputMaybe<Scalars['Float']>;
  offerUuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesCheckout_DigitalCheckoutPhotoUploadInput = {
  assetId?: InputMaybe<Scalars['String']>;
  filename?: InputMaybe<Scalars['String']>;
  kind?: InputMaybe<Scalars['String']>;
  mimetype?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesCheckout_GetDigitalCheckoutRequestInput = {
  dcoIds?: InputMaybe<Array<Scalars['Float']>>;
};

export type OdProtosWebServicesCheckout_LockboxShippingInfoRequestInput = {
  offerUuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesCheckout_OverridePhotoRequirementRequestInput = {
  offerUuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesCheckout_SendCheckoutLinkRequestInput = {
  checkoutUrl?: InputMaybe<Scalars['String']>;
  offerUuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesCheckout_UploadDigitalCheckoutPhotosRequestInput = {
  offerUuid?: InputMaybe<Scalars['String']>;
  photos?: InputMaybe<Array<OdProtosWebServicesCheckout_DigitalCheckoutPhotoUploadInput>>;
};

export type OdProtosWebServicesCommunication_GetFlattenedMessagesByClearinghouseTransactionRequestInput = {
  clearinghouseTransactionId?: InputMaybe<Scalars['String']>;
};

/** results are a union of all messages found using the conditions provided */
export type OdProtosWebServicesCommunication_GetFlattenedMessagesByCustomersRequestInput = {
  /** if provided, will return only messages created after this timestamp */
  createdAfter?: InputMaybe<Scalars['DateTime']>;
  /** if provided, result includes messages involving these custard contacts (customers) */
  customerUuids?: InputMaybe<Array<Scalars['String']>>;
  /** if provided, result includes messages involving custard contacts (customers) identified by these numbers */
  phoneNumbers?: InputMaybe<Array<OdProtosCommon_PhoneNumberInput>>;
};

export type OdProtosWebServicesContractChange_AllowContractChangeWithoutApprovalRequestInput = {
  newCoeDate?: InputMaybe<OdProtosCommon_DateInput>;
  offerId?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesContractChange_CancelContractRequestInput = {
  cancellationInfo?: InputMaybe<OdProtosWebData_CancellationRequestInput>;
  offerId?: InputMaybe<Scalars['String']>;
  withdrawalDetails?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesContractChange_ChangeCoeRequestInput = {
  coeChange?: InputMaybe<OdProtosWebData_CoeChangeRequestInput>;
  offerId?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesContractChange_GrantSubsidyRequestInput = {
  approvedSubsidies?: InputMaybe<Array<OdProtosWebData_SubsidyRequestInput>>;
  offerId?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesContractChange_RequestContractChangeRequestInput = {
  additionalContext?: InputMaybe<Scalars['String']>;
  cancellationInfo?: InputMaybe<OdProtosWebData_CancellationRequestInput>;
  offerId?: InputMaybe<Scalars['String']>;
  requestedCoeChange?: InputMaybe<OdProtosWebData_CoeChangeRequestInput>;
  requestedRepairAdjustment?: InputMaybe<OdProtosWebData_RepairAdjustmentInput>;
  subsidyAmountCents?: InputMaybe<Scalars['Float']>;
};

export type OdProtosWebServicesContract_Requests_GetDownloadUrlInput = {
  /** Internally, this is called the hello_sign_task_id */
  id?: InputMaybe<Scalars['Float']>;
};

export type OdProtosWebServicesCustomerData_CustomerDataRequests_GetInput = {
  customerId?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesCustomerEvent_CustomerEventRequests_ListForCustomersInput = {
  contactUuids?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosWebServicesCustomerEvent_CustomerEventRequests_SearchForCustomerInput = {
  /** These fields get added to the query where clause. */
  contactUuid?: InputMaybe<Scalars['String']>;
  eventTypes?: InputMaybe<Array<OdProtosWebDataEvents_EventType>>;
  /** Number of events to return. Default is 10. */
  limit?: InputMaybe<Scalars['Float']>;
};

export type OdProtosWebServicesDiagnostics_ListWebAssetsRequestInput = {
  _empty?: InputMaybe<Scalars['Boolean']>;
};

export type OdProtosWebServicesDocument_BackfillDocReviewRequestInput = {
  endDocReviewId?: InputMaybe<Scalars['Float']>;
  startDocReviewId?: InputMaybe<Scalars['Float']>;
};

export type OdProtosWebServicesDocument_BackfillDocsRequestInput = {
  endDocId?: InputMaybe<Scalars['Float']>;
  startDocId?: InputMaybe<Scalars['Float']>;
};

export type OdProtosWebServicesDocument_DocumentRequests_DeleteInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesDocument_DocumentRequests_GetDeedDetailsByDocumentUuidInput = {
  uuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesDocument_DocumentRequests_GetInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesDocument_DocumentRequests_GetPurchaseDetailsByDocumentUuidInput = {
  uuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesDocument_DocumentRequests_ListInput = {
  params?: InputMaybe<OdProtosWebServicesDocument_DocumentRequests_List_ParamsOneofInput>;
};

/**
 * finds documents for listing offer and all related
 * listing offers up to and including this one
 */
export type OdProtosWebServicesDocument_DocumentRequests_List_AllListingOfferDocumentsInput = {
  listingOfferId?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesDocument_DocumentRequests_List_CurrentLeadDocumentsInput = {
  sellerLeadUuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesDocument_DocumentRequests_List_DocumentableInput = {
  documentable?: InputMaybe<OdProtosWebData_DocumentableInput>;
};

export type OdProtosWebServicesDocument_DocumentRequests_List_IdsInput = {
  ids?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosWebServicesDocument_DocumentRequests_List_ParamsOneofInput = {
  currentLead?: InputMaybe<OdProtosWebServicesDocument_DocumentRequests_List_CurrentLeadDocumentsInput>;
  documentable?: InputMaybe<OdProtosWebServicesDocument_DocumentRequests_List_DocumentableInput>;
  ids?: InputMaybe<OdProtosWebServicesDocument_DocumentRequests_List_IdsInput>;
  listingOffer?: InputMaybe<OdProtosWebServicesDocument_DocumentRequests_List_AllListingOfferDocumentsInput>;
};

export type OdProtosWebServicesDocument_DocumentRequests_ReviewInput = {
  /** Only intended for DMS to web sync */
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  reason?: InputMaybe<Scalars['String']>;
  /** Only intended for DMS to web sync */
  reviewerToken?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<OdProtosWebServicesDocument_DocumentRequests_Review_ReviewStatus>;
  type?: InputMaybe<OdProtosWebServicesDocument_DocumentRequests_Review_ReviewType>;
  /** Only intended for DMS to web sync */
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type OdProtosWebServicesDocument_DocumentRequests_Review_ReviewStatus =
  | 'APPROVED'
  | 'REJECTED';

export type OdProtosWebServicesDocument_DocumentRequests_Review_ReviewType =
  | 'DUE_DILIGENCE'
  | 'TRANSACTION_COORDINATOR'
  | 'UNKNOWN';

export type OdProtosWebServicesDocument_DocumentRequests_UpdateInput = {
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<OdProtosWebData_Document_Type>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type OdProtosWebServicesDocument_DocumentRequests_UploadInput = {
  params?: InputMaybe<OdProtosWebServicesDocument_DocumentRequests_Upload_ParamsOneofInput>;
};

export type OdProtosWebServicesDocument_DocumentRequests_Upload_DocumentInput = {
  /** Only intended for migration from web to DMS */
  createdAt?: InputMaybe<Scalars['DateTime']>;
  documentable?: InputMaybe<OdProtosWebData_DocumentableInput>;
  name?: InputMaybe<Scalars['String']>;
  sourceChannel?: InputMaybe<OdProtosWebData_Document_SourceChannel>;
  /** Only intended for migration from web to DMS */
  sourceType?: InputMaybe<Scalars['String']>;
  /** Only intended for migration from web to DMS */
  sourceTypeId?: InputMaybe<Scalars['String']>;
  storage?: InputMaybe<OdProtosSettlerData_DocumentStorageInput>;
  type?: InputMaybe<OdProtosWebData_Document_Type>;
  /** Only intended for migration from web to DMS */
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** Only intended for migration from web to DMS */
  uuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesDocument_DocumentRequests_Upload_ParamsOneofInput = {
  document?: InputMaybe<OdProtosWebServicesDocument_DocumentRequests_Upload_DocumentInput>;
};

export type OdProtosWebServicesFlip_FlipSolarPanelDataRequestInput = {
  flipToken?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesFlip_GetFlipMetadataRequestInput = {
  flipToken?: InputMaybe<Scalars['String']>;
};

/** Next ID: 3 */
export type OdProtosWebServicesFlip_GetFlipsByContextRequestInput = {
  contextId?: InputMaybe<Scalars['String']>;
  contextType?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesFlip_GetOdaReservePriceRequestInput = {
  flipTokens?: InputMaybe<Array<Scalars['String']>>;
};

/** Next ID: 2 */
export type OdProtosWebServicesFlip_ListFlipsRequestInput = {
  tokens?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosWebServicesFlip_PropertyDetailsFromFlipRequestInput = {
  flipToken?: InputMaybe<Scalars['String']>;
};

/** Next ID: 2 */
export type OdProtosWebServicesFlip_SpecialFlagsRequestInput = {
  addressId?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesHpmGeoAssignment_GetGeoAssignmentsRequestInput = {
  /**
   * The maximum number of items to return. The service may return fewer than
   * this value.
   * If unspecified, at most 200 items will be returned.
   */
  pageSize?: InputMaybe<Scalars['Float']>;
  /**
   * A page token, received from a previous call.
   * Provide this to retrieve the subsequent page.
   *
   * When paginating, all other parameters provided to this endpoint must match
   * the call that provided the page token.
   */
  pageToken?: InputMaybe<Scalars['String']>;
  primaryFilter?: InputMaybe<OdProtosWebServicesHpmGeoAssignment_GetGeoAssignmentsRequest_PrimaryFilterOneofInput>;
};

export type OdProtosWebServicesHpmGeoAssignment_GetGeoAssignmentsRequest_PrimaryFilterOneofInput = {
  humanId?: InputMaybe<Scalars['String']>;
  marketId?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesHpmGeoAssignment_GetPrimaryByAddressRequestInput = {
  addressId?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesHumanAvailability_HumanAvailabilityRequest_BulkGetInput = {
  humanTokens?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosWebServicesHumanAvailability_HumanAvailabilityRequest_GetInput = {
  humanToken?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesHuman_GetAdminPreferenceRequestInput = {
  humanToken?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesHuman_GetHumansRequestInput = {
  humanToken?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosWebServicesHuman_GetVoicemailGreetingRequestInput = {
  humanToken?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesHuman_IsListWithOpendoorAgentRequestInput = {
  humanToken?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesHuman_ResetPasswordRequestInput = {
  humanToken?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesHuman_UpdateFullNameEmailRequestInput = {
  email?: InputMaybe<Scalars['String']>;
  fullName?: InputMaybe<Scalars['String']>;
  humanToken?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesInvoice_ListInvoicesRequestInput = {
  by?: InputMaybe<OdProtosWebServicesInvoice_ListInvoicesRequest_ByOneofInput>;
};

export type OdProtosWebServicesInvoice_ListInvoicesRequest_ByOneofInput = {
  workOrderId?: InputMaybe<Scalars['String']>;
};

/** Next ID: 2 */
export type OdProtosWebServicesIterable_AddressTokenInput = {
  addressToken?: InputMaybe<Scalars['String']>;
};

/** Next ID: 2 */
export type OdProtosWebServicesIterable_AddressTokensInput = {
  addressTokens?: InputMaybe<Array<OdProtosWebServicesIterable_AddressTokenInput>>;
};

/** Next ID: 2 */
export type OdProtosWebServicesIterable_QueueSidekiqJobForCustomerRequestInput = {
  addressTokens?: InputMaybe<OdProtosWebServicesIterable_AddressTokensInput>;
};

export type OdProtosWebServicesListingFeedbacks_CreateListingFeedbackRequestInput = {
  customerId?: InputMaybe<Scalars['String']>;
  labels?: InputMaybe<Array<Scalars['String']>>;
  listingId?: InputMaybe<Scalars['String']>;
  message?: InputMaybe<Scalars['String']>;
  ticketCreationRequested?: InputMaybe<Scalars['Boolean']>;
};

export type OdProtosWebServicesListingFeedbacks_GetListingFeedbackLabelsRequestInput = {
  _empty?: InputMaybe<Scalars['Boolean']>;
};

export type OdProtosWebServicesListingFeedbacks_GetListingFeedbackRequestInput = {
  listingFeedbackId?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesListingFeedbacks_GetListingFeedbacksRequestInput = {
  identifier?: InputMaybe<OdProtosWebServicesListingFeedbacks_GetListingFeedbacksRequest_IdentifierOneofInput>;
};

export type OdProtosWebServicesListingFeedbacks_GetListingFeedbacksRequest_IdentifierOneofInput = {
  customerId?: InputMaybe<Scalars['String']>;
  listingId?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesListingOffer_ListingOfferEmailTemplate =
  | 'BACKUP_POST_FALLTHROUGH'
  | 'BRN_ADDENDUM_RECEIVED'
  | 'BRN_NOT_SUBMITTED_CHECK_IN'
  | 'BRN_RESPONSE_FOLLOWUP'
  | 'BRN_RESPONSE_TO_CONTRACT_ATTORNEY'
  | 'BUY_DIRECT_BRN_ADDENDUM_RECEIVED'
  | 'BUY_DIRECT_BRN_NOT_SUBMITTED_CHECK_IN'
  | 'BUY_DIRECT_BRN_RESPONSE_FOLLOWUP'
  | 'BUY_DIRECT_CREATE_AND_DELIVER_BRN_RESPONSE'
  | 'BUY_DIRECT_EARNEST_MONEY_NOT_DEPOSITED'
  | 'BUY_DIRECT_FINANCING_CONTINGENCY_CHECKIN'
  | 'BUY_DIRECT_SEND_ACCESS_INSTRUCTIONS'
  | 'BUY_DIRECT_SEND_CONTRACT_KICKOFF_EMAIL'
  | 'BUY_DIRECT_SEND_POSTCLOSE_EMAIL'
  | 'BUY_DIRECT_SEND_PRECLOSE_READINESS_EMAIL'
  | 'BUY_DIRECT_SEND_UTILITIES_INFO'
  | 'COMMUNICATE_HIGHEST_AND_BEST_DEADLINE'
  | 'CONFIRM_CLEAR_TO_CLOSE'
  | 'CREATE_AND_DELIVER_BRN_RESPONSE'
  | 'DELIVER_LENDER_REQUIRED_REPAIRS_ADDENDUM'
  | 'EARNEST_MONEY_NOT_DEPOSITED'
  | 'FINANCING_CONTINGENCY_CHECKIN'
  | 'LENDER_REQUIRED_REPAIRS_ADDENDUM_FOLLOWUP'
  | 'NONE'
  | 'ODA_CONTRACT_KICKOFF_EMAIL'
  | 'ODA_DUE_DILIGENCE_EXPIRING'
  | 'ODA_SEND_ACCESS_INSTRUCTIONS'
  | 'OUTSTANDING_UNSIGNED_CONTRACT'
  | 'PRE_CONTRACT_FOLLOWUP'
  | 'SEND_ACCESS_INSTRUCTIONS'
  | 'SEND_ATTORNEY_REVIEW_KICKOFF_EMAIL'
  | 'SEND_CONTRACT_KICKOFF_EMAIL'
  | 'SEND_POSTCLOSE_EMAIL'
  | 'SEND_PRECLOSE_READINESS_EMAIL'
  | 'SEND_UTILITIES_INFO'
  | 'SET_AND_COMMUNICATE_HIGHEST_AND_BEST';

export type OdProtosWebServicesListingOffer_Requests_CounterInput = {
  additionalContractTerms?: InputMaybe<Scalars['String']>;
  appraisalContingencyReleaseDate?: InputMaybe<OdProtosCommon_DateInput>;
  appraisalPeriodDays?: InputMaybe<Scalars['Float']>;
  brokerCommissionRate?: InputMaybe<Scalars['Float']>;
  closeOfEscrow?: InputMaybe<OdProtosCommon_DateInput>;
  concessions?: InputMaybe<Array<OdProtosWebData_ResaleConcessionInput>>;
  downPaymentCents?: InputMaybe<Scalars['Float']>;
  earnestDepositCents?: InputMaybe<Scalars['Float']>;
  expiresAt?: InputMaybe<Scalars['DateTime']>;
  financingContingenciesReleasedDate?: InputMaybe<OdProtosCommon_DateInput>;
  financingPeriodDays?: InputMaybe<Scalars['Float']>;
  homeWarrantyCents?: InputMaybe<Scalars['Float']>;
  homeWarrantyType?: InputMaybe<OdProtosWebServicesListingOffer_Requests_Counter_WarrantyType>;
  inspectionContingenciesReleasedDate?: InputMaybe<OdProtosCommon_DateInput>;
  inspectionPeriodDays?: InputMaybe<Scalars['Float']>;
  isVerbalOffer?: InputMaybe<Scalars['Boolean']>;
  listingOfferId?: InputMaybe<Scalars['String']>;
  priceCents?: InputMaybe<Scalars['Float']>;
  receivedDate?: InputMaybe<OdProtosCommon_DateInput>;
};

export type OdProtosWebServicesListingOffer_Requests_Counter_WarrantyType =
  | 'NO_WARRANTY_INCLUDED'
  | 'WARRANTY_PAID_BY_BUYER'
  | 'WARRANTY_PAID_BY_OPENDOOR';

export type OdProtosWebServicesListingOffer_Requests_CreateListingOfferInput = {
  assignedHumanId?: InputMaybe<Scalars['String']>;
  channel?: InputMaybe<Scalars['String']>;
  closeOfEscrow?: InputMaybe<OdProtosCommon_DateInput>;
  contactEmail?: InputMaybe<Scalars['String']>;
  contactName?: InputMaybe<Scalars['String']>;
  contactPhone?: InputMaybe<Scalars['String']>;
  financingType?: InputMaybe<Scalars['String']>;
  inspectionContingenciesReleased?: InputMaybe<OdProtosCommon_DateInput>;
  listingId?: InputMaybe<Scalars['String']>;
  manualOfferDetails?: InputMaybe<OdProtosWebServicesListingOffer_Requests_ManualOfferDetailsInput>;
  priceCents?: InputMaybe<Scalars['Float']>;
  receivedDate?: InputMaybe<OdProtosCommon_DateInput>;
  source?: InputMaybe<Scalars['String']>;
  warrantyDeclined?: InputMaybe<Scalars['Boolean']>;
};

export type OdProtosWebServicesListingOffer_Requests_FetchListingOfferEmailTemplateInput = {
  emailTemplate?: InputMaybe<OdProtosWebServicesListingOffer_ListingOfferEmailTemplate>;
  listingOfferId?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesListingOffer_Requests_GetBrnForListingOfferRequestInput = {
  listingOfferId?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesListingOffer_Requests_GetClosedListingOfferIdByListingIdInput = {
  listingId?: InputMaybe<Scalars['Float']>;
};

export type OdProtosWebServicesListingOffer_Requests_GetClosedOrPendingListingOfferIdByListingIdInput = {
  listingId?: InputMaybe<Scalars['Float']>;
};

export type OdProtosWebServicesListingOffer_Requests_GetCustomersInput = {
  listingOfferId?: InputMaybe<Scalars['Float']>;
};

export type OdProtosWebServicesListingOffer_Requests_GetListingOfferChainInput = {
  listingOfferId?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesListingOffer_Requests_GetListingOfferInput = {
  identifier?: InputMaybe<OdProtosWebServicesListingOffer_Requests_GetListingOffer_IdentifierOneofInput>;
};

export type OdProtosWebServicesListingOffer_Requests_GetListingOffer_IdentifierOneofInput = {
  listingOfferId?: InputMaybe<Scalars['Float']>;
  listingOfferUuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesListingOffer_Requests_GetParticipantsInput = {
  listingOfferId?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesListingOffer_Requests_ListOffersInput = {
  identifier?: InputMaybe<OdProtosWebServicesListingOffer_Requests_ListOffers_IdentifierOneofInput>;
};

export type OdProtosWebServicesListingOffer_Requests_ListOffers_IdentifierOneofInput = {
  addressToken?: InputMaybe<Scalars['String']>;
  customerId?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesListingOffer_Requests_ManualOfferDetailsInput = {
  isManualOffer?: InputMaybe<Scalars['Boolean']>;
  zendeskTicketId?: InputMaybe<Scalars['Float']>;
};

export type OdProtosWebServicesListingOffer_Requests_SendListingOfferEmailInput = {
  emailTemplate?: InputMaybe<OdProtosWebServicesListingOffer_ListingOfferEmailTemplate>;
  listingOfferId?: InputMaybe<Scalars['String']>;
  message?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesListingOffer_Requests_SetCustomersInput = {
  agentTc?: InputMaybe<OdProtosWebServicesListingOffer_Requests_SetCustomers_AgentTcOneofInput>;
  buyer?: InputMaybe<OdProtosWebServicesListingOffer_Requests_SetCustomers_BuyerOneofInput>;
  buyer2?: InputMaybe<OdProtosWebServicesListingOffer_Requests_SetCustomers_Buyer2OneofInput>;
  contact?: InputMaybe<OdProtosWebServicesListingOffer_Requests_SetCustomers_ContactOneofInput>;
  listingOfferId?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesListingOffer_Requests_SetCustomers_AgentTcOneofInput = {
  agentTcCustomerId?: InputMaybe<Scalars['String']>;
  nullifyAgentTcCustomer?: InputMaybe<Scalars['Boolean']>;
};

export type OdProtosWebServicesListingOffer_Requests_SetCustomers_BasicCustomerInfoInput = {
  name?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesListingOffer_Requests_SetCustomers_Buyer2OneofInput = {
  buyer2CustomerId?: InputMaybe<Scalars['String']>;
  buyer2Info?: InputMaybe<OdProtosWebServicesListingOffer_Requests_SetCustomers_BasicCustomerInfoInput>;
  nullifyBuyer2Customer?: InputMaybe<Scalars['Boolean']>;
};

export type OdProtosWebServicesListingOffer_Requests_SetCustomers_BuyerOneofInput = {
  buyerCustomerId?: InputMaybe<Scalars['String']>;
  buyerInfo?: InputMaybe<OdProtosWebServicesListingOffer_Requests_SetCustomers_BasicCustomerInfoInput>;
  nullifyBuyerCustomer?: InputMaybe<Scalars['Boolean']>;
};

export type OdProtosWebServicesListingOffer_Requests_SetCustomers_ContactOneofInput = {
  contactCustomerId?: InputMaybe<Scalars['String']>;
  nullifyContactCustomer?: InputMaybe<Scalars['Boolean']>;
};

export type OdProtosWebServicesListingOffer_Requests_SetLenderRequestInput = {
  lender?: InputMaybe<OdProtosWebData_LenderInput>;
  listingOfferId?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesListingOffer_Requests_SetListingOfferTagsInput = {
  listingOfferId?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosWebServicesListingOffer_Requests_SetStatusNoteRequestInput = {
  listingOfferId?: InputMaybe<Scalars['String']>;
  statusNote?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesListing_BuyerWalkRequestInput = {
  buyerWalkCode?: InputMaybe<OdProtosWebServicesListing_BuyerWalkRequest_BuyerWalkCode>;
  buyerWalkReason?: InputMaybe<Scalars['String']>;
  propertyEngagementId?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesListing_BuyerWalkRequest_BuyerWalkCode =
  | 'APPRAISAL_CONCERN'
  | 'BUYING_OTHER_HOME'
  | 'BUYING_WITH_AGENT'
  | 'FINANCING_ISSUES'
  | 'HOME_CONDITION'
  | 'MULTI_OFFER'
  | 'NEIGHBORHOOD'
  | 'OTHER'
  | 'PRICING'
  | 'SPECIAL_TAX_ASSESSMENT'
  | 'WENT_DARK';

export type OdProtosWebServicesListing_CancelListingRequestInput = {
  propertyEngagementId?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesListing_CancelViewingAppointmentsRequestInput = {
  listingId?: InputMaybe<Scalars['String']>;
  until?: InputMaybe<Scalars['DateTime']>;
};

export type OdProtosWebServicesListing_ClaimWebDiscoTaskRequestInput = {
  email?: InputMaybe<Scalars['String']>;
  flipToken?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesListing_CloseListingRequestInput = {
  isSold?: InputMaybe<Scalars['Boolean']>;
  propertyEngagementGroupId?: InputMaybe<Scalars['String']>;
  propertyEngagementId?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesListing_CreateListingRequestInput = {
  acqCoeDate?: InputMaybe<OdProtosCommon_DateInput>;
  propertyEngagementGroupId?: InputMaybe<Scalars['String']>;
  propertyEngagementId?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesListing_DeleteListingPhotosRequestInput = {
  deletedListingPhotoIds?: InputMaybe<Array<Scalars['String']>>;
  listingUuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesListing_DropListPricesRequestInput = {
  updates?: InputMaybe<Array<OdProtosWebServicesListing_DropListPricesRequest_ListPriceUpdateInput>>;
};

export type OdProtosWebServicesListing_DropListPricesRequest_ListPriceUpdateInput = {
  listPriceInDollars?: InputMaybe<Scalars['Float']>;
  listingId?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesListing_GenerateTaskRequestInput = {
  propertyEngagementId?: InputMaybe<Scalars['String']>;
};

/** Next ID: 3 */
export type OdProtosWebServicesListing_GetExternalListingRequestInput = {
  identifier?: InputMaybe<OdProtosWebServicesListing_GetExternalListingRequest_IdentifierOneofInput>;
};

export type OdProtosWebServicesListing_GetExternalListingRequest_IdentifierOneofInput = {
  /** listing_id is the serial id */
  listingId?: InputMaybe<Scalars['String']>;
  listingUuid?: InputMaybe<Scalars['String']>;
  propertyEngagementGroupId?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesListing_GetListingDescriptionRequestInput = {
  additionalAttributes?: InputMaybe<Array<Scalars['String']>>;
  additionalInstructions?: InputMaybe<Scalars['String']>;
  addressToken?: InputMaybe<Scalars['String']>;
  fetchAttributesFromHds?: InputMaybe<Scalars['Boolean']>;
  includeAddressLine?: InputMaybe<Scalars['Boolean']>;
  regenerate?: InputMaybe<Scalars['Boolean']>;
};

export type OdProtosWebServicesListing_GetListingIndexInfoRequestInput = {
  listingUuid?: InputMaybe<Scalars['String']>;
};

/** Next ID: 5 */
export type OdProtosWebServicesListing_GetListingRequestInput = {
  identifier?: InputMaybe<OdProtosWebServicesListing_GetListingRequest_IdentifierOneofInput>;
};

export type OdProtosWebServicesListing_GetListingRequest_IdentifierOneofInput = {
  /** Finds the latest listing for the address. */
  addressToken?: InputMaybe<Scalars['String']>;
  flipToken?: InputMaybe<Scalars['String']>;
  /** listing_id is the serial id */
  listingId?: InputMaybe<Scalars['String']>;
  listingUuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesListing_GetListingsBasicByAddressTokensRequestInput = {
  addressTokens?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosWebServicesListing_GetListingsByAddressTokensRequestInput = {
  addressTokens?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosWebServicesListing_GetListingsByFlipTokensRequestInput = {
  flipTokens?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosWebServicesListing_GetListingsRequestInput = {
  /** The ids of the listings to return */
  listingIds?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosWebServicesListing_GetPriceDropStatusRequestInput = {
  jobToken?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesListing_GetPriceDropStatusResponse_PriceDropStatusType =
  | 'ENQUEUED'
  | 'FAILED'
  | 'NOT_FOUND'
  | 'RUNNING'
  | 'SUCCEEDED'
  | 'UNKNOWN';

export type OdProtosWebServicesListing_GetUploadHistoryDocsRequestInput = {
  flipToken?: InputMaybe<Scalars['String']>;
};

/** Next ID: 3 */
export type OdProtosWebServicesListing_ListExternalListingWeeklyFeedbackRequestInput = {
  identifier?: InputMaybe<OdProtosWebServicesListing_ListExternalListingWeeklyFeedbackRequest_IdentifierOneofInput>;
};

export type OdProtosWebServicesListing_ListExternalListingWeeklyFeedbackRequest_IdentifierOneofInput = {
  flipToken?: InputMaybe<Scalars['String']>;
  listingId?: InputMaybe<Scalars['String']>;
};

/** Next ID: 3 */
export type OdProtosWebServicesListing_ListVisitingCustomersForListingRequestInput = {
  identifier?: InputMaybe<OdProtosWebServicesListing_ListVisitingCustomersForListingRequest_IdentifierOneofInput>;
};

export type OdProtosWebServicesListing_ListVisitingCustomersForListingRequest_IdentifierOneofInput = {
  addressId?: InputMaybe<Scalars['String']>;
  listingId?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesListing_ListingStatusUpdateRequestInput = {
  offerPropertyEngagementId?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesListing_RejectRequestInput = {
  propertyEngagementId?: InputMaybe<Scalars['String']>;
  rejectCode?: InputMaybe<OdProtosWebServicesListing_RejectRequest_RejectCode>;
  rejectReason?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesListing_RejectRequest_RejectCode =
  | 'BWA'
  | 'COE_TOO_LONG'
  | 'CONTINGENT_OFFER'
  | 'FHA_INELIGIBLE'
  | 'MULTI_OFFER'
  | 'NOT_FINANCIALLY_QUALIFIED'
  | 'OFFER_BELOW_ACCEPTABLE'
  | 'OTHER'
  | 'UNACCEPTABLE_RENO_REQUEST';

export type OdProtosWebServicesListing_SearchListingType =
  /**
   * Homes that are currently displayed as available to buy or available
   * soon on the exclusives platform
   */
  | 'EXCLUSIVE_LISTINGS'
  | 'UNKNOWN_SEARCH_TYPE';

export type OdProtosWebServicesListing_SearchListingsRequestInput = {
  externalListing?: InputMaybe<Scalars['Boolean']>;
  /** if non-nil, filter on listings in any of the given states */
  listingStates?: InputMaybe<Array<Scalars['String']>>;
  /** if non-nil, return all listings with the given security_system_type */
  securitySystemType?: InputMaybe<Scalars['String']>;
  traditionalListing?: InputMaybe<Scalars['Boolean']>;
};

export type OdProtosWebServicesListing_SetListingTypeRequestInput = {
  addressToken?: InputMaybe<Scalars['String']>;
  isTraditionalListing?: InputMaybe<Scalars['Boolean']>;
};

export type OdProtosWebServicesListing_UpdateListingDescriptionRequestInput = {
  addressToken?: InputMaybe<Scalars['String']>;
  listingDescription?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesListing_UpdateListingPhotosRequestInput = {
  listingUuid?: InputMaybe<Scalars['String']>;
  updatedListingPhotos?: InputMaybe<Array<OdProtosWebServicesListing_UpdateListingPhotosRequest_UpdatedListingPhotoInput>>;
};

export type OdProtosWebServicesListing_UpdateListingPhotosRequest_UpdatedListingPhotoInput = {
  photoId?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<Scalars['Float']>;
};

export type OdProtosWebServicesListing_UploadDiscoDocToAdminRequestInput = {
  completeTask?: InputMaybe<Scalars['Boolean']>;
  email?: InputMaybe<Scalars['String']>;
  fileName?: InputMaybe<Scalars['String']>;
  flipToken?: InputMaybe<Scalars['String']>;
  keyForS3?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesMaintenance_AddWebPhotoRequestInput = {
  key?: InputMaybe<Scalars['String']>;
  kind?: InputMaybe<Scalars['String']>;
  picableId?: InputMaybe<Scalars['String']>;
  picableType?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesMaintenance_AddressRequestInput = {
  addressId?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesMaintenance_CreateMaintenanceInvoiceRequestInput = {
  endPeriodOn?: InputMaybe<OdProtosCommon_DateInput>;
  organizationId?: InputMaybe<Scalars['String']>;
  startPeriodOn?: InputMaybe<OdProtosCommon_DateInput>;
};

export type OdProtosWebServicesMaintenance_GetBeforeAndAfterPhotosRequestInput = {
  maintenanceRequestId?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesMaintenance_GetFeedbackRequestInput = {
  maintenanceRequestId?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesMaintenance_GetInvoiceableCentsForVendorAndPeriodRequestInput = {
  endPeriodOn?: InputMaybe<OdProtosCommon_DateInput>;
  startPeriodOn?: InputMaybe<OdProtosCommon_DateInput>;
  vendorOrganizationId?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesMaintenance_GetMessageThreadRequestInput = {
  requestType?: InputMaybe<OdProtosWebServicesMaintenance_GetMessageThreadRequest_RequestTypeOneofInput>;
};

export type OdProtosWebServicesMaintenance_GetMessageThreadRequest_RequestTypeOneofInput = {
  requestIdentifier?: InputMaybe<OdProtosWebServicesMaintenance_MaintenanceRequestIdentifierRequestInput>;
};

export type OdProtosWebServicesMaintenance_GetOnsiteWorkersForOrgRequestInput = {
  organizationId?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesMaintenance_GetPhotoRequirementsRequestInput = {
  maintenanceRequestId?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesMaintenance_GetPresignedUploadUrlRequestInput = {
  fileName?: InputMaybe<Scalars['String']>;
  maintenanceRequestId?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesMaintenance_ListMaintenanceRequestsForVendorRequestInput = {
  endPeriodOn?: InputMaybe<OdProtosCommon_DateInput>;
  startPeriodOn?: InputMaybe<OdProtosCommon_DateInput>;
  states?: InputMaybe<Array<OdProtosWebData_MaintenanceRequest_State>>;
  vendorOrganizationId?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesMaintenance_ListMaintenanceRequestsRequestInput = {
  pagination?: InputMaybe<OdProtosWebServicesMaintenance_PaginationRequestInput>;
  requestType?: InputMaybe<OdProtosWebServicesMaintenance_ListMaintenanceRequestsRequest_RequestTypeOneofInput>;
};

export type OdProtosWebServicesMaintenance_ListMaintenanceRequestsRequest_RequestTypeOneofInput = {
  addressRequest?: InputMaybe<OdProtosWebServicesMaintenance_AddressRequestInput>;
  vendorRequest?: InputMaybe<OdProtosWebServicesMaintenance_ListMaintenanceRequestsForVendorRequestInput>;
};

export type OdProtosWebServicesMaintenance_MaintenanceRequestApproveRequestInput = {
  approvalFeedback?: InputMaybe<Scalars['String']>;
  maintenanceRequestId?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesMaintenance_MaintenanceRequestCancelRequestInput = {
  maintenanceRequestId?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesMaintenance_MaintenanceRequestDenyRequestInput = {
  denialFeedback?: InputMaybe<Scalars['String']>;
  maintenanceRequestId?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesMaintenance_MaintenanceRequestIdentifierRequestInput = {
  maintenanceRequestId?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesMaintenance_MarkMaintenanceRequestAsMissedRequestInput = {
  maintenanceRequestId?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesMaintenance_MarkMaintenanceRequestAsNeedsReviewRequestInput = {
  maintenanceRequestId?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesMaintenance_PaginationRequestInput = {
  offset?: InputMaybe<Scalars['Float']>;
  pageSize?: InputMaybe<Scalars['Float']>;
};

export type OdProtosWebServicesMaintenance_PostToMessageThreadRequestInput = {
  authorUserToken?: InputMaybe<Scalars['String']>;
  content?: InputMaybe<Scalars['String']>;
  messageThreadId?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesMaintenance_RemoveWebPhotoRequestInput = {
  kind?: InputMaybe<Scalars['String']>;
  originalFilename?: InputMaybe<Scalars['String']>;
  picableId?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesMaintenance_UpdateMaintenanceRequestScheduledDateRequestInput = {
  maintenanceRequestId?: InputMaybe<Scalars['String']>;
  newScheduledDate?: InputMaybe<OdProtosCommon_DateInput>;
};

export type OdProtosWebServicesMaintenance_UpdateOnsiteWorkerRequestInput = {
  maintenanceRequestId?: InputMaybe<Scalars['String']>;
  memberToken?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesMaintenance_ValidateInvoiceablePeriodSignatureRequestInput = {
  endPeriod?: InputMaybe<Scalars['String']>;
  organizationId?: InputMaybe<Scalars['String']>;
  signature?: InputMaybe<Scalars['String']>;
  startPeriod?: InputMaybe<Scalars['String']>;
};

/** Next ID: 2 */
export type OdProtosWebServicesMarketing_GetAllowedToReengageBulkRequestInput = {
  getAllowedToReengageParams?: InputMaybe<Array<OdProtosWebData_GetAllowedToReengageParamsInput>>;
};

/** Next ID: 4 */
export type OdProtosWebServicesMarketing_GetAllowedToReengageRequestInput = {
  addressToken?: InputMaybe<Scalars['String']>;
};

/** Next ID: 2 */
export type OdProtosWebServicesMarketing_UnsubscribeMailerRequestInput = {
  addressToken?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesMarketplace_SendSavedSearchAgentEmailRequestInput = {
  agentId?: InputMaybe<Scalars['String']>;
  savedSearchId?: InputMaybe<Scalars['String']>;
};

/** Next ID: 2 */
export type OdProtosWebServicesMultipartUploads_AbortMultipartUploadRequestInput = {
  uploadToken?: InputMaybe<Scalars['String']>;
};

/** Next ID: 3 */
export type OdProtosWebServicesMultipartUploads_CompleteMultipartUploadRequestInput = {
  /**
   * Array of MultipartUploadPart entries, each containing the etag returned from S3 for the successful
   *   part upload as well as the part index the etag corresponds to. The server will order these parts
   *   and call S3 to complete the upload here:
   *   https://github.com/fog/fog-aws/blob/66a4183efb4ae4aa392fa7694ce2258636c6a714/lib/fog/aws/requests/storage/complete_multipart_upload.rb#L27
   */
  multipartUploadParts?: InputMaybe<Array<OdProtosWebServicesMultipartUploads_MultipartUploadPartInput>>;
  uploadToken?: InputMaybe<Scalars['String']>;
};

/** Next ID: 4 */
export type OdProtosWebServicesMultipartUploads_GenerateMultipartUploadUrlsRequestInput = {
  partIndexEnd?: InputMaybe<Scalars['Float']>;
  /**
   * The response will include a unique pre-signed URL for each file part on the range
   *   [part_index_start, part_index_end]. The client, not the server, will dictate how
   *   many parts to split the upload into (based on the full upload size).
   */
  partIndexStart?: InputMaybe<Scalars['Float']>;
  uploadToken?: InputMaybe<Scalars['String']>;
};

/** Next ID: 4 */
export type OdProtosWebServicesMultipartUploads_InitiateMultipartUploadRequestInput = {
  bucketName?: InputMaybe<Scalars['String']>;
  contentType?: InputMaybe<Scalars['String']>;
  filePath?: InputMaybe<Scalars['String']>;
};

/** Next ID: 3 */
export type OdProtosWebServicesMultipartUploads_MultipartUploadPartInput = {
  etag?: InputMaybe<Scalars['String']>;
  partNumber?: InputMaybe<Scalars['Float']>;
};

export type OdProtosWebServicesNote_CreateNoteRequestInput = {
  body?: InputMaybe<Scalars['String']>;
  contextIdentifier?: InputMaybe<Scalars['String']>;
  contextType?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesNote_GetNoteRequestInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesOffer_Requests_GetOfferIdByFlipTokenInput = {
  flipToken?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesOffer_Requests_GetOffersByOfferIdsInput = {
  offerIds?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosWebServicesOperator_Requests_GetOperatorDataInput = {
  humanToken?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesPassword_Requests_ResetPasswordInput = {
  newPassword?: InputMaybe<Scalars['String']>;
  resetPasswordToken?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesPassword_Requests_UpdatePasswordInput = {
  currentPassword?: InputMaybe<Scalars['String']>;
  newPassword?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesPassword_Requests_ValidateResetPasswordTokenInput = {
  resetPasswordToken?: InputMaybe<Scalars['String']>;
};

/** Next ID: 2 */
export type OdProtosWebServicesPasswordless_GetActiveTokenRequestInput = {
  params?: InputMaybe<OdProtosWebServicesPasswordless_GetActiveTokenRequest_ParamsOneofInput>;
};

export type OdProtosWebServicesPasswordless_GetActiveTokenRequest_ParamsOneofInput = {
  email?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesPasswordless_HumanIDsInput = {
  humanIds?: InputMaybe<Array<Scalars['String']>>;
};

/** Next ID: 4 */
export type OdProtosWebServicesPasswordless_RequestNewTokenRequestInput = {
  email?: InputMaybe<Scalars['String']>;
  redirectUrl?: InputMaybe<Scalars['String']>;
  token?: InputMaybe<Scalars['String']>;
};

/** Next ID: 2 */
export type OdProtosWebServicesPasswordless_RequestNewTokensRequestInput = {
  humanIds?: InputMaybe<OdProtosWebServicesPasswordless_HumanIDsInput>;
};

export type OdProtosWebServicesPricingQa_GetPricingQaForOfferRequestInput = {
  offerId?: InputMaybe<Scalars['String']>;
};

/** Next ID: 2 */
export type OdProtosWebServicesPricingQa_ListUnderwritingsRequestInput = {
  underwritingIds?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosWebServicesProductGuidance_GetProductGuidanceRequestInput = {
  leadToken?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesProject_GetFlipForProjectRequestInput = {
  /** project_id = Homework.Project.Id */
  projectId?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesRenovation_ListRenovationsRequestInput = {
  ids?: InputMaybe<Array<Scalars['Float']>>;
};

export type OdProtosWebServicesSellDirect_AssignExperiencePartnerRequestInput = {
  experiencePartnerToken?: InputMaybe<Scalars['String']>;
  offerId?: InputMaybe<Scalars['String']>;
};

/** Next ID: 3 */
export type OdProtosWebServicesSellDirect_CalculateCloseOfEscrowCostRequestInput = {
  closeOfEscrowDate?: InputMaybe<OdProtosCommon_DateInput>;
  offerUuid?: InputMaybe<Scalars['String']>;
};

/** Next ID: 3 */
export type OdProtosWebServicesSellDirect_CalculateLateCheckoutCostRequestInput = {
  lateCheckoutDate?: InputMaybe<OdProtosCommon_DateInput>;
  offerUuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesSellDirect_CancelLateCheckoutRequestInput = {
  offerId?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesSellDirect_CancelOrvaRequestInput = {
  cancelReason?: InputMaybe<OdProtosWebData_OrvaCancellationReason>;
  cancelSource?: InputMaybe<Scalars['String']>;
  virtualAssessmentId?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesSellDirect_CancelOfferReviewRequestInput = {
  cancelReason?: InputMaybe<OdProtosWebDataSellDirect_OfferReview_CancelReason>;
  offerReviewId?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesSellDirect_CheckAgentLedAssessmentsEnabledRequestInput = {
  leadIdentifier?: InputMaybe<OdProtosWebData_LeadIdentifierInput>;
};

/**
 * Request object for ClearLastSSVARecordingByRecordedFeature
 * Next ID: 5
 */
export type OdProtosWebServicesSellDirect_ClearLastSsvaRecordingByRecordedFeatureRequestInput = {
  clearAll?: InputMaybe<Scalars['Boolean']>;
  lead?: InputMaybe<OdProtosWebServicesSellDirect_ClearLastSsvaRecordingByRecordedFeatureRequest_LeadOneofInput>;
  recordedFeature?: InputMaybe<OdProtosWebData_RecordedFeature>;
};

export type OdProtosWebServicesSellDirect_ClearLastSsvaRecordingByRecordedFeatureRequest_LeadOneofInput = {
  params?: InputMaybe<OdProtosWebData_LeadQueryParamsInput>;
  source?: InputMaybe<OdProtosWebData_LeadSourceInput>;
};

export type OdProtosWebServicesSellDirect_CompleteLateCheckoutRequestInput = {
  offerId?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesSellDirect_CreateSsvaRequestInput = {
  /** deprecated in favor for seller_lead_uuid */
  addressId?: InputMaybe<Scalars['String']>;
  sellerLeadUuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesSellDirect_CreateUnscheduledOrvaRequestInput = {
  offerId?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesSellDirect_CreateUnscheduledOfferReviewRequestInput = {
  offerUuid?: InputMaybe<Scalars['String']>;
};

/** Next ID: 3 */
export type OdProtosWebServicesSellDirect_DeleteParticipantRequestInput = {
  /** So we can fetch the lead via different ways (e.g. params, token) */
  lead?: InputMaybe<OdProtosWebServicesSellDirect_DeleteParticipantRequest_LeadOneofInput>;
  participantId?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesSellDirect_DeleteParticipantRequest_LeadOneofInput = {
  source?: InputMaybe<OdProtosWebData_LeadSourceInput>;
};

/**
 * Request object for DeleteSSVAFile
 * Next ID: 4
 */
export type OdProtosWebServicesSellDirect_DeleteSsvaFileRequestInput = {
  filePath?: InputMaybe<Scalars['String']>;
  lead?: InputMaybe<OdProtosWebServicesSellDirect_DeleteSsvaFileRequest_LeadOneofInput>;
};

export type OdProtosWebServicesSellDirect_DeleteSsvaFileRequest_LeadOneofInput = {
  params?: InputMaybe<OdProtosWebData_LeadQueryParamsInput>;
  source?: InputMaybe<OdProtosWebData_LeadSourceInput>;
};

export type OdProtosWebServicesSellDirect_DenyLeadRequestInput = {
  denialNotes?: InputMaybe<Scalars['String']>;
  denialReason?: InputMaybe<OdProtosSellCommon_DenialReason>;
  sellerLeadUuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesSellDirect_DenyLeadWithReasonRequestInput = {
  reason?: InputMaybe<Scalars['String']>;
  sellerLeadUuid?: InputMaybe<Scalars['String']>;
};

/** Next ID: 5 */
export type OdProtosWebServicesSellDirect_EligibilityDataForAddressRequestInput = {
  addressToken?: InputMaybe<Scalars['String']>;
  customerUuid?: InputMaybe<Scalars['String']>;
  saleTimeline?: InputMaybe<Scalars['String']>;
  sellerInputUuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesSellDirect_EnrollInLateCheckoutRequestInput = {
  lateCheckoutDate?: InputMaybe<OdProtosCommon_DateInput>;
  numberOfFreeDays?: InputMaybe<Scalars['Float']>;
  offerId?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesSellDirect_ExpireOfferRequestInput = {
  offerId?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesSellDirect_GenerateFinalOfferPdfRequestInput = {
  offerUuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesSellDirect_GetAloEligibityDataRequestInput = {
  leadToken?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesSellDirect_GetActiveOfferBySellerLeadUuidRequestInput = {
  sellerLeadUuid?: InputMaybe<Scalars['String']>;
};

/**
 * Request object for GetAddressesByCustomerUUID
 * Next ID: 2
 */
export type OdProtosWebServicesSellDirect_GetAddressesByCustomerUuidRequestInput = {
  customerUuid?: InputMaybe<Scalars['String']>;
};

/** Next ID: 3 */
export type OdProtosWebServicesSellDirect_GetAllExteriorAssessmentSlotsRequestInput = {
  calendarType?: InputMaybe<OdProtosWebData_AvailabityCalendarType>;
  offerUuid?: InputMaybe<Scalars['String']>;
  /** Fetching can be done with either param */
  sellerInputUuid?: InputMaybe<Scalars['String']>;
};

/** Next ID: 3 */
export type OdProtosWebServicesSellDirect_GetAssessmentStepsRequestInput = {
  /** deprecated in favor for seller_lead_uuid */
  addressUuid?: InputMaybe<Scalars['String']>;
  sellerLeadUuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesSellDirect_GetCurrentOfferBySellerLeadUuidRequestInput = {
  sellerLeadUuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesSellDirect_GetLatestLeadByAddressRequestInput = {
  addressToken?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesSellDirect_GetLatestLeadRequestInput = {
  addressToken?: InputMaybe<Scalars['String']>;
  customerUuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesSellDirect_GetLatestOfferByAddressRequestInput = {
  addressUuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesSellDirect_GetLeadByUnderwritingPropertyEngagementIdRequestInput = {
  underwritingPropertyEngagementId?: InputMaybe<Scalars['String']>;
};

/**
 * Request/Response objects for GetLead
 * Next ID: 7
 */
export type OdProtosWebServicesSellDirect_GetLeadRequestInput = {
  lead?: InputMaybe<OdProtosWebServicesSellDirect_GetLeadRequest_LeadOneofInput>;
  /**
   * Customer participant roles to use for access (e.g. seller_participant, signatory, etc).
   * Access will be granted if the user matches a participant in at least one of the roles listed.
   * Will not require the role to be associated with the user for internal access.
   */
  participantRolesForAccess?: InputMaybe<OdProtosWebData_ParticipantRolesForAccessInput>;
  userEmailForAccess?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesSellDirect_GetLeadRequest_LeadOneofInput = {
  params?: InputMaybe<OdProtosWebData_LeadQueryParamsInput>;
  sellerLeadUuid?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<OdProtosWebData_LeadSourceInput>;
  token?: InputMaybe<Scalars['String']>;
};

/** Next ID: 2 */
export type OdProtosWebServicesSellDirect_GetOfferPricesRequestInput = {
  offerUuid?: InputMaybe<Scalars['String']>;
};

/**
 * Request/Response objects for GetOffer
 * Next ID: 2
 */
export type OdProtosWebServicesSellDirect_GetOfferRequestInput = {
  excludeComps?: InputMaybe<Scalars['Boolean']>;
  offerId?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesSellDirect_GetOfferReviewsRequestInput = {
  identifier?: InputMaybe<OdProtosWebServicesSellDirect_GetOfferReviewsRequest_IdentifierOneofInput>;
};

export type OdProtosWebServicesSellDirect_GetOfferReviewsRequest_IdentifierOneofInput = {
  offerUuid?: InputMaybe<Scalars['String']>;
};

/** Next ID: 2 */
export type OdProtosWebServicesSellDirect_GetOffersFromAddressesForIterableRequestInput = {
  addressUuids?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosWebServicesSellDirect_GetOffersFromLeadByTokenRequestInput = {
  leadToken?: InputMaybe<Scalars['String']>;
};

/** Next ID: 2 */
export type OdProtosWebServicesSellDirect_GetOffersFromLeadsRequestInput = {
  leadIds?: InputMaybe<Array<Scalars['String']>>;
};

/** Next ID: 2 */
export type OdProtosWebServicesSellDirect_GetOrvaAndSoldDatesByCustomerUuidRequestInput = {
  customerUuid?: InputMaybe<Scalars['String']>;
};

/** Next ID: 2 */
export type OdProtosWebServicesSellDirect_GetParticipantsRequestInput = {
  /** So we can fetch the lead via different ways (e.g. params, token) */
  lead?: InputMaybe<OdProtosWebServicesSellDirect_GetParticipantsRequest_LeadOneofInput>;
};

export type OdProtosWebServicesSellDirect_GetParticipantsRequest_LeadOneofInput = {
  sellerLeadUuid?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<OdProtosWebData_LeadSourceInput>;
};

export type OdProtosWebServicesSellDirect_GetPostContractAssessmentStepsRequestInput = {
  sellerLeadUuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesSellDirect_GetPrivateLatestOfferByAddressRequestInput = {
  addressUuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesSellDirect_GetPrivateOfferRequestInput = {
  excludeComps?: InputMaybe<Scalars['Boolean']>;
  offerId?: InputMaybe<Scalars['String']>;
};

/** Next ID: 2 */
export type OdProtosWebServicesSellDirect_GetSsvaStepDetailsRequestInput = {
  sellerLeadUuid?: InputMaybe<Scalars['String']>;
};

/** Next ID: 2 */
export type OdProtosWebServicesSellDirect_GetSellDirectOfferByTokenRequestInput = {
  token?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesSellDirect_LateCheckoutCostsRequestInput = {
  numberOfDays?: InputMaybe<Scalars['Float']>;
  numberOfFreeDays?: InputMaybe<Scalars['Float']>;
  offerId?: InputMaybe<Scalars['String']>;
};

/** Next ID: 2 */
export type OdProtosWebServicesSellDirect_ListExteriorAssessmentAvailabilitySlotsRequestInput = {
  addressUuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesSellDirect_ListLeadsByTokenRequestInput = {
  tokens?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosWebServicesSellDirect_ListLeadsByTokenV2RequestInput = {
  tokens?: InputMaybe<Array<Scalars['String']>>;
};

/**
 * ListLeadsOnUniqueAddressesRequest will return a list of leads a customer
 * has but will filter the leads by unique addresses.
 * Next ID: 2
 */
export type OdProtosWebServicesSellDirect_ListLeadsOnUniqueAddressesRequestInput = {
  customerUuid?: InputMaybe<Scalars['String']>;
};

/** Next ID: 4 */
export type OdProtosWebServicesSellDirect_ListLeadsRequestInput = {
  /**
   * Using the human token will only retrieve a limited amount of offers (20) for performance reasons
   * You probably want to use a combination of Lead fetching/Offer fetching in order to grab every single offer for a given human
   * Using human_token, it will return BOTH the human owns and the human participates in!
   */
  humanToken?: InputMaybe<Scalars['String']>;
  /**
   * NOTE: You should only pass in either lead_identifiers or human_token
   * These fields should be treated as oneof, but that would be a breaking change.
   */
  leadIdentifiers?: InputMaybe<Array<OdProtosWebData_LeadIdentifierInput>>;
  /** Active means the lead's state is qualified */
  returnOnlyActive?: InputMaybe<Scalars['Boolean']>;
};

export type OdProtosWebServicesSellDirect_ListOffersByTokenRequestInput = {
  tokens?: InputMaybe<Array<Scalars['String']>>;
};

/** Next ID: 4 */
export type OdProtosWebServicesSellDirect_ListOffersRequestInput = {
  offerIds?: InputMaybe<Array<Scalars['String']>>;
  offers?: InputMaybe<OdProtosWebServicesSellDirect_ListOffersRequest_OffersOneofInput>;
};

export type OdProtosWebServicesSellDirect_ListOffersRequest_OffersOneofInput = {
  ids?: InputMaybe<OdProtosWebData_OfferIdentifiersInput>;
  params?: InputMaybe<OdProtosWebData_OfferQueryParamsInput>;
};

export type OdProtosWebServicesSellDirect_ListPrivateVirtualAssessmentsByOfferRequestInput = {
  offerId?: InputMaybe<Scalars['String']>;
};

/**
 * Request object for ListVirtualAssessmentsByFlip
 * Next ID: 2
 */
export type OdProtosWebServicesSellDirect_ListVirtualAssessmentsByFlipRequestInput = {
  flipToken?: InputMaybe<Scalars['String']>;
};

/**
 * Request object for ListVirtualAssessmentsByOffer
 * Next ID: 2
 */
export type OdProtosWebServicesSellDirect_ListVirtualAssessmentsByOfferRequestInput = {
  offerId?: InputMaybe<Scalars['String']>;
};

/**
 * Request object for ListVirtualAssessments
 * Next ID: 2
 */
export type OdProtosWebServicesSellDirect_ListVirtualAssessmentsRequestInput = {
  virtualAssessmentIds?: InputMaybe<Array<Scalars['String']>>;
};

/** Next ID: 2 */
export type OdProtosWebServicesSellDirect_MarkFinalOfferViewedRequestInput = {
  offerUuid?: InputMaybe<Scalars['String']>;
};

/** Next ID: 2 */
export type OdProtosWebServicesSellDirect_MaybeBucketForLowOfferConfidenceExperimentRequestInput = {
  offerUuid?: InputMaybe<Scalars['String']>;
};

/** Next ID: 5 */
export type OdProtosWebServicesSellDirect_PerformAgentToCustomerHandoffRequestInput = {
  customerEmail?: InputMaybe<Scalars['String']>;
  customerFirstName?: InputMaybe<Scalars['String']>;
  customerLastName?: InputMaybe<Scalars['String']>;
  sellerInputUuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesSellDirect_PerformLeadHandoffRequestInput = {
  channel?: InputMaybe<OdProtosSellReceptionData_SellerInput_Channel>;
  customer?: InputMaybe<OdProtosWebServicesSellDirect_PerformLeadHandoffRequest_CustomerOneofInput>;
  customerNote?: InputMaybe<Scalars['String']>;
  /** Deprecated, use customer oneof instead. */
  customerUuid?: InputMaybe<Scalars['String']>;
  leadToken?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesSellDirect_PerformLeadHandoffRequest_CustomerOneofInput = {
  customerId?: InputMaybe<Scalars['String']>;
  newCustomer?: InputMaybe<OdProtosWebServicesSellDirect_PerformLeadHandoffRequest_NewCustomerForHandoffInput>;
};

export type OdProtosWebServicesSellDirect_PerformLeadHandoffRequest_NewCustomerForHandoffInput = {
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  isAgent?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesSellDirect_PrelaunchVirtualAssessmentMeetingRequestInput = {
  virtualAssessmentId?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesSellDirect_QualifyLeadRequestInput = {
  product?: InputMaybe<OdProtosSellCommon_Product>;
  sellerLeadUuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesSellDirect_ReenableSsvaUploadRequestInput = {
  offerId?: InputMaybe<Scalars['String']>;
  recordedFeature?: InputMaybe<OdProtosWebData_RecordedFeature>;
};

/**
 * Request/Response objects for refresh offers
 * Next ID: 4
 */
export type OdProtosWebServicesSellDirect_RefreshOfferRequestInput = {
  offerRequestSource?: InputMaybe<OdProtosCommonSell_OfferRequest_Source>;
  sellerLeadUuid?: InputMaybe<Scalars['String']>;
  startUnderwritingWithExistingAssessments?: InputMaybe<Scalars['Boolean']>;
};

export type OdProtosWebServicesSellDirect_RegeneratePurchaseContractRequestInput = {
  offerId?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesSellDirect_ReleaseOfferFromHoldingStateRequestInput = {
  offerUuid?: InputMaybe<Scalars['String']>;
};

/** Next ID: 3 */
export type OdProtosWebServicesSellDirect_RequestChangeCloseOfEscrowRequestInput = {
  closeOfEscrowDate?: InputMaybe<OdProtosCommon_DateInput>;
  offerUuid?: InputMaybe<Scalars['String']>;
};

/** Next ID: 2 */
export type OdProtosWebServicesSellDirect_ResendListedOfferEmailRequestInput = {
  offerId?: InputMaybe<Scalars['String']>;
};

/** Next ID: 3 */
export type OdProtosWebServicesSellDirect_ResendParticipantInviteRequestInput = {
  /** So we can fetch the lead via different ways (e.g. params, token) */
  lead?: InputMaybe<OdProtosWebServicesSellDirect_ResendParticipantInviteRequest_LeadOneofInput>;
  participantId?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesSellDirect_ResendParticipantInviteRequest_LeadOneofInput = {
  source?: InputMaybe<OdProtosWebData_LeadSourceInput>;
};

export type OdProtosWebServicesSellDirect_ResetSsvaRequestInput = {
  offerId?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesSellDirect_RestoreOfferRequestInput = {
  offerUuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesSellDirect_RollbackToAcceptedRequestInput = {
  sellerLeadUuid?: InputMaybe<Scalars['String']>;
  walkReason?: InputMaybe<OdProtosWebServicesSellDirect_RollbackToAcceptedRequest_WalkReasonOneofInput>;
};

export type OdProtosWebServicesSellDirect_RollbackToAcceptedRequest_WalkReasonOneofInput = {
  opendoorWalkReason?: InputMaybe<OdProtosCommonSell_OpendoorWalkReason>;
  sellerWalkReason?: InputMaybe<OdProtosCommonSell_SellerWalkReason>;
};

/** Next ID: 2 */
export type OdProtosWebServicesSellDirect_ScheduleExteriorAssessmentRequestInput = {
  /** required */
  input?: InputMaybe<OdProtosWebData_ScheduleExteriorAssessmentInputInput>;
};

export type OdProtosWebServicesSellDirect_SetAssociatedCustomersRequestInput = {
  associatedCustomerIds?: InputMaybe<Array<Scalars['String']>>;
  offerId?: InputMaybe<Scalars['String']>;
  primaryCustomerId?: InputMaybe<Scalars['String']>;
};

/** Next ID: 4 */
export type OdProtosWebServicesSellDirect_SetSsvaReminderSmsRequestInput = {
  lead?: InputMaybe<OdProtosWebServicesSellDirect_SetSsvaReminderSmsRequest_LeadOneofInput>;
  phoneNumber?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesSellDirect_SetSsvaReminderSmsRequest_LeadOneofInput = {
  params?: InputMaybe<OdProtosWebData_LeadQueryParamsInput>;
  source?: InputMaybe<OdProtosWebData_LeadSourceInput>;
};

export type OdProtosWebServicesSellDirect_SubmitOrvaRecordingUrlRequestInput = {
  recordingUrl?: InputMaybe<Scalars['String']>;
  virtualAssessmentId?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesSellDirect_SubmitOfferReviewRecordingUrlRequestInput = {
  offerReviewId?: InputMaybe<Scalars['String']>;
  recordingUrl?: InputMaybe<Scalars['String']>;
};

/** Next ID: 4 */
export type OdProtosWebServicesSellDirect_SubmitSsvaRecordedFeatureRequestInput = {
  lead?: InputMaybe<OdProtosWebServicesSellDirect_SubmitSsvaRecordedFeatureRequest_LeadOneofInput>;
  recordedFeature?: InputMaybe<OdProtosWebData_RecordedFeature>;
};

export type OdProtosWebServicesSellDirect_SubmitSsvaRecordedFeatureRequest_LeadOneofInput = {
  params?: InputMaybe<OdProtosWebData_LeadQueryParamsInput>;
  source?: InputMaybe<OdProtosWebData_LeadSourceInput>;
};

export type OdProtosWebServicesSellDirect_UndenyLeadRequestInput = {
  sellerLeadUuid?: InputMaybe<Scalars['String']>;
};

/** Next ID: 3 */
export type OdProtosWebServicesSellDirect_UpdateHomeDetailsForOfferRequestInput = {
  /** The home detail to be written. Address UUID, source information, and timestamp are required. */
  homeDetail?: InputMaybe<OdProtosHomeDataStore_HomeDetailInput>;
  offerUuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesSellDirect_UpdateLateCheckoutSecurityAmountRetainedRequestInput = {
  amountRetainedCents?: InputMaybe<Scalars['Float']>;
  offerId?: InputMaybe<Scalars['String']>;
  reason?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesSellDirect_UpdateNetProceedsCalculationFieldsRequestInput = {
  addressId?: InputMaybe<Scalars['String']>;
  customerUuid?: InputMaybe<Scalars['String']>;
  estimatedRepairCostCents?: InputMaybe<Scalars['Float']>;
  mortgagePayoffAmountCents?: InputMaybe<Scalars['Float']>;
};

export type OdProtosWebServicesSellDirect_UpdateOverstayDateRequestInput = {
  offerUuid?: InputMaybe<Scalars['String']>;
  overstayChargeCents?: InputMaybe<Scalars['Float']>;
  overstayDate?: InputMaybe<OdProtosCommon_DateInput>;
};

/**
 * Request object for UpdateSSVARecordings
 * Next ID: 4
 */
export type OdProtosWebServicesSellDirect_UpdateSsvaRecordingsRequestInput = {
  lead?: InputMaybe<OdProtosWebServicesSellDirect_UpdateSsvaRecordingsRequest_LeadOneofInput>;
  recordings?: InputMaybe<Array<OdProtosWebData_VirtualAssessmentRecordingInput>>;
};

export type OdProtosWebServicesSellDirect_UpdateSsvaRecordingsRequest_LeadOneofInput = {
  params?: InputMaybe<OdProtosWebData_LeadQueryParamsInput>;
  source?: InputMaybe<OdProtosWebData_LeadSourceInput>;
};

export type OdProtosWebServicesSellDirect_UpdateStatusNoteRequestInput = {
  leadToken?: InputMaybe<Scalars['String']>;
  statusNote?: InputMaybe<Scalars['String']>;
};

/** Next ID: 3 */
export type OdProtosWebServicesSellDirect_UpsertParticipantRequestInput = {
  /** So we can fetch the lead via different ways (e.g. params, token) */
  lead?: InputMaybe<OdProtosWebServicesSellDirect_UpsertParticipantRequest_LeadOneofInput>;
  participants?: InputMaybe<OdProtosWebData_ParticipantsInput>;
};

export type OdProtosWebServicesSellDirect_UpsertParticipantRequest_LeadOneofInput = {
  source?: InputMaybe<OdProtosWebData_LeadSourceInput>;
};

export type OdProtosWebServicesSellDirect_VerifyActiveOfferRequestInput = {
  addressUuid?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  sellerInputUuid?: InputMaybe<Scalars['String']>;
};

/** Next ID: 3 */
export type OdProtosWebServicesSellDirect_ViewedSsvaPageRequestInput = {
  lead?: InputMaybe<OdProtosWebServicesSellDirect_ViewedSsvaPageRequest_LeadOneofInput>;
};

export type OdProtosWebServicesSellDirect_ViewedSsvaPageRequest_LeadOneofInput = {
  params?: InputMaybe<OdProtosWebData_LeadQueryParamsInput>;
  source?: InputMaybe<OdProtosWebData_LeadSourceInput>;
};

export type OdProtosWebServicesSellDirect_WithdrawOfferRequestInput = {
  sellerLeadUuid?: InputMaybe<Scalars['String']>;
  walkReason?: InputMaybe<OdProtosWebServicesSellDirect_WithdrawOfferRequest_WalkReasonOneofInput>;
  withdrawalDetails?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesSellDirect_WithdrawOfferRequest_WalkReasonOneofInput = {
  opendoorWalkReason?: InputMaybe<OdProtosCommonSell_OpendoorWalkReason>;
  sellerWalkReason?: InputMaybe<OdProtosCommonSell_SellerWalkReason>;
};

export type OdProtosWebServicesSellWithUpside_AcceptRequestInput = {
  sellerLeadUuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesSellWithUpside_AcquisitionProceedsPaidRequestInput = {
  sellerLeadUuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesSellWithUpside_AddAgentPricingRequestInput = {
  estimatedListPriceCents?: InputMaybe<Scalars['Float']>;
  sellerAgentCommissionRate?: InputMaybe<Scalars['Float']>;
  sellerLeadUuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesSellWithUpside_DeclineRequestInput = {
  reason?: InputMaybe<Scalars['String']>;
  sellerLeadUuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesSellWithUpside_EligibleRequestInput = {
  /**
   * If true, marks eligibility as manually overridden to prevent
   * automatic eligibility checks from changing this decision.
   */
  permanentlyOverride?: InputMaybe<Scalars['Boolean']>;
  sellerLeadUuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesSellWithUpside_GetNetSheetPdfRequestInput = {
  sellerLeadUuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesSellWithUpside_GetOrCreateProductRequestInput = {
  addressUuid?: InputMaybe<Scalars['String']>;
  /**
   * If true, skips eligibility checks and forces the product to be marked as eligible.
   * This should only be used when explicitly overriding eligibility rules,
   * such as for manual admin actions.
   */
  ignoreEligibility?: InputMaybe<Scalars['Boolean']>;
  sellDirectOfferUuid?: InputMaybe<Scalars['String']>;
  sellerLeadUuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesSellWithUpside_GetProductRequestInput = {
  sellerLeadUuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesSellWithUpside_GetResaleInfoRequestInput = {
  sellerLeadUuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesSellWithUpside_NotEligibleRequestInput = {
  /**
   * If true, marks eligibility as manually overridden to prevent
   * automatic eligibility checks from changing this decision.
   */
  permanentlyOverride?: InputMaybe<Scalars['Boolean']>;
  reason?: InputMaybe<Scalars['String']>;
  sellerLeadUuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesSellWithUpside_RecheckEligibilityRequestInput = {
  sellerLeadUuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesSellWithUpside_ResaleProceedsPaidRequestInput = {
  sellerLeadUuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesSellWithUpside_SetNotesRequestInput = {
  notes?: InputMaybe<Scalars['String']>;
  sellerLeadUuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesSellWithUpside_UpdatePricingInputsRequestInput = {
  deriveNewPricing?: InputMaybe<Scalars['Boolean']>;
  desiredCashAdvanceCents?: InputMaybe<Scalars['Float']>;
  sellerLeadUuid?: InputMaybe<Scalars['String']>;
  sellerProjectedSalesPriceCents?: InputMaybe<Scalars['Float']>;
};

export type OdProtosWebServicesSellWithUpside_WithdrawRequestInput = {
  sellerLeadUuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesStructuredTouchpoint_Requests_SearchInput = {
  kind?: InputMaybe<OdProtosWebData_StructuredTouchpointKind>;
  query?: InputMaybe<OdProtosWebServicesStructuredTouchpoint_Requests_Search_QueryOneofInput>;
};

export type OdProtosWebServicesStructuredTouchpoint_Requests_Search_QueryOneofInput = {
  offerUuid?: InputMaybe<Scalars['String']>;
  touchpointable?: InputMaybe<OdProtosWebData_TouchpointableInput>;
};

export type OdProtosWebServicesTask_Requests_CancelTasksByFlipInput = {
  flipToken?: InputMaybe<Scalars['String']>;
  taskTypes?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosWebServicesTask_Requests_CompleteTaskInput = {
  completionMethod?: InputMaybe<OdProtosWebServicesTask_TaskCompletionMethod>;
  taskId?: InputMaybe<Scalars['Float']>;
};

export type OdProtosWebServicesTask_TaskCompletionMethod =
  | 'AUTOMATIC'
  | 'EMAIL'
  | 'MANUAL'
  | 'NOT_RELEVANT'
  | 'PHONE_CALL'
  | 'SMS';

export type OdProtosWebServicesTransaction_TransactionRequests_GetInput = {
  uuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesTransaction_TransactionRequests_ListInput = {
  uuids?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosWebServicesTransaction_TransactionRequests_SearchInput = {
  addressToken?: InputMaybe<Scalars['String']>;
  escrowNumber?: InputMaybe<Scalars['String']>;
  fileUuid?: InputMaybe<Scalars['String']>;
  flipToken?: InputMaybe<Scalars['String']>;
  query?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesUnderwritingQcResult_GetCompleteQcCaseyTaskArgumentsErrorCode_Code =
  | 'UNKNOWN';

export type OdProtosWebServicesUnderwritingQcResult_GetCompleteQcCaseyTaskArgumentsRequestInput = {
  addressToken?: InputMaybe<Scalars['String']>;
  /** aka flip_token */
  propertyEngagementGroupId?: InputMaybe<Scalars['String']>;
  propertyEngagementId?: InputMaybe<Scalars['String']>;
  requestId?: InputMaybe<OdProtosCommon_RequestIdInput>;
  requestorId?: InputMaybe<OdProtosCommon_RequestorIdInput>;
};

/** Next ID: 7 */
export type OdProtosWebServicesUnderwriting_CalculateFeesRequestInput = {
  lgmOverride?: InputMaybe<OdProtosWebServicesUnderwriting_CalculateFeesRequest_LgmOverrideInput>;
  propertyEngagementGroupId?: InputMaybe<Scalars['String']>;
  propertyEngagementId?: InputMaybe<Scalars['String']>;
  shouldUpdateUnderwritingUea?: InputMaybe<Scalars['Boolean']>;
  valuation?: InputMaybe<OdProtosWebServicesUnderwriting_CalculateFeesRequest_ValuationOneofInput>;
};

/** Next ID: 4 */
export type OdProtosWebServicesUnderwriting_CalculateFeesRequest_LgmOverrideInput = {
  humanToken?: InputMaybe<Scalars['String']>;
  overrideBps?: InputMaybe<Scalars['Float']>;
  skipOverride?: InputMaybe<Scalars['Boolean']>;
};

export type OdProtosWebServicesUnderwriting_CalculateFeesRequest_ValuationOneofInput = {
  /** the normal flow */
  ensembledValuationId?: InputMaybe<Scalars['Float']>;
  /** OD Select or override valuations */
  valuationId?: InputMaybe<Scalars['Float']>;
};

export type OdProtosWebServicesUnderwriting_CalculateFeesResponse_Error_Code =
  | 'INVALID_ARGUMENT'
  | 'UNKNOWN';

/** Next ID: 2 */
export type OdProtosWebServicesUnderwriting_CheckIfUnderwritingCanBeStartedRequestInput = {
  propertyEngagementGroupId?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesUnderwriting_CheckIfUnderwritingCanBeStartedResponse_Error_Code =
  /** property_engagement_group_id or other request parameters are invalid */
  | 'INVALID_ARGUMENT'
  /** no offer found for property_engagement_group_id */
  | 'OFFER_NOT_FOUND'
  | 'UNKNOWN';

export type OdProtosWebServicesUnderwriting_CheckIfUnderwritingCanBeStartedResponse_Success_Ineligible_Code =
  /** offer found, but in a state that is invalid for UW to start */
  | 'INVALID_OFFER_STATE'
  /** no valid assessment/inspection found for the property_engagement_group_id */
  | 'MISSING_INSPECTION'
  | 'UNKNOWN';

export type OdProtosWebServicesUnderwriting_CheckOdSelectEligibilityRemovalRequestInput = {
  propertyEngagementGroupId?: InputMaybe<Scalars['String']>;
  propertyEngagementId?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesUnderwriting_CheckOdSelectEligibilityRemovalResponse_Error_Code =
  | 'INVALID_ARGUMENT'
  | 'NOT_FOUND'
  | 'UNKNOWN';

export type OdProtosWebServicesUnderwriting_CreateDirectOverrideValuationRequestInput = {
  overrideCi50margin?: InputMaybe<Scalars['Float']>;
  overridePrice?: InputMaybe<OdProtosCommon_MoneyInput>;
  uwPropertyEngagementId?: InputMaybe<Scalars['String']>;
  valuatorToken?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesUnderwriting_CreateDirectOverrideValuationResponse_Error_Code =
  | 'INVALID_ARGUMENT'
  | 'UNKNOWN';

/**
 * Create OVM valuation with home details overlay (POST_DV methodology)
 * Used by validata to create a new valuation when CubiCasa scan reveals home details discrepancy during DV.
 */
export type OdProtosWebServicesUnderwriting_CreateOvmValuationRequestInput = {
  addressToken?: InputMaybe<Scalars['String']>;
  overlay?: InputMaybe<OdProtosWebServicesUnderwriting_HomeDetailsInput>;
};

export type OdProtosWebServicesUnderwriting_CreateOvmValuationResponse_Error_Code =
  | 'INVALID_ARGUMENT'
  | 'SIGNALS_ERROR'
  | 'UNKNOWN';

/** Next ID: 3 */
export type OdProtosWebServicesUnderwriting_GetCalculatedFeesRequestInput = {
  unitEconomicIds?: InputMaybe<Array<Scalars['String']>>;
  /** underwriting property engagement id */
  uwPropertyEngagementId?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesUnderwriting_GetCalculatedFeesResponse_Error_Code =
  | 'INVALID_ARGUMENT'
  | 'UNKNOWN';

/** Next ID: 3 */
export type OdProtosWebServicesUnderwriting_GetEnsembledRepairLineItemsRequestInput = {
  propertyEngagementGroupId?: InputMaybe<Scalars['String']>;
  propertyEngagementId?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesUnderwriting_GetEnsembledRepairLineItemsResponse_Error_Code =
  | 'INVALID_ARGUMENT'
  | 'UNKNOWN';

export type OdProtosWebServicesUnderwriting_GetEnsembledValuationWalkProposalsRequestInput = {
  ensembledValuationId?: InputMaybe<Scalars['Float']>;
};

export type OdProtosWebServicesUnderwriting_GetEnsembledValuationWalkProposalsResponse_Error_Code =
  | 'INVALID_ARGUMENT'
  | 'UNKNOWN';

export type OdProtosWebServicesUnderwriting_GetEstimatedClosingCostsRequestInput = {
  addressToken?: InputMaybe<Scalars['String']>;
  offerPrice?: InputMaybe<OdProtosCommon_MoneyInput>;
};

export type OdProtosWebServicesUnderwriting_GetEstimatedClosingCostsResponse_Error_Code =
  | 'INVALID_ARGUMENT'
  | 'UNKNOWN';

/** Next ID: 2 */
export type OdProtosWebServicesUnderwriting_GetPreliminaryOfferValuationRequestInput = {
  propertyEngagementGroupId?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesUnderwriting_GetPreliminaryOfferValuationResponse_Error_Code =
  | 'INVALID_ARGUMENT'
  | 'UNKNOWN';

/** Next ID: 2 */
export type OdProtosWebServicesUnderwriting_GetRepairBudgetReviewWalkProposalRequestInput = {
  repairBudgetReviewId?: InputMaybe<Scalars['Float']>;
};

export type OdProtosWebServicesUnderwriting_GetRepairBudgetReviewWalkProposalResponse_Error_Code =
  | 'INVALID_ARGUMENT'
  | 'UNKNOWN';

export type OdProtosWebServicesUnderwriting_GetReusableRiskAssessmentDetailsErrorCode_Code =
  | 'NOT_FOUND'
  | 'UNKNOWN';

/** Next ID: 5 */
export type OdProtosWebServicesUnderwriting_GetReusableRiskAssessmentDetailsRequestInput = {
  asOf?: InputMaybe<Scalars['DateTime']>;
  propertyEngagementGroupId?: InputMaybe<Scalars['String']>;
  requestId?: InputMaybe<OdProtosCommon_RequestIdInput>;
  requestorId?: InputMaybe<OdProtosCommon_RequestorIdInput>;
};

export type OdProtosWebServicesUnderwriting_GetRiskTierRequestInput = {
  target?: InputMaybe<OdProtosWebServicesUnderwriting_GetRiskTierRequest_TargetOneofInput>;
};

export type OdProtosWebServicesUnderwriting_GetRiskTierRequest_TargetOneofInput = {
  addressToken?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesUnderwriting_GetRiskTierResponse_RiskTier =
  /** risk_tier = 1 */
  | 'HIGH'
  /**
   * from web.market_service_area.risk_tier
   *
   * risk_tier = 0
   */
  | 'LOW'
  | 'UNKNOWN';

export type OdProtosWebServicesUnderwriting_GetUnderwritingByOfferUuidRequestInput = {
  offerUuid?: InputMaybe<Scalars['String']>;
};

/** Home details for OVM overlay (CubiCasa data) */
export type OdProtosWebServicesUnderwriting_HomeDetailsInput = {
  aboveGradeSqFt?: InputMaybe<Scalars['Int']>;
  bathroomsFull?: InputMaybe<Scalars['Int']>;
  bathroomsHalf?: InputMaybe<Scalars['Int']>;
  bedrooms?: InputMaybe<Scalars['Int']>;
};

/** Next ID: 2 */
export type OdProtosWebServicesUnderwriting_IncreaseVolumeExperimentRequestInput = {
  propertyEngagementGroupId?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesUnderwriting_IncreaseVolumeExperimentResponse_Error_Code =
  | 'INVALID_ARGUMENT'
  | 'UNKNOWN';

export type OdProtosWebServicesUnderwriting_UpdateUnderwritingRequestInput = {
  propertyEngagementGroupId?: InputMaybe<Scalars['String']>;
  propertyEngagementId?: InputMaybe<Scalars['String']>;
  /** Determines if we set the final state of the web Underwriting to "walked" vs. "completed" */
  shouldWalk?: InputMaybe<Scalars['Boolean']>;
  /** The Underwriting object will have its contents copied from source_unit_economic_id */
  sourceUnitEconomicId?: InputMaybe<Scalars['Float']>;
};

export type OdProtosWebServicesUnderwriting_UpdateUnderwritingResponse_Error_Code =
  | 'INVALID_ARGUMENT'
  | 'UNKNOWN';

export type OdProtosWebServicesUnderwriting_UpdateUnderwritingWithWalkRequestInput = {
  propertyEngagementGroupId?: InputMaybe<Scalars['String']>;
  propertyEngagementId?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesUnderwriting_UpdateUnderwritingWithWalkResponse_Error_Code =
  | 'UNKNOWN';

export type OdProtosWebServicesUnlock_UnlockRequests_SearchInput = {
  params?: InputMaybe<OdProtosWebServicesUnlock_UnlockRequests_Search_ParamsOneofInput>;
};

export type OdProtosWebServicesUnlock_UnlockRequests_Search_AddressInput = {
  addressUuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesUnlock_UnlockRequests_Search_ContactInput = {
  contactUuid?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesUnlock_UnlockRequests_Search_ParamsOneofInput = {
  address?: InputMaybe<OdProtosWebServicesUnlock_UnlockRequests_Search_AddressInput>;
  contact?: InputMaybe<OdProtosWebServicesUnlock_UnlockRequests_Search_ContactInput>;
};

export type OdProtosWebServicesValuation_GetValuationForSellRequestIdRequestInput = {
  odlsSellRequestId?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesValuation_GetValuationsForAddressRequestInput = {
  addressToken?: InputMaybe<Scalars['String']>;
};

/** You should not be using this endpoint directly. Use GetMergedCompsForValuation from the Valuations service instead. */
export type OdProtosWebServicesValuation_ProxyGetMergedCompsForValuationRequestInput = {
  valuationKind?: InputMaybe<OdProtosWebServicesValuation_ProxyGetMergedCompsForValuationRequest_ValuationKindOneofInput>;
};

export type OdProtosWebServicesValuation_ProxyGetMergedCompsForValuationRequest_ValuationKindOneofInput = {
  ensembledValuationId?: InputMaybe<Scalars['Float']>;
  valuationId?: InputMaybe<Scalars['Float']>;
};

/** Next ID: 2 */
export type OdProtosWebServicesVirtualAssessment_GetLatestVirtualAssessmentByAddressRequestInput = {
  addressToken?: InputMaybe<Scalars['String']>;
};

/** Next ID: 3 */
export type OdProtosWebServicesVirtualAssessment_UpdateVirtualAssessmentWithReviewUrlRequestInput = {
  reviewUrl?: InputMaybe<Scalars['String']>;
  virtualAssessmentId?: InputMaybe<Scalars['String']>;
};

/** Next ID: 2 */
export type OdProtosWebServicesWebMarket_GetMarketRequestInput = {
  identifier?: InputMaybe<Scalars['String']>;
};

/** Next ID: 6 */
export type OdProtosWebServicesWebMarket_ListMarketsRequestInput = {
  identifiers?: InputMaybe<Array<Scalars['String']>>;
};

/** Next ID: 2 */
export type OdProtosWebServicesWebMarket_ListMlsesRequestInput = {
  postalCode?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesWorkOrder_CreateTaskForCompletedWorkOrderRequestInput = {
  workOrderId?: InputMaybe<Scalars['String']>;
};

export type OdProtosWebServicesWorkOrder_Requests_CompletedWorkOrderInput = {
  workOrderId?: InputMaybe<Scalars['Float']>;
};

export type OdProtosWingmanCommon_TaskStatus =
  | 'CANCELED'
  | 'COMPLETED'
  | 'FAILED'
  | 'IN_PROGRESS'
  | 'NOT_FOUND'
  | 'PENDING'
  | 'UNKNOWN_TASK_STATUS';

export type OdProtosWingmanCommon_TaskType =
  | 'CALL_INSIGHTS'
  | 'COMMUNICATION_INSIGHT'
  | 'CONTEXTUALIZE_REPAIR_ASK'
  | 'FINAL_OFFER_REPAIR_NARRATIVE'
  | 'LISTING_DESCRIPTION'
  | 'MAINTENANCE_VALIDATION'
  | 'SCRIPT'
  | 'TRANSCRIBE'
  | 'UNKNOWN_TASK_TYPE'
  | 'URS_JUSTIFICATION'
  | 'WORK_ORDER_MESSAGE_GENERATION';

export type OdProtosWingmanData_AuditLabel =
  | 'APPROVED'
  | 'NEEDS_ATTENTION'
  | 'REJECTED'
  | 'UNKNOWN';

export type OdProtosWingmanData_CallInsightsInputInput = {
  endDate?: InputMaybe<Scalars['DateTime']>;
  prompt1?: InputMaybe<Scalars['String']>;
  prompt2?: InputMaybe<Scalars['String']>;
  requestedUserToken?: InputMaybe<Scalars['String']>;
  requesterUserToken?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
};

export type OdProtosWingmanData_CommunicationInsightInputInput = {
  identifier?: InputMaybe<Scalars['String']>;
  identifierType?: InputMaybe<OdProtosWingmanData_IdentifierType>;
  prompt?: InputMaybe<Scalars['String']>;
  submittedAt?: InputMaybe<Scalars['DateTime']>;
  submittedBy?: InputMaybe<Scalars['String']>;
};

export type OdProtosWingmanData_ContextualizeRepairAskInputInput = {
  addressId?: InputMaybe<Scalars['String']>;
};

export type OdProtosWingmanData_DataSourceType =
  | 'EXTERIOR_ASSESSMENT'
  | 'FULL_ONSITE_ASSESSMENT'
  | 'IMAGE'
  | 'ORVA_QUESTIONNAIRE'
  | 'SSVA_QUESTIONNAIRE'
  | 'UNKNOWN_SOURCE_TYPE'
  | 'VIRTUAL_FULL_ASSESSMENT'
  | 'VIRTUAL_INTERIOR_ASSESSMENT';

export type OdProtosWingmanData_FeedbackCategoriesInput = {
  categories?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosWingmanData_FinalOfferRepairNarrativeInputInput = {
  addressId?: InputMaybe<Scalars['String']>;
};

export type OdProtosWingmanData_IdentifierType =
  | 'ADDRESS_ID'
  | 'GONG_CALL_ID'
  | 'SMS_CUSTOMER_ID'
  | 'TEXT'
  | 'UNKNOWN_IDENTIFIER_TYPE';

/** Enum for JustificationStatus */
export type OdProtosWingmanData_JustificationStatus =
  | 'JUSTIFIED'
  | 'NOT_JUSTIFIED'
  | 'UNKNOWN_JUSTIFICATION';

export type OdProtosWingmanData_ListingDescriptionInputInput = {
  additionalInstructions?: InputMaybe<Scalars['String']>;
  addressLine?: InputMaybe<Scalars['String']>;
  listingDescriptionAttributes?: InputMaybe<Array<Scalars['String']>>;
};

export type OdProtosWingmanData_MaintenanceValidationTaskInput = {
  maintenanceId?: InputMaybe<Scalars['Float']>;
};

export type OdProtosWingmanData_ParametersInput = {
  parameters?: InputMaybe<Array<OdProtosWingmanData_Parameters_ParametersEntryInput>>;
};

/** `OdProtosWingmanData_Parameters_ParametersEntryInput` represents the `parameters` map in `od_protos.wingman.data.Parameters`. */
export type OdProtosWingmanData_Parameters_ParametersEntryInput = {
  key?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

export type OdProtosWingmanData_ScriptTaskInputInput = {
  parameters?: InputMaybe<OdProtosWingmanData_ParametersInput>;
  scriptType?: InputMaybe<Scalars['String']>;
};

export type OdProtosWingmanData_TranscribeInputInput = {
  addressId?: InputMaybe<Scalars['String']>;
  audioPath?: InputMaybe<Scalars['String']>;
  callDate?: InputMaybe<Scalars['DateTime']>;
  callType?: InputMaybe<Scalars['String']>;
  fileName?: InputMaybe<Scalars['String']>;
  partnerToken?: InputMaybe<Scalars['String']>;
};

export type OdProtosWingmanData_UrsJustificationTaskInputInput = {
  workOrderId?: InputMaybe<Scalars['String']>;
};

export type OdProtosWingmanData_WorkOrderMessageGenerationTaskInput = {
  workOrderId?: InputMaybe<Scalars['String']>;
};

export type OdProtosWingmanServices_CancelEnqueuedTaskRequestInput = {
  taskId?: InputMaybe<Scalars['String']>;
};

export type OdProtosWingmanServices_CreateFeedbackRequestInput = {
  feedbackCategories?: InputMaybe<OdProtosWingmanData_FeedbackCategoriesInput>;
  feedbackFullTaskOutput?: InputMaybe<Scalars['String']>;
  feedbackRating?: InputMaybe<Scalars['Float']>;
  freeformFeedback?: InputMaybe<Scalars['String']>;
  taskId?: InputMaybe<Scalars['String']>;
};

export type OdProtosWingmanServices_GetLastResponseForTaskRequestInput = {
  input?: InputMaybe<OdProtosWingmanServices_GetLastResponseForTaskRequest_InputOneofInput>;
};

export type OdProtosWingmanServices_GetLastResponseForTaskRequest_InputOneofInput = {
  requestId?: InputMaybe<Scalars['String']>;
  taskId?: InputMaybe<Scalars['String']>;
};

export type OdProtosWingmanServices_GetLastResponseForTasksRequestInput = {
  input?: InputMaybe<Array<OdProtosWingmanServices_GetLastResponseForTaskRequestInput>>;
};

export type OdProtosWingmanServices_GetTaskStatusRequestInput = {
  taskId?: InputMaybe<Scalars['String']>;
};

export type OdProtosWingmanServices_GetTasksForFiltersInput = {
  endDate?: InputMaybe<Scalars['DateTime']>;
  lastEvaluatedKey?: InputMaybe<Array<OdProtosWingmanServices_GetTasksForFilters_LastEvaluatedKeyEntryInput>>;
  pageSize?: InputMaybe<Scalars['Float']>;
  requestId?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
};

/** `OdProtosWingmanServices_GetTasksForFilters_LastEvaluatedKeyEntryInput` represents the `last_evaluated_key` map in `od_protos.wingman.services.GetTasksForFilters`. */
export type OdProtosWingmanServices_GetTasksForFilters_LastEvaluatedKeyEntryInput = {
  key?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<OdProtosWingmanServices_LastEvaluatedKeyValueInput>;
};

/**
 * Dynamodb will return primary-key and sort-key as key, and value in those columns as value
 * In our case, the value will always be text, hence string.
 * This value can then be used to query the next page of results.
 */
export type OdProtosWingmanServices_LastEvaluatedKeyValueInput = {
  pair?: InputMaybe<Array<OdProtosWingmanServices_LastEvaluatedKeyValue_PairEntryInput>>;
};

/** `OdProtosWingmanServices_LastEvaluatedKeyValue_PairEntryInput` represents the `pair` map in `od_protos.wingman.services.LastEvaluatedKeyValue`. */
export type OdProtosWingmanServices_LastEvaluatedKeyValue_PairEntryInput = {
  key?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

export type OdProtosWingmanServices_ModelInputInput = {
  modelName?: InputMaybe<Scalars['String']>;
  modelVersion?: InputMaybe<Scalars['String']>;
};

export type OdProtosWingmanServices_SearchFeedbackRequestInput = {
  minRating?: InputMaybe<Scalars['Int']>;
  modelName?: InputMaybe<Scalars['String']>;
  modelVersion?: InputMaybe<Scalars['String']>;
  paginationRequest?: InputMaybe<OdProtosCommonPagination_PaginationRequestInput>;
  taskId?: InputMaybe<Scalars['String']>;
};

export type OdProtosWingmanServices_TaskRequestInput = {
  input?: InputMaybe<OdProtosWingmanServices_TaskRequest_InputOneofInput>;
  modelInput?: InputMaybe<OdProtosWingmanServices_ModelInputInput>;
  requestId?: InputMaybe<Scalars['String']>;
  timeoutSeconds?: InputMaybe<Scalars['Float']>;
  type?: InputMaybe<OdProtosWingmanCommon_TaskType>;
};

export type OdProtosWingmanServices_TaskRequest_InputOneofInput = {
  callInsightsInput?: InputMaybe<OdProtosWingmanData_CallInsightsInputInput>;
  communicationInsightInput?: InputMaybe<OdProtosWingmanData_CommunicationInsightInputInput>;
  contextualizeRepairAskInput?: InputMaybe<OdProtosWingmanData_ContextualizeRepairAskInputInput>;
  finalOfferRepairNarrativeInput?: InputMaybe<OdProtosWingmanData_FinalOfferRepairNarrativeInputInput>;
  listingDescriptionInput?: InputMaybe<OdProtosWingmanData_ListingDescriptionInputInput>;
  maintenanceValidationTask?: InputMaybe<OdProtosWingmanData_MaintenanceValidationTaskInput>;
  scriptTaskInput?: InputMaybe<OdProtosWingmanData_ScriptTaskInputInput>;
  transcribeInput?: InputMaybe<OdProtosWingmanData_TranscribeInputInput>;
  ursJustificationTaskInput?: InputMaybe<OdProtosWingmanData_UrsJustificationTaskInputInput>;
  workOrderMessageGenerationTask?: InputMaybe<OdProtosWingmanData_WorkOrderMessageGenerationTaskInput>;
};

export type OfferSnapshotSource =
  | 'BUY_DIRECT';

export type OfferSnapshotState =
  | 'ACTIVE'
  | 'CANCELED'
  | 'CLOSED'
  | 'DRAFT'
  | 'IN_CONTRACT'
  | 'IN_REVIEW'
  | 'REJECTED'
  | 'UNKNOWN';

export type OtherHomeInfoTaskInput = {
  additionalInfo?: InputMaybe<Scalars['String']>;
  hadPlumbingRepairs?: InputMaybe<Scalars['Boolean']>;
  hadPlumbingRepairsDetails?: InputMaybe<Scalars['String']>;
  hasDispute?: InputMaybe<Scalars['Boolean']>;
  hasDisputeDetails?: InputMaybe<Scalars['String']>;
  hasEncroachedOrSharedProperty?: InputMaybe<Scalars['Boolean']>;
  hasEncroachedOrSharedPropertyDetails?: InputMaybe<Scalars['String']>;
  hasWaterDamage?: InputMaybe<Scalars['Boolean']>;
  hasWaterDamageDetails?: InputMaybe<Scalars['String']>;
  mailboxNumber?: InputMaybe<Scalars['String']>;
  occupancyStatusAtAcquisition?: InputMaybe<Scalars['String']>;
  recyclingCollection?: InputMaybe<Scalars['String']>;
  trashCollection?: InputMaybe<Scalars['String']>;
};

export type PageInput = {
  /** Returns the elements in the list that come after the specified cursor. */
  after?: InputMaybe<Scalars['String']>;
  /** Returns the elements in the list that come before the specified cursor. */
  before?: InputMaybe<Scalars['String']>;
  /** Returns the first _n_ elements from the list. */
  first?: InputMaybe<Scalars['Int']>;
  /** Returns the last _n_ elements from the list. */
  last?: InputMaybe<Scalars['Int']>;
};

export type PhotoInput = {
  fileName: Scalars['String'];
  kind: Scalars['String'];
  mimeType: Scalars['String'];
  photoIdentifier: Scalars['String'];
  url: Scalars['String'];
};

export type PolygonBounds = {
  east: Scalars['Float'];
  north: Scalars['Float'];
  south: Scalars['Float'];
  west: Scalars['Float'];
};

export type PropertiesInput = {
  addressIds: Array<Scalars['String']>;
};

export type PropertyAddressAutocompleteInput = {
  allowInvalidAddresses?: InputMaybe<Scalars['Boolean']>;
  excludeListingStates?: InputMaybe<Array<OdProtosRealtyOdlsData_SellRequest_State>>;
  fetchProperties?: InputMaybe<Scalars['Boolean']>;
  fuzziness?: InputMaybe<PropertyFuzziness>;
  includeListingStates?: InputMaybe<Array<OdProtosRealtyOdlsData_SellRequest_State>>;
  latitude?: InputMaybe<Scalars['Float']>;
  limit?: InputMaybe<Scalars['Int']>;
  longitude?: InputMaybe<Scalars['Float']>;
  query: Scalars['String'];
};

export type PropertyFieldsSearchInput = {
  filters?: InputMaybe<PropertyFilters>;
  pageInput: PageInput;
  sortKey?: InputMaybe<PropertyQuerySortKey>;
};

export type PropertyFilters = {
  aboveGradeSqFt?: InputMaybe<MinMaxFilter>;
  basementSqFt?: InputMaybe<MinMaxFilter>;
  bathroomsTotal?: InputMaybe<MinMaxFloatFilter>;
  bedrooms?: InputMaybe<MinMaxFilter>;
  currentListPrice?: InputMaybe<MinMaxFilter>;
  dwellingTypes?: InputMaybe<Array<Scalars['String']>>;
  excludeAddressIds?: InputMaybe<Array<Scalars['String']>>;
  excludeListingStates?: InputMaybe<Array<OdProtosRealtyOdlsData_SellRequest_State>>;
  gteIndexedAt?: InputMaybe<Scalars['DateTime']>;
  gteListedAt?: InputMaybe<Scalars['DateTime']>;
  gtePendingAt?: InputMaybe<Scalars['DateTime']>;
  gteSoldAt?: InputMaybe<Scalars['DateTime']>;
  hasPhotos?: InputMaybe<Scalars['Boolean']>;
  hasPool?: InputMaybe<Scalars['Boolean']>;
  isDisplayable?: InputMaybe<Scalars['Boolean']>;
  isFhaEligible?: InputMaybe<Scalars['Boolean']>;
  isNewConstruction?: InputMaybe<Scalars['Boolean']>;
  isOpendoorOwned?: InputMaybe<Scalars['Boolean']>;
  listingStates?: InputMaybe<Array<OdProtosRealtyOdlsData_SellRequest_State>>;
  lotSqFt?: InputMaybe<MinMaxFilter>;
  ltIndexedAt?: InputMaybe<Scalars['DateTime']>;
  ltListedAt?: InputMaybe<Scalars['DateTime']>;
  ltPendingAt?: InputMaybe<Scalars['DateTime']>;
  ltSoldAt?: InputMaybe<Scalars['DateTime']>;
  monthlyHoaDues?: InputMaybe<MinMaxFilter>;
  photoThresholdSeconds?: InputMaybe<Scalars['Int']>;
  selfTourAvailable?: InputMaybe<Scalars['Boolean']>;
  soldPrice?: InputMaybe<MinMaxFilter>;
  stories?: InputMaybe<MinMaxFilter>;
  subdivision?: InputMaybe<Scalars['String']>;
  totalLivingSqFt?: InputMaybe<MinMaxFilter>;
  yearBuilt?: InputMaybe<MinMaxFilter>;
  zoneIds?: InputMaybe<Array<Scalars['String']>>;
};

export type PropertyFuzziness =
  | 'FUZZINESS_AUTO'
  | 'FUZZINESS_NONE';

export type PropertyGeoSearchInput = {
  filters?: InputMaybe<PropertyFilters>;
  pageInput: PageInput;
  shape: Scalars['String'];
  sortKey?: InputMaybe<PropertyQuerySortKey>;
};

export type PropertyInput = {
  addressId: Scalars['String'];
};

export type PropertyQuerySortKey =
  | 'SORT_KEY_CURRENT_LIST_PRICE_ASC'
  | 'SORT_KEY_CURRENT_LIST_PRICE_DESC'
  | 'SORT_KEY_DEFAULT'
  | 'SORT_KEY_INDEXED_AT_ASC'
  | 'SORT_KEY_INDEXED_AT_DESC'
  | 'SORT_KEY_LISTED_AT_ASC'
  | 'SORT_KEY_LISTED_AT_DESC'
  | 'SORT_KEY_NONE'
  | 'SORT_KEY_TOTAL_LIVING_SQ_FT_ASC'
  | 'SORT_KEY_TOTAL_LIVING_SQ_FT_DESC';

export type PropertySearchBounds = {
  market?: InputMaybe<Scalars['String']>;
  vertices?: InputMaybe<Array<GeoPoint>>;
  zoneIds?: InputMaybe<Array<Scalars['String']>>;
};

/** Filters for property search */
export type PropertySearchFilters = {
  /** An arbitrary query string to search for properties that match the query */
  fullAddress?: InputMaybe<Scalars['String']>;
  /** The boundary to search within */
  geoBoundary?: InputMaybe<GeoBoundaryInput>;
  /** Does the property have a private pool? */
  hasPool?: InputMaybe<Scalars['Boolean']>;
  /** Is this a single story home? */
  hasSingleStory?: InputMaybe<Scalars['Boolean']>;
  /** Is the property available for self-touring? */
  isSelfTourEligible?: InputMaybe<Scalars['Boolean']>;
  /** The listing state of the property */
  listingState?: InputMaybe<ListingState>;
  /** The maximum monthly HOA fee(s) */
  maxHoaMonthlyFee?: InputMaybe<Scalars['Float']>;
  /** The maximum list price */
  maxListPrice?: InputMaybe<Scalars['Float']>;
  /** The maximum square footage of the property */
  maxSquareFootage?: InputMaybe<Scalars['Int']>;
  /** The maximum year the property was built */
  maxYearBuilt?: InputMaybe<Scalars['Int']>;
  /** The minimum number of bathrooms */
  minBathrooms?: InputMaybe<Scalars['Float']>;
  /** The minimum number of bedrooms */
  minBeds?: InputMaybe<Scalars['Int']>;
  /** The minimum list price */
  minListPrice?: InputMaybe<Scalars['Float']>;
  /** The minimum square footage of the property */
  minSquareFootage?: InputMaybe<Scalars['Int']>;
  /** The minimum year the property was built */
  minYearBuilt?: InputMaybe<Scalars['Int']>;
  /** The types of properties to include */
  propertyType?: InputMaybe<Array<PropertyType>>;
};

/** Used to sort the results of a property search (optional) */
export type PropertySortBy =
  | 'LIST_DATE_ASC'
  | 'LIST_DATE_DSC'
  | 'LIST_PRICE_ASC'
  | 'LIST_PRICE_DSC'
  | 'SQUARE_FOOTAGE_ASC'
  | 'SQUARE_FOOTAGE_DSC'
  | 'YEAR_BUILT_ASC'
  | 'YEAR_BUILT_DSC';

export type PropertyTextSearchInput = {
  filters?: InputMaybe<PropertyFilters>;
  latitude?: InputMaybe<Scalars['Float']>;
  longitude?: InputMaybe<Scalars['Float']>;
  pageInput: PageInput;
  query: Scalars['String'];
};

/**
 * PropertyType represents the type of property
 * Is this exhaustive? Do we need less or more?
 */
export type PropertyType =
  | 'CONDO'
  | 'HOUSE'
  | 'OTHER'
  | 'TOWNHOUSE';

/** Filter input for purchase offers */
export type PurchaseOfferFilter = {
  /** Filter by specific offer ID */
  id?: InputMaybe<Scalars['ID']>;
};

/**
 * Funding source can have two types:
 *   - Mortgage
 *   - Cash
 */
export type PurchaseTransactionFundingSource =
  /** The funding source is cash */
  | 'CASH'
  /** The funding source is a mortgage */
  | 'MORTGAGE';

export type QualMoveTimelineOption =
  | 'just_browsing'
  | 'less_than_one_month'
  | 'not_actively_looking'
  | 'one_to_three_months'
  | 'three_plus_months';

/** Input for requesting the purchase agreement contract */
export type RequestContractInput = {
  /** The listing offer uuid to request the contract for */
  offerUuid: Scalars['ID'];
};

export type S3ClientName =
  /** Uses a client that can list, read, and put to https://s3.console.aws.amazon.com/s3/buckets/imgdrop-production?region=us-east-1 */
  | 'IMGDROP_PRODUCTION';

export type S3CreatePutObjectPresignedUrlInput = {
  clientName: S3ClientName;
  /**
   * default 1 hour. Max expiration time is complicated depending on the nature of the AWS credentials that are used to create the presigned URL;
   * ref https://docs.aws.amazon.com/AmazonS3/latest/userguide/using-presigned-url.html#PresignedUrlUploadObject-LimitCapabilities
   */
  expiresInSeconds?: InputMaybe<Scalars['Int']>;
  key: Scalars['String'];
};

export type S3ListObjectsCommandInput = {
  clientName: S3ClientName;
  continuationToken?: InputMaybe<Scalars['String']>;
  maxKeys?: InputMaybe<Scalars['Int']>;
  objectPrefix?: InputMaybe<Scalars['String']>;
};

export type ScheduleExteriorAssessmentInput = {
  occupant?: InputMaybe<OccupantInfo>;
  reminderPhone?: InputMaybe<Scalars['String']>;
  selectedInspectionTime: Scalars['DateTime'];
  sellerInputUUID: Scalars['String'];
};

/** Input for selecting a product for a seller */
export type SelectProductInput = {
  product: OdProtosSellCommon_Product;
  sellerLeadUuid: Scalars['ID'];
};

/** States of a sell direct offer */
export type SellDirectOfferState =
  /** Final offer state - offer has been finalized */
  | 'FINAL'
  /** Offer is in contract - customer has accepted */
  | 'IN_CONTRACT'
  /** Preliminary offer state - initial offer provided */
  | 'PRELIMINARY'
  /** Offer has been terminated */
  | 'TERMINATED'
  /** Unknown or unrecognized offer state */
  | 'UNKNOWN'
  /** Unreleased final offer - finalized but not yet released to customer */
  | 'UNRELEASED_FINAL';

export type SellerLeadAddress = {
  city?: InputMaybe<Scalars['String']>;
  latitude?: InputMaybe<Scalars['Float']>;
  longitude?: InputMaybe<Scalars['Float']>;
  postal_code?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  street1?: InputMaybe<Scalars['String']>;
};

export type ServiceAccountsTaskInput = {
  coolingType?: InputMaybe<Scalars['String']>;
  electricity?: InputMaybe<Scalars['String']>;
  gas?: InputMaybe<Scalars['String']>;
  hasExistingWaterIssue?: InputMaybe<Scalars['Boolean']>;
  hasExistingWaterIssueDetails?: InputMaybe<Scalars['String']>;
  hasSewerSepticIssue?: InputMaybe<Scalars['Boolean']>;
  hasSewerSepticIssueDetails?: InputMaybe<Scalars['String']>;
  heatingType?: InputMaybe<Scalars['String']>;
  water?: InputMaybe<Scalars['String']>;
};

export type SetCloseDateTaskInput = {
  selectedDate?: InputMaybe<Scalars['String']>;
};

export type SetSignatoriesTaskInput = {
  signerNames?: InputMaybe<Array<Scalars['String']>>;
};

export type SignalsCompOverrideInput = {
  address_token: Scalars['String'];
  overlays: SignalsOverlayInput;
};

export type SignalsEntityType =
  | 'ADDRESS_TOKEN';

export type SignalsHumanAdjustmentsInput = {
  comps: Array<SignalsHumanFeaturesInput>;
  market: Scalars['String'];
  skip_list?: InputMaybe<Array<Scalars['String']>>;
  subject: SignalsHumanFeaturesInput;
};

export type SignalsHumanFeaturesInput = {
  appliances?: InputMaybe<Scalars['String']>;
  basement_finished_sq_ft?: InputMaybe<Scalars['Float']>;
  basement_unfinished_sq_ft?: InputMaybe<Scalars['Float']>;
  bathroom_finish?: InputMaybe<Scalars['Float']>;
  bathrooms?: InputMaybe<Scalars['Float']>;
  bathrooms_full?: InputMaybe<Scalars['Float']>;
  bathrooms_half?: InputMaybe<Scalars['Float']>;
  bedrooms?: InputMaybe<Scalars['Float']>;
  busy_road_type_arterial_connector_strength?: InputMaybe<Scalars['Float']>;
  busy_road_type_freeway_highway_strength?: InputMaybe<Scalars['Float']>;
  busy_road_type_main_within_subdivision_strength?: InputMaybe<Scalars['Float']>;
  carport_spaces?: InputMaybe<Scalars['Float']>;
  commercial_type?: InputMaybe<Scalars['String']>;
  construction_quality?: InputMaybe<Scalars['String']>;
  covered_patio?: InputMaybe<Scalars['Float']>;
  covered_porch?: InputMaybe<Scalars['Float']>;
  cul_de_sac?: InputMaybe<Scalars['Float']>;
  entity_id?: InputMaybe<Scalars['String']>;
  exterior_finish?: InputMaybe<Scalars['Float']>;
  f_close_price?: InputMaybe<Scalars['Float']>;
  f_is_active?: InputMaybe<Scalars['Boolean']>;
  f_is_pending?: InputMaybe<Scalars['Boolean']>;
  floor_type?: InputMaybe<Scalars['String']>;
  garage_spaces?: InputMaybe<Scalars['Float']>;
  golf_lot_strength?: InputMaybe<Scalars['Float']>;
  hardwood_sq_ft?: InputMaybe<Scalars['Float']>;
  implied_price_per_sq_ft_except_basement?: InputMaybe<Scalars['Float']>;
  kitchen_cabinets_material?: InputMaybe<Scalars['String']>;
  kitchen_counters?: InputMaybe<Scalars['String']>;
  kitchen_finish?: InputMaybe<Scalars['Float']>;
  kitchen_fixtures_material?: InputMaybe<Scalars['String']>;
  lake_lot_strength?: InputMaybe<Scalars['Float']>;
  laminate_sq_ft?: InputMaybe<Scalars['Float']>;
  layout_score?: InputMaybe<Scalars['Float']>;
  list_date?: InputMaybe<Scalars['String']>;
  living_room_finish?: InputMaybe<Scalars['Float']>;
  neighbors_commercial_strength?: InputMaybe<Scalars['Float']>;
  neighbors_industrial_strength?: InputMaybe<Scalars['Float']>;
  neighbors_multi_family_strength?: InputMaybe<Scalars['Float']>;
  neighbors_school_strength?: InputMaybe<Scalars['Float']>;
  other_attractor_strength?: InputMaybe<Scalars['Float']>;
  other_detractor_strength?: InputMaybe<Scalars['Float']>;
  park_lot_strength?: InputMaybe<Scalars['Float']>;
  pool?: InputMaybe<Scalars['Boolean']>;
  pool_type?: InputMaybe<Scalars['String']>;
  powerline_type?: InputMaybe<Scalars['String']>;
  powerline_type_high_voltage_powerline_pole_strength?: InputMaybe<Scalars['Float']>;
  powerline_type_high_voltage_powerline_tower_strength?: InputMaybe<Scalars['Float']>;
  powerline_type_high_voltage_powerline_wire_strength?: InputMaybe<Scalars['Float']>;
  powerline_type_low_voltage_powerline_strength?: InputMaybe<Scalars['Float']>;
  powerline_type_powerline_station_strength?: InputMaybe<Scalars['Float']>;
  primary_floor_type?: InputMaybe<Scalars['Float']>;
  primary_flooring_material?: InputMaybe<Scalars['String']>;
  primary_hardwood_sq_ft?: InputMaybe<Scalars['Float']>;
  primary_laminate_sq_ft?: InputMaybe<Scalars['Float']>;
  primary_tile_sq_ft?: InputMaybe<Scalars['Float']>;
  railroad_strength?: InputMaybe<Scalars['Float']>;
  roof_type?: InputMaybe<Scalars['String']>;
  secondary_floor_type?: InputMaybe<Scalars['Float']>;
  secondary_flooring_material?: InputMaybe<Scalars['String']>;
  secondary_hardwood_sq_ft?: InputMaybe<Scalars['Float']>;
  secondary_laminate_sq_ft?: InputMaybe<Scalars['Float']>;
  secondary_tile_sq_ft?: InputMaybe<Scalars['Float']>;
  slc_lender_owned_reo?: InputMaybe<Scalars['Float']>;
  slc_short_sale?: InputMaybe<Scalars['Float']>;
  sloped_back_yard_strength?: InputMaybe<Scalars['Float']>;
  sloped_driveway_strength?: InputMaybe<Scalars['Float']>;
  tile_sq_ft?: InputMaybe<Scalars['Float']>;
  total_hardwood_sq_ft?: InputMaybe<Scalars['Float']>;
  total_laminate_sq_ft?: InputMaybe<Scalars['Float']>;
  total_tile_sq_ft?: InputMaybe<Scalars['Float']>;
  townhouse_end_unit?: InputMaybe<Scalars['Float']>;
  views_strength?: InputMaybe<Scalars['Float']>;
  yard_landscaping_strength?: InputMaybe<Scalars['Float']>;
};

export type SignalsHybridOvmValuationInput = {
  entityId: Scalars['String'];
  entityType: SignalsEntityType;
  featureFlags?: InputMaybe<Array<Scalars['String']>>;
  historicalTimestamp?: InputMaybe<Scalars['DateTime']>;
  manualOverrideComps?: InputMaybe<Array<SignalsCompOverrideInput>>;
  market: Scalars['String'];
  modelType?: InputMaybe<Scalars['String']>;
  responseIncludeFeatures?: InputMaybe<Scalars['Boolean']>;
  responseIncludeRisk?: InputMaybe<Scalars['Boolean']>;
  subjectOverlay?: InputMaybe<SignalsOverlayInput>;
};

export type SignalsOverlayInput = {
  above_grade_sq_ft?: InputMaybe<Scalars['Float']>;
  basement_finished_sq_ft?: InputMaybe<Scalars['Float']>;
  basement_unfinished_sq_ft?: InputMaybe<Scalars['Float']>;
  bathroom_condition_score?: InputMaybe<Scalars['Float']>;
  bathrooms_full?: InputMaybe<Scalars['Float']>;
  bathrooms_half?: InputMaybe<Scalars['Float']>;
  bedrooms?: InputMaybe<Scalars['Float']>;
  busy_road_type_arterial_connector_strength?: InputMaybe<Scalars['Float']>;
  busy_road_type_freeway_highway_strength?: InputMaybe<Scalars['Float']>;
  busy_road_type_main_within_subdivision_strength?: InputMaybe<Scalars['Float']>;
  carport_spaces?: InputMaybe<Scalars['Float']>;
  cul_de_sac?: InputMaybe<Scalars['Float']>;
  dwelling_type?: InputMaybe<Scalars['String']>;
  exterior_condition_score?: InputMaybe<Scalars['Float']>;
  exterior_stories?: InputMaybe<Scalars['Float']>;
  garage_spaces?: InputMaybe<Scalars['Float']>;
  golf_lot_strength?: InputMaybe<Scalars['Float']>;
  has_patio?: InputMaybe<Scalars['Boolean']>;
  has_porch?: InputMaybe<Scalars['Boolean']>;
  interior_condition_score?: InputMaybe<Scalars['Float']>;
  kitchen_appliance_type?: InputMaybe<Scalars['String']>;
  kitchen_condition_score?: InputMaybe<Scalars['Float']>;
  kitchen_countertop?: InputMaybe<Scalars['String']>;
  lake_lot_strength?: InputMaybe<Scalars['Float']>;
  lot_sq_ft?: InputMaybe<Scalars['Float']>;
  neighbors_commercial_strength?: InputMaybe<Scalars['Float']>;
  neighbors_industrial_strength?: InputMaybe<Scalars['Float']>;
  neighbors_multi_family_strength?: InputMaybe<Scalars['Float']>;
  neighbors_school_strength?: InputMaybe<Scalars['Float']>;
  park_lot_strength?: InputMaybe<Scalars['Float']>;
  pool?: InputMaybe<Scalars['Boolean']>;
  powerline_type_high_voltage_powerline_pole_strength?: InputMaybe<Scalars['Float']>;
  powerline_type_high_voltage_powerline_tower_strength?: InputMaybe<Scalars['Float']>;
  powerline_type_high_voltage_powerline_wire_strength?: InputMaybe<Scalars['Float']>;
  powerline_type_low_voltage_powerline_strength?: InputMaybe<Scalars['Float']>;
  powerline_type_powerline_station_strength?: InputMaybe<Scalars['Float']>;
  primary_floor_type?: InputMaybe<Scalars['String']>;
  property_condition_score?: InputMaybe<Scalars['Float']>;
  railroad_strength?: InputMaybe<Scalars['Float']>;
  secondary_floor_type?: InputMaybe<Scalars['String']>;
  sloped_back_yard_strength?: InputMaybe<Scalars['Float']>;
  sloped_driveway_strength?: InputMaybe<Scalars['Float']>;
  views_strength?: InputMaybe<Scalars['Float']>;
  yard_landscaping_strength?: InputMaybe<Scalars['Float']>;
  year_built?: InputMaybe<Scalars['Float']>;
};

export type SignalsSubdivisionStatsInput = {
  compAddressTokens: Array<Scalars['String']>;
  market: Scalars['String'];
  subjectAddressToken: Scalars['String'];
};

export type SimilarListingsInput = {
  minusBedrooms?: InputMaybe<Scalars['Int']>;
  pageInput: PageInput;
  plusBedrooms?: InputMaybe<Scalars['Int']>;
  priceDcrPct?: InputMaybe<Scalars['Float']>;
  priceIncrPct?: InputMaybe<Scalars['Float']>;
  radiusMiles?: InputMaybe<Scalars['Int']>;
  sortKey?: InputMaybe<PropertyQuerySortKey>;
};

export type SprinklerTimer =
  | 'AUTOMATIC'
  | 'MANUAL'
  | 'UNKNOWN';

export type SurveyorValuationCompRequestInput = {
  /** id of the comp we are querying for (eg. '3288535') */
  id: Scalars['String'];
  /** mls type we are requesting from (eg. 'cmls') */
  type: Scalars['String'];
};

export type SurveyorValuationCompsRequestInput = {
  bounds?: InputMaybe<Scalars['String']>;
  featureFlags?: InputMaybe<Array<Scalars['String']>>;
  includeManuallyAddedComps?: InputMaybe<Scalars['Boolean']>;
  /**
   * if mergeComps: 'false', returns only saved comps from valuation.details.comps
   *    mergeComps: 'true', returns all possible comps from dwellings
   */
  mergeComps?: InputMaybe<Scalars['Boolean']>;
  radius?: InputMaybe<Scalars['Float']>;
};

export type SurveyorValuationRequestInput = {
  /**
   * Either `id` or `webValuationId` must be provided in input. If both are provided,
   * `id` is used over `webValuationId`. If neither are provided, TypeError is thrown.
   */
  id?: InputMaybe<Scalars['Int']>;
  webValuationId?: InputMaybe<Scalars['Int']>;
};

/** The type of action for a task CTA */
export type TaskActionType =
  /** Opens a modal dialog */
  | 'DISPLAY_MODAL'
  /** Opens an external URL */
  | 'EXTERNAL_LINK'
  /** Triggers the initiateCustomerTask mutation */
  | 'INITIATE_TASK'
  /** Reveals hidden content (e.g., access code) */
  | 'REVEAL_CONTENT';

/** Icons for task groups */
export type TaskGroupIcon =
  /** Clipboard/search icon for escrow tasks */
  | 'CLIPBOARD_SEARCH'
  /** Door icon for access-related tasks */
  | 'DOOR'
  /** Document/file icon for offer-related tasks */
  | 'FILE_DESCRIPTION'
  /** Home icon for closing tasks */
  | 'HOME';

export type TaskType =
  | 'HOA_FEES'
  | 'HVAC_ROOF_INFO'
  | 'LATE_CHECKOUT'
  | 'OTHER_HOME_INFO'
  | 'SERVICE_ACCOUNTS'
  | 'SET_CLOSE_DATE'
  | 'SET_SIGNATORIES'
  | 'SIGN_CHANGE_CLOSE_OF_ESCROW_ADDENDUM'
  | 'SIGN_COMBINED_PURCHASE_AGREEMENT_AND_REPAIR_ADDENDUM'
  | 'SIGN_FORM_ADDENDUM'
  | 'SIGN_LATE_CHECKOUT_ADDENDUM'
  | 'UNKNOWN';

/**
 * This enum captures the comprehensive states that should be presented to a customer.
 * The value can be determined by a combination of different values in the backend across
 * systems.
 */
export type TransactionState =
  /** The Buy Direct contract is awaiting Opendoor's countersignaure */
  | 'BUY_DIRECT_AWAITING_COUNTERSIGNATURE'
  /** The Buy Direct offer is in backup */
  | 'BUY_DIRECT_BACKUP'
  /** The Buy Direct offer is in contract */
  | 'BUY_DIRECT_IN_CONTRACT'
  /** The Buy Direct contract needs to be signed by the customer */
  | 'BUY_DIRECT_UNSIGNED_CONTRACT'
  /** The buyer cancels an offer */
  | 'CANCELED_OFFER'
  /** The customer has reached closed escrow state and the transaction is complete */
  | 'CLOSE'
  /** The offer was rejected */
  | 'REJECTED';

/**
 * This enum is used to distinguish between Buy Direct transactions and traditional
 * Buy with Opendoor 3P transactions
 */
export type TransactionType =
  | 'BUY_DIRECT';

export type UpdateAgentVerificationStatusInput = {
  agentVerificationStatus: Scalars['String'];
  contactId: Scalars['String'];
};

export type UpdateBuyerDataInput = {
  customer_uuid: Scalars['String'];
  data: BuyerDataInput;
};

export type UpdateContentInput = {
  key: Scalars['String'];
  value: Scalars['String'];
};

export type UpdateExteriorAssessmentInput = {
  occupant?: InputMaybe<OccupantInfo>;
  reminderPhone?: InputMaybe<Scalars['String']>;
  selectedInspectionTime: Scalars['DateTime'];
  sellerInputUUID: Scalars['String'];
  visitId: Scalars['String'];
};

export type WebCreateDocumentInput = {
  documentType: Scalars['String'];
  documentableId: Scalars['String'];
  documentableType: Scalars['String'];
  externalId: Scalars['String'];
  externalSource: Scalars['String'];
  name: Scalars['String'];
  sourceChannel: Scalars['String'];
  sourceId?: InputMaybe<Scalars['String']>;
};

export type WebIncidentParams = {
  location?: InputMaybe<Scalars['String']>;
  tags: Array<InputMaybe<Scalars['String']>>;
};

export type WebListingOfferInput = {
  addendumCounter?: InputMaybe<Scalars['Int']>;
  additionalContractTerms?: InputMaybe<Scalars['String']>;
  agentFirstName?: InputMaybe<Scalars['String']>;
  agentLastName?: InputMaybe<Scalars['String']>;
  agentLicenseNumber?: InputMaybe<Scalars['String']>;
  agentMlsId?: InputMaybe<Scalars['String']>;
  agentOfficeId?: InputMaybe<Scalars['String']>;
  buyer2CustomerId?: InputMaybe<Scalars['Int']>;
  buyer2Email?: InputMaybe<Scalars['String']>;
  buyer2Name?: InputMaybe<Scalars['String']>;
  buyer2Phone?: InputMaybe<Scalars['String']>;
  buyerCustomerId?: InputMaybe<Scalars['Int']>;
  buyerEmail?: InputMaybe<Scalars['String']>;
  buyerName?: InputMaybe<Scalars['String']>;
  buyerPhone?: InputMaybe<Scalars['String']>;
  channel?: InputMaybe<Scalars['String']>;
  closeOfEscrow?: InputMaybe<Scalars['RubyTimestamp']>;
  coSellingAgentFirstName?: InputMaybe<Scalars['String']>;
  coSellingAgentLastName?: InputMaybe<Scalars['String']>;
  coSellingAgentMlsId?: InputMaybe<Scalars['String']>;
  concessionForPurchaseContractCents?: InputMaybe<Scalars['Int']>;
  concessionFromSellerCents?: InputMaybe<Scalars['Int']>;
  contactCustomerId?: InputMaybe<Scalars['Int']>;
  contactEmail?: InputMaybe<Scalars['String']>;
  contactName?: InputMaybe<Scalars['String']>;
  contactPhone?: InputMaybe<Scalars['String']>;
  downPaymentCents?: InputMaybe<Scalars['Int']>;
  earnestDepositCents?: InputMaybe<Scalars['Int']>;
  expiresAt?: InputMaybe<Scalars['DateTime']>;
  financingStatus?: InputMaybe<Scalars['String']>;
  financingType?: InputMaybe<Scalars['String']>;
  homeWarrantyCents?: InputMaybe<Scalars['Int']>;
  homeWarrantyType?: InputMaybe<Scalars['String']>;
  initialOfferNotes?: InputMaybe<Scalars['String']>;
  inspectionContingenciesReleased?: InputMaybe<Scalars['RubyTimestamp']>;
  inspectionPeriodDays?: InputMaybe<Scalars['Int']>;
  lenderContactEmail?: InputMaybe<Scalars['String']>;
  lenderContactName?: InputMaybe<Scalars['String']>;
  lenderContactPhone?: InputMaybe<Scalars['String']>;
  lenderOrganizationName?: InputMaybe<Scalars['String']>;
  lenderType?: InputMaybe<Scalars['String']>;
  listingId?: InputMaybe<Scalars['String']>;
  listingState?: InputMaybe<Scalars['String']>;
  loanAmountCents?: InputMaybe<Scalars['Int']>;
  mlsConcessionType?: InputMaybe<Scalars['String']>;
  priceCents?: InputMaybe<Scalars['Int']>;
  receivedDate?: InputMaybe<Scalars['RubyTimestamp']>;
  source?: InputMaybe<Scalars['String']>;
  titleContactId?: InputMaybe<Scalars['String']>;
  titleOrgId?: InputMaybe<Scalars['String']>;
  warrantyDeclined?: InputMaybe<Scalars['Boolean']>;
};

export type WebNewCloseOfEscrowRequestState =
  | 'ACCEPTED'
  | 'ACTIVE'
  | 'CANCELED'
  | 'DENIED';

export type WebSavedEmailInput = {
  helpscoutThreadId?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  messageableId?: InputMaybe<Scalars['ID']>;
  messageableType?: InputMaybe<Scalars['String']>;
};

export type WebUpdateDocumentInput = {
  documentType?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** enum WebVisitType */
export type WebVisitType =
  | 'ASSESSMENT_VISIT'
  | 'DILIGENCE_VISIT';

export type ZoneShapeOption =
  | 'EXCLUDE'
  | 'FULL_SIZE'
  | 'SIMPLIFY';

export type PropertyDetailsFragment = { __typename?: 'MarketplaceProperty', addressToken: string, bathrooms?: number | null, bedrooms?: number | null, buyDirectPrice?: number | null, canSelfTour?: boolean | null, city: string, cumulativeDaysOnMarket?: number | null, daysOnMarket?: number | null, description?: string | null, displayBadge?: Badge | null, dwellingType?: DwellingType | null, estimatedMonthlyPayment?: number | null, exteriorStories?: number | null, fhaEligible?: boolean | null, fhaEligibleDate?: any | null, garageSpaces?: number | null, hasPrivatePool?: boolean | null, hasCommunityPool?: boolean | null, inGatedCommunity?: boolean | null, kitchenCountertop?: KitchenCountertop | null, latitude: number, longitude: number, listPrice?: number | null, estimatedBuyDirectMonthlyPayment?: number | null, listingState?: ListingState | null, listingTags?: Array<ListingTag> | null, market?: string | null, masterBedroomLocation?: MasterBedroomLocation | null, photos?: Array<string> | null, pricePerSqFt?: number | null, schoolDistricts?: Array<string> | null, sellerDisclosuresDownloadUrl?: string | null, slug: string, sqFtLot?: number | null, sqFtTotalLiving?: number | null, state?: string | null, street?: string | null, subdivision?: string | null, unitType?: string | null, unitNumber?: string | null, yearBuilt?: string | null, zip?: string | null, hoas?: Array<{ __typename?: 'Hoa', name?: string | null, feeAmount?: number | null, feeFrequency?: string | null }> | null, listingHistory?: Array<{ __typename?: 'MarketplaceListingHistory', state?: ListingHistoryState | null, timestamp?: any | null, mls?: string | null, originalListPriceCents?: number | null, soldPriceCents?: number | null, currentListPriceCents?: number | null }> | null, listingMetadata?: { __typename?: 'ListingMetadata', buyDirectDiscountPercent?: number | null } | null, schools?: Array<{ __typename?: 'MarketplaceSchool', id: string, name: string, rating?: number | null }> | null, similarProperties?: { __typename?: 'MarketplacePropertyListQueryResult', count: number, nextPage?: number | null, results?: Array<{ __typename?: 'MarketplacePropertyListResult', id: string, addressToken?: string | null, baths?: number | null, beds?: number | null, city?: string | null, dwellingType?: DwellingType | null, estimatedMonthlyPayment?: number | null, fullAddress?: string | null, listPrice?: number | null, livingSquareFootage?: number | null, neighborhood?: string | null, slug?: string | null, photos?: Array<string> | null }> | null } | null };

export type SimilarPropertiesFragment = { __typename?: 'MarketplacePropertyListQueryResult', count: number, nextPage?: number | null, results?: Array<{ __typename?: 'MarketplacePropertyListResult', id: string, addressToken?: string | null, baths?: number | null, beds?: number | null, city?: string | null, dwellingType?: DwellingType | null, estimatedMonthlyPayment?: number | null, fullAddress?: string | null, listPrice?: number | null, livingSquareFootage?: number | null, neighborhood?: string | null, slug?: string | null, photos?: Array<string> | null }> | null };

export type SimilarPropertyFragment = { __typename?: 'MarketplacePropertyListResult', id: string, addressToken?: string | null, baths?: number | null, beds?: number | null, city?: string | null, dwellingType?: DwellingType | null, estimatedMonthlyPayment?: number | null, fullAddress?: string | null, listPrice?: number | null, livingSquareFootage?: number | null, neighborhood?: string | null, slug?: string | null, photos?: Array<string> | null };

export type PropertiesByMarketResultFragment = { __typename?: 'PropertySearchResult', displaySlug: string, bedrooms?: number | null, bathroomsTotal?: number | null, originalListPrice?: number | null, sqFtTotalLiving?: number | null, sqFtAboveGrade?: number | null, listPrice?: number | null, listTimestamp?: any | null, street: string, unitType?: string | null, unitNumber?: string | null, city: string, state: string, postalCode: string, longitude: number, latitude: number, sqFtLot?: number | null, addressId: string, photos?: { __typename?: 'PhotoConnection', nodes?: Array<{ __typename?: 'PropertyPhoto', id: string, urls?: { __typename?: 'PhotoUrl', resizable: string } | null }> | null } | null };

export type MarketplacePropertySearchResultFragment = { __typename?: 'MarketplacePropertySearchResult', id: string, addressToken?: string | null, badges?: Array<Badge> | null, beds?: number | null, baths?: number | null, listDate?: string | null, listPrice?: number | null, livingSquareFootage?: number | null, listingState?: ListingState | null, slug?: string | null, location?: { __typename?: 'PropertyLocation', lat: number, lon: number } | null };

export type MarketplacePropertySearchFragment = { __typename?: 'MarketplacePropertySearchQueryResult', count: number, results?: Array<{ __typename?: 'MarketplacePropertySearchResult', id: string, addressToken?: string | null, badges?: Array<Badge> | null, beds?: number | null, baths?: number | null, listDate?: string | null, listPrice?: number | null, livingSquareFootage?: number | null, listingState?: ListingState | null, slug?: string | null, location?: { __typename?: 'PropertyLocation', lat: number, lon: number } | null }> | null };

export type MarketplacePropertyListResultFragment = { __typename?: 'MarketplacePropertyListResult', id: string, addressToken?: string | null, badges?: Array<Badge> | null, beds?: number | null, baths?: number | null, city?: string | null, dwellingType?: DwellingType | null, estimatedMonthlyPayment?: number | null, fullAddress?: string | null, isLiked?: boolean | null, listDate?: string | null, listPrice?: number | null, livingSquareFootage?: number | null, listingState?: ListingState | null, neighborhood?: string | null, photos?: Array<string> | null, slug?: string | null, zip?: string | null };

export type AddressSearchResultFragment = { __typename?: 'AddressSearchProperty', addressToken: string, id?: string | null, fullAddress?: string | null, priceCents?: number | null };

export type MarketplacePropertyListFragment = { __typename?: 'MarketplacePropertyListQueryResult', count: number, nextPage?: number | null, results?: Array<{ __typename?: 'MarketplacePropertyListResult', id: string, addressToken?: string | null, badges?: Array<Badge> | null, beds?: number | null, baths?: number | null, city?: string | null, dwellingType?: DwellingType | null, estimatedMonthlyPayment?: number | null, fullAddress?: string | null, isLiked?: boolean | null, listDate?: string | null, listPrice?: number | null, livingSquareFootage?: number | null, listingState?: ListingState | null, neighborhood?: string | null, photos?: Array<string> | null, slug?: string | null, zip?: string | null }> | null };

export type BuyerPropertyReactionFragment = { __typename?: 'OdProtosBuyerV2Data_PropertyReaction', addressId: string, reaction: OdProtosBuyerV2Data_Reaction, source: OdProtosBuyerV2Data_ReactionSource };

export type MarketConfigFragment = { __typename?: 'OdProtosBuyerData_MarketConfig', shape: string, displayName: string, identifier: string, buyingExperience: boolean };

export type MapMarkerDetailsFragment = { __typename?: 'MarketplaceProperty', addressToken: string, photos?: Array<string> | null, estimatedMonthlyPayment?: number | null, bathrooms?: number | null, bedrooms?: number | null, sqFtTotalLiving?: number | null, dwellingType?: DwellingType | null, isLiked?: boolean | null };

export type UnsubscribeMailerMutationVariables = Exact<{
  address: OdProtosWebServicesMarketing_UnsubscribeMailerRequestInput;
}>;


export type UnsubscribeMailerMutation = { __typename?: 'Mutation', marketing: { __typename?: 'OdProtosWebServicesMarketing_Marketing_Mutation', unsubscribeMailer?: { __typename?: 'OdProtosWebServicesMarketing_UnsubscribeMailerResponse', _empty?: boolean | null } | null } };

export type SetMarketplacePropertyReactionMutationVariables = Exact<{
  input: OdProtosBuyerV2ServicesBuyer_SetPropertyReactionRequestInput;
}>;


export type SetMarketplacePropertyReactionMutation = { __typename?: 'Mutation', buyerService: { __typename?: 'OdProtosBuyerV2ServicesBuyer_BuyerService_Mutation', setPropertyReaction?: { __typename?: 'OdProtosBuyerV2ServicesBuyer_SetPropertyReactionResponse', _empty?: boolean | null } | null } };

export type RemoveMarketplacePropertyReactionMutationVariables = Exact<{
  input: OdProtosBuyerV2ServicesBuyer_RemovePropertyReactionRequestInput;
}>;


export type RemoveMarketplacePropertyReactionMutation = { __typename?: 'Mutation', buyerService: { __typename?: 'OdProtosBuyerV2ServicesBuyer_BuyerService_Mutation', removePropertyReaction?: { __typename?: 'OdProtosBuyerV2ServicesBuyer_RemovePropertyReactionResponse', _empty?: boolean | null } | null } };

export type SetImpressionMutationVariables = Exact<{
  grain?: InputMaybe<OdProtosVariantData_GrainInput>;
  key: Scalars['String'];
  variantValue: Scalars['String'];
}>;


export type SetImpressionMutation = { __typename?: 'Mutation', variant: { __typename?: 'OdProtosVariantServices_Variant_Mutation', setImpression?: { __typename?: 'OdProtosVariantServices_SetImpressionResponse', _empty?: boolean | null } | null } };

export type UpdateCustomerMutationVariables = Exact<{
  customerUuid: Scalars['String'];
  params: OdProtosCustomerV1Services_CustomerRequests_Update_ParamsInput;
}>;


export type UpdateCustomerMutation = { __typename?: 'Mutation', customerService: { __typename?: 'OdProtosCustomerV1Services_Customer_Mutation', update?: { __typename?: 'OdProtosCustomerV1Services_CustomerResponses_Update', updatedCustomer?: { __typename?: 'OdProtosCustomerV1Data_Customer', uuid: string, createdAt?: any | null, firstName: string, lastName: string, isAgent: boolean, ccpaSaleOfDataOptOut: boolean, fullName?: string | null, primaryEmail?: { __typename?: 'OdProtosCustomerV1Data_Email', address?: { __typename?: 'OdProtosCommon_EmailAddress', value: string } | null } | null, otherEmails: Array<{ __typename?: 'OdProtosCustomerV1Data_Email', address?: { __typename?: 'OdProtosCommon_EmailAddress', value: string } | null }>, primaryPhoneNumber?: { __typename?: 'OdProtosCustomerV1Data_Phone', type: OdProtosCustomerV1Data_Phone_PhoneType, number?: { __typename?: 'OdProtosCommon_PhoneNumber', value: string } | null } | null, otherPhoneNumbers: Array<{ __typename?: 'OdProtosCustomerV1Data_Phone', type: OdProtosCustomerV1Data_Phone_PhoneType, number?: { __typename?: 'OdProtosCommon_PhoneNumber', value: string } | null }> } | null } | null } };

export type UpdateCurrentCustomerMutationVariables = Exact<{
  customerUpdates: OdProtosCustomerV1Services_CustomerRequests_UpdateCurrentInput;
}>;


export type UpdateCurrentCustomerMutation = { __typename?: 'Mutation', customerService: { __typename?: 'OdProtosCustomerV1Services_Customer_Mutation', updateCurrent?: { __typename?: 'OdProtosCustomerV1Services_CustomerResponses_UpdateCurrent', updatedCustomer?: { __typename?: 'OdProtosCustomerV1Data_Customer', uuid: string, createdAt?: any | null, firstName: string, lastName: string, isAgent: boolean, ccpaSaleOfDataOptOut: boolean, fullName?: string | null, primaryEmail?: { __typename?: 'OdProtosCustomerV1Data_Email', address?: { __typename?: 'OdProtosCommon_EmailAddress', value: string } | null } | null, otherEmails: Array<{ __typename?: 'OdProtosCustomerV1Data_Email', address?: { __typename?: 'OdProtosCommon_EmailAddress', value: string } | null }>, primaryPhoneNumber?: { __typename?: 'OdProtosCustomerV1Data_Phone', type: OdProtosCustomerV1Data_Phone_PhoneType, number?: { __typename?: 'OdProtosCommon_PhoneNumber', value: string } | null } | null, otherPhoneNumbers: Array<{ __typename?: 'OdProtosCustomerV1Data_Phone', type: OdProtosCustomerV1Data_Phone_PhoneType, number?: { __typename?: 'OdProtosCommon_PhoneNumber', value: string } | null }> } | null } | null } };

export type CreateViewingAppointmentMutationVariables = Exact<{
  customerUUID: Scalars['String'];
  appointmentDate: Scalars['String'];
  appointmentTime: Scalars['String'];
  listingId?: InputMaybe<Scalars['Int']>;
  duration?: InputMaybe<Scalars['Int']>;
}>;


export type CreateViewingAppointmentMutation = { __typename?: 'Mutation', web: { __typename?: 'WebMutation', createViewingAppointment?: { __typename?: 'WebViewingAppointment', id: string } | null } };

export type UploadAgentPhotoMutationVariables = Exact<{
  key: Scalars['String'];
}>;


export type UploadAgentPhotoMutation = { __typename?: 'Mutation', external: { __typename?: 'ExternalMutation', aws?: { __typename?: 'AwsMutation', s3CreatePutObjectPresignedUrl: { __typename?: 'S3CreatePutObjectPresignedUrlResult', signedUrl: string, key: string } } | null } };

export type RemoveSavedSearchMutationVariables = Exact<{
  input: OdProtosBuyerV2ServicesBuyer_RemoveSavedSearchRequestInput;
}>;


export type RemoveSavedSearchMutation = { __typename?: 'Mutation', buyerService: { __typename?: 'OdProtosBuyerV2ServicesBuyer_BuyerService_Mutation', removeSavedSearch?: { __typename?: 'OdProtosBuyerV2ServicesBuyer_RemoveSavedSearchResponse', _empty?: boolean | null } | null } };

export type UpdateSavedSearchMutationVariables = Exact<{
  input: OdProtosBuyerV2ServicesBuyer_UpdateSavedSearchRequestInput;
}>;


export type UpdateSavedSearchMutation = { __typename?: 'Mutation', buyerService: { __typename?: 'OdProtosBuyerV2ServicesBuyer_BuyerService_Mutation', updateSavedSearch?: { __typename?: 'OdProtosBuyerV2ServicesBuyer_UpdateSavedSearchResponse', savedSearch?: { __typename?: 'OdProtosBuyerV2Data_SavedSearch', id: string } | null } | null } };

export type InitiateCustomerTaskMutationVariables = Exact<{
  taskType: CustomerTaskType;
  id: Scalars['String'];
}>;


export type InitiateCustomerTaskMutation = { __typename?: 'Mutation', customerAccount: { __typename?: 'CustomerAccountMutation', buying: { __typename?: 'BuyingMutation', initiateCustomerTask: { __typename?: 'InitiateCustomerTaskPayload', success: boolean, errorMessage?: string | null } } } };

export type GetSchoolsQueryVariables = Exact<{
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
}>;


export type GetSchoolsQuery = { __typename?: 'Query', geoDataStore: { __typename?: 'OdProtosGeoDataStoreServices_GeoDataStore_Query', getSchools?: { __typename?: 'OdProtosGeoDataStoreServices_GetSchoolsResponse', schools: Array<{ __typename?: 'OdProtosGeoDataStoreData_School', name: string, rating?: number | null, educationLevel: Array<OdProtosGeoDataStoreData_EducationLevel>, greatSchoolsUrl: string }> } | null } };

export type GetPropertyStatusForRouteQueryVariables = Exact<{
  addressId: Scalars['String'];
}>;


export type GetPropertyStatusForRouteQuery = { __typename?: 'Query', property: { __typename?: 'PropertyQuery', property?: { __typename?: 'Property', addressId: string, displaySlug: string, isDisplayable: boolean, odMarketIdentifier?: OdProtosCommonMarket_Market | null } | null } };

export type GetMarketplacePropertyForRouteQueryVariables = Exact<{
  addressId: Scalars['ID'];
}>;


export type GetMarketplacePropertyForRouteQuery = { __typename?: 'Query', marketplace: { __typename?: 'MarketplaceQuery', property?: { __typename?: 'MarketplaceProperty', addressToken: string, market?: string | null, slug: string } | null } };

export type GetAddressForIdQueryVariables = Exact<{
  addressId: Scalars['String'];
}>;


export type GetAddressForIdQuery = { __typename?: 'Query', casa: { __typename?: 'OdProtosCasaServices_Casa_Query', find?: { __typename?: 'OdProtosCasaServices_CasaResponse_Find', address?: { __typename?: 'OdProtosCasaData_Address', street: string, unitNumber: string, city: string, state: string, postalCode: string } | null } | null } };

export type GetShortListingPropertyInfoQueryVariables = Exact<{
  addressId: Scalars['String'];
}>;


export type GetShortListingPropertyInfoQuery = { __typename?: 'Query', property: { __typename?: 'PropertyQuery', property?: { __typename?: 'Property', addressId: string, sellRequestId?: string | null, displaySlug: string, bathroomsHalf?: number | null, bathroomsFull?: number | null, bedrooms?: number | null, listPrice?: number | null, status?: OdProtosRealtyOdlsData_SellRequest_State | null, sqFtTotalLiving?: number | null, sqFtAboveGrade?: number | null, sqFtLot?: number | null, yearBuilt?: number | null, poolFeatures?: Array<string> | null, publicRemarks?: string | null, garageSpaces?: number | null, sourceType?: OdProtosRealtyCommon_Source_Type | null, listingMetadata?: { __typename?: 'ListingMetadata', tags?: Array<ListingTag> | null, buyDirectDiscountPercent?: number | null } | null, hoas?: Array<{ __typename?: 'Hoa', name?: string | null, feeAmount?: number | null, feeFrequency?: string | null, features?: Array<string | null> | null }> | null, photos?: { __typename?: 'PhotoConnection', nodes?: Array<{ __typename?: 'PropertyPhoto', id: string, urls?: { __typename?: 'PhotoUrl', resizable: string } | null }> | null } | null } | null } };

export type GetMarketplacePropertyReactionQueryVariables = Exact<{
  addressToken: Scalars['ID'];
}>;


export type GetMarketplacePropertyReactionQuery = { __typename?: 'Query', marketplace: { __typename?: 'MarketplaceQuery', property?: { __typename?: 'MarketplaceProperty', addressToken: string, isDisliked?: boolean | null, isLiked?: boolean | null } | null } };

export type GetMarketplacePropertySimilarPropertiesQueryVariables = Exact<{
  addressToken: Scalars['ID'];
}>;


export type GetMarketplacePropertySimilarPropertiesQuery = { __typename?: 'Query', marketplace: { __typename?: 'MarketplaceQuery', property?: { __typename?: 'MarketplaceProperty', similarProperties?: { __typename?: 'MarketplacePropertyListQueryResult', count: number, nextPage?: number | null, results?: Array<{ __typename?: 'MarketplacePropertyListResult', id: string, addressToken?: string | null, baths?: number | null, beds?: number | null, city?: string | null, dwellingType?: DwellingType | null, estimatedMonthlyPayment?: number | null, fullAddress?: string | null, listPrice?: number | null, livingSquareFootage?: number | null, neighborhood?: string | null, slug?: string | null, photos?: Array<string> | null }> | null } | null } | null } };

export type GetMarketplacePropertyQueryVariables = Exact<{
  addressToken: Scalars['ID'];
}>;


export type GetMarketplacePropertyQuery = { __typename?: 'Query', marketplace: { __typename?: 'MarketplaceQuery', property?: { __typename?: 'MarketplaceProperty', addressToken: string, bathrooms?: number | null, bedrooms?: number | null, buyDirectPrice?: number | null, canSelfTour?: boolean | null, city: string, cumulativeDaysOnMarket?: number | null, daysOnMarket?: number | null, description?: string | null, displayBadge?: Badge | null, dwellingType?: DwellingType | null, estimatedMonthlyPayment?: number | null, exteriorStories?: number | null, fhaEligible?: boolean | null, fhaEligibleDate?: any | null, garageSpaces?: number | null, hasPrivatePool?: boolean | null, hasCommunityPool?: boolean | null, inGatedCommunity?: boolean | null, kitchenCountertop?: KitchenCountertop | null, latitude: number, longitude: number, listPrice?: number | null, estimatedBuyDirectMonthlyPayment?: number | null, listingState?: ListingState | null, listingTags?: Array<ListingTag> | null, market?: string | null, masterBedroomLocation?: MasterBedroomLocation | null, photos?: Array<string> | null, pricePerSqFt?: number | null, schoolDistricts?: Array<string> | null, sellerDisclosuresDownloadUrl?: string | null, slug: string, sqFtLot?: number | null, sqFtTotalLiving?: number | null, state?: string | null, street?: string | null, subdivision?: string | null, unitType?: string | null, unitNumber?: string | null, yearBuilt?: string | null, zip?: string | null, hoas?: Array<{ __typename?: 'Hoa', name?: string | null, feeAmount?: number | null, feeFrequency?: string | null }> | null, listingHistory?: Array<{ __typename?: 'MarketplaceListingHistory', state?: ListingHistoryState | null, timestamp?: any | null, mls?: string | null, originalListPriceCents?: number | null, soldPriceCents?: number | null, currentListPriceCents?: number | null }> | null, listingMetadata?: { __typename?: 'ListingMetadata', buyDirectDiscountPercent?: number | null } | null, schools?: Array<{ __typename?: 'MarketplaceSchool', id: string, name: string, rating?: number | null }> | null, similarProperties?: { __typename?: 'MarketplacePropertyListQueryResult', count: number, nextPage?: number | null, results?: Array<{ __typename?: 'MarketplacePropertyListResult', id: string, addressToken?: string | null, baths?: number | null, beds?: number | null, city?: string | null, dwellingType?: DwellingType | null, estimatedMonthlyPayment?: number | null, fullAddress?: string | null, listPrice?: number | null, livingSquareFootage?: number | null, neighborhood?: string | null, slug?: string | null, photos?: Array<string> | null }> | null } | null } | null } };

export type GetMarketplacePropertySellerDisclosuresQueryVariables = Exact<{
  addressToken: Scalars['ID'];
}>;


export type GetMarketplacePropertySellerDisclosuresQuery = { __typename?: 'Query', marketplace: { __typename?: 'MarketplaceQuery', property?: { __typename?: 'MarketplaceProperty', sellerDisclosuresDownloadUrl?: string | null } | null } };

export type GetMarketplacePropertyAccessCodeQueryVariables = Exact<{
  addressToken: Scalars['ID'];
}>;


export type GetMarketplacePropertyAccessCodeQuery = { __typename?: 'Query', marketplace: { __typename?: 'MarketplaceQuery', property?: { __typename?: 'MarketplaceProperty', accessCode?: string | null } | null } };

export type GetLongListingPropertyInfoQueryVariables = Exact<{
  addressId: Scalars['String'];
}>;


export type GetLongListingPropertyInfoQuery = { __typename?: 'Query', property: { __typename?: 'PropertyQuery', property?: { __typename?: 'Property', addressId: string, odMarketIdentifier?: OdProtosCommonMarket_Market | null, statePropertyTaxRate?: number | null, sellRequestId?: string | null, city: string, displaySlug: string, postalCode: string, state: string, street: string, county: string, unitNumber?: string | null, unitType?: string | null, dwellingType: DwellingType, bedrooms?: number | null, bathroomsHalf?: number | null, bathroomsFull?: number | null, builderName?: string | null, exteriorStories?: number | null, sellerDisclosuresDownloadUrl?: string | null, listPrice?: number | null, listTimestamp?: any | null, status?: OdProtosRealtyOdlsData_SellRequest_State | null, sqFtTotalLiving?: number | null, sqFtAboveGrade?: number | null, sqFtLot?: number | null, yearBuilt?: number | null, poolFeatures?: Array<string> | null, publicRemarks?: string | null, inGatedCommunity?: boolean | null, listingOfficeName?: string | null, apn?: string | null, mlsDisplayPermission?: MlsDisplayPermission | null, mlsNumber?: string | null, entryTimestamp?: any | null, sellRequestCreatedAt?: any | null, newConstruction?: boolean | null, opendoorOwned: boolean, instantTourable?: boolean | null, sourceType?: OdProtosRealtyCommon_Source_Type | null, latitude: number, longitude: number, listingMetadata?: { __typename?: 'ListingMetadata', tags?: Array<ListingTag> | null, buyDirectDiscountPercent?: number | null } | null, hoas?: Array<{ __typename?: 'Hoa', name?: string | null, feeAmount?: number | null, feeFrequency?: string | null, features?: Array<string | null> | null }> | null, agent?: { __typename?: 'MLSAgent', brokerage?: string | null, firstName?: string | null, lastName?: string | null, fullName?: string | null, licenseNumber?: string | null, mls?: string | null, mlsId?: string | null, email?: string | null, phoneNumber?: string | null } | null, mls?: { __typename?: 'MLS', identifier: string, logoUrl?: string | null, legalText?: string | null, detailPageLogo?: boolean | null, detailPageLegalText?: boolean | null, detailPageAgentOffice?: boolean | null, detailPageAgentName?: boolean | null, detailPageMLSNumber?: boolean | null, detailPageContactInfo?: boolean | null, logoRequiredDimensions?: { __typename?: 'Dimensions', width: number, height: number } | null } | null, schools?: Array<{ __typename?: 'School', id: string, name: string, rating: string, gradesOffered?: Array<string> | null }> | null, zones?: Array<{ __typename?: 'PropertyZone', id: string, name: string, mapPageSlug: string }> | null, similarListings?: { __typename?: 'PropertySearchResults', results?: { __typename?: 'PropertySearchResultConnection', nodes?: Array<{ __typename?: 'PropertySearchResult', addressId: string, displaySlug: string, city: string, postalCode: string, state: string, street: string, unitNumber?: string | null, unitType?: string | null, bedrooms?: number | null, bathroomsTotal?: number | null, listPrice?: number | null, listTimestamp?: any | null, status?: OdProtosRealtyOdlsData_SellRequest_State | null, sqFtLot?: number | null, sqFtTotalLiving?: number | null, sqFtAboveGrade?: number | null, latitude: number, longitude: number, photos?: { __typename?: 'PhotoConnection', nodes?: Array<{ __typename?: 'PropertyPhoto', id: string, urls?: { __typename?: 'PhotoUrl', resizable: string } | null }> | null } | null }> | null } | null } | null, photos?: { __typename?: 'PhotoConnection', nodes?: Array<{ __typename?: 'PropertyPhoto', id: string, urls?: { __typename?: 'PhotoUrl', resizable: string } | null }> | null } | null, commissionBreakdown?: { __typename?: 'CommissionBreakdown', buyer?: { __typename?: 'Commission', value?: number | null, type?: CommissionType | null } | null } | null } | null } };

export type GetMarketplacePropertySearchQueryVariables = Exact<{
  market?: InputMaybe<Scalars['String']>;
  bedrooms?: InputMaybe<Scalars['Int']>;
  bathrooms?: InputMaybe<Scalars['Float']>;
  canSelfTour?: InputMaybe<Scalars['Boolean']>;
  hasPool?: InputMaybe<Scalars['Boolean']>;
  maxHoaMonthlyFee?: InputMaybe<Scalars['Float']>;
  maxSquareFootage?: InputMaybe<Scalars['Int']>;
  minSquareFootage?: InputMaybe<Scalars['Int']>;
  maxListPrice?: InputMaybe<Scalars['Float']>;
  minListPrice?: InputMaybe<Scalars['Float']>;
  maxYearBuilt?: InputMaybe<Scalars['Int']>;
  minYearBuilt?: InputMaybe<Scalars['Int']>;
  propertyTypes?: InputMaybe<Array<PropertyType> | PropertyType>;
  singleStoryOnly?: InputMaybe<Scalars['Boolean']>;
  vertices?: InputMaybe<Array<GeoPoint> | GeoPoint>;
  zoneIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type GetMarketplacePropertySearchQuery = { __typename?: 'Query', marketplace: { __typename?: 'MarketplaceQuery', propertySearch?: { __typename?: 'MarketplacePropertySearchQueryResult', count: number, results?: Array<{ __typename?: 'MarketplacePropertySearchResult', id: string, addressToken?: string | null, badges?: Array<Badge> | null, beds?: number | null, baths?: number | null, listDate?: string | null, listPrice?: number | null, livingSquareFootage?: number | null, listingState?: ListingState | null, slug?: string | null, location?: { __typename?: 'PropertyLocation', lat: number, lon: number } | null }> | null } | null } };

export type GetMarketplacePropertyListQueryVariables = Exact<{
  page: Scalars['Int'];
  market?: InputMaybe<Scalars['String']>;
  bedrooms?: InputMaybe<Scalars['Int']>;
  bathrooms?: InputMaybe<Scalars['Float']>;
  canSelfTour?: InputMaybe<Scalars['Boolean']>;
  hasPool?: InputMaybe<Scalars['Boolean']>;
  maxHoaMonthlyFee?: InputMaybe<Scalars['Float']>;
  maxListPrice?: InputMaybe<Scalars['Float']>;
  minListPrice?: InputMaybe<Scalars['Float']>;
  maxSquareFootage?: InputMaybe<Scalars['Int']>;
  minSquareFootage?: InputMaybe<Scalars['Int']>;
  maxYearBuilt?: InputMaybe<Scalars['Int']>;
  minYearBuilt?: InputMaybe<Scalars['Int']>;
  propertyTypes?: InputMaybe<Array<PropertyType> | PropertyType>;
  singleStoryOnly?: InputMaybe<Scalars['Boolean']>;
  vertices?: InputMaybe<Array<GeoPoint> | GeoPoint>;
  zoneIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type GetMarketplacePropertyListQuery = { __typename?: 'Query', marketplace: { __typename?: 'MarketplaceQuery', propertyList?: { __typename?: 'MarketplacePropertyListQueryResult', count: number, nextPage?: number | null, results?: Array<{ __typename?: 'MarketplacePropertyListResult', id: string, addressToken?: string | null, badges?: Array<Badge> | null, beds?: number | null, baths?: number | null, city?: string | null, dwellingType?: DwellingType | null, estimatedMonthlyPayment?: number | null, fullAddress?: string | null, isLiked?: boolean | null, listDate?: string | null, listPrice?: number | null, livingSquareFootage?: number | null, listingState?: ListingState | null, neighborhood?: string | null, photos?: Array<string> | null, slug?: string | null, zip?: string | null }> | null } | null } };

export type GetPropertiesByMarketQueryVariables = Exact<{
  shape: Scalars['String'];
  filters?: InputMaybe<PropertyFilters>;
  pageInput: PageInput;
}>;


export type GetPropertiesByMarketQuery = { __typename?: 'Query', property: { __typename?: 'PropertyQuery', geoSearch: { __typename?: 'PropertySearchResults', results?: { __typename?: 'PropertySearchResultConnection', nodes?: Array<{ __typename?: 'PropertySearchResult', displaySlug: string, bedrooms?: number | null, bathroomsTotal?: number | null, originalListPrice?: number | null, sqFtTotalLiving?: number | null, sqFtAboveGrade?: number | null, listPrice?: number | null, listTimestamp?: any | null, street: string, unitType?: string | null, unitNumber?: string | null, city: string, state: string, postalCode: string, longitude: number, latitude: number, sqFtLot?: number | null, addressId: string, photos?: { __typename?: 'PhotoConnection', nodes?: Array<{ __typename?: 'PropertyPhoto', id: string, urls?: { __typename?: 'PhotoUrl', resizable: string } | null }> | null } | null }> | null } | null } } };

export type GetIsLikedByAddressIdForCurrentUserQueryVariables = Exact<{
  addressId: Scalars['String'];
}>;


export type GetIsLikedByAddressIdForCurrentUserQuery = { __typename?: 'Query', buyer: { __typename?: 'OdProtosBuyerServicesBuyer_Buyer_Query', isLikedByAddressIdForCurrentUser?: { __typename?: 'IsLikedByAddressIdForCurrentUserResponse', isLiked: boolean } | null } };

export type GetPropertyPhotosByAddressIDsQueryVariables = Exact<{
  addressIds: Array<Scalars['String']> | Scalars['String'];
  photoCount: Scalars['Int'];
}>;


export type GetPropertyPhotosByAddressIDsQuery = { __typename?: 'Query', property: { __typename?: 'PropertyQuery', properties?: Array<{ __typename?: 'Property', addressId: string, listTimestamp?: any | null, photos?: { __typename?: 'PhotoConnection', nodes?: Array<{ __typename?: 'PropertyPhoto', urls?: { __typename?: 'PhotoUrl', fullSize: string } | null }> | null } | null } | null> | null } };

export type GetVariantRequestQueryVariables = Exact<{
  grain?: InputMaybe<OdProtosVariantData_GrainInput>;
  key: Scalars['String'];
  props?: InputMaybe<GoogleProtobuf_StructInput>;
  autoImpression?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetVariantRequestQuery = { __typename?: 'Query', variant: { __typename?: 'OdProtosVariantServices_Variant_Query', getVariant?: { __typename?: 'OdProtosVariantServices_GetVariantResponse', variant?: { __typename?: 'OdProtosVariantData_Variant', value: string } | null } | null } };

export type GetSeveralVariantsRequestQueryVariables = Exact<{
  grain?: InputMaybe<OdProtosVariantData_GrainInput>;
  keys?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  props?: InputMaybe<GoogleProtobuf_StructInput>;
}>;


export type GetSeveralVariantsRequestQuery = { __typename?: 'Query', variant: { __typename?: 'OdProtosVariantServices_Variant_Query', getVariants?: { __typename?: 'OdProtosVariantServices_GetVariantsResponse', variants: Array<{ __typename?: 'OdProtosVariantServices_GetVariantsResponse_VariantsEntry', key: string, value?: { __typename?: 'OdProtosVariantData_Variant', value: string } | null }> } | null } };

export type GetSeveralFeatureFlagsRequestQueryVariables = Exact<{
  grain?: InputMaybe<OdProtosVariantData_GrainInput>;
  keys?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  props?: InputMaybe<GoogleProtobuf_StructInput>;
}>;


export type GetSeveralFeatureFlagsRequestQuery = { __typename?: 'Query', variant: { __typename?: 'OdProtosVariantServices_Variant_Query', getFeatureFlags?: { __typename?: 'OdProtosVariantServices_GetFeatureFlagsResponse', variants: Array<{ __typename?: 'OdProtosVariantServices_GetFeatureFlagsResponse_VariantsEntry', key: string, value?: { __typename?: 'OdProtosVariantData_Variant', value: string } | null }> } | null } };

export type ListLeadsOnUniqueAddressesQueryVariables = Exact<{
  customerUuid: Scalars['String'];
}>;


export type ListLeadsOnUniqueAddressesQuery = { __typename?: 'Query', sellDirect: { __typename?: 'OdProtosWebServicesSellDirect_SellDirect_Query', listLeadsOnUniqueAddresses?: { __typename?: 'OdProtosWebServicesSellDirect_ListLeadsOnUniqueAddressesResponse', leads: Array<{ __typename?: 'OdProtosWebData_Lead', id: string, isQualified: boolean, latestOffer?: { __typename?: 'OdProtosWebData_Offer', state: OdProtosWebData_Offer_State } | null, address?: { __typename?: 'OdProtosCasaData_Address', uuid: string, street: string } | null }> } | null } };

export type GetUnlockPropertyInfoQueryVariables = Exact<{
  addressId: Scalars['String'];
}>;


export type GetUnlockPropertyInfoQuery = { __typename?: 'Query', property: { __typename?: 'PropertyQuery', property?: { __typename?: 'Property', addressId: string, street: string, unitType?: string | null, unitNumber?: string | null, city: string, state: string, postalCode: string, odMarketIdentifier?: OdProtosCommonMarket_Market | null, sourceId?: string | null, photos?: { __typename?: 'PhotoConnection', nodes?: Array<{ __typename?: 'PropertyPhoto', id: string, urls?: { __typename?: 'PhotoUrl', fullSize: string } | null }> | null } | null } | null } };

export type GetGeoShapeFromUserLocationQueryVariables = Exact<{
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
  shapeGeoOption: OdProtosGeoDataStoreServices_ShapeGeoOption;
}>;


export type GetGeoShapeFromUserLocationQuery = { __typename?: 'Query', geoDataStore: { __typename?: 'OdProtosGeoDataStoreServices_GeoDataStore_Query', getZoneHierarchy?: { __typename?: 'OdProtosGeoDataStoreServices_GetZoneHierarchyResponse', zones: Array<{ __typename?: 'OdProtosGeoDataStoreData_Zone', shape: string }> } | null } };

export type GetPropertiesFromGeoShapeQueryVariables = Exact<{
  shape: Scalars['String'];
  filters: OdProtosPropertyDataStoreServices_PropertyFiltersInput;
  paginationRequest?: InputMaybe<OdProtosPropertyDataStoreServices_PaginationRequestInput>;
}>;


export type GetPropertiesFromGeoShapeQuery = { __typename?: 'Query', propertyDataStore: { __typename?: 'OdProtosPropertyDataStoreServices_PropertyDataStore_Query', mapSearchProperties?: { __typename?: 'OdProtosPropertyDataStoreServices_MapSearchPropertiesResponse', properties: Array<{ __typename?: 'OdProtosPropertyDataStoreData_MapProperty', addressId: string, latitude: number, longitude: number }> } | null } };

export type AddressAutocompleteQueryVariables = Exact<{
  query: Scalars['String'];
  filters?: InputMaybe<PropertyFilters>;
  pageInput: PageInput;
  latitude?: InputMaybe<Scalars['Float']>;
  longitude?: InputMaybe<Scalars['Float']>;
}>;


export type AddressAutocompleteQuery = { __typename?: 'Query', property: { __typename?: 'PropertyQuery', textSearch: { __typename?: 'PropertySearchResults', results?: { __typename?: 'PropertySearchResultConnection', nodes?: Array<{ __typename?: 'PropertySearchResult', addressId: string, displaySlug: string, unitNumber?: string | null, street: string, city: string, state: string, postalCode: string }> | null } | null } } };

export type GetCurrentCustomerQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrentCustomerQuery = { __typename?: 'Query', customerService: { __typename?: 'OdProtosCustomerV1Services_Customer_Query', getCurrentCustomer?: { __typename?: 'OdProtosCustomerV1Services_CustomerResponses_GetCurrentCustomer', customer?: { __typename?: 'OdProtosCustomerV1Data_Customer', uuid: string, createdAt?: any | null, firstName: string, lastName: string, isAgent: boolean, ccpaSaleOfDataOptOut: boolean, fullName?: string | null, primaryEmail?: { __typename?: 'OdProtosCustomerV1Data_Email', address?: { __typename?: 'OdProtosCommon_EmailAddress', value: string } | null } | null, otherEmails: Array<{ __typename?: 'OdProtosCustomerV1Data_Email', address?: { __typename?: 'OdProtosCommon_EmailAddress', value: string } | null }>, primaryPhoneNumber?: { __typename?: 'OdProtosCustomerV1Data_Phone', type: OdProtosCustomerV1Data_Phone_PhoneType, number?: { __typename?: 'OdProtosCommon_PhoneNumber', value: string } | null } | null, otherPhoneNumbers: Array<{ __typename?: 'OdProtosCustomerV1Data_Phone', type: OdProtosCustomerV1Data_Phone_PhoneType, number?: { __typename?: 'OdProtosCommon_PhoneNumber', value: string } | null }> } | null } | null } };

export type GetViewingAppointmentsDataQueryVariables = Exact<{
  customerUuid: Scalars['String'];
  listingId: Scalars['String'];
  daysOut?: InputMaybe<Scalars['Int']>;
  durationMinutes?: InputMaybe<Scalars['Int']>;
}>;


export type GetViewingAppointmentsDataQuery = { __typename?: 'Query', web: { __typename?: 'WebQuery', viewingAppointmentsByCustomer?: Array<{ __typename?: 'WebViewingAppointment', listing_address_id?: string | null, scheduled_for?: any | null, end_time?: any | null, timezone?: string | null } | null> | null, viewingAppointmentAvailabilityForListing?: { __typename?: 'WebViewingAppointmentAvailability', timezone?: string | null, available_days?: Array<{ __typename?: 'WebAvailableDay', date: any, available_slots?: Array<{ __typename?: 'WebAvailableSlot', start_time: any, end_time: any, is_now: boolean } | null> | null }> | null } | null } };

export type GetViewingAppointmentsByCustomerQueryVariables = Exact<{
  customerUuid: Scalars['String'];
}>;


export type GetViewingAppointmentsByCustomerQuery = { __typename?: 'Query', web: { __typename?: 'WebQuery', viewingAppointmentsByCustomer?: Array<{ __typename?: 'WebViewingAppointment', listing_address_id?: string | null, scheduled_for?: any | null, end_time?: any | null, timezone?: string | null } | null> | null } };

export type SearchLocationsQueryVariables = Exact<{
  query: Scalars['String'];
  types?: InputMaybe<Array<OdProtosGeoDataStoreData_Zone_Type> | OdProtosGeoDataStoreData_Zone_Type>;
}>;


export type SearchLocationsQuery = { __typename?: 'Query', geoDataStore: { __typename?: 'OdProtosGeoDataStoreServices_GeoDataStore_Query', searchZonesByTextQuery?: { __typename?: 'OdProtosGeoDataStoreServices_SearchZonesByTextQueryResponse', zones: Array<{ __typename?: 'OdProtosGeoDataStoreData_DisplayableZone', zone?: { __typename?: 'OdProtosGeoDataStoreData_Zone', county: string, name: string, shortName: string, stateAbbr: string, uuid: string, zoneType: OdProtosGeoDataStoreData_Zone_Type, centroid: string, population?: number | null } | null }> } | null } };

export type SearchZonesByLocationQueryVariables = Exact<{
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
  searchDistance: Scalars['Float'];
}>;


export type SearchZonesByLocationQuery = { __typename?: 'Query', geoDataStore: { __typename?: 'OdProtosGeoDataStoreServices_GeoDataStore_Query', searchZonesByLocation?: { __typename?: 'OdProtosGeoDataStoreServices_SearchZonesByLocationResponse', zones: Array<{ __typename?: 'OdProtosGeoDataStoreData_Zone', zoneType: OdProtosGeoDataStoreData_Zone_Type, uuid: string, name: string, slug: string }> } | null } };

export type GetMarketCoordinatesQueryVariables = Exact<{
  market?: InputMaybe<OdProtosCommonMarket_Market>;
}>;


export type GetMarketCoordinatesQuery = { __typename?: 'Query', buyer: { __typename?: 'OdProtosBuyerServicesBuyer_Buyer_Query', getMarketConfigByMarket?: { __typename?: 'OdProtosBuyerServicesBuyer_MarketConfigResponses_GetMarketConfigByMarket', marketConfig?: { __typename?: 'OdProtosBuyerData_MarketConfig', shape: string, displayName: string, identifier: string, buyingExperience: boolean } | null } | null } };

export type GetMarketplacePropertyCoreDetailsQueryVariables = Exact<{
  addressToken: Scalars['ID'];
}>;


export type GetMarketplacePropertyCoreDetailsQuery = { __typename?: 'Query', marketplace: { __typename?: 'MarketplaceQuery', property?: { __typename?: 'MarketplaceProperty', addressToken: string, bathrooms?: number | null, bedrooms?: number | null, buyDirectPrice?: number | null, canSelfTour?: boolean | null, city: string, cumulativeDaysOnMarket?: number | null, daysOnMarket?: number | null, description?: string | null, displayBadge?: Badge | null, dwellingType?: DwellingType | null, estimatedMonthlyPayment?: number | null, exteriorStories?: number | null, fhaEligible?: boolean | null, fhaEligibleDate?: any | null, garageSpaces?: number | null, hasPrivatePool?: boolean | null, hasCommunityPool?: boolean | null, inGatedCommunity?: boolean | null, kitchenCountertop?: KitchenCountertop | null, latitude: number, longitude: number, listPrice?: number | null, estimatedBuyDirectMonthlyPayment?: number | null, listingState?: ListingState | null, listingTags?: Array<ListingTag> | null, market?: string | null, masterBedroomLocation?: MasterBedroomLocation | null, photos?: Array<string> | null, pricePerSqFt?: number | null, schoolDistricts?: Array<string> | null, sellerDisclosuresDownloadUrl?: string | null, slug: string, sqFtLot?: number | null, sqFtTotalLiving?: number | null, state?: string | null, street?: string | null, subdivision?: string | null, unitType?: string | null, unitNumber?: string | null, yearBuilt?: string | null, zip?: string | null, hoas?: Array<{ __typename?: 'Hoa', name?: string | null, feeAmount?: number | null, feeFrequency?: string | null }> | null, listingHistory?: Array<{ __typename?: 'MarketplaceListingHistory', state?: ListingHistoryState | null, timestamp?: any | null, mls?: string | null, originalListPriceCents?: number | null, soldPriceCents?: number | null, currentListPriceCents?: number | null }> | null, listingMetadata?: { __typename?: 'ListingMetadata', buyDirectDiscountPercent?: number | null } | null, schools?: Array<{ __typename?: 'MarketplaceSchool', id: string, name: string, rating?: number | null }> | null, similarProperties?: { __typename?: 'MarketplacePropertyListQueryResult', count: number, nextPage?: number | null, results?: Array<{ __typename?: 'MarketplacePropertyListResult', id: string, addressToken?: string | null, baths?: number | null, beds?: number | null, city?: string | null, dwellingType?: DwellingType | null, estimatedMonthlyPayment?: number | null, fullAddress?: string | null, listPrice?: number | null, livingSquareFootage?: number | null, neighborhood?: string | null, slug?: string | null, photos?: Array<string> | null }> | null } | null } | null } };

export type HistoricalMarketMetricsQueryQueryVariables = Exact<{
  zip?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<OdProtosSellerDashboardMetricsData_HistoricalMarketMetricsFiltersInput>;
  numWeeks?: InputMaybe<Scalars['Float']>;
}>;


export type HistoricalMarketMetricsQueryQuery = { __typename?: 'Query', sellerDashboardMetrics: { __typename?: 'OdProtosSellerDashboardMetricsServices_SellerDashboardMetrics_Query', getHistoricalMarketMetrics?: { __typename?: 'OdProtosSellerDashboardMetricsServices_GetHistoricalMarketMetricsResponse', medianSalePrice: number, medianSalePriceMom: number, daysOnMarket: number, daysOnMarketMom: number, homesSold: number, homesSoldMom: number, homesOnMarket: number, homesOnMarketMom: number, avgListingPrice: number, avgListingPriceMom: number, unfilteredGraphs?: { __typename?: 'OdProtosSellerDashboardMetricsData_HistoricalMarketMetricsGraphs', medianSalePriceGraph: Array<number>, daysOnMarketGraph: Array<number>, homesSoldGraph: Array<number> } | null, filteredGraphs?: { __typename?: 'OdProtosSellerDashboardMetricsData_HistoricalMarketMetricsGraphs', medianSalePriceGraph: Array<number>, daysOnMarketGraph: Array<number>, homesSoldGraph: Array<number> } | null } | null } };

export type GetMarketMetricsQueryQueryVariables = Exact<{
  marketIdentifier?: InputMaybe<Scalars['String']>;
}>;


export type GetMarketMetricsQueryQuery = { __typename?: 'Query', sellerDashboardMetrics: { __typename?: 'OdProtosSellerDashboardMetricsServices_SellerDashboardMetrics_Query', getMarketMetrics?: { __typename?: 'OdProtosSellerDashboardMetricsServices_GetMarketMetricsResponse', marketIdentifier: string, timePeriod?: any | null, homesSold: number, homesSoldWow: number, newListings: number, newListingsWow: number, delistings: number, delistingsWow: number, homesOnMarket: number, homesOnMarketWow: number, averagePriceChange: number, averagePriceChangeWow: number, marketHotness: number } | null } };

export type GetMarketplacePropertyDetailsForMapMarkersQueryVariables = Exact<{
  addressToken: Scalars['ID'];
}>;


export type GetMarketplacePropertyDetailsForMapMarkersQuery = { __typename?: 'Query', marketplace: { __typename?: 'MarketplaceQuery', property?: { __typename?: 'MarketplaceProperty', addressToken: string, photos?: Array<string> | null, estimatedMonthlyPayment?: number | null, bathrooms?: number | null, bedrooms?: number | null, sqFtTotalLiving?: number | null, dwellingType?: DwellingType | null, isLiked?: boolean | null } | null } };

export type GetBuyerPropertyReactionsQueryVariables = Exact<{
  customerId: Scalars['String'];
}>;


export type GetBuyerPropertyReactionsQuery = { __typename?: 'Query', buyerService: { __typename?: 'OdProtosBuyerV2ServicesBuyer_BuyerService_Query', getBuyer?: { __typename?: 'OdProtosBuyerV2ServicesBuyer_GetBuyerResponse', buyer?: { __typename?: 'OdProtosBuyerV2Data_Buyer', reactions: Array<{ __typename?: 'OdProtosBuyerV2Data_PropertyReaction', addressId: string, reaction: OdProtosBuyerV2Data_Reaction, source: OdProtosBuyerV2Data_ReactionSource }> } | null } | null } };

export type GetZoneDataQueryVariables = Exact<{
  zoneId: Scalars['String'];
}>;


export type GetZoneDataQuery = { __typename?: 'Query', geoDataStore: { __typename?: 'OdProtosGeoDataStoreServices_GeoDataStore_Query', getZones?: { __typename?: 'OdProtosGeoDataStoreServices_GetZonesResponse', zones: Array<{ __typename?: 'OdProtosGeoDataStoreData_Zone', uuid: string, name: string, slug: string, zoneType: OdProtosGeoDataStoreData_Zone_Type, boundingBox: string, centroid: string }> } | null } };

export type AddressSearchQueryVariables = Exact<{
  query: Scalars['String'];
}>;


export type AddressSearchQuery = { __typename?: 'Query', marketplace: { __typename?: 'MarketplaceQuery', addressSearch?: { __typename?: 'AddressSearchResult', properties?: Array<{ __typename?: 'AddressSearchProperty', addressToken: string, id?: string | null, fullAddress?: string | null, priceCents?: number | null }> | null } | null } };

export type FavoritePropertiesQueryVariables = Exact<{ [key: string]: never; }>;


export type FavoritePropertiesQuery = { __typename?: 'Query', marketplace: { __typename?: 'MarketplaceQuery', favoriteProperties?: { __typename?: 'FavoritePropertiesResult', properties?: Array<{ __typename?: 'MarketplacePropertyListResult', id: string, addressToken?: string | null, beds?: number | null, baths?: number | null, dwellingType?: DwellingType | null, fullAddress?: string | null, photos?: Array<string> | null, listPrice?: number | null, livingSquareFootage?: number | null, slug?: string | null }> | null } | null } };

export type GetActiveBuyMarketsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
}>;


export type GetActiveBuyMarketsQuery = { __typename?: 'Query', pbdb: { __typename?: 'OdProtosPbdbServices_PBDB_Query', activeBuyMarket: Array<{ __typename?: 'ActiveBuyMarket', identifier: string, displayName: string, stateName: string, displayState: string, homesPath: string }> } };

export type PurchaseTransactionQueryVariables = Exact<{
  transactionId: Scalars['String'];
}>;


export type PurchaseTransactionQuery = { __typename?: 'Query', buy: { __typename?: 'BuyQuery', purchaseTransaction: { __typename?: 'PurchaseTransaction', id?: string | null, acceptedOfferPrice?: number | null, buyerCustomerId?: string | null, buyerEmail?: string | null, buyerName?: string | null, buyerPhone?: string | null, inspectionPeriodDaysRemaining?: number | null, listingOfferId?: string | null, transactionState?: TransactionState | null, resaleCloseOfEscrowDaysRemaining?: number | null, agent?: { __typename?: 'BwODAgent', id?: string | null, email?: string | null, name?: string | null, photoUrl?: string | null, primaryNumber?: string | null, isPartnerAgent?: boolean | null } | null, propertyV2?: { __typename?: 'MarketplaceProperty', addressToken: string, photos?: Array<string> | null } | null, tasks?: Array<{ __typename?: 'BuyClosingTask', id?: string | null, description?: string | null, title?: string | null, taskType?: BuyClosingTaskType | null, isDone?: boolean | null }> | null } } };

export type BuyerOffersQueryVariables = Exact<{ [key: string]: never; }>;


export type BuyerOffersQuery = { __typename?: 'Query', customerAccount: { __typename?: 'CustomerAccountQuery', buying: { __typename?: 'BuyingQuery', offers: Array<{ __typename?: 'PurchaseOffer', id: string, priceDollars: number, discountDollars: number, hasHeroHomeCredit?: boolean | null, requestedEarlyCheckIn?: boolean | null, requestedHomeWarranty?: boolean | null, tradeInAddress?: string | null, transactionState?: TransactionState | null, closeOfEscrowDate?: any | null, resaleAgent?: { __typename?: 'BwODAgent', id?: string | null, email?: string | null, name?: string | null, photoUrl?: string | null, primaryNumber?: string | null } | null, listing: { __typename?: 'Listing', id: string, property: { __typename?: 'MarketplaceProperty', addressToken: string, bathrooms?: number | null, bedrooms?: number | null, buyDirectPrice?: number | null, canSelfTour?: boolean | null, city: string, cumulativeDaysOnMarket?: number | null, daysOnMarket?: number | null, description?: string | null, displayBadge?: Badge | null, dwellingType?: DwellingType | null, estimatedMonthlyPayment?: number | null, exteriorStories?: number | null, fhaEligible?: boolean | null, fhaEligibleDate?: any | null, garageSpaces?: number | null, hasPrivatePool?: boolean | null, hasCommunityPool?: boolean | null, inGatedCommunity?: boolean | null, kitchenCountertop?: KitchenCountertop | null, latitude: number, longitude: number, listPrice?: number | null, estimatedBuyDirectMonthlyPayment?: number | null, listingState?: ListingState | null, listingTags?: Array<ListingTag> | null, market?: string | null, masterBedroomLocation?: MasterBedroomLocation | null, photos?: Array<string> | null, pricePerSqFt?: number | null, schoolDistricts?: Array<string> | null, sellerDisclosuresDownloadUrl?: string | null, slug: string, sqFtLot?: number | null, sqFtTotalLiving?: number | null, state?: string | null, street?: string | null, subdivision?: string | null, unitType?: string | null, unitNumber?: string | null, yearBuilt?: string | null, zip?: string | null, hoas?: Array<{ __typename?: 'Hoa', name?: string | null, feeAmount?: number | null, feeFrequency?: string | null }> | null, listingHistory?: Array<{ __typename?: 'MarketplaceListingHistory', state?: ListingHistoryState | null, timestamp?: any | null, mls?: string | null, originalListPriceCents?: number | null, soldPriceCents?: number | null, currentListPriceCents?: number | null }> | null, listingMetadata?: { __typename?: 'ListingMetadata', buyDirectDiscountPercent?: number | null } | null, schools?: Array<{ __typename?: 'MarketplaceSchool', id: string, name: string, rating?: number | null }> | null, similarProperties?: { __typename?: 'MarketplacePropertyListQueryResult', count: number, nextPage?: number | null, results?: Array<{ __typename?: 'MarketplacePropertyListResult', id: string, addressToken?: string | null, baths?: number | null, beds?: number | null, city?: string | null, dwellingType?: DwellingType | null, estimatedMonthlyPayment?: number | null, fullAddress?: string | null, listPrice?: number | null, livingSquareFootage?: number | null, neighborhood?: string | null, slug?: string | null, photos?: Array<string> | null }> | null } | null } }, taskGroups?: Array<{ __typename?: 'CustomerTaskGroup', title: string, icon?: TaskGroupIcon | null, progress?: { __typename?: 'TaskGroupProgress', completed: number, total: number } | null, tasks: Array<{ __typename?: 'InformationalTask', defaultExpanded?: boolean | null, id: string, taskType: CustomerTaskType, title: string, description: string, state?: CustomerTaskState | null, expandedContent?: { __typename?: 'TaskExpandedContent', instructions?: string | null, bulletPoints?: Array<string> | null } | null } | { __typename?: 'SingleCTATask', defaultExpanded?: boolean | null, id: string, taskType: CustomerTaskType, title: string, description: string, state?: CustomerTaskState | null, expandedContent?: { __typename?: 'TaskExpandedContent', instructions?: string | null, bulletPoints?: Array<string> | null } | null, action: { __typename?: 'TaskAction', label: string, type: TaskActionType, payload?: { __typename?: 'ExternalLinkPayload', url: string, openInNewTab: boolean } | { __typename?: 'ModalPayload', modalId: string, modalData?: any | null } | { __typename?: 'RevealContentPayload', content: string } | null } }> }> | null }> } } };

export type GetMarketInventoryCountsQueryVariables = Exact<{
  markets: Array<Scalars['String']> | Scalars['String'];
}>;


export type GetMarketInventoryCountsQuery = { __typename?: 'Query', marketplace: { __typename?: 'MarketplaceQuery', marketInventoryCounts: Array<{ __typename?: 'MarketInventoryCount', market: string, count: number }> } };

export const SimilarPropertyFragmentDoc = gql`
    fragment SimilarProperty on MarketplacePropertyListResult {
  id
  addressToken
  baths
  beds
  city
  dwellingType
  estimatedMonthlyPayment
  fullAddress
  listPrice
  livingSquareFootage
  neighborhood
  slug
  photos
}
    `;
export const SimilarPropertiesFragmentDoc = gql`
    fragment SimilarProperties on MarketplacePropertyListQueryResult {
  results {
    ...SimilarProperty
  }
  count
  nextPage
}
    ${SimilarPropertyFragmentDoc}`;
export const PropertyDetailsFragmentDoc = gql`
    fragment PropertyDetails on MarketplaceProperty {
  addressToken
  bathrooms
  bedrooms
  buyDirectPrice
  canSelfTour
  city
  cumulativeDaysOnMarket
  daysOnMarket
  description
  displayBadge
  dwellingType
  estimatedMonthlyPayment
  exteriorStories
  fhaEligible
  fhaEligibleDate
  garageSpaces
  hasPrivatePool
  hasCommunityPool
  hoas {
    name
    feeAmount
    feeFrequency
  }
  inGatedCommunity
  kitchenCountertop
  latitude
  longitude
  listPrice
  listingHistory {
    state
    timestamp
    mls
    originalListPriceCents
    soldPriceCents
    currentListPriceCents
  }
  listingMetadata {
    buyDirectDiscountPercent
  }
  estimatedBuyDirectMonthlyPayment
  listingState
  listingTags
  market
  masterBedroomLocation
  photos
  pricePerSqFt
  schoolDistricts
  schools {
    id
    name
    rating
  }
  sellerDisclosuresDownloadUrl
  similarProperties {
    ...SimilarProperties
  }
  slug
  sqFtLot
  sqFtTotalLiving
  state
  street
  subdivision
  unitType
  unitNumber
  yearBuilt
  zip
}
    ${SimilarPropertiesFragmentDoc}`;
export const PropertiesByMarketResultFragmentDoc = gql`
    fragment PropertiesByMarketResult on PropertySearchResult {
  displaySlug
  bedrooms
  bathroomsTotal
  originalListPrice
  sqFtTotalLiving
  sqFtAboveGrade
  listPrice
  listTimestamp
  street
  unitType
  unitNumber
  city
  state
  postalCode
  longitude
  latitude
  sqFtLot
  addressId
  photos(pageInput: {first: 5}) {
    nodes {
      id
      urls {
        resizable
      }
    }
  }
}
    `;
export const MarketplacePropertySearchResultFragmentDoc = gql`
    fragment MarketplacePropertySearchResult on MarketplacePropertySearchResult {
  id
  addressToken
  badges
  beds
  baths
  listDate
  listPrice
  livingSquareFootage
  listingState
  location {
    lat
    lon
  }
  slug
}
    `;
export const MarketplacePropertySearchFragmentDoc = gql`
    fragment MarketplacePropertySearch on MarketplacePropertySearchQueryResult {
  count
  results {
    ...MarketplacePropertySearchResult
  }
}
    ${MarketplacePropertySearchResultFragmentDoc}`;
export const AddressSearchResultFragmentDoc = gql`
    fragment AddressSearchResult on AddressSearchProperty {
  addressToken
  id
  fullAddress
  priceCents
}
    `;
export const MarketplacePropertyListResultFragmentDoc = gql`
    fragment MarketplacePropertyListResult on MarketplacePropertyListResult {
  id
  addressToken
  badges
  beds
  baths
  city
  dwellingType
  estimatedMonthlyPayment
  fullAddress
  isLiked
  listDate
  listPrice
  livingSquareFootage
  listingState
  neighborhood
  photos
  slug
  zip
}
    `;
export const MarketplacePropertyListFragmentDoc = gql`
    fragment MarketplacePropertyList on MarketplacePropertyListQueryResult {
  count
  nextPage
  results {
    ...MarketplacePropertyListResult
  }
}
    ${MarketplacePropertyListResultFragmentDoc}`;
export const BuyerPropertyReactionFragmentDoc = gql`
    fragment BuyerPropertyReaction on OdProtosBuyerV2Data_PropertyReaction {
  addressId
  reaction
  source
}
    `;
export const MarketConfigFragmentDoc = gql`
    fragment MarketConfig on OdProtosBuyerData_MarketConfig {
  shape
  displayName
  identifier
  buyingExperience
}
    `;
export const MapMarkerDetailsFragmentDoc = gql`
    fragment MapMarkerDetails on MarketplaceProperty {
  addressToken
  photos
  estimatedMonthlyPayment
  bathrooms
  bedrooms
  sqFtTotalLiving
  dwellingType
  isLiked
}
    `;
export const UnsubscribeMailerDocument = gql`
    mutation UnsubscribeMailer($address: OdProtosWebServicesMarketing_UnsubscribeMailerRequestInput!) {
  marketing {
    unsubscribeMailer(input: $address) {
      _empty
    }
  }
}
    `;
export const SetMarketplacePropertyReactionDocument = gql`
    mutation SetMarketplacePropertyReaction($input: OdProtosBuyerV2ServicesBuyer_SetPropertyReactionRequestInput!) {
  buyerService {
    setPropertyReaction(input: $input) {
      _empty
    }
  }
}
    `;
export const RemoveMarketplacePropertyReactionDocument = gql`
    mutation RemoveMarketplacePropertyReaction($input: OdProtosBuyerV2ServicesBuyer_RemovePropertyReactionRequestInput!) {
  buyerService {
    removePropertyReaction(input: $input) {
      _empty
    }
  }
}
    `;
export const SetImpressionDocument = gql`
    mutation SetImpression($grain: OdProtosVariantData_GrainInput, $key: String!, $variantValue: String!) {
  variant {
    setImpression(input: {grain: $grain, key: $key, variantValue: $variantValue}) {
      _empty
    }
  }
}
    `;
export const UpdateCustomerDocument = gql`
    mutation UpdateCustomer($customerUuid: String!, $params: OdProtosCustomerV1Services_CustomerRequests_Update_ParamsInput!) {
  customerService {
    update(input: {uuid: $customerUuid, params: $params}) {
      updatedCustomer {
        uuid
        createdAt
        firstName
        lastName
        primaryEmail {
          address {
            value
          }
        }
        otherEmails {
          address {
            value
          }
        }
        primaryPhoneNumber {
          number {
            value
          }
          type
        }
        otherPhoneNumbers {
          number {
            value
          }
          type
        }
        isAgent
        ccpaSaleOfDataOptOut
        fullName
      }
    }
  }
}
    `;
export const UpdateCurrentCustomerDocument = gql`
    mutation UpdateCurrentCustomer($customerUpdates: OdProtosCustomerV1Services_CustomerRequests_UpdateCurrentInput!) {
  customerService {
    updateCurrent(input: $customerUpdates) {
      updatedCustomer {
        uuid
        createdAt
        firstName
        lastName
        primaryEmail {
          address {
            value
          }
        }
        otherEmails {
          address {
            value
          }
        }
        primaryPhoneNumber {
          number {
            value
          }
          type
        }
        otherPhoneNumbers {
          number {
            value
          }
          type
        }
        isAgent
        ccpaSaleOfDataOptOut
        fullName
      }
    }
  }
}
    `;
export const CreateViewingAppointmentDocument = gql`
    mutation CreateViewingAppointment($customerUUID: String!, $appointmentDate: String!, $appointmentTime: String!, $listingId: Int, $duration: Int) {
  web {
    createViewingAppointment(
      customerUUID: $customerUUID
      appointmentDate: $appointmentDate
      appointmentTime: $appointmentTime
      listingId: $listingId
      duration: $duration
    ) {
      id
    }
  }
}
    `;
export const UploadAgentPhotoDocument = gql`
    mutation UploadAgentPhoto($key: String!) {
  external {
    aws {
      s3CreatePutObjectPresignedUrl(
        input: {clientName: IMGDROP_PRODUCTION, key: $key}
      ) {
        signedUrl
        key
      }
    }
  }
}
    `;
export const RemoveSavedSearchDocument = gql`
    mutation RemoveSavedSearch($input: OdProtosBuyerV2ServicesBuyer_RemoveSavedSearchRequestInput!) {
  buyerService {
    removeSavedSearch(input: $input) {
      _empty
    }
  }
}
    `;
export const UpdateSavedSearchDocument = gql`
    mutation UpdateSavedSearch($input: OdProtosBuyerV2ServicesBuyer_UpdateSavedSearchRequestInput!) {
  buyerService {
    updateSavedSearch(input: $input) {
      savedSearch {
        id
      }
    }
  }
}
    `;
export const InitiateCustomerTaskDocument = gql`
    mutation InitiateCustomerTask($taskType: CustomerTaskType!, $id: String!) {
  customerAccount {
    buying {
      initiateCustomerTask(input: {taskType: $taskType, id: $id}) {
        success
        errorMessage
      }
    }
  }
}
    `;
export const GetSchoolsDocument = gql`
    query GetSchools($latitude: Float!, $longitude: Float!) {
  geoDataStore {
    getSchools(input: {latitude: $latitude, longitude: $longitude}) {
      schools {
        name
        rating
        educationLevel
        greatSchoolsUrl
      }
    }
  }
}
    `;
export const GetPropertyStatusForRouteDocument = gql`
    query GetPropertyStatusForRoute($addressId: String!) {
  property {
    property(input: {addressId: $addressId}) {
      addressId
      displaySlug
      isDisplayable
      odMarketIdentifier
    }
  }
}
    `;
export const GetMarketplacePropertyForRouteDocument = gql`
    query GetMarketplacePropertyForRoute($addressId: ID!) {
  marketplace {
    property(addressToken: $addressId) {
      addressToken
      market
      slug
    }
  }
}
    `;
export const GetAddressForIdDocument = gql`
    query GetAddressForId($addressId: String!) {
  casa {
    find(input: {uuid: $addressId}) {
      address {
        street
        unitNumber
        city
        state
        postalCode
      }
    }
  }
}
    `;
export const GetShortListingPropertyInfoDocument = gql`
    query GetShortListingPropertyInfo($addressId: String!) {
  property {
    property(input: {addressId: $addressId}) {
      addressId
      sellRequestId
      displaySlug
      bathroomsHalf
      bathroomsFull
      bedrooms
      listPrice
      listingMetadata {
        tags
        buyDirectDiscountPercent
      }
      status
      sqFtTotalLiving
      sqFtAboveGrade
      sqFtLot
      yearBuilt
      poolFeatures
      publicRemarks
      hoas {
        name
        feeAmount
        feeFrequency
        features
      }
      garageSpaces
      photos(pageInput: {first: 50}) {
        nodes {
          id
          urls {
            resizable
          }
        }
      }
      sourceType
    }
  }
}
    `;
export const GetMarketplacePropertyReactionDocument = gql`
    query GetMarketplacePropertyReaction($addressToken: ID!) {
  marketplace {
    property(addressToken: $addressToken) {
      addressToken
      isDisliked
      isLiked
    }
  }
}
    `;
export const GetMarketplacePropertySimilarPropertiesDocument = gql`
    query GetMarketplacePropertySimilarProperties($addressToken: ID!) {
  marketplace {
    property(addressToken: $addressToken) {
      similarProperties {
        ...SimilarProperties
      }
    }
  }
}
    ${SimilarPropertiesFragmentDoc}`;
export const GetMarketplacePropertyDocument = gql`
    query GetMarketplaceProperty($addressToken: ID!) {
  marketplace {
    property(addressToken: $addressToken) {
      ...PropertyDetails
    }
  }
}
    ${PropertyDetailsFragmentDoc}`;
export const GetMarketplacePropertySellerDisclosuresDocument = gql`
    query GetMarketplacePropertySellerDisclosures($addressToken: ID!) {
  marketplace {
    property(addressToken: $addressToken) {
      sellerDisclosuresDownloadUrl
    }
  }
}
    `;
export const GetMarketplacePropertyAccessCodeDocument = gql`
    query GetMarketplacePropertyAccessCode($addressToken: ID!) {
  marketplace {
    property(addressToken: $addressToken) {
      accessCode
    }
  }
}
    `;
export const GetLongListingPropertyInfoDocument = gql`
    query GetLongListingPropertyInfo($addressId: String!) {
  property {
    property(input: {addressId: $addressId}) {
      addressId
      odMarketIdentifier
      statePropertyTaxRate
      sellRequestId
      city
      displaySlug
      postalCode
      state
      street
      county
      unitNumber
      unitType
      dwellingType
      bedrooms
      bathroomsHalf
      bathroomsFull
      builderName
      exteriorStories
      sellerDisclosuresDownloadUrl
      listingMetadata {
        tags
        buyDirectDiscountPercent
      }
      listPrice
      listTimestamp
      status
      sqFtTotalLiving
      sqFtAboveGrade
      sqFtLot
      yearBuilt
      poolFeatures
      publicRemarks
      hoas {
        name
        feeAmount
        feeFrequency
        features
      }
      inGatedCommunity
      agent {
        brokerage
        firstName
        lastName
        fullName
        licenseNumber
        mls
        mlsId
        email
        phoneNumber
      }
      listingOfficeName
      apn
      mls {
        identifier
        logoUrl
        logoRequiredDimensions {
          width
          height
        }
        legalText
        detailPageLogo
        detailPageLegalText
        detailPageAgentOffice
        detailPageAgentName
        detailPageMLSNumber
        detailPageContactInfo
      }
      mlsDisplayPermission
      mlsNumber
      entryTimestamp
      listTimestamp
      sellRequestCreatedAt
      newConstruction
      opendoorOwned
      instantTourable
      schools {
        id
        name
        rating
        gradesOffered
      }
      sourceType
      odMarketIdentifier
      zones {
        id
        name
        mapPageSlug
      }
      similarListings(input: {pageInput: {first: 5}}) {
        results {
          nodes {
            addressId
            displaySlug
            city
            postalCode
            state
            street
            unitNumber
            unitType
            bedrooms
            bathroomsTotal
            listPrice
            listTimestamp
            status
            photos(pageInput: {first: 1}) {
              nodes {
                id
                urls {
                  resizable
                }
              }
            }
            sqFtLot
            sqFtTotalLiving
            sqFtAboveGrade
            listTimestamp
            status
            latitude
            longitude
          }
        }
      }
      photos(pageInput: {first: 50}) {
        nodes {
          id
          urls {
            resizable
          }
        }
      }
      latitude
      longitude
      commissionBreakdown {
        buyer {
          value
          type
        }
      }
    }
  }
}
    `;
export const GetMarketplacePropertySearchDocument = gql`
    query GetMarketplacePropertySearch($market: String, $bedrooms: Int, $bathrooms: Float, $canSelfTour: Boolean, $hasPool: Boolean, $maxHoaMonthlyFee: Float, $maxSquareFootage: Int, $minSquareFootage: Int, $maxListPrice: Float, $minListPrice: Float, $maxYearBuilt: Int, $minYearBuilt: Int, $propertyTypes: [PropertyType!], $singleStoryOnly: Boolean, $vertices: [GeoPoint!], $zoneIds: [String!]) {
  marketplace {
    propertySearch(
      filters: {listingState: ON_THE_MARKET, minBeds: $bedrooms, minBathrooms: $bathrooms, minListPrice: $minListPrice, maxListPrice: $maxListPrice, minSquareFootage: $minSquareFootage, maxSquareFootage: $maxSquareFootage, maxYearBuilt: $maxYearBuilt, minYearBuilt: $minYearBuilt, isSelfTourEligible: $canSelfTour, propertyType: $propertyTypes, hasSingleStory: $singleStoryOnly, hasPool: $hasPool, maxHoaMonthlyFee: $maxHoaMonthlyFee}
      where: {market: $market, zoneIds: $zoneIds, vertices: $vertices}
    ) {
      ...MarketplacePropertySearch
    }
  }
}
    ${MarketplacePropertySearchFragmentDoc}`;
export const GetMarketplacePropertyListDocument = gql`
    query GetMarketplacePropertyList($page: Int!, $market: String, $bedrooms: Int, $bathrooms: Float, $canSelfTour: Boolean, $hasPool: Boolean, $maxHoaMonthlyFee: Float, $maxListPrice: Float, $minListPrice: Float, $maxSquareFootage: Int, $minSquareFootage: Int, $maxYearBuilt: Int, $minYearBuilt: Int, $propertyTypes: [PropertyType!], $singleStoryOnly: Boolean, $vertices: [GeoPoint!], $zoneIds: [String!]) {
  marketplace {
    propertyList(
      page: $page
      filters: {listingState: ON_THE_MARKET, minBeds: $bedrooms, minBathrooms: $bathrooms, minListPrice: $minListPrice, maxListPrice: $maxListPrice, minSquareFootage: $minSquareFootage, maxSquareFootage: $maxSquareFootage, maxYearBuilt: $maxYearBuilt, minYearBuilt: $minYearBuilt, isSelfTourEligible: $canSelfTour, propertyType: $propertyTypes, hasSingleStory: $singleStoryOnly, hasPool: $hasPool, maxHoaMonthlyFee: $maxHoaMonthlyFee}
      where: {market: $market, zoneIds: $zoneIds, vertices: $vertices}
      sortBy: [LIST_DATE_DSC]
    ) {
      ...MarketplacePropertyList
    }
  }
}
    ${MarketplacePropertyListFragmentDoc}`;
export const GetPropertiesByMarketDocument = gql`
    query GetPropertiesByMarket($shape: String!, $filters: PropertyFilters, $pageInput: PageInput!) {
  property {
    geoSearch(input: {shape: $shape, filters: $filters, pageInput: $pageInput}) {
      results {
        nodes {
          ...PropertiesByMarketResult
        }
      }
    }
  }
}
    ${PropertiesByMarketResultFragmentDoc}`;
export const GetIsLikedByAddressIdForCurrentUserDocument = gql`
    query GetIsLikedByAddressIdForCurrentUser($addressId: String!) {
  buyer {
    isLikedByAddressIdForCurrentUser(addressId: $addressId) {
      isLiked
    }
  }
}
    `;
export const GetPropertyPhotosByAddressIDsDocument = gql`
    query GetPropertyPhotosByAddressIDs($addressIds: [String!]!, $photoCount: Int!) {
  property {
    properties(input: {addressIds: $addressIds}) {
      addressId
      listTimestamp
      photos(pageInput: {first: $photoCount}) {
        nodes {
          urls {
            fullSize
          }
        }
      }
    }
  }
}
    `;
export const GetVariantRequestDocument = gql`
    query GetVariantRequest($grain: OdProtosVariantData_GrainInput, $key: String!, $props: GoogleProtobuf_StructInput, $autoImpression: Boolean) {
  variant {
    getVariant(
      input: {grain: $grain, key: $key, props: $props, autoImpression: $autoImpression}
    ) {
      variant {
        value
      }
    }
  }
}
    `;
export const GetSeveralVariantsRequestDocument = gql`
    query GetSeveralVariantsRequest($grain: OdProtosVariantData_GrainInput, $keys: [String!], $props: GoogleProtobuf_StructInput) {
  variant {
    getVariants(input: {grain: $grain, keys: $keys, props: $props}) {
      variants {
        key
        value {
          value
        }
      }
    }
  }
}
    `;
export const GetSeveralFeatureFlagsRequestDocument = gql`
    query GetSeveralFeatureFlagsRequest($grain: OdProtosVariantData_GrainInput, $keys: [String!], $props: GoogleProtobuf_StructInput) {
  variant {
    getFeatureFlags(input: {grain: $grain, keys: $keys, props: $props}) {
      variants {
        key
        value {
          value
        }
      }
    }
  }
}
    `;
export const ListLeadsOnUniqueAddressesDocument = gql`
    query ListLeadsOnUniqueAddresses($customerUuid: String!) {
  sellDirect {
    listLeadsOnUniqueAddresses(input: {customerUuid: $customerUuid}) {
      leads {
        id
        isQualified
        latestOffer {
          state
        }
        address {
          uuid
          street
        }
      }
    }
  }
}
    `;
export const GetUnlockPropertyInfoDocument = gql`
    query GetUnlockPropertyInfo($addressId: String!) {
  property {
    property(input: {addressId: $addressId}) {
      addressId
      street
      unitType
      unitNumber
      city
      state
      postalCode
      odMarketIdentifier
      sourceId
      photos(pageInput: {first: 1}) {
        nodes {
          id
          urls {
            fullSize
          }
        }
      }
    }
  }
}
    `;
export const GetGeoShapeFromUserLocationDocument = gql`
    query GetGeoShapeFromUserLocation($latitude: Float!, $longitude: Float!, $shapeGeoOption: OdProtosGeoDataStoreServices_ShapeGeoOption!) {
  geoDataStore {
    getZoneHierarchy(
      input: {latitude: $latitude, longitude: $longitude, shapeGeoOption: $shapeGeoOption}
    ) {
      zones {
        shape
      }
    }
  }
}
    `;
export const GetPropertiesFromGeoShapeDocument = gql`
    query GetPropertiesFromGeoShape($shape: String!, $filters: OdProtosPropertyDataStoreServices_PropertyFiltersInput!, $paginationRequest: OdProtosPropertyDataStoreServices_PaginationRequestInput) {
  propertyDataStore {
    mapSearchProperties(
      input: {shape: $shape, filters: $filters, paginationRequest: $paginationRequest}
    ) {
      properties {
        addressId
        latitude
        longitude
      }
    }
  }
}
    `;
export const AddressAutocompleteDocument = gql`
    query AddressAutocomplete($query: String!, $filters: PropertyFilters, $pageInput: PageInput!, $latitude: Float, $longitude: Float) {
  property {
    textSearch(
      input: {query: $query, filters: $filters, pageInput: $pageInput, latitude: $latitude, longitude: $longitude}
    ) {
      results {
        nodes {
          addressId
          displaySlug
          unitNumber
          street
          city
          state
          postalCode
        }
      }
    }
  }
}
    `;
export const GetCurrentCustomerDocument = gql`
    query GetCurrentCustomer {
  customerService {
    getCurrentCustomer {
      customer {
        uuid
        createdAt
        firstName
        lastName
        primaryEmail {
          address {
            value
          }
        }
        otherEmails {
          address {
            value
          }
        }
        primaryPhoneNumber {
          number {
            value
          }
          type
        }
        otherPhoneNumbers {
          number {
            value
          }
          type
        }
        isAgent
        ccpaSaleOfDataOptOut
        fullName
      }
    }
  }
}
    `;
export const GetViewingAppointmentsDataDocument = gql`
    query GetViewingAppointmentsData($customerUuid: String!, $listingId: String!, $daysOut: Int, $durationMinutes: Int) {
  web {
    viewingAppointmentsByCustomer(customerUuid: $customerUuid) {
      listing_address_id
      scheduled_for
      end_time
      timezone
    }
    viewingAppointmentAvailabilityForListing(
      listingId: $listingId
      daysOut: $daysOut
      durationMinutes: $durationMinutes
    ) {
      available_days {
        date
        available_slots {
          start_time
          end_time
          is_now
        }
      }
      timezone
    }
  }
}
    `;
export const GetViewingAppointmentsByCustomerDocument = gql`
    query GetViewingAppointmentsByCustomer($customerUuid: String!) {
  web {
    viewingAppointmentsByCustomer(customerUuid: $customerUuid) {
      listing_address_id
      scheduled_for
      end_time
      timezone
    }
  }
}
    `;
export const SearchLocationsDocument = gql`
    query SearchLocations($query: String!, $types: [OdProtosGeoDataStoreData_Zone_Type!]) {
  geoDataStore {
    searchZonesByTextQuery(input: {queryString: $query, types: $types}) {
      zones {
        zone {
          county
          name
          shortName
          stateAbbr
          uuid
          zoneType
          centroid
          population
        }
      }
    }
  }
}
    `;
export const SearchZonesByLocationDocument = gql`
    query SearchZonesByLocation($latitude: Float!, $longitude: Float!, $searchDistance: Float!) {
  geoDataStore {
    searchZonesByLocation(
      input: {latitude: $latitude, longitude: $longitude, searchDistance: $searchDistance, types: [NEIGHBORHOOD]}
    ) {
      zones {
        zoneType
        uuid
        name
        slug
      }
    }
  }
}
    `;
export const GetMarketCoordinatesDocument = gql`
    query GetMarketCoordinates($market: OdProtosCommonMarket_Market) {
  buyer {
    getMarketConfigByMarket(input: {market: $market}) {
      marketConfig {
        ...MarketConfig
      }
    }
  }
}
    ${MarketConfigFragmentDoc}`;
export const GetMarketplacePropertyCoreDetailsDocument = gql`
    query GetMarketplacePropertyCoreDetails($addressToken: ID!) {
  marketplace {
    property(addressToken: $addressToken) {
      ...PropertyDetails
    }
  }
}
    ${PropertyDetailsFragmentDoc}`;
export const HistoricalMarketMetricsQueryDocument = gql`
    query HistoricalMarketMetricsQuery($zip: String, $filters: OdProtosSellerDashboardMetricsData_HistoricalMarketMetricsFiltersInput, $numWeeks: Float) {
  sellerDashboardMetrics {
    getHistoricalMarketMetrics(
      input: {zip: $zip, filters: $filters, numWeeks: $numWeeks}
    ) {
      medianSalePrice
      medianSalePriceMom
      daysOnMarket
      daysOnMarketMom
      homesSold
      homesSoldMom
      homesOnMarket
      homesOnMarketMom
      avgListingPrice
      avgListingPriceMom
      unfilteredGraphs {
        medianSalePriceGraph
        daysOnMarketGraph
        homesSoldGraph
      }
      filteredGraphs {
        medianSalePriceGraph
        daysOnMarketGraph
        homesSoldGraph
      }
    }
  }
}
    `;
export const GetMarketMetricsQueryDocument = gql`
    query GetMarketMetricsQuery($marketIdentifier: String) {
  sellerDashboardMetrics {
    getMarketMetrics(input: {marketIdentifier: $marketIdentifier}) {
      marketIdentifier
      timePeriod
      homesSold
      homesSoldWow
      newListings
      newListingsWow
      delistings
      delistingsWow
      homesOnMarket
      homesOnMarketWow
      averagePriceChange
      averagePriceChangeWow
      marketHotness
    }
  }
}
    `;
export const GetMarketplacePropertyDetailsForMapMarkersDocument = gql`
    query GetMarketplacePropertyDetailsForMapMarkers($addressToken: ID!) {
  marketplace {
    property(addressToken: $addressToken) {
      ...MapMarkerDetails
    }
  }
}
    ${MapMarkerDetailsFragmentDoc}`;
export const GetBuyerPropertyReactionsDocument = gql`
    query GetBuyerPropertyReactions($customerId: String!) {
  buyerService {
    getBuyer(input: {customerId: $customerId}) {
      buyer {
        reactions {
          ...BuyerPropertyReaction
        }
      }
    }
  }
}
    ${BuyerPropertyReactionFragmentDoc}`;
export const GetZoneDataDocument = gql`
    query GetZoneData($zoneId: String!) {
  geoDataStore {
    getZones(input: {uuids: [$zoneId]}) {
      zones {
        uuid
        name
        slug
        zoneType
        boundingBox
        centroid
      }
    }
  }
}
    `;
export const AddressSearchDocument = gql`
    query AddressSearch($query: String!) {
  marketplace {
    addressSearch(query: $query) {
      properties {
        ...AddressSearchResult
      }
    }
  }
}
    ${AddressSearchResultFragmentDoc}`;
export const FavoritePropertiesDocument = gql`
    query FavoriteProperties {
  marketplace {
    favoriteProperties {
      properties {
        id
        addressToken
        beds
        baths
        dwellingType
        fullAddress
        photos
        listPrice
        livingSquareFootage
        slug
      }
    }
  }
}
    `;
export const GetActiveBuyMarketsDocument = gql`
    query GetActiveBuyMarkets($first: Int) {
  pbdb {
    activeBuyMarket(first: $first) {
      identifier
      displayName
      stateName
      displayState
      homesPath
    }
  }
}
    `;
export const PurchaseTransactionDocument = gql`
    query PurchaseTransaction($transactionId: String!) {
  buy {
    purchaseTransaction(transactionId: $transactionId) {
      id
      acceptedOfferPrice
      agent {
        id
        email
        name
        photoUrl
        primaryNumber
        isPartnerAgent
      }
      buyerCustomerId
      buyerEmail
      buyerName
      buyerPhone
      inspectionPeriodDaysRemaining
      listingOfferId
      propertyV2 {
        addressToken
        photos
      }
      tasks {
        id
        description
        isDone: isComplete
        title
        taskType
      }
      transactionState
      resaleCloseOfEscrowDaysRemaining
    }
  }
}
    `;
export const BuyerOffersDocument = gql`
    query BuyerOffers {
  customerAccount {
    buying {
      offers {
        id
        priceDollars
        discountDollars
        hasHeroHomeCredit
        requestedEarlyCheckIn
        requestedHomeWarranty
        tradeInAddress
        transactionState
        closeOfEscrowDate
        resaleAgent {
          id
          email
          name
          photoUrl
          primaryNumber
        }
        listing {
          id
          property {
            ...PropertyDetails
          }
        }
        taskGroups {
          title
          icon
          progress {
            completed
            total
          }
          tasks {
            id
            taskType
            title
            description
            state
            ... on InformationalTask {
              defaultExpanded
              expandedContent {
                instructions
                bulletPoints
              }
            }
            ... on SingleCTATask {
              defaultExpanded
              expandedContent {
                instructions
                bulletPoints
              }
              action {
                label
                type
                payload {
                  ... on RevealContentPayload {
                    content
                  }
                  ... on ExternalLinkPayload {
                    url
                    openInNewTab
                  }
                  ... on ModalPayload {
                    modalId
                    modalData
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    ${PropertyDetailsFragmentDoc}`;
export const GetMarketInventoryCountsDocument = gql`
    query GetMarketInventoryCounts($markets: [String!]!) {
  marketplace {
    marketInventoryCounts(markets: $markets) {
      market
      count
    }
  }
}
    `;

export type SdkFunctionWrapper = <T>(action: (requestHeaders?:Record<string, string>) => Promise<T>, operationName: string, operationType?: string) => Promise<T>;


const defaultWrapper: SdkFunctionWrapper = (action, _operationName, _operationType) => action();

export function getSdk(client: GraphQLClient, withWrapper: SdkFunctionWrapper = defaultWrapper) {
  return {
    UnsubscribeMailer(variables: UnsubscribeMailerMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UnsubscribeMailerMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UnsubscribeMailerMutation>(UnsubscribeMailerDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UnsubscribeMailer', 'mutation');
    },
    SetMarketplacePropertyReaction(variables: SetMarketplacePropertyReactionMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<SetMarketplacePropertyReactionMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SetMarketplacePropertyReactionMutation>(SetMarketplacePropertyReactionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'SetMarketplacePropertyReaction', 'mutation');
    },
    RemoveMarketplacePropertyReaction(variables: RemoveMarketplacePropertyReactionMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<RemoveMarketplacePropertyReactionMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RemoveMarketplacePropertyReactionMutation>(RemoveMarketplacePropertyReactionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'RemoveMarketplacePropertyReaction', 'mutation');
    },
    SetImpression(variables: SetImpressionMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<SetImpressionMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SetImpressionMutation>(SetImpressionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'SetImpression', 'mutation');
    },
    UpdateCustomer(variables: UpdateCustomerMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdateCustomerMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateCustomerMutation>(UpdateCustomerDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UpdateCustomer', 'mutation');
    },
    UpdateCurrentCustomer(variables: UpdateCurrentCustomerMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdateCurrentCustomerMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateCurrentCustomerMutation>(UpdateCurrentCustomerDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UpdateCurrentCustomer', 'mutation');
    },
    CreateViewingAppointment(variables: CreateViewingAppointmentMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CreateViewingAppointmentMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateViewingAppointmentMutation>(CreateViewingAppointmentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CreateViewingAppointment', 'mutation');
    },
    UploadAgentPhoto(variables: UploadAgentPhotoMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UploadAgentPhotoMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UploadAgentPhotoMutation>(UploadAgentPhotoDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UploadAgentPhoto', 'mutation');
    },
    RemoveSavedSearch(variables: RemoveSavedSearchMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<RemoveSavedSearchMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RemoveSavedSearchMutation>(RemoveSavedSearchDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'RemoveSavedSearch', 'mutation');
    },
    UpdateSavedSearch(variables: UpdateSavedSearchMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdateSavedSearchMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateSavedSearchMutation>(UpdateSavedSearchDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UpdateSavedSearch', 'mutation');
    },
    InitiateCustomerTask(variables: InitiateCustomerTaskMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<InitiateCustomerTaskMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<InitiateCustomerTaskMutation>(InitiateCustomerTaskDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'InitiateCustomerTask', 'mutation');
    },
    GetSchools(variables: GetSchoolsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetSchoolsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetSchoolsQuery>(GetSchoolsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetSchools', 'query');
    },
    GetPropertyStatusForRoute(variables: GetPropertyStatusForRouteQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetPropertyStatusForRouteQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetPropertyStatusForRouteQuery>(GetPropertyStatusForRouteDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetPropertyStatusForRoute', 'query');
    },
    GetMarketplacePropertyForRoute(variables: GetMarketplacePropertyForRouteQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetMarketplacePropertyForRouteQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetMarketplacePropertyForRouteQuery>(GetMarketplacePropertyForRouteDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetMarketplacePropertyForRoute', 'query');
    },
    GetAddressForId(variables: GetAddressForIdQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetAddressForIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetAddressForIdQuery>(GetAddressForIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetAddressForId', 'query');
    },
    GetShortListingPropertyInfo(variables: GetShortListingPropertyInfoQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetShortListingPropertyInfoQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetShortListingPropertyInfoQuery>(GetShortListingPropertyInfoDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetShortListingPropertyInfo', 'query');
    },
    GetMarketplacePropertyReaction(variables: GetMarketplacePropertyReactionQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetMarketplacePropertyReactionQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetMarketplacePropertyReactionQuery>(GetMarketplacePropertyReactionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetMarketplacePropertyReaction', 'query');
    },
    GetMarketplacePropertySimilarProperties(variables: GetMarketplacePropertySimilarPropertiesQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetMarketplacePropertySimilarPropertiesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetMarketplacePropertySimilarPropertiesQuery>(GetMarketplacePropertySimilarPropertiesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetMarketplacePropertySimilarProperties', 'query');
    },
    GetMarketplaceProperty(variables: GetMarketplacePropertyQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetMarketplacePropertyQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetMarketplacePropertyQuery>(GetMarketplacePropertyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetMarketplaceProperty', 'query');
    },
    GetMarketplacePropertySellerDisclosures(variables: GetMarketplacePropertySellerDisclosuresQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetMarketplacePropertySellerDisclosuresQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetMarketplacePropertySellerDisclosuresQuery>(GetMarketplacePropertySellerDisclosuresDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetMarketplacePropertySellerDisclosures', 'query');
    },
    GetMarketplacePropertyAccessCode(variables: GetMarketplacePropertyAccessCodeQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetMarketplacePropertyAccessCodeQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetMarketplacePropertyAccessCodeQuery>(GetMarketplacePropertyAccessCodeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetMarketplacePropertyAccessCode', 'query');
    },
    GetLongListingPropertyInfo(variables: GetLongListingPropertyInfoQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetLongListingPropertyInfoQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetLongListingPropertyInfoQuery>(GetLongListingPropertyInfoDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetLongListingPropertyInfo', 'query');
    },
    GetMarketplacePropertySearch(variables?: GetMarketplacePropertySearchQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetMarketplacePropertySearchQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetMarketplacePropertySearchQuery>(GetMarketplacePropertySearchDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetMarketplacePropertySearch', 'query');
    },
    GetMarketplacePropertyList(variables: GetMarketplacePropertyListQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetMarketplacePropertyListQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetMarketplacePropertyListQuery>(GetMarketplacePropertyListDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetMarketplacePropertyList', 'query');
    },
    GetPropertiesByMarket(variables: GetPropertiesByMarketQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetPropertiesByMarketQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetPropertiesByMarketQuery>(GetPropertiesByMarketDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetPropertiesByMarket', 'query');
    },
    GetIsLikedByAddressIdForCurrentUser(variables: GetIsLikedByAddressIdForCurrentUserQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetIsLikedByAddressIdForCurrentUserQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetIsLikedByAddressIdForCurrentUserQuery>(GetIsLikedByAddressIdForCurrentUserDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetIsLikedByAddressIdForCurrentUser', 'query');
    },
    GetPropertyPhotosByAddressIDs(variables: GetPropertyPhotosByAddressIDsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetPropertyPhotosByAddressIDsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetPropertyPhotosByAddressIDsQuery>(GetPropertyPhotosByAddressIDsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetPropertyPhotosByAddressIDs', 'query');
    },
    GetVariantRequest(variables: GetVariantRequestQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetVariantRequestQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetVariantRequestQuery>(GetVariantRequestDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetVariantRequest', 'query');
    },
    GetSeveralVariantsRequest(variables?: GetSeveralVariantsRequestQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetSeveralVariantsRequestQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetSeveralVariantsRequestQuery>(GetSeveralVariantsRequestDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetSeveralVariantsRequest', 'query');
    },
    GetSeveralFeatureFlagsRequest(variables?: GetSeveralFeatureFlagsRequestQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetSeveralFeatureFlagsRequestQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetSeveralFeatureFlagsRequestQuery>(GetSeveralFeatureFlagsRequestDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetSeveralFeatureFlagsRequest', 'query');
    },
    ListLeadsOnUniqueAddresses(variables: ListLeadsOnUniqueAddressesQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<ListLeadsOnUniqueAddressesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ListLeadsOnUniqueAddressesQuery>(ListLeadsOnUniqueAddressesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ListLeadsOnUniqueAddresses', 'query');
    },
    GetUnlockPropertyInfo(variables: GetUnlockPropertyInfoQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetUnlockPropertyInfoQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetUnlockPropertyInfoQuery>(GetUnlockPropertyInfoDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetUnlockPropertyInfo', 'query');
    },
    GetGeoShapeFromUserLocation(variables: GetGeoShapeFromUserLocationQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetGeoShapeFromUserLocationQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetGeoShapeFromUserLocationQuery>(GetGeoShapeFromUserLocationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetGeoShapeFromUserLocation', 'query');
    },
    GetPropertiesFromGeoShape(variables: GetPropertiesFromGeoShapeQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetPropertiesFromGeoShapeQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetPropertiesFromGeoShapeQuery>(GetPropertiesFromGeoShapeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetPropertiesFromGeoShape', 'query');
    },
    AddressAutocomplete(variables: AddressAutocompleteQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AddressAutocompleteQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AddressAutocompleteQuery>(AddressAutocompleteDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AddressAutocomplete', 'query');
    },
    GetCurrentCustomer(variables?: GetCurrentCustomerQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetCurrentCustomerQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetCurrentCustomerQuery>(GetCurrentCustomerDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetCurrentCustomer', 'query');
    },
    GetViewingAppointmentsData(variables: GetViewingAppointmentsDataQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetViewingAppointmentsDataQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetViewingAppointmentsDataQuery>(GetViewingAppointmentsDataDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetViewingAppointmentsData', 'query');
    },
    GetViewingAppointmentsByCustomer(variables: GetViewingAppointmentsByCustomerQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetViewingAppointmentsByCustomerQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetViewingAppointmentsByCustomerQuery>(GetViewingAppointmentsByCustomerDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetViewingAppointmentsByCustomer', 'query');
    },
    SearchLocations(variables: SearchLocationsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<SearchLocationsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SearchLocationsQuery>(SearchLocationsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'SearchLocations', 'query');
    },
    SearchZonesByLocation(variables: SearchZonesByLocationQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<SearchZonesByLocationQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SearchZonesByLocationQuery>(SearchZonesByLocationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'SearchZonesByLocation', 'query');
    },
    GetMarketCoordinates(variables?: GetMarketCoordinatesQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetMarketCoordinatesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetMarketCoordinatesQuery>(GetMarketCoordinatesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetMarketCoordinates', 'query');
    },
    GetMarketplacePropertyCoreDetails(variables: GetMarketplacePropertyCoreDetailsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetMarketplacePropertyCoreDetailsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetMarketplacePropertyCoreDetailsQuery>(GetMarketplacePropertyCoreDetailsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetMarketplacePropertyCoreDetails', 'query');
    },
    HistoricalMarketMetricsQuery(variables?: HistoricalMarketMetricsQueryQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<HistoricalMarketMetricsQueryQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<HistoricalMarketMetricsQueryQuery>(HistoricalMarketMetricsQueryDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'HistoricalMarketMetricsQuery', 'query');
    },
    GetMarketMetricsQuery(variables?: GetMarketMetricsQueryQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetMarketMetricsQueryQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetMarketMetricsQueryQuery>(GetMarketMetricsQueryDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetMarketMetricsQuery', 'query');
    },
    GetMarketplacePropertyDetailsForMapMarkers(variables: GetMarketplacePropertyDetailsForMapMarkersQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetMarketplacePropertyDetailsForMapMarkersQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetMarketplacePropertyDetailsForMapMarkersQuery>(GetMarketplacePropertyDetailsForMapMarkersDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetMarketplacePropertyDetailsForMapMarkers', 'query');
    },
    GetBuyerPropertyReactions(variables: GetBuyerPropertyReactionsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetBuyerPropertyReactionsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetBuyerPropertyReactionsQuery>(GetBuyerPropertyReactionsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetBuyerPropertyReactions', 'query');
    },
    GetZoneData(variables: GetZoneDataQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetZoneDataQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetZoneDataQuery>(GetZoneDataDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetZoneData', 'query');
    },
    AddressSearch(variables: AddressSearchQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AddressSearchQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AddressSearchQuery>(AddressSearchDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AddressSearch', 'query');
    },
    FavoriteProperties(variables?: FavoritePropertiesQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<FavoritePropertiesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FavoritePropertiesQuery>(FavoritePropertiesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'FavoriteProperties', 'query');
    },
    GetActiveBuyMarkets(variables?: GetActiveBuyMarketsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetActiveBuyMarketsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetActiveBuyMarketsQuery>(GetActiveBuyMarketsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetActiveBuyMarkets', 'query');
    },
    PurchaseTransaction(variables: PurchaseTransactionQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<PurchaseTransactionQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PurchaseTransactionQuery>(PurchaseTransactionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'PurchaseTransaction', 'query');
    },
    BuyerOffers(variables?: BuyerOffersQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<BuyerOffersQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<BuyerOffersQuery>(BuyerOffersDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'BuyerOffers', 'query');
    },
    GetMarketInventoryCounts(variables: GetMarketInventoryCountsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetMarketInventoryCountsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetMarketInventoryCountsQuery>(GetMarketInventoryCountsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetMarketInventoryCounts', 'query');
    }
  };
}
export type Sdk = ReturnType<typeof getSdk>;